
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire98fc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire98fc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iw2gE", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d7acf975af164d67$export$ffb0004e005737fa, (v) => $d7acf975af164d67$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d7acf975af164d67$export$34b9dba7ce09269b, (v) => $d7acf975af164d67$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d7acf975af164d67$export$25062201e9e25d76, (v) => $d7acf975af164d67$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7acf975af164d67$export$ffb0004e005737fa;
var $d7acf975af164d67$export$34b9dba7ce09269b;
var $d7acf975af164d67$export$25062201e9e25d76;
"use strict";
var $d7acf975af164d67$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d7acf975af164d67$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $d7acf975af164d67$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $d7acf975af164d67$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$d7acf975af164d67$export$ffb0004e005737fa = $d7acf975af164d67$var$REACT_FRAGMENT_TYPE;
$d7acf975af164d67$export$34b9dba7ce09269b = $d7acf975af164d67$var$jsxProd;
$d7acf975af164d67$export$25062201e9e25d76 = $d7acf975af164d67$var$jsxProd;

});

parcelRegister("fjpcG", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $b25c2e442c996fe7$export$882461b6382ed46c, (v) => $b25c2e442c996fe7$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $b25c2e442c996fe7$export$757ceba2d55c277e, (v) => $b25c2e442c996fe7$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $b25c2e442c996fe7$export$83d89fbfd8236492, (v) => $b25c2e442c996fe7$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b25c2e442c996fe7$export$882461b6382ed46c;
var $b25c2e442c996fe7$export$757ceba2d55c277e;
var $b25c2e442c996fe7$export$83d89fbfd8236492;
"use strict";

var $bIbqH = parcelRequire("bIbqH");

var $2WGWz = parcelRequire("2WGWz");

var $9Np2q = parcelRequire("9Np2q");
function $b25c2e442c996fe7$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b25c2e442c996fe7$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $b25c2e442c996fe7$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $b25c2e442c996fe7$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $b25c2e442c996fe7$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $b25c2e442c996fe7$var$assertIsMounted(fiber) {
    if ($b25c2e442c996fe7$var$getNearestMountedFiber(fiber) !== fiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
}
function $b25c2e442c996fe7$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $b25c2e442c996fe7$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $b25c2e442c996fe7$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $b25c2e442c996fe7$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $b25c2e442c996fe7$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $b25c2e442c996fe7$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $b25c2e442c996fe7$var$assign = Object.assign, $b25c2e442c996fe7$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b25c2e442c996fe7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b25c2e442c996fe7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b25c2e442c996fe7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b25c2e442c996fe7$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $b25c2e442c996fe7$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b25c2e442c996fe7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $b25c2e442c996fe7$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $b25c2e442c996fe7$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b25c2e442c996fe7$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b25c2e442c996fe7$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b25c2e442c996fe7$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b25c2e442c996fe7$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $b25c2e442c996fe7$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $b25c2e442c996fe7$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $b25c2e442c996fe7$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $b25c2e442c996fe7$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $b25c2e442c996fe7$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $b25c2e442c996fe7$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $b25c2e442c996fe7$var$getComponentNameFromType(type.type) || "Memo";
        case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $b25c2e442c996fe7$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $b25c2e442c996fe7$var$isArrayImpl = Array.isArray, $b25c2e442c996fe7$var$ReactSharedInternals = $2WGWz.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b25c2e442c996fe7$var$ReactDOMSharedInternals = $9Np2q.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b25c2e442c996fe7$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $b25c2e442c996fe7$var$valueStack = [], $b25c2e442c996fe7$var$index = -1;
function $b25c2e442c996fe7$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $b25c2e442c996fe7$var$pop(cursor) {
    0 > $b25c2e442c996fe7$var$index || (cursor.current = $b25c2e442c996fe7$var$valueStack[$b25c2e442c996fe7$var$index], $b25c2e442c996fe7$var$valueStack[$b25c2e442c996fe7$var$index] = null, $b25c2e442c996fe7$var$index--);
}
function $b25c2e442c996fe7$var$push(cursor, value) {
    $b25c2e442c996fe7$var$index++;
    $b25c2e442c996fe7$var$valueStack[$b25c2e442c996fe7$var$index] = cursor.current;
    cursor.current = value;
}
var $b25c2e442c996fe7$var$contextStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$contextFiberStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$rootInstanceStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$hostTransitionProviderCursor = $b25c2e442c996fe7$var$createCursor(null);
function $b25c2e442c996fe7$var$pushHostContainer(fiber, nextRootInstance) {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$rootInstanceStackCursor, nextRootInstance);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextFiberStackCursor, fiber);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $b25c2e442c996fe7$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $b25c2e442c996fe7$var$getOwnHostContext(nextRootInstance), fiber = $b25c2e442c996fe7$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextStackCursor);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextStackCursor, fiber);
}
function $b25c2e442c996fe7$var$popHostContainer() {
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextStackCursor);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextFiberStackCursor);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$rootInstanceStackCursor);
}
function $b25c2e442c996fe7$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$hostTransitionProviderCursor, fiber);
    var context = $b25c2e442c996fe7$var$contextStackCursor.current;
    var JSCompiler_inline_result = $b25c2e442c996fe7$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextFiberStackCursor, fiber), $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$contextStackCursor, JSCompiler_inline_result));
}
function $b25c2e442c996fe7$var$popHostContext(fiber) {
    $b25c2e442c996fe7$var$contextFiberStackCursor.current === fiber && ($b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextStackCursor), $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$contextFiberStackCursor));
    $b25c2e442c996fe7$var$hostTransitionProviderCursor.current === fiber && ($b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$hostTransitionProviderCursor), $b25c2e442c996fe7$var$HostTransitionContext._currentValue = $b25c2e442c996fe7$var$sharedNotPendingObject);
}
var $b25c2e442c996fe7$var$prefix, $b25c2e442c996fe7$var$suffix;
function $b25c2e442c996fe7$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $b25c2e442c996fe7$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $b25c2e442c996fe7$var$prefix = match && match[1] || "";
        $b25c2e442c996fe7$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $b25c2e442c996fe7$var$prefix + name + $b25c2e442c996fe7$var$suffix;
}
var $b25c2e442c996fe7$var$reentry = !1;
function $b25c2e442c996fe7$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $b25c2e442c996fe7$var$reentry) return "";
    $b25c2e442c996fe7$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $b25c2e442c996fe7$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $b25c2e442c996fe7$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $b25c2e442c996fe7$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Suspense Fallback") : $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $b25c2e442c996fe7$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $b25c2e442c996fe7$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $b25c2e442c996fe7$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $b25c2e442c996fe7$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $b25c2e442c996fe7$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $b25c2e442c996fe7$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $b25c2e442c996fe7$var$hasOwnProperty = Object.prototype.hasOwnProperty, $b25c2e442c996fe7$var$scheduleCallback$3 = $bIbqH.unstable_scheduleCallback, $b25c2e442c996fe7$var$cancelCallback$1 = $bIbqH.unstable_cancelCallback, $b25c2e442c996fe7$var$shouldYield = $bIbqH.unstable_shouldYield, $b25c2e442c996fe7$var$requestPaint = $bIbqH.unstable_requestPaint, $b25c2e442c996fe7$var$now = $bIbqH.unstable_now, $b25c2e442c996fe7$var$getCurrentPriorityLevel = $bIbqH.unstable_getCurrentPriorityLevel, $b25c2e442c996fe7$var$ImmediatePriority = $bIbqH.unstable_ImmediatePriority, $b25c2e442c996fe7$var$UserBlockingPriority = $bIbqH.unstable_UserBlockingPriority, $b25c2e442c996fe7$var$NormalPriority$1 = $bIbqH.unstable_NormalPriority, $b25c2e442c996fe7$var$LowPriority = $bIbqH.unstable_LowPriority, $b25c2e442c996fe7$var$IdlePriority = $bIbqH.unstable_IdlePriority, $b25c2e442c996fe7$var$log$1 = $bIbqH.log, $b25c2e442c996fe7$var$unstable_setDisableYieldValue = $bIbqH.unstable_setDisableYieldValue, $b25c2e442c996fe7$var$rendererID = null, $b25c2e442c996fe7$var$injectedHook = null;
function $b25c2e442c996fe7$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $b25c2e442c996fe7$var$log$1 && $b25c2e442c996fe7$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.setStrictMode) try {
        $b25c2e442c996fe7$var$injectedHook.setStrictMode($b25c2e442c996fe7$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $b25c2e442c996fe7$var$clz32 = Math.clz32 ? Math.clz32 : $b25c2e442c996fe7$var$clz32Fallback, $b25c2e442c996fe7$var$log = Math.log, $b25c2e442c996fe7$var$LN2 = Math.LN2;
function $b25c2e442c996fe7$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($b25c2e442c996fe7$var$log(x) / $b25c2e442c996fe7$var$LN2 | 0) | 0;
}
var $b25c2e442c996fe7$var$nextTransitionUpdateLane = 256, $b25c2e442c996fe7$var$nextTransitionDeferredLane = 262144, $b25c2e442c996fe7$var$nextRetryLane = 4194304;
function $b25c2e442c996fe7$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $b25c2e442c996fe7$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $b25c2e442c996fe7$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b25c2e442c996fe7$var$claimNextRetryLane() {
    var lane = $b25c2e442c996fe7$var$nextRetryLane;
    $b25c2e442c996fe7$var$nextRetryLane <<= 1;
    0 === ($b25c2e442c996fe7$var$nextRetryLane & 62914560) && ($b25c2e442c996fe7$var$nextRetryLane = 4194304);
    return lane;
}
function $b25c2e442c996fe7$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $b25c2e442c996fe7$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $b25c2e442c996fe7$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $b25c2e442c996fe7$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $b25c2e442c996fe7$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $b25c2e442c996fe7$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $b25c2e442c996fe7$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $b25c2e442c996fe7$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $b25c2e442c996fe7$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $b25c2e442c996fe7$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $b25c2e442c996fe7$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $b25c2e442c996fe7$var$resolveUpdatePriority() {
    var updatePriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $b25c2e442c996fe7$var$getEventPriority(updatePriority.type);
}
function $b25c2e442c996fe7$var$runWithPriority(priority, fn) {
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        return $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $b25c2e442c996fe7$var$randomKey = Math.random().toString(36).slice(2), $b25c2e442c996fe7$var$internalInstanceKey = "__reactFiber$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalPropsKey = "__reactProps$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalContainerInstanceKey = "__reactContainer$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalEventHandlersKey = "__reactEvents$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalEventHandlerListenersKey = "__reactListeners$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalEventHandlesSetKey = "__reactHandles$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalRootNodeResourcesKey = "__reactResources$" + $b25c2e442c996fe7$var$randomKey, $b25c2e442c996fe7$var$internalHoistableMarker = "__reactMarker$" + $b25c2e442c996fe7$var$randomKey;
function $b25c2e442c996fe7$var$detachDeletedInstance(node) {
    delete node[$b25c2e442c996fe7$var$internalInstanceKey];
    delete node[$b25c2e442c996fe7$var$internalPropsKey];
    delete node[$b25c2e442c996fe7$var$internalEventHandlersKey];
    delete node[$b25c2e442c996fe7$var$internalEventHandlerListenersKey];
    delete node[$b25c2e442c996fe7$var$internalEventHandlesSetKey];
}
function $b25c2e442c996fe7$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$b25c2e442c996fe7$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$b25c2e442c996fe7$var$internalContainerInstanceKey] || parentNode[$b25c2e442c996fe7$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $b25c2e442c996fe7$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$b25c2e442c996fe7$var$internalInstanceKey]) return parentNode;
                targetNode = $b25c2e442c996fe7$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $b25c2e442c996fe7$var$getInstanceFromNode(node) {
    if (node = node[$b25c2e442c996fe7$var$internalInstanceKey] || node[$b25c2e442c996fe7$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $b25c2e442c996fe7$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(33));
}
function $b25c2e442c996fe7$var$getResourcesFromRoot(root) {
    var resources = root[$b25c2e442c996fe7$var$internalRootNodeResourcesKey];
    resources || (resources = root[$b25c2e442c996fe7$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $b25c2e442c996fe7$var$markNodeAsHoistable(node) {
    node[$b25c2e442c996fe7$var$internalHoistableMarker] = !0;
}
var $b25c2e442c996fe7$var$allNativeEvents = new Set(), $b25c2e442c996fe7$var$registrationNameDependencies = {};
function $b25c2e442c996fe7$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $b25c2e442c996fe7$var$registerDirectEvent(registrationName, dependencies);
    $b25c2e442c996fe7$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $b25c2e442c996fe7$var$registerDirectEvent(registrationName, dependencies) {
    $b25c2e442c996fe7$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$b25c2e442c996fe7$var$allNativeEvents.add(dependencies[registrationName]);
}
var $b25c2e442c996fe7$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $b25c2e442c996fe7$var$illegalAttributeNameCache = {}, $b25c2e442c996fe7$var$validatedAttributeNameCache = {};
function $b25c2e442c996fe7$var$isAttributeNameSafe(attributeName) {
    if ($b25c2e442c996fe7$var$hasOwnProperty.call($b25c2e442c996fe7$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($b25c2e442c996fe7$var$hasOwnProperty.call($b25c2e442c996fe7$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($b25c2e442c996fe7$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $b25c2e442c996fe7$var$validatedAttributeNameCache[attributeName] = !0;
    $b25c2e442c996fe7$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $b25c2e442c996fe7$var$setValueForAttribute(node, name, value) {
    if ($b25c2e442c996fe7$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $b25c2e442c996fe7$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $b25c2e442c996fe7$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $b25c2e442c996fe7$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $b25c2e442c996fe7$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $b25c2e442c996fe7$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $b25c2e442c996fe7$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $b25c2e442c996fe7$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $b25c2e442c996fe7$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $b25c2e442c996fe7$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $b25c2e442c996fe7$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $b25c2e442c996fe7$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $b25c2e442c996fe7$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $b25c2e442c996fe7$var$getToStringValue(value);
        } else element.value !== "" + $b25c2e442c996fe7$var$getToStringValue(value) && (element.value = "" + $b25c2e442c996fe7$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $b25c2e442c996fe7$var$setDefaultValue(element, type, $b25c2e442c996fe7$var$getToStringValue(value)) : null != defaultValue ? $b25c2e442c996fe7$var$setDefaultValue(element, type, $b25c2e442c996fe7$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $b25c2e442c996fe7$var$getToStringValue(name) : element.removeAttribute("name");
}
function $b25c2e442c996fe7$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $b25c2e442c996fe7$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $b25c2e442c996fe7$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $b25c2e442c996fe7$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $b25c2e442c996fe7$var$track(element);
}
function $b25c2e442c996fe7$var$setDefaultValue(node, type, value) {
    "number" === type && $b25c2e442c996fe7$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $b25c2e442c996fe7$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $b25c2e442c996fe7$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $b25c2e442c996fe7$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $b25c2e442c996fe7$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $b25c2e442c996fe7$var$getToStringValue(defaultValue) : "";
}
function $b25c2e442c996fe7$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(92));
            if ($b25c2e442c996fe7$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $b25c2e442c996fe7$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $b25c2e442c996fe7$var$track(element);
}
function $b25c2e442c996fe7$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $b25c2e442c996fe7$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $b25c2e442c996fe7$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $b25c2e442c996fe7$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $b25c2e442c996fe7$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $b25c2e442c996fe7$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $b25c2e442c996fe7$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $b25c2e442c996fe7$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b25c2e442c996fe7$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $b25c2e442c996fe7$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $b25c2e442c996fe7$var$sanitizeURL(url) {
    return $b25c2e442c996fe7$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $b25c2e442c996fe7$var$noop$1() {}
var $b25c2e442c996fe7$var$currentReplayingEvent = null;
function $b25c2e442c996fe7$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $b25c2e442c996fe7$var$restoreTarget = null, $b25c2e442c996fe7$var$restoreQueue = null;
function $b25c2e442c996fe7$var$restoreStateOfTarget(target) {
    var internalInstance = $b25c2e442c996fe7$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$b25c2e442c996fe7$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $b25c2e442c996fe7$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$b25c2e442c996fe7$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(90));
                            $b25c2e442c996fe7$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $b25c2e442c996fe7$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $b25c2e442c996fe7$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $b25c2e442c996fe7$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $b25c2e442c996fe7$var$isInsideEventHandler = !1;
function $b25c2e442c996fe7$var$batchedUpdates$1(fn, a, b) {
    if ($b25c2e442c996fe7$var$isInsideEventHandler) return fn(a, b);
    $b25c2e442c996fe7$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($b25c2e442c996fe7$var$isInsideEventHandler = !1, null !== $b25c2e442c996fe7$var$restoreTarget || null !== $b25c2e442c996fe7$var$restoreQueue) {
            if ($b25c2e442c996fe7$var$flushSyncWork$1(), $b25c2e442c996fe7$var$restoreTarget && (a = $b25c2e442c996fe7$var$restoreTarget, fn = $b25c2e442c996fe7$var$restoreQueue, $b25c2e442c996fe7$var$restoreQueue = $b25c2e442c996fe7$var$restoreTarget = null, $b25c2e442c996fe7$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$b25c2e442c996fe7$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $b25c2e442c996fe7$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$b25c2e442c996fe7$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $b25c2e442c996fe7$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b25c2e442c996fe7$var$passiveBrowserEventsSupported = !1;
if ($b25c2e442c996fe7$var$canUseDOM) try {
    var $b25c2e442c996fe7$var$options = {};
    Object.defineProperty($b25c2e442c996fe7$var$options, "passive", {
        get: function() {
            $b25c2e442c996fe7$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $b25c2e442c996fe7$var$options, $b25c2e442c996fe7$var$options);
    window.removeEventListener("test", $b25c2e442c996fe7$var$options, $b25c2e442c996fe7$var$options);
} catch (e) {
    $b25c2e442c996fe7$var$passiveBrowserEventsSupported = !1;
}
var $b25c2e442c996fe7$var$root = null, $b25c2e442c996fe7$var$startText = null, $b25c2e442c996fe7$var$fallbackText = null;
function $b25c2e442c996fe7$var$getData() {
    if ($b25c2e442c996fe7$var$fallbackText) return $b25c2e442c996fe7$var$fallbackText;
    var start, startValue = $b25c2e442c996fe7$var$startText, startLength = startValue.length, end, endValue = "value" in $b25c2e442c996fe7$var$root ? $b25c2e442c996fe7$var$root.value : $b25c2e442c996fe7$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $b25c2e442c996fe7$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $b25c2e442c996fe7$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $b25c2e442c996fe7$var$functionThatReturnsTrue() {
    return !0;
}
function $b25c2e442c996fe7$var$functionThatReturnsFalse() {
    return !1;
}
function $b25c2e442c996fe7$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $b25c2e442c996fe7$var$functionThatReturnsTrue : $b25c2e442c996fe7$var$functionThatReturnsFalse;
        this.isPropagationStopped = $b25c2e442c996fe7$var$functionThatReturnsFalse;
        return this;
    }
    $b25c2e442c996fe7$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $b25c2e442c996fe7$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $b25c2e442c996fe7$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $b25c2e442c996fe7$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $b25c2e442c996fe7$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b25c2e442c996fe7$var$SyntheticEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$EventInterface), $b25c2e442c996fe7$var$UIEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    view: 0,
    detail: 0
}), $b25c2e442c996fe7$var$SyntheticUIEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$UIEventInterface), $b25c2e442c996fe7$var$lastMovementX, $b25c2e442c996fe7$var$lastMovementY, $b25c2e442c996fe7$var$lastMouseEvent, $b25c2e442c996fe7$var$MouseEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b25c2e442c996fe7$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $b25c2e442c996fe7$var$lastMouseEvent && ($b25c2e442c996fe7$var$lastMouseEvent && "mousemove" === event.type ? ($b25c2e442c996fe7$var$lastMovementX = event.screenX - $b25c2e442c996fe7$var$lastMouseEvent.screenX, $b25c2e442c996fe7$var$lastMovementY = event.screenY - $b25c2e442c996fe7$var$lastMouseEvent.screenY) : $b25c2e442c996fe7$var$lastMovementY = $b25c2e442c996fe7$var$lastMovementX = 0, $b25c2e442c996fe7$var$lastMouseEvent = event);
        return $b25c2e442c996fe7$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $b25c2e442c996fe7$var$lastMovementY;
    }
}), $b25c2e442c996fe7$var$SyntheticMouseEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$MouseEventInterface), $b25c2e442c996fe7$var$DragEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$MouseEventInterface, {
    dataTransfer: 0
}), $b25c2e442c996fe7$var$SyntheticDragEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$DragEventInterface), $b25c2e442c996fe7$var$FocusEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    relatedTarget: 0
}), $b25c2e442c996fe7$var$SyntheticFocusEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$FocusEventInterface), $b25c2e442c996fe7$var$AnimationEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b25c2e442c996fe7$var$SyntheticAnimationEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$AnimationEventInterface), $b25c2e442c996fe7$var$ClipboardEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $b25c2e442c996fe7$var$SyntheticClipboardEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$ClipboardEventInterface), $b25c2e442c996fe7$var$CompositionEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    data: 0
}), $b25c2e442c996fe7$var$SyntheticCompositionEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$CompositionEventInterface), $b25c2e442c996fe7$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b25c2e442c996fe7$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b25c2e442c996fe7$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b25c2e442c996fe7$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $b25c2e442c996fe7$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $b25c2e442c996fe7$var$getEventModifierState() {
    return $b25c2e442c996fe7$var$modifierStateGetter;
}
var $b25c2e442c996fe7$var$KeyboardEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $b25c2e442c996fe7$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $b25c2e442c996fe7$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $b25c2e442c996fe7$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b25c2e442c996fe7$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $b25c2e442c996fe7$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $b25c2e442c996fe7$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $b25c2e442c996fe7$var$SyntheticKeyboardEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$KeyboardEventInterface), $b25c2e442c996fe7$var$PointerEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b25c2e442c996fe7$var$SyntheticPointerEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$PointerEventInterface), $b25c2e442c996fe7$var$TouchEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b25c2e442c996fe7$var$getEventModifierState
}), $b25c2e442c996fe7$var$SyntheticTouchEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$TouchEventInterface), $b25c2e442c996fe7$var$TransitionEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b25c2e442c996fe7$var$SyntheticTransitionEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$TransitionEventInterface), $b25c2e442c996fe7$var$WheelEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b25c2e442c996fe7$var$SyntheticWheelEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$WheelEventInterface), $b25c2e442c996fe7$var$ToggleEventInterface = $b25c2e442c996fe7$var$assign({}, $b25c2e442c996fe7$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $b25c2e442c996fe7$var$SyntheticToggleEvent = $b25c2e442c996fe7$var$createSyntheticEvent($b25c2e442c996fe7$var$ToggleEventInterface), $b25c2e442c996fe7$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $b25c2e442c996fe7$var$canUseCompositionEvent = $b25c2e442c996fe7$var$canUseDOM && "CompositionEvent" in window, $b25c2e442c996fe7$var$documentMode = null;
$b25c2e442c996fe7$var$canUseDOM && "documentMode" in document && ($b25c2e442c996fe7$var$documentMode = document.documentMode);
var $b25c2e442c996fe7$var$canUseTextInputEvent = $b25c2e442c996fe7$var$canUseDOM && "TextEvent" in window && !$b25c2e442c996fe7$var$documentMode, $b25c2e442c996fe7$var$useFallbackCompositionData = $b25c2e442c996fe7$var$canUseDOM && (!$b25c2e442c996fe7$var$canUseCompositionEvent || $b25c2e442c996fe7$var$documentMode && 8 < $b25c2e442c996fe7$var$documentMode && 11 >= $b25c2e442c996fe7$var$documentMode), $b25c2e442c996fe7$var$SPACEBAR_CHAR = String.fromCharCode(32), $b25c2e442c996fe7$var$hasSpaceKeypress = !1;
function $b25c2e442c996fe7$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $b25c2e442c996fe7$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b25c2e442c996fe7$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $b25c2e442c996fe7$var$isComposing = !1;
function $b25c2e442c996fe7$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $b25c2e442c996fe7$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $b25c2e442c996fe7$var$hasSpaceKeypress = !0;
            return $b25c2e442c996fe7$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $b25c2e442c996fe7$var$SPACEBAR_CHAR && $b25c2e442c996fe7$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $b25c2e442c996fe7$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($b25c2e442c996fe7$var$isComposing) return "compositionend" === domEventName || !$b25c2e442c996fe7$var$canUseCompositionEvent && $b25c2e442c996fe7$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $b25c2e442c996fe7$var$getData(), $b25c2e442c996fe7$var$fallbackText = $b25c2e442c996fe7$var$startText = $b25c2e442c996fe7$var$root = null, $b25c2e442c996fe7$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $b25c2e442c996fe7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $b25c2e442c996fe7$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b25c2e442c996fe7$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$b25c2e442c996fe7$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $b25c2e442c996fe7$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $b25c2e442c996fe7$var$restoreTarget ? $b25c2e442c996fe7$var$restoreQueue ? $b25c2e442c996fe7$var$restoreQueue.push(target) : $b25c2e442c996fe7$var$restoreQueue = [
        target
    ] : $b25c2e442c996fe7$var$restoreTarget = target;
    inst = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $b25c2e442c996fe7$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $b25c2e442c996fe7$var$activeElement$1 = null, $b25c2e442c996fe7$var$activeElementInst$1 = null;
function $b25c2e442c996fe7$var$runEventInBatch(dispatchQueue) {
    $b25c2e442c996fe7$var$processDispatchQueue(dispatchQueue, 0);
}
function $b25c2e442c996fe7$var$getInstIfValueChanged(targetInst) {
    var targetNode = $b25c2e442c996fe7$var$getNodeFromInstance(targetInst);
    if ($b25c2e442c996fe7$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $b25c2e442c996fe7$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $b25c2e442c996fe7$var$isInputEventSupported = !1;
if ($b25c2e442c996fe7$var$canUseDOM) {
    var $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286;
    if ($b25c2e442c996fe7$var$canUseDOM) {
        var $b25c2e442c996fe7$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$b25c2e442c996fe7$var$isSupported$jscomp$inline_427) {
            var $b25c2e442c996fe7$var$element$jscomp$inline_428 = document.createElement("div");
            $b25c2e442c996fe7$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $b25c2e442c996fe7$var$isSupported$jscomp$inline_427 = "function" === typeof $b25c2e442c996fe7$var$element$jscomp$inline_428.oninput;
        }
        $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286 = $b25c2e442c996fe7$var$isSupported$jscomp$inline_427;
    } else $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286 = !1;
    $b25c2e442c996fe7$var$isInputEventSupported = $b25c2e442c996fe7$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $b25c2e442c996fe7$var$stopWatchingForValueChange() {
    $b25c2e442c996fe7$var$activeElement$1 && ($b25c2e442c996fe7$var$activeElement$1.detachEvent("onpropertychange", $b25c2e442c996fe7$var$handlePropertyChange), $b25c2e442c996fe7$var$activeElementInst$1 = $b25c2e442c996fe7$var$activeElement$1 = null);
}
function $b25c2e442c996fe7$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $b25c2e442c996fe7$var$getInstIfValueChanged($b25c2e442c996fe7$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $b25c2e442c996fe7$var$createAndAccumulateChangeEvent(dispatchQueue, $b25c2e442c996fe7$var$activeElementInst$1, nativeEvent, $b25c2e442c996fe7$var$getEventTarget(nativeEvent));
        $b25c2e442c996fe7$var$batchedUpdates$1($b25c2e442c996fe7$var$runEventInBatch, dispatchQueue);
    }
}
function $b25c2e442c996fe7$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($b25c2e442c996fe7$var$stopWatchingForValueChange(), $b25c2e442c996fe7$var$activeElement$1 = target, $b25c2e442c996fe7$var$activeElementInst$1 = targetInst, $b25c2e442c996fe7$var$activeElement$1.attachEvent("onpropertychange", $b25c2e442c996fe7$var$handlePropertyChange)) : "focusout" === domEventName && $b25c2e442c996fe7$var$stopWatchingForValueChange();
}
function $b25c2e442c996fe7$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $b25c2e442c996fe7$var$getInstIfValueChanged($b25c2e442c996fe7$var$activeElementInst$1);
}
function $b25c2e442c996fe7$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $b25c2e442c996fe7$var$getInstIfValueChanged(targetInst);
}
function $b25c2e442c996fe7$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $b25c2e442c996fe7$var$getInstIfValueChanged(targetInst);
}
function $b25c2e442c996fe7$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b25c2e442c996fe7$var$objectIs = "function" === typeof Object.is ? Object.is : $b25c2e442c996fe7$var$is;
function $b25c2e442c996fe7$var$shallowEqual(objA, objB) {
    if ($b25c2e442c996fe7$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$b25c2e442c996fe7$var$hasOwnProperty.call(objB, currentKey) || !$b25c2e442c996fe7$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $b25c2e442c996fe7$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $b25c2e442c996fe7$var$getNodeForCharacterOffset(root, offset) {
    var node = $b25c2e442c996fe7$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $b25c2e442c996fe7$var$getLeafNode(node);
    }
}
function $b25c2e442c996fe7$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $b25c2e442c996fe7$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $b25c2e442c996fe7$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $b25c2e442c996fe7$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $b25c2e442c996fe7$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $b25c2e442c996fe7$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $b25c2e442c996fe7$var$skipSelectionChangeEvent = $b25c2e442c996fe7$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $b25c2e442c996fe7$var$activeElement = null, $b25c2e442c996fe7$var$activeElementInst = null, $b25c2e442c996fe7$var$lastSelection = null, $b25c2e442c996fe7$var$mouseDown = !1;
function $b25c2e442c996fe7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $b25c2e442c996fe7$var$mouseDown || null == $b25c2e442c996fe7$var$activeElement || $b25c2e442c996fe7$var$activeElement !== $b25c2e442c996fe7$var$getActiveElement(doc) || (doc = $b25c2e442c996fe7$var$activeElement, "selectionStart" in doc && $b25c2e442c996fe7$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $b25c2e442c996fe7$var$lastSelection && $b25c2e442c996fe7$var$shallowEqual($b25c2e442c996fe7$var$lastSelection, doc) || ($b25c2e442c996fe7$var$lastSelection = doc, doc = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners($b25c2e442c996fe7$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $b25c2e442c996fe7$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $b25c2e442c996fe7$var$activeElement)));
}
function $b25c2e442c996fe7$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $b25c2e442c996fe7$var$vendorPrefixes = {
    animationend: $b25c2e442c996fe7$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $b25c2e442c996fe7$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $b25c2e442c996fe7$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $b25c2e442c996fe7$var$makePrefixMap("Transition", "TransitionEnd")
}, $b25c2e442c996fe7$var$prefixedEventNames = {}, $b25c2e442c996fe7$var$style = {};
$b25c2e442c996fe7$var$canUseDOM && ($b25c2e442c996fe7$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $b25c2e442c996fe7$var$vendorPrefixes.animationend.animation, delete $b25c2e442c996fe7$var$vendorPrefixes.animationiteration.animation, delete $b25c2e442c996fe7$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $b25c2e442c996fe7$var$vendorPrefixes.transitionend.transition);
function $b25c2e442c996fe7$var$getVendorPrefixedEventName(eventName) {
    if ($b25c2e442c996fe7$var$prefixedEventNames[eventName]) return $b25c2e442c996fe7$var$prefixedEventNames[eventName];
    if (!$b25c2e442c996fe7$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $b25c2e442c996fe7$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $b25c2e442c996fe7$var$style) return $b25c2e442c996fe7$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $b25c2e442c996fe7$var$ANIMATION_END = $b25c2e442c996fe7$var$getVendorPrefixedEventName("animationend"), $b25c2e442c996fe7$var$ANIMATION_ITERATION = $b25c2e442c996fe7$var$getVendorPrefixedEventName("animationiteration"), $b25c2e442c996fe7$var$ANIMATION_START = $b25c2e442c996fe7$var$getVendorPrefixedEventName("animationstart"), $b25c2e442c996fe7$var$TRANSITION_RUN = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitionrun"), $b25c2e442c996fe7$var$TRANSITION_START = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitionstart"), $b25c2e442c996fe7$var$TRANSITION_CANCEL = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitioncancel"), $b25c2e442c996fe7$var$TRANSITION_END = $b25c2e442c996fe7$var$getVendorPrefixedEventName("transitionend"), $b25c2e442c996fe7$var$topLevelEventsToReactNames = new Map(), $b25c2e442c996fe7$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$b25c2e442c996fe7$var$simpleEventPluginEvents.push("scrollEnd");
function $b25c2e442c996fe7$var$registerSimpleEvent(domEventName, reactName) {
    $b25c2e442c996fe7$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $b25c2e442c996fe7$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $b25c2e442c996fe7$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $b25c2e442c996fe7$var$concurrentQueues = [], $b25c2e442c996fe7$var$concurrentQueuesIndex = 0, $b25c2e442c996fe7$var$concurrentlyUpdatedLanes = 0;
function $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $b25c2e442c996fe7$var$concurrentQueuesIndex, i = $b25c2e442c996fe7$var$concurrentlyUpdatedLanes = $b25c2e442c996fe7$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        var queue = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        var update = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        var lane = $b25c2e442c996fe7$var$concurrentQueues[i];
        $b25c2e442c996fe7$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $b25c2e442c996fe7$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = fiber;
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = queue;
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = update;
    $b25c2e442c996fe7$var$concurrentQueues[$b25c2e442c996fe7$var$concurrentQueuesIndex++] = lane;
    $b25c2e442c996fe7$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
}
function $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, null, null, lane);
    return $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
}
function $b25c2e442c996fe7$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $b25c2e442c996fe7$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $b25c2e442c996fe7$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $b25c2e442c996fe7$var$nestedUpdateCount) throw $b25c2e442c996fe7$var$nestedUpdateCount = 0, $b25c2e442c996fe7$var$rootWithNestedUpdates = null, Error($b25c2e442c996fe7$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $b25c2e442c996fe7$var$emptyContextObject = {};
function $b25c2e442c996fe7$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b25c2e442c996fe7$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $b25c2e442c996fe7$var$FiberNode(tag, pendingProps, key, mode);
}
function $b25c2e442c996fe7$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $b25c2e442c996fe7$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $b25c2e442c996fe7$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $b25c2e442c996fe7$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $b25c2e442c996fe7$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $b25c2e442c996fe7$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $b25c2e442c996fe7$var$isHostHoistableType(type, pendingProps, $b25c2e442c996fe7$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $b25c2e442c996fe7$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE:
            return $b25c2e442c996fe7$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $b25c2e442c996fe7$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $b25c2e442c996fe7$var$REACT_PROFILER_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $b25c2e442c996fe7$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $b25c2e442c996fe7$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $b25c2e442c996fe7$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $b25c2e442c996fe7$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $b25c2e442c996fe7$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $b25c2e442c996fe7$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($b25c2e442c996fe7$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $b25c2e442c996fe7$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $b25c2e442c996fe7$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $b25c2e442c996fe7$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $b25c2e442c996fe7$var$createFiberFromText(content, mode, lanes) {
    content = $b25c2e442c996fe7$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $b25c2e442c996fe7$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $b25c2e442c996fe7$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $b25c2e442c996fe7$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $b25c2e442c996fe7$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $b25c2e442c996fe7$var$CapturedStacks = new WeakMap();
function $b25c2e442c996fe7$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $b25c2e442c996fe7$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $b25c2e442c996fe7$var$getStackByFiberInDevAndProd(source)
        };
        $b25c2e442c996fe7$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $b25c2e442c996fe7$var$getStackByFiberInDevAndProd(source)
    };
}
var $b25c2e442c996fe7$var$forkStack = [], $b25c2e442c996fe7$var$forkStackIndex = 0, $b25c2e442c996fe7$var$treeForkProvider = null, $b25c2e442c996fe7$var$treeForkCount = 0, $b25c2e442c996fe7$var$idStack = [], $b25c2e442c996fe7$var$idStackIndex = 0, $b25c2e442c996fe7$var$treeContextProvider = null, $b25c2e442c996fe7$var$treeContextId = 1, $b25c2e442c996fe7$var$treeContextOverflow = "";
function $b25c2e442c996fe7$var$pushTreeFork(workInProgress, totalChildren) {
    $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex++] = $b25c2e442c996fe7$var$treeForkCount;
    $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex++] = $b25c2e442c996fe7$var$treeForkProvider;
    $b25c2e442c996fe7$var$treeForkProvider = workInProgress;
    $b25c2e442c996fe7$var$treeForkCount = totalChildren;
}
function $b25c2e442c996fe7$var$pushTreeId(workInProgress, totalChildren, index) {
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextId;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextOverflow;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextProvider;
    $b25c2e442c996fe7$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $b25c2e442c996fe7$var$treeContextId;
    workInProgress = $b25c2e442c996fe7$var$treeContextOverflow;
    var baseLength = 32 - $b25c2e442c996fe7$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $b25c2e442c996fe7$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $b25c2e442c996fe7$var$treeContextId = 1 << 32 - $b25c2e442c996fe7$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $b25c2e442c996fe7$var$treeContextOverflow = length + workInProgress;
    } else $b25c2e442c996fe7$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $b25c2e442c996fe7$var$treeContextOverflow = workInProgress;
}
function $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($b25c2e442c996fe7$var$pushTreeFork(workInProgress, 1), $b25c2e442c996fe7$var$pushTreeId(workInProgress, 1, 0));
}
function $b25c2e442c996fe7$var$popTreeContext(workInProgress) {
    for(; workInProgress === $b25c2e442c996fe7$var$treeForkProvider;)$b25c2e442c996fe7$var$treeForkProvider = $b25c2e442c996fe7$var$forkStack[--$b25c2e442c996fe7$var$forkStackIndex], $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex] = null, $b25c2e442c996fe7$var$treeForkCount = $b25c2e442c996fe7$var$forkStack[--$b25c2e442c996fe7$var$forkStackIndex], $b25c2e442c996fe7$var$forkStack[$b25c2e442c996fe7$var$forkStackIndex] = null;
    for(; workInProgress === $b25c2e442c996fe7$var$treeContextProvider;)$b25c2e442c996fe7$var$treeContextProvider = $b25c2e442c996fe7$var$idStack[--$b25c2e442c996fe7$var$idStackIndex], $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex] = null, $b25c2e442c996fe7$var$treeContextOverflow = $b25c2e442c996fe7$var$idStack[--$b25c2e442c996fe7$var$idStackIndex], $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex] = null, $b25c2e442c996fe7$var$treeContextId = $b25c2e442c996fe7$var$idStack[--$b25c2e442c996fe7$var$idStackIndex], $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex] = null;
}
function $b25c2e442c996fe7$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextId;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextOverflow;
    $b25c2e442c996fe7$var$idStack[$b25c2e442c996fe7$var$idStackIndex++] = $b25c2e442c996fe7$var$treeContextProvider;
    $b25c2e442c996fe7$var$treeContextId = suspendedContext.id;
    $b25c2e442c996fe7$var$treeContextOverflow = suspendedContext.overflow;
    $b25c2e442c996fe7$var$treeContextProvider = workInProgress;
}
var $b25c2e442c996fe7$var$hydrationParentFiber = null, $b25c2e442c996fe7$var$nextHydratableInstance = null, $b25c2e442c996fe7$var$isHydrating = !1, $b25c2e442c996fe7$var$hydrationErrors = null, $b25c2e442c996fe7$var$rootOrSingletonContext = !1, $b25c2e442c996fe7$var$HydrationMismatchException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(519));
function $b25c2e442c996fe7$var$throwOnHydrationMismatch(fiber) {
    var error = Error($b25c2e442c996fe7$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $b25c2e442c996fe7$var$queueHydrationError($b25c2e442c996fe7$var$createCapturedValueAtFiber(error, fiber));
    throw $b25c2e442c996fe7$var$HydrationMismatchException;
}
function $b25c2e442c996fe7$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$b25c2e442c996fe7$var$internalInstanceKey] = fiber;
    instance[$b25c2e442c996fe7$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("cancel", instance);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $b25c2e442c996fe7$var$mediaEventTypes.length; type++)$b25c2e442c996fe7$var$listenToNonDelegatedEvent($b25c2e442c996fe7$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", instance);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", instance);
            $b25c2e442c996fe7$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", instance), $b25c2e442c996fe7$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $b25c2e442c996fe7$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($b25c2e442c996fe7$var$listenToNonDelegatedEvent("beforetoggle", instance), $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $b25c2e442c996fe7$var$noop$1), instance = !0) : instance = !1;
    instance || $b25c2e442c996fe7$var$throwOnHydrationMismatch(fiber, !0);
}
function $b25c2e442c996fe7$var$popToNextHostParent(fiber) {
    for($b25c2e442c996fe7$var$hydrationParentFiber = fiber.return; $b25c2e442c996fe7$var$hydrationParentFiber;)switch($b25c2e442c996fe7$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $b25c2e442c996fe7$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $b25c2e442c996fe7$var$rootOrSingletonContext = !0;
            return;
        default:
            $b25c2e442c996fe7$var$hydrationParentFiber = $b25c2e442c996fe7$var$hydrationParentFiber.return;
    }
}
function $b25c2e442c996fe7$var$popHydrationState(fiber) {
    if (fiber !== $b25c2e442c996fe7$var$hydrationParentFiber) return !1;
    if (!$b25c2e442c996fe7$var$isHydrating) return $b25c2e442c996fe7$var$popToNextHostParent(fiber), $b25c2e442c996fe7$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $b25c2e442c996fe7$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $b25c2e442c996fe7$var$nextHydratableInstance && $b25c2e442c996fe7$var$throwOnHydrationMismatch(fiber);
    $b25c2e442c996fe7$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(317));
        $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(317));
        $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $b25c2e442c996fe7$var$nextHydratableInstance, $b25c2e442c996fe7$var$isSingletonScope(fiber.type) ? (fiber = $b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton, $b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton = null, $b25c2e442c996fe7$var$nextHydratableInstance = fiber) : $b25c2e442c996fe7$var$nextHydratableInstance = tag) : $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$hydrationParentFiber ? $b25c2e442c996fe7$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $b25c2e442c996fe7$var$resetHydrationState() {
    $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$hydrationParentFiber = null;
    $b25c2e442c996fe7$var$isHydrating = !1;
}
function $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $b25c2e442c996fe7$var$hydrationErrors;
    null !== queuedErrors && (null === $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors ? $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = queuedErrors : $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors.push.apply($b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, queuedErrors), $b25c2e442c996fe7$var$hydrationErrors = null);
    return queuedErrors;
}
function $b25c2e442c996fe7$var$queueHydrationError(error) {
    null === $b25c2e442c996fe7$var$hydrationErrors ? $b25c2e442c996fe7$var$hydrationErrors = [
        error
    ] : $b25c2e442c996fe7$var$hydrationErrors.push(error);
}
var $b25c2e442c996fe7$var$valueCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null, $b25c2e442c996fe7$var$lastContextDependency = null;
function $b25c2e442c996fe7$var$pushProvider(providerFiber, context, nextValue) {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $b25c2e442c996fe7$var$popProvider(context) {
    context._currentValue = $b25c2e442c996fe7$var$valueCursor.current;
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$valueCursor);
}
function $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $b25c2e442c996fe7$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $b25c2e442c996fe7$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($b25c2e442c996fe7$var$HostTransitionContext) : current = [
                $b25c2e442c996fe7$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $b25c2e442c996fe7$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$b25c2e442c996fe7$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $b25c2e442c996fe7$var$prepareToReadContext(workInProgress) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = workInProgress;
    $b25c2e442c996fe7$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $b25c2e442c996fe7$var$readContext(context) {
    return $b25c2e442c996fe7$var$readContextForConsumer($b25c2e442c996fe7$var$currentlyRenderingFiber$1, context);
}
function $b25c2e442c996fe7$var$readContextDuringReconciliation(consumer, context) {
    null === $b25c2e442c996fe7$var$currentlyRenderingFiber$1 && $b25c2e442c996fe7$var$prepareToReadContext(consumer);
    return $b25c2e442c996fe7$var$readContextForConsumer(consumer, context);
}
function $b25c2e442c996fe7$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $b25c2e442c996fe7$var$lastContextDependency) {
        if (null === consumer) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(308));
        $b25c2e442c996fe7$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$lastContextDependency.next = context;
    return value;
}
var $b25c2e442c996fe7$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $b25c2e442c996fe7$var$scheduleCallback$2 = $bIbqH.unstable_scheduleCallback, $b25c2e442c996fe7$var$NormalPriority = $bIbqH.unstable_NormalPriority, $b25c2e442c996fe7$var$CacheContext = {
    $$typeof: $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $b25c2e442c996fe7$var$createCache() {
    return {
        controller: new $b25c2e442c996fe7$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $b25c2e442c996fe7$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $b25c2e442c996fe7$var$scheduleCallback$2($b25c2e442c996fe7$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $b25c2e442c996fe7$var$currentEntangledListeners = null, $b25c2e442c996fe7$var$currentEntangledPendingCount = 0, $b25c2e442c996fe7$var$currentEntangledLane = 0, $b25c2e442c996fe7$var$currentEntangledActionThenable = null;
function $b25c2e442c996fe7$var$entangleAsyncAction(transition, thenable) {
    if (null === $b25c2e442c996fe7$var$currentEntangledListeners) {
        var entangledListeners = $b25c2e442c996fe7$var$currentEntangledListeners = [];
        $b25c2e442c996fe7$var$currentEntangledPendingCount = 0;
        $b25c2e442c996fe7$var$currentEntangledLane = $b25c2e442c996fe7$var$requestTransitionLane();
        $b25c2e442c996fe7$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $b25c2e442c996fe7$var$currentEntangledPendingCount++;
    thenable.then($b25c2e442c996fe7$var$pingEngtangledActionScope, $b25c2e442c996fe7$var$pingEngtangledActionScope);
    return thenable;
}
function $b25c2e442c996fe7$var$pingEngtangledActionScope() {
    if (0 === --$b25c2e442c996fe7$var$currentEntangledPendingCount && null !== $b25c2e442c996fe7$var$currentEntangledListeners) {
        null !== $b25c2e442c996fe7$var$currentEntangledActionThenable && ($b25c2e442c996fe7$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $b25c2e442c996fe7$var$currentEntangledListeners;
        $b25c2e442c996fe7$var$currentEntangledListeners = null;
        $b25c2e442c996fe7$var$currentEntangledLane = 0;
        $b25c2e442c996fe7$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $b25c2e442c996fe7$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $b25c2e442c996fe7$var$prevOnStartTransitionFinish = $b25c2e442c996fe7$var$ReactSharedInternals.S;
$b25c2e442c996fe7$var$ReactSharedInternals.S = function(transition, returnValue) {
    $b25c2e442c996fe7$var$globalMostRecentTransitionTime = $b25c2e442c996fe7$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $b25c2e442c996fe7$var$entangleAsyncAction(transition, returnValue);
    null !== $b25c2e442c996fe7$var$prevOnStartTransitionFinish && $b25c2e442c996fe7$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $b25c2e442c996fe7$var$resumedCache = $b25c2e442c996fe7$var$createCursor(null);
function $b25c2e442c996fe7$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $b25c2e442c996fe7$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $b25c2e442c996fe7$var$workInProgressRoot.pooledCache;
}
function $b25c2e442c996fe7$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$resumedCache, $b25c2e442c996fe7$var$resumedCache.current) : $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$resumedCache, prevCachePool.pool);
}
function $b25c2e442c996fe7$var$getSuspendedCache() {
    var cacheFromPool = $b25c2e442c996fe7$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $b25c2e442c996fe7$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $b25c2e442c996fe7$var$SuspenseException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(460)), $b25c2e442c996fe7$var$SuspenseyCommitException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(474)), $b25c2e442c996fe7$var$SuspenseActionException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(542)), $b25c2e442c996fe7$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $b25c2e442c996fe7$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $b25c2e442c996fe7$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($b25c2e442c996fe7$var$noop$1, $b25c2e442c996fe7$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $b25c2e442c996fe7$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($b25c2e442c996fe7$var$noop$1, $b25c2e442c996fe7$var$noop$1);
            else {
                thenableState = $b25c2e442c996fe7$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $b25c2e442c996fe7$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $b25c2e442c996fe7$var$suspendedThenable = thenable;
            throw $b25c2e442c996fe7$var$SuspenseException;
    }
}
function $b25c2e442c996fe7$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $b25c2e442c996fe7$var$suspendedThenable = x, $b25c2e442c996fe7$var$SuspenseException;
        throw x;
    }
}
var $b25c2e442c996fe7$var$suspendedThenable = null;
function $b25c2e442c996fe7$var$getSuspendedThenable() {
    if (null === $b25c2e442c996fe7$var$suspendedThenable) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(459));
    var thenable = $b25c2e442c996fe7$var$suspendedThenable;
    $b25c2e442c996fe7$var$suspendedThenable = null;
    return thenable;
}
function $b25c2e442c996fe7$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $b25c2e442c996fe7$var$SuspenseException || rejectedReason === $b25c2e442c996fe7$var$SuspenseActionException) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(483));
}
var $b25c2e442c996fe7$var$thenableState$1 = null, $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0;
function $b25c2e442c996fe7$var$unwrapThenable(thenable) {
    var index = $b25c2e442c996fe7$var$thenableIndexCounter$1;
    $b25c2e442c996fe7$var$thenableIndexCounter$1 += 1;
    null === $b25c2e442c996fe7$var$thenableState$1 && ($b25c2e442c996fe7$var$thenableState$1 = []);
    return $b25c2e442c996fe7$var$trackUsedThenable($b25c2e442c996fe7$var$thenableState$1, thenable, index);
}
function $b25c2e442c996fe7$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $b25c2e442c996fe7$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $b25c2e442c996fe7$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $b25c2e442c996fe7$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $b25c2e442c996fe7$var$REACT_LAZY_TYPE && $b25c2e442c996fe7$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $b25c2e442c996fe7$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $b25c2e442c996fe7$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $b25c2e442c996fe7$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $b25c2e442c996fe7$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $b25c2e442c996fe7$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    return lanes = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b25c2e442c996fe7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    return newChild = $b25c2e442c996fe7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild) || $b25c2e442c996fe7$var$getIteratorFn(newChild)) return newChild = $b25c2e442c996fe7$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild) || $b25c2e442c996fe7$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild) || $b25c2e442c996fe7$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b25c2e442c996fe7$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $b25c2e442c996fe7$var$REACT_LAZY_TYPE && $b25c2e442c996fe7$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $b25c2e442c996fe7$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $b25c2e442c996fe7$var$REACT_FRAGMENT_TYPE ? (lanes = $b25c2e442c996fe7$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b25c2e442c996fe7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $b25c2e442c996fe7$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $b25c2e442c996fe7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $b25c2e442c996fe7$var$REACT_LAZY_TYPE:
                    return newChild = $b25c2e442c996fe7$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($b25c2e442c996fe7$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($b25c2e442c996fe7$var$getIteratorFn(newChild)) {
                key = $b25c2e442c996fe7$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b25c2e442c996fe7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b25c2e442c996fe7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b25c2e442c996fe7$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $b25c2e442c996fe7$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $b25c2e442c996fe7$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $b25c2e442c996fe7$var$SuspenseException || x === $b25c2e442c996fe7$var$SuspenseActionException) throw x;
            var fiber = $b25c2e442c996fe7$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $b25c2e442c996fe7$var$reconcileChildFibers = $b25c2e442c996fe7$var$createChildReconciler(!0), $b25c2e442c996fe7$var$mountChildFibers = $b25c2e442c996fe7$var$createChildReconciler(!1), $b25c2e442c996fe7$var$hasForceUpdate = !1;
function $b25c2e442c996fe7$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $b25c2e442c996fe7$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b25c2e442c996fe7$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($b25c2e442c996fe7$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
        $b25c2e442c996fe7$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $b25c2e442c996fe7$var$getRootForUpdatedFiber(fiber);
}
function $b25c2e442c996fe7$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $b25c2e442c996fe7$var$markRootEntangled(root, lane);
    }
}
function $b25c2e442c996fe7$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $b25c2e442c996fe7$var$didReadFromEntangledAsyncAction = !1;
function $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($b25c2e442c996fe7$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $b25c2e442c996fe7$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $b25c2e442c996fe7$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $b25c2e442c996fe7$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $b25c2e442c996fe7$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $b25c2e442c996fe7$var$currentEntangledLane && ($b25c2e442c996fe7$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $b25c2e442c996fe7$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $b25c2e442c996fe7$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $b25c2e442c996fe7$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $b25c2e442c996fe7$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$b25c2e442c996fe7$var$callCallback(callbacks[updateQueue], context);
}
var $b25c2e442c996fe7$var$currentTreeHiddenStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$prevEntangledRenderLanesCursor = $b25c2e442c996fe7$var$createCursor(0);
function $b25c2e442c996fe7$var$pushHiddenContext(fiber, context) {
    fiber = $b25c2e442c996fe7$var$entangledRenderLanes;
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$prevEntangledRenderLanesCursor, fiber);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$currentTreeHiddenStackCursor, context);
    $b25c2e442c996fe7$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $b25c2e442c996fe7$var$reuseHiddenContextOnStack() {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$prevEntangledRenderLanesCursor, $b25c2e442c996fe7$var$entangledRenderLanes);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$currentTreeHiddenStackCursor, $b25c2e442c996fe7$var$currentTreeHiddenStackCursor.current);
}
function $b25c2e442c996fe7$var$popHiddenContext() {
    $b25c2e442c996fe7$var$entangledRenderLanes = $b25c2e442c996fe7$var$prevEntangledRenderLanesCursor.current;
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$currentTreeHiddenStackCursor);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$prevEntangledRenderLanesCursor);
}
var $b25c2e442c996fe7$var$suspenseHandlerStackCursor = $b25c2e442c996fe7$var$createCursor(null), $b25c2e442c996fe7$var$shellBoundary = null;
function $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current & 1);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, handler);
    null === $b25c2e442c996fe7$var$shellBoundary && (null === current || null !== $b25c2e442c996fe7$var$currentTreeHiddenStackCursor.current ? $b25c2e442c996fe7$var$shellBoundary = handler : null !== current.memoizedState && ($b25c2e442c996fe7$var$shellBoundary = handler));
}
function $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, fiber);
    null === $b25c2e442c996fe7$var$shellBoundary && ($b25c2e442c996fe7$var$shellBoundary = fiber);
}
function $b25c2e442c996fe7$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current), $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, fiber), null === $b25c2e442c996fe7$var$shellBoundary && ($b25c2e442c996fe7$var$shellBoundary = fiber)) : $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(fiber);
}
function $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack() {
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current);
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseHandlerStackCursor, $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current);
}
function $b25c2e442c996fe7$var$popSuspenseHandler(fiber) {
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseHandlerStackCursor);
    $b25c2e442c996fe7$var$shellBoundary === fiber && ($b25c2e442c996fe7$var$shellBoundary = null);
    $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor);
}
var $b25c2e442c996fe7$var$suspenseStackCursor = $b25c2e442c996fe7$var$createCursor(0);
function $b25c2e442c996fe7$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $b25c2e442c996fe7$var$isSuspenseInstancePending(state) || $b25c2e442c996fe7$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $b25c2e442c996fe7$var$renderLanes = 0, $b25c2e442c996fe7$var$currentlyRenderingFiber = null, $b25c2e442c996fe7$var$currentHook = null, $b25c2e442c996fe7$var$workInProgressHook = null, $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !1, $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $b25c2e442c996fe7$var$localIdCounter = 0, $b25c2e442c996fe7$var$thenableIndexCounter = 0, $b25c2e442c996fe7$var$thenableState = null, $b25c2e442c996fe7$var$globalClientIdCounter = 0;
function $b25c2e442c996fe7$var$throwInvalidHookError() {
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(321));
}
function $b25c2e442c996fe7$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$b25c2e442c996fe7$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $b25c2e442c996fe7$var$renderLanes = nextRenderLanes;
    $b25c2e442c996fe7$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $b25c2e442c996fe7$var$HooksDispatcherOnMount : $b25c2e442c996fe7$var$HooksDispatcherOnUpdate;
    $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $b25c2e442c996fe7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $b25c2e442c996fe7$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $b25c2e442c996fe7$var$finishRenderingHooks(current) {
    $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $b25c2e442c996fe7$var$currentHook && null !== $b25c2e442c996fe7$var$currentHook.next;
    $b25c2e442c996fe7$var$renderLanes = 0;
    $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$currentHook = $b25c2e442c996fe7$var$currentlyRenderingFiber = null;
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !1;
    $b25c2e442c996fe7$var$thenableIndexCounter = 0;
    $b25c2e442c996fe7$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(300));
    null === current || $b25c2e442c996fe7$var$didReceiveUpdate || (current = current.dependencies, null !== current && $b25c2e442c996fe7$var$checkIfContextChanged(current) && ($b25c2e442c996fe7$var$didReceiveUpdate = !0));
}
function $b25c2e442c996fe7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass && ($b25c2e442c996fe7$var$thenableState = null);
        $b25c2e442c996fe7$var$thenableIndexCounter = 0;
        $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $b25c2e442c996fe7$var$TransitionAwareHostComponent() {
    var dispatcher = $b25c2e442c996fe7$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $b25c2e442c996fe7$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $b25c2e442c996fe7$var$currentHook ? $b25c2e442c996fe7$var$currentHook.memoizedState : null) !== dispatcher && ($b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $b25c2e442c996fe7$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $b25c2e442c996fe7$var$localIdCounter;
    $b25c2e442c996fe7$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $b25c2e442c996fe7$var$resetHooksOnUnwind(workInProgress) {
    if ($b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !1;
    }
    $b25c2e442c996fe7$var$renderLanes = 0;
    $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$currentHook = $b25c2e442c996fe7$var$currentlyRenderingFiber = null;
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $b25c2e442c996fe7$var$thenableIndexCounter = $b25c2e442c996fe7$var$localIdCounter = 0;
    $b25c2e442c996fe7$var$thenableState = null;
}
function $b25c2e442c996fe7$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b25c2e442c996fe7$var$workInProgressHook ? $b25c2e442c996fe7$var$currentlyRenderingFiber.memoizedState = $b25c2e442c996fe7$var$workInProgressHook = hook : $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$workInProgressHook.next = hook;
    return $b25c2e442c996fe7$var$workInProgressHook;
}
function $b25c2e442c996fe7$var$updateWorkInProgressHook() {
    if (null === $b25c2e442c996fe7$var$currentHook) {
        var nextCurrentHook = $b25c2e442c996fe7$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $b25c2e442c996fe7$var$currentHook.next;
    var nextWorkInProgressHook = null === $b25c2e442c996fe7$var$workInProgressHook ? $b25c2e442c996fe7$var$currentlyRenderingFiber.memoizedState : $b25c2e442c996fe7$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $b25c2e442c996fe7$var$workInProgressHook = nextWorkInProgressHook, $b25c2e442c996fe7$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $b25c2e442c996fe7$var$currentlyRenderingFiber.alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(467));
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(310));
        }
        $b25c2e442c996fe7$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $b25c2e442c996fe7$var$currentHook.memoizedState,
            baseState: $b25c2e442c996fe7$var$currentHook.baseState,
            baseQueue: $b25c2e442c996fe7$var$currentHook.baseQueue,
            queue: $b25c2e442c996fe7$var$currentHook.queue,
            next: null
        };
        null === $b25c2e442c996fe7$var$workInProgressHook ? $b25c2e442c996fe7$var$currentlyRenderingFiber.memoizedState = $b25c2e442c996fe7$var$workInProgressHook = nextCurrentHook : $b25c2e442c996fe7$var$workInProgressHook = $b25c2e442c996fe7$var$workInProgressHook.next = nextCurrentHook;
    }
    return $b25c2e442c996fe7$var$workInProgressHook;
}
function $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $b25c2e442c996fe7$var$useThenable(thenable) {
    var index = $b25c2e442c996fe7$var$thenableIndexCounter;
    $b25c2e442c996fe7$var$thenableIndexCounter += 1;
    null === $b25c2e442c996fe7$var$thenableState && ($b25c2e442c996fe7$var$thenableState = []);
    thenable = $b25c2e442c996fe7$var$trackUsedThenable($b25c2e442c996fe7$var$thenableState, thenable, index);
    index = $b25c2e442c996fe7$var$currentlyRenderingFiber;
    null === (null === $b25c2e442c996fe7$var$workInProgressHook ? index.memoizedState : $b25c2e442c996fe7$var$workInProgressHook.next) && (index = index.alternate, $b25c2e442c996fe7$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $b25c2e442c996fe7$var$HooksDispatcherOnMount : $b25c2e442c996fe7$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $b25c2e442c996fe7$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $b25c2e442c996fe7$var$useThenable(usable);
        if (usable.$$typeof === $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE) return $b25c2e442c996fe7$var$readContext(usable);
    }
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(438, String(usable)));
}
function $b25c2e442c996fe7$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $b25c2e442c996fe7$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $b25c2e442c996fe7$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $b25c2e442c996fe7$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $b25c2e442c996fe7$var$updateReducer(reducer) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    return $b25c2e442c996fe7$var$updateReducerImpl(hook, $b25c2e442c996fe7$var$currentHook, reducer);
}
function $b25c2e442c996fe7$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($b25c2e442c996fe7$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $b25c2e442c996fe7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($b25c2e442c996fe7$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $b25c2e442c996fe7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= revertLane, $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= updateLane, $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$b25c2e442c996fe7$var$objectIs(pendingQueue, hook.memoizedState) && ($b25c2e442c996fe7$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $b25c2e442c996fe7$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $b25c2e442c996fe7$var$rerenderReducer(reducer) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $b25c2e442c996fe7$var$objectIs(newState, hook.memoizedState) || ($b25c2e442c996fe7$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $b25c2e442c996fe7$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $b25c2e442c996fe7$var$currentlyRenderingFiber, hook = $b25c2e442c996fe7$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $b25c2e442c996fe7$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$b25c2e442c996fe7$var$objectIs(($b25c2e442c996fe7$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $b25c2e442c996fe7$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $b25c2e442c996fe7$var$updateEffect($b25c2e442c996fe7$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $b25c2e442c996fe7$var$workInProgressHook && $b25c2e442c996fe7$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $b25c2e442c996fe7$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b25c2e442c996fe7$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $b25c2e442c996fe7$var$workInProgressRoot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($b25c2e442c996fe7$var$renderLanes & 127) || $b25c2e442c996fe7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $b25c2e442c996fe7$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $b25c2e442c996fe7$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $b25c2e442c996fe7$var$checkIfSnapshotChanged(inst) && $b25c2e442c996fe7$var$forceStoreRerender(fiber);
}
function $b25c2e442c996fe7$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $b25c2e442c996fe7$var$checkIfSnapshotChanged(inst) && $b25c2e442c996fe7$var$forceStoreRerender(fiber);
    });
}
function $b25c2e442c996fe7$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b25c2e442c996fe7$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b25c2e442c996fe7$var$forceStoreRerender(fiber) {
    var root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $b25c2e442c996fe7$var$mountStateImpl(initialState) {
    var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b25c2e442c996fe7$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $b25c2e442c996fe7$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $b25c2e442c996fe7$var$updateReducerImpl(hook, $b25c2e442c996fe7$var$currentHook, "function" === typeof reducer ? reducer : $b25c2e442c996fe7$var$basicStateReducer);
}
function $b25c2e442c996fe7$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $b25c2e442c996fe7$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $b25c2e442c996fe7$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $b25c2e442c996fe7$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T, currentTransition = {};
        $b25c2e442c996fe7$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $b25c2e442c996fe7$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $b25c2e442c996fe7$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $b25c2e442c996fe7$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $b25c2e442c996fe7$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $b25c2e442c996fe7$var$onActionError(actionQueue, node, error$66);
    }
}
function $b25c2e442c996fe7$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $b25c2e442c996fe7$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $b25c2e442c996fe7$var$onActionError(actionQueue, node, error);
    }) : $b25c2e442c996fe7$var$onActionSuccess(actionQueue, node, returnValue);
}
function $b25c2e442c996fe7$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $b25c2e442c996fe7$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $b25c2e442c996fe7$var$runActionStateAction(actionQueue, nextState)));
}
function $b25c2e442c996fe7$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $b25c2e442c996fe7$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $b25c2e442c996fe7$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $b25c2e442c996fe7$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $b25c2e442c996fe7$var$mountActionState(action, initialStateProp) {
    if ($b25c2e442c996fe7$var$isHydrating) {
        var ssrFormState = $b25c2e442c996fe7$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $b25c2e442c996fe7$var$currentlyRenderingFiber;
                if ($b25c2e442c996fe7$var$isHydrating) {
                    if ($b25c2e442c996fe7$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $b25c2e442c996fe7$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $b25c2e442c996fe7$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $b25c2e442c996fe7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $b25c2e442c996fe7$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b25c2e442c996fe7$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $b25c2e442c996fe7$var$dispatchSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $b25c2e442c996fe7$var$mountStateImpl(!1);
    inRootOrSingleton = $b25c2e442c996fe7$var$dispatchOptimisticSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $b25c2e442c996fe7$var$dispatchActionState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $b25c2e442c996fe7$var$updateActionState(action) {
    var stateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    return $b25c2e442c996fe7$var$updateActionStateImpl(stateHook, $b25c2e442c996fe7$var$currentHook, action);
}
function $b25c2e442c996fe7$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $b25c2e442c996fe7$var$updateReducerImpl(stateHook, currentStateHook, $b25c2e442c996fe7$var$actionStateReducer)[0];
    stateHook = $b25c2e442c996fe7$var$updateReducer($b25c2e442c996fe7$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $b25c2e442c996fe7$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $b25c2e442c996fe7$var$SuspenseException) throw $b25c2e442c996fe7$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= 2048, $b25c2e442c996fe7$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $b25c2e442c996fe7$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $b25c2e442c996fe7$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $b25c2e442c996fe7$var$rerenderActionState(action) {
    var stateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook(), currentStateHook = $b25c2e442c996fe7$var$currentHook;
    if (null !== currentStateHook) return $b25c2e442c996fe7$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $b25c2e442c996fe7$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $b25c2e442c996fe7$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $b25c2e442c996fe7$var$updateRef() {
    return $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
}
function $b25c2e442c996fe7$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
    $b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $b25c2e442c996fe7$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $b25c2e442c996fe7$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $b25c2e442c996fe7$var$currentHook && null !== deps && $b25c2e442c996fe7$var$areHookInputsEqual(deps, $b25c2e442c996fe7$var$currentHook.memoizedState.deps) ? hook.memoizedState = $b25c2e442c996fe7$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $b25c2e442c996fe7$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $b25c2e442c996fe7$var$mountEffect(create, deps) {
    $b25c2e442c996fe7$var$mountEffectImpl(8390656, 8, create, deps);
}
function $b25c2e442c996fe7$var$updateEffect(create, deps) {
    $b25c2e442c996fe7$var$updateEffectImpl(2048, 8, create, deps);
}
function $b25c2e442c996fe7$var$useEffectEventImpl(payload) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $b25c2e442c996fe7$var$createFunctionComponentUpdateQueue(), $b25c2e442c996fe7$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $b25c2e442c996fe7$var$updateEvent(callback) {
    var ref = $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
    $b25c2e442c996fe7$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($b25c2e442c996fe7$var$executionContext & 2)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $b25c2e442c996fe7$var$updateInsertionEffect(create, deps) {
    return $b25c2e442c996fe7$var$updateEffectImpl(4, 2, create, deps);
}
function $b25c2e442c996fe7$var$updateLayoutEffect(create, deps) {
    return $b25c2e442c996fe7$var$updateEffectImpl(4, 4, create, deps);
}
function $b25c2e442c996fe7$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $b25c2e442c996fe7$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $b25c2e442c996fe7$var$updateEffectImpl(4, 4, $b25c2e442c996fe7$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $b25c2e442c996fe7$var$mountDebugValue() {}
function $b25c2e442c996fe7$var$updateCallback(callback, deps) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b25c2e442c996fe7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $b25c2e442c996fe7$var$updateMemo(nextCreate, deps) {
    var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b25c2e442c996fe7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($b25c2e442c996fe7$var$renderLanes & 1073741824) && 0 === ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $b25c2e442c996fe7$var$requestDeferredLane();
    $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= hook;
    $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $b25c2e442c996fe7$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($b25c2e442c996fe7$var$objectIs(value, prevValue)) return value;
    if (null !== $b25c2e442c996fe7$var$currentTreeHiddenStackCursor.current) return hook = $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue), $b25c2e442c996fe7$var$objectIs(hook, prevValue) || ($b25c2e442c996fe7$var$didReceiveUpdate = !0), hook;
    if (0 === ($b25c2e442c996fe7$var$renderLanes & 42) || 0 !== ($b25c2e442c996fe7$var$renderLanes & 1073741824) && 0 === ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 261930)) return $b25c2e442c996fe7$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $b25c2e442c996fe7$var$requestDeferredLane();
    $b25c2e442c996fe7$var$currentlyRenderingFiber.lanes |= hook;
    $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $b25c2e442c996fe7$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T, currentTransition = {};
    $b25c2e442c996fe7$var$ReactSharedInternals.T = currentTransition;
    $b25c2e442c996fe7$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $b25c2e442c996fe7$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $b25c2e442c996fe7$var$chainThenableValue(returnValue, finishedState);
            $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $b25c2e442c996fe7$var$requestUpdateLane(fiber));
        } else $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, finishedState, $b25c2e442c996fe7$var$requestUpdateLane(fiber));
    } catch (error) {
        $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $b25c2e442c996fe7$var$requestUpdateLane());
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b25c2e442c996fe7$var$noop() {}
function $b25c2e442c996fe7$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(476));
    var queue = $b25c2e442c996fe7$var$ensureFormComponentIsStateful(formFiber).queue;
    $b25c2e442c996fe7$var$startTransition(formFiber, queue, pendingState, $b25c2e442c996fe7$var$sharedNotPendingObject, null === action ? $b25c2e442c996fe7$var$noop : function() {
        $b25c2e442c996fe7$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $b25c2e442c996fe7$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $b25c2e442c996fe7$var$sharedNotPendingObject,
        baseState: $b25c2e442c996fe7$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b25c2e442c996fe7$var$basicStateReducer,
            lastRenderedState: $b25c2e442c996fe7$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b25c2e442c996fe7$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $b25c2e442c996fe7$var$requestFormReset$1(formFiber) {
    var stateHook = $b25c2e442c996fe7$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $b25c2e442c996fe7$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $b25c2e442c996fe7$var$requestUpdateLane());
}
function $b25c2e442c996fe7$var$useHostTransitionStatus() {
    return $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$HostTransitionContext);
}
function $b25c2e442c996fe7$var$updateId() {
    return $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
}
function $b25c2e442c996fe7$var$updateRefresh() {
    return $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
}
function $b25c2e442c996fe7$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $b25c2e442c996fe7$var$requestUpdateLane();
                fiber = $b25c2e442c996fe7$var$createUpdate(lane);
                var root$69 = $b25c2e442c996fe7$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(root$69, provider, lane), $b25c2e442c996fe7$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $b25c2e442c996fe7$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $b25c2e442c996fe7$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $b25c2e442c996fe7$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber) ? $b25c2e442c996fe7$var$enqueueRenderPhaseUpdate(queue, action) : (action = $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(action, fiber, lane), $b25c2e442c996fe7$var$entangleTransitionUpdate(action, queue, lane)));
}
function $b25c2e442c996fe7$var$dispatchSetState(fiber, queue, action) {
    var lane = $b25c2e442c996fe7$var$requestUpdateLane();
    $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $b25c2e442c996fe7$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber)) $b25c2e442c996fe7$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($b25c2e442c996fe7$var$objectIs(eagerState, currentState)) return $b25c2e442c996fe7$var$enqueueUpdate$1(fiber, queue, update, 0), null === $b25c2e442c996fe7$var$workInProgressRoot && $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $b25c2e442c996fe7$var$scheduleUpdateOnFiber(action, fiber, lane), $b25c2e442c996fe7$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $b25c2e442c996fe7$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $b25c2e442c996fe7$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $b25c2e442c996fe7$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $b25c2e442c996fe7$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $b25c2e442c996fe7$var$currentlyRenderingFiber || null !== alternate && alternate === $b25c2e442c996fe7$var$currentlyRenderingFiber;
}
function $b25c2e442c996fe7$var$enqueueRenderPhaseUpdate(queue, update) {
    $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdateDuringThisPass = $b25c2e442c996fe7$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $b25c2e442c996fe7$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $b25c2e442c996fe7$var$markRootEntangled(root, lane);
    }
}
var $b25c2e442c996fe7$var$ContextOnlyDispatcher = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: $b25c2e442c996fe7$var$throwInvalidHookError,
    useContext: $b25c2e442c996fe7$var$throwInvalidHookError,
    useEffect: $b25c2e442c996fe7$var$throwInvalidHookError,
    useImperativeHandle: $b25c2e442c996fe7$var$throwInvalidHookError,
    useLayoutEffect: $b25c2e442c996fe7$var$throwInvalidHookError,
    useInsertionEffect: $b25c2e442c996fe7$var$throwInvalidHookError,
    useMemo: $b25c2e442c996fe7$var$throwInvalidHookError,
    useReducer: $b25c2e442c996fe7$var$throwInvalidHookError,
    useRef: $b25c2e442c996fe7$var$throwInvalidHookError,
    useState: $b25c2e442c996fe7$var$throwInvalidHookError,
    useDebugValue: $b25c2e442c996fe7$var$throwInvalidHookError,
    useDeferredValue: $b25c2e442c996fe7$var$throwInvalidHookError,
    useTransition: $b25c2e442c996fe7$var$throwInvalidHookError,
    useSyncExternalStore: $b25c2e442c996fe7$var$throwInvalidHookError,
    useId: $b25c2e442c996fe7$var$throwInvalidHookError,
    useHostTransitionStatus: $b25c2e442c996fe7$var$throwInvalidHookError,
    useFormState: $b25c2e442c996fe7$var$throwInvalidHookError,
    useActionState: $b25c2e442c996fe7$var$throwInvalidHookError,
    useOptimistic: $b25c2e442c996fe7$var$throwInvalidHookError,
    useMemoCache: $b25c2e442c996fe7$var$throwInvalidHookError,
    useCacheRefresh: $b25c2e442c996fe7$var$throwInvalidHookError
};
$b25c2e442c996fe7$var$ContextOnlyDispatcher.useEffectEvent = $b25c2e442c996fe7$var$throwInvalidHookError;
var $b25c2e442c996fe7$var$HooksDispatcherOnMount = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: function(callback, deps) {
        $b25c2e442c996fe7$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $b25c2e442c996fe7$var$readContext,
    useEffect: $b25c2e442c996fe7$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $b25c2e442c996fe7$var$mountEffectImpl(4194308, 4, $b25c2e442c996fe7$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $b25c2e442c996fe7$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $b25c2e442c996fe7$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($b25c2e442c996fe7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $b25c2e442c996fe7$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $b25c2e442c996fe7$var$dispatchReducerAction.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $b25c2e442c996fe7$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $b25c2e442c996fe7$var$dispatchSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $b25c2e442c996fe7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        return $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $b25c2e442c996fe7$var$mountStateImpl(!1);
        stateHook = $b25c2e442c996fe7$var$startTransition.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $b25c2e442c996fe7$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $b25c2e442c996fe7$var$currentlyRenderingFiber, hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        if ($b25c2e442c996fe7$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $b25c2e442c996fe7$var$workInProgressRoot) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(349));
            0 !== ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 127) || $b25c2e442c996fe7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $b25c2e442c996fe7$var$mountEffect($b25c2e442c996fe7$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $b25c2e442c996fe7$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b25c2e442c996fe7$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook(), identifierPrefix = $b25c2e442c996fe7$var$workInProgressRoot.identifierPrefix;
        if ($b25c2e442c996fe7$var$isHydrating) {
            var JSCompiler_inline_result = $b25c2e442c996fe7$var$treeContextOverflow;
            var idWithLeadingBit = $b25c2e442c996fe7$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $b25c2e442c996fe7$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $b25c2e442c996fe7$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $b25c2e442c996fe7$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $b25c2e442c996fe7$var$useHostTransitionStatus,
    useFormState: $b25c2e442c996fe7$var$mountActionState,
    useActionState: $b25c2e442c996fe7$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $b25c2e442c996fe7$var$dispatchOptimisticSetState.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $b25c2e442c996fe7$var$useMemoCache,
    useCacheRefresh: function() {
        return $b25c2e442c996fe7$var$mountWorkInProgressHook().memoizedState = $b25c2e442c996fe7$var$refreshCache.bind(null, $b25c2e442c996fe7$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $b25c2e442c996fe7$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($b25c2e442c996fe7$var$executionContext & 2)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $b25c2e442c996fe7$var$HooksDispatcherOnUpdate = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: $b25c2e442c996fe7$var$updateCallback,
    useContext: $b25c2e442c996fe7$var$readContext,
    useEffect: $b25c2e442c996fe7$var$updateEffect,
    useImperativeHandle: $b25c2e442c996fe7$var$updateImperativeHandle,
    useInsertionEffect: $b25c2e442c996fe7$var$updateInsertionEffect,
    useLayoutEffect: $b25c2e442c996fe7$var$updateLayoutEffect,
    useMemo: $b25c2e442c996fe7$var$updateMemo,
    useReducer: $b25c2e442c996fe7$var$updateReducer,
    useRef: $b25c2e442c996fe7$var$updateRef,
    useState: function() {
        return $b25c2e442c996fe7$var$updateReducer($b25c2e442c996fe7$var$basicStateReducer);
    },
    useDebugValue: $b25c2e442c996fe7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        return $b25c2e442c996fe7$var$updateDeferredValueImpl(hook, $b25c2e442c996fe7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b25c2e442c996fe7$var$updateReducer($b25c2e442c996fe7$var$basicStateReducer)[0], start = $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b25c2e442c996fe7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b25c2e442c996fe7$var$updateSyncExternalStore,
    useId: $b25c2e442c996fe7$var$updateId,
    useHostTransitionStatus: $b25c2e442c996fe7$var$useHostTransitionStatus,
    useFormState: $b25c2e442c996fe7$var$updateActionState,
    useActionState: $b25c2e442c996fe7$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        return $b25c2e442c996fe7$var$updateOptimisticImpl(hook, $b25c2e442c996fe7$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $b25c2e442c996fe7$var$useMemoCache,
    useCacheRefresh: $b25c2e442c996fe7$var$updateRefresh
};
$b25c2e442c996fe7$var$HooksDispatcherOnUpdate.useEffectEvent = $b25c2e442c996fe7$var$updateEvent;
var $b25c2e442c996fe7$var$HooksDispatcherOnRerender = {
    readContext: $b25c2e442c996fe7$var$readContext,
    use: $b25c2e442c996fe7$var$use,
    useCallback: $b25c2e442c996fe7$var$updateCallback,
    useContext: $b25c2e442c996fe7$var$readContext,
    useEffect: $b25c2e442c996fe7$var$updateEffect,
    useImperativeHandle: $b25c2e442c996fe7$var$updateImperativeHandle,
    useInsertionEffect: $b25c2e442c996fe7$var$updateInsertionEffect,
    useLayoutEffect: $b25c2e442c996fe7$var$updateLayoutEffect,
    useMemo: $b25c2e442c996fe7$var$updateMemo,
    useReducer: $b25c2e442c996fe7$var$rerenderReducer,
    useRef: $b25c2e442c996fe7$var$updateRef,
    useState: function() {
        return $b25c2e442c996fe7$var$rerenderReducer($b25c2e442c996fe7$var$basicStateReducer);
    },
    useDebugValue: $b25c2e442c996fe7$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        return null === $b25c2e442c996fe7$var$currentHook ? $b25c2e442c996fe7$var$mountDeferredValueImpl(hook, value, initialValue) : $b25c2e442c996fe7$var$updateDeferredValueImpl(hook, $b25c2e442c996fe7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b25c2e442c996fe7$var$rerenderReducer($b25c2e442c996fe7$var$basicStateReducer)[0], start = $b25c2e442c996fe7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b25c2e442c996fe7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b25c2e442c996fe7$var$updateSyncExternalStore,
    useId: $b25c2e442c996fe7$var$updateId,
    useHostTransitionStatus: $b25c2e442c996fe7$var$useHostTransitionStatus,
    useFormState: $b25c2e442c996fe7$var$rerenderActionState,
    useActionState: $b25c2e442c996fe7$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b25c2e442c996fe7$var$updateWorkInProgressHook();
        if (null !== $b25c2e442c996fe7$var$currentHook) return $b25c2e442c996fe7$var$updateOptimisticImpl(hook, $b25c2e442c996fe7$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $b25c2e442c996fe7$var$useMemoCache,
    useCacheRefresh: $b25c2e442c996fe7$var$updateRefresh
};
$b25c2e442c996fe7$var$HooksDispatcherOnRerender.useEffectEvent = $b25c2e442c996fe7$var$updateEvent;
function $b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $b25c2e442c996fe7$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $b25c2e442c996fe7$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b25c2e442c996fe7$var$requestUpdateLane(), update = $b25c2e442c996fe7$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b25c2e442c996fe7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(payload, inst, lane), $b25c2e442c996fe7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b25c2e442c996fe7$var$requestUpdateLane(), update = $b25c2e442c996fe7$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b25c2e442c996fe7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(payload, inst, lane), $b25c2e442c996fe7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $b25c2e442c996fe7$var$requestUpdateLane(), update = $b25c2e442c996fe7$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $b25c2e442c996fe7$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(callback, inst, lane), $b25c2e442c996fe7$var$entangleTransitions(callback, inst, lane));
    }
};
function $b25c2e442c996fe7$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$b25c2e442c996fe7$var$shallowEqual(oldProps, newProps) || !$b25c2e442c996fe7$var$shallowEqual(oldState, newState) : !0;
}
function $b25c2e442c996fe7$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $b25c2e442c996fe7$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $b25c2e442c996fe7$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $b25c2e442c996fe7$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $b25c2e442c996fe7$var$defaultOnUncaughtError(error) {
    $b25c2e442c996fe7$var$reportGlobalError(error);
}
function $b25c2e442c996fe7$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $b25c2e442c996fe7$var$defaultOnRecoverableError(error) {
    $b25c2e442c996fe7$var$reportGlobalError(error);
}
function $b25c2e442c996fe7$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $b25c2e442c996fe7$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $b25c2e442c996fe7$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $b25c2e442c996fe7$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $b25c2e442c996fe7$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $b25c2e442c996fe7$var$createClassErrorUpdate(lane) {
    lane = $b25c2e442c996fe7$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $b25c2e442c996fe7$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $b25c2e442c996fe7$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $b25c2e442c996fe7$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed ? $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $b25c2e442c996fe7$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $b25c2e442c996fe7$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $b25c2e442c996fe7$var$shellBoundary ? $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $b25c2e442c996fe7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $b25c2e442c996fe7$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $b25c2e442c996fe7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $b25c2e442c996fe7$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $b25c2e442c996fe7$var$attachPingListener(root, value, rootRenderLanes);
        $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($b25c2e442c996fe7$var$isHydrating) return returnFiber = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $b25c2e442c996fe7$var$HydrationMismatchException && (root = Error($b25c2e442c996fe7$var$formatProdErrorMessage(422), {
        cause: value
    }), $b25c2e442c996fe7$var$queueHydrationError($b25c2e442c996fe7$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $b25c2e442c996fe7$var$HydrationMismatchException && (returnFiber = Error($b25c2e442c996fe7$var$formatProdErrorMessage(423), {
        cause: value
    }), $b25c2e442c996fe7$var$queueHydrationError($b25c2e442c996fe7$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $b25c2e442c996fe7$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $b25c2e442c996fe7$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $b25c2e442c996fe7$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($b25c2e442c996fe7$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $b25c2e442c996fe7$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors ? $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $b25c2e442c996fe7$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $b25c2e442c996fe7$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $b25c2e442c996fe7$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed || !$b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $b25c2e442c996fe7$var$createClassErrorUpdate(rootRenderLanes), $b25c2e442c996fe7$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $b25c2e442c996fe7$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $b25c2e442c996fe7$var$SelectiveHydrationException = Error($b25c2e442c996fe7$var$formatProdErrorMessage(461)), $b25c2e442c996fe7$var$didReceiveUpdate = !1;
function $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $b25c2e442c996fe7$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $b25c2e442c996fe7$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    nextProps = $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $b25c2e442c996fe7$var$checkDidRenderIdHook();
    if (null !== current && !$b25c2e442c996fe7$var$didReceiveUpdate) return $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, renderLanes), $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b25c2e442c996fe7$var$isHydrating && key && $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$b25c2e442c996fe7$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $b25c2e442c996fe7$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $b25c2e442c996fe7$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $b25c2e442c996fe7$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $b25c2e442c996fe7$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $b25c2e442c996fe7$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($b25c2e442c996fe7$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($b25c2e442c996fe7$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($b25c2e442c996fe7$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $b25c2e442c996fe7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $b25c2e442c996fe7$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $b25c2e442c996fe7$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $b25c2e442c996fe7$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $b25c2e442c996fe7$var$pushHiddenContext(workInProgress, prevState) : $b25c2e442c996fe7$var$reuseHiddenContextOnStack(), $b25c2e442c996fe7$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $b25c2e442c996fe7$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($b25c2e442c996fe7$var$pushTransition(workInProgress, prevState.cachePool), $b25c2e442c996fe7$var$pushHiddenContext(workInProgress, prevState), $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $b25c2e442c996fe7$var$pushTransition(workInProgress, null), $b25c2e442c996fe7$var$reuseHiddenContextOnStack(), $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress));
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $b25c2e442c996fe7$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $b25c2e442c996fe7$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $b25c2e442c996fe7$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $b25c2e442c996fe7$var$pushTransition(workInProgress, null);
    $b25c2e442c996fe7$var$reuseHiddenContextOnStack();
    $b25c2e442c996fe7$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $b25c2e442c996fe7$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $b25c2e442c996fe7$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($b25c2e442c996fe7$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, current);
            $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $b25c2e442c996fe7$var$nextHydratableInstance) ? (current = $b25c2e442c996fe7$var$canHydrateHydrationBoundary(current, $b25c2e442c996fe7$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b25c2e442c996fe7$var$treeContextProvider ? {
                    id: $b25c2e442c996fe7$var$treeContextId,
                    overflow: $b25c2e442c996fe7$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b25c2e442c996fe7$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $b25c2e442c996fe7$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(558));
        } else if ($b25c2e442c996fe7$var$didReceiveUpdate || $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $b25c2e442c996fe7$var$didReceiveUpdate || didSuspend) {
            nextProps = $b25c2e442c996fe7$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $b25c2e442c996fe7$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(current, dehydrated), $b25c2e442c996fe7$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $b25c2e442c996fe7$var$SelectiveHydrationException;
            $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b25c2e442c996fe7$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(dehydrated.nextSibling), $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$isHydrating = !0, $b25c2e442c996fe7$var$hydrationErrors = null, $b25c2e442c996fe7$var$rootOrSingletonContext = !1, null !== current && $b25c2e442c996fe7$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b25c2e442c996fe7$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $b25c2e442c996fe7$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $b25c2e442c996fe7$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $b25c2e442c996fe7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    Component = $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $b25c2e442c996fe7$var$checkDidRenderIdHook();
    if (null !== current && !$b25c2e442c996fe7$var$didReceiveUpdate) return $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, renderLanes), $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b25c2e442c996fe7$var$isHydrating && nextProps && $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $b25c2e442c996fe7$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $b25c2e442c996fe7$var$finishRenderingHooks(current);
    Component = $b25c2e442c996fe7$var$checkDidRenderIdHook();
    if (null !== current && !$b25c2e442c996fe7$var$didReceiveUpdate) return $b25c2e442c996fe7$var$bailoutHooks(current, workInProgress, renderLanes), $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b25c2e442c996fe7$var$isHydrating && Component && $b25c2e442c996fe7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b25c2e442c996fe7$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $b25c2e442c996fe7$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $b25c2e442c996fe7$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $b25c2e442c996fe7$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $b25c2e442c996fe7$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $b25c2e442c996fe7$var$readContext(contextType) : $b25c2e442c996fe7$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $b25c2e442c996fe7$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $b25c2e442c996fe7$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $b25c2e442c996fe7$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $b25c2e442c996fe7$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $b25c2e442c996fe7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $b25c2e442c996fe7$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $b25c2e442c996fe7$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $b25c2e442c996fe7$var$hasForceUpdate || $b25c2e442c996fe7$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $b25c2e442c996fe7$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $b25c2e442c996fe7$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $b25c2e442c996fe7$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $b25c2e442c996fe7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $b25c2e442c996fe7$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $b25c2e442c996fe7$var$hasForceUpdate || null !== current && null !== current.dependencies && $b25c2e442c996fe7$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($b25c2e442c996fe7$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $b25c2e442c996fe7$var$hasForceUpdate || $b25c2e442c996fe7$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $b25c2e442c996fe7$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $b25c2e442c996fe7$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $b25c2e442c996fe7$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $b25c2e442c996fe7$var$resetHydrationState();
    workInProgress.flags |= 256;
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $b25c2e442c996fe7$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $b25c2e442c996fe7$var$getSuspendedCache()
    };
}
function $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $b25c2e442c996fe7$var$workInProgressDeferredLane);
    return current;
}
function $b25c2e442c996fe7$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($b25c2e442c996fe7$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($b25c2e442c996fe7$var$isHydrating) {
            showFallback ? $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $b25c2e442c996fe7$var$nextHydratableInstance) ? (current = $b25c2e442c996fe7$var$canHydrateHydrationBoundary(current, $b25c2e442c996fe7$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b25c2e442c996fe7$var$treeContextProvider ? {
                    id: $b25c2e442c996fe7$var$treeContextId,
                    overflow: $b25c2e442c996fe7$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b25c2e442c996fe7$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            $b25c2e442c996fe7$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $b25c2e442c996fe7$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b25c2e442c996fe7$var$SUSPENDED_MARKER, $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, nextProps);
        $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $b25c2e442c996fe7$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b25c2e442c996fe7$var$SUSPENDED_MARKER, workInProgress = $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, nextProps));
        else if ($b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress), $b25c2e442c996fe7$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($b25c2e442c996fe7$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $b25c2e442c996fe7$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($b25c2e442c996fe7$var$didReceiveUpdate || $b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $b25c2e442c996fe7$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $b25c2e442c996fe7$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $b25c2e442c996fe7$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(current, nextProps), $b25c2e442c996fe7$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $b25c2e442c996fe7$var$SelectiveHydrationException;
            $b25c2e442c996fe7$var$isSuspenseInstancePending(nextPrimaryChildren) || $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $b25c2e442c996fe7$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(nextPrimaryChildren.nextSibling), $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$isHydrating = !0, $b25c2e442c996fe7$var$hydrationErrors = null, $b25c2e442c996fe7$var$rootOrSingletonContext = !1, null !== current && $b25c2e442c996fe7$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $b25c2e442c996fe7$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $b25c2e442c996fe7$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $b25c2e442c996fe7$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $b25c2e442c996fe7$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b25c2e442c996fe7$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $b25c2e442c996fe7$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $b25c2e442c996fe7$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $b25c2e442c996fe7$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $b25c2e442c996fe7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b25c2e442c996fe7$var$SUSPENDED_MARKER, $b25c2e442c996fe7$var$bailoutOffscreenComponent(current.child, nextProps);
    $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $b25c2e442c996fe7$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $b25c2e442c996fe7$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $b25c2e442c996fe7$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $b25c2e442c996fe7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b25c2e442c996fe7$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $b25c2e442c996fe7$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $b25c2e442c996fe7$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $b25c2e442c996fe7$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $b25c2e442c996fe7$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, suspenseContext);
    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $b25c2e442c996fe7$var$isHydrating ? $b25c2e442c996fe7$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $b25c2e442c996fe7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $b25c2e442c996fe7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $b25c2e442c996fe7$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $b25c2e442c996fe7$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $b25c2e442c996fe7$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $b25c2e442c996fe7$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $b25c2e442c996fe7$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $b25c2e442c996fe7$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $b25c2e442c996fe7$var$checkIfContextChanged(current) ? !0 : !1;
}
function $b25c2e442c996fe7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, current.memoizedState.cache);
            $b25c2e442c996fe7$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $b25c2e442c996fe7$var$pushHostContext(workInProgress);
            break;
        case 4:
            $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $b25c2e442c996fe7$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $b25c2e442c996fe7$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $b25c2e442c996fe7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $b25c2e442c996fe7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($b25c2e442c996fe7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $b25c2e442c996fe7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $b25c2e442c996fe7$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, current.memoizedState.cache);
    }
    return $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $b25c2e442c996fe7$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $b25c2e442c996fe7$var$didReceiveUpdate = !0;
        else {
            if (!$b25c2e442c996fe7$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $b25c2e442c996fe7$var$didReceiveUpdate = !1, $b25c2e442c996fe7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $b25c2e442c996fe7$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $b25c2e442c996fe7$var$didReceiveUpdate = !1, $b25c2e442c996fe7$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $b25c2e442c996fe7$var$pushTreeId(workInProgress, $b25c2e442c996fe7$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $b25c2e442c996fe7$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $b25c2e442c996fe7$var$shouldConstruct(current) ? (props = $b25c2e442c996fe7$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $b25c2e442c996fe7$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $b25c2e442c996fe7$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $b25c2e442c996fe7$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $b25c2e442c996fe7$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $b25c2e442c996fe7$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $b25c2e442c996fe7$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $b25c2e442c996fe7$var$getComponentNameFromType(current) || current;
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $b25c2e442c996fe7$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $b25c2e442c996fe7$var$resolveClassComponentProps(props, workInProgress.pendingProps), $b25c2e442c996fe7$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress);
                $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, props);
                props !== prevState.cache && $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, [
                    $b25c2e442c996fe7$var$CacheContext
                ], renderLanes, !0);
                $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $b25c2e442c996fe7$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $b25c2e442c996fe7$var$createCapturedValueAtFiber(Error($b25c2e442c996fe7$var$formatProdErrorMessage(424)), workInProgress);
                        $b25c2e442c996fe7$var$queueHydrationError($$typeof);
                        workInProgress = $b25c2e442c996fe7$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(current.firstChild);
                        $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress;
                        $b25c2e442c996fe7$var$isHydrating = !0;
                        $b25c2e442c996fe7$var$hydrationErrors = null;
                        $b25c2e442c996fe7$var$rootOrSingletonContext = !0;
                        renderLanes = $b25c2e442c996fe7$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $b25c2e442c996fe7$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $b25c2e442c996fe7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $b25c2e442c996fe7$var$markRef(current, workInProgress), null === current ? (renderLanes = $b25c2e442c996fe7$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $b25c2e442c996fe7$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer($b25c2e442c996fe7$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress, props[$b25c2e442c996fe7$var$internalPropsKey] = current, $b25c2e442c996fe7$var$setInitialProperties(props, renderLanes, current), $b25c2e442c996fe7$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $b25c2e442c996fe7$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $b25c2e442c996fe7$var$pushHostContext(workInProgress), null === current && $b25c2e442c996fe7$var$isHydrating && (props = workInProgress.stateNode = $b25c2e442c996fe7$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $b25c2e442c996fe7$var$rootInstanceStackCursor.current), $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$rootOrSingletonContext = !0, $$typeof = $b25c2e442c996fe7$var$nextHydratableInstance, $b25c2e442c996fe7$var$isSingletonScope(workInProgress.type) ? ($b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(props.firstChild)) : $b25c2e442c996fe7$var$nextHydratableInstance = $$typeof), $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $b25c2e442c996fe7$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $b25c2e442c996fe7$var$isHydrating) {
                if ($$typeof = props = $b25c2e442c996fe7$var$nextHydratableInstance) props = $b25c2e442c996fe7$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $b25c2e442c996fe7$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = $b25c2e442c996fe7$var$getNextHydratable(props.firstChild), $b25c2e442c996fe7$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            }
            $b25c2e442c996fe7$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $b25c2e442c996fe7$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $b25c2e442c996fe7$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $b25c2e442c996fe7$var$renderWithHooks(current, workInProgress, $b25c2e442c996fe7$var$TransitionAwareHostComponent, null, null, renderLanes), $b25c2e442c996fe7$var$HostTransitionContext._currentValue = $$typeof);
            $b25c2e442c996fe7$var$markRef(current, workInProgress);
            $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $b25c2e442c996fe7$var$isHydrating) {
                if (current = renderLanes = $b25c2e442c996fe7$var$nextHydratableInstance) renderLanes = $b25c2e442c996fe7$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $b25c2e442c996fe7$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $b25c2e442c996fe7$var$hydrationParentFiber = workInProgress, $b25c2e442c996fe7$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $b25c2e442c996fe7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $b25c2e442c996fe7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $b25c2e442c996fe7$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $b25c2e442c996fe7$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $b25c2e442c996fe7$var$pushProvider(workInProgress, workInProgress.type, props.value), $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $b25c2e442c996fe7$var$prepareToReadContext(workInProgress), $$typeof = $b25c2e442c996fe7$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $b25c2e442c996fe7$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $b25c2e442c996fe7$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $b25c2e442c996fe7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $b25c2e442c996fe7$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $b25c2e442c996fe7$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $b25c2e442c996fe7$var$prepareToReadContext(workInProgress), props = $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$CacheContext), null === current ? ($$typeof = $b25c2e442c996fe7$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $b25c2e442c996fe7$var$workInProgressRoot, prevState = $b25c2e442c996fe7$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $b25c2e442c996fe7$var$initializeUpdateQueue(workInProgress), $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($b25c2e442c996fe7$var$cloneUpdateQueue(current, workInProgress), $b25c2e442c996fe7$var$processUpdateQueue(workInProgress, null, null, renderLanes), $b25c2e442c996fe7$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, props)) : (props = prevState.cache, $b25c2e442c996fe7$var$pushProvider(workInProgress, $b25c2e442c996fe7$var$CacheContext, props), props !== $$typeof.cache && $b25c2e442c996fe7$var$propagateContextChanges(workInProgress, [
                $b25c2e442c996fe7$var$CacheContext
            ], renderLanes, !0))), $b25c2e442c996fe7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b25c2e442c996fe7$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($b25c2e442c996fe7$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $b25c2e442c996fe7$var$suspendedThenable = $b25c2e442c996fe7$var$noopSuspenseyCommitThenable, $b25c2e442c996fe7$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $b25c2e442c996fe7$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$b25c2e442c996fe7$var$preloadResource(resource)) {
        if ($b25c2e442c996fe7$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $b25c2e442c996fe7$var$suspendedThenable = $b25c2e442c996fe7$var$noopSuspenseyCommitThenable, $b25c2e442c996fe7$var$SuspenseyCommitException;
    }
}
function $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $b25c2e442c996fe7$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $b25c2e442c996fe7$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$b25c2e442c996fe7$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $b25c2e442c996fe7$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $b25c2e442c996fe7$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $b25c2e442c996fe7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 1:
            return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext);
            $b25c2e442c996fe7$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $b25c2e442c996fe7$var$popHydrationState(workInProgress) ? $b25c2e442c996fe7$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable());
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($b25c2e442c996fe7$var$markUpdate(workInProgress), null !== nextResource ? ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($b25c2e442c996fe7$var$markUpdate(workInProgress), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $b25c2e442c996fe7$var$popHostContext(workInProgress);
            renderLanes = $b25c2e442c996fe7$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(166));
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b25c2e442c996fe7$var$contextStackCursor.current;
                $b25c2e442c996fe7$var$popHydrationState(workInProgress) ? $b25c2e442c996fe7$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $b25c2e442c996fe7$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $b25c2e442c996fe7$var$markUpdate(workInProgress));
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $b25c2e442c996fe7$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(166));
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $b25c2e442c996fe7$var$contextStackCursor.current;
                if ($b25c2e442c996fe7$var$popHydrationState(workInProgress)) $b25c2e442c996fe7$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer($b25c2e442c996fe7$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    nextResource[$b25c2e442c996fe7$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($b25c2e442c996fe7$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
                }
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            $b25c2e442c996fe7$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b25c2e442c996fe7$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(166));
                current = $b25c2e442c996fe7$var$rootInstanceStackCursor.current;
                if ($b25c2e442c996fe7$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $b25c2e442c996fe7$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $b25c2e442c996fe7$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $b25c2e442c996fe7$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $b25c2e442c996fe7$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(557));
                        current[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    } else $b25c2e442c996fe7$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(558));
            }
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $b25c2e442c996fe7$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(317));
                        type[$b25c2e442c996fe7$var$internalInstanceKey] = workInProgress;
                    } else $b25c2e442c996fe7$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $b25c2e442c996fe7$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $b25c2e442c996fe7$var$popHostContainer(), null === current && $b25c2e442c996fe7$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 10:
            return $b25c2e442c996fe7$var$popProvider(workInProgress.type), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 19:
            $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $b25c2e442c996fe7$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $b25c2e442c996fe7$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$b25c2e442c996fe7$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, $b25c2e442c996fe7$var$suspenseStackCursor.current & 1 | 2);
                            $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $b25c2e442c996fe7$var$now() > $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $b25c2e442c996fe7$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, current), $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$b25c2e442c996fe7$var$isHydrating) return $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
                    } else 2 * $b25c2e442c996fe7$var$now() - newProps.renderingStartTime > $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $b25c2e442c996fe7$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $b25c2e442c996fe7$var$now(), current.sibling = null, renderLanes = $b25c2e442c996fe7$var$suspenseStackCursor.current, $b25c2e442c996fe7$var$push($b25c2e442c996fe7$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $b25c2e442c996fe7$var$isHydrating && $b25c2e442c996fe7$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $b25c2e442c996fe7$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), $b25c2e442c996fe7$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($b25c2e442c996fe7$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $b25c2e442c996fe7$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $b25c2e442c996fe7$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext), $b25c2e442c996fe7$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b25c2e442c996fe7$var$unwindWork(current, workInProgress) {
    $b25c2e442c996fe7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext), $b25c2e442c996fe7$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $b25c2e442c996fe7$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(340));
                $b25c2e442c996fe7$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(340));
                $b25c2e442c996fe7$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor), null;
        case 4:
            return $b25c2e442c996fe7$var$popHostContainer(), null;
        case 10:
            return $b25c2e442c996fe7$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $b25c2e442c996fe7$var$popSuspenseHandler(workInProgress), $b25c2e442c996fe7$var$popHiddenContext(), null !== current && $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $b25c2e442c996fe7$var$unwindInterruptedWork(current, interruptedWork) {
    $b25c2e442c996fe7$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext);
            $b25c2e442c996fe7$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $b25c2e442c996fe7$var$popHostContext(interruptedWork);
            break;
        case 4:
            $b25c2e442c996fe7$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $b25c2e442c996fe7$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $b25c2e442c996fe7$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$suspenseStackCursor);
            break;
        case 10:
            $b25c2e442c996fe7$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $b25c2e442c996fe7$var$popSuspenseHandler(interruptedWork);
            $b25c2e442c996fe7$var$popHiddenContext();
            null !== current && $b25c2e442c996fe7$var$pop($b25c2e442c996fe7$var$resumedCache);
            break;
        case 24:
            $b25c2e442c996fe7$var$popProvider($b25c2e442c996fe7$var$CacheContext);
    }
}
function $b25c2e442c996fe7$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $b25c2e442c996fe7$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b25c2e442c996fe7$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $b25c2e442c996fe7$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b25c2e442c996fe7$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b25c2e442c996fe7$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $b25c2e442c996fe7$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $b25c2e442c996fe7$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$b25c2e442c996fe7$var$internalPropsKey] = newProps;
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $b25c2e442c996fe7$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $b25c2e442c996fe7$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $b25c2e442c996fe7$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $b25c2e442c996fe7$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $b25c2e442c996fe7$var$noop$1));
    else if (4 !== tag && (27 === tag && $b25c2e442c996fe7$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $b25c2e442c996fe7$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $b25c2e442c996fe7$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($b25c2e442c996fe7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$b25c2e442c996fe7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $b25c2e442c996fe7$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $b25c2e442c996fe7$var$setInitialProperties(singleton, type, props);
        singleton[$b25c2e442c996fe7$var$internalInstanceKey] = finishedWork;
        singleton[$b25c2e442c996fe7$var$internalPropsKey] = props;
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = !1, $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = !1, $b25c2e442c996fe7$var$needsFormReset = !1, $b25c2e442c996fe7$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $b25c2e442c996fe7$var$nextEffect = null;
function $b25c2e442c996fe7$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $b25c2e442c996fe7$var$eventsEnabled = $b25c2e442c996fe7$var$_enabled;
    root = $b25c2e442c996fe7$var$getActiveElementDeep(root);
    if ($b25c2e442c996fe7$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $b25c2e442c996fe7$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $b25c2e442c996fe7$var$_enabled = !1;
    for($b25c2e442c996fe7$var$nextEffect = firstChild; null !== $b25c2e442c996fe7$var$nextEffect;)if (firstChild = $b25c2e442c996fe7$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $b25c2e442c996fe7$var$nextEffect = root;
    else for(; null !== $b25c2e442c996fe7$var$nextEffect;){
        firstChild = $b25c2e442c996fe7$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $b25c2e442c996fe7$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $b25c2e442c996fe7$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $b25c2e442c996fe7$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $b25c2e442c996fe7$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $b25c2e442c996fe7$var$nextEffect = root;
            break;
        }
        $b25c2e442c996fe7$var$nextEffect = firstChild.return;
    }
}
function $b25c2e442c996fe7$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b25c2e442c996fe7$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $b25c2e442c996fe7$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $b25c2e442c996fe7$var$commitClassCallbacks(finishedWork);
            flags & 512 && $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $b25c2e442c996fe7$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $b25c2e442c996fe7$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $b25c2e442c996fe7$var$commitHostMount(finishedWork);
            flags & 512 && $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b25c2e442c996fe7$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b25c2e442c996fe7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $b25c2e442c996fe7$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $b25c2e442c996fe7$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $b25c2e442c996fe7$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $b25c2e442c996fe7$var$offscreenSubtreeWasHidden;
                prevProps = $b25c2e442c996fe7$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $b25c2e442c996fe7$var$offscreenSubtreeWasHidden;
                $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = flags;
                ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = prevProps;
                $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $b25c2e442c996fe7$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $b25c2e442c996fe7$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $b25c2e442c996fe7$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $b25c2e442c996fe7$var$hostParent = null, $b25c2e442c996fe7$var$hostParentIsContainer = !1;
function $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$b25c2e442c996fe7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $b25c2e442c996fe7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.onCommitFiberUnmount) try {
        $b25c2e442c996fe7$var$injectedHook.onCommitFiberUnmount($b25c2e442c996fe7$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $b25c2e442c996fe7$var$hostParent, prevHostParentIsContainer = $b25c2e442c996fe7$var$hostParentIsContainer;
            $b25c2e442c996fe7$var$isSingletonScope(deletedFiber.type) && ($b25c2e442c996fe7$var$hostParent = deletedFiber.stateNode, $b25c2e442c996fe7$var$hostParentIsContainer = !1);
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$releaseSingletonInstance(deletedFiber.stateNode);
            $b25c2e442c996fe7$var$hostParent = prevHostParent;
            $b25c2e442c996fe7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $b25c2e442c996fe7$var$hostParent;
            prevHostParentIsContainer = $b25c2e442c996fe7$var$hostParentIsContainer;
            $b25c2e442c996fe7$var$hostParent = null;
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$hostParent = prevHostParent;
            $b25c2e442c996fe7$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $b25c2e442c996fe7$var$hostParent) {
                if ($b25c2e442c996fe7$var$hostParentIsContainer) try {
                    (9 === $b25c2e442c996fe7$var$hostParent.nodeType ? $b25c2e442c996fe7$var$hostParent.body : "HTML" === $b25c2e442c996fe7$var$hostParent.nodeName ? $b25c2e442c996fe7$var$hostParent.ownerDocument.body : $b25c2e442c996fe7$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $b25c2e442c996fe7$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $b25c2e442c996fe7$var$hostParent && ($b25c2e442c996fe7$var$hostParentIsContainer ? (finishedRoot = $b25c2e442c996fe7$var$hostParent, $b25c2e442c996fe7$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $b25c2e442c996fe7$var$retryIfBlockedOn(finishedRoot)) : $b25c2e442c996fe7$var$clearHydrationBoundary($b25c2e442c996fe7$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $b25c2e442c996fe7$var$hostParent;
            prevHostParentIsContainer = $b25c2e442c996fe7$var$hostParentIsContainer;
            $b25c2e442c996fe7$var$hostParent = deletedFiber.stateNode.containerInfo;
            $b25c2e442c996fe7$var$hostParentIsContainer = !0;
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$hostParent = prevHostParent;
            $b25c2e442c996fe7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $b25c2e442c996fe7$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || ($b25c2e442c996fe7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $b25c2e442c996fe7$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = (prevHostParent = $b25c2e442c996fe7$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $b25c2e442c996fe7$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $b25c2e442c996fe7$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b25c2e442c996fe7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $b25c2e442c996fe7$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b25c2e442c996fe7$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $b25c2e442c996fe7$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $b25c2e442c996fe7$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $b25c2e442c996fe7$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $b25c2e442c996fe7$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($b25c2e442c996fe7$var$isSingletonScope(parent.type)) {
                        $b25c2e442c996fe7$var$hostParent = parent.stateNode;
                        $b25c2e442c996fe7$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $b25c2e442c996fe7$var$hostParent = parent.stateNode;
                    $b25c2e442c996fe7$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $b25c2e442c996fe7$var$hostParent = parent.stateNode.containerInfo;
                    $b25c2e442c996fe7$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $b25c2e442c996fe7$var$hostParent) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(160));
        $b25c2e442c996fe7$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $b25c2e442c996fe7$var$hostParent = null;
        $b25c2e442c996fe7$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $b25c2e442c996fe7$var$currentHoistableRoot = null;
function $b25c2e442c996fe7$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($b25c2e442c996fe7$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $b25c2e442c996fe7$var$commitHookEffectListMount(3, finishedWork), $b25c2e442c996fe7$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            flags & 64 && $b25c2e442c996fe7$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$b25c2e442c996fe7$var$internalHoistableMarker] || currentResource[$b25c2e442c996fe7$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $b25c2e442c996fe7$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$b25c2e442c996fe7$var$internalInstanceKey] = finishedWork;
                                        $b25c2e442c996fe7$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $b25c2e442c996fe7$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b25c2e442c996fe7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $b25c2e442c996fe7$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b25c2e442c996fe7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$b25c2e442c996fe7$var$internalInstanceKey] = finishedWork;
                                $b25c2e442c996fe7$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $b25c2e442c996fe7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $b25c2e442c996fe7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $b25c2e442c996fe7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $b25c2e442c996fe7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b25c2e442c996fe7$var$offscreenSubtreeWasHidden || null === current || $b25c2e442c996fe7$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $b25c2e442c996fe7$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $b25c2e442c996fe7$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($b25c2e442c996fe7$var$needsFormReset = !0);
            break;
        case 6:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $b25c2e442c996fe7$var$tagCaches = null;
            hoistableRoot = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$currentHoistableRoot = $b25c2e442c996fe7$var$getHoistableRoot(root.containerInfo);
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$currentHoistableRoot = hoistableRoot;
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $b25c2e442c996fe7$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $b25c2e442c996fe7$var$needsFormReset && ($b25c2e442c996fe7$var$needsFormReset = !1, $b25c2e442c996fe7$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$currentHoistableRoot = $b25c2e442c996fe7$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            $b25c2e442c996fe7$var$currentHoistableRoot = flags;
            break;
        case 12:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($b25c2e442c996fe7$var$globalMostRecentFallbackTime = $b25c2e442c996fe7$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $b25c2e442c996fe7$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $b25c2e442c996fe7$var$offscreenSubtreeWasHidden;
            $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $b25c2e442c996fe7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $b25c2e442c996fe7$var$offscreenSubtreeIsHidden || $b25c2e442c996fe7$var$offscreenSubtreeWasHidden || $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $b25c2e442c996fe7$var$hideOrUnhideDehydratedBoundary(instance, !0) : $b25c2e442c996fe7$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $b25c2e442c996fe7$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b25c2e442c996fe7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraverseMutationEffects(root, finishedWork), $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork);
    }
}
function $b25c2e442c996fe7$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($b25c2e442c996fe7$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $b25c2e442c996fe7$var$getHostSibling(finishedWork);
                    $b25c2e442c996fe7$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($b25c2e442c996fe7$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $b25c2e442c996fe7$var$getHostSibling(finishedWork);
                    $b25c2e442c996fe7$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $b25c2e442c996fe7$var$getHostSibling(finishedWork);
                    $b25c2e442c996fe7$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $b25c2e442c996fe7$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $b25c2e442c996fe7$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $b25c2e442c996fe7$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $b25c2e442c996fe7$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $b25c2e442c996fe7$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $b25c2e442c996fe7$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $b25c2e442c996fe7$var$safelyDetachRef(finishedWork, finishedWork.return);
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b25c2e442c996fe7$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$b25c2e442c996fe7$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $b25c2e442c996fe7$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $b25c2e442c996fe7$var$commitClassCallbacks(finishedWork);
                $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $b25c2e442c996fe7$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $b25c2e442c996fe7$var$commitHostMount(finishedWork);
                $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b25c2e442c996fe7$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b25c2e442c996fe7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b25c2e442c996fe7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $b25c2e442c996fe7$var$releaseCache(previousCache));
}
function $b25c2e442c996fe7$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $b25c2e442c996fe7$var$releaseCache(current));
}
function $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b25c2e442c996fe7$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $b25c2e442c996fe7$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $b25c2e442c996fe7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b25c2e442c996fe7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $b25c2e442c996fe7$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $b25c2e442c996fe7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b25c2e442c996fe7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b25c2e442c996fe7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $b25c2e442c996fe7$var$suspenseyCommitFlag = 8192;
function $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $b25c2e442c996fe7$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $b25c2e442c996fe7$var$suspenseyCommitFlag && null !== fiber.memoizedState && $b25c2e442c996fe7$var$suspendResource(suspendedState, $b25c2e442c996fe7$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $b25c2e442c996fe7$var$currentHoistableRoot;
            $b25c2e442c996fe7$var$currentHoistableRoot = $b25c2e442c996fe7$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $b25c2e442c996fe7$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $b25c2e442c996fe7$var$suspenseyCommitFlag, $b25c2e442c996fe7$var$suspenseyCommitFlag = 16777216, $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $b25c2e442c996fe7$var$suspenseyCommitFlag = previousHoistableRoot) : $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $b25c2e442c996fe7$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b25c2e442c996fe7$var$nextEffect = childToDelete;
            $b25c2e442c996fe7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b25c2e442c996fe7$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b25c2e442c996fe7$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b25c2e442c996fe7$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $b25c2e442c996fe7$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $b25c2e442c996fe7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b25c2e442c996fe7$var$nextEffect = childToDelete;
            $b25c2e442c996fe7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b25c2e442c996fe7$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $b25c2e442c996fe7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b25c2e442c996fe7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $b25c2e442c996fe7$var$nextEffect;){
        var fiber = $b25c2e442c996fe7$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $b25c2e442c996fe7$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $b25c2e442c996fe7$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $b25c2e442c996fe7$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $b25c2e442c996fe7$var$nextEffect;){
            cache = $b25c2e442c996fe7$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $b25c2e442c996fe7$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $b25c2e442c996fe7$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $b25c2e442c996fe7$var$nextEffect = sibling;
                break a;
            }
            $b25c2e442c996fe7$var$nextEffect = returnFiber;
        }
    }
}
var $b25c2e442c996fe7$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $b25c2e442c996fe7$var$readContext($b25c2e442c996fe7$var$CacheContext).controller.signal;
    }
}, $b25c2e442c996fe7$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $b25c2e442c996fe7$var$executionContext = 0, $b25c2e442c996fe7$var$workInProgressRoot = null, $b25c2e442c996fe7$var$workInProgress = null, $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0, $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings = !1, $b25c2e442c996fe7$var$workInProgressRootIsPrerendering = !1, $b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener = !1, $b25c2e442c996fe7$var$entangledRenderLanes = 0, $b25c2e442c996fe7$var$workInProgressRootExitStatus = 0, $b25c2e442c996fe7$var$workInProgressRootSkippedLanes = 0, $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes = 0, $b25c2e442c996fe7$var$workInProgressRootPingedLanes = 0, $b25c2e442c996fe7$var$workInProgressDeferredLane = 0, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes = 0, $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors = null, $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = null, $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $b25c2e442c996fe7$var$globalMostRecentFallbackTime = 0, $b25c2e442c996fe7$var$globalMostRecentTransitionTime = 0, $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime = Infinity, $b25c2e442c996fe7$var$workInProgressTransitions = null, $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed = null, $b25c2e442c996fe7$var$pendingEffectsStatus = 0, $b25c2e442c996fe7$var$pendingEffectsRoot = null, $b25c2e442c996fe7$var$pendingFinishedWork = null, $b25c2e442c996fe7$var$pendingEffectsLanes = 0, $b25c2e442c996fe7$var$pendingEffectsRemainingLanes = 0, $b25c2e442c996fe7$var$pendingPassiveTransitions = null, $b25c2e442c996fe7$var$pendingRecoverableErrors = null, $b25c2e442c996fe7$var$nestedUpdateCount = 0, $b25c2e442c996fe7$var$rootWithNestedUpdates = null;
function $b25c2e442c996fe7$var$requestUpdateLane() {
    return 0 !== ($b25c2e442c996fe7$var$executionContext & 2) && 0 !== $b25c2e442c996fe7$var$workInProgressRootRenderLanes ? $b25c2e442c996fe7$var$workInProgressRootRenderLanes & -$b25c2e442c996fe7$var$workInProgressRootRenderLanes : null !== $b25c2e442c996fe7$var$ReactSharedInternals.T ? $b25c2e442c996fe7$var$requestTransitionLane() : $b25c2e442c996fe7$var$resolveUpdatePriority();
}
function $b25c2e442c996fe7$var$requestDeferredLane() {
    if (0 === $b25c2e442c996fe7$var$workInProgressDeferredLane) {
        if (0 === ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 536870912) || $b25c2e442c996fe7$var$isHydrating) {
            var lane = $b25c2e442c996fe7$var$nextTransitionDeferredLane;
            $b25c2e442c996fe7$var$nextTransitionDeferredLane <<= 1;
            0 === ($b25c2e442c996fe7$var$nextTransitionDeferredLane & 3932160) && ($b25c2e442c996fe7$var$nextTransitionDeferredLane = 262144);
            $b25c2e442c996fe7$var$workInProgressDeferredLane = lane;
        } else $b25c2e442c996fe7$var$workInProgressDeferredLane = 536870912;
    }
    lane = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $b25c2e442c996fe7$var$workInProgressDeferredLane;
}
function $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $b25c2e442c996fe7$var$workInProgressRoot && (2 === $b25c2e442c996fe7$var$workInProgressSuspendedReason || 9 === $b25c2e442c996fe7$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $b25c2e442c996fe7$var$prepareFreshStack(root, 0), $b25c2e442c996fe7$var$markRootSuspended(root, $b25c2e442c996fe7$var$workInProgressRootRenderLanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !1);
    $b25c2e442c996fe7$var$markRootUpdated$1(root, lane);
    if (0 === ($b25c2e442c996fe7$var$executionContext & 2) || root !== $b25c2e442c996fe7$var$workInProgressRoot) root === $b25c2e442c996fe7$var$workInProgressRoot && (0 === ($b25c2e442c996fe7$var$executionContext & 2) && ($b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && $b25c2e442c996fe7$var$markRootSuspended(root, $b25c2e442c996fe7$var$workInProgressRootRenderLanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !1)), $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
}
function $b25c2e442c996fe7$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($b25c2e442c996fe7$var$executionContext & 6)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $b25c2e442c996fe7$var$renderRootConcurrent(root$jscomp$0, lanes) : $b25c2e442c996fe7$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $b25c2e442c996fe7$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $b25c2e442c996fe7$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$b25c2e442c996fe7$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $b25c2e442c996fe7$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($b25c2e442c996fe7$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $b25c2e442c996fe7$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors;
                            $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors ? $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors.push.apply($b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $b25c2e442c996fe7$var$prepareFreshStack(root$jscomp$0, 0);
                $b25c2e442c996fe7$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $b25c2e442c996fe7$var$markRootSuspended(shouldTimeSlice, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !$b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $b25c2e442c996fe7$var$globalMostRecentFallbackTime + 300 - $b25c2e442c996fe7$var$now(), 10 < exitStatus)) {
                    $b25c2e442c996fe7$var$markRootSuspended(shouldTimeSlice, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !$b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $b25c2e442c996fe7$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $b25c2e442c996fe7$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $b25c2e442c996fe7$var$scheduleTimeout($b25c2e442c996fe7$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, $b25c2e442c996fe7$var$workInProgressTransitions, $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $b25c2e442c996fe7$var$commitRootWhenReady(shouldTimeSlice, forceSync, $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors, $b25c2e442c996fe7$var$workInProgressTransitions, $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $b25c2e442c996fe7$var$ensureRootIsScheduled(root$jscomp$0);
}
function $b25c2e442c996fe7$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $b25c2e442c996fe7$var$noop$1
        };
        $b25c2e442c996fe7$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $b25c2e442c996fe7$var$globalMostRecentFallbackTime - $b25c2e442c996fe7$var$now() : (lanes & 4194048) === lanes ? $b25c2e442c996fe7$var$globalMostRecentTransitionTime - $b25c2e442c996fe7$var$now() : 0;
        timeoutOffset = $b25c2e442c996fe7$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $b25c2e442c996fe7$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($b25c2e442c996fe7$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $b25c2e442c996fe7$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $b25c2e442c996fe7$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $b25c2e442c996fe7$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$b25c2e442c996fe7$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $b25c2e442c996fe7$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$b25c2e442c996fe7$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $b25c2e442c996fe7$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $b25c2e442c996fe7$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $b25c2e442c996fe7$var$flushSyncWork$1() {
    return 0 === ($b25c2e442c996fe7$var$executionContext & 6) ? ($b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $b25c2e442c996fe7$var$resetWorkInProgressStack() {
    if (null !== $b25c2e442c996fe7$var$workInProgress) {
        if (0 === $b25c2e442c996fe7$var$workInProgressSuspendedReason) var interruptedWork = $b25c2e442c996fe7$var$workInProgress.return;
        else interruptedWork = $b25c2e442c996fe7$var$workInProgress, $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null, $b25c2e442c996fe7$var$resetHooksOnUnwind(interruptedWork), $b25c2e442c996fe7$var$thenableState$1 = null, $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0, interruptedWork = $b25c2e442c996fe7$var$workInProgress;
        for(; null !== interruptedWork;)$b25c2e442c996fe7$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $b25c2e442c996fe7$var$workInProgress = null;
    }
}
function $b25c2e442c996fe7$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $b25c2e442c996fe7$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $b25c2e442c996fe7$var$pendingEffectsLanes = 0;
    $b25c2e442c996fe7$var$resetWorkInProgressStack();
    $b25c2e442c996fe7$var$workInProgressRoot = root;
    $b25c2e442c996fe7$var$workInProgress = timeoutHandle = $b25c2e442c996fe7$var$createWorkInProgress(root.current, null);
    $b25c2e442c996fe7$var$workInProgressRootRenderLanes = lanes;
    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
    $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $b25c2e442c996fe7$var$workInProgressRootIsPrerendering = $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, lanes);
    $b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener = !1;
    $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes = $b25c2e442c996fe7$var$workInProgressDeferredLane = $b25c2e442c996fe7$var$workInProgressRootPingedLanes = $b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes = $b25c2e442c996fe7$var$workInProgressRootSkippedLanes = $b25c2e442c996fe7$var$workInProgressRootExitStatus = 0;
    $b25c2e442c996fe7$var$workInProgressRootRecoverableErrors = $b25c2e442c996fe7$var$workInProgressRootConcurrentErrors = null;
    $b25c2e442c996fe7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $b25c2e442c996fe7$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $b25c2e442c996fe7$var$entangledRenderLanes = lanes;
    $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $b25c2e442c996fe7$var$handleThrow(root, thrownValue) {
    $b25c2e442c996fe7$var$currentlyRenderingFiber = null;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$ContextOnlyDispatcher;
    thrownValue === $b25c2e442c996fe7$var$SuspenseException || thrownValue === $b25c2e442c996fe7$var$SuspenseActionException ? (thrownValue = $b25c2e442c996fe7$var$getSuspendedThenable(), $b25c2e442c996fe7$var$workInProgressSuspendedReason = 3) : thrownValue === $b25c2e442c996fe7$var$SuspenseyCommitException ? (thrownValue = $b25c2e442c996fe7$var$getSuspendedThenable(), $b25c2e442c996fe7$var$workInProgressSuspendedReason = 4) : $b25c2e442c996fe7$var$workInProgressSuspendedReason = thrownValue === $b25c2e442c996fe7$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $b25c2e442c996fe7$var$workInProgressThrownValue = thrownValue;
    null === $b25c2e442c996fe7$var$workInProgress && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 1, $b25c2e442c996fe7$var$logUncaughtError(root, $b25c2e442c996fe7$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $b25c2e442c996fe7$var$shouldRemainOnPreviousScreen() {
    var handler = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 4194048) === $b25c2e442c996fe7$var$workInProgressRootRenderLanes ? null === $b25c2e442c996fe7$var$shellBoundary ? !0 : !1 : ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 62914560) === $b25c2e442c996fe7$var$workInProgressRootRenderLanes || 0 !== ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 536870912) ? handler === $b25c2e442c996fe7$var$shellBoundary : !1;
}
function $b25c2e442c996fe7$var$pushDispatcher() {
    var prevDispatcher = $b25c2e442c996fe7$var$ReactSharedInternals.H;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = $b25c2e442c996fe7$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $b25c2e442c996fe7$var$ContextOnlyDispatcher : prevDispatcher;
}
function $b25c2e442c996fe7$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $b25c2e442c996fe7$var$ReactSharedInternals.A;
    $b25c2e442c996fe7$var$ReactSharedInternals.A = $b25c2e442c996fe7$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $b25c2e442c996fe7$var$renderDidSuspendDelayIfPossible() {
    $b25c2e442c996fe7$var$workInProgressRootExitStatus = 4;
    $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings || ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 4194048) !== $b25c2e442c996fe7$var$workInProgressRootRenderLanes && null !== $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current || ($b25c2e442c996fe7$var$workInProgressRootIsPrerendering = !0);
    0 === ($b25c2e442c996fe7$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($b25c2e442c996fe7$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $b25c2e442c996fe7$var$workInProgressRoot || $b25c2e442c996fe7$var$markRootSuspended($b25c2e442c996fe7$var$workInProgressRoot, $b25c2e442c996fe7$var$workInProgressRootRenderLanes, $b25c2e442c996fe7$var$workInProgressDeferredLane, !1);
}
function $b25c2e442c996fe7$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
    $b25c2e442c996fe7$var$executionContext |= 2;
    var prevDispatcher = $b25c2e442c996fe7$var$pushDispatcher(), prevAsyncDispatcher = $b25c2e442c996fe7$var$pushAsyncDispatcher();
    if ($b25c2e442c996fe7$var$workInProgressRoot !== root || $b25c2e442c996fe7$var$workInProgressRootRenderLanes !== lanes) $b25c2e442c996fe7$var$workInProgressTransitions = null, $b25c2e442c996fe7$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $b25c2e442c996fe7$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason && null !== $b25c2e442c996fe7$var$workInProgress) {
            var unitOfWork = $b25c2e442c996fe7$var$workInProgress, thrownValue = $b25c2e442c996fe7$var$workInProgressThrownValue;
            switch($b25c2e442c996fe7$var$workInProgressSuspendedReason){
                case 8:
                    $b25c2e442c996fe7$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $b25c2e442c996fe7$var$workInProgressSuspendedReason;
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $b25c2e442c996fe7$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $b25c2e442c996fe7$var$workInProgressSuspendedReason, $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $b25c2e442c996fe7$var$workLoopSync();
        exitStatus = $b25c2e442c996fe7$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $b25c2e442c996fe7$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null;
    $b25c2e442c996fe7$var$executionContext = prevExecutionContext;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = prevDispatcher;
    $b25c2e442c996fe7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $b25c2e442c996fe7$var$workInProgress && ($b25c2e442c996fe7$var$workInProgressRoot = null, $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0, $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $b25c2e442c996fe7$var$workLoopSync() {
    for(; null !== $b25c2e442c996fe7$var$workInProgress;)$b25c2e442c996fe7$var$performUnitOfWork($b25c2e442c996fe7$var$workInProgress);
}
function $b25c2e442c996fe7$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
    $b25c2e442c996fe7$var$executionContext |= 2;
    var prevDispatcher = $b25c2e442c996fe7$var$pushDispatcher(), prevAsyncDispatcher = $b25c2e442c996fe7$var$pushAsyncDispatcher();
    $b25c2e442c996fe7$var$workInProgressRoot !== root || $b25c2e442c996fe7$var$workInProgressRootRenderLanes !== lanes ? ($b25c2e442c996fe7$var$workInProgressTransitions = null, $b25c2e442c996fe7$var$workInProgressRootRenderTargetTime = $b25c2e442c996fe7$var$now() + 500, $b25c2e442c996fe7$var$prepareFreshStack(root, lanes)) : $b25c2e442c996fe7$var$workInProgressRootIsPrerendering = $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason && null !== $b25c2e442c996fe7$var$workInProgress) {
            lanes = $b25c2e442c996fe7$var$workInProgress;
            var thrownValue = $b25c2e442c996fe7$var$workInProgressThrownValue;
            b: switch($b25c2e442c996fe7$var$workInProgressSuspendedReason){
                case 1:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($b25c2e442c996fe7$var$isThenableResolved(thrownValue)) {
                        $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                        $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                        $b25c2e442c996fe7$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason && 9 !== $b25c2e442c996fe7$var$workInProgressSuspendedReason || $b25c2e442c996fe7$var$workInProgressRoot !== root || ($b25c2e442c996fe7$var$workInProgressSuspendedReason = 7);
                        $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $b25c2e442c996fe7$var$isThenableResolved(thrownValue) ? ($b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$replaySuspendedUnitOfWork(lanes)) : ($b25c2e442c996fe7$var$workInProgressSuspendedReason = 0, $b25c2e442c996fe7$var$workInProgressThrownValue = null, $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($b25c2e442c996fe7$var$workInProgress.tag){
                        case 26:
                            resource = $b25c2e442c996fe7$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $b25c2e442c996fe7$var$workInProgress;
                            if (resource ? $b25c2e442c996fe7$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                                $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $b25c2e442c996fe7$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($b25c2e442c996fe7$var$workInProgress = returnFiber, $b25c2e442c996fe7$var$completeUnitOfWork(returnFiber)) : $b25c2e442c996fe7$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $b25c2e442c996fe7$var$workInProgressSuspendedReason = 0;
                    $b25c2e442c996fe7$var$workInProgressThrownValue = null;
                    $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $b25c2e442c996fe7$var$resetWorkInProgressStack();
                    $b25c2e442c996fe7$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(462));
            }
        }
        $b25c2e442c996fe7$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $b25c2e442c996fe7$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null;
    $b25c2e442c996fe7$var$ReactSharedInternals.H = prevDispatcher;
    $b25c2e442c996fe7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $b25c2e442c996fe7$var$executionContext = prevExecutionContext;
    if (null !== $b25c2e442c996fe7$var$workInProgress) return 0;
    $b25c2e442c996fe7$var$workInProgressRoot = null;
    $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0;
    $b25c2e442c996fe7$var$finishQueueingConcurrentUpdates();
    return $b25c2e442c996fe7$var$workInProgressRootExitStatus;
}
function $b25c2e442c996fe7$var$workLoopConcurrentByScheduler() {
    for(; null !== $b25c2e442c996fe7$var$workInProgress && !$b25c2e442c996fe7$var$shouldYield();)$b25c2e442c996fe7$var$performUnitOfWork($b25c2e442c996fe7$var$workInProgress);
}
function $b25c2e442c996fe7$var$performUnitOfWork(unitOfWork) {
    var next = $b25c2e442c996fe7$var$beginWork(unitOfWork.alternate, unitOfWork, $b25c2e442c996fe7$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork) : $b25c2e442c996fe7$var$workInProgress = next;
}
function $b25c2e442c996fe7$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $b25c2e442c996fe7$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $b25c2e442c996fe7$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $b25c2e442c996fe7$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $b25c2e442c996fe7$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $b25c2e442c996fe7$var$resetHooksOnUnwind(next);
        default:
            $b25c2e442c996fe7$var$unwindInterruptedWork(current, next), next = $b25c2e442c996fe7$var$workInProgress = $b25c2e442c996fe7$var$resetWorkInProgress(next, $b25c2e442c996fe7$var$entangledRenderLanes), next = $b25c2e442c996fe7$var$beginWork(current, next, $b25c2e442c996fe7$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork) : $b25c2e442c996fe7$var$workInProgress = next;
}
function $b25c2e442c996fe7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $b25c2e442c996fe7$var$lastContextDependency = $b25c2e442c996fe7$var$currentlyRenderingFiber$1 = null;
    $b25c2e442c996fe7$var$resetHooksOnUnwind(unitOfWork);
    $b25c2e442c996fe7$var$thenableState$1 = null;
    $b25c2e442c996fe7$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($b25c2e442c996fe7$var$throwException(root, returnFiber, unitOfWork, thrownValue, $b25c2e442c996fe7$var$workInProgressRootRenderLanes)) {
            $b25c2e442c996fe7$var$workInProgressRootExitStatus = 1;
            $b25c2e442c996fe7$var$logUncaughtError(root, $b25c2e442c996fe7$var$createCapturedValueAtFiber(thrownValue, root.current));
            $b25c2e442c996fe7$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $b25c2e442c996fe7$var$workInProgress = returnFiber, error;
        $b25c2e442c996fe7$var$workInProgressRootExitStatus = 1;
        $b25c2e442c996fe7$var$logUncaughtError(root, $b25c2e442c996fe7$var$createCapturedValueAtFiber(thrownValue, root.current));
        $b25c2e442c996fe7$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($b25c2e442c996fe7$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($b25c2e442c996fe7$var$workInProgressRootIsPrerendering || 0 !== ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $b25c2e442c996fe7$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $b25c2e442c996fe7$var$unwindUnitOfWork(unitOfWork, root);
    } else $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork);
}
function $b25c2e442c996fe7$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $b25c2e442c996fe7$var$unwindUnitOfWork(completedWork, $b25c2e442c996fe7$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $b25c2e442c996fe7$var$completeWork(completedWork.alternate, completedWork, $b25c2e442c996fe7$var$entangledRenderLanes);
        if (null !== next) {
            $b25c2e442c996fe7$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $b25c2e442c996fe7$var$workInProgress = completedWork;
            return;
        }
        $b25c2e442c996fe7$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootExitStatus = 5);
}
function $b25c2e442c996fe7$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $b25c2e442c996fe7$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $b25c2e442c996fe7$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $b25c2e442c996fe7$var$workInProgress = unitOfWork;
            return;
        }
        $b25c2e442c996fe7$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $b25c2e442c996fe7$var$workInProgressRootExitStatus = 6;
    $b25c2e442c996fe7$var$workInProgress = null;
}
function $b25c2e442c996fe7$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $b25c2e442c996fe7$var$flushPendingEffects();
    while (0 !== $b25c2e442c996fe7$var$pendingEffectsStatus);
    if (0 !== ($b25c2e442c996fe7$var$executionContext & 6)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $b25c2e442c996fe7$var$concurrentlyUpdatedLanes;
        $b25c2e442c996fe7$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $b25c2e442c996fe7$var$workInProgressRoot && ($b25c2e442c996fe7$var$workInProgress = $b25c2e442c996fe7$var$workInProgressRoot = null, $b25c2e442c996fe7$var$workInProgressRootRenderLanes = 0);
        $b25c2e442c996fe7$var$pendingFinishedWork = finishedWork;
        $b25c2e442c996fe7$var$pendingEffectsRoot = root;
        $b25c2e442c996fe7$var$pendingEffectsLanes = lanes;
        $b25c2e442c996fe7$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $b25c2e442c996fe7$var$pendingPassiveTransitions = transitions;
        $b25c2e442c996fe7$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $b25c2e442c996fe7$var$scheduleCallback$1($b25c2e442c996fe7$var$NormalPriority$1, function() {
            $b25c2e442c996fe7$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            transitions = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $b25c2e442c996fe7$var$executionContext;
            $b25c2e442c996fe7$var$executionContext |= 4;
            try {
                $b25c2e442c996fe7$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $b25c2e442c996fe7$var$executionContext = spawnedLane, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = transitions, $b25c2e442c996fe7$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $b25c2e442c996fe7$var$pendingEffectsStatus = 1;
        $b25c2e442c996fe7$var$flushMutationEffects();
        $b25c2e442c996fe7$var$flushLayoutEffects();
        $b25c2e442c996fe7$var$flushSpawnedWork();
    }
}
function $b25c2e442c996fe7$var$flushMutationEffects() {
    if (1 === $b25c2e442c996fe7$var$pendingEffectsStatus) {
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        var root = $b25c2e442c996fe7$var$pendingEffectsRoot, finishedWork = $b25c2e442c996fe7$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
            $b25c2e442c996fe7$var$executionContext |= 4;
            try {
                $b25c2e442c996fe7$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $b25c2e442c996fe7$var$selectionInformation, curFocusedElem = $b25c2e442c996fe7$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $b25c2e442c996fe7$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $b25c2e442c996fe7$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $b25c2e442c996fe7$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $b25c2e442c996fe7$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $b25c2e442c996fe7$var$_enabled = !!$b25c2e442c996fe7$var$eventsEnabled;
                $b25c2e442c996fe7$var$selectionInformation = $b25c2e442c996fe7$var$eventsEnabled = null;
            } finally{
                $b25c2e442c996fe7$var$executionContext = prevExecutionContext, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $b25c2e442c996fe7$var$pendingEffectsStatus = 2;
    }
}
function $b25c2e442c996fe7$var$flushLayoutEffects() {
    if (2 === $b25c2e442c996fe7$var$pendingEffectsStatus) {
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        var root = $b25c2e442c996fe7$var$pendingEffectsRoot, finishedWork = $b25c2e442c996fe7$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
            $b25c2e442c996fe7$var$executionContext |= 4;
            try {
                $b25c2e442c996fe7$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $b25c2e442c996fe7$var$executionContext = prevExecutionContext, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $b25c2e442c996fe7$var$pendingEffectsStatus = 3;
    }
}
function $b25c2e442c996fe7$var$flushSpawnedWork() {
    if (4 === $b25c2e442c996fe7$var$pendingEffectsStatus || 3 === $b25c2e442c996fe7$var$pendingEffectsStatus) {
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        $b25c2e442c996fe7$var$requestPaint();
        var root = $b25c2e442c996fe7$var$pendingEffectsRoot, finishedWork = $b25c2e442c996fe7$var$pendingFinishedWork, lanes = $b25c2e442c996fe7$var$pendingEffectsLanes, recoverableErrors = $b25c2e442c996fe7$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $b25c2e442c996fe7$var$pendingEffectsStatus = 5 : ($b25c2e442c996fe7$var$pendingEffectsStatus = 0, $b25c2e442c996fe7$var$pendingFinishedWork = $b25c2e442c996fe7$var$pendingEffectsRoot = null, $b25c2e442c996fe7$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $b25c2e442c996fe7$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.onCommitFiberRoot) try {
            $b25c2e442c996fe7$var$injectedHook.onCommitFiberRoot($b25c2e442c996fe7$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $b25c2e442c996fe7$var$ReactSharedInternals.T;
            remainingLanes = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
            $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2;
            $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $b25c2e442c996fe7$var$ReactSharedInternals.T = finishedWork, $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($b25c2e442c996fe7$var$pendingEffectsLanes & 3) && $b25c2e442c996fe7$var$flushPendingEffects();
        $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $b25c2e442c996fe7$var$rootWithNestedUpdates ? $b25c2e442c996fe7$var$nestedUpdateCount++ : ($b25c2e442c996fe7$var$nestedUpdateCount = 0, $b25c2e442c996fe7$var$rootWithNestedUpdates = root) : $b25c2e442c996fe7$var$nestedUpdateCount = 0;
        $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $b25c2e442c996fe7$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $b25c2e442c996fe7$var$releaseCache(remainingLanes)));
}
function $b25c2e442c996fe7$var$flushPendingEffects() {
    $b25c2e442c996fe7$var$flushMutationEffects();
    $b25c2e442c996fe7$var$flushLayoutEffects();
    $b25c2e442c996fe7$var$flushSpawnedWork();
    return $b25c2e442c996fe7$var$flushPassiveEffects();
}
function $b25c2e442c996fe7$var$flushPassiveEffects() {
    if (5 !== $b25c2e442c996fe7$var$pendingEffectsStatus) return !1;
    var root = $b25c2e442c996fe7$var$pendingEffectsRoot, remainingLanes = $b25c2e442c996fe7$var$pendingEffectsRemainingLanes;
    $b25c2e442c996fe7$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $b25c2e442c996fe7$var$lanesToEventPriority($b25c2e442c996fe7$var$pendingEffectsLanes), prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T, previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
        renderPriority = $b25c2e442c996fe7$var$pendingPassiveTransitions;
        $b25c2e442c996fe7$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $b25c2e442c996fe7$var$pendingEffectsRoot, lanes = $b25c2e442c996fe7$var$pendingEffectsLanes;
        $b25c2e442c996fe7$var$pendingEffectsStatus = 0;
        $b25c2e442c996fe7$var$pendingFinishedWork = $b25c2e442c996fe7$var$pendingEffectsRoot = null;
        $b25c2e442c996fe7$var$pendingEffectsLanes = 0;
        if (0 !== ($b25c2e442c996fe7$var$executionContext & 6)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(331));
        var prevExecutionContext = $b25c2e442c996fe7$var$executionContext;
        $b25c2e442c996fe7$var$executionContext |= 4;
        $b25c2e442c996fe7$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $b25c2e442c996fe7$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $b25c2e442c996fe7$var$executionContext = prevExecutionContext;
        $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($b25c2e442c996fe7$var$injectedHook && "function" === typeof $b25c2e442c996fe7$var$injectedHook.onPostCommitFiberRoot) try {
            $b25c2e442c996fe7$var$injectedHook.onPostCommitFiberRoot($b25c2e442c996fe7$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition, $b25c2e442c996fe7$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $b25c2e442c996fe7$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $b25c2e442c996fe7$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $b25c2e442c996fe7$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $b25c2e442c996fe7$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($b25c2e442c996fe7$var$markRootUpdated$1(rootFiber, 2), $b25c2e442c996fe7$var$ensureRootIsScheduled(rootFiber));
}
function $b25c2e442c996fe7$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $b25c2e442c996fe7$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $b25c2e442c996fe7$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed || !$b25c2e442c996fe7$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $b25c2e442c996fe7$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $b25c2e442c996fe7$var$createClassErrorUpdate(2);
                instance = $b25c2e442c996fe7$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($b25c2e442c996fe7$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $b25c2e442c996fe7$var$markRootUpdated$1(instance, 2), $b25c2e442c996fe7$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $b25c2e442c996fe7$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $b25c2e442c996fe7$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($b25c2e442c996fe7$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $b25c2e442c996fe7$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $b25c2e442c996fe7$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $b25c2e442c996fe7$var$workInProgressRoot === root && ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $b25c2e442c996fe7$var$workInProgressRootExitStatus || 3 === $b25c2e442c996fe7$var$workInProgressRootExitStatus && ($b25c2e442c996fe7$var$workInProgressRootRenderLanes & 62914560) === $b25c2e442c996fe7$var$workInProgressRootRenderLanes && 300 > $b25c2e442c996fe7$var$now() - $b25c2e442c996fe7$var$globalMostRecentFallbackTime ? 0 === ($b25c2e442c996fe7$var$executionContext & 2) && $b25c2e442c996fe7$var$prepareFreshStack(root, 0) : $b25c2e442c996fe7$var$workInProgressRootPingedLanes |= pingedLanes, $b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes === $b25c2e442c996fe7$var$workInProgressRootRenderLanes && ($b25c2e442c996fe7$var$workInProgressSuspendedRetryLanes = 0));
    $b25c2e442c996fe7$var$ensureRootIsScheduled(root);
}
function $b25c2e442c996fe7$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $b25c2e442c996fe7$var$claimNextRetryLane());
    boundaryFiber = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($b25c2e442c996fe7$var$markRootUpdated$1(boundaryFiber, retryLane), $b25c2e442c996fe7$var$ensureRootIsScheduled(boundaryFiber));
}
function $b25c2e442c996fe7$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $b25c2e442c996fe7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b25c2e442c996fe7$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $b25c2e442c996fe7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b25c2e442c996fe7$var$scheduleCallback$1(priorityLevel, callback) {
    return $b25c2e442c996fe7$var$scheduleCallback$3(priorityLevel, callback);
}
var $b25c2e442c996fe7$var$firstScheduledRoot = null, $b25c2e442c996fe7$var$lastScheduledRoot = null, $b25c2e442c996fe7$var$didScheduleMicrotask = !1, $b25c2e442c996fe7$var$mightHavePendingSyncWork = !1, $b25c2e442c996fe7$var$isFlushingWork = !1, $b25c2e442c996fe7$var$currentEventTransitionLane = 0;
function $b25c2e442c996fe7$var$ensureRootIsScheduled(root) {
    root !== $b25c2e442c996fe7$var$lastScheduledRoot && null === root.next && (null === $b25c2e442c996fe7$var$lastScheduledRoot ? $b25c2e442c996fe7$var$firstScheduledRoot = $b25c2e442c996fe7$var$lastScheduledRoot = root : $b25c2e442c996fe7$var$lastScheduledRoot = $b25c2e442c996fe7$var$lastScheduledRoot.next = root);
    $b25c2e442c996fe7$var$mightHavePendingSyncWork = !0;
    $b25c2e442c996fe7$var$didScheduleMicrotask || ($b25c2e442c996fe7$var$didScheduleMicrotask = !0, $b25c2e442c996fe7$var$scheduleImmediateRootScheduleTask());
}
function $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$b25c2e442c996fe7$var$isFlushingWork && $b25c2e442c996fe7$var$mightHavePendingSyncWork) {
        $b25c2e442c996fe7$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $b25c2e442c996fe7$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $b25c2e442c996fe7$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $b25c2e442c996fe7$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $b25c2e442c996fe7$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $b25c2e442c996fe7$var$getNextLanes(root$170, root$170 === $b25c2e442c996fe7$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $b25c2e442c996fe7$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $b25c2e442c996fe7$var$isFlushingWork = !1;
    }
}
function $b25c2e442c996fe7$var$processRootScheduleInImmediateTask() {
    $b25c2e442c996fe7$var$processRootScheduleInMicrotask();
}
function $b25c2e442c996fe7$var$processRootScheduleInMicrotask() {
    $b25c2e442c996fe7$var$mightHavePendingSyncWork = $b25c2e442c996fe7$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $b25c2e442c996fe7$var$currentEventTransitionLane && $b25c2e442c996fe7$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $b25c2e442c996fe7$var$currentEventTransitionLane);
    for(var currentTime = $b25c2e442c996fe7$var$now(), prev = null, root = $b25c2e442c996fe7$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $b25c2e442c996fe7$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $b25c2e442c996fe7$var$firstScheduledRoot = next : prev.next = next, null === next && ($b25c2e442c996fe7$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $b25c2e442c996fe7$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $b25c2e442c996fe7$var$pendingEffectsStatus && 5 !== $b25c2e442c996fe7$var$pendingEffectsStatus || $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $b25c2e442c996fe7$var$currentEventTransitionLane && ($b25c2e442c996fe7$var$currentEventTransitionLane = 0);
}
function $b25c2e442c996fe7$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $b25c2e442c996fe7$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $b25c2e442c996fe7$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $b25c2e442c996fe7$var$workInProgressRoot;
    suspendedLanes = $b25c2e442c996fe7$var$workInProgressRootRenderLanes;
    suspendedLanes = $b25c2e442c996fe7$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $b25c2e442c996fe7$var$workInProgressSuspendedReason || 9 === $b25c2e442c996fe7$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $b25c2e442c996fe7$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $b25c2e442c996fe7$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $b25c2e442c996fe7$var$cancelCallback$1(pingedLanes);
        switch($b25c2e442c996fe7$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $b25c2e442c996fe7$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $b25c2e442c996fe7$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $b25c2e442c996fe7$var$IdlePriority;
                break;
            default:
                suspendedLanes = $b25c2e442c996fe7$var$NormalPriority$1;
        }
        pingedLanes = $b25c2e442c996fe7$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $b25c2e442c996fe7$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $b25c2e442c996fe7$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $b25c2e442c996fe7$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $b25c2e442c996fe7$var$pendingEffectsStatus && 5 !== $b25c2e442c996fe7$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($b25c2e442c996fe7$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $b25c2e442c996fe7$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $b25c2e442c996fe7$var$getNextLanes(root, root === $b25c2e442c996fe7$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $b25c2e442c996fe7$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $b25c2e442c996fe7$var$scheduleTaskForRootDuringMicrotask(root, $b25c2e442c996fe7$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $b25c2e442c996fe7$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $b25c2e442c996fe7$var$performSyncWorkOnRoot(root, lanes) {
    if ($b25c2e442c996fe7$var$flushPendingEffects()) return null;
    $b25c2e442c996fe7$var$performWorkOnRoot(root, lanes, !0);
}
function $b25c2e442c996fe7$var$scheduleImmediateRootScheduleTask() {
    $b25c2e442c996fe7$var$scheduleMicrotask(function() {
        0 !== ($b25c2e442c996fe7$var$executionContext & 6) ? $b25c2e442c996fe7$var$scheduleCallback$3($b25c2e442c996fe7$var$ImmediatePriority, $b25c2e442c996fe7$var$processRootScheduleInImmediateTask) : $b25c2e442c996fe7$var$processRootScheduleInMicrotask();
    });
}
function $b25c2e442c996fe7$var$requestTransitionLane() {
    if (0 === $b25c2e442c996fe7$var$currentEventTransitionLane) {
        var actionScopeLane = $b25c2e442c996fe7$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $b25c2e442c996fe7$var$nextTransitionUpdateLane, $b25c2e442c996fe7$var$nextTransitionUpdateLane <<= 1, 0 === ($b25c2e442c996fe7$var$nextTransitionUpdateLane & 261888) && ($b25c2e442c996fe7$var$nextTransitionUpdateLane = 256));
        $b25c2e442c996fe7$var$currentEventTransitionLane = actionScopeLane;
    }
    return $b25c2e442c996fe7$var$currentEventTransitionLane;
}
function $b25c2e442c996fe7$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $b25c2e442c996fe7$var$sanitizeURL("" + actionProp);
}
function $b25c2e442c996fe7$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $b25c2e442c996fe7$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $b25c2e442c996fe7$var$coerceFormActionProp((nativeEventTarget[$b25c2e442c996fe7$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$b25c2e442c996fe7$var$internalPropsKey] || null) ? $b25c2e442c996fe7$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $b25c2e442c996fe7$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $b25c2e442c996fe7$var$currentEventTransitionLane) {
                                var formData = submitter ? $b25c2e442c996fe7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $b25c2e442c996fe7$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $b25c2e442c996fe7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $b25c2e442c996fe7$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $b25c2e442c996fe7$var$i$jscomp$inline_1577 = 0; $b25c2e442c996fe7$var$i$jscomp$inline_1577 < $b25c2e442c996fe7$var$simpleEventPluginEvents.length; $b25c2e442c996fe7$var$i$jscomp$inline_1577++){
    var $b25c2e442c996fe7$var$eventName$jscomp$inline_1578 = $b25c2e442c996fe7$var$simpleEventPluginEvents[$b25c2e442c996fe7$var$i$jscomp$inline_1577], $b25c2e442c996fe7$var$domEventName$jscomp$inline_1579 = $b25c2e442c996fe7$var$eventName$jscomp$inline_1578.toLowerCase(), $b25c2e442c996fe7$var$capitalizedEvent$jscomp$inline_1580 = $b25c2e442c996fe7$var$eventName$jscomp$inline_1578[0].toUpperCase() + $b25c2e442c996fe7$var$eventName$jscomp$inline_1578.slice(1);
    $b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$domEventName$jscomp$inline_1579, "on" + $b25c2e442c996fe7$var$capitalizedEvent$jscomp$inline_1580);
}
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$ANIMATION_END, "onAnimationEnd");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$ANIMATION_ITERATION, "onAnimationIteration");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$ANIMATION_START, "onAnimationStart");
$b25c2e442c996fe7$var$registerSimpleEvent("dblclick", "onDoubleClick");
$b25c2e442c996fe7$var$registerSimpleEvent("focusin", "onFocus");
$b25c2e442c996fe7$var$registerSimpleEvent("focusout", "onBlur");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_RUN, "onTransitionRun");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_START, "onTransitionStart");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_CANCEL, "onTransitionCancel");
$b25c2e442c996fe7$var$registerSimpleEvent($b25c2e442c996fe7$var$TRANSITION_END, "onTransitionEnd");
$b25c2e442c996fe7$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b25c2e442c996fe7$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b25c2e442c996fe7$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b25c2e442c996fe7$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b25c2e442c996fe7$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b25c2e442c996fe7$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b25c2e442c996fe7$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($b25c2e442c996fe7$var$mediaEventTypes));
function $b25c2e442c996fe7$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b25c2e442c996fe7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b25c2e442c996fe7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $b25c2e442c996fe7$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$b25c2e442c996fe7$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$b25c2e442c996fe7$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($b25c2e442c996fe7$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $b25c2e442c996fe7$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $b25c2e442c996fe7$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $b25c2e442c996fe7$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $b25c2e442c996fe7$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$b25c2e442c996fe7$var$listeningMarker]) {
        rootContainerElement[$b25c2e442c996fe7$var$listeningMarker] = !0;
        $b25c2e442c996fe7$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($b25c2e442c996fe7$var$nonDelegatedEvents.has(domEventName) || $b25c2e442c996fe7$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $b25c2e442c996fe7$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$b25c2e442c996fe7$var$listeningMarker] || (ownerDocument[$b25c2e442c996fe7$var$listeningMarker] = !0, $b25c2e442c996fe7$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $b25c2e442c996fe7$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($b25c2e442c996fe7$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $b25c2e442c996fe7$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $b25c2e442c996fe7$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $b25c2e442c996fe7$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$b25c2e442c996fe7$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $b25c2e442c996fe7$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $b25c2e442c996fe7$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $b25c2e442c996fe7$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $b25c2e442c996fe7$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $b25c2e442c996fe7$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticTouchEvent;
                        break;
                    case $b25c2e442c996fe7$var$ANIMATION_END:
                    case $b25c2e442c996fe7$var$ANIMATION_ITERATION:
                    case $b25c2e442c996fe7$var$ANIMATION_START:
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticAnimationEvent;
                        break;
                    case $b25c2e442c996fe7$var$TRANSITION_END:
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $b25c2e442c996fe7$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $b25c2e442c996fe7$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($b25c2e442c996fe7$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $b25c2e442c996fe7$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($b25c2e442c996fe7$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$b25c2e442c996fe7$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $b25c2e442c996fe7$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $b25c2e442c996fe7$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $b25c2e442c996fe7$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $b25c2e442c996fe7$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $b25c2e442c996fe7$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $b25c2e442c996fe7$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $b25c2e442c996fe7$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $b25c2e442c996fe7$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $b25c2e442c996fe7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $b25c2e442c996fe7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $b25c2e442c996fe7$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForChangeEvent;
                else if ($b25c2e442c996fe7$var$isTextInputElement(reactName)) {
                    if ($b25c2e442c996fe7$var$isInputEventSupported) getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $b25c2e442c996fe7$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $b25c2e442c996fe7$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForChangeEvent) : getTargetInstFunc = $b25c2e442c996fe7$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $b25c2e442c996fe7$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $b25c2e442c996fe7$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $b25c2e442c996fe7$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($b25c2e442c996fe7$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $b25c2e442c996fe7$var$activeElement = handleEventFunc, $b25c2e442c996fe7$var$activeElementInst = targetInst, $b25c2e442c996fe7$var$lastSelection = null;
                    break;
                case "focusout":
                    $b25c2e442c996fe7$var$lastSelection = $b25c2e442c996fe7$var$activeElementInst = $b25c2e442c996fe7$var$activeElement = null;
                    break;
                case "mousedown":
                    $b25c2e442c996fe7$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b25c2e442c996fe7$var$mouseDown = !1;
                    $b25c2e442c996fe7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($b25c2e442c996fe7$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $b25c2e442c996fe7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($b25c2e442c996fe7$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $b25c2e442c996fe7$var$isComposing ? $b25c2e442c996fe7$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($b25c2e442c996fe7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($b25c2e442c996fe7$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $b25c2e442c996fe7$var$isComposing && (fallbackData = $b25c2e442c996fe7$var$getData()) : ($b25c2e442c996fe7$var$root = nativeEventTarget, $b25c2e442c996fe7$var$startText = "value" in $b25c2e442c996fe7$var$root ? $b25c2e442c996fe7$var$root.value : $b25c2e442c996fe7$var$root.textContent, $b25c2e442c996fe7$var$isComposing = !0)), handleEventFunc = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $b25c2e442c996fe7$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $b25c2e442c996fe7$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $b25c2e442c996fe7$var$canUseTextInputEvent ? $b25c2e442c996fe7$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $b25c2e442c996fe7$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $b25c2e442c996fe7$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $b25c2e442c996fe7$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $b25c2e442c996fe7$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $b25c2e442c996fe7$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $b25c2e442c996fe7$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $b25c2e442c996fe7$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($b25c2e442c996fe7$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $b25c2e442c996fe7$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($b25c2e442c996fe7$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $b25c2e442c996fe7$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $b25c2e442c996fe7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $b25c2e442c996fe7$var$getListener(target, registrationName), null != stateNode && listeners.unshift($b25c2e442c996fe7$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $b25c2e442c996fe7$var$getListener(target, registrationName), null != stateNode && listeners.push($b25c2e442c996fe7$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $b25c2e442c996fe7$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $b25c2e442c996fe7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $b25c2e442c996fe7$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($b25c2e442c996fe7$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($b25c2e442c996fe7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $b25c2e442c996fe7$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $b25c2e442c996fe7$var$normalizeMarkupForTextOrAttribute(clientText);
    return $b25c2e442c996fe7$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $b25c2e442c996fe7$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $b25c2e442c996fe7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $b25c2e442c996fe7$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $b25c2e442c996fe7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $b25c2e442c996fe7$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b25c2e442c996fe7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $b25c2e442c996fe7$var$setProp(domElement, tag, "name", props.name, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($b25c2e442c996fe7$var$setProp(domElement, tag, "encType", props.encType, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "method", props.method, props, null), $b25c2e442c996fe7$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b25c2e442c996fe7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b25c2e442c996fe7$var$noop$1);
            break;
        case "onScroll":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $b25c2e442c996fe7$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", domElement);
            $b25c2e442c996fe7$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $b25c2e442c996fe7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $b25c2e442c996fe7$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $b25c2e442c996fe7$var$aliases.get(key) || key, $b25c2e442c996fe7$var$setValueForAttribute(domElement, key, value);
    }
}
function $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $b25c2e442c996fe7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $b25c2e442c996fe7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $b25c2e442c996fe7$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b25c2e442c996fe7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b25c2e442c996fe7$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$b25c2e442c996fe7$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$b25c2e442c996fe7$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $b25c2e442c996fe7$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $b25c2e442c996fe7$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                    default:
                        $b25c2e442c996fe7$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $b25c2e442c996fe7$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $b25c2e442c996fe7$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $b25c2e442c996fe7$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $b25c2e442c996fe7$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $b25c2e442c996fe7$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $b25c2e442c996fe7$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(91));
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $b25c2e442c996fe7$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("cancel", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $b25c2e442c996fe7$var$mediaEventTypes.length; hasSrc++)$b25c2e442c996fe7$var$listenToNonDelegatedEvent($b25c2e442c996fe7$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", domElement);
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $b25c2e442c996fe7$var$listenToNonDelegatedEvent("error", domElement), $b25c2e442c996fe7$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($b25c2e442c996fe7$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $b25c2e442c996fe7$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $b25c2e442c996fe7$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $b25c2e442c996fe7$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $b25c2e442c996fe7$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $b25c2e442c996fe7$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $b25c2e442c996fe7$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $b25c2e442c996fe7$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $b25c2e442c996fe7$var$updateOptions(domElement, !!lastProps, tag, !0) : $b25c2e442c996fe7$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $b25c2e442c996fe7$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $b25c2e442c996fe7$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $b25c2e442c996fe7$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($b25c2e442c996fe7$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $b25c2e442c996fe7$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $b25c2e442c996fe7$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $b25c2e442c996fe7$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $b25c2e442c996fe7$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $b25c2e442c996fe7$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $b25c2e442c996fe7$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $b25c2e442c996fe7$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $b25c2e442c996fe7$var$eventsEnabled = null, $b25c2e442c996fe7$var$selectionInformation = null;
function $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $b25c2e442c996fe7$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $b25c2e442c996fe7$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $b25c2e442c996fe7$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $b25c2e442c996fe7$var$currentPopstateTransitionEvent = null;
function $b25c2e442c996fe7$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $b25c2e442c996fe7$var$currentPopstateTransitionEvent) return !1;
        $b25c2e442c996fe7$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $b25c2e442c996fe7$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $b25c2e442c996fe7$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $b25c2e442c996fe7$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $b25c2e442c996fe7$var$localPromise = "function" === typeof Promise ? Promise : void 0, $b25c2e442c996fe7$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b25c2e442c996fe7$var$localPromise ? function(callback) {
    return $b25c2e442c996fe7$var$localPromise.resolve(null).then(callback).catch($b25c2e442c996fe7$var$handleErrorInNextTick);
} : $b25c2e442c996fe7$var$scheduleTimeout;
function $b25c2e442c996fe7$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $b25c2e442c996fe7$var$isSingletonScope(type) {
    return "head" === type;
}
function $b25c2e442c996fe7$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $b25c2e442c996fe7$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $b25c2e442c996fe7$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $b25c2e442c996fe7$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$b25c2e442c996fe7$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $b25c2e442c996fe7$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $b25c2e442c996fe7$var$retryIfBlockedOn(hydrationInstance);
}
function $b25c2e442c996fe7$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $b25c2e442c996fe7$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $b25c2e442c996fe7$var$clearContainerSparingly(node);
                $b25c2e442c996fe7$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $b25c2e442c996fe7$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$b25c2e442c996fe7$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $b25c2e442c996fe7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $b25c2e442c996fe7$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b25c2e442c996fe7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b25c2e442c996fe7$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b25c2e442c996fe7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b25c2e442c996fe7$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $b25c2e442c996fe7$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $b25c2e442c996fe7$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $b25c2e442c996fe7$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $b25c2e442c996fe7$var$previousHydratableOnEnteringScopedSingleton = null;
function $b25c2e442c996fe7$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $b25c2e442c996fe7$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $b25c2e442c996fe7$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $b25c2e442c996fe7$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $b25c2e442c996fe7$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(451));
    }
}
function $b25c2e442c996fe7$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $b25c2e442c996fe7$var$detachDeletedInstance(instance);
}
var $b25c2e442c996fe7$var$preloadPropsMap = new Map(), $b25c2e442c996fe7$var$preconnectsSet = new Set();
function $b25c2e442c996fe7$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $b25c2e442c996fe7$var$previousDispatcher = $b25c2e442c996fe7$var$ReactDOMSharedInternals.d;
$b25c2e442c996fe7$var$ReactDOMSharedInternals.d = {
    f: $b25c2e442c996fe7$var$flushSyncWork,
    r: $b25c2e442c996fe7$var$requestFormReset,
    D: $b25c2e442c996fe7$var$prefetchDNS,
    C: $b25c2e442c996fe7$var$preconnect,
    L: $b25c2e442c996fe7$var$preload,
    m: $b25c2e442c996fe7$var$preloadModule,
    X: $b25c2e442c996fe7$var$preinitScript,
    S: $b25c2e442c996fe7$var$preinitStyle,
    M: $b25c2e442c996fe7$var$preinitModuleScript
};
function $b25c2e442c996fe7$var$flushSyncWork() {
    var previousWasRendering = $b25c2e442c996fe7$var$previousDispatcher.f(), wasRendering = $b25c2e442c996fe7$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $b25c2e442c996fe7$var$requestFormReset(form) {
    var formInst = $b25c2e442c996fe7$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $b25c2e442c996fe7$var$requestFormReset$1(formInst) : $b25c2e442c996fe7$var$previousDispatcher.r(form);
}
var $b25c2e442c996fe7$var$globalDocument = "undefined" === typeof document ? null : document;
function $b25c2e442c996fe7$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $b25c2e442c996fe7$var$preconnectsSet.has(limitedEscapedHref) || ($b25c2e442c996fe7$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $b25c2e442c996fe7$var$setInitialProperties(href, "link", rel), $b25c2e442c996fe7$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $b25c2e442c996fe7$var$prefetchDNS(href) {
    $b25c2e442c996fe7$var$previousDispatcher.D(href);
    $b25c2e442c996fe7$var$preconnectAs("dns-prefetch", href, null);
}
function $b25c2e442c996fe7$var$preconnect(href, crossOrigin) {
    $b25c2e442c996fe7$var$previousDispatcher.C(href, crossOrigin);
    $b25c2e442c996fe7$var$preconnectAs("preconnect", href, crossOrigin);
}
function $b25c2e442c996fe7$var$preload(href, as, options) {
    $b25c2e442c996fe7$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $b25c2e442c996fe7$var$getStyleKey(href);
                break;
            case "script":
                key = $b25c2e442c996fe7$var$getScriptKey(href);
        }
        $b25c2e442c996fe7$var$preloadPropsMap.has(key) || (href = $b25c2e442c996fe7$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $b25c2e442c996fe7$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $b25c2e442c996fe7$var$setInitialProperties(as, "link", href), $b25c2e442c996fe7$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $b25c2e442c996fe7$var$preloadModule(href, options) {
    $b25c2e442c996fe7$var$previousDispatcher.m(href, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $b25c2e442c996fe7$var$getScriptKey(href);
        }
        if (!$b25c2e442c996fe7$var$preloadPropsMap.has(key) && (href = $b25c2e442c996fe7$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $b25c2e442c996fe7$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $b25c2e442c996fe7$var$setInitialProperties(as, "link", href);
            $b25c2e442c996fe7$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $b25c2e442c996fe7$var$preinitStyle(href, precedence, options) {
    $b25c2e442c996fe7$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $b25c2e442c996fe7$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $b25c2e442c996fe7$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $b25c2e442c996fe7$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $b25c2e442c996fe7$var$markNodeAsHoistable(link);
                $b25c2e442c996fe7$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $b25c2e442c996fe7$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $b25c2e442c996fe7$var$preinitScript(src, options) {
    $b25c2e442c996fe7$var$previousDispatcher.X(src, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b25c2e442c996fe7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b25c2e442c996fe7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key)), resource || (src = $b25c2e442c996fe7$var$assign({
            src: src,
            async: !0
        }, options), (options = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b25c2e442c996fe7$var$markNodeAsHoistable(resource), $b25c2e442c996fe7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b25c2e442c996fe7$var$preinitModuleScript(src, options) {
    $b25c2e442c996fe7$var$previousDispatcher.M(src, options);
    var ownerDocument = $b25c2e442c996fe7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b25c2e442c996fe7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b25c2e442c996fe7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(key)), resource || (src = $b25c2e442c996fe7$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b25c2e442c996fe7$var$markNodeAsHoistable(resource), $b25c2e442c996fe7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b25c2e442c996fe7$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $b25c2e442c996fe7$var$rootInstanceStackCursor.current) ? $b25c2e442c996fe7$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $b25c2e442c996fe7$var$getStyleKey(pendingProps.href), pendingProps = $b25c2e442c996fe7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $b25c2e442c996fe7$var$getStyleKey(pendingProps.href);
                var styles$243 = $b25c2e442c996fe7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $b25c2e442c996fe7$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $b25c2e442c996fe7$var$preloadPropsMap.set(type, pendingProps), styles$243 || $b25c2e442c996fe7$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $b25c2e442c996fe7$var$getScriptKey(pendingProps), pendingProps = $b25c2e442c996fe7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(444, type));
    }
}
function $b25c2e442c996fe7$var$getStyleKey(href) {
    return 'href="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $b25c2e442c996fe7$var$stylesheetPropsFromRawProps(rawProps) {
    return $b25c2e442c996fe7$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $b25c2e442c996fe7$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $b25c2e442c996fe7$var$setInitialProperties(key, "link", preloadProps), $b25c2e442c996fe7$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $b25c2e442c996fe7$var$getScriptKey(src) {
    return '[src="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $b25c2e442c996fe7$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $b25c2e442c996fe7$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $b25c2e442c996fe7$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $b25c2e442c996fe7$var$markNodeAsHoistable(instance), instance;
            var styleProps = $b25c2e442c996fe7$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $b25c2e442c996fe7$var$markNodeAsHoistable(instance);
            $b25c2e442c996fe7$var$setInitialProperties(instance, "style", styleProps);
            $b25c2e442c996fe7$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $b25c2e442c996fe7$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $b25c2e442c996fe7$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $b25c2e442c996fe7$var$stylesheetPropsFromRawProps(props);
            (styleProps = $b25c2e442c996fe7$var$preloadPropsMap.get(styleProps)) && $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $b25c2e442c996fe7$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b25c2e442c996fe7$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $b25c2e442c996fe7$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $b25c2e442c996fe7$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($b25c2e442c996fe7$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $b25c2e442c996fe7$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $b25c2e442c996fe7$var$preloadPropsMap.get(instance$249)) instance = $b25c2e442c996fe7$var$assign({}, props), $b25c2e442c996fe7$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $b25c2e442c996fe7$var$markNodeAsHoistable(styleProps);
            $b25c2e442c996fe7$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $b25c2e442c996fe7$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $b25c2e442c996fe7$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $b25c2e442c996fe7$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $b25c2e442c996fe7$var$tagCaches = null;
function $b25c2e442c996fe7$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $b25c2e442c996fe7$var$tagCaches) {
        var cache = new Map();
        var caches = $b25c2e442c996fe7$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $b25c2e442c996fe7$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$b25c2e442c996fe7$var$internalHoistableMarker] || node[$b25c2e442c996fe7$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $b25c2e442c996fe7$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $b25c2e442c996fe7$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $b25c2e442c996fe7$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $b25c2e442c996fe7$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $b25c2e442c996fe7$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($b25c2e442c996fe7$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $b25c2e442c996fe7$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $b25c2e442c996fe7$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $b25c2e442c996fe7$var$stylesheetPropsFromRawProps(props);
            (key = $b25c2e442c996fe7$var$preloadPropsMap.get(key)) && $b25c2e442c996fe7$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $b25c2e442c996fe7$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b25c2e442c996fe7$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $b25c2e442c996fe7$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $b25c2e442c996fe7$var$estimatedBytesWithinLimit = 0;
function $b25c2e442c996fe7$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $b25c2e442c996fe7$var$estimatedBytesWithinLimit && ($b25c2e442c996fe7$var$estimatedBytesWithinLimit = 62500 * $b25c2e442c996fe7$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $b25c2e442c996fe7$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $b25c2e442c996fe7$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $b25c2e442c996fe7$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $b25c2e442c996fe7$var$precedencesByRoot = null;
function $b25c2e442c996fe7$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $b25c2e442c996fe7$var$precedencesByRoot = new Map(), resources.forEach($b25c2e442c996fe7$var$insertStylesheetIntoRoot, state), $b25c2e442c996fe7$var$precedencesByRoot = null, $b25c2e442c996fe7$var$onUnsuspend.call(state));
}
function $b25c2e442c996fe7$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $b25c2e442c996fe7$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $b25c2e442c996fe7$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $b25c2e442c996fe7$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $b25c2e442c996fe7$var$HostTransitionContext = {
    $$typeof: $b25c2e442c996fe7$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $b25c2e442c996fe7$var$sharedNotPendingObject,
    _currentValue2: $b25c2e442c996fe7$var$sharedNotPendingObject,
    _threadCount: 0
};
function $b25c2e442c996fe7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $b25c2e442c996fe7$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b25c2e442c996fe7$var$createLaneMap(0);
    this.hiddenUpdates = $b25c2e442c996fe7$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $b25c2e442c996fe7$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $b25c2e442c996fe7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $b25c2e442c996fe7$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $b25c2e442c996fe7$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $b25c2e442c996fe7$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $b25c2e442c996fe7$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $b25c2e442c996fe7$var$emptyContextObject;
    parentComponent = $b25c2e442c996fe7$var$emptyContextObject;
    return parentComponent;
}
function $b25c2e442c996fe7$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $b25c2e442c996fe7$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $b25c2e442c996fe7$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $b25c2e442c996fe7$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($b25c2e442c996fe7$var$scheduleUpdateOnFiber(element, rootFiber, lane), $b25c2e442c996fe7$var$entangleTransitions(element, rootFiber, lane));
}
function $b25c2e442c996fe7$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $b25c2e442c996fe7$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $b25c2e442c996fe7$var$markRetryLaneImpl(fiber, retryLane);
}
function $b25c2e442c996fe7$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $b25c2e442c996fe7$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $b25c2e442c996fe7$var$requestUpdateLane();
        lane = $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(lane);
        var root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, lane);
        $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $b25c2e442c996fe7$var$_enabled = !0;
function $b25c2e442c996fe7$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T;
    $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 2, $b25c2e442c996fe7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b25c2e442c996fe7$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b25c2e442c996fe7$var$ReactSharedInternals.T;
    $b25c2e442c996fe7$var$ReactSharedInternals.T = null;
    var previousPriority = $b25c2e442c996fe7$var$ReactDOMSharedInternals.p;
    try {
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = 8, $b25c2e442c996fe7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b25c2e442c996fe7$var$ReactDOMSharedInternals.p = previousPriority, $b25c2e442c996fe7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b25c2e442c996fe7$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($b25c2e442c996fe7$var$_enabled) {
        var blockedOn = $b25c2e442c996fe7$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b25c2e442c996fe7$var$return_targetInst, targetContainer), $b25c2e442c996fe7$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($b25c2e442c996fe7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($b25c2e442c996fe7$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $b25c2e442c996fe7$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $b25c2e442c996fe7$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $b25c2e442c996fe7$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $b25c2e442c996fe7$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $b25c2e442c996fe7$var$ensureRootIsScheduled(fiber);
                                0 === ($b25c2e442c996fe7$var$executionContext & 6) && ($b25c2e442c996fe7$var$workInProgressRootRenderTargetTime = $b25c2e442c996fe7$var$now() + 500, $b25c2e442c996fe7$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $b25c2e442c996fe7$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $b25c2e442c996fe7$var$scheduleUpdateOnFiber(root, fiber, 2), $b25c2e442c996fe7$var$flushSyncWork$1(), $b25c2e442c996fe7$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $b25c2e442c996fe7$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b25c2e442c996fe7$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $b25c2e442c996fe7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $b25c2e442c996fe7$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $b25c2e442c996fe7$var$getEventTarget(nativeEvent);
    return $b25c2e442c996fe7$var$findInstanceBlockingTarget(nativeEvent);
}
var $b25c2e442c996fe7$var$return_targetInst = null;
function $b25c2e442c996fe7$var$findInstanceBlockingTarget(targetNode) {
    $b25c2e442c996fe7$var$return_targetInst = null;
    targetNode = $b25c2e442c996fe7$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $b25c2e442c996fe7$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $b25c2e442c996fe7$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $b25c2e442c996fe7$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $b25c2e442c996fe7$var$return_targetInst = targetNode;
    return null;
}
function $b25c2e442c996fe7$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($b25c2e442c996fe7$var$getCurrentPriorityLevel()){
                case $b25c2e442c996fe7$var$ImmediatePriority:
                    return 2;
                case $b25c2e442c996fe7$var$UserBlockingPriority:
                    return 8;
                case $b25c2e442c996fe7$var$NormalPriority$1:
                case $b25c2e442c996fe7$var$LowPriority:
                    return 32;
                case $b25c2e442c996fe7$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $b25c2e442c996fe7$var$hasScheduledReplayAttempt = !1, $b25c2e442c996fe7$var$queuedFocus = null, $b25c2e442c996fe7$var$queuedDrag = null, $b25c2e442c996fe7$var$queuedMouse = null, $b25c2e442c996fe7$var$queuedPointers = new Map(), $b25c2e442c996fe7$var$queuedPointerCaptures = new Map(), $b25c2e442c996fe7$var$queuedExplicitHydrationTargets = [], $b25c2e442c996fe7$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $b25c2e442c996fe7$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $b25c2e442c996fe7$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $b25c2e442c996fe7$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $b25c2e442c996fe7$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $b25c2e442c996fe7$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b25c2e442c996fe7$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $b25c2e442c996fe7$var$getInstanceFromNode(blockedOn), null !== blockedOn && $b25c2e442c996fe7$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $b25c2e442c996fe7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $b25c2e442c996fe7$var$queuedFocus = $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $b25c2e442c996fe7$var$queuedDrag = $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $b25c2e442c996fe7$var$queuedMouse = $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $b25c2e442c996fe7$var$queuedPointers.set(pointerId, $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $b25c2e442c996fe7$var$queuedPointerCaptures.set(pointerId, $b25c2e442c996fe7$var$accumulateOrCreateContinuousQueuedReplayableEvent($b25c2e442c996fe7$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $b25c2e442c996fe7$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $b25c2e442c996fe7$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $b25c2e442c996fe7$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $b25c2e442c996fe7$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b25c2e442c996fe7$var$runWithPriority(queuedTarget.priority, function() {
                        $b25c2e442c996fe7$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $b25c2e442c996fe7$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b25c2e442c996fe7$var$runWithPriority(queuedTarget.priority, function() {
                        $b25c2e442c996fe7$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $b25c2e442c996fe7$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $b25c2e442c996fe7$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $b25c2e442c996fe7$var$currentReplayingEvent = null;
        } else return targetContainers = $b25c2e442c996fe7$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $b25c2e442c996fe7$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $b25c2e442c996fe7$var$replayUnblockedEvents() {
    $b25c2e442c996fe7$var$hasScheduledReplayAttempt = !1;
    null !== $b25c2e442c996fe7$var$queuedFocus && $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent($b25c2e442c996fe7$var$queuedFocus) && ($b25c2e442c996fe7$var$queuedFocus = null);
    null !== $b25c2e442c996fe7$var$queuedDrag && $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent($b25c2e442c996fe7$var$queuedDrag) && ($b25c2e442c996fe7$var$queuedDrag = null);
    null !== $b25c2e442c996fe7$var$queuedMouse && $b25c2e442c996fe7$var$attemptReplayContinuousQueuedEvent($b25c2e442c996fe7$var$queuedMouse) && ($b25c2e442c996fe7$var$queuedMouse = null);
    $b25c2e442c996fe7$var$queuedPointers.forEach($b25c2e442c996fe7$var$attemptReplayContinuousQueuedEventInMap);
    $b25c2e442c996fe7$var$queuedPointerCaptures.forEach($b25c2e442c996fe7$var$attemptReplayContinuousQueuedEventInMap);
}
function $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $b25c2e442c996fe7$var$hasScheduledReplayAttempt || ($b25c2e442c996fe7$var$hasScheduledReplayAttempt = !0, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, $b25c2e442c996fe7$var$replayUnblockedEvents)));
}
var $b25c2e442c996fe7$var$lastScheduledReplayQueue = null;
function $b25c2e442c996fe7$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $b25c2e442c996fe7$var$lastScheduledReplayQueue !== formReplayingQueue && ($b25c2e442c996fe7$var$lastScheduledReplayQueue = formReplayingQueue, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, function() {
        $b25c2e442c996fe7$var$lastScheduledReplayQueue === formReplayingQueue && ($b25c2e442c996fe7$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $b25c2e442c996fe7$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $b25c2e442c996fe7$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $b25c2e442c996fe7$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $b25c2e442c996fe7$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $b25c2e442c996fe7$var$queuedFocus && $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked($b25c2e442c996fe7$var$queuedFocus, unblocked);
    null !== $b25c2e442c996fe7$var$queuedDrag && $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked($b25c2e442c996fe7$var$queuedDrag, unblocked);
    null !== $b25c2e442c996fe7$var$queuedMouse && $b25c2e442c996fe7$var$scheduleCallbackIfUnblocked($b25c2e442c996fe7$var$queuedMouse, unblocked);
    $b25c2e442c996fe7$var$queuedPointers.forEach(unblock);
    $b25c2e442c996fe7$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $b25c2e442c996fe7$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.length && (i = $b25c2e442c996fe7$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$b25c2e442c996fe7$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$b25c2e442c996fe7$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $b25c2e442c996fe7$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$b25c2e442c996fe7$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $b25c2e442c996fe7$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $b25c2e442c996fe7$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $b25c2e442c996fe7$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $b25c2e442c996fe7$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b25c2e442c996fe7$var$ReactDOMHydrationRoot.prototype.render = $b25c2e442c996fe7$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(409));
    var current = root.current, lane = $b25c2e442c996fe7$var$requestUpdateLane();
    $b25c2e442c996fe7$var$updateContainerImpl(current, lane, children, root, null, null);
};
$b25c2e442c996fe7$var$ReactDOMHydrationRoot.prototype.unmount = $b25c2e442c996fe7$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $b25c2e442c996fe7$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $b25c2e442c996fe7$var$flushSyncWork$1();
        container[$b25c2e442c996fe7$var$internalContainerInstanceKey] = null;
    }
};
function $b25c2e442c996fe7$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b25c2e442c996fe7$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $b25c2e442c996fe7$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $b25c2e442c996fe7$var$queuedExplicitHydrationTargets[i].priority; i++);
        $b25c2e442c996fe7$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $b25c2e442c996fe7$var$attemptExplicitHydrationTarget(target);
    }
};
var $b25c2e442c996fe7$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $2WGWz.version;
if ("19.2.4" !== $b25c2e442c996fe7$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(527, $b25c2e442c996fe7$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$b25c2e442c996fe7$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $b25c2e442c996fe7$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $b25c2e442c996fe7$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $b25c2e442c996fe7$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $b25c2e442c996fe7$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b25c2e442c996fe7$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b25c2e442c996fe7$var$hook$jscomp$inline_2348.isDisabled && $b25c2e442c996fe7$var$hook$jscomp$inline_2348.supportsFiber) try {
        $b25c2e442c996fe7$var$rendererID = $b25c2e442c996fe7$var$hook$jscomp$inline_2348.inject($b25c2e442c996fe7$var$internals$jscomp$inline_2347), $b25c2e442c996fe7$var$injectedHook = $b25c2e442c996fe7$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$b25c2e442c996fe7$export$882461b6382ed46c = function(container, options) {
    if (!$b25c2e442c996fe7$var$isValidContainer(container)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b25c2e442c996fe7$var$defaultOnUncaughtError, onCaughtError = $b25c2e442c996fe7$var$defaultOnCaughtError, onRecoverableError = $b25c2e442c996fe7$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $b25c2e442c996fe7$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $b25c2e442c996fe7$var$defaultOnDefaultTransitionIndicator);
    container[$b25c2e442c996fe7$var$internalContainerInstanceKey] = options.current;
    $b25c2e442c996fe7$var$listenToAllSupportedEvents(container);
    return new $b25c2e442c996fe7$var$ReactDOMRoot(options);
};
$b25c2e442c996fe7$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$b25c2e442c996fe7$var$isValidContainer(container)) throw Error($b25c2e442c996fe7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b25c2e442c996fe7$var$defaultOnUncaughtError, onCaughtError = $b25c2e442c996fe7$var$defaultOnCaughtError, onRecoverableError = $b25c2e442c996fe7$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $b25c2e442c996fe7$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $b25c2e442c996fe7$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $b25c2e442c996fe7$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $b25c2e442c996fe7$var$requestUpdateLane();
    isStrictMode = $b25c2e442c996fe7$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $b25c2e442c996fe7$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $b25c2e442c996fe7$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $b25c2e442c996fe7$var$markRootUpdated$1(initialChildren, options);
    $b25c2e442c996fe7$var$ensureRootIsScheduled(initialChildren);
    container[$b25c2e442c996fe7$var$internalContainerInstanceKey] = initialChildren.current;
    $b25c2e442c996fe7$var$listenToAllSupportedEvents(container);
    return new $b25c2e442c996fe7$var$ReactDOMHydrationRoot(initialChildren);
};
$b25c2e442c996fe7$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("bIbqH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hvKuw"));

});
parcelRegister("hvKuw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $cbf9651fe4890f47$export$c4744153514ff05d, (v) => $cbf9651fe4890f47$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7, (v) => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $cbf9651fe4890f47$export$e26fe2ed2fa76875, (v) => $cbf9651fe4890f47$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $cbf9651fe4890f47$export$502329bbf4b505b1, (v) => $cbf9651fe4890f47$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $cbf9651fe4890f47$export$6e3807111c4874c4, (v) => $cbf9651fe4890f47$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $cbf9651fe4890f47$export$c27134553091fb3a, (v) => $cbf9651fe4890f47$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $cbf9651fe4890f47$export$33ee1acdc04fd2a2, (v) => $cbf9651fe4890f47$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $cbf9651fe4890f47$export$b00a404bbd5edef2, (v) => $cbf9651fe4890f47$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $cbf9651fe4890f47$export$d66a1c1c77bd778b, (v) => $cbf9651fe4890f47$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $cbf9651fe4890f47$export$d3dfb8e4810cb555, (v) => $cbf9651fe4890f47$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $cbf9651fe4890f47$export$72fdf0e06517287b, (v) => $cbf9651fe4890f47$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $cbf9651fe4890f47$export$816d2913ae6b83b1, (v) => $cbf9651fe4890f47$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $cbf9651fe4890f47$export$61bcfe829111a1d0, (v) => $cbf9651fe4890f47$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $cbf9651fe4890f47$export$7ee8c9beb337bc3f, (v) => $cbf9651fe4890f47$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $cbf9651fe4890f47$export$b5836b71941fa3ed, (v) => $cbf9651fe4890f47$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $cbf9651fe4890f47$export$cf845f2c119da08a, (v) => $cbf9651fe4890f47$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbf9651fe4890f47$export$c4744153514ff05d;
var $cbf9651fe4890f47$export$3e506c1ccc9cc1a7;
var $cbf9651fe4890f47$export$e26fe2ed2fa76875;
var $cbf9651fe4890f47$export$502329bbf4b505b1;
var $cbf9651fe4890f47$export$6e3807111c4874c4;
var $cbf9651fe4890f47$export$c27134553091fb3a;
var $cbf9651fe4890f47$export$33ee1acdc04fd2a2;
var $cbf9651fe4890f47$export$b00a404bbd5edef2;
var $cbf9651fe4890f47$export$d66a1c1c77bd778b;
var $cbf9651fe4890f47$export$d3dfb8e4810cb555;
var $cbf9651fe4890f47$export$72fdf0e06517287b;
var $cbf9651fe4890f47$export$816d2913ae6b83b1;
var $cbf9651fe4890f47$export$61bcfe829111a1d0;
var $cbf9651fe4890f47$export$7ee8c9beb337bc3f;
var $cbf9651fe4890f47$export$b5836b71941fa3ed;
var $cbf9651fe4890f47$export$cf845f2c119da08a;
"use strict";
function $cbf9651fe4890f47$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $cbf9651fe4890f47$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $cbf9651fe4890f47$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $cbf9651fe4890f47$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $cbf9651fe4890f47$var$compare(left, last)) rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $cbf9651fe4890f47$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$cbf9651fe4890f47$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cbf9651fe4890f47$var$localPerformance = performance;
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localPerformance.now();
    };
} else {
    var $cbf9651fe4890f47$var$localDate = Date, $cbf9651fe4890f47$var$initialTime = $cbf9651fe4890f47$var$localDate.now();
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localDate.now() - $cbf9651fe4890f47$var$initialTime;
    };
}
var $cbf9651fe4890f47$var$taskQueue = [], $cbf9651fe4890f47$var$timerQueue = [], $cbf9651fe4890f47$var$taskIdCounter = 1, $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = 3, $cbf9651fe4890f47$var$isPerformingWork = !1, $cbf9651fe4890f47$var$isHostCallbackScheduled = !1, $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$needsPaint = !1, $cbf9651fe4890f47$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $cbf9651fe4890f47$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $cbf9651fe4890f47$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $cbf9651fe4890f47$var$advanceTimers(currentTime) {
    for(var timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue); null !== timer;){
        if (null === timer.callback) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue);
        else if (timer.startTime <= currentTime) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue), timer.sortIndex = timer.expirationTime, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, timer);
        else break;
        timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
    }
}
function $cbf9651fe4890f47$var$handleTimeout(currentTime) {
    $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1;
    $cbf9651fe4890f47$var$advanceTimers(currentTime);
    if (!$cbf9651fe4890f47$var$isHostCallbackScheduled) {
        if (null !== $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue)) $cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $cbf9651fe4890f47$var$isMessageLoopRunning = !1, $cbf9651fe4890f47$var$taskTimeoutID = -1, $cbf9651fe4890f47$var$frameInterval = 5, $cbf9651fe4890f47$var$startTime = -1;
function $cbf9651fe4890f47$var$shouldYieldToHost() {
    return $cbf9651fe4890f47$var$needsPaint ? !0 : $cbf9651fe4890f47$export$c4744153514ff05d() - $cbf9651fe4890f47$var$startTime < $cbf9651fe4890f47$var$frameInterval ? !1 : !0;
}
function $cbf9651fe4890f47$var$performWorkUntilDeadline() {
    $cbf9651fe4890f47$var$needsPaint = !1;
    if ($cbf9651fe4890f47$var$isMessageLoopRunning) {
        var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
        $cbf9651fe4890f47$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $cbf9651fe4890f47$var$isHostCallbackScheduled = !1;
                $cbf9651fe4890f47$var$isHostTimeoutScheduled && ($cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1);
                $cbf9651fe4890f47$var$isPerformingWork = !0;
                var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
                try {
                    b: {
                        $cbf9651fe4890f47$var$advanceTimers(currentTime);
                        for($cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue); null !== $cbf9651fe4890f47$var$currentTask && !($cbf9651fe4890f47$var$currentTask.expirationTime > currentTime && $cbf9651fe4890f47$var$shouldYieldToHost());){
                            var callback = $cbf9651fe4890f47$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $cbf9651fe4890f47$var$currentTask.callback = null;
                                $cbf9651fe4890f47$var$currentPriorityLevel = $cbf9651fe4890f47$var$currentTask.priorityLevel;
                                var continuationCallback = callback($cbf9651fe4890f47$var$currentTask.expirationTime <= currentTime);
                                currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $cbf9651fe4890f47$var$currentTask.callback = continuationCallback;
                                    $cbf9651fe4890f47$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $cbf9651fe4890f47$var$currentTask === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                                $cbf9651fe4890f47$var$advanceTimers(currentTime);
                            } else $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                            $cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue);
                        }
                        if (null !== $cbf9651fe4890f47$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
                            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel, $cbf9651fe4890f47$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline() : $cbf9651fe4890f47$var$isMessageLoopRunning = !1;
        }
    }
}
var $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $cbf9651fe4890f47$var$localSetImmediate) $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetImmediate($cbf9651fe4890f47$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cbf9651fe4890f47$var$channel = new MessageChannel(), $cbf9651fe4890f47$var$port = $cbf9651fe4890f47$var$channel.port2;
    $cbf9651fe4890f47$var$channel.port1.onmessage = $cbf9651fe4890f47$var$performWorkUntilDeadline;
    $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
        $cbf9651fe4890f47$var$port.postMessage(null);
    };
} else $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetTimeout($cbf9651fe4890f47$var$performWorkUntilDeadline, 0);
};
function $cbf9651fe4890f47$var$requestHostTimeout(callback, ms) {
    $cbf9651fe4890f47$var$taskTimeoutID = $cbf9651fe4890f47$var$localSetTimeout(function() {
        callback($cbf9651fe4890f47$export$c4744153514ff05d());
    }, ms);
}
$cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = 5;
$cbf9651fe4890f47$export$e26fe2ed2fa76875 = 1;
$cbf9651fe4890f47$export$502329bbf4b505b1 = 4;
$cbf9651fe4890f47$export$6e3807111c4874c4 = 3;
$cbf9651fe4890f47$export$c27134553091fb3a = null;
$cbf9651fe4890f47$export$33ee1acdc04fd2a2 = 2;
$cbf9651fe4890f47$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$cbf9651fe4890f47$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cbf9651fe4890f47$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$cbf9651fe4890f47$export$d3dfb8e4810cb555 = function() {
    return $cbf9651fe4890f47$var$currentPriorityLevel;
};
$cbf9651fe4890f47$export$72fdf0e06517287b = function(eventHandler) {
    switch($cbf9651fe4890f47$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$816d2913ae6b83b1 = function() {
    $cbf9651fe4890f47$var$needsPaint = !0;
};
$cbf9651fe4890f47$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $cbf9651fe4890f47$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$timerQueue, priorityLevel), null === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && priorityLevel === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue) && ($cbf9651fe4890f47$var$isHostTimeoutScheduled ? ($cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1) : $cbf9651fe4890f47$var$isHostTimeoutScheduled = !0, $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, priorityLevel), $cbf9651fe4890f47$var$isHostCallbackScheduled || $cbf9651fe4890f47$var$isPerformingWork || ($cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$cbf9651fe4890f47$export$b5836b71941fa3ed = $cbf9651fe4890f47$var$shouldYieldToHost;
$cbf9651fe4890f47$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
        $cbf9651fe4890f47$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("2WGWz", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Q9Iw"));

});
parcelRegister("9Q9Iw", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72a081fca2fa8551$export$9c16c1426311996d, (v) => $72a081fca2fa8551$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72a081fca2fa8551$export$dca3b0875bd9a954, (v) => $72a081fca2fa8551$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72a081fca2fa8551$export$16fa2f45be04daa8, (v) => $72a081fca2fa8551$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72a081fca2fa8551$export$ffb0004e005737fa, (v) => $72a081fca2fa8551$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72a081fca2fa8551$export$e2c29f18771995cb, (v) => $72a081fca2fa8551$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72a081fca2fa8551$export$221d75b3f55bb0bd, (v) => $72a081fca2fa8551$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72a081fca2fa8551$export$5f8d39834fd61797, (v) => $72a081fca2fa8551$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72a081fca2fa8551$export$74bf444e3cd11ea5, (v) => $72a081fca2fa8551$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72a081fca2fa8551$export$1ced07cd6b1985ce, (v) => $72a081fca2fa8551$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72a081fca2fa8551$export$abd8e32b826d7ea7, (v) => $72a081fca2fa8551$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72a081fca2fa8551$export$69a3209f1a06c04d, (v) => $72a081fca2fa8551$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72a081fca2fa8551$export$8c538325882c7eec, (v) => $72a081fca2fa8551$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72a081fca2fa8551$export$e530037191fcd5d7, (v) => $72a081fca2fa8551$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72a081fca2fa8551$export$fd42f52fd3ae1109, (v) => $72a081fca2fa8551$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72a081fca2fa8551$export$c8a8987d4410bf2d, (v) => $72a081fca2fa8551$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72a081fca2fa8551$export$7d1e3a5e95ceca43, (v) => $72a081fca2fa8551$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72a081fca2fa8551$export$257a8862b851cb5b, (v) => $72a081fca2fa8551$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72a081fca2fa8551$export$a8257692ac88316c, (v) => $72a081fca2fa8551$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72a081fca2fa8551$export$488013bae63b21da, (v) => $72a081fca2fa8551$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72a081fca2fa8551$export$7c73462e0d25e514, (v) => $72a081fca2fa8551$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72a081fca2fa8551$export$7568632d0d33d16d, (v) => $72a081fca2fa8551$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72a081fca2fa8551$export$f93f40ac0ca7e3a8, (v) => $72a081fca2fa8551$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72a081fca2fa8551$export$1f96ae73734a86cc, (v) => $72a081fca2fa8551$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72a081fca2fa8551$export$9a47ced3238df325, (v) => $72a081fca2fa8551$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72a081fca2fa8551$export$35808ee640e87ca7, (v) => $72a081fca2fa8551$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72a081fca2fa8551$export$fae74005e78b1a27, (v) => $72a081fca2fa8551$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72a081fca2fa8551$export$dc8fbce3eb94dc1e, (v) => $72a081fca2fa8551$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72a081fca2fa8551$export$6a7bc4e911dc01cf, (v) => $72a081fca2fa8551$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72a081fca2fa8551$export$6d9c69b0de29b591, (v) => $72a081fca2fa8551$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72a081fca2fa8551$export$7f54fc3180508a52, (v) => $72a081fca2fa8551$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72a081fca2fa8551$export$f680877a34711e37, (v) => $72a081fca2fa8551$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72a081fca2fa8551$export$d5a552a76deda3c2, (v) => $72a081fca2fa8551$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72a081fca2fa8551$export$aaabe4eda9ed9969, (v) => $72a081fca2fa8551$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72a081fca2fa8551$export$e5c5a5f917a5871c, (v) => $72a081fca2fa8551$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72a081fca2fa8551$export$1538c33de8887b59, (v) => $72a081fca2fa8551$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72a081fca2fa8551$export$fca7f784ae7a249a, (v) => $72a081fca2fa8551$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72a081fca2fa8551$export$13e3392192263954, (v) => $72a081fca2fa8551$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72a081fca2fa8551$export$b8f5890fc79d6aca, (v) => $72a081fca2fa8551$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72a081fca2fa8551$export$60241385465d0a34, (v) => $72a081fca2fa8551$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72a081fca2fa8551$export$306c0aa65ff9ec16, (v) => $72a081fca2fa8551$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72a081fca2fa8551$export$7b286972b8d8ccbf, (v) => $72a081fca2fa8551$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72a081fca2fa8551$export$83d89fbfd8236492, (v) => $72a081fca2fa8551$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72a081fca2fa8551$export$9c16c1426311996d;
var $72a081fca2fa8551$export$dca3b0875bd9a954;
var $72a081fca2fa8551$export$16fa2f45be04daa8;
var $72a081fca2fa8551$export$ffb0004e005737fa;
var $72a081fca2fa8551$export$e2c29f18771995cb;
var $72a081fca2fa8551$export$221d75b3f55bb0bd;
var $72a081fca2fa8551$export$5f8d39834fd61797;
var $72a081fca2fa8551$export$74bf444e3cd11ea5;
var $72a081fca2fa8551$export$1ced07cd6b1985ce;
var $72a081fca2fa8551$export$abd8e32b826d7ea7;
var $72a081fca2fa8551$export$69a3209f1a06c04d;
var $72a081fca2fa8551$export$8c538325882c7eec;
var $72a081fca2fa8551$export$e530037191fcd5d7;
var $72a081fca2fa8551$export$fd42f52fd3ae1109;
var $72a081fca2fa8551$export$c8a8987d4410bf2d;
var $72a081fca2fa8551$export$7d1e3a5e95ceca43;
var $72a081fca2fa8551$export$257a8862b851cb5b;
var $72a081fca2fa8551$export$a8257692ac88316c;
var $72a081fca2fa8551$export$488013bae63b21da;
var $72a081fca2fa8551$export$7c73462e0d25e514;
var $72a081fca2fa8551$export$7568632d0d33d16d;
var $72a081fca2fa8551$export$f93f40ac0ca7e3a8;
var $72a081fca2fa8551$export$1f96ae73734a86cc;
var $72a081fca2fa8551$export$9a47ced3238df325;
var $72a081fca2fa8551$export$35808ee640e87ca7;
var $72a081fca2fa8551$export$fae74005e78b1a27;
var $72a081fca2fa8551$export$dc8fbce3eb94dc1e;
var $72a081fca2fa8551$export$6a7bc4e911dc01cf;
var $72a081fca2fa8551$export$6d9c69b0de29b591;
var $72a081fca2fa8551$export$7f54fc3180508a52;
var $72a081fca2fa8551$export$f680877a34711e37;
var $72a081fca2fa8551$export$d5a552a76deda3c2;
var $72a081fca2fa8551$export$aaabe4eda9ed9969;
var $72a081fca2fa8551$export$e5c5a5f917a5871c;
var $72a081fca2fa8551$export$1538c33de8887b59;
var $72a081fca2fa8551$export$fca7f784ae7a249a;
var $72a081fca2fa8551$export$13e3392192263954;
var $72a081fca2fa8551$export$b8f5890fc79d6aca;
var $72a081fca2fa8551$export$60241385465d0a34;
var $72a081fca2fa8551$export$306c0aa65ff9ec16;
var $72a081fca2fa8551$export$7b286972b8d8ccbf;
var $72a081fca2fa8551$export$83d89fbfd8236492;
"use strict";
var $72a081fca2fa8551$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72a081fca2fa8551$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72a081fca2fa8551$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72a081fca2fa8551$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72a081fca2fa8551$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72a081fca2fa8551$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72a081fca2fa8551$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72a081fca2fa8551$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72a081fca2fa8551$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72a081fca2fa8551$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72a081fca2fa8551$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72a081fca2fa8551$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72a081fca2fa8551$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72a081fca2fa8551$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72a081fca2fa8551$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72a081fca2fa8551$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72a081fca2fa8551$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72a081fca2fa8551$var$assign = Object.assign, $72a081fca2fa8551$var$emptyObject = {};
function $72a081fca2fa8551$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72a081fca2fa8551$var$emptyObject;
    this.updater = updater || $72a081fca2fa8551$var$ReactNoopUpdateQueue;
}
$72a081fca2fa8551$var$Component.prototype.isReactComponent = {};
$72a081fca2fa8551$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72a081fca2fa8551$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72a081fca2fa8551$var$ComponentDummy() {}
$72a081fca2fa8551$var$ComponentDummy.prototype = $72a081fca2fa8551$var$Component.prototype;
function $72a081fca2fa8551$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72a081fca2fa8551$var$emptyObject;
    this.updater = updater || $72a081fca2fa8551$var$ReactNoopUpdateQueue;
}
var $72a081fca2fa8551$var$pureComponentPrototype = $72a081fca2fa8551$var$PureComponent.prototype = new $72a081fca2fa8551$var$ComponentDummy();
$72a081fca2fa8551$var$pureComponentPrototype.constructor = $72a081fca2fa8551$var$PureComponent;
$72a081fca2fa8551$var$assign($72a081fca2fa8551$var$pureComponentPrototype, $72a081fca2fa8551$var$Component.prototype);
$72a081fca2fa8551$var$pureComponentPrototype.isPureReactComponent = !0;
var $72a081fca2fa8551$var$isArrayImpl = Array.isArray;
function $72a081fca2fa8551$var$noop() {}
var $72a081fca2fa8551$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72a081fca2fa8551$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72a081fca2fa8551$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72a081fca2fa8551$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72a081fca2fa8551$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72a081fca2fa8551$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72a081fca2fa8551$var$REACT_ELEMENT_TYPE;
}
function $72a081fca2fa8551$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72a081fca2fa8551$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72a081fca2fa8551$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72a081fca2fa8551$var$escape("" + element.key) : index.toString(36);
}
function $72a081fca2fa8551$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72a081fca2fa8551$var$noop, $72a081fca2fa8551$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72a081fca2fa8551$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72a081fca2fa8551$var$REACT_ELEMENT_TYPE:
                case $72a081fca2fa8551$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72a081fca2fa8551$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72a081fca2fa8551$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72a081fca2fa8551$var$getElementKey(children, 0) : nameSoFar, $72a081fca2fa8551$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72a081fca2fa8551$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72a081fca2fa8551$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72a081fca2fa8551$var$isValidElement(callback) && (callback = $72a081fca2fa8551$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72a081fca2fa8551$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72a081fca2fa8551$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72a081fca2fa8551$var$getElementKey(nameSoFar, i), invokeCallback += $72a081fca2fa8551$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72a081fca2fa8551$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72a081fca2fa8551$var$getElementKey(nameSoFar, i++), invokeCallback += $72a081fca2fa8551$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72a081fca2fa8551$var$mapIntoArray($72a081fca2fa8551$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72a081fca2fa8551$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72a081fca2fa8551$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72a081fca2fa8551$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72a081fca2fa8551$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72a081fca2fa8551$var$Children = {
    map: $72a081fca2fa8551$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72a081fca2fa8551$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72a081fca2fa8551$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72a081fca2fa8551$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72a081fca2fa8551$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72a081fca2fa8551$export$9c16c1426311996d = $72a081fca2fa8551$var$REACT_ACTIVITY_TYPE;
$72a081fca2fa8551$export$dca3b0875bd9a954 = $72a081fca2fa8551$var$Children;
$72a081fca2fa8551$export$16fa2f45be04daa8 = $72a081fca2fa8551$var$Component;
$72a081fca2fa8551$export$ffb0004e005737fa = $72a081fca2fa8551$var$REACT_FRAGMENT_TYPE;
$72a081fca2fa8551$export$e2c29f18771995cb = $72a081fca2fa8551$var$REACT_PROFILER_TYPE;
$72a081fca2fa8551$export$221d75b3f55bb0bd = $72a081fca2fa8551$var$PureComponent;
$72a081fca2fa8551$export$5f8d39834fd61797 = $72a081fca2fa8551$var$REACT_STRICT_MODE_TYPE;
$72a081fca2fa8551$export$74bf444e3cd11ea5 = $72a081fca2fa8551$var$REACT_SUSPENSE_TYPE;
$72a081fca2fa8551$export$1ced07cd6b1985ce = $72a081fca2fa8551$var$ReactSharedInternals;
$72a081fca2fa8551$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72a081fca2fa8551$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72a081fca2fa8551$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72a081fca2fa8551$export$8c538325882c7eec = function() {
    return null;
};
$72a081fca2fa8551$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72a081fca2fa8551$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72a081fca2fa8551$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72a081fca2fa8551$var$ReactElement(element.type, key, props);
};
$72a081fca2fa8551$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72a081fca2fa8551$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72a081fca2fa8551$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72a081fca2fa8551$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72a081fca2fa8551$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72a081fca2fa8551$var$ReactElement(type, key, props);
};
$72a081fca2fa8551$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72a081fca2fa8551$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72a081fca2fa8551$export$a8257692ac88316c = $72a081fca2fa8551$var$isValidElement;
$72a081fca2fa8551$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72a081fca2fa8551$var$lazyInitializer
    };
};
$72a081fca2fa8551$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72a081fca2fa8551$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72a081fca2fa8551$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72a081fca2fa8551$var$ReactSharedInternals.T, currentTransition = {};
    $72a081fca2fa8551$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72a081fca2fa8551$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72a081fca2fa8551$var$noop, $72a081fca2fa8551$var$reportGlobalError);
    } catch (error) {
        $72a081fca2fa8551$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72a081fca2fa8551$var$ReactSharedInternals.T = prevTransition;
    }
};
$72a081fca2fa8551$export$f93f40ac0ca7e3a8 = function() {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useCacheRefresh();
};
$72a081fca2fa8551$export$1f96ae73734a86cc = function(usable) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.use(usable);
};
$72a081fca2fa8551$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72a081fca2fa8551$export$35808ee640e87ca7 = function(callback, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72a081fca2fa8551$export$fae74005e78b1a27 = function(Context) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useContext(Context);
};
$72a081fca2fa8551$export$dc8fbce3eb94dc1e = function() {};
$72a081fca2fa8551$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72a081fca2fa8551$export$6d9c69b0de29b591 = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72a081fca2fa8551$export$7f54fc3180508a52 = function(callback) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72a081fca2fa8551$export$f680877a34711e37 = function() {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useId();
};
$72a081fca2fa8551$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72a081fca2fa8551$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72a081fca2fa8551$export$e5c5a5f917a5871c = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72a081fca2fa8551$export$1538c33de8887b59 = function(create, deps) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72a081fca2fa8551$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72a081fca2fa8551$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72a081fca2fa8551$export$b8f5890fc79d6aca = function(initialValue) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useRef(initialValue);
};
$72a081fca2fa8551$export$60241385465d0a34 = function(initialState) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useState(initialState);
};
$72a081fca2fa8551$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72a081fca2fa8551$export$7b286972b8d8ccbf = function() {
    return $72a081fca2fa8551$var$ReactSharedInternals.H.useTransition();
};
$72a081fca2fa8551$export$83d89fbfd8236492 = "19.2.4";

});


parcelRegister("9Np2q", function(module, exports) {
'use strict';
function $721c1cb7ddad561f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($721c1cb7ddad561f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$721c1cb7ddad561f$var$checkDCE();

module.exports = (parcelRequire("b7EY2"));

});
parcelRegister("b7EY2", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $8190206a2fec7346$export$69ce8ef3fe5cead0, (v) => $8190206a2fec7346$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $8190206a2fec7346$export$d39a5bbd09211389, (v) => $8190206a2fec7346$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $8190206a2fec7346$export$cd75ccfd720a3cd4, (v) => $8190206a2fec7346$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $8190206a2fec7346$export$a0816fa17a9e79be, (v) => $8190206a2fec7346$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $8190206a2fec7346$export$7292efcadded39f3, (v) => $8190206a2fec7346$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $8190206a2fec7346$export$da407abadb9b8f86, (v) => $8190206a2fec7346$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $8190206a2fec7346$export$314cfea32580671c, (v) => $8190206a2fec7346$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $8190206a2fec7346$export$513ccb98c53b8039, (v) => $8190206a2fec7346$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $8190206a2fec7346$export$dbca993bc2d264a, (v) => $8190206a2fec7346$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $8190206a2fec7346$export$4797a8006f0655d0, (v) => $8190206a2fec7346$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $8190206a2fec7346$export$c78a37762a8d58e1, (v) => $8190206a2fec7346$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $8190206a2fec7346$export$606f11b2eb45ecc6, (v) => $8190206a2fec7346$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $8190206a2fec7346$export$f7e8a0bf92324b1e, (v) => $8190206a2fec7346$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $8190206a2fec7346$export$83d89fbfd8236492, (v) => $8190206a2fec7346$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8190206a2fec7346$export$69ce8ef3fe5cead0;
var $8190206a2fec7346$export$d39a5bbd09211389;
var $8190206a2fec7346$export$cd75ccfd720a3cd4;
var $8190206a2fec7346$export$a0816fa17a9e79be;
var $8190206a2fec7346$export$7292efcadded39f3;
var $8190206a2fec7346$export$da407abadb9b8f86;
var $8190206a2fec7346$export$314cfea32580671c;
var $8190206a2fec7346$export$513ccb98c53b8039;
var $8190206a2fec7346$export$dbca993bc2d264a;
var $8190206a2fec7346$export$4797a8006f0655d0;
var $8190206a2fec7346$export$c78a37762a8d58e1;
var $8190206a2fec7346$export$606f11b2eb45ecc6;
var $8190206a2fec7346$export$f7e8a0bf92324b1e;
var $8190206a2fec7346$export$83d89fbfd8236492;
"use strict";

var $2WGWz = parcelRequire("2WGWz");
function $8190206a2fec7346$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8190206a2fec7346$var$noop() {}
var $8190206a2fec7346$var$Internals = {
    d: {
        f: $8190206a2fec7346$var$noop,
        r: function() {
            throw Error($8190206a2fec7346$var$formatProdErrorMessage(522));
        },
        D: $8190206a2fec7346$var$noop,
        C: $8190206a2fec7346$var$noop,
        L: $8190206a2fec7346$var$noop,
        m: $8190206a2fec7346$var$noop,
        X: $8190206a2fec7346$var$noop,
        S: $8190206a2fec7346$var$noop,
        M: $8190206a2fec7346$var$noop
    },
    p: 0,
    findDOMNode: null
}, $8190206a2fec7346$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $8190206a2fec7346$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8190206a2fec7346$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $8190206a2fec7346$var$ReactSharedInternals = $2WGWz.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $8190206a2fec7346$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$8190206a2fec7346$export$69ce8ef3fe5cead0 = $8190206a2fec7346$var$Internals;
$8190206a2fec7346$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($8190206a2fec7346$var$formatProdErrorMessage(299));
    return $8190206a2fec7346$var$createPortal$1(children, container, null, key);
};
$8190206a2fec7346$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $8190206a2fec7346$var$ReactSharedInternals.T, previousUpdatePriority = $8190206a2fec7346$var$Internals.p;
    try {
        if ($8190206a2fec7346$var$ReactSharedInternals.T = null, $8190206a2fec7346$var$Internals.p = 2, fn) return fn();
    } finally{
        $8190206a2fec7346$var$ReactSharedInternals.T = previousTransition, $8190206a2fec7346$var$Internals.p = previousUpdatePriority, $8190206a2fec7346$var$Internals.d.f();
    }
};
$8190206a2fec7346$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $8190206a2fec7346$var$Internals.d.C(href, options));
};
$8190206a2fec7346$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $8190206a2fec7346$var$Internals.d.D(href);
};
$8190206a2fec7346$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $8190206a2fec7346$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $8190206a2fec7346$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$8190206a2fec7346$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $8190206a2fec7346$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $8190206a2fec7346$var$Internals.d.M(href);
    }
};
$8190206a2fec7346$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(as, options.crossOrigin);
        $8190206a2fec7346$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$8190206a2fec7346$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $8190206a2fec7346$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $8190206a2fec7346$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $8190206a2fec7346$var$Internals.d.m(href);
    }
};
$8190206a2fec7346$export$4797a8006f0655d0 = function(form) {
    $8190206a2fec7346$var$Internals.d.r(form);
};
$8190206a2fec7346$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$8190206a2fec7346$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $8190206a2fec7346$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$8190206a2fec7346$export$f7e8a0bf92324b1e = function() {
    return $8190206a2fec7346$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$8190206a2fec7346$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("5T0q6", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $44926a34c3961223$export$bf730a2d8bf68b42, (v) => $44926a34c3961223$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $44926a34c3961223$export$bf730a2d8bf68b42;
"use strict";

var $2WGWz = parcelRequire("2WGWz");

var $96A5S = parcelRequire("96A5S");
function $44926a34c3961223$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $44926a34c3961223$var$objectIs = "function" === typeof Object.is ? Object.is : $44926a34c3961223$var$is, $44926a34c3961223$var$useSyncExternalStore = $96A5S.useSyncExternalStore, $44926a34c3961223$var$useRef = $2WGWz.useRef, $44926a34c3961223$var$useEffect = $2WGWz.useEffect, $44926a34c3961223$var$useMemo = $2WGWz.useMemo, $44926a34c3961223$var$useDebugValue = $2WGWz.useDebugValue;
$44926a34c3961223$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $44926a34c3961223$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $44926a34c3961223$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($44926a34c3961223$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $44926a34c3961223$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $44926a34c3961223$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $44926a34c3961223$var$useDebugValue(value);
    return value;
};

});
parcelRegister("96A5S", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lpJiI"));

});
parcelRegister("lpJiI", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $f96f12939c381097$export$306c0aa65ff9ec16, (v) => $f96f12939c381097$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f96f12939c381097$export$306c0aa65ff9ec16;
"use strict";

var $2WGWz = parcelRequire("2WGWz");
function $f96f12939c381097$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f96f12939c381097$var$objectIs = "function" === typeof Object.is ? Object.is : $f96f12939c381097$var$is, $f96f12939c381097$var$useState = $2WGWz.useState, $f96f12939c381097$var$useEffect = $2WGWz.useEffect, $f96f12939c381097$var$useLayoutEffect = $2WGWz.useLayoutEffect, $f96f12939c381097$var$useDebugValue = $2WGWz.useDebugValue;
function $f96f12939c381097$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $f96f12939c381097$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $f96f12939c381097$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $f96f12939c381097$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $f96f12939c381097$var$useEffect(function() {
        $f96f12939c381097$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $f96f12939c381097$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $f96f12939c381097$var$useDebugValue(value);
    return value;
}
function $f96f12939c381097$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f96f12939c381097$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f96f12939c381097$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $f96f12939c381097$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $f96f12939c381097$var$useSyncExternalStore$1 : $f96f12939c381097$var$useSyncExternalStore$2;
$f96f12939c381097$export$306c0aa65ff9ec16 = void 0 !== $2WGWz.useSyncExternalStore ? $2WGWz.useSyncExternalStore : $f96f12939c381097$var$shim;

});



var $419c6008abfcce61$exports = {};
'use strict';

$419c6008abfcce61$exports = (parcelRequire("iw2gE"));


var $9304165f01abb7b7$exports = {};
'use strict';
function $9304165f01abb7b7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9304165f01abb7b7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9304165f01abb7b7$var$checkDCE();

$9304165f01abb7b7$exports = (parcelRequire("fjpcG"));



var $2WGWz = parcelRequire("2WGWz");




var $2WGWz = parcelRequire("2WGWz");

var $2WGWz = parcelRequire("2WGWz");
var $3b951febf8ab45a9$exports = {};

$parcel$export($3b951febf8ab45a9$exports, "ShaderChunk", () => $3b951febf8ab45a9$export$955f9f2e84c43c8b);
$parcel$export($3b951febf8ab45a9$exports, "UniformsLib", () => $3b951febf8ab45a9$export$6643083551874bf5);
$parcel$export($3b951febf8ab45a9$exports, "ShaderLib", () => $3b951febf8ab45a9$export$bee4a7d47f8f5014);
$parcel$export($3b951febf8ab45a9$exports, "PMREMGenerator", () => $3b951febf8ab45a9$export$6add42717753e221);
$parcel$export($3b951febf8ab45a9$exports, "WebGLCubeRenderTarget", () => $3b951febf8ab45a9$export$ac386671d651941e);
$parcel$export($3b951febf8ab45a9$exports, "WebGLUtils", () => $3b951febf8ab45a9$export$ddaebcad857649a8);
$parcel$export($3b951febf8ab45a9$exports, "WebGLRenderer", () => $3b951febf8ab45a9$export$f6cc00ef28d7cf97);
$parcel$export($3b951febf8ab45a9$exports, "AdditiveAnimationBlendMode", () => $ce0cdebec9150cb3$export$d875e029ef558d3);
$parcel$export($3b951febf8ab45a9$exports, "AlwaysStencilFunc", () => $ce0cdebec9150cb3$export$14cf96713ddd97a8);
$parcel$export($3b951febf8ab45a9$exports, "AmbientLight", () => $ce0cdebec9150cb3$export$af279bfef9ec2c96);
$parcel$export($3b951febf8ab45a9$exports, "AnimationAction", () => $ce0cdebec9150cb3$export$6946940a69e799e);
$parcel$export($3b951febf8ab45a9$exports, "AnimationClip", () => $ce0cdebec9150cb3$export$d942c706bf23829c);
$parcel$export($3b951febf8ab45a9$exports, "AnimationLoader", () => $ce0cdebec9150cb3$export$29711c7e14f61db);
$parcel$export($3b951febf8ab45a9$exports, "AnimationMixer", () => $ce0cdebec9150cb3$export$fbd77e5aefaa0102);
$parcel$export($3b951febf8ab45a9$exports, "AnimationObjectGroup", () => $ce0cdebec9150cb3$export$30619c2afd3f34db);
$parcel$export($3b951febf8ab45a9$exports, "AnimationUtils", () => $ce0cdebec9150cb3$export$7ee8caa573e71ad1);
$parcel$export($3b951febf8ab45a9$exports, "ArcCurve", () => $ce0cdebec9150cb3$export$b1eedc9aab6300e8);
$parcel$export($3b951febf8ab45a9$exports, "ArrowHelper", () => $ce0cdebec9150cb3$export$a3008e7bd8d2cbe7);
$parcel$export($3b951febf8ab45a9$exports, "AttachedBindMode", () => $ce0cdebec9150cb3$export$2595a3798997538);
$parcel$export($3b951febf8ab45a9$exports, "Audio", () => $ce0cdebec9150cb3$export$153755f98d9861de);
$parcel$export($3b951febf8ab45a9$exports, "AudioAnalyser", () => $ce0cdebec9150cb3$export$d47da1ef3d382827);
$parcel$export($3b951febf8ab45a9$exports, "AudioContext", () => $ce0cdebec9150cb3$export$fcbc63750ec2a81f);
$parcel$export($3b951febf8ab45a9$exports, "AudioListener", () => $ce0cdebec9150cb3$export$8a1b810c6fde8951);
$parcel$export($3b951febf8ab45a9$exports, "AudioLoader", () => $ce0cdebec9150cb3$export$d8d5fccfbf47714e);
$parcel$export($3b951febf8ab45a9$exports, "AxesHelper", () => $ce0cdebec9150cb3$export$6c8303f35b8578fd);
$parcel$export($3b951febf8ab45a9$exports, "BasicDepthPacking", () => $ce0cdebec9150cb3$export$deeb383078690b50);
$parcel$export($3b951febf8ab45a9$exports, "BasicShadowMap", () => $ce0cdebec9150cb3$export$346307dbae2b7447);
$parcel$export($3b951febf8ab45a9$exports, "BatchedMesh", () => $ce0cdebec9150cb3$export$6e01c5ee52ed8f7b);
$parcel$export($3b951febf8ab45a9$exports, "BezierInterpolant", () => $ce0cdebec9150cb3$export$9a963cfe8bd70b49);
$parcel$export($3b951febf8ab45a9$exports, "Bone", () => $ce0cdebec9150cb3$export$b127726e56765aa4);
$parcel$export($3b951febf8ab45a9$exports, "BooleanKeyframeTrack", () => $ce0cdebec9150cb3$export$d3a344b98cf0b775);
$parcel$export($3b951febf8ab45a9$exports, "Box2", () => $ce0cdebec9150cb3$export$60f553fa130f08b0);
$parcel$export($3b951febf8ab45a9$exports, "Box3", () => $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3);
$parcel$export($3b951febf8ab45a9$exports, "Box3Helper", () => $ce0cdebec9150cb3$export$ce39f4bb96c9a290);
$parcel$export($3b951febf8ab45a9$exports, "BoxHelper", () => $ce0cdebec9150cb3$export$38a664cc862a6a9d);
$parcel$export($3b951febf8ab45a9$exports, "BufferGeometryLoader", () => $ce0cdebec9150cb3$export$dc275bb96327833a);
$parcel$export($3b951febf8ab45a9$exports, "Cache", () => $ce0cdebec9150cb3$export$94affb487e701bf2);
$parcel$export($3b951febf8ab45a9$exports, "Camera", () => $ce0cdebec9150cb3$export$79f141de891a5fed);
$parcel$export($3b951febf8ab45a9$exports, "CameraHelper", () => $ce0cdebec9150cb3$export$ed8e93f853cd795);
$parcel$export($3b951febf8ab45a9$exports, "CanvasTexture", () => $ce0cdebec9150cb3$export$f7189e49152d1c13);
$parcel$export($3b951febf8ab45a9$exports, "CapsuleGeometry", () => $ce0cdebec9150cb3$export$41680e8551036033);
$parcel$export($3b951febf8ab45a9$exports, "CatmullRomCurve3", () => $ce0cdebec9150cb3$export$b9146b27c24b744c);
$parcel$export($3b951febf8ab45a9$exports, "CircleGeometry", () => $ce0cdebec9150cb3$export$d5c0e8d607467193);
$parcel$export($3b951febf8ab45a9$exports, "Clock", () => $ce0cdebec9150cb3$export$9735c82c4bae3302);
$parcel$export($3b951febf8ab45a9$exports, "ColorKeyframeTrack", () => $ce0cdebec9150cb3$export$83444c5d885347d8);
$parcel$export($3b951febf8ab45a9$exports, "Compatibility", () => $ce0cdebec9150cb3$export$10255bda2baf681);
$parcel$export($3b951febf8ab45a9$exports, "CompressedArrayTexture", () => $ce0cdebec9150cb3$export$5fe6b8e34b274fcb);
$parcel$export($3b951febf8ab45a9$exports, "CompressedCubeTexture", () => $ce0cdebec9150cb3$export$d80173634de65bff);
$parcel$export($3b951febf8ab45a9$exports, "CompressedTexture", () => $ce0cdebec9150cb3$export$3466bac9141a5cc4);
$parcel$export($3b951febf8ab45a9$exports, "CompressedTextureLoader", () => $ce0cdebec9150cb3$export$bd73ce947a280350);
$parcel$export($3b951febf8ab45a9$exports, "ConeGeometry", () => $ce0cdebec9150cb3$export$a7a48974f285c9b3);
$parcel$export($3b951febf8ab45a9$exports, "Controls", () => $ce0cdebec9150cb3$export$c7c44baae9d9f25f);
$parcel$export($3b951febf8ab45a9$exports, "CubeTextureLoader", () => $ce0cdebec9150cb3$export$2ec114afc2cf6308);
$parcel$export($3b951febf8ab45a9$exports, "CubicBezierCurve", () => $ce0cdebec9150cb3$export$e36650d36468bb39);
$parcel$export($3b951febf8ab45a9$exports, "CubicBezierCurve3", () => $ce0cdebec9150cb3$export$13d5f1c9525f246c);
$parcel$export($3b951febf8ab45a9$exports, "CubicInterpolant", () => $ce0cdebec9150cb3$export$3646682e7a3959);
$parcel$export($3b951febf8ab45a9$exports, "CullFaceFrontBack", () => $ce0cdebec9150cb3$export$f24be24dcddeac0d);
$parcel$export($3b951febf8ab45a9$exports, "Curve", () => $ce0cdebec9150cb3$export$b0e83c3ef8d2db1);
$parcel$export($3b951febf8ab45a9$exports, "CurvePath", () => $ce0cdebec9150cb3$export$4aaf9b66af1bbf2c);
$parcel$export($3b951febf8ab45a9$exports, "CylinderGeometry", () => $ce0cdebec9150cb3$export$68f745719dbe5198);
$parcel$export($3b951febf8ab45a9$exports, "Cylindrical", () => $ce0cdebec9150cb3$export$287165bb2177f4fd);
$parcel$export($3b951febf8ab45a9$exports, "DataTextureLoader", () => $ce0cdebec9150cb3$export$792d8a18f2c55855);
$parcel$export($3b951febf8ab45a9$exports, "DataUtils", () => $ce0cdebec9150cb3$export$11ce8b759162cc80);
$parcel$export($3b951febf8ab45a9$exports, "DecrementStencilOp", () => $ce0cdebec9150cb3$export$c0e9611c8a15f9a8);
$parcel$export($3b951febf8ab45a9$exports, "DecrementWrapStencilOp", () => $ce0cdebec9150cb3$export$7c74ea00fa1315e6);
$parcel$export($3b951febf8ab45a9$exports, "DefaultLoadingManager", () => $ce0cdebec9150cb3$export$b033c3f9a95c6a16);
$parcel$export($3b951febf8ab45a9$exports, "DetachedBindMode", () => $ce0cdebec9150cb3$export$d7e7dc2e114517a0);
$parcel$export($3b951febf8ab45a9$exports, "DirectionalLight", () => $ce0cdebec9150cb3$export$3fea33cc9972c868);
$parcel$export($3b951febf8ab45a9$exports, "DirectionalLightHelper", () => $ce0cdebec9150cb3$export$f8e434dc14203e7d);
$parcel$export($3b951febf8ab45a9$exports, "DiscreteInterpolant", () => $ce0cdebec9150cb3$export$fb9758ef7ef8d5cc);
$parcel$export($3b951febf8ab45a9$exports, "DodecahedronGeometry", () => $ce0cdebec9150cb3$export$c0babfeb8708fc9c);
$parcel$export($3b951febf8ab45a9$exports, "DynamicCopyUsage", () => $ce0cdebec9150cb3$export$ab4022c2c3f86315);
$parcel$export($3b951febf8ab45a9$exports, "DynamicDrawUsage", () => $ce0cdebec9150cb3$export$8505d14ac8546ca);
$parcel$export($3b951febf8ab45a9$exports, "DynamicReadUsage", () => $ce0cdebec9150cb3$export$9e809946455f13bc);
$parcel$export($3b951febf8ab45a9$exports, "EdgesGeometry", () => $ce0cdebec9150cb3$export$4730b1542707547f);
$parcel$export($3b951febf8ab45a9$exports, "EllipseCurve", () => $ce0cdebec9150cb3$export$3f87a931616cde04);
$parcel$export($3b951febf8ab45a9$exports, "EqualStencilFunc", () => $ce0cdebec9150cb3$export$55648a1cde8329a7);
$parcel$export($3b951febf8ab45a9$exports, "ExtrudeGeometry", () => $ce0cdebec9150cb3$export$598697a1efa63ca7);
$parcel$export($3b951febf8ab45a9$exports, "FileLoader", () => $ce0cdebec9150cb3$export$98435a25b5cf7b2b);
$parcel$export($3b951febf8ab45a9$exports, "Float16BufferAttribute", () => $ce0cdebec9150cb3$export$dbd3698c64958d69);
$parcel$export($3b951febf8ab45a9$exports, "Fog", () => $ce0cdebec9150cb3$export$3c890837b09508d4);
$parcel$export($3b951febf8ab45a9$exports, "FogExp2", () => $ce0cdebec9150cb3$export$6f1519f023b8d0f6);
$parcel$export($3b951febf8ab45a9$exports, "FramebufferTexture", () => $ce0cdebec9150cb3$export$9270d786f73ce6fe);
$parcel$export($3b951febf8ab45a9$exports, "FrustumArray", () => $ce0cdebec9150cb3$export$2d7d04327620499c);
$parcel$export($3b951febf8ab45a9$exports, "GLBufferAttribute", () => $ce0cdebec9150cb3$export$6b7339ae8dbddf73);
$parcel$export($3b951febf8ab45a9$exports, "GLSL1", () => $ce0cdebec9150cb3$export$43600cc67fabd9f);
$parcel$export($3b951febf8ab45a9$exports, "GreaterEqualStencilFunc", () => $ce0cdebec9150cb3$export$4119cf7b4c98fd5a);
$parcel$export($3b951febf8ab45a9$exports, "GreaterStencilFunc", () => $ce0cdebec9150cb3$export$6f93765ab2f451a2);
$parcel$export($3b951febf8ab45a9$exports, "GridHelper", () => $ce0cdebec9150cb3$export$3875d39926561055);
$parcel$export($3b951febf8ab45a9$exports, "Group", () => $ce0cdebec9150cb3$export$eb2fcfdbd7ba97d4);
$parcel$export($3b951febf8ab45a9$exports, "HemisphereLight", () => $ce0cdebec9150cb3$export$8d474f55edbb9624);
$parcel$export($3b951febf8ab45a9$exports, "HemisphereLightHelper", () => $ce0cdebec9150cb3$export$8dca15f13f4f8172);
$parcel$export($3b951febf8ab45a9$exports, "IcosahedronGeometry", () => $ce0cdebec9150cb3$export$9567cc828c9535da);
$parcel$export($3b951febf8ab45a9$exports, "ImageBitmapLoader", () => $ce0cdebec9150cb3$export$52286b55c4a9b51f);
$parcel$export($3b951febf8ab45a9$exports, "ImageLoader", () => $ce0cdebec9150cb3$export$8905ce1c7a2464a1);
$parcel$export($3b951febf8ab45a9$exports, "ImageUtils", () => $ce0cdebec9150cb3$export$698882cf06df44aa);
$parcel$export($3b951febf8ab45a9$exports, "IncrementStencilOp", () => $ce0cdebec9150cb3$export$2928c0231297c036);
$parcel$export($3b951febf8ab45a9$exports, "IncrementWrapStencilOp", () => $ce0cdebec9150cb3$export$9c2c08927385dcc4);
$parcel$export($3b951febf8ab45a9$exports, "InstancedBufferAttribute", () => $ce0cdebec9150cb3$export$32ea87a8b54d744a);
$parcel$export($3b951febf8ab45a9$exports, "InstancedBufferGeometry", () => $ce0cdebec9150cb3$export$231f009cbe414146);
$parcel$export($3b951febf8ab45a9$exports, "InstancedInterleavedBuffer", () => $ce0cdebec9150cb3$export$25ec0e1af1389358);
$parcel$export($3b951febf8ab45a9$exports, "InstancedMesh", () => $ce0cdebec9150cb3$export$f3c979c331175ad7);
$parcel$export($3b951febf8ab45a9$exports, "Int16BufferAttribute", () => $ce0cdebec9150cb3$export$2b755a102ccdcefe);
$parcel$export($3b951febf8ab45a9$exports, "Int32BufferAttribute", () => $ce0cdebec9150cb3$export$46b369aed2968a0a);
$parcel$export($3b951febf8ab45a9$exports, "Int8BufferAttribute", () => $ce0cdebec9150cb3$export$f9ff2d6a20248cbf);
$parcel$export($3b951febf8ab45a9$exports, "InterleavedBuffer", () => $ce0cdebec9150cb3$export$3d5cd879f108f53f);
$parcel$export($3b951febf8ab45a9$exports, "InterleavedBufferAttribute", () => $ce0cdebec9150cb3$export$920b6d07334599c7);
$parcel$export($3b951febf8ab45a9$exports, "Interpolant", () => $ce0cdebec9150cb3$export$b558baee9c0f72d3);
$parcel$export($3b951febf8ab45a9$exports, "InterpolateBezier", () => $ce0cdebec9150cb3$export$ad783ffd8f91a9e3);
$parcel$export($3b951febf8ab45a9$exports, "InterpolateDiscrete", () => $ce0cdebec9150cb3$export$995b32462a65e855);
$parcel$export($3b951febf8ab45a9$exports, "InterpolateLinear", () => $ce0cdebec9150cb3$export$30fac1aace31cf4d);
$parcel$export($3b951febf8ab45a9$exports, "InterpolateSmooth", () => $ce0cdebec9150cb3$export$198b11ff4c72bb30);
$parcel$export($3b951febf8ab45a9$exports, "InterpolationSamplingMode", () => $ce0cdebec9150cb3$export$599d2e4c2d7b2a01);
$parcel$export($3b951febf8ab45a9$exports, "InterpolationSamplingType", () => $ce0cdebec9150cb3$export$ff3764a6b1cf3544);
$parcel$export($3b951febf8ab45a9$exports, "InvertStencilOp", () => $ce0cdebec9150cb3$export$22e2e5726612443);
$parcel$export($3b951febf8ab45a9$exports, "KeepStencilOp", () => $ce0cdebec9150cb3$export$9f542ae4b5baca34);
$parcel$export($3b951febf8ab45a9$exports, "KeyframeTrack", () => $ce0cdebec9150cb3$export$b0e479f45b7006d6);
$parcel$export($3b951febf8ab45a9$exports, "LOD", () => $ce0cdebec9150cb3$export$112e7237be0c5f30);
$parcel$export($3b951febf8ab45a9$exports, "LatheGeometry", () => $ce0cdebec9150cb3$export$6d839803fcd1882c);
$parcel$export($3b951febf8ab45a9$exports, "LessEqualStencilFunc", () => $ce0cdebec9150cb3$export$2dff107857e6aca2);
$parcel$export($3b951febf8ab45a9$exports, "LessStencilFunc", () => $ce0cdebec9150cb3$export$8e1d8ed281997fa6);
$parcel$export($3b951febf8ab45a9$exports, "Light", () => $ce0cdebec9150cb3$export$6ecadb6ed240d696);
$parcel$export($3b951febf8ab45a9$exports, "LightProbe", () => $ce0cdebec9150cb3$export$e7ef036e309b38d2);
$parcel$export($3b951febf8ab45a9$exports, "Line", () => $ce0cdebec9150cb3$export$17d680238e50603e);
$parcel$export($3b951febf8ab45a9$exports, "Line3", () => $ce0cdebec9150cb3$export$e0ba6359f1954fd3);
$parcel$export($3b951febf8ab45a9$exports, "LineBasicMaterial", () => $ce0cdebec9150cb3$export$fbaaa33907730a0c);
$parcel$export($3b951febf8ab45a9$exports, "LineCurve", () => $ce0cdebec9150cb3$export$ab2e07e76531a47e);
$parcel$export($3b951febf8ab45a9$exports, "LineCurve3", () => $ce0cdebec9150cb3$export$1fdfd9d9cf487600);
$parcel$export($3b951febf8ab45a9$exports, "LineDashedMaterial", () => $ce0cdebec9150cb3$export$327886a3efaeaebe);
$parcel$export($3b951febf8ab45a9$exports, "LineLoop", () => $ce0cdebec9150cb3$export$f85a24d745e4f17d);
$parcel$export($3b951febf8ab45a9$exports, "LineSegments", () => $ce0cdebec9150cb3$export$ff1ed10fedfdd604);
$parcel$export($3b951febf8ab45a9$exports, "LinearInterpolant", () => $ce0cdebec9150cb3$export$a8e6009059f51e1a);
$parcel$export($3b951febf8ab45a9$exports, "LinearMipMapLinearFilter", () => $ce0cdebec9150cb3$export$90d80f1e3506775f);
$parcel$export($3b951febf8ab45a9$exports, "LinearMipMapNearestFilter", () => $ce0cdebec9150cb3$export$dbe96bee3fe9dbf0);
$parcel$export($3b951febf8ab45a9$exports, "Loader", () => $ce0cdebec9150cb3$export$3b0d6d7590275603);
$parcel$export($3b951febf8ab45a9$exports, "LoaderUtils", () => $ce0cdebec9150cb3$export$b5d2dc08d867e41a);
$parcel$export($3b951febf8ab45a9$exports, "LoadingManager", () => $ce0cdebec9150cb3$export$99cc795e99919eed);
$parcel$export($3b951febf8ab45a9$exports, "LoopOnce", () => $ce0cdebec9150cb3$export$d62fdc9d1b1cccad);
$parcel$export($3b951febf8ab45a9$exports, "LoopPingPong", () => $ce0cdebec9150cb3$export$f8f6f2041b78e210);
$parcel$export($3b951febf8ab45a9$exports, "LoopRepeat", () => $ce0cdebec9150cb3$export$dfaf4422ce096e29);
$parcel$export($3b951febf8ab45a9$exports, "MOUSE", () => $ce0cdebec9150cb3$export$7177b3e430c2d7ca);
$parcel$export($3b951febf8ab45a9$exports, "Material", () => $ce0cdebec9150cb3$export$a2d8b23205c25948);
$parcel$export($3b951febf8ab45a9$exports, "MaterialBlending", () => $ce0cdebec9150cb3$export$ec822fcd0c1d2914);
$parcel$export($3b951febf8ab45a9$exports, "MaterialLoader", () => $ce0cdebec9150cb3$export$3bd6d323353dcf96);
$parcel$export($3b951febf8ab45a9$exports, "MathUtils", () => $ce0cdebec9150cb3$export$6a7ef315a0d1ef07);
$parcel$export($3b951febf8ab45a9$exports, "Matrix2", () => $ce0cdebec9150cb3$export$cbcc6560bf79fb38);
$parcel$export($3b951febf8ab45a9$exports, "MeshLambertMaterial", () => $ce0cdebec9150cb3$export$5023a9a8114806b8);
$parcel$export($3b951febf8ab45a9$exports, "MeshMatcapMaterial", () => $ce0cdebec9150cb3$export$6f5fef6235ec12ee);
$parcel$export($3b951febf8ab45a9$exports, "MeshNormalMaterial", () => $ce0cdebec9150cb3$export$bfe8c0a091f41ae7);
$parcel$export($3b951febf8ab45a9$exports, "MeshPhongMaterial", () => $ce0cdebec9150cb3$export$24c72f71cbaf0678);
$parcel$export($3b951febf8ab45a9$exports, "MeshPhysicalMaterial", () => $ce0cdebec9150cb3$export$28d04986c4269c9f);
$parcel$export($3b951febf8ab45a9$exports, "MeshStandardMaterial", () => $ce0cdebec9150cb3$export$f2980790215acccd);
$parcel$export($3b951febf8ab45a9$exports, "MeshToonMaterial", () => $ce0cdebec9150cb3$export$df893cf97e765622);
$parcel$export($3b951febf8ab45a9$exports, "NearestMipMapLinearFilter", () => $ce0cdebec9150cb3$export$cbc5b7f5647595d8);
$parcel$export($3b951febf8ab45a9$exports, "NearestMipMapNearestFilter", () => $ce0cdebec9150cb3$export$14a4936464a36496);
$parcel$export($3b951febf8ab45a9$exports, "NeverStencilFunc", () => $ce0cdebec9150cb3$export$1343870698229224);
$parcel$export($3b951febf8ab45a9$exports, "NoNormalPacking", () => $ce0cdebec9150cb3$export$7f96a53e6ab01dca);
$parcel$export($3b951febf8ab45a9$exports, "NormalAnimationBlendMode", () => $ce0cdebec9150cb3$export$bcfbbdcf8de7f8cd);
$parcel$export($3b951febf8ab45a9$exports, "NormalGAPacking", () => $ce0cdebec9150cb3$export$4f8d192b60f65626);
$parcel$export($3b951febf8ab45a9$exports, "NormalRGPacking", () => $ce0cdebec9150cb3$export$bbd2d5168fed5fd6);
$parcel$export($3b951febf8ab45a9$exports, "NotEqualStencilFunc", () => $ce0cdebec9150cb3$export$6f3fb2d2440f2b76);
$parcel$export($3b951febf8ab45a9$exports, "NumberKeyframeTrack", () => $ce0cdebec9150cb3$export$d45f0d1a4d9a9314);
$parcel$export($3b951febf8ab45a9$exports, "Object3D", () => $ce0cdebec9150cb3$export$e4dd07dff30cc924);
$parcel$export($3b951febf8ab45a9$exports, "ObjectLoader", () => $ce0cdebec9150cb3$export$40110c8505c5ad19);
$parcel$export($3b951febf8ab45a9$exports, "OctahedronGeometry", () => $ce0cdebec9150cb3$export$1954e2b809fe361e);
$parcel$export($3b951febf8ab45a9$exports, "Path", () => $ce0cdebec9150cb3$export$4b2950bdac9b6ee9);
$parcel$export($3b951febf8ab45a9$exports, "PlaneHelper", () => $ce0cdebec9150cb3$export$a34fe8156c66e5d7);
$parcel$export($3b951febf8ab45a9$exports, "PointLight", () => $ce0cdebec9150cb3$export$4c9c1cb3f0b6f455);
$parcel$export($3b951febf8ab45a9$exports, "PointLightHelper", () => $ce0cdebec9150cb3$export$9a9291685b9e4023);
$parcel$export($3b951febf8ab45a9$exports, "Points", () => $ce0cdebec9150cb3$export$1c787534cb11aa3e);
$parcel$export($3b951febf8ab45a9$exports, "PointsMaterial", () => $ce0cdebec9150cb3$export$a178c45366ce5d6b);
$parcel$export($3b951febf8ab45a9$exports, "PolarGridHelper", () => $ce0cdebec9150cb3$export$361430a10f533cd3);
$parcel$export($3b951febf8ab45a9$exports, "PolyhedronGeometry", () => $ce0cdebec9150cb3$export$60e57a7d3f20ff65);
$parcel$export($3b951febf8ab45a9$exports, "PositionalAudio", () => $ce0cdebec9150cb3$export$4b3e397ef1832507);
$parcel$export($3b951febf8ab45a9$exports, "PropertyBinding", () => $ce0cdebec9150cb3$export$7bf70fcf9f891893);
$parcel$export($3b951febf8ab45a9$exports, "PropertyMixer", () => $ce0cdebec9150cb3$export$dfe0af1ca1acb78a);
$parcel$export($3b951febf8ab45a9$exports, "QuadraticBezierCurve", () => $ce0cdebec9150cb3$export$5938c4ee491a43ad);
$parcel$export($3b951febf8ab45a9$exports, "QuadraticBezierCurve3", () => $ce0cdebec9150cb3$export$bf3f4c7e459f90fc);
$parcel$export($3b951febf8ab45a9$exports, "Quaternion", () => $ce0cdebec9150cb3$export$23d6a54f0bbc85a3);
$parcel$export($3b951febf8ab45a9$exports, "QuaternionKeyframeTrack", () => $ce0cdebec9150cb3$export$b8043f12b5aafbd7);
$parcel$export($3b951febf8ab45a9$exports, "QuaternionLinearInterpolant", () => $ce0cdebec9150cb3$export$2db1cfb7923d931e);
$parcel$export($3b951febf8ab45a9$exports, "RGBADepthPacking", () => $ce0cdebec9150cb3$export$8f910f4c4f73df11);
$parcel$export($3b951febf8ab45a9$exports, "RGBDepthPacking", () => $ce0cdebec9150cb3$export$be2e2ddbc3983173);
$parcel$export($3b951febf8ab45a9$exports, "RGBIntegerFormat", () => $ce0cdebec9150cb3$export$d1fd40c11bfa798e);
$parcel$export($3b951febf8ab45a9$exports, "RGDepthPacking", () => $ce0cdebec9150cb3$export$1a54198784742f80);
$parcel$export($3b951febf8ab45a9$exports, "Ray", () => $ce0cdebec9150cb3$export$a186db52eed6d40e);
$parcel$export($3b951febf8ab45a9$exports, "Raycaster", () => $ce0cdebec9150cb3$export$8b7aaceff00bd2f);
$parcel$export($3b951febf8ab45a9$exports, "RectAreaLight", () => $ce0cdebec9150cb3$export$61db2d908bbd2429);
$parcel$export($3b951febf8ab45a9$exports, "RenderTarget", () => $ce0cdebec9150cb3$export$efcb1f8bf367cbfb);
$parcel$export($3b951febf8ab45a9$exports, "RenderTarget3D", () => $ce0cdebec9150cb3$export$6b116d2fdfef087c);
$parcel$export($3b951febf8ab45a9$exports, "ReplaceStencilOp", () => $ce0cdebec9150cb3$export$8a4f28336ef203d3);
$parcel$export($3b951febf8ab45a9$exports, "RingGeometry", () => $ce0cdebec9150cb3$export$68cb731f50f614af);
$parcel$export($3b951febf8ab45a9$exports, "Scene", () => $ce0cdebec9150cb3$export$38af1803e3442a7f);
$parcel$export($3b951febf8ab45a9$exports, "ShadowMaterial", () => $ce0cdebec9150cb3$export$e8564da406055a3);
$parcel$export($3b951febf8ab45a9$exports, "Shape", () => $ce0cdebec9150cb3$export$6428a7f2611ef1fa);
$parcel$export($3b951febf8ab45a9$exports, "ShapeGeometry", () => $ce0cdebec9150cb3$export$57a29a1c803e9065);
$parcel$export($3b951febf8ab45a9$exports, "ShapePath", () => $ce0cdebec9150cb3$export$148534a3c727230b);
$parcel$export($3b951febf8ab45a9$exports, "ShapeUtils", () => $ce0cdebec9150cb3$export$96bdf6d9c66d7ba8);
$parcel$export($3b951febf8ab45a9$exports, "Skeleton", () => $ce0cdebec9150cb3$export$8f31e4c4a37b8e9c);
$parcel$export($3b951febf8ab45a9$exports, "SkeletonHelper", () => $ce0cdebec9150cb3$export$5277df3c9e732259);
$parcel$export($3b951febf8ab45a9$exports, "SkinnedMesh", () => $ce0cdebec9150cb3$export$b303577035157ecf);
$parcel$export($3b951febf8ab45a9$exports, "Source", () => $ce0cdebec9150cb3$export$1d2df86270c81ecb);
$parcel$export($3b951febf8ab45a9$exports, "Sphere", () => $ce0cdebec9150cb3$export$805e8b72413ccaba);
$parcel$export($3b951febf8ab45a9$exports, "SphereGeometry", () => $ce0cdebec9150cb3$export$1b417fc3b307a251);
$parcel$export($3b951febf8ab45a9$exports, "Spherical", () => $ce0cdebec9150cb3$export$d712cd887b4a00f7);
$parcel$export($3b951febf8ab45a9$exports, "SphericalHarmonics3", () => $ce0cdebec9150cb3$export$ba61ce607e1f405a);
$parcel$export($3b951febf8ab45a9$exports, "SplineCurve", () => $ce0cdebec9150cb3$export$d3bdd77da77afc1b);
$parcel$export($3b951febf8ab45a9$exports, "SpotLight", () => $ce0cdebec9150cb3$export$81495cbb73897362);
$parcel$export($3b951febf8ab45a9$exports, "SpotLightHelper", () => $ce0cdebec9150cb3$export$4b14638ffdd81e68);
$parcel$export($3b951febf8ab45a9$exports, "Sprite", () => $ce0cdebec9150cb3$export$3075603db8e6204c);
$parcel$export($3b951febf8ab45a9$exports, "SpriteMaterial", () => $ce0cdebec9150cb3$export$5ec7dd1c6994bf8e);
$parcel$export($3b951febf8ab45a9$exports, "StaticCopyUsage", () => $ce0cdebec9150cb3$export$32ab2503ea19469a);
$parcel$export($3b951febf8ab45a9$exports, "StaticDrawUsage", () => $ce0cdebec9150cb3$export$763e8360f4d7f77d);
$parcel$export($3b951febf8ab45a9$exports, "StaticReadUsage", () => $ce0cdebec9150cb3$export$415731dc4f48e299);
$parcel$export($3b951febf8ab45a9$exports, "StereoCamera", () => $ce0cdebec9150cb3$export$bc7f73a1065bee0c);
$parcel$export($3b951febf8ab45a9$exports, "StreamCopyUsage", () => $ce0cdebec9150cb3$export$ba7f1db36a76a970);
$parcel$export($3b951febf8ab45a9$exports, "StreamDrawUsage", () => $ce0cdebec9150cb3$export$721e63549e51d81e);
$parcel$export($3b951febf8ab45a9$exports, "StreamReadUsage", () => $ce0cdebec9150cb3$export$2ed9499a35b5f832);
$parcel$export($3b951febf8ab45a9$exports, "StringKeyframeTrack", () => $ce0cdebec9150cb3$export$6ce41d4f3a8df9cd);
$parcel$export($3b951febf8ab45a9$exports, "TOUCH", () => $ce0cdebec9150cb3$export$d46bd3ead7cc759b);
$parcel$export($3b951febf8ab45a9$exports, "TetrahedronGeometry", () => $ce0cdebec9150cb3$export$fb3f7adc68bd6e02);
$parcel$export($3b951febf8ab45a9$exports, "TextureLoader", () => $ce0cdebec9150cb3$export$fd1bfc71f64c538c);
$parcel$export($3b951febf8ab45a9$exports, "TextureUtils", () => $ce0cdebec9150cb3$export$ec276d39f33d4b7);
$parcel$export($3b951febf8ab45a9$exports, "Timer", () => $ce0cdebec9150cb3$export$c57e9b2d8b9e4de);
$parcel$export($3b951febf8ab45a9$exports, "TimestampQuery", () => $ce0cdebec9150cb3$export$f97db56e2b647801);
$parcel$export($3b951febf8ab45a9$exports, "TorusGeometry", () => $ce0cdebec9150cb3$export$a2312a2a1fa56495);
$parcel$export($3b951febf8ab45a9$exports, "TorusKnotGeometry", () => $ce0cdebec9150cb3$export$77e9bfadfb9ab8c8);
$parcel$export($3b951febf8ab45a9$exports, "Triangle", () => $ce0cdebec9150cb3$export$5a465592bfe74b48);
$parcel$export($3b951febf8ab45a9$exports, "TriangleFanDrawMode", () => $ce0cdebec9150cb3$export$f0d8293634f88842);
$parcel$export($3b951febf8ab45a9$exports, "TriangleStripDrawMode", () => $ce0cdebec9150cb3$export$b23a071aa286eb29);
$parcel$export($3b951febf8ab45a9$exports, "TrianglesDrawMode", () => $ce0cdebec9150cb3$export$4c28c87c2dc84758);
$parcel$export($3b951febf8ab45a9$exports, "TubeGeometry", () => $ce0cdebec9150cb3$export$7897d9d48904490c);
$parcel$export($3b951febf8ab45a9$exports, "UVMapping", () => $ce0cdebec9150cb3$export$1beec6768cbb3d2d);
$parcel$export($3b951febf8ab45a9$exports, "Uint8BufferAttribute", () => $ce0cdebec9150cb3$export$cacc90cf35d11cdd);
$parcel$export($3b951febf8ab45a9$exports, "Uint8ClampedBufferAttribute", () => $ce0cdebec9150cb3$export$baaa85a1a812c157);
$parcel$export($3b951febf8ab45a9$exports, "Uniform", () => $ce0cdebec9150cb3$export$2947cebfe91c02f8);
$parcel$export($3b951febf8ab45a9$exports, "UniformsGroup", () => $ce0cdebec9150cb3$export$c412d5ffe1f79209);
$parcel$export($3b951febf8ab45a9$exports, "VectorKeyframeTrack", () => $ce0cdebec9150cb3$export$5ce2dcb4cc9f2bff);
$parcel$export($3b951febf8ab45a9$exports, "VideoFrameTexture", () => $ce0cdebec9150cb3$export$68498d200b825382);
$parcel$export($3b951febf8ab45a9$exports, "VideoTexture", () => $ce0cdebec9150cb3$export$6e09d1edf8d5a25c);
$parcel$export($3b951febf8ab45a9$exports, "WebGL3DRenderTarget", () => $ce0cdebec9150cb3$export$7ee06591009639df);
$parcel$export($3b951febf8ab45a9$exports, "WebGLArrayRenderTarget", () => $ce0cdebec9150cb3$export$c77a02c11ed180c7);
$parcel$export($3b951febf8ab45a9$exports, "WebGPUCoordinateSystem", () => $ce0cdebec9150cb3$export$cc83beedcb9be9ac);
$parcel$export($3b951febf8ab45a9$exports, "WireframeGeometry", () => $ce0cdebec9150cb3$export$4b739da06d24892b);
$parcel$export($3b951febf8ab45a9$exports, "WrapAroundEnding", () => $ce0cdebec9150cb3$export$8e8c3ecdcd8e1fee);
$parcel$export($3b951febf8ab45a9$exports, "ZeroCurvatureEnding", () => $ce0cdebec9150cb3$export$7f795934b84ab523);
$parcel$export($3b951febf8ab45a9$exports, "ZeroSlopeEnding", () => $ce0cdebec9150cb3$export$24a4ccb5099273b5);
$parcel$export($3b951febf8ab45a9$exports, "ZeroStencilOp", () => $ce0cdebec9150cb3$export$69433f11f42d5527);
$parcel$export($3b951febf8ab45a9$exports, "getConsoleFunction", () => $ce0cdebec9150cb3$export$fa86edd994bb169f);
$parcel$export($3b951febf8ab45a9$exports, "setConsoleFunction", () => $ce0cdebec9150cb3$export$702823ffb42fb3aa);
$parcel$export($3b951febf8ab45a9$exports, "ACESFilmicToneMapping", () => $ce0cdebec9150cb3$export$a0d98fe6d7e4af64);
$parcel$export($3b951febf8ab45a9$exports, "AddEquation", () => $ce0cdebec9150cb3$export$20183a0484ce21a0);
$parcel$export($3b951febf8ab45a9$exports, "AddOperation", () => $ce0cdebec9150cb3$export$e641dc52bc3494aa);
$parcel$export($3b951febf8ab45a9$exports, "AdditiveBlending", () => $ce0cdebec9150cb3$export$777d8f9551c2216b);
$parcel$export($3b951febf8ab45a9$exports, "AgXToneMapping", () => $ce0cdebec9150cb3$export$212d53a513a325b2);
$parcel$export($3b951febf8ab45a9$exports, "AlphaFormat", () => $ce0cdebec9150cb3$export$988473390501ed4b);
$parcel$export($3b951febf8ab45a9$exports, "AlwaysCompare", () => $ce0cdebec9150cb3$export$187b73a3e352c145);
$parcel$export($3b951febf8ab45a9$exports, "AlwaysDepth", () => $ce0cdebec9150cb3$export$7182eb52ea3b3f04);
$parcel$export($3b951febf8ab45a9$exports, "ArrayCamera", () => $ce0cdebec9150cb3$export$56b937d9e5581166);
$parcel$export($3b951febf8ab45a9$exports, "BackSide", () => $ce0cdebec9150cb3$export$d9f0486e75b5ace);
$parcel$export($3b951febf8ab45a9$exports, "BoxGeometry", () => $ce0cdebec9150cb3$export$33e43285f7406bd5);
$parcel$export($3b951febf8ab45a9$exports, "BufferAttribute", () => $ce0cdebec9150cb3$export$8dea267bd6bde117);
$parcel$export($3b951febf8ab45a9$exports, "BufferGeometry", () => $ce0cdebec9150cb3$export$b7be63a67df8959);
$parcel$export($3b951febf8ab45a9$exports, "ByteType", () => $ce0cdebec9150cb3$export$545fce0311a9796a);
$parcel$export($3b951febf8ab45a9$exports, "CineonToneMapping", () => $ce0cdebec9150cb3$export$932b3dd283d4a366);
$parcel$export($3b951febf8ab45a9$exports, "ClampToEdgeWrapping", () => $ce0cdebec9150cb3$export$9d9334239a5a5e06);
$parcel$export($3b951febf8ab45a9$exports, "Color", () => $ce0cdebec9150cb3$export$892596cec99bc70e);
$parcel$export($3b951febf8ab45a9$exports, "ColorManagement", () => $ce0cdebec9150cb3$export$5e6fd513f44698c);
$parcel$export($3b951febf8ab45a9$exports, "ConstantAlphaFactor", () => $ce0cdebec9150cb3$export$310cd2be38d13b56);
$parcel$export($3b951febf8ab45a9$exports, "ConstantColorFactor", () => $ce0cdebec9150cb3$export$7dd8f434fd59075);
$parcel$export($3b951febf8ab45a9$exports, "CubeCamera", () => $ce0cdebec9150cb3$export$d0cdd0bd804995de);
$parcel$export($3b951febf8ab45a9$exports, "CubeDepthTexture", () => $ce0cdebec9150cb3$export$c9f39eef7fb1d170);
$parcel$export($3b951febf8ab45a9$exports, "CubeReflectionMapping", () => $ce0cdebec9150cb3$export$8759762a6477f2c4);
$parcel$export($3b951febf8ab45a9$exports, "CubeRefractionMapping", () => $ce0cdebec9150cb3$export$dc59f8aed047f61d);
$parcel$export($3b951febf8ab45a9$exports, "CubeTexture", () => $ce0cdebec9150cb3$export$ee2e5a18258a4049);
$parcel$export($3b951febf8ab45a9$exports, "CubeUVReflectionMapping", () => $ce0cdebec9150cb3$export$dbf3e70ff37af79);
$parcel$export($3b951febf8ab45a9$exports, "CullFaceBack", () => $ce0cdebec9150cb3$export$b9a7b4fc5cb15f9b);
$parcel$export($3b951febf8ab45a9$exports, "CullFaceFront", () => $ce0cdebec9150cb3$export$b8058bcc7037d3f3);
$parcel$export($3b951febf8ab45a9$exports, "CullFaceNone", () => $ce0cdebec9150cb3$export$3237e1f2c1ea1f44);
$parcel$export($3b951febf8ab45a9$exports, "CustomBlending", () => $ce0cdebec9150cb3$export$eda4864c68df1fa2);
$parcel$export($3b951febf8ab45a9$exports, "CustomToneMapping", () => $ce0cdebec9150cb3$export$2c7b09c1e9abfb5e);
$parcel$export($3b951febf8ab45a9$exports, "Data3DTexture", () => $ce0cdebec9150cb3$export$d7a3086320f856db);
$parcel$export($3b951febf8ab45a9$exports, "DataArrayTexture", () => $ce0cdebec9150cb3$export$dfac6c8e811406a3);
$parcel$export($3b951febf8ab45a9$exports, "DataTexture", () => $ce0cdebec9150cb3$export$b691f601014eabe1);
$parcel$export($3b951febf8ab45a9$exports, "DepthFormat", () => $ce0cdebec9150cb3$export$c1b6b5136be58045);
$parcel$export($3b951febf8ab45a9$exports, "DepthStencilFormat", () => $ce0cdebec9150cb3$export$1e113ac2d0905829);
$parcel$export($3b951febf8ab45a9$exports, "DepthTexture", () => $ce0cdebec9150cb3$export$fc830aa069cc8c2f);
$parcel$export($3b951febf8ab45a9$exports, "DoubleSide", () => $ce0cdebec9150cb3$export$3b296b6f144d5b03);
$parcel$export($3b951febf8ab45a9$exports, "DstAlphaFactor", () => $ce0cdebec9150cb3$export$a78aed1ca2a87192);
$parcel$export($3b951febf8ab45a9$exports, "DstColorFactor", () => $ce0cdebec9150cb3$export$ef5f2dd8ffac5574);
$parcel$export($3b951febf8ab45a9$exports, "EqualCompare", () => $ce0cdebec9150cb3$export$66f28d946fc6a0d5);
$parcel$export($3b951febf8ab45a9$exports, "EqualDepth", () => $ce0cdebec9150cb3$export$a60d398fc7b7590e);
$parcel$export($3b951febf8ab45a9$exports, "EquirectangularReflectionMapping", () => $ce0cdebec9150cb3$export$d64030b316d3b087);
$parcel$export($3b951febf8ab45a9$exports, "EquirectangularRefractionMapping", () => $ce0cdebec9150cb3$export$ee99d97d46898098);
$parcel$export($3b951febf8ab45a9$exports, "Euler", () => $ce0cdebec9150cb3$export$d93cc409a0768c5f);
$parcel$export($3b951febf8ab45a9$exports, "EventDispatcher", () => $ce0cdebec9150cb3$export$ec8b666c5fe2c75a);
$parcel$export($3b951febf8ab45a9$exports, "ExternalTexture", () => $ce0cdebec9150cb3$export$cd10147cacf16ab2);
$parcel$export($3b951febf8ab45a9$exports, "Float32BufferAttribute", () => $ce0cdebec9150cb3$export$cbe7a62641830ebd);
$parcel$export($3b951febf8ab45a9$exports, "FloatType", () => $ce0cdebec9150cb3$export$f6d331659b644596);
$parcel$export($3b951febf8ab45a9$exports, "FrontSide", () => $ce0cdebec9150cb3$export$2ede184fc2998901);
$parcel$export($3b951febf8ab45a9$exports, "Frustum", () => $ce0cdebec9150cb3$export$35efe6f4c85463d2);
$parcel$export($3b951febf8ab45a9$exports, "GLSL3", () => $ce0cdebec9150cb3$export$f63012db5506e7dd);
$parcel$export($3b951febf8ab45a9$exports, "GreaterCompare", () => $ce0cdebec9150cb3$export$155af022118f3a38);
$parcel$export($3b951febf8ab45a9$exports, "GreaterDepth", () => $ce0cdebec9150cb3$export$c5e2c52991f30937);
$parcel$export($3b951febf8ab45a9$exports, "GreaterEqualCompare", () => $ce0cdebec9150cb3$export$1cdcb70d53d65f61);
$parcel$export($3b951febf8ab45a9$exports, "GreaterEqualDepth", () => $ce0cdebec9150cb3$export$7d7234c1240a1fc4);
$parcel$export($3b951febf8ab45a9$exports, "HalfFloatType", () => $ce0cdebec9150cb3$export$2697304443f382bc);
$parcel$export($3b951febf8ab45a9$exports, "IntType", () => $ce0cdebec9150cb3$export$5c612977753abe2);
$parcel$export($3b951febf8ab45a9$exports, "Layers", () => $ce0cdebec9150cb3$export$89312ce47c0ca777);
$parcel$export($3b951febf8ab45a9$exports, "LessCompare", () => $ce0cdebec9150cb3$export$36bcf49c713b3eb7);
$parcel$export($3b951febf8ab45a9$exports, "LessDepth", () => $ce0cdebec9150cb3$export$eedccec66ab7ebe);
$parcel$export($3b951febf8ab45a9$exports, "LessEqualCompare", () => $ce0cdebec9150cb3$export$64eea11eb407ddf1);
$parcel$export($3b951febf8ab45a9$exports, "LessEqualDepth", () => $ce0cdebec9150cb3$export$296f78a0b892f81a);
$parcel$export($3b951febf8ab45a9$exports, "LinearFilter", () => $ce0cdebec9150cb3$export$8a72f490b25c56c8);
$parcel$export($3b951febf8ab45a9$exports, "LinearMipmapLinearFilter", () => $ce0cdebec9150cb3$export$5d8599b6a933fb1b);
$parcel$export($3b951febf8ab45a9$exports, "LinearMipmapNearestFilter", () => $ce0cdebec9150cb3$export$19a719f377145a13);
$parcel$export($3b951febf8ab45a9$exports, "LinearSRGBColorSpace", () => $ce0cdebec9150cb3$export$42429b3acfb233a4);
$parcel$export($3b951febf8ab45a9$exports, "LinearToneMapping", () => $ce0cdebec9150cb3$export$98f52c2a46c598ca);
$parcel$export($3b951febf8ab45a9$exports, "LinearTransfer", () => $ce0cdebec9150cb3$export$f197347d588c1b4a);
$parcel$export($3b951febf8ab45a9$exports, "Matrix3", () => $ce0cdebec9150cb3$export$8ff26dafa08918);
$parcel$export($3b951febf8ab45a9$exports, "Matrix4", () => $ce0cdebec9150cb3$export$2ae72fc923e5eb5);
$parcel$export($3b951febf8ab45a9$exports, "MaxEquation", () => $ce0cdebec9150cb3$export$99948c02fb51055f);
$parcel$export($3b951febf8ab45a9$exports, "Mesh", () => $ce0cdebec9150cb3$export$e176487c05830cc5);
$parcel$export($3b951febf8ab45a9$exports, "MeshBasicMaterial", () => $ce0cdebec9150cb3$export$55cbcc9b622fe1f5);
$parcel$export($3b951febf8ab45a9$exports, "MeshDepthMaterial", () => $ce0cdebec9150cb3$export$2698c22ec13825db);
$parcel$export($3b951febf8ab45a9$exports, "MeshDistanceMaterial", () => $ce0cdebec9150cb3$export$33e187ed002f2a19);
$parcel$export($3b951febf8ab45a9$exports, "MinEquation", () => $ce0cdebec9150cb3$export$c8c1508da8d0600c);
$parcel$export($3b951febf8ab45a9$exports, "MirroredRepeatWrapping", () => $ce0cdebec9150cb3$export$c7e7c00b14f51a4f);
$parcel$export($3b951febf8ab45a9$exports, "MixOperation", () => $ce0cdebec9150cb3$export$9f9d94f963c85479);
$parcel$export($3b951febf8ab45a9$exports, "MultiplyBlending", () => $ce0cdebec9150cb3$export$4138e1c684b46a20);
$parcel$export($3b951febf8ab45a9$exports, "MultiplyOperation", () => $ce0cdebec9150cb3$export$e50ac29801f1774d);
$parcel$export($3b951febf8ab45a9$exports, "NearestFilter", () => $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
$parcel$export($3b951febf8ab45a9$exports, "NearestMipmapLinearFilter", () => $ce0cdebec9150cb3$export$d2327c1afe5bfdf2);
$parcel$export($3b951febf8ab45a9$exports, "NearestMipmapNearestFilter", () => $ce0cdebec9150cb3$export$d129e38cf6feaa8c);
$parcel$export($3b951febf8ab45a9$exports, "NeutralToneMapping", () => $ce0cdebec9150cb3$export$f2863e1668a8e317);
$parcel$export($3b951febf8ab45a9$exports, "NeverCompare", () => $ce0cdebec9150cb3$export$d9e2d19a747baaab);
$parcel$export($3b951febf8ab45a9$exports, "NeverDepth", () => $ce0cdebec9150cb3$export$69025ce147cee220);
$parcel$export($3b951febf8ab45a9$exports, "NoBlending", () => $ce0cdebec9150cb3$export$63b8d6b580fc65ba);
$parcel$export($3b951febf8ab45a9$exports, "NoColorSpace", () => $ce0cdebec9150cb3$export$bfcb490c2dd3db51);
$parcel$export($3b951febf8ab45a9$exports, "NoToneMapping", () => $ce0cdebec9150cb3$export$9fcb6b4294603b2);
$parcel$export($3b951febf8ab45a9$exports, "NormalBlending", () => $ce0cdebec9150cb3$export$5b29a26d96ee6af0);
$parcel$export($3b951febf8ab45a9$exports, "NotEqualCompare", () => $ce0cdebec9150cb3$export$67ab95dde6bed156);
$parcel$export($3b951febf8ab45a9$exports, "NotEqualDepth", () => $ce0cdebec9150cb3$export$2f843afa843d8916);
$parcel$export($3b951febf8ab45a9$exports, "ObjectSpaceNormalMap", () => $ce0cdebec9150cb3$export$9990ad26f9db5b2c);
$parcel$export($3b951febf8ab45a9$exports, "OneFactor", () => $ce0cdebec9150cb3$export$8805bad65e24940e);
$parcel$export($3b951febf8ab45a9$exports, "OneMinusConstantAlphaFactor", () => $ce0cdebec9150cb3$export$db77b8fbcf45dbf4);
$parcel$export($3b951febf8ab45a9$exports, "OneMinusConstantColorFactor", () => $ce0cdebec9150cb3$export$99c8d898a9afbcee);
$parcel$export($3b951febf8ab45a9$exports, "OneMinusDstAlphaFactor", () => $ce0cdebec9150cb3$export$5d0fe17fd8773bac);
$parcel$export($3b951febf8ab45a9$exports, "OneMinusDstColorFactor", () => $ce0cdebec9150cb3$export$56b85b2686ab16);
$parcel$export($3b951febf8ab45a9$exports, "OneMinusSrcAlphaFactor", () => $ce0cdebec9150cb3$export$11d468cc7f19e971);
$parcel$export($3b951febf8ab45a9$exports, "OneMinusSrcColorFactor", () => $ce0cdebec9150cb3$export$947829af9f2c17f6);
$parcel$export($3b951febf8ab45a9$exports, "OrthographicCamera", () => $ce0cdebec9150cb3$export$9ebf355ee4ed261b);
$parcel$export($3b951febf8ab45a9$exports, "PCFShadowMap", () => $ce0cdebec9150cb3$export$5813f879eee7cd88);
$parcel$export($3b951febf8ab45a9$exports, "PCFSoftShadowMap", () => $ce0cdebec9150cb3$export$a47c4b43a1be34f0);
$parcel$export($3b951febf8ab45a9$exports, "PerspectiveCamera", () => $ce0cdebec9150cb3$export$74e4ae24825f68d7);
$parcel$export($3b951febf8ab45a9$exports, "Plane", () => $ce0cdebec9150cb3$export$7ff5ac152ef991b0);
$parcel$export($3b951febf8ab45a9$exports, "PlaneGeometry", () => $ce0cdebec9150cb3$export$967d831af31f69ce);
$parcel$export($3b951febf8ab45a9$exports, "R11_EAC_Format", () => $ce0cdebec9150cb3$export$d5c566817123b2bf);
$parcel$export($3b951febf8ab45a9$exports, "RED_GREEN_RGTC2_Format", () => $ce0cdebec9150cb3$export$d220f6ade8463a0f);
$parcel$export($3b951febf8ab45a9$exports, "RED_RGTC1_Format", () => $ce0cdebec9150cb3$export$b1688df4c4c21670);
$parcel$export($3b951febf8ab45a9$exports, "REVISION", () => $ce0cdebec9150cb3$export$3545e07a80636437);
$parcel$export($3b951febf8ab45a9$exports, "RG11_EAC_Format", () => $ce0cdebec9150cb3$export$e443ea3e1485f7bf);
$parcel$export($3b951febf8ab45a9$exports, "RGBAFormat", () => $ce0cdebec9150cb3$export$3f8bb04b555a363c);
$parcel$export($3b951febf8ab45a9$exports, "RGBAIntegerFormat", () => $ce0cdebec9150cb3$export$c200e7d26f592f21);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_10x10_Format", () => $ce0cdebec9150cb3$export$2eb8634622ddeab7);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_10x5_Format", () => $ce0cdebec9150cb3$export$443cf6567cdd6424);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_10x6_Format", () => $ce0cdebec9150cb3$export$6573984fc9840780);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_10x8_Format", () => $ce0cdebec9150cb3$export$e7aee563f30091de);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_12x10_Format", () => $ce0cdebec9150cb3$export$202b1ce7b5d25742);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_12x12_Format", () => $ce0cdebec9150cb3$export$18ab77abd087e467);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_4x4_Format", () => $ce0cdebec9150cb3$export$dc5570b4a2b92d48);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_5x4_Format", () => $ce0cdebec9150cb3$export$68880cd325f8b2fb);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_5x5_Format", () => $ce0cdebec9150cb3$export$7d2c0be323373d95);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_6x5_Format", () => $ce0cdebec9150cb3$export$22b52da301fc3a3e);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_6x6_Format", () => $ce0cdebec9150cb3$export$c009e2cb4a66485e);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_8x5_Format", () => $ce0cdebec9150cb3$export$118fff5afa255b63);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_8x6_Format", () => $ce0cdebec9150cb3$export$120713c829ae0667);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ASTC_8x8_Format", () => $ce0cdebec9150cb3$export$c79eeabbf53313e9);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_BPTC_Format", () => $ce0cdebec9150cb3$export$ce40b115e188bc81);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_ETC2_EAC_Format", () => $ce0cdebec9150cb3$export$23ed8300a860e7d8);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_PVRTC_2BPPV1_Format", () => $ce0cdebec9150cb3$export$b71692456c47b6c3);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_PVRTC_4BPPV1_Format", () => $ce0cdebec9150cb3$export$b82296714358084c);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_S3TC_DXT1_Format", () => $ce0cdebec9150cb3$export$afa304c3e981b668);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_S3TC_DXT3_Format", () => $ce0cdebec9150cb3$export$d2a1a68024a3e56c);
$parcel$export($3b951febf8ab45a9$exports, "RGBA_S3TC_DXT5_Format", () => $ce0cdebec9150cb3$export$9a79c424327dacf9);
$parcel$export($3b951febf8ab45a9$exports, "RGBFormat", () => $ce0cdebec9150cb3$export$7c67423a5ee6f5eb);
$parcel$export($3b951febf8ab45a9$exports, "RGB_BPTC_SIGNED_Format", () => $ce0cdebec9150cb3$export$d279c5c4bac5121e);
$parcel$export($3b951febf8ab45a9$exports, "RGB_BPTC_UNSIGNED_Format", () => $ce0cdebec9150cb3$export$cde52d17225fdbd3);
$parcel$export($3b951febf8ab45a9$exports, "RGB_ETC1_Format", () => $ce0cdebec9150cb3$export$6ab91af2d757aee7);
$parcel$export($3b951febf8ab45a9$exports, "RGB_ETC2_Format", () => $ce0cdebec9150cb3$export$7800993ef8106a6a);
$parcel$export($3b951febf8ab45a9$exports, "RGB_PVRTC_2BPPV1_Format", () => $ce0cdebec9150cb3$export$d0f0355bb3d948e4);
$parcel$export($3b951febf8ab45a9$exports, "RGB_PVRTC_4BPPV1_Format", () => $ce0cdebec9150cb3$export$19ada9bbb1af3573);
$parcel$export($3b951febf8ab45a9$exports, "RGB_S3TC_DXT1_Format", () => $ce0cdebec9150cb3$export$21d1799c6d552fc0);
$parcel$export($3b951febf8ab45a9$exports, "RGFormat", () => $ce0cdebec9150cb3$export$6cdf0b461c7ce8a0);
$parcel$export($3b951febf8ab45a9$exports, "RGIntegerFormat", () => $ce0cdebec9150cb3$export$1ba1c45f9f77d4d7);
$parcel$export($3b951febf8ab45a9$exports, "RawShaderMaterial", () => $ce0cdebec9150cb3$export$21c421a2e1df9d22);
$parcel$export($3b951febf8ab45a9$exports, "RedFormat", () => $ce0cdebec9150cb3$export$4e041a7967d15c4b);
$parcel$export($3b951febf8ab45a9$exports, "RedIntegerFormat", () => $ce0cdebec9150cb3$export$aa92e870a709d190);
$parcel$export($3b951febf8ab45a9$exports, "ReinhardToneMapping", () => $ce0cdebec9150cb3$export$74b25e54b3bcd548);
$parcel$export($3b951febf8ab45a9$exports, "RepeatWrapping", () => $ce0cdebec9150cb3$export$533346c8e8dac0f5);
$parcel$export($3b951febf8ab45a9$exports, "ReverseSubtractEquation", () => $ce0cdebec9150cb3$export$28e582859cbec660);
$parcel$export($3b951febf8ab45a9$exports, "SIGNED_R11_EAC_Format", () => $ce0cdebec9150cb3$export$f5668dc623297d86);
$parcel$export($3b951febf8ab45a9$exports, "SIGNED_RED_GREEN_RGTC2_Format", () => $ce0cdebec9150cb3$export$768646d09dc1b6ef);
$parcel$export($3b951febf8ab45a9$exports, "SIGNED_RED_RGTC1_Format", () => $ce0cdebec9150cb3$export$fc15e5d8261eed58);
$parcel$export($3b951febf8ab45a9$exports, "SIGNED_RG11_EAC_Format", () => $ce0cdebec9150cb3$export$211402338cb75433);
$parcel$export($3b951febf8ab45a9$exports, "SRGBColorSpace", () => $ce0cdebec9150cb3$export$561f394b24edfcaa);
$parcel$export($3b951febf8ab45a9$exports, "SRGBTransfer", () => $ce0cdebec9150cb3$export$8d0a61916cc26abb);
$parcel$export($3b951febf8ab45a9$exports, "ShaderMaterial", () => $ce0cdebec9150cb3$export$83c7d75d550a8b0d);
$parcel$export($3b951febf8ab45a9$exports, "ShortType", () => $ce0cdebec9150cb3$export$88572337f312435f);
$parcel$export($3b951febf8ab45a9$exports, "SrcAlphaFactor", () => $ce0cdebec9150cb3$export$d5773124e86cf28c);
$parcel$export($3b951febf8ab45a9$exports, "SrcAlphaSaturateFactor", () => $ce0cdebec9150cb3$export$c05e2a1fc8609506);
$parcel$export($3b951febf8ab45a9$exports, "SrcColorFactor", () => $ce0cdebec9150cb3$export$7fbe15b28d28cf52);
$parcel$export($3b951febf8ab45a9$exports, "SubtractEquation", () => $ce0cdebec9150cb3$export$73e0df5177988548);
$parcel$export($3b951febf8ab45a9$exports, "SubtractiveBlending", () => $ce0cdebec9150cb3$export$cdfa06f868e2e467);
$parcel$export($3b951febf8ab45a9$exports, "TangentSpaceNormalMap", () => $ce0cdebec9150cb3$export$2852a58ebdac27b8);
$parcel$export($3b951febf8ab45a9$exports, "Texture", () => $ce0cdebec9150cb3$export$5431306cf43de24a);
$parcel$export($3b951febf8ab45a9$exports, "Uint16BufferAttribute", () => $ce0cdebec9150cb3$export$640a853f68025f2e);
$parcel$export($3b951febf8ab45a9$exports, "Uint32BufferAttribute", () => $ce0cdebec9150cb3$export$7eb8c9fa25cd5bd6);
$parcel$export($3b951febf8ab45a9$exports, "UniformsUtils", () => $ce0cdebec9150cb3$export$d8ecdf8615bfea69);
$parcel$export($3b951febf8ab45a9$exports, "UnsignedByteType", () => $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10);
$parcel$export($3b951febf8ab45a9$exports, "UnsignedInt101111Type", () => $ce0cdebec9150cb3$export$f240f067f72abe41);
$parcel$export($3b951febf8ab45a9$exports, "UnsignedInt248Type", () => $ce0cdebec9150cb3$export$6c8ea339bfab1301);
$parcel$export($3b951febf8ab45a9$exports, "UnsignedInt5999Type", () => $ce0cdebec9150cb3$export$5a4c329b7e2092d3);
$parcel$export($3b951febf8ab45a9$exports, "UnsignedIntType", () => $ce0cdebec9150cb3$export$c3c7fc4518ebba96);
$parcel$export($3b951febf8ab45a9$exports, "UnsignedShort4444Type", () => $ce0cdebec9150cb3$export$b3969b01faf587f2);
$parcel$export($3b951febf8ab45a9$exports, "UnsignedShort5551Type", () => $ce0cdebec9150cb3$export$18886f8ae33e90de);
$parcel$export($3b951febf8ab45a9$exports, "UnsignedShortType", () => $ce0cdebec9150cb3$export$c63dc51868b06a9d);
$parcel$export($3b951febf8ab45a9$exports, "VSMShadowMap", () => $ce0cdebec9150cb3$export$896ae1ade6c829c4);
$parcel$export($3b951febf8ab45a9$exports, "Vector2", () => $ce0cdebec9150cb3$export$c977b3e384af9ae1);
$parcel$export($3b951febf8ab45a9$exports, "Vector3", () => $ce0cdebec9150cb3$export$64b5c384219d3699);
$parcel$export($3b951febf8ab45a9$exports, "Vector4", () => $ce0cdebec9150cb3$export$fa7daccca11cdbe3);
$parcel$export($3b951febf8ab45a9$exports, "WebGLCoordinateSystem", () => $ce0cdebec9150cb3$export$5a0e9190d10875d3);
$parcel$export($3b951febf8ab45a9$exports, "WebGLRenderTarget", () => $ce0cdebec9150cb3$export$3c052beb2e51e23f);
$parcel$export($3b951febf8ab45a9$exports, "WebXRController", () => $ce0cdebec9150cb3$export$cb626c57dcc48b9f);
$parcel$export($3b951febf8ab45a9$exports, "ZeroFactor", () => $ce0cdebec9150cb3$export$2110f05edf778d3d);
$parcel$export($3b951febf8ab45a9$exports, "createCanvasElement", () => $ce0cdebec9150cb3$export$1033a2df66368859);
$parcel$export($3b951febf8ab45a9$exports, "error", () => $ce0cdebec9150cb3$export$a3bc9b8ed74fc);
$parcel$export($3b951febf8ab45a9$exports, "log", () => $ce0cdebec9150cb3$export$bef1f36f5486a6a3);
$parcel$export($3b951febf8ab45a9$exports, "warn", () => $ce0cdebec9150cb3$export$c106dd0671a0fc2d);
$parcel$export($3b951febf8ab45a9$exports, "warnOnce", () => $ce0cdebec9150cb3$export$5b28268982f175ba);
/**
 * @license
 * Copyright 2010-2026 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ /**
 * @license
 * Copyright 2010-2026 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $ce0cdebec9150cb3$export$3545e07a80636437 = '183';
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsMouse}
 * @constant
 */ const $ce0cdebec9150cb3$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
/**
 * Represents touch interaction types in context of controls.
 *
 * @type {ConstantsTouch}
 * @constant
 */ const $ce0cdebec9150cb3$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
/**
 * Disables face culling.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$3237e1f2c1ea1f44 = 0;
/**
 * Culls back faces.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$b9a7b4fc5cb15f9b = 1;
/**
 * Culls front faces.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$b8058bcc7037d3f3 = 2;
/**
 * Culls both front and back faces.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$f24be24dcddeac0d = 3;
/**
 * Gives unfiltered shadow maps - fastest, but lowest quality.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$346307dbae2b7447 = 0;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$5813f879eee7cd88 = 1;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm with
 * better soft shadows especially when using low-resolution shadow maps.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$a47c4b43a1be34f0 = 2;
/**
 * Filters shadow maps using the Variance Shadow Map (VSM) algorithm.
 * When using VSMShadowMap all shadow receivers will also cast shadows.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$896ae1ade6c829c4 = 3;
/**
 * Only front faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2ede184fc2998901 = 0;
/**
 * Only back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d9f0486e75b5ace = 1;
/**
 * Both front and back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$3b296b6f144d5b03 = 2;
/**
 * No blending is performed which effectively disables
 * alpha transparency.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$63b8d6b580fc65ba = 0;
/**
 * The default blending.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$5b29a26d96ee6af0 = 1;
/**
 * Represents additive blending.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$777d8f9551c2216b = 2;
/**
 * Represents subtractive blending.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$cdfa06f868e2e467 = 3;
/**
 * Represents multiply blending.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$4138e1c684b46a20 = 4;
/**
 * Represents custom blending.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$eda4864c68df1fa2 = 5;
/**
 * Represents material blending.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$ec822fcd0c1d2914 = 6;
/**
 * A `source + destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$20183a0484ce21a0 = 100;
/**
 * A `source - destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$73e0df5177988548 = 101;
/**
 * A `destination - source` blending equation.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$28e582859cbec660 = 102;
/**
 * A blend equation that uses the minimum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c8c1508da8d0600c = 103;
/**
 * A blend equation that uses the maximum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$99948c02fb51055f = 104;
/**
 * Multiplies all colors by `0`.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2110f05edf778d3d = 200;
/**
 * Multiplies all colors by `1`.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$8805bad65e24940e = 201;
/**
 * Multiplies all colors by the source colors.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$7fbe15b28d28cf52 = 202;
/**
 * Multiplies all colors by `1` minus each source color.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$947829af9f2c17f6 = 203;
/**
 * Multiplies all colors by the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d5773124e86cf28c = 204;
/**
 * Multiplies all colors by 1 minus the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$11d468cc7f19e971 = 205;
/**
 * Multiplies all colors by the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$a78aed1ca2a87192 = 206;
/**
 * Multiplies all colors by `1` minus the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$5d0fe17fd8773bac = 207;
/**
 * Multiplies all colors by the destination color.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$ef5f2dd8ffac5574 = 208;
/**
 * Multiplies all colors by `1` minus each destination color.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$56b85b2686ab16 = 209;
/**
 * Multiplies the RGB colors by the smaller of either the source alpha
 * value or the value of `1` minus the destination alpha value. The alpha
 * value is multiplied by `1`.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c05e2a1fc8609506 = 210;
/**
 * Multiplies all colors by a constant color.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$7dd8f434fd59075 = 211;
/**
 * Multiplies all colors by `1` minus a constant color.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$99c8d898a9afbcee = 212;
/**
 * Multiplies all colors by a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$310cd2be38d13b56 = 213;
/**
 * Multiplies all colors by 1 minus a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$db77b8fbcf45dbf4 = 214;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$69025ce147cee220 = 0;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$7182eb52ea3b3f04 = 1;
/**
 * Pass if the incoming value is less than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$eedccec66ab7ebe = 2;
/**
 * Pass if the incoming value is less than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$296f78a0b892f81a = 3;
/**
 * Pass if the incoming value equals the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$a60d398fc7b7590e = 4;
/**
 * Pass if the incoming value is greater than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$7d7234c1240a1fc4 = 5;
/**
 * Pass if the incoming value is greater than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c5e2c52991f30937 = 6;
/**
 * Pass if the incoming value is not equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2f843afa843d8916 = 7;
/**
 * Multiplies the environment map color with the surface color.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$e50ac29801f1774d = 0;
/**
 * Uses reflectivity to blend between the two colors.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$9f9d94f963c85479 = 1;
/**
 * Adds the two colors.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$e641dc52bc3494aa = 2;
/**
 * No tone mapping is applied.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$9fcb6b4294603b2 = 0;
/**
 * Linear tone mapping.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$98f52c2a46c598ca = 1;
/**
 * Reinhard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$74b25e54b3bcd548 = 2;
/**
 * Cineon tone mapping.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$932b3dd283d4a366 = 3;
/**
 * ACES Filmic tone mapping.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$a0d98fe6d7e4af64 = 4;
/**
 * Custom tone mapping.
 *
 * Expects a custom implementation by modifying shader code of the material's fragment shader.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2c7b09c1e9abfb5e = 5;
/**
 * AgX tone mapping.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$212d53a513a325b2 = 6;
/**
 * Neutral tone mapping.
 *
 * Implementation based on the Khronos 3D Commerce Group standard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$f2863e1668a8e317 = 7;
/**
 * The skinned mesh shares the same world space as the skeleton.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$2595a3798997538 = 'attached';
/**
 * The skinned mesh does not share the same world space as the skeleton.
 * This is useful when a skeleton is shared across multiple skinned meshes.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$d7e7dc2e114517a0 = 'detached';
/**
 * Maps textures using the geometry's UV coordinates.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$1beec6768cbb3d2d = 300;
/**
 * Reflection mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$8759762a6477f2c4 = 301;
/**
 * Refraction mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$dc59f8aed047f61d = 302;
/**
 * Reflection mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d64030b316d3b087 = 303;
/**
 * Refraction mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$ee99d97d46898098 = 304;
/**
 * Reflection mapping for PMREM textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$dbf3e70ff37af79 = 306;
/**
 * The texture will simply repeat to infinity.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$533346c8e8dac0f5 = 1000;
/**
 * The last pixel of the texture stretches to the edge of the mesh.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$9d9334239a5a5e06 = 1001;
/**
 * The texture will repeats to infinity, mirroring on each repeat.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c7e7c00b14f51a4f = 1002;
/**
 * Returns the value of the texture element that is nearest (in Manhattan distance)
 * to the specified texture coordinates.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$727aa5ec3fe39bf0 = 1003;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured
 * and uses the `NearestFilter` criterion (the texel nearest to the center of the pixel)
 * to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d129e38cf6feaa8c = 1004;
const $ce0cdebec9150cb3$export$14a4936464a36496 = 1004; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and
 * uses the `NearestFilter` criterion to produce a texture value from each mipmap.
 * The final texture value is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d2327c1afe5bfdf2 = 1005;
const $ce0cdebec9150cb3$export$cbc5b7f5647595d8 = 1005; // legacy
/**
 * Returns the weighted average of the four texture elements that are closest to the specified
 * texture coordinates, and can include items wrapped or repeated from other parts of a texture,
 * depending on the values of `wrapS` and `wrapT`, and on the exact mapping.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$8a72f490b25c56c8 = 1006;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured and uses
 * the `LinearFilter` criterion (a weighted average of the four texels that are closest to the
 * center of the pixel) to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$19a719f377145a13 = 1007;
const $ce0cdebec9150cb3$export$dbe96bee3fe9dbf0 = 1007; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and uses
 * the `LinearFilter` criterion to produce a texture value from each mipmap. The final texture value
 * is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$5d8599b6a933fb1b = 1008;
const $ce0cdebec9150cb3$export$90d80f1e3506775f = 1008; // legacy
/**
 * An unsigned byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10 = 1009;
/**
 * A byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$545fce0311a9796a = 1010;
/**
 * A short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$88572337f312435f = 1011;
/**
 * An unsigned short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c63dc51868b06a9d = 1012;
/**
 * An int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$5c612977753abe2 = 1013;
/**
 * An unsigned int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c3c7fc4518ebba96 = 1014;
/**
 * A float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$f6d331659b644596 = 1015;
/**
 * A half float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2697304443f382bc = 1016;
/**
 * An unsigned short 4_4_4_4 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$b3969b01faf587f2 = 1017;
/**
 * An unsigned short 5_5_5_1 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$18886f8ae33e90de = 1018;
/**
 * An unsigned int 24_8 data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$6c8ea339bfab1301 = 1020;
/**
 * An unsigned int 5_9_9_9 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$5a4c329b7e2092d3 = 35902;
/**
 * An unsigned int 10_11_11 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$f240f067f72abe41 = 35899;
/**
 * Discards the red, green and blue components and reads just the alpha component.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$988473390501ed4b = 1021;
/**
 * Discards the alpha component and reads the red, green and blue component.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$7c67423a5ee6f5eb = 1022;
/**
 * Reads the red, green, blue and alpha components.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$3f8bb04b555a363c = 1023;
/**
 * Reads each element as a single depth value, converts it to floating point, and clamps to the range `[0,1]`.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c1b6b5136be58045 = 1026;
/**
 * Reads each element is a pair of depth and stencil values. The depth component of the pair is interpreted as
 * in `DepthFormat`. The stencil component is interpreted based on the depth + stencil internal format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$1e113ac2d0905829 = 1027;
/**
 * Discards the green, blue and alpha components and reads just the red component.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$4e041a7967d15c4b = 1028;
/**
 * Discards the green, blue and alpha components and reads just the red component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$aa92e870a709d190 = 1029;
/**
 * Discards the alpha, and blue components and reads the red, and green components.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$6cdf0b461c7ce8a0 = 1030;
/**
 * Discards the alpha, and blue components and reads the red, and green components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$1ba1c45f9f77d4d7 = 1031;
/**
 * Discards the alpha component and reads the red, green and blue component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d1fd40c11bfa798e = 1032;
/**
 * Reads the red, green, blue and alpha components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c200e7d26f592f21 = 1033;
/**
 * A DXT1-compressed image in an RGB image format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$21d1799c6d552fc0 = 33776;
/**
 * A DXT1-compressed image in an RGB image format with a simple on/off alpha value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$afa304c3e981b668 = 33777;
/**
 * A DXT3-compressed image in an RGBA image format. Compared to a 32-bit RGBA texture, it offers 4:1 compression.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d2a1a68024a3e56c = 33778;
/**
 * A DXT5-compressed image in an RGBA image format. It also provides a 4:1 compression, but differs to the DXT3
 * compression in how the alpha compression is done.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$9a79c424327dacf9 = 33779;
/**
 * PVRTC RGB compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$19ada9bbb1af3573 = 35840;
/**
 * PVRTC RGB compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d0f0355bb3d948e4 = 35841;
/**
 * PVRTC RGBA compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$b82296714358084c = 35842;
/**
 * PVRTC RGBA compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$b71692456c47b6c3 = 35843;
/**
 * ETC1 RGB format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$6ab91af2d757aee7 = 36196;
/**
 * ETC2 RGB format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$7800993ef8106a6a = 37492;
/**
 * ETC2 RGBA format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$23ed8300a860e7d8 = 37496;
/**
 * EAC R11 UNORM format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d5c566817123b2bf = 37488; // 0x9270
/**
 * EAC R11 SNORM format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$f5668dc623297d86 = 37489; // 0x9271
/**
 * EAC RG11 UNORM format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$e443ea3e1485f7bf = 37490; // 0x9272
/**
 * EAC RG11 SNORM format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$211402338cb75433 = 37491; // 0x9273
/**
 * ASTC RGBA 4x4 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$dc5570b4a2b92d48 = 37808;
/**
 * ASTC RGBA 5x4 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$68880cd325f8b2fb = 37809;
/**
 * ASTC RGBA 5x5 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$7d2c0be323373d95 = 37810;
/**
 * ASTC RGBA 6x5 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$22b52da301fc3a3e = 37811;
/**
 * ASTC RGBA 6x6 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c009e2cb4a66485e = 37812;
/**
 * ASTC RGBA 8x5 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$118fff5afa255b63 = 37813;
/**
 * ASTC RGBA 8x6 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$120713c829ae0667 = 37814;
/**
 * ASTC RGBA 8x8 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c79eeabbf53313e9 = 37815;
/**
 * ASTC RGBA 10x5 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$443cf6567cdd6424 = 37816;
/**
 * ASTC RGBA 10x6 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$6573984fc9840780 = 37817;
/**
 * ASTC RGBA 10x8 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$e7aee563f30091de = 37818;
/**
 * ASTC RGBA 10x10 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2eb8634622ddeab7 = 37819;
/**
 * ASTC RGBA 12x10 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$202b1ce7b5d25742 = 37820;
/**
 * ASTC RGBA 12x12 format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$18ab77abd087e467 = 37821;
/**
 * BPTC RGBA format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$ce40b115e188bc81 = 36492;
/**
 * BPTC Signed RGB format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d279c5c4bac5121e = 36494;
/**
 * BPTC Unsigned RGB format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$cde52d17225fdbd3 = 36495;
/**
 * RGTC1 Red format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$b1688df4c4c21670 = 36283;
/**
 * RGTC1 Signed Red format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$fc15e5d8261eed58 = 36284;
/**
 * RGTC2 Red Green format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d220f6ade8463a0f = 36285;
/**
 * RGTC2 Signed Red Green format.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$768646d09dc1b6ef = 36286;
/**
 * Animations are played once.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d62fdc9d1b1cccad = 2200;
/**
 * Animations are played with a chosen number of repetitions, each time jumping from
 * the end of the clip directly to its beginning.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$dfaf4422ce096e29 = 2201;
/**
 * Animations are played with a chosen number of repetitions, alternately playing forward
 * and backward.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$f8f6f2041b78e210 = 2202;
/**
 * Discrete interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$995b32462a65e855 = 2300;
/**
 * Linear interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$30fac1aace31cf4d = 2301;
/**
 * Smooth interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$198b11ff4c72bb30 = 2302;
/**
 * Bezier interpolation mode for keyframe tracks.
 *
 * Uses cubic Bezier curves with explicit 2D control points.
 * Requires tangent data to be set on the track.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$ad783ffd8f91a9e3 = 2303;
/**
 * Zero curvature ending for animations.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$7f795934b84ab523 = 2400;
/**
 * Zero slope ending for animations.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$24a4ccb5099273b5 = 2401;
/**
 * Wrap around ending for animations.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$8e8c3ecdcd8e1fee = 2402;
/**
 * Default animation blend mode.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$bcfbbdcf8de7f8cd = 2500;
/**
 * Additive animation blend mode. Can be used to layer motions on top of
 * each other to build complex performances from smaller re-usable assets.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d875e029ef558d3 = 2501;
/**
 * For every three vertices draw a single triangle.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$4c28c87c2dc84758 = 0;
/**
 * For each vertex draw a triangle from the last three vertices.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$b23a071aa286eb29 = 1;
/**
 * For each vertex draw a triangle from the first vertex and the last two vertices.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$f0d8293634f88842 = 2;
/**
 * The depth value is inverted (1.0 - z) for visualization purposes.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$deeb383078690b50 = 3200;
/**
 * The depth value is packed into 32 bit RGBA.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$8f910f4c4f73df11 = 3201;
/**
 * The depth value is packed into 24 bit RGB.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$be2e2ddbc3983173 = 3202;
/**
 * The depth value is packed into 16 bit RG.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$1a54198784742f80 = 3203;
/**
 * Normal information is relative to the underlying surface.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2852a58ebdac27b8 = 0;
/**
 * Normal information is relative to the object orientation.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
/**
 * No color space.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$bfcb490c2dd3db51 = '';
/**
 * sRGB color space.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$561f394b24edfcaa = 'srgb';
/**
 * sRGB-linear color space.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$42429b3acfb233a4 = 'srgb-linear';
/**
 * Linear transfer function.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$f197347d588c1b4a = 'linear';
/**
 * sRGB transfer function.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$8d0a61916cc26abb = 'srgb';
/**
 * No normal map packing.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$7f96a53e6ab01dca = '';
/**
 * Normal RG packing.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$bbd2d5168fed5fd6 = 'rg';
/**
 * Normal GA packing.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$4f8d192b60f65626 = 'ga';
/**
 * Sets the stencil buffer value to `0`.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$69433f11f42d5527 = 0;
/**
 * Keeps the current value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$9f542ae4b5baca34 = 7680;
/**
 * Sets the stencil buffer value to the specified reference value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$8a4f28336ef203d3 = 7681;
/**
 * Increments the current stencil buffer value. Clamps to the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2928c0231297c036 = 7682;
/**
 * Decrements the current stencil buffer value. Clamps to `0`.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$c0e9611c8a15f9a8 = 7683;
/**
 * Increments the current stencil buffer value. Wraps stencil buffer value to zero when incrementing
 * the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$9c2c08927385dcc4 = 34055;
/**
 * Decrements the current stencil buffer value. Wraps stencil buffer value to the maximum representable
 * unsigned value when decrementing a stencil buffer value of `0`.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$7c74ea00fa1315e6 = 34056;
/**
 * Inverts the current stencil buffer value bitwise.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$22e2e5726612443 = 5386;
/**
 * Will never return true.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$1343870698229224 = 512;
/**
 * Will return true if the stencil reference value is less than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$8e1d8ed281997fa6 = 513;
/**
 * Will return true if the stencil reference value is equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$55648a1cde8329a7 = 514;
/**
 * Will return true if the stencil reference value is less than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2dff107857e6aca2 = 515;
/**
 * Will return true if the stencil reference value is greater than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$6f93765ab2f451a2 = 516;
/**
 * Will return true if the stencil reference value is not equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$6f3fb2d2440f2b76 = 517;
/**
 * Will return true if the stencil reference value is greater than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$4119cf7b4c98fd5a = 518;
/**
 * Will always return true.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$14cf96713ddd97a8 = 519;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$d9e2d19a747baaab = 512;
/**
 * Pass if the incoming value is less than the texture value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$36bcf49c713b3eb7 = 513;
/**
 * Pass if the incoming value equals the texture value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$66f28d946fc6a0d5 = 514;
/**
 * Pass if the incoming value is less than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$64eea11eb407ddf1 = 515;
/**
 * Pass if the incoming value is greater than the texture value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$155af022118f3a38 = 516;
/**
 * Pass if the incoming value is not equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$67ab95dde6bed156 = 517;
/**
 * Pass if the incoming value is greater than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$1cdcb70d53d65f61 = 518;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$187b73a3e352c145 = 519;
/**
 * The contents are intended to be specified once by the application, and used many
 * times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$763e8360f4d7f77d = 35044;
/**
 * The contents are intended to be respecified repeatedly by the application, and
 * used many times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$8505d14ac8546ca = 35048;
/**
 * The contents are intended to be specified once by the application, and used at most
 * a few times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$721e63549e51d81e = 35040;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$415731dc4f48e299 = 35045;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$9e809946455f13bc = 35049;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried at most
 * a few times by the application
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$2ed9499a35b5f832 = 35041;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used many times as
 * the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$32ab2503ea19469a = 35046;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and used many times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$ab4022c2c3f86315 = 35050;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used at most a few times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$ba7f1db36a76a970 = 35042;
/**
 * GLSL 1 shader code.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$43600cc67fabd9f = '100';
/**
 * GLSL 3 shader code.
 *
 * @type {string}
 * @constant
 */ const $ce0cdebec9150cb3$export$f63012db5506e7dd = '300 es';
/**
 * WebGL coordinate system.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$5a0e9190d10875d3 = 2000;
/**
 * WebGPU coordinate system.
 *
 * @type {number}
 * @constant
 */ const $ce0cdebec9150cb3$export$cc83beedcb9be9ac = 2001;
/**
 * Represents the different timestamp query types.
 *
 * @type {ConstantsTimestampQuery}
 * @constant
 */ const $ce0cdebec9150cb3$export$f97db56e2b647801 = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsInterpolationSamplingType}
 * @constant
 */ const $ce0cdebec9150cb3$export$ff3764a6b1cf3544 = {
    PERSPECTIVE: 'perspective',
    LINEAR: 'linear',
    FLAT: 'flat'
};
/**
 * Represents the different interpolation sampling modes.
 *
 * @type {ConstantsInterpolationSamplingMode}
 * @constant
 */ const $ce0cdebec9150cb3$export$599d2e4c2d7b2a01 = {
    NORMAL: 'normal',
    CENTROID: 'centroid',
    SAMPLE: 'sample',
    FIRST: 'first',
    EITHER: 'either'
};
/**
 * Compatibility flags for features that may not be supported across all platforms.
 *
 * @type {Object}
 * @constant
 */ const $ce0cdebec9150cb3$export$10255bda2baf681 = {
    TEXTURE_COMPARE: 'depthTextureCompare'
};
/**
 * This type represents mouse buttons and interaction types in context of controls.
 *
 * @typedef {Object} ConstantsMouse
 * @property {number} MIDDLE - The left mouse button.
 * @property {number} LEFT - The middle mouse button.
 * @property {number} RIGHT - The right mouse button.
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} DOLLY - A dolly interaction.
 * @property {number} PAN - A pan interaction.
 **/ /**
 * This type represents touch interaction types in context of controls.
 *
 * @typedef {Object} ConstantsTouch
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} PAN - A pan interaction.
 * @property {number} DOLLY_PAN - The dolly-pan interaction.
 * @property {number} DOLLY_ROTATE - A dolly-rotate interaction.
 **/ /**
 * This type represents the different timestamp query types.
 *
 * @typedef {Object} ConstantsTimestampQuery
 * @property {string} COMPUTE - A `compute` timestamp query.
 * @property {string} RENDER - A `render` timestamp query.
 **/ /**
 * Represents the different interpolation sampling types.
 *
 * @typedef {Object} ConstantsInterpolationSamplingType
 * @property {string} PERSPECTIVE - Perspective-correct interpolation.
 * @property {string} LINEAR - Linear interpolation.
 * @property {string} FLAT - Flat interpolation.
 */ /**
 * Represents the different interpolation sampling modes.
 *
 * @typedef {Object} ConstantsInterpolationSamplingMode
 * @property {string} NORMAL - Normal sampling mode.
 * @property {string} CENTROID - Centroid sampling mode.
 * @property {string} SAMPLE - Sample-specific sampling mode.
 * @property {string} FIRST - Flat interpolation using the first vertex.
 * @property {string} EITHER - Flat interpolation using either vertex.
 */ /**
 * Checks if an array contains values that require Uint32 representation.
 *
 * This function determines whether the array contains any values >= 65535,
 * which would require a Uint32Array rather than a Uint16Array for proper storage.
 * The function iterates from the end of the array, assuming larger values are
 * typically located at the end.
 *
 * @private
 * @param {Array<number>} array - The array to check.
 * @return {boolean} True if the array contains values >= 65535, false otherwise.
 */ function $ce0cdebec9150cb3$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
/**
 * Map of typed array constructor names to their constructors.
 * This mapping enables dynamic creation of typed arrays based on string type names.
 *
 * @private
 * @constant
 * @type {Object<string, TypedArrayConstructor>}
 */ const $ce0cdebec9150cb3$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
/**
 * Creates a typed array of the specified type from the given buffer.
 *
 * @private
 * @param {string} type - The name of the typed array type (e.g., 'Float32Array', 'Uint16Array').
 * @param {ArrayBuffer} buffer - The buffer to create the typed array from.
 * @return {TypedArray} A new typed array of the specified type.
 */ function $ce0cdebec9150cb3$var$getTypedArray(type, buffer) {
    return new $ce0cdebec9150cb3$var$TYPED_ARRAYS[type](buffer);
}
/**
 * Returns `true` if the given object is a typed array.
 *
 * @param {any} array - The object to check.
 * @return {boolean} Whether the given object is a typed array.
 */ function $ce0cdebec9150cb3$export$b119cc7e1840e59c(array) {
    return ArrayBuffer.isView(array) && !(array instanceof DataView);
}
/**
 * Creates an XHTML element with the specified tag name.
 *
 * This function uses the XHTML namespace to create DOM elements,
 * ensuring proper element creation in XML-based contexts.
 *
 * @private
 * @param {string} name - The tag name of the element to create (e.g., 'canvas', 'div').
 * @return {HTMLElement} The created XHTML element.
 */ function $ce0cdebec9150cb3$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
/**
 * Creates a canvas element configured for block display.
 *
 * This is a convenience function that creates a canvas element with
 * display style set to 'block', which is commonly used in three.js
 * rendering contexts to avoid inline element spacing issues.
 *
 * @return {HTMLCanvasElement} A canvas element with display set to 'block'.
 */ function $ce0cdebec9150cb3$export$1033a2df66368859() {
    const canvas = $ce0cdebec9150cb3$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
/**
 * Internal cache for tracking warning messages to prevent duplicate warnings.
 *
 * @private
 * @type {Object<string, boolean>}
 */ const $ce0cdebec9150cb3$var$_cache = {};
/**
 * Custom console function handler for intercepting log, warn, and error calls.
 *
 * @private
 * @type {Function|null}
 */ let $ce0cdebec9150cb3$var$_setConsoleFunction = null;
/**
 * Sets a custom function to handle console output.
 *
 * This allows external code to intercept and handle console.log, console.warn,
 * and console.error calls made by three.js, which is useful for custom logging,
 * testing, or debugging workflows.
 *
 * @param {Function} fn - The function to handle console output. Should accept
 *                        (type, message, ...params) where type is 'log', 'warn', or 'error'.
 */ function $ce0cdebec9150cb3$export$702823ffb42fb3aa(fn) {
    $ce0cdebec9150cb3$var$_setConsoleFunction = fn;
}
/**
 * Gets the currently set custom console function.
 *
 * @return {Function|null} The custom console function, or null if not set.
 */ function $ce0cdebec9150cb3$export$fa86edd994bb169f() {
    return $ce0cdebec9150cb3$var$_setConsoleFunction;
}
/**
 * Logs an informational message with the 'THREE.' prefix.
 *
 * If a custom console function is set via setConsoleFunction(), it will be used
 * instead of the native console.log. The first parameter is treated as the
 * method name and is automatically prefixed with 'THREE.'.
 *
 * @param {...any} params - The message components. The first param is used as
 *                          the method name and prefixed with 'THREE.'.
 */ function $ce0cdebec9150cb3$export$bef1f36f5486a6a3(...params) {
    const message = 'THREE.' + params.shift();
    if ($ce0cdebec9150cb3$var$_setConsoleFunction) $ce0cdebec9150cb3$var$_setConsoleFunction('log', message, ...params);
    else console.log(message, ...params);
}
/**
 * Enhances log/warn/error messages related to TSL.
 *
 * @param {Array<any>} params - The original message parameters.
 * @returns {Array<any>} The filtered and enhanced message parameters.
 */ function $ce0cdebec9150cb3$var$enhanceLogMessage(params) {
    const message = params[0];
    if (typeof message === 'string' && message.startsWith('TSL:')) {
        const stackTrace = params[1];
        if (stackTrace && stackTrace.isStackTrace) params[0] += ' ' + stackTrace.getLocation();
        else params[1] = 'Stack trace not available. Enable "THREE.Node.captureStackTrace" to capture stack traces.';
    }
    return params;
}
/**
 * Logs a warning message with the 'THREE.' prefix.
 *
 * If a custom console function is set via setConsoleFunction(), it will be used
 * instead of the native console.warn. The first parameter is treated as the
 * method name and is automatically prefixed with 'THREE.'.
 *
 * @param {...any} params - The message components. The first param is used as
 *                          the method name and prefixed with 'THREE.'.
 */ function $ce0cdebec9150cb3$export$c106dd0671a0fc2d(...params) {
    params = $ce0cdebec9150cb3$var$enhanceLogMessage(params);
    const message = 'THREE.' + params.shift();
    if ($ce0cdebec9150cb3$var$_setConsoleFunction) $ce0cdebec9150cb3$var$_setConsoleFunction('warn', message, ...params);
    else {
        const stackTrace = params[0];
        if (stackTrace && stackTrace.isStackTrace) console.warn(stackTrace.getError(message));
        else console.warn(message, ...params);
    }
}
/**
 * Logs an error message with the 'THREE.' prefix.
 *
 * If a custom console function is set via setConsoleFunction(), it will be used
 * instead of the native console.error. The first parameter is treated as the
 * method name and is automatically prefixed with 'THREE.'.
 *
 * @param {...any} params - The message components. The first param is used as
 *                          the method name and prefixed with 'THREE.'.
 */ function $ce0cdebec9150cb3$export$a3bc9b8ed74fc(...params) {
    params = $ce0cdebec9150cb3$var$enhanceLogMessage(params);
    const message = 'THREE.' + params.shift();
    if ($ce0cdebec9150cb3$var$_setConsoleFunction) $ce0cdebec9150cb3$var$_setConsoleFunction('error', message, ...params);
    else {
        const stackTrace = params[0];
        if (stackTrace && stackTrace.isStackTrace) console.error(stackTrace.getError(message));
        else console.error(message, ...params);
    }
}
/**
 * Logs a warning message only once, preventing duplicate warnings.
 *
 * This function maintains an internal cache of warning messages and will only
 * output each unique warning message once. Useful for warnings that may be
 * triggered repeatedly but should only be shown to the user once.
 *
 * @param {...any} params - The warning message components.
 */ function $ce0cdebec9150cb3$export$5b28268982f175ba(...params) {
    const message = params.join(' ');
    if (message in $ce0cdebec9150cb3$var$_cache) return;
    $ce0cdebec9150cb3$var$_cache[message] = true;
    $ce0cdebec9150cb3$export$c106dd0671a0fc2d(...params);
}
/**
 * Asynchronously probes for WebGL sync object completion.
 *
 * This function creates a promise that resolves when the WebGL sync object
 * signals completion or rejects if the sync operation fails. It uses polling
 * at the specified interval to check the sync status without blocking the
 * main thread. This is useful for GPU-CPU synchronization in WebGL contexts.
 *
 * @private
 * @param {WebGL2RenderingContext} gl - The WebGL rendering context.
 * @param {WebGLSync} sync - The WebGL sync object to wait for.
 * @param {number} interval - The polling interval in milliseconds.
 * @return {Promise<void>} A promise that resolves when the sync completes or rejects if it fails.
 */ function $ce0cdebec9150cb3$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
/**
 * Used to select the correct depth functions
 * when reversed depth buffer is used.
 *
 * @private
 * @type {Object}
 */ const $ce0cdebec9150cb3$export$611f4ad2374e11ff = {
    [$ce0cdebec9150cb3$export$69025ce147cee220]: $ce0cdebec9150cb3$export$7182eb52ea3b3f04,
    [$ce0cdebec9150cb3$export$eedccec66ab7ebe]: $ce0cdebec9150cb3$export$c5e2c52991f30937,
    [$ce0cdebec9150cb3$export$a60d398fc7b7590e]: $ce0cdebec9150cb3$export$2f843afa843d8916,
    [$ce0cdebec9150cb3$export$296f78a0b892f81a]: $ce0cdebec9150cb3$export$7d7234c1240a1fc4,
    [$ce0cdebec9150cb3$export$7182eb52ea3b3f04]: $ce0cdebec9150cb3$export$69025ce147cee220,
    [$ce0cdebec9150cb3$export$c5e2c52991f30937]: $ce0cdebec9150cb3$export$eedccec66ab7ebe,
    [$ce0cdebec9150cb3$export$2f843afa843d8916]: $ce0cdebec9150cb3$export$a60d398fc7b7590e,
    [$ce0cdebec9150cb3$export$7d7234c1240a1fc4]: $ce0cdebec9150cb3$export$296f78a0b892f81a
};
/**
 * This modules allows to dispatch event objects on custom JavaScript objects.
 *
 * Main repository: [eventdispatcher.js](https://github.com/mrdoob/eventdispatcher.js/)
 *
 * Code Example:
 * ```js
 * class Car extends EventDispatcher {
 * 	start() {
 *		this.dispatchEvent( { type: 'start', message: 'vroom vroom!' } );
 *	}
 *};
 *
 * // Using events with the custom object
 * const car = new Car();
 * car.addEventListener( 'start', function ( event ) {
 * 	alert( event.message );
 * } );
 *
 * car.start();
 * ```
 */ class $ce0cdebec9150cb3$export$ec8b666c5fe2c75a {
    /**
	 * Adds the given event listener to the given event type.
	 *
	 * @param {string} type - The type of event to listen to.
	 * @param {Function} listener - The function that gets called when the event is fired.
	 */ addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
	 * Returns `true` if the given event listener has been added to the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to check.
	 * @return {boolean} Whether the given event listener has been added to the given event type.
	 */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return false;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
	 * Removes the given event listener from the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to remove.
	 */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
	 * Dispatches an event object.
	 *
	 * @param {Object} event - The event that gets fired.
	 */ dispatchEvent(event) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $ce0cdebec9150cb3$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $ce0cdebec9150cb3$var$_seed = 1234567;
const $ce0cdebec9150cb3$var$DEG2RAD = Math.PI / 180;
const $ce0cdebec9150cb3$export$914076c8150813e5 = 180 / Math.PI;
/**
 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
 * (universally unique identifier).
 *
 * @return {string} The UUID.
 */ function $ce0cdebec9150cb3$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $ce0cdebec9150cb3$var$_lut[d0 & 0xff] + $ce0cdebec9150cb3$var$_lut[d0 >> 8 & 0xff] + $ce0cdebec9150cb3$var$_lut[d0 >> 16 & 0xff] + $ce0cdebec9150cb3$var$_lut[d0 >> 24 & 0xff] + '-' + $ce0cdebec9150cb3$var$_lut[d1 & 0xff] + $ce0cdebec9150cb3$var$_lut[d1 >> 8 & 0xff] + '-' + $ce0cdebec9150cb3$var$_lut[d1 >> 16 & 0x0f | 0x40] + $ce0cdebec9150cb3$var$_lut[d1 >> 24 & 0xff] + '-' + $ce0cdebec9150cb3$var$_lut[d2 & 0x3f | 0x80] + $ce0cdebec9150cb3$var$_lut[d2 >> 8 & 0xff] + '-' + $ce0cdebec9150cb3$var$_lut[d2 >> 16 & 0xff] + $ce0cdebec9150cb3$var$_lut[d2 >> 24 & 0xff] + $ce0cdebec9150cb3$var$_lut[d3 & 0xff] + $ce0cdebec9150cb3$var$_lut[d3 >> 8 & 0xff] + $ce0cdebec9150cb3$var$_lut[d3 >> 16 & 0xff] + $ce0cdebec9150cb3$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
/**
 * Clamps the given value between min and max.
 *
 * @param {number} value - The value to clamp.
 * @param {number} min - The min value.
 * @param {number} max - The max value.
 * @return {number} The clamped value.
 */ function $ce0cdebec9150cb3$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Computes the Euclidean modulo of the given parameters that
 * is `( ( n % m ) + m ) % m`.
 *
 * @param {number} n - The first parameter.
 * @param {number} m - The second parameter.
 * @return {number} The Euclidean modulo.
 */ function $ce0cdebec9150cb3$var$euclideanModulo(n, m) {
    // https://en.wikipedia.org/wiki/Modulo_operation
    return (n % m + m) % m;
}
/**
 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
 * for the given value. `a2` must be greater than `a1`.
 *
 * @param {number} x - The value to be mapped.
 * @param {number} a1 - Minimum value for range A.
 * @param {number} a2 - Maximum value for range A.
 * @param {number} b1 - Minimum value for range B.
 * @param {number} b2 - Maximum value for range B.
 * @return {number} The mapped value.
 */ function $ce0cdebec9150cb3$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
/**
 * Returns the percentage in the closed interval `[0, 1]` of the given value
 * between the start and end point.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} value - A value between start and end.
 * @return {number} The interpolation factor.
 */ function $ce0cdebec9150cb3$var$inverseLerp(x, y, value) {
    // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
/**
 * Returns a value linearly interpolated from two known points based on the given interval -
 * `t = 0` will return `x` and `t = 1` will return `y`.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
 * @return {number} The interpolated value.
 */ function $ce0cdebec9150cb3$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
/**
 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
 * time to maintain frame rate independent movement. For details, see
 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
 *
 * @param {number} x - The current point.
 * @param {number} y - The target point.
 * @param {number} lambda - A higher lambda value will make the movement more sudden,
 * and a lower value will make the movement more gradual.
 * @param {number} dt - Delta time in seconds.
 * @return {number} The interpolated value.
 */ function $ce0cdebec9150cb3$var$damp(x, y, lambda, dt) {
    return $ce0cdebec9150cb3$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
/**
 * Returns a value that alternates between `0` and the given `length` parameter.
 *
 * @param {number} x - The value to pingpong.
 * @param {number} [length=1] - The positive value the function will pingpong to.
 * @return {number} The alternated value.
 */ function $ce0cdebec9150cb3$var$pingpong(x, length = 1) {
    // https://www.desmos.com/calculator/vcsjnyz7x4
    return length - Math.abs($ce0cdebec9150cb3$var$euclideanModulo(x, length * 2) - length);
}
/**
 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
 * the `min` and `max`.
 *
 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
 *
 * @param {number} x - The value to evaluate based on its position between `min` and `max`.
 * @param {number} min - The min value. Any `x` value below `min` will be `0`. `min` must be lower than `max`.
 * @param {number} max - The max value. Any `x` value above `max` will be `1`. `max` must be greater than `min`.
 * @return {number} The alternated value.
 */ function $ce0cdebec9150cb3$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
/**
 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
 * that has zero 1st and 2nd order derivatives at `x=0` and `x=1`.
 *
 * @param {number} x - The value to evaluate based on its position between `min` and `max`.
 * @param {number} min - The min value. Any `x` value below `min` will be `0`. `min` must be lower than `max`.
 * @param {number} max - The max value. Any `x` value above `max` will be `1`. `max` must be greater than `min`.
 * @return {number} The alternated value.
 */ function $ce0cdebec9150cb3$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
/**
 * Returns a random integer from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random integer.
 */ function $ce0cdebec9150cb3$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
/**
 * Returns a random float from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random float.
 */ function $ce0cdebec9150cb3$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
/**
 * Returns a random integer from `<-range/2, range/2>` interval.
 *
 * @param {number} range - Defines the value range.
 * @return {number} A random float.
 */ function $ce0cdebec9150cb3$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
/**
 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
 *
 * @param {number} [s] - The integer seed.
 * @return {number} A random float.
 */ function $ce0cdebec9150cb3$var$seededRandom(s) {
    if (s !== undefined) $ce0cdebec9150cb3$var$_seed = s;
    // Mulberry32 generator
    let t = $ce0cdebec9150cb3$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} degrees - A value in degrees.
 * @return {number} The converted value in radians.
 */ function $ce0cdebec9150cb3$var$degToRad(degrees) {
    return degrees * $ce0cdebec9150cb3$var$DEG2RAD;
}
/**
 * Converts radians to degrees.
 *
 * @param {number} radians - A value in radians.
 * @return {number} The converted value in degrees.
 */ function $ce0cdebec9150cb3$var$radToDeg(radians) {
    return radians * $ce0cdebec9150cb3$export$914076c8150813e5;
}
/**
 * Returns `true` if the given number is a power of two.
 *
 * @param {number} value - The value to check.
 * @return {boolean} Whether the given number is a power of two or not.
 */ function $ce0cdebec9150cb3$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
/**
 * Returns the smallest power of two that is greater than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for. Must be greater than `0`.
 * @return {number} The smallest power of two that is greater than or equal to the given number.
 */ function $ce0cdebec9150cb3$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Returns the largest power of two that is less than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for. Must be greater than `0`.
 * @return {number} The largest power of two that is less than or equal to the given number.
 */ function $ce0cdebec9150cb3$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
/**
 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
 * defined by the given angles and order.
 *
 * Rotations are applied to the axes in the order specified by order:
 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
 *
 * @param {Quaternion} q - The quaternion to set.
 * @param {number} a - The rotation applied to the first axis, in radians.
 * @param {number} b - The rotation applied to the second axis, in radians.
 * @param {number} c - The rotation applied to the third axis, in radians.
 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
 */ function $ce0cdebec9150cb3$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
/**
 * Denormalizes the given value according to the given typed array.
 *
 * @param {number} value - The value to denormalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The denormalize (float) value in the range `[0,1]`.
 */ function $ce0cdebec9150cb3$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * Normalizes the given value according to the given typed array.
 *
 * @param {number} value - The float value in the range `[0,1]` to normalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The normalize value.
 */ function $ce0cdebec9150cb3$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * @class
 * @classdesc A collection of math utility functions.
 * @hideconstructor
 */ const $ce0cdebec9150cb3$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $ce0cdebec9150cb3$var$DEG2RAD,
    RAD2DEG: $ce0cdebec9150cb3$export$914076c8150813e5,
    /**
	 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
	 * (universally unique identifier).
	 *
	 * @static
	 * @method
	 * @return {string} The UUID.
	 */ generateUUID: $ce0cdebec9150cb3$var$generateUUID,
    /**
	 * Clamps the given value between min and max.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to clamp.
	 * @param {number} min - The min value.
	 * @param {number} max - The max value.
	 * @return {number} The clamped value.
	 */ clamp: $ce0cdebec9150cb3$var$clamp,
    /**
	 * Computes the Euclidean modulo of the given parameters that
	 * is `( ( n % m ) + m ) % m`.
	 *
	 * @static
	 * @method
	 * @param {number} n - The first parameter.
	 * @param {number} m - The second parameter.
	 * @return {number} The Euclidean modulo.
	 */ euclideanModulo: $ce0cdebec9150cb3$var$euclideanModulo,
    /**
	 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
	 * for the given value.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to be mapped.
	 * @param {number} a1 - Minimum value for range A.
	 * @param {number} a2 - Maximum value for range A.
	 * @param {number} b1 - Minimum value for range B.
	 * @param {number} b2 - Maximum value for range B.
	 * @return {number} The mapped value.
	 */ mapLinear: $ce0cdebec9150cb3$var$mapLinear,
    /**
	 * Returns the percentage in the closed interval `[0, 1]` of the given value
	 * between the start and end point.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} value - A value between start and end.
	 * @return {number} The interpolation factor.
	 */ inverseLerp: $ce0cdebec9150cb3$var$inverseLerp,
    /**
	 * Returns a value linearly interpolated from two known points based on the given interval -
	 * `t = 0` will return `x` and `t = 1` will return `y`.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {number} The interpolated value.
	 */ lerp: $ce0cdebec9150cb3$var$lerp,
    /**
	 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
	 * time to maintain frame rate independent movement. For details, see
	 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
	 *
	 * @static
	 * @method
	 * @param {number} x - The current point.
	 * @param {number} y - The target point.
	 * @param {number} lambda - A higher lambda value will make the movement more sudden,
	 * and a lower value will make the movement more gradual.
	 * @param {number} dt - Delta time in seconds.
	 * @return {number} The interpolated value.
	 */ damp: $ce0cdebec9150cb3$var$damp,
    /**
	 * Returns a value that alternates between `0` and the given `length` parameter.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to pingpong.
	 * @param {number} [length=1] - The positive value the function will pingpong to.
	 * @return {number} The alternated value.
	 */ pingpong: $ce0cdebec9150cb3$var$pingpong,
    /**
	 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
	 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
	 * the `min` and `max`.
	 *
	 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smoothstep: $ce0cdebec9150cb3$var$smoothstep,
    /**
	 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
	 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smootherstep: $ce0cdebec9150cb3$var$smootherstep,
    /**
	 * Returns a random integer from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random integer.
	 */ randInt: $ce0cdebec9150cb3$var$randInt,
    /**
	 * Returns a random float from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random float.
	 */ randFloat: $ce0cdebec9150cb3$var$randFloat,
    /**
	 * Returns a random integer from `<-range/2, range/2>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} range - Defines the value range.
	 * @return {number} A random float.
	 */ randFloatSpread: $ce0cdebec9150cb3$var$randFloatSpread,
    /**
	 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
	 *
	 * @static
	 * @method
	 * @param {number} [s] - The integer seed.
	 * @return {number} A random float.
	 */ seededRandom: $ce0cdebec9150cb3$var$seededRandom,
    /**
	 * Converts degrees to radians.
	 *
	 * @static
	 * @method
	 * @param {number} degrees - A value in degrees.
	 * @return {number} The converted value in radians.
	 */ degToRad: $ce0cdebec9150cb3$var$degToRad,
    /**
	 * Converts radians to degrees.
	 *
	 * @static
	 * @method
	 * @param {number} radians - A value in radians.
	 * @return {number} The converted value in degrees.
	 */ radToDeg: $ce0cdebec9150cb3$var$radToDeg,
    /**
	 * Returns `true` if the given number is a power of two.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to check.
	 * @return {boolean} Whether the given number is a power of two or not.
	 */ isPowerOfTwo: $ce0cdebec9150cb3$var$isPowerOfTwo,
    /**
	 * Returns the smallest power of two that is greater than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The smallest power of two that is greater than or equal to the given number.
	 */ ceilPowerOfTwo: $ce0cdebec9150cb3$var$ceilPowerOfTwo,
    /**
	 * Returns the largest power of two that is less than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The largest power of two that is less than or equal to the given number.
	 */ floorPowerOfTwo: $ce0cdebec9150cb3$var$floorPowerOfTwo,
    /**
	 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
	 * defined by the given angles and order.
	 *
	 * Rotations are applied to the axes in the order specified by order:
	 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
	 *
	 * @static
	 * @method
	 * @param {Quaternion} q - The quaternion to set.
	 * @param {number} a - The rotation applied to the first axis, in radians.
	 * @param {number} b - The rotation applied to the second axis, in radians.
	 * @param {number} c - The rotation applied to the third axis, in radians.
	 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
	 */ setQuaternionFromProperEuler: $ce0cdebec9150cb3$var$setQuaternionFromProperEuler,
    /**
	 * Normalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The float value in the range `[0,1]` to normalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The normalize value.
	 */ normalize: $ce0cdebec9150cb3$var$normalize,
    /**
	 * Denormalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to denormalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The denormalize (float) value in the range `[0,1]`.
	 */ denormalize: $ce0cdebec9150cb3$var$denormalize
};
/**
 * Class representing a 2D vector. A 2D vector is an ordered pair of numbers
 * (labeled x and y), which can be used to represent a number of things, such as:
 *
 * - A point in 2D space (i.e. a position on a plane).
 * - A direction and length across a plane. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0)` to `(x, y)`
 * and the direction is also measured from `(0, 0)` towards `(x, y)`.
 * - Any arbitrary ordered pair of numbers.
 *
 * There are other things a 2D vector can be used to represent, such as
 * momentum vectors, complex numbers and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector2( 0, 1 );
 *
 * //no arguments; will be initialised to (0, 0)
 * const b = new THREE.Vector2( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $ce0cdebec9150cb3$export$c977b3e384af9ae1 {
    /**
	 * Constructs a new 2D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 */ constructor(x = 0, y = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $ce0cdebec9150cb3$export$c977b3e384af9ae1.prototype.isVector2 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
    }
    /**
	 * Alias for {@link Vector2#x}.
	 *
	 * @type {number}
	 */ get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    /**
	 * Alias for {@link Vector2#y}.
	 *
	 * @type {number}
	 */ get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @return {Vector2} A reference to this vector.
	 */ set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector2} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @param {number} value - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector2} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to copy.
	 * @return {Vector2} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to add.
	 * @return {Vector2} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector2} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector2} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector2} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector2} v - The vector to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector2} v - The vector to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Multiplies this vector (with an implicit 1 as the 3rd component) by
	 * the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {Vector2} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the given vector's x or y
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is less than the given vector's x or y
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the max vector's x or y
	 * value, it is replaced by the corresponding value.
	 * If this vector's x or y value is less than the min vector's x or y value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector2} min - The minimum x and y values.
	 * @param {Vector2} max - The maximum x and y values in the desired range.
	 * @return {Vector2} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $ce0cdebec9150cb3$var$clamp(this.x, min.x, max.x);
        this.y = $ce0cdebec9150cb3$var$clamp(this.y, min.y, max.y);
        return this;
    }
    /**
	 * If this vector's x or y values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x or y values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $ce0cdebec9150cb3$var$clamp(this.x, minVal, maxVal);
        this.y = $ce0cdebec9150cb3$var$clamp(this.y, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($ce0cdebec9150cb3$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector2} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x and y = -y.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the cross product with.
	 * @return {number} The result of the cross product.
	 */ cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Computes the angle in radians of this vector with respect to the positive x-axis.
	 *
	 * @return {number} The angle in radians.
	 */ angle() {
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector2} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($ce0cdebec9150cb3$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector2} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector2} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector2} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector2} v1 - The first vector.
	 * @param {Vector2} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector2} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]` and y
	 * value to be `array[ offset + 1 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector2} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector2} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    /**
	 * Rotates this vector around the given center by the given angle.
	 *
	 * @param {Vector2} center - The point around which to rotate.
	 * @param {number} angle - The angle to rotate, in radians.
	 * @return {Vector2} A reference to this vector.
	 */ rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
/**
 * Class for representing a Quaternion. Quaternions are used in three.js to represent rotations.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 *
 * Note that three.js expects Quaternions to be normalized.
 * ```js
 * const quaternion = new THREE.Quaternion();
 * quaternion.setFromAxisAngle( new THREE.Vector3( 0, 1, 0 ), Math.PI / 2 );
 *
 * const vector = new THREE.Vector3( 1, 0, 0 );
 * vector.applyQuaternion( quaternion );
 * ```
 */ class $ce0cdebec9150cb3$export$23d6a54f0bbc85a3 {
    /**
	 * Constructs a new quaternion.
	 *
	 * @param {number} [x=0] - The x value of this quaternion.
	 * @param {number} [y=0] - The y value of this quaternion.
	 * @param {number} [z=0] - The z value of this quaternion.
	 * @param {number} [w=1] - The w value of this quaternion.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    /**
	 * Interpolates between two quaternions via SLERP. This implementation assumes the
	 * quaternion data are managed in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @param {number} t - The interpolation factor. A value in the range `[0,1]` will interpolate. A value outside the range `[0,1]` will extrapolate.
	 * @see {@link Quaternion#slerp}
	 */ static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        let x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let dot = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1;
            if (dot < 0) {
                x1 = -x1;
                y1 = -y1;
                z1 = -z1;
                w1 = -w1;
                dot = -dot;
            }
            let s = 1 - t;
            if (dot < 0.9995) {
                // slerp
                const theta = Math.acos(dot);
                const sin = Math.sin(theta);
                s = Math.sin(s * theta) / sin;
                t = Math.sin(t * theta) / sin;
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
            } else {
                // for small angles, lerp then normalize
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    /**
	 * Multiplies two quaternions. This implementation assumes the quaternion data are managed
	 * in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @return {Array<number>} The destination array.
	 * @see {@link Quaternion#multiplyQuaternions}.
	 */ static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    /**
	 * The x value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The y value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The z value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * The w value of this quaternion.
	 *
	 * @type {number}
	 * @default 1
	 */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the quaternion components.
	 *
	 * @param {number} x - The x value of this quaternion.
	 * @param {number} y - The y value of this quaternion.
	 * @param {number} z - The z value of this quaternion.
	 * @param {number} w - The w value of this quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new quaternion with copied values from this instance.
	 *
	 * @return {Quaternion} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
	 * Copies the values of the given quaternion to this instance.
	 *
	 * @param {Quaternion} quaternion - The quaternion to copy.
	 * @return {Quaternion} A reference to this quaternion.
	 */ copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the rotation specified by the given
	 * Euler angles.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given axis and angle.
	 *
	 * @param {Vector3} axis - The normalized axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion to the rotation required to rotate the direction vector
	 * `vFrom` to the direction vector `vTo`.
	 *
	 * @param {Vector3} vFrom - The first (normalized) direction vector.
	 * @param {Vector3} vTo - The second (normalized) direction vector.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < 1e-8) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    /**
	 * Returns the angle between this quaternion and the given one in radians.
	 *
	 * @param {Quaternion} q - The quaternion to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(q) {
        return 2 * Math.acos(Math.abs($ce0cdebec9150cb3$var$clamp(this.dot(q), -1, 1)));
    }
    /**
	 * Rotates this quaternion by a given angular step to the given quaternion.
	 * The method ensures that the final quaternion will not overshoot `q`.
	 *
	 * @param {Quaternion} q - The target quaternion.
	 * @param {number} step - The angular step in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    /**
	 * Sets this quaternion to the identity quaternion; that is, to the
	 * quaternion that represents "no rotation".
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ identity() {
        return this.set(0, 0, 0, 1);
    }
    /**
	 * Inverts this quaternion via {@link Quaternion#conjugate}. The
	 * quaternion is assumed to have unit length.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ invert() {
        return this.conjugate();
    }
    /**
	 * Returns the rotational conjugate of this quaternion. The conjugate of a
	 * quaternion represents the same rotation in the opposite direction about
	 * the rotational axis.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Calculates the dot product of this quaternion and the given one.
	 *
	 * @param {Quaternion} v - The quaternion to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    /**
	 * Computes the squared Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector. This can be useful if you are comparing the
	 * lengths of two quaternions, as this is a slightly more efficient calculation than
	 * {@link Quaternion#length}.
	 *
	 * @return {number} The squared Euclidean length.
	 */ lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
	 * Computes the Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector.
	 *
	 * @return {number} The Euclidean length.
	 */ length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
	 * Normalizes this quaternion - that is, calculated the quaternion that performs
	 * the same rotation as this one, but has a length equal to `1`.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    /**
	 * Pre-multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    /**
	 * Multiplies the given quaternions and stores the result in this instance.
	 *
	 * @param {Quaternion} a - The first quaternion.
	 * @param {Quaternion} b - The second quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between this quaternion and the target quaternion.
	 *
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor. A value in the range `[0,1]` will interpolate. A value outside the range `[0,1]` will extrapolate.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerp(qb, t) {
        let x = qb._x, y = qb._y, z = qb._z, w = qb._w;
        let dot = this.dot(qb);
        if (dot < 0) {
            x = -x;
            y = -y;
            z = -z;
            w = -w;
            dot = -dot;
        }
        let s = 1 - t;
        if (dot < 0.9995) {
            // slerp
            const theta = Math.acos(dot);
            const sin = Math.sin(theta);
            s = Math.sin(s * theta) / sin;
            t = Math.sin(t * theta) / sin;
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this._onChangeCallback();
        } else {
            // for small angles, lerp then normalize
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this.normalize(); // normalize calls _onChangeCallback()
        }
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between the given quaternions
	 * and stores the result in this quaternion.
	 *
	 * @param {Quaternion} qa - The source quaternion.
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    /**
	 * Sets this quaternion to a uniformly random, normalized quaternion.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ random() {
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    /**
	 * Returns `true` if this quaternion is equal with the given one.
	 *
	 * @param {Quaternion} quaternion - The quaternion to test for equality.
	 * @return {boolean} Whether this quaternion is equal with the given one.
	 */ equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    /**
	 * Sets this quaternion's components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the quaternion component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this quaternion to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The quaternion components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    /**
	 * Sets the components of this quaternion from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
	 * @param {number} index - The index into the attribute.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the
	 * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
	 *
	 * @return {Array<number>} The serialized quaternion.
	 */ toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
/**
 * Class representing a 3D vector. A 3D vector is an ordered triplet of numbers
 * (labeled x, y and z), which can be used to represent a number of things, such as:
 *
 * - A point in 3D space.
 * - A direction and length in 3D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0)` to `(x, y, z)`
 * and the direction is also measured from `(0, 0, 0)` towards `(x, y, z)`.
 * - Any arbitrary ordered triplet of numbers.
 *
 * There are other things a 3D vector can be used to represent, such as
 * momentum vectors and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y, z)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector3( 0, 1, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0)
 * const b = new THREE.Vector3( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $ce0cdebec9150cb3$export$64b5c384219d3699 {
    /**
	 * Constructs a new 3D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 */ constructor(x = 0, y = 0, z = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $ce0cdebec9150cb3$export$64b5c384219d3699.prototype.isVector3 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @return {Vector3} A reference to this vector.
	 */ set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector3} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value.
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value.
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value.
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @param {number} value - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector3} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to copy.
	 * @return {Vector3} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to add.
	 * @return {Vector3} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector3} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector3} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector3} v - The vector to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    /**
	 * Multiplies the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    /**
	 * Applies the given Euler rotation to this vector.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Vector3} A reference to this vector.
	 */ applyEuler(euler) {
        return this.applyQuaternion($ce0cdebec9150cb3$var$_quaternion$5.setFromEuler(euler));
    }
    /**
	 * Applies a rotation specified by an axis and an angle to this vector.
	 *
	 * @param {Vector3} axis - A normalized vector representing the rotation axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ applyAxisAngle(axis, angle) {
        return this.applyQuaternion($ce0cdebec9150cb3$var$_quaternion$5.setFromAxisAngle(axis, angle));
    }
    /**
	 * Multiplies this vector with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    /**
	 * Multiplies this vector by the given normal matrix and normalizes
	 * the result.
	 *
	 * @param {Matrix3} m - The normal matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    /**
	 * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
	 * divides by perspective.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    /**
	 * Applies the given Quaternion to this vector.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Vector3} A reference to this vector.
	 */ applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    /**
	 * Projects this vector from world space into the camera's normalized
	 * device coordinate (NDC) space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    /**
	 * Unprojects this vector from the camera's normalized device coordinate (NDC)
	 * space into world space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    /**
	 * Transforms the direction of this vector by a matrix (the upper left 3 x 3
	 * subset of the given 4x4 matrix and then normalizes the result.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Vector3} A reference to this vector.
	 */ transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector3} v - The vector to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * If this vector's x, y or z value is greater than the given vector's x, y or z
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is less than the given vector's x, y or z
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is greater than the max vector's x, y or z
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y or z value is less than the min vector's x, y or z value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector3} min - The minimum x, y and z values.
	 * @param {Vector3} max - The maximum x, y and z values in the desired range.
	 * @return {Vector3} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $ce0cdebec9150cb3$var$clamp(this.x, min.x, max.x);
        this.y = $ce0cdebec9150cb3$var$clamp(this.y, min.y, max.y);
        this.z = $ce0cdebec9150cb3$var$clamp(this.z, min.z, max.z);
        return this;
    }
    /**
	 * If this vector's x, y or z values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y or z values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $ce0cdebec9150cb3$var$clamp(this.x, minVal, maxVal);
        this.y = $ce0cdebec9150cb3$var$clamp(this.y, minVal, maxVal);
        this.z = $ce0cdebec9150cb3$var$clamp(this.z, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($ce0cdebec9150cb3$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector3} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector3} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector3} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector3} v1 - The first vector.
	 * @param {Vector3} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the cross product with.
	 * @return {Vector3} The result of the cross product.
	 */ cross(v) {
        return this.crossVectors(this, v);
    }
    /**
	 * Calculates the cross product of the given vectors and stores the result
	 * in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    /**
	 * Projects this vector onto the given one.
	 *
	 * @param {Vector3} v - The vector to project to.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    /**
	 * Projects this vector onto a plane by subtracting this
	 * vector projected onto the plane's normal from this vector.
	 *
	 * @param {Vector3} planeNormal - The plane normal.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnPlane(planeNormal) {
        $ce0cdebec9150cb3$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($ce0cdebec9150cb3$var$_vector$c);
    }
    /**
	 * Reflects this vector off a plane orthogonal to the given normal vector.
	 *
	 * @param {Vector3} normal - The (normalized) normal vector.
	 * @return {Vector3} A reference to this vector.
	 */ reflect(normal) {
        return this.sub($ce0cdebec9150cb3$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector3} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($ce0cdebec9150cb3$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector3} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {Spherical} s - The spherical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The phi angle in radians.
	 * @param {number} theta - The theta angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {Cylindrical} c - The cylindrical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle in radians.
	 * @param {number} y - The y value.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    /**
	 * Sets the vector components to the scale elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    /**
	 * Sets the vector components from the given Euler angles.
	 *
	 * @param {Euler} e - The Euler angles to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    /**
	 * Sets the vector components from the RGB components of the
	 * given color.
	 *
	 * @param {Color} c - The color to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector3} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
	 * and z value to be `array[ offset + 2 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector3} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector3} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    /**
	 * Sets this vector to a uniformly random point on a unit sphere.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $ce0cdebec9150cb3$var$_vector$c = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_quaternion$5 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3();
/**
 * Represents a 3x3 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix();
 * m.set( 11, 12, 13,
 *        21, 22, 23,
 *        31, 32, 33 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31,
 *                12, 22, 32,
 *                13, 23, 33 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $ce0cdebec9150cb3$export$8ff26dafa08918 {
    /**
	 * Constructs a new 3x3 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 */ constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $ce0cdebec9150cb3$export$8ff26dafa08918.prototype.isMatrix3 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @return {Matrix3} A reference to this matrix.
	 */ set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    /**
	 * Sets this matrix to the 3x3 identity matrix.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix3} m - The matrix to copy.
	 * @return {Matrix3} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    /**
	 * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 3x3 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix3} a - The first matrix.
	 * @param {Matrix3} b - The second matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    /**
	 * Computes the normal matrix which is the inverse transpose of the upper
	 * left 3x3 portion of the given 4x4 matrix.
	 *
	 * @param {Matrix4} matrix4 - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    /**
	 * Transposes this matrix into the supplied array, and returns itself unchanged.
	 *
	 * @param {Array<number>} r - An array to store the transposed matrix elements.
	 * @return {Matrix3} A reference to this matrix.
	 */ transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    /**
	 * Sets the UV transform matrix from offset, repeat, rotation, and center.
	 *
	 * @param {number} tx - Offset x.
	 * @param {number} ty - Offset y.
	 * @param {number} sx - Repeat x.
	 * @param {number} sy - Repeat y.
	 * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
	 * @param {number} cx - Center x of rotation.
	 * @param {number} cy - Center y of rotation
	 * @return {Matrix3} A reference to this matrix.
	 */ setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    /**
	 * Scales this matrix with the given scalar values.
	 *
	 * @param {number} sx - The amount to scale in the X axis.
	 * @param {number} sy - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ scale(sx, sy) {
        this.premultiply($ce0cdebec9150cb3$var$_m3.makeScale(sx, sy));
        return this;
    }
    /**
	 * Rotates this matrix by the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ rotate(theta) {
        this.premultiply($ce0cdebec9150cb3$var$_m3.makeRotation(-theta));
        return this;
    }
    /**
	 * Translates this matrix by the given scalar values.
	 *
	 * @param {number} tx - The amount to translate in the X axis.
	 * @param {number} ty - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ translate(tx, ty) {
        this.premultiply($ce0cdebec9150cb3$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    /**
	 * Sets this matrix as a 2D translation transform.
	 *
	 * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D rotational transformation.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D scale transform.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix3} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix3} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix3} A clone of this instance.
	 */ clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $ce0cdebec9150cb3$var$_m3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$8ff26dafa08918();
const $ce0cdebec9150cb3$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $ce0cdebec9150cb3$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $ce0cdebec9150cb3$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $ce0cdebec9150cb3$var$createColorManagement() {
    const ColorManagement = {
        enabled: true,
        workingColorSpace: $ce0cdebec9150cb3$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $ce0cdebec9150cb3$export$8d0a61916cc26abb) {
                color.r = $ce0cdebec9150cb3$var$SRGBToLinear(color.r);
                color.g = $ce0cdebec9150cb3$var$SRGBToLinear(color.g);
                color.b = $ce0cdebec9150cb3$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $ce0cdebec9150cb3$export$8d0a61916cc26abb) {
                color.r = $ce0cdebec9150cb3$var$LinearToSRGB(color.r);
                color.g = $ce0cdebec9150cb3$var$LinearToSRGB(color.g);
                color.b = $ce0cdebec9150cb3$var$LinearToSRGB(color.b);
            }
            return color;
        },
        workingToColorSpace: function(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        colorSpaceToWorking: function(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function(colorSpace) {
            if (colorSpace === $ce0cdebec9150cb3$export$bfcb490c2dd3db51) return $ce0cdebec9150cb3$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getToneMappingMode: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.toneMappingMode || 'standard';
        },
        getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        },
        // Deprecated
        fromWorkingColorSpace: function(color, targetColorSpace) {
            $ce0cdebec9150cb3$export$5b28268982f175ba('ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().'); // @deprecated, r177
            return ColorManagement.workingToColorSpace(color, targetColorSpace);
        },
        toWorkingColorSpace: function(color, sourceColorSpace) {
            $ce0cdebec9150cb3$export$5b28268982f175ba('ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().'); // @deprecated, r177
            return ColorManagement.colorSpaceToWorking(color, sourceColorSpace);
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ const REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    const REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    const D65 = [
        0.3127,
        0.3290
    ];
    ColorManagement.define({
        [$ce0cdebec9150cb3$export$42429b3acfb233a4]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $ce0cdebec9150cb3$export$f197347d588c1b4a,
            toXYZ: $ce0cdebec9150cb3$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $ce0cdebec9150cb3$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            workingColorSpaceConfig: {
                unpackColorSpace: $ce0cdebec9150cb3$export$561f394b24edfcaa
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $ce0cdebec9150cb3$export$561f394b24edfcaa
            }
        },
        [$ce0cdebec9150cb3$export$561f394b24edfcaa]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $ce0cdebec9150cb3$export$8d0a61916cc26abb,
            toXYZ: $ce0cdebec9150cb3$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $ce0cdebec9150cb3$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $ce0cdebec9150cb3$export$561f394b24edfcaa
            }
        }
    });
    return ColorManagement;
}
const $ce0cdebec9150cb3$export$5e6fd513f44698c = /*@__PURE__*/ $ce0cdebec9150cb3$var$createColorManagement();
function $ce0cdebec9150cb3$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $ce0cdebec9150cb3$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $ce0cdebec9150cb3$var$_canvas;
/**
 * A class containing utility functions for images.
 *
 * @hideconstructor
 */ class $ce0cdebec9150cb3$export$698882cf06df44aa {
    /**
	 * Returns a data URI containing a representation of the given image.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
	 * @param {string} [type='image/png'] - Indicates the image format.
	 * @return {string} The data URI.
	 */ static getDataURL(image, type = 'image/png') {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($ce0cdebec9150cb3$var$_canvas === undefined) $ce0cdebec9150cb3$var$_canvas = $ce0cdebec9150cb3$export$7094a064528c7fee('canvas');
            $ce0cdebec9150cb3$var$_canvas.width = image.width;
            $ce0cdebec9150cb3$var$_canvas.height = image.height;
            const context = $ce0cdebec9150cb3$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $ce0cdebec9150cb3$var$_canvas;
        }
        return canvas.toDataURL(type);
    }
    /**
	 * Converts the given sRGB image data to linear color space.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
	 * @return {HTMLCanvasElement|Object} The converted image.
	 */ static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $ce0cdebec9150cb3$export$7094a064528c7fee('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $ce0cdebec9150cb3$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($ce0cdebec9150cb3$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $ce0cdebec9150cb3$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $ce0cdebec9150cb3$var$_sourceId = 0;
/**
 * Represents the data source of a texture.
 *
 * The main purpose of this class is to decouple the data definition from the texture
 * definition so the same data can be used with multiple texture instances.
 */ class $ce0cdebec9150cb3$export$1d2df86270c81ecb {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {any} [data=null] - The data definition of a texture.
	 */ constructor(data = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSource = true;
        /**
		 * The ID of the source.
		 *
		 * @name Source#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $ce0cdebec9150cb3$var$_sourceId++
        });
        /**
		 * The UUID of the source.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $ce0cdebec9150cb3$var$generateUUID();
        /**
		 * The data definition of a texture.
		 *
		 * @type {any}
		 */ this.data = data;
        /**
		 * This property is only relevant when {@link Source#needsUpdate} is set to `true` and
		 * provides more control on how texture data should be processed. When `dataReady` is set
		 * to `false`, the engine performs the memory allocation (if necessary) but does not transfer
		 * the data into the GPU memory.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.dataReady = true;
        /**
		 * This starts at `0` and counts how many times {@link Source#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
    /**
	 * Returns the dimensions of the source into the given target vector.
	 *
	 * @param {(Vector2|Vector3)} target - The target object the result is written into.
	 * @return {(Vector2|Vector3)} The dimensions of the source.
	 */ getSize(target) {
        const data = this.data;
        if (typeof HTMLVideoElement !== 'undefined' && data instanceof HTMLVideoElement) target.set(data.videoWidth, data.videoHeight, 0);
        else if (typeof VideoFrame !== 'undefined' && data instanceof VideoFrame) target.set(data.displayHeight, data.displayWidth, 0);
        else if (data !== null) target.set(data.width, data.height, data.depth || 0);
        else target.set(0, 0, 0);
        return target;
    }
    /**
	 * When the property is set to `true`, the engine allocates the memory
	 * for the texture (if necessary) and triggers the actual texture upload
	 * to the GPU next time the source is used.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Serializes the source into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized source.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($ce0cdebec9150cb3$var$serializeImage(data[i].image));
                else url.push($ce0cdebec9150cb3$var$serializeImage(data[i]));
            } else // texture
            url = $ce0cdebec9150cb3$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $ce0cdebec9150cb3$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $ce0cdebec9150cb3$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $ce0cdebec9150cb3$var$_textureId = 0;
const $ce0cdebec9150cb3$var$_tempVec3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * Base class for all textures.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments EventDispatcher
 */ class $ce0cdebec9150cb3$export$5431306cf43de24a extends $ce0cdebec9150cb3$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(image = $ce0cdebec9150cb3$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $ce0cdebec9150cb3$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $ce0cdebec9150cb3$export$9d9334239a5a5e06, wrapT = $ce0cdebec9150cb3$export$9d9334239a5a5e06, magFilter = $ce0cdebec9150cb3$export$8a72f490b25c56c8, minFilter = $ce0cdebec9150cb3$export$5d8599b6a933fb1b, format = $ce0cdebec9150cb3$export$3f8bb04b555a363c, type = $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10, anisotropy = $ce0cdebec9150cb3$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = $ce0cdebec9150cb3$export$bfcb490c2dd3db51){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture = true;
        /**
		 * The ID of the texture.
		 *
		 * @name Texture#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $ce0cdebec9150cb3$var$_textureId++
        });
        /**
		 * The UUID of the texture.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $ce0cdebec9150cb3$var$generateUUID();
        /**
		 * The name of the texture.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The data definition of a texture. A reference to the data source can be
		 * shared across textures. This is often useful in context of spritesheets
		 * where multiple textures render the same data but with different texture
		 * transformations.
		 *
		 * @type {Source}
		 */ this.source = new $ce0cdebec9150cb3$export$1d2df86270c81ecb(image);
        /**
		 * An array holding user-defined mipmaps.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = [];
        /**
		 * How the texture is applied to the object. The value `UVMapping`
		 * is the default, where texture or uv coordinates are used to apply the map.
		 *
		 * @type {(UVMapping|CubeReflectionMapping|CubeRefractionMapping|EquirectangularReflectionMapping|EquirectangularRefractionMapping|CubeUVReflectionMapping)}
		 * @default UVMapping
		*/ this.mapping = mapping;
        /**
		 * Lets you select the uv attribute to map the texture to. `0` for `uv`,
		 * `1` for `uv1`, `2` for `uv2` and `3` for `uv3`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.channel = 0;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *U* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapS = wrapS;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *V* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapT = wrapT;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearFilter
		 */ this.magFilter = magFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearMipmapLinearFilter
		 */ this.minFilter = minFilter;
        /**
		 * The number of samples taken along the axis through the pixel that has the
		 * highest density of texels. By default, this value is `1`. A higher value
		 * gives a less blurry result than a basic mipmap, at the cost of more
		 * texture samples being used.
		 *
		 * @type {number}
		 * @default Texture.DEFAULT_ANISOTROPY
		 */ this.anisotropy = anisotropy;
        /**
		 * The format of the texture.
		 *
		 * @type {number}
		 * @default RGBAFormat
		 */ this.format = format;
        /**
		 * The default internal format is derived from {@link Texture#format} and {@link Texture#type} and
		 * defines how the texture data is going to be stored on the GPU.
		 *
		 * This property allows to overwrite the default format.
		 *
		 * @type {?string}
		 * @default null
		 */ this.internalFormat = null;
        /**
		 * The data type of the texture.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.type = type;
        /**
		 * How much a single repetition of the texture is offset from the beginning,
		 * in each direction U and V. Typical range is `0.0` to `1.0`.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.offset = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0, 0);
        /**
		 * How many times the texture is repeated across the surface, in each
		 * direction U and V. If repeat is set greater than `1` in either direction,
		 * the corresponding wrap parameter should also be set to `RepeatWrapping`
		 * or `MirroredRepeatWrapping` to achieve the desired tiling effect.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.repeat = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1);
        /**
		 * The point around which rotation occurs. A value of `(0.5, 0.5)` corresponds
		 * to the center of the texture. Default is `(0, 0)`, the lower left.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.center = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0, 0);
        /**
		 * How much the texture is rotated around the center point, in radians.
		 * Positive values are counter-clockwise.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Whether to update the texture's uv-transformation {@link Texture#matrix}
		 * from the properties {@link Texture#offset}, {@link Texture#repeat},
		 * {@link Texture#rotation}, and {@link Texture#center}.
		 *
		 * Set this to `false` if you are specifying the uv-transform matrix directly.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = true;
        /**
		 * The uv-transformation matrix of the texture.
		 *
		 * @type {Matrix3}
		 */ this.matrix = new $ce0cdebec9150cb3$export$8ff26dafa08918();
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Set this to `false` if you are creating mipmaps manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.generateMipmaps = true;
        /**
		 * If set to `true`, the alpha channel, if present, is multiplied into the
		 * color channels when the texture is uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure premultiply alpha on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultiplyAlpha = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure the flip on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.flipY = true;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 * The allowable values are `1` (byte-alignment), `2` (rows aligned to even-numbered bytes),
		 * `4` (word-alignment), and `8` (rows start on double-word boundaries).
		 *
		 * @type {number}
		 * @default 4
		 */ this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        /**
		 * Textures containing color data should be annotated with `SRGBColorSpace` or `LinearSRGBColorSpace`.
		 *
		 * @type {string}
		 * @default NoColorSpace
		 */ this.colorSpace = colorSpace;
        /**
		 * An object that can be used to store custom data about the texture. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This can be used to only update a subregion or specific rows of the texture (for example, just the
		 * first 3 rows). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * This starts at `0` and counts how many times {@link Texture#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * A callback function, called when the texture is updated (e.g., when
		 * {@link Texture#needsUpdate} has been set to true and then the texture is used).
		 *
		 * @type {?Function}
		 * @default null
		 */ this.onUpdate = null;
        /**
		 * An optional back reference to the textures render target.
		 *
		 * @type {?(RenderTarget|WebGLRenderTarget)}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * Indicates whether a texture belongs to a render target or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isRenderTargetTexture = false;
        /**
		 * Indicates if a texture should be handled like a texture array.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isArrayTexture = image && image.depth && image.depth > 1 ? true : false;
        /**
		 * Indicates whether this texture should be processed by `PMREMGenerator` or not
		 * (only relevant for render target textures).
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.pmremVersion = 0;
    }
    /**
	 * The width of the texture in pixels.
	 */ get width() {
        return this.source.getSize($ce0cdebec9150cb3$var$_tempVec3).x;
    }
    /**
	 * The height of the texture in pixels.
	 */ get height() {
        return this.source.getSize($ce0cdebec9150cb3$var$_tempVec3).y;
    }
    /**
	 * The depth of the texture in pixels.
	 */ get depth() {
        return this.source.getSize($ce0cdebec9150cb3$var$_tempVec3).z;
    }
    /**
	 * The image object holding the texture data.
	 *
	 * @type {?Object}
	 */ get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    /**
	 * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
	 * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
	 */ updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
	 * Adds a range of data in the data texture to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Returns a new texture with copied values from this instance.
	 *
	 * @return {Texture} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given texture to this instance.
	 *
	 * @param {Texture} source - The texture to copy.
	 * @return {Texture} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.isArrayTexture = source.isArrayTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    /**
	 * Sets this texture's properties based on `values`.
	 * @param {Object} values - A container with texture parameters.
	 */ setValues(values) {
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                $ce0cdebec9150cb3$export$c106dd0671a0fc2d(`Texture.setValues(): parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                $ce0cdebec9150cb3$export$c106dd0671a0fc2d(`Texture.setValues(): property '${key}' does not exist.`);
                continue;
            }
            if (currentValue && newValue && currentValue.isVector2 && newValue.isVector2) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isVector3 && newValue.isVector3) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isMatrix3 && newValue.isMatrix3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the texture into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized texture.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.7,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        /**
		 * Fires when the texture has been disposed of.
		 *
		 * @event Texture#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Transforms the given uv vector with the textures uv transformation matrix.
	 *
	 * @param {Vector2} uv - The uv vector.
	 * @return {Vector2} The transformed uv vector.
	 */ transformUv(uv) {
        if (this.mapping !== $ce0cdebec9150cb3$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $ce0cdebec9150cb3$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $ce0cdebec9150cb3$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $ce0cdebec9150cb3$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $ce0cdebec9150cb3$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $ce0cdebec9150cb3$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $ce0cdebec9150cb3$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    /**
	 * Setting this property to `true` indicates the engine the texture
	 * must be updated in the next render. This triggers a texture upload
	 * to the GPU and ensures correct texture parameter configuration.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    /**
	 * Setting this property to `true` indicates the engine the PMREM
	 * must be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
/**
 * The default image for all textures.
 *
 * @static
 * @type {?Image}
 * @default null
 */ $ce0cdebec9150cb3$export$5431306cf43de24a.DEFAULT_IMAGE = null;
/**
 * The default mapping for all textures.
 *
 * @static
 * @type {number}
 * @default UVMapping
 */ $ce0cdebec9150cb3$export$5431306cf43de24a.DEFAULT_MAPPING = $ce0cdebec9150cb3$export$1beec6768cbb3d2d;
/**
 * The default anisotropy value for all textures.
 *
 * @static
 * @type {number}
 * @default 1
 */ $ce0cdebec9150cb3$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
/**
 * Class representing a 4D vector. A 4D vector is an ordered quadruplet of numbers
 * (labeled x, y, z and w), which can be used to represent a number of things, such as:
 *
 * - A point in 4D space.
 * - A direction and length in 4D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0, 0)` to `(x, y, z, w)`
 * and the direction is also measured from `(0, 0, 0, 0)` towards `(x, y, z, w)`.
 * - Any arbitrary ordered quadruplet of numbers.
 *
 * There are other things a 4D vector can be used to represent, however these
 * are the most common uses in *three.js*.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector4( 0, 1, 0, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0, 1)
 * const b = new THREE.Vector4( );
 *
 * const d = a.dot( b );
 * ```
 */ class $ce0cdebec9150cb3$export$fa7daccca11cdbe3 {
    /**
	 * Constructs a new 4D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 * @param {number} [w=1] - The w value of this vector.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $ce0cdebec9150cb3$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
        /**
		 * The w value of this vector.
		 *
		 * @type {number}
		 */ this.w = w;
    }
    /**
	 * Alias for {@link Vector4#z}.
	 *
	 * @type {number}
	 */ get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    /**
	 * Alias for {@link Vector4#w}.
	 *
	 * @type {number}
	 */ get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @param {number} w - The value of the w component.
	 * @return {Vector4} A reference to this vector.
	 */ set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector4} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector's w component to the given value
	 *
	 * @param {number} w - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setW(w) {
        this.w = w;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @param {number} value - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector4} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector to copy.
	 * @return {Vector4} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector4} v - The vector to add.
	 * @return {Vector4} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector4} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector4} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector4} v - The vector to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    /**
	 * Multiplies this vector with the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector4} v - The vector to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the quaternion's axis and w to the angle.
	 *
	 * @param {Quaternion} q - The Quaternion to set.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the axis of rotation and w to the angle.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector4} min - The minimum x, y and z values.
	 * @param {Vector4} max - The maximum x, y and z values in the desired range.
	 * @return {Vector4} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $ce0cdebec9150cb3$var$clamp(this.x, min.x, max.x);
        this.y = $ce0cdebec9150cb3$var$clamp(this.y, min.y, max.y);
        this.z = $ce0cdebec9150cb3$var$clamp(this.z, min.z, max.z);
        this.w = $ce0cdebec9150cb3$var$clamp(this.w, min.w, max.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y, z or w values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $ce0cdebec9150cb3$var$clamp(this.x, minVal, maxVal);
        this.y = $ce0cdebec9150cb3$var$clamp(this.y, minVal, maxVal);
        this.z = $ce0cdebec9150cb3$var$clamp(this.z, minVal, maxVal);
        this.w = $ce0cdebec9150cb3$var$clamp(this.w, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($ce0cdebec9150cb3$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector4} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector4} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector4} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector4} v1 - The first vector.
	 * @param {Vector4} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector4} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
	 * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector4} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector4} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/**
 * A render target is a buffer where the video card draws pixels for a scene
 * that is being rendered in the background. It is used in different effects,
 * such as applying postprocessing to a rendered image before displaying it
 * on the screen.
 *
 * @augments EventDispatcher
 */ class $ce0cdebec9150cb3$export$efcb1f8bf367cbfb extends $ce0cdebec9150cb3$export$ec8b666c5fe2c75a {
    /**
	 * Render target options.
	 *
	 * @typedef {Object} RenderTarget~Options
	 * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
	 * @property {number} [magFilter=LinearFilter] - The mag filter.
	 * @property {number} [minFilter=LinearFilter] - The min filter.
	 * @property {number} [format=RGBAFormat] - The texture format.
	 * @property {number} [type=UnsignedByteType] - The texture type.
	 * @property {?string} [internalFormat=null] - The texture's internal format.
	 * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [anisotropy=1] - The texture's anisotropy value.
	 * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
	 * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
	 * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
	 * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
	 * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
	 * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
	 * @property {number} [samples=0] - The MSAA samples count.
	 * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
	 * @property {number} [depth=1] - The texture depth.
	 * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
	 */ /**
	 * Constructs a new render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super();
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $ce0cdebec9150cb3$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: false
        }, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget = true;
        /**
		 * The width of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.width = width;
        /**
		 * The height of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.height = height;
        /**
		 * The depth of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.depth = options.depth;
        /**
		 * A rectangular area inside the render target's viewport. Fragments that are
		 * outside the area will be discarded.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.scissor = new $ce0cdebec9150cb3$export$fa7daccca11cdbe3(0, 0, width, height);
        /**
		 * Indicates whether the scissor test should be enabled when rendering into
		 * this render target or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.scissorTest = false;
        /**
		 * A rectangular area representing the render target's viewport.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.viewport = new $ce0cdebec9150cb3$export$fa7daccca11cdbe3(0, 0, width, height);
        /**
		 * An array of textures. Each color attachment is represented as a separate texture.
		 * Has at least a single entry for the default color attachment.
		 *
		 * @type {Array<Texture>}
		 */ this.textures = [];
        const image = {
            width: width,
            height: height,
            depth: options.depth
        };
        const texture = new $ce0cdebec9150cb3$export$5431306cf43de24a(image);
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        this._setTextureOptions(options);
        /**
		 * Whether to allocate a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthBuffer = options.depthBuffer;
        /**
		 * Whether to allocate a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilBuffer = options.stencilBuffer;
        /**
		 * Whether to resolve the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveDepthBuffer = options.resolveDepthBuffer;
        /**
		 * Whether to resolve the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = null;
        this.depthTexture = options.depthTexture;
        /**
		 * The number of MSAA samples.
		 *
		 * A value of `0` disables MSAA.
		 *
		 * @type {number}
		 * @default 0
		 */ this.samples = options.samples;
        /**
		 * Whether to this target is used in multiview rendering.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.multiview = options.multiview;
    }
    _setTextureOptions(options = {}) {
        const values = {
            minFilter: $ce0cdebec9150cb3$export$8a72f490b25c56c8,
            generateMipmaps: false,
            flipY: false,
            internalFormat: null
        };
        if (options.mapping !== undefined) values.mapping = options.mapping;
        if (options.wrapS !== undefined) values.wrapS = options.wrapS;
        if (options.wrapT !== undefined) values.wrapT = options.wrapT;
        if (options.wrapR !== undefined) values.wrapR = options.wrapR;
        if (options.magFilter !== undefined) values.magFilter = options.magFilter;
        if (options.minFilter !== undefined) values.minFilter = options.minFilter;
        if (options.format !== undefined) values.format = options.format;
        if (options.type !== undefined) values.type = options.type;
        if (options.anisotropy !== undefined) values.anisotropy = options.anisotropy;
        if (options.colorSpace !== undefined) values.colorSpace = options.colorSpace;
        if (options.flipY !== undefined) values.flipY = options.flipY;
        if (options.generateMipmaps !== undefined) values.generateMipmaps = options.generateMipmaps;
        if (options.internalFormat !== undefined) values.internalFormat = options.internalFormat;
        for(let i = 0; i < this.textures.length; i++){
            const texture = this.textures[i];
            texture.setValues(values);
        }
    }
    /**
	 * The texture representing the default color attachment.
	 *
	 * @type {Texture}
	 */ get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
    }
    /**
	 * Instead of saving the depth in a renderbuffer, a texture
	 * can be used instead which is useful for further processing
	 * e.g. in context of post-processing.
	 *
	 * @type {?DepthTexture}
	 * @default null
	 */ get depthTexture() {
        return this._depthTexture;
    }
    /**
	 * Sets the size of this render target.
	 *
	 * @param {number} width - The width.
	 * @param {number} height - The height.
	 * @param {number} [depth=1] - The depth.
	 */ setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
                if (this.textures[i].isData3DTexture !== true) // TODO: Reconsider setting isArrayTexture flag here and in the ctor of Texture.
                // Maybe a method `isArrayTexture()` or just a getter could replace a flag since
                // both are evaluated on each call?
                this.textures[i].isArrayTexture = this.textures[i].image.depth > 1;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    /**
	 * Returns a new render target with copied values from this instance.
	 *
	 * @return {RenderTarget} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the settings of the given render target. This is a structural copy so
	 * no resources are shared between render targets after the copy. That includes
	 * all MRT textures and the depth texture.
	 *
	 * @param {RenderTarget} source - The render target to copy.
	 * @return {RenderTarget} A reference to this instance.
	 */ copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
            // ensure image object is not shared, see #20328
            const image = Object.assign({}, source.textures[i].image);
            this.textures[i].source = new $ce0cdebec9150cb3$export$1d2df86270c81ecb(image);
        }
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * A render target used in context of {@link WebGLRenderer}.
 *
 * @augments RenderTarget
 */ class $ce0cdebec9150cb3$export$3c052beb2e51e23f extends $ce0cdebec9150cb3$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderTarget = true;
    }
}
/**
 * Creates an array of textures directly from raw buffer data.
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$dfac6c8e811406a3 extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataArrayTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $ce0cdebec9150cb3$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire data texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * An array render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $ce0cdebec9150cb3$export$c77a02c11ed180c7 extends $ce0cdebec9150cb3$export$3c052beb2e51e23f {
    /**
	 * Constructs a new array render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $ce0cdebec9150cb3$export$dfac6c8e811406a3(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Creates a three-dimensional texture from raw data, with parameters to
 * divide it into width, height, and depth.
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$d7a3086320f856db extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isData3DTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $ce0cdebec9150cb3$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
/**
 * A 3D render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $ce0cdebec9150cb3$export$7ee06591009639df extends $ce0cdebec9150cb3$export$3c052beb2e51e23f {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $ce0cdebec9150cb3$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents a 4x4 matrix.
 *
 * The most common use of a 4x4 matrix in 3D computer graphics is as a transformation matrix.
 * For an introduction to transformation matrices as used in WebGL, check out [this tutorial](https://www.opengl-tutorial.org/beginners-tutorials/tutorial-3-matrices)
 *
 * This allows a 3D vector representing a point in 3D space to undergo
 * transformations such as translation, rotation, shear, scale, reflection,
 * orthogonal or perspective projection and so on, by being multiplied by the
 * matrix. This is known as `applying` the matrix to the vector.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix4();
 * m.set( 11, 12, 13, 14,
 *        21, 22, 23, 24,
 *        31, 32, 33, 34,
 *        41, 42, 43, 44 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31, 41,
 *                12, 22, 32, 42,
 *                13, 23, 33, 43,
 *                14, 24, 34, 44 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $ce0cdebec9150cb3$export$2ae72fc923e5eb5 {
    /**
	 * Constructs a new 4x4 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 */ constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $ce0cdebec9150cb3$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 * @return {Matrix4} A reference to this matrix.
	 */ set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    /**
	 * Sets this matrix to the 4x4 identity matrix.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix4} A clone of this instance.
	 */ clone() {
        return new $ce0cdebec9150cb3$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix4} m - The matrix to copy.
	 * @return {Matrix4} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    /**
	 * Copies the translation component of the given matrix
	 * into this matrix's translation component.
	 *
	 * @param {Matrix4} m - The matrix to copy the translation component.
	 * @return {Matrix4} A reference to this matrix.
	 */ copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    /**
	 * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        if (this.determinant() === 0) {
            xAxis.set(1, 0, 0);
            yAxis.set(0, 1, 0);
            zAxis.set(0, 0, 1);
            return this;
        }
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    /**
	 * Sets the given basis vectors to this matrix.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the rotation component of the given matrix
	 * into this matrix's rotation component.
	 *
	 * Note: This method does not support reflection matrices.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractRotation(m) {
        if (m.determinant() === 0) return this.identity();
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $ce0cdebec9150cb3$var$_v1$7.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $ce0cdebec9150cb3$var$_v1$7.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $ce0cdebec9150cb3$var$_v1$7.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
	 * the rotation specified by the given Euler angles. The rest of
	 * the matrix is set to the identity. Depending on the {@link Euler#order},
	 * there are six possible outcomes. See [this page](https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix)
	 * for a complete list.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component of this matrix to the rotation specified by
	 * the given Quaternion as outlined [here](https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion)
	 * The rest of the matrix is set to the identity.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromQuaternion(q) {
        return this.compose($ce0cdebec9150cb3$var$_zero, q, $ce0cdebec9150cb3$var$_one);
    }
    /**
	 * Sets the rotation component of the transformation matrix, looking from `eye` towards
	 * `target`, and oriented by the up-direction.
	 *
	 * @param {Vector3} eye - The eye vector.
	 * @param {Vector3} target - The target vector.
	 * @param {Vector3} up - The up vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ lookAt(eye, target, up) {
        const te = this.elements;
        $ce0cdebec9150cb3$var$_z.subVectors(eye, target);
        if ($ce0cdebec9150cb3$var$_z.lengthSq() === 0) // eye and target are in the same position
        $ce0cdebec9150cb3$var$_z.z = 1;
        $ce0cdebec9150cb3$var$_z.normalize();
        $ce0cdebec9150cb3$var$_x.crossVectors(up, $ce0cdebec9150cb3$var$_z);
        if ($ce0cdebec9150cb3$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $ce0cdebec9150cb3$var$_z.x += 0.0001;
            else $ce0cdebec9150cb3$var$_z.z += 0.0001;
            $ce0cdebec9150cb3$var$_z.normalize();
            $ce0cdebec9150cb3$var$_x.crossVectors(up, $ce0cdebec9150cb3$var$_z);
        }
        $ce0cdebec9150cb3$var$_x.normalize();
        $ce0cdebec9150cb3$var$_y.crossVectors($ce0cdebec9150cb3$var$_z, $ce0cdebec9150cb3$var$_x);
        te[0] = $ce0cdebec9150cb3$var$_x.x;
        te[4] = $ce0cdebec9150cb3$var$_y.x;
        te[8] = $ce0cdebec9150cb3$var$_z.x;
        te[1] = $ce0cdebec9150cb3$var$_x.y;
        te[5] = $ce0cdebec9150cb3$var$_y.y;
        te[9] = $ce0cdebec9150cb3$var$_z.y;
        te[2] = $ce0cdebec9150cb3$var$_x.z;
        te[6] = $ce0cdebec9150cb3$var$_y.z;
        te[10] = $ce0cdebec9150cb3$var$_z.z;
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 4x4 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix4} a - The first matrix.
	 * @param {Matrix4} b - The second matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * Based on the method outlined [here](http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html).
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        const t11 = n23 * n34 - n24 * n33;
        const t12 = n22 * n34 - n24 * n32;
        const t13 = n22 * n33 - n23 * n32;
        const t21 = n21 * n34 - n24 * n31;
        const t22 = n21 * n33 - n23 * n31;
        const t23 = n21 * n32 - n22 * n31;
        return n11 * (n42 * t11 - n43 * t12 + n44 * t13) - n12 * (n41 * t11 - n43 * t21 + n44 * t22) + n13 * (n41 * t12 - n42 * t21 + n44 * t23) - n14 * (n41 * t13 - n42 * t22 + n43 * t23);
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    /**
	 * Sets the position component for this matrix from the given vector,
	 * without affecting the rest of the matrix.
	 *
	 * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
	 * @param {number} y - The y component of the vector.
	 * @param {number} z - The z component of the vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ invert() {
        // based on https://github.com/toji/gl-matrix
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t1 = n11 * n22 - n21 * n12, t2 = n11 * n32 - n31 * n12, t3 = n11 * n42 - n41 * n12, t4 = n21 * n32 - n31 * n22, t5 = n21 * n42 - n41 * n22, t6 = n31 * n42 - n41 * n32, t7 = n13 * n24 - n23 * n14, t8 = n13 * n34 - n33 * n14, t9 = n13 * n44 - n43 * n14, t10 = n23 * n34 - n33 * n24, t11 = n23 * n44 - n43 * n24, t12 = n33 * n44 - n43 * n34;
        const det = t1 * t12 - t2 * t11 + t3 * t10 + t4 * t9 - t5 * t8 + t6 * t7;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = (n22 * t12 - n32 * t11 + n42 * t10) * detInv;
        te[1] = (n31 * t11 - n21 * t12 - n41 * t10) * detInv;
        te[2] = (n24 * t6 - n34 * t5 + n44 * t4) * detInv;
        te[3] = (n33 * t5 - n23 * t6 - n43 * t4) * detInv;
        te[4] = (n32 * t9 - n12 * t12 - n42 * t8) * detInv;
        te[5] = (n11 * t12 - n31 * t9 + n41 * t8) * detInv;
        te[6] = (n34 * t3 - n14 * t6 - n44 * t2) * detInv;
        te[7] = (n13 * t6 - n33 * t3 + n43 * t2) * detInv;
        te[8] = (n12 * t11 - n22 * t9 + n42 * t7) * detInv;
        te[9] = (n21 * t9 - n11 * t11 - n41 * t7) * detInv;
        te[10] = (n14 * t5 - n24 * t3 + n44 * t1) * detInv;
        te[11] = (n23 * t3 - n13 * t5 - n43 * t1) * detInv;
        te[12] = (n22 * t8 - n12 * t10 - n32 * t7) * detInv;
        te[13] = (n11 * t10 - n21 * t8 + n31 * t7) * detInv;
        te[14] = (n24 * t2 - n14 * t4 - n34 * t1) * detInv;
        te[15] = (n13 * t4 - n23 * t2 + n33 * t1) * detInv;
        return this;
    }
    /**
	 * Multiplies the columns of this matrix by the given vector.
	 *
	 * @param {Vector3} v - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    /**
	 * Gets the maximum scale value of the three axes.
	 *
	 * @return {number} The maximum scale.
	 */ getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    /**
	 * Sets this matrix as a translation transform from the given vector.
	 *
	 * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @param {number} z - The amount to translate in the z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the X axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Y axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Z axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the given axis by
	 * the given angle.
	 *
	 * This is a somewhat controversial but mathematically sound alternative to
	 * rotating via Quaternions. See the discussion [here](https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199).
	 *
	 * @param {Vector3} axis - The normalized rotation axis.
	 * @param {number} angle - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a scale transformation.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @param {number} z - The amount to scale in the Z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a shear transformation.
	 *
	 * @param {number} xy - The amount to shear X by Y.
	 * @param {number} xz - The amount to shear X by Z.
	 * @param {number} yx - The amount to shear Y by X.
	 * @param {number} yz - The amount to shear Y by Z.
	 * @param {number} zx - The amount to shear Z by X.
	 * @param {number} zy - The amount to shear Z by Y.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix to the transformation composed of the given position,
	 * rotation (Quaternion) and scale.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    /**
	 * Decomposes this matrix into its position, rotation and scale components
	 * and provides the result in the given objects.
	 *
	 * Note: Not all matrices are decomposable in this way. For example, if an
	 * object has a non-uniformly scaled parent, then the object's world matrix
	 * may not be decomposable, and this method may not be appropriate.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ decompose(position, quaternion, scale) {
        const te = this.elements;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        const det = this.determinant();
        if (det === 0) {
            scale.set(1, 1, 1);
            quaternion.identity();
            return this;
        }
        let sx = $ce0cdebec9150cb3$var$_v1$7.set(te[0], te[1], te[2]).length();
        const sy = $ce0cdebec9150cb3$var$_v1$7.set(te[4], te[5], te[6]).length();
        const sz = $ce0cdebec9150cb3$var$_v1$7.set(te[8], te[9], te[10]).length();
        // if determinant is negative, we need to invert one scale
        if (det < 0) sx = -sx;
        // scale the rotation part
        $ce0cdebec9150cb3$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $ce0cdebec9150cb3$var$_m1$2.elements[0] *= invSX;
        $ce0cdebec9150cb3$var$_m1$2.elements[1] *= invSX;
        $ce0cdebec9150cb3$var$_m1$2.elements[2] *= invSX;
        $ce0cdebec9150cb3$var$_m1$2.elements[4] *= invSY;
        $ce0cdebec9150cb3$var$_m1$2.elements[5] *= invSY;
        $ce0cdebec9150cb3$var$_m1$2.elements[6] *= invSY;
        $ce0cdebec9150cb3$var$_m1$2.elements[8] *= invSZ;
        $ce0cdebec9150cb3$var$_m1$2.elements[9] *= invSZ;
        $ce0cdebec9150cb3$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($ce0cdebec9150cb3$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    /**
	 * Creates a perspective projection matrix. This is used internally by
	 * {@link PerspectiveCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makePerspective(left, right, top, bottom, near, far, coordinateSystem = $ce0cdebec9150cb3$export$5a0e9190d10875d3, reversedDepth = false) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = near / (far - near);
            d = far * near / (far - near);
        } else {
            if (coordinateSystem === $ce0cdebec9150cb3$export$5a0e9190d10875d3) {
                c = -(far + near) / (far - near);
                d = -2 * far * near / (far - near);
            } else if (coordinateSystem === $ce0cdebec9150cb3$export$cc83beedcb9be9ac) {
                c = -far / (far - near);
                d = -far * near / (far - near);
            } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    /**
	 * Creates a orthographic projection matrix. This is used internally by
	 * {@link OrthographicCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $ce0cdebec9150cb3$export$5a0e9190d10875d3, reversedDepth = false) {
        const te = this.elements;
        const x = 2 / (right - left);
        const y = 2 / (top - bottom);
        const a = -(right + left) / (right - left);
        const b = -(top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = 1 / (far - near);
            d = far / (far - near);
        } else {
            if (coordinateSystem === $ce0cdebec9150cb3$export$5a0e9190d10875d3) {
                c = -2 / (far - near);
                d = -(far + near) / (far - near);
            } else if (coordinateSystem === $ce0cdebec9150cb3$export$cc83beedcb9be9ac) {
                c = -1 / (far - near);
                d = -near / (far - near);
            } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = 0;
        te[12] = a;
        te[1] = 0;
        te[5] = y;
        te[9] = 0;
        te[13] = b;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix4} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix4} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $ce0cdebec9150cb3$var$_v1$7 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_m1$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_zero = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(0, 0, 0);
const $ce0cdebec9150cb3$var$_one = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(1, 1, 1);
const $ce0cdebec9150cb3$var$_x = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_y = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_z = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_matrix$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_quaternion$4 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3();
/**
 * A class representing Euler angles.
 *
 * Euler angles describe a rotational transformation by rotating an object on
 * its various axes in specified amounts per axis, and a specified axis
 * order.
 *
 * Iterating through an instance will yield its components (x, y, z,
 * order) in the corresponding order.
 *
 * ```js
 * const a = new THREE.Euler( 0, 1, 1.57, 'XYZ' );
 * const b = new THREE.Vector3( 1, 0, 1 );
 * b.applyEuler(a);
 * ```
 */ class $ce0cdebec9150cb3$export$d93cc409a0768c5f {
    /**
	 * Constructs a new euler instance.
	 *
	 * @param {number} [x=0] - The angle of the x axis in radians.
	 * @param {number} [y=0] - The angle of the y axis in radians.
	 * @param {number} [z=0] - The angle of the z axis in radians.
	 * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
	 */ constructor(x = 0, y = 0, z = 0, order = $ce0cdebec9150cb3$export$d93cc409a0768c5f.DEFAULT_ORDER){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    /**
	 * The angle of the x axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the y axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the z axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * A string representing the order that the rotations are applied.
	 *
	 * @type {string}
	 * @default 'XYZ'
	 */ get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the Euler components.
	 *
	 * @param {number} x - The angle of the x axis in radians.
	 * @param {number} y - The angle of the y axis in radians.
	 * @param {number} z - The angle of the z axis in radians.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new Euler instance with copied values from this instance.
	 *
	 * @return {Euler} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
	 * Copies the values of the given Euler instance to this instance.
	 *
	 * @param {Euler} euler - The Euler instance to copy.
	 * @return {Euler} A reference to this Euler instance.
	 */ copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a pure rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromRotationMatrix(m, order = this._order, update = true) {
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($ce0cdebec9150cb3$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$ce0cdebec9150cb3$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($ce0cdebec9150cb3$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$ce0cdebec9150cb3$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($ce0cdebec9150cb3$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$ce0cdebec9150cb3$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a normalized quaternion.
	 *
	 * @param {Quaternion} q - A normalized Quaternion.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromQuaternion(q, order, update) {
        $ce0cdebec9150cb3$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($ce0cdebec9150cb3$var$_matrix$2, order, update);
    }
    /**
	 * Sets the angles of this Euler instance from the given vector.
	 *
	 * @param {Vector3} v - The vector.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    /**
	 * Resets the euler angle with a new order by creating a quaternion from this
	 * euler angle and then setting this euler angle with the quaternion and the
	 * new order.
	 *
	 * Warning: This discards revolution information.
	 *
	 * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ reorder(newOrder) {
        $ce0cdebec9150cb3$var$_quaternion$4.setFromEuler(this);
        return this.setFromQuaternion($ce0cdebec9150cb3$var$_quaternion$4, newOrder);
    }
    /**
	 * Returns `true` if this Euler instance is equal with the given one.
	 *
	 * @param {Euler} euler - The Euler instance to test for equality.
	 * @return {boolean} Whether this Euler instance is equal with the given one.
	 */ equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    /**
	 * Sets this Euler instance's components to values from the given array. The first three
	 * entries of the array are assign to the x,y and z components. An optional fourth entry
	 * defines the Euler order.
	 *
	 * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
	 * @return {Euler} A reference to this Euler instance.
	 */ fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this Euler instance to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number,number,number,string>} The Euler components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
/**
 * The default Euler angle order.
 *
 * @static
 * @type {string}
 * @default 'XYZ'
 */ $ce0cdebec9150cb3$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
/**
 * A layers object assigns an 3D object to 1 or more of 32
 * layers numbered `0` to `31` - internally the layers are stored as a
 * bit mask], and by default all 3D objects are a member of layer `0`.
 *
 * This can be used to control visibility - an object must share a layer with
 * a camera to be visible when that camera's view is
 * rendered.
 *
 * All classes that inherit from {@link Object3D} have an `layers` property which
 * is an instance of this class.
 */ class $ce0cdebec9150cb3$export$89312ce47c0ca777 {
    /**
	 * Constructs a new layers instance, with membership
	 * initially set to layer `0`.
	 */ constructor(){
        /**
		 * A bit mask storing which of the 32 layers this layers object is currently
		 * a member of.
		 *
		 * @type {number}
		 */ this.mask = 1;
    }
    /**
	 * Sets membership to the given layer, and remove membership all other layers.
	 *
	 * @param {number} layer - The layer to set.
	 */ set(layer) {
        this.mask = (1 << layer | 0) >>> 0;
    }
    /**
	 * Adds membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ enable(layer) {
        this.mask |= 1 << layer | 0;
    }
    /**
	 * Adds membership to all layers.
	 */ enableAll() {
        this.mask = -1;
    }
    /**
	 * Toggles the membership of the given layer.
	 *
	 * @param {number} layer - The layer to toggle.
	 */ toggle(layer) {
        this.mask ^= 1 << layer | 0;
    }
    /**
	 * Removes membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ disable(layer) {
        this.mask &= ~(1 << layer | 0);
    }
    /**
	 * Removes the membership from all layers.
	 */ disableAll() {
        this.mask = 0;
    }
    /**
	 * Returns `true` if this and the given layers object have at least one
	 * layer in common.
	 *
	 * @param {Layers} layers - The layers to test.
	 * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
	 */ test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    /**
	 * Returns `true` if the given layer is enabled.
	 *
	 * @param {number} layer - The layer to test.
	 * @return {boolean } Whether the given layer is enabled or not.
	 */ isEnabled(layer) {
        return (this.mask & (1 << layer | 0)) !== 0;
    }
}
let $ce0cdebec9150cb3$var$_object3DId = 0;
const $ce0cdebec9150cb3$var$_v1$6 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_q1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3();
const $ce0cdebec9150cb3$var$_m1$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_target = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_position$4 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_scale$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_quaternion$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3();
const $ce0cdebec9150cb3$var$_xAxis = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(1, 0, 0);
const $ce0cdebec9150cb3$var$_yAxis = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(0, 1, 0);
const $ce0cdebec9150cb3$var$_zAxis = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(0, 0, 1);
/**
 * Fires when the object has been added to its parent object.
 *
 * @event Object3D#added
 * @type {Object}
 */ const $ce0cdebec9150cb3$var$_addedEvent = {
    type: 'added'
};
/**
 * Fires when the object has been removed from its parent object.
 *
 * @event Object3D#removed
 * @type {Object}
 */ const $ce0cdebec9150cb3$var$_removedEvent = {
    type: 'removed'
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childadded
 * @type {Object}
 */ const $ce0cdebec9150cb3$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
/**
 * Fires when a child object has been removed.
 *
 * @event Object3D#childremoved
 * @type {Object}
 */ const $ce0cdebec9150cb3$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
/**
 * This is the base class for most objects in three.js and provides a set of
 * properties and methods for manipulating objects in 3D space.
 *
 * @augments EventDispatcher
 */ class $ce0cdebec9150cb3$export$e4dd07dff30cc924 extends $ce0cdebec9150cb3$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new 3D object.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isObject3D = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name Object3D#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $ce0cdebec9150cb3$var$_object3DId++
        });
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $ce0cdebec9150cb3$var$generateUUID();
        /**
		 * The name of the 3D object.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Object3D';
        /**
		 * A reference to the parent object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.parent = null;
        /**
		 * An array holding the child 3D objects of this instance.
		 *
		 * @type {Array<Object3D>}
		 */ this.children = [];
        /**
		 * Defines the `up` direction of the 3D object which influences
		 * the orientation via methods like {@link Object3D#lookAt}.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_UP`.
		 *
		 * @type {Vector3}
		 */ this.up = $ce0cdebec9150cb3$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const rotation = new $ce0cdebec9150cb3$export$d93cc409a0768c5f();
        const quaternion = new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3();
        const scale = new $ce0cdebec9150cb3$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            /**
			 * Represents the object's local position.
			 *
			 * @name Object3D#position
			 * @type {Vector3}
			 * @default (0,0,0)
			 */ position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            /**
			 * Represents the object's local rotation as Euler angles, in radians.
			 *
			 * @name Object3D#rotation
			 * @type {Euler}
			 * @default (0,0,0)
			 */ rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            /**
			 * Represents the object's local rotation as Quaternions.
			 *
			 * @name Object3D#quaternion
			 * @type {Quaternion}
			 */ quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            /**
			 * Represents the object's local scale.
			 *
			 * @name Object3D#scale
			 * @type {Vector3}
			 * @default (1,1,1)
			 */ scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            /**
			 * Represents the object's model-view matrix.
			 *
			 * @name Object3D#modelViewMatrix
			 * @type {Matrix4}
			 */ modelViewMatrix: {
                value: new $ce0cdebec9150cb3$export$2ae72fc923e5eb5()
            },
            /**
			 * Represents the object's normal matrix.
			 *
			 * @name Object3D#normalMatrix
			 * @type {Matrix3}
			 */ normalMatrix: {
                value: new $ce0cdebec9150cb3$export$8ff26dafa08918()
            }
        });
        /**
		 * Represents the object's transformation matrix in local space.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
        /**
		 * Represents the object's transformation matrix in world space.
		 * If the 3D object has no parent, then it's identical to the local transformation matrix
		 *
		 * @type {Matrix4}
		 */ this.matrixWorld = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
        /**
		 * When set to `true`, the engine automatically computes the local matrix from position,
		 * rotation and scale every frame. If set to `false`, the app is responsible for recomputing
		 * the local matrix by calling `updateMatrix()`.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = $ce0cdebec9150cb3$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        /**
		 * When set to `true`, the engine automatically computes the world matrix from the current local
		 * matrix and the object's transformation hierarchy. If set to `false`, the app is responsible for
		 * recomputing the world matrix by directly updating the `matrixWorld` property.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixWorldAutoUpdate = $ce0cdebec9150cb3$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        /**
		 * When set to `true`, it calculates the world matrix in that frame and resets this property
		 * to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.matrixWorldNeedsUpdate = false;
        /**
		 * The layer membership of the 3D object. The 3D object is only visible if it has
		 * at least one layer in common with the camera in use. This property can also be
		 * used to filter out unwanted objects in ray-intersection tests when using {@link Raycaster}.
		 *
		 * @type {Layers}
		 */ this.layers = new $ce0cdebec9150cb3$export$89312ce47c0ca777();
        /**
		 * When set to `true`, the 3D object gets rendered.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * When set to `true`, the 3D object gets rendered into shadow maps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.castShadow = false;
        /**
		 * When set to `true`, the 3D object is affected by shadows in the scene.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.receiveShadow = false;
        /**
		 * When set to `true`, the 3D object is honored by view frustum culling.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.frustumCulled = true;
        /**
		 * This value allows the default rendering order of scene graph objects to be
		 * overridden although opaque and transparent objects remain sorted independently.
		 * When this property is set for an instance of {@link Group},all descendants
		 * objects will be sorted and rendered together. Sorting is from lowest to highest
		 * render order.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderOrder = 0;
        /**
		 * An array holding the animation clips of the 3D object.
		 *
		 * @type {Array<AnimationClip>}
		 */ this.animations = [];
        /**
		 * Custom depth material to be used when rendering to the depth map. Can only be used
		 * in context of meshes. When shadow-casting with a {@link DirectionalLight} or {@link SpotLight},
		 * if you are modifying vertex positions in the vertex shader you must specify a custom depth
		 * material for proper shadows.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDepthMaterial = undefined;
        /**
		 * Same as {@link Object3D#customDepthMaterial}, but used with {@link PointLight}.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDistanceMaterial = undefined;
        /**
		 * Whether the 3D object is supposed to be static or not. If set to `true`, it means
		 * the 3D object is not going to be changed after the initial renderer. This includes
		 * geometry and material settings. A static 3D object can be processed by the renderer
		 * slightly faster since certain state checks can be bypassed.
		 *
		 * Only relevant in context of {@link WebGPURenderer}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.static = false;
        /**
		 * An object that can be used to store custom data about the 3D object. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * The pivot point for rotation and scale transformations.
		 * When set, rotation and scale are applied around this point
		 * instead of the object's origin.
		 *
		 * @type {?Vector3}
		 * @default null
		 */ this.pivot = null;
    }
    /**
	 * A callback that is executed immediately before a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeShadow() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterShadow() {}
    /**
	 * A callback that is executed immediately before a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterRender() {}
    /**
	 * Applies the given transformation matrix to the object and updates the object's position,
	 * rotation and scale.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 */ applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
	 * Applies a rotation represented by given the quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Object3D} A reference to this instance.
	 */ applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    /**
	 * Sets the given rotation represented as an axis/angle couple to the 3D object.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 */ setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    /**
	 * Sets the given rotation represented as Euler angles to the 3D object.
	 *
	 * @param {Euler} euler - The Euler angles.
	 */ setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    /**
	 * Sets the given rotation represented as rotation matrix to the 3D object.
	 *
	 * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
	 * a pure rotation matrix (i.e, unscaled).
	 */ setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    /**
	 * Sets the given rotation represented as a Quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The Quaternion
	 */ setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    /**
	 * Rotates the 3D object along an axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $ce0cdebec9150cb3$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($ce0cdebec9150cb3$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object along an axis in world space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $ce0cdebec9150cb3$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($ce0cdebec9150cb3$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object around its X axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateX(angle) {
        return this.rotateOnAxis($ce0cdebec9150cb3$var$_xAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Y axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateY(angle) {
        return this.rotateOnAxis($ce0cdebec9150cb3$var$_yAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Z axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateZ(angle) {
        return this.rotateOnAxis($ce0cdebec9150cb3$var$_zAxis, angle);
    }
    /**
	 * Translate the 3D object by a distance along the given axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $ce0cdebec9150cb3$var$_v1$6.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($ce0cdebec9150cb3$var$_v1$6.multiplyScalar(distance));
        return this;
    }
    /**
	 * Translate the 3D object by a distance along its X-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateX(distance) {
        return this.translateOnAxis($ce0cdebec9150cb3$var$_xAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Y-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateY(distance) {
        return this.translateOnAxis($ce0cdebec9150cb3$var$_yAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Z-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateZ(distance) {
        return this.translateOnAxis($ce0cdebec9150cb3$var$_zAxis, distance);
    }
    /**
	 * Converts the given vector from this 3D object's local space to world space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    /**
	 * Converts the given vector from this 3D object's world space to local space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($ce0cdebec9150cb3$var$_m1$1.copy(this.matrixWorld).invert());
    }
    /**
	 * Rotates the object to face a point in world space.
	 *
	 * This method does not support objects having non-uniformly-scaled parent(s).
	 *
	 * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
	 * @param {number} [y] - The y coordinate in world space.
	 * @param {number} [z] - The z coordinate in world space.
	 */ lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $ce0cdebec9150cb3$var$_target.copy(x);
        else $ce0cdebec9150cb3$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $ce0cdebec9150cb3$var$_position$4.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $ce0cdebec9150cb3$var$_m1$1.lookAt($ce0cdebec9150cb3$var$_position$4, $ce0cdebec9150cb3$var$_target, this.up);
        else $ce0cdebec9150cb3$var$_m1$1.lookAt($ce0cdebec9150cb3$var$_target, $ce0cdebec9150cb3$var$_position$4, this.up);
        this.quaternion.setFromRotationMatrix($ce0cdebec9150cb3$var$_m1$1);
        if (parent) {
            $ce0cdebec9150cb3$var$_m1$1.extractRotation(parent.matrixWorld);
            $ce0cdebec9150cb3$var$_q1.setFromRotationMatrix($ce0cdebec9150cb3$var$_m1$1);
            this.quaternion.premultiply($ce0cdebec9150cb3$var$_q1.invert());
        }
    }
    /**
	 * Adds the given 3D object as a child to this 3D object. An arbitrary number of
	 * objects may be added. Any current parent on an object passed in here will be
	 * removed, since an object can have at most one parent.
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to add.
	 * @return {Object3D} A reference to this instance.
	 */ add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            $ce0cdebec9150cb3$export$a3bc9b8ed74fc('Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($ce0cdebec9150cb3$var$_addedEvent);
            $ce0cdebec9150cb3$var$_childaddedEvent.child = object;
            this.dispatchEvent($ce0cdebec9150cb3$var$_childaddedEvent);
            $ce0cdebec9150cb3$var$_childaddedEvent.child = null;
        } else $ce0cdebec9150cb3$export$a3bc9b8ed74fc('Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    /**
	 * Removes the given 3D object as child from this 3D object.
	 * An arbitrary number of objects may be removed.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @param {Object3D} object - The 3D object to remove.
	 * @return {Object3D} A reference to this instance.
	 */ remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($ce0cdebec9150cb3$var$_removedEvent);
            $ce0cdebec9150cb3$var$_childremovedEvent.child = object;
            this.dispatchEvent($ce0cdebec9150cb3$var$_childremovedEvent);
            $ce0cdebec9150cb3$var$_childremovedEvent.child = null;
        }
        return this;
    }
    /**
	 * Removes this 3D object from its current parent.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    /**
	 * Removes all child objects.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ clear() {
        return this.remove(...this.children);
    }
    /**
	 * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
	 * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to attach.
	 * @return {Object3D} A reference to this instance.
	 */ attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $ce0cdebec9150cb3$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $ce0cdebec9150cb3$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($ce0cdebec9150cb3$var$_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($ce0cdebec9150cb3$var$_addedEvent);
        $ce0cdebec9150cb3$var$_childaddedEvent.child = object;
        this.dispatchEvent($ce0cdebec9150cb3$var$_childaddedEvent);
        $ce0cdebec9150cb3$var$_childaddedEvent.child = null;
        return this;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching ID.
	 *
	 * @param {number} id - The id.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching name.
	 *
	 * @param {string} name - The name.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns all 3D objects with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @param {Array<Object3D>} result - The method stores the result in this array.
	 * @return {Array<Object3D>} The found 3D objects.
	 */ getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    /**
	 * Returns a vector representing the position of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's position in world space.
	 */ getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    /**
	 * Returns a Quaternion representing the position of the 3D object in world space.
	 *
	 * @param {Quaternion} target - The target Quaternion the result is stored to.
	 * @return {Quaternion} The 3D object's rotation in world space.
	 */ getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($ce0cdebec9150cb3$var$_position$4, target, $ce0cdebec9150cb3$var$_scale$3);
        return target;
    }
    /**
	 * Returns a vector representing the scale of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's scale in world space.
	 */ getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($ce0cdebec9150cb3$var$_position$4, $ce0cdebec9150cb3$var$_quaternion$3, target);
        return target;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    /**
	 * Abstract method to get intersections between a casted ray and this
	 * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
	 * implement this method in order to use raycasting.
	 *
	 * @abstract
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - An array holding the result of the method.
	 */ raycast() {}
    /**
	 * Executes the callback on this 3D object and all descendants.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
	 * Descendants of invisible 3D objects are not traversed.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    /**
	 * Updates the transformation matrix in local space by computing it from the current
	 * position, rotation and scale values.
	 */ updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        const pivot = this.pivot;
        if (pivot !== null) {
            const px = pivot.x, py = pivot.y, pz = pivot.z;
            const te = this.matrix.elements;
            te[12] += px - te[0] * px - te[4] * py - te[8] * pz;
            te[13] += py - te[1] * px - te[5] * py - te[9] * pz;
            te[14] += pz - te[2] * px - te[6] * py - te[10] * pz;
        }
        this.matrixWorldNeedsUpdate = true;
    }
    /**
	 * Updates the transformation matrix in world space of this 3D objects and its descendants.
	 *
	 * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
	 * local space. The computation of the local and world matrix can be controlled with the
	 * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
	 * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
	 * when {@link Object3D#matrixWorldNeedsUpdate} is `false`.
	 */ updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    /**
	 * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
	 * update of ancestor and descendant nodes.
	 *
	 * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
	 * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
	 */ updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    /**
	 * Serializes the 3D object into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized 3D object.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.7,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (this.static !== false) object.static = this.static;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.pivot !== null) object.pivot = this.pivot.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        if (this.morphTargetDictionary !== undefined) object.morphTargetDictionary = Object.assign({}, this.morphTargetDictionary);
        if (this.morphTargetInfluences !== undefined) object.morphTargetInfluences = this.morphTargetInfluences.slice();
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.geometryInfo = this._geometryInfo.map((info)=>({
                    ...info,
                    boundingBox: info.boundingBox ? info.boundingBox.toJSON() : undefined,
                    boundingSphere: info.boundingSphere ? info.boundingSphere.toJSON() : undefined
                }));
            object.instanceInfo = this._instanceInfo.map((info)=>({
                    ...info
                }));
            object.availableInstanceIds = this._availableInstanceIds.slice();
            object.availableGeometryIds = this._availableGeometryIds.slice();
            object.nextIndexStart = this._nextIndexStart;
            object.nextVertexStart = this._nextVertexStart;
            object.geometryCount = this._geometryCount;
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            object.indirectTexture = this._indirectTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = this.boundingSphere.toJSON();
            if (this.boundingBox !== null) object.boundingBox = this.boundingBox.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    /**
	 * Returns a new 3D object with copied values from this instance.
	 *
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
	 * @return {Object3D} A clone of this instance.
	 */ clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    /**
	 * Copies the values of the given 3D object to this instance.
	 *
	 * @param {Object3D} source - The 3D object to copy.
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
	 * @return {Object3D} A reference to this instance.
	 */ copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        if (source.pivot !== null) this.pivot = source.pivot.clone();
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.static = source.static;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
/**
 * The default up direction for objects, also used as the default
 * position for {@link DirectionalLight} and {@link HemisphereLight}.
 *
 * @static
 * @type {Vector3}
 * @default (0,1,0)
 */ $ce0cdebec9150cb3$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(0, 1, 0);
/**
 * The default setting for {@link Object3D#matrixAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $ce0cdebec9150cb3$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
/**
 * The default setting for {@link Object3D#matrixWorldAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $ce0cdebec9150cb3$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
/**
 * This is almost identical to an {@link Object3D}. Its purpose is to
 * make working with groups of objects syntactically clearer.
 *
 * ```js
 * // Create a group and add the two cubes.
 * // These cubes can now be rotated / scaled etc as a group.
 * const group = new THREE.Group();
 *
 * group.add( meshA );
 * group.add( meshB );
 *
 * scene.add( group );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$eb2fcfdbd7ba97d4 extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGroup = true;
        this.type = 'Group';
    }
}
const $ce0cdebec9150cb3$var$_moveEvent = {
    type: 'move'
};
/**
 * Class for representing a XR controller with its
 * different coordinate systems.
 *
 * @private
 */ class $ce0cdebec9150cb3$export$cb626c57dcc48b9f {
    /**
	 * Constructs a new XR controller.
	 */ constructor(){
        /**
		 * A group representing the target ray space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._targetRay = null;
        /**
		 * A group representing the grip space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._grip = null;
        /**
		 * A group representing the hand space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._hand = null;
    }
    /**
	 * Returns a group representing the hand space of the XR controller.
	 *
	 * @return {Group} A group representing the hand space of the XR controller.
	 */ getHandSpace() {
        if (this._hand === null) {
            this._hand = new $ce0cdebec9150cb3$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    /**
	 * Returns a group representing the target ray space of the XR controller.
	 *
	 * @return {Group} A group representing the target ray space of the XR controller.
	 */ getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $ce0cdebec9150cb3$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    /**
	 * Returns a group representing the grip space of the XR controller.
	 *
	 * @return {Group} A group representing the grip space of the XR controller.
	 */ getGripSpace() {
        if (this._grip === null) {
            this._grip = new $ce0cdebec9150cb3$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        }
        return this._grip;
    }
    /**
	 * Dispatches the given event to the groups representing
	 * the different coordinate spaces of the XR controller.
	 *
	 * @param {Object} event - The event to dispatch.
	 * @return {WebXRController} A reference to this instance.
	 */ dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    /**
	 * Connects the controller with the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    /**
	 * Disconnects the controller from the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    /**
	 * Updates the controller with the given input source, XR frame and reference space.
	 * This updates the transformations of the groups that represent the different
	 * coordinate systems of the controller.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @param {XRFrame} frame - The XR frame.
	 * @param {XRReferenceSpace} referenceSpace - The reference space.
	 * @return {WebXRController} A reference to this instance.
	 */ update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($ce0cdebec9150cb3$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    /**
	 * Returns a group representing the hand joint for the given input joint.
	 *
	 * @private
	 * @param {Group} hand - The group representing the hand space.
	 * @param {XRJointSpace} inputjoint - The hand joint data.
	 * @return {Group} A group representing the hand joint for the given input joint.
	 */ _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $ce0cdebec9150cb3$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
const $ce0cdebec9150cb3$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $ce0cdebec9150cb3$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $ce0cdebec9150cb3$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $ce0cdebec9150cb3$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
/**
 * A Color instance is represented by RGB components in the linear <i>working
 * color space</i>, which defaults to `LinearSRGBColorSpace`. Inputs
 * conventionally using `SRGBColorSpace` (such as hexadecimals and CSS
 * strings) are converted to the working color space automatically.
 *
 * ```js
 * // converted automatically from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setHex( 0x112233 );
 * ```
 * Source color spaces may be specified explicitly, to ensure correct conversions.
 * ```js
 * // assumed already LinearSRGBColorSpace; no conversion
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5 );
 *
 * // converted explicitly from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5, SRGBColorSpace );
 * ```
 * If THREE.ColorManagement is disabled, no conversions occur. For details,
 * see <i>Color management</i>. Iterating through a Color instance will yield
 * its components (r, g, b) in the corresponding order. A Color can be initialised
 * in any of the following ways:
 * ```js
 * //empty constructor - will default white
 * const color1 = new THREE.Color();
 *
 * //Hexadecimal color (recommended)
 * const color2 = new THREE.Color( 0xff0000 );
 *
 * //RGB string
 * const color3 = new THREE.Color("rgb(255, 0, 0)");
 * const color4 = new THREE.Color("rgb(100%, 0%, 0%)");
 *
 * //X11 color name - all 140 color names are supported.
 * //Note the lack of CamelCase in the name
 * const color5 = new THREE.Color( 'skyblue' );
 * //HSL string
 * const color6 = new THREE.Color("hsl(0, 100%, 50%)");
 *
 * //Separate RGB values between 0 and 1
 * const color7 = new THREE.Color( 1, 0, 0 );
 * ```
 */ class $ce0cdebec9150cb3$export$892596cec99bc70e {
    /**
	 * Constructs a new color.
	 *
	 * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
	 * and that method is used throughout the rest of the documentation.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 */ constructor(r, g, b){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColor = true;
        /**
		 * The red component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.r = 1;
        /**
		 * The green component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.g = 1;
        /**
		 * The blue component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.b = 1;
        return this.set(r, g, b);
    }
    /**
	 * Sets the colors's components from the given values.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 * @return {Color} A reference to this color.
	 */ set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    /**
	 * Sets the colors's components to the given scalar value.
	 *
	 * @param {number} scalar - The scalar value.
	 * @return {Color} A reference to this color.
	 */ setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    /**
	 * Sets this color from a hexadecimal value.
	 *
	 * @param {number} hex - The hexadecimal value.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHex(hex, colorSpace = $ce0cdebec9150cb3$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $ce0cdebec9150cb3$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} r - Red channel value between `0.0` and `1.0`.
	 * @param {number} g - Green channel value between `0.0` and `1.0`.
	 * @param {number} b - Blue channel value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setRGB(r, g, b, colorSpace = $ce0cdebec9150cb3$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $ce0cdebec9150cb3$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHSL(h, s, l, colorSpace = $ce0cdebec9150cb3$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $ce0cdebec9150cb3$var$euclideanModulo(h, 1);
        s = $ce0cdebec9150cb3$var$clamp(s, 0, 1);
        l = $ce0cdebec9150cb3$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $ce0cdebec9150cb3$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $ce0cdebec9150cb3$var$hue2rgb(q, p, h);
            this.b = $ce0cdebec9150cb3$var$hue2rgb(q, p, h - 1 / 3);
        }
        $ce0cdebec9150cb3$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
	 * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
	 * any [X11 color name](https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart) -
	 * all 140 color names are supported).
	 *
	 * @param {string} style - Color as a CSS-style string.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setStyle(style, colorSpace = $ce0cdebec9150cb3$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a color name. Faster than {@link Color#setStyle} if
	 * you don't need the other CSS-style formats.
	 *
	 * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
	 * ```js
	 * Color.NAMES.aliceblue // returns 0xF0F8FF
	 * ```
	 *
	 * @param {string} style - The color name.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setColorName(style, colorSpace = $ce0cdebec9150cb3$export$561f394b24edfcaa) {
        // color keywords
        const hex = $ce0cdebec9150cb3$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Color: Unknown color ' + style);
        return this;
    }
    /**
	 * Returns a new color with copied values from this instance.
	 *
	 * @return {Color} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
	 * Copies the values of the given color to this instance.
	 *
	 * @param {Color} color - The color to copy.
	 * @return {Color} A reference to this color.
	 */ copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copySRGBToLinear(color) {
        this.r = $ce0cdebec9150cb3$var$SRGBToLinear(color.r);
        this.g = $ce0cdebec9150cb3$var$SRGBToLinear(color.g);
        this.b = $ce0cdebec9150cb3$var$SRGBToLinear(color.b);
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copyLinearToSRGB(color) {
        this.r = $ce0cdebec9150cb3$var$LinearToSRGB(color.r);
        this.g = $ce0cdebec9150cb3$var$LinearToSRGB(color.g);
        this.b = $ce0cdebec9150cb3$var$LinearToSRGB(color.b);
        return this;
    }
    /**
	 * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    /**
	 * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    /**
	 * Returns the hexadecimal value of this color.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {number} The hexadecimal value.
	 */ getHex(colorSpace = $ce0cdebec9150cb3$export$561f394b24edfcaa) {
        $ce0cdebec9150cb3$export$5e6fd513f44698c.workingToColorSpace($ce0cdebec9150cb3$var$_color.copy(this), colorSpace);
        return Math.round($ce0cdebec9150cb3$var$clamp($ce0cdebec9150cb3$var$_color.r * 255, 0, 255)) * 65536 + Math.round($ce0cdebec9150cb3$var$clamp($ce0cdebec9150cb3$var$_color.g * 255, 0, 255)) * 256 + Math.round($ce0cdebec9150cb3$var$clamp($ce0cdebec9150cb3$var$_color.b * 255, 0, 255));
    }
    /**
	 * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The hexadecimal value as a string.
	 */ getHexString(colorSpace = $ce0cdebec9150cb3$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    /**
	 * Converts the colors RGB values into the HSL format and stores them into the
	 * given target object.
	 *
	 * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {{h:number,s:number,l:number}} The HSL representation of this color.
	 */ getHSL(target, colorSpace = $ce0cdebec9150cb3$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $ce0cdebec9150cb3$export$5e6fd513f44698c.workingToColorSpace($ce0cdebec9150cb3$var$_color.copy(this), colorSpace);
        const r = $ce0cdebec9150cb3$var$_color.r, g = $ce0cdebec9150cb3$var$_color.g, b = $ce0cdebec9150cb3$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    /**
	 * Returns the RGB values of this color and stores them into the given target object.
	 *
	 * @param {Color} target - The target color that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} The RGB representation of this color.
	 */ getRGB(target, colorSpace = $ce0cdebec9150cb3$export$5e6fd513f44698c.workingColorSpace) {
        $ce0cdebec9150cb3$export$5e6fd513f44698c.workingToColorSpace($ce0cdebec9150cb3$var$_color.copy(this), colorSpace);
        target.r = $ce0cdebec9150cb3$var$_color.r;
        target.g = $ce0cdebec9150cb3$var$_color.g;
        target.b = $ce0cdebec9150cb3$var$_color.b;
        return target;
    }
    /**
	 * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The CSS representation of this color.
	 */ getStyle(colorSpace = $ce0cdebec9150cb3$export$561f394b24edfcaa) {
        $ce0cdebec9150cb3$export$5e6fd513f44698c.workingToColorSpace($ce0cdebec9150cb3$var$_color.copy(this), colorSpace);
        const r = $ce0cdebec9150cb3$var$_color.r, g = $ce0cdebec9150cb3$var$_color.g, b = $ce0cdebec9150cb3$var$_color.b;
        if (colorSpace !== $ce0cdebec9150cb3$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    /**
	 * Adds the given HSL values to this color's values.
	 * Internally, this converts the color's RGB values to HSL, adds HSL
	 * and then converts the color back to RGB.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @return {Color} A reference to this color.
	 */ offsetHSL(h, s, l) {
        this.getHSL($ce0cdebec9150cb3$var$_hslA);
        return this.setHSL($ce0cdebec9150cb3$var$_hslA.h + h, $ce0cdebec9150cb3$var$_hslA.s + s, $ce0cdebec9150cb3$var$_hslA.l + l);
    }
    /**
	 * Adds the RGB values of the given color to the RGB values of this color.
	 *
	 * @param {Color} color - The color to add.
	 * @return {Color} A reference to this color.
	 */ add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    /**
	 * Adds the RGB values of the given colors and stores the result in this instance.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @return {Color} A reference to this color.
	 */ addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    /**
	 * Adds the given scalar value to the RGB values of this color.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Color} A reference to this color.
	 */ addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    /**
	 * Subtracts the RGB values of the given color from the RGB values of this color.
	 *
	 * @param {Color} color - The color to subtract.
	 * @return {Color} A reference to this color.
	 */ sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    /**
	 * Multiplies the RGB values of the given color with the RGB values of this color.
	 *
	 * @param {Color} color - The color to multiply.
	 * @return {Color} A reference to this color.
	 */ multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    /**
	 * Multiplies the given scalar value with the RGB values of this color.
	 *
	 * @param {number} s - The scalar to multiply.
	 * @return {Color} A reference to this color.
	 */ multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    /**
	 * Linearly interpolates this color's RGB values toward the RGB values of the
	 * given color. The alpha argument can be thought of as the ratio between
	 * the two colors, where `0.0` is this color and `1.0` is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given colors and stores the result in this instance.
	 * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
	 * is the first and `1.0` is the second color.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates this color's HSL values toward the HSL values of the
	 * given color. It differs from {@link Color#lerp} by not interpolating straight
	 * from one color to the other, but instead going through all the hues in between
	 * those two colors. The alpha argument can be thought of as the ratio between
	 * the two colors, where 0.0 is this color and 1.0 is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpHSL(color, alpha) {
        this.getHSL($ce0cdebec9150cb3$var$_hslA);
        color.getHSL($ce0cdebec9150cb3$var$_hslB);
        const h = $ce0cdebec9150cb3$var$lerp($ce0cdebec9150cb3$var$_hslA.h, $ce0cdebec9150cb3$var$_hslB.h, alpha);
        const s = $ce0cdebec9150cb3$var$lerp($ce0cdebec9150cb3$var$_hslA.s, $ce0cdebec9150cb3$var$_hslB.s, alpha);
        const l = $ce0cdebec9150cb3$var$lerp($ce0cdebec9150cb3$var$_hslA.l, $ce0cdebec9150cb3$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    /**
	 * Sets the color's RGB components from the given 3D vector.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Color} A reference to this color.
	 */ setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    /**
	 * Transforms this color with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix.
	 * @return {Color} A reference to this color.
	 */ applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    /**
	 * Returns `true` if this color is equal with the given one.
	 *
	 * @param {Color} c - The color to test for equality.
	 * @return {boolean} Whether this bounding color is equal with the given one.
	 */ equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    /**
	 * Sets this color's RGB components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the RGB values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Color} A reference to this color.
	 */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    /**
	 * Writes the RGB components of this color to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the color components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The color components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    /**
	 * Sets the components of this color from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding color data.
	 * @param {number} index - The index into the attribute.
	 * @return {Color} A reference to this color.
	 */ fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the color
	 * as a hexadecimal value.
	 *
	 * @return {number} The hexadecimal value.
	 */ toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $ce0cdebec9150cb3$var$_color = /*@__PURE__*/ new $ce0cdebec9150cb3$export$892596cec99bc70e();
/**
 * A dictionary with X11 color names.
 *
 * Note that multiple words such as Dark Orange become the string 'darkorange'.
 *
 * @static
 * @type {Object}
 */ $ce0cdebec9150cb3$export$892596cec99bc70e.NAMES = $ce0cdebec9150cb3$var$_colorKeywords;
/**
 * This class can be used to define an exponential squared fog,
 * which gives a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
 * ```
 */ class $ce0cdebec9150cb3$export$6f1519f023b8d0f6 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [density=0.00025] - Defines how fast the fog will grow dense.
	 */ constructor(color, density = 0.00025){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFogExp2 = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(color);
        /**
		 *  Defines how fast the fog will grow dense.
		 *
		 * @type {number}
		 * @default 0.00025
		 */ this.density = density;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {FogExp2} A clone of this instance.
	 */ clone() {
        return new $ce0cdebec9150cb3$export$6f1519f023b8d0f6(this.color, this.density);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
/**
 * This class can be used to define a linear fog that grows linearly denser
 * with the distance.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );
 * ```
 */ class $ce0cdebec9150cb3$export$3c890837b09508d4 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [near=1] - The minimum distance to start applying fog.
	 * @param {number} [far=1000] - The maximum distance at which fog stops being calculated and applied.
	 */ constructor(color, near = 1, far = 1000){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFog = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(color);
        /**
		 * The minimum distance to start applying fog. Objects that are less than
		 * `near` units from the active camera won't be affected by fog.
		 *
		 * @type {number}
		 * @default 1
		 */ this.near = near;
        /**
		 * The maximum distance at which fog stops being calculated and applied.
		 * Objects that are more than `far` units away from the active camera won't
		 * be affected by fog.
		 *
		 * @type {number}
		 * @default 1000
		 */ this.far = far;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {Fog} A clone of this instance.
	 */ clone() {
        return new $ce0cdebec9150cb3$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
/**
 * Scenes allow you to set up what is to be rendered and where by three.js.
 * This is where you place 3D objects like meshes, lines or lights.
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$38af1803e3442a7f extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new scene.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScene = true;
        this.type = 'Scene';
        /**
		 * Defines the background of the scene. Valid inputs are:
		 *
		 * - A color for defining a uniform colored background.
		 * - A texture for defining a (flat) textured background.
		 * - Cube textures or equirectangular textures for defining a skybox.
		 *
		 * @type {?(Color|Texture)}
		 * @default null
		 */ this.background = null;
        /**
		 * Sets the environment map for all physical materials in the scene. However,
		 * it's not possible to overwrite an existing texture assigned to the `envMap`
		 * material property.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.environment = null;
        /**
		 * A fog instance defining the type of fog that affects everything
		 * rendered in the scene.
		 *
		 * @type {?(Fog|FogExp2)}
		 * @default null
		 */ this.fog = null;
        /**
		 * Sets the blurriness of the background. Only influences environment maps
		 * assigned to {@link Scene#background}. Valid input is a float between `0`
		 * and `1`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.backgroundBlurriness = 0;
        /**
		 * Attenuates the color of the background. Only applies to background textures.
		 *
		 * @type {number}
		 * @default 1
		 */ this.backgroundIntensity = 1;
        /**
		 * The rotation of the background in radians. Only influences environment maps
		 * assigned to {@link Scene#background}.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.backgroundRotation = new $ce0cdebec9150cb3$export$d93cc409a0768c5f();
        /**
		 * Attenuates the color of the environment. Only influences environment maps
		 * assigned to {@link Scene#environment}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.environmentIntensity = 1;
        /**
		 * The rotation of the environment map in radians. Only influences physical materials
		 * in the scene when {@link Scene#environment} is used.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.environmentRotation = new $ce0cdebec9150cb3$export$d93cc409a0768c5f();
        /**
		 * Forces everything in the scene to be rendered with the defined material. It is possible
		 * to exclude materials from override by setting {@link Material#allowOverride} to `false`.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
const $ce0cdebec9150cb3$var$_v0$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v1$5 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v2$4 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v3$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vab = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vac = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vbc = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vap = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vbp = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vcp = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v40 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$fa7daccca11cdbe3();
const $ce0cdebec9150cb3$var$_v41 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$fa7daccca11cdbe3();
const $ce0cdebec9150cb3$var$_v42 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$fa7daccca11cdbe3();
/**
 * A geometric triangle as defined by three vectors representing its three corners.
 */ class $ce0cdebec9150cb3$export$5a465592bfe74b48 {
    /**
	 * Constructs a new triangle.
	 *
	 * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
	 * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
	 * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
	 */ constructor(a = new $ce0cdebec9150cb3$export$64b5c384219d3699(), b = new $ce0cdebec9150cb3$export$64b5c384219d3699(), c = new $ce0cdebec9150cb3$export$64b5c384219d3699()){
        /**
		 * The first corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.a = a;
        /**
		 * The second corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.b = b;
        /**
		 * The third corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.c = c;
    }
    /**
	 * Computes the normal vector of a triangle.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $ce0cdebec9150cb3$var$_v0$2.subVectors(a, b);
        target.cross($ce0cdebec9150cb3$var$_v0$2);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ static getBarycoord(point, a, b, c, target) {
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        $ce0cdebec9150cb3$var$_v0$2.subVectors(c, a);
        $ce0cdebec9150cb3$var$_v1$5.subVectors(b, a);
        $ce0cdebec9150cb3$var$_v2$4.subVectors(point, a);
        const dot00 = $ce0cdebec9150cb3$var$_v0$2.dot($ce0cdebec9150cb3$var$_v0$2);
        const dot01 = $ce0cdebec9150cb3$var$_v0$2.dot($ce0cdebec9150cb3$var$_v1$5);
        const dot02 = $ce0cdebec9150cb3$var$_v0$2.dot($ce0cdebec9150cb3$var$_v2$4);
        const dot11 = $ce0cdebec9150cb3$var$_v1$5.dot($ce0cdebec9150cb3$var$_v1$5);
        const dot12 = $ce0cdebec9150cb3$var$_v1$5.dot($ce0cdebec9150cb3$var$_v2$4);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $ce0cdebec9150cb3$var$_v3$2) === null) return false;
        return $ce0cdebec9150cb3$var$_v3$2.x >= 0 && $ce0cdebec9150cb3$var$_v3$2.y >= 0 && $ce0cdebec9150cb3$var$_v3$2.x + $ce0cdebec9150cb3$var$_v3$2.y <= 1;
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} p1 - The first corner of the triangle.
	 * @param {Vector3} p2 - The second corner of the triangle.
	 * @param {Vector3} p3 - The third corner of the triangle.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $ce0cdebec9150cb3$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $ce0cdebec9150cb3$var$_v3$2.x);
        target.addScaledVector(v2, $ce0cdebec9150cb3$var$_v3$2.y);
        target.addScaledVector(v3, $ce0cdebec9150cb3$var$_v3$2.z);
        return target;
    }
    /**
	 * Computes the value barycentrically interpolated for the given attribute and indices.
	 *
	 * @param {BufferAttribute} attr - The attribute to interpolate.
	 * @param {number} i1 - Index of first vertex.
	 * @param {number} i2 - Index of second vertex.
	 * @param {number} i3 - Index of third vertex.
	 * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The interpolated attribute value.
	 */ static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $ce0cdebec9150cb3$var$_v40.setScalar(0);
        $ce0cdebec9150cb3$var$_v41.setScalar(0);
        $ce0cdebec9150cb3$var$_v42.setScalar(0);
        $ce0cdebec9150cb3$var$_v40.fromBufferAttribute(attr, i1);
        $ce0cdebec9150cb3$var$_v41.fromBufferAttribute(attr, i2);
        $ce0cdebec9150cb3$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($ce0cdebec9150cb3$var$_v40, barycoord.x);
        target.addScaledVector($ce0cdebec9150cb3$var$_v41, barycoord.y);
        target.addScaledVector($ce0cdebec9150cb3$var$_v42, barycoord.z);
        return target;
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ static isFrontFacing(a, b, c, direction) {
        $ce0cdebec9150cb3$var$_v0$2.subVectors(c, b);
        $ce0cdebec9150cb3$var$_v1$5.subVectors(a, b);
        // strictly front facing
        return $ce0cdebec9150cb3$var$_v0$2.cross($ce0cdebec9150cb3$var$_v1$5).dot(direction) < 0 ? true : false;
    }
    /**
	 * Sets the triangle's vertices by copying the given values.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given array values.
	 *
	 * @param {Array<Vector3>} points - An array with 3D points.
	 * @param {number} i0 - The array index representing the first corner of the triangle.
	 * @param {number} i1 - The array index representing the second corner of the triangle.
	 * @param {number} i2 - The array index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given attribute values.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
	 * @param {number} i0 - The attribute index representing the first corner of the triangle.
	 * @param {number} i1 - The attribute index representing the second corner of the triangle.
	 * @param {number} i2 - The attribute index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    /**
	 * Returns a new triangle with copied values from this instance.
	 *
	 * @return {Triangle} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given triangle to this instance.
	 *
	 * @param {Triangle} triangle - The triangle to copy.
	 * @return {Triangle} A reference to this triangle.
	 */ copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    /**
	 * Computes the area of the triangle.
	 *
	 * @return {number} The triangle's area.
	 */ getArea() {
        $ce0cdebec9150cb3$var$_v0$2.subVectors(this.c, this.b);
        $ce0cdebec9150cb3$var$_v1$5.subVectors(this.a, this.b);
        return $ce0cdebec9150cb3$var$_v0$2.cross($ce0cdebec9150cb3$var$_v1$5).length() * 0.5;
    }
    /**
	 * Computes the midpoint of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's midpoint.
	 */ getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
	 * Computes the normal of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ getNormal(target) {
        return $ce0cdebec9150cb3$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    /**
	 * Computes a plane the triangle lies within.
	 *
	 * @param {Plane} target - The target vector that is used to store the method's result.
	 * @return {Plane} The plane the triangle lies within.
	 */ getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ getBarycoord(point, target) {
        return $ce0cdebec9150cb3$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ getInterpolation(point, v1, v2, v3, target) {
        return $ce0cdebec9150cb3$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ containsPoint(point) {
        return $ce0cdebec9150cb3$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ isFrontFacing(direction) {
        return $ce0cdebec9150cb3$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    /**
	 * Returns `true` if this triangle intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this triangle intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    /**
	 * Returns the closest point on the triangle to the given point.
	 *
	 * @param {Vector3} p - The point to compute the closest point for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the triangle.
	 */ closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $ce0cdebec9150cb3$var$_vab.subVectors(b, a);
        $ce0cdebec9150cb3$var$_vac.subVectors(c, a);
        $ce0cdebec9150cb3$var$_vap.subVectors(p, a);
        const d1 = $ce0cdebec9150cb3$var$_vab.dot($ce0cdebec9150cb3$var$_vap);
        const d2 = $ce0cdebec9150cb3$var$_vac.dot($ce0cdebec9150cb3$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $ce0cdebec9150cb3$var$_vbp.subVectors(p, b);
        const d3 = $ce0cdebec9150cb3$var$_vab.dot($ce0cdebec9150cb3$var$_vbp);
        const d4 = $ce0cdebec9150cb3$var$_vac.dot($ce0cdebec9150cb3$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($ce0cdebec9150cb3$var$_vab, v);
        }
        $ce0cdebec9150cb3$var$_vcp.subVectors(p, c);
        const d5 = $ce0cdebec9150cb3$var$_vab.dot($ce0cdebec9150cb3$var$_vcp);
        const d6 = $ce0cdebec9150cb3$var$_vac.dot($ce0cdebec9150cb3$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($ce0cdebec9150cb3$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $ce0cdebec9150cb3$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($ce0cdebec9150cb3$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($ce0cdebec9150cb3$var$_vab, v).addScaledVector($ce0cdebec9150cb3$var$_vac, w);
    }
    /**
	 * Returns `true` if this triangle is equal with the given one.
	 *
	 * @param {Triangle} triangle - The triangle to test for equality.
	 * @return {boolean} Whether this triangle is equal with the given one.
	 */ equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
/**
 * Represents an axis-aligned bounding box (AABB) in 3D space.
 */ class $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $ce0cdebec9150cb3$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $ce0cdebec9150cb3$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox3 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector3} min - The lower boundary of the box.
	 * @param {Vector3} max - The upper boundary of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<number>} array - An array holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($ce0cdebec9150cb3$var$_vector$b.fromArray(array, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($ce0cdebec9150cb3$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector3} center - The center of the box.
	 * @param {Vector3} size - The x, y and z dimensions of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $ce0cdebec9150cb3$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Computes the world-axis-aligned bounding box for the given 3D object
	 * (including its children), accounting for the object's, and children's,
	 * world transforms. The function may result in a larger box than strictly necessary.
	 *
	 * @param {Object3D} object - The 3D object to compute the bounding box for.
	 * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
	 * world-axis-aligned bounding box at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box3} box - The box to copy.
	 * @return {Box3} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 3D.
	 *
	 * @return {Box3} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector3} point - The point that should be included by the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions. The depth of this box will be
	 * expanded by the z component of the vector in both directions.
	 *
	 * @param {Vector3} vector - The vector that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Expands the boundaries of this box to include the given 3D object and
	 * its children, accounting for the object's, and children's, world
	 * transforms. The function may result in a larger box than strictly
	 * necessary (unless the precise parameter is set to true).
	 *
	 * @param {Object3D} object - The 3D object that should expand the bounding box.
	 * @param {boolean} precise - If set to `true`, the method expands the bounding box
	 * as little as necessary at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $ce0cdebec9150cb3$var$_vector$b);
                else $ce0cdebec9150cb3$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $ce0cdebec9150cb3$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($ce0cdebec9150cb3$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $ce0cdebec9150cb3$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $ce0cdebec9150cb3$var$_box$4.copy(geometry.boundingBox);
                }
                $ce0cdebec9150cb3$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($ce0cdebec9150cb3$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    /**
	 * Returns a point as a proportion of this box's width, height and depth.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A point as a proportion of this box's width, height and depth.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with this bounding box.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
	 */ intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $ce0cdebec9150cb3$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $ce0cdebec9150cb3$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Returns `true` if the given plane intersects with this bounding box.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether the given plane intersects with this bounding box.
	 */ intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    /**
	 * Returns `true` if the given triangle intersects with this bounding box.
	 *
	 * @param {Triangle} triangle - The triangle to test.
	 * @return {boolean} Whether the given triangle intersects with this bounding box.
	 */ intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($ce0cdebec9150cb3$var$_center);
        $ce0cdebec9150cb3$var$_extents.subVectors(this.max, $ce0cdebec9150cb3$var$_center);
        // translate triangle to aabb origin
        $ce0cdebec9150cb3$var$_v0$1.subVectors(triangle.a, $ce0cdebec9150cb3$var$_center);
        $ce0cdebec9150cb3$var$_v1$4.subVectors(triangle.b, $ce0cdebec9150cb3$var$_center);
        $ce0cdebec9150cb3$var$_v2$3.subVectors(triangle.c, $ce0cdebec9150cb3$var$_center);
        // compute edge vectors for triangle
        $ce0cdebec9150cb3$var$_f0.subVectors($ce0cdebec9150cb3$var$_v1$4, $ce0cdebec9150cb3$var$_v0$1);
        $ce0cdebec9150cb3$var$_f1.subVectors($ce0cdebec9150cb3$var$_v2$3, $ce0cdebec9150cb3$var$_v1$4);
        $ce0cdebec9150cb3$var$_f2.subVectors($ce0cdebec9150cb3$var$_v0$1, $ce0cdebec9150cb3$var$_v2$3);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$ce0cdebec9150cb3$var$_f0.z,
            $ce0cdebec9150cb3$var$_f0.y,
            0,
            -$ce0cdebec9150cb3$var$_f1.z,
            $ce0cdebec9150cb3$var$_f1.y,
            0,
            -$ce0cdebec9150cb3$var$_f2.z,
            $ce0cdebec9150cb3$var$_f2.y,
            $ce0cdebec9150cb3$var$_f0.z,
            0,
            -$ce0cdebec9150cb3$var$_f0.x,
            $ce0cdebec9150cb3$var$_f1.z,
            0,
            -$ce0cdebec9150cb3$var$_f1.x,
            $ce0cdebec9150cb3$var$_f2.z,
            0,
            -$ce0cdebec9150cb3$var$_f2.x,
            -$ce0cdebec9150cb3$var$_f0.y,
            $ce0cdebec9150cb3$var$_f0.x,
            0,
            -$ce0cdebec9150cb3$var$_f1.y,
            $ce0cdebec9150cb3$var$_f1.x,
            0,
            -$ce0cdebec9150cb3$var$_f2.y,
            $ce0cdebec9150cb3$var$_f2.x,
            0
        ];
        if (!$ce0cdebec9150cb3$var$satForAxes(axes, $ce0cdebec9150cb3$var$_v0$1, $ce0cdebec9150cb3$var$_v1$4, $ce0cdebec9150cb3$var$_v2$3, $ce0cdebec9150cb3$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$ce0cdebec9150cb3$var$satForAxes(axes, $ce0cdebec9150cb3$var$_v0$1, $ce0cdebec9150cb3$var$_v1$4, $ce0cdebec9150cb3$var$_v2$3, $ce0cdebec9150cb3$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $ce0cdebec9150cb3$var$_triangleNormal.crossVectors($ce0cdebec9150cb3$var$_f0, $ce0cdebec9150cb3$var$_f1);
        axes = [
            $ce0cdebec9150cb3$var$_triangleNormal.x,
            $ce0cdebec9150cb3$var$_triangleNormal.y,
            $ce0cdebec9150cb3$var$_triangleNormal.z
        ];
        return $ce0cdebec9150cb3$var$satForAxes(axes, $ce0cdebec9150cb3$var$_v0$1, $ce0cdebec9150cb3$var$_v1$4, $ce0cdebec9150cb3$var$_v2$3, $ce0cdebec9150cb3$var$_extents);
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector3} point - The point to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $ce0cdebec9150cb3$var$_vector$b).distanceTo(point);
    }
    /**
	 * Returns a bounding sphere that encloses this bounding box.
	 *
	 * @param {Sphere} target - The target sphere that is used to store the method's result.
	 * @return {Sphere} The bounding sphere that encloses this bounding box.
	 */ getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($ce0cdebec9150cb3$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box3} box - The bounding box to intersect with.
	 * @return {Box3} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box3} box - The bounding box that will be unioned with this instance.
	 * @return {Box3} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Transforms this bounding box by the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Box3} A reference to this bounding box.
	 */ applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $ce0cdebec9150cb3$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $ce0cdebec9150cb3$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $ce0cdebec9150cb3$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $ce0cdebec9150cb3$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $ce0cdebec9150cb3$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $ce0cdebec9150cb3$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $ce0cdebec9150cb3$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $ce0cdebec9150cb3$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($ce0cdebec9150cb3$var$_points);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 3D space.
	 *
	 * @param {Vector3} offset - The offset that should be used to translate the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box3} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @param {Object} json - The serialized json to set the box from.
	 * @return {Box3} A reference to this bounding box.
	 */ fromJSON(json) {
        this.min.fromArray(json.min);
        this.max.fromArray(json.max);
        return this;
    }
}
const $ce0cdebec9150cb3$var$_points = [
    /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699()
];
const $ce0cdebec9150cb3$var$_vector$b = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_box$4 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $ce0cdebec9150cb3$var$_v0$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v1$4 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v2$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
// triangle edge vectors
const $ce0cdebec9150cb3$var$_f0 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_f1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_f2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_center = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_extents = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_triangleNormal = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_testAxis = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
function $ce0cdebec9150cb3$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $ce0cdebec9150cb3$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($ce0cdebec9150cb3$var$_testAxis.x) + extents.y * Math.abs($ce0cdebec9150cb3$var$_testAxis.y) + extents.z * Math.abs($ce0cdebec9150cb3$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($ce0cdebec9150cb3$var$_testAxis);
        const p1 = v1.dot($ce0cdebec9150cb3$var$_testAxis);
        const p2 = v2.dot($ce0cdebec9150cb3$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $ce0cdebec9150cb3$var$_tables = /*@__PURE__*/ $ce0cdebec9150cb3$var$_generateTables();
function $ce0cdebec9150cb3$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
/**
 * Returns a half precision floating point value (FP16) from the given single
 * precision floating point value (FP32).
 *
 * @param {number} val - A single precision floating point value.
 * @return {number} The FP16 value.
 */ function $ce0cdebec9150cb3$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('DataUtils.toHalfFloat(): Value out of range.');
    val = $ce0cdebec9150cb3$var$clamp(val, -65504, 65504);
    $ce0cdebec9150cb3$var$_tables.floatView[0] = val;
    const f = $ce0cdebec9150cb3$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $ce0cdebec9150cb3$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $ce0cdebec9150cb3$var$_tables.shiftTable[e]);
}
/**
 * Returns a single precision floating point value (FP32) from the given half
 * precision floating point value (FP16).
 *
 * @param {number} val - A half precision floating point value.
 * @return {number} The FP32 value.
 */ function $ce0cdebec9150cb3$var$fromHalfFloat(val) {
    const m = val >> 10;
    $ce0cdebec9150cb3$var$_tables.uint32View[0] = $ce0cdebec9150cb3$var$_tables.mantissaTable[$ce0cdebec9150cb3$var$_tables.offsetTable[m] + (val & 0x3ff)] + $ce0cdebec9150cb3$var$_tables.exponentTable[m];
    return $ce0cdebec9150cb3$var$_tables.floatView[0];
}
/**
 * A class containing utility functions for data.
 *
 * @hideconstructor
 */ class $ce0cdebec9150cb3$export$11ce8b759162cc80 {
    /**
	 * Returns a half precision floating point value (FP16) from the given single
	 * precision floating point value (FP32).
	 *
	 * @param {number} val - A single precision floating point value.
	 * @return {number} The FP16 value.
	 */ static toHalfFloat(val) {
        return $ce0cdebec9150cb3$var$toHalfFloat(val);
    }
    /**
	 * Returns a single precision floating point value (FP32) from the given half
	 * precision floating point value (FP16).
	 *
	 * @param {number} val - A half precision floating point value.
	 * @return {number} The FP32 value.
	 */ static fromHalfFloat(val) {
        return $ce0cdebec9150cb3$var$fromHalfFloat(val);
    }
}
const $ce0cdebec9150cb3$var$_vector$a = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vector2$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
let $ce0cdebec9150cb3$var$_id$2 = 0;
/**
 * This class stores data for an attribute (such as vertex positions, face
 * indices, normals, colors, UVs, and any custom attributes ) associated with
 * a geometry, which allows for more efficient passing of data to the GPU.
 *
 * When working with vector-like data, the `fromBufferAttribute( attribute, index )`
 * helper methods on vector and color class might be helpful. E.g. {@link Vector3#fromBufferAttribute}.
 */ class $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferAttribute = true;
        /**
		 * The ID of the buffer attribute.
		 *
		 * @name BufferAttribute#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $ce0cdebec9150cb3$var$_id$2++
        });
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The array holding the attribute data. It should have `itemSize * numVertices`
		 * elements, where `numVertices` is the number of vertices in the associated geometry.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of values of the array that should be associated with a particular vertex.
		 * For instance, if this attribute is storing a 3-component vector (such as a position,
		 * normal, or color), then the value should be `3`.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * Represents the number of items this buffer attribute stores. It is internally computed
		 * by dividing the `array` length by the `itemSize`.
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / itemSize : 0;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `array` is an instance of `UInt16Array`,
		 * and `normalized` is `true`, the values `0 - +65535` in the array data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $ce0cdebec9150cb3$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * Configures the bound GPU type for use in shaders.
		 *
		 * Note: this only has an effect for integer arrays and is not configurable for float arrays.
		 * For lower precision float types, use `Float16BufferAttribute`.
		 *
		 * @type {(FloatType|IntType)}
		 * @default FloatType
		 */ this.gpuType = $ce0cdebec9150cb3$export$f6d331659b644596;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute
	 * array data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this buffer attribute.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {BufferAttribute} A reference to this buffer attribute.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given buffer attribute to this instance.
	 *
	 * @param {BufferAttribute} source - The buffer attribute to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    /**
	 * Copies a vector from the given buffer attribute to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this buffer attribute.
	 * @param {BufferAttribute} attribute - The buffer attribute to copy from.
	 * @param {number} index2 - The source index into the given buffer attribute.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    /**
	 * Copies the given array data into this buffer attribute.
	 *
	 * @param {(TypedArray|Array)} array - The array to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyArray(array) {
        this.array.set(array);
        return this;
    }
    /**
	 * Applies the given 3x3 matrix to the given attribute. Works with
	 * item size `2` and `3`.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $ce0cdebec9150cb3$var$_vector2$1.fromBufferAttribute(this, i);
            $ce0cdebec9150cb3$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $ce0cdebec9150cb3$var$_vector2$1.x, $ce0cdebec9150cb3$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $ce0cdebec9150cb3$var$_vector$a.fromBufferAttribute(this, i);
            $ce0cdebec9150cb3$var$_vector$a.applyMatrix3(m);
            this.setXYZ(i, $ce0cdebec9150cb3$var$_vector$a.x, $ce0cdebec9150cb3$var$_vector$a.y, $ce0cdebec9150cb3$var$_vector$a.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ce0cdebec9150cb3$var$_vector$a.fromBufferAttribute(this, i);
            $ce0cdebec9150cb3$var$_vector$a.applyMatrix4(m);
            this.setXYZ(i, $ce0cdebec9150cb3$var$_vector$a.x, $ce0cdebec9150cb3$var$_vector$a.y, $ce0cdebec9150cb3$var$_vector$a.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ce0cdebec9150cb3$var$_vector$a.fromBufferAttribute(this, i);
            $ce0cdebec9150cb3$var$_vector$a.applyNormalMatrix(m);
            this.setXYZ(i, $ce0cdebec9150cb3$var$_vector$a.x, $ce0cdebec9150cb3$var$_vector$a.y, $ce0cdebec9150cb3$var$_vector$a.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ce0cdebec9150cb3$var$_vector$a.fromBufferAttribute(this, i);
            $ce0cdebec9150cb3$var$_vector$a.transformDirection(m);
            this.setXYZ(i, $ce0cdebec9150cb3$var$_vector$a.x, $ce0cdebec9150cb3$var$_vector$a.y, $ce0cdebec9150cb3$var$_vector$a.z);
        }
        return this;
    }
    /**
	 * Sets the given array data in the buffer attribute.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this buffer attribute's array.
	 * @return {BufferAttribute} A reference to this instance.
	 */ set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $ce0cdebec9150cb3$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $ce0cdebec9150cb3$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $ce0cdebec9150cb3$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $ce0cdebec9150cb3$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $ce0cdebec9150cb3$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $ce0cdebec9150cb3$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $ce0cdebec9150cb3$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $ce0cdebec9150cb3$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $ce0cdebec9150cb3$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $ce0cdebec9150cb3$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ce0cdebec9150cb3$var$normalize(x, this.array);
            y = $ce0cdebec9150cb3$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ce0cdebec9150cb3$var$normalize(x, this.array);
            y = $ce0cdebec9150cb3$var$normalize(y, this.array);
            z = $ce0cdebec9150cb3$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ce0cdebec9150cb3$var$normalize(x, this.array);
            y = $ce0cdebec9150cb3$var$normalize(y, this.array);
            z = $ce0cdebec9150cb3$var$normalize(z, this.array);
            w = $ce0cdebec9150cb3$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the attribute array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when attribute data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {BufferAttribute} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * @return {BufferAttribute} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $ce0cdebec9150cb3$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
/**
 * Convenient class that can be used when creating a `Int8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$f9ff2d6a20248cbf extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$cacc90cf35d11cdd extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8Clamped` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$baaa85a1a812c157 extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8ClampedArray)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$2b755a102ccdcefe extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$640a853f68025f2e extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$46b369aed2968a0a extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$7eb8c9fa25cd5bd6 extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Float16` buffer attribute with
 * a plain `Array` instance.
 *
 * This class automatically converts to and from FP16 via `Uint16Array` since `Float16Array`
 * browser support is still problematic.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$dbd3698c64958d69 extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $ce0cdebec9150cb3$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $ce0cdebec9150cb3$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $ce0cdebec9150cb3$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $ce0cdebec9150cb3$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $ce0cdebec9150cb3$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $ce0cdebec9150cb3$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $ce0cdebec9150cb3$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $ce0cdebec9150cb3$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $ce0cdebec9150cb3$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $ce0cdebec9150cb3$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $ce0cdebec9150cb3$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $ce0cdebec9150cb3$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $ce0cdebec9150cb3$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $ce0cdebec9150cb3$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $ce0cdebec9150cb3$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $ce0cdebec9150cb3$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ce0cdebec9150cb3$var$normalize(x, this.array);
            y = $ce0cdebec9150cb3$var$normalize(y, this.array);
        }
        this.array[index + 0] = $ce0cdebec9150cb3$var$toHalfFloat(x);
        this.array[index + 1] = $ce0cdebec9150cb3$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ce0cdebec9150cb3$var$normalize(x, this.array);
            y = $ce0cdebec9150cb3$var$normalize(y, this.array);
            z = $ce0cdebec9150cb3$var$normalize(z, this.array);
        }
        this.array[index + 0] = $ce0cdebec9150cb3$var$toHalfFloat(x);
        this.array[index + 1] = $ce0cdebec9150cb3$var$toHalfFloat(y);
        this.array[index + 2] = $ce0cdebec9150cb3$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ce0cdebec9150cb3$var$normalize(x, this.array);
            y = $ce0cdebec9150cb3$var$normalize(y, this.array);
            z = $ce0cdebec9150cb3$var$normalize(z, this.array);
            w = $ce0cdebec9150cb3$var$normalize(w, this.array);
        }
        this.array[index + 0] = $ce0cdebec9150cb3$var$toHalfFloat(x);
        this.array[index + 1] = $ce0cdebec9150cb3$var$toHalfFloat(y);
        this.array[index + 2] = $ce0cdebec9150cb3$var$toHalfFloat(z);
        this.array[index + 3] = $ce0cdebec9150cb3$var$toHalfFloat(w);
        return this;
    }
}
/**
 * Convenient class that can be used when creating a `Float32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$cbe7a62641830ebd extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
const $ce0cdebec9150cb3$var$_box$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
const $ce0cdebec9150cb3$var$_v1$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v2$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * An analytical 3D sphere defined by a center and radius. This class is mainly
 * used as a Bounding Sphere for 3D objects.
 */ class $ce0cdebec9150cb3$export$805e8b72413ccaba {
    /**
	 * Constructs a new sphere.
	 *
	 * @param {Vector3} [center=(0,0,0)] - The center of the sphere
	 * @param {number} [radius=-1] - The radius of the sphere.
	 */ constructor(center = new $ce0cdebec9150cb3$export$64b5c384219d3699(), radius = -1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphere = true;
        /**
		 * The center of the sphere
		 *
		 * @type {Vector3}
		 */ this.center = center;
        /**
		 * The radius of the sphere.
		 *
		 * @type {number}
		 */ this.radius = radius;
    }
    /**
	 * Sets the sphere's components by copying the given values.
	 *
	 * @param {Vector3} center - The center.
	 * @param {number} radius - The radius.
	 * @return {Sphere} A reference to this sphere.
	 */ set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    /**
	 * Computes the minimum bounding sphere for list of points.
	 * If the optional center point is given, it is used as the sphere's
	 * center. Otherwise, the center of the axis-aligned bounding box
	 * encompassing the points is calculated.
	 *
	 * @param {Array<Vector3>} points - A list of points in 3D space.
	 * @param {Vector3} [optionalCenter] - The center of the sphere.
	 * @return {Sphere} A reference to this sphere.
	 */ setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $ce0cdebec9150cb3$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    /**
	 * Copies the values of the given sphere to this instance.
	 *
	 * @param {Sphere} sphere - The sphere to copy.
	 * @return {Sphere} A reference to this sphere.
	 */ copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    /**
	 * Returns `true` if the sphere is empty (the radius set to a negative number).
	 *
	 * Spheres with a radius of `0` contain only their center point and are not
	 * considered to be empty.
	 *
	 * @return {boolean} Whether this sphere is empty or not.
	 */ isEmpty() {
        return this.radius < 0;
    }
    /**
	 * Makes this sphere empty which means in encloses a zero space in 3D.
	 *
	 * @return {Sphere} A reference to this sphere.
	 */ makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    /**
	 * Returns `true` if this sphere contains the given point inclusive of
	 * the surface of the sphere.
	 *
	 * @param {Vector3} point - The point to check.
	 * @return {boolean} Whether this sphere contains the given point or not.
	 */ containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
	 * Returns the closest distance from the boundary of the sphere to the
	 * given point. If the sphere contains the point, the distance will
	 * be negative.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The distance to the point.
	 */ distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    /**
	 * Returns `true` if this sphere intersects with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test.
	 * @return {boolean} Whether this sphere intersects with the given one or not.
	 */ intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    /**
	 * Returns `true` if this sphere intersects with the given box.
	 *
	 * @param {Box3} box - The box to test.
	 * @return {boolean} Whether this sphere intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    /**
	 * Returns `true` if this sphere intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether this sphere intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    /**
	 * Clamps a point within the sphere. If the point is outside the sphere, it
	 * will clamp it to the closest point on the edge of the sphere. Points
	 * already inside the sphere will not be affected.
	 *
	 * @param {Vector3} point - The plane to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    /**
	 * Returns a bounding box that encloses this sphere.
	 *
	 * @param {Box3} target - The target box that is used to store the method's result.
	 * @return {Box3} The bounding box that encloses this sphere.
	 */ getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    /**
	 * Transforms this sphere with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Sphere} A reference to this sphere.
	 */ applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    /**
	 * Translates the sphere's center by the given offset.
	 *
	 * @param {Vector3} offset - The offset.
	 * @return {Sphere} A reference to this sphere.
	 */ translate(offset) {
        this.center.add(offset);
        return this;
    }
    /**
	 * Expands the boundaries of this sphere to include the given point.
	 *
	 * @param {Vector3} point - The point to include.
	 * @return {Sphere} A reference to this sphere.
	 */ expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $ce0cdebec9150cb3$var$_v1$3.subVectors(point, this.center);
        const lengthSq = $ce0cdebec9150cb3$var$_v1$3.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($ce0cdebec9150cb3$var$_v1$3, delta / length);
            this.radius += delta;
        }
        return this;
    }
    /**
	 * Expands this sphere to enclose both the original sphere and the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to include.
	 * @return {Sphere} A reference to this sphere.
	 */ union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $ce0cdebec9150cb3$var$_v2$2.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($ce0cdebec9150cb3$var$_v1$3.copy(sphere.center).add($ce0cdebec9150cb3$var$_v2$2));
            this.expandByPoint($ce0cdebec9150cb3$var$_v1$3.copy(sphere.center).sub($ce0cdebec9150cb3$var$_v2$2));
        }
        return this;
    }
    /**
	 * Returns `true` if this sphere is equal with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test for equality.
	 * @return {boolean} Whether this bounding sphere is equal with the given one.
	 */ equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    /**
	 * Returns a new sphere with copied values from this instance.
	 *
	 * @return {Sphere} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @param {Object} json - The serialized json to set the sphere from.
	 * @return {Sphere} A reference to this bounding sphere.
	 */ fromJSON(json) {
        this.radius = json.radius;
        this.center.fromArray(json.center);
        return this;
    }
}
let $ce0cdebec9150cb3$var$_id$1 = 0;
const $ce0cdebec9150cb3$var$_m1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_obj = /*@__PURE__*/ new $ce0cdebec9150cb3$export$e4dd07dff30cc924();
const $ce0cdebec9150cb3$var$_offset = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_box$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
const $ce0cdebec9150cb3$var$_boxMorphTargets = /*@__PURE__*/ new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
const $ce0cdebec9150cb3$var$_vector$9 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * A representation of mesh, line, or point geometry. Includes vertex
 * positions, face indices, normals, colors, UVs, and custom attributes
 * within buffers, reducing the cost of passing all this data to the GPU.
 *
 * ```js
 * const geometry = new THREE.BufferGeometry();
 * // create a simple square shape. We duplicate the top left and bottom right
 * // vertices because each vertex needs to appear once per triangle.
 * const vertices = new Float32Array( [
 * 	-1.0, -1.0,  1.0, // v0
 * 	 1.0, -1.0,  1.0, // v1
 * 	 1.0,  1.0,  1.0, // v2
 *
 * 	 1.0,  1.0,  1.0, // v3
 * 	-1.0,  1.0,  1.0, // v4
 * 	-1.0, -1.0,  1.0  // v5
 * ] );
 * // itemSize = 3 because there are 3 values (components) per vertex
 * geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
 * const material = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * ```
 *
 * @augments EventDispatcher
 */ class $ce0cdebec9150cb3$export$b7be63a67df8959 extends $ce0cdebec9150cb3$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferGeometry = true;
        /**
		 * The ID of the geometry.
		 *
		 * @name BufferGeometry#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $ce0cdebec9150cb3$var$_id$1++
        });
        /**
		 * The UUID of the geometry.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $ce0cdebec9150cb3$var$generateUUID();
        /**
		 * The name of the geometry.
		 *
		 * @type {string}
		 */ this.name = '';
        this.type = 'BufferGeometry';
        /**
		 * Allows for vertices to be re-used across multiple triangles; this is
		 * called using "indexed triangles". Each triangle is associated with the
		 * indices of three vertices. This attribute therefore stores the index of
		 * each vertex for each triangular face. If this attribute is not set, the
		 * renderer assumes that each three contiguous positions represent a single triangle.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.index = null;
        /**
		 * A (storage) buffer attribute which was generated with a compute shader and
		 * now defines indirect draw calls.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.indirect = null;
        /**
		 * The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {number|Array<number>}
		 * @default 0
		 */ this.indirectOffset = 0;
        /**
		 * This dictionary has as id the name of the attribute to be set and as value
		 * the buffer attribute to set it to. Rather than accessing this property directly,
		 * use `setAttribute()` and `getAttribute()` to access attributes of this geometry.
		 *
		 * @type {Object<string,(BufferAttribute|InterleavedBufferAttribute)>}
		 */ this.attributes = {};
        /**
		 * This dictionary holds the morph targets of the geometry.
		 *
		 * Note: Once the geometry has been rendered, the morph attribute data cannot
		 * be changed. You will have to call `dispose()`, and create a new geometry instance.
		 *
		 * @type {Object}
		 */ this.morphAttributes = {};
        /**
		 * Used to control the morph target behavior; when set to `true`, the morph
		 * target data is treated as relative offsets, rather than as absolute
		 * positions/normals.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.morphTargetsRelative = false;
        /**
		 * Split the geometry into groups, each of which will be rendered in a
		 * separate draw call. This allows an array of materials to be used with the geometry.
		 *
		 * Use `addGroup()` and `clearGroups()` to edit groups, rather than modifying this array directly.
		 *
		 * Every vertex and index must belong to exactly one group — groups must not share vertices or
		 * indices, and must not leave vertices or indices unused.
		 *
		 * @type {Array<Object>}
		 */ this.groups = [];
        /**
		 * Bounding box for the geometry which can be calculated with `computeBoundingBox()`.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * Bounding sphere for the geometry which can be calculated with `computeBoundingSphere()`.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Determines the part of the geometry to render. This should not be set directly,
		 * instead use `setDrawRange()`.
		 *
		 * @type {{start:number,count:number}}
		 */ this.drawRange = {
            start: 0,
            count: Infinity
        };
        /**
		 * An object that can be used to store custom data about the geometry.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * Returns the index of this geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
	 */ getIndex() {
        return this.index;
    }
    /**
	 * Sets the given index to this geometry.
	 *
	 * @param {Array<number>|BufferAttribute} index - The index to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndex(index) {
        if (Array.isArray(index)) this.index = new ($ce0cdebec9150cb3$var$arrayNeedsUint32(index) ? $ce0cdebec9150cb3$export$7eb8c9fa25cd5bd6 : $ce0cdebec9150cb3$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    /**
	 * Sets the given indirect attribute to this geometry.
	 *
	 * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
	 * @param {number|Array<number>} [indirectOffset=0] - The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndirect(indirect, indirectOffset = 0) {
        this.indirect = indirect;
        this.indirectOffset = indirectOffset;
        return this;
    }
    /**
	 * Returns the indirect attribute of this geometry.
	 *
	 * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
	 */ getIndirect() {
        return this.indirect;
    }
    /**
	 * Returns the buffer attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
	 * Returns `undefined` if not attribute has been found.
	 */ getAttribute(name) {
        return this.attributes[name];
    }
    /**
	 * Sets the given attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    /**
	 * Deletes the attribute for the given name.
	 *
	 * @param {string} name - The attribute name to delete.
	 * @return {BufferGeometry} A reference to this instance.
	 */ deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    /**
	 * Returns `true` if this geometry has an attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether this geometry has an attribute for the given name or not.
	 */ hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    /**
	 * Adds a group to this geometry.
	 *
	 * @param {number} start - The first element in this draw call. That is the first
	 * vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - Specifies how many vertices (or indices) are part of this group.
	 * @param {number} [materialIndex=0] - The material array index to use.
	 */ addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    /**
	 * Clears all groups.
	 */ clearGroups() {
        this.groups = [];
    }
    /**
	 * Sets the draw range for this geometry.
	 *
	 * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
	 * For indexed BufferGeometry, `count` is the number of indices to render.
	 */ setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    /**
	 * Applies the given 4x4 transformation matrix to the geometry.
	 *
	 * @param {Matrix4} matrix - The matrix to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $ce0cdebec9150cb3$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    /**
	 * Applies the rotation represented by the Quaternion to the geometry.
	 *
	 * @param {Quaternion} q - The Quaternion to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyQuaternion(q) {
        $ce0cdebec9150cb3$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($ce0cdebec9150cb3$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the X axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateX(angle) {
        // rotate geometry around world x-axis
        $ce0cdebec9150cb3$var$_m1.makeRotationX(angle);
        this.applyMatrix4($ce0cdebec9150cb3$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Y axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateY(angle) {
        // rotate geometry around world y-axis
        $ce0cdebec9150cb3$var$_m1.makeRotationY(angle);
        this.applyMatrix4($ce0cdebec9150cb3$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Z axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateZ(angle) {
        // rotate geometry around world z-axis
        $ce0cdebec9150cb3$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($ce0cdebec9150cb3$var$_m1);
        return this;
    }
    /**
	 * Translates the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#position} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x offset.
	 * @param {number} y - The y offset.
	 * @param {number} z - The z offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ translate(x, y, z) {
        // translate geometry
        $ce0cdebec9150cb3$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($ce0cdebec9150cb3$var$_m1);
        return this;
    }
    /**
	 * Scales the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#scale} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x scale.
	 * @param {number} y - The y scale.
	 * @param {number} z - The z scale.
	 * @return {BufferGeometry} A reference to this instance.
	 */ scale(x, y, z) {
        // scale geometry
        $ce0cdebec9150cb3$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($ce0cdebec9150cb3$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry to face a point in 3D space. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
	 * real-time mesh rotation.
	 *
	 * @param {Vector3} vector - The target point.
	 * @return {BufferGeometry} A reference to this instance.
	 */ lookAt(vector) {
        $ce0cdebec9150cb3$var$_obj.lookAt(vector);
        $ce0cdebec9150cb3$var$_obj.updateMatrix();
        this.applyMatrix4($ce0cdebec9150cb3$var$_obj.matrix);
        return this;
    }
    /**
	 * Center the geometry based on its bounding box.
	 *
	 * @return {BufferGeometry} A reference to this instance.
	 */ center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($ce0cdebec9150cb3$var$_offset).negate();
        this.translate($ce0cdebec9150cb3$var$_offset.x, $ce0cdebec9150cb3$var$_offset.y, $ce0cdebec9150cb3$var$_offset.z);
        return this;
    }
    /**
	 * Defines a geometry by creating a `position` attribute based on the given array of points. The array
	 * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
	 * set to `0`.
	 *
	 * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
	 * data from the array. The length of the array must match the vertex count.
	 *
	 * @param {Array<Vector2>|Array<Vector3>} points - The points.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(position, 3));
        } else {
            const l = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
            for(let i = 0; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    /**
	 * Computes the bounding box of the geometry, and updates the `boundingBox` member.
	 * The bounding box is not computed by the engine; it must be computed by your app.
	 * You may need to recompute the bounding box if the geometry vertices are modified.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            $ce0cdebec9150cb3$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $ce0cdebec9150cb3$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $ce0cdebec9150cb3$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $ce0cdebec9150cb3$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $ce0cdebec9150cb3$var$_vector$9.addVectors(this.boundingBox.min, $ce0cdebec9150cb3$var$_box$2.min);
                    this.boundingBox.expandByPoint($ce0cdebec9150cb3$var$_vector$9);
                    $ce0cdebec9150cb3$var$_vector$9.addVectors(this.boundingBox.max, $ce0cdebec9150cb3$var$_box$2.max);
                    this.boundingBox.expandByPoint($ce0cdebec9150cb3$var$_vector$9);
                } else {
                    this.boundingBox.expandByPoint($ce0cdebec9150cb3$var$_box$2.min);
                    this.boundingBox.expandByPoint($ce0cdebec9150cb3$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) $ce0cdebec9150cb3$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    /**
	 * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if the geometry vertices are modified.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $ce0cdebec9150cb3$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            $ce0cdebec9150cb3$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $ce0cdebec9150cb3$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $ce0cdebec9150cb3$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $ce0cdebec9150cb3$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $ce0cdebec9150cb3$var$_vector$9.addVectors($ce0cdebec9150cb3$var$_box$2.min, $ce0cdebec9150cb3$var$_boxMorphTargets.min);
                    $ce0cdebec9150cb3$var$_box$2.expandByPoint($ce0cdebec9150cb3$var$_vector$9);
                    $ce0cdebec9150cb3$var$_vector$9.addVectors($ce0cdebec9150cb3$var$_box$2.max, $ce0cdebec9150cb3$var$_boxMorphTargets.max);
                    $ce0cdebec9150cb3$var$_box$2.expandByPoint($ce0cdebec9150cb3$var$_vector$9);
                } else {
                    $ce0cdebec9150cb3$var$_box$2.expandByPoint($ce0cdebec9150cb3$var$_boxMorphTargets.min);
                    $ce0cdebec9150cb3$var$_box$2.expandByPoint($ce0cdebec9150cb3$var$_boxMorphTargets.max);
                }
            }
            $ce0cdebec9150cb3$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $ce0cdebec9150cb3$var$_vector$9.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($ce0cdebec9150cb3$var$_vector$9));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $ce0cdebec9150cb3$var$_vector$9.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $ce0cdebec9150cb3$var$_offset.fromBufferAttribute(position, j);
                        $ce0cdebec9150cb3$var$_vector$9.add($ce0cdebec9150cb3$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($ce0cdebec9150cb3$var$_vector$9));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) $ce0cdebec9150cb3$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    /**
	 * Calculates and adds a tangent attribute to this geometry.
	 *
	 * The computation is only supported for indexed geometries and if position, normal, and uv attributes
	 * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
	 * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
	 */ computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            $ce0cdebec9150cb3$export$a3bc9b8ed74fc('BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $ce0cdebec9150cb3$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            tan2[i] = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        }
        const vA = new $ce0cdebec9150cb3$export$64b5c384219d3699(), vB = new $ce0cdebec9150cb3$export$64b5c384219d3699(), vC = new $ce0cdebec9150cb3$export$64b5c384219d3699(), uvA = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(), uvB = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(), uvC = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(), sdir = new $ce0cdebec9150cb3$export$64b5c384219d3699(), tdir = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $ce0cdebec9150cb3$export$64b5c384219d3699(), tmp2 = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const n = new $ce0cdebec9150cb3$export$64b5c384219d3699(), n2 = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    /**
	 * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
	 * each vertex normal to be the average of the face normals of the faces that share that vertex.
	 * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
	 * to be the same as the face normal.
	 */ computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $ce0cdebec9150cb3$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $ce0cdebec9150cb3$export$64b5c384219d3699(), pB = new $ce0cdebec9150cb3$export$64b5c384219d3699(), pC = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const nA = new $ce0cdebec9150cb3$export$64b5c384219d3699(), nB = new $ce0cdebec9150cb3$export$64b5c384219d3699(), nC = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const cb = new $ce0cdebec9150cb3$export$64b5c384219d3699(), ab = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    /**
	 * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
	 * correct lighting on the geometry surfaces.
	 */ normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $ce0cdebec9150cb3$var$_vector$9.fromBufferAttribute(normals, i);
            $ce0cdebec9150cb3$var$_vector$9.normalize();
            normals.setXYZ(i, $ce0cdebec9150cb3$var$_vector$9.x, $ce0cdebec9150cb3$var$_vector$9.y, $ce0cdebec9150cb3$var$_vector$9.z);
        }
    }
    /**
	 * Return a new non-index version of this indexed geometry. If the geometry
	 * is already non-indexed, the method is a NOOP.
	 *
	 * @return {BufferGeometry} The non-indexed version of this indexed geometry.
	 */ toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $ce0cdebec9150cb3$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    /**
	 * Serializes the geometry into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized geometry.
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = boundingSphere.toJSON();
        return data;
    }
    /**
	 * Returns a new geometry with copied values from this instance.
	 *
	 * @return {BufferGeometry} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given geometry to this instance.
	 *
	 * @param {BufferGeometry} source - The geometry to copy.
	 * @return {BufferGeometry} A reference to this instance.
	 */ copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone());
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires BufferGeometry#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * "Interleaved" means that multiple attributes, possibly of different types,
 * (e.g., position, normal, uv, color) are packed into a single array buffer.
 *
 * An introduction into interleaved arrays can be found here: [Interleaved array basics](https://blog.tojicode.com/2011/05/interleaved-array-basics.html)
 */ class $ce0cdebec9150cb3$export$3d5cd879f108f53f {
    /**
	 * Constructs a new interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 */ constructor(array, stride){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBuffer = true;
        /**
		 * A typed array with a shared buffer storing attribute data.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of typed-array elements per vertex.
		 *
		 * @type {number}
		 */ this.stride = stride;
        /**
		 * The total number of elements in the array
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / stride : 0;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $ce0cdebec9150cb3$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
        /**
		 * The UUID of the interleaved buffer.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $ce0cdebec9150cb3$var$generateUUID();
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute array
	 * data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this interleaved buffer.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {InterleavedBuffer} A reference to this interleaved buffer.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given interleaved buffer to this instance.
	 *
	 * @param {InterleavedBuffer} source - The interleaved buffer to copy.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    /**
	 * Copies a vector from the given interleaved buffer to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this interleaved buffer.
	 * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
	 * @param {number} index2 - The source index into the given interleaved buffer.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copyAt(index1, interleavedBuffer, index2) {
        index1 *= this.stride;
        index2 *= interleavedBuffer.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = interleavedBuffer.array[index2 + i];
        return this;
    }
    /**
	 * Sets the given array data in the interleaved buffer.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this interleaved buffer's array.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns a new interleaved buffer with copied values from this instance.
	 *
	 * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
	 * @return {InterleavedBuffer} A clone of this instance.
	 */ clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $ce0cdebec9150cb3$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Serializes the interleaved buffer into JSON.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized interleaved buffer.
	 */ toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $ce0cdebec9150cb3$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $ce0cdebec9150cb3$var$_vector$8 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * An alternative version of a buffer attribute with interleaved data. Interleaved
 * attributes share a common interleaved data storage ({@link InterleavedBuffer}) and refer with
 * different offsets into the buffer.
 */ class $ce0cdebec9150cb3$export$920b6d07334599c7 {
    /**
	 * Constructs a new interleaved buffer attribute.
	 *
	 * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
	 * @param {number} itemSize - The item size.
	 * @param {number} offset - The attribute offset into the buffer.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(interleavedBuffer, itemSize, offset, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer holding the interleaved data.
		 *
		 * @type {InterleavedBuffer}
		 */ this.data = interleavedBuffer;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The attribute offset into the buffer.
		 *
		 * @type {number}
		 */ this.offset = offset;
        /**
		 * Whether the data are normalized or not, see {@link BufferAttribute#normalized}
		 *
		 * @type {InterleavedBuffer}
		 */ this.normalized = normalized;
    }
    /**
	 * The item count of this buffer attribute.
	 *
	 * @type {number}
	 * @readonly
	 */ get count() {
        return this.data.count;
    }
    /**
	 * The array holding the interleaved buffer attribute data.
	 *
	 * @type {TypedArray}
	 */ get array() {
        return this.data.array;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $ce0cdebec9150cb3$var$_vector$8.fromBufferAttribute(this, i);
            $ce0cdebec9150cb3$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $ce0cdebec9150cb3$var$_vector$8.x, $ce0cdebec9150cb3$var$_vector$8.y, $ce0cdebec9150cb3$var$_vector$8.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ce0cdebec9150cb3$var$_vector$8.fromBufferAttribute(this, i);
            $ce0cdebec9150cb3$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $ce0cdebec9150cb3$var$_vector$8.x, $ce0cdebec9150cb3$var$_vector$8.y, $ce0cdebec9150cb3$var$_vector$8.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ce0cdebec9150cb3$var$_vector$8.fromBufferAttribute(this, i);
            $ce0cdebec9150cb3$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $ce0cdebec9150cb3$var$_vector$8.x, $ce0cdebec9150cb3$var$_vector$8.y, $ce0cdebec9150cb3$var$_vector$8.z);
        }
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $ce0cdebec9150cb3$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $ce0cdebec9150cb3$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $ce0cdebec9150cb3$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $ce0cdebec9150cb3$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $ce0cdebec9150cb3$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $ce0cdebec9150cb3$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $ce0cdebec9150cb3$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $ce0cdebec9150cb3$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $ce0cdebec9150cb3$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $ce0cdebec9150cb3$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $ce0cdebec9150cb3$var$normalize(x, this.array);
            y = $ce0cdebec9150cb3$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $ce0cdebec9150cb3$var$normalize(x, this.array);
            y = $ce0cdebec9150cb3$var$normalize(y, this.array);
            z = $ce0cdebec9150cb3$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $ce0cdebec9150cb3$var$normalize(x, this.array);
            y = $ce0cdebec9150cb3$var$normalize(y, this.array);
            z = $ce0cdebec9150cb3$var$normalize(z, this.array);
            w = $ce0cdebec9150cb3$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
	 * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
	 */ clone(data) {
        if (data === undefined) {
            $ce0cdebec9150cb3$export$bef1f36f5486a6a3('InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $ce0cdebec9150cb3$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $ce0cdebec9150cb3$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON(data) {
        if (data === undefined) {
            $ce0cdebec9150cb3$export$bef1f36f5486a6a3('InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
let $ce0cdebec9150cb3$var$_materialId = 0;
/**
 * Abstract base class for materials.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $ce0cdebec9150cb3$export$a2d8b23205c25948 extends $ce0cdebec9150cb3$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterial = true;
        /**
		 * The ID of the material.
		 *
		 * @name Material#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $ce0cdebec9150cb3$var$_materialId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $ce0cdebec9150cb3$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Material';
        /**
		 * Defines the blending type of the material.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link Material#blendSrc}, {@link Material#blendDst} or {@link Material#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending)}
		 * @default NormalBlending
		 */ this.blending = $ce0cdebec9150cb3$export$5b29a26d96ee6af0;
        /**
		 * Defines which side of faces will be rendered - front, back or both.
		 *
		 * @type {(FrontSide|BackSide|DoubleSide)}
		 * @default FrontSide
		 */ this.side = $ce0cdebec9150cb3$export$2ede184fc2998901;
        /**
		 * If set to `true`, vertex colors should be used.
		 *
		 * The engine supports RGB and RGBA vertex colors depending on whether a three (RGB) or
		 * four (RGBA) component color buffer attribute is used.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.vertexColors = false;
        /**
		 * Defines how transparent the material is.
		 * A value of `0.0` indicates fully transparent, `1.0` is fully opaque.
		 *
		 * If the {@link Material#transparent} is not set to `true`,
		 * the material will remain fully opaque and this value will only affect its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.opacity = 1;
        /**
		 * Defines whether this material is transparent. This has an effect on
		 * rendering as transparent objects need special treatment and are rendered
		 * after non-transparent objects.
		 *
		 * When set to true, the extent to which the material is transparent is
		 * controlled by {@link Material#opacity}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = false;
        /**
		 * Enables alpha hashed transparency, an alternative to {@link Material#transparent} or
		 * {@link Material#alphaTest}. The material will not be rendered if opacity is lower than
		 * a random threshold. Randomization introduces some grain or noise, but approximates alpha
		 * blending without the associated problems of sorting. Using TAA can reduce the resulting noise.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaHash = false;
        /**
		 * Defines the blending source factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ this.blendSrc = $ce0cdebec9150cb3$export$d5773124e86cf28c;
        /**
		 * Defines the blending destination factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendDst = $ce0cdebec9150cb3$export$11d468cc7f19e971;
        /**
		 * Defines the blending equation.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default AddEquation
		 */ this.blendEquation = $ce0cdebec9150cb3$export$20183a0484ce21a0;
        /**
		 * Defines the blending source alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * @type {?(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default null
		 */ this.blendEquationAlpha = null;
        /**
		 * Represents the RGB values of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantColor` or `OneMinusConstantColor`.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.blendColor = new $ce0cdebec9150cb3$export$892596cec99bc70e(0, 0, 0);
        /**
		 * Represents the alpha value of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantAlpha` or `OneMinusConstantAlpha`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blendAlpha = 0;
        /**
		 * Defines the depth function.
		 *
		 * @type {(NeverDepth|AlwaysDepth|LessDepth|LessEqualDepth|EqualDepth|GreaterEqualDepth|GreaterDepth|NotEqualDepth)}
		 * @default LessEqualDepth
		 */ this.depthFunc = $ce0cdebec9150cb3$export$296f78a0b892f81a;
        /**
		 * Whether to have depth test enabled when rendering this material.
		 * When the depth test is disabled, the depth write will also be implicitly disabled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthTest = true;
        /**
		 * Whether rendering this material has any effect on the depth buffer.
		 *
		 * When drawing 2D overlays it can be useful to disable the depth writing in
		 * order to layer several things together without creating z-index artifacts.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthWrite = true;
        /**
		 * The bit mask to use when writing to the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilWriteMask = 0xff;
        /**
		 * The stencil comparison function to use.
		 *
		 * @type {NeverStencilFunc|LessStencilFunc|EqualStencilFunc|LessEqualStencilFunc|GreaterStencilFunc|NotEqualStencilFunc|GreaterEqualStencilFunc|AlwaysStencilFunc}
		 * @default AlwaysStencilFunc
		 */ this.stencilFunc = $ce0cdebec9150cb3$export$14cf96713ddd97a8;
        /**
		 * The value to use when performing stencil comparisons or stencil operations.
		 *
		 * @type {number}
		 * @default 0
		 */ this.stencilRef = 0;
        /**
		 * The bit mask to use when comparing against the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilFuncMask = 0xff;
        /**
		 * Which stencil operation to perform when the comparison function returns `false`.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilFail = $ce0cdebec9150cb3$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` but the depth test fails.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZFail = $ce0cdebec9150cb3$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` and the depth test passes.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZPass = $ce0cdebec9150cb3$export$9f542ae4b5baca34;
        /**
		 * Whether stencil operations are performed against the stencil buffer. In
		 * order to perform writes or comparisons against the stencil buffer this
		 * value must be `true`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilWrite = false;
        /**
		 * User-defined clipping planes specified as THREE.Plane objects in world
		 * space. These planes apply to the objects this material is attached to.
		 * Points in space whose signed distance to the plane is negative are clipped
		 * (not rendered). This requires {@link WebGLRenderer#localClippingEnabled} to
		 * be `true`.
		 *
		 * @type {?Array<Plane>}
		 * @default null
		 */ this.clippingPlanes = null;
        /**
		 * Changes the behavior of clipping planes so that only their intersection is
		 * clipped, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Defines whether to clip shadows according to the clipping planes specified
		 * on this material.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
        /**
		 * Defines which side of faces cast shadows. If `null`, the side casting shadows
		 * is determined as follows:
		 *
		 * - When {@link Material#side} is set to `FrontSide`, the back side cast shadows.
		 * - When {@link Material#side} is set to `BackSide`, the front side cast shadows.
		 * - When {@link Material#side} is set to `DoubleSide`, both sides cast shadows.
		 *
		 * @type {?(FrontSide|BackSide|DoubleSide)}
		 * @default null
		 */ this.shadowSide = null;
        /**
		 * Whether to render the material's color.
		 *
		 * This can be used in conjunction with {@link Object3D#renderOder} to create invisible
		 * objects that occlude other objects.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.colorWrite = true;
        /**
		 * Override the renderer's default precision for this material.
		 *
		 * @type {?('highp'|'mediump'|'lowp')}
		 * @default null
		 */ this.precision = null;
        /**
		 * Whether to use polygon offset or not. When enabled, each fragment's depth value will
		 * be offset after it is interpolated from the depth values of the appropriate vertices.
		 * The offset is added before the depth test is performed and before the value is written
		 * into the depth buffer.
		 *
		 * Can be useful for rendering hidden-line images, for applying decals to surfaces, and for
		 * rendering solids with highlighted edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.polygonOffset = false;
        /**
		 * Specifies a scale factor that is used to create a variable depth offset for each polygon.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetFactor = 0;
        /**
		 * Is multiplied by an implementation-specific value to create a constant depth offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetUnits = 0;
        /**
		 * Whether to apply dithering to the color to remove the appearance of banding.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dithering = false;
        /**
		 * Whether alpha to coverage should be enabled or not. Can only be used with MSAA-enabled contexts
		 * (meaning when the renderer was created with *antialias* parameter set to `true`). Enabling this
		 * will smooth aliasing on clip plane edges and alphaTest-clipped edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaToCoverage = false;
        /**
		 * Whether to premultiply the alpha (transparency) value.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultipliedAlpha = false;
        /**
		 * Whether double-sided, transparent objects should be rendered with a single pass or not.
		 *
		 * The engine renders double-sided, transparent objects with two draw calls (back faces first,
		 * then front faces) to mitigate transparency artifacts. There are scenarios however where this
		 * approach produces no quality gains but still doubles draw calls e.g. when rendering flat
		 * vegetation like grass sprites. In these cases, set the `forceSinglePass` flag to `true` to
		 * disable the two pass rendering to avoid performance issues.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.forceSinglePass = false;
        /**
		 * Whether it's possible to override the material with {@link Scene#overrideMaterial} or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.allowOverride = true;
        /**
		 * Defines whether 3D objects using this material are visible.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * Defines whether this material is tone mapped according to the renderer's tone mapping setting.
		 *
		 * It is ignored when rendering to a render target or using post processing or when using
		 * `WebGPURenderer`. In all these cases, all materials are honored by tone mapping.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.toneMapped = true;
        /**
		 * An object that can be used to store custom data about the Material. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Material#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        this._alphaTest = 0;
    }
    /**
	 * Sets the alpha value to be used when running an alpha test. The material
	 * will not be rendered if the opacity is lower than this value.
	 *
	 * @type {number}
	 * @readonly
	 * @default 0
	 */ get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    /**
	 * An optional callback that is executed immediately before the material is used to render a 3D object.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Object3D} object - The 3D object.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * An optional callback that is executed immediately before the shader
	 * program is compiled. This function is called with the shader source code
	 * as a parameter. Useful for the modification of built-in materials.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}. The
	 * recommended approach when customizing materials is to use `WebGPURenderer` with the new
	 * Node Material system and [TSL](https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language).
	 *
	 * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
	 * @param {WebGLRenderer} renderer - A reference to the renderer.
	 */ onBeforeCompile() {}
    /**
	 * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
	 * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
	 * shader or recompile the shader for this material as needed.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @return {string} The custom program cache key.
	 */ customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    /**
	 * This method can be used to set default values from parameter objects.
	 * It is a generic implementation so it can be used with different types
	 * of materials.
	 *
	 * @param {Object} [values] - The material values to set.
	 */ setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                $ce0cdebec9150cb3$export$c106dd0671a0fc2d(`Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                $ce0cdebec9150cb3$export$c106dd0671a0fc2d(`Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the material into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized material.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.7,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.sheenColorMap && this.sheenColorMap.isTexture) data.sheenColorMap = this.sheenColorMap.toJSON(meta).uuid;
        if (this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture) data.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(meta).uuid;
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $ce0cdebec9150cb3$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $ce0cdebec9150cb3$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $ce0cdebec9150cb3$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $ce0cdebec9150cb3$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $ce0cdebec9150cb3$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $ce0cdebec9150cb3$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $ce0cdebec9150cb3$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $ce0cdebec9150cb3$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $ce0cdebec9150cb3$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $ce0cdebec9150cb3$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.allowOverride === false) data.allowOverride = false;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    /**
	 * Returns a new material with copied values from this instance.
	 *
	 * @return {Material} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given material to this instance.
	 *
	 * @param {Material} source - The material to copy.
	 * @return {Material} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.allowOverride = source.allowOverride;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Material#dispose
	 */ dispose() {
        /**
		 * Fires when the material has been disposed of.
		 *
		 * @event Material#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Setting this property to `true` indicates the engine the material
	 * needs to be recompiled.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
/**
 * A material for rendering instances of {@link Sprite}.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'textures/sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map, color: 0xffffff } );
 *
 * const sprite = new THREE.Sprite( material );
 * sprite.scale.set(200, 200, 1)
 * scene.add( sprite );
 * ```
 *
 * @augments Material
 */ class $ce0cdebec9150cb3$export$5ec7dd1c6994bf8e extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new sprite material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The rotation of the sprite in radians.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Specifies whether size of the sprite is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Overwritten since sprite materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $ce0cdebec9150cb3$var$_geometry;
const $ce0cdebec9150cb3$var$_intersectPoint = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_worldScale = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_mvPosition = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_alignedPosition = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
const $ce0cdebec9150cb3$var$_rotatedPosition = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
const $ce0cdebec9150cb3$var$_viewWorldMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_vA$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vB$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vC$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_uvA = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
const $ce0cdebec9150cb3$var$_uvB = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
const $ce0cdebec9150cb3$var$_uvC = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
/**
 * A sprite is a plane that always faces towards the camera, generally with a
 * partially transparent texture applied.
 *
 * Sprites do not cast shadows, setting {@link Object3D#castShadow} to `true` will
 * have no effect.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map } );
 *
 * const sprite = new THREE.Sprite( material );
 * scene.add( sprite );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$3075603db8e6204c extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new sprite.
	 *
	 * @param {(SpriteMaterial|SpriteNodeMaterial)} [material] - The sprite material.
	 */ constructor(material = new $ce0cdebec9150cb3$export$5ec7dd1c6994bf8e()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSprite = true;
        this.type = 'Sprite';
        if ($ce0cdebec9150cb3$var$_geometry === undefined) {
            $ce0cdebec9150cb3$var$_geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $ce0cdebec9150cb3$export$3d5cd879f108f53f(float32Array, 5);
            $ce0cdebec9150cb3$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $ce0cdebec9150cb3$var$_geometry.setAttribute('position', new $ce0cdebec9150cb3$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $ce0cdebec9150cb3$var$_geometry.setAttribute('uv', new $ce0cdebec9150cb3$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        /**
		 * The sprite geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = $ce0cdebec9150cb3$var$_geometry;
        /**
		 * The sprite material.
		 *
		 * @type {(SpriteMaterial|SpriteNodeMaterial)}
		 */ this.material = material;
        /**
		 * The sprite's anchor point, and the point around which the sprite rotates.
		 * A value of `(0.5, 0.5)` corresponds to the midpoint of the sprite. A value
		 * of `(0, 0)` corresponds to the lower left corner of the sprite.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ this.center = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0.5, 0.5);
        /**
		 * The number of instances of this sprite.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
    }
    /**
	 * Computes intersection points between a casted ray and this sprite.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        if (raycaster.camera === null) $ce0cdebec9150cb3$export$a3bc9b8ed74fc('Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $ce0cdebec9150cb3$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $ce0cdebec9150cb3$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $ce0cdebec9150cb3$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $ce0cdebec9150cb3$var$_worldScale.multiplyScalar(-$ce0cdebec9150cb3$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $ce0cdebec9150cb3$var$transformVertex($ce0cdebec9150cb3$var$_vA$1.set(-0.5, -0.5, 0), $ce0cdebec9150cb3$var$_mvPosition, center, $ce0cdebec9150cb3$var$_worldScale, sin, cos);
        $ce0cdebec9150cb3$var$transformVertex($ce0cdebec9150cb3$var$_vB$1.set(0.5, -0.5, 0), $ce0cdebec9150cb3$var$_mvPosition, center, $ce0cdebec9150cb3$var$_worldScale, sin, cos);
        $ce0cdebec9150cb3$var$transformVertex($ce0cdebec9150cb3$var$_vC$1.set(0.5, 0.5, 0), $ce0cdebec9150cb3$var$_mvPosition, center, $ce0cdebec9150cb3$var$_worldScale, sin, cos);
        $ce0cdebec9150cb3$var$_uvA.set(0, 0);
        $ce0cdebec9150cb3$var$_uvB.set(1, 0);
        $ce0cdebec9150cb3$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($ce0cdebec9150cb3$var$_vA$1, $ce0cdebec9150cb3$var$_vB$1, $ce0cdebec9150cb3$var$_vC$1, false, $ce0cdebec9150cb3$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $ce0cdebec9150cb3$var$transformVertex($ce0cdebec9150cb3$var$_vB$1.set(-0.5, 0.5, 0), $ce0cdebec9150cb3$var$_mvPosition, center, $ce0cdebec9150cb3$var$_worldScale, sin, cos);
            $ce0cdebec9150cb3$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($ce0cdebec9150cb3$var$_vA$1, $ce0cdebec9150cb3$var$_vC$1, $ce0cdebec9150cb3$var$_vB$1, false, $ce0cdebec9150cb3$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($ce0cdebec9150cb3$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $ce0cdebec9150cb3$var$_intersectPoint.clone(),
            uv: $ce0cdebec9150cb3$export$5a465592bfe74b48.getInterpolation($ce0cdebec9150cb3$var$_intersectPoint, $ce0cdebec9150cb3$var$_vA$1, $ce0cdebec9150cb3$var$_vB$1, $ce0cdebec9150cb3$var$_vC$1, $ce0cdebec9150cb3$var$_uvA, $ce0cdebec9150cb3$var$_uvB, $ce0cdebec9150cb3$var$_uvC, new $ce0cdebec9150cb3$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $ce0cdebec9150cb3$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $ce0cdebec9150cb3$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $ce0cdebec9150cb3$var$_rotatedPosition.x = cos * $ce0cdebec9150cb3$var$_alignedPosition.x - sin * $ce0cdebec9150cb3$var$_alignedPosition.y;
        $ce0cdebec9150cb3$var$_rotatedPosition.y = sin * $ce0cdebec9150cb3$var$_alignedPosition.x + cos * $ce0cdebec9150cb3$var$_alignedPosition.y;
    } else $ce0cdebec9150cb3$var$_rotatedPosition.copy($ce0cdebec9150cb3$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $ce0cdebec9150cb3$var$_rotatedPosition.x;
    vertexPosition.y += $ce0cdebec9150cb3$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($ce0cdebec9150cb3$var$_viewWorldMatrix);
}
const $ce0cdebec9150cb3$var$_v1$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v2$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * A component for providing a basic Level of Detail (LOD) mechanism.
 *
 * Every LOD level is associated with an object, and rendering can be switched
 * between them at the distances specified. Typically you would create, say,
 * three meshes, one for far away (low detail), one for mid range (medium
 * detail) and one for close up (high detail).
 *
 * ```js
 * const lod = new THREE.LOD();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 *
 * //Create spheres with 3 levels of detail and create new LOD levels for them
 * for( let i = 0; i < 3; i++ ) {
 *
 * 	const geometry = new THREE.IcosahedronGeometry( 10, 3 - i );
 * 	const mesh = new THREE.Mesh( geometry, material );
 * 	lod.addLevel( mesh, i * 75 );
 *
 * }
 *
 * scene.add( lod );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$112e7237be0c5f30 extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new LOD.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLOD = true;
        /**
		 * The current LOD index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            /**
			 * This array holds the LOD levels.
			 *
			 * @name LOD#levels
			 * @type {Array<{object:Object3D,distance:number,hysteresis:number}>}
			 */ levels: {
                enumerable: true,
                value: []
            }
        });
        /**
		 * Whether the LOD object is updated automatically by the renderer per frame
		 * or not. If set to `false`, you have to call {@link LOD#update} in the
		 * render loop by yourself.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    /**
	 * Adds a mesh that will display at a certain distance and greater. Typically
	 * the further away the distance, the lower the detail on the mesh.
	 *
	 * @param {Object3D} object - The 3D object to display at this level.
	 * @param {number} [distance=0] - The distance at which to display this level of detail.
	 * @param {number} [hysteresis=0] - Threshold used to avoid flickering at LOD boundaries, as a fraction of distance.
	 * @return {LOD} A reference to this instance.
	 */ addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    /**
	 * Removes an existing level, based on the distance from the camera.
	 * Returns `true` when the level has been removed. Otherwise `false`.
	 *
	 * @param {number} distance - Distance of the level to remove.
	 * @return {boolean} Whether the level has been removed or not.
	 */ removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    /**
	 * Returns the currently active LOD level index.
	 *
	 * @return {number} The current active LOD level index.
	 */ getCurrentLevel() {
        return this._currentLevel;
    }
    /**
	 * Returns a reference to the first 3D object that is greater than
	 * the given distance.
	 *
	 * @param {number} distance - The LOD distance.
	 * @return {?Object3D} The found 3D object. `null` if no 3D object has been found.
	 */ getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    /**
	 * Computes intersection points between a casted ray and this LOD.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $ce0cdebec9150cb3$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($ce0cdebec9150cb3$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    /**
	 * Updates the LOD by computing which LOD level should be visible according
	 * to the current distance of the given camera.
	 *
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $ce0cdebec9150cb3$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $ce0cdebec9150cb3$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $ce0cdebec9150cb3$var$_v1$2.distanceTo($ce0cdebec9150cb3$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $ce0cdebec9150cb3$var$_vector$7 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_segCenter = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_segDir = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_diff = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_edge1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_edge2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_normal$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * A ray that emits from an origin in a certain direction. The class is used by
 * {@link Raycaster} to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3D space the mouse is over)
 * amongst other things.
 */ class $ce0cdebec9150cb3$export$a186db52eed6d40e {
    /**
	 * Constructs a new ray.
	 *
	 * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
	 * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
	 */ constructor(origin = new $ce0cdebec9150cb3$export$64b5c384219d3699(), direction = new $ce0cdebec9150cb3$export$64b5c384219d3699(0, 0, -1)){
        /**
		 * The origin of the ray.
		 *
		 * @type {Vector3}
		 */ this.origin = origin;
        /**
		 * The (normalized) direction of the ray.
		 *
		 * @type {Vector3}
		 */ this.direction = direction;
    }
    /**
	 * Sets the ray's components by copying the given values.
	 *
	 * @param {Vector3} origin - The origin.
	 * @param {Vector3} direction - The direction.
	 * @return {Ray} A reference to this ray.
	 */ set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    /**
	 * Copies the values of the given ray to this instance.
	 *
	 * @param {Ray} ray - The ray to copy.
	 * @return {Ray} A reference to this ray.
	 */ copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    /**
	 * Returns a vector that is located at a given distance along this ray.
	 *
	 * @param {number} t - The distance along the ray to retrieve a position for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A position on the ray.
	 */ at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    /**
	 * Adjusts the direction of the ray to point at the given vector in world space.
	 *
	 * @param {Vector3} v - The target position.
	 * @return {Ray} A reference to this ray.
	 */ lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    /**
	 * Shift the origin of this ray along its direction by the given distance.
	 *
	 * @param {number} t - The distance along the ray to interpolate.
	 * @return {Ray} A reference to this ray.
	 */ recast(t) {
        this.origin.copy(this.at(t, $ce0cdebec9150cb3$var$_vector$7));
        return this;
    }
    /**
	 * Returns the point along this ray that is closest to the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on this ray.
	 */ closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    /**
	 * Returns the distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The distance.
	 */ distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    /**
	 * Returns the squared distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The squared distance.
	 */ distanceSqToPoint(point) {
        const directionDistance = $ce0cdebec9150cb3$var$_vector$7.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $ce0cdebec9150cb3$var$_vector$7.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $ce0cdebec9150cb3$var$_vector$7.distanceToSquared(point);
    }
    /**
	 * Returns the squared distance between this ray and the given line segment.
	 *
	 * @param {Vector3} v0 - The start point of the line segment.
	 * @param {Vector3} v1 - The end point of the line segment.
	 * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
	 * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
	 * @return {number} The squared distance.
	 */ distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $ce0cdebec9150cb3$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $ce0cdebec9150cb3$var$_segDir.copy(v1).sub(v0).normalize();
        $ce0cdebec9150cb3$var$_diff.copy(this.origin).sub($ce0cdebec9150cb3$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($ce0cdebec9150cb3$var$_segDir);
        const b0 = $ce0cdebec9150cb3$var$_diff.dot(this.direction);
        const b1 = -$ce0cdebec9150cb3$var$_diff.dot($ce0cdebec9150cb3$var$_segDir);
        const c = $ce0cdebec9150cb3$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($ce0cdebec9150cb3$var$_segCenter).addScaledVector($ce0cdebec9150cb3$var$_segDir, s1);
        return sqrDist;
    }
    /**
	 * Intersects this ray with the given sphere, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectSphere(sphere, target) {
        $ce0cdebec9150cb3$var$_vector$7.subVectors(sphere.center, this.origin);
        const tca = $ce0cdebec9150cb3$var$_vector$7.dot(this.direction);
        const d2 = $ce0cdebec9150cb3$var$_vector$7.dot($ce0cdebec9150cb3$var$_vector$7) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @return {boolean} Whether this ray intersects with the given sphere or not.
	 */ intersectsSphere(sphere) {
        if (sphere.radius < 0) return false; // handle empty spheres, see #31187
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
	 * does not intersect with the plane.
	 *
	 * @param {Plane} plane - The plane to compute the distance to.
	 * @return {?number} Whether this ray intersects with the given sphere or not.
	 */ distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    /**
	 * Intersects this ray with the given plane, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @return {boolean} Whether this ray intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    /**
	 * Intersects this ray with the given bounding box, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this ray intersects with the given box or not.
	 */ intersectsBox(box) {
        return this.intersectBox(box, $ce0cdebec9150cb3$var$_vector$7) !== null;
    }
    /**
	 * Intersects this ray with the given triangle, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Vector3} a - The first vertex of the triangle.
	 * @param {Vector3} b - The second vertex of the triangle.
	 * @param {Vector3} c - The third vertex of the triangle.
	 * @param {boolean} backfaceCulling - Whether to use backface culling or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $ce0cdebec9150cb3$var$_edge1.subVectors(b, a);
        $ce0cdebec9150cb3$var$_edge2.subVectors(c, a);
        $ce0cdebec9150cb3$var$_normal$1.crossVectors($ce0cdebec9150cb3$var$_edge1, $ce0cdebec9150cb3$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($ce0cdebec9150cb3$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $ce0cdebec9150cb3$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($ce0cdebec9150cb3$var$_edge2.crossVectors($ce0cdebec9150cb3$var$_diff, $ce0cdebec9150cb3$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($ce0cdebec9150cb3$var$_edge1.cross($ce0cdebec9150cb3$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $ce0cdebec9150cb3$var$_diff.dot($ce0cdebec9150cb3$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    /**
	 * Transforms this ray with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix4 - The transformation matrix.
	 * @return {Ray} A reference to this ray.
	 */ applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    /**
	 * Returns `true` if this ray is equal with the given one.
	 *
	 * @param {Ray} ray - The ray to test for equality.
	 * @return {boolean} Whether this ray is equal with the given one.
	 */ equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
	 * Returns a new ray with copied values from this instance.
	 *
	 * @return {Ray} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * A material for drawing geometries in a simple shaded (flat or wireframe) way.
 *
 * This material is not affected by lights.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshBasicMaterial
 */ class $ce0cdebec9150cb3$export$55cbcc9b622fe1f5 extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $ce0cdebec9150cb3$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $ce0cdebec9150cb3$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
const $ce0cdebec9150cb3$var$_inverseMatrix$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_ray$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$a186db52eed6d40e();
const $ce0cdebec9150cb3$var$_sphere$6 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$805e8b72413ccaba();
const $ce0cdebec9150cb3$var$_sphereHitAt = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vA = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vB = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vC = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_tempA = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_morphA = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_intersectionPoint = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_intersectionPointWorld = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * Class representing triangular polygon mesh based objects.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$e176487c05830cc5 extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959(), material = new $ce0cdebec9150cb3$export$55cbcc9b622fe1f5()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMesh = true;
        this.type = 'Mesh';
        /**
		 * The mesh geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The mesh material.
		 *
		 * @type {Material|Array<Material>}
		 * @default MeshBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        /**
		 * The number of instances of this mesh.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Returns the local-space position of the vertex at the given index, taking into
	 * account the current animation state of both morph targets and skinning.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * @return {Vector3} The vertex position in local space.
	 */ getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $ce0cdebec9150cb3$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $ce0cdebec9150cb3$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $ce0cdebec9150cb3$var$_morphA.addScaledVector($ce0cdebec9150cb3$var$_tempA, influence);
                else $ce0cdebec9150cb3$var$_morphA.addScaledVector($ce0cdebec9150cb3$var$_tempA.sub(target), influence);
            }
            target.add($ce0cdebec9150cb3$var$_morphA);
        }
        return target;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $ce0cdebec9150cb3$var$_sphere$6.copy(geometry.boundingSphere);
        $ce0cdebec9150cb3$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $ce0cdebec9150cb3$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($ce0cdebec9150cb3$var$_sphere$6.containsPoint($ce0cdebec9150cb3$var$_ray$3.origin) === false) {
            if ($ce0cdebec9150cb3$var$_ray$3.intersectSphere($ce0cdebec9150cb3$var$_sphere$6, $ce0cdebec9150cb3$var$_sphereHitAt) === null) return;
            if ($ce0cdebec9150cb3$var$_ray$3.origin.distanceToSquared($ce0cdebec9150cb3$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $ce0cdebec9150cb3$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $ce0cdebec9150cb3$var$_ray$3.copy(raycaster.ray).applyMatrix4($ce0cdebec9150cb3$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($ce0cdebec9150cb3$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $ce0cdebec9150cb3$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $ce0cdebec9150cb3$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $ce0cdebec9150cb3$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $ce0cdebec9150cb3$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $ce0cdebec9150cb3$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $ce0cdebec9150cb3$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $ce0cdebec9150cb3$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $ce0cdebec9150cb3$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $ce0cdebec9150cb3$var$_intersectionPointWorld.copy(point);
    $ce0cdebec9150cb3$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($ce0cdebec9150cb3$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $ce0cdebec9150cb3$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $ce0cdebec9150cb3$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $ce0cdebec9150cb3$var$_vA);
    object.getVertexPosition(b, $ce0cdebec9150cb3$var$_vB);
    object.getVertexPosition(c, $ce0cdebec9150cb3$var$_vC);
    const intersection = $ce0cdebec9150cb3$var$checkIntersection$1(object, material, raycaster, ray, $ce0cdebec9150cb3$var$_vA, $ce0cdebec9150cb3$var$_vB, $ce0cdebec9150cb3$var$_vC, $ce0cdebec9150cb3$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        $ce0cdebec9150cb3$export$5a465592bfe74b48.getBarycoord($ce0cdebec9150cb3$var$_intersectionPoint, $ce0cdebec9150cb3$var$_vA, $ce0cdebec9150cb3$var$_vB, $ce0cdebec9150cb3$var$_vC, barycoord);
        if (uv) intersection.uv = $ce0cdebec9150cb3$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $ce0cdebec9150cb3$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $ce0cdebec9150cb3$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $ce0cdebec9150cb3$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $ce0cdebec9150cb3$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $ce0cdebec9150cb3$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $ce0cdebec9150cb3$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $ce0cdebec9150cb3$export$5a465592bfe74b48.getNormal($ce0cdebec9150cb3$var$_vA, $ce0cdebec9150cb3$var$_vB, $ce0cdebec9150cb3$var$_vC, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
const $ce0cdebec9150cb3$var$_basePosition = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_skinIndex = /*@__PURE__*/ new $ce0cdebec9150cb3$export$fa7daccca11cdbe3();
const $ce0cdebec9150cb3$var$_skinWeight = /*@__PURE__*/ new $ce0cdebec9150cb3$export$fa7daccca11cdbe3();
const $ce0cdebec9150cb3$var$_vector3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_matrix4 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_vertex = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_sphere$5 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$805e8b72413ccaba();
const $ce0cdebec9150cb3$var$_inverseMatrix$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_ray$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$a186db52eed6d40e();
/**
 * A mesh that has a {@link Skeleton} that can then be used to animate the
 * vertices of the geometry with skinning/skeleton animation.
 *
 * Next to a valid skeleton, the skinned mesh requires skin indices and weights
 * as buffer attributes in its geometry. These attribute define which bones affect a single
 * vertex to a certain extend.
 *
 * Typically skinned meshes are not created manually but loaders like {@link GLTFLoader}
 * or {@link FBXLoader } import respective models.
 *
 * @augments Mesh
 * @demo scenes/bones-browser.html
 */ class $ce0cdebec9150cb3$export$b303577035157ecf extends $ce0cdebec9150cb3$export$e176487c05830cc5 {
    /**
	 * Constructs a new skinned mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        /**
		 * `AttachedBindMode` means the skinned mesh shares the same world space as the skeleton.
		 * This is not true when using `DetachedBindMode` which is useful when sharing a skeleton
		 * across multiple skinned meshes.
		 *
		 * @type {(AttachedBindMode|DetachedBindMode)}
		 * @default AttachedBindMode
		 */ this.bindMode = $ce0cdebec9150cb3$export$2595a3798997538;
        /**
		 * The base matrix that is used for the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrix = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
        /**
		 * The base matrix that is used for resetting the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrixInverse = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
        /**
		 * The bounding box of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
    }
    /**
	 * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
	 * the current animation state.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $ce0cdebec9150cb3$var$_vertex);
            this.boundingBox.expandByPoint($ce0cdebec9150cb3$var$_vertex);
        }
    }
    /**
	 * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
	 * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
	 * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
	 * per frame in order to reflect the current animation state.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $ce0cdebec9150cb3$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $ce0cdebec9150cb3$var$_vertex);
            this.boundingSphere.expandByPoint($ce0cdebec9150cb3$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $ce0cdebec9150cb3$var$_sphere$5.copy(this.boundingSphere);
        $ce0cdebec9150cb3$var$_sphere$5.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($ce0cdebec9150cb3$var$_sphere$5) === false) return;
        // convert ray to local space of skinned mesh
        $ce0cdebec9150cb3$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $ce0cdebec9150cb3$var$_ray$2.copy(raycaster.ray).applyMatrix4($ce0cdebec9150cb3$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($ce0cdebec9150cb3$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $ce0cdebec9150cb3$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    /**
	 * Binds the given skeleton to the skinned mesh.
	 *
	 * @param {Skeleton} skeleton - The skeleton to bind.
	 * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
	 * the skinned mesh's world matrix will be used instead.
	 */ bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    /**
	 * This method sets the skinned mesh in the rest pose).
	 */ pose() {
        this.skeleton.pose();
    }
    /**
	 * Normalizes the skin weights which are defined as a buffer attribute
	 * in the skinned mesh's geometry.
	 */ normalizeSkinWeights() {
        const vector = new $ce0cdebec9150cb3$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $ce0cdebec9150cb3$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $ce0cdebec9150cb3$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else $ce0cdebec9150cb3$export$c106dd0671a0fc2d('SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    /**
	 * Applies the bone transform associated with the given index to the given
	 * vertex position. Returns the updated vector.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * the skinned mesh's world matrix will be used instead.
	 * @return {Vector3} The updated vertex position.
	 */ applyBoneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $ce0cdebec9150cb3$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $ce0cdebec9150cb3$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $ce0cdebec9150cb3$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $ce0cdebec9150cb3$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $ce0cdebec9150cb3$var$_skinIndex.getComponent(i);
                $ce0cdebec9150cb3$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($ce0cdebec9150cb3$var$_vector3.copy($ce0cdebec9150cb3$var$_basePosition).applyMatrix4($ce0cdebec9150cb3$var$_matrix4), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
/**
 * A bone which is part of a {@link Skeleton}. The skeleton in turn is used by
 * the {@link SkinnedMesh}.
 *
 * ```js
 * const root = new THREE.Bone();
 * const child = new THREE.Bone();
 *
 * root.add( child );
 * child.position.y = 5;
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$b127726e56765aa4 extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new bone.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBone = true;
        this.type = 'Bone';
    }
}
/**
 * Creates a texture directly from raw buffer data.
 *
 * The interpretation of the data depends on type and format: If the type is
 * `UnsignedByteType`, a `Uint8Array` will be useful for addressing the
 * texel data. If the format is `RGBAFormat`, data needs four values for
 * one texel; Red, Green, Blue and Alpha (typically the opacity).
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$b691f601014eabe1 extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Constructs a new data texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0, minFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height
        };
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
const $ce0cdebec9150cb3$var$_offsetMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_identityMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
/**
 * Class for representing the armatures in `three.js`. The skeleton
 * is defined by a hierarchy of bones.
 *
 * ```js
 * const bones = [];
 *
 * const shoulder = new THREE.Bone();
 * const elbow = new THREE.Bone();
 * const hand = new THREE.Bone();
 *
 * shoulder.add( elbow );
 * elbow.add( hand );
 *
 * bones.push( shoulder , elbow, hand);
 *
 * shoulder.position.y = -5;
 * elbow.position.y = 0;
 * hand.position.y = 5;
 *
 * const armSkeleton = new THREE.Skeleton( bones );
 * ```
 */ class $ce0cdebec9150cb3$export$8f31e4c4a37b8e9c {
    /**
	 * Constructs a new skeleton.
	 *
	 * @param {Array<Bone>} [bones] - An array of bones.
	 * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
	 * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
	 */ constructor(bones = [], boneInverses = []){
        this.uuid = $ce0cdebec9150cb3$var$generateUUID();
        /**
		 * An array of bones defining the skeleton.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones.slice(0);
        /**
		 * An array of bone inverse matrices.
		 *
		 * @type {Array<Matrix4>}
		 */ this.boneInverses = boneInverses;
        /**
		 * An array buffer holding the bone data.
		 * Input data for {@link Skeleton#boneTexture}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.boneMatrices = null;
        /**
		 * An array buffer holding the bone data of the previous frame.
		 * Required for computing velocity. Maintained in {@link SkinningNode}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.previousBoneMatrices = null;
        /**
		 * A texture holding the bone data for use
		 * in the vertex shader.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.boneTexture = null;
        this.init();
    }
    /**
	 * Initializes the skeleton. This method gets automatically called by the constructor
	 * but depending on how the skeleton is created it might be necessary to call this method
	 * manually.
	 */ init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $ce0cdebec9150cb3$export$2ae72fc923e5eb5());
        }
    }
    /**
	 * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
	 * and fills it with new matrices.
	 */ calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $ce0cdebec9150cb3$var$_identityMatrix;
            $ce0cdebec9150cb3$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $ce0cdebec9150cb3$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    /**
	 * Returns a new skeleton with copied values from this instance.
	 *
	 * @return {Skeleton} A clone of this instance.
	 */ clone() {
        return new $ce0cdebec9150cb3$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    /**
	 * Computes a data texture for passing bone data to the vertex shader.
	 *
	 * @return {Skeleton} A reference of this instance.
	 */ computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $ce0cdebec9150cb3$export$b691f601014eabe1(boneMatrices, size, size, $ce0cdebec9150cb3$export$3f8bb04b555a363c, $ce0cdebec9150cb3$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    /**
	 * Searches through the skeleton's bone array and returns the first with a
	 * matching name.
	 *
	 * @param {string} name - The name of the bone.
	 * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
	 */ getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    /**
	 * Setups the skeleton by the given JSON and bones.
	 *
	 * @param {Object} json - The skeleton as serialized JSON.
	 * @param {Object<string, Bone>} bones - An array of bones.
	 * @return {Skeleton} A reference of this instance.
	 */ fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Skeleton: No bone found with UUID:', uuid);
                bone = new $ce0cdebec9150cb3$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $ce0cdebec9150cb3$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    /**
	 * Serializes the skeleton into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized skeleton.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
/**
 * An instanced version of a buffer attribute.
 *
 * @augments BufferAttribute
 */ class $ce0cdebec9150cb3$export$32ea87a8b54d744a extends $ce0cdebec9150cb3$export$8dea267bd6bde117 {
    /**
	 * Constructs a new instanced buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
	 */ constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferAttribute = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated. A
		 * value of one means that each value of the instanced attribute is used for
		 * a single instance. A value of two means that each value is used for two
		 * consecutive instances (and so on).
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $ce0cdebec9150cb3$var$_instanceLocalMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_instanceWorldMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_instanceIntersects = [];
const $ce0cdebec9150cb3$var$_box3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
const $ce0cdebec9150cb3$var$_identity = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_mesh$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$e176487c05830cc5();
const $ce0cdebec9150cb3$var$_sphere$4 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$805e8b72413ccaba();
/**
 * A special version of a mesh with instanced rendering support. Use
 * this class if you have to render a large number of objects with the same
 * geometry and material(s) but with different world transformations. The usage
 * of 'InstancedMesh' will help you to reduce the number of draw calls and thus
 * improve the overall rendering performance in your application.
 *
 * @augments Mesh
 */ class $ce0cdebec9150cb3$export$f3c979c331175ad7 extends $ce0cdebec9150cb3$export$e176487c05830cc5 {
    /**
	 * Constructs a new instanced mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 * @param {number} count - The number of instances.
	 */ constructor(geometry, material, count){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedMesh = true;
        /**
		 * Represents the local transformation of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMatrixAt}.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = new $ce0cdebec9150cb3$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        /**
		 * Represents the local transformation of all instances of the previous frame.
		 * Required for computing velocity. Maintained in {@link InstanceNode}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.previousInstanceMatrix = null;
        /**
		 * Represents the color of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setColorAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.instanceColor = null;
        /**
		 * Represents the morph target weights of all instances. You have to set its
		 * {@link Texture#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMorphAt}.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.morphTexture = null;
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * The bounding box of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $ce0cdebec9150cb3$var$_identity);
    }
    /**
	 * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $ce0cdebec9150cb3$var$_instanceLocalMatrix);
            $ce0cdebec9150cb3$var$_box3.copy(geometry.boundingBox).applyMatrix4($ce0cdebec9150cb3$var$_instanceLocalMatrix);
            this.boundingBox.union($ce0cdebec9150cb3$var$_box3);
        }
    }
    /**
	 * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $ce0cdebec9150cb3$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $ce0cdebec9150cb3$var$_instanceLocalMatrix);
            $ce0cdebec9150cb3$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($ce0cdebec9150cb3$var$_instanceLocalMatrix);
            this.boundingSphere.union($ce0cdebec9150cb3$var$_sphere$4);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.previousInstanceMatrix !== null) this.previousInstanceMatrix = source.previousInstanceMatrix.clone();
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    /**
	 * Gets the color of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The target object that is used to store the method's result.
	 */ getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Gets the local transformation matrix of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 */ getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Gets the morph target weights of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object - The target object that is used to store the method's result.
	 */ getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $ce0cdebec9150cb3$var$_mesh$1.geometry = this.geometry;
        $ce0cdebec9150cb3$var$_mesh$1.material = this.material;
        if ($ce0cdebec9150cb3$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $ce0cdebec9150cb3$var$_sphere$4.copy(this.boundingSphere);
        $ce0cdebec9150cb3$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($ce0cdebec9150cb3$var$_sphere$4) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $ce0cdebec9150cb3$var$_instanceLocalMatrix);
            $ce0cdebec9150cb3$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $ce0cdebec9150cb3$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $ce0cdebec9150cb3$var$_mesh$1.matrixWorld = $ce0cdebec9150cb3$var$_instanceWorldMatrix;
            $ce0cdebec9150cb3$var$_mesh$1.raycast(raycaster, $ce0cdebec9150cb3$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $ce0cdebec9150cb3$var$_instanceIntersects.length; i < l; i++){
                const intersect = $ce0cdebec9150cb3$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $ce0cdebec9150cb3$var$_instanceIntersects.length = 0;
        }
    }
    /**
	 * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The instance color.
	 */ setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $ce0cdebec9150cb3$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The local transformation.
	 */ setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
	 * of a single instance.
	 */ setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $ce0cdebec9150cb3$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $ce0cdebec9150cb3$export$4e041a7967d15c4b, $ce0cdebec9150cb3$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
    }
}
const $ce0cdebec9150cb3$var$_vector1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vector2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_normalMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$8ff26dafa08918();
/**
 * A two dimensional surface that extends infinitely in 3D space, represented
 * in [Hessian normal form](http://mathworld.wolfram.com/HessianNormalForm.html)
 * by a unit length normal vector and a constant.
 */ class $ce0cdebec9150cb3$export$7ff5ac152ef991b0 {
    /**
	 * Constructs a new plane.
	 *
	 * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
	 * @param {number} [constant=0] - The signed distance from the origin to the plane.
	 */ constructor(normal = new $ce0cdebec9150cb3$export$64b5c384219d3699(1, 0, 0), constant = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPlane = true;
        /**
		 * A unit length vector defining the normal of the plane.
		 *
		 * @type {Vector3}
		 */ this.normal = normal;
        /**
		 * The signed distance from the origin to the plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.constant = constant;
    }
    /**
	 * Sets the plane components by copying the given values.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {number} constant - The constant.
	 * @return {Plane} A reference to this plane.
	 */ set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    /**
	 * Sets the plane components by defining `x`, `y`, `z` as the
	 * plane normal and `w` as the constant.
	 *
	 * @param {number} x - The value for the normal's x component.
	 * @param {number} y - The value for the normal's y component.
	 * @param {number} z - The value for the normal's z component.
	 * @param {number} w - The constant value.
	 * @return {Plane} A reference to this plane.
	 */ setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    /**
	 * Sets the plane from the given normal and coplanar point (that is a point
	 * that lies onto the plane).
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Vector3} point - A coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    /**
	 * Sets the plane from three coplanar points. The winding order is
	 * assumed to be counter-clockwise, and determines the direction of
	 * the plane normal.
	 *
	 * @param {Vector3} a - The first coplanar point.
	 * @param {Vector3} b - The second coplanar point.
	 * @param {Vector3} c - The third coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromCoplanarPoints(a, b, c) {
        const normal = $ce0cdebec9150cb3$var$_vector1.subVectors(c, b).cross($ce0cdebec9150cb3$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    /**
	 * Copies the values of the given plane to this instance.
	 *
	 * @param {Plane} plane - The plane to copy.
	 * @return {Plane} A reference to this plane.
	 */ copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    /**
	 * Normalizes the plane normal and adjusts the constant accordingly.
	 *
	 * @return {Plane} A reference to this plane.
	 */ normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    /**
	 * Negates both the plane normal and the constant.
	 *
	 * @return {Plane} A reference to this plane.
	 */ negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    /**
	 * Returns the signed distance from the given point to this plane.
	 *
	 * @param {Vector3} point - The point to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    /**
	 * Returns the signed distance from the given sphere to this plane.
	 *
	 * @param {Sphere} sphere - The sphere to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    /**
	 * Projects a the given point onto the plane.
	 *
	 * @param {Vector3} point - The point to project.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The projected point on the plane.
	 */ projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    /**
	 * Returns the intersection point of the passed line and the plane. Returns
	 * `null` if the line does not intersect. Returns the line's starting point if
	 * the line is coplanar with the plane.
	 *
	 * @param {Line3} line - The line to compute the intersection for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectLine(line, target) {
        const direction = line.delta($ce0cdebec9150cb3$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    /**
	 * Returns `true` if the given line segment intersects with (passes through) the plane.
	 *
	 * @param {Line3} line - The line to test.
	 * @return {boolean} Whether the given line segment intersects with the plane or not.
	 */ intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    /**
	 * Returns `true` if the given bounding box intersects with the plane.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with the plane or not.
	 */ intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with the plane.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
	 */ intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    /**
	 * Returns a coplanar vector to the plane, by calculating the
	 * projection of the normal at the origin onto the plane.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The coplanar point.
	 */ coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
	 * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
	 *
	 * The optional normal matrix can be pre-computed like so:
	 * ```js
	 * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
	 * ```
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
	 * @return {Plane} A reference to this plane.
	 */ applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $ce0cdebec9150cb3$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($ce0cdebec9150cb3$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    /**
	 * Translates the plane by the distance defined by the given offset vector.
	 * Note that this only affects the plane constant and will not affect the normal vector.
	 *
	 * @param {Vector3} offset - The offset vector.
	 * @return {Plane} A reference to this plane.
	 */ translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    /**
	 * Returns `true` if this plane is equal with the given one.
	 *
	 * @param {Plane} plane - The plane to test for equality.
	 * @return {boolean} Whether this plane is equal with the given one.
	 */ equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    /**
	 * Returns a new plane with copied values from this instance.
	 *
	 * @return {Plane} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $ce0cdebec9150cb3$var$_sphere$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$805e8b72413ccaba();
const $ce0cdebec9150cb3$var$_defaultSpriteCenter = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0.5, 0.5);
const $ce0cdebec9150cb3$var$_vector$6 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * Frustums are used to determine what is inside the camera's field of view.
 * They help speed up the rendering process - objects which lie outside a camera's
 * frustum can safely be excluded from rendering.
 *
 * This class is mainly intended for use internally by a renderer.
 */ class $ce0cdebec9150cb3$export$35efe6f4c85463d2 {
    /**
	 * Constructs a new frustum.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 */ constructor(p0 = new $ce0cdebec9150cb3$export$7ff5ac152ef991b0(), p1 = new $ce0cdebec9150cb3$export$7ff5ac152ef991b0(), p2 = new $ce0cdebec9150cb3$export$7ff5ac152ef991b0(), p3 = new $ce0cdebec9150cb3$export$7ff5ac152ef991b0(), p4 = new $ce0cdebec9150cb3$export$7ff5ac152ef991b0(), p5 = new $ce0cdebec9150cb3$export$7ff5ac152ef991b0()){
        /**
		 * This array holds the planes that enclose the frustum.
		 *
		 * @type {Array<Plane>}
		 */ this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    /**
	 * Sets the frustum planes by copying the given planes.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 * @return {Frustum} A reference to this frustum.
	 */ set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    /**
	 * Copies the values of the given frustum to this instance.
	 *
	 * @param {Frustum} frustum - The frustum to copy.
	 * @return {Frustum} A reference to this frustum.
	 */ copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    /**
	 * Sets the frustum planes from the given projection matrix.
	 *
	 * @param {Matrix4} m - The projection matrix.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Frustum} A reference to this frustum.
	 */ setFromProjectionMatrix(m, coordinateSystem = $ce0cdebec9150cb3$export$5a0e9190d10875d3, reversedDepth = false) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        if (reversedDepth) {
            planes[4].setComponents(me2, me6, me10, me14).normalize(); // far
            planes[5].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // near
        } else {
            planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // far
            if (coordinateSystem === $ce0cdebec9150cb3$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize(); // near
            else if (coordinateSystem === $ce0cdebec9150cb3$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize(); // near
            else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        }
        return this;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
	 *
	 * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
	 */ intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $ce0cdebec9150cb3$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $ce0cdebec9150cb3$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($ce0cdebec9150cb3$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given sprite is intersecting this frustum.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @return {boolean} Whether the sprite is intersecting this frustum or not.
	 */ intersectsSprite(sprite) {
        $ce0cdebec9150cb3$var$_sphere$3.center.set(0, 0, 0);
        const offset = $ce0cdebec9150cb3$var$_defaultSpriteCenter.distanceTo(sprite.center);
        $ce0cdebec9150cb3$var$_sphere$3.radius = 0.7071067811865476 + offset;
        $ce0cdebec9150cb3$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($ce0cdebec9150cb3$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting this frustum.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
	 */ intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given bounding box is intersecting this frustum.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box is intersecting this frustum or not.
	 */ intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $ce0cdebec9150cb3$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $ce0cdebec9150cb3$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $ce0cdebec9150cb3$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($ce0cdebec9150cb3$var$_vector$6) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given point lies within the frustum.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the point lies within this frustum or not.
	 */ containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns a new frustum with copied values from this instance.
	 *
	 * @return {Frustum} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $ce0cdebec9150cb3$var$_projScreenMatrix$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_frustum$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$35efe6f4c85463d2();
/**
 * FrustumArray is used to determine if an object is visible in at least one camera
 * from an array of cameras. This is particularly useful for multi-view renderers.
*/ class $ce0cdebec9150cb3$export$2d7d04327620499c {
    /**
	 * Constructs a new frustum array.
	 *
	 */ constructor(){
        /**
		 * The coordinate system to use.
		 *
		 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
		 * @default WebGLCoordinateSystem
		 */ this.coordinateSystem = $ce0cdebec9150cb3$export$5a0e9190d10875d3;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the 3D object is visible in any camera.
	 */ intersectsObject(object, cameraArray) {
        if (!cameraArray.isArrayCamera || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $ce0cdebec9150cb3$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $ce0cdebec9150cb3$var$_frustum$1.setFromProjectionMatrix($ce0cdebec9150cb3$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($ce0cdebec9150cb3$var$_frustum$1.intersectsObject(object)) return true; // Object is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given sprite is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sprite is visible in any camera.
	 */ intersectsSprite(sprite, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $ce0cdebec9150cb3$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $ce0cdebec9150cb3$var$_frustum$1.setFromProjectionMatrix($ce0cdebec9150cb3$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($ce0cdebec9150cb3$var$_frustum$1.intersectsSprite(sprite)) return true; // Sprite is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sphere is visible in any camera.
	 */ intersectsSphere(sphere, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $ce0cdebec9150cb3$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $ce0cdebec9150cb3$var$_frustum$1.setFromProjectionMatrix($ce0cdebec9150cb3$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($ce0cdebec9150cb3$var$_frustum$1.intersectsSphere(sphere)) return true; // Sphere is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding box is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the box is visible in any camera.
	 */ intersectsBox(box, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $ce0cdebec9150cb3$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $ce0cdebec9150cb3$var$_frustum$1.setFromProjectionMatrix($ce0cdebec9150cb3$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($ce0cdebec9150cb3$var$_frustum$1.intersectsBox(box)) return true; // Box is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given point lies within any frustum
	 * from the camera array.
	 *
	 * @param {Vector3} point - The point to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the point is visible in any camera.
	 */ containsPoint(point, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $ce0cdebec9150cb3$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $ce0cdebec9150cb3$var$_frustum$1.setFromProjectionMatrix($ce0cdebec9150cb3$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($ce0cdebec9150cb3$var$_frustum$1.containsPoint(point)) return true; // Point is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns a new frustum array with copied values from this instance.
	 *
	 * @return {FrustumArray} A clone of this instance.
	 */ clone() {
        return new $ce0cdebec9150cb3$export$2d7d04327620499c();
    }
}
function $ce0cdebec9150cb3$var$ascIdSort(a, b) {
    return a - b;
}
function $ce0cdebec9150cb3$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $ce0cdebec9150cb3$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $ce0cdebec9150cb3$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $ce0cdebec9150cb3$var$_matrix$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_whiteColor = /*@__PURE__*/ new $ce0cdebec9150cb3$export$892596cec99bc70e(1, 1, 1);
const $ce0cdebec9150cb3$var$_frustum = /*@__PURE__*/ new $ce0cdebec9150cb3$export$35efe6f4c85463d2();
const $ce0cdebec9150cb3$var$_frustumArray = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2d7d04327620499c();
const $ce0cdebec9150cb3$var$_box$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
const $ce0cdebec9150cb3$var$_sphere$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$805e8b72413ccaba();
const $ce0cdebec9150cb3$var$_vector$5 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_forward$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_temp = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_renderList = /*@__PURE__*/ new $ce0cdebec9150cb3$var$MultiDrawRenderList();
const $ce0cdebec9150cb3$var$_mesh = /*@__PURE__*/ new $ce0cdebec9150cb3$export$e176487c05830cc5();
const $ce0cdebec9150cb3$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $ce0cdebec9150cb3$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $ce0cdebec9150cb3$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
/**
 * A special version of a mesh with multi draw batch rendering support. Use
 * this class if you have to render a large number of objects with the same
 * material but with different geometries or world transformations. The usage of
 * `BatchedMesh` will help you to reduce the number of draw calls and thus improve the overall
 * rendering performance in your application.
 *
 * ```js
 * const box = new THREE.BoxGeometry( 1, 1, 1 );
 * const sphere = new THREE.SphereGeometry( 1, 12, 12 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 *
 * // initialize and add geometries into the batched mesh
 * const batchedMesh = new BatchedMesh( 10, 5000, 10000, material );
 * const boxGeometryId = batchedMesh.addGeometry( box );
 * const sphereGeometryId = batchedMesh.addGeometry( sphere );
 *
 * // create instances of those geometries
 * const boxInstancedId1 = batchedMesh.addInstance( boxGeometryId );
 * const boxInstancedId2 = batchedMesh.addInstance( boxGeometryId );
 *
 * const sphereInstancedId1 = batchedMesh.addInstance( sphereGeometryId );
 * const sphereInstancedId2 = batchedMesh.addInstance( sphereGeometryId );
 *
 * // position the geometries
 * batchedMesh.setMatrixAt( boxInstancedId1, boxMatrix1 );
 * batchedMesh.setMatrixAt( boxInstancedId2, boxMatrix2 );
 *
 * batchedMesh.setMatrixAt( sphereInstancedId1, sphereMatrix1 );
 * batchedMesh.setMatrixAt( sphereInstancedId2, sphereMatrix2 );
 *
 * scene.add( batchedMesh );
 * ```
 *
 * @augments Mesh
 */ class $ce0cdebec9150cb3$export$6e01c5ee52ed8f7b extends $ce0cdebec9150cb3$export$e176487c05830cc5 {
    /**
	 * Constructs a new batched mesh.
	 *
	 * @param {number} maxInstanceCount - The maximum number of individual instances planned to be added and rendered.
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries.
	 * @param {number} [maxIndexCount=maxVertexCount*2] - The maximum number of indices to be used by all unique geometries
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $ce0cdebec9150cb3$export$b7be63a67df8959(), material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBatchedMesh = true;
        /**
		 * When set ot `true`, the individual objects of a batch are frustum culled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.perObjectFrustumCulled = true;
        /**
		 * When set to `true`, the individual objects of a batch are sorted to improve overdraw-related artifacts.
		 * If the material is marked as "transparent" objects are rendered back to front and if not then they are
		 * rendered front to back.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * The bounding box of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Takes a sort a function that is run before render. The function takes a list of instances to
		 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered
		 * sort with.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    /**
	 * The maximum number of individual instances that can be stored in the batch.
	 *
	 * @type {number}
	 * @readonly
	 */ get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    /**
	 * The instance count.
	 *
	 * @type {number}
	 * @readonly
	 */ get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    /**
	 * The number of unused vertices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    /**
	 * The number of unused indices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $ce0cdebec9150cb3$export$b691f601014eabe1(matricesArray, size, size, $ce0cdebec9150cb3$export$3f8bb04b555a363c, $ce0cdebec9150cb3$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $ce0cdebec9150cb3$export$b691f601014eabe1(indirectArray, size, size, $ce0cdebec9150cb3$export$aa92e870a709d190, $ce0cdebec9150cb3$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $ce0cdebec9150cb3$export$b691f601014eabe1(colorsArray, size, size, $ce0cdebec9150cb3$export$3f8bb04b555a363c, $ce0cdebec9150cb3$export$f6d331659b644596);
        colorsTexture.colorSpace = $ce0cdebec9150cb3$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $ce0cdebec9150cb3$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $ce0cdebec9150cb3$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    /**
	 * Validates the instance defined by the given ID.
	 *
	 * @param {number} instanceId - The instance to validate.
	 */ validateInstanceId(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
    /**
	 * Validates the geometry defined by the given ID.
	 *
	 * @param {number} geometryId - The geometry to validate.
	 */ validateGeometryId(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
    /**
	 * Takes a sort a function that is run before render. The function takes a list of instances to
	 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered sort with.
	 *
	 * @param {Function} func - The custom sort function.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    /**
	 * Computes the bounding box, updating {@link BatchedMesh#boundingBox}.
	 * Bounding boxes aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $ce0cdebec9150cb3$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $ce0cdebec9150cb3$var$_box$1).applyMatrix4($ce0cdebec9150cb3$var$_matrix$1);
            boundingBox.union($ce0cdebec9150cb3$var$_box$1);
        }
    }
    /**
	 * Computes the bounding sphere, updating {@link BatchedMesh#boundingSphere}.
	 * Bounding spheres aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $ce0cdebec9150cb3$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $ce0cdebec9150cb3$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $ce0cdebec9150cb3$var$_sphere$2).applyMatrix4($ce0cdebec9150cb3$var$_matrix$1);
            boundingSphere.union($ce0cdebec9150cb3$var$_sphere$2);
        }
    }
    /**
	 * Adds a new instance to the batch using the geometry of the given ID and returns
	 * a new id referring to the new instance to be used by other functions.
	 *
	 * @param {number} geometryId - The ID of a previously added geometry via {@link BatchedMesh#addGeometry}.
	 * @return {number} The instance ID.
	 */ addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort($ce0cdebec9150cb3$var$ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        $ce0cdebec9150cb3$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $ce0cdebec9150cb3$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    /**
	 * Adds the given geometry to the batch and returns the associated
	 * geometry id referring to it to be used in other functions.
	 *
	 * @param {BufferGeometry} geometry - The geometry to add.
	 * @param {number} [reservedVertexCount=-1] - Optional parameter specifying the amount of
	 * vertex buffer space to reserve for the added geometry. This is necessary if it is planned
	 * to set a new geometry at this index at a later time that is larger than the original geometry.
	 * Defaults to the length of the given geometry vertex buffer.
	 * @param {number} [reservedIndexCount=-1] - Optional parameter specifying the amount of index
	 * buffer space to reserve for the added geometry. This is necessary if it is planned to set a
	 * new geometry at this index at a later time that is larger than the original geometry. Defaults to
	 * the length of the given geometry index buffer.
	 * @return {number} The geometry ID.
	 */ addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort($ce0cdebec9150cb3$var$ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    /**
	 * Replaces the geometry at the given ID with the provided geometry. Throws an error if there
	 * is not enough space reserved for geometry. Calling this will change all instances that are
	 * rendering that geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry that should be replaced with the given geometry.
	 * @param {BufferGeometry} geometry - The new geometry.
	 * @return {number} The geometry ID.
	 */ setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $ce0cdebec9150cb3$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    /**
	 * Deletes the geometry defined by the given ID from this batch. Any instances referencing
	 * this geometry will also be removed as a side effect.
	 *
	 * @param {number} geometryId - The ID of the geometry to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Deletes an existing instance from the batch using the given ID.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteInstance(instanceId) {
        this.validateInstanceId(instanceId);
        this._instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Repacks the sub geometries in BatchedMesh to remove any unused space remaining from
	 * previously deleted geometry, freeing up space to add new geometry.
	 *
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart: indexStart, vertexStart: vertexStart, reservedIndexCount: reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    index.needsUpdate = true;
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart: vertexStart, reservedVertexCount: reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array: array, itemSize: itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                    attribute.needsUpdate = true;
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
        }
        this._nextIndexStart = nextIndexStart;
        this._nextVertexStart = nextVertexStart;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the bounding box for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding box for.
	 * @param {Box3} target - The target object that is used to store the method's result.
	 * @return {?Box3} The geometry's bounding box. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($ce0cdebec9150cb3$var$_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    /**
	 * Returns the bounding sphere for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding sphere for.
	 * @param {Sphere} target - The target object that is used to store the method's result.
	 * @return {?Sphere} The geometry's bounding sphere. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new $ce0cdebec9150cb3$export$805e8b72413ccaba();
            this.getBoundingBoxAt(geometryId, $ce0cdebec9150cb3$var$_box$1);
            $ce0cdebec9150cb3$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $ce0cdebec9150cb3$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($ce0cdebec9150cb3$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    /**
	 * Sets the given local transformation matrix to the defined instance.
	 * Negatively scaled matrices are not supported.
	 *
	 * @param {number} instanceId - The ID of an instance to set the matrix of.
	 * @param {Matrix4} matrix - A 4x4 matrix representing the local transformation of a single instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the local transformation matrix of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the matrix of.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} The instance's local transformation matrix.
	 */ getMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
    }
    /**
	 * Sets the given color to the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to set the color of.
	 * @param {Color|Vector4} color - The color to set the instance to. Use a `Vector4` to also define alpha.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) this._initColorsTexture();
        color.toArray(this._colorsTexture.image.data, instanceId * 4);
        this._colorsTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the color of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the color of.
	 * @param {Color|Vector4} color - The target object that is used to store the method's result.
	 * @return {Color|Vector4} The instance's color.  Use a `Vector4` to also retrieve alpha.
	 */ getColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
    }
    /**
	 * Sets the visibility of the instance.
	 *
	 * @param {number} instanceId - The id of the instance to set the visibility of.
	 * @param {boolean} visible - Whether the instance is visible or not.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setVisibleAt(instanceId, visible) {
        this.validateInstanceId(instanceId);
        if (this._instanceInfo[instanceId].visible === visible) return this;
        this._instanceInfo[instanceId].visible = visible;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the visibility state of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the visibility state of.
	 * @return {boolean} Whether the instance is visible or not.
	 */ getVisibleAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].visible;
    }
    /**
	 * Sets the geometry ID of the instance at the given index.
	 *
	 * @param {number} instanceId - The ID of the instance to set the geometry ID of.
	 * @param {number} geometryId - The geometry ID to be use by the instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setGeometryIdAt(instanceId, geometryId) {
        this.validateInstanceId(instanceId);
        this.validateGeometryId(geometryId);
        this._instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    /**
	 * Returns the geometry ID of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the geometry ID of.
	 * @return {number} The instance's geometry ID.
	 */ getGeometryIdAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].geometryIndex;
    }
    /**
	 * Get the range representing the subset of triangles related to the attached geometry,
	 * indicating the starting offset and count, or `null` if invalid.
	 *
	 * @param {number} geometryId - The id of the geometry to get the range of.
	 * @param {Object} [target] - The target object that is used to store the method's result.
	 * @return {{
	 * 	vertexStart:number,vertexCount:number,reservedVertexCount:number,
	 * 	indexStart:number,indexCount:number,reservedIndexCount:number,
	 * 	start:number,count:number
	 * }} The result object with range data.
	 */ getGeometryRangeAt(geometryId, target = {}) {
        this.validateGeometryId(geometryId);
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    /**
	 * Resizes the necessary buffers to support the provided number of instances.
	 * If the provided arguments shrink the number of instances but there are not enough
	 * unused Ids at the end of the list then an error is thrown.
	 *
	 * @param {number} maxInstanceCount - The max number of individual instances that can be added and rendered by the batch.
	*/ setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort($ce0cdebec9150cb3$var$ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length - 1){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        $ce0cdebec9150cb3$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        $ce0cdebec9150cb3$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        $ce0cdebec9150cb3$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        $ce0cdebec9150cb3$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            $ce0cdebec9150cb3$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    /**
	 * Resizes the available space in the batch's vertex and index buffer attributes to the provided sizes.
	 * If the provided arguments shrink the geometry buffers but there is not enough unused space at the
	 * end of the geometry attributes then an error is thrown.
	 *
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries to resize to.
	 * @param {number} maxIndexCount - The maximum number of indices to be used by all unique geometries to resize to.
	*/ setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) $ce0cdebec9150cb3$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)$ce0cdebec9150cb3$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $ce0cdebec9150cb3$var$_mesh.material = this.material;
        $ce0cdebec9150cb3$var$_mesh.geometry.index = batchGeometry.index;
        $ce0cdebec9150cb3$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($ce0cdebec9150cb3$var$_mesh.geometry.boundingBox === null) $ce0cdebec9150cb3$var$_mesh.geometry.boundingBox = new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
        if ($ce0cdebec9150cb3$var$_mesh.geometry.boundingSphere === null) $ce0cdebec9150cb3$var$_mesh.geometry.boundingSphere = new $ce0cdebec9150cb3$export$805e8b72413ccaba();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            $ce0cdebec9150cb3$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, $ce0cdebec9150cb3$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $ce0cdebec9150cb3$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $ce0cdebec9150cb3$var$_mesh.geometry.boundingSphere);
            $ce0cdebec9150cb3$var$_mesh.raycast(raycaster, $ce0cdebec9150cb3$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $ce0cdebec9150cb3$var$_batchIntersects.length; j < l; j++){
                const intersect = $ce0cdebec9150cb3$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $ce0cdebec9150cb3$var$_batchIntersects.length = 0;
        }
        $ce0cdebec9150cb3$var$_mesh.material = null;
        $ce0cdebec9150cb3$var$_mesh.geometry.index = null;
        $ce0cdebec9150cb3$var$_mesh.geometry.attributes = {};
        $ce0cdebec9150cb3$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>({
                ...info,
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>({
                ...info
            }));
        this._availableInstanceIds = source._availableInstanceIds.slice();
        this._availableGeometryIds = source._availableGeometryIds.slice();
        this._nextIndexStart = source._nextIndexStart;
        this._nextVertexStart = source._nextVertexStart;
        this._geometryCount = source._geometryCount;
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._indirectTexture = source._indirectTexture.clone();
        this._indirectTexture.image.data = this._indirectTexture.image.data.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        let bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        // the "wireframe" attribute implicitly creates a line attribute in the renderer, which is double
        // the vertices to draw (3 lines per triangle) so we multiply the draw counts / starts and make
        // assumptions about the index buffer byte size.
        let multiDrawMultiplier = 1;
        if (material.wireframe) {
            multiDrawMultiplier = 2;
            bytesPerElement = geometry.attributes.position.count > 65535 ? 4 : 2;
        }
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        const frustum = camera.isArrayCamera ? $ce0cdebec9150cb3$var$_frustumArray : $ce0cdebec9150cb3$var$_frustum;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled && !camera.isArrayCamera) {
            $ce0cdebec9150cb3$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $ce0cdebec9150cb3$var$_frustum.setFromProjectionMatrix($ce0cdebec9150cb3$var$_matrix$1, camera.coordinateSystem, camera.reversedDepth);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $ce0cdebec9150cb3$var$_matrix$1.copy(this.matrixWorld).invert();
            $ce0cdebec9150cb3$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($ce0cdebec9150cb3$var$_matrix$1);
            $ce0cdebec9150cb3$var$_forward$1.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($ce0cdebec9150cb3$var$_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $ce0cdebec9150cb3$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $ce0cdebec9150cb3$var$_sphere$2).applyMatrix4($ce0cdebec9150cb3$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !frustum.intersectsSphere($ce0cdebec9150cb3$var$_sphere$2, camera);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = $ce0cdebec9150cb3$var$_temp.subVectors($ce0cdebec9150cb3$var$_sphere$2.center, $ce0cdebec9150cb3$var$_vector$5).dot($ce0cdebec9150cb3$var$_forward$1);
                    $ce0cdebec9150cb3$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $ce0cdebec9150cb3$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $ce0cdebec9150cb3$var$sortTransparent : $ce0cdebec9150cb3$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement * multiDrawMultiplier;
                multiDrawCounts[multiDrawCount] = item.count * multiDrawMultiplier;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            $ce0cdebec9150cb3$var$_renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $ce0cdebec9150cb3$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $ce0cdebec9150cb3$var$_sphere$2).applyMatrix4($ce0cdebec9150cb3$var$_matrix$1);
                    culled = !frustum.intersectsSphere($ce0cdebec9150cb3$var$_sphere$2, camera);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement * multiDrawMultiplier;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count * multiDrawMultiplier;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 * ```
 *
 * @augments Material
 */ class $ce0cdebec9150cb3$export$fbaaa33907730a0c extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new line basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff);
        /**
		 * Sets the color of the lines using data from a texture. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Controls line thickness or lines.
		 *
		 * Can only be used with {@link SVGRenderer}. WebGL and WebGPU
		 * ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Defines appearance of line ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('butt'|'round'|'square')}
		 * @default 'round'
		 */ this.linecap = 'round';
        /**
		 * Defines appearance of line joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.linejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $ce0cdebec9150cb3$var$_vStart = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_vEnd = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_inverseMatrix$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_ray$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$a186db52eed6d40e();
const $ce0cdebec9150cb3$var$_sphere$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$805e8b72413ccaba();
const $ce0cdebec9150cb3$var$_intersectPointOnRay = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_intersectPointOnSegment = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * A continuous line. The line are rendered by connecting consecutive
 * vertices with straight lines.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0x0000ff } );
 *
 * const points = [];
 * points.push( new THREE.Vector3( - 10, 0, 0 ) );
 * points.push( new THREE.Vector3( 0, 10, 0 ) );
 * points.push( new THREE.Vector3( 10, 0, 0 ) );
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$17d680238e50603e extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new line.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959(), material = new $ce0cdebec9150cb3$export$fbaaa33907730a0c()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine = true;
        this.type = 'Line';
        /**
		 * The line geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default LineBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes an array of distance values which are necessary for rendering dashed lines.
	 * For each vertex in the geometry, the method calculates the cumulative length from the
	 * current point to the very beginning of the line.
	 *
	 * @return {Line} A reference to this line.
	 */ computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $ce0cdebec9150cb3$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $ce0cdebec9150cb3$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $ce0cdebec9150cb3$var$_vStart.distanceTo($ce0cdebec9150cb3$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(lineDistances, 1));
        } else $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $ce0cdebec9150cb3$var$_sphere$1.copy(geometry.boundingSphere);
        $ce0cdebec9150cb3$var$_sphere$1.applyMatrix4(matrixWorld);
        $ce0cdebec9150cb3$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($ce0cdebec9150cb3$var$_sphere$1) === false) return;
        //
        $ce0cdebec9150cb3$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $ce0cdebec9150cb3$var$_ray$1.copy(raycaster.ray).applyMatrix4($ce0cdebec9150cb3$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $ce0cdebec9150cb3$var$checkIntersection(this, raycaster, $ce0cdebec9150cb3$var$_ray$1, localThresholdSq, a, b, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $ce0cdebec9150cb3$var$checkIntersection(this, raycaster, $ce0cdebec9150cb3$var$_ray$1, localThresholdSq, a, b, end - 1);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $ce0cdebec9150cb3$var$checkIntersection(this, raycaster, $ce0cdebec9150cb3$var$_ray$1, localThresholdSq, i, i + 1, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $ce0cdebec9150cb3$var$checkIntersection(this, raycaster, $ce0cdebec9150cb3$var$_ray$1, localThresholdSq, end - 1, start, end - 1);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    /**
	 * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $ce0cdebec9150cb3$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    const positionAttribute = object.geometry.attributes.position;
    $ce0cdebec9150cb3$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $ce0cdebec9150cb3$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($ce0cdebec9150cb3$var$_vStart, $ce0cdebec9150cb3$var$_vEnd, $ce0cdebec9150cb3$var$_intersectPointOnRay, $ce0cdebec9150cb3$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $ce0cdebec9150cb3$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($ce0cdebec9150cb3$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $ce0cdebec9150cb3$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $ce0cdebec9150cb3$var$_start = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_end = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * A series of lines drawn between pairs of vertices.
 *
 * @augments Line
 */ class $ce0cdebec9150cb3$export$ff1ed10fedfdd604 extends $ce0cdebec9150cb3$export$17d680238e50603e {
    /**
	 * Constructs a new line segments.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $ce0cdebec9150cb3$var$_start.fromBufferAttribute(positionAttribute, i);
                $ce0cdebec9150cb3$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $ce0cdebec9150cb3$var$_start.distanceTo($ce0cdebec9150cb3$var$_end);
            }
            geometry.setAttribute('lineDistance', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(lineDistances, 1));
        } else $ce0cdebec9150cb3$export$c106dd0671a0fc2d('LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
/**
 * A continuous line. This is nearly the same as {@link Line} the only difference
 * is that the last vertex is connected with the first vertex in order to close
 * the line to form a loop.
 *
 * @augments Line
 */ class $ce0cdebec9150cb3$export$f85a24d745e4f17d extends $ce0cdebec9150cb3$export$17d680238e50603e {
    /**
	 * Constructs a new line loop.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
/**
 * A material for rendering point primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const vertices = [];
 *
 * for ( let i = 0; i < 10000; i ++ ) {
 * 	const x = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const y = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const z = THREE.MathUtils.randFloatSpread( 2000 );
 *
 * 	vertices.push( x, y, z );
 * }
 *
 * const geometry = new THREE.BufferGeometry();
 * geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
 * const material = new THREE.PointsMaterial( { color: 0x888888 } );
 * const points = new THREE.Points( geometry, material );
 * scene.add( points );
 * ```
 *
 * @augments Material
 */ class $ce0cdebec9150cb3$export$a178c45366ce5d6b extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new points material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Defines the size of the points in pixels.
		 *
		 * Might be capped if the value exceeds hardware dependent parameters like [gl.ALIASED_POINT_SIZE_RANGE](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getParamete).
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = 1;
        /**
		 * Specifies whether size of individual points is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $ce0cdebec9150cb3$var$_inverseMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_ray = /*@__PURE__*/ new $ce0cdebec9150cb3$export$a186db52eed6d40e();
const $ce0cdebec9150cb3$var$_sphere = /*@__PURE__*/ new $ce0cdebec9150cb3$export$805e8b72413ccaba();
const $ce0cdebec9150cb3$var$_position$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * A class for displaying points or point clouds.
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$1c787534cb11aa3e extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new point cloud.
	 *
	 * @param {BufferGeometry} [geometry] - The points geometry.
	 * @param {Material|Array<Material>} [material] - The points material.
	 */ constructor(geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959(), material = new $ce0cdebec9150cb3$export$a178c45366ce5d6b()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPoints = true;
        this.type = 'Points';
        /**
		 * The points geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default PointsMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this point cloud.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $ce0cdebec9150cb3$var$_sphere.copy(geometry.boundingSphere);
        $ce0cdebec9150cb3$var$_sphere.applyMatrix4(matrixWorld);
        $ce0cdebec9150cb3$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($ce0cdebec9150cb3$var$_sphere) === false) return;
        //
        $ce0cdebec9150cb3$var$_inverseMatrix.copy(matrixWorld).invert();
        $ce0cdebec9150cb3$var$_ray.copy(raycaster.ray).applyMatrix4($ce0cdebec9150cb3$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $ce0cdebec9150cb3$var$_position$3.fromBufferAttribute(positionAttribute, a);
                $ce0cdebec9150cb3$var$testPoint($ce0cdebec9150cb3$var$_position$3, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $ce0cdebec9150cb3$var$_position$3.fromBufferAttribute(positionAttribute, i);
                $ce0cdebec9150cb3$var$testPoint($ce0cdebec9150cb3$var$_position$3, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    /**
	 * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $ce0cdebec9150cb3$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $ce0cdebec9150cb3$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        $ce0cdebec9150cb3$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
/**
 * A texture for use with a video.
 *
 * ```js
 * // assuming you have created a HTML video element with id="video"
 * const video = document.getElementById( 'video' );
 * const texture = new THREE.VideoTexture( video );
 * ```
 *
 * Note: When using video textures with {@link WebGPURenderer}, {@link Texture#colorSpace} must be
 * set to THREE.SRGBColorSpace.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$6e09d1edf8d5a25c extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {HTMLVideoElement} video - The video element to use as a data source for the texture.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(video, mapping, wrapS, wrapT, magFilter = $ce0cdebec9150cb3$export$8a72f490b25c56c8, minFilter = $ce0cdebec9150cb3$export$8a72f490b25c56c8, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoTexture = true;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * The video frame request callback identifier, which is a positive integer.
		 *
		 * Value of 0 represents no scheduled rVFC.
		 *
		 * @private
		 * @type {number}
		 */ this._requestVideoFrameCallbackId = 0;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            scope._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) this._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    /**
	 * This method is called automatically by the renderer and sets {@link Texture#needsUpdate}
	 * to `true` every time a new frame is available.
	 *
	 * Only relevant if `requestVideoFrameCallback` is not supported in the browser.
	 */ update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
    dispose() {
        if (this._requestVideoFrameCallbackId !== 0) {
            this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId);
            this._requestVideoFrameCallbackId = 0;
        }
        super.dispose();
    }
}
/**
 * This class can be used as an alternative way to define video data. Instead of using
 * an instance of `HTMLVideoElement` like with `VideoTexture`, `VideoFrameTexture` expects each frame is
 * defined manually via {@link VideoFrameTexture#setFrame}. A typical use case for this module is when
 * video frames are decoded with the WebCodecs API.
 *
 * ```js
 * const texture = new THREE.VideoFrameTexture();
 * texture.setFrame( frame );
 * ```
 *
 * @augments VideoTexture
 */ class $ce0cdebec9150cb3$export$68498d200b825382 extends $ce0cdebec9150cb3$export$6e09d1edf8d5a25c {
    /**
	 * Constructs a new video frame texture.
	 *
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super({}, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoFrameTexture = true;
    }
    /**
	 * This method overwritten with an empty implementation since
	 * this type of texture is updated via `setFrame()`.
	 */ update() {}
    clone() {
        return new this.constructor().copy(this); // restoring Texture.clone()
    }
    /**
	 * Sets the current frame of the video. This will automatically update the texture
	 * so the data can be used for rendering.
	 *
	 * @param {VideoFrame} frame - The video frame.
	 */ setFrame(frame) {
        this.image = frame;
        this.needsUpdate = true;
    }
}
/**
 * This class can only be used in combination with `copyFramebufferToTexture()` methods
 * of renderers. It extracts the contents of the current bound framebuffer and provides it
 * as a texture for further usage.
 *
 * ```js
 * const pixelRatio = window.devicePixelRatio;
 * const textureSize = 128 * pixelRatio;
 *
 * const frameTexture = new FramebufferTexture( textureSize, textureSize );
 *
 * // calculate start position for copying part of the frame data
 * const vector = new Vector2();
 * vector.x = ( window.innerWidth * pixelRatio / 2 ) - ( textureSize / 2 );
 * vector.y = ( window.innerHeight * pixelRatio / 2 ) - ( textureSize / 2 );
 *
 * renderer.render( scene, camera );
 *
 * // copy part of the rendered frame into the framebuffer texture
 * renderer.copyFramebufferToTexture( frameTexture, vector );
 * ```
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$9270d786f73ce6fe extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Constructs a new framebuffer texture.
	 *
	 * @param {number} [width] - The width of the texture.
	 * @param {number} [height] - The height of the texture.
	 */ constructor(width, height){
        super({
            width: width,
            height: height
        });
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFramebufferTexture = true;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
/**
 * Creates a texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$3466bac9141a5cc4 extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @type {{width:number,height:number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * This array holds for all mipmaps (including the bases mip) the data and dimensions.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = mipmaps;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default since it is not possible to
		 * flip compressed textures.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default since it is not
		 * possible to generate mipmaps for compressed data. Mipmaps
		 * must be embedded in the compressed texture file.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.generateMipmaps = false;
    }
}
/**
 * Creates a texture 2D array based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $ce0cdebec9150cb3$export$5fe6b8e34b274fcb extends $ce0cdebec9150cb3$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed array texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} depth - The depth of the texture.
	 * @param {number} [format=RGBAFormat] - The min filter value.
	 * @param {number} [type=UnsignedByteType] - The min filter value.
	 */ constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedArrayTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @name CompressedArrayTexture#image
		 * @type {{width:number,height:number,depth:number}}
		 */ this.image.depth = depth;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $ce0cdebec9150cb3$export$9d9334239a5a5e06;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire compressed texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * Creates a cube texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $ce0cdebec9150cb3$export$d80173634de65bff extends $ce0cdebec9150cb3$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<CompressedTexture>} images - An array of compressed textures.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 */ constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $ce0cdebec9150cb3$export$8759762a6477f2c4);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedCubeTexture = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        this.image = images;
    }
}
/**
 * Creates a cube texture made up of six images.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader();
 * loader.setPath( 'textures/cube/pisa/' );
 *
 * const textureCube = loader.load( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xffffff, envMap: textureCube } );
 * ```
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$ee2e5a18258a4049 extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Constructs a new cube texture.
	 *
	 * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space value.
	 */ constructor(images = [], mapping = $ce0cdebec9150cb3$export$8759762a6477f2c4, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
    }
    /**
	 * Alias for {@link CubeTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * Creates a texture from a canvas element.
 *
 * This is almost the same as the base texture class, except that it sets {@link Texture#needsUpdate}
 * to `true` immediately since a canvas can directly be used for rendering.
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$f7189e49152d1c13 extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * rendering into a texture.
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$fc830aa069cc8c2f extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Constructs a new depth texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(width, height, type = $ce0cdebec9150cb3$export$c3c7fc4518ebba96, mapping, wrapS, wrapT, magFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0, minFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0, anisotropy, format = $ce0cdebec9150cb3$export$c1b6b5136be58045, depth = 1){
        if (format !== $ce0cdebec9150cb3$export$c1b6b5136be58045 && format !== $ce0cdebec9150cb3$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        const image = {
            width: width,
            height: height,
            depth: depth
        };
        super(image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDepthTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * Code corresponding to the depth compare function.
		 *
		 * @type {?(NeverCompare|LessCompare|EqualCompare|LessEqualCompare|GreaterCompare|NotEqualCompare|GreaterEqualCompare|AlwaysCompare)}
		 * @default null
		 */ this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.source = new $ce0cdebec9150cb3$export$1d2df86270c81ecb(Object.assign({}, source.image)); // see #30540
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * cube rendering into a cube texture with depth format. Used for PointLight shadows.
 *
 * @augments DepthTexture
 */ class $ce0cdebec9150cb3$export$c9f39eef7fb1d170 extends $ce0cdebec9150cb3$export$fc830aa069cc8c2f {
    /**
	 * Constructs a new cube depth texture.
	 *
	 * @param {number} size - The size (width and height) of each cube face.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 */ constructor(size, type = $ce0cdebec9150cb3$export$c3c7fc4518ebba96, mapping = $ce0cdebec9150cb3$export$8759762a6477f2c4, wrapS, wrapT, magFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0, minFilter = $ce0cdebec9150cb3$export$727aa5ec3fe39bf0, anisotropy, format = $ce0cdebec9150cb3$export$c1b6b5136be58045){
        // Create 6 identical image descriptors for the cube faces
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        // Call DepthTexture constructor with width, height
        super(size, size, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format);
        // Replace the single image with the array of 6 images
        this.image = images;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeDepthTexture = true;
        /**
		 * Set to true for cube texture handling in WebGLTextures.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
    }
    /**
	 * Alias for {@link CubeDepthTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * Represents a texture created externally with the same renderer context.
 *
 * This may be a texture from a protected media stream, device camera feed,
 * or other data feeds like a depth sensor.
 *
 * Note that this class is only supported in {@link WebGLRenderer}, and in
 * the {@link WebGPURenderer} WebGPU backend.
 *
 * @augments Texture
 */ class $ce0cdebec9150cb3$export$cd10147cacf16ab2 extends $ce0cdebec9150cb3$export$5431306cf43de24a {
    /**
	 * Creates a new raw texture.
	 *
	 * @param {?(WebGLTexture|GPUTexture)} [sourceTexture=null] - The external texture.
	 */ constructor(sourceTexture = null){
        super();
        /**
		 * The external source texture.
		 *
		 * @type {?(WebGLTexture|GPUTexture)}
		 * @default null
		 */ this.sourceTexture = sourceTexture;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isExternalTexture = true;
    }
    copy(source) {
        super.copy(source);
        this.sourceTexture = source.sourceTexture;
        return this;
    }
}
/**
 * A geometry class for a rectangular cuboid with a given width, height, and depth.
 * On creation, the cuboid is centred on the origin, with each edge parallel to one
 * of the axes.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const cube = new THREE.Mesh( geometry, material );
 * scene.add( cube );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#BoxGeometry
 */ class $ce0cdebec9150cb3$export$33e43285f7406bd5 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new box geometry.
	 *
	 * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
	 * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
	 * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
	 * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
	 * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
	 * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
	 */ constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {BoxGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * A geometry class for representing a capsule.
 *
 * ```js
 * const geometry = new THREE.CapsuleGeometry( 1, 1, 4, 8, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const capsule = new THREE.Mesh( geometry, material );
 * scene.add( capsule );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CapsuleGeometry
 */ class $ce0cdebec9150cb3$export$41680e8551036033 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new capsule geometry.
	 *
	 * @param {number} [radius=1] - Radius of the capsule.
	 * @param {number} [height=1] - Height of the middle section.
	 * @param {number} [capSegments=4] - Number of curve segments used to build each cap.
	 * @param {number} [radialSegments=8] - Number of segmented faces around the circumference of the capsule. Must be an integer >= 3.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the middle section. Must be an integer >= 1.
	 */ constructor(radius = 1, height = 1, capSegments = 4, radialSegments = 8, heightSegments = 1){
        super();
        this.type = 'CapsuleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            capSegments: capSegments,
            radialSegments: radialSegments,
            heightSegments: heightSegments
        };
        height = Math.max(0, height);
        capSegments = Math.max(1, Math.floor(capSegments));
        radialSegments = Math.max(3, Math.floor(radialSegments));
        heightSegments = Math.max(1, Math.floor(heightSegments));
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const halfHeight = height / 2;
        const capArcLength = Math.PI / 2 * radius;
        const cylinderPartLength = height;
        const totalArcLength = 2 * capArcLength + cylinderPartLength;
        const numVerticalSegments = capSegments * 2 + heightSegments;
        const verticesPerRow = radialSegments + 1;
        const normal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        // generate vertices, normals, and uvs
        for(let iy = 0; iy <= numVerticalSegments; iy++){
            let currentArcLength = 0;
            let profileY = 0;
            let profileRadius = 0;
            let normalYComponent = 0;
            if (iy <= capSegments) {
                // bottom cap
                const segmentProgress = iy / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = -halfHeight - radius * Math.cos(angle);
                profileRadius = radius * Math.sin(angle);
                normalYComponent = -radius * Math.cos(angle);
                currentArcLength = segmentProgress * capArcLength;
            } else if (iy <= capSegments + heightSegments) {
                // middle section
                const segmentProgress = (iy - capSegments) / heightSegments;
                profileY = -halfHeight + segmentProgress * height;
                profileRadius = radius;
                normalYComponent = 0;
                currentArcLength = capArcLength + segmentProgress * cylinderPartLength;
            } else {
                // top cap
                const segmentProgress = (iy - capSegments - heightSegments) / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = halfHeight + radius * Math.sin(angle);
                profileRadius = radius * Math.cos(angle);
                normalYComponent = radius * Math.sin(angle);
                currentArcLength = capArcLength + cylinderPartLength + segmentProgress * capArcLength;
            }
            const v = Math.max(0, Math.min(1, currentArcLength / totalArcLength));
            // special case for the poles
            let uOffset = 0;
            if (iy === 0) uOffset = 0.5 / radialSegments;
            else if (iy === numVerticalSegments) uOffset = -0.5 / radialSegments;
            for(let ix = 0; ix <= radialSegments; ix++){
                const u = ix / radialSegments;
                const theta = u * Math.PI * 2;
                const sinTheta = Math.sin(theta);
                const cosTheta = Math.cos(theta);
                // vertex
                vertex.x = -profileRadius * cosTheta;
                vertex.y = profileY;
                vertex.z = profileRadius * sinTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(-profileRadius * cosTheta, normalYComponent, profileRadius * sinTheta);
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, v);
            }
            if (iy > 0) {
                const prevIndexRow = (iy - 1) * verticesPerRow;
                for(let ix = 0; ix < radialSegments; ix++){
                    const i1 = prevIndexRow + ix;
                    const i2 = prevIndexRow + ix + 1;
                    const i3 = iy * verticesPerRow + ix;
                    const i4 = iy * verticesPerRow + ix + 1;
                    indices.push(i1, i2, i3);
                    indices.push(i2, i4, i3);
                }
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CapsuleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$41680e8551036033(data.radius, data.height, data.capSegments, data.radialSegments, data.heightSegments);
    }
}
/**
 * A simple shape of Euclidean geometry. It is constructed from a
 * number of triangular segments that are oriented around a central point and
 * extend as far out as a given radius. It is built counter-clockwise from a
 * start angle and a given central angle. It can also be used to create
 * regular polygons, where the number of segments determines the number of
 * sides.
 *
 * ```js
 * const geometry = new THREE.CircleGeometry( 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const circle = new THREE.Mesh( geometry, material );
 * scene.add( circle )
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CircleGeometry
 */ class $ce0cdebec9150cb3$export$d5c0e8d607467193 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new circle geometry.
	 *
	 * @param {number} [radius=1] - Radius of the circle.
	 * @param {number} [segments=32] - Number of segments (triangles), minimum = `3`.
	 * @param {number} [thetaStart=0] - Start angle for first segment in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta,
	 * of the circular sector in radians. The default value results in a complete circle.
	 */ constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const uv = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CircleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cylinder.
 *
 * ```js
 * const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cylinder = new THREE.Mesh( geometry, material );
 * scene.add( cylinder );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CylinderGeometry
 */ class $ce0cdebec9150cb3$export$68f745719dbe5198 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new cylinder geometry.
	 *
	 * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
	 * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
	 * @param {number} [height=1] - Height of the cylinder.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
	 * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cylinder.
	 */ constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
            const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CylinderGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cone.
 *
 * ```js
 * const geometry = new THREE.ConeGeometry( 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cone = new THREE.Mesh(geometry, material );
 * scene.add( cone );
 * ```
 *
 * @augments CylinderGeometry
 * @demo scenes/geometry-browser.html#ConeGeometry
 */ class $ce0cdebec9150cb3$export$a7a48974f285c9b3 extends $ce0cdebec9150cb3$export$68f745719dbe5198 {
    /**
	 * Constructs a new cone geometry.
	 *
	 * @param {number} [radius=1] - Radius of the cone base.
	 * @param {number} [height=1] - Height of the cone.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cone.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cone.
	 * @param {boolean} [openEnded=false] - Whether the base of the cone is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cone.
	 */ constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {ConeGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A polyhedron is a solid in three dimensions with flat faces. This class
 * will take an array of vertices, project them onto a sphere, and then
 * divide them up to the desired level of detail.
 *
 * @augments BufferGeometry
 */ class $ce0cdebec9150cb3$export$60e57a7d3f20ff65 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new polyhedron geometry.
	 *
	 * @param {Array<number>} [vertices] - A flat array of vertices describing the base shape.
	 * @param {Array<number>} [indices] - A flat array of indices describing the base shape.
	 * @param {number} [radius=1] - The radius of the shape.
	 * @param {number} [detail=0] - How many levels to subdivide the geometry. The more detail, the smoother the shape.
	 */ constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const b = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const c = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const b = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const c = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const centroid = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const uvA = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
            const uvB = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
            const uvC = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PolyhedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a dodecahedron.
 *
 * ```js
 * const geometry = new THREE.DodecahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const dodecahedron = new THREE.Mesh( geometry, material );
 * scene.add( dodecahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#DodecahedronGeometry
 */ class $ce0cdebec9150cb3$export$c0babfeb8708fc9c extends $ce0cdebec9150cb3$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new dodecahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the dodecahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a dodecahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {DodecahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $ce0cdebec9150cb3$var$_v0 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v1$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_normal = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_triangle = /*@__PURE__*/ new $ce0cdebec9150cb3$export$5a465592bfe74b48();
/**
 * Can be used as a helper object to view the edges of a geometry.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry();
 * const edges = new THREE.EdgesGeometry( geometry );
 * const line = new THREE.LineSegments( edges );
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $ce0cdebec9150cb3$export$4730b1542707547f extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new edges geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 * @param {number} [thresholdAngle=1] - An edge is only rendered if the angle (in degrees)
	 * between the face normals of the adjoining faces exceeds this value.
	 */ constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($ce0cdebec9150cb3$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $ce0cdebec9150cb3$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $ce0cdebec9150cb3$var$_triangle.getNormal($ce0cdebec9150cb3$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $ce0cdebec9150cb3$var$_triangle[vertKeys[j]];
                    const v1 = $ce0cdebec9150cb3$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($ce0cdebec9150cb3$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $ce0cdebec9150cb3$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $ce0cdebec9150cb3$var$_v0.fromBufferAttribute(positionAttr, index0);
                $ce0cdebec9150cb3$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($ce0cdebec9150cb3$var$_v0.x, $ce0cdebec9150cb3$var$_v0.y, $ce0cdebec9150cb3$var$_v0.z);
                vertices.push($ce0cdebec9150cb3$var$_v1$1.x, $ce0cdebec9150cb3$var$_v1$1.y, $ce0cdebec9150cb3$var$_v1$1.z);
            }
            this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
/**
 * An abstract base class for creating an analytic curve object that contains methods
 * for interpolation.
 *
 * @abstract
 */ class $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Curve';
        /**
		 * This value determines the amount of divisions when calculating the
		 * cumulative segment lengths of a curve via {@link Curve#getLengths}. To ensure
		 * precision when using methods like {@link Curve#getSpacedPoints}, it is
		 * recommended to increase the value of this property if the curve is very large.
		 *
		 * @type {number}
		 * @default 200
		 */ this.arcLengthDivisions = 200;
        /**
		 * Must be set to `true` if the curve parameters have changed.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        /**
		 * An internal cache that holds precomputed curve length values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this.cacheArcLengths = null;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor.
	 *
	 * @abstract
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint() {
        $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Curve: .getPoint() not implemented.');
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
	 * of the curve which equidistant samples.
	 *
	 * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    /**
	 * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
	 * the curve shape.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    /**
	 * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
	 * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
	 * curve.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    /**
	 * Returns the total arc length of the curve.
	 *
	 * @return {number} The length of the curve.
	 */ getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    /**
	 * Returns an array of cumulative segment lengths of the curve.
	 *
	 * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
	 * @return {Array<number>} An array holding the cumulative segment lengths.
	 */ getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    /**
	 * Update the cumulative segment distance cache. The method must be called
	 * every time curve parameters are changed. If an updated curve is part of a
	 * composed curve like {@link CurvePath}, this method must be called on the
	 * composed curve, too.
	 */ updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    /**
	 * Given an interpolation factor in the range `[0,1]`, this method returns an updated
	 * interpolation factor in the same range that can be ued to sample equidistant points
	 * from a curve.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {?number} distance - An optional distance on the curve.
	 * @return {number} The updated interpolation factor.
	 */ getUtoTmapping(u, distance = null) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 * If the derived curve does not implement its tangent derivation,
	 * two points a small delta apart will be used to find its gradient
	 * which seems to give a reasonable approximation.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 */ getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $ce0cdebec9150cb3$export$c977b3e384af9ae1() : new $ce0cdebec9150cb3$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    /**
	 * Same as {@link Curve#getTangent} but with equidistant samples.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 * @see {@link Curve#getPointAt}
	 */ getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    /**
	 * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
	 * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
	 *
	 * @param {number} segments - The number of segments.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
	 */ computeFrenetFrames(segments, closed = false) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const mat = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $ce0cdebec9150cb3$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        binormals[0] = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($ce0cdebec9150cb3$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($ce0cdebec9150cb3$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    /**
	 * Returns a new curve with copied values from this instance.
	 *
	 * @return {Curve} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given curve to this instance.
	 *
	 * @param {Curve} source - The curve to copy.
	 * @return {Curve} A reference to this curve.
	 */ copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    /**
	 * Serializes the curve into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized curve.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    /**
	 * Deserializes the curve from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized curve.
	 * @return {Curve} A reference to this curve.
	 */ fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
/**
 * A curve representing an ellipse.
 *
 * ```js
 * const curve = new THREE.EllipseCurve(
 * 	0, 0,
 * 	10, 10,
 * 	0, 2 * Math.PI,
 * 	false,
 * 	0
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const ellipse = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$3f87a931616cde04 extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new ellipse curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 */ constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        /**
		 * The X center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aX = aX;
        /**
		 * The Y center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aY = aY;
        /**
		 * The radius of the ellipse in the x direction.
		 * Setting the this value equal to the {@link EllipseCurve#yRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.xRadius = xRadius;
        /**
		 * The radius of the ellipse in the y direction.
		 * Setting the this value equal to the {@link EllipseCurve#xRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.yRadius = yRadius;
        /**
		 * The start angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aStartAngle = aStartAngle;
        /**
		 * The end angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default Math.PI*2
		 */ this.aEndAngle = aEndAngle;
        /**
		 * Whether the ellipse is drawn clockwise or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.aClockwise = aClockwise;
        /**
		 * The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aRotation = aRotation;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $ce0cdebec9150cb3$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
/**
 * A curve representing an arc.
 *
 * @augments EllipseCurve
 */ class $ce0cdebec9150cb3$export$b1eedc9aab6300e8 extends $ce0cdebec9150cb3$export$3f87a931616cde04 {
    /**
	 * Constructs a new arc curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [aRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 */ constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
function $ce0cdebec9150cb3$var$CubicPoly() {
    /**
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	* cusps and self-intersections in non-uniform catmull rom curves.
	* http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	*
	* curve.type accepts centripetal(default), chordal and catmullrom
	* curve.tension is used for catmullrom which defaults to 0.5
	*/ /*
	Based on an optimized c++ solution in
	- http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	- http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/ let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $ce0cdebec9150cb3$var$tmp = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$px = /*@__PURE__*/ new $ce0cdebec9150cb3$var$CubicPoly();
const $ce0cdebec9150cb3$var$py = /*@__PURE__*/ new $ce0cdebec9150cb3$var$CubicPoly();
const $ce0cdebec9150cb3$var$pz = /*@__PURE__*/ new $ce0cdebec9150cb3$var$CubicPoly();
/**
 * A curve representing a Catmull-Rom spline.
 *
 * ```js
 * //Create a closed wavey loop
 * const curve = new THREE.CatmullRomCurve3( [
 * 	new THREE.Vector3( -10, 0, 10 ),
 * 	new THREE.Vector3( -5, 5, 5 ),
 * 	new THREE.Vector3( 0, 0, 0 ),
 * 	new THREE.Vector3( 5, -5, 5 ),
 * 	new THREE.Vector3( 10, 0, 10 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$b9146b27c24b744c extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Catmull-Rom curve.
	 *
	 * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
	 * @param {number} [tension=0.5] - Tension of the curve.
	 */ constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        /**
		 * An array of 3D points defining the curve.
		 *
		 * @type {Array<Vector3>}
		 */ this.points = points;
        /**
		 * Whether the curve is closed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.closed = closed;
        /**
		 * The curve type.
		 *
		 * @type {('centripetal'|'chordal'|'catmullrom')}
		 * @default 'centripetal'
		 */ this.curveType = curveType;
        /**
		 * Tension of the curve.
		 *
		 * @type {number}
		 * @default 0.5
		 */ this.tension = tension;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $ce0cdebec9150cb3$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $ce0cdebec9150cb3$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $ce0cdebec9150cb3$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $ce0cdebec9150cb3$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $ce0cdebec9150cb3$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $ce0cdebec9150cb3$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $ce0cdebec9150cb3$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $ce0cdebec9150cb3$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $ce0cdebec9150cb3$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $ce0cdebec9150cb3$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $ce0cdebec9150cb3$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($ce0cdebec9150cb3$var$px.calc(weight), $ce0cdebec9150cb3$var$py.calc(weight), $ce0cdebec9150cb3$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $ce0cdebec9150cb3$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Interpolations contains spline and Bézier functions internally used by concrete curve classes.
 *
 * Bezier Curves formulas obtained from: https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 *
 * @module Interpolations
 */ /**
 * Computes a point on a Catmull-Rom spline.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Catmull-Rom spline.
 */ function $ce0cdebec9150cb3$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $ce0cdebec9150cb3$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $ce0cdebec9150cb3$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $ce0cdebec9150cb3$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
/**
 * Computes a point on a Quadratic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @return {number} The calculated point on a Quadratic Bezier curve.
 */ function $ce0cdebec9150cb3$var$QuadraticBezier(t, p0, p1, p2) {
    return $ce0cdebec9150cb3$var$QuadraticBezierP0(t, p0) + $ce0cdebec9150cb3$var$QuadraticBezierP1(t, p1) + $ce0cdebec9150cb3$var$QuadraticBezierP2(t, p2);
}
//
function $ce0cdebec9150cb3$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $ce0cdebec9150cb3$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $ce0cdebec9150cb3$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $ce0cdebec9150cb3$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
/**
 * Computes a point on a Cubic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Cubic Bezier curve.
 */ function $ce0cdebec9150cb3$var$CubicBezier(t, p0, p1, p2, p3) {
    return $ce0cdebec9150cb3$var$CubicBezierP0(t, p0) + $ce0cdebec9150cb3$var$CubicBezierP1(t, p1) + $ce0cdebec9150cb3$var$CubicBezierP2(t, p2) + $ce0cdebec9150cb3$var$CubicBezierP3(t, p3);
}
/**
 * A curve representing a 2D Cubic Bezier curve.
 *
 * ```js
 * const curve = new THREE.CubicBezierCurve(
 * 	new THREE.Vector2( - 0, 0 ),
 * 	new THREE.Vector2( - 5, 15 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$e36650d36468bb39 extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The first control point.
	 * @param {Vector2} [v2] - The second control point.
	 * @param {Vector2} [v3] - The end point.
	 */ constructor(v0 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(), v1 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(), v2 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(), v3 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $ce0cdebec9150cb3$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($ce0cdebec9150cb3$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $ce0cdebec9150cb3$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 3D Cubic Bezier curve.
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$13d5f1c9525f246c extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The first control point.
	 * @param {Vector3} [v2] - The second control point.
	 * @param {Vector3} [v3] - The end point.
	 */ constructor(v0 = new $ce0cdebec9150cb3$export$64b5c384219d3699(), v1 = new $ce0cdebec9150cb3$export$64b5c384219d3699(), v2 = new $ce0cdebec9150cb3$export$64b5c384219d3699(), v3 = new $ce0cdebec9150cb3$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $ce0cdebec9150cb3$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($ce0cdebec9150cb3$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $ce0cdebec9150cb3$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $ce0cdebec9150cb3$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 2D line segment.
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$ab2e07e76531a47e extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector2} [v1] - The start point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v1 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(), v2 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve = true;
        this.type = 'LineCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the line.
	 */ getPoint(t, optionalTarget = new $ce0cdebec9150cb3$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $ce0cdebec9150cb3$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D line segment.
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$1fdfd9d9cf487600 extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector3} [v1] - The start point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v1 = new $ce0cdebec9150cb3$export$64b5c384219d3699(), v2 = new $ce0cdebec9150cb3$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the line.
	 */ getPoint(t, optionalTarget = new $ce0cdebec9150cb3$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $ce0cdebec9150cb3$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D Quadratic Bezier curve.
 *
 * ```js
 * const curve = new THREE.QuadraticBezierCurve(
 * 	new THREE.Vector2( - 10, 0 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * )
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$5938c4ee491a43ad extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The control point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v0 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(), v1 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(), v2 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $ce0cdebec9150cb3$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($ce0cdebec9150cb3$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $ce0cdebec9150cb3$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D Quadratic Bezier curve.
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$bf3f4c7e459f90fc extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The control point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v0 = new $ce0cdebec9150cb3$export$64b5c384219d3699(), v1 = new $ce0cdebec9150cb3$export$64b5c384219d3699(), v2 = new $ce0cdebec9150cb3$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $ce0cdebec9150cb3$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($ce0cdebec9150cb3$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $ce0cdebec9150cb3$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $ce0cdebec9150cb3$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D spline curve.
 *
 * ```js
 * // Create a sine-like wave
 * const curve = new THREE.SplineCurve( [
 * 	new THREE.Vector2( -10, 0 ),
 * 	new THREE.Vector2( -5, 5 ),
 * 	new THREE.Vector2( 0, 0 ),
 * 	new THREE.Vector2( 5, -5 ),
 * 	new THREE.Vector2( 10, 0 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const splineObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$d3bdd77da77afc1b extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new 2D spline curve.
	 *
	 * @param {Array<Vector2>} [points] -  An array of 2D points defining the curve.
	 */ constructor(points = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplineCurve = true;
        this.type = 'SplineCurve';
        /**
		 * An array of 2D points defining the curve.
		 *
		 * @type {Array<Vector2>}
		 */ this.points = points;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $ce0cdebec9150cb3$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($ce0cdebec9150cb3$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $ce0cdebec9150cb3$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $ce0cdebec9150cb3$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $ce0cdebec9150cb3$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $ce0cdebec9150cb3$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $ce0cdebec9150cb3$export$b9146b27c24b744c,
    CubicBezierCurve: $ce0cdebec9150cb3$export$e36650d36468bb39,
    CubicBezierCurve3: $ce0cdebec9150cb3$export$13d5f1c9525f246c,
    EllipseCurve: $ce0cdebec9150cb3$export$3f87a931616cde04,
    LineCurve: $ce0cdebec9150cb3$export$ab2e07e76531a47e,
    LineCurve3: $ce0cdebec9150cb3$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $ce0cdebec9150cb3$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $ce0cdebec9150cb3$export$bf3f4c7e459f90fc,
    SplineCurve: $ce0cdebec9150cb3$export$d3bdd77da77afc1b
});
/**
 * A base class extending {@link Curve}. `CurvePath` is simply an
 * array of connected curves, but retains the API of a curve.
 *
 * @augments Curve
 */ class $ce0cdebec9150cb3$export$4aaf9b66af1bbf2c extends $ce0cdebec9150cb3$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve path.
	 */ constructor(){
        super();
        this.type = 'CurvePath';
        /**
		 * An array of curves defining the
		 * path.
		 *
		 * @type {Array<Curve>}
		 */ this.curves = [];
        /**
		 * Whether the path should automatically be closed
		 * by a line curve.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoClose = false;
    }
    /**
	 * Adds a curve to this curve path.
	 *
	 * @param {Curve} curve - The curve to add.
	 */ add(curve) {
        this.curves.push(curve);
    }
    /**
	 * Adds a line curve to close the path.
	 *
	 * @return {CurvePath} A reference to this curve path.
	 */ closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $ce0cdebec9150cb3$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definitions)
	 * for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint(t, optionalTarget) {
        // To get accurate point with reference to
        // entire path distance at time t,
        // following has to be done:
        // 1. Length of each sub path have to be known
        // 2. Locate and identify type of curve
        // 3. Get t for the curve
        // 4. Return curve.getPointAt(t')
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    getLength() {
        // We cannot use the default THREE.Curve getPoint() with getLength() because in
        // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
        // getPoint() depends on getLength
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    updateArcLengths() {
        // cacheLengths must be recalculated.
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    /**
	 * Returns list of cumulative curve lengths of the defined curves.
	 *
	 * @return {Array<number>} The curve lengths.
	 */ getCurveLengths() {
        // Compute lengths and cache them
        // We cannot overwrite getLengths() because UtoT mapping uses it.
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $ce0cdebec9150cb3$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
/**
 * A 2D path representation. The class provides methods for creating paths
 * and contours of 2D shapes similar to the 2D Canvas API.
 *
 * ```js
 * const path = new THREE.Path();
 *
 * path.lineTo( 0, 0.8 );
 * path.quadraticCurveTo( 0, 1, 0.2, 1 );
 * path.lineTo( 1, 1 );
 *
 * const points = path.getPoints();
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments CurvePath
 */ class $ce0cdebec9150cb3$export$4b2950bdac9b6ee9 extends $ce0cdebec9150cb3$export$4aaf9b66af1bbf2c {
    /**
	 * Constructs a new path.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the path.
	 */ constructor(points){
        super();
        this.type = 'Path';
        /**
		 * The current offset of the path. Any new curve added will start here.
		 *
		 * @type {Vector2}
		 */ this.currentPoint = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    /**
	 * Creates a path from the given list of points. The points are added
	 * to the path as instances of {@link LineCurve}.
	 *
	 * @param {Array<Vector2>} points - An array of 2D points.
	 * @return {Path} A reference to this path.
	 */ setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    /**
	 * Moves {@link Path#currentPoint} to the given point.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {Path} A reference to this path.
	 */ moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ lineTo(x, y) {
        const curve = new $ce0cdebec9150cb3$export$ab2e07e76531a47e(this.currentPoint.clone(), new $ce0cdebec9150cb3$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $ce0cdebec9150cb3$export$5938c4ee491a43ad(this.currentPoint.clone(), new $ce0cdebec9150cb3$export$c977b3e384af9ae1(aCPx, aCPy), new $ce0cdebec9150cb3$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $ce0cdebec9150cb3$export$e36650d36468bb39(this.currentPoint.clone(), new $ce0cdebec9150cb3$export$c977b3e384af9ae1(aCP1x, aCP1y), new $ce0cdebec9150cb3$export$c977b3e384af9ae1(aCP2x, aCP2y), new $ce0cdebec9150cb3$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {Path} A reference to this path.
	 */ splineThru(pts) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $ce0cdebec9150cb3$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    /**
	 * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    /**
	 * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the absolute center of the ellipse.
	 * @param {number} [aY=0] - The y coordinate of the absolute center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $ce0cdebec9150cb3$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
/**
 * Defines an arbitrary 2d shape plane using paths with optional holes. It
 * can be used with {@link ExtrudeGeometry}, {@link ShapeGeometry}, to get
 * points, or to get triangulated faces.
 *
 * ```js
 * const heartShape = new THREE.Shape();
 *
 * heartShape.moveTo( 25, 25 );
 * heartShape.bezierCurveTo( 25, 25, 20, 0, 0, 0 );
 * heartShape.bezierCurveTo( - 30, 0, - 30, 35, - 30, 35 );
 * heartShape.bezierCurveTo( - 30, 55, - 10, 77, 25, 95 );
 * heartShape.bezierCurveTo( 60, 77, 80, 55, 80, 35 );
 * heartShape.bezierCurveTo( 80, 35, 80, 0, 50, 0 );
 * heartShape.bezierCurveTo( 35, 0, 25, 25, 25, 25 );
 *
 * const extrudeSettings = {
 * 	depth: 8,
 * 	bevelEnabled: true,
 * 	bevelSegments: 2,
 * 	steps: 2,
 * 	bevelSize: 1,
 * 	bevelThickness: 1
 * };
 *
 * const geometry = new THREE.ExtrudeGeometry( heartShape, extrudeSettings );
 * const mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial() );
 * ```
 *
 * @augments Path
 */ class $ce0cdebec9150cb3$export$6428a7f2611ef1fa extends $ce0cdebec9150cb3$export$4b2950bdac9b6ee9 {
    /**
	 * Constructs a new shape.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the shape.
	 */ constructor(points){
        super(points);
        /**
		 * The UUID of the shape.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $ce0cdebec9150cb3$var$generateUUID();
        this.type = 'Shape';
        /**
		 * Defines the holes in the shape. Hole definitions must use the
		 * opposite winding order (CW/CCW) than the outer shape.
		 *
		 * @type {Array<Path>}
		 * @readonly
		 */ this.holes = [];
    }
    /**
	 * Returns an array representing each contour of the holes
	 * as a list of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
	 */ getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    /**
	 * Returns an object that holds contour data for the shape and its holes as
	 * arrays of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
	 */ extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $ce0cdebec9150cb3$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/* eslint-disable */ // copy of mapbox/earcut version 3.0.2
// https://github.com/mapbox/earcut/tree/v3.0.2
function $ce0cdebec9150cb3$var$earcut(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $ce0cdebec9150cb3$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $ce0cdebec9150cb3$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = data[0];
        minY = data[1];
        let maxX = minX;
        let maxY = minY;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $ce0cdebec9150cb3$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $ce0cdebec9150cb3$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $ce0cdebec9150cb3$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $ce0cdebec9150cb3$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $ce0cdebec9150cb3$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $ce0cdebec9150cb3$var$equals(last, last.next)) {
        $ce0cdebec9150cb3$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $ce0cdebec9150cb3$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($ce0cdebec9150cb3$var$equals(p, p.next) || $ce0cdebec9150cb3$var$area(p.prev, p, p.next) === 0)) {
            $ce0cdebec9150cb3$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $ce0cdebec9150cb3$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $ce0cdebec9150cb3$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $ce0cdebec9150cb3$var$isEarHashed(ear, minX, minY, invSize) : $ce0cdebec9150cb3$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $ce0cdebec9150cb3$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $ce0cdebec9150cb3$var$earcutLinked($ce0cdebec9150cb3$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $ce0cdebec9150cb3$var$cureLocalIntersections($ce0cdebec9150cb3$var$filterPoints(ear), triangles);
                $ce0cdebec9150cb3$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $ce0cdebec9150cb3$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $ce0cdebec9150cb3$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($ce0cdebec9150cb3$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $ce0cdebec9150cb3$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $ce0cdebec9150cb3$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $ce0cdebec9150cb3$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($ce0cdebec9150cb3$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $ce0cdebec9150cb3$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $ce0cdebec9150cb3$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $ce0cdebec9150cb3$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $ce0cdebec9150cb3$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $ce0cdebec9150cb3$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $ce0cdebec9150cb3$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $ce0cdebec9150cb3$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $ce0cdebec9150cb3$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $ce0cdebec9150cb3$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $ce0cdebec9150cb3$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $ce0cdebec9150cb3$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$ce0cdebec9150cb3$var$equals(a, b) && $ce0cdebec9150cb3$var$intersects(a, p, p.next, b) && $ce0cdebec9150cb3$var$locallyInside(a, b) && $ce0cdebec9150cb3$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $ce0cdebec9150cb3$var$removeNode(p);
            $ce0cdebec9150cb3$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $ce0cdebec9150cb3$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $ce0cdebec9150cb3$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $ce0cdebec9150cb3$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $ce0cdebec9150cb3$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $ce0cdebec9150cb3$var$filterPoints(a, a.next);
                c = $ce0cdebec9150cb3$var$filterPoints(c, c.next);
                // run earcut on each half
                $ce0cdebec9150cb3$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $ce0cdebec9150cb3$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $ce0cdebec9150cb3$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $ce0cdebec9150cb3$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($ce0cdebec9150cb3$var$getLeftmost(list));
    }
    queue.sort($ce0cdebec9150cb3$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $ce0cdebec9150cb3$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $ce0cdebec9150cb3$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $ce0cdebec9150cb3$var$eliminateHole(hole, outerNode) {
    const bridge = $ce0cdebec9150cb3$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $ce0cdebec9150cb3$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $ce0cdebec9150cb3$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $ce0cdebec9150cb3$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $ce0cdebec9150cb3$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($ce0cdebec9150cb3$var$equals(hole, p)) return p;
    do {
        if ($ce0cdebec9150cb3$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $ce0cdebec9150cb3$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($ce0cdebec9150cb3$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $ce0cdebec9150cb3$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $ce0cdebec9150cb3$var$sectorContainsSector(m, p) {
    return $ce0cdebec9150cb3$var$area(m.prev, m, p.prev) < 0 && $ce0cdebec9150cb3$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $ce0cdebec9150cb3$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $ce0cdebec9150cb3$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $ce0cdebec9150cb3$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $ce0cdebec9150cb3$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $ce0cdebec9150cb3$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $ce0cdebec9150cb3$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $ce0cdebec9150cb3$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $ce0cdebec9150cb3$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $ce0cdebec9150cb3$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $ce0cdebec9150cb3$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$ce0cdebec9150cb3$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($ce0cdebec9150cb3$var$locallyInside(a, b) && $ce0cdebec9150cb3$var$locallyInside(b, a) && $ce0cdebec9150cb3$var$middleInside(a, b) && // locally visible
    ($ce0cdebec9150cb3$var$area(a.prev, a, b.prev) || $ce0cdebec9150cb3$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $ce0cdebec9150cb3$var$equals(a, b) && $ce0cdebec9150cb3$var$area(a.prev, a, a.next) > 0 && $ce0cdebec9150cb3$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $ce0cdebec9150cb3$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $ce0cdebec9150cb3$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $ce0cdebec9150cb3$var$intersects(p1, q1, p2, q2) {
    const o1 = $ce0cdebec9150cb3$var$sign($ce0cdebec9150cb3$var$area(p1, q1, p2));
    const o2 = $ce0cdebec9150cb3$var$sign($ce0cdebec9150cb3$var$area(p1, q1, q2));
    const o3 = $ce0cdebec9150cb3$var$sign($ce0cdebec9150cb3$var$area(p2, q2, p1));
    const o4 = $ce0cdebec9150cb3$var$sign($ce0cdebec9150cb3$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $ce0cdebec9150cb3$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $ce0cdebec9150cb3$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $ce0cdebec9150cb3$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $ce0cdebec9150cb3$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $ce0cdebec9150cb3$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $ce0cdebec9150cb3$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $ce0cdebec9150cb3$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $ce0cdebec9150cb3$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $ce0cdebec9150cb3$var$locallyInside(a, b) {
    return $ce0cdebec9150cb3$var$area(a.prev, a, a.next) < 0 ? $ce0cdebec9150cb3$var$area(a, b, a.next) >= 0 && $ce0cdebec9150cb3$var$area(a, a.prev, b) >= 0 : $ce0cdebec9150cb3$var$area(a, b, a.prev) < 0 || $ce0cdebec9150cb3$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $ce0cdebec9150cb3$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $ce0cdebec9150cb3$var$splitPolygon(a, b) {
    const a2 = $ce0cdebec9150cb3$var$createNode(a.i, a.x, a.y), b2 = $ce0cdebec9150cb3$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $ce0cdebec9150cb3$var$insertNode(i, x, y, last) {
    const p = $ce0cdebec9150cb3$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $ce0cdebec9150cb3$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $ce0cdebec9150cb3$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $ce0cdebec9150cb3$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
/**
 * An implementation of the earcut polygon triangulation algorithm.
 * The code is a port of [mapbox/earcut](https://github.com/mapbox/earcut).
 *
 * @see https://github.com/mapbox/earcut
 */ class $ce0cdebec9150cb3$var$Earcut {
    /**
	 * Triangulates the given shape definition by returning an array of triangles.
	 *
	 * @param {Array<number>} data - An array with 2D points.
	 * @param {Array<number>} holeIndices - An array with indices defining holes.
	 * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
	 * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
	 * representing vertex indices.
	 */ static triangulate(data, holeIndices, dim = 2) {
        return $ce0cdebec9150cb3$var$earcut(data, holeIndices, dim);
    }
}
/**
 * A class containing utility functions for shapes.
 *
 * @hideconstructor
 */ class $ce0cdebec9150cb3$export$96bdf6d9c66d7ba8 {
    /**
	 * Calculate area of a ( 2D ) contour polygon.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points.
	 * @return {number} The area.
	 */ static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    /**
	 * Returns `true` if the given contour uses a clockwise winding order.
	 *
	 * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
	 * @return {boolean} Whether the given contour uses a clockwise winding order or not.
	 */ static isClockWise(pts) {
        return $ce0cdebec9150cb3$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    /**
	 * Triangulates the given shape definition.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
	 * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
	 * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
	 */ static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $ce0cdebec9150cb3$var$removeDupEndPts(contour);
        $ce0cdebec9150cb3$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($ce0cdebec9150cb3$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $ce0cdebec9150cb3$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $ce0cdebec9150cb3$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $ce0cdebec9150cb3$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $ce0cdebec9150cb3$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * ```js
 * const length = 12, width = 8;
 *
 * const shape = new THREE.Shape();
 * shape.moveTo( 0,0 );
 * shape.lineTo( 0, width );
 * shape.lineTo( length, width );
 * shape.lineTo( length, 0 );
 * shape.lineTo( 0, 0 );
 *
 * const geometry = new THREE.ExtrudeGeometry( shape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ExtrudeGeometry
 */ class $ce0cdebec9150cb3$export$598697a1efa63ca7 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new extrude geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {ExtrudeGeometry~Options} [options] - The extrude settings.
	 */ constructor(shapes = new $ce0cdebec9150cb3$export$6428a7f2611ef1fa([
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0.5, 0.5),
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(-0.5, 0.5),
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(-0.5, -0.5),
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $ce0cdebec9150cb3$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                const isClosed = extrudePath.isCatmullRomCurve3 ? extrudePath.closed : false;
                splineTube = extrudePath.computeFrenetFrames(steps, isClosed);
                // log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
                normal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
                position2 = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$ce0cdebec9150cb3$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($ce0cdebec9150cb3$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            /**Merges index-adjacent points that are within a threshold distance of each other. Array is modified in-place. Threshold distance is empirical, and scaled based on the magnitude of point coordinates.
			 * @param {Array<Vector2>} points
			*/ function mergeOverlappingPoints(points) {
                const THRESHOLD = 1e-10;
                const THRESHOLD_SQ = THRESHOLD * THRESHOLD;
                let prevPos = points[0];
                for(let i = 1; i <= points.length; i++){
                    const currentIndex = i % points.length;
                    const currentPos = points[currentIndex];
                    const dx = currentPos.x - prevPos.x;
                    const dy = currentPos.y - prevPos.y;
                    const distSq = dx * dx + dy * dy;
                    const scalingFactorSqrt = Math.max(Math.abs(currentPos.x), Math.abs(currentPos.y), Math.abs(prevPos.x), Math.abs(prevPos.y));
                    const thresholdSqScaled = THRESHOLD_SQ * scalingFactorSqrt * scalingFactorSqrt;
                    if (distSq <= thresholdSqScaled) {
                        points.splice(currentIndex, 1);
                        i--;
                        continue;
                    }
                    prevPos = currentPos;
                }
            }
            mergeOverlappingPoints(vertices);
            holes.forEach(mergeOverlappingPoints);
            const numHoles = holes.length;
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0; h < numHoles; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) $ce0cdebec9150cb3$export$a3bc9b8ed74fc('ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $ce0cdebec9150cb3$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $ce0cdebec9150cb3$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = numHoles; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            let faces;
            if (bevelSegments === 0) faces = $ce0cdebec9150cb3$export$96bdf6d9c66d7ba8.triangulateShape(contour, holes);
            else {
                const contractedContourVertices = [];
                const expandedHoleVertices = [];
                // Loop bevelSegments, 1 for the front, 1 for the back
                for(let b = 0; b < bevelSegments; b++){
                    //for ( b = bevelSegments; b > 0; b -- ) {
                    const t = b / bevelSegments;
                    const z = bevelThickness * Math.cos(t * Math.PI / 2);
                    const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                    // contract shape
                    for(let i = 0, il = contour.length; i < il; i++){
                        const vert = scalePt2(contour[i], contourMovements[i], bs);
                        v(vert.x, vert.y, -z);
                        if (t === 0) contractedContourVertices.push(vert);
                    }
                    // expand holes
                    for(let h = 0, hl = numHoles; h < hl; h++){
                        const ahole = holes[h];
                        oneHoleMovements = holesMovements[h];
                        const oneHoleVertices = [];
                        for(let i = 0, il = ahole.length; i < il; i++){
                            const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                            v(vert.x, vert.y, -z);
                            if (t === 0) oneHoleVertices.push(vert);
                        }
                        if (t === 0) expandedHoleVertices.push(oneHoleVertices);
                    }
                }
                faces = $ce0cdebec9150cb3$export$96bdf6d9c66d7ba8.triangulateShape(contractedContourVertices, expandedHoleVertices);
            }
            const flen = faces.length;
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $ce0cdebec9150cb3$var$toJSON$1(shapes, options, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ExtrudeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $ce0cdebec9150cb3$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $ce0cdebec9150cb3$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $ce0cdebec9150cb3$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(a_x, a_y),
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(b_x, b_y),
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $ce0cdebec9150cb3$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $ce0cdebec9150cb3$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * A geometry class for representing an icosahedron.
 *
 * ```js
 * const geometry = new THREE.IcosahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const icosahedron = new THREE.Mesh( geometry, material );
 * scene.add( icosahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#IcosahedronGeometry
 */ class $ce0cdebec9150cb3$export$9567cc828c9535da extends $ce0cdebec9150cb3$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new icosahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the icosahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a icosahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {IcosahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$9567cc828c9535da(data.radius, data.detail);
    }
}
/**
 * Creates meshes with axial symmetry like vases. The lathe rotates around the Y axis.
 *
 * ```js
 * const points = [];
 * for ( let i = 0; i < 10; i ++ ) {
 * 	points.push( new THREE.Vector2( Math.sin( i * 0.2 ) * 10 + 5, ( i - 5 ) * 2 ) );
 * }
 * const geometry = new THREE.LatheGeometry( points );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const lathe = new THREE.Mesh( geometry, material );
 * scene.add( lathe );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#LatheGeometry
 */ class $ce0cdebec9150cb3$export$6d839803fcd1882c extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new lathe geometry.
	 *
	 * @param {Array<Vector2|Vector3>} [points] - An array of points in 2D space. The x-coordinate of each point
	 * must be greater than zero.
	 * @param {number} [segments=12] - The number of circumference segments to generate.
	 * @param {number} [phiStart=0] - The starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The radian (0 to 2PI) range of the lathed section 2PI is a
	 * closed lathe, less than 2PI is a portion.
	 */ constructor(points = [
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0, -0.5),
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0.5, 0),
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $ce0cdebec9150cb3$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const uv = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
        const normal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const curNormal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const prevNormal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {LatheGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
/**
 * A geometry class for representing an octahedron.
 *
 * ```js
 * const geometry = new THREE.OctahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const octahedron = new THREE.Mesh( geometry, material );
 * scene.add( octahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#OctahedronGeometry
 */ class $ce0cdebec9150cb3$export$1954e2b809fe361e extends $ce0cdebec9150cb3$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new octahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the octahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a octahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {OctahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a plane.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const plane = new THREE.Mesh( geometry, material );
 * scene.add( plane );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#PlaneGeometry
 */ class $ce0cdebec9150cb3$export$967d831af31f69ce extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new plane geometry.
	 *
	 * @param {number} [width=1] - The width along the X axis.
	 * @param {number} [height=1] - The height along the Y axis
	 * @param {number} [widthSegments=1] - The number of segments along the X axis.
	 * @param {number} [heightSegments=1] - The number of segments along the Y axis.
	 */ constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PlaneGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
/**
 * A class for generating a two-dimensional ring geometry.
 *
 * ```js
 * const geometry = new THREE.RingGeometry( 1, 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#RingGeometry
 */ class $ce0cdebec9150cb3$export$68cb731f50f614af extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new ring geometry.
	 *
	 * @param {number} [innerRadius=0.5] - The inner radius of the ring.
	 * @param {number} [outerRadius=1] - The outer radius of the ring.
	 * @param {number} [thetaSegments=32] - Number of segments. A higher number means the ring will be more round. Minimum is `3`.
	 * @param {number} [phiSegments=1] - Number of segments per ring segment. Minimum is `1`.
	 * @param {number} [thetaStart=0] - Starting angle in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Central angle in radians.
	 */ constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const uv = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {RingGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
/**
 * Creates an one-sided polygonal geometry from one or more path shapes.
 *
 * ```js
 * const arcShape = new THREE.Shape()
 *	.moveTo( 5, 1 )
 *	.absarc( 1, 1, 4, 0, Math.PI * 2, false );
 *
 * const geometry = new THREE.ShapeGeometry( arcShape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ShapeGeometry
 */ class $ce0cdebec9150cb3$export$57a29a1c803e9065 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new shape geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {number} [curveSegments=12] - Number of segments per shape.
	 */ constructor(shapes = new $ce0cdebec9150cb3$export$6428a7f2611ef1fa([
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0, 0.5),
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(-0.5, -0.5),
        new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($ce0cdebec9150cb3$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($ce0cdebec9150cb3$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $ce0cdebec9150cb3$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $ce0cdebec9150cb3$var$toJSON(shapes, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ShapeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $ce0cdebec9150cb3$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $ce0cdebec9150cb3$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
/**
 * A class for generating a sphere geometry.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry( 15, 32, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const sphere = new THREE.Mesh( geometry, material );
 * scene.add( sphere );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#SphereGeometry
 */ class $ce0cdebec9150cb3$export$1b417fc3b307a251 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new sphere geometry.
	 *
	 * @param {number} [radius=1] - The sphere radius.
	 * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
	 * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
	 * @param {number} [phiStart=0] - The horizontal starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
	 * @param {number} [thetaStart=0] - The vertical starting angle in radians.
	 * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
	 */ constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const normal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {SphereGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing an tetrahedron.
 *
 * ```js
 * const geometry = new THREE.TetrahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const tetrahedron = new THREE.Mesh( geometry, material );
 * scene.add( tetrahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#TetrahedronGeometry
 */ class $ce0cdebec9150cb3$export$fb3f7adc68bd6e02 extends $ce0cdebec9150cb3$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new tetrahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the tetrahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a tetrahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TetrahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing an torus.
 *
 * ```js
 * const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torus = new THREE.Mesh( geometry, material );
 * scene.add( torus );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusGeometry
 */ class $ce0cdebec9150cb3$export$a2312a2a1fa56495 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
	 * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
	 * @param {number} [radialSegments=12] - The number of radial segments.
	 * @param {number} [tubularSegments=48] - The number of tubular segments.
	 * @param {number} [arc=Math.PI*2] - Central angle in radians.
	 * @param {number} [thetaStart=0] - Start of the tubular sweep in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Length of the tubular sweep in radians.
	 */ constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const normal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++){
            const v = thetaStart + j / radialSegments * thetaLength;
            for(let i = 0; i <= tubularSegments; i++){
                const u = i / tubularSegments * arc;
                // vertex
                vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
                vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
                vertex.z = tube * Math.sin(v);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                center.x = radius * Math.cos(u);
                center.y = radius * Math.sin(u);
                normal.subVectors(vertex, center).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
/**
 * Creates a torus knot, the particular shape of which is defined by a pair
 * of coprime integers, p and q. If p and q are not coprime, the result will
 * be a torus link.
 *
 * ```js
 * const geometry = new THREE.TorusKnotGeometry( 10, 3, 100, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torusKnot = new THREE.Mesh( geometry, material );
 * scene.add( torusKnot );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusKnotGeometry
 */ class $ce0cdebec9150cb3$export$77e9bfadfb9ab8c8 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus knot geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus knot.
	 * @param {number} [tube=0.4] - Radius of the tube.
	 * @param {number} [tubularSegments=64] - The number of tubular segments.
	 * @param {number} [radialSegments=8] - The number of radial segments.
	 * @param {number} [p=2] - This value determines, how many times the geometry winds around its axis of rotational symmetry.
	 * @param {number} [q=3] - This value determines, how many times the geometry winds around a circle in the interior of the torus.
	 */ constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const normal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const P1 = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const P2 = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const B = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const T = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const N = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusKnotGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $ce0cdebec9150cb3$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
/**
 * Creates a tube that extrudes along a 3D curve.
 *
 * ```js
 * class CustomSinCurve extends THREE.Curve {
 *
 * 	getPoint( t, optionalTarget = new THREE.Vector3() ) {
 *
 * 		const tx = t * 3 - 1.5;
 * 		const ty = Math.sin( 2 * Math.PI * t );
 * 		const tz = 0;
 *
 * 		return optionalTarget.set( tx, ty, tz );
 * 	}
 *
 * }
 *
 * const path = new CustomSinCurve( 10 );
 * const geometry = new THREE.TubeGeometry( path, 20, 2, 8, false );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TubeGeometry
 */ class $ce0cdebec9150cb3$export$7897d9d48904490c extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new tube geometry.
	 *
	 * @param {Curve} [path=QuadraticBezierCurve3] - A 3D curve defining the path of the tube.
	 * @param {number} [tubularSegments=64] - The number of segments that make up the tube.
	 * @param {number} [radius=1] -The radius of the tube.
	 * @param {number} [radialSegments=8] - The number of segments that make up the cross-section.
	 * @param {boolean} [closed=false] - Whether the tube is closed or not.
	 */ constructor(path = new $ce0cdebec9150cb3$export$bf3f4c7e459f90fc(new $ce0cdebec9150cb3$export$64b5c384219d3699(-1, -1, 0), new $ce0cdebec9150cb3$export$64b5c384219d3699(-1, 1, 0), new $ce0cdebec9150cb3$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const normal = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const uv = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
        let P = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TubeGeometry} A new instance.
	 */ static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $ce0cdebec9150cb3$export$7897d9d48904490c(new $ce0cdebec9150cb3$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
/**
 * Can be used as a helper object to visualize a geometry as a wireframe.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry();
 *
 * const wireframe = new THREE.WireframeGeometry( geometry );
 *
 * const line = new THREE.LineSegments( wireframe );
 * line.material.depthWrite = false;
 * line.material.opacity = 0.25;
 * line.material.transparent = true;
 *
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $ce0cdebec9150cb3$export$4b739da06d24892b extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new wireframe geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 */ constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            const end = new $ce0cdebec9150cb3$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($ce0cdebec9150cb3$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($ce0cdebec9150cb3$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $ce0cdebec9150cb3$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $ce0cdebec9150cb3$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $ce0cdebec9150cb3$export$33e43285f7406bd5,
    CapsuleGeometry: $ce0cdebec9150cb3$export$41680e8551036033,
    CircleGeometry: $ce0cdebec9150cb3$export$d5c0e8d607467193,
    ConeGeometry: $ce0cdebec9150cb3$export$a7a48974f285c9b3,
    CylinderGeometry: $ce0cdebec9150cb3$export$68f745719dbe5198,
    DodecahedronGeometry: $ce0cdebec9150cb3$export$c0babfeb8708fc9c,
    EdgesGeometry: $ce0cdebec9150cb3$export$4730b1542707547f,
    ExtrudeGeometry: $ce0cdebec9150cb3$export$598697a1efa63ca7,
    IcosahedronGeometry: $ce0cdebec9150cb3$export$9567cc828c9535da,
    LatheGeometry: $ce0cdebec9150cb3$export$6d839803fcd1882c,
    OctahedronGeometry: $ce0cdebec9150cb3$export$1954e2b809fe361e,
    PlaneGeometry: $ce0cdebec9150cb3$export$967d831af31f69ce,
    PolyhedronGeometry: $ce0cdebec9150cb3$export$60e57a7d3f20ff65,
    RingGeometry: $ce0cdebec9150cb3$export$68cb731f50f614af,
    ShapeGeometry: $ce0cdebec9150cb3$export$57a29a1c803e9065,
    SphereGeometry: $ce0cdebec9150cb3$export$1b417fc3b307a251,
    TetrahedronGeometry: $ce0cdebec9150cb3$export$fb3f7adc68bd6e02,
    TorusGeometry: $ce0cdebec9150cb3$export$a2312a2a1fa56495,
    TorusKnotGeometry: $ce0cdebec9150cb3$export$77e9bfadfb9ab8c8,
    TubeGeometry: $ce0cdebec9150cb3$export$7897d9d48904490c,
    WireframeGeometry: $ce0cdebec9150cb3$export$4b739da06d24892b
});
/**
 * This material can receive shadows, but otherwise is completely transparent.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 2000, 2000 );
 * geometry.rotateX( - Math.PI / 2 );
 *
 * const material = new THREE.ShadowMaterial();
 * material.opacity = 0.2;
 *
 * const plane = new THREE.Mesh( geometry, material );
 * plane.position.y = -200;
 * plane.receiveShadow = true;
 * scene.add( plane );
 * ```
 *
 * @augments Material
 */ class $ce0cdebec9150cb3$export$e8564da406055a3 extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shadow material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x000000);
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
/**
 * Provides utility functions for managing uniforms.
 *
 * @module UniformsUtils
 */ /**
 * Clones the given uniform definitions by performing a deep-copy. That means
 * if the value of a uniform refers to an object like a Vector3 or Texture,
 * the cloned uniform will refer to a new object reference.
 *
 * @param {Object} src - An object representing uniform definitions.
 * @return {Object} The cloned uniforms.
 */ function $ce0cdebec9150cb3$export$acda854380553452(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    $ce0cdebec9150cb3$export$c106dd0671a0fc2d('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
/**
 * Merges the given uniform definitions into a single object. Since the
 * method internally uses cloneUniforms(), it performs a deep-copy when
 * producing the merged uniform definitions.
 *
 * @param {Array} uniforms - An array of objects containing uniform definitions.
 * @return {Object} The merged uniforms.
 */ function $ce0cdebec9150cb3$export$8916ce6879271f43(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $ce0cdebec9150cb3$export$acda854380553452(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $ce0cdebec9150cb3$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $ce0cdebec9150cb3$export$a630742c640528c1(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $ce0cdebec9150cb3$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $ce0cdebec9150cb3$export$d8ecdf8615bfea69 = {
    clone: $ce0cdebec9150cb3$export$acda854380553452,
    merge: $ce0cdebec9150cb3$export$8916ce6879271f43
};
var $ce0cdebec9150cb3$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $ce0cdebec9150cb3$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * A material rendered with custom shaders. A shader is a small program written in GLSL.
 * that runs on the GPU. You may want to use a custom shader if you need to implement an
 * effect not included with any of the built-in materials.
 *
 * There are the following notes to bear in mind when using a `ShaderMaterial`:
 *
 * - `ShaderMaterial` can only be used with {@link WebGLRenderer}.
 * - Built in attributes and uniforms are passed to the shaders along with your code. If
 * you don't want that, use {@link RawShaderMaterial} instead.
 * - You can use the directive `#pragma unroll_loop_start` and `#pragma unroll_loop_end`
 * in order to unroll a `for` loop in GLSL by the shader preprocessor. The directive has
 * to be placed right above the loop. The loop formatting has to correspond to a defined standard.
 *   - The loop has to be [normalized](https://en.wikipedia.org/wiki/Normalized_loop).
 *   - The loop variable has to be *i*.
 *   - The value `UNROLLED_LOOP_INDEX` will be replaced with the explicitly
 * value of *i* for the given iteration and can be used in preprocessor
 * statements.
 *
 * ```js
 * const material = new THREE.ShaderMaterial( {
 * 	uniforms: {
 * 		time: { value: 1.0 },
 * 		resolution: { value: new THREE.Vector2() }
 * 	},
 * 	vertexShader: document.getElementById( 'vertexShader' ).textContent,
 * 	fragmentShader: document.getElementById( 'fragmentShader' ).textContent
 * } );
 * ```
 *
 * @augments Material
 */ class $ce0cdebec9150cb3$export$83c7d75d550a8b0d extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        /**
		 * Defines custom constants using `#define` directives within the GLSL code
		 * for both the vertex shader and the fragment shader; each key/value pair
		 * yields another directive.
		 * ```js
		 * defines: {
		 * 	FOO: 15,
		 * 	BAR: true
		 * }
		 * ```
		 * Yields the lines:
		 * ```
		 * #define FOO 15
		 * #define BAR true
		 * ```
		 *
		 * @type {Object}
		 */ this.defines = {};
        /**
		 * An object of the form:
		 * ```js
		 * {
		 * 	"uniform1": { value: 1.0 },
		 * 	"uniform2": { value: 2 }
		 * }
		 * ```
		 * specifying the uniforms to be passed to the shader code; keys are uniform
		 * names, values are definitions of the form
		 * ```
		 * {
		 * 	value: 1.0
		 * }
		 * ```
		 * where `value` is the value of the uniform. Names must match the name of
		 * the uniform, as defined in the GLSL code. Note that uniforms are refreshed
		 * on every frame, so updating the value of the uniform will immediately
		 * update the value available to the GLSL code.
		 *
		 * @type {Object}
		 */ this.uniforms = {};
        /**
		 * An array holding uniforms groups for configuring UBOs.
		 *
		 * @type {Array<UniformsGroup>}
		 */ this.uniformsGroups = [];
        /**
		 * Vertex shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.vertexShader = $ce0cdebec9150cb3$var$default_vertex;
        /**
		 * Fragment shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.fragmentShader = $ce0cdebec9150cb3$var$default_fragment;
        /**
		 * Controls line thickness or lines.
		 *
		 * WebGL and WebGPU ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines whether the material color is affected by global fog settings; `true`
		 * to pass fog uniforms to the shader.
		 *
		 * Setting this property to `true` requires the definition of fog uniforms. It is
		 * recommended to use `UniformsUtils.merge()` to combine the custom shader uniforms
		 * with predefined fog uniforms.
		 *
		 * ```js
		 * const material = new ShaderMaterial( {
		 *     uniforms: UniformsUtils.merge( [ UniformsLib[ 'fog' ], shaderUniforms ] );
		 *     vertexShader: vertexShader,
		 *     fragmentShader: fragmentShader,
		 *     fog: true
		 * } );
		 * ```
		 *
		 * @type {boolean}
		 * @default false
		 */ this.fog = false;
        /**
		 * Defines whether this material uses lighting; `true` to pass uniform data
		 * related to lighting to this shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.lights = false;
        /**
		 * Defines whether this material supports clipping; `true` to let the renderer
		 * pass the clippingPlanes uniform.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipping = false;
        /**
		 * Overwritten and set to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.forceSinglePass = true;
        /**
		 * This object allows to enable certain WebGL 2 extensions.
		 *
		 * - clipCullDistance: set to `true` to use vertex shader clipping
		 * - multiDraw: set to `true` to use vertex shader multi_draw / enable gl_DrawID
		 *
		 * @type {{clipCullDistance:false,multiDraw:false}}
		 */ this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        /**
		 * When the rendered geometry doesn't include these attributes but the
		 * material does, these default values will be passed to the shaders. This
		 * avoids errors when buffer data is missing.
		 *
		 * - color: [ 1, 1, 1 ]
		 * - uv: [ 0, 0 ]
		 * - uv1: [ 0, 0 ]
		 *
		 * @type {Object}
		 */ this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        /**
		 * If set, this calls [gl.bindAttribLocation](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindAttribLocation)
		 * to bind a generic vertex index to an attribute variable.
		 *
		 * @type {string|undefined}
		 * @default undefined
		 */ this.index0AttributeName = undefined;
        /**
		 * Can be used to force a uniform update while changing uniforms in
		 * {@link Object3D#onBeforeRender}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.uniformsNeedUpdate = false;
        /**
		 * Defines the GLSL version of custom shader code.
		 *
		 * @type {?(GLSL1|GLSL3)}
		 * @default null
		 */ this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $ce0cdebec9150cb3$export$acda854380553452(source.uniforms);
        this.uniformsGroups = $ce0cdebec9150cb3$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        this.defaultAttributeValues = Object.assign({}, source.defaultAttributeValues);
        this.index0AttributeName = source.index0AttributeName;
        this.uniformsNeedUpdate = source.uniformsNeedUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
/**
 * This class works just like {@link ShaderMaterial}, except that definitions
 * of built-in uniforms and attributes are not automatically prepended to the
 * GLSL shader code.
 *
 * `RawShaderMaterial` can only be used with {@link WebGLRenderer}.
 *
 * @augments ShaderMaterial
 */ class $ce0cdebec9150cb3$export$21c421a2e1df9d22 extends $ce0cdebec9150cb3$export$83c7d75d550a8b0d {
    /**
	 * Constructs a new raw shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
/**
 * A standard physically based material, using Metallic-Roughness workflow.
 *
 * Physically based rendering (PBR) has recently become the standard in many
 * 3D applications, such as [Unity](https://blogs.unity3d.com/2014/10/29/physically-based-shading-in-unity-5-a-primer/),
 * [Unreal](https://docs.unrealengine.com/latest/INT/Engine/Rendering/Materials/PhysicallyBased/) and
 * [3D Studio Max](http://area.autodesk.com/blogs/the-3ds-max-blog/what039s-new-for-rendering-in-3ds-max-2017).
 *
 * This approach differs from older approaches in that instead of using
 * approximations for the way in which light interacts with a surface, a
 * physically correct model is used. The idea is that, instead of tweaking
 * materials to look good under specific lighting, a material can be created
 * that will react 'correctly' under all lighting scenarios.
 *
 * In practice this gives a more accurate and realistic looking result than
 * the {@link MeshLambertMaterial} or {@link MeshPhongMaterial}, at the cost of
 * being somewhat more computationally expensive. `MeshStandardMaterial` uses per-fragment
 * shading.
 *
 * Note that for best results you should always specify an environment map when using this material.
 *
 * For a non-technical introduction to the concept of PBR and how to set up a
 * PBR material, check out these articles by the people at [marmoset](https://www.marmoset.co):
 *
 * - [Basic Theory of Physically Based Rendering](https://www.marmoset.co/posts/basic-theory-of-physically-based-rendering/)
 * - [Physically Based Rendering and You Can Too](https://www.marmoset.co/posts/physically-based-rendering-and-you-can-too/)
 *
 * Technical details of the approach used in three.js (and most other PBR systems) can be found is this
 * [paper from Disney](https://media.disneyanimation.com/uploads/production/publication_asset/48/asset/s2012_pbs_disney_brdf_notes_v3.pdf)
 * (pdf), by Brent Burley.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshStandardMaterial
 */ class $ce0cdebec9150cb3$export$f2980790215acccd extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh standard material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshStandardMaterial = true;
        this.type = 'MeshStandardMaterial';
        this.defines = {
            'STANDARD': ''
        };
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * How rough the material appears. `0.0` means a smooth mirror reflection, `1.0`
		 * means fully diffuse. If `roughnessMap` is also provided,
		 * both values are multiplied.
		 *
		 * @type {number}
		 * @default 1
		 */ this.roughness = 1.0;
        /**
		 * How much the material is like a metal. Non-metallic materials such as wood
		 * or stone use `0.0`, metallic use `1.0`, with nothing (usually) in between.
		 * A value between `0.0` and `1.0` could be used for a rusty metal look.
		 * If `metalnessMap` is also provided, both values are multiplied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.metalness = 0.0;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $ce0cdebec9150cb3$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The green channel of this texture is used to alter the roughness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.roughnessMap = null;
        /**
		 * The blue channel of this texture is used to alter the metalness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.metalnessMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map. To ensure a physically correct rendering, environment maps
		 * are internally pre-processed with {@link PMREMGenerator}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $ce0cdebec9150cb3$export$d93cc409a0768c5f();
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * An extension of the {@link MeshStandardMaterial}, providing more advanced
 * physically-based rendering properties:
 *
 * - Anisotropy: Ability to represent the anisotropic property of materials
 * as observable with brushed metals.
 * - Clearcoat: Some materials — like car paints, carbon fiber, and wet surfaces — require
 * a clear, reflective layer on top of another layer that may be irregular or rough.
 * Clearcoat approximates this effect, without the need for a separate transparent surface.
 * - Iridescence: Allows to render the effect where hue varies  depending on the viewing
 * angle and illumination angle. This can be seen on soap bubbles, oil films, or on the
 * wings of many insects.
 * - Physically-based transparency: One limitation of {@link Material#opacity} is that highly
 * transparent materials are less reflective. Physically-based transmission provides a more
 * realistic option for thin, transparent surfaces like glass.
 * - Advanced reflectivity: More flexible reflectivity for non-metallic materials.
 * - Sheen: Can be used for representing cloth and fabric materials.
 *
 * As a result of these complex shading features, `MeshPhysicalMaterial` has a
 * higher performance cost, per pixel, than other three.js materials. Most
 * effects are disabled by default, and add cost as they are enabled. For
 * best results, always specify an environment map when using this material.
 *
 * @augments MeshStandardMaterial
 * @demo scenes/material-browser.html#MeshPhysicalMaterial
 */ class $ce0cdebec9150cb3$export$28d04986c4269c9f extends $ce0cdebec9150cb3$export$f2980790215acccd {
    /**
	 * Constructs a new mesh physical material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        /**
		 * The rotation of the anisotropy in tangent, bitangent space, measured in radians
		 * counter-clockwise from the tangent. When `anisotropyMap` is present, this
		 * property provides additional rotation to the vectors in the texture.
		 *
		 * @type {number}
		 * @default 1
		 */ this.anisotropyRotation = 0;
        /**
		 * Red and green channels represent the anisotropy direction in `[-1, 1]` tangent,
		 * bitangent space, to be rotated by `anisotropyRotation`. The blue channel
		 * contains strength as `[0, 1]` to be multiplied by `anisotropy`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.anisotropyMap = null;
        /**
		 * The red channel of this texture is multiplied against `clearcoat`,
		 * for per-pixel control over a coating's intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatMap = null;
        /**
		 * Roughness of the clear coat layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.clearcoatRoughness = 0.0;
        /**
		 * The green channel of this texture is multiplied against
		 * `clearcoatRoughness`, for per-pixel control over a coating's roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatRoughnessMap = null;
        /**
		 * How much `clearcoatNormalMap` affects the clear coat layer, from
		 * `(0,0)` to `(1,1)`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.clearcoatNormalScale = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1);
        /**
		 * Can be used to enable independent normals for the clear coat layer.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatNormalMap = null;
        /**
		 * Index-of-refraction for non-metallic materials, from `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.5
		 */ this.ior = 1.5;
        /**
		 * Degree of reflectivity, from `0.0` to `1.0`. Default is `0.5`, which
		 * corresponds to an index-of-refraction of `1.5`.
		 *
		 * This models the reflectivity of non-metallic materials. It has no effect
		 * when `metalness` is `1.0`
		 *
		 * @name MeshPhysicalMaterial#reflectivity
		 * @type {number}
		 * @default 0.5
		 */ Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $ce0cdebec9150cb3$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        /**
		 * The red channel of this texture is multiplied against `iridescence`, for per-pixel
		 * control over iridescence.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceMap = null;
        /**
		 * Strength of the iridescence RGB color shift effect, represented by an index-of-refraction.
		 * Between `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.3
		 */ this.iridescenceIOR = 1.3;
        /**
		 *Array of exactly 2 elements, specifying minimum and maximum thickness of the iridescence layer.
		 Thickness of iridescence layer has an equivalent effect of the one `thickness` has on `ior`.
		 *
		 * @type {Array<number,number>}
		 * @default [100,400]
		 */ this.iridescenceThicknessRange = [
            100,
            400
        ];
        /**
		 * A texture that defines the thickness of the iridescence layer, stored in the green channel.
		 * Minimum and maximum values of thickness are defined by `iridescenceThicknessRange` array:
		 * - `0.0` in the green channel will result in thickness equal to first element of the array.
		 * - `1.0` in the green channel will result in thickness equal to second element of the array.
		 * - Values in-between will linearly interpolate between the elements of the array.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceThicknessMap = null;
        /**
		 * The sheen tint.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.sheenColor = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x000000);
        /**
		 * The RGB channels of this texture are multiplied against  `sheenColor`, for per-pixel control
		 * over sheen tint.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenColorMap = null;
        /**
		 * Roughness of the sheen layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.sheenRoughness = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `sheenRoughness`, for per-pixel control
		 * over sheen roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenRoughnessMap = null;
        /**
		 * The red channel of this texture is multiplied against `transmission`, for per-pixel control over
		 * optical transparency.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.transmissionMap = null;
        /**
		 * The thickness of the volume beneath the surface. The value is given in the
		 * coordinate space of the mesh. If the value is `0` the material is
		 * thin-walled. Otherwise the material is a volume boundary.
		 *
		 * @type {number}
		 * @default 0
		 */ this.thickness = 0;
        /**
		 * A texture that defines the thickness, stored in the green channel. This will
		 * be multiplied by `thickness`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.thicknessMap = null;
        /**
		 * Density of the medium given as the average distance that light travels in
		 * the medium before interacting with a particle. The value is given in world
		 * space units, and must be greater than zero.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.attenuationDistance = Infinity;
        /**
		 * The color that white light turns into due to absorption when reaching the
		 * attenuation distance.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.attenuationColor = new $ce0cdebec9150cb3$export$892596cec99bc70e(1, 1, 1);
        /**
		 * A float that scales the amount of specular reflection for non-metals only.
		 * When set to zero, the model is effectively Lambertian. From `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.specularIntensity = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `specularIntensity`,
		 * for per-pixel control over specular intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularIntensityMap = null;
        /**
		 * Tints the specular reflection at normal incidence for non-metals only.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.specularColor = new $ce0cdebec9150cb3$export$892596cec99bc70e(1, 1, 1);
        /**
		 * The RGB channels of this texture are multiplied against `specularColor`,
		 * for per-pixel control over specular color.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    /**
	 * The anisotropy strength, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    /**
	 * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
	 * clear coat related properties to enable multilayer materials that have a
	 * thin translucent layer over the base layer.
	 *
	 * @type {number}
	 * @default 0
	 */ get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    /**
	 * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
	 * the surface and the viewer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    /**
	 * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
	 * through a relatively clear volume. Any value zero or larger is valid, the typical range of
	 * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
	 *
	 * @type {number}
	 * @default 0
	 */ get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    /**
	 * The intensity of the sheen layer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    /**
	 * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
	 *
	 * Thin, transparent or semitransparent, plastic or glass materials remain
	 * largely reflective even if they are fully transmissive. The transmission
	 * property can be used to model these materials.
	 *
	 * When transmission is non-zero, `opacity` should be  set to `1`.
	 *
	 * @type {number}
	 * @default 0
	 */ get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
/**
 * A material for shiny surfaces with specular highlights.
 *
 * The material uses a non-physically based [Blinn-Phong](https://en.wikipedia.org/wiki/Blinn-Phong_shading_model)
 * model for calculating reflectance. Unlike the Lambertian model used in the
 * {@link MeshLambertMaterial} this can simulate shiny surfaces with specular
 * highlights (such as varnished wood). `MeshPhongMaterial` uses per-fragment shading.
 *
 * Performance will generally be greater when using this material over the
 * {@link MeshStandardMaterial} or {@link MeshPhysicalMaterial}, at the cost of
 * some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshPhongMaterial
 */ class $ce0cdebec9150cb3$export$24c72f71cbaf0678 extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh phong material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * Specular color of the material. The default color is set to `0x111111` (very dark grey)
		 *
		 * This defines how shiny the material is and the color of its shine.
		 *
		 * @type {Color}
		 */ this.specular = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x111111);
        /**
		 * How shiny the specular highlight is; a higher value gives a sharper highlight.
		 *
		 * @type {number}
		 * @default 30
		 */ this.shininess = 30;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $ce0cdebec9150cb3$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The specular map value affects both how much the specular surface
		 * highlight contributes and how much of the environment map affects the
		 * surface.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $ce0cdebec9150cb3$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $ce0cdebec9150cb3$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.envMapIntensity = source.envMapIntensity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material implementing toon shading.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshToonMaterial
 */ class $ce0cdebec9150cb3$export$df893cf97e765622 extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh toon material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Gradient map for toon shading. It's required to set
		 * {@link Texture#minFilter} and {@link Texture#magFilter} to {@linkNearestFilter}
		 * when using this type of texture.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.gradientMap = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $ce0cdebec9150cb3$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material that maps the normal vectors to RGB colors.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshNormalMaterial
 */ class $ce0cdebec9150cb3$export$bfe8c0a091f41ae7 extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh normal material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $ce0cdebec9150cb3$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
/**
 * A material for non-shiny surfaces, without specular highlights.
 *
 * The material uses a non-physically based [Lambertian](https://en.wikipedia.org/wiki/Lambertian_reflectance)
 * model for calculating reflectance. This can simulate some surfaces (such
 * as untreated wood or stone) well, but cannot simulate shiny surfaces with
 * specular highlights (such as varnished wood). `MeshLambertMaterial` uses per-fragment
 * shading.
 *
 * Due to the simplicity of the reflectance and illumination models,
 * performance will be greater when using this material over the
 * {@link MeshPhongMaterial}, {@link MeshStandardMaterial} or
 * {@link MeshPhysicalMaterial}, at the cost of some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshLambertMaterial
 */ class $ce0cdebec9150cb3$export$5023a9a8114806b8 extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh lambert material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $ce0cdebec9150cb3$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $ce0cdebec9150cb3$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $ce0cdebec9150cb3$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.envMapIntensity = source.envMapIntensity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for drawing geometry by depth. Depth is based off of the camera
 * near and far plane. White is nearest, black is farthest.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshDepthMaterial
 */ class $ce0cdebec9150cb3$export$2698c22ec13825db extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh depth material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        /**
		 * Type for depth packing.
		 *
		 * @type {(BasicDepthPacking|RGBADepthPacking|RGBDepthPacking|RGDepthPacking)}
		 * @default BasicDepthPacking
		 */ this.depthPacking = $ce0cdebec9150cb3$export$deeb383078690b50;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
/**
 * A material used internally for implementing shadow mapping with
 * point lights.
 *
 * Can also be used to customize the shadow casting of an object by assigning
 * an instance of `MeshDistanceMaterial` to {@link Object3D#customDistanceMaterial}.
 * The following examples demonstrates this approach in order to ensure
 * transparent parts of objects do not cast shadows.
 *
 * @augments Material
 */ class $ce0cdebec9150cb3$export$33e187ed002f2a19 extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh distance material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
/**
 * This material is defined by a MatCap (or Lit Sphere) texture, which encodes the
 * material color and shading.
 *
 * `MeshMatcapMaterial` does not respond to lights since the matcap image file encodes
 * baked lighting. It will cast a shadow onto an object that receives shadows
 * (and shadow clipping works), but it will not self-shadow or receive
 * shadows.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshMatcapMaterial
 */ class $ce0cdebec9150cb3$export$6f5fef6235ec12ee extends $ce0cdebec9150cb3$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh matcap material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The matcap map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.matcap = null;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $ce0cdebec9150cb3$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineDashedMaterial( {
 * 	color: 0xffffff,
 * 	scale: 1,
 * 	dashSize: 3,
 * 	gapSize: 1,
 * } );
 * ```
 *
 * @augments LineBasicMaterial
 */ class $ce0cdebec9150cb3$export$327886a3efaeaebe extends $ce0cdebec9150cb3$export$fbaaa33907730a0c {
    /**
	 * Constructs a new line dashed material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        /**
		 * The scale of the dashed part of a line.
		 *
		 * @type {number}
		 * @default 1
		 */ this.scale = 1;
        /**
		 * The size of the dash. This is both the gap with the stroke.
		 *
		 * @type {number}
		 * @default 3
		 */ this.dashSize = 3;
        /**
		 * The size of the gap.
		 *
		 * @type {number}
		 * @default 1
		 */ this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
/**
 * Converts an array to a specific type.
 *
 * @param {TypedArray|Array} array - The array to convert.
 * @param {TypedArray.constructor} type - The constructor of a typed array that defines the new type.
 * @return {TypedArray} The converted array.
 */ function $ce0cdebec9150cb3$var$convertArray(array, type) {
    if (!array || array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
/**
 * Returns an array by which times and values can be sorted.
 *
 * @param {Array<number>} times - The keyframe time values.
 * @return {Array<number>} The array.
 */ function $ce0cdebec9150cb3$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
/**
 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
 *
 * @param {Array<number>} values - The values to sort.
 * @param {number} stride - The stride.
 * @param {Array<number>} order - The sort order.
 * @return {Array<number>} The sorted values.
 */ function $ce0cdebec9150cb3$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
/**
 * Used for parsing AOS keyframe formats.
 *
 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
 * @param {Array<number>} times - This array will be filled with keyframe times by this function.
 * @param {Array<number>} values - This array will be filled with keyframe values by this function.
 * @param {string} valuePropertyName - The name of the property to use.
 */ function $ce0cdebec9150cb3$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(...value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
/**
 * Creates a new clip, containing only the segment of the original clip between the given frames.
 *
 * @param {AnimationClip} sourceClip - The values to sort.
 * @param {string} name - The name of the clip.
 * @param {number} startFrame - The start frame.
 * @param {number} endFrame - The end frame.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The new sub clip.
 */ function $ce0cdebec9150cb3$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $ce0cdebec9150cb3$var$convertArray(times, track.times.constructor);
        track.values = $ce0cdebec9150cb3$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
/**
 * Converts the keyframes of the given animation clip to an additive format.
 *
 * @param {AnimationClip} targetClip - The clip to make additive.
 * @param {number} [referenceFrame=0] - The reference frame.
 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The updated clip which is now additive.
 */ function $ce0cdebec9150cb3$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $ce0cdebec9150cb3$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $ce0cdebec9150cb3$export$d875e029ef558d3;
    return targetClip;
}
/**
 * A class with various methods to assist with animations.
 *
 * @hideconstructor
 */ class $ce0cdebec9150cb3$export$7ee8caa573e71ad1 {
    /**
	 * Converts an array to a specific type
	 *
	 * @static
	 * @param {TypedArray|Array} array - The array to convert.
	 * @param {TypedArray.constructor} type - The constructor of a type array.
	 * @return {TypedArray} The converted array
	 */ static convertArray(array, type) {
        return $ce0cdebec9150cb3$var$convertArray(array, type);
    }
    /**
	 * Returns `true` if the given object is a typed array.
	 *
	 * @static
	 * @param {any} object - The object to check.
	 * @return {boolean} Whether the given object is a typed array.
	 */ static isTypedArray(object) {
        return $ce0cdebec9150cb3$export$b119cc7e1840e59c(object);
    }
    /**
	 * Returns an array by which times and values can be sorted.
	 *
	 * @static
	 * @param {Array<number>} times - The keyframe time values.
	 * @return {Array<number>} The array.
	 */ static getKeyframeOrder(times) {
        return $ce0cdebec9150cb3$var$getKeyframeOrder(times);
    }
    /**
	 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
	 *
	 * @static
	 * @param {Array<number>} values - The values to sort.
	 * @param {number} stride - The stride.
	 * @param {Array<number>} order - The sort order.
	 * @return {Array<number>} The sorted values.
	 */ static sortedArray(values, stride, order) {
        return $ce0cdebec9150cb3$var$sortedArray(values, stride, order);
    }
    /**
	 * Used for parsing AOS keyframe formats.
	 *
	 * @static
	 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
	 * @param {Array<number>} times - This array will be filled with keyframe times by this method.
	 * @param {Array<number>} values - This array will be filled with keyframe values by this method.
	 * @param {string} valuePropertyName - The name of the property to use.
	 */ static flattenJSON(jsonKeys, times, values, valuePropertyName) {
        $ce0cdebec9150cb3$var$flattenJSON(jsonKeys, times, values, valuePropertyName);
    }
    /**
	 * Creates a new clip, containing only the segment of the original clip between the given frames.
	 *
	 * @static
	 * @param {AnimationClip} sourceClip - The values to sort.
	 * @param {string} name - The name of the clip.
	 * @param {number} startFrame - The start frame.
	 * @param {number} endFrame - The end frame.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The new sub clip.
	 */ static subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
        return $ce0cdebec9150cb3$var$subclip(sourceClip, name, startFrame, endFrame, fps);
    }
    /**
	 * Converts the keyframes of the given animation clip to an additive format.
	 *
	 * @static
	 * @param {AnimationClip} targetClip - The clip to make additive.
	 * @param {number} [referenceFrame=0] - The reference frame.
	 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The updated clip which is now additive.
	 */ static makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        return $ce0cdebec9150cb3$var$makeClipAdditive(targetClip, referenceFrame, referenceClip, fps);
    }
}
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References: {@link http://www.oodesign.com/template-method-pattern.html}
 *
 * @abstract
 */ class $ce0cdebec9150cb3$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        /**
		 * The parameter positions.
		 *
		 * @type {TypedArray}
		 */ this.parameterPositions = parameterPositions;
        /**
		 * A cache index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cachedIndex = 0;
        /**
		 * The result buffer.
		 *
		 * @type {TypedArray}
		 */ this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        /**
		 * The sample values.
		 *
		 * @type {TypedArray}
		 */ this.sampleValues = sampleValues;
        /**
		 * The value size.
		 *
		 * @type {TypedArray}
		 */ this.valueSize = sampleSize;
        /**
		 * The interpolation settings.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.settings = null;
        /**
		 * The default settings object.
		 *
		 * @type {Object}
		 */ this.DefaultSettings_ = {};
    }
    /**
	 * Evaluate the interpolant at position `t`.
	 *
	 * @param {number} t - The interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    /**
	 * Returns the interpolation settings.
	 *
	 * @return {Object} The interpolation settings.
	 */ getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @param {number} index - An index into the sample value buffer.
	 * @return {TypedArray} The result buffer.
	 */ copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @abstract
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 * @param {number} t1 - The next interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    /**
	 * Optional method that is executed when the interval has changed.
	 *
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 */ intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @augments Interpolant
 */ class $ce0cdebec9150cb3$export$3646682e7a3959 extends $ce0cdebec9150cb3$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new cubic interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $ce0cdebec9150cb3$export$7f795934b84ab523,
            endingEnd: $ce0cdebec9150cb3$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $ce0cdebec9150cb3$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $ce0cdebec9150cb3$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $ce0cdebec9150cb3$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $ce0cdebec9150cb3$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
/**
 * A basic linear interpolant.
 *
 * @augments Interpolant
 */ class $ce0cdebec9150cb3$export$a8e6009059f51e1a extends $ce0cdebec9150cb3$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new linear interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 *
 * @augments Interpolant
 */ class $ce0cdebec9150cb3$export$fb9758ef7ef8d5cc extends $ce0cdebec9150cb3$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new discrete interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
/**
 * A Bezier interpolant using cubic Bezier curves with 2D control points.
 *
 * This interpolant supports the COLLADA/Maya style of Bezier animation where
 * each keyframe has explicit in/out tangent control points specified as
 * 2D coordinates (time, value).
 *
 * The tangent data must be provided via the `settings` object:
 * - `settings.inTangents`: Float32Array with [time, value] pairs per keyframe per component
 * - `settings.outTangents`: Float32Array with [time, value] pairs per keyframe per component
 *
 * For a track with N keyframes and stride S:
 * - Each tangent array has N * S * 2 values
 * - Layout: [k0_c0_time, k0_c0_value, k0_c1_time, k0_c1_value, ..., k0_cS_time, k0_cS_value,
 *            k1_c0_time, k1_c0_value, ...]
 *
 * @augments Interpolant
 */ class $ce0cdebec9150cb3$export$9a963cfe8bd70b49 extends $ce0cdebec9150cb3$export$b558baee9c0f72d3 {
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const offset1 = i1 * stride;
        const offset0 = offset1 - stride;
        const settings = this.settings || this.DefaultSettings_;
        const inTangents = settings.inTangents;
        const outTangents = settings.outTangents;
        // If no tangent data, fall back to linear interpolation
        if (!inTangents || !outTangents) {
            const weight1 = (t - t0) / (t1 - t0);
            const weight0 = 1 - weight1;
            for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
            return result;
        }
        const tangentStride = stride * 2;
        const i0 = i1 - 1;
        for(let i = 0; i !== stride; ++i){
            const v0 = values[offset0 + i];
            const v1 = values[offset1 + i];
            // outTangent of previous keyframe (C0)
            const outTangentOffset = i0 * tangentStride + i * 2;
            const c0x = outTangents[outTangentOffset];
            const c0y = outTangents[outTangentOffset + 1];
            // inTangent of current keyframe (C1)
            const inTangentOffset = i1 * tangentStride + i * 2;
            const c1x = inTangents[inTangentOffset];
            const c1y = inTangents[inTangentOffset + 1];
            // Solve for Bezier parameter s where Bx(s) = t using Newton-Raphson
            let s = (t - t0) / (t1 - t0);
            let s2, s3, oneMinusS, oneMinusS2, oneMinusS3;
            for(let iter = 0; iter < 8; iter++){
                s2 = s * s;
                s3 = s2 * s;
                oneMinusS = 1 - s;
                oneMinusS2 = oneMinusS * oneMinusS;
                oneMinusS3 = oneMinusS2 * oneMinusS;
                // Bezier X(s) = (1-s)³·t0 + 3(1-s)²s·c0x + 3(1-s)s²·c1x + s³·t1
                const bx = oneMinusS3 * t0 + 3 * oneMinusS2 * s * c0x + 3 * oneMinusS * s2 * c1x + s3 * t1;
                const error = bx - t;
                if (Math.abs(error) < 1e-10) break;
                // Derivative dX/ds
                const dbx = 3 * oneMinusS2 * (c0x - t0) + 6 * oneMinusS * s * (c1x - c0x) + 3 * s2 * (t1 - c1x);
                if (Math.abs(dbx) < 1e-10) break;
                s = s - error / dbx;
                s = Math.max(0, Math.min(1, s));
            }
            // Evaluate Bezier Y(s)
            result[i] = oneMinusS3 * v0 + 3 * oneMinusS2 * s * c0y + 3 * oneMinusS * s2 * c1y + s3 * v1;
        }
        return result;
    }
}
/**
 * Represents a timed sequence of keyframes, which are composed of lists of
 * times and related values, and which are used to animate a specific property
 * of an object.
 */ class $ce0cdebec9150cb3$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number|string|boolean>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth|InterpolateBezier)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        /**
		 * The track's name can refer to morph targets or bones or
		 * possibly other values within an animated object. See {@link PropertyBinding#parseTrackName}
		 * for the forms of strings that can be parsed for property binding.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The keyframe times.
		 *
		 * @type {Float32Array}
		 */ this.times = $ce0cdebec9150cb3$var$convertArray(times, this.TimeBufferType);
        /**
		 * The keyframe values.
		 *
		 * @type {Float32Array}
		 */ this.values = $ce0cdebec9150cb3$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    /**
	 * Converts the keyframe track to JSON.
	 *
	 * @static
	 * @param {KeyframeTrack} track - The keyframe track to serialize.
	 * @return {Object} The serialized keyframe track as JSON.
	 */ static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $ce0cdebec9150cb3$var$convertArray(track.times, Array),
                'values': $ce0cdebec9150cb3$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    /**
	 * Factory method for creating a new discrete interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {DiscreteInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodDiscrete(result) {
        return new $ce0cdebec9150cb3$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new linear interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {LinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $ce0cdebec9150cb3$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new smooth interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {CubicInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodSmooth(result) {
        return new $ce0cdebec9150cb3$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new Bezier interpolant.
	 *
	 * The Bezier interpolant requires tangent data to be set via the `settings` property
	 * on the track before creating the interpolant. The settings should contain:
	 * - `inTangents`: Float32Array with [time, value] pairs per keyframe per component
	 * - `outTangents`: Float32Array with [time, value] pairs per keyframe per component
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {BezierInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodBezier(result) {
        const interpolant = new $ce0cdebec9150cb3$export$9a963cfe8bd70b49(this.times, this.values, this.getValueSize(), result);
        // Pass tangent data from track settings to interpolant
        if (this.settings) interpolant.settings = this.settings;
        return interpolant;
    }
    /**
	 * Defines the interpolation factor method for this keyframe track.
	 *
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth|InterpolateBezier)} interpolation - The interpolation type.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $ce0cdebec9150cb3$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $ce0cdebec9150cb3$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $ce0cdebec9150cb3$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
            case $ce0cdebec9150cb3$export$ad783ffd8f91a9e3:
                factoryMethod = this.InterpolantFactoryMethodBezier;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    /**
	 * Returns the current interpolation type.
	 *
	 * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth|InterpolateBezier)} The interpolation type.
	 */ getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $ce0cdebec9150cb3$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $ce0cdebec9150cb3$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $ce0cdebec9150cb3$export$198b11ff4c72bb30;
            case this.InterpolantFactoryMethodBezier:
                return $ce0cdebec9150cb3$export$ad783ffd8f91a9e3;
        }
    }
    /**
	 * Returns the value size.
	 *
	 * @return {number} The value size.
	 */ getValueSize() {
        return this.values.length / this.times.length;
    }
    /**
	 * Moves all keyframes either forward or backward in time.
	 *
	 * @param {number} timeOffset - The offset to move the time values.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    /**
	 * Scale all keyframe times by a factor (useful for frame - seconds conversions).
	 *
	 * @param {number} timeScale - The time scale.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    /**
	 * Removes keyframes before and after animation without changing any values within the defined time range.
	 *
	 * Note: The method does not shift around keys to the start of the track time, because for interpolated
	 * keys this will change their values
	 *
	 * @param {number} startTime - The start time.
	 * @param {number} endTime - The end time.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    /**
	 * Performs minimal validation on the keyframe track. Returns `true` if the values
	 * are valid.
	 *
	 * @return {boolean} Whether the keyframes are valid or not.
	 */ validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            $ce0cdebec9150cb3$export$a3bc9b8ed74fc('KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            $ce0cdebec9150cb3$export$a3bc9b8ed74fc('KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                $ce0cdebec9150cb3$export$a3bc9b8ed74fc('KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                $ce0cdebec9150cb3$export$a3bc9b8ed74fc('KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($ce0cdebec9150cb3$export$b119cc7e1840e59c(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    $ce0cdebec9150cb3$export$a3bc9b8ed74fc('KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    /**
	 * Optimizes this keyframe track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ optimize() {
        // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $ce0cdebec9150cb3$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    /**
	 * Returns a new keyframe track with copied values from this instance.
	 *
	 * @return {KeyframeTrack} A clone of this instance.
	 */ clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default ''
 */ $ce0cdebec9150cb3$export$b0e479f45b7006d6.prototype.ValueTypeName = '';
/**
 * The time buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $ce0cdebec9150cb3$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $ce0cdebec9150cb3$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth|InterpolateBezier)}
 * @default InterpolateLinear
 */ $ce0cdebec9150cb3$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $ce0cdebec9150cb3$export$30fac1aace31cf4d;
/**
 * A track for boolean keyframe values.
 *
 * @augments KeyframeTrack
 */ class $ce0cdebec9150cb3$export$d3a344b98cf0b775 extends $ce0cdebec9150cb3$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new boolean keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<boolean>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'bool'
 */ $ce0cdebec9150cb3$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $ce0cdebec9150cb3$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $ce0cdebec9150cb3$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $ce0cdebec9150cb3$export$995b32462a65e855;
$ce0cdebec9150cb3$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$ce0cdebec9150cb3$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for color keyframe values.
 *
 * @augments KeyframeTrack
 */ class $ce0cdebec9150cb3$export$83444c5d885347d8 extends $ce0cdebec9150cb3$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new color keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'color'
 */ $ce0cdebec9150cb3$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A track for numeric keyframe values.
 *
 * @augments KeyframeTrack
 */ class $ce0cdebec9150cb3$export$d45f0d1a4d9a9314 extends $ce0cdebec9150cb3$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new number keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'number'
 */ $ce0cdebec9150cb3$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 *
 * @augments Interpolant
 */ class $ce0cdebec9150cb3$export$2db1cfb7923d931e extends $ce0cdebec9150cb3$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new SLERP interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$ce0cdebec9150cb3$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A track for Quaternion keyframe values.
 *
 * @augments KeyframeTrack
 */ class $ce0cdebec9150cb3$export$b8043f12b5aafbd7 extends $ce0cdebec9150cb3$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new Quaternion keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
    /**
	 * Overwritten so the method returns Quaternion based interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {QuaternionLinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $ce0cdebec9150cb3$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'quaternion'
 */ $ce0cdebec9150cb3$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$ce0cdebec9150cb3$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for string keyframe values.
 *
 * @augments KeyframeTrack
 */ class $ce0cdebec9150cb3$export$6ce41d4f3a8df9cd extends $ce0cdebec9150cb3$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new string keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<string>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'string'
 */ $ce0cdebec9150cb3$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $ce0cdebec9150cb3$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $ce0cdebec9150cb3$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $ce0cdebec9150cb3$export$995b32462a65e855;
$ce0cdebec9150cb3$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$ce0cdebec9150cb3$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for vector keyframe values.
 *
 * @augments KeyframeTrack
 */ class $ce0cdebec9150cb3$export$5ce2dcb4cc9f2bff extends $ce0cdebec9150cb3$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new vector keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'vector'
 */ $ce0cdebec9150cb3$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
/**
 * A reusable set of keyframe tracks which represent an animation.
 */ class $ce0cdebec9150cb3$export$d942c706bf23829c {
    /**
	 * Constructs a new animation clip.
	 *
	 * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
	 * use the static interface of this class for creating clips. In most cases though, animation clips
	 * will automatically be created by loaders when importing animated 3D assets.
	 *
	 * @param {string} [name=''] - The clip's name.
	 * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
	 * the duration will be calculated from the passed keyframes.
	 * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
	 * is blended/combined when two or more animations are simultaneously played.
	 */ constructor(name = '', duration = -1, tracks = [], blendMode = $ce0cdebec9150cb3$export$bcfbbdcf8de7f8cd){
        /**
		 * The clip's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 *  An array of keyframe tracks.
		 *
		 * @type {Array<KeyframeTrack>}
		 */ this.tracks = tracks;
        /**
		 * The clip's duration in seconds.
		 *
		 * @type {number}
		 */ this.duration = duration;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        /**
		 * The UUID of the animation clip.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $ce0cdebec9150cb3$var$generateUUID();
        /**
		 * An object that can be used to store custom data about the animation clip.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    /**
	 * Factory method for creating an animation clip from the given JSON.
	 *
	 * @static
	 * @param {Object} json - The serialized animation clip.
	 * @return {AnimationClip} The new animation clip.
	 */ static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($ce0cdebec9150cb3$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        clip.userData = JSON.parse(json.userData || '{}');
        return clip;
    }
    /**
	 * Serializes the given animation clip into JSON.
	 *
	 * @static
	 * @param {AnimationClip} clip - The animation clip to serialize.
	 * @return {Object} The JSON object.
	 */ static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode,
            'userData': JSON.stringify(clip.userData)
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($ce0cdebec9150cb3$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    /**
	 * Returns a new animation clip from the passed morph targets array of a
	 * geometry, taking a name and the number of frames per second.
	 *
	 * Note: The fps parameter is required, but the animation speed can be
	 * overridden via {@link AnimationAction#setDuration}.
	 *
	 * @static
	 * @param {string} name - The name of the animation clip.
	 * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {AnimationClip} The new animation clip.
	 */ static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $ce0cdebec9150cb3$var$getKeyframeOrder(times);
            times = $ce0cdebec9150cb3$var$sortedArray(times, 1, order);
            values = $ce0cdebec9150cb3$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $ce0cdebec9150cb3$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    /**
	 * Searches for an animation clip by name, taking as its first parameter
	 * either an array of clips, or a mesh or geometry that contains an
	 * array named "animations" property.
	 *
	 * @static
	 * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
	 * @param {string} name - The name to search for.
	 * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
	 */ static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    /**
	 * Returns an array of new AnimationClips created from the morph target
	 * sequences of a geometry, trying to sort morph target names into
	 * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
	 *
	 * See {@link MD2Loader#parse} as an example for how the method should be used.
	 *
	 * @static
	 * @param {Array<Object>} morphTargets - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {Array<AnimationClip>} An array of new animation clips.
	 */ static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    /**
	 * Parses the `animation.hierarchy` format and returns a new animation clip.
	 *
	 * @static
	 * @deprecated since r175.
	 * @param {Object} animation - A serialized animation clip as JSON.
	 * @param {Array<Bone>} bones - An array of bones.
	 * @return {?AnimationClip} The new animation clip.
	 */ static parseAnimation(animation, bones) {
        $ce0cdebec9150cb3$export$c106dd0671a0fc2d('AnimationClip: parseAnimation() is deprecated and will be removed with r185');
        if (!animation) {
            $ce0cdebec9150cb3$export$a3bc9b8ed74fc('AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $ce0cdebec9150cb3$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $ce0cdebec9150cb3$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($ce0cdebec9150cb3$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($ce0cdebec9150cb3$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($ce0cdebec9150cb3$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    /**
	 * Sets the duration of this clip to the duration of its longest keyframe track.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    /**
	 * Trims all tracks to the clip's duration.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    /**
	 * Performs minimal validation on each track in the clip. Returns `true` if all
	 * tracks are valid.
	 *
	 * @return {boolean} Whether the clip's keyframes are valid or not.
	 */ validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    /**
	 * Optimizes each track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    /**
	 * Returns a new animation clip with copied values from this instance.
	 *
	 * @return {AnimationClip} A clone of this instance.
	 */ clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        const clip = new this.constructor(this.name, this.duration, tracks, this.blendMode);
        clip.userData = JSON.parse(JSON.stringify(this.userData));
        return clip;
    }
    /**
	 * Serializes this animation clip into JSON.
	 *
	 * @return {Object} The JSON object.
	 */ toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $ce0cdebec9150cb3$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $ce0cdebec9150cb3$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $ce0cdebec9150cb3$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $ce0cdebec9150cb3$export$83444c5d885347d8;
        case 'quaternion':
            return $ce0cdebec9150cb3$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $ce0cdebec9150cb3$export$d3a344b98cf0b775;
        case 'string':
            return $ce0cdebec9150cb3$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $ce0cdebec9150cb3$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $ce0cdebec9150cb3$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $ce0cdebec9150cb3$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
/**
 * @class
 * @classdesc A simple caching system, used internally by {@link FileLoader}.
 * To enable caching across all loaders that use {@link FileLoader}, add `THREE.Cache.enabled = true.` once in your app.
 * @hideconstructor
 */ const $ce0cdebec9150cb3$export$94affb487e701bf2 = {
    /**
	 * Whether caching is enabled or not.
	 *
	 * @static
	 * @type {boolean}
	 * @default false
	 */ enabled: false,
    /**
	 * A dictionary that holds cached files.
	 *
	 * @static
	 * @type {Object<string,Object>}
	 */ files: {},
    /**
	 * Adds a cache entry with a key to reference the file. If this key already
	 * holds a file, it is overwritten.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @param {Object} file -  The file to be cached.
	 */ add: function(key, file) {
        if (this.enabled === false) return;
        if ($ce0cdebec9150cb3$var$isBlobURL(key)) return;
        // log( 'Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    /**
	 * Gets the cached value for the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
	 */ get: function(key) {
        if (this.enabled === false) return;
        if ($ce0cdebec9150cb3$var$isBlobURL(key)) return;
        // log( 'Cache', 'Checking key:', key );
        return this.files[key];
    },
    /**
	 * Removes the cached file associated with the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 */ remove: function(key) {
        delete this.files[key];
    },
    /**
	 * Remove all values from the cache.
	 *
	 * @static
	 */ clear: function() {
        this.files = {};
    }
};
/**
 * Returns true if the given cache key contains the blob: scheme.
 *
 * @private
 * @param {string} key - The cache key.
 * @return {boolean} Whether the given cache key contains the blob: scheme or not.
 */ function $ce0cdebec9150cb3$var$isBlobURL(key) {
    try {
        const urlString = key.slice(key.indexOf(':') + 1); // remove type identifier
        const url = new URL(urlString);
        return url.protocol === 'blob:';
    } catch (e) {
        // If the string is not a valid URL, it throws an error
        return false;
    }
}
/**
 * Handles and keeps track of loaded and pending data. A default global
 * instance of this class is created and used by loaders if not supplied
 * manually.
 *
 * In general that should be sufficient, however there are times when it can
 * be useful to have separate loaders - for example if you want to show
 * separate loading bars for objects and textures.
 *
 * ```js
 * const manager = new THREE.LoadingManager();
 * manager.onLoad = () => console.log( 'Loading complete!' );
 *
 * const loader1 = new OBJLoader( manager );
 * const loader2 = new ColladaLoader( manager );
 * ```
 */ class $ce0cdebec9150cb3$export$99cc795e99919eed {
    /**
	 * Constructs a new loading manager.
	 *
	 * @param {Function} [onLoad] - Executes when all items have been loaded.
	 * @param {Function} [onProgress] - Executes when single items have been loaded.
	 * @param {Function} [onError] - Executes when an error occurs.
	 */ constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        /**
		 * Executes when an item starts loading.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onStart = undefined;
        /**
		 * Executes when all items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onLoad = onLoad;
        /**
		 * Executes when single items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onProgress = onProgress;
        /**
		 * Executes when an error occurs.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onError = onError;
        /**
		 * Used for aborting ongoing requests in loaders using this manager.
		 *
		 * @private
		 * @type {AbortController | null}
		 */ this._abortController = null;
        /**
		 * This should be called by any loader using the manager when the loader
		 * starts loading an item.
		 *
		 * @param {string} url - The URL to load.
		 */ this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * ended loading an item.
		 *
		 * @param {string} url - The URL of the loaded item.
		 */ this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * encounters an error when loading an item.
		 *
		 * @param {string} url - The URL of the item that produces an error.
		 */ this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        /**
		 * Given a URL, uses the URL modifier callback (if any) and returns a
		 * resolved URL. If no URL modifier is set, returns the original URL.
		 *
		 * @param {string} url - The URL to load.
		 * @return {string} The resolved URL.
		 */ this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        /**
		 * If provided, the callback will be passed each resource URL before a
		 * request is sent. The callback may return the original URL, or a new URL to
		 * override loading behavior. This behavior can be used to load assets from
		 * .ZIP files, drag-and-drop APIs, and Data URIs.
		 *
		 * ```js
		 * const blobs = {'fish.gltf': blob1, 'diffuse.png': blob2, 'normal.png': blob3};
		 *
		 * const manager = new THREE.LoadingManager();
		 *
		 * // Initialize loading manager with URL callback.
		 * const objectURLs = [];
		 * manager.setURLModifier( ( url ) => {
		 *
		 * 	url = URL.createObjectURL( blobs[ url ] );
		 * 	objectURLs.push( url );
		 * 	return url;
		 *
		 * } );
		 *
		 * // Load as usual, then revoke the blob URLs.
		 * const loader = new GLTFLoader( manager );
		 * loader.load( 'fish.gltf', (gltf) => {
		 *
		 * 	scene.add( gltf.scene );
		 * 	objectURLs.forEach( ( url ) => URL.revokeObjectURL( url ) );
		 *
		 * } );
		 * ```
		 *
		 * @param {function(string):string} transform - URL modifier callback. Called with an URL and must return a resolved URL.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        /**
		 * Registers a loader with the given regular expression. Can be used to
		 * define what loader should be used in order to load specific files. A
		 * typical use case is to overwrite the default loader for textures.
		 *
		 * ```js
		 * // add handler for TGA textures
		 * manager.addHandler( /\.tga$/i, new TGALoader() );
		 * ```
		 *
		 * @param {string} regex - A regular expression.
		 * @param {Loader} loader - A loader that should handle matched cases.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        /**
		 * Removes the loader for the given regular expression.
		 *
		 * @param {string} regex - A regular expression.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        /**
		 * Can be used to retrieve the registered loader for the given file path.
		 *
		 * @param {string} file - The file path.
		 * @return {?Loader} The registered loader. Returns `null` if no loader was found.
		 */ this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
        /**
		 * Can be used to abort ongoing loading requests in loaders using this manager.
		 * The abort only works if the loaders implement {@link Loader#abort} and `AbortSignal.any()`
		 * is supported in the browser.
		 *
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.abort = function() {
            this.abortController.abort();
            this._abortController = null;
            return this;
        };
    }
    // TODO: Revert this back to a single member variable once this issue has been fixed
    // https://github.com/cloudflare/workerd/issues/3657
    /**
	 * Used for aborting ongoing requests in loaders using this manager.
	 *
	 * @type {AbortController}
	 */ get abortController() {
        if (!this._abortController) this._abortController = new AbortController();
        return this._abortController;
    }
}
/**
 * The global default loading manager.
 *
 * @constant
 * @type {LoadingManager}
 */ const $ce0cdebec9150cb3$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$99cc795e99919eed();
/**
 * Abstract base class for loaders.
 *
 * @abstract
 */ class $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        /**
		 * The loading manager.
		 *
		 * @type {LoadingManager}
		 * @default DefaultLoadingManager
		 */ this.manager = manager !== undefined ? manager : $ce0cdebec9150cb3$export$b033c3f9a95c6a16;
        /**
		 * The crossOrigin string to implement CORS for loading the url from a
		 * different domain that allows CORS.
		 *
		 * @type {string}
		 * @default 'anonymous'
		 */ this.crossOrigin = 'anonymous';
        /**
		 * Whether the XMLHttpRequest uses credentials.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.withCredentials = false;
        /**
		 * The base path from which the asset will be loaded.
		 *
		 * @type {string}
		 */ this.path = '';
        /**
		 * The base path from which additional resources like textures will be loaded.
		 *
		 * @type {string}
		 */ this.resourcePath = '';
        /**
		 * The [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
		 * used in HTTP request.
		 *
		 * @type {Object<string, any>}
		 */ this.requestHeader = {};
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for loading assets from the backend.
	 *
	 * @abstract
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 */ load() {}
    /**
	 * A async version of {@link Loader#load}.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @return {Promise} A Promise that resolves when the asset has been loaded.
	 */ loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for parsing the asset into three.js entities.
	 *
	 * @abstract
	 * @param {any} data - The data to parse.
	 */ parse() {}
    /**
	 * Sets the `crossOrigin` String to implement CORS for loading the URL
	 * from a different domain that allows CORS.
	 *
	 * @param {string} crossOrigin - The `crossOrigin` value.
	 * @return {Loader} A reference to this instance.
	 */ setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    /**
	 * Whether the XMLHttpRequest uses credentials such as cookies, authorization
	 * headers or TLS client certificates, see [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials).
	 *
	 * Note: This setting has no effect if you are loading files locally or from the same domain.
	 *
	 * @param {boolean} value - The `withCredentials` value.
	 * @return {Loader} A reference to this instance.
	 */ setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    /**
	 * Sets the base path for the asset.
	 *
	 * @param {string} path - The base path.
	 * @return {Loader} A reference to this instance.
	 */ setPath(path) {
        this.path = path;
        return this;
    }
    /**
	 * Sets the base path for dependent resources like textures.
	 *
	 * @param {string} resourcePath - The resource path.
	 * @return {Loader} A reference to this instance.
	 */ setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    /**
	 * Sets the given request header.
	 *
	 * @param {Object} requestHeader - A [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
	 * for configuring the HTTP request.
	 * @return {Loader} A reference to this instance.
	 */ setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
    /**
	 * This method can be implemented in loaders for aborting ongoing requests.
	 *
	 * @abstract
	 * @return {Loader} A reference to this instance.
	 */ abort() {
        return this;
    }
}
/**
 * Callback for onProgress in loaders.
 *
 * @callback onProgressCallback
 * @param {ProgressEvent} event - An instance of `ProgressEvent` that represents the current loading status.
 */ /**
 * Callback for onError in loaders.
 *
 * @callback onErrorCallback
 * @param {Error} error - The error which occurred during the loading process.
 */ /**
 * The default material name that is used by loaders
 * when creating materials for loaded 3D objects.
 *
 * Note: Not all loaders might honor this setting.
 *
 * @static
 * @type {string}
 * @default '__DEFAULT'
 */ $ce0cdebec9150cb3$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $ce0cdebec9150cb3$var$loading = {};
class $ce0cdebec9150cb3$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
/**
 * A low level class for loading resources with the Fetch API, used internally by
 * most loaders. It can also be used directly to load any file type that does
 * not have a loader.
 *
 * This loader supports caching. If you want to use it, add `THREE.Cache.enabled = true;`
 * once to your application.
 *
 * ```js
 * const loader = new THREE.FileLoader();
 * const data = await loader.loadAsync( 'example.txt' );
 * ```
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$98435a25b5cf7b2b extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new file loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * The expected mime type. Valid values can be found
		 * [here](https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#mimetype)
		 *
		 * @type {string}
		 */ this.mimeType = '';
        /**
		 * The expected response type.
		 *
		 * @type {('arraybuffer'|'blob'|'document'|'json'|'')}
		 * @default ''
		 */ this.responseType = '';
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(any)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 * @return {any|undefined} The cached resource if available.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $ce0cdebec9150cb3$export$94affb487e701bf2.get(`file:${url}`);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($ce0cdebec9150cb3$var$loading[url] !== undefined) {
            $ce0cdebec9150cb3$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $ce0cdebec9150cb3$var$loading[url] = [];
        $ce0cdebec9150cb3$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin',
            signal: typeof AbortSignal.any === 'function' ? AbortSignal.any([
                this._abortController.signal,
                this.manager.abortController.signal
            ]) : this._abortController.signal
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $ce0cdebec9150cb3$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $ce0cdebec9150cb3$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === '') return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $ce0cdebec9150cb3$export$94affb487e701bf2.add(`file:${url}`, data);
            const callbacks = $ce0cdebec9150cb3$var$loading[url];
            delete $ce0cdebec9150cb3$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $ce0cdebec9150cb3$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $ce0cdebec9150cb3$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    /**
	 * Sets the expected response type.
	 *
	 * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setResponseType(value) {
        this.responseType = value;
        return this;
    }
    /**
	 * Sets the expected mime type of the loaded file.
	 *
	 * @param {string} value - The mime type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setMimeType(value) {
        this.mimeType = value;
        return this;
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {FileLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
/**
 * Class for loading animation clips in the JSON format. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.AnimationLoader();
 * const animations = await loader.loadAsync( 'animations/animation.js' );
 * ```
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$29711c7e14f61db extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new animation loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded animations as an array
	 * holding instances of {@link AnimationClip} to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Array<AnimationClip>)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $ce0cdebec9150cb3$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $ce0cdebec9150cb3$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns an array of animation clips.
	 *
	 * @param {Object} json - The serialized animation clips.
	 * @return {Array<AnimationClip>} The parsed animation clips.
	 */ parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $ce0cdebec9150cb3$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract base class for loading compressed texture formats S3TC, ASTC or ETC.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$bd73ce947a280350 extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new compressed texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded compressed texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(CompressedTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CompressedTexture} The compressed texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $ce0cdebec9150cb3$export$3466bac9141a5cc4();
        const loader = new $ce0cdebec9150cb3$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $ce0cdebec9150cb3$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $ce0cdebec9150cb3$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
const $ce0cdebec9150cb3$var$_loading = new WeakMap();
/**
 * A loader for loading images. The class loads images with the HTML `Image` API.
 *
 * ```js
 * const loader = new THREE.ImageLoader();
 * const image = await loader.loadAsync( 'image.png' );
 * ```
 * Please note that `ImageLoader` has dropped support for progress
 * events in `r84`. For an `ImageLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-275785639).
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$8905ce1c7a2464a1 extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded image
	 * to the `onLoad()` callback. The method also returns a new `Image` object which can
	 * directly be used for texture creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Image)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Image} The image.
	 */ load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $ce0cdebec9150cb3$export$94affb487e701bf2.get(`image:${url}`);
        if (cached !== undefined) {
            if (cached.complete === true) {
                scope.manager.itemStart(url);
                setTimeout(function() {
                    if (onLoad) onLoad(cached);
                    scope.manager.itemEnd(url);
                }, 0);
            } else {
                let arr = $ce0cdebec9150cb3$var$_loading.get(cached);
                if (arr === undefined) {
                    arr = [];
                    $ce0cdebec9150cb3$var$_loading.set(cached, arr);
                }
                arr.push({
                    onLoad: onLoad,
                    onError: onError
                });
            }
            return cached;
        }
        const image = $ce0cdebec9150cb3$export$7094a064528c7fee('img');
        function onImageLoad() {
            removeEventListeners();
            if (onLoad) onLoad(this);
            //
            const callbacks = $ce0cdebec9150cb3$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(this);
            }
            $ce0cdebec9150cb3$var$_loading.delete(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            $ce0cdebec9150cb3$export$94affb487e701bf2.remove(`image:${url}`);
            //
            const callbacks = $ce0cdebec9150cb3$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(event);
            }
            $ce0cdebec9150cb3$var$_loading.delete(this);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        $ce0cdebec9150cb3$export$94affb487e701bf2.add(`image:${url}`, image);
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
/**
 * Class for loading cube textures. Images are internally loaded via {@link ImageLoader}.
 *
 * The loader returns an instance of {@link CubeTexture} and expects the cube map to
 * be defined as six separate images representing the sides of a cube. Other cube map definitions
 * like vertical and horizontal cross, column and row layouts are not supported.
 *
 * Note that, by convention, cube maps are specified in a coordinate system
 * in which positive-x is to the right when looking up the positive-z axis --
 * in other words, using a left-handed coordinate system. Since three.js uses
 * a right-handed coordinate system, environment maps used in three.js will
 * have pos-x and neg-x swapped.
 *
 * The loaded cube texture is in sRGB color space. Meaning {@link Texture#colorSpace}
 * is set to `SRGBColorSpace` by default.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader().setPath( 'textures/cubeMaps/' );
 * const cubeTexture = await loader.loadAsync( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 * scene.background = cubeTexture;
 * ```
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$2ec114afc2cf6308 extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new cube texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded cube texture
	 * to the `onLoad()` callback. The method also returns a new cube texture object which can
	 * directly be used for material creation. If you do it this way, the cube texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {Array<string>} urls - Array of 6 URLs to images, one for each side of the
	 * cube texture. The urls should be specified in the following order: pos-x,
	 * neg-x, pos-y, neg-y, pos-z, neg-z. An array of data URIs are allowed as well.
	 * @param {function(CubeTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CubeTexture} The cube texture.
	 */ load(urls, onLoad, onProgress, onError) {
        const texture = new $ce0cdebec9150cb3$export$ee2e5a18258a4049();
        texture.colorSpace = $ce0cdebec9150cb3$export$561f394b24edfcaa;
        const loader = new $ce0cdebec9150cb3$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract base class for loading binary texture formats RGBE, EXR or TGA.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$792d8a18f2c55855 extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new data texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded data texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(DataTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {DataTexture} The data texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $ce0cdebec9150cb3$export$b691f601014eabe1();
        const loader = new $ce0cdebec9150cb3$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $ce0cdebec9150cb3$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $ce0cdebec9150cb3$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $ce0cdebec9150cb3$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $ce0cdebec9150cb3$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $ce0cdebec9150cb3$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $ce0cdebec9150cb3$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Class for loading textures. Images are internally
 * loaded via {@link ImageLoader}.
 *
 * ```js
 * const loader = new THREE.TextureLoader();
 * const texture = await loader.loadAsync( 'textures/land_ocean_ice_cloud_2048.jpg' );
 *
 * const material = new THREE.MeshBasicMaterial( { map:texture } );
 * ```
 * Please note that `TextureLoader` has dropped support for progress
 * events in `r84`. For a `TextureLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-293260145).
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$fd1bfc71f64c538c extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Texture} The texture.
	 */ load(url, onLoad, onProgress, onError) {
        const texture = new $ce0cdebec9150cb3$export$5431306cf43de24a();
        const loader = new $ce0cdebec9150cb3$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Abstract base class for lights - all other light types inherit the
 * properties and methods described here.
 *
 * @abstract
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$6ecadb6ed240d696 extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity = 1){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLight = true;
        this.type = 'Light';
        /**
		 * The light's color.
		 *
		 * @type {Color}
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e(color);
        /**
		 * The light's intensity.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = intensity;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        return data;
    }
}
/**
 * A light source positioned directly above the scene, with color fading from
 * the sky color to the ground color.
 *
 * This light cannot be used to cast shadows.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $ce0cdebec9150cb3$export$8d474f55edbb9624 extends $ce0cdebec9150cb3$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new hemisphere light.
	 *
	 * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
	 * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($ce0cdebec9150cb3$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The light's ground color.
		 *
		 * @type {Color}
		 */ this.groundColor = new $ce0cdebec9150cb3$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.groundColor = this.groundColor.getHex();
        return data;
    }
}
const $ce0cdebec9150cb3$var$_projScreenMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_lightPositionWorld = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_lookTarget = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * Abstract base class for light shadow classes. These classes
 * represent the shadow configuration for different light types.
 *
 * @abstract
 */ class $ce0cdebec9150cb3$var$LightShadow {
    /**
	 * Constructs a new light shadow.
	 *
	 * @param {Camera} camera - The light's view of the world.
	 */ constructor(camera){
        /**
		 * The light's view of the world.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The intensity of the shadow. The default is `1`.
		 * Valid values are in the range `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = 1;
        /**
		 * Shadow map bias, how much to add or subtract from the normalized depth
		 * when deciding whether a surface is in shadow.
		 *
		 * The default is `0`. Very tiny adjustments here (in the order of `0.0001`)
		 * may help reduce artifacts in shadows.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bias = 0;
        /**
		 * A node version of `bias`. Only supported with `WebGPURenderer`.
		 *
		 * If a bias node is defined, `bias` has no effect.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.biasNode = null;
        /**
		 * Defines how much the position used to query the shadow map is offset along
		 * the object normal. The default is `0`. Increasing this value can be used to
		 * reduce shadow acne especially in large scenes where light shines onto
		 * geometry at a shallow angle. The cost is that shadows may appear distorted.
		 *
		 * @type {number}
		 * @default 0
		 */ this.normalBias = 0;
        /**
		 * Setting this to values greater than 1 will blur the edges of the shadow.
		 * High values will cause unwanted banding effects in the shadows - a greater
		 * map size will allow for a higher value to be used here before these effects
		 * become visible.
		 *
		 * The property has no effect when the shadow map type is `BasicShadowMap`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = 1;
        /**
		 * The amount of samples to use when blurring a VSM shadow map.
		 *
		 * @type {number}
		 * @default 8
		 */ this.blurSamples = 8;
        /**
		 * Defines the width and height of the shadow map. Higher values give better quality
		 * shadows at the cost of computation time. Values must be powers of two.
		 *
		 * @type {Vector2}
		 * @default (512,512)
		 */ this.mapSize = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(512, 512);
        /**
		 * The type of shadow texture. The default is `UnsignedByteType`.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.mapType = $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10;
        /**
		 * The depth map generated using the internal camera; a location beyond a
		 * pixel's depth is in shadow. Computed internally during rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.map = null;
        /**
		 * The distribution map generated using the internal camera; an occlusion is
		 * calculated based on the distribution of depths. Computed internally during
		 * rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.mapPass = null;
        /**
		 * Model to shadow camera space, to compute location and depth in shadow map.
		 * This is computed internally during rendering.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
        /**
		 * Enables automatic updates of the light's shadow. If you do not require dynamic
		 * lighting / shadows, you may set this to `false`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * When set to `true`, shadow maps will be updated in the next `render` call.
		 * If you have set {@link LightShadow#autoUpdate} to `false`, you will need to
		 * set this property to `true` and then make a render call to update the light's shadow.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        this._frustum = new $ce0cdebec9150cb3$export$35efe6f4c85463d2();
        this._frameExtents = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $ce0cdebec9150cb3$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    /**
	 * Used internally by the renderer to get the number of viewports that need
	 * to be rendered for this shadow.
	 *
	 * @return {number} The viewport count.
	 */ getViewportCount() {
        return this._viewportCount;
    }
    /**
	 * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
	 *
	 * @return {Frustum} The shadow camera frustum.
	 */ getFrustum() {
        return this._frustum;
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 */ updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $ce0cdebec9150cb3$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($ce0cdebec9150cb3$var$_lightPositionWorld);
        $ce0cdebec9150cb3$var$_lookTarget.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($ce0cdebec9150cb3$var$_lookTarget);
        shadowCamera.updateMatrixWorld();
        $ce0cdebec9150cb3$var$_projScreenMatrix.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($ce0cdebec9150cb3$var$_projScreenMatrix, shadowCamera.coordinateSystem, shadowCamera.reversedDepth);
        if (shadowCamera.coordinateSystem === $ce0cdebec9150cb3$export$cc83beedcb9be9ac || shadowCamera.reversedDepth) shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
        else shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($ce0cdebec9150cb3$var$_projScreenMatrix);
    }
    /**
	 * Returns a viewport definition for the given viewport index.
	 *
	 * @param {number} viewportIndex - The viewport index.
	 * @return {Vector4} The viewport.
	 */ getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    /**
	 * Returns the frame extends.
	 *
	 * @return {Vector2} The frame extends.
	 */ getFrameExtents() {
        return this._frameExtents;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    /**
	 * Copies the values of the given light shadow instance to this instance.
	 *
	 * @param {LightShadow} source - The light shadow to copy.
	 * @return {LightShadow} A reference to this light shadow instance.
	 */ copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.autoUpdate = source.autoUpdate;
        this.needsUpdate = source.needsUpdate;
        this.normalBias = source.normalBias;
        this.blurSamples = source.blurSamples;
        this.mapSize.copy(source.mapSize);
        this.biasNode = source.biasNode;
        return this;
    }
    /**
	 * Returns a new light shadow instance with copied values from this instance.
	 *
	 * @return {LightShadow} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Serializes the light shadow into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized light shadow.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
const $ce0cdebec9150cb3$var$_position$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_quaternion$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3();
const $ce0cdebec9150cb3$var$_scale$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * Abstract base class for cameras. This class should always be inherited
 * when you build a new camera.
 *
 * @abstract
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$79f141de891a5fed extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new camera.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCamera = true;
        this.type = 'Camera';
        /**
		 * The inverse of the camera's world matrix.
		 *
		 * @type {Matrix4}
		 */ this.matrixWorldInverse = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
        /**
		 * The camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrix = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
        /**
		 * The inverse of the camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrixInverse = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
        /**
		 * The coordinate system in which the camera is used.
		 *
		 * @type {(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 */ this.coordinateSystem = $ce0cdebec9150cb3$export$5a0e9190d10875d3;
        this._reversedDepth = false;
    }
    /**
	 * The flag that indicates whether the camera uses a reversed depth buffer.
	 *
	 * @type {boolean}
	 * @default false
	 */ get reversedDepth() {
        return this._reversedDepth;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * This method is overwritten since cameras have a different forward vector compared to other
	 * 3D objects. A camera looks down its local, negative z-axis by default.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        // exclude scale from view matrix to be glTF conform
        this.matrixWorld.decompose($ce0cdebec9150cb3$var$_position$2, $ce0cdebec9150cb3$var$_quaternion$2, $ce0cdebec9150cb3$var$_scale$2);
        if ($ce0cdebec9150cb3$var$_scale$2.x === 1 && $ce0cdebec9150cb3$var$_scale$2.y === 1 && $ce0cdebec9150cb3$var$_scale$2.z === 1) this.matrixWorldInverse.copy(this.matrixWorld).invert();
        else this.matrixWorldInverse.compose($ce0cdebec9150cb3$var$_position$2, $ce0cdebec9150cb3$var$_quaternion$2, $ce0cdebec9150cb3$var$_scale$2.set(1, 1, 1)).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        // exclude scale from view matrix to be glTF conform
        this.matrixWorld.decompose($ce0cdebec9150cb3$var$_position$2, $ce0cdebec9150cb3$var$_quaternion$2, $ce0cdebec9150cb3$var$_scale$2);
        if ($ce0cdebec9150cb3$var$_scale$2.x === 1 && $ce0cdebec9150cb3$var$_scale$2.y === 1 && $ce0cdebec9150cb3$var$_scale$2.z === 1) this.matrixWorldInverse.copy(this.matrixWorld).invert();
        else this.matrixWorldInverse.compose($ce0cdebec9150cb3$var$_position$2, $ce0cdebec9150cb3$var$_quaternion$2, $ce0cdebec9150cb3$var$_scale$2.set(1, 1, 1)).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $ce0cdebec9150cb3$var$_v3$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_minTarget = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
const $ce0cdebec9150cb3$var$_maxTarget = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
/**
 * Camera that uses [perspective projection](https://en.wikipedia.org/wiki/Perspective_(graphical)).
 *
 * This projection mode is designed to mimic the way the human eye sees. It
 * is the most common projection mode used for rendering a 3D scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 45, width / height, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $ce0cdebec9150cb3$export$74e4ae24825f68d7 extends $ce0cdebec9150cb3$export$79f141de891a5fed {
    /**
	 * Constructs a new perspective camera.
	 *
	 * @param {number} [fov=50] - The vertical field of view.
	 * @param {number} [aspect=1] - The aspect ratio.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        /**
		 * The vertical field of view, from bottom to top of view,
		 * in degrees.
		 *
		 * @type {number}
		 * @default 50
		 */ this.fov = fov;
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link PerspectiveCamera#far}.
		 *
		 * Note that, unlike for the {@link OrthographicCamera}, `0` is <em>not</em> a
		 * valid value for a perspective camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link PerspectiveCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        /**
		 * Object distance used for stereoscopy and depth-of-field effects. This
		 * parameter does not influence the projection matrix unless a
		 * {@link StereoCamera} is being used.
		 *
		 * @type {number}
		 * @default 10
		 */ this.focus = 10;
        /**
		 * The aspect ratio, usually the canvas width / canvas height.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = aspect;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * Film size used for the larger axis. Default is `35` (millimeters). This
		 * parameter does not influence the projection matrix unless {@link PerspectiveCamera#filmOffset}
		 * is set to a nonzero value.
		 *
		 * @type {number}
		 * @default 35
		 */ this.filmGauge = 35;
        /**
		 * Horizontal off-center offset in the same unit as {@link PerspectiveCamera#filmGauge}.
		 *
		 * @type {number}
		 * @default 0
		 */ this.filmOffset = 0;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $ce0cdebec9150cb3$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Returns the focal length from the current {@link PerspectiveCamera#fov} and
	 * {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The computed focal length.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($ce0cdebec9150cb3$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    /**
	 * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
	 *
	 * @return {number} The effective FOV.
	 */ getEffectiveFOV() {
        return $ce0cdebec9150cb3$export$914076c8150813e5 * 2 * Math.atan(Math.tan($ce0cdebec9150cb3$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    /**
	 * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
	 * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
	 * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $ce0cdebec9150cb3$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($ce0cdebec9150cb3$var$_v3$1.x, $ce0cdebec9150cb3$var$_v3$1.y).multiplyScalar(-distance / $ce0cdebec9150cb3$var$_v3$1.z);
        $ce0cdebec9150cb3$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($ce0cdebec9150cb3$var$_v3$1.x, $ce0cdebec9150cb3$var$_v3$1.y).multiplyScalar(-distance / $ce0cdebec9150cb3$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
	 * @returns {Vector2} The view size.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $ce0cdebec9150cb3$var$_minTarget, $ce0cdebec9150cb3$var$_maxTarget);
        return target.subVectors($ce0cdebec9150cb3$var$_maxTarget, $ce0cdebec9150cb3$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *```
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *```
	 * then for each monitor you would call it like this:
	 *```js
	 * const w = 1920;
	 * const h = 1080;
	 * const fullWidth = w * 3;
	 * const fullHeight = h * 2;
	 *
	 * // --A--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 * // --B--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 * // --C--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 * // --D--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 * // --E--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 * // --F--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 * ```
	 *
	 * Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($ce0cdebec9150cb3$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $ce0cdebec9150cb3$var$SpotLightShadow extends $ce0cdebec9150cb3$var$LightShadow {
    /**
	 * Constructs a new spot light shadow.
	 */ constructor(){
        super(new $ce0cdebec9150cb3$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLightShadow = true;
        /**
		 * Used to focus the shadow camera. The camera's field of view is set as a
		 * percentage of the spotlight's field-of-view. Range is `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.focus = 1;
        /**
		 * Texture aspect ratio.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $ce0cdebec9150cb3$export$914076c8150813e5 * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height * this.aspect;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
/**
 * This light gets emitted from a single point in one direction, along a cone
 * that increases in size the further from the light it gets.
 *
 * This light can cast shadows - see the {@link SpotLightShadow} for details.
 *
 * ```js
 * // white spotlight shining from the side, modulated by a texture
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 100, 1000, 100 );
 * spotLight.map = new THREE.TextureLoader().load( url );
 *
 * spotLight.castShadow = true;
 * spotLight.shadow.mapSize.width = 1024;
 * spotLight.shadow.mapSize.height = 1024;
 * spotLight.shadow.camera.near = 500;
 * spotLight.shadow.camera.far = 4000;
 * spotLight.shadow.camera.fov = 30;s
 * ```
 *
 * @augments Light
 */ class $ce0cdebec9150cb3$export$81495cbb73897362 extends $ce0cdebec9150cb3$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($ce0cdebec9150cb3$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The spot light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $ce0cdebec9150cb3$export$e4dd07dff30cc924();
        /**
		 * Maximum range of the light. `0` means no limit.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
		 *
		 * @type {number}
		 * @default Math.PI/3
		 */ this.angle = angle;
        /**
		 * Percent of the spotlight cone that is attenuated due to penumbra.
		 * Value range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.penumbra = penumbra;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * A texture used to modulate the color of the light. The spot light
		 * color is mixed with the RGB value of this texture, with a ratio
		 * corresponding to its alpha value. The cookie-like masking effect is
		 * reproduced using pixel values (0, 0, 0, 1-cookie_value).
		 *
		 * *Warning*: This property is disabled if {@link Object3D#castShadow} is set to `false`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {SpotLightShadow}
		 */ this.shadow = new $ce0cdebec9150cb3$var$SpotLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 *  Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.map = source.map;
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.distance = this.distance;
        data.object.angle = this.angle;
        data.object.decay = this.decay;
        data.object.penumbra = this.penumbra;
        data.object.target = this.target.uuid;
        if (this.map && this.map.isTexture) data.object.map = this.map.toJSON(meta).uuid;
        data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
/**
 * Represents the shadow configuration of point lights.
 *
 * @augments LightShadow
 */ class $ce0cdebec9150cb3$var$PointLightShadow extends $ce0cdebec9150cb3$var$LightShadow {
    /**
	 * Constructs a new point light shadow.
	 */ constructor(){
        super(new $ce0cdebec9150cb3$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLightShadow = true;
    }
}
/**
 * A light that gets emitted from a single point in all directions. A common
 * use case for this is to replicate the light emitted from a bare
 * lightbulb.
 *
 * This light can cast shadows - see the {@link PointLightShadow} for details.
 *
 * ```js
 * const light = new THREE.PointLight( 0xff0000, 1, 100 );
 * light.position.set( 50, 50, 50 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $ce0cdebec9150cb3$export$4c9c1cb3f0b6f455 extends $ce0cdebec9150cb3$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new point light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLight = true;
        this.type = 'PointLight';
        /**
		 * When distance is zero, light will attenuate according to inverse-square
		 * law to infinite distance. When distance is non-zero, light will attenuate
		 * according to inverse-square law until near the distance cutoff, where it
		 * will then attenuate quickly and smoothly to 0. Inherently, cutoffs are not
		 * physically correct.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {PointLightShadow}
		 */ this.shadow = new $ce0cdebec9150cb3$var$PointLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.distance = this.distance;
        data.object.decay = this.decay;
        data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
/**
 * Camera that uses [orthographic projection](https://en.wikipedia.org/wiki/Orthographic_projection).
 *
 * In this projection mode, an object's size in the rendered image stays
 * constant regardless of its distance from the camera. This can be useful
 * for rendering 2D scenes and UI elements, amongst other things.
 *
 * ```js
 * const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $ce0cdebec9150cb3$export$9ebf355ee4ed261b extends $ce0cdebec9150cb3$export$79f141de891a5fed {
    /**
	 * Constructs a new orthographic camera.
	 *
	 * @param {number} [left=-1] - The left plane of the camera's frustum.
	 * @param {number} [right=1] - The right plane of the camera's frustum.
	 * @param {number} [top=1] - The top plane of the camera's frustum.
	 * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * The left plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.left = left;
        /**
		 * The right plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.right = right;
        /**
		 * The top plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.top = top;
        /**
		 * The bottom plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.bottom = bottom;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link OrthographicCamera#far}.
		 *
		 * Note that, unlike for the {@link PerspectiveCamera}, `0` is a
		 * valid value for an orthographic camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link OrthographicCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 * @see {@link PerspectiveCamera#setViewOffset}
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $ce0cdebec9150cb3$var$DirectionalLightShadow extends $ce0cdebec9150cb3$var$LightShadow {
    /**
	 * Constructs a new directional light shadow.
	 */ constructor(){
        super(new $ce0cdebec9150cb3$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLightShadow = true;
    }
}
/**
 * A light that gets emitted in a specific direction. This light will behave
 * as though it is infinitely far away and the rays produced from it are all
 * parallel. The common use case for this is to simulate daylight; the sun is
 * far enough away that its position can be considered to be infinite, and
 * all light rays coming from it are parallel.
 *
 * A common point of confusion for directional lights is that setting the
 * rotation has no effect. This is because three.js's DirectionalLight is the
 * equivalent to what is often called a 'Target Direct Light' in other
 * applications.
 *
 * This means that its direction is calculated as pointing from the light's
 * {@link Object3D#position} to the {@link DirectionalLight#target} position
 * (as opposed to a 'Free Direct Light' that just has a rotation
 * component).
 *
 * This light can cast shadows - see the {@link DirectionalLightShadow} for details.
 *
 * ```js
 * // White directional light at half intensity shining from the top.
 * const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
 * scene.add( directionalLight );
 * ```
 *
 * @augments Light
 */ class $ce0cdebec9150cb3$export$3fea33cc9972c868 extends $ce0cdebec9150cb3$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new directional light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($ce0cdebec9150cb3$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The directional light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $ce0cdebec9150cb3$export$e4dd07dff30cc924();
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {DirectionalLightShadow}
		 */ this.shadow = new $ce0cdebec9150cb3$var$DirectionalLightShadow();
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.shadow = this.shadow.toJSON();
        data.object.target = this.target.uuid;
        return data;
    }
}
/**
 * This light globally illuminates all objects in the scene equally.
 *
 * It cannot be used to cast shadows as it does not have a direction.
 *
 * ```js
 * const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $ce0cdebec9150cb3$export$af279bfef9ec2c96 extends $ce0cdebec9150cb3$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new ambient light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
/**
 * This class emits light uniformly across the face a rectangular plane.
 * This light type can be used to simulate light sources such as bright
 * windows or strip lighting.
 *
 * Important Notes:
 *
 * - There is no shadow support.
 * - Only PBR materials are supported.
 * - You have to include `RectAreaLightUniformsLib` (`WebGLRenderer`) or `RectAreaLightTexturesLib` (`WebGPURenderer`)
 * into your app and init the uniforms/textures.
 *
 * ```js
 * RectAreaLightUniformsLib.init(); // only relevant for WebGLRenderer
 * THREE.RectAreaLightNode.setLTC( RectAreaLightTexturesLib.init() ); //  only relevant for WebGPURenderer
 *
 * const intensity = 1; const width = 10; const height = 10;
 * const rectLight = new THREE.RectAreaLight( 0xffffff, intensity, width, height );
 * rectLight.position.set( 5, 5, 0 );
 * rectLight.lookAt( 0, 0, 0 );
 * scene.add( rectLight )
 * ```
 *
 * @augments Light
 */ class $ce0cdebec9150cb3$export$61db2d908bbd2429 extends $ce0cdebec9150cb3$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new area light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 * @param {number} [width=10] - The width of the light.
	 * @param {number} [height=10] - The height of the light.
	 */ constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        /**
		 * The width of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.width = width;
        /**
		 * The height of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.height = height;
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Represents a third-order spherical harmonics (SH). Light probes use this class
 * to encode lighting information.
 *
 * - Primary reference: {@link https://graphics.stanford.edu/papers/envmap/envmap.pdf}
 * - Secondary reference: {@link https://www.ppsloan.org/publications/StupidSH36.pdf}
 */ class $ce0cdebec9150cb3$export$ba61ce607e1f405a {
    /**
	 * Constructs a new spherical harmonics.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphericalHarmonics3 = true;
        /**
		 * An array holding the (9) SH coefficients.
		 *
		 * @type {Array<Vector3>}
		 */ this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $ce0cdebec9150cb3$export$64b5c384219d3699());
    }
    /**
	 * Sets the given SH coefficients to this instance by copying
	 * the values.
	 *
	 * @param {Array<Vector3>} coefficients - The SH coefficients.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    /**
	 * Sets all SH coefficients to `0`.
	 *
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    /**
	 * Returns the radiance in the direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The radiance.
	 */ getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    /**
	 * Returns the irradiance (radiance convolved with cosine lobe) in the
	 * direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The irradiance.
	 */ getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    /**
	 * Adds the given SH to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    /**
	 * A convenience method for performing {@link SphericalHarmonics3#add} and
	 * {@link SphericalHarmonics3#scale} at once.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    /**
	 * Scales this SH by the given scale factor.
	 *
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    /**
	 * Linear interpolates between the given SH and this instance by the given
	 * alpha factor.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to interpolate with.
	 * @param {number} alpha - The alpha factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    /**
	 * Returns `true` if this spherical harmonics is equal with the given one.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
	 * @return {boolean} Whether this spherical harmonics is equal with the given one.
	 */ equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    /**
	 * Copies the values of the given spherical harmonics to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ copy(sh) {
        return this.set(sh.coefficients);
    }
    /**
	 * Returns a new spherical harmonics with copied values from this instance.
	 *
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Sets the SH coefficients of this instance from the given array.
	 *
	 * @param {Array<number>} array - An array holding the SH coefficients.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    /**
	 * Returns an array with the SH coefficients, or copies them into the provided
	 * array. The coefficients are represented as numbers.
	 *
	 * @param {Array<number>} [array=[]] - The target array.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {Array<number>} An array with flat SH coefficients.
	 */ toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    /**
	 * Computes the SH basis for the given normal vector.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Array<number>} shBasis - The target array holding the SH basis.
	 */ static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
/**
 * Light probes are an alternative way of adding light to a 3D scene. Unlike
 * classical light sources (e.g. directional, point or spot lights), light
 * probes do not emit light. Instead they store information about light
 * passing through 3D space. During rendering, the light that hits a 3D
 * object is approximated by using the data from the light probe.
 *
 * Light probes are usually created from (radiance) environment maps. The
 * class {@link LightProbeGenerator} can be used to create light probes from
 * cube textures or render targets. However, light estimation data could also
 * be provided in other forms e.g. by WebXR. This enables the rendering of
 * augmented reality content that reacts to real world lighting.
 *
 * The current probe implementation in three.js supports so-called diffuse
 * light probes. This type of light probe is functionally equivalent to an
 * irradiance environment map.
 *
 * @augments Light
 */ class $ce0cdebec9150cb3$export$e7ef036e309b38d2 extends $ce0cdebec9150cb3$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new light probe.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics which represents encoded lighting information.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(sh = new $ce0cdebec9150cb3$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightProbe = true;
        /**
		 * A light probe uses spherical harmonics to encode lighting information.
		 *
		 * @type {SphericalHarmonics3}
		 */ this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
/**
 * Class for loading materials. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.MaterialLoader();
 * const material = await loader.loadAsync( 'material.json' );
 * ```
 * This loader does not support node materials. Use {@link NodeMaterialLoader} instead.
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$3bd6d323353dcf96 extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new material loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * A dictionary holding textures used by the material.
		 *
		 * @type {Object<string,Texture>}
		 */ this.textures = {};
    }
    /**
	 * Starts loading from the given URL and pass the loaded material to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Material)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $ce0cdebec9150cb3$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $ce0cdebec9150cb3$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a material.
	 *
	 * @param {Object} json - The serialized material.
	 * @return {Material} The parsed material.
	 */ parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $ce0cdebec9150cb3$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.allowOverride !== undefined) material.allowOverride = json.allowOverride;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $ce0cdebec9150cb3$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $ce0cdebec9150cb3$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $ce0cdebec9150cb3$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $ce0cdebec9150cb3$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $ce0cdebec9150cb3$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $ce0cdebec9150cb3$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $ce0cdebec9150cb3$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $ce0cdebec9150cb3$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    /**
	 * Textures are not embedded in the material JSON so they have
	 * to be injected before the loading process starts.
	 *
	 * @param {Object} value - A dictionary holding textures for material properties.
	 * @return {MaterialLoader} A reference to this material loader.
	 */ setTextures(value) {
        this.textures = value;
        return this;
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ createMaterialFromType(type) {
        return $ce0cdebec9150cb3$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @static
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $ce0cdebec9150cb3$export$e8564da406055a3,
            SpriteMaterial: $ce0cdebec9150cb3$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $ce0cdebec9150cb3$export$21c421a2e1df9d22,
            ShaderMaterial: $ce0cdebec9150cb3$export$83c7d75d550a8b0d,
            PointsMaterial: $ce0cdebec9150cb3$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $ce0cdebec9150cb3$export$28d04986c4269c9f,
            MeshStandardMaterial: $ce0cdebec9150cb3$export$f2980790215acccd,
            MeshPhongMaterial: $ce0cdebec9150cb3$export$24c72f71cbaf0678,
            MeshToonMaterial: $ce0cdebec9150cb3$export$df893cf97e765622,
            MeshNormalMaterial: $ce0cdebec9150cb3$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $ce0cdebec9150cb3$export$5023a9a8114806b8,
            MeshDepthMaterial: $ce0cdebec9150cb3$export$2698c22ec13825db,
            MeshDistanceMaterial: $ce0cdebec9150cb3$export$33e187ed002f2a19,
            MeshBasicMaterial: $ce0cdebec9150cb3$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $ce0cdebec9150cb3$export$6f5fef6235ec12ee,
            LineDashedMaterial: $ce0cdebec9150cb3$export$327886a3efaeaebe,
            LineBasicMaterial: $ce0cdebec9150cb3$export$fbaaa33907730a0c,
            Material: $ce0cdebec9150cb3$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
/**
 * A class with loader utility functions.
 */ class $ce0cdebec9150cb3$export$b5d2dc08d867e41a {
    /**
	 * Extracts the base URL from the given URL.
	 *
	 * @param {string} url -The URL to extract the base URL from.
	 * @return {string} The extracted base URL.
	 */ static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    /**
	 * Resolves relative URLs against the given path. Absolute paths, data urls,
	 * and blob URLs will be returned as is. Invalid URLs will return an empty
	 * string.
	 *
	 * @param {string} url -The URL to resolve.
	 * @param {string} path - The base path for relative URLs to be resolved against.
	 * @return {string} The resolved URL.
	 */ static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
/**
 * An instanced version of a geometry.
 */ class $ce0cdebec9150cb3$export$231f009cbe414146 extends $ce0cdebec9150cb3$export$b7be63a67df8959 {
    /**
	 * Constructs a new instanced buffer geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        /**
		 * The instance count.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.BufferGeometryLoader();
 * const geometry = await loader.loadAsync( 'models/json/pressure.json' );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xF5F5F5 } );
 * const object = new THREE.Mesh( geometry, material );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$dc275bb96327833a extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new geometry loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded geometry to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $ce0cdebec9150cb3$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $ce0cdebec9150cb3$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a geometry.
	 *
	 * @param {Object} json - The serialized geometry.
	 * @return {BufferGeometry} The parsed geometry.
	 */ parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $ce0cdebec9150cb3$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $ce0cdebec9150cb3$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $ce0cdebec9150cb3$export$231f009cbe414146() : new $ce0cdebec9150cb3$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $ce0cdebec9150cb3$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $ce0cdebec9150cb3$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $ce0cdebec9150cb3$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $ce0cdebec9150cb3$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $ce0cdebec9150cb3$export$32ea87a8b54d744a : $ce0cdebec9150cb3$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $ce0cdebec9150cb3$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $ce0cdebec9150cb3$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $ce0cdebec9150cb3$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) geometry.boundingSphere = new $ce0cdebec9150cb3$export$805e8b72413ccaba().fromJSON(boundingSphere);
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
/**
 * A loader for loading a JSON resource in the [JSON Object/Scene format](https://github.com/mrdoob/three.js/wiki/JSON-Object-Scene-format-4).
 * The files are internally loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.ObjectLoader();
 * const obj = await loader.loadAsync( 'models/json/example.json' );
 * scene.add( obj );
 *
 * // Alternatively, to parse a previously loaded JSON structure
 * const object = await loader.parseAsync( a_json_object );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$40110c8505c5ad19 extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new object loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded 3D object to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $ce0cdebec9150cb3$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $ce0cdebec9150cb3$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                error('ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                $ce0cdebec9150cb3$export$a3bc9b8ed74fc('ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    /**
	 * Async version of {@link ObjectLoader#load}.
	 *
	 * @async
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @return {Promise<Object3D>} A Promise that resolves with the loaded 3D object.
	 */ async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $ce0cdebec9150cb3$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $ce0cdebec9150cb3$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        let json;
        try {
            json = JSON.parse(text);
        } catch (e) {
            throw new Error('ObjectLoader: Can\'t parse ' + url + '. ' + e.message);
        }
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    /**
	 * Parses the given JSON. This is used internally by {@link ObjectLoader#load}
	 * but can also be used directly to parse a previously loaded JSON structure.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @param {onLoad} onLoad - Executed when all resources (e.g. textures) have been fully loaded.
	 * @return {Object3D} The parsed 3D object.
	 */ parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    /**
	 * Async version of {@link ObjectLoader#parse}.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @return {Promise<Object3D>} A Promise that resolves with the parsed 3D object.
	 */ async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    // internals
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $ce0cdebec9150cb3$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $ce0cdebec9150cb3$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $ce0cdebec9150cb3$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $ce0cdebec9150cb3$var$Geometries) geometry = $ce0cdebec9150cb3$var$Geometries[data.type].fromJSON(data, shapes);
                        else $ce0cdebec9150cb3$export$c106dd0671a0fc2d(`ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $ce0cdebec9150cb3$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $ce0cdebec9150cb3$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $ce0cdebec9150cb3$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $ce0cdebec9150cb3$export$99cc795e99919eed(onLoad);
            loader = new $ce0cdebec9150cb3$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $ce0cdebec9150cb3$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $ce0cdebec9150cb3$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $ce0cdebec9150cb3$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $ce0cdebec9150cb3$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $ce0cdebec9150cb3$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $ce0cdebec9150cb3$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $ce0cdebec9150cb3$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $ce0cdebec9150cb3$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $ce0cdebec9150cb3$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $ce0cdebec9150cb3$export$b691f601014eabe1();
                else texture = new $ce0cdebec9150cb3$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $ce0cdebec9150cb3$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $ce0cdebec9150cb3$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $ce0cdebec9150cb3$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $ce0cdebec9150cb3$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $ce0cdebec9150cb3$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $ce0cdebec9150cb3$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $ce0cdebec9150cb3$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $ce0cdebec9150cb3$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $ce0cdebec9150cb3$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $ce0cdebec9150cb3$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $ce0cdebec9150cb3$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $ce0cdebec9150cb3$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $ce0cdebec9150cb3$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $ce0cdebec9150cb3$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $ce0cdebec9150cb3$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $ce0cdebec9150cb3$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $ce0cdebec9150cb3$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                const sh = new $ce0cdebec9150cb3$export$ba61ce607e1f405a().fromArray(data.sh);
                object = new $ce0cdebec9150cb3$export$e7ef036e309b38d2(sh, data.intensity);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $ce0cdebec9150cb3$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $ce0cdebec9150cb3$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $ce0cdebec9150cb3$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $ce0cdebec9150cb3$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $ce0cdebec9150cb3$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $ce0cdebec9150cb3$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._geometryInfo = data.geometryInfo.map((info)=>{
                    let box = null;
                    let sphere = null;
                    if (info.boundingBox !== undefined) box = new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3().fromJSON(info.boundingBox);
                    if (info.boundingSphere !== undefined) sphere = new $ce0cdebec9150cb3$export$805e8b72413ccaba().fromJSON(info.boundingSphere);
                    return {
                        ...info,
                        boundingBox: box,
                        boundingSphere: sphere
                    };
                });
                object._instanceInfo = data.instanceInfo;
                object._availableInstanceIds = data._availableInstanceIds;
                object._availableGeometryIds = data._availableGeometryIds;
                object._nextIndexStart = data.nextIndexStart;
                object._nextVertexStart = data.nextVertexStart;
                object._geometryCount = data.geometryCount;
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                object._indirectTexture = getTexture(data.indirectTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                if (data.boundingSphere !== undefined) object.boundingSphere = new $ce0cdebec9150cb3$export$805e8b72413ccaba().fromJSON(data.boundingSphere);
                if (data.boundingBox !== undefined) object.boundingBox = new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3().fromJSON(data.boundingBox);
                break;
            case 'LOD':
                object = new $ce0cdebec9150cb3$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $ce0cdebec9150cb3$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $ce0cdebec9150cb3$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $ce0cdebec9150cb3$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $ce0cdebec9150cb3$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $ce0cdebec9150cb3$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $ce0cdebec9150cb3$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $ce0cdebec9150cb3$export$b127726e56765aa4();
                break;
            default:
                object = new $ce0cdebec9150cb3$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.pivot !== undefined) object.pivot = new $ce0cdebec9150cb3$export$64b5c384219d3699().fromArray(data.pivot);
        if (data.morphTargetDictionary !== undefined) object.morphTargetDictionary = Object.assign({}, data.morphTargetDictionary);
        if (data.morphTargetInfluences !== undefined) object.morphTargetInfluences = data.morphTargetInfluences.slice();
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.static !== undefined) object.static = data.static;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $ce0cdebec9150cb3$export$e4dd07dff30cc924();
            }
        });
    }
}
const $ce0cdebec9150cb3$var$TEXTURE_MAPPING = {
    UVMapping: $ce0cdebec9150cb3$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $ce0cdebec9150cb3$export$8759762a6477f2c4,
    CubeRefractionMapping: $ce0cdebec9150cb3$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $ce0cdebec9150cb3$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $ce0cdebec9150cb3$export$ee99d97d46898098,
    CubeUVReflectionMapping: $ce0cdebec9150cb3$export$dbf3e70ff37af79
};
const $ce0cdebec9150cb3$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $ce0cdebec9150cb3$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $ce0cdebec9150cb3$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $ce0cdebec9150cb3$export$c7e7c00b14f51a4f
};
const $ce0cdebec9150cb3$var$TEXTURE_FILTER = {
    NearestFilter: $ce0cdebec9150cb3$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $ce0cdebec9150cb3$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $ce0cdebec9150cb3$export$d2327c1afe5bfdf2,
    LinearFilter: $ce0cdebec9150cb3$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $ce0cdebec9150cb3$export$19a719f377145a13,
    LinearMipmapLinearFilter: $ce0cdebec9150cb3$export$5d8599b6a933fb1b
};
const $ce0cdebec9150cb3$var$_errorMap = new WeakMap();
/**
 * A loader for loading images as an [ImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap).
 * An `ImageBitmap` provides an asynchronous and resource efficient pathway to prepare
 * textures for rendering.
 *
 * Note that {@link Texture#flipY} and {@link Texture#premultiplyAlpha} are ignored with image bitmaps.
 * These options need to be configured via {@link ImageBitmapLoader#setOptions} prior to loading,
 * unlike regular images which can be configured on the Texture to set these options on GPU upload instead.
 *
 * To match the default behaviour of {@link Texture}, the following options are needed:
 *
 * ```js
 * { imageOrientation: 'flipY', premultiplyAlpha: 'none' }
 * ```
 *
 * Also note that unlike {@link FileLoader}, this loader will only avoid multiple concurrent requests to the same URL if {@link Cache} is enabled.
 *
 * ```js
 * const loader = new THREE.ImageBitmapLoader();
 * loader.setOptions( { imageOrientation: 'flipY' } ); // set options if needed
 * const imageBitmap = await loader.loadAsync( 'image.png' );
 *
 * const texture = new THREE.Texture( imageBitmap );
 * texture.needsUpdate = true;
 * ```
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$52286b55c4a9b51f extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image bitmap loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') $ce0cdebec9150cb3$export$c106dd0671a0fc2d('ImageBitmapLoader: fetch() not supported.');
        /**
		 * Represents the loader options.
		 *
		 * @type {Object}
		 * @default {premultiplyAlpha:'none'}
		 */ this.options = {
            premultiplyAlpha: 'none'
        };
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Sets the given loader options. The structure of the object must match the `options` parameter of
	 * [createImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap).
	 *
	 * @param {Object} options - The loader options to set.
	 * @return {ImageBitmapLoader} A reference to this image bitmap loader.
	 */ setOptions(options) {
        this.options = options;
        return this;
    }
    /**
	 * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {ImageBitmap|undefined} The image bitmap.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $ce0cdebec9150cb3$export$94affb487e701bf2.get(`image-bitmap:${url}`);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    // check if there is an error for the cached promise
                    if ($ce0cdebec9150cb3$var$_errorMap.has(cached) === true) {
                        if (onError) onError($ce0cdebec9150cb3$var$_errorMap.get(cached));
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    } else {
                        if (onLoad) onLoad(imageBitmap);
                        scope.manager.itemEnd(url);
                        return imageBitmap;
                    }
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetchOptions.signal = typeof AbortSignal.any === 'function' ? AbortSignal.any([
            this._abortController.signal,
            this.manager.abortController.signal
        ]) : this._abortController.signal;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $ce0cdebec9150cb3$export$94affb487e701bf2.add(`image-bitmap:${url}`, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $ce0cdebec9150cb3$var$_errorMap.set(promise, e);
            $ce0cdebec9150cb3$export$94affb487e701bf2.remove(`image-bitmap:${url}`);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $ce0cdebec9150cb3$export$94affb487e701bf2.add(`image-bitmap:${url}`, promise);
        scope.manager.itemStart(url);
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {ImageBitmapLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
let $ce0cdebec9150cb3$var$_context;
/**
 * Manages the global audio context in the engine.
 *
 * @hideconstructor
 */ class $ce0cdebec9150cb3$export$fcbc63750ec2a81f {
    /**
	 * Returns the global native audio context.
	 *
	 * @return {AudioContext} The native audio context.
	 */ static getContext() {
        if ($ce0cdebec9150cb3$var$_context === undefined) $ce0cdebec9150cb3$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $ce0cdebec9150cb3$var$_context;
    }
    /**
	 * Allows to set the global native audio context from outside.
	 *
	 * @param {AudioContext} value - The native context to set.
	 */ static setContext(value) {
        $ce0cdebec9150cb3$var$_context = value;
    }
}
/**
 * Class for loading audio buffers. Audios are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const audioListener = new THREE.AudioListener();
 * const ambientSound = new THREE.Audio( audioListener );
 *
 * const loader = new THREE.AudioLoader();
 * const audioBuffer = await loader.loadAsync( 'audio/ambient_ocean.ogg' );
 *
 * ambientSound.setBuffer( audioBuffer );
 * ambientSound.play();
 * ```
 *
 * @augments Loader
 */ class $ce0cdebec9150cb3$export$d8d5fccfbf47714e extends $ce0cdebec9150cb3$export$3b0d6d7590275603 {
    /**
	 * Constructs a new audio loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded audio buffer
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(AudioBuffer)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $ce0cdebec9150cb3$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $ce0cdebec9150cb3$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else $ce0cdebec9150cb3$export$a3bc9b8ed74fc(e);
            scope.manager.itemError(url);
        }
    }
}
const $ce0cdebec9150cb3$var$_eyeRight = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_eyeLeft = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_projectionMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
/**
 * A special type of camera that uses two perspective cameras with
 * stereoscopic projection. Can be used for rendering stereo effects
 * like [3D Anaglyph](https://en.wikipedia.org/wiki/Anaglyph_3D) or
 * [Parallax Barrier](https://en.wikipedia.org/wiki/parallax_barrier).
 */ class $ce0cdebec9150cb3$export$bc7f73a1065bee0c {
    /**
	 * Constructs a new stereo camera.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'StereoCamera';
        /**
		 * The aspect.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
        /**
		 * The eye separation which represents the distance
		 * between the left and right camera.
		 *
		 * @type {number}
		 * @default 0.064
		 */ this.eyeSep = 0.064;
        /**
		 * The camera representing the left eye. This is added to layer `1` so objects to be
		 * rendered by the left camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraL = new $ce0cdebec9150cb3$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        /**
		 * The camera representing the right eye. This is added to layer `2` so objects to be
		 * rendered by the right camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraR = new $ce0cdebec9150cb3$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    /**
	 * Updates the stereo camera based on the given perspective camera.
	 *
	 * @param {PerspectiveCamera} camera - The perspective camera.
	 */ update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $ce0cdebec9150cb3$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($ce0cdebec9150cb3$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $ce0cdebec9150cb3$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $ce0cdebec9150cb3$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $ce0cdebec9150cb3$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $ce0cdebec9150cb3$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($ce0cdebec9150cb3$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $ce0cdebec9150cb3$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $ce0cdebec9150cb3$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($ce0cdebec9150cb3$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($ce0cdebec9150cb3$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($ce0cdebec9150cb3$var$_eyeRight);
    }
}
const $ce0cdebec9150cb3$var$fov = -90; // negative fov is not an error
const $ce0cdebec9150cb3$var$aspect = 1;
/**
 * A special type of camera that is positioned in 3D space to render its surroundings into a
 * cube render target. The render target can then be used as an environment map for rendering
 * realtime reflections in your scene.
 *
 * ```js
 * // Create cube render target
 * const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
 *
 * // Create cube camera
 * const cubeCamera = new THREE.CubeCamera( 1, 100000, cubeRenderTarget );
 * scene.add( cubeCamera );
 *
 * // Create car
 * const chromeMaterial = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: cubeRenderTarget.texture } );
 * const car = new THREE.Mesh( carGeometry, chromeMaterial );
 * scene.add( car );
 *
 * // Update the render target cube
 * car.visible = false;
 * cubeCamera.position.copy( car.position );
 * cubeCamera.update( renderer, scene );
 *
 * // Render the scene
 * car.visible = true;
 * renderer.render( scene, camera );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$d0cdd0bd804995de extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new cube camera.
	 *
	 * @param {number} near - The camera's near plane.
	 * @param {number} far - The camera's far plane.
	 * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
	 */ constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        /**
		 * A reference to the cube render target.
		 *
		 * @type {WebGLCubeRenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * The current active coordinate system.
		 *
		 * @type {?(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 * @default null
		 */ this.coordinateSystem = null;
        /**
		 * The current active mipmap level
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        const cameraPX = new $ce0cdebec9150cb3$export$74e4ae24825f68d7($ce0cdebec9150cb3$var$fov, $ce0cdebec9150cb3$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $ce0cdebec9150cb3$export$74e4ae24825f68d7($ce0cdebec9150cb3$var$fov, $ce0cdebec9150cb3$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $ce0cdebec9150cb3$export$74e4ae24825f68d7($ce0cdebec9150cb3$var$fov, $ce0cdebec9150cb3$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $ce0cdebec9150cb3$export$74e4ae24825f68d7($ce0cdebec9150cb3$var$fov, $ce0cdebec9150cb3$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $ce0cdebec9150cb3$export$74e4ae24825f68d7($ce0cdebec9150cb3$var$fov, $ce0cdebec9150cb3$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $ce0cdebec9150cb3$export$74e4ae24825f68d7($ce0cdebec9150cb3$var$fov, $ce0cdebec9150cb3$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    /**
	 * Must be called when the coordinate system of the cube camera is changed.
	 */ updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $ce0cdebec9150cb3$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $ce0cdebec9150cb3$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    /**
	 * Calling this method will render the given scene with the given renderer
	 * into the cube render target of the camera.
	 *
	 * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
	 * @param {Scene} scene - The scene to render.
	 */ update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        // https://github.com/mrdoob/three.js/issues/31413#issuecomment-3095966812
        let reversedDepthBuffer = false;
        if (renderer.isWebGLRenderer === true) reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        else reversedDepthBuffer = renderer.reversedDepthBuffer;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
/**
 * This type of camera can be used in order to efficiently render a scene with a
 * predefined set of cameras. This is an important performance aspect for
 * rendering VR scenes.
 *
 * An instance of `ArrayCamera` always has an array of sub cameras. It's mandatory
 * to define for each sub camera the `viewport` property which determines the
 * part of the viewport that is rendered with this camera.
 *
 * @augments PerspectiveCamera
 */ class $ce0cdebec9150cb3$export$56b937d9e5581166 extends $ce0cdebec9150cb3$export$74e4ae24825f68d7 {
    /**
	 * Constructs a new array camera.
	 *
	 * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
	 */ constructor(array = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayCamera = true;
        /**
		 * Whether this camera is used with multiview rendering or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isMultiViewCamera = false;
        /**
		 * An array of perspective sub cameras.
		 *
		 * @type {Array<PerspectiveCamera>}
		 */ this.cameras = array;
    }
}
/**
 * This class is an alternative to {@link Clock} with a different API design and behavior.
 * The goal is to avoid the conceptual flaws that became apparent in `Clock` over time.
 *
 * - `Timer` has an `update()` method that updates its internal state. That makes it possible to
 * call `getDelta()` and `getElapsed()` multiple times per simulation step without getting different values.
 * - The class can make use of the Page Visibility API to avoid large time delta values when the app
 * is inactive (e.g. tab switched or browser hidden).
 *
 * ```js
 * const timer = new Timer();
 * timer.connect( document ); // use Page Visibility API
 * ```
 */ class $ce0cdebec9150cb3$export$c57e9b2d8b9e4de {
    /**
	 * Constructs a new timer.
	 */ constructor(){
        this._previousTime = 0;
        this._currentTime = 0;
        this._startTime = performance.now();
        this._delta = 0;
        this._elapsed = 0;
        this._timescale = 1;
        this._document = null;
        this._pageVisibilityHandler = null;
    }
    /**
	 * Connect the timer to the given document.Calling this method is not mandatory to
	 * use the timer but enables the usage of the Page Visibility API to avoid large time
	 * delta values.
	 *
	 * @param {Document} document - The document.
	 */ connect(document1) {
        this._document = document1;
        // use Page Visibility API to avoid large time delta values
        if (document1.hidden !== undefined) {
            this._pageVisibilityHandler = $ce0cdebec9150cb3$var$handleVisibilityChange.bind(this);
            document1.addEventListener('visibilitychange', this._pageVisibilityHandler, false);
        }
    }
    /**
	 * Disconnects the timer from the DOM and also disables the usage of the Page Visibility API.
	 */ disconnect() {
        if (this._pageVisibilityHandler !== null) {
            this._document.removeEventListener('visibilitychange', this._pageVisibilityHandler);
            this._pageVisibilityHandler = null;
        }
        this._document = null;
    }
    /**
	 * Returns the time delta in seconds.
	 *
	 * @return {number} The time delta in second.
	 */ getDelta() {
        return this._delta / 1000;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time in second.
	 */ getElapsed() {
        return this._elapsed / 1000;
    }
    /**
	 * Returns the timescale.
	 *
	 * @return {number} The timescale.
	 */ getTimescale() {
        return this._timescale;
    }
    /**
	 * Sets the given timescale which scale the time delta computation
	 * in `update()`.
	 *
	 * @param {number} timescale - The timescale to set.
	 * @return {Timer} A reference to this timer.
	 */ setTimescale(timescale) {
        this._timescale = timescale;
        return this;
    }
    /**
	 * Resets the time computation for the current simulation step.
	 *
	 * @return {Timer} A reference to this timer.
	 */ reset() {
        this._currentTime = performance.now() - this._startTime;
        return this;
    }
    /**
	 * Can be used to free all internal resources. Usually called when
	 * the timer instance isn't required anymore.
	 */ dispose() {
        this.disconnect();
    }
    /**
	 * Updates the internal state of the timer. This method should be called
	 * once per simulation step and before you perform queries against the timer
	 * (e.g. via `getDelta()`).
	 *
	 * @param {number} timestamp - The current time in milliseconds. Can be obtained
	 * from the `requestAnimationFrame` callback argument. If not provided, the current
	 * time will be determined with `performance.now`.
	 * @return {Timer} A reference to this timer.
	 */ update(timestamp) {
        if (this._pageVisibilityHandler !== null && this._document.hidden === true) this._delta = 0;
        else {
            this._previousTime = this._currentTime;
            this._currentTime = (timestamp !== undefined ? timestamp : performance.now()) - this._startTime;
            this._delta = (this._currentTime - this._previousTime) * this._timescale;
            this._elapsed += this._delta; // _elapsed is the accumulation of all previous deltas
        }
        return this;
    }
}
function $ce0cdebec9150cb3$var$handleVisibilityChange() {
    if (this._document.hidden === false) this.reset();
}
const $ce0cdebec9150cb3$var$_position$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_quaternion$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3();
const $ce0cdebec9150cb3$var$_scale$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_forward = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_up = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * The class represents a virtual listener of the all positional and non-positional audio effects
 * in the scene. A three.js application usually creates a single listener. It is a mandatory
 * constructor parameter for audios entities like {@link Audio} and {@link PositionalAudio}.
 *
 * In most cases, the listener object is a child of the camera. So the 3D transformation of the
 * camera represents the 3D transformation of the listener.
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$8a1b810c6fde8951 extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio listener.
	 */ constructor(){
        super();
        this.type = 'AudioListener';
        /**
		 * The native audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = $ce0cdebec9150cb3$export$fcbc63750ec2a81f.getContext();
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        /**
		 * An optional filter.
		 *
		 * Defined via {@link AudioListener#setFilter}.
		 *
		 * @type {?AudioNode}
		 * @default null
		 * @readonly
		 */ this.filter = null;
        /**
		 * Time delta values required for `linearRampToValueAtTime()` usage.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.timeDelta = 0;
        // private
        this._timer = new $ce0cdebec9150cb3$export$c57e9b2d8b9e4de();
    }
    /**
	 * Returns the listener's input node.
	 *
	 * This method is used by other audio nodes to connect to this listener.
	 *
	 * @return {GainNode} The input node.
	 */ getInput() {
        return this.gain;
    }
    /**
	 * Removes the current filter from this listener.
	 *
	 * @return {AudioListener} A reference to this listener.
	 */ removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    /**
	 * Returns the current set filter.
	 *
	 * @return {?AudioNode} The filter.
	 */ getFilter() {
        return this.filter;
    }
    /**
	 * Sets the given filter to this listener.
	 *
	 * @param {AudioNode} value - The filter to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    /**
	 * Returns the applications master volume.
	 *
	 * @return {number} The master volume.
	 */ getMasterVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the applications master volume. This volume setting affects
	 * all audio nodes in the scene.
	 *
	 * @param {number} value - The master volume to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this._timer.update();
        const listener = this.context.listener;
        this.timeDelta = this._timer.getDelta();
        this.matrixWorld.decompose($ce0cdebec9150cb3$var$_position$1, $ce0cdebec9150cb3$var$_quaternion$1, $ce0cdebec9150cb3$var$_scale$1);
        // the initial forward and up directions must be orthogonal
        $ce0cdebec9150cb3$var$_forward.set(0, 0, -1).applyQuaternion($ce0cdebec9150cb3$var$_quaternion$1);
        $ce0cdebec9150cb3$var$_up.set(0, 1, 0).applyQuaternion($ce0cdebec9150cb3$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($ce0cdebec9150cb3$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($ce0cdebec9150cb3$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($ce0cdebec9150cb3$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($ce0cdebec9150cb3$var$_forward.x, endTime);
            listener.forwardY.linearRampToValueAtTime($ce0cdebec9150cb3$var$_forward.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($ce0cdebec9150cb3$var$_forward.z, endTime);
            listener.upX.linearRampToValueAtTime($ce0cdebec9150cb3$var$_up.x, endTime);
            listener.upY.linearRampToValueAtTime($ce0cdebec9150cb3$var$_up.y, endTime);
            listener.upZ.linearRampToValueAtTime($ce0cdebec9150cb3$var$_up.z, endTime);
        } else {
            listener.setPosition($ce0cdebec9150cb3$var$_position$1.x, $ce0cdebec9150cb3$var$_position$1.y, $ce0cdebec9150cb3$var$_position$1.z);
            listener.setOrientation($ce0cdebec9150cb3$var$_forward.x, $ce0cdebec9150cb3$var$_forward.y, $ce0cdebec9150cb3$var$_forward.z, $ce0cdebec9150cb3$var$_up.x, $ce0cdebec9150cb3$var$_up.y, $ce0cdebec9150cb3$var$_up.z);
        }
    }
}
/**
 * Represents a non-positional ( global ) audio object.
 *
 * This and related audio modules make use of the [Web Audio API](https://www.w3.org/TR/webaudio-1.1/).
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create a global audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop( true );
 * 	sound.setVolume( 0.5 );
 * 	sound.play();
 * });
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$153755f98d9861de extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super();
        this.type = 'Audio';
        /**
		 * The global audio listener.
		 *
		 * @type {AudioListener}
		 * @readonly
		 */ this.listener = listener;
        /**
		 * The audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = listener.context;
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        /**
		 * Whether to start playback automatically or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoplay = false;
        /**
		 * A reference to an audio buffer.
		 *
		 * Defined via {@link Audio#setBuffer}.
		 *
		 * @type {?AudioBuffer}
		 * @default null
		 * @readonly
		 */ this.buffer = null;
        /**
		 * Modify pitch, measured in cents. +/- 100 is a semitone.
		 * +/- 1200 is an octave.
		 *
		 * Defined via {@link Audio#setDetune}.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.detune = 0;
        /**
		 * Whether the audio should loop or not.
		 *
		 * Defined via {@link Audio#setLoop}.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.loop = false;
        /**
		 * Defines where in the audio buffer the replay should
		 * start, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopStart = 0;
        /**
		 * Defines where in the audio buffer the replay should
		 * stop, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopEnd = 0;
        /**
		 * An offset to the time within the audio buffer the playback
		 * should begin, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.offset = 0;
        /**
		 * Overrides the default duration of the audio.
		 *
		 * @type {undefined|number}
		 * @default undefined
		 */ this.duration = undefined;
        /**
		 * The playback speed.
		 *
		 * Defined via {@link Audio#setPlaybackRate}.
		 *
		 * @type {number}
		 * @readonly
		 * @default 1
		 */ this.playbackRate = 1;
        /**
		 * Indicates whether the audio is playing or not.
		 *
		 * This flag will be automatically set when using {@link Audio#play},
		 * {@link Audio#pause}, {@link Audio#stop}.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPlaying = false;
        /**
		 * Indicates whether the audio playback can be controlled
		 * with method like {@link Audio#play} or {@link Audio#pause}.
		 *
		 * This flag will be automatically set when audio sources are
		 * defined.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.hasPlaybackControl = true;
        /**
		 * Holds a reference to the current audio source.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {?AudioNode}
		 * @readonly
		 * @default null
		 */ this.source = null;
        /**
		 * Defines the source type.
		 *
		 * The property is automatically set by one of the `set*()` methods.
		 *
		 * @type {('empty'|'audioNode'|'mediaNode'|'mediaStreamNode'|'buffer')}
		 * @readonly
		 * @default 'empty'
		 */ this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        /**
		 * Can be used to apply a variety of low-order filters to create
		 * more complex sound effects e.g. via `BiquadFilterNode`.
		 *
		 * The property is automatically set by {@link Audio#setFilters}.
		 *
		 * @type {Array<AudioNode>}
		 * @readonly
		 */ this.filters = [];
    }
    /**
	 * Returns the output audio node.
	 *
	 * @return {GainNode} The output node.
	 */ getOutput() {
        return this.gain;
    }
    /**
	 * Sets the given audio node as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `audioNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {AudioNode} audioNode - The audio node like an instance of `OscillatorNode`.
	 * @return {Audio} A reference to this instance.
	 */ setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    /**
	 * Sets the given media element as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {HTMLMediaElement} mediaElement - The media element.
	 * @return {Audio} A reference to this instance.
	 */ setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    /**
	 * Sets the given media stream as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaStreamNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {MediaStream} mediaStream - The media stream.
	 * @return {Audio} A reference to this instance.
	 */ setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    /**
	 * Sets the given audio buffer as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `buffer` and {@link Audio#hasPlaybackControl} to `true`.
	 *
	 * @param {AudioBuffer} audioBuffer - The audio buffer.
	 * @return {Audio} A reference to this instance.
	 */ setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    /**
	 * Starts the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should start playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ play(delay = 0) {
        if (this.isPlaying === true) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    /**
	 * Pauses the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ pause() {
        if (this.hasPlaybackControl === false) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    /**
	 * Stops the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should stop playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    /**
	 * Connects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio} A reference to this instance.
	 */ connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    /**
	 * Disconnects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    /**
	 * Returns the current set filters.
	 *
	 * @return {Array<AudioNode>} The list of filters.
	 */ getFilters() {
        return this.filters;
    }
    /**
	 * Sets an array of filters and connects them with the audio source.
	 *
	 * @param {Array<AudioNode>} [value] - A list of filters.
	 * @return {Audio} A reference to this instance.
	 */ setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    /**
	 * Defines the detuning of oscillation in cents.
	 *
	 * @param {number} value - The detuning of oscillation in cents.
	 * @return {Audio} A reference to this instance.
	 */ setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the detuning of oscillation in cents.
	 *
	 * @return {number} The detuning of oscillation in cents.
	 */ getDetune() {
        return this.detune;
    }
    /**
	 * Returns the first filter in the list of filters.
	 *
	 * @return {AudioNode|undefined} The first filter in the list of filters.
	 */ getFilter() {
        return this.getFilters()[0];
    }
    /**
	 * Applies a single filter node to the audio.
	 *
	 * @param {AudioNode} [filter] - The filter to set.
	 * @return {Audio} A reference to this instance.
	 */ setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    /**
	 * Sets the playback rate.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [value] - The playback rate to set.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the current playback rate.

	 * @return {number} The playback rate.
	 */ getPlaybackRate() {
        return this.playbackRate;
    }
    /**
	 * Automatically called when playback finished.
	 */ onEnded() {
        this.isPlaying = false;
        this._progress = 0;
    }
    /**
	 * Returns the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {boolean} Whether the audio should loop or not.
	 */ getLoop() {
        if (this.hasPlaybackControl === false) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    /**
	 * Sets the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {boolean} value - Whether the audio should loop or not.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setLoop(value) {
        if (this.hasPlaybackControl === false) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    /**
	 * Sets the loop start value which defines where in the audio buffer the replay should
	 * start, in seconds.
	 *
	 * @param {number} value - The loop start value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    /**
	 * Sets the loop end value which defines where in the audio buffer the replay should
	 * stop, in seconds.
	 *
	 * @param {number} value - The loop end value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    /**
	 * Returns the volume.
	 *
	 * @return {number} The volume.
	 */ getVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the volume.
	 *
	 * @param {number} value - The volume to set.
	 * @return {Audio} A reference to this instance.
	 */ setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.sourceType !== 'buffer') {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Audio: Audio source type cannot be copied.');
            return this;
        }
        this.autoplay = source.autoplay;
        this.buffer = source.buffer;
        this.detune = source.detune;
        this.loop = source.loop;
        this.loopStart = source.loopStart;
        this.loopEnd = source.loopEnd;
        this.offset = source.offset;
        this.duration = source.duration;
        this.playbackRate = source.playbackRate;
        this.hasPlaybackControl = source.hasPlaybackControl;
        this.sourceType = source.sourceType;
        this.filters = source.filters.slice();
        return this;
    }
    clone(recursive) {
        return new this.constructor(this.listener).copy(this, recursive);
    }
}
const $ce0cdebec9150cb3$var$_position = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_quaternion = /*@__PURE__*/ new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3();
const $ce0cdebec9150cb3$var$_scale = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_orientation = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * Represents a positional audio object.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create the PositionalAudio object (passing in the listener)
 * const sound = new THREE.PositionalAudio( listener );
 *
 * // load a sound and set it as the PositionalAudio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/song.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setRefDistance( 20 );
 * 	sound.play();
 * });
 *
 * // create an object for the sound to play from
 * const sphere = new THREE.SphereGeometry( 20, 32, 16 );
 * const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
 * const mesh = new THREE.Mesh( sphere, material );
 * scene.add( mesh );
 *
 * // finally add the sound to the mesh
 * mesh.add( sound );
 *
 * @augments Audio
 */ class $ce0cdebec9150cb3$export$4b3e397ef1832507 extends $ce0cdebec9150cb3$export$153755f98d9861de {
    /**
	 * Constructs a positional audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super(listener);
        /**
		 * The panner node represents the location, direction, and behavior of an audio
		 * source in 3D space.
		 *
		 * @type {PannerNode}
		 * @readonly
		 */ this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
        return this;
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
        return this;
    }
    getOutput() {
        return this.panner;
    }
    /**
	 * Returns the current reference distance.
	 *
	 * @return {number} The reference distance.
	 */ getRefDistance() {
        return this.panner.refDistance;
    }
    /**
	 * Defines the reference distance for reducing volume as the audio source moves
	 * further from the listener – i.e. the distance at which the volume reduction
	 * starts taking effect.
	 *
	 * @param {number} value - The reference distance to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    /**
	 * Returns the current rolloff factor.
	 *
	 * @return {number} The rolloff factor.
	 */ getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    /**
	 * Defines how quickly the volume is reduced as the source moves away from the listener.
	 *
	 * @param {number} value - The rolloff factor.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    /**
	 * Returns the current distance model.
	 *
	 * @return {('linear'|'inverse'|'exponential')} The distance model.
	 */ getDistanceModel() {
        return this.panner.distanceModel;
    }
    /**
	 * Defines which algorithm to use to reduce the volume of the audio source
	 * as it moves away from the listener.
	 *
	 * Read [the spec](https://www.w3.org/TR/webaudio-1.1/#enumdef-distancemodeltype)
	 * for more details.
	 *
	 * @param {('linear'|'inverse'|'exponential')} value - The distance model to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    /**
	 * Returns the current max distance.
	 *
	 * @return {number} The max distance.
	 */ getMaxDistance() {
        return this.panner.maxDistance;
    }
    /**
	 * Defines the maximum distance between the audio source and the listener,
	 * after which the volume is not reduced any further.
	 *
	 * This value is used only by the `linear` distance model.
	 *
	 * @param {number} value - The max distance.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    /**
	 * Sets the directional cone in which the audio can be listened.
	 *
	 * @param {number} coneInnerAngle - An angle, in degrees, of a cone inside of which there will be no volume reduction.
	 * @param {number} coneOuterAngle - An angle, in degrees, of a cone outside of which the volume will be reduced by a constant value, defined by the `coneOuterGain` parameter.
	 * @param {number} coneOuterGain - The amount of volume reduction outside the cone defined by the `coneOuterAngle`. When set to `0`, no sound can be heard.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($ce0cdebec9150cb3$var$_position, $ce0cdebec9150cb3$var$_quaternion, $ce0cdebec9150cb3$var$_scale);
        $ce0cdebec9150cb3$var$_orientation.set(0, 0, 1).applyQuaternion($ce0cdebec9150cb3$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($ce0cdebec9150cb3$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($ce0cdebec9150cb3$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($ce0cdebec9150cb3$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($ce0cdebec9150cb3$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($ce0cdebec9150cb3$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($ce0cdebec9150cb3$var$_orientation.z, endTime);
        } else {
            panner.setPosition($ce0cdebec9150cb3$var$_position.x, $ce0cdebec9150cb3$var$_position.y, $ce0cdebec9150cb3$var$_position.z);
            panner.setOrientation($ce0cdebec9150cb3$var$_orientation.x, $ce0cdebec9150cb3$var$_orientation.y, $ce0cdebec9150cb3$var$_orientation.z);
        }
    }
}
/**
 * This class can be used to analyse audio data.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create an Audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop(true);
 * 	sound.setVolume(0.5);
 * 	sound.play();
 * });
 *
 * // create an AudioAnalyser, passing in the sound and desired fftSize
 * const analyser = new THREE.AudioAnalyser( sound, 32 );
 *
 * // get the average frequency of the sound
 * const data = analyser.getAverageFrequency();
 * ```
 */ class $ce0cdebec9150cb3$export$d47da1ef3d382827 {
    /**
	 * Constructs a new audio analyzer.
	 *
	 * @param {Audio} audio - The audio to analyze.
	 * @param {number} [fftSize=2048] - The window size in samples that is used when performing a Fast Fourier Transform (FFT) to get frequency domain data.
	 */ constructor(audio, fftSize = 2048){
        /**
		 * The global audio listener.
		 *
		 * @type {AnalyserNode}
		 */ this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        /**
		 * Holds the analyzed data.
		 *
		 * @type {Uint8Array}
		 */ this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    /**
	 * Returns an array with frequency data of the audio.
	 *
	 * Each item in the array represents the decibel value for a specific frequency.
	 * The frequencies are spread linearly from 0 to 1/2 of the sample rate.
	 * For example, for 48000 sample rate, the last item of the array will represent
	 * the decibel value for 24000 Hz.
	 *
	 * @return {Uint8Array} The frequency data.
	 */ getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    /**
	 * Returns the average of the frequencies returned by {@link AudioAnalyser#getFrequencyData}.
	 *
	 * @return {number} The average frequency.
	 */ getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
/**
 * Buffered scene graph property that allows weighted accumulation; used internally.
 */ class $ce0cdebec9150cb3$export$dfe0af1ca1acb78a {
    /**
	 * Constructs a new property mixer.
	 *
	 * @param {PropertyBinding} binding - The property binding.
	 * @param {string} typeName - The keyframe track type name.
	 * @param {number} valueSize - The keyframe track value size.
	 */ constructor(binding, typeName, valueSize){
        /**
		 * The property binding.
		 *
		 * @type {PropertyBinding}
		 */ this.binding = binding;
        /**
		 * The keyframe track value size.
		 *
		 * @type {number}
		 */ this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        /**
		 * Accumulated weight of the property binding.
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeight = 0;
        /**
		 * Accumulated additive weight of the property binding.
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeightAdditive = 0;
        /**
		 * Number of active keyframe tracks currently using this property binding.
		 *
		 * @type {number}
		 * @default 0
		 */ this.useCount = 0;
        /**
		 * Number of keyframe tracks referencing this property binding.
		 *
		 * @type {number}
		 * @default 0
		 */ this.referenceCount = 0;
    }
    /**
	 * Accumulates data in the `incoming` region into `accu<i>`.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 * @param {number} weight - The weight.
	 */ accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    /**
	 * Accumulates data in the `incoming` region into `add`.
	 *
	 * @param {number} weight - The weight.
	 */ accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    /**
	 * Applies the state of `accu<i>` to the binding when accus differ.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 */ apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    /**
	 * Remembers the state of the bound property and copy it to both accus.
	 */ saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    /**
	 * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
	 */ restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    // internals
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $ce0cdebec9150cb3$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $ce0cdebec9150cb3$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $ce0cdebec9150cb3$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $ce0cdebec9150cb3$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $ce0cdebec9150cb3$var$_reservedRe = new RegExp('[' + $ce0cdebec9150cb3$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $ce0cdebec9150cb3$var$_wordChar = '[^' + $ce0cdebec9150cb3$var$_RESERVED_CHARS_RE + ']';
const $ce0cdebec9150cb3$var$_wordCharOrDot = '[^' + $ce0cdebec9150cb3$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $ce0cdebec9150cb3$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $ce0cdebec9150cb3$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $ce0cdebec9150cb3$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $ce0cdebec9150cb3$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $ce0cdebec9150cb3$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $ce0cdebec9150cb3$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $ce0cdebec9150cb3$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $ce0cdebec9150cb3$var$_wordChar);
const $ce0cdebec9150cb3$var$_trackRe = new RegExp("^" + $ce0cdebec9150cb3$var$_directoryRe + $ce0cdebec9150cb3$var$_nodeRe + $ce0cdebec9150cb3$var$_objectRe + $ce0cdebec9150cb3$var$_propertyRe + '$');
const $ce0cdebec9150cb3$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $ce0cdebec9150cb3$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $ce0cdebec9150cb3$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
/**
 * This holds a reference to a real property in the scene graph; used internally.
 */ class $ce0cdebec9150cb3$export$7bf70fcf9f891893 {
    /**
	 * Constructs a new property binding.
	 *
	 * @param {Object} rootNode - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 */ constructor(rootNode, path, parsedPath){
        /**
		 * The object path to the animated property.
		 *
		 * @type {string}
		 */ this.path = path;
        /**
		 * An object holding information about the path.
		 *
		 * @type {Object}
		 */ this.parsedPath = parsedPath || $ce0cdebec9150cb3$export$7bf70fcf9f891893.parseTrackName(path);
        /**
		 * The object owns the animated property.
		 *
		 * @type {?Object}
		 */ this.node = $ce0cdebec9150cb3$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        /**
		 * The root node.
		 *
		 * @type {Object3D|Skeleton}
		 */ this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    /**
	 * Factory method for creating a property binding from the given parameters.
	 *
	 * @static
	 * @param {Object} root - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 * @return {PropertyBinding|Composite} The created property binding or composite.
	 */ static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $ce0cdebec9150cb3$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $ce0cdebec9150cb3$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name - Node name to be sanitized.
	 * @return {string} The sanitized node name.
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($ce0cdebec9150cb3$var$_reservedRe, '');
    }
    /**
	 * Parses the given track name (an object path to an animated property) and
	 * returns an object with information about the path. Matches strings in the following forms:
	 *
	 * - nodeName.property
	 * - nodeName.property[accessor]
	 * - nodeName.material.property[accessor]
	 * - uuid.property[accessor]
	 * - uuid.objectName[objectIndex].propertyName[propertyIndex]
	 * - parentName/nodeName.property
	 * - parentName/parentName/nodeName.property[index]
	 * - .bone[Armature.DEF_cog].position
	 * - scene:helium_balloon_model:helium_balloon_model.position
	 *
	 * @static
	 * @param {string} trackName - The track name to parse.
	 * @return {Object} The parsed track name as an object.
	 */ static parseTrackName(trackName) {
        const matches = $ce0cdebec9150cb3$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($ce0cdebec9150cb3$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    /**
	 * Searches for a node in the hierarchy of the given root object by the given
	 * node name.
	 *
	 * @static
	 * @param {Object} root - The root object.
	 * @param {string|number} nodeName - The name of the node.
	 * @return {?Object} The found node. Returns `null` if no object was found.
	 */ static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    /**
	 * Creates a getter / setter pair for the property tracked by this binding.
	 */ bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $ce0cdebec9150cb3$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    $ce0cdebec9150cb3$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    /**
	 * Unbinds the property.
	 */ unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$ce0cdebec9150cb3$export$7bf70fcf9f891893.Composite = $ce0cdebec9150cb3$var$Composite;
$ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._getValue_direct,
    $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._getValue_array,
    $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_direct,
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_array,
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $ce0cdebec9150cb3$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * - Add objects you would otherwise pass as 'root' to the
 * constructor or the .clipAction method of AnimationMixer.
 * - Instead pass this object as 'root'.
 * - You can also add and remove objects later when the mixer is running.
 *
 * Note:
 *
 * - Objects of this class appear as one object to the mixer,
 * so cache control of the individual objects must be done on the group.
 *
 * Limitation:
 *
 * - The animated properties must be compatible among the all objects in the group.
 * - A single property can either be controlled through a target group or directly, but not both.
 */ class $ce0cdebec9150cb3$export$30619c2afd3f34db {
    /**
	 * Constructs a new animation group.
	 *
	 * @param {...Object3D} arguments - An arbitrary number of 3D objects that share the same animation state.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnimationObjectGroup = true;
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $ce0cdebec9150cb3$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    /**
	 * Adds an arbitrary number of objects to this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to add.
	 */ add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $ce0cdebec9150cb3$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $ce0cdebec9150cb3$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) $ce0cdebec9150cb3$export$a3bc9b8ed74fc("AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Removes an arbitrary number of objects to this animation group
	 *
	 * @param {...Object3D} arguments - The 3D objects to remove.
	 */ remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Deallocates all memory resources for the passed 3D objects of this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to uncache.
	 */ uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $ce0cdebec9150cb3$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
/**
 * An instance of `AnimationAction` schedules the playback of an animation which is
 * stored in {@link AnimationClip}.
 */ class $ce0cdebec9150cb3$export$6946940a69e799e {
    /**
	 * Constructs a new animation action.
	 *
	 * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
	 * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
	 * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 */ constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $ce0cdebec9150cb3$export$7f795934b84ab523,
            endingEnd: $ce0cdebec9150cb3$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        /**
		 * The loop mode, set via {@link AnimationAction#setLoop}.
		 *
		 * @type {(LoopRepeat|LoopOnce|LoopPingPong)}
		 * @default LoopRepeat
		 */ this.loop = $ce0cdebec9150cb3$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        /**
		 * The local time of this action (in seconds, starting with `0`).
		 *
		 * The value gets clamped or wrapped to `[0,clip.duration]` (according to the
		 * loop state).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.time = 0;
        /**
		 * Scaling factor for the {@link AnimationAction#time}. A value of `0` causes the
		 * animation to pause. Negative values cause the animation to play backwards.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1;
        this._effectiveTimeScale = 1;
        /**
		 * The degree of influence of this action (in the interval `[0, 1]`). Values
		 * between `0` (no impact) and `1` (full impact) can be used to blend between
		 * several actions.
		 *
		 * @type {number}
		 * @default 1
		 */ this.weight = 1;
        this._effectiveWeight = 1;
        /**
		 * The number of repetitions of the performed clip over the course of this action.
		 * Can be set via {@link AnimationAction#setLoop}.
		 *
		 * Setting this number has no effect if {@link AnimationAction#loop} is set to
		 * `THREE:LoopOnce`.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.repetitions = Infinity;
        /**
		 * If set to `true`, the playback of the action is paused.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.paused = false;
        /**
		 * If set to `false`, the action is disabled so it has no impact.
		 *
		 * When the action is re-enabled, the animation continues from its current
		 * time (setting `enabled` to `false` doesn't reset the action).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to true the animation will automatically be paused on its last frame.
		 *
		 * If set to false, {@link AnimationAction#enabled} will automatically be switched
		 * to `false` when the last loop of the action has finished, so that this action has
		 * no further impact.
		 *
		 * Note: This member has no impact if the action is interrupted (it
		 * has only an effect if its last loop has really finished).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clampWhenFinished = false;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtStart = true;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtEnd = true;
    }
    /**
	 * Starts the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ play() {
        this._mixer._activateAction(this);
        return this;
    }
    /**
	 * Stops the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    /**
	 * Resets the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    /**
	 * Returns `true` if the animation is running.
	 *
	 * @return {boolean} Whether the animation is running or not.
	 */ isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    /**
	 * Returns `true` when {@link AnimationAction#play} has been called.
	 *
	 * @return {boolean} Whether the animation is scheduled or not.
	 */ isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    /**
	 * Defines the time when the animation should start.
	 *
	 * @param {number} time - The start time in seconds.
	 * @return {AnimationAction} A reference to this animation action.
	 */ startAt(time) {
        this._startTime = time;
        return this;
    }
    /**
	 * Configures the loop settings for this action.
	 *
	 * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
	 * @param {number} repetitions - The number of repetitions.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    /**
	 * Sets the effective weight of this action.
	 *
	 * An action has no effect and thus an effective weight of zero when the
	 * action is disabled.
	 *
	 * @param {number} weight - The weight to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    /**
	 * Returns the effective weight of this action.
	 *
	 * @return {number} The effective weight.
	 */ getEffectiveWeight() {
        return this._effectiveWeight;
    }
    /**
	 * Fades the animation in by increasing its weight gradually from `0` to `1`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    /**
	 * Fades the animation out by decreasing its weight gradually from `1` to `0`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    /**
	 * Causes this action to fade in and the given action to fade out,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeOutAction - The animation action to fade out.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeFrom(fadeOutAction, duration, warp = false) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp === true) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    /**
	 * Causes this action to fade out and the given action to fade in,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeInAction - The animation action to fade in.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeTo(fadeInAction, duration, warp = false) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    /**
	 * Stops any fading which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    /**
	 * Sets the effective time scale of this action.
	 *
	 * An action has no effect and thus an effective time scale of zero when the
	 * action is paused.
	 *
	 * @param {number} timeScale - The time scale to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    /**
	 * Returns the effective time scale of this action.
	 *
	 * @return {number} The effective time scale.
	 */ getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    /**
	 * Sets the duration for a single loop of this action.
	 *
	 * @param {number} duration - The duration to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    /**
	 * Synchronizes this action with the passed other action.
	 *
	 * @param {AnimationAction} action - The action to sync with.
	 * @return {AnimationAction} A reference to this animation action.
	 */ syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    /**
	 * Decelerates this animation's speed to `0` within the passed time interval.
	 *
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    /**
	 * Changes the playback speed, within the passed time interval, by modifying
	 * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
	 * `endTimeScale`.
	 *
	 * @param {number} startTimeScale - The start time scale.
	 * @param {number} endTimeScale - The end time scale.
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    /**
	 * Stops any scheduled warping which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    /**
	 * Returns the animation mixer of this animation action.
	 *
	 * @return {AnimationMixer} The animation mixer.
	 */ getMixer() {
        return this._mixer;
    }
    /**
	 * Returns the animation clip of this animation action.
	 *
	 * @return {AnimationClip} The animation clip.
	 */ getClip() {
        return this._clip;
    }
    /**
	 * Returns the root object of this animation action.
	 *
	 * @return {Object3D} The root object.
	 */ getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Internal
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $ce0cdebec9150cb3$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $ce0cdebec9150cb3$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $ce0cdebec9150cb3$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $ce0cdebec9150cb3$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $ce0cdebec9150cb3$export$24a4ccb5099273b5;
            settings.endingEnd = $ce0cdebec9150cb3$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $ce0cdebec9150cb3$export$24a4ccb5099273b5 : $ce0cdebec9150cb3$export$7f795934b84ab523;
            else settings.endingStart = $ce0cdebec9150cb3$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $ce0cdebec9150cb3$export$24a4ccb5099273b5 : $ce0cdebec9150cb3$export$7f795934b84ab523;
            else settings.endingEnd = $ce0cdebec9150cb3$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $ce0cdebec9150cb3$var$_controlInterpolantsResultBuffer = new Float32Array(1);
/**
 * `AnimationMixer` is a player for animations on a particular object in
 * the scene. When multiple objects in the scene are animated independently,
 * one `AnimationMixer` may be used for each object.
 */ class $ce0cdebec9150cb3$export$fbd77e5aefaa0102 extends $ce0cdebec9150cb3$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new animation mixer.
	 *
	 * @param {Object3D} root - The object whose animations shall be played by this mixer.
	 */ constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        /**
		 * The global mixer time (in seconds; starting with `0` on the mixer's creation).
		 *
		 * @type {number}
		 * @default 0
		 */ this.time = 0;
        /**
		 * A scaling factor for the global time.
		 *
		 * Note: Setting this member to `0` and later back to `1` is a
		 * possibility to pause/unpause all actions that are controlled by this
		 * mixer.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1.0;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $ce0cdebec9150cb3$export$dfe0af1ca1acb78a($ce0cdebec9150cb3$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $ce0cdebec9150cb3$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $ce0cdebec9150cb3$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    /**
	 * Returns an instance of {@link AnimationAction} for the passed clip.
	 *
	 * If an action fitting the clip and root parameters doesn't yet exist, it
	 * will be created by this method. Calling this method several times with the
	 * same clip and root parameters always returns the same action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 * @return {?AnimationAction} The animation action.
	 */ clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $ce0cdebec9150cb3$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $ce0cdebec9150cb3$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $ce0cdebec9150cb3$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    /**
	 * Returns an existing animation action for the passed clip.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
	 */ existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $ce0cdebec9150cb3$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    /**
	 * Deactivates all previously scheduled actions on this mixer.
	 *
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    /**
	 * Advances the global mixer time and updates the animation.
	 *
	 * This is usually done in the render loop by passing the delta
	 * time from {@link Clock} or {@link Timer}.
	 *
	 * @param {number} deltaTime - The delta time in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    /**
	 * Sets the global mixer to a specific time and updates the animation accordingly.
	 *
	 * This is useful when you need to jump to an exact time in an animation. The
	 * input parameter will be scaled by {@link AnimationMixer#timeScale}
	 *
	 * @param {number} time - The time to set in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ setTime(time) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(time); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    /**
	 * Returns this mixer's root object.
	 *
	 * @return {Object3D} The mixer's root object.
	 */ getRoot() {
        return this._root;
    }
    /**
	 * Deallocates all memory resources for a clip. Before using this method make
	 * sure to call {@link AnimationAction#stop} for all related actions.
	 *
	 * @param {AnimationClip} clip - The clip to uncache.
	 */ uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    /**
	 * Deallocates all memory resources for a root object. Before using this
	 * method make sure to call {@link AnimationAction#stop} for all related
	 * actions or alternatively {@link AnimationMixer#stopAllAction} when the
	 * mixer operates on a single root.
	 *
	 * @param {Object3D} root - The root object to uncache.
	 */ uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    /**
	 * Deallocates all memory resources for an action. The action is identified by the
	 * given clip and an optional root object. Before using this method make
	 * sure to call {@link AnimationAction#stop} to deactivate the action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 */ uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
/**
 * Represents a 3D render target.
 *
 * @augments RenderTarget
 */ class $ce0cdebec9150cb3$export$6b116d2fdfef087c extends $ce0cdebec9150cb3$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget3D = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $ce0cdebec9150cb3$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents a uniform which is a global shader variable. They are passed to shader programs.
 *
 * When declaring a uniform of a {@link ShaderMaterial}, it is declared by value or by object.
 * ```js
 * uniforms: {
 * 	time: { value: 1.0 },
 * 	resolution: new Uniform( new Vector2() )
 * };
 * ```
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 */ class $ce0cdebec9150cb3$export$2947cebfe91c02f8 {
    /**
	 * Constructs a new uniform.
	 *
	 * @param {any} value - The uniform value.
	 */ constructor(value){
        /**
		 * The uniform value.
		 *
		 * @type {any}
		 */ this.value = value;
    }
    /**
	 * Returns a new uniform with copied values from this instance.
	 * If the value has a `clone()` method, the value is cloned as well.
	 *
	 * @return {Uniform} A clone of this instance.
	 */ clone() {
        return new $ce0cdebec9150cb3$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $ce0cdebec9150cb3$var$_id = 0;
/**
 * A class for managing multiple uniforms in a single group. The renderer will process
 * such a definition as a single UBO.
 *
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 *
 * @augments EventDispatcher
 */ class $ce0cdebec9150cb3$export$c412d5ffe1f79209 extends $ce0cdebec9150cb3$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new uniforms group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformsGroup = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name UniformsGroup#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $ce0cdebec9150cb3$var$_id++
        });
        /**
		 * The name of the uniforms group.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer usage.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $ce0cdebec9150cb3$export$763e8360f4d7f77d;
        /**
		 * An array holding the uniforms.
		 *
		 * @type {Array<Uniform>}
		 */ this.uniforms = [];
    }
    /**
	 * Adds the given uniform to this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    /**
	 * Removes the given uniform from this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    /**
	 * Sets the name of this uniforms group.
	 *
	 * @param {string} name - The name to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the usage of this uniforms group.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Copies the values of the given uniforms group to this instance.
	 *
	 * @param {UniformsGroup} source - The uniforms group to copy.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    /**
	 * Returns a new uniforms group with copied values from this instance.
	 *
	 * @return {UniformsGroup} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * An instanced version of an interleaved buffer.
 *
 * @augments InterleavedBuffer
 */ class $ce0cdebec9150cb3$export$25ec0e1af1389358 extends $ce0cdebec9150cb3$export$3d5cd879f108f53f {
    /**
	 * Constructs a new instanced interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
	 */ constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedInterleavedBuffer = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated,
		 * see {@link InstancedBufferAttribute#meshPerAttribute}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
/**
 * An alternative version of a buffer attribute with more control over the VBO.
 *
 * The renderer does not construct a VBO for this kind of attribute. Instead, it uses
 * whatever VBO is passed in constructor and can later be altered via the `buffer` property.
 *
 * The most common use case for this class is when some kind of GPGPU calculation interferes
 * or even produces the VBOs in question.
 *
 * Notice that this class can only be used with {@link WebGLRenderer}.
 */ class $ce0cdebec9150cb3$export$6b7339ae8dbddf73 {
    /**
	 * Constructs a new GL buffer attribute.
	 *
	 * @param {WebGLBuffer} buffer - The native WebGL buffer.
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} itemSize - The item size.
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @param {number} count - The expected number of vertices in VBO.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(buffer, type, itemSize, elementSize, count, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGLBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The native WebGL buffer.
		 *
		 * @type {WebGLBuffer}
		 */ this.buffer = buffer;
        /**
		 * The native data type.
		 *
		 * @type {number}
		 */ this.type = type;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The corresponding size (in bytes) for the given `type` parameter.
		 *
		 * @type {number}
		 */ this.elementSize = elementSize;
        /**
		 * The expected number of vertices in VBO.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `buffer` contains data of `gl.UNSIGNED_SHORT`,
		 * and `normalized` is `true`, the values `0 - +65535` in the buffer data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the given native WebGL buffer.
	 *
	 * @param {WebGLBuffer} buffer - The buffer to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    /**
	 * Sets the given native data type and element size.
	 *
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    /**
	 * Sets the item size.
	 *
	 * @param {number} itemSize - The item size.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    /**
	 * Sets the count (the expected number of vertices in VBO).
	 *
	 * @param {number} count - The count.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setCount(count) {
        this.count = count;
        return this;
    }
}
const $ce0cdebec9150cb3$var$_matrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
/**
 * This class is designed to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3d space the mouse is over)
 * amongst other things.
 */ class $ce0cdebec9150cb3$export$8b7aaceff00bd2f {
    /**
	 * Constructs a new raycaster.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
	 * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
	 */ constructor(origin, direction, near = 0, far = Infinity){
        /**
		 * The ray used for raycasting.
		 *
		 * @type {Ray}
		 */ this.ray = new $ce0cdebec9150cb3$export$a186db52eed6d40e(origin, direction);
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default 0
		 */ this.near = near;
        /**
		 * All results returned are closer than far. Far can't be lower than near.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.far = far;
        /**
		 * The camera to use when raycasting against view-dependent objects such as
		 * billboarded objects like sprites. This field can be set manually or
		 * is set when calling `setFromCamera()`.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * Allows to selectively ignore 3D objects when performing intersection tests.
		 * The following code example ensures that only 3D objects on layer `1` will be
		 * honored by raycaster.
		 * ```js
		 * raycaster.layers.set( 1 );
		 * object.layers.enable( 1 );
		 * ```
		 *
		 * @type {Layers}
		 */ this.layers = new $ce0cdebec9150cb3$export$89312ce47c0ca777();
        /**
		 * A parameter object that configures the raycasting. It has the structure:
		 *
		 * ```
		 * {
		 * 	Mesh: {},
		 * 	Line: { threshold: 1 },
		 * 	LOD: {},
		 * 	Points: { threshold: 1 },
		 * 	Sprite: {}
		 * }
		 * ```
		 * Where `threshold` is the precision of the raycaster when intersecting objects, in world units.
		 *
		 * @type {Object}
		 */ this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    /**
	 * Updates the ray with a new origin and direction by copying the values from the arguments.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 */ set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    /**
	 * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
	 *
	 * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
	 * X and Y components should be between `-1` and `1`.
	 * @param {Camera} camera - The camera from which the ray should originate.
	 */ setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else $ce0cdebec9150cb3$export$a3bc9b8ed74fc('Raycaster: Unsupported camera type: ' + camera.type);
    }
    /**
	 * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
	 *
	 * @param {WebXRController} controller - The controller to copy the position and direction from.
	 * @return {Raycaster} A reference to this raycaster.
	 */ setFromXRController(controller) {
        $ce0cdebec9150cb3$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($ce0cdebec9150cb3$var$_matrix);
        return this;
    }
    /**
	 * The intersection point of a raycaster intersection test.
	 * @typedef {Object} Raycaster~Intersection
	 * @property {number} distance - The distance from the ray's origin to the intersection point.
	 * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
	 * intersection to the nearest point on the ray. For other objects it will be `undefined`.
	 * @property {Vector3} point - The intersection point, in world coordinates.
	 * @property {Object} face - The face that has been intersected.
	 * @property {number} faceIndex - The face index.
	 * @property {Object3D} object - The 3D object that has been intersected.
	 * @property {Vector2} uv - U,V coordinates at point of intersection.
	 * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
	 * @property {Vector3} normal - Interpolated normal vector at point of intersection.
	 * @property {number} instanceId - The index number of the instance where the ray
	 * intersects the {@link InstancedMesh}.
	 */ /**
	 * Checks all intersection between the ray and the object with or without the
	 * descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
	 * evaluating whether the ray intersects the object or not. This allows meshes to respond
	 * differently to ray casting than lines or points.
	 *
	 * Note that for meshes, faces must be pointed towards the origin of the ray in order
	 * to be detected; intersections of the ray passing through the back of a face will not
	 * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
	 * to `THREE.DoubleSide`.
	 *
	 * @param {Object3D} object - The 3D object to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObject(object, recursive = true, intersects = []) {
        $ce0cdebec9150cb3$var$intersect(object, this, intersects, recursive);
        intersects.sort($ce0cdebec9150cb3$var$ascSort);
        return intersects;
    }
    /**
	 * Checks all intersection between the ray and the objects with or without
	 * the descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$ce0cdebec9150cb3$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($ce0cdebec9150cb3$var$ascSort);
        return intersects;
    }
}
function $ce0cdebec9150cb3$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $ce0cdebec9150cb3$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$ce0cdebec9150cb3$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * Class for keeping track of time.
 *
 * @deprecated since r183.
 */ class $ce0cdebec9150cb3$export$9735c82c4bae3302 {
    /**
	 * Constructs a new clock.
	 *
	 * @deprecated since 183.
	 * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
	 * `getDelta()` is called for the first time.
	 */ constructor(autoStart = true){
        /**
		 * If set to `true`, the clock starts automatically when `getDelta()` is called
		 * for the first time.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoStart = autoStart;
        /**
		 * Holds the time at which the clock's `start()` method was last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.startTime = 0;
        /**
		 * Holds the time at which the clock's `start()`, `getElapsedTime()` or
		 * `getDelta()` methods were last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.oldTime = 0;
        /**
		 * Keeps track of the total time that the clock has been running.
		 *
		 * @type {number}
		 * @default 0
		 */ this.elapsedTime = 0;
        /**
		 * Whether the clock is running or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.running = false;
        $ce0cdebec9150cb3$export$c106dd0671a0fc2d('THREE.Clock: This module has been deprecated. Please use THREE.Timer instead.'); // @deprecated, r183
    }
    /**
	 * Starts the clock. When `autoStart` is set to `true`, the method is automatically
	 * called by the class.
	 */ start() {
        this.startTime = performance.now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    /**
	 * Stops the clock.
	 */ stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time.
	 */ getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    /**
	 * Returns the delta time in seconds.
	 *
	 * @return {number} The delta time.
	 */ getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = performance.now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Spherical coordinates](https://en.wikipedia.org/wiki/Spherical_coordinate_system).
 */ class $ce0cdebec9150cb3$export$d712cd887b4a00f7 {
    /**
	 * Constructs a new spherical.
	 *
	 * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
	 * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
	 * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
	 */ constructor(radius = 1, phi = 0, theta = 0){
        /**
		 * The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * The polar angle in radians from the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.phi = phi;
        /**
		 * The equator/azimuthal angle in radians around the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
    }
    /**
	 * Sets the spherical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The polar angle.
	 * @param {number} theta - The azimuthal angle.
	 * @return {Spherical} A reference to this spherical.
	 */ set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    /**
	 * Copies the values of the given spherical to this instance.
	 *
	 * @param {Spherical} other - The spherical to copy.
	 * @return {Spherical} A reference to this spherical.
	 */ copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    /**
	 * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
	 * `0.000001`.
	 *
	 * @return {Spherical} A reference to this spherical.
	 */ makeSafe() {
        const EPS = 0.000001;
        this.phi = $ce0cdebec9150cb3$var$clamp(this.phi, EPS, Math.PI - EPS);
        return this;
    }
    /**
	 * Sets the spherical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the spherical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The y value.
	 * @param {number} z - The z value.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($ce0cdebec9150cb3$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    /**
	 * Returns a new spherical with copied values from this instance.
	 *
	 * @return {Spherical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Cylindrical coordinates](https://en.wikipedia.org/wiki/Cylindrical_coordinate_system).
 */ class $ce0cdebec9150cb3$export$287165bb2177f4fd {
    /**
	 * Constructs a new cylindrical.
	 *
	 * @param {number} [radius=1] - The distance from the origin to a point in the x-z plane.
	 * @param {number} [theta=0] - A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
	 * @param {number} [y=0] - The height above the x-z plane.
	 */ constructor(radius = 1, theta = 0, y = 0){
        /**
		 * The distance from the origin to a point in the x-z plane.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
        /**
		 * The height above the x-z plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.y = y;
    }
    /**
	 * Sets the cylindrical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle.
	 * @param {number} y - The height value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    /**
	 * Copies the values of the given cylindrical to this instance.
	 *
	 * @param {Cylindrical} other - The cylindrical to copy.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    /**
	 * Sets the cylindrical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the cylindrical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    /**
	 * Returns a new cylindrical with copied values from this instance.
	 *
	 * @return {Cylindrical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 2x2 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix2#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix2#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix2();
 * m.set( 11, 12,
 *        21, 22 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21,
 *                12, 22 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $ce0cdebec9150cb3$export$cbcc6560bf79fb38 {
    /**
	 * Constructs a new 2x2 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 */ constructor(n11, n12, n21, n22){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $ce0cdebec9150cb3$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    /**
	 * Sets this matrix to the 2x2 identity matrix.
	 *
	 * @return {Matrix2} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix2} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} n11 - 1-1 matrix element.
	 * @param {number} n12 - 1-2 matrix element.
	 * @param {number} n21 - 2-1 matrix element.
	 * @param {number} n22 - 2-2 matrix element.
	 * @return {Matrix2} A reference to this matrix.
	 */ set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $ce0cdebec9150cb3$var$_vector$4 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
/**
 * Represents an axis-aligned bounding box (AABB) in 2D space.
 */ class $ce0cdebec9150cb3$export$60f553fa130f08b0 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector2} [min=(Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector2} [max=(-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(Infinity, Infinity), max = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox2 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector2} min - The lower boundary of the box.
	 * @param {Vector2} max - The upper boundary of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector2>} points - An array holding 2D position data as instances of {@link Vector2}.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector2} center - The center of the box.
	 * @param {Vector2} size - The x and y dimensions of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $ce0cdebec9150cb3$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box2} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box2} box - The box to copy.
	 * @return {Box2} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 2D.
	 *
	 * @return {Box2} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector2} point - The point that should be included by the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions.
	 *
	 * @param {Vector2} vector - The vector that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector2} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    /**
	 * Returns a point as a proportion of this box's width and height.
	 *
	 * @param {Vector2} point - A point in 2D space.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} A point as a proportion of this box's width and height.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector2} point - The point to clamp.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector2} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $ce0cdebec9150cb3$var$_vector$4).distanceTo(point);
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box2} box - The bounding box to intersect with.
	 * @return {Box2} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box2} box - The bounding box that will be unioned with this instance.
	 * @return {Box2} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 2D space.
	 *
	 * @param {Vector2} offset - The offset that should be used to translate the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box2} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $ce0cdebec9150cb3$var$_startP = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_startEnd = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_d1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_d2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_r = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_c1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_c2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * An analytical line segment in 3D space represented by a start and end point.
 */ class $ce0cdebec9150cb3$export$e0ba6359f1954fd3 {
    /**
	 * Constructs a new line segment.
	 *
	 * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
	 * @param {Vector3} [end=(0,0,0)] - End of the line segment.
	 */ constructor(start = new $ce0cdebec9150cb3$export$64b5c384219d3699(), end = new $ce0cdebec9150cb3$export$64b5c384219d3699()){
        /**
		 * Start of the line segment.
		 *
		 * @type {Vector3}
		 */ this.start = start;
        /**
		 * End of the line segment.
		 *
		 * @type {Vector3}
		 */ this.end = end;
    }
    /**
	 * Sets the start and end values by copying the given vectors.
	 *
	 * @param {Vector3} start - The start point.
	 * @param {Vector3} end - The end point.
	 * @return {Line3} A reference to this line segment.
	 */ set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    /**
	 * Copies the values of the given line segment to this instance.
	 *
	 * @param {Line3} line - The line segment to copy.
	 * @return {Line3} A reference to this line segment.
	 */ copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    /**
	 * Returns the center of the line segment.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    /**
	 * Returns the delta vector of the line segment's start and end point.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ delta(target) {
        return target.subVectors(this.end, this.start);
    }
    /**
	 * Returns the squared Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The squared Euclidean distance.
	 */ distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    /**
	 * Returns the Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The Euclidean distance.
	 */ distance() {
        return this.start.distanceTo(this.end);
    }
    /**
	 * Returns a vector at a certain position along the line segment.
	 *
	 * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns a point parameter based on the closest point as projected on the line segment.
	 *
	 * @param {Vector3} point - The point for which to return a point parameter.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @return {number} The point parameter.
	 */ closestPointToPointParameter(point, clampToLine) {
        $ce0cdebec9150cb3$var$_startP.subVectors(point, this.start);
        $ce0cdebec9150cb3$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $ce0cdebec9150cb3$var$_startEnd.dot($ce0cdebec9150cb3$var$_startEnd);
        const startEnd_startP = $ce0cdebec9150cb3$var$_startEnd.dot($ce0cdebec9150cb3$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $ce0cdebec9150cb3$var$clamp(t, 0, 1);
        return t;
    }
    /**
	 * Returns the closest point on the line for a given point.
	 *
	 * @param {Vector3} point - The point to compute the closest point on the line for.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the line.
	 */ closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns the closest squared distance between this line segment and the given one.
	 *
	 * @param {Line3} line - The line segment to compute the closest squared distance to.
	 * @param {Vector3} [c1] - The closest point on this line segment.
	 * @param {Vector3} [c2] - The closest point on the given line segment.
	 * @return {number} The squared distance between this line segment and the given one.
	 */ distanceSqToLine3(line, c1 = $ce0cdebec9150cb3$var$_c1, c2 = $ce0cdebec9150cb3$var$_c2) {
        // from Real-Time Collision Detection by Christer Ericson, chapter 5.1.9
        // Computes closest points C1 and C2 of S1(s)=P1+s*(Q1-P1) and
        // S2(t)=P2+t*(Q2-P2), returning s and t. Function result is squared
        // distance between between S1(s) and S2(t)
        const EPSILON = 1e-8 * 1e-8; // must be squared since we compare squared length
        let s, t;
        const p1 = this.start;
        const p2 = line.start;
        const q1 = this.end;
        const q2 = line.end;
        $ce0cdebec9150cb3$var$_d1.subVectors(q1, p1); // Direction vector of segment S1
        $ce0cdebec9150cb3$var$_d2.subVectors(q2, p2); // Direction vector of segment S2
        $ce0cdebec9150cb3$var$_r.subVectors(p1, p2);
        const a = $ce0cdebec9150cb3$var$_d1.dot($ce0cdebec9150cb3$var$_d1); // Squared length of segment S1, always nonnegative
        const e = $ce0cdebec9150cb3$var$_d2.dot($ce0cdebec9150cb3$var$_d2); // Squared length of segment S2, always nonnegative
        const f = $ce0cdebec9150cb3$var$_d2.dot($ce0cdebec9150cb3$var$_r);
        // Check if either or both segments degenerate into points
        if (a <= EPSILON && e <= EPSILON) {
            // Both segments degenerate into points
            c1.copy(p1);
            c2.copy(p2);
            c1.sub(c2);
            return c1.dot(c1);
        }
        if (a <= EPSILON) {
            // First segment degenerates into a point
            s = 0;
            t = f / e; // s = 0 => t = (b*s + f) / e = f / e
            t = $ce0cdebec9150cb3$var$clamp(t, 0, 1);
        } else {
            const c = $ce0cdebec9150cb3$var$_d1.dot($ce0cdebec9150cb3$var$_r);
            if (e <= EPSILON) {
                // Second segment degenerates into a point
                t = 0;
                s = $ce0cdebec9150cb3$var$clamp(-c / a, 0, 1); // t = 0 => s = (b*t - c) / a = -c / a
            } else {
                // The general nondegenerate case starts here
                const b = $ce0cdebec9150cb3$var$_d1.dot($ce0cdebec9150cb3$var$_d2);
                const denom = a * e - b * b; // Always nonnegative
                // If segments not parallel, compute closest point on L1 to L2 and
                // clamp to segment S1. Else pick arbitrary s (here 0)
                if (denom !== 0) s = $ce0cdebec9150cb3$var$clamp((b * f - c * e) / denom, 0, 1);
                else s = 0;
                // Compute point on L2 closest to S1(s) using
                // t = Dot((P1 + D1*s) - P2,D2) / Dot(D2,D2) = (b*s + f) / e
                t = (b * s + f) / e;
                // If t in [0,1] done. Else clamp t, recompute s for the new value
                // of t using s = Dot((P2 + D2*t) - P1,D1) / Dot(D1,D1)= (t*b - c) / a
                // and clamp s to [0, 1]
                if (t < 0) {
                    t = 0.;
                    s = $ce0cdebec9150cb3$var$clamp(-c / a, 0, 1);
                } else if (t > 1) {
                    t = 1;
                    s = $ce0cdebec9150cb3$var$clamp((b - c) / a, 0, 1);
                }
            }
        }
        c1.copy(p1).addScaledVector($ce0cdebec9150cb3$var$_d1, s);
        c2.copy(p2).addScaledVector($ce0cdebec9150cb3$var$_d2, t);
        return c1.distanceToSquared(c2);
    }
    /**
	 * Applies a 4x4 transformation matrix to this line segment.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Line3} A reference to this line segment.
	 */ applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    /**
	 * Returns `true` if this line segment is equal with the given one.
	 *
	 * @param {Line3} line - The line segment to test for equality.
	 * @return {boolean} Whether this line segment is equal with the given one.
	 */ equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    /**
	 * Returns a new line segment with copied values from this instance.
	 *
	 * @return {Line3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $ce0cdebec9150cb3$var$_vector$3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * This displays a cone shaped helper object for a {@link SpotLight}.
 *
 * When the spot light or its target are transformed or light properties are
 * changed, it's necessary to call the `update()` method of the respective helper.
 *
 * ```js
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 10, 10, 10 );
 * scene.add( spotLight );
 *
 * const spotLightHelper = new THREE.SpotLightHelper( spotLight );
 * scene.add( spotLightHelper );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$4b14638ffdd81e68 extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new spot light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {SpotLight}
		 */ this.light = light;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(positions, 3));
        const material = new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $ce0cdebec9150cb3$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $ce0cdebec9150cb3$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($ce0cdebec9150cb3$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $ce0cdebec9150cb3$var$_vector$2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_boneMatrix = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
const $ce0cdebec9150cb3$var$_matrixWorldInv = /*@__PURE__*/ new $ce0cdebec9150cb3$export$2ae72fc923e5eb5();
/**
 * A helper object to assist with visualizing a {@link Skeleton}.
 *
 * ```js
 * const helper = new THREE.SkeletonHelper( skinnedMesh );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $ce0cdebec9150cb3$export$5277df3c9e732259 extends $ce0cdebec9150cb3$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new skeleton helper.
	 *
	 * @param {Object3D} object -  Usually an instance of {@link SkinnedMesh}. However, any 3D object
	 * can be used if it represents a hierarchy of bones (see {@link Bone}).
	 */ constructor(object){
        const bones = $ce0cdebec9150cb3$var$getBoneList(object);
        const geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(0, 0, 0);
                colors.push(0, 0, 0);
            }
        }
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(colors, 3));
        const material = new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        /**
		 * The object being visualized.
		 *
		 * @type {Object3D}
		 */ this.root = object;
        /**
		 * The list of bones that the helper visualizes.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
        // colors
        const color1 = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x0000ff);
        const color2 = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x00ff00);
        this.setColors(color1, color2);
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $ce0cdebec9150cb3$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $ce0cdebec9150cb3$var$_boneMatrix.multiplyMatrices($ce0cdebec9150cb3$var$_matrixWorldInv, bone.matrixWorld);
                $ce0cdebec9150cb3$var$_vector$2.setFromMatrixPosition($ce0cdebec9150cb3$var$_boneMatrix);
                position.setXYZ(j, $ce0cdebec9150cb3$var$_vector$2.x, $ce0cdebec9150cb3$var$_vector$2.y, $ce0cdebec9150cb3$var$_vector$2.z);
                $ce0cdebec9150cb3$var$_boneMatrix.multiplyMatrices($ce0cdebec9150cb3$var$_matrixWorldInv, bone.parent.matrixWorld);
                $ce0cdebec9150cb3$var$_vector$2.setFromMatrixPosition($ce0cdebec9150cb3$var$_boneMatrix);
                position.setXYZ(j + 1, $ce0cdebec9150cb3$var$_vector$2.x, $ce0cdebec9150cb3$var$_vector$2.y, $ce0cdebec9150cb3$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} color1 - The first line color for each bone.
	 * @param {Color} color2 - The second line color for each bone.
	 * @return {SkeletonHelper} A reference to this helper.
	 */ setColors(color1, color2) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        for(let i = 0; i < colorAttribute.count; i += 2){
            colorAttribute.setXYZ(i, color1.r, color1.g, color1.b);
            colorAttribute.setXYZ(i + 1, color2.r, color2.g, color2.b);
        }
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $ce0cdebec9150cb3$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push(...$ce0cdebec9150cb3$var$getBoneList(object.children[i]));
    return boneList;
}
/**
 * This displays a helper object consisting of a spherical mesh for
 * visualizing an instance of {@link PointLight}.
 *
 * ```js
 * const pointLight = new THREE.PointLight( 0xff0000, 1, 100 );
 * pointLight.position.set( 10, 10, 10 );
 * scene.add( pointLight );
 *
 * const sphereSize = 1;
 * const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
 * scene.add( pointLightHelper );
 * ```
 *
 * @augments Mesh
 */ class $ce0cdebec9150cb3$export$9a9291685b9e4023 extends $ce0cdebec9150cb3$export$e176487c05830cc5 {
    /**
	 * Constructs a new point light helper.
	 *
	 * @param {PointLight} light - The light to be visualized.
	 * @param {number} [sphereSize=1] - The size of the sphere helper.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, sphereSize, color){
        const geometry = new $ce0cdebec9150cb3$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $ce0cdebec9150cb3$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        /**
		 * The light being visualized.
		 *
		 * @type {PointLight}
		 */ this.light = light;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Updates the helper to match the position of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $ce0cdebec9150cb3$var$_vector$1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_color1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$892596cec99bc70e();
const $ce0cdebec9150cb3$var$_color2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$892596cec99bc70e();
/**
 * Creates a visual aid consisting of a spherical mesh for a
 * given {@link HemisphereLight}.
 *
 * When the hemisphere light is transformed or its light properties are changed,
 * it's necessary to call the `update()` method of the respective helper.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * const helper = new THREE.HemisphereLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$8dca15f13f4f8172 extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number} [size=1] - The size of the mesh used to visualize the light.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $ce0cdebec9150cb3$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $ce0cdebec9150cb3$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $ce0cdebec9150cb3$export$8dea267bd6bde117(colors, 3));
        this.add(new $ce0cdebec9150cb3$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $ce0cdebec9150cb3$var$_color1.copy(this.light.color);
            $ce0cdebec9150cb3$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $ce0cdebec9150cb3$var$_color1 : $ce0cdebec9150cb3$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($ce0cdebec9150cb3$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
/**
 * The helper is an object to define grids. Grids are two-dimensional
 * arrays of lines.
 *
 * ```js
 * const size = 10;
 * const divisions = 10;
 *
 * const gridHelper = new THREE.GridHelper( size, divisions );
 * scene.add( gridHelper );
 * ```
 *
 * @augments LineSegments
 */ class $ce0cdebec9150cb3$export$3875d39926561055 extends $ce0cdebec9150cb3$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new grid helper.
	 *
	 * @param {number} [size=10] - The size of the grid.
	 * @param {number} [divisions=10] - The number of divisions across the grid.
	 * @param {number|Color|string} [color1=0x444444] - The color of the center line.
	 * @param {number|Color|string} [color2=0x888888] - The color of the lines of the grid.
	 */ constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $ce0cdebec9150cb3$export$892596cec99bc70e(color1);
        color2 = new $ce0cdebec9150cb3$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(colors, 3));
        const material = new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This helper is an object to define polar grids. Grids are
 * two-dimensional arrays of lines.
 *
 * ```js
 * const radius = 10;
 * const sectors = 16;
 * const rings = 8;
 * const divisions = 64;
 *
 * const helper = new THREE.PolarGridHelper( radius, sectors, rings, divisions );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $ce0cdebec9150cb3$export$361430a10f533cd3 extends $ce0cdebec9150cb3$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new polar grid helper.
	 *
	 * @param {number} [radius=10] - The radius of the polar grid. This can be any positive number.
	 * @param {number} [sectors=16] - The number of sectors the grid will be divided into. This can be any positive integer.
	 * @param {number} [rings=16] - The number of rings. This can be any positive integer.
	 * @param {number} [divisions=64] - The number of line segments used for each circle. This can be any positive integer.
	 * @param {number|Color|string} [color1=0x444444] - The first color used for grid elements.
	 * @param {number|Color|string} [color2=0x888888] -  The second color used for grid elements.
	 */ constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $ce0cdebec9150cb3$export$892596cec99bc70e(color1);
        color2 = new $ce0cdebec9150cb3$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(colors, 3));
        const material = new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $ce0cdebec9150cb3$var$_v1 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v2 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_v3 = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
/**
 * Helper object to assist with visualizing a {@link DirectionalLight}'s
 * effect on the scene. This consists of a plane and a line representing the
 * light's position and direction.
 *
 * When the directional light or its target are transformed or light properties
 * are changed, it's necessary to call the `update()` method of the respective helper.
 *
 * ```js
 * const light = new THREE.DirectionalLight( 0xFFFFFF );
 * scene.add( light );
 *
 * const helper = new THREE.DirectionalLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$f8e434dc14203e7d extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new directional light helper.
	 *
	 * @param {DirectionalLight} light - The light to be visualized.
	 * @param {number} [size=1] - The dimensions of the plane.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {DirectionalLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        /**
		 * Contains the line showing the location of the directional light.
		 *
		 * @type {Line}
		 */ this.lightPlane = new $ce0cdebec9150cb3$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        /**
		 * Represents the target line of the directional light.
		 *
		 * @type {Line}
		 */ this.targetLine = new $ce0cdebec9150cb3$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $ce0cdebec9150cb3$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $ce0cdebec9150cb3$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $ce0cdebec9150cb3$var$_v3.subVectors($ce0cdebec9150cb3$var$_v2, $ce0cdebec9150cb3$var$_v1);
        this.lightPlane.lookAt($ce0cdebec9150cb3$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($ce0cdebec9150cb3$var$_v2);
        this.targetLine.scale.z = $ce0cdebec9150cb3$var$_v3.length();
    }
}
const $ce0cdebec9150cb3$var$_vector = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
const $ce0cdebec9150cb3$var$_camera = /*@__PURE__*/ new $ce0cdebec9150cb3$export$79f141de891a5fed();
/**
 * This helps with visualizing what a camera contains in its frustum. It
 * visualizes the frustum of a camera using a line segments.
 *
 * Based on frustum visualization in [lightgl.js shadowmap example](https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html).
 *
 * `CameraHelper` must be a child of the scene.
 *
 * When the camera is transformed or its projection matrix is changed, it's necessary
 * to call the `update()` method of the respective helper.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
 * const helper = new THREE.CameraHelper( camera );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $ce0cdebec9150cb3$export$ed8e93f853cd795 extends $ce0cdebec9150cb3$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Camera} camera - The camera to visualize.
	 */ constructor(camera){
        const geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        const material = new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        /**
		 * The camera being visualized.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * This contains the points used to visualize the camera.
		 *
		 * @type {Object<string,Array<number>>}
		 */ this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xff0000);
        const colorUp = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $ce0cdebec9150cb3$export$892596cec99bc70e(0xffffff);
        const colorCross = new $ce0cdebec9150cb3$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} frustum - The frustum line color.
	 * @param {Color} cone - The cone line color.
	 * @param {Color} up - The up line color.
	 * @param {Color} target - The target line color.
	 * @param {Color} cross - The cross line color.
	 * @return {CameraHelper} A reference to this helper.
	 */ setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Updates the helper based on the projection matrix of the camera.
	 */ update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        let nearZ, farZ;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $ce0cdebec9150cb3$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // Adjust z values based on coordinate system
        if (this.camera.reversedDepth === true) {
            nearZ = 1;
            farZ = 0;
        } else {
            if (this.camera.coordinateSystem === $ce0cdebec9150cb3$export$5a0e9190d10875d3) {
                nearZ = -1;
                farZ = 1;
            } else if (this.camera.coordinateSystem === $ce0cdebec9150cb3$export$cc83beedcb9be9ac) {
                nearZ = 0;
                farZ = 1;
            } else throw new Error('THREE.CameraHelper.update(): Invalid coordinate system: ' + this.camera.coordinateSystem);
        }
        // center / target
        $ce0cdebec9150cb3$var$setPoint('c', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, 0, 0, nearZ);
        $ce0cdebec9150cb3$var$setPoint('t', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, 0, 0, farZ);
        // near
        $ce0cdebec9150cb3$var$setPoint('n1', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, -w, -h, nearZ);
        $ce0cdebec9150cb3$var$setPoint('n2', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, w, -h, nearZ);
        $ce0cdebec9150cb3$var$setPoint('n3', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, -w, h, nearZ);
        $ce0cdebec9150cb3$var$setPoint('n4', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, w, h, nearZ);
        // far
        $ce0cdebec9150cb3$var$setPoint('f1', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, -w, -h, farZ);
        $ce0cdebec9150cb3$var$setPoint('f2', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, w, -h, farZ);
        $ce0cdebec9150cb3$var$setPoint('f3', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, -w, h, farZ);
        $ce0cdebec9150cb3$var$setPoint('f4', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, w, h, farZ);
        // up
        $ce0cdebec9150cb3$var$setPoint('u1', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, w * 0.7, h * 1.1, nearZ);
        $ce0cdebec9150cb3$var$setPoint('u2', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, -w * 0.7, h * 1.1, nearZ);
        $ce0cdebec9150cb3$var$setPoint('u3', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, 0, h * 2, nearZ);
        // cross
        $ce0cdebec9150cb3$var$setPoint('cf1', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, -w, 0, farZ);
        $ce0cdebec9150cb3$var$setPoint('cf2', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, w, 0, farZ);
        $ce0cdebec9150cb3$var$setPoint('cf3', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, 0, -h, farZ);
        $ce0cdebec9150cb3$var$setPoint('cf4', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, 0, h, farZ);
        $ce0cdebec9150cb3$var$setPoint('cn1', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, -w, 0, nearZ);
        $ce0cdebec9150cb3$var$setPoint('cn2', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, w, 0, nearZ);
        $ce0cdebec9150cb3$var$setPoint('cn3', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, 0, -h, nearZ);
        $ce0cdebec9150cb3$var$setPoint('cn4', pointMap, geometry, $ce0cdebec9150cb3$var$_camera, 0, h, nearZ);
        geometry.getAttribute('position').needsUpdate = true;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $ce0cdebec9150cb3$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $ce0cdebec9150cb3$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $ce0cdebec9150cb3$var$_vector.x, $ce0cdebec9150cb3$var$_vector.y, $ce0cdebec9150cb3$var$_vector.z);
    }
}
const $ce0cdebec9150cb3$var$_box = /*@__PURE__*/ new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3();
/**
 * Helper object to graphically show the world-axis-aligned bounding box
 * around an object. The actual bounding box is handled with {@link Box3},
 * this is just a visual helper for debugging. It can be automatically
 * resized with {@link BoxHelper#update} when the object it's created from
 * is transformed. Note that the object must have a geometry for this to work,
 * so it won't work with sprites.
 *
 * ```js
 * const sphere = new THREE.SphereGeometry();
 * const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
 * const box = new THREE.BoxHelper( object, 0xffff00 );
 * scene.add( box );
 * ```
 *
 * @augments LineSegments
 */ class $ce0cdebec9150cb3$export$38a664cc862a6a9d extends $ce0cdebec9150cb3$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box helper.
	 *
	 * @param {Object3D} [object] - The 3D object to show the world-axis-aligned bounding box.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        geometry.setIndex(new $ce0cdebec9150cb3$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The 3D object being visualized.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    /**
	 * Updates the helper's geometry to match the dimensions of the object,
	 * including any children.
	 */ update() {
        if (this.object !== undefined) $ce0cdebec9150cb3$var$_box.setFromObject(this.object);
        if ($ce0cdebec9150cb3$var$_box.isEmpty()) return;
        const min = $ce0cdebec9150cb3$var$_box.min;
        const max = $ce0cdebec9150cb3$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    /**
	 * Updates the wireframe box for the passed object.
	 *
	 * @param {Object3D} object - The 3D object to create the helper for.
	 * @return {BoxHelper} A reference to this instance.
	 */ setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Box3}.
 *
 * ```js
 * const box = new THREE.Box3();
 * box.setFromCenterAndSize( new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 2, 1, 3 ) );
 *
 * const helper = new THREE.Box3Helper( box, 0xffff00 );
 * scene.add( helper )
 * ```
 *
 * @augments LineSegments
 */ class $ce0cdebec9150cb3$export$ce39f4bb96c9a290 extends $ce0cdebec9150cb3$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box3 helper.
	 *
	 * @param {Box3} box - The box to visualize.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        geometry.setIndex(new $ce0cdebec9150cb3$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The box being visualized.
		 *
		 * @type {Box3}
		 */ this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Plane}.
 *
 * ```js
 * const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 3 );
 * const helper = new THREE.PlaneHelper( plane, 1, 0xffff00 );
 * scene.add( helper );
 * ```
 *
 * @augments Line
 */ class $ce0cdebec9150cb3$export$a34fe8156c66e5d7 extends $ce0cdebec9150cb3$export$17d680238e50603e {
    /**
	 * Constructs a new plane helper.
	 *
	 * @param {Plane} plane - The plane to be visualized.
	 * @param {number} [size=1] - The side length of plane helper.
	 * @param {number|Color|string} [hex=0xffff00] - The helper's color.
	 */ constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        /**
		 * The plane being visualized.
		 *
		 * @type {Plane}
		 */ this.plane = plane;
        /**
		 * The side length of plane helper.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $ce0cdebec9150cb3$export$e176487c05830cc5(geometry2, new $ce0cdebec9150cb3$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $ce0cdebec9150cb3$var$_axis = /*@__PURE__*/ new $ce0cdebec9150cb3$export$64b5c384219d3699();
let $ce0cdebec9150cb3$var$_lineGeometry, $ce0cdebec9150cb3$var$_coneGeometry;
/**
 * An 3D arrow object for visualizing directions.
 *
 * ```js
 * const dir = new THREE.Vector3( 1, 2, 0 );
 *
 * //normalize the direction vector (convert to vector of length 1)
 * dir.normalize();
 *
 * const origin = new THREE.Vector3( 0, 0, 0 );
 * const length = 1;
 * const hex = 0xffff00;
 *
 * const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );
 * scene.add( arrowHelper );
 * ```
 *
 * @augments Object3D
 */ class $ce0cdebec9150cb3$export$a3008e7bd8d2cbe7 extends $ce0cdebec9150cb3$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Vector3} [dir=(0, 0, 1)] - The (normalized) direction vector.
	 * @param {Vector3} [origin=(0, 0, 0)] - Point at which the arrow starts.
	 * @param {number} [length=1] - Length of the arrow in world units.
	 * @param {(number|Color|string)} [color=0xffff00] - Color of the arrow.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ constructor(dir = new $ce0cdebec9150cb3$export$64b5c384219d3699(0, 0, 1), origin = new $ce0cdebec9150cb3$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($ce0cdebec9150cb3$var$_lineGeometry === undefined) {
            $ce0cdebec9150cb3$var$_lineGeometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
            $ce0cdebec9150cb3$var$_lineGeometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $ce0cdebec9150cb3$var$_coneGeometry = new $ce0cdebec9150cb3$export$a7a48974f285c9b3(0.5, 1, 5, 1);
            $ce0cdebec9150cb3$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        /**
		 * The line part of the arrow helper.
		 *
		 * @type {Line}
		 */ this.line = new $ce0cdebec9150cb3$export$17d680238e50603e($ce0cdebec9150cb3$var$_lineGeometry, new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        /**
		 * The cone part of the arrow helper.
		 *
		 * @type {Mesh}
		 */ this.cone = new $ce0cdebec9150cb3$export$e176487c05830cc5($ce0cdebec9150cb3$var$_coneGeometry, new $ce0cdebec9150cb3$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    /**
	 * Sets the direction of the helper.
	 *
	 * @param {Vector3} dir - The normalized direction vector.
	 */ setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $ce0cdebec9150cb3$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($ce0cdebec9150cb3$var$_axis, radians);
        }
    }
    /**
	 * Sets the length of the helper.
	 *
	 * @param {number} length - Length of the arrow in world units.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    /**
	 * Sets the color of the helper.
	 *
	 * @param {number|Color|string} color - The color to set.
	 */ setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
/**
 * An axis object to visualize the 3 axes in a simple way.
 * The X axis is red. The Y axis is green. The Z axis is blue.
 *
 * ```js
 * const axesHelper = new THREE.AxesHelper( 5 );
 * scene.add( axesHelper );
 * ```
 *
 * @augments LineSegments
 */ class $ce0cdebec9150cb3$export$6c8303f35b8578fd extends $ce0cdebec9150cb3$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new axes helper.
	 *
	 * @param {number} [size=1] - Size of the lines representing the axes.
	 */ constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $ce0cdebec9150cb3$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ce0cdebec9150cb3$export$cbe7a62641830ebd(colors, 3));
        const material = new $ce0cdebec9150cb3$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    /**
	 * Defines the colors of the axes helper.
	 *
	 * @param {number|Color|string} xAxisColor - The color for the x axis.
	 * @param {number|Color|string} yAxisColor - The color for the y axis.
	 * @param {number|Color|string} zAxisColor - The color for the z axis.
	 * @return {AxesHelper} A reference to this axes helper.
	 */ setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $ce0cdebec9150cb3$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This class is used to convert a series of paths to an array of
 * shapes. It is specifically used in context of fonts and SVG.
 */ class $ce0cdebec9150cb3$export$148534a3c727230b {
    /**
	 * Constructs a new shape path.
	 */ constructor(){
        this.type = 'ShapePath';
        /**
		 * The color of the shape.
		 *
		 * @type {Color}
		 */ this.color = new $ce0cdebec9150cb3$export$892596cec99bc70e();
        /**
		 * The paths that have been generated for this shape.
		 *
		 * @type {Array<Path>}
		 * @default null
		 */ this.subPaths = [];
        /**
		 * The current path that is being generated.
		 *
		 * @type {?Path}
		 * @default null
		 */ this.currentPath = null;
    }
    /**
	 * Creates a new path and moves it current point to the given one.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {ShapePath} A reference to this shape path.
	 */ moveTo(x, y) {
        this.currentPath = new $ce0cdebec9150cb3$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {ShapePath} A reference to this shape path.
	 */ splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    /**
	 * Converts the paths into an array of shapes.
	 *
	 * @param {boolean} isCCW - By default solid shapes are  defined clockwise (CW) and holes are defined counterclockwise (CCW).
	 * If this flag is set to `true`, then those are flipped.
	 * @return {Array<Shape>} An array of shapes.
	 */ toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $ce0cdebec9150cb3$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $ce0cdebec9150cb3$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $ce0cdebec9150cb3$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $ce0cdebec9150cb3$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //log("shape", shapes);
        return shapes;
    }
}
/**
 * Abstract base class for controls.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $ce0cdebec9150cb3$export$c7c44baae9d9f25f extends $ce0cdebec9150cb3$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super();
        /**
		 * The object that is managed by the controls.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The HTML element used for event listeners.
		 *
		 * @type {?HTMLElement}
		 * @default null
		 */ this.domElement = domElement;
        /**
		 * Whether the controls responds to user input or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * The internal state of the controls.
		 *
		 * @type {number}
		 * @default -1
		 */ this.state = -1;
        /**
		 * This object defines the keyboard input of the controls.
		 *
		 * @type {Object}
		 */ this.keys = {};
        /**
		 * This object defines what type of actions are assigned to the available mouse buttons.
		 * It depends on the control implementation what kind of mouse buttons and actions are supported.
		 *
		 * @type {{LEFT: ?number, MIDDLE: ?number, RIGHT: ?number}}
		 */ this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        /**
		 * This object defines what type of actions are assigned to what kind of touch interaction.
		 * It depends on the control implementation what kind of touch interaction and actions are supported.
		 *
		 * @type {{ONE: ?number, TWO: ?number}}
		 */ this.touches = {
            ONE: null,
            TWO: null
        };
    }
    /**
	 * Connects the controls to the DOM. This method has so called "side effects" since
	 * it adds the module's event listeners to the DOM.
	 *
	 * @param {HTMLElement} element - The DOM element to connect to.
	 */ connect(element) {
        if (element === undefined) {
            $ce0cdebec9150cb3$export$c106dd0671a0fc2d('Controls: connect() now requires an element.'); // @deprecated, the warning can be removed with r185
            return;
        }
        if (this.domElement !== null) this.disconnect();
        this.domElement = element;
    }
    /**
	 * Disconnects the controls from the DOM.
	 */ disconnect() {}
    /**
	 * Call this method if you no longer want use to the controls. It frees all internal
	 * resources and removes all event listeners.
	 */ dispose() {}
    /**
	 * Controls should implement this method if they have to update their internal state
	 * per simulation step.
	 *
	 * @param {number} [delta] - The time delta in seconds.
	 */ update() {}
}
/**
 * Scales the texture as large as possible within its surface without cropping
 * or stretching the texture. The method preserves the original aspect ratio of
 * the texture. Akin to CSS `object-fit: contain`
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $ce0cdebec9150cb3$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
/**
 * Scales the texture to the smallest possible size to fill the surface, leaving
 * no empty space. The method preserves the original aspect ratio of the texture.
 * Akin to CSS `object-fit: cover`.
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $ce0cdebec9150cb3$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
/**
 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
 *
 * @param {Texture} texture - The texture.
 * @return {Texture} The updated texture.
 */ function $ce0cdebec9150cb3$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Determines how many bytes must be used to represent the texture.
 *
 * @param {number} width - The width of the texture.
 * @param {number} height - The height of the texture.
 * @param {number} format - The texture's format.
 * @param {number} type - The texture's type.
 * @return {number} The byte length.
 */ function $ce0cdebec9150cb3$export$cc8c3b705bb8e6e2(width, height, format, type) {
    const typeByteLength = $ce0cdebec9150cb3$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $ce0cdebec9150cb3$export$988473390501ed4b:
            return width * height;
        case $ce0cdebec9150cb3$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $ce0cdebec9150cb3$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $ce0cdebec9150cb3$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $ce0cdebec9150cb3$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $ce0cdebec9150cb3$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $ce0cdebec9150cb3$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $ce0cdebec9150cb3$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $ce0cdebec9150cb3$export$21d1799c6d552fc0:
        case $ce0cdebec9150cb3$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $ce0cdebec9150cb3$export$d2a1a68024a3e56c:
        case $ce0cdebec9150cb3$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $ce0cdebec9150cb3$export$d0f0355bb3d948e4:
        case $ce0cdebec9150cb3$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $ce0cdebec9150cb3$export$19ada9bbb1af3573:
        case $ce0cdebec9150cb3$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $ce0cdebec9150cb3$export$6ab91af2d757aee7:
        case $ce0cdebec9150cb3$export$7800993ef8106a6a:
        case $ce0cdebec9150cb3$export$d5c566817123b2bf:
        case $ce0cdebec9150cb3$export$f5668dc623297d86:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $ce0cdebec9150cb3$export$23ed8300a860e7d8:
        case $ce0cdebec9150cb3$export$e443ea3e1485f7bf:
        case $ce0cdebec9150cb3$export$211402338cb75433:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $ce0cdebec9150cb3$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $ce0cdebec9150cb3$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $ce0cdebec9150cb3$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $ce0cdebec9150cb3$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $ce0cdebec9150cb3$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $ce0cdebec9150cb3$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $ce0cdebec9150cb3$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $ce0cdebec9150cb3$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $ce0cdebec9150cb3$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $ce0cdebec9150cb3$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $ce0cdebec9150cb3$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $ce0cdebec9150cb3$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $ce0cdebec9150cb3$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $ce0cdebec9150cb3$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $ce0cdebec9150cb3$export$ce40b115e188bc81:
        case $ce0cdebec9150cb3$export$d279c5c4bac5121e:
        case $ce0cdebec9150cb3$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $ce0cdebec9150cb3$export$b1688df4c4c21670:
        case $ce0cdebec9150cb3$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $ce0cdebec9150cb3$export$d220f6ade8463a0f:
        case $ce0cdebec9150cb3$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $ce0cdebec9150cb3$var$getTextureTypeByteLength(type) {
    switch(type){
        case $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10:
        case $ce0cdebec9150cb3$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $ce0cdebec9150cb3$export$c63dc51868b06a9d:
        case $ce0cdebec9150cb3$export$88572337f312435f:
        case $ce0cdebec9150cb3$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $ce0cdebec9150cb3$export$b3969b01faf587f2:
        case $ce0cdebec9150cb3$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $ce0cdebec9150cb3$export$c3c7fc4518ebba96:
        case $ce0cdebec9150cb3$export$5c612977753abe2:
        case $ce0cdebec9150cb3$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $ce0cdebec9150cb3$export$5a4c329b7e2092d3:
        case $ce0cdebec9150cb3$export$f240f067f72abe41:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
/**
 * A class containing utility functions for textures.
 *
 * @hideconstructor
 */ class $ce0cdebec9150cb3$export$ec276d39f33d4b7 {
    /**
	 * Scales the texture as large as possible within its surface without cropping
	 * or stretching the texture. The method preserves the original aspect ratio of
	 * the texture. Akin to CSS `object-fit: contain`
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static contain(texture, aspect) {
        return $ce0cdebec9150cb3$var$contain(texture, aspect);
    }
    /**
	 * Scales the texture to the smallest possible size to fill the surface, leaving
	 * no empty space. The method preserves the original aspect ratio of the texture.
	 * Akin to CSS `object-fit: cover`.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static cover(texture, aspect) {
        return $ce0cdebec9150cb3$var$cover(texture, aspect);
    }
    /**
	 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Texture} The updated texture.
	 */ static fill(texture) {
        return $ce0cdebec9150cb3$var$fill(texture);
    }
    /**
	 * Determines how many bytes must be used to represent the texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} format - The texture's format.
	 * @param {number} type - The texture's type.
	 * @return {number} The byte length.
	 */ static getByteLength(width, height, format, type) {
        return $ce0cdebec9150cb3$export$cc8c3b705bb8e6e2(width, height, format, type);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $ce0cdebec9150cb3$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) $ce0cdebec9150cb3$export$c106dd0671a0fc2d('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $ce0cdebec9150cb3$export$3545e07a80636437;
}


function $3b951febf8ab45a9$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $3b951febf8ab45a9$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (typeof Float16Array !== 'undefined' && array instanceof Float16Array) type = gl.HALF_FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $3b951febf8ab45a9$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $3b951febf8ab45a9$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $3b951febf8ab45a9$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $3b951febf8ab45a9$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $3b951febf8ab45a9$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $3b951febf8ab45a9$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $3b951febf8ab45a9$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec4 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 );\n\t}\n#endif";
var $3b951febf8ab45a9$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $3b951febf8ab45a9$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $3b951febf8ab45a9$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $3b951febf8ab45a9$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $3b951febf8ab45a9$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $3b951febf8ab45a9$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $3b951febf8ab45a9$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $3b951febf8ab45a9$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $3b951febf8ab45a9$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $3b951febf8ab45a9$var$color_fragment = "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#endif";
var $3b951febf8ab45a9$var$color_pars_fragment = "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#endif";
var $3b951febf8ab45a9$var$color_pars_vertex = "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec4 vColor;\n#endif";
var $3b951febf8ab45a9$var$color_vertex = "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec4( 1.0 );\n#endif\n#ifdef USE_COLOR_ALPHA\n\tvColor *= color;\n#elif defined( USE_COLOR )\n\tvColor.rgb *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.rgb *= instanceColor.rgb;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvColor *= getBatchingColor( getIndirectIndex( gl_DrawID ) );\n#endif";
var $3b951febf8ab45a9$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $3b951febf8ab45a9$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $3b951febf8ab45a9$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $3b951febf8ab45a9$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $3b951febf8ab45a9$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $3b951febf8ab45a9$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $3b951febf8ab45a9$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $3b951febf8ab45a9$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $3b951febf8ab45a9$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t\t#endif\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $3b951febf8ab45a9$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $3b951febf8ab45a9$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $3b951febf8ab45a9$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $3b951febf8ab45a9$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $3b951febf8ab45a9$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $3b951febf8ab45a9$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $3b951febf8ab45a9$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $3b951febf8ab45a9$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $3b951febf8ab45a9$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $3b951febf8ab45a9$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $3b951febf8ab45a9$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $3b951febf8ab45a9$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.metalness = metalnessFactor;\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = vec3( 0.04 );\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $3b951febf8ab45a9$var$lights_physical_pars_fragment = "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tvec3 diffuseContribution;\n\tvec3 specularColor;\n\tvec3 specularColorBlended;\n\tfloat roughness;\n\tfloat metalness;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t\tvec3 iridescenceFresnelDielectric;\n\t\tvec3 iridescenceFresnelMetallic;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn v;\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColorBlended;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat rInv = 1.0 / ( roughness + 0.1 );\n\tfloat a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;\n\tfloat b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;\n\tfloat DG = exp( a * dotNV + b );\n\treturn saturate( DG );\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;\n\tvec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;\n\tvec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;\n\tvec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;\n\tfloat Ess_V = dfgV.x + dfgV.y;\n\tfloat Ess_L = dfgL.x + dfgL.y;\n\tfloat Ems_V = 1.0 - Ess_V;\n\tfloat Ems_L = 1.0 - Ess_L;\n\tvec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;\n\tvec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );\n\tfloat compensationFactor = Ems_V * Ems_L;\n\tvec3 multiScatter = Fms * compensationFactor;\n\treturn singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColorBlended * t2.x + ( material.specularF90 - material.specularColorBlended ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t\t#ifdef USE_CLEARCOAT\n\t\t\tvec3 Ncc = geometryClearcoatNormal;\n\t\t\tvec2 uvClearcoat = LTC_Uv( Ncc, viewDir, material.clearcoatRoughness );\n\t\t\tvec4 t1Clearcoat = texture2D( ltc_1, uvClearcoat );\n\t\t\tvec4 t2Clearcoat = texture2D( ltc_2, uvClearcoat );\n\t\t\tmat3 mInvClearcoat = mat3(\n\t\t\t\tvec3( t1Clearcoat.x, 0, t1Clearcoat.y ),\n\t\t\t\tvec3(             0, 1,             0 ),\n\t\t\t\tvec3( t1Clearcoat.z, 0, t1Clearcoat.w )\n\t\t\t);\n\t\t\tvec3 fresnelClearcoat = material.clearcoatF0 * t2Clearcoat.x + ( material.clearcoatF90 - material.clearcoatF0 ) * t2Clearcoat.y;\n\t\t\tclearcoatSpecularDirect += lightColor * fresnelClearcoat * LTC_Evaluate( Ncc, viewDir, position, mInvClearcoat, rectCoords );\n\t\t#endif\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n \n \t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n \n \t\tfloat sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n \t\tfloat sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );\n \n \t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );\n \n \t\tirradiance *= sheenEnergyComp;\n \n \t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tdiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectDiffuse += diffuse;\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;\n \t#endif\n\tvec3 singleScatteringDielectric = vec3( 0.0 );\n\tvec3 multiScatteringDielectric = vec3( 0.0 );\n\tvec3 singleScatteringMetallic = vec3( 0.0 );\n\tvec3 multiScatteringMetallic = vec3( 0.0 );\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#endif\n\tvec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );\n\tvec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );\n\tvec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;\n\tvec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tvec3 indirectSpecular = radiance * singleScattering;\n\tindirectSpecular += multiScattering * cosineWeightedIrradiance;\n\tvec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tindirectSpecular *= sheenEnergyComp;\n\t\tindirectDiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectSpecular += indirectSpecular;\n\treflectedLight.indirectDiffuse += indirectDiffuse;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $3b951febf8ab45a9$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );\n\t\tmaterial.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $3b951febf8ab45a9$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\t#if defined( STANDARD ) || defined( LAMBERT ) || defined( PHONG )\n\t\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t\t#endif\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\t#if defined( LAMBERT ) || defined( PHONG )\n\t\tirradiance += iblIrradiance;\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $3b951febf8ab45a9$var$logdepthbuf_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $3b951febf8ab45a9$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $3b951febf8ab45a9$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $3b951febf8ab45a9$var$logdepthbuf_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $3b951febf8ab45a9$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $3b951febf8ab45a9$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $3b951febf8ab45a9$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $3b951febf8ab45a9$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $3b951febf8ab45a9$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $3b951febf8ab45a9$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $3b951febf8ab45a9$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $3b951febf8ab45a9$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $3b951febf8ab45a9$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $3b951febf8ab45a9$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $3b951febf8ab45a9$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $3b951febf8ab45a9$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $3b951febf8ab45a9$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $3b951febf8ab45a9$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $3b951febf8ab45a9$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $3b951febf8ab45a9$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $3b951febf8ab45a9$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $3b951febf8ab45a9$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $3b951febf8ab45a9$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $3b951febf8ab45a9$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\n\t\treturn depth * ( far - near ) - far;\n\t#else\n\t\treturn depth * ( near - far ) - near;\n\t#endif\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\t\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\treturn ( near * far ) / ( ( near - far ) * depth - near );\n\t#else\n\t\treturn ( near * far ) / ( ( far - near ) * depth - far );\n\t#endif\n}";
var $3b951febf8ab45a9$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $3b951febf8ab45a9$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $3b951febf8ab45a9$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $3b951febf8ab45a9$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $3b951febf8ab45a9$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $3b951febf8ab45a9$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $3b951febf8ab45a9$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\t\t\tuniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat interleavedGradientNoise( vec2 position ) {\n\t\t\treturn fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );\n\t\t}\n\t\tvec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {\n\t\t\tconst float goldenAngle = 2.399963229728653;\n\t\t\tfloat r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );\n\t\t\tfloat theta = float( sampleIndex ) * goldenAngle + phi;\n\t\t\treturn vec2( cos( theta ), sin( theta ) ) * r;\n\t\t}\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\t\tfloat radius = shadowRadius * texelSize.x;\n\t\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )\n\t\t\t\t) * 0.2;\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadowCoord.z -= shadowBias;\n\t\t\t#else\n\t\t\t\tshadowCoord.z += shadowBias;\n\t\t\t#endif\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;\n\t\t\t\tfloat mean = distribution.x;\n\t\t\t\tfloat variance = distribution.y * distribution.y;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tfloat hard_shadow = step( mean, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tfloat hard_shadow = step( shadowCoord.z, mean );\n\t\t\t\t#endif\n\t\t\t\t\n\t\t\t\tif ( hard_shadow == 1.0 ) {\n\t\t\t\t\tshadow = 1.0;\n\t\t\t\t} else {\n\t\t\t\t\tvariance = max( variance, 0.0000001 );\n\t\t\t\t\tfloat d = shadowCoord.z - mean;\n\t\t\t\t\tfloat p_max = variance / ( variance + d * d );\n\t\t\t\t\tp_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );\n\t\t\t\t\tshadow = max( hard_shadow, p_max );\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#else\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadowCoord.z -= shadowBias;\n\t\t\t#else\n\t\t\t\tshadowCoord.z += shadowBias;\n\t\t\t#endif\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tfloat depth = texture2D( shadowMap, shadowCoord.xy ).r;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tshadow = step( depth, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tshadow = step( shadowCoord.z, depth );\n\t\t\t\t#endif\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\tfloat getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tfloat dp = ( shadowCameraNear * ( shadowCameraFar - viewSpaceZ ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\t\tdp -= shadowBias;\n\t\t\t#else\n\t\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\t\tdp += shadowBias;\n\t\t\t#endif\n\t\t\tfloat texelSize = shadowRadius / shadowMapSize.x;\n\t\t\tvec3 absDir = abs( bd3D );\n\t\t\tvec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );\n\t\t\ttangent = normalize( cross( bd3D, tangent ) );\n\t\t\tvec3 bitangent = cross( bd3D, tangent );\n\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n\t\t\tvec2 sample0 = vogelDiskSample( 0, 5, phi );\n\t\t\tvec2 sample1 = vogelDiskSample( 1, 5, phi );\n\t\t\tvec2 sample2 = vogelDiskSample( 2, 5, phi );\n\t\t\tvec2 sample3 = vogelDiskSample( 3, 5, phi );\n\t\t\tvec2 sample4 = vogelDiskSample( 4, 5, phi );\n\t\t\tshadow = (\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample0.x + bitangent * sample0.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample1.x + bitangent * sample1.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample2.x + bitangent * sample2.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample3.x + bitangent * sample3.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample4.x + bitangent * sample4.y ) * texelSize, dp ) )\n\t\t\t) * 0.2;\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\tfloat getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tfloat depth = textureCube( shadowMap, bd3D ).r;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tdepth = 1.0 - depth;\n\t\t\t#endif\n\t\t\tshadow = step( dp, depth );\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#endif\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $3b951febf8ab45a9$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $3b951febf8ab45a9$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $3b951febf8ab45a9$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $3b951febf8ab45a9$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $3b951febf8ab45a9$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $3b951febf8ab45a9$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $3b951febf8ab45a9$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $3b951febf8ab45a9$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $3b951febf8ab45a9$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $3b951febf8ab45a9$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $3b951febf8ab45a9$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $3b951febf8ab45a9$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $3b951febf8ab45a9$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $3b951febf8ab45a9$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $3b951febf8ab45a9$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $3b951febf8ab45a9$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $3b951febf8ab45a9$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $3b951febf8ab45a9$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $3b951febf8ab45a9$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $3b951febf8ab45a9$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\tfloat fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n\t#else\n\t\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n\t#endif\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $3b951febf8ab45a9$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $3b951febf8ab45a9$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );\n}";
const $3b951febf8ab45a9$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $3b951febf8ab45a9$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $3b951febf8ab45a9$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $3b951febf8ab45a9$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $3b951febf8ab45a9$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $3b951febf8ab45a9$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $3b951febf8ab45a9$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $3b951febf8ab45a9$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $3b951febf8ab45a9$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $3b951febf8ab45a9$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n \n\t\toutgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;\n \n \t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $3b951febf8ab45a9$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $3b951febf8ab45a9$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $3b951febf8ab45a9$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $3b951febf8ab45a9$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $3b951febf8ab45a9$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $3b951febf8ab45a9$export$955f9f2e84c43c8b = {
    alphahash_fragment: $3b951febf8ab45a9$var$alphahash_fragment,
    alphahash_pars_fragment: $3b951febf8ab45a9$var$alphahash_pars_fragment,
    alphamap_fragment: $3b951febf8ab45a9$var$alphamap_fragment,
    alphamap_pars_fragment: $3b951febf8ab45a9$var$alphamap_pars_fragment,
    alphatest_fragment: $3b951febf8ab45a9$var$alphatest_fragment,
    alphatest_pars_fragment: $3b951febf8ab45a9$var$alphatest_pars_fragment,
    aomap_fragment: $3b951febf8ab45a9$var$aomap_fragment,
    aomap_pars_fragment: $3b951febf8ab45a9$var$aomap_pars_fragment,
    batching_pars_vertex: $3b951febf8ab45a9$var$batching_pars_vertex,
    batching_vertex: $3b951febf8ab45a9$var$batching_vertex,
    begin_vertex: $3b951febf8ab45a9$var$begin_vertex,
    beginnormal_vertex: $3b951febf8ab45a9$var$beginnormal_vertex,
    bsdfs: $3b951febf8ab45a9$var$bsdfs,
    iridescence_fragment: $3b951febf8ab45a9$var$iridescence_fragment,
    bumpmap_pars_fragment: $3b951febf8ab45a9$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $3b951febf8ab45a9$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $3b951febf8ab45a9$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $3b951febf8ab45a9$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $3b951febf8ab45a9$var$clipping_planes_vertex,
    color_fragment: $3b951febf8ab45a9$var$color_fragment,
    color_pars_fragment: $3b951febf8ab45a9$var$color_pars_fragment,
    color_pars_vertex: $3b951febf8ab45a9$var$color_pars_vertex,
    color_vertex: $3b951febf8ab45a9$var$color_vertex,
    common: $3b951febf8ab45a9$var$common,
    cube_uv_reflection_fragment: $3b951febf8ab45a9$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $3b951febf8ab45a9$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $3b951febf8ab45a9$var$displacementmap_pars_vertex,
    displacementmap_vertex: $3b951febf8ab45a9$var$displacementmap_vertex,
    emissivemap_fragment: $3b951febf8ab45a9$var$emissivemap_fragment,
    emissivemap_pars_fragment: $3b951febf8ab45a9$var$emissivemap_pars_fragment,
    colorspace_fragment: $3b951febf8ab45a9$var$colorspace_fragment,
    colorspace_pars_fragment: $3b951febf8ab45a9$var$colorspace_pars_fragment,
    envmap_fragment: $3b951febf8ab45a9$var$envmap_fragment,
    envmap_common_pars_fragment: $3b951febf8ab45a9$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $3b951febf8ab45a9$var$envmap_pars_fragment,
    envmap_pars_vertex: $3b951febf8ab45a9$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $3b951febf8ab45a9$var$envmap_physical_pars_fragment,
    envmap_vertex: $3b951febf8ab45a9$var$envmap_vertex,
    fog_vertex: $3b951febf8ab45a9$var$fog_vertex,
    fog_pars_vertex: $3b951febf8ab45a9$var$fog_pars_vertex,
    fog_fragment: $3b951febf8ab45a9$var$fog_fragment,
    fog_pars_fragment: $3b951febf8ab45a9$var$fog_pars_fragment,
    gradientmap_pars_fragment: $3b951febf8ab45a9$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $3b951febf8ab45a9$var$lightmap_pars_fragment,
    lights_lambert_fragment: $3b951febf8ab45a9$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $3b951febf8ab45a9$var$lights_lambert_pars_fragment,
    lights_pars_begin: $3b951febf8ab45a9$var$lights_pars_begin,
    lights_toon_fragment: $3b951febf8ab45a9$var$lights_toon_fragment,
    lights_toon_pars_fragment: $3b951febf8ab45a9$var$lights_toon_pars_fragment,
    lights_phong_fragment: $3b951febf8ab45a9$var$lights_phong_fragment,
    lights_phong_pars_fragment: $3b951febf8ab45a9$var$lights_phong_pars_fragment,
    lights_physical_fragment: $3b951febf8ab45a9$var$lights_physical_fragment,
    lights_physical_pars_fragment: $3b951febf8ab45a9$var$lights_physical_pars_fragment,
    lights_fragment_begin: $3b951febf8ab45a9$var$lights_fragment_begin,
    lights_fragment_maps: $3b951febf8ab45a9$var$lights_fragment_maps,
    lights_fragment_end: $3b951febf8ab45a9$var$lights_fragment_end,
    logdepthbuf_fragment: $3b951febf8ab45a9$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $3b951febf8ab45a9$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $3b951febf8ab45a9$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $3b951febf8ab45a9$var$logdepthbuf_vertex,
    map_fragment: $3b951febf8ab45a9$var$map_fragment,
    map_pars_fragment: $3b951febf8ab45a9$var$map_pars_fragment,
    map_particle_fragment: $3b951febf8ab45a9$var$map_particle_fragment,
    map_particle_pars_fragment: $3b951febf8ab45a9$var$map_particle_pars_fragment,
    metalnessmap_fragment: $3b951febf8ab45a9$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $3b951febf8ab45a9$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $3b951febf8ab45a9$var$morphinstance_vertex,
    morphcolor_vertex: $3b951febf8ab45a9$var$morphcolor_vertex,
    morphnormal_vertex: $3b951febf8ab45a9$var$morphnormal_vertex,
    morphtarget_pars_vertex: $3b951febf8ab45a9$var$morphtarget_pars_vertex,
    morphtarget_vertex: $3b951febf8ab45a9$var$morphtarget_vertex,
    normal_fragment_begin: $3b951febf8ab45a9$var$normal_fragment_begin,
    normal_fragment_maps: $3b951febf8ab45a9$var$normal_fragment_maps,
    normal_pars_fragment: $3b951febf8ab45a9$var$normal_pars_fragment,
    normal_pars_vertex: $3b951febf8ab45a9$var$normal_pars_vertex,
    normal_vertex: $3b951febf8ab45a9$var$normal_vertex,
    normalmap_pars_fragment: $3b951febf8ab45a9$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $3b951febf8ab45a9$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $3b951febf8ab45a9$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $3b951febf8ab45a9$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $3b951febf8ab45a9$var$iridescence_pars_fragment,
    opaque_fragment: $3b951febf8ab45a9$var$opaque_fragment,
    packing: $3b951febf8ab45a9$var$packing,
    premultiplied_alpha_fragment: $3b951febf8ab45a9$var$premultiplied_alpha_fragment,
    project_vertex: $3b951febf8ab45a9$var$project_vertex,
    dithering_fragment: $3b951febf8ab45a9$var$dithering_fragment,
    dithering_pars_fragment: $3b951febf8ab45a9$var$dithering_pars_fragment,
    roughnessmap_fragment: $3b951febf8ab45a9$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $3b951febf8ab45a9$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $3b951febf8ab45a9$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $3b951febf8ab45a9$var$shadowmap_pars_vertex,
    shadowmap_vertex: $3b951febf8ab45a9$var$shadowmap_vertex,
    shadowmask_pars_fragment: $3b951febf8ab45a9$var$shadowmask_pars_fragment,
    skinbase_vertex: $3b951febf8ab45a9$var$skinbase_vertex,
    skinning_pars_vertex: $3b951febf8ab45a9$var$skinning_pars_vertex,
    skinning_vertex: $3b951febf8ab45a9$var$skinning_vertex,
    skinnormal_vertex: $3b951febf8ab45a9$var$skinnormal_vertex,
    specularmap_fragment: $3b951febf8ab45a9$var$specularmap_fragment,
    specularmap_pars_fragment: $3b951febf8ab45a9$var$specularmap_pars_fragment,
    tonemapping_fragment: $3b951febf8ab45a9$var$tonemapping_fragment,
    tonemapping_pars_fragment: $3b951febf8ab45a9$var$tonemapping_pars_fragment,
    transmission_fragment: $3b951febf8ab45a9$var$transmission_fragment,
    transmission_pars_fragment: $3b951febf8ab45a9$var$transmission_pars_fragment,
    uv_pars_fragment: $3b951febf8ab45a9$var$uv_pars_fragment,
    uv_pars_vertex: $3b951febf8ab45a9$var$uv_pars_vertex,
    uv_vertex: $3b951febf8ab45a9$var$uv_vertex,
    worldpos_vertex: $3b951febf8ab45a9$var$worldpos_vertex,
    background_vert: $3b951febf8ab45a9$var$vertex$h,
    background_frag: $3b951febf8ab45a9$var$fragment$h,
    backgroundCube_vert: $3b951febf8ab45a9$var$vertex$g,
    backgroundCube_frag: $3b951febf8ab45a9$var$fragment$g,
    cube_vert: $3b951febf8ab45a9$var$vertex$f,
    cube_frag: $3b951febf8ab45a9$var$fragment$f,
    depth_vert: $3b951febf8ab45a9$var$vertex$e,
    depth_frag: $3b951febf8ab45a9$var$fragment$e,
    distance_vert: $3b951febf8ab45a9$var$vertex$d,
    distance_frag: $3b951febf8ab45a9$var$fragment$d,
    equirect_vert: $3b951febf8ab45a9$var$vertex$c,
    equirect_frag: $3b951febf8ab45a9$var$fragment$c,
    linedashed_vert: $3b951febf8ab45a9$var$vertex$b,
    linedashed_frag: $3b951febf8ab45a9$var$fragment$b,
    meshbasic_vert: $3b951febf8ab45a9$var$vertex$a,
    meshbasic_frag: $3b951febf8ab45a9$var$fragment$a,
    meshlambert_vert: $3b951febf8ab45a9$var$vertex$9,
    meshlambert_frag: $3b951febf8ab45a9$var$fragment$9,
    meshmatcap_vert: $3b951febf8ab45a9$var$vertex$8,
    meshmatcap_frag: $3b951febf8ab45a9$var$fragment$8,
    meshnormal_vert: $3b951febf8ab45a9$var$vertex$7,
    meshnormal_frag: $3b951febf8ab45a9$var$fragment$7,
    meshphong_vert: $3b951febf8ab45a9$var$vertex$6,
    meshphong_frag: $3b951febf8ab45a9$var$fragment$6,
    meshphysical_vert: $3b951febf8ab45a9$var$vertex$5,
    meshphysical_frag: $3b951febf8ab45a9$var$fragment$5,
    meshtoon_vert: $3b951febf8ab45a9$var$vertex$4,
    meshtoon_frag: $3b951febf8ab45a9$var$fragment$4,
    points_vert: $3b951febf8ab45a9$var$vertex$3,
    points_frag: $3b951febf8ab45a9$var$fragment$3,
    shadow_vert: $3b951febf8ab45a9$var$vertex$2,
    shadow_frag: $3b951febf8ab45a9$var$fragment$2,
    sprite_vert: $3b951febf8ab45a9$var$vertex$1,
    sprite_frag: $3b951febf8ab45a9$var$fragment$1
};
// Uniforms library for shared webgl shaders
const $3b951febf8ab45a9$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        },
        dfgLUT: {
            value: null
        } // DFG LUT for physically-based rendering
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $3b951febf8ab45a9$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.specularmap,
            $3b951febf8ab45a9$export$6643083551874bf5.envmap,
            $3b951febf8ab45a9$export$6643083551874bf5.aomap,
            $3b951febf8ab45a9$export$6643083551874bf5.lightmap,
            $3b951febf8ab45a9$export$6643083551874bf5.fog
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.specularmap,
            $3b951febf8ab45a9$export$6643083551874bf5.envmap,
            $3b951febf8ab45a9$export$6643083551874bf5.aomap,
            $3b951febf8ab45a9$export$6643083551874bf5.lightmap,
            $3b951febf8ab45a9$export$6643083551874bf5.emissivemap,
            $3b951febf8ab45a9$export$6643083551874bf5.bumpmap,
            $3b951febf8ab45a9$export$6643083551874bf5.normalmap,
            $3b951febf8ab45a9$export$6643083551874bf5.displacementmap,
            $3b951febf8ab45a9$export$6643083551874bf5.fog,
            $3b951febf8ab45a9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x000000)
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.specularmap,
            $3b951febf8ab45a9$export$6643083551874bf5.envmap,
            $3b951febf8ab45a9$export$6643083551874bf5.aomap,
            $3b951febf8ab45a9$export$6643083551874bf5.lightmap,
            $3b951febf8ab45a9$export$6643083551874bf5.emissivemap,
            $3b951febf8ab45a9$export$6643083551874bf5.bumpmap,
            $3b951febf8ab45a9$export$6643083551874bf5.normalmap,
            $3b951febf8ab45a9$export$6643083551874bf5.displacementmap,
            $3b951febf8ab45a9$export$6643083551874bf5.fog,
            $3b951febf8ab45a9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x111111)
                },
                shininess: {
                    value: 30
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.envmap,
            $3b951febf8ab45a9$export$6643083551874bf5.aomap,
            $3b951febf8ab45a9$export$6643083551874bf5.lightmap,
            $3b951febf8ab45a9$export$6643083551874bf5.emissivemap,
            $3b951febf8ab45a9$export$6643083551874bf5.bumpmap,
            $3b951febf8ab45a9$export$6643083551874bf5.normalmap,
            $3b951febf8ab45a9$export$6643083551874bf5.displacementmap,
            $3b951febf8ab45a9$export$6643083551874bf5.roughnessmap,
            $3b951febf8ab45a9$export$6643083551874bf5.metalnessmap,
            $3b951febf8ab45a9$export$6643083551874bf5.fog,
            $3b951febf8ab45a9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.aomap,
            $3b951febf8ab45a9$export$6643083551874bf5.lightmap,
            $3b951febf8ab45a9$export$6643083551874bf5.emissivemap,
            $3b951febf8ab45a9$export$6643083551874bf5.bumpmap,
            $3b951febf8ab45a9$export$6643083551874bf5.normalmap,
            $3b951febf8ab45a9$export$6643083551874bf5.displacementmap,
            $3b951febf8ab45a9$export$6643083551874bf5.gradientmap,
            $3b951febf8ab45a9$export$6643083551874bf5.fog,
            $3b951febf8ab45a9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x000000)
                }
            }
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.bumpmap,
            $3b951febf8ab45a9$export$6643083551874bf5.normalmap,
            $3b951febf8ab45a9$export$6643083551874bf5.displacementmap,
            $3b951febf8ab45a9$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.points,
            $3b951febf8ab45a9$export$6643083551874bf5.fog
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.bumpmap,
            $3b951febf8ab45a9$export$6643083551874bf5.normalmap,
            $3b951febf8ab45a9$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.sprite,
            $3b951febf8ab45a9$export$6643083551874bf5.fog
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            }
        },
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.equirect_frag
    },
    distance: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.common,
            $3b951febf8ab45a9$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.distance_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.distance_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
            $3b951febf8ab45a9$export$6643083551874bf5.lights,
            $3b951febf8ab45a9$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.shadow_frag
    }
};
$3b951febf8ab45a9$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $ce0cdebec9150cb3$export$8916ce6879271f43)([
        $3b951febf8ab45a9$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)()
            }
        }
    ]),
    vertexShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $3b951febf8ab45a9$export$955f9f2e84c43c8b.meshphysical_frag
};
const $3b951febf8ab45a9$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $3b951febf8ab45a9$var$_e1$1 = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$d93cc409a0768c5f)();
const $3b951febf8ab45a9$var$_m1$1 = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
function $3b951febf8ab45a9$var$WebGLBackground(renderer, environments, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = environments.get(background, usePMREM);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $ce0cdebec9150cb3$export$dbf3e70ff37af79))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(new (0, $ce0cdebec9150cb3$export$33e43285f7406bd5)(1, 1, 1), new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $ce0cdebec9150cb3$export$acda854380553452)($3b951febf8ab45a9$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $3b951febf8ab45a9$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $3b951febf8ab45a9$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $3b951febf8ab45a9$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $3b951febf8ab45a9$var$_e1$1.x *= -1;
            $3b951febf8ab45a9$var$_e1$1.y *= -1;
            $3b951febf8ab45a9$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $3b951febf8ab45a9$var$_e1$1.y *= -1;
                $3b951febf8ab45a9$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($3b951febf8ab45a9$var$_m1$1.makeRotationFromEuler($3b951febf8ab45a9$var$_e1$1));
            boxMesh.material.toneMapped = (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(new (0, $ce0cdebec9150cb3$export$967d831af31f69ce)(2, 2), new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $ce0cdebec9150cb3$export$acda854380553452)($3b951febf8ab45a9$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $3b951febf8ab45a9$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $3b951febf8ab45a9$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $ce0cdebec9150cb3$export$2ede184fc2998901),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($3b951febf8ab45a9$var$_rgb, (0, $ce0cdebec9150cb3$export$a630742c640528c1)(renderer));
        state.buffers.color.setClear($3b951febf8ab45a9$var$_rgb.r, $3b951febf8ab45a9$var$_rgb.g, $3b951febf8ab45a9$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $3b951febf8ab45a9$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(object, geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(object, geometry, program, material) {
        const wireframe = material.wireframe === true;
        let objectMap = bindingStates[geometry.id];
        if (objectMap === undefined) {
            objectMap = {};
            bindingStates[geometry.id] = objectMap;
        }
        // Each InstancedMesh requires unique binding states because it contains instanced attributes.
        const objectId = object.isInstancedMesh === true ? object.id : 0;
        let programMap = objectMap[objectId];
        if (programMap === undefined) {
            programMap = {};
            objectMap[objectId] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $ce0cdebec9150cb3$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const objectMap = bindingStates[geometryId];
            for(const objectId in objectMap){
                const programMap = objectMap[objectId];
                for(const programId in programMap){
                    const stateMap = programMap[programId];
                    for(const wireframe in stateMap){
                        deleteVertexArrayObject(stateMap[wireframe].object);
                        delete stateMap[wireframe];
                    }
                    delete programMap[programId];
                }
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const objectMap = bindingStates[geometry.id];
        for(const objectId in objectMap){
            const programMap = objectMap[objectId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const objectMap = bindingStates[geometryId];
            for(const objectId in objectMap){
                const programMap = objectMap[objectId];
                if (programMap[program.id] === undefined) continue;
                const stateMap = programMap[program.id];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[program.id];
            }
        }
    }
    function releaseStatesOfObject(object) {
        for(const geometryId in bindingStates){
            const objectMap = bindingStates[geometryId];
            const objectId = object.isInstancedMesh === true ? object.id : 0;
            const programMap = objectMap[objectId];
            if (programMap === undefined) continue;
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete objectMap[objectId];
            if (Object.keys(objectMap).length === 0) delete bindingStates[geometryId];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfObject: releaseStatesOfObject,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $3b951febf8ab45a9$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $3b951febf8ab45a9$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === (0, $ce0cdebec9150cb3$export$2697304443f382bc) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $ce0cdebec9150cb3$export$f6d331659b644596) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reversedDepthBuffer = parameters.reversedDepthBuffer === true && extensions.has('EXT_clip_control');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    const samples = gl.getParameter(gl.SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reversedDepthBuffer: reversedDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        maxSamples: maxSamples,
        samples: samples
    };
}
function $3b951febf8ab45a9$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new (0, $ce0cdebec9150cb3$export$7ff5ac152ef991b0)(), viewNormalMatrix = new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
const $3b951febf8ab45a9$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips.
// Used for scene blur in fromScene() method.
const $3b951febf8ab45a9$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
// Used for scene blur in fromScene() method.
const $3b951febf8ab45a9$var$MAX_SAMPLES = 20;
// GGX VNDF importance sampling configuration
const $3b951febf8ab45a9$var$GGX_SAMPLES = 256;
const $3b951febf8ab45a9$var$_flatCamera = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$9ebf355ee4ed261b)();
const $3b951febf8ab45a9$var$_clearColor = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)();
let $3b951febf8ab45a9$var$_oldTarget = null;
let $3b951febf8ab45a9$var$_oldActiveCubeFace = 0;
let $3b951febf8ab45a9$var$_oldActiveMipmapLevel = 0;
let $3b951febf8ab45a9$var$_oldXrEnabled = false;
const $3b951febf8ab45a9$var$_origin = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * The prefiltering uses GGX VNDF (Visible Normal Distribution Function)
 * importance sampling based on "Sampling the GGX Distribution of Visible Normals"
 * (Heitz, 2018) to generate environment maps that accurately match the GGX BRDF
 * used in material rendering for physically-based image-based lighting.
 */ class $3b951febf8ab45a9$export$6add42717753e221 {
    /**
	 * Constructs a new PMREM generator.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._sizeLods = [];
        this._sigmas = [];
        this._lodMeshes = [];
        this._backgroundBox = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._blurMaterial = null;
        this._ggxMaterial = null;
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size: size = 256, position: position = $3b951febf8ab45a9$var$_origin } = options;
        $3b951febf8ab45a9$var$_oldTarget = this._renderer.getRenderTarget();
        $3b951febf8ab45a9$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $3b951febf8ab45a9$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $3b951febf8ab45a9$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(size);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $3b951febf8ab45a9$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $3b951febf8ab45a9$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
        if (this._backgroundBox !== null) {
            this._backgroundBox.geometry.dispose();
            this._backgroundBox.material.dispose();
        }
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._ggxMaterial !== null) this._ggxMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodMeshes.length; i++)this._lodMeshes[i].geometry.dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($3b951febf8ab45a9$var$_oldTarget, $3b951febf8ab45a9$var$_oldActiveCubeFace, $3b951febf8ab45a9$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $3b951febf8ab45a9$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $3b951febf8ab45a9$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, $ce0cdebec9150cb3$export$8759762a6477f2c4) || texture.mapping === (0, $ce0cdebec9150cb3$export$dc59f8aed047f61d)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $3b951febf8ab45a9$var$_oldTarget = this._renderer.getRenderTarget();
        $3b951febf8ab45a9$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $3b951febf8ab45a9$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $3b951febf8ab45a9$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            generateMipmaps: false,
            type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
            format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c),
            colorSpace: (0, $ce0cdebec9150cb3$export$42429b3acfb233a4),
            depthBuffer: false
        };
        const cubeUVRenderTarget = $3b951febf8ab45a9$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $3b951febf8ab45a9$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = $3b951febf8ab45a9$var$_createPlanes(_lodMax));
            this._blurMaterial = $3b951febf8ab45a9$var$_getBlurShader(_lodMax, width, height);
            this._ggxMaterial = $3b951febf8ab45a9$var$_getGGXShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const mesh = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(new (0, $ce0cdebec9150cb3$export$b7be63a67df8959)(), material);
        this._renderer.compile(mesh, $3b951febf8ab45a9$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($3b951febf8ab45a9$var$_clearColor);
        renderer.toneMapping = (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2);
        renderer.autoClear = false;
        // https://github.com/mrdoob/three.js/issues/31413#issuecomment-3095966812
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        if (reversedDepthBuffer) {
            renderer.setRenderTarget(cubeUVRenderTarget);
            renderer.clearDepth();
            renderer.setRenderTarget(null);
        }
        if (this._backgroundBox === null) this._backgroundBox = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(new (0, $ce0cdebec9150cb3$export$33e43285f7406bd5)(), new (0, $ce0cdebec9150cb3$export$55cbcc9b622fe1f5)({
            name: 'PMREM.Background',
            side: (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace),
            depthWrite: false,
            depthTest: false
        }));
        const backgroundBox = this._backgroundBox;
        const backgroundMaterial = backgroundBox.material;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($3b951febf8ab45a9$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            $3b951febf8ab45a9$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $ce0cdebec9150cb3$export$8759762a6477f2c4) || texture.mapping === (0, $ce0cdebec9150cb3$export$dc59f8aed047f61d);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $3b951febf8ab45a9$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $3b951febf8ab45a9$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = this._lodMeshes[0];
        mesh.material = material;
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $3b951febf8ab45a9$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $3b951febf8ab45a9$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodMeshes.length;
        // Use GGX VNDF importance sampling
        for(let i = 1; i < n; i++)this._applyGGXFilter(cubeUVRenderTarget, i - 1, i);
        renderer.autoClear = autoClear;
    }
    /**
	 * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
	 * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
	 * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
	 * applies incremental roughness filtering to avoid over-blurring.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn - Source LOD level to read from
	 * @param {number} lodOut - Target LOD level to write to
	 */ _applyGGXFilter(cubeUVRenderTarget, lodIn, lodOut) {
        const renderer = this._renderer;
        const pingPongRenderTarget = this._pingPongRenderTarget;
        const ggxMaterial = this._ggxMaterial;
        const ggxMesh = this._lodMeshes[lodOut];
        ggxMesh.material = ggxMaterial;
        const ggxUniforms = ggxMaterial.uniforms;
        // Calculate incremental roughness between LOD levels
        const targetRoughness = lodOut / (this._lodMeshes.length - 1);
        const sourceRoughness = lodIn / (this._lodMeshes.length - 1);
        const incrementalRoughness = Math.sqrt(targetRoughness * targetRoughness - sourceRoughness * sourceRoughness);
        // Apply blur strength mapping for better quality across the roughness range
        const blurStrength = 0.0 + targetRoughness * 1.25;
        const adjustedRoughness = incrementalRoughness * blurStrength;
        // Calculate viewport position based on output LOD level
        const { _lodMax: _lodMax } = this;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $3b951febf8ab45a9$var$LOD_MIN ? lodOut - _lodMax + $3b951febf8ab45a9$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        // Read from previous LOD with incremental roughness
        ggxUniforms['envMap'].value = cubeUVRenderTarget.texture;
        ggxUniforms['roughness'].value = adjustedRoughness;
        ggxUniforms['mipInt'].value = _lodMax - lodIn; // Sample from input LOD
        $3b951febf8ab45a9$var$_setViewport(pingPongRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(pingPongRenderTarget);
        renderer.render(ggxMesh, $3b951febf8ab45a9$var$_flatCamera);
        // Copy from pingPong back to cubeUV (simple direct copy)
        ggxUniforms['envMap'].value = pingPongRenderTarget.texture;
        ggxUniforms['roughness'].value = 0.0; // Direct copy
        ggxUniforms['mipInt'].value = _lodMax - lodOut; // Read from the level we just wrote
        $3b951febf8ab45a9$var$_setViewport(cubeUVRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(ggxMesh, $3b951febf8ab45a9$var$_flatCamera);
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * Used for initial scene blur in fromScene() method when sigma > 0.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = this._lodMeshes[lodOut];
        blurMesh.material = blurMaterial;
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $3b951febf8ab45a9$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $3b951febf8ab45a9$var$MAX_SAMPLES;
        if (samples > $3b951febf8ab45a9$var$MAX_SAMPLES) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$3b951febf8ab45a9$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $3b951febf8ab45a9$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $3b951febf8ab45a9$var$LOD_MIN ? lodOut - _lodMax + $3b951febf8ab45a9$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $3b951febf8ab45a9$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $3b951febf8ab45a9$var$_flatCamera);
    }
}
function $3b951febf8ab45a9$var$_createPlanes(lodMax) {
    const sizeLods = [];
    const sigmas = [];
    const lodMeshes = [];
    let lod = lodMax;
    const totalLods = lodMax - $3b951febf8ab45a9$var$LOD_MIN + 1 + $3b951febf8ab45a9$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $3b951febf8ab45a9$var$LOD_MIN) sigma = $3b951febf8ab45a9$var$EXTRA_LOD_SIGMA[i - lodMax + $3b951febf8ab45a9$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new (0, $ce0cdebec9150cb3$export$b7be63a67df8959)();
        planes.setAttribute('position', new (0, $ce0cdebec9150cb3$export$8dea267bd6bde117)(position, positionSize));
        planes.setAttribute('uv', new (0, $ce0cdebec9150cb3$export$8dea267bd6bde117)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $ce0cdebec9150cb3$export$8dea267bd6bde117)(faceIndex, faceIndexSize));
        lodMeshes.push(new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(planes, null));
        if (lod > $3b951febf8ab45a9$var$LOD_MIN) lod--;
    }
    return {
        lodMeshes: lodMeshes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $3b951febf8ab45a9$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $ce0cdebec9150cb3$export$dbf3e70ff37af79);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $3b951febf8ab45a9$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $3b951febf8ab45a9$var$_getGGXShader(lodMax, width, height) {
    const shaderMaterial = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
        name: 'PMREMGGXConvolution',
        defines: {
            'GGX_SAMPLES': $3b951febf8ab45a9$var$GGX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'roughness': {
                value: 0.0
            },
            'mipInt': {
                value: 0
            }
        },
        vertexShader: $3b951febf8ab45a9$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 4.1: Orthonormal basis
				vec3 T1 = vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(V, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + V.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * V;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`,
        blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $3b951febf8ab45a9$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($3b951febf8ab45a9$var$MAX_SAMPLES);
    const poleAxis = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 1, 0);
    const shaderMaterial = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $3b951febf8ab45a9$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $3b951febf8ab45a9$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $3b951febf8ab45a9$var$_getEquirectMaterial() {
    return new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $3b951febf8ab45a9$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $3b951febf8ab45a9$var$_getCubemapMaterial() {
    return new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $3b951febf8ab45a9$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $3b951febf8ab45a9$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
/**
 * A cube render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $3b951febf8ab45a9$export$ac386671d651941e extends (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f) {
    /**
	 * Constructs a new cube render target.
	 *
	 * @param {number} [size=1] - The size of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(size = 1, options = {}){
        super(size, size, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new (0, $ce0cdebec9150cb3$export$ee2e5a18258a4049)(images);
        this._setTextureOptions(options);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
    }
    /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {WebGLCubeRenderTarget} A reference to this cube render target.
	 */ fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new (0, $ce0cdebec9150cb3$export$33e43285f7406bd5)(5, 5, 5);
        const material = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
            name: 'CubemapFromEquirect',
            uniforms: (0, $ce0cdebec9150cb3$export$acda854380553452)(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace),
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba)
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === (0, $ce0cdebec9150cb3$export$5d8599b6a933fb1b)) texture.minFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
        const camera = new (0, $ce0cdebec9150cb3$export$d0cdd0bd804995de)(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    /**
	 * Clears this cube render target.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(renderer, color = true, depth = true, stencil = true) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
function $3b951febf8ab45a9$var$WebGLEnvironments(renderer) {
    let cubeMaps = new WeakMap();
    let pmremMaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture, usePMREM = false) {
        if (texture === null || texture === undefined) return null;
        if (usePMREM) return getPMREM(texture);
        return getCube(texture);
    }
    function getCube(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === (0, $ce0cdebec9150cb3$export$d64030b316d3b087) || mapping === (0, $ce0cdebec9150cb3$export$ee99d97d46898098)) {
                if (cubeMaps.has(texture)) {
                    const cubemap = cubeMaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $3b951febf8ab45a9$export$ac386671d651941e(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubeMaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onCubemapDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function getPMREM(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === (0, $ce0cdebec9150cb3$export$d64030b316d3b087) || mapping === (0, $ce0cdebec9150cb3$export$ee99d97d46898098);
            const isCubeMap = mapping === (0, $ce0cdebec9150cb3$export$8759762a6477f2c4) || mapping === (0, $ce0cdebec9150cb3$export$dc59f8aed047f61d);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = pmremMaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $3b951febf8ab45a9$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    pmremMaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $3b951febf8ab45a9$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            pmremMaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onPMREMDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $ce0cdebec9150cb3$export$d64030b316d3b087)) texture.mapping = (0, $ce0cdebec9150cb3$export$8759762a6477f2c4);
        else if (mapping === (0, $ce0cdebec9150cb3$export$ee99d97d46898098)) texture.mapping = (0, $ce0cdebec9150cb3$export$dc59f8aed047f61d);
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onCubemapDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onCubemapDispose);
        const cubemap = cubeMaps.get(texture);
        if (cubemap !== undefined) {
            cubeMaps.delete(texture);
            cubemap.dispose();
        }
    }
    function onPMREMDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onPMREMDispose);
        const pmrem = pmremMaps.get(texture);
        if (pmrem !== undefined) {
            pmremMaps.delete(texture);
            pmrem.dispose();
        }
    }
    function dispose() {
        cubeMaps = new WeakMap();
        pmremMaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $3b951febf8ab45a9$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        const extension = gl.getExtension(name);
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) (0, $ce0cdebec9150cb3$export$5b28268982f175ba)('WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $3b951febf8ab45a9$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryPosition === undefined) return;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        // check whether a 32 bit or 16 bit buffer is required to store the indices
        // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
        const attribute = new (geometryPosition.count >= 65535 ? (0, $ce0cdebec9150cb3$export$7eb8c9fa25cd5bd6) : (0, $ce0cdebec9150cb3$export$640a853f68025f2e))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $3b951febf8ab45a9$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $3b951febf8ab45a9$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $3b951febf8ab45a9$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new (0, $ce0cdebec9150cb3$export$dfac6c8e811406a3)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $ce0cdebec9150cb3$export$f6d331659b644596);
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $3b951febf8ab45a9$var$WebGLObjects(gl, geometries, attributes, bindingStates, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        bindingStates.releaseStatesOfObject(instancedMesh);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
const $3b951febf8ab45a9$var$toneMappingMap = {
    [(0, $ce0cdebec9150cb3$export$98f52c2a46c598ca)]: 'LINEAR_TONE_MAPPING',
    [(0, $ce0cdebec9150cb3$export$74b25e54b3bcd548)]: 'REINHARD_TONE_MAPPING',
    [(0, $ce0cdebec9150cb3$export$932b3dd283d4a366)]: 'CINEON_TONE_MAPPING',
    [(0, $ce0cdebec9150cb3$export$a0d98fe6d7e4af64)]: 'ACES_FILMIC_TONE_MAPPING',
    [(0, $ce0cdebec9150cb3$export$212d53a513a325b2)]: 'AGX_TONE_MAPPING',
    [(0, $ce0cdebec9150cb3$export$f2863e1668a8e317)]: 'NEUTRAL_TONE_MAPPING',
    [(0, $ce0cdebec9150cb3$export$2c7b09c1e9abfb5e)]: 'CUSTOM_TONE_MAPPING'
};
function $3b951febf8ab45a9$var$WebGLOutput(type, width, height, depth, stencil) {
    // render targets for scene and post-processing
    const targetA = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(width, height, {
        type: type,
        depthBuffer: depth,
        stencilBuffer: stencil
    });
    const targetB = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(width, height, {
        type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
        depthBuffer: false,
        stencilBuffer: false
    });
    // create fullscreen triangle geometry
    const geometry = new (0, $ce0cdebec9150cb3$export$b7be63a67df8959)();
    geometry.setAttribute('position', new (0, $ce0cdebec9150cb3$export$cbe7a62641830ebd)([
        -1,
        3,
        0,
        -1,
        -1,
        0,
        3,
        -1,
        0
    ], 3));
    geometry.setAttribute('uv', new (0, $ce0cdebec9150cb3$export$cbe7a62641830ebd)([
        0,
        2,
        0,
        0,
        2,
        0
    ], 2));
    // create output material with tone mapping support
    const material = new (0, $ce0cdebec9150cb3$export$21c421a2e1df9d22)({
        uniforms: {
            tDiffuse: {
                value: null
            }
        },
        vertexShader: /* glsl */ `
			precision highp float;

			uniform mat4 modelViewMatrix;
			uniform mat4 projectionMatrix;

			attribute vec3 position;
			attribute vec2 uv;

			varying vec2 vUv;

			void main() {
				vUv = uv;
				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
			}`,
        fragmentShader: /* glsl */ `
			precision highp float;

			uniform sampler2D tDiffuse;

			varying vec2 vUv;

			#include <tonemapping_pars_fragment>
			#include <colorspace_pars_fragment>

			void main() {
				gl_FragColor = texture2D( tDiffuse, vUv );

				#ifdef LINEAR_TONE_MAPPING
					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );
				#elif defined( REINHARD_TONE_MAPPING )
					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );
				#elif defined( CINEON_TONE_MAPPING )
					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );
				#elif defined( ACES_FILMIC_TONE_MAPPING )
					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );
				#elif defined( AGX_TONE_MAPPING )
					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );
				#elif defined( NEUTRAL_TONE_MAPPING )
					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );
				#elif defined( CUSTOM_TONE_MAPPING )
					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );
				#endif

				#ifdef SRGB_TRANSFER
					gl_FragColor = sRGBTransferOETF( gl_FragColor );
				#endif
			}`,
        depthTest: false,
        depthWrite: false
    });
    const mesh = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(geometry, material);
    const camera = new (0, $ce0cdebec9150cb3$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
    let _outputColorSpace = null;
    let _outputToneMapping = null;
    let _isCompositing = false;
    let _savedToneMapping;
    let _savedRenderTarget = null;
    let _effects = [];
    let _hasRenderPass = false;
    this.setSize = function(width, height) {
        targetA.setSize(width, height);
        targetB.setSize(width, height);
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.setSize) effect.setSize(width, height);
        }
    };
    this.setEffects = function(effects) {
        _effects = effects;
        _hasRenderPass = _effects.length > 0 && _effects[0].isRenderPass === true;
        const width = targetA.width;
        const height = targetA.height;
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.setSize) effect.setSize(width, height);
        }
    };
    this.begin = function(renderer, renderTarget) {
        // Don't begin during compositing phase (post-processing effects call render())
        if (_isCompositing) return false;
        if (renderer.toneMapping === (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2) && _effects.length === 0) return false;
        _savedRenderTarget = renderTarget;
        // resize internal buffers to match render target (e.g. XR resolution)
        if (renderTarget !== null) {
            const width = renderTarget.width;
            const height = renderTarget.height;
            if (targetA.width !== width || targetA.height !== height) this.setSize(width, height);
        }
        // if first effect is a RenderPass, it will set its own render target
        if (_hasRenderPass === false) renderer.setRenderTarget(targetA);
        // disable tone mapping during render - it will be applied in end()
        _savedToneMapping = renderer.toneMapping;
        renderer.toneMapping = (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2);
        return true;
    };
    this.hasRenderPass = function() {
        return _hasRenderPass;
    };
    this.end = function(renderer, deltaTime) {
        // restore tone mapping
        renderer.toneMapping = _savedToneMapping;
        _isCompositing = true;
        // run post-processing effects
        let readBuffer = targetA;
        let writeBuffer = targetB;
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.enabled === false) continue;
            effect.render(renderer, writeBuffer, readBuffer, deltaTime);
            if (effect.needsSwap !== false) {
                const temp = readBuffer;
                readBuffer = writeBuffer;
                writeBuffer = temp;
            }
        }
        // update output material defines if settings changed
        if (_outputColorSpace !== renderer.outputColorSpace || _outputToneMapping !== renderer.toneMapping) {
            _outputColorSpace = renderer.outputColorSpace;
            _outputToneMapping = renderer.toneMapping;
            material.defines = {};
            if ((0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getTransfer(_outputColorSpace) === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb)) material.defines.SRGB_TRANSFER = '';
            const toneMapping = $3b951febf8ab45a9$var$toneMappingMap[_outputToneMapping];
            if (toneMapping) material.defines[toneMapping] = '';
            material.needsUpdate = true;
        }
        // final output to canvas (or XR render target)
        material.uniforms.tDiffuse.value = readBuffer.texture;
        renderer.setRenderTarget(_savedRenderTarget);
        renderer.render(mesh, camera);
        _savedRenderTarget = null;
        _isCompositing = false;
    };
    this.isCompositing = function() {
        return _isCompositing;
    };
    this.dispose = function() {
        targetA.dispose();
        targetB.dispose();
        geometry.dispose();
        material.dispose();
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $3b951febf8ab45a9$var$emptyTexture = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$5431306cf43de24a)();
const $3b951febf8ab45a9$var$emptyShadowTexture = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)(1, 1);
const $3b951febf8ab45a9$var$emptyArrayTexture = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$dfac6c8e811406a3)();
const $3b951febf8ab45a9$var$empty3dTexture = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$d7a3086320f856db)();
const $3b951febf8ab45a9$var$emptyCubeTexture = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$ee2e5a18258a4049)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $3b951febf8ab45a9$var$arrayCacheF32 = [];
const $3b951febf8ab45a9$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $3b951febf8ab45a9$var$mat4array = new Float32Array(16);
const $3b951febf8ab45a9$var$mat3array = new Float32Array(9);
const $3b951febf8ab45a9$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $3b951febf8ab45a9$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $3b951febf8ab45a9$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $3b951febf8ab45a9$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $3b951febf8ab45a9$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $3b951febf8ab45a9$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $3b951febf8ab45a9$var$allocTexUnits(textures, n) {
    let r = $3b951febf8ab45a9$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $3b951febf8ab45a9$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $3b951febf8ab45a9$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $3b951febf8ab45a9$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    }
}
function $3b951febf8ab45a9$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    }
}
function $3b951febf8ab45a9$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $3b951febf8ab45a9$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, elements)) return;
        $3b951febf8ab45a9$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $3b951febf8ab45a9$var$mat2array);
        $3b951febf8ab45a9$var$copyArray(cache, elements);
    }
}
function $3b951febf8ab45a9$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, elements)) return;
        $3b951febf8ab45a9$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $3b951febf8ab45a9$var$mat3array);
        $3b951febf8ab45a9$var$copyArray(cache, elements);
    }
}
function $3b951febf8ab45a9$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, elements)) return;
        $3b951febf8ab45a9$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $3b951febf8ab45a9$var$mat4array);
        $3b951febf8ab45a9$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $3b951febf8ab45a9$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $3b951febf8ab45a9$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    }
}
function $3b951febf8ab45a9$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    }
}
function $3b951febf8ab45a9$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $3b951febf8ab45a9$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $3b951febf8ab45a9$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    }
}
function $3b951febf8ab45a9$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    }
}
function $3b951febf8ab45a9$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($3b951febf8ab45a9$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $3b951febf8ab45a9$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $3b951febf8ab45a9$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $3b951febf8ab45a9$var$emptyShadowTexture.compareFunction = textures.isReversedDepthBuffer() ? (0, $ce0cdebec9150cb3$export$1cdcb70d53d65f61) : (0, $ce0cdebec9150cb3$export$64eea11eb407ddf1);
        emptyTexture2D = $3b951febf8ab45a9$var$emptyShadowTexture;
    } else emptyTexture2D = $3b951febf8ab45a9$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $3b951febf8ab45a9$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $3b951febf8ab45a9$var$empty3dTexture, unit);
}
function $3b951febf8ab45a9$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $3b951febf8ab45a9$var$emptyCubeTexture, unit);
}
function $3b951febf8ab45a9$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $3b951febf8ab45a9$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $3b951febf8ab45a9$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $3b951febf8ab45a9$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $3b951febf8ab45a9$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $3b951febf8ab45a9$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $3b951febf8ab45a9$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $3b951febf8ab45a9$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $3b951febf8ab45a9$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $3b951febf8ab45a9$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $3b951febf8ab45a9$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $3b951febf8ab45a9$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $3b951febf8ab45a9$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $3b951febf8ab45a9$var$setValueV4i; // _VEC4
        case 0x1405:
            return $3b951febf8ab45a9$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $3b951febf8ab45a9$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $3b951febf8ab45a9$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $3b951febf8ab45a9$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $3b951febf8ab45a9$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $3b951febf8ab45a9$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $3b951febf8ab45a9$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $3b951febf8ab45a9$var$setValueT2DArray1;
    }
}
// Array of scalars
function $3b951febf8ab45a9$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $3b951febf8ab45a9$var$setValueV2fArray(gl, v) {
    const data = $3b951febf8ab45a9$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $3b951febf8ab45a9$var$setValueV3fArray(gl, v) {
    const data = $3b951febf8ab45a9$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $3b951febf8ab45a9$var$setValueV4fArray(gl, v) {
    const data = $3b951febf8ab45a9$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $3b951febf8ab45a9$var$setValueM2Array(gl, v) {
    const data = $3b951febf8ab45a9$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $3b951febf8ab45a9$var$setValueM3Array(gl, v) {
    const data = $3b951febf8ab45a9$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $3b951febf8ab45a9$var$setValueM4Array(gl, v) {
    const data = $3b951febf8ab45a9$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $3b951febf8ab45a9$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $3b951febf8ab45a9$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $3b951febf8ab45a9$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $3b951febf8ab45a9$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $3b951febf8ab45a9$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $3b951febf8ab45a9$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $3b951febf8ab45a9$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $3b951febf8ab45a9$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $3b951febf8ab45a9$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $3b951febf8ab45a9$var$allocTexUnits(textures, n);
    if (!$3b951febf8ab45a9$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $3b951febf8ab45a9$var$copyArray(cache, units);
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) emptyTexture2D = $3b951febf8ab45a9$var$emptyShadowTexture;
    else emptyTexture2D = $3b951febf8ab45a9$var$emptyTexture;
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || emptyTexture2D, units[i]);
}
function $3b951febf8ab45a9$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $3b951febf8ab45a9$var$allocTexUnits(textures, n);
    if (!$3b951febf8ab45a9$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $3b951febf8ab45a9$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $3b951febf8ab45a9$var$empty3dTexture, units[i]);
}
function $3b951febf8ab45a9$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $3b951febf8ab45a9$var$allocTexUnits(textures, n);
    if (!$3b951febf8ab45a9$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $3b951febf8ab45a9$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $3b951febf8ab45a9$var$emptyCubeTexture, units[i]);
}
function $3b951febf8ab45a9$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $3b951febf8ab45a9$var$allocTexUnits(textures, n);
    if (!$3b951febf8ab45a9$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $3b951febf8ab45a9$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $3b951febf8ab45a9$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $3b951febf8ab45a9$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $3b951febf8ab45a9$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $3b951febf8ab45a9$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $3b951febf8ab45a9$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $3b951febf8ab45a9$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $3b951febf8ab45a9$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $3b951febf8ab45a9$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $3b951febf8ab45a9$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $3b951febf8ab45a9$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $3b951febf8ab45a9$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $3b951febf8ab45a9$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $3b951febf8ab45a9$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $3b951febf8ab45a9$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $3b951febf8ab45a9$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $3b951febf8ab45a9$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $3b951febf8ab45a9$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $3b951febf8ab45a9$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $3b951febf8ab45a9$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $3b951febf8ab45a9$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $3b951febf8ab45a9$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $3b951febf8ab45a9$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $3b951febf8ab45a9$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $3b951febf8ab45a9$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $3b951febf8ab45a9$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $3b951febf8ab45a9$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $3b951febf8ab45a9$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $3b951febf8ab45a9$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $3b951febf8ab45a9$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $3b951febf8ab45a9$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $3b951febf8ab45a9$var$RePathPart.exec(path), matchEnd = $3b951febf8ab45a9$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $3b951febf8ab45a9$var$addUniform(container, subscript === undefined ? new $3b951febf8ab45a9$var$SingleUniform(id, activeInfo, addr) : new $3b951febf8ab45a9$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $3b951febf8ab45a9$var$StructuredUniform(id);
                $3b951febf8ab45a9$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $3b951febf8ab45a9$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $3b951febf8ab45a9$var$parseUniform(info, addr, this);
        }
        // Sort uniforms to prioritize shadow samplers first (for optimal texture unit allocation)
        const shadowSamplers = [];
        const otherUniforms = [];
        for (const u of this.seq)if (u.type === gl.SAMPLER_2D_SHADOW || u.type === gl.SAMPLER_CUBE_SHADOW || u.type === gl.SAMPLER_2D_ARRAY_SHADOW) shadowSamplers.push(u);
        else otherUniforms.push(u);
        if (shadowSamplers.length > 0) this.seq = shadowSamplers.concat(otherUniforms);
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $3b951febf8ab45a9$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $3b951febf8ab45a9$var$COMPLETION_STATUS_KHR = 0x91B1;
let $3b951febf8ab45a9$var$programIdCount = 0;
function $3b951febf8ab45a9$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const $3b951febf8ab45a9$var$_m0 = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)();
function $3b951febf8ab45a9$var$getEncodingComponents(colorSpace) {
    (0, $ce0cdebec9150cb3$export$5e6fd513f44698c)._getMatrix($3b951febf8ab45a9$var$_m0, (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${$3b951febf8ab45a9$var$_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch((0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getTransfer(colorSpace)){
        case 0, $ce0cdebec9150cb3$export$f197347d588c1b4a:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $ce0cdebec9150cb3$export$8d0a61916cc26abb:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $3b951febf8ab45a9$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const shaderInfoLog = gl.getShaderInfoLog(shader) || '';
    const errors = shaderInfoLog.trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $3b951febf8ab45a9$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $3b951febf8ab45a9$var$getTexelEncodingFunction(functionName, colorSpace) {
    const components = $3b951febf8ab45a9$var$getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
const $3b951febf8ab45a9$var$toneMappingFunctions = {
    [(0, $ce0cdebec9150cb3$export$98f52c2a46c598ca)]: 'Linear',
    [(0, $ce0cdebec9150cb3$export$74b25e54b3bcd548)]: 'Reinhard',
    [(0, $ce0cdebec9150cb3$export$932b3dd283d4a366)]: 'Cineon',
    [(0, $ce0cdebec9150cb3$export$a0d98fe6d7e4af64)]: 'ACESFilmic',
    [(0, $ce0cdebec9150cb3$export$212d53a513a325b2)]: 'AgX',
    [(0, $ce0cdebec9150cb3$export$f2863e1668a8e317)]: 'Neutral',
    [(0, $ce0cdebec9150cb3$export$2c7b09c1e9abfb5e)]: 'Custom'
};
function $3b951febf8ab45a9$var$getToneMappingFunction(functionName, toneMapping) {
    const toneMappingName = $3b951febf8ab45a9$var$toneMappingFunctions[toneMapping];
    if (toneMappingName === undefined) {
        (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLProgram: Unsupported toneMapping:', toneMapping);
        return 'vec3 ' + functionName + '( vec3 color ) { return LinearToneMapping( color ); }';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $3b951febf8ab45a9$var$_v0 = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
function $3b951febf8ab45a9$var$getLuminanceFunction() {
    (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getLuminanceCoefficients($3b951febf8ab45a9$var$_v0);
    const r = $3b951febf8ab45a9$var$_v0.x.toFixed(4);
    const g = $3b951febf8ab45a9$var$_v0.y.toFixed(4);
    const b = $3b951febf8ab45a9$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $3b951febf8ab45a9$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($3b951febf8ab45a9$var$filterEmptyLine).join('\n');
}
function $3b951febf8ab45a9$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $3b951febf8ab45a9$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // log( 'WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $3b951febf8ab45a9$var$filterEmptyLine(string) {
    return string !== '';
}
function $3b951febf8ab45a9$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $3b951febf8ab45a9$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $3b951febf8ab45a9$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $3b951febf8ab45a9$var$resolveIncludes(string) {
    return string.replace($3b951febf8ab45a9$var$includePattern, $3b951febf8ab45a9$var$includeReplacer);
}
const $3b951febf8ab45a9$var$shaderChunkMap = new Map();
function $3b951febf8ab45a9$var$includeReplacer(match, include) {
    let string = $3b951febf8ab45a9$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $3b951febf8ab45a9$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $3b951febf8ab45a9$export$955f9f2e84c43c8b[newInclude];
            (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $3b951febf8ab45a9$var$resolveIncludes(string);
}
// Unroll Loops
const $3b951febf8ab45a9$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $3b951febf8ab45a9$var$unrollLoops(string) {
    return string.replace($3b951febf8ab45a9$var$unrollLoopPattern, $3b951febf8ab45a9$var$loopReplacer);
}
function $3b951febf8ab45a9$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $3b951febf8ab45a9$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
const $3b951febf8ab45a9$var$shadowMapTypeDefines = {
    [(0, $ce0cdebec9150cb3$export$5813f879eee7cd88)]: 'SHADOWMAP_TYPE_PCF',
    [(0, $ce0cdebec9150cb3$export$896ae1ade6c829c4)]: 'SHADOWMAP_TYPE_VSM'
};
function $3b951febf8ab45a9$var$generateShadowMapTypeDefine(parameters) {
    return $3b951febf8ab45a9$var$shadowMapTypeDefines[parameters.shadowMapType] || 'SHADOWMAP_TYPE_BASIC';
}
const $3b951febf8ab45a9$var$envMapTypeDefines = {
    [(0, $ce0cdebec9150cb3$export$8759762a6477f2c4)]: 'ENVMAP_TYPE_CUBE',
    [(0, $ce0cdebec9150cb3$export$dc59f8aed047f61d)]: 'ENVMAP_TYPE_CUBE',
    [(0, $ce0cdebec9150cb3$export$dbf3e70ff37af79)]: 'ENVMAP_TYPE_CUBE_UV'
};
function $3b951febf8ab45a9$var$generateEnvMapTypeDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_TYPE_CUBE';
    return $3b951febf8ab45a9$var$envMapTypeDefines[parameters.envMapMode] || 'ENVMAP_TYPE_CUBE';
}
const $3b951febf8ab45a9$var$envMapModeDefines = {
    [(0, $ce0cdebec9150cb3$export$dc59f8aed047f61d)]: 'ENVMAP_MODE_REFRACTION'
};
function $3b951febf8ab45a9$var$generateEnvMapModeDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_MODE_REFLECTION';
    return $3b951febf8ab45a9$var$envMapModeDefines[parameters.envMapMode] || 'ENVMAP_MODE_REFLECTION';
}
const $3b951febf8ab45a9$var$envMapBlendingDefines = {
    [(0, $ce0cdebec9150cb3$export$e50ac29801f1774d)]: 'ENVMAP_BLENDING_MULTIPLY',
    [(0, $ce0cdebec9150cb3$export$9f9d94f963c85479)]: 'ENVMAP_BLENDING_MIX',
    [(0, $ce0cdebec9150cb3$export$e641dc52bc3494aa)]: 'ENVMAP_BLENDING_ADD'
};
function $3b951febf8ab45a9$var$generateEnvMapBlendingDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_BLENDING_NONE';
    return $3b951febf8ab45a9$var$envMapBlendingDefines[parameters.combine] || 'ENVMAP_BLENDING_NONE';
}
function $3b951febf8ab45a9$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $3b951febf8ab45a9$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $3b951febf8ab45a9$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $3b951febf8ab45a9$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $3b951febf8ab45a9$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $3b951febf8ab45a9$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $3b951febf8ab45a9$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $3b951febf8ab45a9$var$generateVertexExtensions(parameters);
    const customDefines = $3b951febf8ab45a9$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($3b951febf8ab45a9$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($3b951febf8ab45a9$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $3b951febf8ab45a9$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($3b951febf8ab45a9$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $3b951febf8ab45a9$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas || parameters.batchingColor ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2) ? $3b951febf8ab45a9$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2) ? $3b951febf8ab45a9$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $3b951febf8ab45a9$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $3b951febf8ab45a9$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $3b951febf8ab45a9$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($3b951febf8ab45a9$var$filterEmptyLine).join('\n');
    }
    vertexShader = $3b951febf8ab45a9$var$resolveIncludes(vertexShader);
    vertexShader = $3b951febf8ab45a9$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $3b951febf8ab45a9$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $3b951febf8ab45a9$var$resolveIncludes(fragmentShader);
    fragmentShader = $3b951febf8ab45a9$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $3b951febf8ab45a9$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $3b951febf8ab45a9$var$unrollLoops(vertexShader);
    fragmentShader = $3b951febf8ab45a9$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $ce0cdebec9150cb3$export$f63012db5506e7dd) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $ce0cdebec9150cb3$export$f63012db5506e7dd) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // log( '*VERTEX*', vertexGlsl );
    // log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $3b951febf8ab45a9$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $3b951febf8ab45a9$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programInfoLog = gl.getProgramInfoLog(program) || '';
            const vertexShaderInfoLog = gl.getShaderInfoLog(glVertexShader) || '';
            const fragmentShaderInfoLog = gl.getShaderInfoLog(glFragmentShader) || '';
            const programLog = programInfoLog.trim();
            const vertexLog = vertexShaderInfoLog.trim();
            const fragmentLog = fragmentShaderInfoLog.trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $3b951febf8ab45a9$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $3b951febf8ab45a9$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $3b951febf8ab45a9$var$WebGLUniforms(gl, program);
        cachedAttributes = $3b951febf8ab45a9$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $3b951febf8ab45a9$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $3b951febf8ab45a9$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $3b951febf8ab45a9$var$_id = 0;
class $3b951febf8ab45a9$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $3b951febf8ab45a9$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $3b951febf8ab45a9$var$WebGLShaderStage {
    constructor(code){
        this.id = $3b951febf8ab45a9$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $3b951febf8ab45a9$var$WebGLPrograms(renderer, environments, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new (0, $ce0cdebec9150cb3$export$89312ce47c0ca777)();
    const _customShaders = new $3b951febf8ab45a9$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const programsMap = new Map();
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distance',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial || material.isMeshLambertMaterial || material.isMeshPhongMaterial ? scene.environment : null;
        const usePMREM = material.isMeshStandardMaterial || material.isMeshLambertMaterial && !material.envMap || material.isMeshPhongMaterial && !material.envMap;
        const envMap = environments.get(material.envMap || environment, usePMREM);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $ce0cdebec9150cb3$export$dbf3e70ff37af79) ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $3b951febf8ab45a9$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $ce0cdebec9150cb3$export$42429b3acfb233a4),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $ce0cdebec9150cb3$export$9990ad26f9db5b2c),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $ce0cdebec9150cb3$export$2852a58ebdac27b8),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $ce0cdebec9150cb3$export$5b29a26d96ee6af0) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.wireframe === false && (material.flatShading === true || geometry.attributes.normal === undefined && HAS_NORMALMAP === false && (material.isMeshLambertMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isMeshPhysicalMaterial)),
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reversedDepthBuffer: reversedDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getTransfer(material.map.colorSpace) === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getTransfer(material.emissiveMap.colorSpace) === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03),
            flipSided: material.side === (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.instancing) _programLayers.enable(0);
        if (parameters.instancingColor) _programLayers.enable(1);
        if (parameters.instancingMorph) _programLayers.enable(2);
        if (parameters.matcap) _programLayers.enable(3);
        if (parameters.envMap) _programLayers.enable(4);
        if (parameters.normalMapObjectSpace) _programLayers.enable(5);
        if (parameters.normalMapTangentSpace) _programLayers.enable(6);
        if (parameters.clearcoat) _programLayers.enable(7);
        if (parameters.iridescence) _programLayers.enable(8);
        if (parameters.alphaTest) _programLayers.enable(9);
        if (parameters.vertexColors) _programLayers.enable(10);
        if (parameters.vertexAlphas) _programLayers.enable(11);
        if (parameters.vertexUv1s) _programLayers.enable(12);
        if (parameters.vertexUv2s) _programLayers.enable(13);
        if (parameters.vertexUv3s) _programLayers.enable(14);
        if (parameters.vertexTangents) _programLayers.enable(15);
        if (parameters.anisotropy) _programLayers.enable(16);
        if (parameters.alphaHash) _programLayers.enable(17);
        if (parameters.batching) _programLayers.enable(18);
        if (parameters.dispersion) _programLayers.enable(19);
        if (parameters.batchingColor) _programLayers.enable(20);
        if (parameters.gradientMap) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reversedDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $3b951febf8ab45a9$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $ce0cdebec9150cb3$export$d8ecdf8615bfea69).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program = programsMap.get(cacheKey);
        if (program !== undefined) ++program.usedTimes;
        else {
            program = new $3b951febf8ab45a9$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
            programsMap.set(cacheKey, program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Remove from map
            programsMap.delete(program.cacheKey);
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $3b951febf8ab45a9$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $3b951febf8ab45a9$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.materialVariant !== b.materialVariant) return a.materialVariant - b.materialVariant;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $3b951febf8ab45a9$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $3b951febf8ab45a9$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function materialVariant(object) {
        let variant = 0;
        if (object.isInstancedMesh) variant += 2;
        if (object.isSkinnedMesh) variant += 1;
        return variant;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                materialVariant: materialVariant(object),
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.materialVariant = materialVariant(object);
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $3b951febf8ab45a9$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $3b951febf8ab45a9$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $3b951febf8ab45a9$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $3b951febf8ab45a9$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $3b951febf8ab45a9$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $3b951febf8ab45a9$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $3b951febf8ab45a9$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(),
                        color: new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(),
                        direction: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(),
                        color: new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(),
                        color: new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(),
                        skyColor: new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(),
                        groundColor: new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(),
                        position: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(),
                        halfWidth: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(),
                        halfHeight: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $3b951febf8ab45a9$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $3b951febf8ab45a9$var$nextVersion = 0;
function $3b951febf8ab45a9$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $3b951febf8ab45a9$var$WebGLLights(extensions) {
    const cache = new $3b951febf8ab45a9$var$UniformsCache();
    const shadowCache = $3b951febf8ab45a9$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)());
    const vector3 = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
    const matrix4 = new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
    const matrix42 = new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($3b951febf8ab45a9$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            let shadowMap = null;
            if (light.shadow && light.shadow.map) {
                if (light.shadow.map.texture.format === (0, $ce0cdebec9150cb3$export$6cdf0b461c7ce8a0)) // VSM uses color texture with blurred mean/std_dev
                shadowMap = light.shadow.map.texture;
                else // Other types use depth texture
                shadowMap = light.shadow.map.depthTexture || light.shadow.map.texture;
            }
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $3b951febf8ab45a9$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $3b951febf8ab45a9$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $3b951febf8ab45a9$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $3b951febf8ab45a9$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $3b951febf8ab45a9$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $3b951febf8ab45a9$var$WebGLRenderState(extensions) {
    const lights = new $3b951febf8ab45a9$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $3b951febf8ab45a9$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $3b951febf8ab45a9$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $3b951febf8ab45a9$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $3b951febf8ab45a9$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $3b951febf8ab45a9$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );\n\tgl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );\n}";
const $3b951febf8ab45a9$var$_cubeDirections = [
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(1, 0, 0),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(-1, 0, 0),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 1, 0),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 0, 1),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 0, -1)
];
const $3b951febf8ab45a9$var$_cubeUps = [
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 0, 1),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 0, -1),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, -1, 0)
];
const $3b951febf8ab45a9$var$_projScreenMatrix = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
const $3b951febf8ab45a9$var$_lightPositionWorld = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
const $3b951febf8ab45a9$var$_lookTarget = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
function $3b951febf8ab45a9$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new (0, $ce0cdebec9150cb3$export$35efe6f4c85463d2)();
    const _shadowMapSize = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(), _viewportSize = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(), _viewport = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)(), _depthMaterial = new (0, $ce0cdebec9150cb3$export$2698c22ec13825db)(), _distanceMaterial = new (0, $ce0cdebec9150cb3$export$33e187ed002f2a19)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [(0, $ce0cdebec9150cb3$export$2ede184fc2998901)]: (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace),
        [(0, $ce0cdebec9150cb3$export$d9f0486e75b5ace)]: (0, $ce0cdebec9150cb3$export$2ede184fc2998901),
        [(0, $ce0cdebec9150cb3$export$3b296b6f144d5b03)]: (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03)
    };
    const shadowMaterialVertical = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $3b951febf8ab45a9$var$vertex,
        fragmentShader: $3b951febf8ab45a9$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new (0, $ce0cdebec9150cb3$export$b7be63a67df8959)();
    fullScreenTri.setAttribute('position', new (0, $ce0cdebec9150cb3$export$8dea267bd6bde117)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $ce0cdebec9150cb3$export$5813f879eee7cd88);
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        if (this.type === (0, $ce0cdebec9150cb3$export$a47c4b43a1be34f0)) {
            (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead.');
            this.type = (0, $ce0cdebec9150cb3$export$5813f879eee7cd88);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba));
        if (_state.buffers.depth.getReversed() === true) _state.buffers.color.setClear(0, 0, 0, 0);
        else _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const typeChanged = _previousType !== this.type;
        // When shadow map type changes, materials need recompilation because sampler types change
        // (sampler2DShadow for PCF vs sampler2D for Basic)
        if (typeChanged) scene.traverse(function(object) {
            if (object.material) {
                if (Array.isArray(object.material)) object.material.forEach((mat)=>mat.needsUpdate = true);
                else object.material.needsUpdate = true;
            }
        });
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
            shadow.camera._reversedDepth = reversedDepthBuffer;
            if (shadow.map === null || typeChanged === true) {
                if (shadow.map !== null) {
                    if (shadow.map.depthTexture !== null) {
                        shadow.map.depthTexture.dispose();
                        shadow.map.depthTexture = null;
                    }
                    shadow.map.dispose();
                }
                if (this.type === (0, $ce0cdebec9150cb3$export$896ae1ade6c829c4)) {
                    if (light.isPointLight) {
                        (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.');
                        continue;
                    }
                    shadow.map = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y, {
                        format: (0, $ce0cdebec9150cb3$export$6cdf0b461c7ce8a0),
                        type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
                        minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
                        magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
                        generateMipmaps: false
                    });
                    shadow.map.texture.name = light.name + '.shadowMap';
                    // Native depth texture for VSM - depth is captured here, then blurred into the color texture
                    shadow.map.depthTexture = new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)(_shadowMapSize.x, _shadowMapSize.y, (0, $ce0cdebec9150cb3$export$f6d331659b644596));
                    shadow.map.depthTexture.name = light.name + '.shadowMapDepth';
                    shadow.map.depthTexture.format = (0, $ce0cdebec9150cb3$export$c1b6b5136be58045);
                    shadow.map.depthTexture.compareFunction = null; // For regular sampling (not shadow comparison)
                    shadow.map.depthTexture.minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
                    shadow.map.depthTexture.magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
                } else {
                    if (light.isPointLight) {
                        shadow.map = new $3b951febf8ab45a9$export$ac386671d651941e(_shadowMapSize.x);
                        shadow.map.depthTexture = new (0, $ce0cdebec9150cb3$export$c9f39eef7fb1d170)(_shadowMapSize.x, (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96));
                    } else {
                        shadow.map = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y);
                        shadow.map.depthTexture = new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)(_shadowMapSize.x, _shadowMapSize.y, (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96));
                    }
                    shadow.map.depthTexture.name = light.name + '.shadowMap';
                    shadow.map.depthTexture.format = (0, $ce0cdebec9150cb3$export$c1b6b5136be58045);
                    if (this.type === (0, $ce0cdebec9150cb3$export$5813f879eee7cd88)) {
                        shadow.map.depthTexture.compareFunction = reversedDepthBuffer ? (0, $ce0cdebec9150cb3$export$1cdcb70d53d65f61) : (0, $ce0cdebec9150cb3$export$64eea11eb407ddf1);
                        shadow.map.depthTexture.minFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
                        shadow.map.depthTexture.magFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
                    } else {
                        shadow.map.depthTexture.compareFunction = null;
                        shadow.map.depthTexture.minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
                        shadow.map.depthTexture.magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
                    }
                }
                shadow.camera.updateProjectionMatrix();
            }
            // For cube render targets (PointLights), render all 6 faces. Otherwise, render once.
            const faceCount = shadow.map.isWebGLCubeRenderTarget ? 6 : 1;
            for(let face = 0; face < faceCount; face++){
                // For cube render targets, render to each face separately
                if (shadow.map.isWebGLCubeRenderTarget) {
                    renderer.setRenderTarget(shadow.map, face);
                    renderer.clear();
                } else {
                    // For 2D render targets, use viewports
                    if (face === 0) {
                        renderer.setRenderTarget(shadow.map);
                        renderer.clear();
                    }
                    const viewport = shadow.getViewport(face);
                    _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                    _state.viewport(_viewport);
                }
                if (light.isPointLight) {
                    const camera = shadow.camera;
                    const shadowMatrix = shadow.matrix;
                    const far = light.distance || camera.far;
                    if (far !== camera.far) {
                        camera.far = far;
                        camera.updateProjectionMatrix();
                    }
                    $3b951febf8ab45a9$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
                    camera.position.copy($3b951febf8ab45a9$var$_lightPositionWorld);
                    $3b951febf8ab45a9$var$_lookTarget.copy(camera.position);
                    $3b951febf8ab45a9$var$_lookTarget.add($3b951febf8ab45a9$var$_cubeDirections[face]);
                    camera.up.copy($3b951febf8ab45a9$var$_cubeUps[face]);
                    camera.lookAt($3b951febf8ab45a9$var$_lookTarget);
                    camera.updateMatrixWorld();
                    shadowMatrix.makeTranslation(-$3b951febf8ab45a9$var$_lightPositionWorld.x, -$3b951febf8ab45a9$var$_lightPositionWorld.y, -$3b951febf8ab45a9$var$_lightPositionWorld.z);
                    $3b951febf8ab45a9$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                    shadow._frustum.setFromProjectionMatrix($3b951febf8ab45a9$var$_projScreenMatrix, camera.coordinateSystem, camera.reversedDepth);
                } else shadow.updateMatrices(light);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $ce0cdebec9150cb3$export$896ae1ade6c829c4)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y, {
            format: (0, $ce0cdebec9150cb3$export$6cdf0b461c7ce8a0),
            type: (0, $ce0cdebec9150cb3$export$2697304443f382bc)
        });
        // vertical pass - read from native depth texture
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.depthTexture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0 || material.alphaToCoverage === true) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $ce0cdebec9150cb3$export$896ae1ade6c829c4)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaToCoverage === true ? 0.5 : material.alphaTest; // approximate alphaToCoverage by using a fixed alphaTest value
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $ce0cdebec9150cb3$export$896ae1ade6c829c4)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
function $3b951febf8ab45a9$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
        let currentColorMask = null;
        const currentColorClear = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentReversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(reversed) {
                if (currentReversed !== reversed) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    currentReversed = reversed;
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
            },
            getReversed: function() {
                return currentReversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentReversed) depthFunc = (0, $ce0cdebec9150cb3$export$611f4ad2374e11ff)[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $ce0cdebec9150cb3$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $ce0cdebec9150cb3$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $ce0cdebec9150cb3$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $ce0cdebec9150cb3$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $ce0cdebec9150cb3$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $ce0cdebec9150cb3$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $ce0cdebec9150cb3$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $ce0cdebec9150cb3$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    currentDepthClear = depth;
                    if (currentReversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                currentReversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)().fromArray(scissorParam);
    const currentViewport = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $ce0cdebec9150cb3$export$296f78a0b892f81a));
    setFlipSided(false);
    setCullFace((0, $ce0cdebec9150cb3$export$b9a7b4fc5cb15f9b));
    enable(gl.CULL_FACE);
    setBlending((0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [(0, $ce0cdebec9150cb3$export$20183a0484ce21a0)]: gl.FUNC_ADD,
        [(0, $ce0cdebec9150cb3$export$73e0df5177988548)]: gl.FUNC_SUBTRACT,
        [(0, $ce0cdebec9150cb3$export$28e582859cbec660)]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[0, $ce0cdebec9150cb3$export$c8c1508da8d0600c] = gl.MIN;
    equationToGL[0, $ce0cdebec9150cb3$export$99948c02fb51055f] = gl.MAX;
    const factorToGL = {
        [(0, $ce0cdebec9150cb3$export$2110f05edf778d3d)]: gl.ZERO,
        [(0, $ce0cdebec9150cb3$export$8805bad65e24940e)]: gl.ONE,
        [(0, $ce0cdebec9150cb3$export$7fbe15b28d28cf52)]: gl.SRC_COLOR,
        [(0, $ce0cdebec9150cb3$export$d5773124e86cf28c)]: gl.SRC_ALPHA,
        [(0, $ce0cdebec9150cb3$export$c05e2a1fc8609506)]: gl.SRC_ALPHA_SATURATE,
        [(0, $ce0cdebec9150cb3$export$ef5f2dd8ffac5574)]: gl.DST_COLOR,
        [(0, $ce0cdebec9150cb3$export$a78aed1ca2a87192)]: gl.DST_ALPHA,
        [(0, $ce0cdebec9150cb3$export$947829af9f2c17f6)]: gl.ONE_MINUS_SRC_COLOR,
        [(0, $ce0cdebec9150cb3$export$11d468cc7f19e971)]: gl.ONE_MINUS_SRC_ALPHA,
        [(0, $ce0cdebec9150cb3$export$56b85b2686ab16)]: gl.ONE_MINUS_DST_COLOR,
        [(0, $ce0cdebec9150cb3$export$5d0fe17fd8773bac)]: gl.ONE_MINUS_DST_ALPHA,
        [(0, $ce0cdebec9150cb3$export$7dd8f434fd59075)]: gl.CONSTANT_COLOR,
        [(0, $ce0cdebec9150cb3$export$99c8d898a9afbcee)]: gl.ONE_MINUS_CONSTANT_COLOR,
        [(0, $ce0cdebec9150cb3$export$310cd2be38d13b56)]: gl.CONSTANT_ALPHA,
        [(0, $ce0cdebec9150cb3$export$db77b8fbcf45dbf4)]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $ce0cdebec9150cb3$export$eda4864c68df1fa2)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $ce0cdebec9150cb3$export$20183a0484ce21a0) || currentBlendEquationAlpha !== (0, $ce0cdebec9150cb3$export$20183a0484ce21a0)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $ce0cdebec9150cb3$export$20183a0484ce21a0);
                    currentBlendEquationAlpha = (0, $ce0cdebec9150cb3$export$20183a0484ce21a0);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $ce0cdebec9150cb3$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $ce0cdebec9150cb3$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $ce0cdebec9150cb3$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $ce0cdebec9150cb3$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                        break;
                    default:
                        (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $ce0cdebec9150cb3$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $ce0cdebec9150cb3$export$777d8f9551c2216b:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                        break;
                    case 0, $ce0cdebec9150cb3$export$cdfa06f868e2e467:
                        (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true');
                        break;
                    case 0, $ce0cdebec9150cb3$export$4138e1c684b46a20:
                        (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState: MultiplyBlending requires material.premultipliedAlpha = true');
                        break;
                    default:
                        (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $ce0cdebec9150cb3$export$5b29a26d96ee6af0) && material.transparent === false ? setBlending((0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $ce0cdebec9150cb3$export$3237e1f2c1ea1f44)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $ce0cdebec9150cb3$export$b9a7b4fc5cb15f9b)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $ce0cdebec9150cb3$export$b8058bcc7037d3f3)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
                if (depthBuffer.getReversed()) factor = -factor;
                gl.polygonOffset(factor, units);
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D(...arguments);
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $3b951febf8ab45a9$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : (0, $ce0cdebec9150cb3$export$7094a064528c7fee)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
            if (glType === _gl.UNSIGNED_INT_10F_11F_11F_REV) internalFormat = _gl.R11F_G11F_B10F;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $ce0cdebec9150cb3$export$f197347d588c1b4a) : (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96) || depthType === (0, $ce0cdebec9150cb3$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $ce0cdebec9150cb3$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $ce0cdebec9150cb3$export$c63dc51868b06a9d)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96) || depthType === (0, $ce0cdebec9150cb3$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $ce0cdebec9150cb3$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $ce0cdebec9150cb3$export$c63dc51868b06a9d)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0) && texture.minFilter !== (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.isExternalTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isCubeDepthTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [(0, $ce0cdebec9150cb3$export$533346c8e8dac0f5)]: _gl.REPEAT,
        [(0, $ce0cdebec9150cb3$export$9d9334239a5a5e06)]: _gl.CLAMP_TO_EDGE,
        [(0, $ce0cdebec9150cb3$export$c7e7c00b14f51a4f)]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [(0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0)]: _gl.NEAREST,
        [(0, $ce0cdebec9150cb3$export$d129e38cf6feaa8c)]: _gl.NEAREST_MIPMAP_NEAREST,
        [(0, $ce0cdebec9150cb3$export$d2327c1afe5bfdf2)]: _gl.NEAREST_MIPMAP_LINEAR,
        [(0, $ce0cdebec9150cb3$export$8a72f490b25c56c8)]: _gl.LINEAR,
        [(0, $ce0cdebec9150cb3$export$19a719f377145a13)]: _gl.LINEAR_MIPMAP_NEAREST,
        [(0, $ce0cdebec9150cb3$export$5d8599b6a933fb1b)]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [(0, $ce0cdebec9150cb3$export$d9e2d19a747baaab)]: _gl.NEVER,
        [(0, $ce0cdebec9150cb3$export$187b73a3e352c145)]: _gl.ALWAYS,
        [(0, $ce0cdebec9150cb3$export$36bcf49c713b3eb7)]: _gl.LESS,
        [(0, $ce0cdebec9150cb3$export$64eea11eb407ddf1)]: _gl.LEQUAL,
        [(0, $ce0cdebec9150cb3$export$66f28d946fc6a0d5)]: _gl.EQUAL,
        [(0, $ce0cdebec9150cb3$export$1cdcb70d53d65f61)]: _gl.GEQUAL,
        [(0, $ce0cdebec9150cb3$export$155af022118f3a38)]: _gl.GREATER,
        [(0, $ce0cdebec9150cb3$export$67ab95dde6bed156)]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $ce0cdebec9150cb3$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8) || texture.magFilter === (0, $ce0cdebec9150cb3$export$19a719f377145a13) || texture.magFilter === (0, $ce0cdebec9150cb3$export$d2327c1afe5bfdf2) || texture.magFilter === (0, $ce0cdebec9150cb3$export$5d8599b6a933fb1b) || texture.minFilter === (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8) || texture.minFilter === (0, $ce0cdebec9150cb3$export$19a719f377145a13) || texture.minFilter === (0, $ce0cdebec9150cb3$export$d2327c1afe5bfdf2) || texture.minFilter === (0, $ce0cdebec9150cb3$export$5d8599b6a933fb1b))) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0)) return;
            if (texture.minFilter !== (0, $ce0cdebec9150cb3$export$d2327c1afe5bfdf2) && texture.minFilter !== (0, $ce0cdebec9150cb3$export$5d8599b6a933fb1b)) return;
            if (texture.type === (0, $ce0cdebec9150cb3$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function getRow(index, rowLength, componentStride) {
        return Math.floor(Math.floor(index / componentStride) / rowLength);
    }
    function updateTexture(texture, image, glFormat, glType) {
        const componentStride = 4; // only RGBA supported
        const updateRanges = texture.updateRanges;
        if (updateRanges.length === 0) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.texSubImage2D`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // Only merge if in the same row and overlapping/adjacent
                const previousEnd = previousRange.start + previousRange.count;
                const currentRow = getRow(range.start, image.width, componentStride);
                const previousRow = getRow(previousRange.start, image.width, componentStride);
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousEnd + 1 && currentRow === previousRow && getRow(range.start + range.count - 1, image.width, componentStride) === currentRow // ensure range doesn't spill
                ) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                const pixelStart = Math.floor(range.start / componentStride);
                const pixelCount = Math.ceil(range.count / componentStride);
                const x = pixelStart % image.width;
                const y = Math.floor(pixelStart / image.width);
                // Assumes update ranges refer to contiguous memory
                const width = pixelCount;
                const height = 1;
                _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, x);
                _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, y);
                state.texSubImage2D(_gl.TEXTURE_2D, 0, x, y, width, height, glFormat, glType, image.data);
            }
            texture.clearUpdateRanges();
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getPrimaries((0, $ce0cdebec9150cb3$export$5e6fd513f44698c).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51) ? null : (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $ce0cdebec9150cb3$export$1e113ac2d0905829), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) updateTexture(texture, image, glFormat, glType);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = (0, $ce0cdebec9150cb3$export$cc8c3b705bb8e6e2)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = (0, $ce0cdebec9150cb3$export$cc8c3b705bb8e6e2)(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getPrimaries((0, $ce0cdebec9150cb3$export$5e6fd513f44698c).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51) ? null : (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, useMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
            else if (useMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget, cubeFace) {
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        if (isCube) {
            // For cube depth textures, initialize and bind without uploading image data
            if (textureProperties.__webglInit === undefined) {
                textureProperties.__webglInit = true;
                renderTarget.depthTexture.addEventListener('dispose', onTextureDispose);
            }
            // Only create and allocate storage once
            if (textureProperties.__webglTexture === undefined) {
                textureProperties.__webglTexture = _gl.createTexture();
                state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_CUBE_MAP, renderTarget.depthTexture);
                // Allocate storage for all 6 faces with correct depth texture format
                const glFormat = utils.convert(renderTarget.depthTexture.format);
                const glType = utils.convert(renderTarget.depthTexture.type);
                // Use proper internal format for depth textures
                let glInternalFormat;
                if (renderTarget.depthTexture.format === (0, $ce0cdebec9150cb3$export$c1b6b5136be58045)) glInternalFormat = _gl.DEPTH_COMPONENT24;
                else if (renderTarget.depthTexture.format === (0, $ce0cdebec9150cb3$export$1e113ac2d0905829)) glInternalFormat = _gl.DEPTH24_STENCIL8;
                for(let i = 0; i < 6; i++)_gl.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
            }
        } else setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        const glTextureType = isCube ? _gl.TEXTURE_CUBE_MAP_POSITIVE_X + cubeFace : _gl.TEXTURE_2D;
        const glAttachmentType = renderTarget.depthTexture.format === (0, $ce0cdebec9150cb3$export$1e113ac2d0905829) ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
        if (renderTarget.depthTexture.format === (0, $ce0cdebec9150cb3$export$c1b6b5136be58045)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $ce0cdebec9150cb3$export$1e113ac2d0905829)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) // For cube render targets with depth texture, setup each face
            for(let i = 0; i < 6; i++)setupDepthTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, i);
            else {
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) setupDepthTexture(renderTargetProperties.__webglFramebuffer[0], renderTarget, 0);
                else setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget, 0);
            }
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            const mipmaps = renderTarget.texture.mipmaps;
            if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
            else state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                let glTextureType = _gl.TEXTURE_2D;
                if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                state.bindTexture(glTextureType, attachmentProperties.__webglTexture);
                setTextureParameters(glTextureType, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, glTextureType, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(glTextureType);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
                else state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $ce0cdebec9150cb3$export$42429b3acfb233a4) && colorSpace !== (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51)) {
            // sRGB
            if ((0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getTransfer(colorSpace) === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c) || type !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
    this.isReversedDepthBuffer = function() {
        return state.buffers.depth.getReversed();
    };
}
function $3b951febf8ab45a9$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace = (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51)) {
        let extension;
        const transfer = (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).getTransfer(colorSpace);
        if (p === (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) return gl.UNSIGNED_BYTE;
        if (p === (0, $ce0cdebec9150cb3$export$b3969b01faf587f2)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $ce0cdebec9150cb3$export$18886f8ae33e90de)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $ce0cdebec9150cb3$export$5a4c329b7e2092d3)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $ce0cdebec9150cb3$export$f240f067f72abe41)) return gl.UNSIGNED_INT_10F_11F_11F_REV;
        if (p === (0, $ce0cdebec9150cb3$export$545fce0311a9796a)) return gl.BYTE;
        if (p === (0, $ce0cdebec9150cb3$export$88572337f312435f)) return gl.SHORT;
        if (p === (0, $ce0cdebec9150cb3$export$c63dc51868b06a9d)) return gl.UNSIGNED_SHORT;
        if (p === (0, $ce0cdebec9150cb3$export$5c612977753abe2)) return gl.INT;
        if (p === (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96)) return gl.UNSIGNED_INT;
        if (p === (0, $ce0cdebec9150cb3$export$f6d331659b644596)) return gl.FLOAT;
        if (p === (0, $ce0cdebec9150cb3$export$2697304443f382bc)) return gl.HALF_FLOAT;
        if (p === (0, $ce0cdebec9150cb3$export$988473390501ed4b)) return gl.ALPHA;
        if (p === (0, $ce0cdebec9150cb3$export$7c67423a5ee6f5eb)) return gl.RGB;
        if (p === (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)) return gl.RGBA;
        if (p === (0, $ce0cdebec9150cb3$export$c1b6b5136be58045)) return gl.DEPTH_COMPONENT;
        if (p === (0, $ce0cdebec9150cb3$export$1e113ac2d0905829)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $ce0cdebec9150cb3$export$4e041a7967d15c4b)) return gl.RED;
        if (p === (0, $ce0cdebec9150cb3$export$aa92e870a709d190)) return gl.RED_INTEGER;
        if (p === (0, $ce0cdebec9150cb3$export$6cdf0b461c7ce8a0)) return gl.RG;
        if (p === (0, $ce0cdebec9150cb3$export$1ba1c45f9f77d4d7)) return gl.RG_INTEGER;
        if (p === (0, $ce0cdebec9150cb3$export$c200e7d26f592f21)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $ce0cdebec9150cb3$export$21d1799c6d552fc0) || p === (0, $ce0cdebec9150cb3$export$afa304c3e981b668) || p === (0, $ce0cdebec9150cb3$export$d2a1a68024a3e56c) || p === (0, $ce0cdebec9150cb3$export$9a79c424327dacf9)) {
            if (transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $ce0cdebec9150cb3$export$21d1799c6d552fc0)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $ce0cdebec9150cb3$export$afa304c3e981b668)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $ce0cdebec9150cb3$export$d2a1a68024a3e56c)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $ce0cdebec9150cb3$export$9a79c424327dacf9)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $ce0cdebec9150cb3$export$21d1799c6d552fc0)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $ce0cdebec9150cb3$export$afa304c3e981b668)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $ce0cdebec9150cb3$export$d2a1a68024a3e56c)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $ce0cdebec9150cb3$export$9a79c424327dacf9)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $ce0cdebec9150cb3$export$19ada9bbb1af3573) || p === (0, $ce0cdebec9150cb3$export$d0f0355bb3d948e4) || p === (0, $ce0cdebec9150cb3$export$b82296714358084c) || p === (0, $ce0cdebec9150cb3$export$b71692456c47b6c3)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $ce0cdebec9150cb3$export$19ada9bbb1af3573)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $ce0cdebec9150cb3$export$d0f0355bb3d948e4)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $ce0cdebec9150cb3$export$b82296714358084c)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $ce0cdebec9150cb3$export$b71692456c47b6c3)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $ce0cdebec9150cb3$export$6ab91af2d757aee7) || p === (0, $ce0cdebec9150cb3$export$7800993ef8106a6a) || p === (0, $ce0cdebec9150cb3$export$23ed8300a860e7d8) || p === (0, $ce0cdebec9150cb3$export$d5c566817123b2bf) || p === (0, $ce0cdebec9150cb3$export$f5668dc623297d86) || p === (0, $ce0cdebec9150cb3$export$e443ea3e1485f7bf) || p === (0, $ce0cdebec9150cb3$export$211402338cb75433)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $ce0cdebec9150cb3$export$6ab91af2d757aee7) || p === (0, $ce0cdebec9150cb3$export$7800993ef8106a6a)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $ce0cdebec9150cb3$export$23ed8300a860e7d8)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
                if (p === (0, $ce0cdebec9150cb3$export$d5c566817123b2bf)) return extension.COMPRESSED_R11_EAC;
                if (p === (0, $ce0cdebec9150cb3$export$f5668dc623297d86)) return extension.COMPRESSED_SIGNED_R11_EAC;
                if (p === (0, $ce0cdebec9150cb3$export$e443ea3e1485f7bf)) return extension.COMPRESSED_RG11_EAC;
                if (p === (0, $ce0cdebec9150cb3$export$211402338cb75433)) return extension.COMPRESSED_SIGNED_RG11_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $ce0cdebec9150cb3$export$dc5570b4a2b92d48) || p === (0, $ce0cdebec9150cb3$export$68880cd325f8b2fb) || p === (0, $ce0cdebec9150cb3$export$7d2c0be323373d95) || p === (0, $ce0cdebec9150cb3$export$22b52da301fc3a3e) || p === (0, $ce0cdebec9150cb3$export$c009e2cb4a66485e) || p === (0, $ce0cdebec9150cb3$export$118fff5afa255b63) || p === (0, $ce0cdebec9150cb3$export$120713c829ae0667) || p === (0, $ce0cdebec9150cb3$export$c79eeabbf53313e9) || p === (0, $ce0cdebec9150cb3$export$443cf6567cdd6424) || p === (0, $ce0cdebec9150cb3$export$6573984fc9840780) || p === (0, $ce0cdebec9150cb3$export$e7aee563f30091de) || p === (0, $ce0cdebec9150cb3$export$2eb8634622ddeab7) || p === (0, $ce0cdebec9150cb3$export$202b1ce7b5d25742) || p === (0, $ce0cdebec9150cb3$export$18ab77abd087e467)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $ce0cdebec9150cb3$export$dc5570b4a2b92d48)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$68880cd325f8b2fb)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$7d2c0be323373d95)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$22b52da301fc3a3e)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$c009e2cb4a66485e)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$118fff5afa255b63)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$120713c829ae0667)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$c79eeabbf53313e9)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$443cf6567cdd6424)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$6573984fc9840780)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$e7aee563f30091de)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$2eb8634622ddeab7)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$202b1ce7b5d25742)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $ce0cdebec9150cb3$export$18ab77abd087e467)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $ce0cdebec9150cb3$export$ce40b115e188bc81) || p === (0, $ce0cdebec9150cb3$export$d279c5c4bac5121e) || p === (0, $ce0cdebec9150cb3$export$cde52d17225fdbd3)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $ce0cdebec9150cb3$export$ce40b115e188bc81)) return transfer === (0, $ce0cdebec9150cb3$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $ce0cdebec9150cb3$export$d279c5c4bac5121e)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $ce0cdebec9150cb3$export$cde52d17225fdbd3)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $ce0cdebec9150cb3$export$b1688df4c4c21670) || p === (0, $ce0cdebec9150cb3$export$fc15e5d8261eed58) || p === (0, $ce0cdebec9150cb3$export$d220f6ade8463a0f) || p === (0, $ce0cdebec9150cb3$export$768646d09dc1b6ef)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $ce0cdebec9150cb3$export$b1688df4c4c21670)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $ce0cdebec9150cb3$export$fc15e5d8261eed58)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $ce0cdebec9150cb3$export$d220f6ade8463a0f)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $ce0cdebec9150cb3$export$768646d09dc1b6ef)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $ce0cdebec9150cb3$export$6c8ea339bfab1301)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
const $3b951febf8ab45a9$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $3b951febf8ab45a9$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
/**
 * A XR module that manages the access to the Depth Sensing API.
 */ class $3b951febf8ab45a9$var$WebXRDepthSensing {
    /**
	 * Constructs a new depth sensing module.
	 */ constructor(){
        /**
		 * An opaque texture representing the depth of the user's environment.
		 *
		 * @type {?ExternalTexture}
		 */ this.texture = null;
        /**
		 * A plane mesh for visualizing the depth texture.
		 *
		 * @type {?Mesh}
		 */ this.mesh = null;
        /**
		 * The depth near value.
		 *
		 * @type {number}
		 */ this.depthNear = 0;
        /**
		 * The depth near far.
		 *
		 * @type {number}
		 */ this.depthFar = 0;
    }
    /**
	 * Inits the depth sensing module
	 *
	 * @param {XRWebGLDepthInformation} depthData - The XR depth data.
	 * @param {XRRenderState} renderState - The XR render state.
	 */ init(depthData, renderState) {
        if (this.texture === null) {
            const texture = new (0, $ce0cdebec9150cb3$export$cd10147cacf16ab2)(depthData.texture);
            if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    /**
	 * Returns a plane mesh that visualizes the depth texture.
	 *
	 * @param {ArrayCamera} cameraXR - The XR camera.
	 * @return {?Mesh} The plane mesh.
	 */ getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
                    vertexShader: $3b951febf8ab45a9$var$_occlusion_vertex,
                    fragmentShader: $3b951febf8ab45a9$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(new (0, $ce0cdebec9150cb3$export$967d831af31f69ce)(20, 20), material);
            }
        }
        return this.mesh;
    }
    /**
	 * Resets the module
	 */ reset() {
        this.texture = null;
        this.mesh = null;
    }
    /**
	 * Returns a texture representing the depth of the user's environment.
	 *
	 * @return {?ExternalTexture} The depth texture.
	 */ getDepthTexture() {
        return this.texture;
    }
}
/**
 * This class represents an abstraction of the WebXR Device API and is
 * internally used by {@link WebGLRenderer}. `WebXRManager` also provides a public
 * interface that allows users to enable/disable XR and perform XR related
 * tasks like for instance retrieving controllers.
 *
 * @augments EventDispatcher
 * @hideconstructor
 */ class $3b951febf8ab45a9$var$WebXRManager extends (0, $ce0cdebec9150cb3$export$ec8b666c5fe2c75a) {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 */ constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const supportsGlBinding = typeof XRWebGLBinding !== 'undefined';
        const depthSensing = new $3b951febf8ab45a9$var$WebXRDepthSensing();
        const cameraAccessTextures = {};
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        let currentPixelRatio = null;
        //
        const cameraL = new (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)();
        cameraL.viewport = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
        const cameraR = new (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)();
        cameraR.viewport = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new (0, $ce0cdebec9150cb3$export$56b937d9e5581166)();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        /**
		 * Whether the manager's XR camera should be automatically updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.cameraAutoUpdate = true;
        /**
		 * This flag notifies the renderer to be ready for XR rendering. Set it to `true`
		 * if you are going to use XR in your app.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enabled = false;
        /**
		 * Whether XR presentation is active or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPresenting = false;
        /**
		 * Returns a group representing the `target ray` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `target ray` space.
		 */ this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $ce0cdebec9150cb3$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        /**
		 * Returns a group representing the `grip` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * Note: If you want to show something in the user's hand AND offer a
		 * pointing ray at the same time, you'll want to attached the handheld object
		 * to the group returned by `getControllerGrip()` and the ray to the
		 * group returned by `getController()`. The idea is to have two
		 * different groups in two different coordinate spaces for the same WebXR
		 * controller.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `grip` space.
		 */ this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $ce0cdebec9150cb3$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        /**
		 * Returns a group representing the `hand` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `hand` space.
		 */ this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $ce0cdebec9150cb3$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            for(const key in cameraAccessTextures)delete cameraAccessTextures[key];
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        /**
		 * Sets the framebuffer scale factor.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {number} value - The framebuffer scale factor.
		 */ this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        /**
		 * Sets the reference space type. Can be used to configure a spatial relationship with the user's physical
		 * environment. Depending on how the user moves in 3D space, setting an appropriate reference space can
		 * improve tracking. Default is `local-floor`. Valid values can be found here
		 * https://developer.mozilla.org/en-US/docs/Web/API/XRReferenceSpace#reference_space_types.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {string} value - The reference space type.
		 */ this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebXRManager: Cannot change reference space type while presenting.');
        };
        /**
		 * Returns the XR reference space.
		 *
		 * @return {XRReferenceSpace} The XR reference space.
		 */ this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        /**
		 * Sets a custom XR reference space.
		 *
		 * @param {XRReferenceSpace} space - The XR reference space.
		 */ this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        /**
		 * Returns the current base layer.
		 *
		 * This is an `XRProjectionLayer` when the targeted XR device supports the
		 * WebXR Layers API, or an `XRWebGLLayer` otherwise.
		 *
		 * @return {?(XRWebGLLayer|XRProjectionLayer)} The XR base layer.
		 */ this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        /**
		 * Returns the current XR binding.
		 *
		 * Creates a new binding if needed and the browser is
		 * capable of doing so.
		 *
		 * @return {?XRWebGLBinding} The XR binding. Returns `null` if one cannot be created.
		 */ this.getBinding = function() {
            if (glBinding === null && supportsGlBinding) glBinding = new XRWebGLBinding(session, gl);
            return glBinding;
        };
        /**
		 * Returns the current XR frame.
		 *
		 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
		 */ this.getFrame = function() {
            return xrFrame;
        };
        /**
		 * Returns the current XR session.
		 *
		 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
		 */ this.getSession = function() {
            return session;
        };
        /**
		 * After a XR session has been requested usually with one of the `*Button` modules, it
		 * is injected into the renderer with this method. This method triggers the start of
		 * the actual XR rendering.
		 *
		 * @async
		 * @param {XRSession} value - The XR session to set.
		 * @return {Promise} A Promise that resolves when the session has been set.
		 */ this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                // Check that the browser implements the necessary APIs to use an
                // XRProjectionLayer rather than an XRWebGLLayer
                const supportsLayers = supportsGlBinding && 'createProjectionLayer' in XRWebGLBinding.prototype;
                if (!supportsLayers) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c),
                        type: (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10),
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil,
                        resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? (0, $ce0cdebec9150cb3$export$1e113ac2d0905829) : (0, $ce0cdebec9150cb3$export$c1b6b5136be58045);
                        depthType = attributes.stencil ? (0, $ce0cdebec9150cb3$export$6c8ea339bfab1301) : (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96);
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = this.getBinding();
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c),
                        type: (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10),
                        depthTexture: new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        /**
		 * Returns the environment blend mode from the current XR session.
		 *
		 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
		 */ this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        /**
		 * Returns the current depth texture computed via depth sensing.
		 *
		 * See {@link WebXRDepthSensing#getDepthTexture}.
		 *
		 * @return {?Texture} The depth texture.
		 */ this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
        const cameraRPos = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        /**
		 * Updates the state of the XR camera. Use this method on app level if you
		 * set `cameraAutoUpdate` to `false`. The method requires the non-XR
		 * camera of the scene as a parameter. The passed in camera's transformation
		 * is automatically adjusted to the position of the XR camera when calling
		 * this method.
		 *
		 * @param {Camera} camera - The camera.
		 */ this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            // inherit camera layers and enable eye layers (1 = left, 2 = right)
            cameraXR.layers.mask = camera.layers.mask | 6;
            cameraL.layers.mask = cameraXR.layers.mask & -5;
            cameraR.layers.mask = cameraXR.layers.mask & -3;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $ce0cdebec9150cb3$export$914076c8150813e5) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        /**
		 * Returns an instance of {@link ArrayCamera} which represents the XR camera
		 * of the active XR session. For each view it holds a separate camera object.
		 *
		 * The camera's `fov` is currently not used and does not reflect the fov of
		 * the XR camera. If you need the fov on app level, you have to compute in
		 * manually from the XR camera's projection matrices.
		 *
		 * @return {ArrayCamera} The XR camera.
		 */ this.getCamera = function() {
            return cameraXR;
        };
        /**
		 * Returns the amount of foveation used by the XR compositor for the projection layer.
		 *
		 * @return {number|undefined} The amount of foveation.
		 */ this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        /**
		 * Sets the foveation value.
		 *
		 * @param {number} value - A number in the range `[0,1]` where `0` means no foveation (full resolution)
		 * and `1` means maximum foveation (the edges render at lower resolution).
		 */ this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        /**
		 * Returns `true` if depth sensing is supported.
		 *
		 * @return {boolean} Whether depth sensing is supported or not.
		 */ this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        /**
		 * Returns the depth sensing mesh.
		 *
		 * See {@link WebXRDepthSensing#getMesh}.
		 *
		 * @return {Mesh} The depth sensing mesh.
		 */ this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        /**
		 * Retrieves an opaque texture from the view-aligned {@link XRCamera}.
		 * Only available during the current animation loop.
		 *
		 * @param {XRCamera} xrCamera - The camera to query.
		 * @return {?Texture} An opaque texture representing the current raw camera frame.
		 */ this.getCameraTexture = function(xrCamera) {
            return cameraAccessTextures[xrCamera];
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && supportsGlBinding) {
                    glBinding = scope.getBinding();
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(depthData, session.renderState);
                }
                const cameraAccessEnabled = enabledFeatures && enabledFeatures.includes('camera-access');
                if (cameraAccessEnabled && supportsGlBinding) {
                    renderer.state.unbindTexture();
                    glBinding = scope.getBinding();
                    for(let i = 0; i < views.length; i++){
                        const camera = views[i].camera;
                        if (camera) {
                            let cameraTex = cameraAccessTextures[camera];
                            if (!cameraTex) {
                                cameraTex = new (0, $ce0cdebec9150cb3$export$cd10147cacf16ab2)();
                                cameraAccessTextures[camera] = cameraTex;
                            }
                            const glTexture = glBinding.getCameraImage(camera);
                            cameraTex.sourceTexture = glTexture;
                        }
                    }
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $3b951febf8ab45a9$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $3b951febf8ab45a9$var$_e1 = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$d93cc409a0768c5f)();
const $3b951febf8ab45a9$var$_m1 = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
function $3b951febf8ab45a9$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $ce0cdebec9150cb3$export$a630742c640528c1)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) {
            refreshUniformsCommon(uniforms, material);
            if (material.envMap) uniforms.envMapIntensity.value = material.envMapIntensity;
        } else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
            if (material.envMap) uniforms.envMapIntensity.value = material.envMapIntensity;
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $3b951febf8ab45a9$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $3b951febf8ab45a9$var$_e1.x *= -1;
            $3b951febf8ab45a9$var$_e1.y *= -1;
            $3b951febf8ab45a9$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $3b951febf8ab45a9$var$_e1.y *= -1;
                $3b951febf8ab45a9$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($3b951febf8ab45a9$var$_m1.makeRotationFromEuler($3b951febf8ab45a9$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $3b951febf8ab45a9$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
/**
 * Precomputed DFG LUT for Image-Based Lighting
 * Resolution: 16x16
 * Samples: 4096 per texel
 * Format: RG16F (2 half floats per texel: scale, bias)
 */ const $3b951febf8ab45a9$var$DATA = new Uint16Array([
    0x30b5,
    0x3ad1,
    0x314c,
    0x3a4d,
    0x33d2,
    0x391c,
    0x35ef,
    0x3828,
    0x37f3,
    0x36a6,
    0x38d1,
    0x3539,
    0x3979,
    0x3410,
    0x39f8,
    0x3252,
    0x3a53,
    0x30f0,
    0x3a94,
    0x2fc9,
    0x3abf,
    0x2e35,
    0x3ada,
    0x2d05,
    0x3ae8,
    0x2c1f,
    0x3aed,
    0x2ae0,
    0x3aea,
    0x29d1,
    0x3ae1,
    0x28ff,
    0x3638,
    0x38e4,
    0x364a,
    0x38ce,
    0x3699,
    0x385e,
    0x374e,
    0x372c,
    0x3839,
    0x35a4,
    0x38dc,
    0x3462,
    0x396e,
    0x32c4,
    0x39de,
    0x3134,
    0x3a2b,
    0x3003,
    0x3a59,
    0x2e3a,
    0x3a6d,
    0x2ce1,
    0x3a6e,
    0x2bba,
    0x3a5f,
    0x2a33,
    0x3a49,
    0x290a,
    0x3a2d,
    0x2826,
    0x3a0a,
    0x26e8,
    0x3894,
    0x36d7,
    0x3897,
    0x36c9,
    0x38a3,
    0x3675,
    0x38bc,
    0x35ac,
    0x38ee,
    0x349c,
    0x393e,
    0x3332,
    0x3997,
    0x3186,
    0x39e2,
    0x3038,
    0x3a13,
    0x2e75,
    0x3a29,
    0x2cf5,
    0x3a2d,
    0x2bac,
    0x3a21,
    0x29ff,
    0x3a04,
    0x28bc,
    0x39dc,
    0x2790,
    0x39ad,
    0x261a,
    0x3978,
    0x24fa,
    0x39ac,
    0x34a8,
    0x39ac,
    0x34a3,
    0x39ae,
    0x3480,
    0x39ae,
    0x3423,
    0x39b1,
    0x330e,
    0x39c2,
    0x31a9,
    0x39e0,
    0x3063,
    0x39fc,
    0x2eb5,
    0x3a0c,
    0x2d1d,
    0x3a14,
    0x2bcf,
    0x3a07,
    0x29ff,
    0x39e9,
    0x28a3,
    0x39be,
    0x273c,
    0x3989,
    0x25b3,
    0x394a,
    0x2488,
    0x3907,
    0x2345,
    0x3a77,
    0x3223,
    0x3a76,
    0x321f,
    0x3a73,
    0x3204,
    0x3a6a,
    0x31b3,
    0x3a58,
    0x3114,
    0x3a45,
    0x303b,
    0x3a34,
    0x2eb6,
    0x3a26,
    0x2d31,
    0x3a1e,
    0x2bef,
    0x3a0b,
    0x2a0d,
    0x39ec,
    0x28a1,
    0x39c0,
    0x271b,
    0x3987,
    0x2580,
    0x3944,
    0x2449,
    0x38fa,
    0x22bd,
    0x38ac,
    0x2155,
    0x3b07,
    0x2fca,
    0x3b06,
    0x2fca,
    0x3b00,
    0x2fb8,
    0x3af4,
    0x2f7c,
    0x3adb,
    0x2eea,
    0x3ab4,
    0x2e00,
    0x3a85,
    0x2cec,
    0x3a5e,
    0x2bc5,
    0x3a36,
    0x2a00,
    0x3a0d,
    0x2899,
    0x39dc,
    0x2707,
    0x39a0,
    0x2562,
    0x395a,
    0x2424,
    0x390b,
    0x2268,
    0x38b7,
    0x20fd,
    0x385f,
    0x1fd1,
    0x3b69,
    0x2cb9,
    0x3b68,
    0x2cbb,
    0x3b62,
    0x2cbb,
    0x3b56,
    0x2cae,
    0x3b3b,
    0x2c78,
    0x3b0d,
    0x2c0a,
    0x3acf,
    0x2ae3,
    0x3a92,
    0x2998,
    0x3a54,
    0x2867,
    0x3a17,
    0x26d0,
    0x39d3,
    0x253c,
    0x3989,
    0x2402,
    0x3935,
    0x2226,
    0x38dc,
    0x20bd,
    0x387d,
    0x1f54,
    0x381d,
    0x1db3,
    0x3ba9,
    0x296b,
    0x3ba8,
    0x296f,
    0x3ba3,
    0x297b,
    0x3b98,
    0x2987,
    0x3b7f,
    0x2976,
    0x3b4e,
    0x2927,
    0x3b0e,
    0x2895,
    0x3ac2,
    0x27b7,
    0x3a73,
    0x263b,
    0x3a23,
    0x24e7,
    0x39d0,
    0x239b,
    0x3976,
    0x21d9,
    0x3917,
    0x207e,
    0x38b2,
    0x1ee7,
    0x384b,
    0x1d53,
    0x37c7,
    0x1c1e,
    0x3bd2,
    0x25cb,
    0x3bd1,
    0x25d3,
    0x3bcd,
    0x25f0,
    0x3bc2,
    0x261f,
    0x3bad,
    0x2645,
    0x3b7d,
    0x262d,
    0x3b3e,
    0x25c4,
    0x3aec,
    0x250f,
    0x3a93,
    0x243a,
    0x3a32,
    0x22ce,
    0x39d0,
    0x215b,
    0x3969,
    0x202a,
    0x38fe,
    0x1e6e,
    0x388f,
    0x1cf1,
    0x381f,
    0x1b9b,
    0x3762,
    0x19dd,
    0x3be9,
    0x21ab,
    0x3be9,
    0x21b7,
    0x3be5,
    0x21e5,
    0x3bdd,
    0x2241,
    0x3bc9,
    0x22a7,
    0x3ba0,
    0x22ec,
    0x3b62,
    0x22cd,
    0x3b0f,
    0x2247,
    0x3aae,
    0x2175,
    0x3a44,
    0x2088,
    0x39d4,
    0x1f49,
    0x3960,
    0x1dbe,
    0x38e9,
    0x1c77,
    0x3870,
    0x1ae8,
    0x37f1,
    0x1953,
    0x3708,
    0x181b,
    0x3bf6,
    0x1cea,
    0x3bf6,
    0x1cfb,
    0x3bf3,
    0x1d38,
    0x3bec,
    0x1dbd,
    0x3bda,
    0x1e7c,
    0x3bb7,
    0x1f25,
    0x3b7d,
    0x1f79,
    0x3b2c,
    0x1f4c,
    0x3ac6,
    0x1ea6,
    0x3a55,
    0x1dbb,
    0x39da,
    0x1cbd,
    0x395a,
    0x1b9d,
    0x38d8,
    0x1a00,
    0x3855,
    0x18ac,
    0x37ab,
    0x173c,
    0x36b7,
    0x1598,
    0x3bfc,
    0x1736,
    0x3bfc,
    0x1759,
    0x3bf9,
    0x17e7,
    0x3bf4,
    0x1896,
    0x3be4,
    0x1997,
    0x3bc6,
    0x1aa8,
    0x3b91,
    0x1b84,
    0x3b43,
    0x1bd2,
    0x3ade,
    0x1b8a,
    0x3a65,
    0x1acd,
    0x39e2,
    0x19d3,
    0x3957,
    0x18cd,
    0x38ca,
    0x17b3,
    0x383e,
    0x1613,
    0x376d,
    0x14bf,
    0x366f,
    0x135e,
    0x3bff,
    0x101b,
    0x3bff,
    0x1039,
    0x3bfc,
    0x10c8,
    0x3bf9,
    0x1226,
    0x3bea,
    0x1428,
    0x3bcf,
    0x1584,
    0x3b9f,
    0x16c5,
    0x3b54,
    0x179a,
    0x3af0,
    0x17ce,
    0x3a76,
    0x1771,
    0x39ea,
    0x16a4,
    0x3956,
    0x15a7,
    0x38bf,
    0x14a7,
    0x3829,
    0x1379,
    0x3735,
    0x11ea,
    0x362d,
    0x10a1,
    0x3c00,
    0x061b,
    0x3c00,
    0x066a,
    0x3bfe,
    0x081c,
    0x3bfa,
    0x0a4c,
    0x3bed,
    0x0d16,
    0x3bd5,
    0x0fb3,
    0x3ba9,
    0x114d,
    0x3b63,
    0x127c,
    0x3b01,
    0x132f,
    0x3a85,
    0x1344,
    0x39f4,
    0x12d2,
    0x3957,
    0x120d,
    0x38b5,
    0x1122,
    0x3817,
    0x103c,
    0x3703,
    0x0ed3,
    0x35f0,
    0x0d6d,
    0x3c00,
    0x007a,
    0x3c00,
    0x0089,
    0x3bfe,
    0x011d,
    0x3bfb,
    0x027c,
    0x3bf0,
    0x04fa,
    0x3bda,
    0x0881,
    0x3bb1,
    0x0acd,
    0x3b6f,
    0x0c97,
    0x3b10,
    0x0d7b,
    0x3a93,
    0x0df1,
    0x39fe,
    0x0def,
    0x3959,
    0x0d8a,
    0x38af,
    0x0ce9,
    0x3808,
    0x0c31,
    0x36d5,
    0x0af0,
    0x35b9,
    0x09a3,
    0x3c00,
    0x0000,
    0x3c00,
    0x0001,
    0x3bff,
    0x0015,
    0x3bfb,
    0x0059,
    0x3bf2,
    0x00fd,
    0x3bdd,
    0x01df,
    0x3bb7,
    0x031c,
    0x3b79,
    0x047c,
    0x3b1d,
    0x05d4,
    0x3aa0,
    0x06d5,
    0x3a08,
    0x075a,
    0x395d,
    0x075e,
    0x38aa,
    0x06f7,
    0x37f4,
    0x0648,
    0x36ac,
    0x0576,
    0x3586,
    0x049f
]);
let $3b951febf8ab45a9$var$lut = null;
function $3b951febf8ab45a9$var$getDFGLUT() {
    if ($3b951febf8ab45a9$var$lut === null) {
        $3b951febf8ab45a9$var$lut = new (0, $ce0cdebec9150cb3$export$b691f601014eabe1)($3b951febf8ab45a9$var$DATA, 16, 16, (0, $ce0cdebec9150cb3$export$6cdf0b461c7ce8a0), (0, $ce0cdebec9150cb3$export$2697304443f382bc));
        $3b951febf8ab45a9$var$lut.name = 'DFG_LUT';
        $3b951febf8ab45a9$var$lut.minFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
        $3b951febf8ab45a9$var$lut.magFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
        $3b951febf8ab45a9$var$lut.wrapS = (0, $ce0cdebec9150cb3$export$9d9334239a5a5e06);
        $3b951febf8ab45a9$var$lut.wrapT = (0, $ce0cdebec9150cb3$export$9d9334239a5a5e06);
        $3b951febf8ab45a9$var$lut.generateMipmaps = false;
        $3b951febf8ab45a9$var$lut.needsUpdate = true;
    }
    return $3b951febf8ab45a9$var$lut;
}
/**
 * This renderer uses WebGL 2 to display scenes.
 *
 * WebGL 1 is not supported since `r163`.
 */ class $3b951febf8ab45a9$export$f6cc00ef28d7cf97 {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        const { canvas: canvas = (0, $ce0cdebec9150cb3$export$1033a2df66368859)(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false, reversedDepthBuffer: reversedDepthBuffer = false, outputBufferType: outputBufferType = (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10) } = parameters;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const _outputBufferType = outputBufferType;
        const INTEGER_FORMATS = new Set([
            (0, $ce0cdebec9150cb3$export$c200e7d26f592f21),
            (0, $ce0cdebec9150cb3$export$1ba1c45f9f77d4d7),
            (0, $ce0cdebec9150cb3$export$aa92e870a709d190)
        ]);
        const UNSIGNED_TYPES = new Set([
            (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10),
            (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96),
            (0, $ce0cdebec9150cb3$export$c63dc51868b06a9d),
            (0, $ce0cdebec9150cb3$export$6c8ea339bfab1301),
            (0, $ce0cdebec9150cb3$export$b3969b01faf587f2),
            (0, $ce0cdebec9150cb3$export$18886f8ae33e90de)
        ]);
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // internal render target for non-UnsignedByteType color buffer
        let output = null;
        // public properties
        /**
		 * A canvas where the renderer draws its output. This is automatically created by the renderer
		 * in the constructor (if not provided already); you just need to add it to your page like so:
		 * ```js
		 * document.body.appendChild( renderer.domElement );
		 * ```
		 *
		 * @type {HTMLCanvasElement|OffscreenCanvas}
		 */ this.domElement = canvas;
        /**
		 * A object with debug configuration settings.
		 *
		 * - `checkShaderErrors`: If it is `true`, defines whether material shader programs are
		 * checked for errors during compilation and linkage process. It may be useful to disable
		 * this check in production for performance gain. It is strongly recommended to keep these
		 * checks enabled during development. If the shader does not compile and link, it will not
		 * work and associated material will not render.
		 * - `onShaderError(gl, program, glVertexShader,glFragmentShader)`: A callback function that
		 * can be used for custom error reporting. The callback receives the WebGL context, an instance
		 * of WebGLProgram as well two instances of WebGLShader representing the vertex and fragment shader.
		 * Assigning a custom function disables the default error reporting.
		 *
		 * @type {Object}
		 */ this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled.
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        /**
		 * Whether the renderer should automatically clear its output before rendering a frame or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the color buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        // scene graph
        /**
		 * Whether the renderer should sort objects or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some
		 * degree of transparency. By definition, sorting objects may not work in all
		 * cases. Depending on the needs of application, it may be necessary to turn
		 * off sorting and use other methods to deal with transparency rendering e.g.
		 * manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        // user-defined clipping
        /**
		 * User-defined clipping planes specified in world space. These planes apply globally.
		 * Points in space whose dot product with the plane is negative are cut away.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether the renderer respects object-level clipping planes or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.localClippingEnabled = false;
        // tone mapping
        /**
		 * The tone mapping technique of the renderer.
		 *
		 * @type {(NoToneMapping|LinearToneMapping|ReinhardToneMapping|CineonToneMapping|ACESFilmicToneMapping|CustomToneMapping|AgXToneMapping|NeutralToneMapping)}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2);
        /**
		 * Exposure level of tone mapping.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        // transmission
        /**
		 * The normalized resolution scale for the transmission render target, measured in percentage
		 * of viewport dimensions. Lowering this value can result in significant performance improvements
		 * when using {@link MeshPhysicalMaterial#transmission}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.transmissionResolutionScale = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        this._outputColorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
        const _currentScissor = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
        let _currentScissorTest = null;
        const _currentClearColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        const _scissor = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new (0, $ce0cdebec9150cb3$export$35efe6f4c85463d2)();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _projScreenMatrix = new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
        const _vector3 = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
        const _vector4 = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${(0, $ce0cdebec9150cb3$export$3545e07a80636437)}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (e) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLRenderer: ' + e.message);
            throw e;
        }
        let extensions, capabilities, state, info;
        let properties, textures, environments, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $3b951febf8ab45a9$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $3b951febf8ab45a9$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $3b951febf8ab45a9$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $3b951febf8ab45a9$var$WebGLState(_gl, extensions);
            if (capabilities.reversedDepthBuffer && reversedDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $3b951febf8ab45a9$var$WebGLInfo(_gl);
            properties = new $3b951febf8ab45a9$var$WebGLProperties();
            textures = new $3b951febf8ab45a9$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            environments = new $3b951febf8ab45a9$var$WebGLEnvironments(_this);
            attributes = new $3b951febf8ab45a9$var$WebGLAttributes(_gl);
            bindingStates = new $3b951febf8ab45a9$var$WebGLBindingStates(_gl, attributes);
            geometries = new $3b951febf8ab45a9$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $3b951febf8ab45a9$var$WebGLObjects(_gl, geometries, attributes, bindingStates, info);
            morphtargets = new $3b951febf8ab45a9$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $3b951febf8ab45a9$var$WebGLClipping(properties);
            programCache = new $3b951febf8ab45a9$var$WebGLPrograms(_this, environments, extensions, capabilities, bindingStates, clipping);
            materials = new $3b951febf8ab45a9$var$WebGLMaterials(_this, properties);
            renderLists = new $3b951febf8ab45a9$var$WebGLRenderLists();
            renderStates = new $3b951febf8ab45a9$var$WebGLRenderStates(extensions);
            background = new $3b951febf8ab45a9$var$WebGLBackground(_this, environments, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $3b951febf8ab45a9$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $3b951febf8ab45a9$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $3b951febf8ab45a9$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $3b951febf8ab45a9$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            /**
			 * Holds details about the capabilities of the current rendering context.
			 *
			 * @name WebGLRenderer#capabilities
			 * @type {WebGLRenderer~Capabilities}
			 */ _this.capabilities = capabilities;
            /**
			 * Provides methods for retrieving and testing WebGL extensions.
			 *
			 * - `get(extensionName:string)`: Used to check whether a WebGL extension is supported
			 * and return the extension object if available.
			 * - `has(extensionName:string)`: returns `true` if the extension is supported.
			 *
			 * @name WebGLRenderer#extensions
			 * @type {Object}
			 */ _this.extensions = extensions;
            /**
			 * Used to track properties of other objects like native WebGL objects.
			 *
			 * @name WebGLRenderer#properties
			 * @type {Object}
			 */ _this.properties = properties;
            /**
			 * Manages the render lists of the renderer.
			 *
			 * @name WebGLRenderer#renderLists
			 * @type {Object}
			 */ _this.renderLists = renderLists;
            /**
			 * Interface for managing shadows.
			 *
			 * @name WebGLRenderer#shadowMap
			 * @type {WebGLRenderer~ShadowMap}
			 */ _this.shadowMap = shadowMap;
            /**
			 * Interface for managing the WebGL state.
			 *
			 * @name WebGLRenderer#state
			 * @type {Object}
			 */ _this.state = state;
            /**
			 * Holds a series of statistical information about the GPU memory
			 * and the rendering process. Useful for debugging and monitoring.
			 *
			 * By default these data are reset at each render call but when having
			 * multiple render passes per frame (e.g. when using post processing) it can
			 * be preferred to reset with a custom pattern. First, set `autoReset` to
			 * `false`.
			 * ```js
			 * renderer.info.autoReset = false;
			 * ```
			 * Call `reset()` whenever you have finished to render a single frame.
			 * ```js
			 * renderer.info.reset();
			 * ```
			 *
			 * @name WebGLRenderer#info
			 * @type {WebGLRenderer~Info}
			 */ _this.info = info;
        }
        initGLContext();
        // initialize internal render target for non-UnsignedByteType color buffer
        if (_outputBufferType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) output = new $3b951febf8ab45a9$var$WebGLOutput(_outputBufferType, canvas.width, canvas.height, depth, stencil);
        // xr
        const xr = new $3b951febf8ab45a9$var$WebXRManager(_this, _gl);
        /**
		 * A reference to the XR manager.
		 *
		 * @type {WebXRManager}
		 */ this.xr = xr;
        /**
		 * Returns the rendering context.
		 *
		 * @return {WebGL2RenderingContext} The rendering context.
		 */ this.getContext = function() {
            return _gl;
        };
        /**
		 * Returns the rendering context attributes.
		 *
		 * @return {WebGLContextAttributes} The rendering context attributes.
		 */ this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        /**
		 * Simulates a loss of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        /**
		 * Simulates a restore of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        /**
		 * Returns the pixel ratio.
		 *
		 * @return {number} The pixel ratio.
		 */ this.getPixelRatio = function() {
            return _pixelRatio;
        };
        /**
		 * Sets the given pixel ratio and resizes the canvas if necessary.
		 *
		 * @param {number} value - The pixel ratio.
		 */ this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        /**
		 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The renderer's size in logical pixels.
		 */ this.getSize = function(target) {
            return target.set(_width, _height);
        };
        /**
		 * Resizes the output canvas to (width, height) with device pixel ratio taken
		 * into account, and also sets the viewport to fit that size, starting in (0,
		 * 0). Setting `updateStyle` to false prevents any style changes to the output canvas.
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
		 */ this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                (0, $ce0cdebec9150cb3$export$c106dd0671a0fc2d)('WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            if (output !== null) output.setSize(canvas.width, canvas.height);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The drawing buffer size.
		 */ this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        /**
		 * This method allows to define the drawing buffer size by specifying
		 * width, height and pixel ratio all at once. The size of the drawing
		 * buffer is computed with this formula:
		 * ```js
		 * size.x = width * pixelRatio;
		 * size.y = height * pixelRatio;
		 * ```
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {number} pixelRatio - The pixel ratio.
		 */ this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Sets the post-processing effects to be applied after rendering.
		 *
		 * @param {Array} effects - An array of post-processing effects.
		 */ this.setEffects = function(effects) {
            if (_outputBufferType === (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) {
                console.error('THREE.WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.');
                return;
            }
            if (effects) {
                for(let i = 0; i < effects.length; i++)if (effects[i].isOutputPass === true) {
                    console.warn('THREE.WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.');
                    break;
                }
            }
            output.setEffects(effects || []);
        };
        /**
		 * Returns the current viewport definition.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The current viewport definition.
		 */ this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        /**
		 * Returns the viewport definition.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The viewport definition.
		 */ this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        /**
		 * Sets the viewport to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the viewport.
		 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
		 * @param {number} width - The width of the viewport in logical pixel unit.
		 * @param {number} height - The height of the viewport in logical pixel unit.
		 */ this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns the scissor region.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The scissor region.
		 */ this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        /**
		 * Sets the scissor region to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the scissor region origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the scissor region.
		 * @param {number} y - The vertical coordinate for the lower left corner of the scissor region origin  in logical pixel unit.
		 * @param {number} width - The width of the scissor region in logical pixel unit.
		 * @param {number} height - The height of the scissor region in logical pixel unit.
		 */ this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns `true` if the scissor test is enabled.
		 *
		 * @return {boolean} Whether the scissor test is enabled or not.
		 */ this.getScissorTest = function() {
            return _scissorTest;
        };
        /**
		 * Enable or disable the scissor test. When this is enabled, only the pixels
		 * within the defined scissor area will be affected by further renderer
		 * actions.
		 *
		 * @param {boolean} boolean - Whether the scissor test is enabled or not.
		 */ this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        /**
		 * Sets a custom opaque sort function for the render lists. Pass `null`
		 * to use the default `painterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        /**
		 * Sets a custom transparent sort function for the render lists. Pass `null`
		 * to use the default `reversePainterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        /**
		 * Returns the clear color.
		 *
		 * @param {Color} target - The method writes the result in this target object.
		 * @return {Color} The clear color.
		 */ this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        /**
		 * Sets the clear color and alpha.
		 *
		 * @param {Color} color - The clear color.
		 * @param {number} [alpha=1] - The clear alpha.
		 */ this.setClearColor = function() {
            background.setClearColor(...arguments);
        };
        /**
		 * Returns the clear alpha. Ranges within `[0,1]`.
		 *
		 * @return {number} The clear alpha.
		 */ this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        /**
		 * Sets the clear alpha.
		 *
		 * @param {number} alpha - The clear alpha.
		 */ this.setClearAlpha = function() {
            background.setClearAlpha(...arguments);
        };
        /**
		 * Tells the renderer to clear its color, depth or stencil drawing buffer(s).
		 * This method initializes the buffers to the current clear color values.
		 *
		 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
		 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
		 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
		 */ this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = INTEGER_FORMATS.has(targetFormat);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = UNSIGNED_TYPES.has(targetType);
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            if (bits !== 0) _gl.clear(bits);
        };
        /**
		 * Clears the color buffer. Equivalent to calling `renderer.clear( true, false, false )`.
		 */ this.clearColor = function() {
            this.clear(true, false, false);
        };
        /**
		 * Clears the depth buffer. Equivalent to calling `renderer.clear( false, true, false )`.
		 */ this.clearDepth = function() {
            this.clear(false, true, false);
        };
        /**
		 * Clears the stencil buffer. Equivalent to calling `renderer.clear( false, false, true )`.
		 */ this.clearStencil = function() {
            this.clear(false, false, true);
        };
        /**
		 * Frees the GPU-related resources allocated by this instance. Call this
		 * method whenever this instance is no longer used in your app.
		 */ this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            environments.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            (0, $ce0cdebec9150cb3$export$bef1f36f5486a6a3)('WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            (0, $ce0cdebec9150cb3$export$bef1f36f5486a6a3)('WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) {
                    // @deprecated, r174
                    (0, $ce0cdebec9150cb3$export$5b28268982f175ba)('WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                    renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                } else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $ce0cdebec9150cb3$export$2ede184fc2998901);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03);
            } else getProgram(material, scene, object);
        }
        /**
		 * Compiles all materials in the scene with the camera. This is useful to precompile shaders
		 * before the first rendering. If you want to add a 3D object to an existing scene, use the third
		 * optional parameter for applying the target scene.
		 *
		 * Note that the (target) scene's lighting and environment must be configured before calling this method.
		 *
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Set<Material>} The precompiled materials.
		 */ this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            currentRenderState = renderStateStack.pop();
            return materials;
        };
        // compileAsync
        /**
		 * Asynchronous version of {@link WebGLRenderer#compile}.
		 *
		 * This method makes use of the `KHR_parallel_shader_compile` WebGL extension. Hence,
		 * it is recommended to use this version of `compile()` whenever possible.
		 *
		 * @async
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Promise} A Promise that resolves when the given scene can be rendered without unnecessary stalling due to shader compilation.
		 */ this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $3b951febf8ab45a9$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        /**
		 * Applications are advised to always define the animation loop
		 * with this method and not manually with `requestAnimationFrame()`
		 * for best compatibility.
		 *
		 * @param {?onAnimationCallback} callback - The application's animation loop.
		 */ this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        /**
		 * Renders the given scene (or other type of 3D object) using the given camera.
		 *
		 * The render is done to a previously specified render target set by calling {@link WebGLRenderer#setRenderTarget}
		 * or to the canvas as usual.
		 *
		 * By default render buffers are cleared before rendering but you can prevent
		 * this by setting the property `autoClear` to `false`. If you want to prevent
		 * only certain buffers being cleared you can `autoClearColor`, `autoClearDepth`
		 * or `autoClearStencil` to `false`. To force a clear, use {@link WebGLRenderer#clear}.
		 *
		 * @param {Object3D} scene - The scene to render.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // use internal render target for HalfFloatType color buffer (only when tone mapping is enabled)
            const isXRPresenting = xr.enabled === true && xr.isPresenting === true;
            const useOutput = output !== null && (_currentRenderTarget === null || isXRPresenting) && output.begin(_this, _currentRenderTarget);
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true && (output === null || output.isCompositing() === false)) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix, (0, $ce0cdebec9150cb3$export$5a0e9190d10875d3), camera.reversedDepth);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene (skip if first effect is a render pass - it will render the scene itself)
            const skipSceneRender = useOutput && output.hasRenderPass();
            if (skipSceneRender === false) {
                const opaqueObjects = currentRenderList.opaque;
                const transmissiveObjects = currentRenderList.transmissive;
                currentRenderState.setupLights();
                if (camera.isArrayCamera) {
                    const cameras = camera.cameras;
                    if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                        const camera2 = cameras[i];
                        renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                    }
                    if (_renderBackground) background.render(scene);
                    for(let i = 0, l = cameras.length; i < l; i++){
                        const camera2 = cameras[i];
                        renderScene(currentRenderList, scene, camera2, camera2.viewport);
                    }
                } else {
                    if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                    if (_renderBackground) background.render(scene);
                    renderScene(currentRenderList, scene, camera);
                }
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            // copy from internal render target to canvas using fullscreen quad
            if (useOutput) output.end(_this);
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const { opaque: opaqueObjects, transmissive: transmissiveObjects, transparent: transparentObjects } = currentRenderList;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) {
                const hasHalfFloatSupport = extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float');
                currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
                    generateMipmaps: true,
                    type: hasHalfFloatSupport ? (0, $ce0cdebec9150cb3$export$2697304443f382bc) : (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10),
                    minFilter: (0, $ce0cdebec9150cb3$export$5d8599b6a933fb1b),
                    samples: Math.max(4, capabilities.samples),
                    stencilBuffer: stencil,
                    resolveDepthBuffer: false,
                    resolveStencilBuffer: false,
                    colorSpace: (0, $ce0cdebec9150cb3$export$5e6fd513f44698c).workingColorSpace
                });
            // debug
            /*
				const geometry = new PlaneGeometry();
				const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );

				const mesh = new Mesh( geometry, material );
				scene.add( mesh );
				*/ }
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            const currentRenderTarget = _this.getRenderTarget();
            const currentActiveCubeFace = _this.getActiveCubeFace();
            const currentActiveMipmapLevel = _this.getActiveMipmapLevel();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const { object: object, geometry: geometry, material: material, group: group } = renderItem;
                    if (material.side === (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03) && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const { object: object, geometry: geometry, group: group } = renderItem;
                let material = renderItem.material;
                if (material.allowOverride === true && overrideMaterial !== null) material = overrideMaterial;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $ce0cdebec9150cb3$export$2ede184fc2998901);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial || material.isMeshLambertMaterial || material.isMeshPhongMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            const usePMREM = material.isMeshStandardMaterial || material.isMeshLambertMaterial && !material.envMap || material.isMeshPhongMaterial && !material.envMap;
            materialProperties.envMap = environments.get(material.envMap || materialProperties.environment, usePMREM);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $3b951febf8ab45a9$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial || material.isMeshLambertMaterial || material.isMeshPhongMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $ce0cdebec9150cb3$export$42429b3acfb233a4);
            const usePMREM = material.isMeshStandardMaterial || material.isMeshLambertMaterial && !material.envMap || material.isMeshPhongMaterial && !material.envMap;
            const envMap = environments.get(material.envMap || environment, usePMREM);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reversedDepthBuffer = state.buffers.depth.getReversed();
                if (reversedDepthBuffer && camera.reversedDepth !== true) {
                    camera._reversedDepth = true;
                    camera.updateProjectionMatrix();
                }
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // Pre-allocate texture units for shadow samplers before setting data textures
            if (materialProperties.needsLights) {
                // Set shadow map uniforms first to ensure they get the first texture units
                if (lights.state.directionalShadowMap.length > 0) p_uniforms.setValue(_gl, 'directionalShadowMap', lights.state.directionalShadowMap, textures);
                if (lights.state.spotShadowMap.length > 0) p_uniforms.setValue(_gl, 'spotShadowMap', lights.state.spotShadowMap, textures);
                if (lights.state.pointShadowMap.length > 0) p_uniforms.setValue(_gl, 'pointShadowMap', lights.state.pointShadowMap, textures);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            if ((material.isMeshStandardMaterial || material.isMeshLambertMaterial || material.isMeshPhongMaterial) && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            // Set DFG LUT for physically-based materials
            if (m_uniforms.dfgLUT !== undefined) m_uniforms.dfgLUT.value = $3b951febf8ab45a9$var$getDFGLUT();
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $3b951febf8ab45a9$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $3b951febf8ab45a9$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        /**
		 * Returns the active cube face.
		 *
		 * @return {number} The active cube face.
		 */ this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        /**
		 * Returns the active mipmap level.
		 *
		 * @return {number} The active mipmap level.
		 */ this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        /**
		 * Returns the active render target.
		 *
		 * @return {?WebGLRenderTarget} The active render target. Returns `null` if no render target
		 * is currently set.
		 */ this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
            if (renderTargetProperties.__autoAllocateDepthBuffer === false) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            renderTargetProperties.__useRenderToTexture = false;
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? undefined : depthTexture;
            renderTargetProperties.__hasExternalTextures = true;
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        /**
		 * Sets the active rendertarget.
		 *
		 * @param {?WebGLRenderTarget} renderTarget - The render target to set. When `null` is given,
		 * the canvas is set as the active render target instead.
		 * @param {number} [activeCubeFace=0] - The active cube face when using a cube render target.
		 * Indicates the z layer to render in to when using 3D or array render targets.
		 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
		 */ this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // Externally-managed framebuffer (e.g. XR)
                    // Bind to the stored framebuffer (may be null for default, or a WebGLFramebuffer)
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _currentViewport.copy(renderTarget.viewport);
                    _currentScissor.copy(renderTarget.scissor);
                    _currentScissorTest = renderTarget.scissorTest;
                    state.viewport(_currentViewport);
                    state.scissor(_currentScissor);
                    state.setScissorTest(_currentScissorTest);
                    _currentMaterialId = -1;
                    return;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const layer = activeCubeFace;
                for(let i = 0; i < renderTarget.textures.length; i++){
                    const textureProperties = properties.get(renderTarget.textures[i]);
                    _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, textureProperties.__webglTexture, activeMipmapLevel, layer);
                }
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        /**
		 * Reads the pixel data from the given render target into the given buffer.
		 *
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 */ this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    // when using MRT, select the correct color buffer for the subsequent read command
                    if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        (0, $ce0cdebec9150cb3$export$a3bc9b8ed74fc)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        /**
		 * Asynchronous, non-blocking version of {@link WebGLRenderer#readRenderTargetPixels}.
		 *
		 * It is recommended to use this version of `readRenderTargetPixels()` whenever possible.
		 *
		 * @async
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
		 */ this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    // when using MRT, select the correct color buffer for the subsequent read command
                    if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                    if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                    if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await (0, $ce0cdebec9150cb3$export$d43f91ebeafb2c7)(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        /**
		 * Copies pixels from the current bound framebuffer into the given texture.
		 *
		 * @param {FramebufferTexture} texture - The texture.
		 * @param {?Vector2} [position=null] - The start position of the copy operation.
		 * @param {number} [level=0] - The mip level. The default represents the base mip.
		 */ this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        /**
		 * Copies data of the given source texture into a destination texture.
		 *
		 * When using render target textures as `srcTexture` and `dstTexture`, you must make sure both render targets are initialized
		 * {@link WebGLRenderer#initRenderTarget}.
		 *
		 * @param {Texture} srcTexture - The source texture.
		 * @param {Texture} dstTexture - The destination texture.
		 * @param {?(Box2|Box3)} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
		 * @param {?(Vector2|Vector3)} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
		 * @param {number} [srcLevel=0] - The source mipmap level to copy.
		 * @param {?number} [dstLevel=0] - The destination mipmap level.
		 */ this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                const levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(let i = 0; i < depth; i++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        /**
		 * Initializes the given WebGLRenderTarget memory. Useful for initializing a render target so data
		 * can be copied into it using {@link WebGLRenderer#copyTextureToTexture} before it has been
		 * rendered to.
		 *
		 * @param {WebGLRenderTarget} target - The render target.
		 */ this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        /**
		 * Initializes the given texture. Useful for preloading a texture rather than waiting until first
		 * render (which can cause noticeable lags due to decode and GPU upload overhead).
		 *
		 * @param {Texture} texture - The texture.
		 */ this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        /**
		 * Can be used to reset the internal WebGL state. This method is mostly
		 * relevant for applications which share a single WebGL context across
		 * multiple WebGL libraries.
		 */ this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    /**
	 * Defines the coordinate system of the renderer.
	 *
	 * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
	 *
	 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
	 * @default WebGLCoordinateSystem
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $ce0cdebec9150cb3$export$5a0e9190d10875d3;
    }
    /**
	 * Defines the output color space of the renderer.
	 *
	 * @type {SRGBColorSpace|LinearSRGBColorSpace}
	 * @default SRGBColorSpace
	 */ get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = (0, $ce0cdebec9150cb3$export$5e6fd513f44698c)._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = (0, $ce0cdebec9150cb3$export$5e6fd513f44698c)._getUnpackColorSpace();
    }
}


var $ab264bb1b0f39ff6$export$c883e057baa24e24;
var $ab264bb1b0f39ff6$export$2951cba41945c0c8;
'use strict';

var $2WGWz = parcelRequire("2WGWz");
var $8d32b4480d1d3987$exports = {};
'use strict';

$8d32b4480d1d3987$exports = (parcelRequire("5T0q6"));


var $4af0aba13d3b580f$export$f51a9068ac82ea43;
'use strict';
const $4af0aba13d3b580f$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $4af0aba13d3b580f$var$createStore = (createState)=>createState ? $4af0aba13d3b580f$var$createStoreImpl(createState) : $4af0aba13d3b580f$var$createStoreImpl;
$4af0aba13d3b580f$export$f51a9068ac82ea43 = $4af0aba13d3b580f$var$createStore;


const { useSyncExternalStoreWithSelector: $ab264bb1b0f39ff6$var$useSyncExternalStoreWithSelector } = $8d32b4480d1d3987$exports;
const $ab264bb1b0f39ff6$var$identity = (arg)=>arg;
function $ab264bb1b0f39ff6$var$useStoreWithEqualityFn(api, selector = $ab264bb1b0f39ff6$var$identity, equalityFn) {
    const slice = $ab264bb1b0f39ff6$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getInitialState, selector, equalityFn);
    $2WGWz.useDebugValue(slice);
    return slice;
}
const $ab264bb1b0f39ff6$var$createWithEqualityFnImpl = (createState, defaultEqualityFn)=>{
    const api = $4af0aba13d3b580f$export$f51a9068ac82ea43(createState);
    const useBoundStoreWithEqualityFn = (selector, equalityFn = defaultEqualityFn)=>$ab264bb1b0f39ff6$var$useStoreWithEqualityFn(api, selector, equalityFn);
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
const $ab264bb1b0f39ff6$var$createWithEqualityFn = (createState, defaultEqualityFn)=>createState ? $ab264bb1b0f39ff6$var$createWithEqualityFnImpl(createState, defaultEqualityFn) : $ab264bb1b0f39ff6$var$createWithEqualityFnImpl;
$ab264bb1b0f39ff6$export$c883e057baa24e24 = $ab264bb1b0f39ff6$var$createWithEqualityFn;
$ab264bb1b0f39ff6$export$2951cba41945c0c8 = $ab264bb1b0f39ff6$var$useStoreWithEqualityFn;


const $80d81cbdf67965be$var$isPromise = (promise)=>typeof promise === 'object' && typeof promise.then === 'function';
const $80d81cbdf67965be$var$globalCache = [];
function $80d81cbdf67965be$var$shallowEqualArrays(arrA, arrB, equal = (a, b)=>a === b) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++)if (!equal(arrA[i], arrB[i])) return false;
    return true;
}
function $80d81cbdf67965be$var$query(fn, keys = null, preload = false, config = {}) {
    // If no keys were given, the function is the key
    if (keys === null) keys = [
        fn
    ];
    for (const entry of $80d81cbdf67965be$var$globalCache)// Find a match
    if ($80d81cbdf67965be$var$shallowEqualArrays(keys, entry.keys, entry.equal)) {
        // If we're pre-loading and the element is present, just return
        if (preload) return undefined; // If an error occurred, throw
        if (Object.prototype.hasOwnProperty.call(entry, 'error')) throw entry.error; // If a response was successful, return
        if (Object.prototype.hasOwnProperty.call(entry, 'response')) {
            if (config.lifespan && config.lifespan > 0) {
                if (entry.timeout) clearTimeout(entry.timeout);
                entry.timeout = setTimeout(entry.remove, config.lifespan);
            }
            return entry.response;
        } // If the promise is still unresolved, throw
        if (!preload) throw entry.promise;
    }
     // The request is new or has changed.
    const entry = {
        keys: keys,
        equal: config.equal,
        remove: ()=>{
            const index = $80d81cbdf67965be$var$globalCache.indexOf(entry);
            if (index !== -1) $80d81cbdf67965be$var$globalCache.splice(index, 1);
        },
        promise: ($80d81cbdf67965be$var$isPromise(fn) ? fn : fn(...keys) // When it resolves, store its value
        ).then((response)=>{
            entry.response = response; // Remove the entry in time if a lifespan was given
            if (config.lifespan && config.lifespan > 0) entry.timeout = setTimeout(entry.remove, config.lifespan);
        }) // Store caught errors, they will be thrown in the render-phase to bubble into an error-bound
        .catch((error)=>entry.error = error)
    }; // Register the entry
    $80d81cbdf67965be$var$globalCache.push(entry); // And throw the promise, this yields control back to React
    if (!preload) throw entry.promise;
    return undefined;
}
const $80d81cbdf67965be$export$a1428c8f7ba796e8 = (fn, keys, config)=>$80d81cbdf67965be$var$query(fn, keys, false, config);
const $80d81cbdf67965be$export$513ccb98c53b8039 = (fn, keys, config)=>void $80d81cbdf67965be$var$query(fn, keys, true, config);
const $80d81cbdf67965be$export$4d3fb11e950abb9e = (keys)=>{
    var _globalCache$find;
    return (_globalCache$find = $80d81cbdf67965be$var$globalCache.find((entry)=>$80d81cbdf67965be$var$shallowEqualArrays(keys, entry.keys, entry.equal))) == null ? void 0 : _globalCache$find.response;
};
const $80d81cbdf67965be$export$42ffd38884aecdac = (keys)=>{
    if (keys === undefined || keys.length === 0) $80d81cbdf67965be$var$globalCache.splice(0, $80d81cbdf67965be$var$globalCache.length);
    else {
        const entry = $80d81cbdf67965be$var$globalCache.find((entry)=>$80d81cbdf67965be$var$shallowEqualArrays(keys, entry.keys, entry.equal));
        if (entry) entry.remove();
    }
};



var $bIbqH = parcelRequire("bIbqH");


var $2WGWz = parcelRequire("2WGWz");
const $b76b7764c0739eb0$var$f = /* @__PURE__ */ (()=>{
    var e, t;
    return typeof window != "undefined" && (((e = window.document) == null ? void 0 : e.createElement) || ((t = window.navigator) == null ? void 0 : t.product) === "ReactNative");
})() ? $2WGWz.useLayoutEffect : $2WGWz.useEffect;
function $b76b7764c0739eb0$export$e2f435051054a3fd(e, t, r) {
    if (!e) return;
    if (r(e) === !0) return e;
    let n = t ? e.return : e.child;
    for(; n;){
        const u = $b76b7764c0739eb0$export$e2f435051054a3fd(n, t, r);
        if (u) return u;
        n = t ? null : n.sibling;
    }
}
function $b76b7764c0739eb0$var$l(e) {
    try {
        return Object.defineProperties(e, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (t) {
        return e;
    }
}
const $b76b7764c0739eb0$var$a = /* @__PURE__ */ $b76b7764c0739eb0$var$l(/* @__PURE__ */ $2WGWz.createContext(null));
class $b76b7764c0739eb0$export$5a20fcbfd44d38b7 extends $2WGWz.Component {
    render() {
        return /* @__PURE__ */ $2WGWz.createElement($b76b7764c0739eb0$var$a.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function $b76b7764c0739eb0$export$69c8591d5df5c7d6() {
    const e = $2WGWz.useContext($b76b7764c0739eb0$var$a);
    if (e === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const t = $2WGWz.useId();
    return $2WGWz.useMemo(()=>{
        for (const n of [
            e,
            e == null ? void 0 : e.alternate
        ]){
            if (!n) continue;
            const u = $b76b7764c0739eb0$export$e2f435051054a3fd(n, !1, (d)=>{
                let s = d.memoizedState;
                for(; s;){
                    if (s.memoizedState === t) return !0;
                    s = s.next;
                }
            });
            if (u) return u;
        }
    }, [
        e,
        t
    ]);
}
function $b76b7764c0739eb0$export$b537cf6ebaf7ff54() {
    const e = $b76b7764c0739eb0$export$69c8591d5df5c7d6(), t = $2WGWz.useMemo(()=>$b76b7764c0739eb0$export$e2f435051054a3fd(e, !0, (r)=>{
            var n;
            return ((n = r.stateNode) == null ? void 0 : n.containerInfo) != null;
        }), [
        e
    ]);
    return t == null ? void 0 : t.stateNode.containerInfo;
}
function $b76b7764c0739eb0$export$aec415ac1d7388b6(e) {
    const t = $b76b7764c0739eb0$export$69c8591d5df5c7d6(), r = $2WGWz.useRef(void 0);
    return $b76b7764c0739eb0$var$f(()=>{
        var n;
        r.current = (n = $b76b7764c0739eb0$export$e2f435051054a3fd(t, !1, (u)=>typeof u.type == "string" && (e === void 0 || u.type === e))) == null ? void 0 : n.stateNode;
    }, [
        t
    ]), r;
}
function $b76b7764c0739eb0$export$b57c9fdd1434988b(e) {
    const t = $b76b7764c0739eb0$export$69c8591d5df5c7d6(), r = $2WGWz.useRef(void 0);
    return $b76b7764c0739eb0$var$f(()=>{
        var n;
        r.current = (n = $b76b7764c0739eb0$export$e2f435051054a3fd(t, !0, (u)=>typeof u.type == "string" && (e === void 0 || u.type === e))) == null ? void 0 : n.stateNode;
    }, [
        t
    ]), r;
}
const $b76b7764c0739eb0$var$p = Symbol.for("react.context"), $b76b7764c0739eb0$var$b = (e)=>e !== null && typeof e == "object" && "$$typeof" in e && e.$$typeof === $b76b7764c0739eb0$var$p;
function $b76b7764c0739eb0$export$8859381a76e56404() {
    const e = $b76b7764c0739eb0$export$69c8591d5df5c7d6(), [t] = $2WGWz.useState(()=>/* @__PURE__ */ new Map());
    t.clear();
    let r = e;
    for(; r;){
        const n = r.type;
        $b76b7764c0739eb0$var$b(n) && n !== $b76b7764c0739eb0$var$a && !t.has(n) && t.set(n, $2WGWz.use($b76b7764c0739eb0$var$l(n))), r = r.return;
    }
    return t;
}
function $b76b7764c0739eb0$export$39579d26c695d393() {
    const e = $b76b7764c0739eb0$export$8859381a76e56404();
    return $2WGWz.useMemo(()=>Array.from(e.keys()).reduce((t, r)=>(n)=>/* @__PURE__ */ $2WGWz.createElement(t, null, /* @__PURE__ */ $2WGWz.createElement(r.Provider, {
                    ...n,
                    value: e.get(r)
                })), (t)=>/* @__PURE__ */ $2WGWz.createElement($b76b7764c0739eb0$export$5a20fcbfd44d38b7, {
                ...t
            })), [
        e
    ]);
}


var $02a5e071daeb5f48$export$625550452a3fa3ec = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
/**
 * Returns the instance's initial (outmost) root.
 */ function $02a5e071daeb5f48$var$findInitialRoot(instance) {
    let root = instance.root;
    while(root.getState().previousRoot)root = root.getState().previousRoot;
    return root;
}
/**
 * Safely flush async effects when testing, simulating a legacy root.
 * @deprecated Import from React instead. import { act } from 'react'
 */ // Reference with computed key to break Webpack static analysis
// https://github.com/webpack/webpack/issues/14814
const $02a5e071daeb5f48$export$d141bba7fdc215a3 = $2WGWz.act;
const $02a5e071daeb5f48$var$isOrthographicCamera = (def)=>def && def.isOrthographicCamera;
const $02a5e071daeb5f48$export$23f2a1d2818174ef = (obj)=>obj && obj.hasOwnProperty('current');
const $02a5e071daeb5f48$var$isColorRepresentation = (value)=>value != null && (typeof value === 'string' || typeof value === 'number' || value.isColor);
/**
 * An SSR-friendly useLayoutEffect.
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect elsewhere.
 *
 * @see https://github.com/facebook/react/issues/14927
 */ const $02a5e071daeb5f48$export$8b22cf2602fb60ce = /* @__PURE__ */ ((_window$document, _window$navigator)=>typeof window !== 'undefined' && (((_window$document = window.document) == null ? void 0 : _window$document.createElement) || ((_window$navigator = window.navigator) == null ? void 0 : _window$navigator.product) === 'ReactNative'))() ? $2WGWz.useLayoutEffect : $2WGWz.useEffect;
function $02a5e071daeb5f48$export$407448d2b89b1813(fn) {
    const ref = $2WGWz.useRef(fn);
    $02a5e071daeb5f48$export$8b22cf2602fb60ce(()=>void (ref.current = fn), [
        fn
    ]);
    return ref;
}
/**
 * Bridges renderer Context and StrictMode from a primary renderer.
 */ function $02a5e071daeb5f48$export$3b14a55fb2447963() {
    const fiber = (0, $b76b7764c0739eb0$export$69c8591d5df5c7d6)();
    const ContextBridge = (0, $b76b7764c0739eb0$export$39579d26c695d393)();
    return $2WGWz.useMemo(()=>({ children: children })=>{
            const strict = !!(0, $b76b7764c0739eb0$export$e2f435051054a3fd)(fiber, true, (node)=>node.type === $2WGWz.StrictMode);
            const Root = strict ? $2WGWz.StrictMode : $2WGWz.Fragment;
            return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Root, {
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(ContextBridge, {
                    children: children
                })
            });
        }, [
        fiber,
        ContextBridge
    ]);
}
function $02a5e071daeb5f48$export$ef35774e6d314e91({ set: set }) {
    $02a5e071daeb5f48$export$8b22cf2602fb60ce(()=>{
        set(new Promise(()=>null));
        return ()=>set(false);
    }, [
        set
    ]);
    return null;
}
// NOTE: static members get down-level transpiled to mutations which break tree-shaking
const $02a5e071daeb5f48$export$a9c23c6ac3fc3eca = /* @__PURE__ */ ((_ErrorBoundary)=>(_ErrorBoundary = class ErrorBoundary extends $2WGWz.Component {
        constructor(...args){
            super(...args);
            this.state = {
                error: false
            };
        }
        componentDidCatch(err) {
            this.props.set(err);
        }
        render() {
            return this.state.error ? null : this.props.children;
        }
    }, _ErrorBoundary.getDerivedStateFromError = ()=>({
            error: true
        }), _ErrorBoundary))();
function $02a5e071daeb5f48$var$calculateDpr(dpr) {
    var _window$devicePixelRa;
    // Err on the side of progress by assuming 2x dpr if we can't detect it
    // This will happen in workers where window is defined but dpr isn't.
    const target = typeof window !== 'undefined' ? (_window$devicePixelRa = window.devicePixelRatio) != null ? _window$devicePixelRa : 2 : 1;
    return Array.isArray(dpr) ? Math.min(Math.max(dpr[0], target), dpr[1]) : dpr;
}
/**
 * Returns instance root state
 */ function $02a5e071daeb5f48$export$90a7f3efeed30595(obj) {
    var _r3f;
    return (_r3f = obj.__r3f) == null ? void 0 : _r3f.root.getState();
}
// A collection of compare functions
const $02a5e071daeb5f48$var$is = {
    obj: (a)=>a === Object(a) && !$02a5e071daeb5f48$var$is.arr(a) && typeof a !== 'function',
    fun: (a)=>typeof a === 'function',
    str: (a)=>typeof a === 'string',
    num: (a)=>typeof a === 'number',
    boo: (a)=>typeof a === 'boolean',
    und: (a)=>a === void 0,
    nul: (a)=>a === null,
    arr: (a)=>Array.isArray(a),
    equ (a, b, { arrays: arrays = 'shallow', objects: objects = 'reference', strict: strict = true } = {}) {
        // Wrong type or one of the two undefined, doesn't match
        if (typeof a !== typeof b || !!a !== !!b) return false;
        // Atomic, just compare a against b
        if ($02a5e071daeb5f48$var$is.str(a) || $02a5e071daeb5f48$var$is.num(a) || $02a5e071daeb5f48$var$is.boo(a)) return a === b;
        const isObj = $02a5e071daeb5f48$var$is.obj(a);
        if (isObj && objects === 'reference') return a === b;
        const isArr = $02a5e071daeb5f48$var$is.arr(a);
        if (isArr && arrays === 'reference') return a === b;
        // Array or Object, shallow compare first to see if it's a match
        if ((isArr || isObj) && a === b) return true;
        // Last resort, go through keys
        let i;
        // Check if a has all the keys of b
        for(i in a)if (!(i in b)) return false;
        // Check if values between keys match
        if (isObj && arrays === 'shallow' && objects === 'shallow') {
            for(i in strict ? b : a)if (!$02a5e071daeb5f48$var$is.equ(a[i], b[i], {
                strict: strict,
                objects: 'reference'
            })) return false;
        } else {
            for(i in strict ? b : a)if (a[i] !== b[i]) return false;
        }
        // If i is undefined
        if ($02a5e071daeb5f48$var$is.und(i)) {
            // If both arrays are empty we consider them equal
            if (isArr && a.length === 0 && b.length === 0) return true;
            // If both objects are empty we consider them equal
            if (isObj && Object.keys(a).length === 0 && Object.keys(b).length === 0) return true;
            // Otherwise match them by value
            if (a !== b) return false;
        }
        return true;
    }
};
// Collects nodes and materials from a THREE.Object3D
function $02a5e071daeb5f48$export$4a5767248b18ef41(object) {
    const data = {
        nodes: {},
        materials: {},
        meshes: {}
    };
    if (object) object.traverse((obj)=>{
        if (obj.name) data.nodes[obj.name] = obj;
        if (obj.material && !data.materials[obj.material.name]) data.materials[obj.material.name] = obj.material;
        if (obj.isMesh && !data.meshes[obj.name]) data.meshes[obj.name] = obj;
    });
    return data;
}
// Disposes an object and all its properties
function $02a5e071daeb5f48$export$efccba1c4a2ef57b(obj) {
    if (obj.type !== 'Scene') obj.dispose == null || obj.dispose();
    for(const p in obj){
        const prop = obj[p];
        if ((prop == null ? void 0 : prop.type) !== 'Scene') prop == null || prop.dispose == null || prop.dispose();
    }
}
const $02a5e071daeb5f48$var$REACT_INTERNAL_PROPS = [
    'children',
    'key',
    'ref'
];
// Gets only instance props from reconciler fibers
function $02a5e071daeb5f48$var$getInstanceProps(pendingProps) {
    const props = {};
    for(const key in pendingProps)if (!$02a5e071daeb5f48$var$REACT_INTERNAL_PROPS.includes(key)) props[key] = pendingProps[key];
    return props;
}
// Each object in the scene carries a small LocalState descriptor
function $02a5e071daeb5f48$var$prepare(target, root, type, props) {
    const object = target;
    // Create instance descriptor
    let instance = object == null ? void 0 : object.__r3f;
    if (!instance) {
        instance = {
            root: root,
            type: type,
            parent: null,
            children: [],
            props: $02a5e071daeb5f48$var$getInstanceProps(props),
            object: object,
            eventCount: 0,
            handlers: {},
            isHidden: false
        };
        if (object) object.__r3f = instance;
    }
    return instance;
}
function $02a5e071daeb5f48$var$resolve(root, key) {
    if (!key.includes('-')) return {
        root: root,
        key: key,
        target: root[key]
    };
    // First try the entire key as a single property (e.g., 'foo-bar')
    if (key in root) return {
        root: root,
        key: key,
        target: root[key]
    };
    // Try piercing (e.g., 'material-color' -> material.color)
    let target = root;
    const parts = key.split('-');
    for (const part of parts){
        if (typeof target !== 'object' || target === null) {
            if (target !== undefined) {
                // Property exists but has unexpected shape
                const remaining = parts.slice(parts.indexOf(part)).join('-');
                return {
                    root: target,
                    key: remaining,
                    target: undefined
                };
            }
            // Property doesn't exist - fallback to original key
            return {
                root: root,
                key: key,
                target: undefined
            };
        }
        key = part;
        root = target;
        target = target[key];
    }
    return {
        root: root,
        key: key,
        target: target
    };
}
// Checks if a dash-cased string ends with an integer
const $02a5e071daeb5f48$var$INDEX_REGEX = /-\d+$/;
function $02a5e071daeb5f48$var$attach(parent, child) {
    if ($02a5e071daeb5f48$var$is.str(child.props.attach)) {
        // If attaching into an array (foo-0), create one
        if ($02a5e071daeb5f48$var$INDEX_REGEX.test(child.props.attach)) {
            const index = child.props.attach.replace($02a5e071daeb5f48$var$INDEX_REGEX, '');
            const { root: root, key: key } = $02a5e071daeb5f48$var$resolve(parent.object, index);
            if (!Array.isArray(root[key])) root[key] = [];
        }
        const { root: root, key: key } = $02a5e071daeb5f48$var$resolve(parent.object, child.props.attach);
        child.previousAttach = root[key];
        root[key] = child.object;
    } else if ($02a5e071daeb5f48$var$is.fun(child.props.attach)) child.previousAttach = child.props.attach(parent.object, child.object);
}
function $02a5e071daeb5f48$var$detach(parent, child) {
    if ($02a5e071daeb5f48$var$is.str(child.props.attach)) {
        const { root: root, key: key } = $02a5e071daeb5f48$var$resolve(parent.object, child.props.attach);
        const previous = child.previousAttach;
        // When the previous value was undefined, it means the value was never set to begin with
        if (previous === undefined) delete root[key];
        else root[key] = previous;
    } else child.previousAttach == null || child.previousAttach(parent.object, child.object);
    delete child.previousAttach;
}
const $02a5e071daeb5f48$var$RESERVED_PROPS = [
    ...$02a5e071daeb5f48$var$REACT_INTERNAL_PROPS,
    // Instance props
    'args',
    'dispose',
    'attach',
    'object',
    'onUpdate',
    // Behavior flags
    'dispose'
];
const $02a5e071daeb5f48$var$MEMOIZED_PROTOTYPES = new Map();
function $02a5e071daeb5f48$var$getMemoizedPrototype(root) {
    let ctor = $02a5e071daeb5f48$var$MEMOIZED_PROTOTYPES.get(root.constructor);
    try {
        if (!ctor) {
            ctor = new root.constructor();
            $02a5e071daeb5f48$var$MEMOIZED_PROTOTYPES.set(root.constructor, ctor);
        }
    } catch (e) {
    // ...
    }
    return ctor;
}
// This function prepares a set of changes to be applied to the instance
function $02a5e071daeb5f48$var$diffProps(instance, newProps) {
    const changedProps = {};
    // Sort through props
    for(const prop in newProps){
        // Skip reserved keys
        if ($02a5e071daeb5f48$var$RESERVED_PROPS.includes(prop)) continue;
        // Skip if props match
        if ($02a5e071daeb5f48$var$is.equ(newProps[prop], instance.props[prop])) continue;
        // Props changed, add them
        changedProps[prop] = newProps[prop];
        // Reset pierced props
        for(const other in newProps)if (other.startsWith(`${prop}-`)) changedProps[other] = newProps[other];
    }
    // Reset removed props for HMR
    for(const prop in instance.props){
        if ($02a5e071daeb5f48$var$RESERVED_PROPS.includes(prop) || newProps.hasOwnProperty(prop)) continue;
        const { root: root, key: key } = $02a5e071daeb5f48$var$resolve(instance.object, prop);
        // https://github.com/mrdoob/three.js/issues/21209
        // HMR/fast-refresh relies on the ability to cancel out props, but threejs
        // has no means to do this. Hence we curate a small collection of value-classes
        // with their respective constructor/set arguments
        // For removed props, try to set default values, if possible
        if (root.constructor && root.constructor.length === 0) {
            // create a blank slate of the instance and copy the particular parameter.
            const ctor = $02a5e071daeb5f48$var$getMemoizedPrototype(root);
            if (!$02a5e071daeb5f48$var$is.und(ctor)) changedProps[key] = ctor[key];
        } else // instance does not have constructor, just set it to 0
        changedProps[key] = 0;
    }
    return changedProps;
}
// https://github.com/mrdoob/three.js/pull/27042
// https://github.com/mrdoob/three.js/pull/22748
const $02a5e071daeb5f48$var$colorMaps = [
    'map',
    'emissiveMap',
    'sheenColorMap',
    'specularColorMap',
    'envMap'
];
const $02a5e071daeb5f48$var$EVENT_REGEX = /^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/;
// This function applies a set of changes to the instance
function $02a5e071daeb5f48$export$2408f22a0fab9ae5(object, props) {
    var _instance$object;
    const instance = object.__r3f;
    const rootState = instance && $02a5e071daeb5f48$var$findInitialRoot(instance).getState();
    const prevHandlers = instance == null ? void 0 : instance.eventCount;
    for(const prop in props){
        let value = props[prop];
        // Don't mutate reserved keys
        if ($02a5e071daeb5f48$var$RESERVED_PROPS.includes(prop)) continue;
        // Deal with pointer events, including removing them if undefined
        if (instance && $02a5e071daeb5f48$var$EVENT_REGEX.test(prop)) {
            if (typeof value === 'function') instance.handlers[prop] = value;
            else delete instance.handlers[prop];
            instance.eventCount = Object.keys(instance.handlers).length;
            continue;
        }
        // Ignore setting undefined props
        // https://github.com/pmndrs/react-three-fiber/issues/274
        if (value === undefined) continue;
        let { root: root, key: key, target: target } = $02a5e071daeb5f48$var$resolve(object, prop);
        // Throw an error if we attempted to set a pierced prop to a non-object
        if (target === undefined && (typeof root !== 'object' || root === null)) throw Error(`R3F: Cannot set "${prop}". Ensure it is an object before setting "${key}".`);
        // Layers must be written to the mask property
        if (target instanceof $ce0cdebec9150cb3$export$89312ce47c0ca777 && value instanceof $ce0cdebec9150cb3$export$89312ce47c0ca777) target.mask = value.mask;
        else if (target instanceof $ce0cdebec9150cb3$export$892596cec99bc70e && $02a5e071daeb5f48$var$isColorRepresentation(value)) target.set(value);
        else if (target !== null && typeof target === 'object' && typeof target.set === 'function' && typeof target.copy === 'function' && value != null && value.constructor && target.constructor === value.constructor) target.copy(value);
        else if (target !== null && typeof target === 'object' && typeof target.set === 'function' && Array.isArray(value)) {
            if (typeof target.fromArray === 'function') target.fromArray(value);
            else target.set(...value);
        } else if (target !== null && typeof target === 'object' && typeof target.set === 'function' && typeof value === 'number') {
            // Allow setting array scalars
            if (typeof target.setScalar === 'function') target.setScalar(value);
            else target.set(value);
        } else {
            var _root$key;
            root[key] = value;
            // Auto-convert sRGB texture parameters for built-in materials
            // https://github.com/pmndrs/react-three-fiber/issues/344
            // https://github.com/mrdoob/three.js/pull/25857
            if (rootState && !rootState.linear && $02a5e071daeb5f48$var$colorMaps.includes(key) && (_root$key = root[key]) != null && _root$key.isTexture && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
            root[key].format === $ce0cdebec9150cb3$export$3f8bb04b555a363c && root[key].type === $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10) // NOTE: this cannot be set from the renderer (e.g. sRGB source textures rendered to P3)
            root[key].colorSpace = $ce0cdebec9150cb3$export$561f394b24edfcaa;
        }
    }
    // Register event handlers
    if (instance != null && instance.parent && rootState != null && rootState.internal && (_instance$object = instance.object) != null && _instance$object.isObject3D && prevHandlers !== instance.eventCount) {
        const object = instance.object;
        // Pre-emptively remove the instance from the interaction manager
        const index = rootState.internal.interaction.indexOf(object);
        if (index > -1) rootState.internal.interaction.splice(index, 1);
        // Add the instance to the interaction manager only when it has handlers
        if (instance.eventCount && object.raycast !== null) rootState.internal.interaction.push(object);
    }
    // Auto-attach geometries and materials
    if (instance && instance.props.attach === undefined) {
        if (instance.object.isBufferGeometry) instance.props.attach = 'geometry';
        else if (instance.object.isMaterial) instance.props.attach = 'material';
    }
    // Instance was updated, request a frame
    if (instance) $02a5e071daeb5f48$var$invalidateInstance(instance);
    return object;
}
function $02a5e071daeb5f48$var$invalidateInstance(instance) {
    var _instance$root;
    if (!instance.parent) return;
    instance.props.onUpdate == null || instance.props.onUpdate(instance.object);
    const state = (_instance$root = instance.root) == null ? void 0 : _instance$root.getState == null ? void 0 : _instance$root.getState();
    if (state && state.internal.frames === 0) state.invalidate();
}
function $02a5e071daeb5f48$var$updateCamera(camera, size) {
    // Do not mess with the camera if it belongs to the user
    // https://github.com/pmndrs/react-three-fiber/issues/92
    if (camera.manual) return;
    if ($02a5e071daeb5f48$var$isOrthographicCamera(camera)) {
        camera.left = size.width / -2;
        camera.right = size.width / 2;
        camera.top = size.height / 2;
        camera.bottom = size.height / -2;
    } else camera.aspect = size.width / size.height;
    camera.updateProjectionMatrix();
}
const $02a5e071daeb5f48$var$isObject3D = (object)=>object == null ? void 0 : object.isObject3D;
function $02a5e071daeb5f48$var$makeId(event) {
    return (event.eventObject || event.object).uuid + '/' + event.index + event.instanceId;
}
/**
 * Release pointer captures.
 * This is called by releasePointerCapture in the API, and when an object is removed.
 */ function $02a5e071daeb5f48$var$releaseInternalPointerCapture(capturedMap, obj, captures, pointerId) {
    const captureData = captures.get(obj);
    if (captureData) {
        captures.delete(obj);
        // If this was the last capturing object for this pointer
        if (captures.size === 0) {
            capturedMap.delete(pointerId);
            captureData.target.releasePointerCapture(pointerId);
        }
    }
}
function $02a5e071daeb5f48$var$removeInteractivity(store, object) {
    const { internal: internal } = store.getState();
    // Removes every trace of an object from the data store
    internal.interaction = internal.interaction.filter((o)=>o !== object);
    internal.initialHits = internal.initialHits.filter((o)=>o !== object);
    internal.hovered.forEach((value, key)=>{
        if (value.eventObject === object || value.object === object) // Clear out intersects, they are outdated by now
        internal.hovered.delete(key);
    });
    internal.capturedMap.forEach((captures, pointerId)=>{
        $02a5e071daeb5f48$var$releaseInternalPointerCapture(internal.capturedMap, object, captures, pointerId);
    });
}
function $02a5e071daeb5f48$export$39b482c5e57630a8(store) {
    /** Calculates delta */ function calculateDistance(event) {
        const { internal: internal } = store.getState();
        const dx = event.offsetX - internal.initialClick[0];
        const dy = event.offsetY - internal.initialClick[1];
        return Math.round(Math.sqrt(dx * dx + dy * dy));
    }
    /** Returns true if an instance has a valid pointer-event registered, this excludes scroll, clicks etc */ function filterPointerEvents(objects) {
        return objects.filter((obj)=>[
                'Move',
                'Over',
                'Enter',
                'Out',
                'Leave'
            ].some((name)=>{
                var _r3f;
                return (_r3f = obj.__r3f) == null ? void 0 : _r3f.handlers['onPointer' + name];
            }));
    }
    function intersect(event, filter) {
        const state = store.getState();
        const duplicates = new Set();
        const intersections = [];
        // Allow callers to eliminate event objects
        const eventsObjects = filter ? filter(state.internal.interaction) : state.internal.interaction;
        // Reset all raycaster cameras to undefined
        for(let i = 0; i < eventsObjects.length; i++){
            const state = $02a5e071daeb5f48$export$90a7f3efeed30595(eventsObjects[i]);
            if (state) state.raycaster.camera = undefined;
        }
        if (!state.previousRoot) // Make sure root-level pointer and ray are set up
        state.events.compute == null || state.events.compute(event, state);
        function handleRaycast(obj) {
            const state = $02a5e071daeb5f48$export$90a7f3efeed30595(obj);
            // Skip event handling when noEvents is set, or when the raycasters camera is null
            if (!state || !state.events.enabled || state.raycaster.camera === null) return [];
            // When the camera is undefined we have to call the event layers update function
            if (state.raycaster.camera === undefined) {
                var _state$previousRoot;
                state.events.compute == null || state.events.compute(event, state, (_state$previousRoot = state.previousRoot) == null ? void 0 : _state$previousRoot.getState());
                // If the camera is still undefined we have to skip this layer entirely
                if (state.raycaster.camera === undefined) state.raycaster.camera = null;
            }
            // Intersect object by object
            return state.raycaster.camera ? state.raycaster.intersectObject(obj, true) : [];
        }
        // Collect events
        let hits = eventsObjects// Intersect objects
        .flatMap(handleRaycast)// Sort by event priority and distance
        .sort((a, b)=>{
            const aState = $02a5e071daeb5f48$export$90a7f3efeed30595(a.object);
            const bState = $02a5e071daeb5f48$export$90a7f3efeed30595(b.object);
            if (!aState || !bState) return a.distance - b.distance;
            return bState.events.priority - aState.events.priority || a.distance - b.distance;
        })// Filter out duplicates
        .filter((item)=>{
            const id = $02a5e071daeb5f48$var$makeId(item);
            if (duplicates.has(id)) return false;
            duplicates.add(id);
            return true;
        });
        // https://github.com/mrdoob/three.js/issues/16031
        // Allow custom userland intersect sort order, this likely only makes sense on the root filter
        if (state.events.filter) hits = state.events.filter(hits, state);
        // Bubble up the events, find the event source (eventObject)
        for (const hit of hits){
            let eventObject = hit.object;
            // Bubble event up
            while(eventObject){
                var _r3f2;
                if ((_r3f2 = eventObject.__r3f) != null && _r3f2.eventCount) intersections.push({
                    ...hit,
                    eventObject: eventObject
                });
                eventObject = eventObject.parent;
            }
        }
        // If the interaction is captured, make all capturing targets part of the intersect.
        if ('pointerId' in event && state.internal.capturedMap.has(event.pointerId)) {
            for (let captureData of state.internal.capturedMap.get(event.pointerId).values())if (!duplicates.has($02a5e071daeb5f48$var$makeId(captureData.intersection))) intersections.push(captureData.intersection);
        }
        return intersections;
    }
    /**  Handles intersections by forwarding them to handlers */ function handleIntersects(intersections, event, delta, callback) {
        // If anything has been found, forward it to the event listeners
        if (intersections.length) {
            const localState = {
                stopped: false
            };
            for (const hit of intersections){
                let state = $02a5e071daeb5f48$export$90a7f3efeed30595(hit.object);
                // If the object is not managed by R3F, it might be parented to an element which is.
                // Traverse upwards until we find a managed parent and use its state instead.
                if (!state) hit.object.traverseAncestors((obj)=>{
                    const parentState = $02a5e071daeb5f48$export$90a7f3efeed30595(obj);
                    if (parentState) {
                        state = parentState;
                        return false;
                    }
                });
                if (state) {
                    const { raycaster: raycaster, pointer: pointer, camera: camera, internal: internal } = state;
                    const unprojectedPoint = new $ce0cdebec9150cb3$export$64b5c384219d3699(pointer.x, pointer.y, 0).unproject(camera);
                    const hasPointerCapture = (id)=>{
                        var _internal$capturedMap, _internal$capturedMap2;
                        return (_internal$capturedMap = (_internal$capturedMap2 = internal.capturedMap.get(id)) == null ? void 0 : _internal$capturedMap2.has(hit.eventObject)) != null ? _internal$capturedMap : false;
                    };
                    const setPointerCapture = (id)=>{
                        const captureData = {
                            intersection: hit,
                            target: event.target
                        };
                        if (internal.capturedMap.has(id)) // if the pointerId was previously captured, we add the hit to the
                        // event capturedMap.
                        internal.capturedMap.get(id).set(hit.eventObject, captureData);
                        else // if the pointerId was not previously captured, we create a map
                        // containing the hitObject, and the hit. hitObject is used for
                        // faster access.
                        internal.capturedMap.set(id, new Map([
                            [
                                hit.eventObject,
                                captureData
                            ]
                        ]));
                        event.target.setPointerCapture(id);
                    };
                    const releasePointerCapture = (id)=>{
                        const captures = internal.capturedMap.get(id);
                        if (captures) $02a5e071daeb5f48$var$releaseInternalPointerCapture(internal.capturedMap, hit.eventObject, captures, id);
                    };
                    // Add native event props
                    let extractEventProps = {};
                    // This iterates over the event's properties including the inherited ones. Native PointerEvents have most of their props as getters which are inherited, but polyfilled PointerEvents have them all as their own properties (i.e. not inherited). We can't use Object.keys() or Object.entries() as they only return "own" properties; nor Object.getPrototypeOf(event) as that *doesn't* return "own" properties, only inherited ones.
                    for(let prop in event){
                        let property = event[prop];
                        // Only copy over atomics, leave functions alone as these should be
                        // called as event.nativeEvent.fn()
                        if (typeof property !== 'function') extractEventProps[prop] = property;
                    }
                    let raycastEvent = {
                        ...hit,
                        ...extractEventProps,
                        pointer: pointer,
                        intersections: intersections,
                        stopped: localState.stopped,
                        delta: delta,
                        unprojectedPoint: unprojectedPoint,
                        ray: raycaster.ray,
                        camera: camera,
                        // Hijack stopPropagation, which just sets a flag
                        stopPropagation () {
                            // https://github.com/pmndrs/react-three-fiber/issues/596
                            // Events are not allowed to stop propagation if the pointer has been captured
                            const capturesForPointer = 'pointerId' in event && internal.capturedMap.get(event.pointerId);
                            // We only authorize stopPropagation...
                            if (// ...if this pointer hasn't been captured
                            !capturesForPointer || // ... or if the hit object is capturing the pointer
                            capturesForPointer.has(hit.eventObject)) {
                                raycastEvent.stopped = localState.stopped = true;
                                // Propagation is stopped, remove all other hover records
                                // An event handler is only allowed to flush other handlers if it is hovered itself
                                if (internal.hovered.size && Array.from(internal.hovered.values()).find((i)=>i.eventObject === hit.eventObject)) {
                                    // Objects cannot flush out higher up objects that have already caught the event
                                    const higher = intersections.slice(0, intersections.indexOf(hit));
                                    cancelPointer([
                                        ...higher,
                                        hit
                                    ]);
                                }
                            }
                        },
                        // there should be a distinction between target and currentTarget
                        target: {
                            hasPointerCapture: hasPointerCapture,
                            setPointerCapture: setPointerCapture,
                            releasePointerCapture: releasePointerCapture
                        },
                        currentTarget: {
                            hasPointerCapture: hasPointerCapture,
                            setPointerCapture: setPointerCapture,
                            releasePointerCapture: releasePointerCapture
                        },
                        nativeEvent: event
                    };
                    // Call subscribers
                    callback(raycastEvent);
                    // Event bubbling may be interrupted by stopPropagation
                    if (localState.stopped === true) break;
                }
            }
        }
        return intersections;
    }
    function cancelPointer(intersections) {
        const { internal: internal } = store.getState();
        for (const hoveredObj of internal.hovered.values())// When no objects were hit or the the hovered object wasn't found underneath the cursor
        // we call onPointerOut and delete the object from the hovered-elements map
        if (!intersections.length || !intersections.find((hit)=>hit.object === hoveredObj.object && hit.index === hoveredObj.index && hit.instanceId === hoveredObj.instanceId)) {
            const eventObject = hoveredObj.eventObject;
            const instance = eventObject.__r3f;
            internal.hovered.delete($02a5e071daeb5f48$var$makeId(hoveredObj));
            if (instance != null && instance.eventCount) {
                const handlers = instance.handlers;
                // Clear out intersects, they are outdated by now
                const data = {
                    ...hoveredObj,
                    intersections: intersections
                };
                handlers.onPointerOut == null || handlers.onPointerOut(data);
                handlers.onPointerLeave == null || handlers.onPointerLeave(data);
            }
        }
    }
    function pointerMissed(event, objects) {
        for(let i = 0; i < objects.length; i++){
            const instance = objects[i].__r3f;
            instance == null || instance.handlers.onPointerMissed == null || instance.handlers.onPointerMissed(event);
        }
    }
    function handlePointer(name) {
        // Deal with cancelation
        switch(name){
            case 'onPointerLeave':
            case 'onPointerCancel':
                return ()=>cancelPointer([]);
            case 'onLostPointerCapture':
                return (event)=>{
                    const { internal: internal } = store.getState();
                    if ('pointerId' in event && internal.capturedMap.has(event.pointerId)) // If the object event interface had onLostPointerCapture, we'd call it here on every
                    // object that's getting removed. We call it on the next frame because onLostPointerCapture
                    // fires before onPointerUp. Otherwise pointerUp would never be called if the event didn't
                    // happen in the object it originated from, leaving components in a in-between state.
                    requestAnimationFrame(()=>{
                        // Only release if pointer-up didn't do it already
                        if (internal.capturedMap.has(event.pointerId)) {
                            internal.capturedMap.delete(event.pointerId);
                            cancelPointer([]);
                        }
                    });
                };
        }
        // Any other pointer goes here ...
        return function handleEvent(event) {
            const { onPointerMissed: onPointerMissed, internal: internal } = store.getState();
            // prepareRay(event)
            internal.lastEvent.current = event;
            // Get fresh intersects
            const isPointerMove = name === 'onPointerMove';
            const isClickEvent = name === 'onClick' || name === 'onContextMenu' || name === 'onDoubleClick';
            const filter = isPointerMove ? filterPointerEvents : undefined;
            const hits = intersect(event, filter);
            const delta = isClickEvent ? calculateDistance(event) : 0;
            // Save initial coordinates on pointer-down
            if (name === 'onPointerDown') {
                internal.initialClick = [
                    event.offsetX,
                    event.offsetY
                ];
                internal.initialHits = hits.map((hit)=>hit.eventObject);
            }
            // If a click yields no results, pass it back to the user as a miss
            // Missed events have to come first in order to establish user-land side-effect clean up
            if (isClickEvent && !hits.length) {
                if (delta <= 2) {
                    pointerMissed(event, internal.interaction);
                    if (onPointerMissed) onPointerMissed(event);
                }
            }
            // Take care of unhover
            if (isPointerMove) cancelPointer(hits);
            function onIntersect(data) {
                const eventObject = data.eventObject;
                const instance = eventObject.__r3f;
                // Check presence of handlers
                if (!(instance != null && instance.eventCount)) return;
                const handlers = instance.handlers;
                /*
        MAYBE TODO, DELETE IF NOT: 
          Check if the object is captured, captured events should not have intersects running in parallel
          But wouldn't it be better to just replace capturedMap with a single entry?
          Also, are we OK with straight up making picking up multiple objects impossible?
          
        const pointerId = (data as ThreeEvent<PointerEvent>).pointerId        
        if (pointerId !== undefined) {
          const capturedMeshSet = internal.capturedMap.get(pointerId)
          if (capturedMeshSet) {
            const captured = capturedMeshSet.get(eventObject)
            if (captured && captured.localState.stopped) return
          }
        }*/ if (isPointerMove) {
                    // Move event ...
                    if (handlers.onPointerOver || handlers.onPointerEnter || handlers.onPointerOut || handlers.onPointerLeave) {
                        // When enter or out is present take care of hover-state
                        const id = $02a5e071daeb5f48$var$makeId(data);
                        const hoveredItem = internal.hovered.get(id);
                        if (!hoveredItem) {
                            // If the object wasn't previously hovered, book it and call its handler
                            internal.hovered.set(id, data);
                            handlers.onPointerOver == null || handlers.onPointerOver(data);
                            handlers.onPointerEnter == null || handlers.onPointerEnter(data);
                        } else if (hoveredItem.stopped) // If the object was previously hovered and stopped, we shouldn't allow other items to proceed
                        data.stopPropagation();
                    }
                    // Call mouse move
                    handlers.onPointerMove == null || handlers.onPointerMove(data);
                } else {
                    // All other events ...
                    const handler = handlers[name];
                    if (handler) // Forward all events back to their respective handlers with the exception of click events,
                    // which must use the initial target
                    {
                        if (!isClickEvent || internal.initialHits.includes(eventObject)) {
                            // Missed events have to come first
                            pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                            // Now call the handler
                            handler(data);
                        }
                    } else // Trigger onPointerMissed on all elements that have pointer over/out handlers, but not click and weren't hit
                    if (isClickEvent && internal.initialHits.includes(eventObject)) pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                }
            }
            handleIntersects(hits, event, delta, onIntersect);
        };
    }
    return {
        handlePointer: handlePointer
    };
}
const $02a5e071daeb5f48$var$isRenderer = (def)=>!!(def != null && def.render);
const $02a5e071daeb5f48$export$9e5f44173e64f162 = /* @__PURE__ */ $2WGWz.createContext(null);
const $02a5e071daeb5f48$var$createStore = (invalidate, advance)=>{
    const rootStore = (0, $ab264bb1b0f39ff6$export$c883e057baa24e24)((set, get)=>{
        const position = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const defaultTarget = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        const tempTarget = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        function getCurrentViewport(camera = get().camera, target = defaultTarget, size = get().size) {
            const { width: width, height: height, top: top, left: left } = size;
            const aspect = width / height;
            if (target.isVector3) tempTarget.copy(target);
            else tempTarget.set(...target);
            const distance = camera.getWorldPosition(position).distanceTo(tempTarget);
            if ($02a5e071daeb5f48$var$isOrthographicCamera(camera)) return {
                width: width / camera.zoom,
                height: height / camera.zoom,
                top: top,
                left: left,
                factor: 1,
                distance: distance,
                aspect: aspect
            };
            else {
                const fov = camera.fov * Math.PI / 180; // convert vertical fov to radians
                const h = 2 * Math.tan(fov / 2) * distance; // visible height
                const w = h * (width / height);
                return {
                    width: w,
                    height: h,
                    top: top,
                    left: left,
                    factor: width / w,
                    distance: distance,
                    aspect: aspect
                };
            }
        }
        let performanceTimeout = undefined;
        const setPerformanceCurrent = (current)=>set((state)=>({
                    performance: {
                        ...state.performance,
                        current: current
                    }
                }));
        const pointer = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
        const rootState = {
            set: set,
            get: get,
            // Mock objects that have to be configured
            gl: null,
            camera: null,
            raycaster: null,
            events: {
                priority: 1,
                enabled: true,
                connected: false
            },
            scene: null,
            xr: null,
            invalidate: (frames = 1)=>invalidate(get(), frames),
            advance: (timestamp, runGlobalEffects)=>advance(timestamp, runGlobalEffects, get()),
            legacy: false,
            linear: false,
            flat: false,
            controls: null,
            clock: new $ce0cdebec9150cb3$export$9735c82c4bae3302(),
            pointer: pointer,
            mouse: pointer,
            frameloop: 'always',
            onPointerMissed: undefined,
            performance: {
                current: 1,
                min: 0.5,
                max: 1,
                debounce: 200,
                regress: ()=>{
                    const state = get();
                    // Clear timeout
                    if (performanceTimeout) clearTimeout(performanceTimeout);
                    // Set lower bound performance
                    if (state.performance.current !== state.performance.min) setPerformanceCurrent(state.performance.min);
                    // Go back to upper bound performance after a while unless something regresses meanwhile
                    performanceTimeout = setTimeout(()=>setPerformanceCurrent(get().performance.max), state.performance.debounce);
                }
            },
            size: {
                width: 0,
                height: 0,
                top: 0,
                left: 0
            },
            viewport: {
                initialDpr: 0,
                dpr: 0,
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                aspect: 0,
                distance: 0,
                factor: 0,
                getCurrentViewport: getCurrentViewport
            },
            setEvents: (events)=>set((state)=>({
                        ...state,
                        events: {
                            ...state.events,
                            ...events
                        }
                    })),
            setSize: (width, height, top = 0, left = 0)=>{
                const camera = get().camera;
                const size = {
                    width: width,
                    height: height,
                    top: top,
                    left: left
                };
                set((state)=>({
                        size: size,
                        viewport: {
                            ...state.viewport,
                            ...getCurrentViewport(camera, defaultTarget, size)
                        }
                    }));
            },
            setDpr: (dpr)=>set((state)=>{
                    const resolved = $02a5e071daeb5f48$var$calculateDpr(dpr);
                    return {
                        viewport: {
                            ...state.viewport,
                            dpr: resolved,
                            initialDpr: state.viewport.initialDpr || resolved
                        }
                    };
                }),
            setFrameloop: (frameloop = 'always')=>{
                const clock = get().clock;
                // if frameloop === "never" clock.elapsedTime is updated using advance(timestamp)
                clock.stop();
                clock.elapsedTime = 0;
                if (frameloop !== 'never') {
                    clock.start();
                    clock.elapsedTime = 0;
                }
                set(()=>({
                        frameloop: frameloop
                    }));
            },
            previousRoot: undefined,
            internal: {
                // Events
                interaction: [],
                hovered: new Map(),
                subscribers: [],
                initialClick: [
                    0,
                    0
                ],
                initialHits: [],
                capturedMap: new Map(),
                lastEvent: /*#__PURE__*/ $2WGWz.createRef(),
                // Updates
                active: false,
                frames: 0,
                priority: 0,
                subscribe: (ref, priority, store)=>{
                    const internal = get().internal;
                    // If this subscription was given a priority, it takes rendering into its own hands
                    // For that reason we switch off automatic rendering and increase the manual flag
                    // As long as this flag is positive there can be no internal rendering at all
                    // because there could be multiple render subscriptions
                    internal.priority = internal.priority + (priority > 0 ? 1 : 0);
                    internal.subscribers.push({
                        ref: ref,
                        priority: priority,
                        store: store
                    });
                    // Register subscriber and sort layers from lowest to highest, meaning,
                    // highest priority renders last (on top of the other frames)
                    internal.subscribers = internal.subscribers.sort((a, b)=>a.priority - b.priority);
                    return ()=>{
                        const internal = get().internal;
                        if (internal != null && internal.subscribers) {
                            // Decrease manual flag if this subscription had a priority
                            internal.priority = internal.priority - (priority > 0 ? 1 : 0);
                            // Remove subscriber from list
                            internal.subscribers = internal.subscribers.filter((s)=>s.ref !== ref);
                        }
                    };
                }
            }
        };
        return rootState;
    });
    const state = rootStore.getState();
    let oldSize = state.size;
    let oldDpr = state.viewport.dpr;
    let oldCamera = state.camera;
    rootStore.subscribe(()=>{
        const { camera: camera, size: size, viewport: viewport, gl: gl, set: set } = rootStore.getState();
        // Resize camera and renderer on changes to size and pixelratio
        if (size.width !== oldSize.width || size.height !== oldSize.height || viewport.dpr !== oldDpr) {
            oldSize = size;
            oldDpr = viewport.dpr;
            // Update camera & renderer
            $02a5e071daeb5f48$var$updateCamera(camera, size);
            if (viewport.dpr > 0) gl.setPixelRatio(viewport.dpr);
            const updateStyle = typeof HTMLCanvasElement !== 'undefined' && gl.domElement instanceof HTMLCanvasElement;
            gl.setSize(size.width, size.height, updateStyle);
        }
        // Update viewport once the camera changes
        if (camera !== oldCamera) {
            oldCamera = camera;
            // Update viewport
            set((state)=>({
                    viewport: {
                        ...state.viewport,
                        ...state.viewport.getCurrentViewport(camera)
                    }
                }));
        }
    });
    // Invalidate on any change
    rootStore.subscribe((state)=>invalidate(state));
    // Return root state
    return rootStore;
};
/**
 * Exposes an object's {@link Instance}.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#useInstanceHandle
 *
 * **Note**: this is an escape hatch to react-internal fields. Expect this to change significantly between versions.
 */ function $02a5e071daeb5f48$export$df995fae86a55f06(ref) {
    const instance = $2WGWz.useRef(null);
    $2WGWz.useImperativeHandle(instance, ()=>ref.current.__r3f, [
        ref
    ]);
    return instance;
}
/**
 * Returns the R3F Canvas' Zustand store. Useful for [transient updates](https://github.com/pmndrs/zustand#transient-updates-for-often-occurring-state-changes).
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usestore
 */ function $02a5e071daeb5f48$export$ebd11618f299a286() {
    const store = $2WGWz.useContext($02a5e071daeb5f48$export$9e5f44173e64f162);
    if (!store) throw new Error('R3F: Hooks can only be used within the Canvas component!');
    return store;
}
/**
 * Accesses R3F's internal state, containing renderer, canvas, scene, etc.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usethree
 */ function $02a5e071daeb5f48$export$e7094788287c5e9b(selector = (state)=>state, equalityFn) {
    return $02a5e071daeb5f48$export$ebd11618f299a286()(selector, equalityFn);
}
/**
 * Executes a callback before render in a shared frame loop.
 * Can order effects with render priority or manually render with a positive priority.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useframe
 */ function $02a5e071daeb5f48$export$96f57966bedc81b4(callback, renderPriority = 0) {
    const store = $02a5e071daeb5f48$export$ebd11618f299a286();
    const subscribe = store.getState().internal.subscribe;
    // Memoize ref
    const ref = $02a5e071daeb5f48$export$407448d2b89b1813(callback);
    // Subscribe on mount, unsubscribe on unmount
    $02a5e071daeb5f48$export$8b22cf2602fb60ce(()=>subscribe(ref, renderPriority, store), [
        renderPriority,
        subscribe,
        store
    ]);
    return null;
}
/**
 * Returns a node graph of an object with named nodes & materials.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usegraph
 */ function $02a5e071daeb5f48$export$d66501df72047452(object) {
    return $2WGWz.useMemo(()=>$02a5e071daeb5f48$export$4a5767248b18ef41(object), [
        object
    ]);
}
const $02a5e071daeb5f48$var$memoizedLoaders = new WeakMap();
const $02a5e071daeb5f48$var$isConstructor$1 = (value)=>{
    var _value$prototype;
    return typeof value === 'function' && (value == null ? void 0 : (_value$prototype = value.prototype) == null ? void 0 : _value$prototype.constructor) === value;
};
function $02a5e071daeb5f48$var$loadingFn(extensions, onProgress) {
    return function(Proto, ...input) {
        let loader;
        // Construct and cache loader if constructor was passed
        if ($02a5e071daeb5f48$var$isConstructor$1(Proto)) {
            loader = $02a5e071daeb5f48$var$memoizedLoaders.get(Proto);
            if (!loader) {
                loader = new Proto();
                $02a5e071daeb5f48$var$memoizedLoaders.set(Proto, loader);
            }
        } else loader = Proto;
        // Apply loader extensions
        if (extensions) extensions(loader);
        // Go through the urls and load them
        return Promise.all(input.map((input)=>new Promise((res, reject)=>loader.load(input, (data)=>{
                    if ($02a5e071daeb5f48$var$isObject3D(data == null ? void 0 : data.scene)) Object.assign(data, $02a5e071daeb5f48$export$4a5767248b18ef41(data.scene));
                    res(data);
                }, onProgress, (error)=>reject(new Error(`Could not load ${input}: ${error == null ? void 0 : error.message}`))))));
    };
}
/**
 * Synchronously loads and caches assets with a three loader.
 *
 * Note: this hook's caller must be wrapped with `React.Suspense`
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useloader
 */ function $02a5e071daeb5f48$export$2329c99376c9d0a4(loader, input, extensions, onProgress) {
    // Use suspense to load async assets
    const keys = Array.isArray(input) ? input : [
        input
    ];
    const results = (0, $80d81cbdf67965be$export$a1428c8f7ba796e8)($02a5e071daeb5f48$var$loadingFn(extensions, onProgress), [
        loader,
        ...keys
    ], {
        equal: $02a5e071daeb5f48$var$is.equ
    });
    // Return the object(s)
    return Array.isArray(input) ? results : results[0];
}
/**
 * Preloads an asset into cache as a side-effect.
 */ $02a5e071daeb5f48$export$2329c99376c9d0a4.preload = function(loader, input, extensions) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $80d81cbdf67965be$export$513ccb98c53b8039)($02a5e071daeb5f48$var$loadingFn(extensions), [
        loader,
        ...keys
    ]);
};
/**
 * Removes a loaded asset from cache.
 */ $02a5e071daeb5f48$export$2329c99376c9d0a4.clear = function(loader, input) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $80d81cbdf67965be$export$42ffd38884aecdac)([
        loader,
        ...keys
    ]);
};
/**
 * @license React
 * react-reconciler-constants.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ const $02a5e071daeb5f48$var$t = 1, $02a5e071daeb5f48$var$o = 8, $02a5e071daeb5f48$var$r = 32, $02a5e071daeb5f48$var$e = 2;
var $02a5e071daeb5f48$var$packageData = {
    name: "@react-three/fiber",
    version: "9.5.0",
    description: "A React renderer for Threejs",
    keywords: [
        "react",
        "renderer",
        "fiber",
        "three",
        "threejs"
    ],
    author: "Paul Henschel (https://github.com/drcmda)",
    license: "MIT",
    maintainers: [
        "Josh Ellis (https://github.com/joshuaellis)",
        "Cody Bennett (https://github.com/codyjasonbennett)",
        "Kris Baumgarter (https://github.com/krispya)"
    ],
    bugs: {
        url: "https://github.com/pmndrs/react-three-fiber/issues"
    },
    homepage: "https://github.com/pmndrs/react-three-fiber#readme",
    repository: {
        type: "git",
        url: "git+https://github.com/pmndrs/react-three-fiber.git"
    },
    collective: {
        type: "opencollective",
        url: "https://opencollective.com/react-three-fiber"
    },
    main: "dist/react-three-fiber.cjs.js",
    module: "dist/react-three-fiber.esm.js",
    types: "dist/react-three-fiber.cjs.d.ts",
    "react-native": "native/dist/react-three-fiber-native.cjs.js",
    sideEffects: false,
    preconstruct: {
        entrypoints: [
            "index.tsx",
            "native.tsx"
        ]
    },
    scripts: {
        prebuild: "cp ../../readme.md readme.md"
    },
    devDependencies: {
        "@types/react-reconciler": "^0.32.3",
        "react-reconciler": "^0.33.0"
    },
    dependencies: {
        "@babel/runtime": "^7.17.8",
        "@types/webxr": "*",
        "base64-js": "^1.5.1",
        buffer: "^6.0.3",
        "its-fine": "^2.0.0",
        "react-use-measure": "^2.1.7",
        scheduler: "^0.27.0",
        "suspend-react": "^0.1.3",
        "use-sync-external-store": "^1.4.0",
        zustand: "^5.0.3"
    },
    peerDependencies: {
        expo: ">=43.0",
        "expo-asset": ">=8.4",
        "expo-file-system": ">=11.0",
        "expo-gl": ">=11.0",
        react: ">=19 <19.3",
        "react-dom": ">=19 <19.3",
        "react-native": ">=0.78",
        three: ">=0.156"
    },
    peerDependenciesMeta: {
        "react-dom": {
            optional: true
        },
        "react-native": {
            optional: true
        },
        expo: {
            optional: true
        },
        "expo-asset": {
            optional: true
        },
        "expo-file-system": {
            optional: true
        },
        "expo-gl": {
            optional: true
        }
    }
};
function $02a5e071daeb5f48$var$Xb(Tt) {
    return Tt && Tt.__esModule && Object.prototype.hasOwnProperty.call(Tt, "default") ? Tt.default : Tt;
}
var $02a5e071daeb5f48$var$Rm = {
    exports: {}
}, $02a5e071daeb5f48$var$Og = {
    exports: {}
}; /**
     * @license React
     * react-reconciler.production.js
     *
     * Copyright (c) Meta Platforms, Inc. and affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */ 
$02a5e071daeb5f48$var$Og.exports;
var $02a5e071daeb5f48$var$_b;
function $02a5e071daeb5f48$var$Kb() {
    return $02a5e071daeb5f48$var$_b || ($02a5e071daeb5f48$var$_b = 1, function(Tt) {
        Tt.exports = function(m) {
            function Yn(t, r, a, l) {
                return new uc(t, r, a, l);
            }
            function _d() {}
            function F(t) {
                var r = "https://react.dev/errors/" + t;
                if (1 < arguments.length) {
                    r += "?args[]=" + encodeURIComponent(arguments[1]);
                    for(var a = 2; a < arguments.length; a++)r += "&args[]=" + encodeURIComponent(arguments[a]);
                }
                return "Minified React error #" + t + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            function Rd(t) {
                var r = t, a = t;
                if (t.alternate) for(; r.return;)r = r.return;
                else {
                    t = r;
                    do r = t, (r.flags & 4098) !== 0 && (a = r.return), t = r.return;
                    while (t);
                }
                return r.tag === 3 ? a : null;
            }
            function du(t) {
                if (Rd(t) !== t) throw Error(F(188));
            }
            function fu(t) {
                var r = t.alternate;
                if (!r) {
                    if (r = Rd(t), r === null) throw Error(F(188));
                    return r !== t ? null : t;
                }
                for(var a = t, l = r;;){
                    var c = a.return;
                    if (c === null) break;
                    var d = c.alternate;
                    if (d === null) {
                        if (l = c.return, l !== null) {
                            a = l;
                            continue;
                        }
                        break;
                    }
                    if (c.child === d.child) {
                        for(d = c.child; d;){
                            if (d === a) return du(c), t;
                            if (d === l) return du(c), r;
                            d = d.sibling;
                        }
                        throw Error(F(188));
                    }
                    if (a.return !== l.return) a = c, l = d;
                    else {
                        for(var h = !1, y = c.child; y;){
                            if (y === a) {
                                h = !0, a = c, l = d;
                                break;
                            }
                            if (y === l) {
                                h = !0, l = c, a = d;
                                break;
                            }
                            y = y.sibling;
                        }
                        if (!h) {
                            for(y = d.child; y;){
                                if (y === a) {
                                    h = !0, a = d, l = c;
                                    break;
                                }
                                if (y === l) {
                                    h = !0, l = d, a = c;
                                    break;
                                }
                                y = y.sibling;
                            }
                            if (!h) throw Error(F(189));
                        }
                    }
                    if (a.alternate !== l) throw Error(F(190));
                }
                if (a.tag !== 3) throw Error(F(188));
                return a.stateNode.current === a ? t : r;
            }
            function pu(t) {
                var r = t.tag;
                if (r === 5 || r === 26 || r === 27 || r === 6) return t;
                for(t = t.child; t !== null;){
                    if (r = pu(t), r !== null) return r;
                    t = t.sibling;
                }
                return null;
            }
            function lt(t) {
                var r = t.tag;
                if (r === 5 || r === 26 || r === 27 || r === 6) return t;
                for(t = t.child; t !== null;){
                    if (t.tag !== 4 && (r = lt(t), r !== null)) return r;
                    t = t.sibling;
                }
                return null;
            }
            function Fl(t) {
                return t === null || typeof t != "object" ? null : (t = Pf && t[Pf] || t["@@iterator"], typeof t == "function" ? t : null);
            }
            function hu(t) {
                if (t == null) return null;
                if (typeof t == "function") return t.$$typeof === xf ? null : t.displayName || t.name || null;
                if (typeof t == "string") return t;
                switch(t){
                    case $a:
                        return "Fragment";
                    case Cs:
                        return "Profiler";
                    case kf:
                        return "StrictMode";
                    case Va:
                        return "Suspense";
                    case Te:
                        return "SuspenseList";
                    case gc:
                        return "Activity";
                }
                if (typeof t == "object") switch(t.$$typeof){
                    case sa:
                        return "Portal";
                    case Io:
                        return t.displayName || "Context";
                    case mc:
                        return (t._context.displayName || "Context") + ".Consumer";
                    case Zi:
                        var r = t.render;
                        return t = t.displayName, t || (t = r.displayName || r.name || "", t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"), t;
                    case wf:
                        return r = t.displayName || null, r !== null ? r : hu(t.type) || "Memo";
                    case ua:
                        r = t._payload, t = t._init;
                        try {
                            return hu(t(r));
                        } catch  {}
                }
                return null;
            }
            function Ir(t) {
                return {
                    current: t
                };
            }
            function D(t) {
                0 > tl || (t.current = Hs[tl], Hs[tl] = null, tl--);
            }
            function Ce(t, r) {
                tl++, Hs[tl] = t.current, t.current = r;
            }
            function Em(t) {
                return t >>>= 0, t === 0 ? 32 : 31 - (Dh(t) / Wh | 0) | 0;
            }
            function Zo(t) {
                var r = t & 42;
                if (r !== 0) return r;
                switch(t & -t){
                    case 1:
                        return 1;
                    case 2:
                        return 2;
                    case 4:
                        return 4;
                    case 8:
                        return 8;
                    case 16:
                        return 16;
                    case 32:
                        return 32;
                    case 64:
                        return 64;
                    case 128:
                        return 128;
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                        return t & 261888;
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                        return t & 3932160;
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        return t & 62914560;
                    case 67108864:
                        return 67108864;
                    case 134217728:
                        return 134217728;
                    case 268435456:
                        return 268435456;
                    case 536870912:
                        return 536870912;
                    case 1073741824:
                        return 0;
                    default:
                        return t;
                }
            }
            function Lr(t, r, a) {
                var l = t.pendingLanes;
                if (l === 0) return 0;
                var c = 0, d = t.suspendedLanes, h = t.pingedLanes;
                t = t.warmLanes;
                var y = l & 134217727;
                return y !== 0 ? (l = y & ~d, l !== 0 ? c = Zo(l) : (h &= y, h !== 0 ? c = Zo(h) : a || (a = y & ~t, a !== 0 && (c = Zo(a))))) : (y = l & ~d, y !== 0 ? c = Zo(y) : h !== 0 ? c = Zo(h) : a || (a = l & ~t, a !== 0 && (c = Zo(a)))), c === 0 ? 0 : r !== 0 && r !== c && (r & d) === 0 && (d = c & -c, a = r & -r, d >= a || d === 32 && (a & 4194048) !== 0) ? r : c;
            }
            function Pi(t, r) {
                return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & r) === 0;
            }
            function Tp(t, r) {
                switch(t){
                    case 1:
                    case 2:
                    case 4:
                    case 8:
                    case 64:
                        return r + 250;
                    case 16:
                    case 32:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                        return r + 5e3;
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        return -1;
                    case 67108864:
                    case 134217728:
                    case 268435456:
                    case 536870912:
                    case 1073741824:
                        return -1;
                    default:
                        return -1;
                }
            }
            function Ed() {
                var t = rl;
                return rl <<= 1, (rl & 62914560) === 0 && (rl = 4194304), t;
            }
            function mu(t) {
                for(var r = [], a = 0; 31 > a; a++)r.push(t);
                return r;
            }
            function xi(t, r) {
                t.pendingLanes |= r, r !== 268435456 && (t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0);
            }
            function _p(t, r, a, l, c, d) {
                var h = t.pendingLanes;
                t.pendingLanes = a, t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0, t.expiredLanes &= a, t.entangledLanes &= a, t.errorRecoveryDisabledLanes &= a, t.shellSuspendCounter = 0;
                var y = t.entanglements, R = t.expirationTimes, L = t.hiddenUpdates;
                for(a = h & ~a; 0 < a;){
                    var j = 31 - vt(a), A = 1 << j;
                    y[j] = 0, R[j] = -1;
                    var W = L[j];
                    if (W !== null) for(L[j] = null, j = 0; j < W.length; j++){
                        var V = W[j];
                        V !== null && (V.lane &= -536870913);
                    }
                    a &= ~A;
                }
                l !== 0 && Yo(t, l, 0), d !== 0 && c === 0 && t.tag !== 0 && (t.suspendedLanes |= d & ~(h & ~r));
            }
            function Yo(t, r, a) {
                t.pendingLanes |= r, t.suspendedLanes &= ~r;
                var l = 31 - vt(r);
                t.entangledLanes |= r, t.entanglements[l] = t.entanglements[l] | 1073741824 | a & 261930;
            }
            function $e(t, r) {
                var a = t.entangledLanes |= r;
                for(t = t.entanglements; a;){
                    var l = 31 - vt(a), c = 1 << l;
                    c & r | t[l] & r && (t[l] |= r), a &= ~c;
                }
            }
            function G(t, r) {
                var a = r & -r;
                return a = (a & 42) !== 0 ? 1 : st(a), (a & (t.suspendedLanes | r)) !== 0 ? 0 : a;
            }
            function st(t) {
                switch(t){
                    case 2:
                        t = 1;
                        break;
                    case 8:
                        t = 4;
                        break;
                    case 32:
                        t = 16;
                        break;
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        t = 128;
                        break;
                    case 268435456:
                        t = 134217728;
                        break;
                    default:
                        t = 0;
                }
                return t;
            }
            function Ze(t) {
                return t &= -t, 2 < t ? 8 < t ? (t & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
            }
            function pe(t) {
                if (typeof Lc == "function" && Uf(t), on && typeof on.setStrictMode == "function") try {
                    on.setStrictMode(ei, t);
                } catch  {}
            }
            function Im(t, r) {
                return t === r && (t !== 0 || 1 / t === 1 / r) || t !== t && r !== r;
            }
            function _t(t) {
                if (al === void 0) try {
                    throw Error();
                } catch (a) {
                    var r = a.stack.trim().match(/\n( *(at )?)/);
                    al = r && r[1] || "", kt = -1 < a.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < a.stack.indexOf("@") ? "@unknown:0:0" : "";
                }
                return `
` + al + t + kt;
            }
            function zi(t, r) {
                if (!t || Ds) return "";
                Ds = !0;
                var a = Error.prepareStackTrace;
                Error.prepareStackTrace = void 0;
                try {
                    var l = {
                        DetermineComponentFrameRoot: function() {
                            try {
                                if (r) {
                                    var A = function() {
                                        throw Error();
                                    };
                                    if (Object.defineProperty(A.prototype, "props", {
                                        set: function() {
                                            throw Error();
                                        }
                                    }), typeof Reflect == "object" && Reflect.construct) {
                                        try {
                                            Reflect.construct(A, []);
                                        } catch (V) {
                                            var W = V;
                                        }
                                        Reflect.construct(t, [], A);
                                    } else {
                                        try {
                                            A.call();
                                        } catch (V) {
                                            W = V;
                                        }
                                        t.call(A.prototype);
                                    }
                                } else {
                                    try {
                                        throw Error();
                                    } catch (V) {
                                        W = V;
                                    }
                                    (A = t()) && typeof A.catch == "function" && A.catch(function() {});
                                }
                            } catch (V) {
                                if (V && W && typeof V.stack == "string") return [
                                    V.stack,
                                    W.stack
                                ];
                            }
                            return [
                                null,
                                null
                            ];
                        }
                    };
                    l.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
                    var c = Object.getOwnPropertyDescriptor(l.DetermineComponentFrameRoot, "name");
                    c && c.configurable && Object.defineProperty(l.DetermineComponentFrameRoot, "name", {
                        value: "DetermineComponentFrameRoot"
                    });
                    var d = l.DetermineComponentFrameRoot(), h = d[0], y = d[1];
                    if (h && y) {
                        var R = h.split(`
`), L = y.split(`
`);
                        for(c = l = 0; l < R.length && !R[l].includes("DetermineComponentFrameRoot");)l++;
                        for(; c < L.length && !L[c].includes("DetermineComponentFrameRoot");)c++;
                        if (l === R.length || c === L.length) for(l = R.length - 1, c = L.length - 1; 1 <= l && 0 <= c && R[l] !== L[c];)c--;
                        for(; 1 <= l && 0 <= c; l--, c--)if (R[l] !== L[c]) {
                            if (l !== 1 || c !== 1) do if (l--, c--, 0 > c || R[l] !== L[c]) {
                                var j = `
` + R[l].replace(" at new ", " at ");
                                return t.displayName && j.includes("<anonymous>") && (j = j.replace("<anonymous>", t.displayName)), j;
                            }
                            while (1 <= l && 0 <= c);
                            break;
                        }
                    }
                } finally{
                    Ds = !1, Error.prepareStackTrace = a;
                }
                return (a = t ? t.displayName || t.name : "") ? _t(a) : "";
            }
            function Hl(t, r) {
                switch(t.tag){
                    case 26:
                    case 27:
                    case 5:
                        return _t(t.type);
                    case 16:
                        return _t("Lazy");
                    case 13:
                        return t.child !== r && r !== null ? _t("Suspense Fallback") : _t("Suspense");
                    case 19:
                        return _t("SuspenseList");
                    case 0:
                    case 15:
                        return zi(t.type, !1);
                    case 11:
                        return zi(t.type.render, !1);
                    case 1:
                        return zi(t.type, !0);
                    case 31:
                        return _t("Activity");
                    default:
                        return "";
                }
            }
            function Rp(t) {
                try {
                    var r = "", a = null;
                    do r += Hl(t, a), a = t, t = t.return;
                    while (t);
                    return r;
                } catch (l) {
                    return `
Error generating stack: ` + l.message + `
` + l.stack;
                }
            }
            function ut(t, r) {
                if (typeof t == "object" && t !== null) {
                    var a = Bh.get(t);
                    return a !== void 0 ? a : (r = {
                        value: t,
                        source: r,
                        stack: Rp(r)
                    }, Bh.set(t, r), r);
                }
                return {
                    value: t,
                    source: r,
                    stack: Rp(r)
                };
            }
            function or(t, r) {
                ni[il++] = x, ni[il++] = fn, fn = t, x = r;
            }
            function Ci(t, r, a) {
                Jt[Zt++] = ot, Jt[Zt++] = Zr, Jt[Zt++] = jo, jo = t;
                var l = ot;
                t = Zr;
                var c = 32 - vt(l) - 1;
                l &= ~(1 << c), a += 1;
                var d = 32 - vt(r) + c;
                if (30 < d) {
                    var h = c - c % 5;
                    d = (l & (1 << h) - 1).toString(32), l >>= h, c -= h, ot = 1 << 32 - vt(r) + c | a << c | l, Zr = d + t;
                } else ot = 1 << d | a << c | l, Zr = t;
            }
            function Id(t) {
                t.return !== null && (or(t, 1), Ci(t, 1, 0));
            }
            function gu(t) {
                for(; t === fn;)fn = ni[--il], ni[il] = null, x = ni[--il], ni[il] = null;
                for(; t === jo;)jo = Jt[--Zt], Jt[Zt] = null, Zr = Jt[--Zt], Jt[Zt] = null, ot = Jt[--Zt], Jt[Zt] = null;
            }
            function Ld(t, r) {
                Jt[Zt++] = ot, Jt[Zt++] = Zr, Jt[Zt++] = jo, ot = r.id, Zr = r.overflow, jo = t;
            }
            function Al(t, r) {
                Ce(pa, r), Ce(Ws, t), Ce(Dn, null), t = Hm(r), D(Dn), Ce(Dn, t);
            }
            function Xo() {
                D(Dn), D(Ws), D(pa);
            }
            function yu(t) {
                t.memoizedState !== null && Ce(Fc, t);
                var r = Dn.current, a = Xp(r, t.type);
                r !== a && (Ce(Ws, t), Ce(Dn, a));
            }
            function jl(t) {
                Ws.current === t && (D(Dn), D(Ws)), Fc.current === t && (D(Fc), qt ? da._currentValue = rt : da._currentValue2 = rt);
            }
            function ar(t) {
                var r = Error(F(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", ""));
                throw ct(ut(r, t)), Of;
            }
            function Ep(t, r) {
                if (!Hn) throw Error(F(175));
                Ki(t.stateNode, t.type, t.memoizedProps, r, t) || ar(t, !0);
            }
            function De(t) {
                for(bn = t.return; bn;)switch(bn.tag){
                    case 5:
                    case 31:
                    case 13:
                        Yt = !1;
                        return;
                    case 27:
                    case 3:
                        Yt = !0;
                        return;
                    default:
                        bn = bn.return;
                }
            }
            function Ti(t) {
                if (!Hn || t !== bn) return !1;
                if (!ue) return De(t), ue = !0, !1;
                var r = t.tag;
                if (dn ? r !== 3 && r !== 27 && (r !== 5 || Nh(t.type) && !Rs(t.type, t.memoizedProps)) && Ue && ar(t) : r !== 3 && (r !== 5 || Nh(t.type) && !Rs(t.type, t.memoizedProps)) && Ue && ar(t), De(t), r === 13) {
                    if (!Hn) throw Error(F(316));
                    if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(F(317));
                    Ue = Th(t);
                } else if (r === 31) {
                    if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(F(317));
                    Ue = Ch(t);
                } else Ue = dn && r === 27 ? kh(t.type, Ue) : bn ? Nf(t.stateNode) : null;
                return !0;
            }
            function _a() {
                Hn && (Ue = bn = null, ue = !1);
            }
            function Dl() {
                var t = Do;
                return t !== null && (xt === null ? xt = t : xt.push.apply(xt, t), Do = null), t;
            }
            function ct(t) {
                Do === null ? Do = [
                    t
                ] : Do.push(t);
            }
            function fo(t, r, a) {
                qt ? (Ce(Yr, r._currentValue), r._currentValue = a) : (Ce(Yr, r._currentValue2), r._currentValue2 = a);
            }
            function En(t) {
                var r = Yr.current;
                qt ? t._currentValue = r : t._currentValue2 = r, D(Yr);
            }
            function Ot(t, r, a) {
                for(; t !== null;){
                    var l = t.alternate;
                    if ((t.childLanes & r) !== r ? (t.childLanes |= r, l !== null && (l.childLanes |= r)) : l !== null && (l.childLanes & r) !== r && (l.childLanes |= r), t === a) break;
                    t = t.return;
                }
            }
            function _i(t, r, a, l) {
                var c = t.child;
                for(c !== null && (c.return = t); c !== null;){
                    var d = c.dependencies;
                    if (d !== null) {
                        var h = c.child;
                        d = d.firstContext;
                        e: for(; d !== null;){
                            var y = d;
                            d = c;
                            for(var R = 0; R < r.length; R++)if (y.context === r[R]) {
                                d.lanes |= a, y = d.alternate, y !== null && (y.lanes |= a), Ot(d.return, a, t), l || (h = null);
                                break e;
                            }
                            d = y.next;
                        }
                    } else if (c.tag === 18) {
                        if (h = c.return, h === null) throw Error(F(341));
                        h.lanes |= a, d = h.alternate, d !== null && (d.lanes |= a), Ot(h, a, t), h = null;
                    } else h = c.child;
                    if (h !== null) h.return = c;
                    else for(h = c; h !== null;){
                        if (h === t) {
                            h = null;
                            break;
                        }
                        if (c = h.sibling, c !== null) {
                            c.return = h.return, h = c;
                            break;
                        }
                        h = h.return;
                    }
                    c = h;
                }
            }
            function po(t, r, a, l) {
                t = null;
                for(var c = r, d = !1; c !== null;){
                    if (!d) {
                        if ((c.flags & 524288) !== 0) d = !0;
                        else if ((c.flags & 262144) !== 0) break;
                    }
                    if (c.tag === 10) {
                        var h = c.alternate;
                        if (h === null) throw Error(F(387));
                        if (h = h.memoizedProps, h !== null) {
                            var y = c.type;
                            jn(c.pendingProps.value, h.value) || (t !== null ? t.push(y) : t = [
                                y
                            ]);
                        }
                    } else if (c === Fc.current) {
                        if (h = c.alternate, h === null) throw Error(F(387));
                        h.memoizedState.memoizedState !== c.memoizedState.memoizedState && (t !== null ? t.push(da) : t = [
                            da
                        ]);
                    }
                    c = c.return;
                }
                t !== null && _i(r, t, a, l), r.flags |= 262144;
            }
            function Ri(t) {
                for(t = t.firstContext; t !== null;){
                    var r = t.context;
                    if (!jn(qt ? r._currentValue : r._currentValue2, t.memoizedValue)) return !0;
                    t = t.next;
                }
                return !1;
            }
            function Un(t) {
                at = t, Be = null, t = t.dependencies, t !== null && (t.firstContext = null);
            }
            function In(t) {
                return Nd(at, t);
            }
            function Wl(t, r) {
                return at === null && Un(t), Nd(t, r);
            }
            function Nd(t, r) {
                var a = qt ? r._currentValue : r._currentValue2;
                if (r = {
                    context: r,
                    memoizedValue: a,
                    next: null
                }, Be === null) {
                    if (t === null) throw Error(F(308));
                    Be = r, t.dependencies = {
                        lanes: 0,
                        firstContext: r
                    }, t.flags |= 524288;
                } else Be = Be.next = r;
                return a;
            }
            function Fd() {
                return {
                    controller: new Xr(),
                    data: new Map(),
                    refCount: 0
                };
            }
            function Ra(t) {
                t.refCount--, t.refCount === 0 && qn(Gm, function() {
                    t.controller.abort();
                });
            }
            function bu() {}
            function ir(t) {
                t !== wt && t.next === null && (wt === null ? an = wt = t : wt = wt.next = t), ll = !0, Mf || (Mf = !0, Lm());
            }
            function Ea(t, r) {
                if (!ti && ll) {
                    ti = !0;
                    do for(var a = !1, l = an; l !== null;){
                        if (!r) {
                            if (t !== 0) {
                                var c = l.pendingLanes;
                                if (c === 0) var d = 0;
                                else {
                                    var h = l.suspendedLanes, y = l.pingedLanes;
                                    d = (1 << 31 - vt(42 | t) + 1) - 1, d &= c & ~(h & ~y), d = d & 201326741 ? d & 201326741 | 1 : d ? d | 2 : 0;
                                }
                                d !== 0 && (a = !0, Su(l, d));
                            } else d = he, d = Lr(l, l === Ne ? d : 0, l.cancelPendingCommit !== null || l.timeoutHandle !== Lo), (d & 3) === 0 || Pi(l, d) || (a = !0, Su(l, d));
                        }
                        l = l.next;
                    }
                    while (a);
                    ti = !1;
                }
            }
            function Ip() {
                Lp();
            }
            function Lp() {
                ll = Mf = !1;
                var t = 0;
                Pr !== 0 && _f() && (t = Pr);
                for(var r = ze(), a = null, l = an; l !== null;){
                    var c = l.next, d = vu(l, r);
                    d === 0 ? (l.next = null, a === null ? an = c : a.next = c, c === null && (wt = a)) : (a = l, (t !== 0 || (d & 3) !== 0) && (ll = !0)), l = c;
                }
                Re !== 0 && Re !== 5 || Ea(t, !1), Pr !== 0 && (Pr = 0);
            }
            function vu(t, r) {
                for(var a = t.suspendedLanes, l = t.pingedLanes, c = t.expirationTimes, d = t.pendingLanes & -62914561; 0 < d;){
                    var h = 31 - vt(d), y = 1 << h, R = c[h];
                    R === -1 ? ((y & a) === 0 || (y & l) !== 0) && (c[h] = Tp(y, r)) : R <= r && (t.expiredLanes |= y), d &= ~y;
                }
                if (r = Ne, a = he, a = Lr(t, t === r ? a : 0, t.cancelPendingCommit !== null || t.timeoutHandle !== Lo), l = t.callbackNode, a === 0 || t === r && (_e === 2 || _e === 9) || t.cancelPendingCommit !== null) return l !== null && l !== null && le(l), t.callbackNode = null, t.callbackPriority = 0;
                if ((a & 3) === 0 || Pi(t, a)) {
                    if (r = a & -a, r === t.callbackPriority) return r;
                    switch(l !== null && le(l), Ze(a)){
                        case 2:
                        case 8:
                            a = Ho;
                            break;
                        case 32:
                            a = Ao;
                            break;
                        case 268435456:
                            a = ol;
                            break;
                        default:
                            a = Ao;
                    }
                    return l = dt.bind(null, t), a = Ic(a, l), t.callbackPriority = r, t.callbackNode = a, r;
                }
                return l !== null && l !== null && le(l), t.callbackPriority = 2, t.callbackNode = null, 2;
            }
            function dt(t, r) {
                if (Re !== 0 && Re !== 5) return t.callbackNode = null, t.callbackPriority = 0, null;
                var a = t.callbackNode;
                if (rn() && t.callbackNode !== a) return null;
                var l = he;
                return l = Lr(t, t === Ne ? l : 0, t.cancelPendingCommit !== null || t.timeoutHandle !== Lo), l === 0 ? null : (uf(t, l, r), vu(t, ze()), t.callbackNode != null && t.callbackNode === a ? dt.bind(null, t) : null);
            }
            function Su(t, r) {
                if (rn()) return null;
                uf(t, r, !0);
            }
            function Lm() {
                ih ? Gr(function() {
                    (ce & 6) !== 0 ? Ic(Uh, Ip) : Lp();
                }) : Ic(Uh, Ip);
            }
            function ku() {
                if (Pr === 0) {
                    var t = sl;
                    t === 0 && (t = As, As <<= 1, (As & 261888) === 0 && (As = 256)), Pr = t;
                }
                return Pr;
            }
            function Np(t, r) {
                if (Us === null) {
                    var a = Us = [];
                    Qf = 0, sl = ku(), ul = {
                        status: "pending",
                        value: void 0,
                        then: function(l) {
                            a.push(l);
                        }
                    };
                }
                return Qf++, r.then(ft, ft), r;
            }
            function ft() {
                if (--Qf === 0 && Us !== null) {
                    ul !== null && (ul.status = "fulfilled");
                    var t = Us;
                    Us = null, sl = 0, ul = null;
                    for(var r = 0; r < t.length; r++)(0, t[r])();
                }
            }
            function ho(t, r) {
                var a = [], l = {
                    status: "pending",
                    value: null,
                    reason: null,
                    then: function(c) {
                        a.push(c);
                    }
                };
                return t.then(function() {
                    l.status = "fulfilled", l.value = r;
                    for(var c = 0; c < a.length; c++)(0, a[c])(r);
                }, function(c) {
                    for(l.status = "rejected", l.reason = c, c = 0; c < a.length; c++)(0, a[c])(void 0);
                }), l;
            }
            function wu() {
                var t = ha.current;
                return t !== null ? t : Ne.pooledCache;
            }
            function Ei(t, r) {
                r === null ? Ce(ha, ha.current) : Ce(ha, r.pool);
            }
            function Pu() {
                var t = wu();
                return t === null ? null : {
                    parent: qt ? qe._currentValue : qe._currentValue2,
                    pool: t
                };
            }
            function Ul(t, r) {
                if (jn(t, r)) return !0;
                if (typeof t != "object" || t === null || typeof r != "object" || r === null) return !1;
                var a = Object.keys(t), l = Object.keys(r);
                if (a.length !== l.length) return !1;
                for(l = 0; l < a.length; l++){
                    var c = a[l];
                    if (!Bf.call(r, c) || !jn(t[c], r[c])) return !1;
                }
                return !0;
            }
            function Hd(t) {
                return t = t.status, t === "fulfilled" || t === "rejected";
            }
            function mo(t, r, a) {
                switch(a = t[a], a === void 0 ? t.push(r) : a !== r && (r.then(bu, bu), r = a), r.status){
                    case "fulfilled":
                        return r.value;
                    case "rejected":
                        throw t = r.reason, Ia(t), t;
                    default:
                        if (typeof r.status == "string") r.then(bu, bu);
                        else {
                            if (t = Ne, t !== null && 100 < t.shellSuspendCounter) throw Error(F(482));
                            t = r, t.status = "pending", t.then(function(l) {
                                if (r.status === "pending") {
                                    var c = r;
                                    c.status = "fulfilled", c.value = l;
                                }
                            }, function(l) {
                                if (r.status === "pending") {
                                    var c = r;
                                    c.status = "rejected", c.reason = l;
                                }
                            });
                        }
                        switch(r.status){
                            case "fulfilled":
                                return r.value;
                            case "rejected":
                                throw t = r.reason, Ia(t), t;
                        }
                        throw Xt = r, cl;
                }
            }
            function pt(t) {
                try {
                    var r = t._init;
                    return r(t._payload);
                } catch (a) {
                    throw a !== null && typeof a == "object" && typeof a.then == "function" ? (Xt = a, cl) : a;
                }
            }
            function Bl() {
                if (Xt === null) throw Error(F(459));
                var t = Xt;
                return Xt = null, t;
            }
            function Ia(t) {
                if (t === cl || t === jc) throw Error(F(483));
            }
            function Rt(t) {
                var r = Bs;
                return Bs += 1, Kt === null && (Kt = []), mo(Kt, t, r);
            }
            function La(t, r) {
                r = r.props.ref, t.ref = r !== void 0 ? r : null;
            }
            function Na(t, r) {
                throw r.$$typeof === hc ? Error(F(525)) : (t = Object.prototype.toString.call(r), Error(F(31, t === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : t)));
            }
            function Ad(t) {
                function r(P, w) {
                    if (t) {
                        var C = P.deletions;
                        C === null ? (P.deletions = [
                            w
                        ], P.flags |= 16) : C.push(w);
                    }
                }
                function a(P, w) {
                    if (!t) return null;
                    for(; w !== null;)r(P, w), w = w.sibling;
                    return null;
                }
                function l(P) {
                    for(var w = new Map(); P !== null;)P.key !== null ? w.set(P.key, P) : w.set(P.index, P), P = P.sibling;
                    return w;
                }
                function c(P, w) {
                    return P = Qr(P, w), P.index = 0, P.sibling = null, P;
                }
                function d(P, w, C) {
                    return P.index = C, t ? (C = P.alternate, C !== null ? (C = C.index, C < w ? (P.flags |= 67108866, w) : C) : (P.flags |= 67108866, w)) : (P.flags |= 1048576, w);
                }
                function h(P) {
                    return t && P.alternate === null && (P.flags |= 67108866), P;
                }
                function y(P, w, C, H) {
                    return w === null || w.tag !== 6 ? (w = Ps(C, P.mode, H), w.return = P, w) : (w = c(w, C), w.return = P, w);
                }
                function R(P, w, C, H) {
                    var Q = C.type;
                    return Q === $a ? j(P, w, C.props.children, H, C.key) : w !== null && (w.elementType === Q || typeof Q == "object" && Q !== null && Q.$$typeof === ua && pt(Q) === w.type) ? (w = c(w, C.props), La(w, C), w.return = P, w) : (w = ws(C.type, C.key, C.props, null, P.mode, H), La(w, C), w.return = P, w);
                }
                function L(P, w, C, H) {
                    return w === null || w.tag !== 4 || w.stateNode.containerInfo !== C.containerInfo || w.stateNode.implementation !== C.implementation ? (w = dc(C, P.mode, H), w.return = P, w) : (w = c(w, C.children || []), w.return = P, w);
                }
                function j(P, w, C, H, Q) {
                    return w === null || w.tag !== 7 ? (w = Eo(C, P.mode, H, Q), w.return = P, w) : (w = c(w, C), w.return = P, w);
                }
                function A(P, w, C) {
                    if (typeof w == "string" && w !== "" || typeof w == "number" || typeof w == "bigint") return w = Ps("" + w, P.mode, C), w.return = P, w;
                    if (typeof w == "object" && w !== null) {
                        switch(w.$$typeof){
                            case zs:
                                return C = ws(w.type, w.key, w.props, null, P.mode, C), La(C, w), C.return = P, C;
                            case sa:
                                return w = dc(w, P.mode, C), w.return = P, w;
                            case ua:
                                return w = pt(w), A(P, w, C);
                        }
                        if (ca(w) || Fl(w)) return w = Eo(w, P.mode, C, null), w.return = P, w;
                        if (typeof w.then == "function") return A(P, Rt(w), C);
                        if (w.$$typeof === Io) return A(P, Wl(P, w), C);
                        Na(P, w);
                    }
                    return null;
                }
                function W(P, w, C, H) {
                    var Q = w !== null ? w.key : null;
                    if (typeof C == "string" && C !== "" || typeof C == "number" || typeof C == "bigint") return Q !== null ? null : y(P, w, "" + C, H);
                    if (typeof C == "object" && C !== null) {
                        switch(C.$$typeof){
                            case zs:
                                return C.key === Q ? R(P, w, C, H) : null;
                            case sa:
                                return C.key === Q ? L(P, w, C, H) : null;
                            case ua:
                                return C = pt(C), W(P, w, C, H);
                        }
                        if (ca(C) || Fl(C)) return Q !== null ? null : j(P, w, C, H, null);
                        if (typeof C.then == "function") return W(P, w, Rt(C), H);
                        if (C.$$typeof === Io) return W(P, w, Wl(P, C), H);
                        Na(P, C);
                    }
                    return null;
                }
                function V(P, w, C, H, Q) {
                    if (typeof H == "string" && H !== "" || typeof H == "number" || typeof H == "bigint") return P = P.get(C) || null, y(w, P, "" + H, Q);
                    if (typeof H == "object" && H !== null) {
                        switch(H.$$typeof){
                            case zs:
                                return P = P.get(H.key === null ? C : H.key) || null, R(w, P, H, Q);
                            case sa:
                                return P = P.get(H.key === null ? C : H.key) || null, L(w, P, H, Q);
                            case ua:
                                return H = pt(H), V(P, w, C, H, Q);
                        }
                        if (ca(H) || Fl(H)) return P = P.get(C) || null, j(w, P, H, Q, null);
                        if (typeof H.then == "function") return V(P, w, C, Rt(H), Q);
                        if (H.$$typeof === Io) return V(P, w, C, Wl(w, H), Q);
                        Na(w, H);
                    }
                    return null;
                }
                function Oe(P, w, C, H) {
                    for(var Q = null, Ge = null, J = w, Pe = w = 0, me = null; J !== null && Pe < C.length; Pe++){
                        J.index > Pe ? (me = J, J = null) : me = J.sibling;
                        var be = W(P, J, C[Pe], H);
                        if (be === null) {
                            J === null && (J = me);
                            break;
                        }
                        t && J && be.alternate === null && r(P, J), w = d(be, w, Pe), Ge === null ? Q = be : Ge.sibling = be, Ge = be, J = me;
                    }
                    if (Pe === C.length) return a(P, J), ue && or(P, Pe), Q;
                    if (J === null) {
                        for(; Pe < C.length; Pe++)J = A(P, C[Pe], H), J !== null && (w = d(J, w, Pe), Ge === null ? Q = J : Ge.sibling = J, Ge = J);
                        return ue && or(P, Pe), Q;
                    }
                    for(J = l(J); Pe < C.length; Pe++)me = V(J, P, Pe, C[Pe], H), me !== null && (t && me.alternate !== null && J.delete(me.key === null ? Pe : me.key), w = d(me, w, Pe), Ge === null ? Q = me : Ge.sibling = me, Ge = me);
                    return t && J.forEach(function(Oo) {
                        return r(P, Oo);
                    }), ue && or(P, Pe), Q;
                }
                function vn(P, w, C, H) {
                    if (C == null) throw Error(F(151));
                    for(var Q = null, Ge = null, J = w, Pe = w = 0, me = null, be = C.next(); J !== null && !be.done; Pe++, be = C.next()){
                        J.index > Pe ? (me = J, J = null) : me = J.sibling;
                        var Oo = W(P, J, be.value, H);
                        if (Oo === null) {
                            J === null && (J = me);
                            break;
                        }
                        t && J && Oo.alternate === null && r(P, J), w = d(Oo, w, Pe), Ge === null ? Q = Oo : Ge.sibling = Oo, Ge = Oo, J = me;
                    }
                    if (be.done) return a(P, J), ue && or(P, Pe), Q;
                    if (J === null) {
                        for(; !be.done; Pe++, be = C.next())be = A(P, be.value, H), be !== null && (w = d(be, w, Pe), Ge === null ? Q = be : Ge.sibling = be, Ge = be);
                        return ue && or(P, Pe), Q;
                    }
                    for(J = l(J); !be.done; Pe++, be = C.next())be = V(J, P, Pe, be.value, H), be !== null && (t && be.alternate !== null && J.delete(be.key === null ? Pe : be.key), w = d(be, w, Pe), Ge === null ? Q = be : Ge.sibling = be, Ge = be);
                    return t && J.forEach(function(qs) {
                        return r(P, qs);
                    }), ue && or(P, Pe), Q;
                }
                function li(P, w, C, H) {
                    if (typeof C == "object" && C !== null && C.type === $a && C.key === null && (C = C.props.children), typeof C == "object" && C !== null) {
                        switch(C.$$typeof){
                            case zs:
                                e: {
                                    for(var Q = C.key; w !== null;){
                                        if (w.key === Q) {
                                            if (Q = C.type, Q === $a) {
                                                if (w.tag === 7) {
                                                    a(P, w.sibling), H = c(w, C.props.children), H.return = P, P = H;
                                                    break e;
                                                }
                                            } else if (w.elementType === Q || typeof Q == "object" && Q !== null && Q.$$typeof === ua && pt(Q) === w.type) {
                                                a(P, w.sibling), H = c(w, C.props), La(H, C), H.return = P, P = H;
                                                break e;
                                            }
                                            a(P, w);
                                            break;
                                        } else r(P, w);
                                        w = w.sibling;
                                    }
                                    C.type === $a ? (H = Eo(C.props.children, P.mode, H, C.key), H.return = P, P = H) : (H = ws(C.type, C.key, C.props, null, P.mode, H), La(H, C), H.return = P, P = H);
                                }
                                return h(P);
                            case sa:
                                e: {
                                    for(Q = C.key; w !== null;){
                                        if (w.key === Q) {
                                            if (w.tag === 4 && w.stateNode.containerInfo === C.containerInfo && w.stateNode.implementation === C.implementation) {
                                                a(P, w.sibling), H = c(w, C.children || []), H.return = P, P = H;
                                                break e;
                                            } else {
                                                a(P, w);
                                                break;
                                            }
                                        } else r(P, w);
                                        w = w.sibling;
                                    }
                                    H = dc(C, P.mode, H), H.return = P, P = H;
                                }
                                return h(P);
                            case ua:
                                return C = pt(C), li(P, w, C, H);
                        }
                        if (ca(C)) return Oe(P, w, C, H);
                        if (Fl(C)) {
                            if (Q = Fl(C), typeof Q != "function") throw Error(F(150));
                            return C = Q.call(C), vn(P, w, C, H);
                        }
                        if (typeof C.then == "function") return li(P, w, Rt(C), H);
                        if (C.$$typeof === Io) return li(P, w, Wl(P, C), H);
                        Na(P, C);
                    }
                    return typeof C == "string" && C !== "" || typeof C == "number" || typeof C == "bigint" ? (C = "" + C, w !== null && w.tag === 6 ? (a(P, w.sibling), H = c(w, C), H.return = P, P = H) : (a(P, w), H = Ps(C, P.mode, H), H.return = P, P = H), h(P)) : a(P, w);
                }
                return function(P, w, C, H) {
                    try {
                        Bs = 0;
                        var Q = li(P, w, C, H);
                        return Kt = null, Q;
                    } catch (J) {
                        if (J === cl || J === jc) throw J;
                        var Ge = Yn(29, J, null, P.mode);
                        return Ge.lanes = H, Ge.return = P, Ge;
                    } finally{}
                };
            }
            function Bn() {
                for(var t = xr, r = $f = xr = 0; r < t;){
                    var a = er[r];
                    er[r++] = null;
                    var l = er[r];
                    er[r++] = null;
                    var c = er[r];
                    er[r++] = null;
                    var d = er[r];
                    if (er[r++] = null, l !== null && c !== null) {
                        var h = l.pending;
                        h === null ? c.next = c : (c.next = h.next, h.next = c), l.pending = c;
                    }
                    d !== 0 && Ii(a, c, d);
                }
            }
            function go(t, r, a, l) {
                er[xr++] = t, er[xr++] = r, er[xr++] = a, er[xr++] = l, $f |= l, t.lanes |= l, t = t.alternate, t !== null && (t.lanes |= l);
            }
            function yo(t, r, a, l) {
                return go(t, r, a, l), Fa(t);
            }
            function Ko(t, r) {
                return go(t, null, null, r), Fa(t);
            }
            function Ii(t, r, a) {
                t.lanes |= a;
                var l = t.alternate;
                l !== null && (l.lanes |= a);
                for(var c = !1, d = t.return; d !== null;)d.childLanes |= a, l = d.alternate, l !== null && (l.childLanes |= a), d.tag === 22 && (t = d.stateNode, t === null || t._visibility & 1 || (c = !0)), t = d, d = d.return;
                return t.tag === 3 ? (d = t.stateNode, c && r !== null && (c = 31 - vt(a), t = d.hiddenUpdates, l = t[c], l === null ? t[c] = [
                    r
                ] : l.push(r), r.lane = a | 536870912), d) : null;
            }
            function Fa(t) {
                if (50 < gl) throw gl = 0, nd = null, Error(F(185));
                for(var r = t.return; r !== null;)t = r, r = t.return;
                return t.tag === 3 ? t.stateNode : null;
            }
            function Ol(t) {
                t.updateQueue = {
                    baseState: t.memoizedState,
                    firstBaseUpdate: null,
                    lastBaseUpdate: null,
                    shared: {
                        pending: null,
                        lanes: 0,
                        hiddenCallbacks: null
                    },
                    callbacks: null
                };
            }
            function Ha(t, r) {
                t = t.updateQueue, r.updateQueue === t && (r.updateQueue = {
                    baseState: t.baseState,
                    firstBaseUpdate: t.firstBaseUpdate,
                    lastBaseUpdate: t.lastBaseUpdate,
                    shared: t.shared,
                    callbacks: null
                });
            }
            function Et(t) {
                return {
                    lane: t,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                };
            }
            function Nr(t, r, a) {
                var l = t.updateQueue;
                if (l === null) return null;
                if (l = l.shared, (ce & 2) !== 0) {
                    var c = l.pending;
                    return c === null ? r.next = r : (r.next = c.next, c.next = r), l.pending = r, r = Fa(t), Ii(t, null, a), r;
                }
                return go(t, l, r, a), Fa(t);
            }
            function Ml(t, r, a) {
                if (r = r.updateQueue, r !== null && (r = r.shared, (a & 4194048) !== 0)) {
                    var l = r.lanes;
                    l &= t.pendingLanes, a |= l, r.lanes = a, $e(t, a);
                }
            }
            function jd(t, r) {
                var a = t.updateQueue, l = t.alternate;
                if (l !== null && (l = l.updateQueue, a === l)) {
                    var c = null, d = null;
                    if (a = a.firstBaseUpdate, a !== null) {
                        do {
                            var h = {
                                lane: a.lane,
                                tag: a.tag,
                                payload: a.payload,
                                callback: null,
                                next: null
                            };
                            d === null ? c = d = h : d = d.next = h, a = a.next;
                        }while (a !== null);
                        d === null ? c = d = r : d = d.next = r;
                    } else c = d = r;
                    a = {
                        baseState: l.baseState,
                        firstBaseUpdate: c,
                        lastBaseUpdate: d,
                        shared: l.shared,
                        callbacks: l.callbacks
                    }, t.updateQueue = a;
                    return;
                }
                t = a.lastBaseUpdate, t === null ? a.firstBaseUpdate = r : t.next = r, a.lastBaseUpdate = r;
            }
            function Li() {
                if (Vf) {
                    var t = ul;
                    if (t !== null) throw t;
                }
            }
            function Aa(t, r, a, l) {
                Vf = !1;
                var c = t.updateQueue;
                ma = !1;
                var d = c.firstBaseUpdate, h = c.lastBaseUpdate, y = c.shared.pending;
                if (y !== null) {
                    c.shared.pending = null;
                    var R = y, L = R.next;
                    R.next = null, h === null ? d = L : h.next = L, h = R;
                    var j = t.alternate;
                    j !== null && (j = j.updateQueue, y = j.lastBaseUpdate, y !== h && (y === null ? j.firstBaseUpdate = L : y.next = L, j.lastBaseUpdate = R));
                }
                if (d !== null) {
                    var A = c.baseState;
                    h = 0, j = L = R = null, y = d;
                    do {
                        var W = y.lane & -536870913, V = W !== y.lane;
                        if (V ? (he & W) === W : (l & W) === W) {
                            W !== 0 && W === sl && (Vf = !0), j !== null && (j = j.next = {
                                lane: 0,
                                tag: y.tag,
                                payload: y.payload,
                                callback: null,
                                next: null
                            });
                            e: {
                                var Oe = t, vn = y;
                                W = r;
                                var li = a;
                                switch(vn.tag){
                                    case 1:
                                        if (Oe = vn.payload, typeof Oe == "function") {
                                            A = Oe.call(li, A, W);
                                            break e;
                                        }
                                        A = Oe;
                                        break e;
                                    case 3:
                                        Oe.flags = Oe.flags & -65537 | 128;
                                    case 0:
                                        if (Oe = vn.payload, W = typeof Oe == "function" ? Oe.call(li, A, W) : Oe, W == null) break e;
                                        A = Lt({}, A, W);
                                        break e;
                                    case 2:
                                        ma = !0;
                                }
                            }
                            W = y.callback, W !== null && (t.flags |= 64, V && (t.flags |= 8192), V = c.callbacks, V === null ? c.callbacks = [
                                W
                            ] : V.push(W));
                        } else V = {
                            lane: W,
                            tag: y.tag,
                            payload: y.payload,
                            callback: y.callback,
                            next: null
                        }, j === null ? (L = j = V, R = A) : j = j.next = V, h |= W;
                        if (y = y.next, y === null) {
                            if (y = c.shared.pending, y === null) break;
                            V = y, y = V.next, V.next = null, c.lastBaseUpdate = V, c.shared.pending = null;
                        }
                    }while (!0);
                    j === null && (R = A), c.baseState = R, c.firstBaseUpdate = L, c.lastBaseUpdate = j, d === null && (c.shared.lanes = 0), ba |= h, t.lanes = h, t.memoizedState = A;
                }
            }
            function Dd(t, r) {
                if (typeof t != "function") throw Error(F(191, t));
                t.call(r);
            }
            function Fp(t, r) {
                var a = t.callbacks;
                if (a !== null) for(t.callbacks = null, t = 0; t < a.length; t++)Dd(a[t], r);
            }
            function B(t, r) {
                t = Uo, Ce(Wc, t), Ce(Kr, r), Uo = t | r.baseLanes;
            }
            function Ql() {
                Ce(Wc, Uo), Ce(Kr, Kr.current);
            }
            function bo() {
                Uo = Wc.current, D(Kr), D(Wc);
            }
            function vo(t) {
                var r = t.alternate;
                Ce(ln, ln.current & 1), Ce(Ft, t), zr === null && (r === null || Kr.current !== null || r.memoizedState !== null) && (zr = t);
            }
            function Ni(t) {
                Ce(ln, ln.current), Ce(Ft, t), zr === null && (zr = t);
            }
            function Fr(t) {
                t.tag === 22 ? (Ce(ln, ln.current), Ce(Ft, t), zr === null && (zr = t)) : So();
            }
            function So() {
                Ce(ln, ln.current), Ce(Ft, Ft.current);
            }
            function ht(t) {
                D(Ft), zr === t && (zr = null), D(ln);
            }
            function ko(t) {
                for(var r = t; r !== null;){
                    if (r.tag === 13) {
                        var a = r.memoizedState;
                        if (a !== null && (a = a.dehydrated, a === null || Ns(a) || Fs(a))) return r;
                    } else if (r.tag === 19 && (r.memoizedProps.revealOrder === "forwards" || r.memoizedProps.revealOrder === "backwards" || r.memoizedProps.revealOrder === "unstable_legacy-backwards" || r.memoizedProps.revealOrder === "together")) {
                        if ((r.flags & 128) !== 0) return r;
                    } else if (r.child !== null) {
                        r.child.return = r, r = r.child;
                        continue;
                    }
                    if (r === t) break;
                    for(; r.sibling === null;){
                        if (r.return === null || r.return === t) return null;
                        r = r.return;
                    }
                    r.sibling.return = r.return, r = r.sibling;
                }
                return null;
            }
            function Ve() {
                throw Error(F(321));
            }
            function wo(t, r) {
                if (r === null) return !1;
                for(var a = 0; a < r.length && a < t.length; a++)if (!jn(t[a], r[a])) return !1;
                return !0;
            }
            function $l(t, r, a, l, c, d) {
                return Wo = d, ne = r, r.memoizedState = null, r.updateQueue = null, r.lanes = 0, M.H = t === null || t.memoizedState === null ? Mh : qf, oi = !1, d = a(l, c), oi = !1, dl && (d = xu(r, a, l, c)), Fi(t), d;
            }
            function Fi(t) {
                M.H = Os;
                var r = Ie !== null && Ie.next !== null;
                if (Wo = 0, pn = Ie = ne = null, Uc = !1, fl = 0, pl = null, r) throw Error(F(300));
                t === null || hn || (t = t.dependencies, t !== null && Ri(t) && (hn = !0));
            }
            function xu(t, r, a, l) {
                ne = t;
                var c = 0;
                do {
                    if (dl && (pl = null), fl = 0, dl = !1, 25 <= c) throw Error(F(301));
                    if (c += 1, pn = Ie = null, t.updateQueue != null) {
                        var d = t.updateQueue;
                        d.lastEffect = null, d.events = null, d.stores = null, d.memoCache != null && (d.memoCache.index = 0);
                    }
                    M.H = Qh, d = r(a, l);
                }while (dl);
                return d;
            }
            function zu() {
                var t = M.H, r = t.useState()[0];
                return r = typeof r.then == "function" ? sr(r) : r, t = t.useState()[0], (Ie !== null ? Ie.memoizedState : null) !== t && (ne.flags |= 1024), r;
            }
            function Hr() {
                var t = Bc !== 0;
                return Bc = 0, t;
            }
            function lr(t, r, a) {
                r.updateQueue = t.updateQueue, r.flags &= -2053, t.lanes &= ~a;
            }
            function Vl(t) {
                if (Uc) {
                    for(t = t.memoizedState; t !== null;){
                        var r = t.queue;
                        r !== null && (r.pending = null), t = t.next;
                    }
                    Uc = !1;
                }
                Wo = 0, pn = Ie = ne = null, dl = !1, fl = Bc = 0, pl = null;
            }
            function Ln() {
                var t = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return pn === null ? ne.memoizedState = pn = t : pn = pn.next = t, pn;
            }
            function He() {
                if (Ie === null) {
                    var t = ne.alternate;
                    t = t !== null ? t.memoizedState : null;
                } else t = Ie.next;
                var r = pn === null ? ne.memoizedState : pn.next;
                if (r !== null) pn = r, Ie = t;
                else {
                    if (t === null) throw ne.alternate === null ? Error(F(467)) : Error(F(310));
                    Ie = t, t = {
                        memoizedState: Ie.memoizedState,
                        baseState: Ie.baseState,
                        baseQueue: Ie.baseQueue,
                        queue: Ie.queue,
                        next: null
                    }, pn === null ? ne.memoizedState = pn = t : pn = pn.next = t;
                }
                return pn;
            }
            function ja() {
                return {
                    lastEffect: null,
                    events: null,
                    stores: null,
                    memoCache: null
                };
            }
            function sr(t) {
                var r = fl;
                return fl += 1, pl === null && (pl = []), t = mo(pl, t, r), r = ne, (pn === null ? r.memoizedState : pn.next) === null && (r = r.alternate, M.H = r === null || r.memoizedState === null ? Mh : qf), t;
            }
            function Ee(t) {
                if (t !== null && typeof t == "object") {
                    if (typeof t.then == "function") return sr(t);
                    if (t.$$typeof === Io) return In(t);
                }
                throw Error(F(438, String(t)));
            }
            function Hi(t) {
                var r = null, a = ne.updateQueue;
                if (a !== null && (r = a.memoCache), r == null) {
                    var l = ne.alternate;
                    l !== null && (l = l.updateQueue, l !== null && (l = l.memoCache, l != null && (r = {
                        data: l.data.map(function(c) {
                            return c.slice();
                        }),
                        index: 0
                    })));
                }
                if (r == null && (r = {
                    data: [],
                    index: 0
                }), a === null && (a = ja(), ne.updateQueue = a), a.memoCache = r, a = r.data[r.index], a === void 0) for(a = r.data[r.index] = Array(t), l = 0; l < t; l++)a[l] = $r;
                return r.index++, a;
            }
            function Ar(t, r) {
                return typeof r == "function" ? r(t) : r;
            }
            function Ai(t) {
                var r = He();
                return Po(r, Ie, t);
            }
            function Po(t, r, a) {
                var l = t.queue;
                if (l === null) throw Error(F(311));
                l.lastRenderedReducer = a;
                var c = t.baseQueue, d = l.pending;
                if (d !== null) {
                    if (c !== null) {
                        var h = c.next;
                        c.next = d.next, d.next = h;
                    }
                    r.baseQueue = c = d, l.pending = null;
                }
                if (d = t.baseState, c === null) t.memoizedState = d;
                else {
                    r = c.next;
                    var y = h = null, R = null, L = r, j = !1;
                    do {
                        var A = L.lane & -536870913;
                        if (A !== L.lane ? (he & A) === A : (Wo & A) === A) {
                            var W = L.revertLane;
                            if (W === 0) R !== null && (R = R.next = {
                                lane: 0,
                                revertLane: 0,
                                gesture: null,
                                action: L.action,
                                hasEagerState: L.hasEagerState,
                                eagerState: L.eagerState,
                                next: null
                            }), A === sl && (j = !0);
                            else if ((Wo & W) === W) {
                                L = L.next, W === sl && (j = !0);
                                continue;
                            } else A = {
                                lane: 0,
                                revertLane: L.revertLane,
                                gesture: null,
                                action: L.action,
                                hasEagerState: L.hasEagerState,
                                eagerState: L.eagerState,
                                next: null
                            }, R === null ? (y = R = A, h = d) : R = R.next = A, ne.lanes |= W, ba |= W;
                            A = L.action, oi && a(d, A), d = L.hasEagerState ? L.eagerState : a(d, A);
                        } else W = {
                            lane: A,
                            revertLane: L.revertLane,
                            gesture: L.gesture,
                            action: L.action,
                            hasEagerState: L.hasEagerState,
                            eagerState: L.eagerState,
                            next: null
                        }, R === null ? (y = R = W, h = d) : R = R.next = W, ne.lanes |= A, ba |= A;
                        L = L.next;
                    }while (L !== null && L !== r);
                    if (R === null ? h = d : R.next = y, !jn(d, t.memoizedState) && (hn = !0, j && (a = ul, a !== null))) throw a;
                    t.memoizedState = d, t.baseState = h, t.baseQueue = R, l.lastRenderedState = d;
                }
                return c === null && (l.lanes = 0), [
                    t.memoizedState,
                    l.dispatch
                ];
            }
            function Da(t) {
                var r = He(), a = r.queue;
                if (a === null) throw Error(F(311));
                a.lastRenderedReducer = t;
                var l = a.dispatch, c = a.pending, d = r.memoizedState;
                if (c !== null) {
                    a.pending = null;
                    var h = c = c.next;
                    do d = t(d, h.action), h = h.next;
                    while (h !== c);
                    jn(d, r.memoizedState) || (hn = !0), r.memoizedState = d, r.baseQueue === null && (r.baseState = d), a.lastRenderedState = d;
                }
                return [
                    d,
                    l
                ];
            }
            function ur(t, r, a) {
                var l = ne, c = He(), d = ue;
                if (d) {
                    if (a === void 0) throw Error(F(407));
                    a = a();
                } else a = r();
                var h = !jn((Ie || c).memoizedState, a);
                if (h && (c.memoizedState = a, hn = !0), c = c.queue, Tu(ql.bind(null, l, c, t), [
                    t
                ]), c.getSnapshot !== r || h || pn !== null && pn.memoizedState.tag & 1) {
                    if (l.flags |= 2048, Kn(9, {
                        destroy: void 0
                    }, jr.bind(null, l, c, a, r), null), Ne === null) throw Error(F(349));
                    d || (Wo & 127) !== 0 || Hp(l, r, a);
                }
                return a;
            }
            function Hp(t, r, a) {
                t.flags |= 16384, t = {
                    getSnapshot: r,
                    value: a
                }, r = ne.updateQueue, r === null ? (r = ja(), ne.updateQueue = r, r.stores = [
                    t
                ]) : (a = r.stores, a === null ? r.stores = [
                    t
                ] : a.push(t));
            }
            function jr(t, r, a, l) {
                r.value = a, r.getSnapshot = l, ji(r) && Gl(t);
            }
            function ql(t, r, a) {
                return a(function() {
                    ji(r) && Gl(t);
                });
            }
            function ji(t) {
                var r = t.getSnapshot;
                t = t.value;
                try {
                    var a = r();
                    return !jn(t, a);
                } catch  {
                    return !0;
                }
            }
            function Gl(t) {
                var r = Ko(t, 2);
                r !== null && nt(r, t, 2);
            }
            function Xn(t) {
                var r = Ln();
                if (typeof t == "function") {
                    var a = t;
                    if (t = a(), oi) {
                        pe(!0);
                        try {
                            a();
                        } finally{
                            pe(!1);
                        }
                    }
                }
                return r.memoizedState = r.baseState = t, r.queue = {
                    pending: null,
                    lanes: 0,
                    dispatch: null,
                    lastRenderedReducer: Ar,
                    lastRenderedState: t
                }, r;
            }
            function mt(t, r, a, l) {
                return t.baseState = a, Po(t, Ie, typeof l == "function" ? l : Ar);
            }
            function Dr(t, r, a, l, c) {
                if (na(t)) throw Error(F(485));
                if (t = r.action, t !== null) {
                    var d = {
                        payload: c,
                        action: t,
                        next: null,
                        isTransition: !0,
                        status: "pending",
                        value: null,
                        reason: null,
                        listeners: [],
                        then: function(h) {
                            d.listeners.push(h);
                        }
                    };
                    M.T !== null ? a(!0) : d.isTransition = !1, l(d), a = r.pending, a === null ? (d.next = r.pending = d, cr(r, d)) : (d.next = a.next, r.pending = a.next = d);
                }
            }
            function cr(t, r) {
                var a = r.action, l = r.payload, c = t.state;
                if (r.isTransition) {
                    var d = M.T, h = {};
                    M.T = h;
                    try {
                        var y = a(c, l), R = M.S;
                        R !== null && R(h, y), dr(t, r, y);
                    } catch (L) {
                        Jl(t, r, L);
                    } finally{
                        d !== null && h.types !== null && (d.types = h.types), M.T = d;
                    }
                } else try {
                    d = a(c, l), dr(t, r, d);
                } catch (L) {
                    Jl(t, r, L);
                }
            }
            function dr(t, r, a) {
                a !== null && typeof a == "object" && typeof a.then == "function" ? a.then(function(l) {
                    fr(t, r, l);
                }, function(l) {
                    return Jl(t, r, l);
                }) : fr(t, r, a);
            }
            function fr(t, r, a) {
                r.status = "fulfilled", r.value = a, Cu(r), t.state = a, r = t.pending, r !== null && (a = r.next, a === r ? t.pending = null : (a = a.next, r.next = a, cr(t, a)));
            }
            function Jl(t, r, a) {
                var l = t.pending;
                if (t.pending = null, l !== null) {
                    l = l.next;
                    do r.status = "rejected", r.reason = a, Cu(r), r = r.next;
                    while (r !== l);
                }
                t.action = null;
            }
            function Cu(t) {
                t = t.listeners;
                for(var r = 0; r < t.length; r++)(0, t[r])();
            }
            function Wd(t, r) {
                return r;
            }
            function pr(t, r) {
                if (ue) {
                    var a = Ne.formState;
                    if (a !== null) {
                        e: {
                            var l = ne;
                            if (ue) {
                                if (Ue) {
                                    var c = vh(Ue, Yt);
                                    if (c) {
                                        Ue = Nf(c), l = Sh(c);
                                        break e;
                                    }
                                }
                                ar(l);
                            }
                            l = !1;
                        }
                        l && (r = a[0]);
                    }
                }
                a = Ln(), a.memoizedState = a.baseState = r, l = {
                    pending: null,
                    lanes: 0,
                    dispatch: null,
                    lastRenderedReducer: Wd,
                    lastRenderedState: r
                }, a.queue = l, a = Nu.bind(null, ne, l), l.dispatch = a, l = Xn(!1);
                var d = Wi.bind(null, ne, !1, l.queue);
                return l = Ln(), c = {
                    state: r,
                    dispatch: null,
                    action: t,
                    pending: null
                }, l.queue = c, a = Dr.bind(null, ne, c, d, a), c.dispatch = a, l.memoizedState = t, [
                    r,
                    a,
                    !1
                ];
            }
            function Ud(t) {
                var r = He();
                return hr(r, Ie, t);
            }
            function hr(t, r, a) {
                if (r = Po(t, r, Wd)[0], t = Ai(Ar)[0], typeof r == "object" && r !== null && typeof r.then == "function") try {
                    var l = sr(r);
                } catch (h) {
                    throw h === cl ? jc : h;
                }
                else l = r;
                r = He();
                var c = r.queue, d = c.dispatch;
                return a !== r.memoizedState && (ne.flags |= 2048, Kn(9, {
                    destroy: void 0
                }, Zl.bind(null, c, a), null)), [
                    l,
                    d,
                    t
                ];
            }
            function Zl(t, r) {
                t.action = r;
            }
            function Yl(t) {
                var r = He(), a = Ie;
                if (a !== null) return hr(r, a, t);
                He(), r = r.memoizedState, a = He();
                var l = a.queue.dispatch;
                return a.memoizedState = t, [
                    r,
                    l,
                    !1
                ];
            }
            function Kn(t, r, a, l) {
                return t = {
                    tag: t,
                    create: a,
                    deps: l,
                    inst: r,
                    next: null
                }, r = ne.updateQueue, r === null && (r = ja(), ne.updateQueue = r), a = r.lastEffect, a === null ? r.lastEffect = t.next = t : (l = a.next, a.next = t, t.next = l, r.lastEffect = t), t;
            }
            function Wa() {
                return He().memoizedState;
            }
            function Xl(t, r, a, l) {
                var c = Ln();
                ne.flags |= t, c.memoizedState = Kn(1 | r, {
                    destroy: void 0
                }, a, l === void 0 ? null : l);
            }
            function Di(t, r, a, l) {
                var c = He();
                l = l === void 0 ? null : l;
                var d = c.memoizedState.inst;
                Ie !== null && l !== null && wo(l, Ie.memoizedState.deps) ? c.memoizedState = Kn(r, d, a, l) : (ne.flags |= t, c.memoizedState = Kn(1 | r, d, a, l));
            }
            function Bd(t, r) {
                Xl(8390656, 8, t, r);
            }
            function Tu(t, r) {
                Di(2048, 8, t, r);
            }
            function Ap(t) {
                ne.flags |= 4;
                var r = ne.updateQueue;
                if (r === null) r = ja(), ne.updateQueue = r, r.events = [
                    t
                ];
                else {
                    var a = r.events;
                    a === null ? r.events = [
                        t
                    ] : a.push(t);
                }
            }
            function _u(t) {
                var r = He().memoizedState;
                return Ap({
                    ref: r,
                    nextImpl: t
                }), function() {
                    if ((ce & 2) !== 0) throw Error(F(440));
                    return r.impl.apply(void 0, arguments);
                };
            }
            function Od(t, r) {
                return Di(4, 2, t, r);
            }
            function Ru(t, r) {
                return Di(4, 4, t, r);
            }
            function jp(t, r) {
                if (typeof r == "function") {
                    t = t();
                    var a = r(t);
                    return function() {
                        typeof a == "function" ? a() : r(null);
                    };
                }
                if (r != null) return t = t(), r.current = t, function() {
                    r.current = null;
                };
            }
            function Md(t, r, a) {
                a = a != null ? a.concat([
                    t
                ]) : null, Di(4, 4, jp.bind(null, r, t), a);
            }
            function Qd() {}
            function Eu(t, r) {
                var a = He();
                r = r === void 0 ? null : r;
                var l = a.memoizedState;
                return r !== null && wo(r, l[1]) ? l[0] : (a.memoizedState = [
                    t,
                    r
                ], t);
            }
            function Kl(t, r) {
                var a = He();
                r = r === void 0 ? null : r;
                var l = a.memoizedState;
                if (r !== null && wo(r, l[1])) return l[0];
                if (l = t(), oi) {
                    pe(!0);
                    try {
                        t();
                    } finally{
                        pe(!1);
                    }
                }
                return a.memoizedState = [
                    l,
                    r
                ], l;
            }
            function Iu(t, r, a) {
                return a === void 0 || (Wo & 1073741824) !== 0 && (he & 261930) === 0 ? t.memoizedState = r : (t.memoizedState = a, t = ys(), ne.lanes |= t, ba |= t, a);
            }
            function es(t, r, a, l) {
                return jn(a, r) ? a : Kr.current !== null ? (t = Iu(t, a, l), jn(t, r) || (hn = !0), t) : (Wo & 42) === 0 || (Wo & 1073741824) !== 0 && (he & 261930) === 0 ? (hn = !0, t.memoizedState = a) : (t = ys(), ne.lanes |= t, ba |= t, r);
            }
            function $d(t, r, a, l, c) {
                var d = qr();
                yn(d !== 0 && 8 > d ? d : 8);
                var h = M.T, y = {};
                M.T = y, Wi(t, !1, r, a);
                try {
                    var R = c(), L = M.S;
                    if (L !== null && L(y, R), R !== null && typeof R == "object" && typeof R.then == "function") {
                        var j = ho(R, l);
                        ea(t, r, j, bt(t));
                    } else ea(t, r, l, bt(t));
                } catch (A) {
                    ea(t, r, {
                        then: function() {},
                        status: "rejected",
                        reason: A
                    }, bt());
                } finally{
                    yn(d), h !== null && y.types !== null && (h.types = y.types), M.T = h;
                }
            }
            function Vd(t) {
                var r = t.memoizedState;
                if (r !== null) return r;
                r = {
                    memoizedState: rt,
                    baseState: rt,
                    baseQueue: null,
                    queue: {
                        pending: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: Ar,
                        lastRenderedState: rt
                    },
                    next: null
                };
                var a = {};
                return r.next = {
                    memoizedState: a,
                    baseState: a,
                    baseQueue: null,
                    queue: {
                        pending: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: Ar,
                        lastRenderedState: a
                    },
                    next: null
                }, t.memoizedState = r, t = t.alternate, t !== null && (t.memoizedState = r), r;
            }
            function Lu() {
                return In(da);
            }
            function xo() {
                return He().memoizedState;
            }
            function qd() {
                return He().memoizedState;
            }
            function Dp(t) {
                for(var r = t.return; r !== null;){
                    switch(r.tag){
                        case 24:
                        case 3:
                            var a = bt();
                            t = Et(a);
                            var l = Nr(r, t, a);
                            l !== null && (nt(l, r, a), Ml(l, r, a)), r = {
                                cache: Fd()
                            }, t.payload = r;
                            return;
                    }
                    r = r.return;
                }
            }
            function Nn(t, r, a) {
                var l = bt();
                a = {
                    lane: l,
                    revertLane: 0,
                    gesture: null,
                    action: a,
                    hasEagerState: !1,
                    eagerState: null,
                    next: null
                }, na(t) ? Gd(r, a) : (a = yo(t, r, a, l), a !== null && (nt(a, t, l), ns(a, r, l)));
            }
            function Nu(t, r, a) {
                var l = bt();
                ea(t, r, a, l);
            }
            function ea(t, r, a, l) {
                var c = {
                    lane: l,
                    revertLane: 0,
                    gesture: null,
                    action: a,
                    hasEagerState: !1,
                    eagerState: null,
                    next: null
                };
                if (na(t)) Gd(r, c);
                else {
                    var d = t.alternate;
                    if (t.lanes === 0 && (d === null || d.lanes === 0) && (d = r.lastRenderedReducer, d !== null)) try {
                        var h = r.lastRenderedState, y = d(h, a);
                        if (c.hasEagerState = !0, c.eagerState = y, jn(y, h)) return go(t, r, c, 0), Ne === null && Bn(), !1;
                    } catch  {} finally{}
                    if (a = yo(t, r, c, l), a !== null) return nt(a, t, l), ns(a, r, l), !0;
                }
                return !1;
            }
            function Wi(t, r, a, l) {
                if (l = {
                    lane: 2,
                    revertLane: ku(),
                    gesture: null,
                    action: l,
                    hasEagerState: !1,
                    eagerState: null,
                    next: null
                }, na(t)) {
                    if (r) throw Error(F(479));
                } else r = yo(t, a, l, 2), r !== null && nt(r, t, 2);
            }
            function na(t) {
                var r = t.alternate;
                return t === ne || r !== null && r === ne;
            }
            function Gd(t, r) {
                dl = Uc = !0;
                var a = t.pending;
                a === null ? r.next = r : (r.next = a.next, a.next = r), t.pending = r;
            }
            function ns(t, r, a) {
                if ((a & 4194048) !== 0) {
                    var l = r.lanes;
                    l &= t.pendingLanes, a |= l, r.lanes = a, $e(t, a);
                }
            }
            function Fu(t, r, a, l) {
                r = t.memoizedState, a = a(l, r), a = a == null ? r : Lt({}, r, a), t.memoizedState = a, t.lanes === 0 && (t.updateQueue.baseState = a);
            }
            function ts(t, r, a, l, c, d, h) {
                return t = t.stateNode, typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(l, d, h) : r.prototype && r.prototype.isPureReactComponent ? !Ul(a, l) || !Ul(c, d) : !0;
            }
            function Jd(t, r, a, l) {
                t = r.state, typeof r.componentWillReceiveProps == "function" && r.componentWillReceiveProps(a, l), typeof r.UNSAFE_componentWillReceiveProps == "function" && r.UNSAFE_componentWillReceiveProps(a, l), r.state !== t && Oc.enqueueReplaceState(r, r.state, null);
            }
            function Wr(t, r) {
                var a = r;
                if ("ref" in r) {
                    a = {};
                    for(var l in r)l !== "ref" && (a[l] = r[l]);
                }
                if (t = t.defaultProps) {
                    a === r && (a = Lt({}, a));
                    for(var c in t)a[c] === void 0 && (a[c] = t[c]);
                }
                return a;
            }
            function rs(t, r) {
                try {
                    var a = t.onUncaughtError;
                    a(r.value, {
                        componentStack: r.stack
                    });
                } catch (l) {
                    setTimeout(function() {
                        throw l;
                    });
                }
            }
            function Zd(t, r, a) {
                try {
                    var l = t.onCaughtError;
                    l(a.value, {
                        componentStack: a.stack,
                        errorBoundary: r.tag === 1 ? r.stateNode : null
                    });
                } catch (c) {
                    setTimeout(function() {
                        throw c;
                    });
                }
            }
            function Ui(t, r, a) {
                return a = Et(a), a.tag = 3, a.payload = {
                    element: null
                }, a.callback = function() {
                    rs(t, r);
                }, a;
            }
            function os(t) {
                return t = Et(t), t.tag = 3, t;
            }
            function Hu(t, r, a, l) {
                var c = a.type.getDerivedStateFromError;
                if (typeof c == "function") {
                    var d = l.value;
                    t.payload = function() {
                        return c(d);
                    }, t.callback = function() {
                        Zd(r, a, l);
                    };
                }
                var h = a.stateNode;
                h !== null && typeof h.componentDidCatch == "function" && (t.callback = function() {
                    Zd(r, a, l), typeof c != "function" && (va === null ? va = new Set([
                        this
                    ]) : va.add(this));
                    var y = l.stack;
                    this.componentDidCatch(l.value, {
                        componentStack: y !== null ? y : ""
                    });
                });
            }
            function On(t, r, a, l, c) {
                if (a.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
                    if (r = a.alternate, r !== null && po(r, a, c, !0), a = Ft.current, a !== null) {
                        switch(a.tag){
                            case 31:
                            case 13:
                                return zr === null ? Gi() : a.alternate === null && Xe === 0 && (Xe = 3), a.flags &= -257, a.flags |= 65536, a.lanes = c, l === Dc ? a.flags |= 16384 : (r = a.updateQueue, r === null ? a.updateQueue = new Set([
                                    l
                                ]) : r.add(l), lc(t, l, c)), !1;
                            case 22:
                                return a.flags |= 65536, l === Dc ? a.flags |= 16384 : (r = a.updateQueue, r === null ? (r = {
                                    transitions: null,
                                    markerInstances: null,
                                    retryQueue: new Set([
                                        l
                                    ])
                                }, a.updateQueue = r) : (a = r.retryQueue, a === null ? r.retryQueue = new Set([
                                    l
                                ]) : a.add(l)), lc(t, l, c)), !1;
                        }
                        throw Error(F(435, a.tag));
                    }
                    return lc(t, l, c), Gi(), !1;
                }
                if (ue) return r = Ft.current, r !== null ? ((r.flags & 65536) === 0 && (r.flags |= 256), r.flags |= 65536, r.lanes = c, l !== Of && (t = Error(F(422), {
                    cause: l
                }), ct(ut(t, a)))) : (l !== Of && (r = Error(F(423), {
                    cause: l
                }), ct(ut(r, a))), t = t.current.alternate, t.flags |= 65536, c &= -c, t.lanes |= c, l = ut(l, a), c = Ui(t.stateNode, l, c), jd(t, c), Xe !== 4 && (Xe = 2)), !1;
                var d = Error(F(520), {
                    cause: l
                });
                if (d = ut(d, a), $s === null ? $s = [
                    d
                ] : $s.push(d), Xe !== 4 && (Xe = 2), r === null) return !0;
                l = ut(l, a), a = r;
                do {
                    switch(a.tag){
                        case 3:
                            return a.flags |= 65536, t = c & -c, a.lanes |= t, t = Ui(a.stateNode, l, t), jd(a, t), !1;
                        case 1:
                            if (r = a.type, d = a.stateNode, (a.flags & 128) === 0 && (typeof r.getDerivedStateFromError == "function" || d !== null && typeof d.componentDidCatch == "function" && (va === null || !va.has(d)))) return a.flags |= 65536, c &= -c, a.lanes |= c, c = os(c), Hu(c, t, a, l), jd(a, c), !1;
                    }
                    a = a.return;
                }while (a !== null);
                return !1;
            }
            function wn(t, r, a, l) {
                r.child = t === null ? Oh(r, null, a, l) : ri(r, t.child, a, l);
            }
            function as(t, r, a, l, c) {
                a = a.render;
                var d = r.ref;
                if ("ref" in l) {
                    var h = {};
                    for(var y in l)y !== "ref" && (h[y] = l[y]);
                } else h = l;
                return Un(r), l = $l(t, r, a, h, d, c), y = Hr(), t !== null && !hn ? (lr(t, r, c), gt(t, r, c)) : (ue && y && Id(r), r.flags |= 1, wn(t, r, l, c), r.child);
            }
            function Au(t, r, a, l, c) {
                if (t === null) {
                    var d = a.type;
                    return typeof d == "function" && !ks(d) && d.defaultProps === void 0 && a.compare === null ? (r.tag = 15, r.type = d, ju(t, r, d, l, c)) : (t = ws(a.type, null, l, r, r.mode, c), t.ref = r.ref, t.return = r, r.child = t);
                }
                if (d = t.child, !Mi(t, c)) {
                    var h = d.memoizedProps;
                    if (a = a.compare, a = a !== null ? a : Ul, a(h, l) && t.ref === r.ref) return gt(t, r, c);
                }
                return r.flags |= 1, t = Qr(d, l), t.ref = r.ref, t.return = r, r.child = t;
            }
            function ju(t, r, a, l, c) {
                if (t !== null) {
                    var d = t.memoizedProps;
                    if (Ul(d, l) && t.ref === r.ref) {
                        if (hn = !1, r.pendingProps = l = d, Mi(t, c)) (t.flags & 131072) !== 0 && (hn = !0);
                        else return r.lanes = t.lanes, gt(t, r, c);
                    }
                }
                return Yd(t, r, a, l, c);
            }
            function zo(t, r, a, l) {
                var c = l.children, d = t !== null ? t.memoizedState : null;
                if (t === null && r.stateNode === null && (r.stateNode = {
                    _visibility: 1,
                    _pendingMarkers: null,
                    _retryCache: null,
                    _transitions: null
                }), l.mode === "hidden") {
                    if ((r.flags & 128) !== 0) {
                        if (d = d !== null ? d.baseLanes | a : a, t !== null) {
                            for(l = r.child = t.child, c = 0; l !== null;)c = c | l.lanes | l.childLanes, l = l.sibling;
                            l = c & ~d;
                        } else l = 0, r.child = null;
                        return Bi(t, r, d, a, l);
                    }
                    if ((a & 536870912) !== 0) r.memoizedState = {
                        baseLanes: 0,
                        cachePool: null
                    }, t !== null && Ei(r, d !== null ? d.cachePool : null), d !== null ? B(r, d) : Ql(), Fr(r);
                    else return l = r.lanes = 536870912, Bi(t, r, d !== null ? d.baseLanes | a : a, a, l);
                } else d !== null ? (Ei(r, d.cachePool), B(r, d), So(), r.memoizedState = null) : (t !== null && Ei(r, null), Ql(), So());
                return wn(t, r, c, a), r.child;
            }
            function Mt(t, r) {
                return t !== null && t.tag === 22 || r.stateNode !== null || (r.stateNode = {
                    _visibility: 1,
                    _pendingMarkers: null,
                    _retryCache: null,
                    _transitions: null
                }), r.sibling;
            }
            function Bi(t, r, a, l, c) {
                var d = wu();
                return d = d === null ? null : {
                    parent: qt ? qe._currentValue : qe._currentValue2,
                    pool: d
                }, r.memoizedState = {
                    baseLanes: a,
                    cachePool: d
                }, t !== null && Ei(r, null), Ql(), Fr(r), t !== null && po(t, r, l, !0), r.childLanes = c, null;
            }
            function Ua(t, r) {
                return r = mr({
                    mode: r.mode,
                    children: r.children
                }, t.mode), r.ref = t.ref, t.child = r, r.return = t, r;
            }
            function Oi(t, r, a) {
                return ri(r, t.child, null, a), t = Ua(r, r.pendingProps), t.flags |= 2, ht(r), r.memoizedState = null, t;
            }
            function is(t, r, a) {
                var l = r.pendingProps, c = (r.flags & 128) !== 0;
                if (r.flags &= -129, t === null) {
                    if (ue) {
                        if (l.mode === "hidden") return t = Ua(r, l), r.lanes = 536870912, Mt(null, t);
                        if (Ni(r), (t = Ue) ? (t = xh(t, Yt), t !== null && (r.memoizedState = {
                            dehydrated: t,
                            treeContext: jo !== null ? {
                                id: ot,
                                overflow: Zr
                            } : null,
                            retryLane: 536870912,
                            hydrationErrors: null
                        }, a = cc(t), a.return = r, r.child = a, bn = r, Ue = null)) : t = null, t === null) throw ar(r);
                        return r.lanes = 536870912, null;
                    }
                    return Ua(r, l);
                }
                var d = t.memoizedState;
                if (d !== null) {
                    var h = d.dehydrated;
                    if (Ni(r), c) {
                        if (r.flags & 256) r.flags &= -257, r = Oi(t, r, a);
                        else if (r.memoizedState !== null) r.child = t.child, r.flags |= 128, r = null;
                        else throw Error(F(558));
                    } else if (hn || po(t, r, a, !1), c = (a & t.childLanes) !== 0, hn || c) {
                        if (l = Ne, l !== null && (h = G(l, a), h !== 0 && h !== d.retryLane)) throw d.retryLane = h, Ko(t, h), nt(l, t, h), Mc;
                        Gi(), r = Oi(t, r, a);
                    } else t = d.treeContext, Hn && (Ue = Ff(h), bn = r, ue = !0, Do = null, Yt = !1, t !== null && Ld(r, t)), r = Ua(r, l), r.flags |= 4096;
                    return r;
                }
                return t = Qr(t.child, {
                    mode: l.mode,
                    children: l.children
                }), t.ref = r.ref, r.child = t, t.return = r, t;
            }
            function ls(t, r) {
                var a = r.ref;
                if (a === null) t !== null && t.ref !== null && (r.flags |= 4194816);
                else {
                    if (typeof a != "function" && typeof a != "object") throw Error(F(284));
                    (t === null || t.ref !== a) && (r.flags |= 4194816);
                }
            }
            function Yd(t, r, a, l, c) {
                return Un(r), a = $l(t, r, a, l, void 0, c), l = Hr(), t !== null && !hn ? (lr(t, r, c), gt(t, r, c)) : (ue && l && Id(r), r.flags |= 1, wn(t, r, a, c), r.child);
            }
            function Xd(t, r, a, l, c, d) {
                return Un(r), r.updateQueue = null, a = xu(r, l, a, c), Fi(t), l = Hr(), t !== null && !hn ? (lr(t, r, d), gt(t, r, d)) : (ue && l && Id(r), r.flags |= 1, wn(t, r, a, d), r.child);
            }
            function Kd(t, r, a, l, c) {
                if (Un(r), r.stateNode === null) {
                    var d = Ka, h = a.contextType;
                    typeof h == "object" && h !== null && (d = In(h)), d = new a(l, d), r.memoizedState = d.state !== null && d.state !== void 0 ? d.state : null, d.updater = Oc, r.stateNode = d, d._reactInternals = r, d = r.stateNode, d.props = l, d.state = r.memoizedState, d.refs = {}, Ol(r), h = a.contextType, d.context = typeof h == "object" && h !== null ? In(h) : Ka, d.state = r.memoizedState, h = a.getDerivedStateFromProps, typeof h == "function" && (Fu(r, a, h, l), d.state = r.memoizedState), typeof a.getDerivedStateFromProps == "function" || typeof d.getSnapshotBeforeUpdate == "function" || typeof d.UNSAFE_componentWillMount != "function" && typeof d.componentWillMount != "function" || (h = d.state, typeof d.componentWillMount == "function" && d.componentWillMount(), typeof d.UNSAFE_componentWillMount == "function" && d.UNSAFE_componentWillMount(), h !== d.state && Oc.enqueueReplaceState(d, d.state, null), Aa(r, l, d, c), Li(), d.state = r.memoizedState), typeof d.componentDidMount == "function" && (r.flags |= 4194308), l = !0;
                } else if (t === null) {
                    d = r.stateNode;
                    var y = r.memoizedProps, R = Wr(a, y);
                    d.props = R;
                    var L = d.context, j = a.contextType;
                    h = Ka, typeof j == "object" && j !== null && (h = In(j));
                    var A = a.getDerivedStateFromProps;
                    j = typeof A == "function" || typeof d.getSnapshotBeforeUpdate == "function", y = r.pendingProps !== y, j || typeof d.UNSAFE_componentWillReceiveProps != "function" && typeof d.componentWillReceiveProps != "function" || (y || L !== h) && Jd(r, d, l, h), ma = !1;
                    var W = r.memoizedState;
                    d.state = W, Aa(r, l, d, c), Li(), L = r.memoizedState, y || W !== L || ma ? (typeof A == "function" && (Fu(r, a, A, l), L = r.memoizedState), (R = ma || ts(r, a, R, l, W, L, h)) ? (j || typeof d.UNSAFE_componentWillMount != "function" && typeof d.componentWillMount != "function" || (typeof d.componentWillMount == "function" && d.componentWillMount(), typeof d.UNSAFE_componentWillMount == "function" && d.UNSAFE_componentWillMount()), typeof d.componentDidMount == "function" && (r.flags |= 4194308)) : (typeof d.componentDidMount == "function" && (r.flags |= 4194308), r.memoizedProps = l, r.memoizedState = L), d.props = l, d.state = L, d.context = h, l = R) : (typeof d.componentDidMount == "function" && (r.flags |= 4194308), l = !1);
                } else {
                    d = r.stateNode, Ha(t, r), h = r.memoizedProps, j = Wr(a, h), d.props = j, A = r.pendingProps, W = d.context, L = a.contextType, R = Ka, typeof L == "object" && L !== null && (R = In(L)), y = a.getDerivedStateFromProps, (L = typeof y == "function" || typeof d.getSnapshotBeforeUpdate == "function") || typeof d.UNSAFE_componentWillReceiveProps != "function" && typeof d.componentWillReceiveProps != "function" || (h !== A || W !== R) && Jd(r, d, l, R), ma = !1, W = r.memoizedState, d.state = W, Aa(r, l, d, c), Li();
                    var V = r.memoizedState;
                    h !== A || W !== V || ma || t !== null && t.dependencies !== null && Ri(t.dependencies) ? (typeof y == "function" && (Fu(r, a, y, l), V = r.memoizedState), (j = ma || ts(r, a, j, l, W, V, R) || t !== null && t.dependencies !== null && Ri(t.dependencies)) ? (L || typeof d.UNSAFE_componentWillUpdate != "function" && typeof d.componentWillUpdate != "function" || (typeof d.componentWillUpdate == "function" && d.componentWillUpdate(l, V, R), typeof d.UNSAFE_componentWillUpdate == "function" && d.UNSAFE_componentWillUpdate(l, V, R)), typeof d.componentDidUpdate == "function" && (r.flags |= 4), typeof d.getSnapshotBeforeUpdate == "function" && (r.flags |= 1024)) : (typeof d.componentDidUpdate != "function" || h === t.memoizedProps && W === t.memoizedState || (r.flags |= 4), typeof d.getSnapshotBeforeUpdate != "function" || h === t.memoizedProps && W === t.memoizedState || (r.flags |= 1024), r.memoizedProps = l, r.memoizedState = V), d.props = l, d.state = V, d.context = R, l = j) : (typeof d.componentDidUpdate != "function" || h === t.memoizedProps && W === t.memoizedState || (r.flags |= 4), typeof d.getSnapshotBeforeUpdate != "function" || h === t.memoizedProps && W === t.memoizedState || (r.flags |= 1024), l = !1);
                }
                return d = l, ls(t, r), l = (r.flags & 128) !== 0, d || l ? (d = r.stateNode, a = l && typeof a.getDerivedStateFromError != "function" ? null : d.render(), r.flags |= 1, t !== null && l ? (r.child = ri(r, t.child, null, c), r.child = ri(r, null, a, c)) : wn(t, r, a, c), r.memoizedState = d.state, t = r.child) : t = gt(t, r, c), t;
            }
            function Du(t, r, a, l) {
                return _a(), r.flags |= 256, wn(t, r, a, l), r.child;
            }
            function ss(t) {
                return {
                    baseLanes: t,
                    cachePool: Pu()
                };
            }
            function Ur(t, r, a) {
                return t = t !== null ? t.childLanes & ~a : 0, r && (t |= At), t;
            }
            function Wu(t, r, a) {
                var l = r.pendingProps, c = !1, d = (r.flags & 128) !== 0, h;
                if ((h = d) || (h = t !== null && t.memoizedState === null ? !1 : (ln.current & 2) !== 0), h && (c = !0, r.flags &= -129), h = (r.flags & 32) !== 0, r.flags &= -33, t === null) {
                    if (ue) {
                        if (c ? vo(r) : So(), (t = Ue) ? (t = Om(t, Yt), t !== null && (r.memoizedState = {
                            dehydrated: t,
                            treeContext: jo !== null ? {
                                id: ot,
                                overflow: Zr
                            } : null,
                            retryLane: 536870912,
                            hydrationErrors: null
                        }, a = cc(t), a.return = r, r.child = a, bn = r, Ue = null)) : t = null, t === null) throw ar(r);
                        return Fs(t) ? r.lanes = 32 : r.lanes = 536870912, null;
                    }
                    var y = l.children;
                    return l = l.fallback, c ? (So(), c = r.mode, y = mr({
                        mode: "hidden",
                        children: y
                    }, c), l = Eo(l, c, a, null), y.return = r, l.return = r, y.sibling = l, r.child = y, l = r.child, l.memoizedState = ss(a), l.childLanes = Ur(t, h, a), r.memoizedState = Qc, Mt(null, l)) : (vo(r), Uu(r, y));
                }
                var R = t.memoizedState;
                if (R !== null && (y = R.dehydrated, y !== null)) {
                    if (d) r.flags & 256 ? (vo(r), r.flags &= -257, r = et(t, r, a)) : r.memoizedState !== null ? (So(), r.child = t.child, r.flags |= 128, r = null) : (So(), y = l.fallback, c = r.mode, l = mr({
                        mode: "visible",
                        children: l.children
                    }, c), y = Eo(y, c, a, null), y.flags |= 2, l.return = r, y.return = r, l.sibling = y, r.child = l, ri(r, t.child, null, a), l = r.child, l.memoizedState = ss(a), l.childLanes = Ur(t, h, a), r.memoizedState = Qc, r = Mt(null, l));
                    else if (vo(r), Fs(y)) h = Za(y).digest, l = Error(F(419)), l.stack = "", l.digest = h, ct({
                        value: l,
                        source: null,
                        stack: null
                    }), r = et(t, r, a);
                    else if (hn || po(t, r, a, !1), h = (a & t.childLanes) !== 0, hn || h) {
                        if (h = Ne, h !== null && (l = G(h, a), l !== 0 && l !== R.retryLane)) throw R.retryLane = l, Ko(t, l), nt(h, t, l), Mc;
                        Ns(y) || Gi(), r = et(t, r, a);
                    } else Ns(y) ? (r.flags |= 192, r.child = t.child, r = null) : (t = R.treeContext, Hn && (Ue = wh(y), bn = r, ue = !0, Do = null, Yt = !1, t !== null && Ld(r, t)), r = Uu(r, l.children), r.flags |= 4096);
                    return r;
                }
                return c ? (So(), y = l.fallback, c = r.mode, R = t.child, d = R.sibling, l = Qr(R, {
                    mode: "hidden",
                    children: l.children
                }), l.subtreeFlags = R.subtreeFlags & 65011712, d !== null ? y = Qr(d, y) : (y = Eo(y, c, a, null), y.flags |= 2), y.return = r, l.return = r, l.sibling = y, r.child = l, Mt(null, l), l = r.child, y = t.child.memoizedState, y === null ? y = ss(a) : (c = y.cachePool, c !== null ? (R = qt ? qe._currentValue : qe._currentValue2, c = c.parent !== R ? {
                    parent: R,
                    pool: R
                } : c) : c = Pu(), y = {
                    baseLanes: y.baseLanes | a,
                    cachePool: c
                }), l.memoizedState = y, l.childLanes = Ur(t, h, a), r.memoizedState = Qc, Mt(t.child, l)) : (vo(r), a = t.child, t = a.sibling, a = Qr(a, {
                    mode: "visible",
                    children: l.children
                }), a.return = r, a.sibling = null, t !== null && (h = r.deletions, h === null ? (r.deletions = [
                    t
                ], r.flags |= 16) : h.push(t)), r.child = a, r.memoizedState = null, a);
            }
            function Uu(t, r) {
                return r = mr({
                    mode: "visible",
                    children: r
                }, t.mode), r.return = t, t.child = r;
            }
            function mr(t, r) {
                return t = Yn(22, t, null, r), t.lanes = 0, t;
            }
            function et(t, r, a) {
                return ri(r, t.child, null, a), t = Uu(r, r.pendingProps.children), t.flags |= 2, r.memoizedState = null, t;
            }
            function us(t, r, a) {
                t.lanes |= r;
                var l = t.alternate;
                l !== null && (l.lanes |= r), Ot(t.return, r, a);
            }
            function ee(t, r, a, l, c, d) {
                var h = t.memoizedState;
                h === null ? t.memoizedState = {
                    isBackwards: r,
                    rendering: null,
                    renderingStartTime: 0,
                    last: l,
                    tail: a,
                    tailMode: c,
                    treeForkCount: d
                } : (h.isBackwards = r, h.rendering = null, h.renderingStartTime = 0, h.last = l, h.tail = a, h.tailMode = c, h.treeForkCount = d);
            }
            function N(t, r, a) {
                var l = r.pendingProps, c = l.revealOrder, d = l.tail;
                l = l.children;
                var h = ln.current, y = (h & 2) !== 0;
                if (y ? (h = h & 1 | 2, r.flags |= 128) : h &= 1, Ce(ln, h), wn(t, r, l, a), l = ue ? x : 0, !y && t !== null && (t.flags & 128) !== 0) e: for(t = r.child; t !== null;){
                    if (t.tag === 13) t.memoizedState !== null && us(t, a, r);
                    else if (t.tag === 19) us(t, a, r);
                    else if (t.child !== null) {
                        t.child.return = t, t = t.child;
                        continue;
                    }
                    if (t === r) break e;
                    for(; t.sibling === null;){
                        if (t.return === null || t.return === r) break e;
                        t = t.return;
                    }
                    t.sibling.return = t.return, t = t.sibling;
                }
                switch(c){
                    case "forwards":
                        for(a = r.child, c = null; a !== null;)t = a.alternate, t !== null && ko(t) === null && (c = a), a = a.sibling;
                        a = c, a === null ? (c = r.child, r.child = null) : (c = a.sibling, a.sibling = null), ee(r, !1, c, a, d, l);
                        break;
                    case "backwards":
                    case "unstable_legacy-backwards":
                        for(a = null, c = r.child, r.child = null; c !== null;){
                            if (t = c.alternate, t !== null && ko(t) === null) {
                                r.child = c;
                                break;
                            }
                            t = c.sibling, c.sibling = a, a = c, c = t;
                        }
                        ee(r, !0, a, null, d, l);
                        break;
                    case "together":
                        ee(r, !1, null, null, void 0, l);
                        break;
                    default:
                        r.memoizedState = null;
                }
                return r.child;
            }
            function gt(t, r, a) {
                if (t !== null && (r.dependencies = t.dependencies), ba |= r.lanes, (a & r.childLanes) === 0) {
                    if (t !== null) {
                        if (po(t, r, a, !1), (a & r.childLanes) === 0) return null;
                    } else return null;
                }
                if (t !== null && r.child !== t.child) throw Error(F(153));
                if (r.child !== null) {
                    for(t = r.child, a = Qr(t, t.pendingProps), r.child = a, a.return = r; t.sibling !== null;)t = t.sibling, a = a.sibling = Qr(t, t.pendingProps), a.return = r;
                    a.sibling = null;
                }
                return r.child;
            }
            function Mi(t, r) {
                return (t.lanes & r) !== 0 ? !0 : (t = t.dependencies, !!(t !== null && Ri(t)));
            }
            function Ye(t, r, a) {
                switch(r.tag){
                    case 3:
                        Al(r, r.stateNode.containerInfo), fo(r, qe, t.memoizedState.cache), _a();
                        break;
                    case 27:
                    case 5:
                        yu(r);
                        break;
                    case 4:
                        Al(r, r.stateNode.containerInfo);
                        break;
                    case 10:
                        fo(r, r.type, r.memoizedProps.value);
                        break;
                    case 31:
                        if (r.memoizedState !== null) return r.flags |= 128, Ni(r), null;
                        break;
                    case 13:
                        var l = r.memoizedState;
                        if (l !== null) return l.dehydrated !== null ? (vo(r), r.flags |= 128, null) : (a & r.child.childLanes) !== 0 ? Wu(t, r, a) : (vo(r), t = gt(t, r, a), t !== null ? t.sibling : null);
                        vo(r);
                        break;
                    case 19:
                        var c = (t.flags & 128) !== 0;
                        if (l = (a & r.childLanes) !== 0, l || (po(t, r, a, !1), l = (a & r.childLanes) !== 0), c) {
                            if (l) return N(t, r, a);
                            r.flags |= 128;
                        }
                        if (c = r.memoizedState, c !== null && (c.rendering = null, c.tail = null, c.lastEffect = null), Ce(ln, ln.current), l) break;
                        return null;
                    case 22:
                        return r.lanes = 0, zo(t, r, a, r.pendingProps);
                    case 24:
                        fo(r, qe, t.memoizedState.cache);
                }
                return gt(t, r, a);
            }
            function Bu(t, r, a) {
                if (t !== null) {
                    if (t.memoizedProps !== r.pendingProps) hn = !0;
                    else {
                        if (!Mi(t, a) && (r.flags & 128) === 0) return hn = !1, Ye(t, r, a);
                        hn = (t.flags & 131072) !== 0;
                    }
                } else hn = !1, ue && (r.flags & 1048576) !== 0 && Ci(r, x, r.index);
                switch(r.lanes = 0, r.tag){
                    case 16:
                        e: {
                            var l = r.pendingProps;
                            if (t = pt(r.elementType), r.type = t, typeof t == "function") ks(t) ? (l = Wr(t, l), r.tag = 1, r = Kd(null, r, t, l, a)) : (r.tag = 0, r = Yd(null, r, t, l, a));
                            else {
                                if (t != null) {
                                    var c = t.$$typeof;
                                    if (c === Zi) {
                                        r.tag = 11, r = as(null, r, t, l, a);
                                        break e;
                                    } else if (c === wf) {
                                        r.tag = 14, r = Au(null, r, t, l, a);
                                        break e;
                                    }
                                }
                                throw r = hu(t) || t, Error(F(306, r, ""));
                            }
                        }
                        return r;
                    case 0:
                        return Yd(t, r, r.type, r.pendingProps, a);
                    case 1:
                        return l = r.type, c = Wr(l, r.pendingProps), Kd(t, r, l, c, a);
                    case 3:
                        e: {
                            if (Al(r, r.stateNode.containerInfo), t === null) throw Error(F(387));
                            var d = r.pendingProps;
                            c = r.memoizedState, l = c.element, Ha(t, r), Aa(r, d, null, a);
                            var h = r.memoizedState;
                            if (d = h.cache, fo(r, qe, d), d !== c.cache && _i(r, [
                                qe
                            ], a, !0), Li(), d = h.element, Hn && c.isDehydrated) {
                                if (c = {
                                    element: d,
                                    isDehydrated: !1,
                                    cache: h.cache
                                }, r.updateQueue.baseState = c, r.memoizedState = c, r.flags & 256) {
                                    r = Du(t, r, d, a);
                                    break e;
                                } else if (d !== l) {
                                    l = ut(Error(F(424)), r), ct(l), r = Du(t, r, d, a);
                                    break e;
                                } else for(Hn && (Ue = Pc(r.stateNode.containerInfo), bn = r, ue = !0, Do = null, Yt = !0), a = Oh(r, null, d, a), r.child = a; a;)a.flags = a.flags & -3 | 4096, a = a.sibling;
                            } else {
                                if (_a(), d === l) {
                                    r = gt(t, r, a);
                                    break e;
                                }
                                wn(t, r, d, a);
                            }
                            r = r.child;
                        }
                        return r;
                    case 26:
                        if (Gt) return ls(t, r), t === null ? (a = nl(r.type, null, r.pendingProps, null)) ? r.memoizedState = a : ue || (r.stateNode = Ah(r.type, r.pendingProps, pa.current, r)) : r.memoizedState = nl(r.type, t.memoizedProps, r.pendingProps, t.memoizedState), null;
                    case 27:
                        if (dn) return yu(r), t === null && dn && ue && (l = r.stateNode = _c(r.type, r.pendingProps, pa.current, Dn.current, !1), bn = r, Yt = !0, Ue = Um(r.type, l, Ue)), wn(t, r, r.pendingProps.children, a), ls(t, r), t === null && (r.flags |= 4194304), r.child;
                    case 5:
                        return t === null && ue && ($m(r.type, r.pendingProps, Dn.current), (c = l = Ue) && (l = Bm(l, r.type, r.pendingProps, Yt), l !== null ? (r.stateNode = l, bn = r, Ue = wc(l), Yt = !1, c = !0) : c = !1), c || ar(r)), yu(r), c = r.type, d = r.pendingProps, h = t !== null ? t.memoizedProps : null, l = d.children, Rs(c, d) ? l = null : h !== null && Rs(c, h) && (r.flags |= 32), r.memoizedState !== null && (c = $l(t, r, zu, null, null, a), qt ? da._currentValue = c : da._currentValue2 = c), ls(t, r), wn(t, r, l, a), r.child;
                    case 6:
                        return t === null && ue && (jf(r.pendingProps, Dn.current), (t = a = Ue) && (a = Ph(a, r.pendingProps, Yt), a !== null ? (r.stateNode = a, bn = r, Ue = null, t = !0) : t = !1), t || ar(r)), null;
                    case 13:
                        return Wu(t, r, a);
                    case 4:
                        return Al(r, r.stateNode.containerInfo), l = r.pendingProps, t === null ? r.child = ri(r, null, l, a) : wn(t, r, l, a), r.child;
                    case 11:
                        return as(t, r, r.type, r.pendingProps, a);
                    case 7:
                        return wn(t, r, r.pendingProps, a), r.child;
                    case 8:
                        return wn(t, r, r.pendingProps.children, a), r.child;
                    case 12:
                        return wn(t, r, r.pendingProps.children, a), r.child;
                    case 10:
                        return l = r.pendingProps, fo(r, r.type, l.value), wn(t, r, l.children, a), r.child;
                    case 9:
                        return c = r.type._context, l = r.pendingProps.children, Un(r), c = In(c), l = l(c), r.flags |= 1, wn(t, r, l, a), r.child;
                    case 14:
                        return Au(t, r, r.type, r.pendingProps, a);
                    case 15:
                        return ju(t, r, r.type, r.pendingProps, a);
                    case 19:
                        return N(t, r, a);
                    case 31:
                        return is(t, r, a);
                    case 22:
                        return zo(t, r, a, r.pendingProps);
                    case 24:
                        return Un(r), l = In(qe), t === null ? (c = wu(), c === null && (c = Ne, d = Fd(), c.pooledCache = d, d.refCount++, d !== null && (c.pooledCacheLanes |= a), c = d), r.memoizedState = {
                            parent: l,
                            cache: c
                        }, Ol(r), fo(r, qe, c)) : ((t.lanes & a) !== 0 && (Ha(t, r), Aa(r, null, null, a), Li()), c = t.memoizedState, d = r.memoizedState, c.parent !== l ? (c = {
                            parent: l,
                            cache: l
                        }, r.memoizedState = c, r.lanes === 0 && (r.memoizedState = r.updateQueue.baseState = c), fo(r, qe, l)) : (l = d.cache, fo(r, qe, l), l !== c.cache && _i(r, [
                            qe
                        ], a, !0))), wn(t, r, r.pendingProps.children, a), r.child;
                    case 29:
                        throw r.pendingProps;
                }
                throw Error(F(156, r.tag));
            }
            function It(t) {
                t.flags |= 4;
            }
            function cs(t) {
                Sr && (t.flags |= 8);
            }
            function Ou(t, r) {
                if (t !== null && t.child === r.child) return !1;
                if ((r.flags & 16) !== 0) return !0;
                for(t = r.child; t !== null;){
                    if ((t.flags & 8218) !== 0 || (t.subtreeFlags & 8218) !== 0) return !0;
                    t = t.sibling;
                }
                return !1;
            }
            function ef(t, r, a, l) {
                if ($n) for(a = r.child; a !== null;){
                    if (a.tag === 5 || a.tag === 6) yc(t, a.stateNode);
                    else if (!(a.tag === 4 || dn && a.tag === 27) && a.child !== null) {
                        a.child.return = a, a = a.child;
                        continue;
                    }
                    if (a === r) break;
                    for(; a.sibling === null;){
                        if (a.return === null || a.return === r) return;
                        a = a.return;
                    }
                    a.sibling.return = a.return, a = a.sibling;
                }
                else if (Sr) for(var c = r.child; c !== null;){
                    if (c.tag === 5) {
                        var d = c.stateNode;
                        a && l && (d = No(d, c.type, c.memoizedProps)), yc(t, d);
                    } else if (c.tag === 6) d = c.stateNode, a && l && (d = Ls(d, c.memoizedProps)), yc(t, d);
                    else if (c.tag !== 4) {
                        if (c.tag === 22 && c.memoizedState !== null) d = c.child, d !== null && (d.return = c), ef(t, c, !0, !0);
                        else if (c.child !== null) {
                            c.child.return = c, c = c.child;
                            continue;
                        }
                    }
                    if (c === r) break;
                    for(; c.sibling === null;){
                        if (c.return === null || c.return === r) return;
                        c = c.return;
                    }
                    c.sibling.return = c.return, c = c.sibling;
                }
            }
            function Mu(t, r, a, l) {
                var c = !1;
                if (Sr) for(var d = r.child; d !== null;){
                    if (d.tag === 5) {
                        var h = d.stateNode;
                        a && l && (h = No(h, d.type, d.memoizedProps)), Lf(t, h);
                    } else if (d.tag === 6) h = d.stateNode, a && l && (h = Ls(h, d.memoizedProps)), Lf(t, h);
                    else if (d.tag !== 4) {
                        if (d.tag === 22 && d.memoizedState !== null) c = d.child, c !== null && (c.return = d), Mu(t, d, !0, !0), c = !0;
                        else if (d.child !== null) {
                            d.child.return = d, d = d.child;
                            continue;
                        }
                    }
                    if (d === r) break;
                    for(; d.sibling === null;){
                        if (d.return === null || d.return === r) return c;
                        d = d.return;
                    }
                    d.sibling.return = d.return, d = d.sibling;
                }
                return c;
            }
            function Qu(t, r) {
                if (Sr && Ou(t, r)) {
                    t = r.stateNode;
                    var a = t.containerInfo, l = We();
                    Mu(l, r, !1, !1), t.pendingChildren = l, It(r), yh(a, l);
                }
            }
            function ds(t, r, a, l) {
                if ($n) t.memoizedProps !== l && It(r);
                else if (Sr) {
                    var c = t.stateNode, d = t.memoizedProps;
                    if ((t = Ou(t, r)) || d !== l) {
                        var h = Dn.current;
                        d = gh(c, a, d, l, !t, null), d === c ? r.stateNode = c : (cs(r), Kp(d, a, l, h) && It(r), r.stateNode = d, t && ef(d, r, !1, !1));
                    } else r.stateNode = c;
                }
            }
            function Fn(t, r, a, l, c) {
                if ((t.mode & 32) !== 0 && (a === null ? rh(r, l) : Dm(r, a, l))) {
                    if (t.flags |= 16777216, (c & 335544128) === c || Yi(r, l)) {
                        if (An(t.stateNode, r, l)) t.flags |= 8192;
                        else if (Vp()) t.flags |= 8192;
                        else throw Xt = Dc, Ac;
                    }
                } else t.flags &= -16777217;
            }
            function xe(t, r) {
                if (Vm(r)) {
                    if (t.flags |= 16777216, !Tc(r)) {
                        if (Vp()) t.flags |= 8192;
                        else throw Xt = Dc, Ac;
                    }
                } else t.flags &= -16777217;
            }
            function Ba(t, r) {
                r !== null && (t.flags |= 4), t.flags & 16384 && (r = t.tag !== 22 ? Ed() : 536870912, t.lanes |= r, hl |= r);
            }
            function Co(t, r) {
                if (!ue) switch(t.tailMode){
                    case "hidden":
                        r = t.tail;
                        for(var a = null; r !== null;)r.alternate !== null && (a = r), r = r.sibling;
                        a === null ? t.tail = null : a.sibling = null;
                        break;
                    case "collapsed":
                        a = t.tail;
                        for(var l = null; a !== null;)a.alternate !== null && (l = a), a = a.sibling;
                        l === null ? r || t.tail === null ? t.tail = null : t.tail.sibling = null : l.sibling = null;
                }
            }
            function we(t) {
                var r = t.alternate !== null && t.alternate.child === t.child, a = 0, l = 0;
                if (r) for(var c = t.child; c !== null;)a |= c.lanes | c.childLanes, l |= c.subtreeFlags & 65011712, l |= c.flags & 65011712, c.return = t, c = c.sibling;
                else for(c = t.child; c !== null;)a |= c.lanes | c.childLanes, l |= c.subtreeFlags, l |= c.flags, c.return = t, c = c.sibling;
                return t.subtreeFlags |= l, t.childLanes = a, r;
            }
            function Oa(t, r, a) {
                var l = r.pendingProps;
                switch(gu(r), r.tag){
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return we(r), null;
                    case 1:
                        return we(r), null;
                    case 3:
                        return a = r.stateNode, l = null, t !== null && (l = t.memoizedState.cache), r.memoizedState.cache !== l && (r.flags |= 2048), En(qe), Xo(), a.pendingContext && (a.context = a.pendingContext, a.pendingContext = null), (t === null || t.child === null) && (Ti(r) ? It(r) : t === null || t.memoizedState.isDehydrated && (r.flags & 256) === 0 || (r.flags |= 1024, Dl())), Qu(t, r), we(r), null;
                    case 26:
                        if (Gt) {
                            var c = r.type, d = r.memoizedState;
                            return t === null ? (It(r), d !== null ? (we(r), xe(r, d)) : (we(r), Fn(r, c, null, l, a))) : d ? d !== t.memoizedState ? (It(r), we(r), xe(r, d)) : (we(r), r.flags &= -16777217) : (d = t.memoizedProps, $n ? d !== l && It(r) : ds(t, r, c, l), we(r), Fn(r, c, d, l, a)), null;
                        }
                    case 27:
                        if (dn) {
                            if (jl(r), a = pa.current, c = r.type, t !== null && r.stateNode != null) $n ? t.memoizedProps !== l && It(r) : ds(t, r, c, l);
                            else {
                                if (!l) {
                                    if (r.stateNode === null) throw Error(F(166));
                                    return we(r), null;
                                }
                                t = Dn.current, Ti(r) ? Ep(r, t) : (t = _c(c, l, a, t, !0), r.stateNode = t, It(r));
                            }
                            return we(r), null;
                        }
                    case 5:
                        if (jl(r), c = r.type, t !== null && r.stateNode != null) ds(t, r, c, l);
                        else {
                            if (!l) {
                                if (r.stateNode === null) throw Error(F(166));
                                return we(r), null;
                            }
                            if (d = Dn.current, Ti(r)) Ep(r, d), Eh(r.stateNode, c, l, d) && (r.flags |= 64);
                            else {
                                var h = Vr(c, l, pa.current, d, r);
                                cs(r), ef(h, r, !1, !1), r.stateNode = h, Kp(h, c, l, d) && It(r);
                            }
                        }
                        return we(r), Fn(r, r.type, t === null ? null : t.memoizedProps, r.pendingProps, a), null;
                    case 6:
                        if (t && r.stateNode != null) a = t.memoizedProps, $n ? a !== l && It(r) : Sr && (a !== l ? (t = pa.current, a = Dn.current, cs(r), r.stateNode = bc(l, t, a, r)) : r.stateNode = t.stateNode);
                        else {
                            if (typeof l != "string" && r.stateNode === null) throw Error(F(166));
                            if (t = pa.current, a = Dn.current, Ti(r)) {
                                if (!Hn) throw Error(F(176));
                                if (t = r.stateNode, a = r.memoizedProps, l = null, c = bn, c !== null) switch(c.tag){
                                    case 27:
                                    case 5:
                                        l = c.memoizedProps;
                                }
                                xc(t, a, r, l) || ar(r, !0);
                            } else cs(r), r.stateNode = bc(l, t, a, r);
                        }
                        return we(r), null;
                    case 31:
                        if (a = r.memoizedState, t === null || t.memoizedState !== null) {
                            if (l = Ti(r), a !== null) {
                                if (t === null) {
                                    if (!l) throw Error(F(318));
                                    if (!Hn) throw Error(F(556));
                                    if (t = r.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(F(557));
                                    zh(t, r);
                                } else _a(), (r.flags & 128) === 0 && (r.memoizedState = null), r.flags |= 4;
                                we(r), t = !1;
                            } else a = Dl(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = a), t = !0;
                            if (!t) return r.flags & 256 ? (ht(r), r) : (ht(r), null);
                            if ((r.flags & 128) !== 0) throw Error(F(558));
                        }
                        return we(r), null;
                    case 13:
                        if (l = r.memoizedState, t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
                            if (c = Ti(r), l !== null && l.dehydrated !== null) {
                                if (t === null) {
                                    if (!c) throw Error(F(318));
                                    if (!Hn) throw Error(F(344));
                                    if (c = r.memoizedState, c = c !== null ? c.dehydrated : null, !c) throw Error(F(317));
                                    Hf(c, r);
                                } else _a(), (r.flags & 128) === 0 && (r.memoizedState = null), r.flags |= 4;
                                we(r), c = !1;
                            } else c = Dl(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = c), c = !0;
                            if (!c) return r.flags & 256 ? (ht(r), r) : (ht(r), null);
                        }
                        return ht(r), (r.flags & 128) !== 0 ? (r.lanes = a, r) : (a = l !== null, t = t !== null && t.memoizedState !== null, a && (l = r.child, c = null, l.alternate !== null && l.alternate.memoizedState !== null && l.alternate.memoizedState.cachePool !== null && (c = l.alternate.memoizedState.cachePool.pool), d = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (d = l.memoizedState.cachePool.pool), d !== c && (l.flags |= 2048)), a !== t && a && (r.child.flags |= 8192), Ba(r, r.updateQueue), we(r), null);
                    case 4:
                        return Xo(), Qu(t, r), t === null && jm(r.stateNode.containerInfo), we(r), null;
                    case 10:
                        return En(r.type), we(r), null;
                    case 19:
                        if (D(ln), l = r.memoizedState, l === null) return we(r), null;
                        if (c = (r.flags & 128) !== 0, d = l.rendering, d === null) {
                            if (c) Co(l, !1);
                            else {
                                if (Xe !== 0 || t !== null && (t.flags & 128) !== 0) for(t = r.child; t !== null;){
                                    if (d = ko(t), d !== null) {
                                        for(r.flags |= 128, Co(l, !1), t = d.updateQueue, r.updateQueue = t, Ba(r, t), r.subtreeFlags = 0, t = a, a = r.child; a !== null;)yf(a, t), a = a.sibling;
                                        return Ce(ln, ln.current & 1 | 2), ue && or(r, l.treeForkCount), r.child;
                                    }
                                    t = t.sibling;
                                }
                                l.tail !== null && ze() > ml && (r.flags |= 128, c = !0, Co(l, !1), r.lanes = 4194304);
                            }
                        } else {
                            if (!c) {
                                if (t = ko(d), t !== null) {
                                    if (r.flags |= 128, c = !0, t = t.updateQueue, r.updateQueue = t, Ba(r, t), Co(l, !0), l.tail === null && l.tailMode === "hidden" && !d.alternate && !ue) return we(r), null;
                                } else 2 * ze() - l.renderingStartTime > ml && a !== 536870912 && (r.flags |= 128, c = !0, Co(l, !1), r.lanes = 4194304);
                            }
                            l.isBackwards ? (d.sibling = r.child, r.child = d) : (t = l.last, t !== null ? t.sibling = d : r.child = d, l.last = d);
                        }
                        return l.tail !== null ? (t = l.tail, l.rendering = t, l.tail = t.sibling, l.renderingStartTime = ze(), t.sibling = null, a = ln.current, Ce(ln, c ? a & 1 | 2 : a & 1), ue && or(r, l.treeForkCount), t) : (we(r), null);
                    case 22:
                    case 23:
                        return ht(r), bo(), l = r.memoizedState !== null, t !== null ? t.memoizedState !== null !== l && (r.flags |= 8192) : l && (r.flags |= 8192), l ? (a & 536870912) !== 0 && (r.flags & 128) === 0 && (we(r), r.subtreeFlags & 6 && (r.flags |= 8192)) : we(r), a = r.updateQueue, a !== null && Ba(r, a.retryQueue), a = null, t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (a = t.memoizedState.cachePool.pool), l = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (l = r.memoizedState.cachePool.pool), l !== a && (r.flags |= 2048), t !== null && D(ha), null;
                    case 24:
                        return a = null, t !== null && (a = t.memoizedState.cache), r.memoizedState.cache !== a && (r.flags |= 2048), En(qe), we(r), null;
                    case 25:
                        return null;
                    case 30:
                        return null;
                }
                throw Error(F(156, r.tag));
            }
            function gr(t, r) {
                switch(gu(r), r.tag){
                    case 1:
                        return t = r.flags, t & 65536 ? (r.flags = t & -65537 | 128, r) : null;
                    case 3:
                        return En(qe), Xo(), t = r.flags, (t & 65536) !== 0 && (t & 128) === 0 ? (r.flags = t & -65537 | 128, r) : null;
                    case 26:
                    case 27:
                    case 5:
                        return jl(r), null;
                    case 31:
                        if (r.memoizedState !== null) {
                            if (ht(r), r.alternate === null) throw Error(F(340));
                            _a();
                        }
                        return t = r.flags, t & 65536 ? (r.flags = t & -65537 | 128, r) : null;
                    case 13:
                        if (ht(r), t = r.memoizedState, t !== null && t.dehydrated !== null) {
                            if (r.alternate === null) throw Error(F(340));
                            _a();
                        }
                        return t = r.flags, t & 65536 ? (r.flags = t & -65537 | 128, r) : null;
                    case 19:
                        return D(ln), null;
                    case 4:
                        return Xo(), null;
                    case 10:
                        return En(r.type), null;
                    case 22:
                    case 23:
                        return ht(r), bo(), t !== null && D(ha), t = r.flags, t & 65536 ? (r.flags = t & -65537 | 128, r) : null;
                    case 24:
                        return En(qe), null;
                    case 25:
                        return null;
                    default:
                        return null;
                }
            }
            function $u(t, r) {
                switch(gu(r), r.tag){
                    case 3:
                        En(qe), Xo();
                        break;
                    case 26:
                    case 27:
                    case 5:
                        jl(r);
                        break;
                    case 4:
                        Xo();
                        break;
                    case 31:
                        r.memoizedState !== null && ht(r);
                        break;
                    case 13:
                        ht(r);
                        break;
                    case 19:
                        D(ln);
                        break;
                    case 10:
                        En(r.type);
                        break;
                    case 22:
                    case 23:
                        ht(r), bo(), t !== null && D(ha);
                        break;
                    case 24:
                        En(qe);
                }
            }
            function Br(t, r) {
                try {
                    var a = r.updateQueue, l = a !== null ? a.lastEffect : null;
                    if (l !== null) {
                        var c = l.next;
                        a = c;
                        do {
                            if ((a.tag & t) === t) {
                                l = void 0;
                                var d = a.create, h = a.inst;
                                l = d(), h.destroy = l;
                            }
                            a = a.next;
                        }while (a !== c);
                    }
                } catch (y) {
                    ve(r, r.return, y);
                }
            }
            function Or(t, r, a) {
                try {
                    var l = r.updateQueue, c = l !== null ? l.lastEffect : null;
                    if (c !== null) {
                        var d = c.next;
                        l = d;
                        do {
                            if ((l.tag & t) === t) {
                                var h = l.inst, y = h.destroy;
                                if (y !== void 0) {
                                    h.destroy = void 0, c = r;
                                    var R = a, L = y;
                                    try {
                                        L();
                                    } catch (j) {
                                        ve(c, R, j);
                                    }
                                }
                            }
                            l = l.next;
                        }while (l !== d);
                    }
                } catch (j) {
                    ve(r, r.return, j);
                }
            }
            function Qi(t) {
                var r = t.updateQueue;
                if (r !== null) {
                    var a = t.stateNode;
                    try {
                        Fp(r, a);
                    } catch (l) {
                        ve(t, t.return, l);
                    }
                }
            }
            function Vu(t, r, a) {
                a.props = Wr(t.type, t.memoizedProps), a.state = t.memoizedState;
                try {
                    a.componentWillUnmount();
                } catch (l) {
                    ve(t, r, l);
                }
            }
            function ta(t, r) {
                try {
                    var a = t.ref;
                    if (a !== null) {
                        switch(t.tag){
                            case 26:
                            case 27:
                            case 5:
                                var l = Ts(t.stateNode);
                                break;
                            case 30:
                                l = t.stateNode;
                                break;
                            default:
                                l = t.stateNode;
                        }
                        typeof a == "function" ? t.refCleanup = a(l) : a.current = l;
                    }
                } catch (c) {
                    ve(t, r, c);
                }
            }
            function yr(t, r) {
                var a = t.ref, l = t.refCleanup;
                if (a !== null) {
                    if (typeof l == "function") try {
                        l();
                    } catch (c) {
                        ve(t, r, c);
                    } finally{
                        t.refCleanup = null, t = t.alternate, t != null && (t.refCleanup = null);
                    }
                    else if (typeof a == "function") try {
                        a(null);
                    } catch (c) {
                        ve(t, r, c);
                    }
                    else a.current = null;
                }
            }
            function nf(t) {
                var r = t.type, a = t.memoizedProps, l = t.stateNode;
                try {
                    dh(l, r, a, t);
                } catch (c) {
                    ve(t, t.return, c);
                }
            }
            function qu(t, r, a) {
                try {
                    vc(t.stateNode, t.type, a, r, t);
                } catch (l) {
                    ve(t, t.return, l);
                }
            }
            function tf(t) {
                return t.tag === 5 || t.tag === 3 || (Gt ? t.tag === 26 : !1) || (dn ? t.tag === 27 && Xa(t.type) : !1) || t.tag === 4;
            }
            function Gu(t) {
                e: for(;;){
                    for(; t.sibling === null;){
                        if (t.return === null || tf(t.return)) return null;
                        t = t.return;
                    }
                    for(t.sibling.return = t.return, t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18;){
                        if (dn && t.tag === 27 && Xa(t.type) || t.flags & 2 || t.child === null || t.tag === 4) continue e;
                        t.child.return = t, t = t.child;
                    }
                    if (!(t.flags & 2)) return t.stateNode;
                }
            }
            function fs(t, r, a) {
                var l = t.tag;
                if (l === 5 || l === 6) t = t.stateNode, r ? ph(a, t, r) : ch(a, t);
                else if (l !== 4 && (dn && l === 27 && Xa(t.type) && (a = t.stateNode, r = null), t = t.child, t !== null)) for(fs(t, r, a), t = t.sibling; t !== null;)fs(t, r, a), t = t.sibling;
            }
            function $i(t, r, a) {
                var l = t.tag;
                if (l === 5 || l === 6) t = t.stateNode, r ? fh(a, t, r) : uh(a, t);
                else if (l !== 4 && (dn && l === 27 && Xa(t.type) && (a = t.stateNode), t = t.child, t !== null)) for($i(t, r, a), t = t.sibling; t !== null;)$i(t, r, a), t = t.sibling;
            }
            function Ju(t, r, a) {
                t = t.containerInfo;
                try {
                    bh(t, a);
                } catch (l) {
                    ve(r, r.return, l);
                }
            }
            function rf(t) {
                var r = t.stateNode, a = t.memoizedProps;
                try {
                    Rc(t.type, a, r, t);
                } catch (l) {
                    ve(t, t.return, l);
                }
            }
            function Wp(t, r) {
                for(Am(t.containerInfo), Pn = r; Pn !== null;)if (t = Pn, r = t.child, (t.subtreeFlags & 1028) !== 0 && r !== null) r.return = t, Pn = r;
                else for(; Pn !== null;){
                    t = Pn;
                    var a = t.alternate;
                    switch(r = t.flags, t.tag){
                        case 0:
                            if ((r & 4) !== 0 && (r = t.updateQueue, r = r !== null ? r.events : null, r !== null)) for(var l = 0; l < r.length; l++){
                                var c = r[l];
                                c.ref.impl = c.nextImpl;
                            }
                            break;
                        case 11:
                        case 15:
                            break;
                        case 1:
                            if ((r & 1024) !== 0 && a !== null) {
                                r = void 0, l = t, c = a.memoizedProps, a = a.memoizedState;
                                var d = l.stateNode;
                                try {
                                    var h = Wr(l.type, c);
                                    r = d.getSnapshotBeforeUpdate(h, a), d.__reactInternalSnapshotBeforeUpdate = r;
                                } catch (y) {
                                    ve(l, l.return, y);
                                }
                            }
                            break;
                        case 3:
                            (r & 1024) !== 0 && $n && Nt(t.stateNode.containerInfo);
                            break;
                        case 5:
                        case 26:
                        case 27:
                        case 6:
                        case 4:
                        case 17:
                            break;
                        default:
                            if ((r & 1024) !== 0) throw Error(F(163));
                    }
                    if (r = t.sibling, r !== null) {
                        r.return = t.return, Pn = r;
                        break;
                    }
                    Pn = t.return;
                }
            }
            function of(t, r, a) {
                var l = a.flags;
                switch(a.tag){
                    case 0:
                    case 11:
                    case 15:
                        $t(t, a), l & 4 && Br(5, a);
                        break;
                    case 1:
                        if ($t(t, a), l & 4) {
                            if (t = a.stateNode, r === null) try {
                                t.componentDidMount();
                            } catch (h) {
                                ve(a, a.return, h);
                            }
                            else {
                                var c = Wr(a.type, r.memoizedProps);
                                r = r.memoizedState;
                                try {
                                    t.componentDidUpdate(c, r, t.__reactInternalSnapshotBeforeUpdate);
                                } catch (h) {
                                    ve(a, a.return, h);
                                }
                            }
                        }
                        l & 64 && Qi(a), l & 512 && ta(a, a.return);
                        break;
                    case 3:
                        if ($t(t, a), l & 64 && (l = a.updateQueue, l !== null)) {
                            if (t = null, a.child !== null) switch(a.child.tag){
                                case 27:
                                case 5:
                                    t = Ts(a.child.stateNode);
                                    break;
                                case 1:
                                    t = a.child.stateNode;
                            }
                            try {
                                Fp(l, t);
                            } catch (h) {
                                ve(a, a.return, h);
                            }
                        }
                        break;
                    case 27:
                        dn && r === null && l & 4 && rf(a);
                    case 26:
                    case 5:
                        if ($t(t, a), r === null) {
                            if (l & 4) nf(a);
                            else if (l & 64) {
                                t = a.type, r = a.memoizedProps, c = a.stateNode;
                                try {
                                    _h(c, t, r, a);
                                } catch (h) {
                                    ve(a, a.return, h);
                                }
                            }
                        }
                        l & 512 && ta(a, a.return);
                        break;
                    case 12:
                        $t(t, a);
                        break;
                    case 31:
                        $t(t, a), l & 4 && af(t, a);
                        break;
                    case 13:
                        $t(t, a), l & 4 && Yu(t, a), l & 64 && (l = a.memoizedState, l !== null && (l = l.dehydrated, l !== null && (a = sc.bind(null, a), Xi(l, a))));
                        break;
                    case 22:
                        if (l = a.memoizedState !== null || eo, !l) {
                            r = r !== null && r.memoizedState !== null || sn, c = eo;
                            var d = sn;
                            eo = l, (sn = r) && !d ? br(t, a, (a.subtreeFlags & 8772) !== 0) : $t(t, a), eo = c, sn = d;
                        }
                        break;
                    case 30:
                        break;
                    default:
                        $t(t, a);
                }
            }
            function Up(t) {
                var r = t.alternate;
                r !== null && (t.alternate = null, Up(r)), t.child = null, t.deletions = null, t.sibling = null, t.tag === 5 && (r = t.stateNode, r !== null && th(r)), t.stateNode = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
            }
            function Qt(t, r, a) {
                for(a = a.child; a !== null;)Zu(t, r, a), a = a.sibling;
            }
            function Zu(t, r, a) {
                if (on && typeof on.onCommitFiberUnmount == "function") try {
                    on.onCommitFiberUnmount(ei, a);
                } catch  {}
                switch(a.tag){
                    case 26:
                        if (Gt) {
                            sn || yr(a, r), Qt(t, r, a), a.memoizedState ? Hh(a.memoizedState) : a.stateNode && Wf(a.stateNode);
                            break;
                        }
                    case 27:
                        if (dn) {
                            sn || yr(a, r);
                            var l = mn, c = Pt;
                            Xa(a.type) && (mn = a.stateNode, Pt = !1), Qt(t, r, a), fa(a.stateNode), mn = l, Pt = c;
                            break;
                        }
                    case 5:
                        sn || yr(a, r);
                    case 6:
                        if ($n) {
                            if (l = mn, c = Pt, mn = null, Qt(t, r, a), mn = l, Pt = c, mn !== null) {
                                if (Pt) try {
                                    If(mn, a.stateNode);
                                } catch (d) {
                                    ve(a, r, d);
                                }
                                else try {
                                    Ef(mn, a.stateNode);
                                } catch (d) {
                                    ve(a, r, d);
                                }
                            }
                        } else Qt(t, r, a);
                        break;
                    case 18:
                        $n && mn !== null && (Pt ? Af(mn, a.stateNode) : Se(mn, a.stateNode));
                        break;
                    case 4:
                        $n ? (l = mn, c = Pt, mn = a.stateNode.containerInfo, Pt = !0, Qt(t, r, a), mn = l, Pt = c) : (Sr && Ju(a.stateNode, a, We()), Qt(t, r, a));
                        break;
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        Or(2, a, r), sn || Or(4, a, r), Qt(t, r, a);
                        break;
                    case 1:
                        sn || (yr(a, r), l = a.stateNode, typeof l.componentWillUnmount == "function" && Vu(a, r, l)), Qt(t, r, a);
                        break;
                    case 21:
                        Qt(t, r, a);
                        break;
                    case 22:
                        sn = (l = sn) || a.memoizedState !== null, Qt(t, r, a), sn = l;
                        break;
                    default:
                        Qt(t, r, a);
                }
            }
            function af(t, r) {
                if (Hn && r.memoizedState === null && (t = r.alternate, t !== null && (t = t.memoizedState, t !== null))) {
                    t = t.dehydrated;
                    try {
                        Rh(t);
                    } catch (a) {
                        ve(r, r.return, a);
                    }
                }
            }
            function Yu(t, r) {
                if (Hn && r.memoizedState === null && (t = r.alternate, t !== null && (t = t.memoizedState, t !== null && (t = t.dehydrated, t !== null)))) try {
                    el(t);
                } catch (a) {
                    ve(r, r.return, a);
                }
            }
            function Bp(t) {
                switch(t.tag){
                    case 31:
                    case 13:
                    case 19:
                        var r = t.stateNode;
                        return r === null && (r = t.stateNode = new $c()), r;
                    case 22:
                        return t = t.stateNode, r = t._retryCache, r === null && (r = t._retryCache = new $c()), r;
                    default:
                        throw Error(F(435, t.tag));
                }
            }
            function ps(t, r) {
                var a = Bp(t);
                r.forEach(function(l) {
                    if (!a.has(l)) {
                        a.add(l);
                        var c = Zp.bind(null, t, l);
                        l.then(c, c);
                    }
                });
            }
            function tn(t, r) {
                var a = r.deletions;
                if (a !== null) for(var l = 0; l < a.length; l++){
                    var c = a[l], d = t, h = r;
                    if ($n) {
                        var y = h;
                        e: for(; y !== null;){
                            switch(y.tag){
                                case 27:
                                    if (dn) {
                                        if (Xa(y.type)) {
                                            mn = y.stateNode, Pt = !1;
                                            break e;
                                        }
                                        break;
                                    }
                                case 5:
                                    mn = y.stateNode, Pt = !1;
                                    break e;
                                case 3:
                                case 4:
                                    mn = y.stateNode.containerInfo, Pt = !0;
                                    break e;
                            }
                            y = y.return;
                        }
                        if (mn === null) throw Error(F(160));
                        Zu(d, h, c), mn = null, Pt = !1;
                    } else Zu(d, h, c);
                    d = c.alternate, d !== null && (d.return = null), c.return = null;
                }
                if (r.subtreeFlags & 13886) for(r = r.child; r !== null;)hs(r, t), r = r.sibling;
            }
            function hs(t, r) {
                var a = t.alternate, l = t.flags;
                switch(t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        tn(r, t), Mn(t), l & 4 && (Or(3, t, t.return), Br(3, t), Or(5, t, t.return));
                        break;
                    case 1:
                        tn(r, t), Mn(t), l & 512 && (sn || a === null || yr(a, a.return)), l & 64 && eo && (t = t.updateQueue, t !== null && (l = t.callbacks, l !== null && (a = t.shared.hiddenCallbacks, t.shared.hiddenCallbacks = a === null ? l : a.concat(l))));
                        break;
                    case 26:
                        if (Gt) {
                            var c = Cr;
                            if (tn(r, t), Mn(t), l & 512 && (sn || a === null || yr(a, a.return)), l & 4) {
                                l = a !== null ? a.memoizedState : null;
                                var d = t.memoizedState;
                                a === null ? d === null ? t.stateNode === null ? t.stateNode = Ya(c, t.type, t.memoizedProps, t) : Cc(c, t.type, t.stateNode) : t.stateNode = Fh(c, d, t.memoizedProps) : l !== d ? (l === null ? a.stateNode !== null && Wf(a.stateNode) : Hh(l), d === null ? Cc(c, t.type, t.stateNode) : Fh(c, d, t.memoizedProps)) : d === null && t.stateNode !== null && qu(t, t.memoizedProps, a.memoizedProps);
                            }
                            break;
                        }
                    case 27:
                        if (dn) {
                            tn(r, t), Mn(t), l & 512 && (sn || a === null || yr(a, a.return)), a !== null && l & 4 && qu(t, t.memoizedProps, a.memoizedProps);
                            break;
                        }
                    case 5:
                        if (tn(r, t), Mn(t), l & 512 && (sn || a === null || yr(a, a.return)), $n) {
                            if (t.flags & 32) {
                                c = t.stateNode;
                                try {
                                    Sc(c);
                                } catch (A) {
                                    ve(t, t.return, A);
                                }
                            }
                            l & 4 && t.stateNode != null && (c = t.memoizedProps, qu(t, c, a !== null ? a.memoizedProps : c)), l & 1024 && (Ms = !0);
                        } else Sr && t.alternate !== null && (t.alternate.stateNode = t.stateNode);
                        break;
                    case 6:
                        if (tn(r, t), Mn(t), l & 4 && $n) {
                            if (t.stateNode === null) throw Error(F(162));
                            l = t.memoizedProps, a = a !== null ? a.memoizedProps : l, c = t.stateNode;
                            try {
                                Is(c, a, l);
                            } catch (A) {
                                ve(t, t.return, A);
                            }
                        }
                        break;
                    case 3:
                        if (Gt ? (jh(), c = Cr, Cr = zc(r.containerInfo), tn(r, t), Cr = c) : tn(r, t), Mn(t), l & 4) {
                            if ($n && Hn && a !== null && a.memoizedState.isDehydrated) try {
                                Mm(r.containerInfo);
                            } catch (A) {
                                ve(t, t.return, A);
                            }
                            if (Sr) {
                                l = r.containerInfo, a = r.pendingChildren;
                                try {
                                    bh(l, a);
                                } catch (A) {
                                    ve(t, t.return, A);
                                }
                            }
                        }
                        Ms && (Ms = !1, Op(t));
                        break;
                    case 4:
                        Gt ? (a = Cr, Cr = zc(t.stateNode.containerInfo), tn(r, t), Mn(t), Cr = a) : (tn(r, t), Mn(t)), l & 4 && Sr && Ju(t.stateNode, t, t.stateNode.pendingChildren);
                        break;
                    case 12:
                        tn(r, t), Mn(t);
                        break;
                    case 31:
                        tn(r, t), Mn(t), l & 4 && (l = t.updateQueue, l !== null && (t.updateQueue = null, ps(t, l)));
                        break;
                    case 13:
                        tn(r, t), Mn(t), t.child.flags & 8192 && t.memoizedState !== null != (a !== null && a.memoizedState !== null) && (Vs = ze()), l & 4 && (l = t.updateQueue, l !== null && (t.updateQueue = null, ps(t, l)));
                        break;
                    case 22:
                        c = t.memoizedState !== null;
                        var h = a !== null && a.memoizedState !== null, y = eo, R = sn;
                        if (eo = y || c, sn = R || h, tn(r, t), sn = R, eo = y, Mn(t), l & 8192 && (r = t.stateNode, r._visibility = c ? r._visibility & -2 : r._visibility | 1, c && (a === null || h || eo || sn || Vt(t)), $n)) {
                            e: if (a = null, $n) for(r = t;;){
                                if (r.tag === 5 || Gt && r.tag === 26) {
                                    if (a === null) {
                                        h = a = r;
                                        try {
                                            d = h.stateNode, c ? hh(d) : Wm(h.stateNode, h.memoizedProps);
                                        } catch (A) {
                                            ve(h, h.return, A);
                                        }
                                    }
                                } else if (r.tag === 6) {
                                    if (a === null) {
                                        h = r;
                                        try {
                                            var L = h.stateNode;
                                            c ? kc(L) : mh(L, h.memoizedProps);
                                        } catch (A) {
                                            ve(h, h.return, A);
                                        }
                                    }
                                } else if (r.tag === 18) {
                                    if (a === null) {
                                        h = r;
                                        try {
                                            var j = h.stateNode;
                                            c ? Qm(j) : Lh(h.stateNode);
                                        } catch (A) {
                                            ve(h, h.return, A);
                                        }
                                    }
                                } else if ((r.tag !== 22 && r.tag !== 23 || r.memoizedState === null || r === t) && r.child !== null) {
                                    r.child.return = r, r = r.child;
                                    continue;
                                }
                                if (r === t) break e;
                                for(; r.sibling === null;){
                                    if (r.return === null || r.return === t) break e;
                                    a === r && (a = null), r = r.return;
                                }
                                a === r && (a = null), r.sibling.return = r.return, r = r.sibling;
                            }
                        }
                        l & 4 && (l = t.updateQueue, l !== null && (a = l.retryQueue, a !== null && (l.retryQueue = null, ps(t, a))));
                        break;
                    case 19:
                        tn(r, t), Mn(t), l & 4 && (l = t.updateQueue, l !== null && (t.updateQueue = null, ps(t, l)));
                        break;
                    case 30:
                        break;
                    case 21:
                        break;
                    default:
                        tn(r, t), Mn(t);
                }
            }
            function Mn(t) {
                var r = t.flags;
                if (r & 2) {
                    try {
                        for(var a, l = t.return; l !== null;){
                            if (tf(l)) {
                                a = l;
                                break;
                            }
                            l = l.return;
                        }
                        if ($n) {
                            if (a == null) throw Error(F(160));
                            switch(a.tag){
                                case 27:
                                    if (dn) {
                                        var c = a.stateNode, d = Gu(t);
                                        $i(t, d, c);
                                        break;
                                    }
                                case 5:
                                    var h = a.stateNode;
                                    a.flags & 32 && (Sc(h), a.flags &= -33);
                                    var y = Gu(t);
                                    $i(t, y, h);
                                    break;
                                case 3:
                                case 4:
                                    var R = a.stateNode.containerInfo, L = Gu(t);
                                    fs(t, L, R);
                                    break;
                                default:
                                    throw Error(F(161));
                            }
                        }
                    } catch (j) {
                        ve(t, t.return, j);
                    }
                    t.flags &= -3;
                }
                r & 4096 && (t.flags &= -4097);
            }
            function Op(t) {
                if (t.subtreeFlags & 1024) for(t = t.child; t !== null;){
                    var r = t;
                    Op(r), r.tag === 5 && r.flags & 1024 && qa(r.stateNode), t = t.sibling;
                }
            }
            function $t(t, r) {
                if (r.subtreeFlags & 8772) for(r = r.child; r !== null;)of(t, r.alternate, r), r = r.sibling;
            }
            function Vt(t) {
                for(t = t.child; t !== null;){
                    var r = t;
                    switch(r.tag){
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            Or(4, r, r.return), Vt(r);
                            break;
                        case 1:
                            yr(r, r.return);
                            var a = r.stateNode;
                            typeof a.componentWillUnmount == "function" && Vu(r, r.return, a), Vt(r);
                            break;
                        case 27:
                            dn && fa(r.stateNode);
                        case 26:
                        case 5:
                            yr(r, r.return), Vt(r);
                            break;
                        case 22:
                            r.memoizedState === null && Vt(r);
                            break;
                        case 30:
                            Vt(r);
                            break;
                        default:
                            Vt(r);
                    }
                    t = t.sibling;
                }
            }
            function br(t, r, a) {
                for(a = a && (r.subtreeFlags & 8772) !== 0, r = r.child; r !== null;){
                    var l = r.alternate, c = t, d = r, h = d.flags;
                    switch(d.tag){
                        case 0:
                        case 11:
                        case 15:
                            br(c, d, a), Br(4, d);
                            break;
                        case 1:
                            if (br(c, d, a), l = d, c = l.stateNode, typeof c.componentDidMount == "function") try {
                                c.componentDidMount();
                            } catch (L) {
                                ve(l, l.return, L);
                            }
                            if (l = d, c = l.updateQueue, c !== null) {
                                var y = l.stateNode;
                                try {
                                    var R = c.shared.hiddenCallbacks;
                                    if (R !== null) for(c.shared.hiddenCallbacks = null, c = 0; c < R.length; c++)Dd(R[c], y);
                                } catch (L) {
                                    ve(l, l.return, L);
                                }
                            }
                            a && h & 64 && Qi(d), ta(d, d.return);
                            break;
                        case 27:
                            dn && rf(d);
                        case 26:
                        case 5:
                            br(c, d, a), a && l === null && h & 4 && nf(d), ta(d, d.return);
                            break;
                        case 12:
                            br(c, d, a);
                            break;
                        case 31:
                            br(c, d, a), a && h & 4 && af(c, d);
                            break;
                        case 13:
                            br(c, d, a), a && h & 4 && Yu(c, d);
                            break;
                        case 22:
                            d.memoizedState === null && br(c, d, a), ta(d, d.return);
                            break;
                        case 30:
                            break;
                        default:
                            br(c, d, a);
                    }
                    r = r.sibling;
                }
            }
            function To(t, r) {
                var a = null;
                t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (a = t.memoizedState.cachePool.pool), t = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (t = r.memoizedState.cachePool.pool), t !== a && (t != null && t.refCount++, a != null && Ra(a));
            }
            function Qn(t, r) {
                t = null, r.alternate !== null && (t = r.alternate.memoizedState.cache), r = r.memoizedState.cache, r !== t && (r.refCount++, t != null && Ra(t));
            }
            function yt(t, r, a, l) {
                if (r.subtreeFlags & 10256) for(r = r.child; r !== null;)Mp(t, r, a, l), r = r.sibling;
            }
            function Mp(t, r, a, l) {
                var c = r.flags;
                switch(r.tag){
                    case 0:
                    case 11:
                    case 15:
                        yt(t, r, a, l), c & 2048 && Br(9, r);
                        break;
                    case 1:
                        yt(t, r, a, l);
                        break;
                    case 3:
                        yt(t, r, a, l), c & 2048 && (t = null, r.alternate !== null && (t = r.alternate.memoizedState.cache), r = r.memoizedState.cache, r !== t && (r.refCount++, t != null && Ra(t)));
                        break;
                    case 12:
                        if (c & 2048) {
                            yt(t, r, a, l), t = r.stateNode;
                            try {
                                var d = r.memoizedProps, h = d.id, y = d.onPostCommit;
                                typeof y == "function" && y(h, r.alternate === null ? "mount" : "update", t.passiveEffectDuration, -0);
                            } catch (R) {
                                ve(r, r.return, R);
                            }
                        } else yt(t, r, a, l);
                        break;
                    case 31:
                        yt(t, r, a, l);
                        break;
                    case 13:
                        yt(t, r, a, l);
                        break;
                    case 23:
                        break;
                    case 22:
                        d = r.stateNode, h = r.alternate, r.memoizedState !== null ? d._visibility & 2 ? yt(t, r, a, l) : oa(t, r) : d._visibility & 2 ? yt(t, r, a, l) : (d._visibility |= 2, ra(t, r, a, l, (r.subtreeFlags & 10256) !== 0 || !1)), c & 2048 && To(h, r);
                        break;
                    case 24:
                        yt(t, r, a, l), c & 2048 && Qn(r.alternate, r);
                        break;
                    default:
                        yt(t, r, a, l);
                }
            }
            function ra(t, r, a, l, c) {
                for(c = c && ((r.subtreeFlags & 10256) !== 0 || !1), r = r.child; r !== null;){
                    var d = t, h = r, y = a, R = l, L = h.flags;
                    switch(h.tag){
                        case 0:
                        case 11:
                        case 15:
                            ra(d, h, y, R, c), Br(8, h);
                            break;
                        case 23:
                            break;
                        case 22:
                            var j = h.stateNode;
                            h.memoizedState !== null ? j._visibility & 2 ? ra(d, h, y, R, c) : oa(d, h) : (j._visibility |= 2, ra(d, h, y, R, c)), c && L & 2048 && To(h.alternate, h);
                            break;
                        case 24:
                            ra(d, h, y, R, c), c && L & 2048 && Qn(h.alternate, h);
                            break;
                        default:
                            ra(d, h, y, R, c);
                    }
                    r = r.sibling;
                }
            }
            function oa(t, r) {
                if (r.subtreeFlags & 10256) for(r = r.child; r !== null;){
                    var a = t, l = r, c = l.flags;
                    switch(l.tag){
                        case 22:
                            oa(a, l), c & 2048 && To(l.alternate, l);
                            break;
                        case 24:
                            oa(a, l), c & 2048 && Qn(l.alternate, l);
                            break;
                        default:
                            oa(a, l);
                    }
                    r = r.sibling;
                }
            }
            function _o(t, r, a) {
                if (t.subtreeFlags & ga) for(t = t.child; t !== null;)lf(t, r, a), t = t.sibling;
            }
            function lf(t, r, a) {
                switch(t.tag){
                    case 26:
                        if (_o(t, r, a), t.flags & ga) {
                            if (t.memoizedState !== null) Fo(a, Cr, t.memoizedState, t.memoizedProps);
                            else {
                                var l = t.stateNode, c = t.type;
                                t = t.memoizedProps, ((r & 335544128) === r || Yi(c, t)) && Vn(a, l, c, t);
                            }
                        }
                        break;
                    case 5:
                        _o(t, r, a), t.flags & ga && (l = t.stateNode, c = t.type, t = t.memoizedProps, ((r & 335544128) === r || Yi(c, t)) && Vn(a, l, c, t));
                        break;
                    case 3:
                    case 4:
                        Gt ? (l = Cr, Cr = zc(t.stateNode.containerInfo), _o(t, r, a), Cr = l) : _o(t, r, a);
                        break;
                    case 22:
                        t.memoizedState === null && (l = t.alternate, l !== null && l.memoizedState !== null ? (l = ga, ga = 16777216, _o(t, r, a), ga = l) : _o(t, r, a));
                        break;
                    default:
                        _o(t, r, a);
                }
            }
            function Xu(t) {
                var r = t.alternate;
                if (r !== null && (t = r.child, t !== null)) {
                    r.child = null;
                    do r = t.sibling, t.sibling = null, t = r;
                    while (t !== null);
                }
            }
            function aa(t) {
                var r = t.deletions;
                if ((t.flags & 16) !== 0) {
                    if (r !== null) for(var a = 0; a < r.length; a++){
                        var l = r[a];
                        Pn = l, ec(l, t);
                    }
                    Xu(t);
                }
                if (t.subtreeFlags & 10256) for(t = t.child; t !== null;)Ku(t), t = t.sibling;
            }
            function Ku(t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 15:
                        aa(t), t.flags & 2048 && Or(9, t, t.return);
                        break;
                    case 3:
                        aa(t);
                        break;
                    case 12:
                        aa(t);
                        break;
                    case 22:
                        var r = t.stateNode;
                        t.memoizedState !== null && r._visibility & 2 && (t.return === null || t.return.tag !== 13) ? (r._visibility &= -3, Ma(t)) : aa(t);
                        break;
                    default:
                        aa(t);
                }
            }
            function Ma(t) {
                var r = t.deletions;
                if ((t.flags & 16) !== 0) {
                    if (r !== null) for(var a = 0; a < r.length; a++){
                        var l = r[a];
                        Pn = l, ec(l, t);
                    }
                    Xu(t);
                }
                for(t = t.child; t !== null;){
                    switch(r = t, r.tag){
                        case 0:
                        case 11:
                        case 15:
                            Or(8, r, r.return), Ma(r);
                            break;
                        case 22:
                            a = r.stateNode, a._visibility & 2 && (a._visibility &= -3, Ma(r));
                            break;
                        default:
                            Ma(r);
                    }
                    t = t.sibling;
                }
            }
            function ec(t, r) {
                for(; Pn !== null;){
                    var a = Pn;
                    switch(a.tag){
                        case 0:
                        case 11:
                        case 15:
                            Or(8, a, r);
                            break;
                        case 23:
                        case 22:
                            if (a.memoizedState !== null && a.memoizedState.cachePool !== null) {
                                var l = a.memoizedState.cachePool.pool;
                                l != null && l.refCount++;
                            }
                            break;
                        case 24:
                            Ra(a.memoizedState.cache);
                    }
                    if (l = a.child, l !== null) l.return = a, Pn = l;
                    else e: for(a = t; Pn !== null;){
                        l = Pn;
                        var c = l.sibling, d = l.return;
                        if (Up(l), l === a) {
                            Pn = null;
                            break e;
                        }
                        if (c !== null) {
                            c.return = d, Pn = c;
                            break e;
                        }
                        Pn = d;
                    }
                }
            }
            function Vi(t) {
                var r = nh(t);
                if (r != null) {
                    if (typeof r.memoizedProps["data-testname"] != "string") throw Error(F(364));
                    return r;
                }
                if (t = Rf(t), t === null) throw Error(F(362));
                return t.stateNode.current;
            }
            function ms(t, r) {
                var a = t.tag;
                switch(r.$$typeof){
                    case Vc:
                        if (t.type === r.value) return !0;
                        break;
                    case qc:
                        e: {
                            for(r = r.value, t = [
                                t,
                                0
                            ], a = 0; a < t.length;){
                                var l = t[a++], c = l.tag, d = t[a++], h = r[d];
                                if (c !== 5 && c !== 26 && c !== 27 || !Jr(l)) {
                                    for(; h != null && ms(l, h);)d++, h = r[d];
                                    if (d === r.length) {
                                        r = !0;
                                        break e;
                                    } else for(l = l.child; l !== null;)t.push(l, d), l = l.sibling;
                                }
                            }
                            r = !1;
                        }
                        return r;
                    case Gc:
                        if ((a === 5 || a === 26 || a === 27) && sh(t.stateNode, r.value)) return !0;
                        break;
                    case Zc:
                        if ((a === 5 || a === 6 || a === 26 || a === 27) && (t = lh(t), t !== null && 0 <= t.indexOf(r.value))) return !0;
                        break;
                    case Jc:
                        if ((a === 5 || a === 26 || a === 27) && (t = t.memoizedProps["data-testname"], typeof t == "string" && t.toLowerCase() === r.value.toLowerCase())) return !0;
                        break;
                    default:
                        throw Error(F(365));
                }
                return !1;
            }
            function nc(t) {
                switch(t.$$typeof){
                    case Vc:
                        return "<" + (hu(t.value) || "Unknown") + ">";
                    case qc:
                        return ":has(" + (nc(t) || "") + ")";
                    case Gc:
                        return '[role="' + t.value + '"]';
                    case Zc:
                        return '"' + t.value + '"';
                    case Jc:
                        return '[data-testname="' + t.value + '"]';
                    default:
                        throw Error(F(365));
                }
            }
            function sf(t, r) {
                var a = [];
                t = [
                    t,
                    0
                ];
                for(var l = 0; l < t.length;){
                    var c = t[l++], d = c.tag, h = t[l++], y = r[h];
                    if (d !== 5 && d !== 26 && d !== 27 || !Jr(c)) {
                        for(; y != null && ms(c, y);)h++, y = r[h];
                        if (h === r.length) a.push(c);
                        else for(c = c.child; c !== null;)t.push(c, h), c = c.sibling;
                    }
                }
                return a;
            }
            function gs(t, r) {
                if (!Ga) throw Error(F(363));
                t = Vi(t), t = sf(t, r), r = [], t = Array.from(t);
                for(var a = 0; a < t.length;){
                    var l = t[a++], c = l.tag;
                    if (c === 5 || c === 26 || c === 27) Jr(l) || r.push(l.stateNode);
                    else for(l = l.child; l !== null;)t.push(l), l = l.sibling;
                }
                return r;
            }
            function bt() {
                return (ce & 2) !== 0 && he !== 0 ? he & -he : M.T !== null ? ku() : kr();
            }
            function ys() {
                if (At === 0) {
                    if ((he & 536870912) === 0 || ue) {
                        var t = js;
                        js <<= 1, (js & 3932160) === 0 && (js = 262144), At = t;
                    } else At = 536870912;
                }
                return t = Ft.current, t !== null && (t.flags |= 32), At;
            }
            function nt(t, r, a) {
                (t === Ne && (_e === 2 || _e === 9) || t.cancelPendingCommit !== null) && (la(t, 0), Ro(t, he, At, !1)), xi(t, a), ((ce & 2) === 0 || t !== Ne) && (t === Ne && ((ce & 2) === 0 && (ii |= a), Xe === 4 && Ro(t, he, At, !1)), ir(t));
            }
            function uf(t, r, a) {
                if ((ce & 6) !== 0) throw Error(F(327));
                var l = !a && (r & 127) === 0 && (r & t.expiredLanes) === 0 || Pi(t, r), c = l ? Gp(t, r) : Ji(t, r, !0), d = l;
                do {
                    if (c === 0) {
                        ai && !l && Ro(t, r, 0, !1);
                        break;
                    } else {
                        if (a = t.current.alternate, d && !Qp(a)) {
                            c = Ji(t, r, !1), d = !1;
                            continue;
                        }
                        if (c === 2) {
                            if (d = r, t.errorRecoveryDisabledLanes & d) var h = 0;
                            else h = t.pendingLanes & -536870913, h = h !== 0 ? h : h & 536870912 ? 536870912 : 0;
                            if (h !== 0) {
                                r = h;
                                e: {
                                    var y = t;
                                    c = $s;
                                    var R = Hn && y.current.memoizedState.isDehydrated;
                                    if (R && (la(y, h).flags |= 256), h = Ji(y, h, !1), h !== 2) {
                                        if (Gf && !R) {
                                            y.errorRecoveryDisabledLanes |= d, ii |= d, c = 4;
                                            break e;
                                        }
                                        d = xt, xt = c, d !== null && (xt === null ? xt = d : xt.push.apply(xt, d));
                                    }
                                    c = h;
                                }
                                if (d = !1, c !== 2) continue;
                            }
                        }
                        if (c === 1) {
                            la(t, 0), Ro(t, r, 0, !0);
                            break;
                        }
                        e: {
                            switch(l = t, d = c, d){
                                case 0:
                                case 1:
                                    throw Error(F(345));
                                case 4:
                                    if ((r & 4194048) !== r) break;
                                case 6:
                                    Ro(l, r, At, !ya);
                                    break e;
                                case 2:
                                    xt = null;
                                    break;
                                case 3:
                                case 5:
                                    break;
                                default:
                                    throw Error(F(329));
                            }
                            if ((r & 62914560) === r && (c = Vs + 300 - ze(), 10 < c)) {
                                if (Ro(l, r, At, !ya), Lr(l, 0, !0) !== 0) break e;
                                no = r, l.timeoutHandle = eh(tc.bind(null, l, a, xt, Xc, Yc, r, At, ii, hl, ya, d, "Throttled", -0, 0), c);
                                break e;
                            }
                            tc(l, a, xt, Xc, Yc, r, At, ii, hl, ya, d, null, -0, 0);
                        }
                    }
                    break;
                }while (!0);
                ir(t);
            }
            function tc(t, r, a, l, c, d, h, y, R, L, j, A, W, V) {
                if (t.timeoutHandle = Lo, A = r.subtreeFlags, A & 8192 || (A & 16785408) === 16785408) {
                    A = oh(), lf(r, d, A);
                    var Oe = (d & 62914560) === d ? Vs - ze() : (d & 4194048) === d ? Zf - ze() : 0;
                    if (Oe = ah(A, Oe), Oe !== null) {
                        no = d, t.cancelPendingCommit = Oe(pf.bind(null, t, r, d, a, l, c, h, y, R, j, A, null, W, V)), Ro(t, d, h, !L);
                        return;
                    }
                }
                pf(t, r, d, a, l, c, h, y, R);
            }
            function Qp(t) {
                for(var r = t;;){
                    var a = r.tag;
                    if ((a === 0 || a === 11 || a === 15) && r.flags & 16384 && (a = r.updateQueue, a !== null && (a = a.stores, a !== null))) for(var l = 0; l < a.length; l++){
                        var c = a[l], d = c.getSnapshot;
                        c = c.value;
                        try {
                            if (!jn(d(), c)) return !1;
                        } catch  {
                            return !1;
                        }
                    }
                    if (a = r.child, r.subtreeFlags & 16384 && a !== null) a.return = r, r = a;
                    else {
                        if (r === t) break;
                        for(; r.sibling === null;){
                            if (r.return === null || r.return === t) return !0;
                            r = r.return;
                        }
                        r.sibling.return = r.return, r = r.sibling;
                    }
                }
                return !0;
            }
            function Ro(t, r, a, l) {
                r &= ~Jf, r &= ~ii, t.suspendedLanes |= r, t.pingedLanes &= ~r, l && (t.warmLanes |= r), l = t.expirationTimes;
                for(var c = r; 0 < c;){
                    var d = 31 - vt(c), h = 1 << d;
                    l[d] = -1, c &= ~h;
                }
                a !== 0 && Yo(t, a, r);
            }
            function ia() {
                return (ce & 6) === 0 ? (Ea(0, !1), !1) : !0;
            }
            function bs() {
                if (de !== null) {
                    if (_e === 0) var t = de.return;
                    else t = de, Be = at = null, Vl(t), Kt = null, Bs = 0, t = de;
                    for(; t !== null;)$u(t.alternate, t), t = t.return;
                    de = null;
                }
            }
            function la(t, r) {
                var a = t.timeoutHandle;
                a !== Lo && (t.timeoutHandle = Lo, Tf(a)), a = t.cancelPendingCommit, a !== null && (t.cancelPendingCommit = null, a()), no = 0, bs(), Ne = t, de = a = Qr(t.current, null), he = r, _e = 0, Ht = null, ya = !1, ai = Pi(t, r), Gf = !1, hl = At = Jf = ii = ba = Xe = 0, xt = $s = null, Yc = !1, (r & 8) !== 0 && (r |= r & 32);
                var l = t.entangledLanes;
                if (l !== 0) for(t = t.entanglements, l &= r; 0 < l;){
                    var c = 31 - vt(l), d = 1 << c;
                    r |= t[c], l &= ~d;
                }
                return Uo = r, Bn(), a;
            }
            function $p(t, r) {
                ne = null, M.H = Os, r === cl || r === jc ? (r = Bl(), _e = 3) : r === Ac ? (r = Bl(), _e = 4) : _e = r === Mc ? 8 : r !== null && typeof r == "object" && typeof r.then == "function" ? 6 : 1, Ht = r, de === null && (Xe = 1, rs(t, ut(r, t.current)));
            }
            function Vp() {
                var t = Ft.current;
                return t === null ? !0 : (he & 4194048) === he ? zr === null : (he & 62914560) === he || (he & 536870912) !== 0 ? t === zr : !1;
            }
            function cf() {
                var t = M.H;
                return M.H = Os, t === null ? Os : t;
            }
            function qi() {
                var t = M.A;
                return M.A = Zm, t;
            }
            function Gi() {
                Xe = 4, ya || (he & 4194048) !== he && Ft.current !== null || (ai = !0), (ba & 134217727) === 0 && (ii & 134217727) === 0 || Ne === null || Ro(Ne, he, At, !1);
            }
            function Ji(t, r, a) {
                var l = ce;
                ce |= 2;
                var c = cf(), d = qi();
                (Ne !== t || he !== r) && (Xc = null, la(t, r)), r = !1;
                var h = Xe;
                e: do try {
                    if (_e !== 0 && de !== null) {
                        var y = de, R = Ht;
                        switch(_e){
                            case 8:
                                bs(), h = 6;
                                break e;
                            case 3:
                            case 2:
                            case 9:
                            case 6:
                                Ft.current === null && (r = !0);
                                var L = _e;
                                if (_e = 0, Ht = null, Qa(t, y, R, L), a && ai) {
                                    h = 0;
                                    break e;
                                }
                                break;
                            default:
                                L = _e, _e = 0, Ht = null, Qa(t, y, R, L);
                        }
                    }
                    qp(), h = Xe;
                    break;
                } catch (j) {
                    $p(t, j);
                }
                while (!0);
                return r && t.shellSuspendCounter++, Be = at = null, ce = l, M.H = c, M.A = d, de === null && (Ne = null, he = 0, Bn()), h;
            }
            function qp() {
                for(; de !== null;)rc(de);
            }
            function Gp(t, r) {
                var a = ce;
                ce |= 2;
                var l = cf(), c = qi();
                Ne !== t || he !== r ? (Xc = null, ml = ze() + 500, la(t, r)) : ai = Pi(t, r);
                e: do try {
                    if (_e !== 0 && de !== null) {
                        r = de;
                        var d = Ht;
                        n: switch(_e){
                            case 1:
                                _e = 0, Ht = null, Qa(t, r, d, 1);
                                break;
                            case 2:
                            case 9:
                                if (Hd(d)) {
                                    _e = 0, Ht = null, ff(r);
                                    break;
                                }
                                r = function() {
                                    _e !== 2 && _e !== 9 || Ne !== t || (_e = 7), ir(t);
                                }, d.then(r, r);
                                break e;
                            case 3:
                                _e = 7;
                                break e;
                            case 4:
                                _e = 5;
                                break e;
                            case 7:
                                Hd(d) ? (_e = 0, Ht = null, ff(r)) : (_e = 0, Ht = null, Qa(t, r, d, 7));
                                break;
                            case 5:
                                var h = null;
                                switch(de.tag){
                                    case 26:
                                        h = de.memoizedState;
                                    case 5:
                                    case 27:
                                        var y = de, R = y.type, L = y.pendingProps;
                                        if (h ? Tc(h) : An(y.stateNode, R, L)) {
                                            _e = 0, Ht = null;
                                            var j = y.sibling;
                                            if (j !== null) de = j;
                                            else {
                                                var A = y.return;
                                                A !== null ? (de = A, Mr(A)) : de = null;
                                            }
                                            break n;
                                        }
                                }
                                _e = 0, Ht = null, Qa(t, r, d, 5);
                                break;
                            case 6:
                                _e = 0, Ht = null, Qa(t, r, d, 6);
                                break;
                            case 8:
                                bs(), Xe = 6;
                                break e;
                            default:
                                throw Error(F(462));
                        }
                    }
                    df();
                    break;
                } catch (W) {
                    $p(t, W);
                }
                while (!0);
                return Be = at = null, M.H = l, M.A = c, ce = a, de !== null ? 0 : (Ne = null, he = 0, Bn(), Xe);
            }
            function df() {
                for(; de !== null && !qm();)rc(de);
            }
            function rc(t) {
                var r = Bu(t.alternate, t, Uo);
                t.memoizedProps = t.pendingProps, r === null ? Mr(t) : de = r;
            }
            function ff(t) {
                var r = t, a = r.alternate;
                switch(r.tag){
                    case 15:
                    case 0:
                        r = Xd(a, r, r.pendingProps, r.type, void 0, he);
                        break;
                    case 11:
                        r = Xd(a, r, r.pendingProps, r.type.render, r.ref, he);
                        break;
                    case 5:
                        Vl(r);
                    default:
                        $u(a, r), r = de = yf(r, Uo), r = Bu(a, r, Uo);
                }
                t.memoizedProps = t.pendingProps, r === null ? Mr(t) : de = r;
            }
            function Qa(t, r, a, l) {
                Be = at = null, Vl(r), Kt = null, Bs = 0;
                var c = r.return;
                try {
                    if (On(t, c, r, a, he)) {
                        Xe = 1, rs(t, ut(a, t.current)), de = null;
                        return;
                    }
                } catch (d) {
                    if (c !== null) throw de = c, d;
                    Xe = 1, rs(t, ut(a, t.current)), de = null;
                    return;
                }
                r.flags & 32768 ? (ue || l === 1 ? t = !0 : ai || (he & 536870912) !== 0 ? t = !1 : (ya = t = !0, (l === 2 || l === 9 || l === 3 || l === 6) && (l = Ft.current, l !== null && l.tag === 13 && (l.flags |= 16384))), vs(r, t)) : Mr(r);
            }
            function Mr(t) {
                var r = t;
                do {
                    if ((r.flags & 32768) !== 0) {
                        vs(r, ya);
                        return;
                    }
                    t = r.return;
                    var a = Oa(r.alternate, r, Uo);
                    if (a !== null) {
                        de = a;
                        return;
                    }
                    if (r = r.sibling, r !== null) {
                        de = r;
                        return;
                    }
                    de = r = t;
                }while (r !== null);
                Xe === 0 && (Xe = 5);
            }
            function vs(t, r) {
                do {
                    var a = gr(t.alternate, t);
                    if (a !== null) {
                        a.flags &= 32767, de = a;
                        return;
                    }
                    if (a = t.return, a !== null && (a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null), !r && (t = t.sibling, t !== null)) {
                        de = t;
                        return;
                    }
                    de = t = a;
                }while (t !== null);
                Xe = 6, de = null;
            }
            function pf(t, r, a, l, c, d, h, y, R) {
                t.cancelPendingCommit = null;
                do rn();
                while (Re !== 0);
                if ((ce & 6) !== 0) throw Error(F(327));
                if (r !== null) {
                    if (r === t.current) throw Error(F(177));
                    if (d = r.lanes | r.childLanes, d |= $f, _p(t, a, d, h, y, R), t === Ne && (de = Ne = null, he = 0), Sa = r, Bo = t, no = a, Kc = d, ed = c, $h = l, (r.subtreeFlags & 10256) !== 0 || (r.flags & 10256) !== 0 ? (t.callbackNode = null, t.callbackPriority = 0, Nm(Ao, function() {
                        return hf(), null;
                    })) : (t.callbackNode = null, t.callbackPriority = 0), l = (r.flags & 13878) !== 0, (r.subtreeFlags & 13878) !== 0 || l) {
                        l = M.T, M.T = null, c = qr(), yn(2), h = ce, ce |= 4;
                        try {
                            Wp(t, r, a);
                        } finally{
                            ce = h, yn(c), M.T = l;
                        }
                    }
                    Re = 1, oc(), ac(), ic();
                }
            }
            function oc() {
                if (Re === 1) {
                    Re = 0;
                    var t = Bo, r = Sa, a = (r.flags & 13878) !== 0;
                    if ((r.subtreeFlags & 13878) !== 0 || a) {
                        a = M.T, M.T = null;
                        var l = qr();
                        yn(2);
                        var c = ce;
                        ce |= 4;
                        try {
                            hs(r, t), _s(t.containerInfo);
                        } finally{
                            ce = c, yn(l), M.T = a;
                        }
                    }
                    t.current = r, Re = 2;
                }
            }
            function ac() {
                if (Re === 2) {
                    Re = 0;
                    var t = Bo, r = Sa, a = (r.flags & 8772) !== 0;
                    if ((r.subtreeFlags & 8772) !== 0 || a) {
                        a = M.T, M.T = null;
                        var l = qr();
                        yn(2);
                        var c = ce;
                        ce |= 4;
                        try {
                            of(t, r.alternate, r);
                        } finally{
                            ce = c, yn(l), M.T = a;
                        }
                    }
                    Re = 3;
                }
            }
            function ic() {
                if (Re === 4 || Re === 3) {
                    Re = 0, St();
                    var t = Bo, r = Sa, a = no, l = $h;
                    (r.subtreeFlags & 10256) !== 0 || (r.flags & 10256) !== 0 ? Re = 5 : (Re = 0, Sa = Bo = null, Jp(t, t.pendingLanes));
                    var c = t.pendingLanes;
                    if (c === 0 && (va = null), Ze(a), r = r.stateNode, on && typeof on.onCommitFiberRoot == "function") try {
                        on.onCommitFiberRoot(ei, r, void 0, (r.current.flags & 128) === 128);
                    } catch  {}
                    if (l !== null) {
                        r = M.T, c = qr(), yn(2), M.T = null;
                        try {
                            for(var d = t.onRecoverableError, h = 0; h < l.length; h++){
                                var y = l[h];
                                d(y.value, {
                                    componentStack: y.stack
                                });
                            }
                        } finally{
                            M.T = r, yn(c);
                        }
                    }
                    (no & 3) !== 0 && rn(), ir(t), c = t.pendingLanes, (a & 261930) !== 0 && (c & 42) !== 0 ? t === nd ? gl++ : (gl = 0, nd = t) : gl = 0, Hn && Ih(), Ea(0, !1);
                }
            }
            function Jp(t, r) {
                (t.pooledCacheLanes &= r) === 0 && (r = t.pooledCache, r != null && (t.pooledCache = null, Ra(r)));
            }
            function rn() {
                return oc(), ac(), ic(), hf();
            }
            function hf() {
                if (Re !== 5) return !1;
                var t = Bo, r = Kc;
                Kc = 0;
                var a = Ze(no), l = 32 > a ? 32 : a;
                a = M.T;
                var c = qr();
                try {
                    yn(l), M.T = null, l = ed, ed = null;
                    var d = Bo, h = no;
                    if (Re = 0, Sa = Bo = null, no = 0, (ce & 6) !== 0) throw Error(F(331));
                    var y = ce;
                    if (ce |= 4, Ku(d.current), Mp(d, d.current, h, l), ce = y, Ea(0, !1), on && typeof on.onPostCommitFiberRoot == "function") try {
                        on.onPostCommitFiberRoot(ei, d);
                    } catch  {}
                    return !0;
                } finally{
                    yn(c), M.T = a, Jp(t, r);
                }
            }
            function mf(t, r, a) {
                r = ut(a, r), r = Ui(t.stateNode, r, 2), t = Nr(t, r, 2), t !== null && (xi(t, 2), ir(t));
            }
            function ve(t, r, a) {
                if (t.tag === 3) mf(t, t, a);
                else for(; r !== null;){
                    if (r.tag === 3) {
                        mf(r, t, a);
                        break;
                    } else if (r.tag === 1) {
                        var l = r.stateNode;
                        if (typeof r.type.getDerivedStateFromError == "function" || typeof l.componentDidCatch == "function" && (va === null || !va.has(l))) {
                            t = ut(a, t), a = os(2), l = Nr(r, a, 2), l !== null && (Hu(a, l, r, t), xi(l, 2), ir(l));
                            break;
                        }
                    }
                    r = r.return;
                }
            }
            function lc(t, r, a) {
                var l = t.pingCache;
                if (l === null) {
                    l = t.pingCache = new Ym();
                    var c = new Set();
                    l.set(r, c);
                } else c = l.get(r), c === void 0 && (c = new Set(), l.set(r, c));
                c.has(a) || (Gf = !0, c.add(a), t = Ss.bind(null, t, r, a), r.then(t, t));
            }
            function Ss(t, r, a) {
                var l = t.pingCache;
                l !== null && l.delete(r), t.pingedLanes |= t.suspendedLanes & a, t.warmLanes &= ~a, Ne === t && (he & a) === a && (Xe === 4 || Xe === 3 && (he & 62914560) === he && 300 > ze() - Vs ? (ce & 2) === 0 && la(t, 0) : Jf |= a, hl === he && (hl = 0)), ir(t);
            }
            function gf(t, r) {
                r === 0 && (r = Ed()), t = Ko(t, r), t !== null && (xi(t, r), ir(t));
            }
            function sc(t) {
                var r = t.memoizedState, a = 0;
                r !== null && (a = r.retryLane), gf(t, a);
            }
            function Zp(t, r) {
                var a = 0;
                switch(t.tag){
                    case 31:
                    case 13:
                        var l = t.stateNode, c = t.memoizedState;
                        c !== null && (a = c.retryLane);
                        break;
                    case 19:
                        l = t.stateNode;
                        break;
                    case 22:
                        l = t.stateNode._retryCache;
                        break;
                    default:
                        throw Error(F(314));
                }
                l !== null && l.delete(r), gf(t, a);
            }
            function Nm(t, r) {
                return Ic(t, r);
            }
            function uc(t, r, a, l) {
                this.tag = t, this.key = a, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = r, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = l, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
            }
            function ks(t) {
                return t = t.prototype, !(!t || !t.isReactComponent);
            }
            function Qr(t, r) {
                var a = t.alternate;
                return a === null ? (a = Yn(t.tag, r, t.key, t.mode), a.elementType = t.elementType, a.type = t.type, a.stateNode = t.stateNode, a.alternate = t, t.alternate = a) : (a.pendingProps = r, a.type = t.type, a.flags = 0, a.subtreeFlags = 0, a.deletions = null), a.flags = t.flags & 65011712, a.childLanes = t.childLanes, a.lanes = t.lanes, a.child = t.child, a.memoizedProps = t.memoizedProps, a.memoizedState = t.memoizedState, a.updateQueue = t.updateQueue, r = t.dependencies, a.dependencies = r === null ? null : {
                    lanes: r.lanes,
                    firstContext: r.firstContext
                }, a.sibling = t.sibling, a.index = t.index, a.ref = t.ref, a.refCleanup = t.refCleanup, a;
            }
            function yf(t, r) {
                t.flags &= 65011714;
                var a = t.alternate;
                return a === null ? (t.childLanes = 0, t.lanes = r, t.child = null, t.subtreeFlags = 0, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null) : (t.childLanes = a.childLanes, t.lanes = a.lanes, t.child = a.child, t.subtreeFlags = 0, t.deletions = null, t.memoizedProps = a.memoizedProps, t.memoizedState = a.memoizedState, t.updateQueue = a.updateQueue, t.type = a.type, r = a.dependencies, t.dependencies = r === null ? null : {
                    lanes: r.lanes,
                    firstContext: r.firstContext
                }), t;
            }
            function ws(t, r, a, l, c, d) {
                var h = 0;
                if (l = t, typeof t == "function") ks(t) && (h = 1);
                else if (typeof t == "string") h = Gt && dn ? Df(t, a, Dn.current) ? 26 : Ec(t) ? 27 : 5 : Gt ? Df(t, a, Dn.current) ? 26 : 5 : dn && Ec(t) ? 27 : 5;
                else e: switch(t){
                    case gc:
                        return t = Yn(31, a, r, c), t.elementType = gc, t.lanes = d, t;
                    case $a:
                        return Eo(a.children, c, d, r);
                    case kf:
                        h = 8, c |= 24;
                        break;
                    case Cs:
                        return t = Yn(12, a, r, c | 2), t.elementType = Cs, t.lanes = d, t;
                    case Va:
                        return t = Yn(13, a, r, c), t.elementType = Va, t.lanes = d, t;
                    case Te:
                        return t = Yn(19, a, r, c), t.elementType = Te, t.lanes = d, t;
                    default:
                        if (typeof t == "object" && t !== null) switch(t.$$typeof){
                            case Io:
                                h = 10;
                                break e;
                            case mc:
                                h = 9;
                                break e;
                            case Zi:
                                h = 11;
                                break e;
                            case wf:
                                h = 14;
                                break e;
                            case ua:
                                h = 16, l = null;
                                break e;
                        }
                        h = 29, a = Error(F(130, t === null ? "null" : typeof t, "")), l = null;
                }
                return r = Yn(h, a, r, c), r.elementType = t, r.type = l, r.lanes = d, r;
            }
            function Eo(t, r, a, l) {
                return t = Yn(7, t, l, r), t.lanes = a, t;
            }
            function Ps(t, r, a) {
                return t = Yn(6, t, null, r), t.lanes = a, t;
            }
            function cc(t) {
                var r = Yn(18, null, null, 0);
                return r.stateNode = t, r;
            }
            function dc(t, r, a) {
                return r = Yn(4, t.children !== null ? t.children : [], t.key, r), r.lanes = a, r.stateNode = {
                    containerInfo: t.containerInfo,
                    pendingChildren: null,
                    implementation: t.implementation
                }, r;
            }
            function bf(t, r, a, l, c, d, h, y, R) {
                this.tag = 1, this.containerInfo = t, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = Lo, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = mu(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = mu(0), this.hiddenUpdates = mu(null), this.identifierPrefix = l, this.onUncaughtError = c, this.onCaughtError = d, this.onRecoverableError = h, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = R, this.incompleteTransitions = new Map();
            }
            function xs(t, r, a, l, c, d, h, y, R, L, j, A) {
                return t = new bf(t, r, a, h, R, L, j, A, y), r = 1, d === !0 && (r |= 24), d = Yn(3, null, null, r), t.current = d, d.stateNode = t, r = Fd(), r.refCount++, t.pooledCache = r, r.refCount++, d.memoizedState = {
                    element: l,
                    isDehydrated: a,
                    cache: r
                }, Ol(d), t;
            }
            function fc(t) {
                return t ? (t = Ka, t) : Ka;
            }
            function vf(t) {
                var r = t._reactInternals;
                if (r === void 0) throw typeof t.render == "function" ? Error(F(188)) : (t = Object.keys(t).join(","), Error(F(268, t)));
                return t = fu(r), t = t !== null ? pu(t) : null, t === null ? null : Ts(t.stateNode);
            }
            function pc(t, r, a, l, c, d) {
                c = fc(c), l.context === null ? l.context = c : l.pendingContext = c, l = Et(r), l.payload = {
                    element: a
                }, d = d === void 0 ? null : d, d !== null && (l.callback = d), a = Nr(t, l, r), a !== null && (nt(a, t, r), Ml(a, t, r));
            }
            function Sf(t, r) {
                if (t = t.memoizedState, t !== null && t.dehydrated !== null) {
                    var a = t.retryLane;
                    t.retryLane = a !== 0 && a < r ? a : r;
                }
            }
            function vr(t, r) {
                Sf(t, r), (t = t.alternate) && Sf(t, r);
            }
            var ie = {}, Fm = (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))), tt = (0, (/*@__PURE__*/$parcel$interopDefault($bIbqH))), Lt = Object.assign, hc = Symbol.for("react.element"), zs = Symbol.for("react.transitional.element"), sa = Symbol.for("react.portal"), $a = Symbol.for("react.fragment"), kf = Symbol.for("react.strict_mode"), Cs = Symbol.for("react.profiler"), mc = Symbol.for("react.consumer"), Io = Symbol.for("react.context"), Zi = Symbol.for("react.forward_ref"), Va = Symbol.for("react.suspense"), Te = Symbol.for("react.suspense_list"), wf = Symbol.for("react.memo"), ua = Symbol.for("react.lazy");
            var gc = Symbol.for("react.activity");
            var $r = Symbol.for("react.memo_cache_sentinel");
            var Pf = Symbol.iterator, xf = Symbol.for("react.client.reference"), ca = Array.isArray, M = Fm.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Yp = m.rendererVersion, zf = m.rendererPackageName, Cf = m.extraDevToolsConfig, Ts = m.getPublicInstance, Hm = m.getRootHostContext, Xp = m.getChildHostContext, Am = m.prepareForCommit, _s = m.resetAfterCommit, Vr = m.createInstance;
            m.cloneMutableInstance;
            var yc = m.appendInitialChild, Kp = m.finalizeInitialChildren, Rs = m.shouldSetTextContent, bc = m.createTextInstance;
            m.cloneMutableTextInstance;
            var eh = m.scheduleTimeout, Tf = m.cancelTimeout, Lo = m.noTimeout, qt = m.isPrimaryRenderer;
            m.warnsIfNotActing;
            var $n = m.supportsMutation, Sr = m.supportsPersistence, Hn = m.supportsHydration, nh = m.getInstanceFromNode;
            m.beforeActiveInstanceBlur;
            var jm = m.preparePortalMount;
            m.prepareScopeUpdate, m.getInstanceFromScope;
            var yn = m.setCurrentUpdatePriority, qr = m.getCurrentUpdatePriority, kr = m.resolveUpdatePriority;
            m.trackSchedulerEvent, m.resolveEventType, m.resolveEventTimeStamp;
            var _f = m.shouldAttemptEagerTransition, th = m.detachDeletedInstance;
            m.requestPostPaintCallback;
            var rh = m.maySuspendCommit, Dm = m.maySuspendCommitOnUpdate, Yi = m.maySuspendCommitInSyncRender, An = m.preloadInstance, oh = m.startSuspendingCommit, Vn = m.suspendInstance;
            m.suspendOnActiveViewTransition;
            var ah = m.waitForCommitToBeReady;
            m.getSuspendedCommitReason;
            var rt = m.NotPendingTransition, da = m.HostTransitionContext, qa = m.resetFormInstance;
            m.bindToConsole;
            var ih = m.supportsMicrotasks, Gr = m.scheduleMicrotask, Ga = m.supportsTestSelectors, Rf = m.findFiberRoot, wr = m.getBoundingRect, lh = m.getTextContent, Jr = m.isHiddenSubtree, sh = m.matchAccessibilityRole, Es = m.setFocusIfFocusable, Ja = m.setupIntersectionObserver, uh = m.appendChild, ch = m.appendChildToContainer, Is = m.commitTextUpdate, dh = m.commitMount, vc = m.commitUpdate, fh = m.insertBefore, ph = m.insertInContainerBefore, Ef = m.removeChild, If = m.removeChildFromContainer, Sc = m.resetTextContent, hh = m.hideInstance, kc = m.hideTextInstance, Wm = m.unhideInstance, mh = m.unhideTextInstance;
            m.cancelViewTransitionName, m.cancelRootViewTransitionName, m.restoreRootViewTransitionName, m.cloneRootViewTransitionContainer, m.removeRootViewTransitionClone, m.measureClonedInstance, m.hasInstanceChanged, m.hasInstanceAffectedParent, m.startViewTransition, m.startGestureTransition, m.stopViewTransition, m.getCurrentGestureOffset, m.createViewTransitionInstance;
            var Nt = m.clearContainer;
            m.createFragmentInstance, m.updateFragmentInstanceFiber, m.commitNewChildToFragmentInstance, m.deleteChildFromFragmentInstance;
            var gh = m.cloneInstance, We = m.createContainerChildSet, Lf = m.appendChildToContainerChildSet, yh = m.finalizeContainerChildren, bh = m.replaceContainerChildren, No = m.cloneHiddenInstance, Ls = m.cloneHiddenTextInstance, Ns = m.isSuspenseInstancePending, Fs = m.isSuspenseInstanceFallback, Za = m.getSuspenseInstanceFallbackErrorDetails, Xi = m.registerSuspenseInstanceRetry, vh = m.canHydrateFormStateMarker, Sh = m.isFormStateMarkerMatching, Nf = m.getNextHydratableSibling, kh = m.getNextHydratableSiblingAfterSingleton, wc = m.getFirstHydratableChild, Pc = m.getFirstHydratableChildWithinContainer, Ff = m.getFirstHydratableChildWithinActivityInstance, wh = m.getFirstHydratableChildWithinSuspenseInstance, Um = m.getFirstHydratableChildWithinSingleton, Bm = m.canHydrateInstance, Ph = m.canHydrateTextInstance, xh = m.canHydrateActivityInstance, Om = m.canHydrateSuspenseInstance, Ki = m.hydrateInstance, xc = m.hydrateTextInstance, zh = m.hydrateActivityInstance, Hf = m.hydrateSuspenseInstance, Ch = m.getNextHydratableInstanceAfterActivityInstance, Th = m.getNextHydratableInstanceAfterSuspenseInstance, _h = m.commitHydratedInstance, Mm = m.commitHydratedContainer, Rh = m.commitHydratedActivityInstance, el = m.commitHydratedSuspenseInstance, Eh = m.finalizeHydratedChildren, Ih = m.flushHydrationEvents;
            m.clearActivityBoundary;
            var Se = m.clearSuspenseBoundary;
            m.clearActivityBoundaryFromContainer;
            var Af = m.clearSuspenseBoundaryFromContainer, Qm = m.hideDehydratedBoundary, Lh = m.unhideDehydratedBoundary, Nh = m.shouldDeleteUnhydratedTailInstances;
            m.diffHydratedPropsForDevWarnings, m.diffHydratedTextForDevWarnings, m.describeHydratableInstanceForDevWarnings;
            var $m = m.validateHydratableInstance, jf = m.validateHydratableTextInstance, Gt = m.supportsResources, Df = m.isHostHoistableType, zc = m.getHoistableRoot, nl = m.getResource, Fh = m.acquireResource, Hh = m.releaseResource, Ya = m.hydrateHoistable, Cc = m.mountHoistable, Wf = m.unmountHoistable, Ah = m.createHoistableInstance, jh = m.prepareToCommitHoistables, Vm = m.mayResourceSuspendCommit, Tc = m.preloadResource, Fo = m.suspendResource, dn = m.supportsSingletons, _c = m.resolveSingletonInstance, Rc = m.acquireSingletonInstance, fa = m.releaseSingletonInstance, Ec = m.isHostSingletonType, Xa = m.isSingletonScope, Hs = [], tl = -1, Ka = {}, vt = Math.clz32 ? Math.clz32 : Em, Dh = Math.log, Wh = Math.LN2, As = 256, js = 262144, rl = 4194304, Ic = tt.unstable_scheduleCallback, le = tt.unstable_cancelCallback, qm = tt.unstable_shouldYield, St = tt.unstable_requestPaint, ze = tt.unstable_now, Uh = tt.unstable_ImmediatePriority, Ho = tt.unstable_UserBlockingPriority, Ao = tt.unstable_NormalPriority, ol = tt.unstable_IdlePriority, Lc = tt.log, Uf = tt.unstable_setDisableYieldValue, ei = null, on = null, jn = typeof Object.is == "function" ? Object.is : Im, Nc = typeof reportError == "function" ? reportError : function(t) {
                if (typeof window == "object" && typeof window.ErrorEvent == "function") {
                    var r = new window.ErrorEvent("error", {
                        bubbles: !0,
                        cancelable: !0,
                        message: typeof t == "object" && t !== null && typeof t.message == "string" ? String(t.message) : String(t),
                        error: t
                    });
                    if (!window.dispatchEvent(r)) return;
                }
                console.error(t);
            }, Bf = Object.prototype.hasOwnProperty, al, kt, Ds = !1, Bh = new WeakMap(), ni = [], il = 0, fn = null, x = 0, Jt = [], Zt = 0, jo = null, ot = 1, Zr = "", Dn = Ir(null), Ws = Ir(null), pa = Ir(null), Fc = Ir(null), bn = null, Ue = null, ue = !1, Do = null, Yt = !1, Of = Error(F(519)), Yr = Ir(null), at = null, Be = null, Xr = typeof AbortController < "u" ? AbortController : function() {
                var t = [], r = this.signal = {
                    aborted: !1,
                    addEventListener: function(a, l) {
                        t.push(l);
                    }
                };
                this.abort = function() {
                    r.aborted = !0, t.forEach(function(a) {
                        return a();
                    });
                };
            }, qn = tt.unstable_scheduleCallback, Gm = tt.unstable_NormalPriority, qe = {
                $$typeof: Io,
                Consumer: null,
                Provider: null,
                _currentValue: null,
                _currentValue2: null,
                _threadCount: 0
            }, an = null, wt = null, Mf = !1, ll = !1, ti = !1, Pr = 0, Us = null, Qf = 0, sl = 0, ul = null, Hc = M.S;
            M.S = function(t, r) {
                Zf = ze(), typeof r == "object" && r !== null && typeof r.then == "function" && Np(t, r), Hc !== null && Hc(t, r);
            };
            var ha = Ir(null), cl = Error(F(460)), Ac = Error(F(474)), jc = Error(F(542)), Dc = {
                then: function() {}
            }, Xt = null, Kt = null, Bs = 0, ri = Ad(!0), Oh = Ad(!1), er = [], xr = 0, $f = 0, ma = !1, Vf = !1, Kr = Ir(null), Wc = Ir(0), Ft = Ir(null), zr = null, ln = Ir(0), Wo = 0, ne = null, Ie = null, pn = null, Uc = !1, dl = !1, oi = !1, Bc = 0, fl = 0, pl = null, Jm = 0, Os = {
                readContext: In,
                use: Ee,
                useCallback: Ve,
                useContext: Ve,
                useEffect: Ve,
                useImperativeHandle: Ve,
                useLayoutEffect: Ve,
                useInsertionEffect: Ve,
                useMemo: Ve,
                useReducer: Ve,
                useRef: Ve,
                useState: Ve,
                useDebugValue: Ve,
                useDeferredValue: Ve,
                useTransition: Ve,
                useSyncExternalStore: Ve,
                useId: Ve,
                useHostTransitionStatus: Ve,
                useFormState: Ve,
                useActionState: Ve,
                useOptimistic: Ve,
                useMemoCache: Ve,
                useCacheRefresh: Ve
            };
            Os.useEffectEvent = Ve;
            var Mh = {
                readContext: In,
                use: Ee,
                useCallback: function(t, r) {
                    return Ln().memoizedState = [
                        t,
                        r === void 0 ? null : r
                    ], t;
                },
                useContext: In,
                useEffect: Bd,
                useImperativeHandle: function(t, r, a) {
                    a = a != null ? a.concat([
                        t
                    ]) : null, Xl(4194308, 4, jp.bind(null, r, t), a);
                },
                useLayoutEffect: function(t, r) {
                    return Xl(4194308, 4, t, r);
                },
                useInsertionEffect: function(t, r) {
                    Xl(4, 2, t, r);
                },
                useMemo: function(t, r) {
                    var a = Ln();
                    r = r === void 0 ? null : r;
                    var l = t();
                    if (oi) {
                        pe(!0);
                        try {
                            t();
                        } finally{
                            pe(!1);
                        }
                    }
                    return a.memoizedState = [
                        l,
                        r
                    ], l;
                },
                useReducer: function(t, r, a) {
                    var l = Ln();
                    if (a !== void 0) {
                        var c = a(r);
                        if (oi) {
                            pe(!0);
                            try {
                                a(r);
                            } finally{
                                pe(!1);
                            }
                        }
                    } else c = r;
                    return l.memoizedState = l.baseState = c, t = {
                        pending: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: t,
                        lastRenderedState: c
                    }, l.queue = t, t = t.dispatch = Nn.bind(null, ne, t), [
                        l.memoizedState,
                        t
                    ];
                },
                useRef: function(t) {
                    var r = Ln();
                    return t = {
                        current: t
                    }, r.memoizedState = t;
                },
                useState: function(t) {
                    t = Xn(t);
                    var r = t.queue, a = Nu.bind(null, ne, r);
                    return r.dispatch = a, [
                        t.memoizedState,
                        a
                    ];
                },
                useDebugValue: Qd,
                useDeferredValue: function(t, r) {
                    var a = Ln();
                    return Iu(a, t, r);
                },
                useTransition: function() {
                    var t = Xn(!1);
                    return t = $d.bind(null, ne, t.queue, !0, !1), Ln().memoizedState = t, [
                        !1,
                        t
                    ];
                },
                useSyncExternalStore: function(t, r, a) {
                    var l = ne, c = Ln();
                    if (ue) {
                        if (a === void 0) throw Error(F(407));
                        a = a();
                    } else {
                        if (a = r(), Ne === null) throw Error(F(349));
                        (he & 127) !== 0 || Hp(l, r, a);
                    }
                    c.memoizedState = a;
                    var d = {
                        value: a,
                        getSnapshot: r
                    };
                    return c.queue = d, Bd(ql.bind(null, l, d, t), [
                        t
                    ]), l.flags |= 2048, Kn(9, {
                        destroy: void 0
                    }, jr.bind(null, l, d, a, r), null), a;
                },
                useId: function() {
                    var t = Ln(), r = Ne.identifierPrefix;
                    if (ue) {
                        var a = Zr, l = ot;
                        a = (l & ~(1 << 32 - vt(l) - 1)).toString(32) + a, r = "_" + r + "R_" + a, a = Bc++, 0 < a && (r += "H" + a.toString(32)), r += "_";
                    } else a = Jm++, r = "_" + r + "r_" + a.toString(32) + "_";
                    return t.memoizedState = r;
                },
                useHostTransitionStatus: Lu,
                useFormState: pr,
                useActionState: pr,
                useOptimistic: function(t) {
                    var r = Ln();
                    r.memoizedState = r.baseState = t;
                    var a = {
                        pending: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: null,
                        lastRenderedState: null
                    };
                    return r.queue = a, r = Wi.bind(null, ne, !0, a), a.dispatch = r, [
                        t,
                        r
                    ];
                },
                useMemoCache: Hi,
                useCacheRefresh: function() {
                    return Ln().memoizedState = Dp.bind(null, ne);
                },
                useEffectEvent: function(t) {
                    var r = Ln(), a = {
                        impl: t
                    };
                    return r.memoizedState = a, function() {
                        if ((ce & 2) !== 0) throw Error(F(440));
                        return a.impl.apply(void 0, arguments);
                    };
                }
            }, qf = {
                readContext: In,
                use: Ee,
                useCallback: Eu,
                useContext: In,
                useEffect: Tu,
                useImperativeHandle: Md,
                useInsertionEffect: Od,
                useLayoutEffect: Ru,
                useMemo: Kl,
                useReducer: Ai,
                useRef: Wa,
                useState: function() {
                    return Ai(Ar);
                },
                useDebugValue: Qd,
                useDeferredValue: function(t, r) {
                    var a = He();
                    return es(a, Ie.memoizedState, t, r);
                },
                useTransition: function() {
                    var t = Ai(Ar)[0], r = He().memoizedState;
                    return [
                        typeof t == "boolean" ? t : sr(t),
                        r
                    ];
                },
                useSyncExternalStore: ur,
                useId: xo,
                useHostTransitionStatus: Lu,
                useFormState: Ud,
                useActionState: Ud,
                useOptimistic: function(t, r) {
                    var a = He();
                    return mt(a, Ie, t, r);
                },
                useMemoCache: Hi,
                useCacheRefresh: qd
            };
            qf.useEffectEvent = _u;
            var Qh = {
                readContext: In,
                use: Ee,
                useCallback: Eu,
                useContext: In,
                useEffect: Tu,
                useImperativeHandle: Md,
                useInsertionEffect: Od,
                useLayoutEffect: Ru,
                useMemo: Kl,
                useReducer: Da,
                useRef: Wa,
                useState: function() {
                    return Da(Ar);
                },
                useDebugValue: Qd,
                useDeferredValue: function(t, r) {
                    var a = He();
                    return Ie === null ? Iu(a, t, r) : es(a, Ie.memoizedState, t, r);
                },
                useTransition: function() {
                    var t = Da(Ar)[0], r = He().memoizedState;
                    return [
                        typeof t == "boolean" ? t : sr(t),
                        r
                    ];
                },
                useSyncExternalStore: ur,
                useId: xo,
                useHostTransitionStatus: Lu,
                useFormState: Yl,
                useActionState: Yl,
                useOptimistic: function(t, r) {
                    var a = He();
                    return Ie !== null ? mt(a, Ie, t, r) : (a.baseState = t, [
                        t,
                        a.queue.dispatch
                    ]);
                },
                useMemoCache: Hi,
                useCacheRefresh: qd
            };
            Qh.useEffectEvent = _u;
            var Oc = {
                enqueueSetState: function(t, r, a) {
                    t = t._reactInternals;
                    var l = bt(), c = Et(l);
                    c.payload = r, a != null && (c.callback = a), r = Nr(t, c, l), r !== null && (nt(r, t, l), Ml(r, t, l));
                },
                enqueueReplaceState: function(t, r, a) {
                    t = t._reactInternals;
                    var l = bt(), c = Et(l);
                    c.tag = 1, c.payload = r, a != null && (c.callback = a), r = Nr(t, c, l), r !== null && (nt(r, t, l), Ml(r, t, l));
                },
                enqueueForceUpdate: function(t, r) {
                    t = t._reactInternals;
                    var a = bt(), l = Et(a);
                    l.tag = 2, r != null && (l.callback = r), r = Nr(t, l, a), r !== null && (nt(r, t, a), Ml(r, t, a));
                }
            }, Mc = Error(F(461)), hn = !1, Qc = {
                dehydrated: null,
                treeContext: null,
                retryLane: 0,
                hydrationErrors: null
            }, eo = !1, sn = !1, Ms = !1, $c = typeof WeakSet == "function" ? WeakSet : Set, Pn = null, mn = null, Pt = !1, Cr = null, ga = 8192, Zm = {
                getCacheForType: function(t) {
                    var r = In(qe), a = r.data.get(t);
                    return a === void 0 && (a = t(), r.data.set(t, a)), a;
                },
                cacheSignal: function() {
                    return In(qe).controller.signal;
                }
            }, Vc = 0, qc = 1, Gc = 2, Jc = 3, Zc = 4;
            if (typeof Symbol == "function" && Symbol.for) {
                var Qs = Symbol.for;
                Vc = Qs("selector.component"), qc = Qs("selector.has_pseudo_class"), Gc = Qs("selector.role"), Jc = Qs("selector.test_id"), Zc = Qs("selector.text");
            }
            var Ym = typeof WeakMap == "function" ? WeakMap : Map, ce = 0, Ne = null, de = null, he = 0, _e = 0, Ht = null, ya = !1, ai = !1, Gf = !1, Uo = 0, Xe = 0, ba = 0, ii = 0, Jf = 0, At = 0, hl = 0, $s = null, xt = null, Yc = !1, Vs = 0, Zf = 0, ml = 1 / 0, Xc = null, va = null, Re = 0, Bo = null, Sa = null, no = 0, Kc = 0, ed = null, $h = null, gl = 0, nd = null;
            return ie.attemptContinuousHydration = function(t) {
                if (t.tag === 13 || t.tag === 31) {
                    var r = Ko(t, 67108864);
                    r !== null && nt(r, t, 67108864), vr(t, 67108864);
                }
            }, ie.attemptHydrationAtCurrentPriority = function(t) {
                if (t.tag === 13 || t.tag === 31) {
                    var r = bt();
                    r = st(r);
                    var a = Ko(t, r);
                    a !== null && nt(a, t, r), vr(t, r);
                }
            }, ie.attemptSynchronousHydration = function(t) {
                switch(t.tag){
                    case 3:
                        if (t = t.stateNode, t.current.memoizedState.isDehydrated) {
                            var r = Zo(t.pendingLanes);
                            if (r !== 0) {
                                for(t.pendingLanes |= 2, t.entangledLanes |= 2; r;){
                                    var a = 1 << 31 - vt(r);
                                    t.entanglements[1] |= a, r &= ~a;
                                }
                                ir(t), (ce & 6) === 0 && (ml = ze() + 500, Ea(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        r = Ko(t, 2), r !== null && nt(r, t, 2), ia(), vr(t, 2);
                }
            }, ie.batchedUpdates = function(t, r) {
                return t(r);
            }, ie.createComponentSelector = function(t) {
                return {
                    $$typeof: Vc,
                    value: t
                };
            }, ie.createContainer = function(t, r, a, l, c, d, h, y, R, L) {
                return xs(t, r, !1, null, a, l, d, null, h, y, R, L);
            }, ie.createHasPseudoClassSelector = function(t) {
                return {
                    $$typeof: qc,
                    value: t
                };
            }, ie.createHydrationContainer = function(t, r, a, l, c, d, h, y, R, L, j, A, W, V) {
                var _r2;
                return t = xs(a, l, !0, t, c, d, y, V, R, L, j, A), t.context = fc(null), a = t.current, l = bt(), l = st(l), c = Et(l), c.callback = (_r2 = r) != null ? _r2 : null, Nr(a, c, l), r = l, t.current.lanes = r, xi(t, r), ir(t), t;
            }, ie.createPortal = function(t, r, a) {
                var l = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
                return {
                    $$typeof: sa,
                    key: l == null ? null : "" + l,
                    children: t,
                    containerInfo: r,
                    implementation: a
                };
            }, ie.createRoleSelector = function(t) {
                return {
                    $$typeof: Gc,
                    value: t
                };
            }, ie.createTestNameSelector = function(t) {
                return {
                    $$typeof: Jc,
                    value: t
                };
            }, ie.createTextSelector = function(t) {
                return {
                    $$typeof: Zc,
                    value: t
                };
            }, ie.defaultOnCaughtError = function(t) {
                console.error(t);
            }, ie.defaultOnRecoverableError = function(t) {
                Nc(t);
            }, ie.defaultOnUncaughtError = function(t) {
                Nc(t);
            }, ie.deferredUpdates = function(t) {
                var r = M.T, a = qr();
                try {
                    return yn(32), M.T = null, t();
                } finally{
                    yn(a), M.T = r;
                }
            }, ie.discreteUpdates = function(t, r, a, l, c) {
                var d = M.T, h = qr();
                try {
                    return yn(2), M.T = null, t(r, a, l, c);
                } finally{
                    yn(h), M.T = d, ce === 0 && (ml = ze() + 500);
                }
            }, ie.findAllNodes = gs, ie.findBoundingRects = function(t, r) {
                if (!Ga) throw Error(F(363));
                r = gs(t, r), t = [];
                for(var a = 0; a < r.length; a++)t.push(wr(r[a]));
                for(r = t.length - 1; 0 < r; r--){
                    a = t[r];
                    for(var l = a.x, c = l + a.width, d = a.y, h = d + a.height, y = r - 1; 0 <= y; y--)if (r !== y) {
                        var R = t[y], L = R.x, j = L + R.width, A = R.y, W = A + R.height;
                        if (l >= L && d >= A && c <= j && h <= W) {
                            t.splice(r, 1);
                            break;
                        } else if (l !== L || a.width !== R.width || W < d || A > h) {
                            if (!(d !== A || a.height !== R.height || j < l || L > c)) {
                                L > l && (R.width += L - l, R.x = l), j < c && (R.width = c - L), t.splice(r, 1);
                                break;
                            }
                        } else {
                            A > d && (R.height += A - d, R.y = d), W < h && (R.height = h - A), t.splice(r, 1);
                            break;
                        }
                    }
                }
                return t;
            }, ie.findHostInstance = vf, ie.findHostInstanceWithNoPortals = function(t) {
                return t = fu(t), t = t !== null ? lt(t) : null, t === null ? null : Ts(t.stateNode);
            }, ie.findHostInstanceWithWarning = function(t) {
                return vf(t);
            }, ie.flushPassiveEffects = rn, ie.flushSyncFromReconciler = function(t) {
                var r = ce;
                ce |= 1;
                var a = M.T, l = qr();
                try {
                    if (yn(2), M.T = null, t) return t();
                } finally{
                    yn(l), M.T = a, ce = r, (ce & 6) === 0 && Ea(0, !1);
                }
            }, ie.flushSyncWork = ia, ie.focusWithin = function(t, r) {
                if (!Ga) throw Error(F(363));
                for(t = Vi(t), r = sf(t, r), r = Array.from(r), t = 0; t < r.length;){
                    var a = r[t++], l = a.tag;
                    if (!Jr(a)) {
                        if ((l === 5 || l === 26 || l === 27) && Es(a.stateNode)) return !0;
                        for(a = a.child; a !== null;)r.push(a), a = a.sibling;
                    }
                }
                return !1;
            }, ie.getFindAllNodesFailureDescription = function(t, r) {
                if (!Ga) throw Error(F(363));
                var a = 0, l = [];
                t = [
                    Vi(t),
                    0
                ];
                for(var c = 0; c < t.length;){
                    var d = t[c++], h = d.tag, y = t[c++], R = r[y];
                    if ((h !== 5 && h !== 26 && h !== 27 || !Jr(d)) && (ms(d, R) && (l.push(nc(R)), y++, y > a && (a = y)), y < r.length)) for(d = d.child; d !== null;)t.push(d, y), d = d.sibling;
                }
                if (a < r.length) {
                    for(t = []; a < r.length; a++)t.push(nc(r[a]));
                    return `findAllNodes was able to match part of the selector:
  ` + (l.join(" > ") + `

No matching component was found for:
  `) + t.join(" > ");
                }
                return null;
            }, ie.getPublicRootInstance = function(t) {
                if (t = t.current, !t.child) return null;
                switch(t.child.tag){
                    case 27:
                    case 5:
                        return Ts(t.child.stateNode);
                    default:
                        return t.child.stateNode;
                }
            }, ie.injectIntoDevTools = function() {
                var t = {
                    bundleType: 0,
                    version: Yp,
                    rendererPackageName: zf,
                    currentDispatcherRef: M,
                    reconcilerVersion: "19.2.0"
                };
                if (Cf !== null && (t.rendererConfig = Cf), typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") t = !1;
                else {
                    var r = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                    if (r.isDisabled || !r.supportsFiber) t = !0;
                    else {
                        try {
                            ei = r.inject(t), on = r;
                        } catch  {}
                        t = !!r.checkDCE;
                    }
                }
                return t;
            }, ie.isAlreadyRendering = function() {
                return (ce & 6) !== 0;
            }, ie.observeVisibleRects = function(t, r, a, l) {
                if (!Ga) throw Error(F(363));
                t = gs(t, r);
                var c = Ja(t, a, l).disconnect;
                return {
                    disconnect: function() {
                        c();
                    }
                };
            }, ie.shouldError = function() {
                return null;
            }, ie.shouldSuspend = function() {
                return !1;
            }, ie.startHostTransition = function(t, r, a, l) {
                if (t.tag !== 5) throw Error(F(476));
                var c = Vd(t).queue;
                $d(t, c, r, rt, a === null ? _d : function() {
                    var d = Vd(t);
                    return d.next === null && (d = t.alternate.memoizedState), ea(t, d.next.queue, {}, bt()), a(l);
                });
            }, ie.updateContainer = function(t, r, a, l) {
                var c = r.current, d = bt();
                return pc(c, d, t, r, a, l), d;
            }, ie.updateContainerSync = function(t, r, a, l) {
                return pc(r.current, 2, t, r, a, l), 2;
            }, ie;
        }, Tt.exports.default = Tt.exports, Object.defineProperty(Tt.exports, "__esModule", {
            value: !0
        });
    }($02a5e071daeb5f48$var$Og)), $02a5e071daeb5f48$var$Og.exports;
}
var $02a5e071daeb5f48$var$Mg = {
    exports: {}
}; /**
   * @license React
   * react-reconciler.development.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ 
$02a5e071daeb5f48$var$Mg.exports;
var $02a5e071daeb5f48$var$Rb;
function $02a5e071daeb5f48$var$e0() {
    return $02a5e071daeb5f48$var$Rb || ($02a5e071daeb5f48$var$Rb = 1, function(Tt) {}($02a5e071daeb5f48$var$Mg)), $02a5e071daeb5f48$var$Mg.exports;
}
var $02a5e071daeb5f48$var$Eb;
function $02a5e071daeb5f48$var$n0() {
    return $02a5e071daeb5f48$var$Eb || ($02a5e071daeb5f48$var$Eb = 1, $02a5e071daeb5f48$var$Rm.exports = $02a5e071daeb5f48$var$Kb()), $02a5e071daeb5f48$var$Rm.exports;
}
var $02a5e071daeb5f48$var$t0 = $02a5e071daeb5f48$var$n0();
const $02a5e071daeb5f48$var$r0 = $02a5e071daeb5f48$var$Xb($02a5e071daeb5f48$var$t0);
function $02a5e071daeb5f48$var$createReconciler(config) {
    const reconciler = $02a5e071daeb5f48$var$r0(config);
    // @ts-ignore DefinitelyTyped is not up to date
    reconciler.injectIntoDevTools();
    return reconciler;
}
const $02a5e071daeb5f48$var$NoEventPriority = 0;
// TODO: handle constructor overloads
// https://github.com/pmndrs/react-three-fiber/pull/2931
// https://github.com/microsoft/TypeScript/issues/37079
const $02a5e071daeb5f48$var$catalogue = {};
const $02a5e071daeb5f48$var$PREFIX_REGEX = /^three(?=[A-Z])/;
const $02a5e071daeb5f48$var$toPascalCase = (type)=>`${type[0].toUpperCase()}${type.slice(1)}`;
let $02a5e071daeb5f48$var$i = 0;
const $02a5e071daeb5f48$var$isConstructor = (object)=>typeof object === 'function';
function $02a5e071daeb5f48$export$f1e1789686576879(objects) {
    if ($02a5e071daeb5f48$var$isConstructor(objects)) {
        const Component = `${$02a5e071daeb5f48$var$i++}`;
        $02a5e071daeb5f48$var$catalogue[Component] = objects;
        return Component;
    } else Object.assign($02a5e071daeb5f48$var$catalogue, objects);
}
function $02a5e071daeb5f48$var$validateInstance(type, props) {
    // Get target from catalogue
    const name = $02a5e071daeb5f48$var$toPascalCase(type);
    const target = $02a5e071daeb5f48$var$catalogue[name];
    // Validate element target
    if (type !== 'primitive' && !target) throw new Error(`R3F: ${name} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
    // Validate primitives
    if (type === 'primitive' && !props.object) throw new Error(`R3F: Primitives without 'object' are invalid!`);
    // Throw if an object or literal was passed for args
    if (props.args !== undefined && !Array.isArray(props.args)) throw new Error('R3F: The args prop must be an array!');
}
function $02a5e071daeb5f48$var$createInstance(type, props, root) {
    var _props$object;
    // Remove three* prefix from elements if native element not present
    type = $02a5e071daeb5f48$var$toPascalCase(type) in $02a5e071daeb5f48$var$catalogue ? type : type.replace($02a5e071daeb5f48$var$PREFIX_REGEX, '');
    $02a5e071daeb5f48$var$validateInstance(type, props);
    // Regenerate the R3F instance for primitives to simulate a new object
    if (type === 'primitive' && (_props$object = props.object) != null && _props$object.__r3f) delete props.object.__r3f;
    return $02a5e071daeb5f48$var$prepare(props.object, root, type, props);
}
function $02a5e071daeb5f48$var$hideInstance(instance) {
    if (!instance.isHidden) {
        var _instance$parent;
        if (instance.props.attach && (_instance$parent = instance.parent) != null && _instance$parent.object) $02a5e071daeb5f48$var$detach(instance.parent, instance);
        else if ($02a5e071daeb5f48$var$isObject3D(instance.object)) instance.object.visible = false;
        instance.isHidden = true;
        $02a5e071daeb5f48$var$invalidateInstance(instance);
    }
}
function $02a5e071daeb5f48$var$unhideInstance(instance) {
    if (instance.isHidden) {
        var _instance$parent2;
        if (instance.props.attach && (_instance$parent2 = instance.parent) != null && _instance$parent2.object) $02a5e071daeb5f48$var$attach(instance.parent, instance);
        else if ($02a5e071daeb5f48$var$isObject3D(instance.object) && instance.props.visible !== false) instance.object.visible = true;
        instance.isHidden = false;
        $02a5e071daeb5f48$var$invalidateInstance(instance);
    }
}
// https://github.com/facebook/react/issues/20271
// This will make sure events and attach are only handled once when trees are complete
function $02a5e071daeb5f48$var$handleContainerEffects(parent, child, beforeChild) {
    // Bail if tree isn't mounted or parent is not a container.
    // This ensures that the tree is finalized and React won't discard results to Suspense
    const state = child.root.getState();
    if (!parent.parent && parent.object !== state.scene) return;
    // Create & link object on first run
    if (!child.object) {
        var _child$props$object, _child$props$args;
        // Get target from catalogue
        const target = $02a5e071daeb5f48$var$catalogue[$02a5e071daeb5f48$var$toPascalCase(child.type)];
        // Create object
        child.object = (_child$props$object = child.props.object) != null ? _child$props$object : new target(...(_child$props$args = child.props.args) != null ? _child$props$args : []);
        child.object.__r3f = child;
    }
    // Set initial props
    $02a5e071daeb5f48$export$2408f22a0fab9ae5(child.object, child.props);
    // Append instance
    if (child.props.attach) $02a5e071daeb5f48$var$attach(parent, child);
    else if ($02a5e071daeb5f48$var$isObject3D(child.object) && $02a5e071daeb5f48$var$isObject3D(parent.object)) {
        const childIndex = parent.object.children.indexOf(beforeChild == null ? void 0 : beforeChild.object);
        if (beforeChild && childIndex !== -1) {
            // If the child is already in the parent's children array, move it to the new position
            // Otherwise, just insert it at the target position
            const existingIndex = parent.object.children.indexOf(child.object);
            if (existingIndex !== -1) {
                parent.object.children.splice(existingIndex, 1);
                const adjustedIndex = existingIndex < childIndex ? childIndex - 1 : childIndex;
                parent.object.children.splice(adjustedIndex, 0, child.object);
            } else {
                child.object.parent = parent.object;
                parent.object.children.splice(childIndex, 0, child.object);
                child.object.dispatchEvent({
                    type: 'added'
                });
                parent.object.dispatchEvent({
                    type: 'childadded',
                    child: child.object
                });
            }
        } else parent.object.add(child.object);
    }
    // Link subtree
    for (const childInstance of child.children)$02a5e071daeb5f48$var$handleContainerEffects(child, childInstance);
    // Tree was updated, request a frame
    $02a5e071daeb5f48$var$invalidateInstance(child);
}
function $02a5e071daeb5f48$var$appendChild(parent, child) {
    if (!child) return;
    // Link instances
    child.parent = parent;
    parent.children.push(child);
    // Attach tree once complete
    $02a5e071daeb5f48$var$handleContainerEffects(parent, child);
}
function $02a5e071daeb5f48$var$insertBefore(parent, child, beforeChild) {
    if (!child || !beforeChild) return;
    // Link instances
    child.parent = parent;
    const childIndex = parent.children.indexOf(beforeChild);
    if (childIndex !== -1) parent.children.splice(childIndex, 0, child);
    else parent.children.push(child);
    // Attach tree once complete
    $02a5e071daeb5f48$var$handleContainerEffects(parent, child, beforeChild);
}
function $02a5e071daeb5f48$var$disposeOnIdle(object) {
    if (typeof object.dispose === 'function') {
        const handleDispose = ()=>{
            try {
                object.dispose();
            } catch  {
            // no-op
            }
        };
        // In a testing environment, cleanup immediately
        if (typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined') handleDispose();
        else (0, $bIbqH.unstable_scheduleCallback)((0, $bIbqH.unstable_IdlePriority), handleDispose);
    }
}
function $02a5e071daeb5f48$var$removeChild(parent, child, dispose) {
    if (!child) return;
    // Unlink instances
    child.parent = null;
    const childIndex = parent.children.indexOf(child);
    if (childIndex !== -1) parent.children.splice(childIndex, 1);
    // Eagerly tear down tree
    if (child.props.attach) $02a5e071daeb5f48$var$detach(parent, child);
    else if ($02a5e071daeb5f48$var$isObject3D(child.object) && $02a5e071daeb5f48$var$isObject3D(parent.object)) {
        parent.object.remove(child.object);
        $02a5e071daeb5f48$var$removeInteractivity($02a5e071daeb5f48$var$findInitialRoot(child), child.object);
    }
    // Allow objects to bail out of unmount disposal with dispose={null}
    const shouldDispose = child.props.dispose !== null && dispose !== false;
    // Recursively remove instance children
    for(let i = child.children.length - 1; i >= 0; i--){
        const node = child.children[i];
        $02a5e071daeb5f48$var$removeChild(child, node, shouldDispose);
    }
    child.children.length = 0;
    // Unlink instance object
    delete child.object.__r3f;
    // Dispose object whenever the reconciler feels like it.
    // Never dispose of primitives because their state may be kept outside of React!
    // In order for an object to be able to dispose it
    //   - has a dispose method
    //   - cannot be a <primitive object={...} />
    //   - cannot be a THREE.Scene, because three has broken its own API
    if (shouldDispose && child.type !== 'primitive' && child.object.type !== 'Scene') $02a5e071daeb5f48$var$disposeOnIdle(child.object);
    // Tree was updated, request a frame for top-level instance
    if (dispose === undefined) $02a5e071daeb5f48$var$invalidateInstance(child);
}
function $02a5e071daeb5f48$var$setFiberRef(fiber, publicInstance) {
    for (const _fiber of [
        fiber,
        fiber.alternate
    ])if (_fiber !== null) {
        if (typeof _fiber.ref === 'function') {
            _fiber.refCleanup == null || _fiber.refCleanup();
            const cleanup = _fiber.ref(publicInstance);
            if (typeof cleanup === 'function') _fiber.refCleanup = cleanup;
        } else if (_fiber.ref) _fiber.ref.current = publicInstance;
    }
}
const $02a5e071daeb5f48$var$reconstructed = [];
function $02a5e071daeb5f48$var$swapInstances() {
    // Detach instance
    for (const [instance] of $02a5e071daeb5f48$var$reconstructed){
        const parent = instance.parent;
        if (parent) {
            if (instance.props.attach) $02a5e071daeb5f48$var$detach(parent, instance);
            else if ($02a5e071daeb5f48$var$isObject3D(instance.object) && $02a5e071daeb5f48$var$isObject3D(parent.object)) parent.object.remove(instance.object);
            for (const child of instance.children){
                if (child.props.attach) $02a5e071daeb5f48$var$detach(instance, child);
                else if ($02a5e071daeb5f48$var$isObject3D(child.object) && $02a5e071daeb5f48$var$isObject3D(instance.object)) instance.object.remove(child.object);
            }
        }
        // If the old instance is hidden, we need to unhide it.
        // React assumes it can discard instances since they're pure for DOM.
        // This isn't true for us since our lifetimes are impure and longliving.
        // So, we manually check if an instance was hidden and unhide it.
        if (instance.isHidden) $02a5e071daeb5f48$var$unhideInstance(instance);
        // Dispose of old object if able
        if (instance.object.__r3f) delete instance.object.__r3f;
        if (instance.type !== 'primitive') $02a5e071daeb5f48$var$disposeOnIdle(instance.object);
    }
    // Update instance
    for (const [instance, props, fiber] of $02a5e071daeb5f48$var$reconstructed){
        instance.props = props;
        const parent = instance.parent;
        if (parent) {
            var _instance$props$objec, _instance$props$args;
            // Get target from catalogue
            const target = $02a5e071daeb5f48$var$catalogue[$02a5e071daeb5f48$var$toPascalCase(instance.type)];
            // Create object
            instance.object = (_instance$props$objec = instance.props.object) != null ? _instance$props$objec : new target(...(_instance$props$args = instance.props.args) != null ? _instance$props$args : []);
            instance.object.__r3f = instance;
            $02a5e071daeb5f48$var$setFiberRef(fiber, instance.object);
            // Set initial props
            $02a5e071daeb5f48$export$2408f22a0fab9ae5(instance.object, instance.props);
            if (instance.props.attach) $02a5e071daeb5f48$var$attach(parent, instance);
            else if ($02a5e071daeb5f48$var$isObject3D(instance.object) && $02a5e071daeb5f48$var$isObject3D(parent.object)) parent.object.add(instance.object);
            for (const child of instance.children){
                if (child.props.attach) $02a5e071daeb5f48$var$attach(instance, child);
                else if ($02a5e071daeb5f48$var$isObject3D(child.object) && $02a5e071daeb5f48$var$isObject3D(instance.object)) instance.object.add(child.object);
            }
            // Tree was updated, request a frame
            $02a5e071daeb5f48$var$invalidateInstance(instance);
        }
    }
    $02a5e071daeb5f48$var$reconstructed.length = 0;
}
// Don't handle text instances, make it no-op
const $02a5e071daeb5f48$var$handleTextInstance = ()=>{};
const $02a5e071daeb5f48$var$NO_CONTEXT = {};
let $02a5e071daeb5f48$var$currentUpdatePriority = $02a5e071daeb5f48$var$NoEventPriority;
// https://github.com/facebook/react/blob/main/packages/react-reconciler/src/ReactFiberFlags.js
const $02a5e071daeb5f48$var$NoFlags = 0;
const $02a5e071daeb5f48$var$Update = 4;
const $02a5e071daeb5f48$export$43caf9889c228507 = /* @__PURE__ */ $02a5e071daeb5f48$var$createReconciler({
    isPrimaryRenderer: false,
    warnsIfNotActing: false,
    supportsMutation: true,
    supportsPersistence: false,
    supportsHydration: false,
    createInstance: $02a5e071daeb5f48$var$createInstance,
    removeChild: $02a5e071daeb5f48$var$removeChild,
    appendChild: $02a5e071daeb5f48$var$appendChild,
    appendInitialChild: $02a5e071daeb5f48$var$appendChild,
    insertBefore: $02a5e071daeb5f48$var$insertBefore,
    appendChildToContainer (container, child) {
        const scene = container.getState().scene.__r3f;
        if (!child || !scene) return;
        $02a5e071daeb5f48$var$appendChild(scene, child);
    },
    removeChildFromContainer (container, child) {
        const scene = container.getState().scene.__r3f;
        if (!child || !scene) return;
        $02a5e071daeb5f48$var$removeChild(scene, child);
    },
    insertInContainerBefore (container, child, beforeChild) {
        const scene = container.getState().scene.__r3f;
        if (!child || !beforeChild || !scene) return;
        $02a5e071daeb5f48$var$insertBefore(scene, child, beforeChild);
    },
    getRootHostContext: ()=>$02a5e071daeb5f48$var$NO_CONTEXT,
    getChildHostContext: ()=>$02a5e071daeb5f48$var$NO_CONTEXT,
    commitUpdate (instance, type, oldProps, newProps, fiber) {
        var _newProps$args, _oldProps$args, _newProps$args2;
        $02a5e071daeb5f48$var$validateInstance(type, newProps);
        let reconstruct = false;
        // Reconstruct primitives if object prop changes
        if (instance.type === 'primitive' && oldProps.object !== newProps.object) reconstruct = true;
        else if (((_newProps$args = newProps.args) == null ? void 0 : _newProps$args.length) !== ((_oldProps$args = oldProps.args) == null ? void 0 : _oldProps$args.length)) reconstruct = true;
        else if ((_newProps$args2 = newProps.args) != null && _newProps$args2.some((value, index)=>{
            var _oldProps$args2;
            return value !== ((_oldProps$args2 = oldProps.args) == null ? void 0 : _oldProps$args2[index]);
        })) reconstruct = true;
        // Reconstruct when args or <primitive object={...} have changes
        if (reconstruct) $02a5e071daeb5f48$var$reconstructed.push([
            instance,
            {
                ...newProps
            },
            fiber
        ]);
        else {
            // Create a diff-set, flag if there are any changes
            const changedProps = $02a5e071daeb5f48$var$diffProps(instance, newProps);
            if (Object.keys(changedProps).length) {
                Object.assign(instance.props, changedProps);
                $02a5e071daeb5f48$export$2408f22a0fab9ae5(instance.object, changedProps);
            }
        }
        // Flush reconstructed siblings when we hit the last updated child in a sequence
        const isTailSibling = fiber.sibling === null || (fiber.flags & $02a5e071daeb5f48$var$Update) === $02a5e071daeb5f48$var$NoFlags;
        if (isTailSibling) $02a5e071daeb5f48$var$swapInstances();
    },
    finalizeInitialChildren: ()=>false,
    commitMount () {},
    getPublicInstance: (instance)=>instance == null ? void 0 : instance.object,
    prepareForCommit: ()=>null,
    preparePortalMount: (container)=>$02a5e071daeb5f48$var$prepare(container.getState().scene, container, '', {}),
    resetAfterCommit: ()=>{},
    shouldSetTextContent: ()=>false,
    clearContainer: ()=>false,
    hideInstance: $02a5e071daeb5f48$var$hideInstance,
    unhideInstance: $02a5e071daeb5f48$var$unhideInstance,
    createTextInstance: $02a5e071daeb5f48$var$handleTextInstance,
    hideTextInstance: $02a5e071daeb5f48$var$handleTextInstance,
    unhideTextInstance: $02a5e071daeb5f48$var$handleTextInstance,
    scheduleTimeout: typeof setTimeout === 'function' ? setTimeout : undefined,
    cancelTimeout: typeof clearTimeout === 'function' ? clearTimeout : undefined,
    noTimeout: -1,
    getInstanceFromNode: ()=>null,
    beforeActiveInstanceBlur () {},
    afterActiveInstanceBlur () {},
    detachDeletedInstance () {},
    prepareScopeUpdate () {},
    getInstanceFromScope: ()=>null,
    shouldAttemptEagerTransition: ()=>false,
    trackSchedulerEvent: ()=>{},
    resolveEventType: ()=>null,
    resolveEventTimeStamp: ()=>-1.1,
    requestPostPaintCallback () {},
    maySuspendCommit: ()=>false,
    preloadInstance: ()=>true,
    // true indicates already loaded
    suspendInstance () {},
    waitForCommitToBeReady: ()=>null,
    NotPendingTransition: null,
    // The reconciler types use the internal ReactContext with all the hidden properties
    // so we have to cast from the public React.Context type
    HostTransitionContext: /* @__PURE__ */ $2WGWz.createContext(null),
    setCurrentUpdatePriority (newPriority) {
        $02a5e071daeb5f48$var$currentUpdatePriority = newPriority;
    },
    getCurrentUpdatePriority () {
        return $02a5e071daeb5f48$var$currentUpdatePriority;
    },
    resolveUpdatePriority () {
        var _window$event;
        if ($02a5e071daeb5f48$var$currentUpdatePriority !== $02a5e071daeb5f48$var$NoEventPriority) return $02a5e071daeb5f48$var$currentUpdatePriority;
        switch(typeof window !== 'undefined' && ((_window$event = window.event) == null ? void 0 : _window$event.type)){
            case 'click':
            case 'contextmenu':
            case 'dblclick':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
                return $02a5e071daeb5f48$var$e;
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerenter':
            case 'pointerleave':
            case 'wheel':
                return $02a5e071daeb5f48$var$o;
            default:
                return $02a5e071daeb5f48$var$r;
        }
    },
    resetFormInstance () {},
    // @ts-ignore DefinitelyTyped is not up to date
    rendererPackageName: '@react-three/fiber',
    rendererVersion: $02a5e071daeb5f48$var$packageData.version,
    // https://github.com/facebook/react/pull/31975
    // https://github.com/facebook/react/pull/31999
    applyViewTransitionName (_instance, _name, _className) {},
    restoreViewTransitionName (_instance, _props) {},
    cancelViewTransitionName (_instance, _name, _props) {},
    cancelRootViewTransitionName (_rootContainer) {},
    restoreRootViewTransitionName (_rootContainer) {},
    InstanceMeasurement: null,
    measureInstance: (_instance)=>null,
    wasInstanceInViewport: (_measurement)=>true,
    hasInstanceChanged: (_oldMeasurement, _newMeasurement)=>false,
    hasInstanceAffectedParent: (_oldMeasurement, _newMeasurement)=>false,
    // https://github.com/facebook/react/pull/32002
    // https://github.com/facebook/react/pull/34486
    suspendOnActiveViewTransition (_state, _container) {},
    // https://github.com/facebook/react/pull/32451
    // https://github.com/facebook/react/pull/32760
    startGestureTransition: ()=>null,
    startViewTransition: ()=>null,
    stopViewTransition (_transition) {},
    // https://github.com/facebook/react/pull/32038
    createViewTransitionInstance: (_name)=>null,
    // https://github.com/facebook/react/pull/32379
    // https://github.com/facebook/react/pull/32786
    getCurrentGestureOffset (_provider) {
        throw new Error('startGestureTransition is not yet supported in react-three-fiber.');
    },
    // https://github.com/facebook/react/pull/32500
    cloneMutableInstance (instance, _keepChildren) {
        return instance;
    },
    cloneMutableTextInstance (textInstance) {
        return textInstance;
    },
    cloneRootViewTransitionContainer (_rootContainer) {
        throw new Error('Not implemented.');
    },
    removeRootViewTransitionClone (_rootContainer, _clone) {
        throw new Error('Not implemented.');
    },
    // https://github.com/facebook/react/pull/32465
    createFragmentInstance: (_fiber)=>null,
    updateFragmentInstanceFiber (_fiber, _instance) {},
    commitNewChildToFragmentInstance (_child, _fragmentInstance) {},
    deleteChildFromFragmentInstance (_child, _fragmentInstance) {},
    // https://github.com/facebook/react/pull/32653
    measureClonedInstance: (_instance)=>null,
    // https://github.com/facebook/react/pull/32819
    maySuspendCommitOnUpdate: (_type, _oldProps, _newProps)=>false,
    maySuspendCommitInSyncRender: (_type, _props)=>false,
    // https://github.com/facebook/react/pull/34486
    startSuspendingCommit: ()=>null,
    // https://github.com/facebook/react/pull/34522
    getSuspendedCommitReason: (_state, _rootContainer)=>null
});
const $02a5e071daeb5f48$export$71511d61b312f219 = new Map();
const $02a5e071daeb5f48$var$shallowLoose = {
    objects: 'shallow',
    strict: false
};
function $02a5e071daeb5f48$var$computeInitialSize(canvas, size) {
    if (!size && typeof HTMLCanvasElement !== 'undefined' && canvas instanceof HTMLCanvasElement && canvas.parentElement) {
        const { width: width, height: height, top: top, left: left } = canvas.parentElement.getBoundingClientRect();
        return {
            width: width,
            height: height,
            top: top,
            left: left
        };
    } else if (!size && typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return {
        width: canvas.width,
        height: canvas.height,
        top: 0,
        left: 0
    };
    return {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        ...size
    };
}
function $02a5e071daeb5f48$export$db3b6bfb95261072(canvas) {
    // Check against mistaken use of createRoot
    const prevRoot = $02a5e071daeb5f48$export$71511d61b312f219.get(canvas);
    const prevFiber = prevRoot == null ? void 0 : prevRoot.fiber;
    const prevStore = prevRoot == null ? void 0 : prevRoot.store;
    if (prevRoot) console.warn('R3F.createRoot should only be called once!');
    // Report when an error was detected in a previous render
    // https://github.com/pmndrs/react-three-fiber/pull/2261
    const logRecoverableError = typeof reportError === 'function' ? // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : // In older browsers and test environments, fallback to console.error.
    console.error;
    // Create store
    const store = prevStore || $02a5e071daeb5f48$var$createStore($02a5e071daeb5f48$export$953cecd6e717a553, $02a5e071daeb5f48$export$7ccc53e8f1e7dfc5);
    // Create renderer
    const fiber = prevFiber || $02a5e071daeb5f48$export$43caf9889c228507.createContainer(store, // container
    $02a5e071daeb5f48$var$t, // tag
    null, // hydration callbacks
    false, // isStrictMode
    null, // concurrentUpdatesByDefaultOverride
    '', // identifierPrefix
    logRecoverableError, // onUncaughtError
    logRecoverableError, // onCaughtError
    logRecoverableError, // onRecoverableError
    null // transitionCallbacks
    );
    // Map it
    if (!prevRoot) $02a5e071daeb5f48$export$71511d61b312f219.set(canvas, {
        fiber: fiber,
        store: store
    });
    // Locals
    let onCreated;
    let lastCamera;
    let configured = false;
    let pending = null;
    return {
        async configure (props = {}) {
            let resolve;
            pending = new Promise((_resolve)=>resolve = _resolve);
            let { gl: glConfig, size: propsSize, scene: sceneOptions, events: events, onCreated: onCreatedCallback, shadows: shadows = false, linear: linear = false, flat: flat = false, legacy: legacy = false, orthographic: orthographic = false, frameloop: frameloop = 'always', dpr: dpr = [
                1,
                2
            ], performance: performance, raycaster: raycastOptions, camera: cameraOptions, onPointerMissed: onPointerMissed } = props;
            let state = store.getState();
            // Set up renderer (one time only!)
            let gl = state.gl;
            if (!state.gl) {
                const defaultProps = {
                    canvas: canvas,
                    powerPreference: 'high-performance',
                    antialias: true,
                    alpha: true
                };
                const customRenderer = typeof glConfig === 'function' ? await glConfig(defaultProps) : glConfig;
                if ($02a5e071daeb5f48$var$isRenderer(customRenderer)) gl = customRenderer;
                else gl = new $3b951febf8ab45a9$export$f6cc00ef28d7cf97({
                    ...defaultProps,
                    ...glConfig
                });
                state.set({
                    gl: gl
                });
            }
            // Set up raycaster (one time only!)
            let raycaster = state.raycaster;
            if (!raycaster) state.set({
                raycaster: raycaster = new $ce0cdebec9150cb3$export$8b7aaceff00bd2f()
            });
            // Set raycaster options
            const { params: params, ...options } = raycastOptions || {};
            if (!$02a5e071daeb5f48$var$is.equ(options, raycaster, $02a5e071daeb5f48$var$shallowLoose)) $02a5e071daeb5f48$export$2408f22a0fab9ae5(raycaster, {
                ...options
            });
            if (!$02a5e071daeb5f48$var$is.equ(params, raycaster.params, $02a5e071daeb5f48$var$shallowLoose)) $02a5e071daeb5f48$export$2408f22a0fab9ae5(raycaster, {
                params: {
                    ...raycaster.params,
                    ...params
                }
            });
            // Create default camera, don't overwrite any user-set state
            if (!state.camera || state.camera === lastCamera && !$02a5e071daeb5f48$var$is.equ(lastCamera, cameraOptions, $02a5e071daeb5f48$var$shallowLoose)) {
                lastCamera = cameraOptions;
                const isCamera = cameraOptions == null ? void 0 : cameraOptions.isCamera;
                const camera = isCamera ? cameraOptions : orthographic ? new $ce0cdebec9150cb3$export$9ebf355ee4ed261b(0, 0, 0, 0, 0.1, 1000) : new $ce0cdebec9150cb3$export$74e4ae24825f68d7(75, 0, 0.1, 1000);
                if (!isCamera) {
                    camera.position.z = 5;
                    if (cameraOptions) {
                        $02a5e071daeb5f48$export$2408f22a0fab9ae5(camera, cameraOptions);
                        // Preserve user-defined frustum if possible
                        // https://github.com/pmndrs/react-three-fiber/issues/3160
                        if (!camera.manual) {
                            if ('aspect' in cameraOptions || 'left' in cameraOptions || 'right' in cameraOptions || 'bottom' in cameraOptions || 'top' in cameraOptions) {
                                camera.manual = true;
                                camera.updateProjectionMatrix();
                            }
                        }
                    }
                    // Always look at center by default
                    if (!state.camera && !(cameraOptions != null && cameraOptions.rotation)) camera.lookAt(0, 0, 0);
                }
                state.set({
                    camera: camera
                });
                // Configure raycaster
                // https://github.com/pmndrs/react-xr/issues/300
                raycaster.camera = camera;
            }
            // Set up scene (one time only!)
            if (!state.scene) {
                let scene;
                if (sceneOptions != null && sceneOptions.isScene) {
                    scene = sceneOptions;
                    $02a5e071daeb5f48$var$prepare(scene, store, '', {});
                } else {
                    scene = new $ce0cdebec9150cb3$export$38af1803e3442a7f();
                    $02a5e071daeb5f48$var$prepare(scene, store, '', {});
                    if (sceneOptions) $02a5e071daeb5f48$export$2408f22a0fab9ae5(scene, sceneOptions);
                }
                state.set({
                    scene: scene
                });
            }
            // Store events internally
            if (events && !state.events.handlers) state.set({
                events: events(store)
            });
            // Check size, allow it to take on container bounds initially
            const size = $02a5e071daeb5f48$var$computeInitialSize(canvas, propsSize);
            if (!$02a5e071daeb5f48$var$is.equ(size, state.size, $02a5e071daeb5f48$var$shallowLoose)) state.setSize(size.width, size.height, size.top, size.left);
            // Check pixelratio
            if (dpr && state.viewport.dpr !== $02a5e071daeb5f48$var$calculateDpr(dpr)) state.setDpr(dpr);
            // Check frameloop
            if (state.frameloop !== frameloop) state.setFrameloop(frameloop);
            // Check pointer missed
            if (!state.onPointerMissed) state.set({
                onPointerMissed: onPointerMissed
            });
            // Check performance
            if (performance && !$02a5e071daeb5f48$var$is.equ(performance, state.performance, $02a5e071daeb5f48$var$shallowLoose)) state.set((state)=>({
                    performance: {
                        ...state.performance,
                        ...performance
                    }
                }));
            // Set up XR (one time only!)
            if (!state.xr) {
                var _gl$xr;
                // Handle frame behavior in WebXR
                const handleXRFrame = (timestamp, frame)=>{
                    const state = store.getState();
                    if (state.frameloop === 'never') return;
                    $02a5e071daeb5f48$export$7ccc53e8f1e7dfc5(timestamp, true, state, frame);
                };
                // Toggle render switching on session
                const handleSessionChange = ()=>{
                    const state = store.getState();
                    state.gl.xr.enabled = state.gl.xr.isPresenting;
                    state.gl.xr.setAnimationLoop(state.gl.xr.isPresenting ? handleXRFrame : null);
                    if (!state.gl.xr.isPresenting) $02a5e071daeb5f48$export$953cecd6e717a553(state);
                };
                // WebXR session manager
                const xr = {
                    connect () {
                        const gl = store.getState().gl;
                        gl.xr.addEventListener('sessionstart', handleSessionChange);
                        gl.xr.addEventListener('sessionend', handleSessionChange);
                    },
                    disconnect () {
                        const gl = store.getState().gl;
                        gl.xr.removeEventListener('sessionstart', handleSessionChange);
                        gl.xr.removeEventListener('sessionend', handleSessionChange);
                    }
                };
                // Subscribe to WebXR session events
                if (typeof ((_gl$xr = gl.xr) == null ? void 0 : _gl$xr.addEventListener) === 'function') xr.connect();
                state.set({
                    xr: xr
                });
            }
            // Set shadowmap
            if (gl.shadowMap) {
                const oldEnabled = gl.shadowMap.enabled;
                const oldType = gl.shadowMap.type;
                gl.shadowMap.enabled = !!shadows;
                if ($02a5e071daeb5f48$var$is.boo(shadows)) gl.shadowMap.type = $ce0cdebec9150cb3$export$a47c4b43a1be34f0;
                else if ($02a5e071daeb5f48$var$is.str(shadows)) {
                    var _types$shadows;
                    const types = {
                        basic: $ce0cdebec9150cb3$export$346307dbae2b7447,
                        percentage: $ce0cdebec9150cb3$export$5813f879eee7cd88,
                        soft: $ce0cdebec9150cb3$export$a47c4b43a1be34f0,
                        variance: $ce0cdebec9150cb3$export$896ae1ade6c829c4
                    };
                    gl.shadowMap.type = (_types$shadows = types[shadows]) != null ? _types$shadows : $ce0cdebec9150cb3$export$a47c4b43a1be34f0;
                } else if ($02a5e071daeb5f48$var$is.obj(shadows)) Object.assign(gl.shadowMap, shadows);
                if (oldEnabled !== gl.shadowMap.enabled || oldType !== gl.shadowMap.type) gl.shadowMap.needsUpdate = true;
            }
            $ce0cdebec9150cb3$export$5e6fd513f44698c.enabled = !legacy;
            // Set color space and tonemapping preferences
            if (!configured) {
                gl.outputColorSpace = linear ? $ce0cdebec9150cb3$export$42429b3acfb233a4 : $ce0cdebec9150cb3$export$561f394b24edfcaa;
                gl.toneMapping = flat ? $ce0cdebec9150cb3$export$9fcb6b4294603b2 : $ce0cdebec9150cb3$export$a0d98fe6d7e4af64;
            }
            // Update color management state
            if (state.legacy !== legacy) state.set(()=>({
                    legacy: legacy
                }));
            if (state.linear !== linear) state.set(()=>({
                    linear: linear
                }));
            if (state.flat !== flat) state.set(()=>({
                    flat: flat
                }));
            // Set gl props
            if (glConfig && !$02a5e071daeb5f48$var$is.fun(glConfig) && !$02a5e071daeb5f48$var$isRenderer(glConfig) && !$02a5e071daeb5f48$var$is.equ(glConfig, gl, $02a5e071daeb5f48$var$shallowLoose)) $02a5e071daeb5f48$export$2408f22a0fab9ae5(gl, glConfig);
            // Set locals
            onCreated = onCreatedCallback;
            configured = true;
            resolve();
            return this;
        },
        render (children) {
            // The root has to be configured before it can be rendered
            if (!configured && !pending) this.configure();
            pending.then(()=>{
                $02a5e071daeb5f48$export$43caf9889c228507.updateContainer(/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($02a5e071daeb5f48$var$Provider, {
                    store: store,
                    children: children,
                    onCreated: onCreated,
                    rootElement: canvas
                }), fiber, null, ()=>undefined);
            });
            return store;
        },
        unmount () {
            $02a5e071daeb5f48$export$4368d992c4eafac0(canvas);
        }
    };
}
function $02a5e071daeb5f48$var$Provider({ store: store, children: children, onCreated: onCreated, rootElement: rootElement }) {
    $02a5e071daeb5f48$export$8b22cf2602fb60ce(()=>{
        const state = store.getState();
        // Flag the canvas active, rendering will now begin
        state.set((state)=>({
                internal: {
                    ...state.internal,
                    active: true
                }
            }));
        // Notify that init is completed, the scene graph exists, but nothing has yet rendered
        if (onCreated) onCreated(state);
        // Connect events to the targets parent, this is done to ensure events are registered on
        // a shared target, and not on the canvas itself
        if (!store.getState().events.connected) state.events.connect == null || state.events.connect(rootElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($02a5e071daeb5f48$export$9e5f44173e64f162.Provider, {
        value: store,
        children: children
    });
}
function $02a5e071daeb5f48$export$4368d992c4eafac0(canvas, callback) {
    const root = $02a5e071daeb5f48$export$71511d61b312f219.get(canvas);
    const fiber = root == null ? void 0 : root.fiber;
    if (fiber) {
        const state = root == null ? void 0 : root.store.getState();
        if (state) state.internal.active = false;
        $02a5e071daeb5f48$export$43caf9889c228507.updateContainer(null, fiber, null, ()=>{
            if (state) setTimeout(()=>{
                try {
                    var _state$gl, _state$gl$renderLists, _state$gl2, _state$gl3;
                    state.events.disconnect == null || state.events.disconnect();
                    (_state$gl = state.gl) == null || (_state$gl$renderLists = _state$gl.renderLists) == null || _state$gl$renderLists.dispose == null || _state$gl$renderLists.dispose();
                    (_state$gl2 = state.gl) == null || _state$gl2.forceContextLoss == null || _state$gl2.forceContextLoss();
                    if ((_state$gl3 = state.gl) != null && _state$gl3.xr) state.xr.disconnect();
                    $02a5e071daeb5f48$export$efccba1c4a2ef57b(state.scene);
                    $02a5e071daeb5f48$export$71511d61b312f219.delete(canvas);
                    if (callback) callback(canvas);
                } catch (e) {
                /* ... */ }
            }, 500);
        });
    }
}
function $02a5e071daeb5f48$export$ae1af26003f05816(children, container, state) {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($02a5e071daeb5f48$var$Portal, {
        children: children,
        container: container,
        state: state
    });
}
function $02a5e071daeb5f48$var$Portal({ state: state = {}, children: children, container: container }) {
    /** This has to be a component because it would not be able to call useThree/useStore otherwise since
   *  if this is our environment, then we are not in r3f's renderer but in react-dom, it would trigger
   *  the "R3F hooks can only be used within the Canvas component!" warning:
   *  <Canvas>
   *    {createPortal(...)} */ const { events: events, size: size, ...rest } = state;
    const previousRoot = $02a5e071daeb5f48$export$ebd11618f299a286();
    const [raycaster] = $2WGWz.useState(()=>new $ce0cdebec9150cb3$export$8b7aaceff00bd2f());
    const [pointer] = $2WGWz.useState(()=>new $ce0cdebec9150cb3$export$c977b3e384af9ae1());
    const inject = $02a5e071daeb5f48$export$407448d2b89b1813((rootState, injectState)=>{
        let viewport = undefined;
        if (injectState.camera && size) {
            const camera = injectState.camera;
            // Calculate the override viewport, if present
            viewport = rootState.viewport.getCurrentViewport(camera, new $ce0cdebec9150cb3$export$64b5c384219d3699(), size);
            // Update the portal camera, if it differs from the previous layer
            if (camera !== rootState.camera) $02a5e071daeb5f48$var$updateCamera(camera, size);
        }
        return {
            // The intersect consists of the previous root state
            ...rootState,
            ...injectState,
            // Portals have their own scene, which forms the root, a raycaster and a pointer
            scene: container,
            raycaster: raycaster,
            pointer: pointer,
            mouse: pointer,
            previousRoot: // Their previous root is the layer before it
            previousRoot,
            // Events, size and viewport can be overridden by the inject layer
            events: {
                ...rootState.events,
                ...injectState.events,
                ...events
            },
            size: {
                ...rootState.size,
                ...size
            },
            viewport: {
                ...rootState.viewport,
                ...viewport
            },
            // Layers are allowed to override events
            setEvents: (events)=>injectState.set((state)=>({
                        ...state,
                        events: {
                            ...state.events,
                            ...events
                        }
                    }))
        };
    });
    const usePortalStore = $2WGWz.useMemo(()=>{
        // Create a mirrored store, based on the previous root with a few overrides ...
        const store = (0, $ab264bb1b0f39ff6$export$c883e057baa24e24)((set, get)=>({
                ...rest,
                set: set,
                get: get
            }));
        // Subscribe to previous root-state and copy changes over to the mirrored portal-state
        const onMutate = (prev)=>store.setState((state)=>inject.current(prev, state));
        onMutate(previousRoot.getState());
        previousRoot.subscribe(onMutate);
        return store;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        previousRoot,
        container
    ]);
    return(/*#__PURE__*/ // @ts-ignore, reconciler types are not maintained
    (0, $419c6008abfcce61$exports.jsx)((0, $419c6008abfcce61$exports.Fragment), {
        children: $02a5e071daeb5f48$export$43caf9889c228507.createPortal(/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($02a5e071daeb5f48$export$9e5f44173e64f162.Provider, {
            value: usePortalStore,
            children: children
        }), usePortalStore, null)
    }));
}
/**
 * Force React to flush any updates inside the provided callback synchronously and immediately.
 * All the same caveats documented for react-dom's `flushSync` apply here (see https://react.dev/reference/react-dom/flushSync).
 * Nevertheless, sometimes one needs to render synchronously, for example to keep DOM and 3D changes in lock-step without
 * having to revert to a non-React solution. Note: this will only flush updates within the `Canvas` root.
 */ function $02a5e071daeb5f48$export$ffb5f4729a158638(fn) {
    // @ts-ignore - reconciler types are not maintained
    return $02a5e071daeb5f48$export$43caf9889c228507.flushSyncFromReconciler(fn);
}
function $02a5e071daeb5f48$var$createSubs(callback, subs) {
    const sub = {
        callback: callback
    };
    subs.add(sub);
    return ()=>void subs.delete(sub);
}
const $02a5e071daeb5f48$var$globalEffects = new Set();
const $02a5e071daeb5f48$var$globalAfterEffects = new Set();
const $02a5e071daeb5f48$var$globalTailEffects = new Set();
/**
 * Adds a global render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addEffect
 */ const $02a5e071daeb5f48$export$35e795649ee09318 = (callback)=>$02a5e071daeb5f48$var$createSubs(callback, $02a5e071daeb5f48$var$globalEffects);
/**
 * Adds a global after-render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addAfterEffect
 */ const $02a5e071daeb5f48$export$342063e11d6c3cad = (callback)=>$02a5e071daeb5f48$var$createSubs(callback, $02a5e071daeb5f48$var$globalAfterEffects);
/**
 * Adds a global callback which is called when rendering stops.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addTail
 */ const $02a5e071daeb5f48$export$882b5998b3b9117c = (callback)=>$02a5e071daeb5f48$var$createSubs(callback, $02a5e071daeb5f48$var$globalTailEffects);
function $02a5e071daeb5f48$var$run(effects, timestamp) {
    if (!effects.size) return;
    for (const { callback: callback } of effects.values())callback(timestamp);
}
function $02a5e071daeb5f48$export$dda1d9f60106f0e9(type, timestamp) {
    switch(type){
        case 'before':
            return $02a5e071daeb5f48$var$run($02a5e071daeb5f48$var$globalEffects, timestamp);
        case 'after':
            return $02a5e071daeb5f48$var$run($02a5e071daeb5f48$var$globalAfterEffects, timestamp);
        case 'tail':
            return $02a5e071daeb5f48$var$run($02a5e071daeb5f48$var$globalTailEffects, timestamp);
    }
}
let $02a5e071daeb5f48$var$subscribers;
let $02a5e071daeb5f48$var$subscription;
function $02a5e071daeb5f48$var$update(timestamp, state, frame) {
    // Run local effects
    let delta = state.clock.getDelta();
    // In frameloop='never' mode, clock times are updated using the provided timestamp
    if (state.frameloop === 'never' && typeof timestamp === 'number') {
        delta = timestamp - state.clock.elapsedTime;
        state.clock.oldTime = state.clock.elapsedTime;
        state.clock.elapsedTime = timestamp;
    }
    // Call subscribers (useFrame)
    $02a5e071daeb5f48$var$subscribers = state.internal.subscribers;
    for(let i = 0; i < $02a5e071daeb5f48$var$subscribers.length; i++){
        $02a5e071daeb5f48$var$subscription = $02a5e071daeb5f48$var$subscribers[i];
        $02a5e071daeb5f48$var$subscription.ref.current($02a5e071daeb5f48$var$subscription.store.getState(), delta, frame);
    }
    // Render content
    if (!state.internal.priority && state.gl.render) state.gl.render(state.scene, state.camera);
    // Decrease frame count
    state.internal.frames = Math.max(0, state.internal.frames - 1);
    return state.frameloop === 'always' ? 1 : state.internal.frames;
}
let $02a5e071daeb5f48$var$running = false;
let $02a5e071daeb5f48$var$useFrameInProgress = false;
let $02a5e071daeb5f48$var$repeat;
let $02a5e071daeb5f48$var$frame;
let $02a5e071daeb5f48$var$state;
function $02a5e071daeb5f48$var$loop(timestamp) {
    $02a5e071daeb5f48$var$frame = requestAnimationFrame($02a5e071daeb5f48$var$loop);
    $02a5e071daeb5f48$var$running = true;
    $02a5e071daeb5f48$var$repeat = 0;
    // Run effects
    $02a5e071daeb5f48$export$dda1d9f60106f0e9('before', timestamp);
    // Render all roots
    $02a5e071daeb5f48$var$useFrameInProgress = true;
    for (const root of $02a5e071daeb5f48$export$71511d61b312f219.values()){
        var _state$gl$xr;
        $02a5e071daeb5f48$var$state = root.store.getState();
        // If the frameloop is invalidated, do not run another frame
        if ($02a5e071daeb5f48$var$state.internal.active && ($02a5e071daeb5f48$var$state.frameloop === 'always' || $02a5e071daeb5f48$var$state.internal.frames > 0) && !((_state$gl$xr = $02a5e071daeb5f48$var$state.gl.xr) != null && _state$gl$xr.isPresenting)) $02a5e071daeb5f48$var$repeat += $02a5e071daeb5f48$var$update(timestamp, $02a5e071daeb5f48$var$state);
    }
    $02a5e071daeb5f48$var$useFrameInProgress = false;
    // Run after-effects
    $02a5e071daeb5f48$export$dda1d9f60106f0e9('after', timestamp);
    // Stop the loop if nothing invalidates it
    if ($02a5e071daeb5f48$var$repeat === 0) {
        // Tail call effects, they are called when rendering stops
        $02a5e071daeb5f48$export$dda1d9f60106f0e9('tail', timestamp);
        // Flag end of operation
        $02a5e071daeb5f48$var$running = false;
        return cancelAnimationFrame($02a5e071daeb5f48$var$frame);
    }
}
/**
 * Invalidates the view, requesting a frame to be rendered. Will globally invalidate unless passed a root's state.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#invalidate
 */ function $02a5e071daeb5f48$export$953cecd6e717a553(state, frames = 1) {
    var _state$gl$xr2;
    if (!state) return $02a5e071daeb5f48$export$71511d61b312f219.forEach((root)=>$02a5e071daeb5f48$export$953cecd6e717a553(root.store.getState(), frames));
    if ((_state$gl$xr2 = state.gl.xr) != null && _state$gl$xr2.isPresenting || !state.internal.active || state.frameloop === 'never') return;
    if (frames > 1) // legacy support for people using frames parameters
    // Increase frames, do not go higher than 60
    state.internal.frames = Math.min(60, state.internal.frames + frames);
    else if ($02a5e071daeb5f48$var$useFrameInProgress) //called from within a useFrame, it means the user wants an additional frame
    state.internal.frames = 2;
    else //the user need a new frame, no need to increment further than 1
    state.internal.frames = 1;
    // If the render-loop isn't active, start it
    if (!$02a5e071daeb5f48$var$running) {
        $02a5e071daeb5f48$var$running = true;
        requestAnimationFrame($02a5e071daeb5f48$var$loop);
    }
}
/**
 * Advances the frameloop and runs render effects, useful for when manually rendering via `frameloop="never"`.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#advance
 */ function $02a5e071daeb5f48$export$7ccc53e8f1e7dfc5(timestamp, runGlobalEffects = true, state, frame) {
    if (runGlobalEffects) $02a5e071daeb5f48$export$dda1d9f60106f0e9('before', timestamp);
    if (!state) for (const root of $02a5e071daeb5f48$export$71511d61b312f219.values())$02a5e071daeb5f48$var$update(timestamp, root.store.getState());
    else $02a5e071daeb5f48$var$update(timestamp, state, frame);
    if (runGlobalEffects) $02a5e071daeb5f48$export$dda1d9f60106f0e9('after', timestamp);
}
const $02a5e071daeb5f48$var$DOM_EVENTS = {
    onClick: [
        'click',
        false
    ],
    onContextMenu: [
        'contextmenu',
        false
    ],
    onDoubleClick: [
        'dblclick',
        false
    ],
    onWheel: [
        'wheel',
        true
    ],
    onPointerDown: [
        'pointerdown',
        true
    ],
    onPointerUp: [
        'pointerup',
        true
    ],
    onPointerLeave: [
        'pointerleave',
        true
    ],
    onPointerMove: [
        'pointermove',
        true
    ],
    onPointerCancel: [
        'pointercancel',
        true
    ],
    onLostPointerCapture: [
        'lostpointercapture',
        true
    ]
};
/** Default R3F event manager for web */ function $02a5e071daeb5f48$export$2d1720544b23b823(store) {
    const { handlePointer: handlePointer } = $02a5e071daeb5f48$export$39b482c5e57630a8(store);
    return {
        priority: 1,
        enabled: true,
        compute (event, state, previous) {
            // https://github.com/pmndrs/react-three-fiber/pull/782
            // Events trigger outside of canvas when moved, use offsetX/Y by default and allow overrides
            state.pointer.set(event.offsetX / state.size.width * 2 - 1, -(event.offsetY / state.size.height) * 2 + 1);
            state.raycaster.setFromCamera(state.pointer, state.camera);
        },
        connected: undefined,
        handlers: Object.keys($02a5e071daeb5f48$var$DOM_EVENTS).reduce((acc, key)=>({
                ...acc,
                [key]: handlePointer(key)
            }), {}),
        update: ()=>{
            var _internal$lastEvent;
            const { events: events, internal: internal } = store.getState();
            if ((_internal$lastEvent = internal.lastEvent) != null && _internal$lastEvent.current && events.handlers) events.handlers.onPointerMove(internal.lastEvent.current);
        },
        connect: (target)=>{
            const { set: set, events: events } = store.getState();
            events.disconnect == null || events.disconnect();
            set((state)=>({
                    events: {
                        ...state.events,
                        connected: target
                    }
                }));
            if (events.handlers) for(const name in events.handlers){
                const event = events.handlers[name];
                const [eventName, passive] = $02a5e071daeb5f48$var$DOM_EVENTS[name];
                target.addEventListener(eventName, event, {
                    passive: passive
                });
            }
        },
        disconnect: ()=>{
            const { set: set, events: events } = store.getState();
            if (events.connected) {
                if (events.handlers) for(const name in events.handlers){
                    const event = events.handlers[name];
                    const [eventName] = $02a5e071daeb5f48$var$DOM_EVENTS[name];
                    events.connected.removeEventListener(eventName, event);
                }
                set((state)=>({
                        events: {
                            ...state.events,
                            connected: undefined
                        }
                    }));
            }
        }
    };
}



var $2WGWz = parcelRequire("2WGWz");


var $2WGWz = parcelRequire("2WGWz");
function $011370b68e8caf36$var$g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function $011370b68e8caf36$export$2e2bcd8739ae039({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, $2WGWz.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, $2WGWz.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, $2WGWz.useRef)(!1);
    (0, $2WGWz.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, $2WGWz.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !$011370b68e8caf36$var$D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? $011370b68e8caf36$var$g(r, f) : r,
            d ? $011370b68e8caf36$var$g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = $011370b68e8caf36$var$E(r), b());
    };
    return $011370b68e8caf36$var$X(s, !!t), $011370b68e8caf36$var$W(m), (0, $2WGWz.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, $2WGWz.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function $011370b68e8caf36$var$W(n) {
    (0, $2WGWz.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function $011370b68e8caf36$var$X(n, t) {
    (0, $2WGWz.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function $011370b68e8caf36$var$E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...$011370b68e8caf36$var$E(n.parentElement)
    ];
}
const $011370b68e8caf36$var$k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $011370b68e8caf36$var$D = (n, t)=>$011370b68e8caf36$var$k.every((o)=>n[o] === t[o]);






parcelRequire("bIbqH");
function $eccc7fd3f3cbe7a9$var$CanvasImpl({ ref: ref, children: children, fallback: fallback, resize: resize, style: style, gl: gl, events: events = (0, $02a5e071daeb5f48$export$2d1720544b23b823), eventSource: eventSource, eventPrefix: eventPrefix, shadows: shadows, linear: linear, flat: flat, legacy: legacy, orthographic: orthographic, frameloop: frameloop, dpr: dpr, performance: performance, raycaster: raycaster, camera: camera, scene: scene, onPointerMissed: onPointerMissed, onCreated: onCreated, ...props }) {
    // Create a known catalogue of Threejs-native elements
    // This will include the entire THREE namespace by default, users can extend
    // their own elements by using the createRoot API instead
    $2WGWz.useMemo(()=>(0, $02a5e071daeb5f48$export$f1e1789686576879)($3b951febf8ab45a9$exports), []);
    const Bridge = (0, $02a5e071daeb5f48$export$3b14a55fb2447963)();
    const [containerRef, containerRect] = (0, $011370b68e8caf36$export$2e2bcd8739ae039)({
        scroll: true,
        debounce: {
            scroll: 50,
            resize: 0
        },
        ...resize
    });
    const canvasRef = $2WGWz.useRef(null);
    const divRef = $2WGWz.useRef(null);
    $2WGWz.useImperativeHandle(ref, ()=>canvasRef.current);
    const handlePointerMissed = (0, $02a5e071daeb5f48$export$407448d2b89b1813)(onPointerMissed);
    const [block, setBlock] = $2WGWz.useState(false);
    const [error, setError] = $2WGWz.useState(false);
    // Suspend this component if block is a promise (2nd run)
    if (block) throw block;
    // Throw exception outwards if anything within canvas throws
    if (error) throw error;
    const root = $2WGWz.useRef(null);
    (0, $02a5e071daeb5f48$export$8b22cf2602fb60ce)(()=>{
        const canvas = canvasRef.current;
        if (containerRect.width > 0 && containerRect.height > 0 && canvas) {
            if (!root.current) root.current = (0, $02a5e071daeb5f48$export$db3b6bfb95261072)(canvas);
            async function run() {
                await root.current.configure({
                    gl: gl,
                    scene: scene,
                    events: events,
                    shadows: shadows,
                    linear: linear,
                    flat: flat,
                    legacy: legacy,
                    orthographic: orthographic,
                    frameloop: frameloop,
                    dpr: dpr,
                    performance: performance,
                    raycaster: raycaster,
                    camera: camera,
                    size: containerRect,
                    // Pass mutable reference to onPointerMissed so it's free to update
                    onPointerMissed: (...args)=>handlePointerMissed.current == null ? void 0 : handlePointerMissed.current(...args),
                    onCreated: (state)=>{
                        // Connect to event source
                        state.events.connect == null || state.events.connect(eventSource ? (0, $02a5e071daeb5f48$export$23f2a1d2818174ef)(eventSource) ? eventSource.current : eventSource : divRef.current);
                        // Set up compute function
                        if (eventPrefix) state.setEvents({
                            compute: (event, state)=>{
                                const x = event[eventPrefix + 'X'];
                                const y = event[eventPrefix + 'Y'];
                                state.pointer.set(x / state.size.width * 2 - 1, -(y / state.size.height) * 2 + 1);
                                state.raycaster.setFromCamera(state.pointer, state.camera);
                            }
                        });
                        // Call onCreated callback
                        onCreated == null || onCreated(state);
                    }
                });
                root.current.render(/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(Bridge, {
                    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $02a5e071daeb5f48$export$a9c23c6ac3fc3eca), {
                        set: setError,
                        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($2WGWz.Suspense, {
                            fallback: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $02a5e071daeb5f48$export$ef35774e6d314e91), {
                                set: setBlock
                            }),
                            children: children != null ? children : null
                        })
                    })
                }));
            }
            run();
        }
    });
    $2WGWz.useEffect(()=>{
        const canvas = canvasRef.current;
        if (canvas) return ()=>(0, $02a5e071daeb5f48$export$4368d992c4eafac0)(canvas);
    }, []);
    // When the event source is not this div, we need to set pointer-events to none
    // Or else the canvas will block events from reaching the event source
    const pointerEvents = eventSource ? 'none' : 'auto';
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
        ref: divRef,
        style: {
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            pointerEvents: pointerEvents,
            ...style
        },
        ...props,
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
            ref: containerRef,
            style: {
                width: '100%',
                height: '100%'
            },
            children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    display: 'block'
                },
                children: fallback
            })
        })
    });
}
/**
 * A DOM canvas which accepts threejs elements as children.
 * @see https://docs.pmnd.rs/react-three-fiber/api/canvas
 */ function $eccc7fd3f3cbe7a9$export$8d01c972ee8b14a9(props) {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $b76b7764c0739eb0$export$5a20fcbfd44d38b7), {
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($eccc7fd3f3cbe7a9$var$CanvasImpl, {
            ...props
        })
    });
}




var $2WGWz = parcelRequire("2WGWz");


/**
 * postprocessing v6.39.0 build Fri Mar 20 2026
 * https://github.com/pmndrs/postprocessing
 * Copyright 2015-2026 Raoul van Rüschen
 * @license Zlib
 */ // package.json

var $2046da3312f94030$export$83d89fbfd8236492 = "6.39.0";
// src/core/Disposable.js
var $2046da3312f94030$export$252720412a173de = class {
    /**
   * Frees internal resources.
   */ dispose() {}
};
var $2046da3312f94030$var$fullscreenGeometry = /* @__PURE__ */ (()=>{
    const vertices = new Float32Array([
        -1,
        -1,
        0,
        3,
        -1,
        0,
        -1,
        3,
        0
    ]);
    const uvs = new Float32Array([
        0,
        0,
        2,
        0,
        0,
        2
    ]);
    const geometry = new (0, $ce0cdebec9150cb3$export$b7be63a67df8959)();
    geometry.setAttribute("position", new (0, $ce0cdebec9150cb3$export$8dea267bd6bde117)(vertices, 3));
    geometry.setAttribute("uv", new (0, $ce0cdebec9150cb3$export$8dea267bd6bde117)(uvs, 2));
    return geometry;
})();
var $2046da3312f94030$export$802bc10488da99c7 = class _Pass {
    /**
   * A shared fullscreen triangle.
   *
   * The screen size is 2x2 units (NDC). A triangle needs to be 4x4 units to fill the screen.
   * @see https://michaldrobot.com/2014/04/01/gcn-execution-patterns-in-full-screen-passes/
   * @type {BufferGeometry}
   * @internal
   */ static get fullscreenGeometry() {
        return $2046da3312f94030$var$fullscreenGeometry;
    }
    /**
   * Constructs a new pass.
   *
   * @param {String} [name] - The name of this pass. Does not have to be unique.
   * @param {Scene} [scene] - The scene to render. The default scene contains a single mesh that fills the screen.
   * @param {Camera} [camera] - A camera. Fullscreen effect passes don't require a camera.
   */ constructor(name = "Pass", scene = new (0, $ce0cdebec9150cb3$export$38af1803e3442a7f)(), camera = new (0, $ce0cdebec9150cb3$export$9ebf355ee4ed261b)()){
        this.name = name;
        this.renderer = null;
        this.scene = scene;
        this.camera = camera;
        this.screen = null;
        this.rtt = true;
        this.needsSwap = true;
        this.needsDepthBlit = false;
        this.needsDepthTexture = false;
        this.enabled = true;
    }
    /**
   * Sets the render to screen flag.
   *
   * If this flag is changed, the fullscreen material will be updated as well.
   *
   * @type {Boolean}
   */ get renderToScreen() {
        return !this.rtt;
    }
    set renderToScreen(value) {
        if (this.rtt === value) {
            const material = this.fullscreenMaterial;
            if (material !== null) material.needsUpdate = true;
            this.rtt = !value;
        }
    }
    /**
   * Sets the main scene.
   *
   * @type {Scene}
   */ set mainScene(value) {}
    /**
   * Sets the main camera.
   *
   * @type {Camera}
   */ set mainCamera(value) {}
    /**
   * Sets the renderer
   *
   * @deprecated
   * @param {WebGLRenderer} renderer - The renderer.
   */ setRenderer(renderer) {
        this.renderer = renderer;
    }
    /**
   * Indicates whether this pass is enabled.
   *
   * @deprecated Use enabled instead.
   * @return {Boolean} Whether this pass is enabled.
   */ isEnabled() {
        return this.enabled;
    }
    /**
   * Enables or disables this pass.
   *
   * @deprecated Use enabled instead.
   * @param {Boolean} value - Whether the pass should be enabled.
   */ setEnabled(value) {
        this.enabled = value;
    }
    /**
   * The fullscreen material.
   *
   * @type {Material}
   */ get fullscreenMaterial() {
        return this.screen !== null ? this.screen.material : null;
    }
    set fullscreenMaterial(value) {
        let screen = this.screen;
        if (screen !== null) screen.material = value;
        else {
            screen = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)(_Pass.fullscreenGeometry, value);
            screen.frustumCulled = false;
            if (this.scene === null) this.scene = new (0, $ce0cdebec9150cb3$export$38af1803e3442a7f)();
            this.scene.add(screen);
            this.screen = screen;
        }
    }
    /**
   * Returns the current fullscreen material.
   *
   * @deprecated Use fullscreenMaterial instead.
   * @return {Material} The current fullscreen material, or null if there is none.
   */ getFullscreenMaterial() {
        return this.fullscreenMaterial;
    }
    /**
   * Sets the fullscreen material.
   *
   * @deprecated Use fullscreenMaterial instead.
   * @protected
   * @param {Material} value - A fullscreen material.
   */ setFullscreenMaterial(value) {
        this.fullscreenMaterial = value;
    }
    /**
   * Returns the current depth texture.
   *
   * @return {Texture} The current depth texture, or null if there is none.
   */ getDepthTexture() {
        return null;
    }
    /**
   * Sets the depth texture.
   *
   * This method will be called automatically by the {@link EffectComposer}.
   * You may override this method if your pass relies on the depth information of a preceding {@link RenderPass}.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategy} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {}
    /**
   * Renders this pass.
   *
   * This is an abstract method that must be overridden.
   *
   * @abstract
   * @throws {Error} An error is thrown if the method is not overridden.
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        throw new Error("Render method not implemented!");
    }
    /**
   * Sets the size.
   *
   * You may override this method if you want to be informed about the size of the backbuffer/canvas.
   * This method is called before {@link initialize} and every time the size of the {@link EffectComposer} changes.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {}
    /**
   * Performs initialization tasks.
   *
   * This method is called when this pass is added to an {@link EffectComposer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {}
    /**
   * Performs a shallow search for disposable properties and deletes them.
   *
   * The {@link EffectComposer} calls this method when it is being destroyed. You can use it independently to free
   * memory when you're certain that you don't need this pass anymore.
   */ dispose() {
        for (const key of Object.keys(this)){
            const property = this[key];
            const isDisposable = property instanceof (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f) || property instanceof (0, $ce0cdebec9150cb3$export$a2d8b23205c25948) || property instanceof (0, $ce0cdebec9150cb3$export$5431306cf43de24a) || property instanceof _Pass;
            if (isDisposable) this[key].dispose();
        }
        if (this.fullscreenMaterial !== null) this.fullscreenMaterial.dispose();
    }
};
// src/passes/ClearMaskPass.js
var $2046da3312f94030$export$8d8650aed29c6251 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new clear mask pass.
   */ constructor(){
        super("ClearMaskPass", null, null);
        this.needsSwap = false;
    }
    /**
   * Disables the global stencil test.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const stencil = renderer.state.buffers.stencil;
        stencil.setLocked(false);
        stencil.setTest(false);
    }
};
// src/materials/glsl/copy.frag
var $2046da3312f94030$var$copy_default = `#ifdef COLOR_WRITE
#include <common>
#include <dithering_pars_fragment>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#endif
#ifdef DEPTH_WRITE
#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}
#endif
#ifdef USE_WEIGHTS
uniform vec4 channelWeights;
#endif
uniform float opacity;varying vec2 vUv;void main(){
#ifdef COLOR_WRITE
vec4 texel=texture2D(inputBuffer,vUv);
#ifdef USE_WEIGHTS
texel*=channelWeights;
#endif
gl_FragColor=opacity*texel;
#ifdef COLOR_SPACE_CONVERSION
#include <colorspace_fragment>
#endif
#include <dithering_fragment>
#else
gl_FragColor=vec4(0.0);
#endif
#ifdef DEPTH_WRITE
gl_FragDepth=readDepth(vUv);
#endif
}`;
// src/materials/glsl/common.vert
var $2046da3312f94030$var$common_default = `varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/CopyMaterial.js
var $2046da3312f94030$export$d4b5f24bda67f7e4 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new copy material.
   */ constructor(){
        super({
            name: "CopyMaterial",
            defines: {
                COLOR_SPACE_CONVERSION: "1",
                DEPTH_PACKING: "0",
                COLOR_WRITE: "1"
            },
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                depthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                channelWeights: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                opacity: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$copy_default,
            vertexShader: $2046da3312f94030$var$common_default
        });
        this.depthFunc = (0, $ce0cdebec9150cb3$export$7182eb52ea3b3f04);
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ get inputBuffer() {
        return this.uniforms.inputBuffer.value;
    }
    set inputBuffer(value) {
        const colorWrite = value !== null;
        if (this.colorWrite !== colorWrite) {
            if (colorWrite) this.defines.COLOR_WRITE = true;
            else delete this.defines.COLOR_WRITE;
            this.colorWrite = colorWrite;
            this.needsUpdate = true;
        }
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * A depth buffer.
   *
   * @type {Texture}
   */ get depthBuffer() {
        return this.uniforms.depthBuffer.value;
    }
    set depthBuffer(value) {
        const depthWrite = value !== null;
        if (this.depthWrite !== depthWrite) {
            if (depthWrite) this.defines.DEPTH_WRITE = true;
            else delete this.defines.DEPTH_WRITE;
            this.depthTest = depthWrite;
            this.depthWrite = depthWrite;
            this.needsUpdate = true;
        }
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy of the depth buffer.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Indicates whether output color space conversion is enabled.
   *
   * @type {Boolean}
   */ get colorSpaceConversion() {
        return this.defines.COLOR_SPACE_CONVERSION !== void 0;
    }
    set colorSpaceConversion(value) {
        if (this.colorSpaceConversion !== value) {
            if (value) this.defines.COLOR_SPACE_CONVERSION = true;
            else delete this.defines.COLOR_SPACE_CONVERSION;
            this.needsUpdate = true;
        }
    }
    /**
   * Color channel weights that modulate texels from the input buffer.
   *
   * Set to `null` to disable.
   *
   * @type {Vector4 | null}
   */ get channelWeights() {
        return this.uniforms.channelWeights.value;
    }
    set channelWeights(value) {
        if (value !== null) {
            this.defines.USE_WEIGHTS = "1";
            this.uniforms.channelWeights.value = value;
        } else delete this.defines.USE_WEIGHTS;
        this.needsUpdate = true;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Number} value - The buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Returns the opacity.
   *
   * @deprecated Use opacity instead.
   * @return {Number} The opacity.
   */ getOpacity(value) {
        return this.uniforms.opacity.value;
    }
    /**
   * Sets the opacity.
   *
   * @deprecated Use opacity instead.
   * @param {Number} value - The opacity.
   */ setOpacity(value) {
        this.uniforms.opacity.value = value;
    }
};
// src/passes/CopyPass.js
var $2046da3312f94030$export$ec9e16bd0f76e979 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new save pass.
   *
   * @param {WebGLRenderTarget} [renderTarget] - A render target.
   * @param {Boolean} [autoResize=true] - Whether the render target size should be updated automatically.
   */ constructor(renderTarget, autoResize = true){
        super("CopyPass");
        this.fullscreenMaterial = new $2046da3312f94030$export$d4b5f24bda67f7e4();
        this.needsSwap = false;
        this.renderTarget = renderTarget;
        if (renderTarget === void 0) {
            this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
                minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
                magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
                stencilBuffer: false,
                depthBuffer: false
            });
            this.renderTarget.texture.name = "CopyPass.Target";
        }
        this.autoResize = autoResize;
    }
    /**
   * Enables or disables auto resizing of the render target.
   *
   * @deprecated Use autoResize instead.
   * @type {Boolean}
   */ get resize() {
        return this.autoResize;
    }
    set resize(value) {
        this.autoResize = value;
    }
    /**
   * The output texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the output texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Enables or disables auto resizing of the render target.
   *
   * @deprecated Use autoResize instead.
   * @param {Boolean} value - Whether the render target size should be updated automatically.
   */ setAutoResizeEnabled(value) {
        this.autoResize = value;
    }
    /**
   * Saves the input buffer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        this.fullscreenMaterial.inputBuffer = inputBuffer.texture;
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        if (this.autoResize) this.renderTarget.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - A renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0) {
            this.renderTarget.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            else if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) this.renderTarget.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
        }
    }
};
var $2046da3312f94030$var$color = /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)();
var $2046da3312f94030$export$fc4180e277a6a0c2 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new clear pass.
   *
   * @param {Boolean} [color=true] - Determines whether the color buffer should be cleared.
   * @param {Boolean} [depth=true] - Determines whether the depth buffer should be cleared.
   * @param {Boolean} [stencil=false] - Determines whether the stencil buffer should be cleared.
   */ constructor(color2 = true, depth = true, stencil = false){
        super("ClearPass", null, null);
        this.needsSwap = false;
        this.color = color2;
        this.depth = depth;
        this.stencil = stencil;
        this.overrideClearColor = null;
        this.overrideClearAlpha = -1;
    }
    /**
   * Sets the clear flags.
   *
   * @param {Boolean} color - Whether the color buffer should be cleared.
   * @param {Boolean} depth - Whether the depth buffer should be cleared.
   * @param {Boolean} stencil - Whether the stencil buffer should be cleared.
   */ setClearFlags(color2, depth, stencil) {
        this.color = color2;
        this.depth = depth;
        this.stencil = stencil;
    }
    /**
   * Returns the override clear color. Default is null.
   *
   * @deprecated Use overrideClearColor instead.
   * @return {Color} The clear color.
   */ getOverrideClearColor() {
        return this.overrideClearColor;
    }
    /**
   * Sets the override clear color.
   *
   * @deprecated Use overrideClearColor instead.
   * @param {Color} value - The clear color.
   */ setOverrideClearColor(value) {
        this.overrideClearColor = value;
    }
    /**
   * Returns the override clear alpha. Default is -1.
   *
   * @deprecated Use overrideClearAlpha instead.
   * @return {Number} The clear alpha.
   */ getOverrideClearAlpha() {
        return this.overrideClearAlpha;
    }
    /**
   * Sets the override clear alpha.
   *
   * @deprecated Use overrideClearAlpha instead.
   * @param {Number} value - The clear alpha.
   */ setOverrideClearAlpha(value) {
        this.overrideClearAlpha = value;
    }
    /**
   * Clears the input buffer or the screen.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const overrideClearColor = this.overrideClearColor;
        const overrideClearAlpha = this.overrideClearAlpha;
        const clearAlpha = renderer.getClearAlpha();
        const hasOverrideClearColor = overrideClearColor !== null;
        const hasOverrideClearAlpha = overrideClearAlpha >= 0;
        if (hasOverrideClearColor) {
            renderer.getClearColor($2046da3312f94030$var$color);
            renderer.setClearColor(overrideClearColor, hasOverrideClearAlpha ? overrideClearAlpha : clearAlpha);
        } else if (hasOverrideClearAlpha) renderer.setClearAlpha(overrideClearAlpha);
        renderer.setRenderTarget(this.renderToScreen ? null : inputBuffer);
        renderer.clear(this.color, this.depth, this.stencil);
        if (hasOverrideClearColor) renderer.setClearColor($2046da3312f94030$var$color, clearAlpha);
        else if (hasOverrideClearAlpha) renderer.setClearAlpha(clearAlpha);
    }
};
// src/passes/MaskPass.js
var $2046da3312f94030$export$bb424a4005d6dde0 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new mask pass.
   *
   * @param {Scene} scene - The scene to render.
   * @param {Camera} camera - The camera to use.
   */ constructor(scene, camera){
        super("MaskPass", scene, camera);
        this.needsSwap = false;
        this.clearPass = new $2046da3312f94030$export$fc4180e277a6a0c2(false, false, true);
        this.inverse = false;
    }
    set mainScene(value) {
        this.scene = value;
    }
    set mainCamera(value) {
        this.camera = value;
    }
    /**
   * Indicates whether the mask should be inverted.
   *
   * @type {Boolean}
   */ get inverted() {
        return this.inverse;
    }
    set inverted(value) {
        this.inverse = value;
    }
    /**
   * Indicates whether this pass should clear the stencil buffer.
   *
   * @type {Boolean}
   * @deprecated Use clearPass.enabled instead.
   */ get clear() {
        return this.clearPass.enabled;
    }
    set clear(value) {
        this.clearPass.enabled = value;
    }
    /**
   * Returns the internal clear pass.
   *
   * @deprecated Use clearPass.enabled instead.
   * @return {ClearPass} The clear pass.
   */ getClearPass() {
        return this.clearPass;
    }
    /**
   * Indicates whether the mask is inverted.
   *
   * @deprecated Use inverted instead.
   * @return {Boolean} Whether the mask is inverted.
   */ isInverted() {
        return this.inverted;
    }
    /**
   * Enables or disable mask inversion.
   *
   * @deprecated Use inverted instead.
   * @param {Boolean} value - Whether the mask should be inverted.
   */ setInverted(value) {
        this.inverted = value;
    }
    /**
   * Renders the effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const context = renderer.getContext();
        const buffers = renderer.state.buffers;
        const scene = this.scene;
        const camera = this.camera;
        const clearPass = this.clearPass;
        const writeValue = this.inverted ? 0 : 1;
        const clearValue = 1 - writeValue;
        buffers.color.setMask(false);
        buffers.depth.setMask(false);
        buffers.color.setLocked(true);
        buffers.depth.setLocked(true);
        buffers.stencil.setTest(true);
        buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
        buffers.stencil.setFunc(context.ALWAYS, writeValue, 4294967295);
        buffers.stencil.setClear(clearValue);
        buffers.stencil.setLocked(true);
        if (this.clearPass.enabled) {
            if (this.renderToScreen) clearPass.render(renderer, null);
            else {
                clearPass.render(renderer, inputBuffer);
                clearPass.render(renderer, outputBuffer);
            }
        }
        if (this.renderToScreen) {
            renderer.setRenderTarget(null);
            renderer.render(scene, camera);
        } else {
            renderer.setRenderTarget(inputBuffer);
            renderer.render(scene, camera);
            renderer.setRenderTarget(outputBuffer);
            renderer.render(scene, camera);
        }
        buffers.color.setLocked(false);
        buffers.depth.setLocked(false);
        buffers.stencil.setLocked(false);
        buffers.stencil.setFunc(context.EQUAL, 1, 4294967295);
        buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
        buffers.stencil.setLocked(true);
    }
};
// src/core/Timer.js
var $2046da3312f94030$var$MILLISECONDS_TO_SECONDS = 0.001;
var $2046da3312f94030$var$SECONDS_TO_MILLISECONDS = 1e3;
var $2046da3312f94030$export$c57e9b2d8b9e4de = class {
    /**
   * Constructs a new timer.
   */ constructor(){
        this.startTime = performance.now();
        this.previousTime = 0;
        this.currentTime = 0;
        this._delta = 0;
        this._elapsed = 0;
        this._fixedDelta = 1e3 / 60;
        this.timescale = 1;
        this.useFixedDelta = false;
        this._autoReset = false;
    }
    /**
   * Enables or disables auto reset based on page visibility.
   *
   * If enabled, the timer will be reset when the page becomes visible. This effectively pauses the timer when the page
   * is hidden. Has no effect if the API is not supported.
   *
   * @type {Boolean}
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
   */ get autoReset() {
        return this._autoReset;
    }
    set autoReset(value) {
        if (typeof document !== "undefined" && document.hidden !== void 0) {
            if (value) document.addEventListener("visibilitychange", this);
            else document.removeEventListener("visibilitychange", this);
            this._autoReset = value;
        }
    }
    get delta() {
        return this._delta * $2046da3312f94030$var$MILLISECONDS_TO_SECONDS;
    }
    get fixedDelta() {
        return this._fixedDelta * $2046da3312f94030$var$MILLISECONDS_TO_SECONDS;
    }
    set fixedDelta(value) {
        this._fixedDelta = value * $2046da3312f94030$var$SECONDS_TO_MILLISECONDS;
    }
    get elapsed() {
        return this._elapsed * $2046da3312f94030$var$MILLISECONDS_TO_SECONDS;
    }
    /**
   * Updates this timer.
   *
   * @param {Boolean} [timestamp] - The current time in milliseconds.
   */ update(timestamp) {
        if (this.useFixedDelta) this._delta = this.fixedDelta;
        else {
            this.previousTime = this.currentTime;
            this.currentTime = (timestamp !== void 0 ? timestamp : performance.now()) - this.startTime;
            this._delta = this.currentTime - this.previousTime;
        }
        this._delta *= this.timescale;
        this._elapsed += this._delta;
    }
    /**
   * Resets this timer.
   */ reset() {
        this._delta = 0;
        this._elapsed = 0;
        this.currentTime = performance.now() - this.startTime;
    }
    getDelta() {
        return this.delta;
    }
    getElapsed() {
        return this.elapsed;
    }
    handleEvent(e) {
        if (!document.hidden) this.currentTime = performance.now() - this.startTime;
    }
    dispose() {
        this.autoReset = false;
    }
};
// src/core/EffectComposer.js
var $2046da3312f94030$export$7fe01e6ab8aa748c = class {
    /**
   * Constructs a new effect composer.
   *
   * @param {WebGLRenderer} renderer - The renderer that should be used.
   * @param {Object} [options] - The options.
   * @param {Boolean} [options.depthBuffer=true] - Whether the main render targets should have a depth buffer.
   * @param {Boolean} [options.stencilBuffer=false] - Whether the main render targets should have a stencil buffer.
   * @param {Number} [options.multisampling=0] - The number of samples used for multisample antialiasing. Requires WebGL 2.
   * @param {Number} [options.frameBufferType] - The type of the internal frame buffers. It's recommended to use HalfFloatType if possible.
   */ constructor(renderer = null, { depthBuffer: depthBuffer = true, stencilBuffer: stencilBuffer = false, multisampling: multisampling = 0, frameBufferType: frameBufferType } = {}){
        this.renderer = null;
        this.inputBuffer = this.createBuffer(depthBuffer, stencilBuffer, frameBufferType, multisampling);
        this.outputBuffer = this.inputBuffer.clone();
        this.copyPass = new $2046da3312f94030$export$ec9e16bd0f76e979();
        this.depthTexture = null;
        this.depthRenderTarget = null;
        this.passes = [];
        this.timer = new $2046da3312f94030$export$c57e9b2d8b9e4de();
        this.autoRenderToScreen = true;
        this.setRenderer(renderer);
    }
    /**
   * The current amount of samples used for multisample anti-aliasing.
   *
   * @type {Number}
   */ get multisampling() {
        return this.inputBuffer.samples;
    }
    /**
   * Sets the amount of MSAA samples.
   *
   * Requires WebGL 2. Set to zero to disable multisampling.
   *
   * @type {Number}
   */ set multisampling(value) {
        const buffer = this.inputBuffer;
        const multisampling = this.multisampling;
        if (multisampling > 0 && value > 0) {
            this.inputBuffer.samples = value;
            this.outputBuffer.samples = value;
            this.inputBuffer.dispose();
            this.outputBuffer.dispose();
        } else if (multisampling !== value) {
            this.inputBuffer.dispose();
            this.outputBuffer.dispose();
            this.inputBuffer = this.createBuffer(buffer.depthBuffer, buffer.stencilBuffer, buffer.texture.type, value);
            this.outputBuffer = this.inputBuffer.clone();
        }
    }
    /**
   * Returns the internal timer.
   *
   * @return {Timer} The timer.
   */ getTimer() {
        return this.timer;
    }
    /**
   * Returns the renderer.
   *
   * @return {WebGLRenderer} The renderer.
   */ getRenderer() {
        return this.renderer;
    }
    /**
   * Sets the renderer.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   */ setRenderer(renderer) {
        this.renderer = renderer;
        if (renderer !== null) {
            const size = renderer.getSize(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)());
            const alpha = renderer.getContext().getContextAttributes().alpha;
            const frameBufferType = this.inputBuffer.texture.type;
            if (frameBufferType === (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10) && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) {
                this.inputBuffer.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.outputBuffer.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.inputBuffer.dispose();
                this.outputBuffer.dispose();
            }
            renderer.autoClear = false;
            this.setSize(size.width, size.height);
            for (const pass of this.passes)pass.initialize(renderer, alpha, frameBufferType);
        }
    }
    /**
   * Replaces the current renderer with the given one.
   *
   * The auto clear mechanism of the provided renderer will be disabled. If the new render size differs from the
   * previous one, all passes will be updated.
   *
   * By default, the DOM element of the current renderer will automatically be removed from its parent node and the DOM
   * element of the new renderer will take its place.
   *
   * @deprecated Use setRenderer instead.
   * @param {WebGLRenderer} renderer - The new renderer.
   * @param {Boolean} updateDOM - Indicates whether the old canvas should be replaced by the new one in the DOM.
   * @return {WebGLRenderer} The old renderer.
   */ replaceRenderer(renderer, updateDOM = true) {
        const oldRenderer = this.renderer;
        const parent = oldRenderer.domElement.parentNode;
        this.setRenderer(renderer);
        if (updateDOM && parent !== null) {
            parent.removeChild(oldRenderer.domElement);
            parent.appendChild(renderer.domElement);
        }
        return oldRenderer;
    }
    /**
   * Creates a depth texture attachment that will be provided to all passes.
   *
   * To prevent errors or incorrect behavior when the same depth buffer is attached to the input and output buffers,
   * a separate stable depth target is created alongside the ping-pong buffers.  All passes receive the stable target's
   * depth texture, which is never used as a render output and therefore cannot create a feedback loop.  The stable
   * texture is populated each frame via blitFramebuffer immediately before the first buffer swap.
   *
   * @private
   * @return {DepthTexture} The stable depth texture distributed to passes.
   */ createDepthTexture() {
        const inputBuffer = this.inputBuffer;
        const depthTexture = new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)();
        this.depthTexture = depthTexture;
        if (inputBuffer.stencilBuffer) {
            depthTexture.format = (0, $ce0cdebec9150cb3$export$1e113ac2d0905829);
            depthTexture.type = (0, $ce0cdebec9150cb3$export$6c8ea339bfab1301);
        } else depthTexture.type = (0, $ce0cdebec9150cb3$export$f6d331659b644596);
        const stableDepthTexture = depthTexture.clone();
        stableDepthTexture.name = "EffectComposer.StableDepth";
        this.depthRenderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(inputBuffer.width, inputBuffer.height, {
            depthBuffer: true,
            stencilBuffer: inputBuffer.stencilBuffer,
            depthTexture: stableDepthTexture
        });
        return stableDepthTexture;
    }
    /**
   * Copies the depth buffer from the src render target into the stable depth target.
   *
   * @private
   * @param {WebGLRenderTarget} renderTarget - The render target whose depth buffer should be copied.
   */ blitDepthBuffer(renderTarget) {
        const renderer = this.renderer;
        const depthRenderTarget = this.depthRenderTarget;
        const props = renderer.properties;
        const gl = renderer.getContext();
        renderer.setRenderTarget(depthRenderTarget);
        const srcFBO = props.get(renderTarget).__webglFramebuffer;
        const dstFBO = props.get(depthRenderTarget).__webglFramebuffer;
        const blitMask = renderTarget.stencilBuffer ? gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT : gl.DEPTH_BUFFER_BIT;
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, srcFBO);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, dstFBO);
        gl.blitFramebuffer(0, 0, renderTarget.width, renderTarget.height, 0, 0, depthRenderTarget.width, depthRenderTarget.height, blitMask, gl.NEAREST);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        renderer.setRenderTarget(null);
    }
    /**
   * Deletes the current depth texture.
   *
   * @private
   */ deleteDepthTexture() {
        if (this.depthTexture !== null) {
            this.depthTexture.dispose();
            this.depthTexture = null;
            this.depthRenderTarget.dispose();
            this.depthRenderTarget = null;
            this.inputBuffer.depthTexture = null;
            this.outputBuffer.depthTexture = null;
            for (const pass of this.passes)pass.setDepthTexture(null);
        }
    }
    /**
   * Creates a new render target.
   *
   * @private
   * @param {Boolean} depthBuffer - Whether the render target should have a depth buffer.
   * @param {Boolean} stencilBuffer - Whether the render target should have a stencil buffer.
   * @param {Number} type - The frame buffer type.
   * @param {Number} multisampling - The number of samples to use for antialiasing.
   * @return {WebGLRenderTarget} A new render target that equals the renderer's canvas.
   */ createBuffer(depthBuffer, stencilBuffer, type, multisampling) {
        const renderer = this.renderer;
        const size = renderer === null ? new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)() : renderer.getDrawingBufferSize(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)());
        const options = {
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            stencilBuffer: stencilBuffer,
            depthBuffer: depthBuffer,
            type: type
        };
        const renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(size.width, size.height, options);
        if (multisampling > 0) renderTarget.samples = multisampling;
        if (type === (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10) && renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) renderTarget.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
        renderTarget.texture.name = "EffectComposer.Buffer";
        renderTarget.texture.generateMipmaps = false;
        return renderTarget;
    }
    /**
   * Can be used to change the main scene for all registered passes and effects.
   *
   * @param {Scene} scene - The scene.
   */ setMainScene(scene) {
        for (const pass of this.passes)pass.mainScene = scene;
    }
    /**
   * Can be used to change the main camera for all registered passes and effects.
   *
   * @param {Camera} camera - The camera.
   */ setMainCamera(camera) {
        for (const pass of this.passes)pass.mainCamera = camera;
    }
    /**
   * Adds a pass, optionally at a specific index.
   *
   * @param {Pass} pass - A new pass.
   * @param {Number} [index] - An index at which the pass should be inserted.
   */ addPass(pass, index) {
        const passes = this.passes;
        const renderer = this.renderer;
        const drawingBufferSize = renderer.getDrawingBufferSize(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)());
        const alpha = renderer.getContext().getContextAttributes().alpha;
        const frameBufferType = this.inputBuffer.texture.type;
        pass.renderer = renderer;
        pass.setSize(drawingBufferSize.width, drawingBufferSize.height);
        pass.initialize(renderer, alpha, frameBufferType);
        if (this.autoRenderToScreen) {
            if (passes.length > 0) passes[passes.length - 1].renderToScreen = false;
            if (pass.renderToScreen) this.autoRenderToScreen = false;
        }
        if (index !== void 0) passes.splice(index, 0, pass);
        else passes.push(pass);
        if (this.autoRenderToScreen) passes[passes.length - 1].renderToScreen = true;
        if (pass.needsDepthTexture || this.depthTexture !== null) {
            if (this.depthTexture === null) {
                const stableDepthTexture = this.createDepthTexture();
                for (pass of passes)pass.setDepthTexture(stableDepthTexture);
            } else {
                const stableDepthTexture = this.depthRenderTarget.depthTexture;
                pass.setDepthTexture(stableDepthTexture);
            }
        }
    }
    /**
   * Removes a pass.
   *
   * @param {Pass} pass - The pass.
   */ removePass(pass) {
        const passes = this.passes;
        const index = passes.indexOf(pass);
        const exists = index !== -1;
        const removed = exists && passes.splice(index, 1).length > 0;
        if (removed) {
            if (this.depthTexture !== null) {
                const reducer = (a, b)=>a || b.needsDepthTexture;
                const depthTextureRequired = passes.reduce(reducer, false);
                if (!depthTextureRequired) {
                    const stableDepthTexture = this.depthRenderTarget.depthTexture;
                    if (pass.getDepthTexture() === stableDepthTexture) pass.setDepthTexture(null);
                    this.deleteDepthTexture();
                }
            }
            if (this.autoRenderToScreen) {
                if (index === passes.length) {
                    pass.renderToScreen = false;
                    if (passes.length > 0) passes[passes.length - 1].renderToScreen = true;
                }
            }
        }
    }
    /**
   * Removes all passes.
   */ removeAllPasses() {
        const passes = this.passes;
        this.deleteDepthTexture();
        if (passes.length > 0) {
            if (this.autoRenderToScreen) passes[passes.length - 1].renderToScreen = false;
            this.passes = [];
        }
    }
    /**
   * Renders all enabled passes in the order in which they were added.
   *
   * @param {Number} [deltaTime] - The time since the last frame in seconds.
   */ render(deltaTime) {
        const renderer = this.renderer;
        const copyPass = this.copyPass;
        let inputBuffer = this.inputBuffer;
        let outputBuffer = this.outputBuffer;
        let buffer;
        let stencilTest = false;
        if (deltaTime === void 0) {
            this.timer.update();
            deltaTime = this.timer.getDelta();
        }
        for (const pass of this.passes){
            if (!pass.enabled) continue;
            inputBuffer.depthTexture = this.depthTexture;
            outputBuffer.depthTexture = null;
            pass.render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest);
            if (pass.needsDepthBlit) {
                if (this.depthRenderTarget !== null) this.blitDepthBuffer(inputBuffer);
            }
            if (pass.needsSwap) {
                if (stencilTest) {
                    copyPass.renderToScreen = pass.renderToScreen;
                    const context = renderer.getContext();
                    const stencil = renderer.state.buffers.stencil;
                    stencil.setFunc(context.NOTEQUAL, 1, 4294967295);
                    copyPass.render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest);
                    stencil.setFunc(context.EQUAL, 1, 4294967295);
                }
                buffer = inputBuffer;
                inputBuffer = outputBuffer;
                outputBuffer = buffer;
            }
            if (pass instanceof $2046da3312f94030$export$bb424a4005d6dde0) stencilTest = true;
            else if (pass instanceof $2046da3312f94030$export$8d8650aed29c6251) stencilTest = false;
        }
    }
    /**
   * Sets the size of the buffers, passes and the renderer.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   * @param {Boolean} [updateStyle] - Determines whether the style of the canvas should be updated.
   */ setSize(width, height, updateStyle) {
        const renderer = this.renderer;
        const currentSize = renderer.getSize(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)());
        if (width === void 0 || height === void 0) {
            width = currentSize.width;
            height = currentSize.height;
        }
        if (currentSize.width !== width || currentSize.height !== height) renderer.setSize(width, height, updateStyle);
        const drawingBufferSize = renderer.getDrawingBufferSize(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)());
        this.inputBuffer.setSize(drawingBufferSize.width, drawingBufferSize.height);
        this.outputBuffer.setSize(drawingBufferSize.width, drawingBufferSize.height);
        if (this.depthRenderTarget !== null) this.depthRenderTarget.setSize(drawingBufferSize.width, drawingBufferSize.height);
        for (const pass of this.passes)pass.setSize(drawingBufferSize.width, drawingBufferSize.height);
    }
    /**
   * Resets this composer by deleting all passes and creating new buffers.
   */ reset() {
        this.dispose();
        this.autoRenderToScreen = true;
    }
    /**
   * Disposes this composer and all passes.
   */ dispose() {
        for (const pass of this.passes)pass.dispose();
        this.passes = [];
        if (this.inputBuffer !== null) this.inputBuffer.dispose();
        if (this.outputBuffer !== null) this.outputBuffer.dispose();
        this.deleteDepthTexture();
        this.copyPass.dispose();
        this.timer.dispose();
        $2046da3312f94030$export$802bc10488da99c7.fullscreenGeometry.dispose();
    }
};
// src/enums/EffectAttribute.js
var $2046da3312f94030$export$a72ebb312f9e05c6 = {
    NONE: 0,
    DEPTH: 1,
    CONVOLUTION: 2
};
// src/enums/EffectShaderSection.js
var $2046da3312f94030$export$a147810b69c6903e = {
    FRAGMENT_HEAD: "FRAGMENT_HEAD",
    FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV",
    FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE",
    VERTEX_HEAD: "VERTEX_HEAD",
    VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT"
};
// src/core/EffectShaderData.js
var $2046da3312f94030$export$810aed40073d4f73 = class {
    /**
   * Constructs new shader data.
   */ constructor(){
        this.shaderParts = /* @__PURE__ */ new Map([
            [
                $2046da3312f94030$export$a147810b69c6903e.FRAGMENT_HEAD,
                null
            ],
            [
                $2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_UV,
                null
            ],
            [
                $2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE,
                null
            ],
            [
                $2046da3312f94030$export$a147810b69c6903e.VERTEX_HEAD,
                null
            ],
            [
                $2046da3312f94030$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT,
                null
            ]
        ]);
        this.defines = /* @__PURE__ */ new Map();
        this.uniforms = /* @__PURE__ */ new Map();
        this.blendModes = /* @__PURE__ */ new Map();
        this.extensions = /* @__PURE__ */ new Set();
        this.attributes = $2046da3312f94030$export$a72ebb312f9e05c6.NONE;
        this.varyings = /* @__PURE__ */ new Set();
        this.uvTransformation = false;
        this.readDepth = false;
        this.colorSpace = (0, $ce0cdebec9150cb3$export$42429b3acfb233a4);
    }
};
// src/core/GaussKernel.js
function $2046da3312f94030$var$getCoefficients(n) {
    let result;
    if (n === 0) result = new Float64Array(0);
    else if (n === 1) result = new Float64Array([
        1
    ]);
    else if (n > 1) {
        let row0 = new Float64Array(n);
        let row1 = new Float64Array(n);
        for(let y = 1; y <= n; ++y){
            for(let x = 0; x < y; ++x)row1[x] = x === 0 || x === y - 1 ? 1 : row0[x - 1] + row0[x];
            result = row1;
            row1 = row0;
            row0 = result;
        }
    }
    return result;
}
var $2046da3312f94030$export$66c54bc65bf8869c = class {
    /**
   * Constructs a new Gauss kernel.
   *
   * @param {Number} kernelSize - The kernel size. Should be an odd number in the range [3, 1020].
   * @param {Number} [edgeBias=2] - Determines how many edge coefficients should be cut off for increased accuracy.
   */ constructor(kernelSize, edgeBias = 2){
        this.weights = null;
        this.offsets = null;
        this.linearWeights = null;
        this.linearOffsets = null;
        this.generate(kernelSize, edgeBias);
    }
    /**
   * The number of steps for discrete sampling.
   *
   * @type {Number}
   */ get steps() {
        return this.offsets === null ? 0 : this.offsets.length;
    }
    /**
   * The number of steps for linear sampling.
   *
   * @type {Number}
   */ get linearSteps() {
        return this.linearOffsets === null ? 0 : this.linearOffsets.length;
    }
    /**
   * Generates the kernel.
   *
   * @private
   * @param {Number} kernelSize - The kernel size.
   * @param {Number} edgeBias - The amount of edge coefficients to ignore.
   */ generate(kernelSize, edgeBias) {
        if (kernelSize < 3 || kernelSize > 1020) throw new Error("The kernel size must be in the range [3, 1020]");
        const n = kernelSize + edgeBias * 2;
        const coefficients = edgeBias > 0 ? $2046da3312f94030$var$getCoefficients(n).slice(edgeBias, -edgeBias) : $2046da3312f94030$var$getCoefficients(n);
        const mid = Math.floor((coefficients.length - 1) / 2);
        const sum = coefficients.reduce((a, b)=>a + b, 0);
        const weights = coefficients.slice(mid);
        const offsets = [
            ...Array(mid + 1).keys()
        ];
        const linearWeights = new Float64Array(Math.floor(offsets.length / 2));
        const linearOffsets = new Float64Array(linearWeights.length);
        linearWeights[0] = weights[0] / sum;
        for(let i = 1, j = 1, l = offsets.length - 1; i < l; i += 2, ++j){
            const offset0 = offsets[i], offset1 = offsets[i + 1];
            const weight0 = weights[i], weight1 = weights[i + 1];
            const w = weight0 + weight1;
            const o = (offset0 * weight0 + offset1 * weight1) / w;
            linearWeights[j] = w / sum;
            linearOffsets[j] = o;
        }
        for(let i = 0, l = weights.length, s = 1 / sum; i < l; ++i)weights[i] *= s;
        const linearWeightSum = (linearWeights.reduce((a, b)=>a + b, 0) - linearWeights[0] * 0.5) * 2;
        if (linearWeightSum !== 0) for(let i = 0, l = linearWeights.length, s = 1 / linearWeightSum; i < l; ++i)linearWeights[i] *= s;
        this.offsets = offsets;
        this.weights = weights;
        this.linearOffsets = linearOffsets;
        this.linearWeights = linearWeights;
    }
};
// src/core/ImmutableTimer.js
var $2046da3312f94030$export$330f1e2d95fbcda4 = class {
    /**
   * The current delta time in seconds.
   *
   * @type {Number}
   */ getDelta() {
        return NaN;
    }
    /**
   * The elapsed time in seconds.
   *
   * @type {Number}
   */ getElapsed() {
        return NaN;
    }
};
// src/core/Initializable.js
var $2046da3312f94030$export$45a3d12ae694afd = class {
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - A renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {}
};
var $2046da3312f94030$var$workaroundEnabled = false;
var $2046da3312f94030$export$6ef25c308da0147b = class {
    /**
   * Constructs a new override material manager.
   *
   * @param {Material} [material=null] - An override material.
   */ constructor(material = null){
        this.originalMaterials = /* @__PURE__ */ new Map();
        this.material = null;
        this.materials = null;
        this.materialsBackSide = null;
        this.materialsDoubleSide = null;
        this.materialsFlatShaded = null;
        this.materialsFlatShadedBackSide = null;
        this.materialsFlatShadedDoubleSide = null;
        this.setMaterial(material);
        this.meshCount = 0;
        this.replaceMaterial = (node)=>{
            if (node.isMesh) {
                let materials;
                if (node.material.flatShading) switch(node.material.side){
                    case 0, $ce0cdebec9150cb3$export$3b296b6f144d5b03:
                        materials = this.materialsFlatShadedDoubleSide;
                        break;
                    case 0, $ce0cdebec9150cb3$export$d9f0486e75b5ace:
                        materials = this.materialsFlatShadedBackSide;
                        break;
                    default:
                        materials = this.materialsFlatShaded;
                        break;
                }
                else switch(node.material.side){
                    case 0, $ce0cdebec9150cb3$export$3b296b6f144d5b03:
                        materials = this.materialsDoubleSide;
                        break;
                    case 0, $ce0cdebec9150cb3$export$d9f0486e75b5ace:
                        materials = this.materialsBackSide;
                        break;
                    default:
                        materials = this.materials;
                        break;
                }
                this.originalMaterials.set(node, node.material);
                if (node.isSkinnedMesh) node.material = materials[2];
                else if (node.isInstancedMesh) node.material = materials[1];
                else node.material = materials[0];
                ++this.meshCount;
            }
        };
    }
    /**
   * Clones the given material.
   *
   * @private
   * @param {Material} material - The material.
   * @return {Material} The cloned material.
   */ cloneMaterial(material) {
        if (!(material instanceof (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d))) return material.clone();
        const uniforms = material.uniforms;
        const textureUniforms = /* @__PURE__ */ new Map();
        for(const key in uniforms){
            const value = uniforms[key].value;
            if (value.isRenderTargetTexture) {
                uniforms[key].value = null;
                textureUniforms.set(key, value);
            }
        }
        const clone = material.clone();
        for (const entry of textureUniforms){
            uniforms[entry[0]].value = entry[1];
            clone.uniforms[entry[0]].value = entry[1];
        }
        return clone;
    }
    /**
   * Sets the override material.
   *
   * @param {Material} material - The material.
   */ setMaterial(material) {
        this.disposeMaterials();
        this.material = material;
        if (material !== null) {
            const materials = this.materials = [
                this.cloneMaterial(material),
                this.cloneMaterial(material),
                this.cloneMaterial(material)
            ];
            for (const m2 of materials){
                m2.uniforms = Object.assign({}, material.uniforms);
                m2.side = (0, $ce0cdebec9150cb3$export$2ede184fc2998901);
            }
            materials[2].skinning = true;
            this.materialsBackSide = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.side = (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace);
                return c2;
            });
            this.materialsDoubleSide = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.side = (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03);
                return c2;
            });
            this.materialsFlatShaded = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.flatShading = true;
                return c2;
            });
            this.materialsFlatShadedBackSide = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.flatShading = true;
                c2.side = (0, $ce0cdebec9150cb3$export$d9f0486e75b5ace);
                return c2;
            });
            this.materialsFlatShadedDoubleSide = materials.map((m2)=>{
                const c2 = this.cloneMaterial(m2);
                c2.uniforms = Object.assign({}, material.uniforms);
                c2.flatShading = true;
                c2.side = (0, $ce0cdebec9150cb3$export$3b296b6f144d5b03);
                return c2;
            });
        }
    }
    /**
   * Renders the scene with the override material.
   *
   * @private
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Scene} scene - A scene.
   * @param {Camera} camera - A camera.
   */ render(renderer, scene, camera) {
        const shadowMapEnabled = renderer.shadowMap.enabled;
        renderer.shadowMap.enabled = false;
        if ($2046da3312f94030$var$workaroundEnabled) {
            const originalMaterials = this.originalMaterials;
            this.meshCount = 0;
            scene.traverse(this.replaceMaterial);
            renderer.render(scene, camera);
            for (const entry of originalMaterials)entry[0].material = entry[1];
            if (this.meshCount !== originalMaterials.size) originalMaterials.clear();
        } else {
            const overrideMaterial = scene.overrideMaterial;
            scene.overrideMaterial = this.material;
            renderer.render(scene, camera);
            scene.overrideMaterial = overrideMaterial;
        }
        renderer.shadowMap.enabled = shadowMapEnabled;
    }
    /**
   * Deletes cloned override materials.
   *
   * @private
   */ disposeMaterials() {
        if (this.material !== null) {
            const materials = this.materials.concat(this.materialsBackSide).concat(this.materialsDoubleSide).concat(this.materialsFlatShaded).concat(this.materialsFlatShadedBackSide).concat(this.materialsFlatShadedDoubleSide);
            for (const m2 of materials)m2.dispose();
        }
    }
    /**
   * Performs cleanup tasks.
   */ dispose() {
        this.originalMaterials.clear();
        this.disposeMaterials();
    }
    /**
   * Indicates whether the override material workaround is enabled.
   *
   * @type {Boolean}
   */ static get workaroundEnabled() {
        return $2046da3312f94030$var$workaroundEnabled;
    }
    /**
   * Enables or disables the override material workaround globally.
   *
   * This only affects post processing passes and effects.
   *
   * @type {Boolean}
   */ static set workaroundEnabled(value) {
        $2046da3312f94030$var$workaroundEnabled = value;
    }
};
// src/core/Resizable.js
var $2046da3312f94030$export$e82068809229c83c = class {
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {}
};
var $2046da3312f94030$var$AUTO_SIZE = -1;
var $2046da3312f94030$export$48a76196cafe3b93 = class extends (0, $ce0cdebec9150cb3$export$ec8b666c5fe2c75a) {
    /**
   * Constructs a new resolution.
   *
   * TODO Remove resizable param.
   * @param {Resizable} resizable - A resizable object.
   * @param {Number} [width=Resolution.AUTO_SIZE] - The preferred width.
   * @param {Number} [height=Resolution.AUTO_SIZE] - The preferred height.
   * @param {Number} [scale=1.0] - A resolution scale.
   */ constructor(resizable, width = $2046da3312f94030$var$AUTO_SIZE, height = $2046da3312f94030$var$AUTO_SIZE, scale = 1){
        super();
        this.resizable = resizable;
        this.baseSize = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(1, 1);
        this.preferredSize = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(width, height);
        this.target = this.preferredSize;
        this.s = scale;
        this.effectiveSize = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        this.addEventListener("change", ()=>this.updateEffectiveSize());
        this.updateEffectiveSize();
    }
    /**
   * Calculates the effective size.
   *
   * @private
   */ updateEffectiveSize() {
        const base = this.baseSize;
        const preferred = this.preferredSize;
        const effective = this.effectiveSize;
        const scale = this.scale;
        if (preferred.width !== $2046da3312f94030$var$AUTO_SIZE) effective.width = preferred.width;
        else if (preferred.height !== $2046da3312f94030$var$AUTO_SIZE) effective.width = Math.round(preferred.height * (base.width / Math.max(base.height, 1)));
        else effective.width = Math.round(base.width * scale);
        if (preferred.height !== $2046da3312f94030$var$AUTO_SIZE) effective.height = preferred.height;
        else if (preferred.width !== $2046da3312f94030$var$AUTO_SIZE) effective.height = Math.round(preferred.width / Math.max(base.width / Math.max(base.height, 1), 1));
        else effective.height = Math.round(base.height * scale);
    }
    /**
   * The effective width.
   *
   * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base width will be returned.
   *
   * @type {Number}
   */ get width() {
        return this.effectiveSize.width;
    }
    set width(value) {
        this.preferredWidth = value;
    }
    /**
   * The effective height.
   *
   * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base height will be returned.
   *
   * @type {Number}
   */ get height() {
        return this.effectiveSize.height;
    }
    set height(value) {
        this.preferredHeight = value;
    }
    /**
   * Returns the effective width.
   *
   * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base width will be returned.
   *
   * @deprecated Use width instead.
   * @return {Number} The effective width.
   */ getWidth() {
        return this.width;
    }
    /**
   * Returns the effective height.
   *
   * If the preferred width and height are set to {@link Resizer.AUTO_SIZE}, the base height will be returned.
   *
   * @deprecated Use height instead.
   * @return {Number} The effective height.
   */ getHeight() {
        return this.height;
    }
    /**
   * The resolution scale.
   *
   * @type {Number}
   */ get scale() {
        return this.s;
    }
    set scale(value) {
        if (this.s !== value) {
            this.s = value;
            this.preferredSize.setScalar($2046da3312f94030$var$AUTO_SIZE);
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the current resolution scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} The scale.
   */ getScale() {
        return this.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * Also sets the preferred resolution to {@link Resizer.AUTO_SIZE}.
   *
   * @deprecated Use scale instead.
   * @param {Number} value - The scale.
   */ setScale(value) {
        this.scale = value;
    }
    /**
   * The base width.
   *
   * @type {Number}
   */ get baseWidth() {
        return this.baseSize.width;
    }
    set baseWidth(value) {
        if (this.baseSize.width !== value) {
            this.baseSize.width = value;
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the base width.
   *
   * @deprecated Use baseWidth instead.
   * @return {Number} The base width.
   */ getBaseWidth() {
        return this.baseWidth;
    }
    /**
   * Sets the base width.
   *
   * @deprecated Use baseWidth instead.
   * @param {Number} value - The width.
   */ setBaseWidth(value) {
        this.baseWidth = value;
    }
    /**
   * The base height.
   *
   * @type {Number}
   */ get baseHeight() {
        return this.baseSize.height;
    }
    set baseHeight(value) {
        if (this.baseSize.height !== value) {
            this.baseSize.height = value;
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the base height.
   *
   * @deprecated Use baseHeight instead.
   * @return {Number} The base height.
   */ getBaseHeight() {
        return this.baseHeight;
    }
    /**
   * Sets the base height.
   *
   * @deprecated Use baseHeight instead.
   * @param {Number} value - The height.
   */ setBaseHeight(value) {
        this.baseHeight = value;
    }
    /**
   * Sets the base size.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setBaseSize(width, height) {
        if (this.baseSize.width !== width || this.baseSize.height !== height) {
            this.baseSize.set(width, height);
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * The preferred width.
   *
   * @type {Number}
   */ get preferredWidth() {
        return this.preferredSize.width;
    }
    set preferredWidth(value) {
        if (this.preferredSize.width !== value) {
            this.preferredSize.width = value;
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the preferred width.
   *
   * @deprecated Use preferredWidth instead.
   * @return {Number} The preferred width.
   */ getPreferredWidth() {
        return this.preferredWidth;
    }
    /**
   * Sets the preferred width.
   *
   * Use {@link Resizer.AUTO_SIZE} to automatically calculate the width based on the height and aspect ratio.
   *
   * @deprecated Use preferredWidth instead.
   * @param {Number} value - The width.
   */ setPreferredWidth(value) {
        this.preferredWidth = value;
    }
    /**
   * The preferred height.
   *
   * @type {Number}
   */ get preferredHeight() {
        return this.preferredSize.height;
    }
    set preferredHeight(value) {
        if (this.preferredSize.height !== value) {
            this.preferredSize.height = value;
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Returns the preferred height.
   *
   * @deprecated Use preferredHeight instead.
   * @return {Number} The preferred height.
   */ getPreferredHeight() {
        return this.preferredHeight;
    }
    /**
   * Sets the preferred height.
   *
   * Use {@link Resizer.AUTO_SIZE} to automatically calculate the height based on the width and aspect ratio.
   *
   * @deprecated Use preferredHeight instead.
   * @param {Number} value - The height.
   */ setPreferredHeight(value) {
        this.preferredHeight = value;
    }
    /**
   * Sets the preferred size.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setPreferredSize(width, height) {
        if (this.preferredSize.width !== width || this.preferredSize.height !== height) {
            this.preferredSize.set(width, height);
            this.dispatchEvent({
                type: "change"
            });
            this.resizable.setSize(this.baseSize.width, this.baseSize.height);
        }
    }
    /**
   * Copies the given resolution.
   *
   * @param {Resolution} resolution - The resolution.
   */ copy(resolution) {
        this.s = resolution.scale;
        this.baseSize.set(resolution.baseWidth, resolution.baseHeight);
        this.preferredSize.set(resolution.preferredWidth, resolution.preferredHeight);
        this.dispatchEvent({
            type: "change"
        });
        this.resizable.setSize(this.baseSize.width, this.baseSize.height);
    }
    /**
   * An auto sizing constant.
   *
   * Can be used to automatically calculate the width or height based on the original aspect ratio.
   *
   * @type {Number}
   */ static get AUTO_SIZE() {
        return $2046da3312f94030$var$AUTO_SIZE;
    }
};
// src/utils/IdManager.js
var $2046da3312f94030$var$IdManager = class {
    /**
   * Constructs a new ID manager.
   *
   * @param initialId - The first ID.
   */ constructor(initialId = 0){
        this.nextId = initialId;
    }
    /**
   * Returns the next unique ID.
   *
   * @return The ID.
   */ getNextId() {
        return this.nextId++;
    }
    /**
   * Resets the ID counter.
   *
   * @param initialId - The first ID.
   * @return This manager.
   */ reset(initialId = 0) {
        this.nextId = initialId;
        return this;
    }
};
// src/core/Selection.js
var $2046da3312f94030$var$idManager = /* @__PURE__ */ new $2046da3312f94030$var$IdManager(2);
var $2046da3312f94030$export$52baac22726c72bf = class extends Set {
    /**
   * Constructs a new selection.
   *
   * @param {Iterable<Object3D>} [iterable] - A collection of objects that should be added to this selection.
   * @param {Number} [layer] - A dedicated render layer for selected objects. Range is `[2, 31]`. Starts at 2 if omitted.
   */ constructor(iterable, layer = $2046da3312f94030$var$idManager.getNextId()){
        super();
        this.exclusive = false;
        this._layer = layer;
        if (this._layer < 1 || this._layer > 31) {
            console.warn("Layer out of range, resetting to 2");
            $2046da3312f94030$var$idManager.reset(2);
            this._layer = $2046da3312f94030$var$idManager.getNextId();
        }
        if (iterable !== void 0) this.set(iterable);
    }
    /**
   * The render layer for selected objects.
   *
   * @type {Number}
   */ get layer() {
        return this._layer;
    }
    set layer(value) {
        const currentLayer = this._layer;
        for (const object of this){
            object.layers.disable(currentLayer);
            object.layers.enable(value);
        }
        this._layer = value;
    }
    /**
   * Returns the current render layer for selected objects.
   *
   * The default layer is 2. If this collides with your own custom layers, please change it before rendering!
   *
   * @deprecated Use layer instead.
   * @return {Number} The layer.
   */ getLayer() {
        return this.layer;
    }
    /**
   * Sets the render layer for selected objects.
   *
   * The current selection will be updated accordingly.
   *
   * @deprecated Use layer instead.
   * @param {Number} value - The layer. Range is [0, 31].
   */ setLayer(value) {
        this.layer = value;
    }
    /**
   * Indicates whether objects that are added to this selection will be removed from all other layers.
   *
   * @deprecated Use exclusive instead.
   * @return {Number} Whether this selection is exclusive. Default is false.
   */ isExclusive() {
        return this.exclusive;
    }
    /**
   * Controls whether objects that are added to this selection should be removed from all other layers.
   *
   * @deprecated Use exclusive instead.
   * @param {Number} value - Whether this selection should be exclusive.
   */ setExclusive(value) {
        this.exclusive = value;
    }
    /**
   * Clears this selection.
   *
   * @return {Selection} This selection.
   */ clear() {
        const layer = this.layer;
        for (const object of this)object.layers.disable(layer);
        return super.clear();
    }
    /**
   * Clears this selection and adds the given objects.
   *
   * @param {Iterable<Object3D>} objects - The objects that should be selected.
   * @return {Selection} This selection.
   */ set(objects) {
        this.clear();
        for (const object of objects)this.add(object);
        return this;
    }
    /**
   * An alias for {@link has}.
   *
   * @param {Object3D} object - An object.
   * @return {Number} Returns 0 if the given object is currently selected, or -1 otherwise.
   * @deprecated Added for backward-compatibility.
   */ indexOf(object) {
        return this.has(object) ? 0 : -1;
    }
    /**
   * Adds an object to this selection.
   *
   * If {@link exclusive} is set to `true`, the object will also be removed from all other layers.
   *
   * @param {Object3D} object - The object that should be selected.
   * @return {Selection} This selection.
   */ add(object) {
        if (this.exclusive) object.layers.set(this.layer);
        else object.layers.enable(this.layer);
        return super.add(object);
    }
    /**
   * Removes an object from this selection.
   *
   * @param {Object3D} object - The object that should be deselected.
   * @return {Boolean} Returns true if an object has successfully been removed from this selection; otherwise false.
   */ delete(object) {
        if (this.has(object)) object.layers.disable(this.layer);
        return super.delete(object);
    }
    /**
   * Removes an existing object from the selection. If the object doesn't exist it's added instead.
   *
   * @param {Object3D} object - The object.
   * @return {Boolean} Returns true if the object is added, false otherwise.
   */ toggle(object) {
        let result;
        if (this.has(object)) {
            this.delete(object);
            result = false;
        } else {
            this.add(object);
            result = true;
        }
        return result;
    }
    /**
   * Sets the visibility of all selected objects.
   *
   * This method enables or disables render layer 0 of all selected objects.
   *
   * @param {Boolean} visible - Whether the selected objects should be visible.
   * @return {Selection} This selection.
   */ setVisible(visible) {
        for (const object of this)if (visible) object.layers.enable(0);
        else object.layers.disable(0);
        return this;
    }
};
// src/enums/BlendFunction.js
var $2046da3312f94030$export$ea7520add44ba1b6 = {
    SKIP: 9,
    SET: 30,
    ADD: 0,
    ALPHA: 1,
    AVERAGE: 2,
    COLOR: 3,
    COLOR_BURN: 4,
    COLOR_DODGE: 5,
    DARKEN: 6,
    DIFFERENCE: 7,
    DIVIDE: 8,
    DST: 9,
    EXCLUSION: 10,
    HARD_LIGHT: 11,
    HARD_MIX: 12,
    HUE: 13,
    INVERT: 14,
    INVERT_RGB: 15,
    LIGHTEN: 16,
    LINEAR_BURN: 17,
    LINEAR_DODGE: 18,
    LINEAR_LIGHT: 19,
    LUMINOSITY: 20,
    MULTIPLY: 21,
    NEGATION: 22,
    NORMAL: 23,
    OVERLAY: 24,
    PIN_LIGHT: 25,
    REFLECT: 26,
    SATURATION: 27,
    SCREEN: 28,
    SOFT_LIGHT: 29,
    SRC: 30,
    SUBTRACT: 31,
    VIVID_LIGHT: 32
};
// src/effects/blending/glsl/add.frag
var $2046da3312f94030$var$add_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=dst.rgb+src.rgb;return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/alpha.frag
var $2046da3312f94030$var$alpha_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){return mix(dst,src,src.a*opacity);}`;
// src/effects/blending/glsl/average.frag
var $2046da3312f94030$var$average_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=(dst.rgb+src.rgb)*0.5;return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/color.frag
var $2046da3312f94030$var$color_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 a=RGBToHSL(dst.rgb);vec3 b=RGBToHSL(src.rgb);vec3 c=HSLToRGB(vec3(b.xy,a.z));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/color-burn.frag
var $2046da3312f94030$var$color_burn_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 a=dst.rgb,b=src.rgb;vec3 c=mix(step(0.0,b)*(1.0-min(vec3(1.0),(1.0-a)/max(b,1e-9))),vec3(1.0),step(1.0,a));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/color-dodge.frag
var $2046da3312f94030$var$color_dodge_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 a=dst.rgb,b=src.rgb;vec3 c=step(0.0,a)*mix(min(vec3(1.0),a/max(1.0-b,1e-9)),vec3(1.0),step(1.0,b));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/darken.frag
var $2046da3312f94030$var$darken_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=min(dst.rgb,src.rgb);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/difference.frag
var $2046da3312f94030$var$difference_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=abs(dst.rgb-src.rgb);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/divide.frag
var $2046da3312f94030$var$divide_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=dst.rgb/max(src.rgb,1e-9);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/exclusion.frag
var $2046da3312f94030$var$exclusion_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=dst.rgb+src.rgb-2.0*dst.rgb*src.rgb;return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/hard-light.frag
var $2046da3312f94030$var$hard_light_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 a=min(dst.rgb,1.0);vec3 b=min(src.rgb,1.0);vec3 c=mix(2.0*a*b,1.0-2.0*(1.0-a)*(1.0-b),step(0.5,b));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/hard-mix.frag
var $2046da3312f94030$var$hard_mix_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=step(1.0,dst.rgb+src.rgb);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/hue.frag
var $2046da3312f94030$var$hue_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 a=RGBToHSL(dst.rgb);vec3 b=RGBToHSL(src.rgb);vec3 c=HSLToRGB(vec3(b.x,a.yz));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/invert.frag
var $2046da3312f94030$var$invert_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=max(1.0-src.rgb,0.0);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/invert-rgb.frag
var $2046da3312f94030$var$invert_rgb_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=src.rgb*max(1.0-dst.rgb,0.0);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/lighten.frag
var $2046da3312f94030$var$lighten_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=max(dst.rgb,src.rgb);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/linear-burn.frag
var $2046da3312f94030$var$linear_burn_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=clamp(src.rgb+dst.rgb-1.0,0.0,1.0);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/linear-dodge.frag
var $2046da3312f94030$var$linear_dodge_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=min(dst.rgb+src.rgb,1.0);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/linear-light.frag
var $2046da3312f94030$var$linear_light_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=clamp(2.0*src.rgb+dst.rgb-1.0,0.0,1.0);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/luminosity.frag
var $2046da3312f94030$var$luminosity_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 a=RGBToHSL(dst.rgb);vec3 b=RGBToHSL(src.rgb);vec3 c=HSLToRGB(vec3(a.xy,b.z));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/multiply.frag
var $2046da3312f94030$var$multiply_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=dst.rgb*src.rgb;return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/negation.frag
var $2046da3312f94030$var$negation_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=max(1.0-abs(1.0-dst.rgb-src.rgb),0.0);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/normal.frag
var $2046da3312f94030$var$normal_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){return mix(dst,src,opacity);}`;
// src/effects/blending/glsl/overlay.frag
var $2046da3312f94030$var$overlay_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 a=2.0*src.rgb*dst.rgb;vec3 b=1.0-2.0*(1.0-src.rgb)*(1.0-dst.rgb);vec3 c=mix(a,b,step(0.5,dst.rgb));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/pin-light.frag
var $2046da3312f94030$var$pin_light_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 src2=2.0*src.rgb;vec3 c=mix(mix(src2,dst.rgb,step(0.5*dst.rgb,src.rgb)),max(src2-1.0,vec3(0.0)),step(dst.rgb,src2-1.0));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/reflect.frag
var $2046da3312f94030$var$reflect_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 a=min(dst.rgb*dst.rgb/max(1.0-src.rgb,1e-9),1.0);vec3 c=mix(a,src.rgb,step(1.0,src.rgb));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/saturation.frag
var $2046da3312f94030$var$saturation_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 a=RGBToHSL(dst.rgb);vec3 b=RGBToHSL(src.rgb);vec3 c=HSLToRGB(vec3(a.x,b.y,a.z));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/screen.frag
var $2046da3312f94030$var$screen_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=dst.rgb+src.rgb-min(dst.rgb*src.rgb,1.0);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/soft-light.frag
var $2046da3312f94030$var$soft_light_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 src2=2.0*src.rgb;vec3 d=dst.rgb+(src2-1.0);vec3 w=step(0.5,src.rgb);vec3 a=dst.rgb-(1.0-src2)*dst.rgb*(1.0-dst.rgb);vec3 b=mix(d*(sqrt(dst.rgb)-dst.rgb),d*dst.rgb*((16.0*dst.rgb-12.0)*dst.rgb+3.0),w*(1.0-step(0.25,dst.rgb)));vec3 c=mix(a,b,w);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/src.frag
var $2046da3312f94030$var$src_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){return src;}`;
// src/effects/blending/glsl/subtract.frag
var $2046da3312f94030$var$subtract_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=max(dst.rgb-src.rgb,0.0);return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/glsl/vivid-light.frag
var $2046da3312f94030$var$vivid_light_default = `vec4 blend(const in vec4 dst,const in vec4 src,const in float opacity){vec3 c=mix(max(1.0-min((1.0-dst.rgb)/(2.0*src.rgb),1.0),0.0),min(dst.rgb/(2.0*(1.0-src.rgb)),1.0),step(0.5,src.rgb));return mix(dst,vec4(c,max(dst.a,src.a)),opacity);}`;
// src/effects/blending/BlendMode.js
var $2046da3312f94030$var$blendFunctions = /* @__PURE__ */ new Map([
    [
        $2046da3312f94030$export$ea7520add44ba1b6.ADD,
        $2046da3312f94030$var$add_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.ALPHA,
        $2046da3312f94030$var$alpha_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.AVERAGE,
        $2046da3312f94030$var$average_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.COLOR,
        $2046da3312f94030$var$color_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.COLOR_BURN,
        $2046da3312f94030$var$color_burn_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.COLOR_DODGE,
        $2046da3312f94030$var$color_dodge_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.DARKEN,
        $2046da3312f94030$var$darken_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.DIFFERENCE,
        $2046da3312f94030$var$difference_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.DIVIDE,
        $2046da3312f94030$var$divide_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.DST,
        null
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.EXCLUSION,
        $2046da3312f94030$var$exclusion_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.HARD_LIGHT,
        $2046da3312f94030$var$hard_light_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.HARD_MIX,
        $2046da3312f94030$var$hard_mix_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.HUE,
        $2046da3312f94030$var$hue_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.INVERT,
        $2046da3312f94030$var$invert_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.INVERT_RGB,
        $2046da3312f94030$var$invert_rgb_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.LIGHTEN,
        $2046da3312f94030$var$lighten_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.LINEAR_BURN,
        $2046da3312f94030$var$linear_burn_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.LINEAR_DODGE,
        $2046da3312f94030$var$linear_dodge_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.LINEAR_LIGHT,
        $2046da3312f94030$var$linear_light_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.LUMINOSITY,
        $2046da3312f94030$var$luminosity_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.MULTIPLY,
        $2046da3312f94030$var$multiply_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.NEGATION,
        $2046da3312f94030$var$negation_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.NORMAL,
        $2046da3312f94030$var$normal_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.OVERLAY,
        $2046da3312f94030$var$overlay_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.PIN_LIGHT,
        $2046da3312f94030$var$pin_light_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.REFLECT,
        $2046da3312f94030$var$reflect_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.SATURATION,
        $2046da3312f94030$var$saturation_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.SCREEN,
        $2046da3312f94030$var$screen_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.SOFT_LIGHT,
        $2046da3312f94030$var$soft_light_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.SRC,
        $2046da3312f94030$var$src_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.SUBTRACT,
        $2046da3312f94030$var$subtract_default
    ],
    [
        $2046da3312f94030$export$ea7520add44ba1b6.VIVID_LIGHT,
        $2046da3312f94030$var$vivid_light_default
    ]
]);
var $2046da3312f94030$export$c9b8fe72ac71821 = class extends (0, $ce0cdebec9150cb3$export$ec8b666c5fe2c75a) {
    /**
   * Constructs a new blend mode.
   *
   * @param {BlendFunction} blendFunction - The blend function.
   * @param {Number} opacity - The opacity of the color that will be blended with the base color.
   */ constructor(blendFunction, opacity = 1){
        super();
        this._blendFunction = blendFunction;
        this.opacity = new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(opacity);
    }
    /**
   * Returns the opacity.
   *
   * @return {Number} The opacity.
   */ getOpacity() {
        return this.opacity.value;
    }
    /**
   * Sets the opacity.
   *
   * @param {Number} value - The opacity.
   */ setOpacity(value) {
        this.opacity.value = value;
    }
    /**
   * The blend function.
   *
   * @type {BlendFunction}
   */ get blendFunction() {
        return this._blendFunction;
    }
    set blendFunction(value) {
        this._blendFunction = value;
        this.dispatchEvent({
            type: "change"
        });
    }
    /**
   * Returns the blend function.
   *
   * @deprecated Use blendFunction instead.
   * @return {BlendFunction} The blend function.
   */ getBlendFunction() {
        return this.blendFunction;
    }
    /**
   * Sets the blend function.
   *
   * @deprecated Use blendFunction instead.
   * @param {BlendFunction} value - The blend function.
   */ setBlendFunction(value) {
        this.blendFunction = value;
    }
    /**
   * Returns the blend function shader code.
   *
   * @return {String} The blend function shader code.
   */ getShaderCode() {
        return $2046da3312f94030$var$blendFunctions.get(this.blendFunction);
    }
};
var $2046da3312f94030$export$dace868717185b4 = class extends (0, $ce0cdebec9150cb3$export$f7189e49152d1c13) {
    /**
   * Constructs a new ASCII texture.
   *
   * @param {Object} [options] - The options.
   * @param {String} [options.characters] - The character set to render. Defaults to a common ASCII art charset.
   * @param {String} [options.font="Arial"] - The font.
   * @param {Number} [options.fontSize=54] - The font size in pixels.
   * @param {Number} [options.size=1024] - The texture size.
   * @param {Number} [options.cellCount=16] - The cell count along each side of the texture.
   */ constructor({ characters: characters = " .:,'-^=*+?!|0#X%WM@", font: font = "Arial", fontSize: fontSize = 54, size: size = 1024, cellCount: cellCount = 16 } = {}){
        super(document.createElement("canvas"), void 0, (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5), (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5));
        const canvas = this.image;
        canvas.width = canvas.height = size;
        const context = canvas.getContext("2d");
        const cellSize = size / cellCount;
        context.font = `${fontSize}px ${font}`;
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillStyle = "#ffffff";
        for(let i = 0, l = characters.length; i < l; ++i){
            const char = characters[i];
            const x = i % cellCount;
            const y = Math.floor(i / cellCount);
            context.fillText(char, x * cellSize + cellSize / 2, y * cellSize + cellSize / 2);
        }
        this.characterCount = characters.length;
        this.cellCount = cellCount;
    }
};
var $2046da3312f94030$export$a32b0b1c1ac59d04 = class extends (0, $ce0cdebec9150cb3$export$ec8b666c5fe2c75a) {
    /**
   * Constructs a new effect.
   *
   * @param {String} name - The name of this effect. Doesn't have to be unique.
   * @param {String} fragmentShader - The fragment shader. This shader is required.
   * @param {Object} [options] - Additional options.
   * @param {EffectAttribute} [options.attributes=EffectAttribute.NONE] - The effect attributes that determine the execution priority and resource requirements.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.NORMAL] - The blend function of this effect.
   * @param {Map<String, String>} [options.defines] - Custom preprocessor macro definitions. Keys are names and values are code.
   * @param {Map<String, Uniform>} [options.uniforms] - Custom shader uniforms. Keys are names and values are uniforms.
   * @param {Set<WebGLExtension>} [options.extensions] - WebGL extensions.
   * @param {String} [options.vertexShader=null] - The vertex shader. Most effects don't need one.
   */ constructor(name, fragmentShader, { attributes: attributes = $2046da3312f94030$export$a72ebb312f9e05c6.NONE, blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.NORMAL, defines: defines = /* @__PURE__ */ new Map(), uniforms: uniforms = /* @__PURE__ */ new Map(), extensions: extensions = null, vertexShader: vertexShader = null } = {}){
        super();
        this.name = name;
        this.renderer = null;
        this.attributes = attributes;
        this.fragmentShader = fragmentShader;
        this.vertexShader = vertexShader;
        this.defines = defines;
        this.uniforms = uniforms;
        this.extensions = extensions;
        this.blendMode = new $2046da3312f94030$export$c9b8fe72ac71821(blendFunction);
        this.blendMode.addEventListener("change", (event)=>this.setChanged());
        this._inputColorSpace = (0, $ce0cdebec9150cb3$export$42429b3acfb233a4);
        this._outputColorSpace = (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51);
    }
    /**
   * The input color space.
   *
   * @type {ColorSpace}
   * @experimental
   */ get inputColorSpace() {
        return this._inputColorSpace;
    }
    /**
   * @type {ColorSpace}
   * @protected
   * @experimental
   */ set inputColorSpace(value) {
        this._inputColorSpace = value;
        this.setChanged();
    }
    /**
   * The output color space.
   *
   * Should only be changed if this effect converts the input colors to a different color space.
   *
   * @type {ColorSpace}
   * @experimental
   */ get outputColorSpace() {
        return this._outputColorSpace;
    }
    /**
   * @type {ColorSpace}
   * @protected
   * @experimental
   */ set outputColorSpace(value) {
        this._outputColorSpace = value;
        this.setChanged();
    }
    /**
   * Sets the main scene.
   *
   * @type {Scene}
   */ set mainScene(value) {}
    /**
   * Sets the main camera.
   *
   * @type {Camera}
   */ set mainCamera(value) {}
    /**
   * Returns the name of this effect.
   *
   * @deprecated Use name instead.
   * @return {String} The name.
   */ getName() {
        return this.name;
    }
    /**
   * Sets the renderer.
   *
   * @deprecated
   * @param {WebGLRenderer} renderer - The renderer.
   */ setRenderer(renderer) {
        this.renderer = renderer;
    }
    /**
   * Returns the preprocessor macro definitions.
   *
   * @deprecated Use defines instead.
   * @return {Map<String, String>} The extensions.
   */ getDefines() {
        return this.defines;
    }
    /**
   * Returns the uniforms of this effect.
   *
   * @deprecated Use uniforms instead.
   * @return {Map<String, Uniform>} The extensions.
   */ getUniforms() {
        return this.uniforms;
    }
    /**
   * Returns the WebGL extensions that are required by this effect.
   *
   * @deprecated Use extensions instead.
   * @return {Set<WebGLExtension>} The extensions.
   */ getExtensions() {
        return this.extensions;
    }
    /**
   * Returns the blend mode.
   *
   * The result of this effect will be blended with the result of the previous effect using this blend mode.
   *
   * @deprecated Use blendMode instead.
   * @return {BlendMode} The blend mode.
   */ getBlendMode() {
        return this.blendMode;
    }
    /**
   * Returns the effect attributes.
   *
   * @return {EffectAttribute} The attributes.
   */ getAttributes() {
        return this.attributes;
    }
    /**
   * Sets the effect attributes.
   *
   * Effects that have the same attributes will be executed in the order in which they were registered. Some attributes
   * imply a higher priority.
   *
   * @protected
   * @param {EffectAttribute} attributes - The attributes.
   */ setAttributes(attributes) {
        this.attributes = attributes;
        this.setChanged();
    }
    /**
   * Returns the fragment shader.
   *
   * @return {String} The fragment shader.
   */ getFragmentShader() {
        return this.fragmentShader;
    }
    /**
   * Sets the fragment shader.
   *
   * @protected
   * @param {String} fragmentShader - The fragment shader.
   */ setFragmentShader(fragmentShader) {
        this.fragmentShader = fragmentShader;
        this.setChanged();
    }
    /**
   * Returns the vertex shader.
   *
   * @return {String} The vertex shader.
   */ getVertexShader() {
        return this.vertexShader;
    }
    /**
   * Sets the vertex shader.
   *
   * @protected
   * @param {String} vertexShader - The vertex shader.
   */ setVertexShader(vertexShader) {
        this.vertexShader = vertexShader;
        this.setChanged();
    }
    /**
   * Informs the associated {@link EffectPass} that this effect requires a shader recompilation.
   *
   * Should be called after changing macros or extensions and after adding/removing uniforms.
   *
   * @protected
   */ setChanged() {
        this.dispatchEvent({
            type: "change"
        });
    }
    /**
   * Sets the depth texture.
   *
   * You may override this method if your effect requires direct access to the depth texture that is bound to the
   * associated {@link EffectPass}.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {}
    /**
   * Updates this effect by performing supporting operations.
   *
   * This method is called by the {@link EffectPass} right before the main fullscreen render operation, even if the
   * blend function is set to `SKIP`.
   *
   * You may override this method if you need to update custom uniforms or render additional off-screen textures.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {}
    /**
   * Updates the size of this effect.
   *
   * You may override this method if you want to be informed about the size of the backbuffer/canvas.
   * This method is called before {@link initialize} and every time the size of the {@link EffectComposer} changes.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {}
    /**
   * Performs initialization tasks.
   *
   * This method is called when the associated {@link EffectPass} is added to an {@link EffectComposer}.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   * @example if(!alpha && frameBufferType === UnsignedByteType) { this.myRenderTarget.texture.format = RGBFormat; }
   */ initialize(renderer, alpha, frameBufferType) {}
    /**
   * Performs a shallow search for properties that define a dispose method and deletes them.
   *
   * The {@link EffectComposer} calls this method when it is being destroyed.
   */ dispose() {
        for (const key of Object.keys(this)){
            const property = this[key];
            const isDisposable = property instanceof (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f) || property instanceof (0, $ce0cdebec9150cb3$export$a2d8b23205c25948) || property instanceof (0, $ce0cdebec9150cb3$export$5431306cf43de24a) || property instanceof $2046da3312f94030$export$802bc10488da99c7;
            if (isDisposable) this[key].dispose();
        }
    }
};
// src/effects/glsl/ascii.frag
var $2046da3312f94030$var$ascii_default = `uniform sampler2D asciiTexture;uniform vec4 cellCount;
#ifdef USE_COLOR
uniform vec3 color;
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 pixelizedUv=cellCount.zw*(0.5+floor(uv*cellCount.xy));vec4 texel=texture(inputBuffer,pixelizedUv);float lum=min(luminance(texel.rgb),1.0);
#ifdef INVERTED
lum=1.0-lum;
#endif
float characterIndex=floor(CHAR_COUNT_MINUS_ONE*lum);vec2 characterPosition=vec2(mod(characterIndex,TEX_CELL_COUNT),floor(characterIndex*INV_TEX_CELL_COUNT));vec2 offset=vec2(characterPosition.x,-characterPosition.y)*INV_TEX_CELL_COUNT;vec2 characterUv=mod(uv*(cellCount.xy*INV_TEX_CELL_COUNT),INV_TEX_CELL_COUNT);characterUv=characterUv-vec2(0.0,INV_TEX_CELL_COUNT)+offset;float asciiCharacter=texture(asciiTexture,characterUv).r;
#ifdef USE_COLOR
outputColor=vec4(color*asciiCharacter,inputColor.a);
#else
outputColor=vec4(texel.rgb*asciiCharacter,inputColor.a);
#endif
}`;
// src/effects/ASCIIEffect.js
var $2046da3312f94030$export$98efc1d0bc513717 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new ASCII effect.
   *
   * @param {Object} [options] - The options.
   * @param {ASCIITexture} [options.asciiTexture] - An ASCII character lookup texture.
   * @param {Number} [options.cellSize=16] - The cell size. It's recommended to use even numbers.
   * @param {Number} [options.color=null] - A color to use instead of the scene colors.
   * @param {Boolean} [options.inverted=false] - Inverts the effect.
   */ constructor({ asciiTexture: asciiTexture = new $2046da3312f94030$export$dace868717185b4(), cellSize: cellSize = 16, color: color2 = null, inverted: inverted = false } = {}){
        super("ASCIIEffect", $2046da3312f94030$var$ascii_default, {
            uniforms: /* @__PURE__ */ new Map([
                [
                    "asciiTexture",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "cellCount",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)())
                ],
                [
                    "color",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)())
                ]
            ])
        });
        this._cellSize = -1;
        this.resolution = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        this.asciiTexture = asciiTexture;
        this.cellSize = cellSize;
        this.color = color2;
        this.inverted = inverted;
    }
    /**
   * The current ASCII lookup texture.
   *
   * @type {ASCIITexture}
   */ get asciiTexture() {
        return this.uniforms.get("asciiTexture").value;
    }
    set asciiTexture(value) {
        const currentTexture = this.uniforms.get("asciiTexture").value;
        this.uniforms.get("asciiTexture").value = value;
        if (currentTexture !== null && currentTexture !== value) currentTexture.dispose();
        if (value !== null) {
            const cellCount = value.cellCount;
            this.defines.set("CHAR_COUNT_MINUS_ONE", (value.characterCount - 1).toFixed(1));
            this.defines.set("TEX_CELL_COUNT", cellCount.toFixed(1));
            this.defines.set("INV_TEX_CELL_COUNT", (1 / cellCount).toFixed(9));
            this.setChanged();
        }
    }
    /**
   * A color that overrides the scene colors.
   *
   * @type {Color | String | Number | null}
   */ get color() {
        return this.uniforms.get("color").value;
    }
    set color(value) {
        if (value !== null) this.uniforms.get("color").value.set(value);
        if (this.defines.has("USE_COLOR") && value === null) {
            this.defines.delete("USE_COLOR");
            this.setChanged();
        } else if (!this.defines.has("USE_COLOR") && value !== null) {
            this.defines.set("USE_COLOR", "1");
            this.setChanged();
        }
    }
    /**
   * Controls whether the effect should be inverted.
   *
   * @type {Boolean}
   */ get inverted() {
        return this.defines.has("INVERTED");
    }
    set inverted(value) {
        if (this.inverted !== value) {
            if (value) this.defines.set("INVERTED", "1");
            else this.defines.delete("INVERTED");
            this.setChanged();
        }
    }
    /**
   * The cell size.
   *
   * @type {Number}
   */ get cellSize() {
        return this._cellSize;
    }
    set cellSize(value) {
        if (this._cellSize !== value) {
            this._cellSize = value;
            this.updateCellCount();
        }
    }
    /**
   * Updates the cell count uniform.
   *
   * @private
   */ updateCellCount() {
        const cellCount = this.uniforms.get("cellCount").value;
        const resolution = this.resolution;
        cellCount.x = resolution.width / this.cellSize;
        cellCount.y = resolution.height / this.cellSize;
        cellCount.z = 1 / cellCount.x;
        cellCount.w = 1 / cellCount.y;
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.resolution.set(width, height);
        this.updateCellCount();
    }
    /**
   * Deletes internal render targets and textures.
   */ dispose() {
        if (this.asciiTexture !== null) this.asciiTexture.dispose();
        super.dispose();
    }
};
// src/enums/KernelSize.js
var $2046da3312f94030$export$543b1e4815577d06 = {
    VERY_SMALL: 0,
    SMALL: 1,
    MEDIUM: 2,
    LARGE: 3,
    VERY_LARGE: 4,
    HUGE: 5
};
// src/materials/glsl/convolution.kawase.frag
var $2046da3312f94030$var$convolution_kawase_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec4 sum=texture2D(inputBuffer,vUv0);sum+=texture2D(inputBuffer,vUv1);sum+=texture2D(inputBuffer,vUv2);sum+=texture2D(inputBuffer,vUv3);gl_FragColor=sum*0.25;
#include <colorspace_fragment>
}`;
// src/materials/glsl/convolution.kawase.vert
var $2046da3312f94030$var$convolution_kawase_default2 = `uniform vec4 texelSize;uniform float kernel;uniform float scale;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vec2 dUv=(texelSize.xy*vec2(kernel)+texelSize.zw)*scale;vUv0=vec2(uv.x-dUv.x,uv.y+dUv.y);vUv1=vec2(uv.x+dUv.x,uv.y+dUv.y);vUv2=vec2(uv.x+dUv.x,uv.y-dUv.y);vUv3=vec2(uv.x-dUv.x,uv.y-dUv.y);gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/KawaseBlurMaterial.js
var $2046da3312f94030$var$kernelPresets = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        0,
        1,
        1
    ]),
    new Float32Array([
        0,
        1,
        1,
        2
    ]),
    new Float32Array([
        0,
        1,
        2,
        2,
        3
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        4,
        5
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        5,
        7,
        8,
        9,
        10
    ])
];
var $2046da3312f94030$export$c69ac3f2757c20a = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new convolution material.
   *
   * TODO Remove texelSize param.
   * @param {Vector4} [texelSize] - Deprecated.
   */ constructor(texelSize = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)()){
        super({
            name: "KawaseBlurMaterial",
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)()),
                scale: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1),
                kernel: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$convolution_kawase_default,
            vertexShader: $2046da3312f94030$var$convolution_kawase_default2
        });
        this.setTexelSize(texelSize.x, texelSize.y);
        this.kernelSize = $2046da3312f94030$export$543b1e4815577d06.MEDIUM;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.inputBuffer = value;
    }
    /**
   * The kernel sequence for the current kernel size.
   *
   * @type {Float32Array}
   */ get kernelSequence() {
        return $2046da3312f94030$var$kernelPresets[this.kernelSize];
    }
    /**
   * The blur scale.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.scale.value;
    }
    set scale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * Returns the blur scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} The scale.
   */ getScale() {
        return this.uniforms.scale.value;
    }
    /**
   * Sets the blur scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} value - The scale.
   */ setScale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * Returns the kernel.
   *
   * @return {Float32Array} The kernel.
   * @deprecated Implementation detail, removed with no replacement.
   */ getKernel() {
        return null;
    }
    /**
   * The current kernel.
   *
   * @type {Number}
   */ get kernel() {
        return this.uniforms.kernel.value;
    }
    set kernel(value) {
        this.uniforms.kernel.value = value;
    }
    /**
   * Sets the current kernel.
   *
   * @deprecated Use kernel instead.
   * @param {Number} value - The kernel.
   */ setKernel(value) {
        this.kernel = value;
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y, x * 0.5, y * 0.5);
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const x = 1 / width, y = 1 / height;
        this.uniforms.texelSize.value.set(x, y, x * 0.5, y * 0.5);
    }
};
// src/passes/KawaseBlurPass.js
var $2046da3312f94030$export$657273fee9302035 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new Kawase blur pass.
   *
   * @param {Object} [options] - The options.
   * @param {KernelSize} [options.kernelSize=KernelSize.MEDIUM] - The blur kernel size.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor({ kernelSize: kernelSize = $2046da3312f94030$export$543b1e4815577d06.MEDIUM, resolutionScale: resolutionScale = 0.5, width: width = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, height: height = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("KawaseBlurPass");
        this.renderTargetA = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetA.texture.name = "Blur.Target.A";
        this.renderTargetB = this.renderTargetA.clone();
        this.renderTargetB.texture.name = "Blur.Target.B";
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this._blurMaterial = new $2046da3312f94030$export$c69ac3f2757c20a();
        this._blurMaterial.kernelSize = kernelSize;
        this.copyMaterial = new $2046da3312f94030$export$d4b5f24bda67f7e4();
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * The blur material.
   *
   * @type {KawaseBlurMaterial}
   */ get blurMaterial() {
        return this._blurMaterial;
    }
    /**
   * The blur material.
   *
   * @type {KawaseBlurMaterial}
   * @protected
   */ set blurMaterial(value) {
        this._blurMaterial = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   * @deprecated Use copyMaterial.dithering instead.
   */ get dithering() {
        return this.copyMaterial.dithering;
    }
    set dithering(value) {
        this.copyMaterial.dithering = value;
    }
    /**
   * The kernel size.
   *
   * @type {KernelSize}
   * @deprecated Use blurMaterial.kernelSize instead.
   */ get kernelSize() {
        return this.blurMaterial.kernelSize;
    }
    set kernelSize(value) {
        this.blurMaterial.kernelSize = value;
    }
    /**
   * The current width of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.width instead.
   */ get width() {
        return this.resolution.width;
    }
    /**
   * Sets the render width.
   *
   * @type {Number}
   * @deprecated Use resolution.preferredWidth instead.
   */ set width(value) {
        this.resolution.preferredWidth = value;
    }
    /**
   * The current height of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.height instead.
   */ get height() {
        return this.resolution.height;
    }
    /**
   * Sets the render height.
   *
   * @type {Number}
   * @deprecated Use resolution.preferredHeight instead.
   */ set height(value) {
        this.resolution.preferredHeight = value;
    }
    /**
   * The current blur scale.
   *
   * @type {Number}
   * @deprecated Use blurMaterial.scale instead.
   */ get scale() {
        return this.blurMaterial.scale;
    }
    set scale(value) {
        this.blurMaterial.scale = value;
    }
    /**
   * Returns the current blur scale.
   *
   * @deprecated Use blurMaterial.scale instead.
   * @return {Number} The scale.
   */ getScale() {
        return this.blurMaterial.scale;
    }
    /**
   * Sets the blur scale.
   *
   * @deprecated Use blurMaterial.scale instead.
   * @param {Number} value - The scale.
   */ setScale(value) {
        this.blurMaterial.scale = value;
    }
    /**
   * Returns the kernel size.
   *
   * @deprecated Use blurMaterial.kernelSize instead.
   * @return {KernelSize} The kernel size.
   */ getKernelSize() {
        return this.kernelSize;
    }
    /**
   * Sets the kernel size.
   *
   * Larger kernels require more processing power but scale well with larger render resolutions.
   *
   * @deprecated Use blurMaterial.kernelSize instead.
   * @param {KernelSize} value - The kernel size.
   */ setKernelSize(value) {
        this.kernelSize = value;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Renders the blur.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const scene = this.scene;
        const camera = this.camera;
        const renderTargetA = this.renderTargetA;
        const renderTargetB = this.renderTargetB;
        const material = this.blurMaterial;
        const kernelSequence = material.kernelSequence;
        let previousBuffer = inputBuffer;
        this.fullscreenMaterial = material;
        for(let i = 0, l = kernelSequence.length; i < l; ++i){
            const buffer = (i & 1) === 0 ? renderTargetA : renderTargetB;
            material.kernel = kernelSequence[i];
            material.inputBuffer = previousBuffer.texture;
            renderer.setRenderTarget(buffer);
            renderer.render(scene, camera);
            previousBuffer = buffer;
        }
        this.fullscreenMaterial = this.copyMaterial;
        this.copyMaterial.inputBuffer = previousBuffer.texture;
        renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
        renderer.render(scene, camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.renderTargetA.setSize(w, h);
        this.renderTargetB.setSize(w, h);
        this.blurMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0) {
            this.renderTargetA.texture.type = frameBufferType;
            this.renderTargetB.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) {
                this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
                this.copyMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            } else if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) {
                this.renderTargetA.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.renderTargetB.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
            }
        }
    }
    /**
   * An auto sizing flag.
   *
   * @type {Number}
   * @deprecated Use {@link Resolution.AUTO_SIZE} instead.
   */ static get AUTO_SIZE() {
        return $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE;
    }
};
// src/materials/glsl/luminance.frag
var $2046da3312f94030$var$luminance_default = `#include <common>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef RANGE
uniform vec2 range;
#elif defined(THRESHOLD)
uniform float threshold;uniform float smoothing;
#endif
varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);float l=luminance(texel.rgb);float mask=1.0;
#ifdef RANGE
float low=step(range.x,l);float high=step(l,range.y);mask=low*high;
#elif defined(THRESHOLD)
mask=smoothstep(threshold,threshold+smoothing,l);
#endif
#ifdef COLOR
gl_FragColor=texel*mask;
#else
gl_FragColor=vec4(l*mask);
#endif
}`;
// src/materials/LuminanceMaterial.js
var $2046da3312f94030$export$5965aa8be393908 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new luminance material.
   *
   * @param {Boolean} [colorOutput=false] - Defines whether the shader should output colors scaled with their luminance value.
   * @param {Vector2} [luminanceRange] - If provided, the shader will mask out texels that aren't in the specified luminance range.
   */ constructor(colorOutput = false, luminanceRange = null){
        super({
            name: "LuminanceMaterial",
            defines: {
                THREE_REVISION: (0, $ce0cdebec9150cb3$export$3545e07a80636437).replace(/\D+/g, "")
            },
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                threshold: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0),
                smoothing: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1),
                range: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$luminance_default,
            vertexShader: $2046da3312f94030$var$common_default
        });
        this.colorOutput = colorOutput;
        this.luminanceRange = luminanceRange;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The luminance threshold.
   *
   * @type {Number}
   */ get threshold() {
        return this.uniforms.threshold.value;
    }
    set threshold(value) {
        if (this.smoothing > 0 || value > 0) this.defines.THRESHOLD = "1";
        else delete this.defines.THRESHOLD;
        this.uniforms.threshold.value = value;
    }
    /**
   * Returns the luminance threshold.
   *
   * @deprecated Use threshold instead.
   * @return {Number} The threshold.
   */ getThreshold() {
        return this.threshold;
    }
    /**
   * Sets the luminance threshold.
   *
   * @deprecated Use threshold instead.
   * @param {Number} value - The threshold.
   */ setThreshold(value) {
        this.threshold = value;
    }
    /**
   * The luminance threshold smoothing.
   *
   * @type {Number}
   */ get smoothing() {
        return this.uniforms.smoothing.value;
    }
    set smoothing(value) {
        if (this.threshold > 0 || value > 0) this.defines.THRESHOLD = "1";
        else delete this.defines.THRESHOLD;
        this.uniforms.smoothing.value = value;
    }
    /**
   * Returns the luminance threshold smoothing factor.
   *
   * @deprecated Use smoothing instead.
   * @return {Number} The smoothing factor.
   */ getSmoothingFactor() {
        return this.smoothing;
    }
    /**
   * Sets the luminance threshold smoothing factor.
   *
   * @deprecated Use smoothing instead.
   * @param {Number} value - The smoothing factor.
   */ setSmoothingFactor(value) {
        this.smoothing = value;
    }
    /**
   * Indicates whether the luminance threshold is enabled.
   *
   * @type {Boolean}
   * @deprecated Adjust the threshold or smoothing factor instead.
   */ get useThreshold() {
        return this.threshold > 0 || this.smoothing > 0;
    }
    set useThreshold(value) {}
    /**
   * Indicates whether color output is enabled.
   *
   * @type {Boolean}
   */ get colorOutput() {
        return this.defines.COLOR !== void 0;
    }
    set colorOutput(value) {
        if (value) this.defines.COLOR = "1";
        else delete this.defines.COLOR;
        this.needsUpdate = true;
    }
    /**
   * Indicates whether color output is enabled.
   *
   * @deprecated Use colorOutput instead.
   * @return {Boolean} Whether color output is enabled.
   */ isColorOutputEnabled(value) {
        return this.colorOutput;
    }
    /**
   * Enables or disables color output.
   *
   * @deprecated Use colorOutput instead.
   * @param {Boolean} value - Whether color output should be enabled.
   */ setColorOutputEnabled(value) {
        this.colorOutput = value;
    }
    /**
   * Indicates whether luminance masking is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get useRange() {
        return this.luminanceRange !== null;
    }
    set useRange(value) {
        this.luminanceRange = null;
    }
    /**
   * The luminance range. Set to null to disable.
   *
   * @type {Boolean}
   */ get luminanceRange() {
        return this.uniforms.range.value;
    }
    set luminanceRange(value) {
        if (value !== null) this.defines.RANGE = "1";
        else delete this.defines.RANGE;
        this.uniforms.range.value = value;
        this.needsUpdate = true;
    }
    /**
   * Returns the current luminance range.
   *
   * @deprecated Use luminanceRange instead.
   * @return {Vector2} The luminance range.
   */ getLuminanceRange() {
        return this.luminanceRange;
    }
    /**
   * Sets a luminance range. Set to null to disable.
   *
   * @deprecated Use luminanceRange instead.
   * @param {Vector2} value - The luminance range.
   */ setLuminanceRange(value) {
        this.luminanceRange = value;
    }
};
// src/passes/LuminancePass.js
var $2046da3312f94030$export$855ea63a754bfd18 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new luminance pass.
   *
   * @param {Object} [options] - The options. See {@link LuminanceMaterial} for additional options.
   * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor({ renderTarget: renderTarget, luminanceRange: luminanceRange, colorOutput: colorOutput, resolutionScale: resolutionScale = 1, width: width = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, height: height = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("LuminancePass");
        this.fullscreenMaterial = new $2046da3312f94030$export$5965aa8be393908(colorOutput, luminanceRange);
        this.needsSwap = false;
        this.renderTarget = renderTarget;
        if (this.renderTarget === void 0) {
            this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
                depthBuffer: false
            });
            this.renderTarget.texture.name = "LuminancePass.Target";
        }
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    /**
   * The luminance texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the luminance texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Renders the luminance.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const material = this.fullscreenMaterial;
        material.inputBuffer = inputBuffer.texture;
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - A renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0 && frameBufferType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) {
            this.renderTarget.texture.type = frameBufferType;
            this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
        }
    }
};
// src/materials/glsl/convolution.downsampling.frag
var $2046da3312f94030$var$convolution_downsampling_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#define WEIGHT_INNER 0.125
#define WEIGHT_OUTER 0.05556
varying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;float clampToBorder(const in vec2 uv){return float(uv.s>=0.0&&uv.s<=1.0&&uv.t>=0.0&&uv.t<=1.0);}void main(){vec4 c=vec4(0.0);vec4 w=WEIGHT_INNER*vec4(clampToBorder(vUv00),clampToBorder(vUv01),clampToBorder(vUv02),clampToBorder(vUv03));c+=w.x*texture2D(inputBuffer,vUv00);c+=w.y*texture2D(inputBuffer,vUv01);c+=w.z*texture2D(inputBuffer,vUv02);c+=w.w*texture2D(inputBuffer,vUv03);w=WEIGHT_OUTER*vec4(clampToBorder(vUv04),clampToBorder(vUv05),clampToBorder(vUv06),clampToBorder(vUv07));c+=w.x*texture2D(inputBuffer,vUv04);c+=w.y*texture2D(inputBuffer,vUv05);c+=w.z*texture2D(inputBuffer,vUv06);c+=w.w*texture2D(inputBuffer,vUv07);w=WEIGHT_OUTER*vec4(clampToBorder(vUv08),clampToBorder(vUv09),clampToBorder(vUv10),clampToBorder(vUv11));c+=w.x*texture2D(inputBuffer,vUv08);c+=w.y*texture2D(inputBuffer,vUv09);c+=w.z*texture2D(inputBuffer,vUv10);c+=w.w*texture2D(inputBuffer,vUv11);c+=WEIGHT_OUTER*texture2D(inputBuffer,vUv);gl_FragColor=c;
#include <colorspace_fragment>
}`;
// src/materials/glsl/convolution.downsampling.vert
var $2046da3312f94030$var$convolution_downsampling_default2 = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv00;varying vec2 vUv01;varying vec2 vUv02;varying vec2 vUv03;varying vec2 vUv04;varying vec2 vUv05;varying vec2 vUv06;varying vec2 vUv07;varying vec2 vUv08;varying vec2 vUv09;varying vec2 vUv10;varying vec2 vUv11;void main(){vUv=position.xy*0.5+0.5;vUv00=vUv+texelSize*vec2(-1.0,1.0);vUv01=vUv+texelSize*vec2(1.0,1.0);vUv02=vUv+texelSize*vec2(-1.0,-1.0);vUv03=vUv+texelSize*vec2(1.0,-1.0);vUv04=vUv+texelSize*vec2(-2.0,2.0);vUv05=vUv+texelSize*vec2(0.0,2.0);vUv06=vUv+texelSize*vec2(2.0,2.0);vUv07=vUv+texelSize*vec2(-2.0,0.0);vUv08=vUv+texelSize*vec2(2.0,0.0);vUv09=vUv+texelSize*vec2(-2.0,-2.0);vUv10=vUv+texelSize*vec2(0.0,-2.0);vUv11=vUv+texelSize*vec2(2.0,-2.0);gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/DownsamplingMaterial.js
var $2046da3312f94030$export$28b4600b285eba04 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new downsampling material.
   */ constructor(){
        super({
            name: "DownsamplingMaterial",
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$convolution_downsampling_default,
            vertexShader: $2046da3312f94030$var$convolution_downsampling_default2
        });
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/materials/glsl/convolution.upsampling.frag
var $2046da3312f94030$var$convolution_upsampling_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;uniform mediump sampler2D supportBuffer;
#else
uniform lowp sampler2D inputBuffer;uniform lowp sampler2D supportBuffer;
#endif
uniform float radius;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vec4 c=vec4(0.0);c+=texture2D(inputBuffer,vUv0)*0.0625;c+=texture2D(inputBuffer,vUv1)*0.125;c+=texture2D(inputBuffer,vUv2)*0.0625;c+=texture2D(inputBuffer,vUv3)*0.125;c+=texture2D(inputBuffer,vUv)*0.25;c+=texture2D(inputBuffer,vUv4)*0.125;c+=texture2D(inputBuffer,vUv5)*0.0625;c+=texture2D(inputBuffer,vUv6)*0.125;c+=texture2D(inputBuffer,vUv7)*0.0625;vec4 baseColor=texture2D(supportBuffer,vUv);gl_FragColor=mix(baseColor,c,radius);
#include <colorspace_fragment>
}`;
// src/materials/glsl/convolution.upsampling.vert
var $2046da3312f94030$var$convolution_upsampling_default2 = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;varying vec2 vUv6;varying vec2 vUv7;void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,1.0);vUv1=vUv+texelSize*vec2(0.0,1.0);vUv2=vUv+texelSize*vec2(1.0,1.0);vUv3=vUv+texelSize*vec2(-1.0,0.0);vUv4=vUv+texelSize*vec2(1.0,0.0);vUv5=vUv+texelSize*vec2(-1.0,-1.0);vUv6=vUv+texelSize*vec2(0.0,-1.0);vUv7=vUv+texelSize*vec2(1.0,-1.0);gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/UpsamplingMaterial.js
var $2046da3312f94030$export$bfa5970d414d05b5 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new upsampling material.
   */ constructor(){
        super({
            name: "UpsamplingMaterial",
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                supportBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                radius: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0.85)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$convolution_upsampling_default,
            vertexShader: $2046da3312f94030$var$convolution_upsampling_default2
        });
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * A support buffer.
   *
   * @type {Texture}
   */ set supportBuffer(value) {
        this.uniforms.supportBuffer.value = value;
    }
    /**
   * The blur radius.
   *
   * @type {Number}
   */ get radius() {
        return this.uniforms.radius.value;
    }
    set radius(value) {
        this.uniforms.radius.value = value;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/passes/MipmapBlurPass.js
var $2046da3312f94030$export$dd9496fb07a8ca00 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new mipmap blur pass.
   *
   * @param {Object} [options] - The options.
   */ constructor(){
        super("MipmapBlurPass");
        this.needsSwap = false;
        this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "Upsampling.Mipmap0";
        this.downsamplingMipmaps = [];
        this.upsamplingMipmaps = [];
        this.downsamplingMaterial = new $2046da3312f94030$export$28b4600b285eba04();
        this.upsamplingMaterial = new $2046da3312f94030$export$bfa5970d414d05b5();
        this.resolution = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
    }
    /**
   * A texture that contains the blurred result.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * The MIP levels. Default is 8.
   *
   * @type {Number}
   */ get levels() {
        return this.downsamplingMipmaps.length;
    }
    set levels(value) {
        if (this.levels !== value) {
            const renderTarget = this.renderTarget;
            this.dispose();
            this.downsamplingMipmaps = [];
            this.upsamplingMipmaps = [];
            for(let i = 0; i < value; ++i){
                const mipmap = renderTarget.clone();
                mipmap.texture.name = "Downsampling.Mipmap" + i;
                this.downsamplingMipmaps.push(mipmap);
            }
            this.upsamplingMipmaps.push(renderTarget);
            for(let i = 1, l = value - 1; i < l; ++i){
                const mipmap = renderTarget.clone();
                mipmap.texture.name = "Upsampling.Mipmap" + i;
                this.upsamplingMipmaps.push(mipmap);
            }
            this.setSize(this.resolution.x, this.resolution.y);
        }
    }
    /**
   * The blur radius.
   *
   * @type {Number}
   */ get radius() {
        return this.upsamplingMaterial.radius;
    }
    set radius(value) {
        this.upsamplingMaterial.radius = value;
    }
    /**
   * Renders the blur.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const { scene: scene, camera: camera } = this;
        const { downsamplingMaterial: downsamplingMaterial, upsamplingMaterial: upsamplingMaterial } = this;
        const { downsamplingMipmaps: downsamplingMipmaps, upsamplingMipmaps: upsamplingMipmaps } = this;
        let previousBuffer = inputBuffer;
        this.fullscreenMaterial = downsamplingMaterial;
        for(let i = 0, l = downsamplingMipmaps.length; i < l; ++i){
            const mipmap = downsamplingMipmaps[i];
            downsamplingMaterial.setSize(previousBuffer.width, previousBuffer.height);
            downsamplingMaterial.inputBuffer = previousBuffer.texture;
            renderer.setRenderTarget(mipmap);
            renderer.render(scene, camera);
            previousBuffer = mipmap;
        }
        this.fullscreenMaterial = upsamplingMaterial;
        for(let i = upsamplingMipmaps.length - 1; i >= 0; --i){
            const mipmap = upsamplingMipmaps[i];
            upsamplingMaterial.setSize(previousBuffer.width, previousBuffer.height);
            upsamplingMaterial.inputBuffer = previousBuffer.texture;
            upsamplingMaterial.supportBuffer = downsamplingMipmaps[i].texture;
            renderer.setRenderTarget(mipmap);
            renderer.render(scene, camera);
            previousBuffer = mipmap;
        }
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.set(width, height);
        let w = resolution.width, h = resolution.height;
        for(let i = 0, l = this.downsamplingMipmaps.length; i < l; ++i){
            w = Math.round(w * 0.5);
            h = Math.round(h * 0.5);
            this.downsamplingMipmaps[i].setSize(w, h);
            if (i < this.upsamplingMipmaps.length) this.upsamplingMipmaps[i].setSize(w, h);
        }
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0) {
            const mipmaps = this.downsamplingMipmaps.concat(this.upsamplingMipmaps);
            for (const mipmap of mipmaps)mipmap.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) {
                this.downsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
                this.upsamplingMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            } else if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) for (const mipmap of mipmaps)mipmap.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
        }
    }
    /**
   * Deletes internal render targets and textures.
   */ dispose() {
        super.dispose();
        for (const mipmap of this.downsamplingMipmaps.concat(this.upsamplingMipmaps))mipmap.dispose();
    }
};
// src/effects/glsl/bloom.frag
var $2046da3312f94030$var$bloom_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
uniform float intensity;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=texture2D(map,uv)*intensity;}`;
// src/effects/BloomEffect.js
var $2046da3312f94030$export$1e2a1743038c77d5 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new bloom effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function of this effect.
   * @param {Number} [options.luminanceThreshold=1.0] - The luminance threshold. Raise this value to mask out darker elements in the scene.
   * @param {Number} [options.luminanceSmoothing=0.03] - Controls the smoothness of the luminance threshold.
   * @param {Boolean} [options.mipmapBlur=true] - Enables or disables mipmap blur.
   * @param {Number} [options.intensity=1.0] - The bloom intensity.
   * @param {Number} [options.radius=0.85] - The blur radius. Only applies to mipmap blur.
   * @param {Number} [options.levels=8] - The amount of MIP levels. Only applies to mipmap blur.
   * @param {KernelSize} [options.kernelSize=KernelSize.LARGE] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.resolutionScale=0.5] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use mipmapBlur instead.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SCREEN, luminanceThreshold: luminanceThreshold = 1, luminanceSmoothing: luminanceSmoothing = 0.03, mipmapBlur: mipmapBlur = true, intensity: intensity = 1, radius: radius = 0.85, levels: levels = 8, kernelSize: kernelSize = $2046da3312f94030$export$543b1e4815577d06.LARGE, resolutionScale: resolutionScale = 0.5, width: width = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, height: height = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("BloomEffect", $2046da3312f94030$var$bloom_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "map",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "intensity",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(intensity)
                ]
            ])
        });
        this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "Bloom.Target";
        this.blurPass = new $2046da3312f94030$export$657273fee9302035({
            kernelSize: kernelSize
        });
        this.luminancePass = new $2046da3312f94030$export$855ea63a754bfd18({
            colorOutput: true
        });
        this.luminanceMaterial.threshold = luminanceThreshold;
        this.luminanceMaterial.smoothing = luminanceSmoothing;
        this.mipmapBlurPass = new $2046da3312f94030$export$dd9496fb07a8ca00();
        this.mipmapBlurPass.enabled = mipmapBlur;
        this.mipmapBlurPass.radius = radius;
        this.mipmapBlurPass.levels = levels;
        this.uniforms.get("map").value = mipmapBlur ? this.mipmapBlurPass.texture : this.renderTarget.texture;
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    /**
   * A texture that contains the intermediate result of this effect.
   *
   * @type {Texture}
   */ get texture() {
        return this.mipmapBlurPass.enabled ? this.mipmapBlurPass.texture : this.renderTarget.texture;
    }
    /**
   * Returns the generated bloom texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Returns the blur pass.
   *
   * @deprecated
   * @return {KawaseBlurPass} The blur pass.
   */ getBlurPass() {
        return this.blurPass;
    }
    /**
   * Returns the luminance pass.
   *
   * @deprecated Use luminancePass instead.
   * @return {LuminancePass} The luminance pass.
   */ getLuminancePass() {
        return this.luminancePass;
    }
    /**
   * The luminance material.
   *
   * @type {LuminanceMaterial}
   */ get luminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    /**
   * Returns the luminance material.
   *
   * @deprecated Use luminanceMaterial instead.
   * @return {LuminanceMaterial} The material.
   */ getLuminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    /**
   * The current width of the internal render targets.
   *
   * @type {Number}
   * @deprecated
   */ get width() {
        return this.resolution.width;
    }
    set width(value) {
        this.resolution.preferredWidth = value;
    }
    /**
   * The current height of the internal render targets.
   *
   * @type {Number}
   * @deprecated
   */ get height() {
        return this.resolution.height;
    }
    set height(value) {
        this.resolution.preferredHeight = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   * @deprecated Use EffectPass.dithering instead.
   */ get dithering() {
        return this.blurPass.dithering;
    }
    set dithering(value) {
        this.blurPass.dithering = value;
    }
    /**
   * The blur kernel size.
   *
   * @type {KernelSize}
   * @deprecated
   */ get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(value) {
        this.blurPass.kernelSize = value;
    }
    /**
   * @type {Number}
   * @deprecated
   */ get distinction() {
        console.warn(this.name, "distinction was removed");
        return 1;
    }
    set distinction(value) {
        console.warn(this.name, "distinction was removed");
    }
    /**
   * The bloom intensity.
   *
   * @type {Number}
   */ get intensity() {
        return this.uniforms.get("intensity").value;
    }
    set intensity(value) {
        this.uniforms.get("intensity").value = value;
    }
    /**
   * The bloom intensity.
   *
   * @deprecated Use intensity instead.
   * @return {Number} The intensity.
   */ getIntensity() {
        return this.intensity;
    }
    /**
   * Sets the bloom intensity.
   *
   * @deprecated Use intensity instead.
   * @param {Number} value - The intensity.
   */ setIntensity(value) {
        this.intensity = value;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const renderTarget = this.renderTarget;
        const luminancePass = this.luminancePass;
        if (luminancePass.enabled) {
            luminancePass.render(renderer, inputBuffer);
            if (this.mipmapBlurPass.enabled) this.mipmapBlurPass.render(renderer, luminancePass.renderTarget);
            else this.blurPass.render(renderer, luminancePass.renderTarget, renderTarget);
        } else if (this.mipmapBlurPass.enabled) this.mipmapBlurPass.render(renderer, inputBuffer);
        else this.blurPass.render(renderer, inputBuffer, renderTarget);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
        this.blurPass.resolution.copy(resolution);
        this.luminancePass.setSize(width, height);
        this.mipmapBlurPass.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.blurPass.initialize(renderer, alpha, frameBufferType);
        this.luminancePass.initialize(renderer, alpha, frameBufferType);
        this.mipmapBlurPass.initialize(renderer, alpha, frameBufferType);
        if (frameBufferType !== void 0) {
            this.renderTarget.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) this.renderTarget.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
        }
    }
};
// src/effects/glsl/bokeh.frag
var $2046da3312f94030$var$bokeh_default = `uniform float focus;uniform float dof;uniform float aperture;uniform float maxBlur;void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){vec2 aspectCorrection=vec2(1.0,aspect);
#ifdef PERSPECTIVE_CAMERA
float viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);
#else
float linearDepth=depth;
#endif
float focusNear=clamp(focus-dof,0.0,1.0);float focusFar=clamp(focus+dof,0.0,1.0);float low=step(linearDepth,focusNear);float high=step(focusFar,linearDepth);float factor=(linearDepth-focusNear)*low+(linearDepth-focusFar)*high;vec2 dofBlur=vec2(clamp(factor*aperture,-maxBlur,maxBlur));vec2 dofblur9=dofBlur*0.9;vec2 dofblur7=dofBlur*0.7;vec2 dofblur4=dofBlur*0.4;vec4 color=inputColor;color+=texture2D(inputBuffer,uv+(vec2(0.0,0.4)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.15,0.37)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.29,0.29)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.37,0.15)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.40,0.0)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.37,-0.15)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.29,-0.29)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.15,-0.37)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.0,-0.4)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.15,0.37)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.29,0.29)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.37,0.15)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.4,0.0)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.37,-0.15)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(-0.29,-0.29)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.15,-0.37)*aspectCorrection)*dofBlur);color+=texture2D(inputBuffer,uv+(vec2(0.15,0.37)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(-0.37,0.15)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(0.37,-0.15)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(-0.15,-0.37)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(-0.15,0.37)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(0.37,0.15)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(-0.37,-0.15)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(0.15,-0.37)*aspectCorrection)*dofblur9);color+=texture2D(inputBuffer,uv+(vec2(0.29,0.29)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.40,0.0)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.29,-0.29)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.0,-0.4)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(-0.29,0.29)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(-0.4,0.0)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(-0.29,-0.29)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.0,0.4)*aspectCorrection)*dofblur7);color+=texture2D(inputBuffer,uv+(vec2(0.29,0.29)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(0.4,0.0)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(0.29,-0.29)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(0.0,-0.4)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(-0.29,0.29)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(-0.4,0.0)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(-0.29,-0.29)*aspectCorrection)*dofblur4);color+=texture2D(inputBuffer,uv+(vec2(0.0,0.4)*aspectCorrection)*dofblur4);outputColor=color/41.0;}`;
// src/effects/BokehEffect.js
var $2046da3312f94030$export$39a5b8c6d088825c = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new bokeh effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.focus=0.5] - The focus distance ratio, ranging from 0.0 to 1.0.
   * @param {Number} [options.dof=0.02] - Depth of field. An area in front of and behind the focal point that still appears sharp.
   * @param {Number} [options.aperture=0.015] - Camera aperture scale. Bigger values for stronger blur and shallower depth of field.
   * @param {Number} [options.maxBlur=1.0] - The maximum blur strength.
   */ constructor({ blendFunction: blendFunction, focus: focus = 0.5, dof: dof = 0.02, aperture: aperture = 0.015, maxBlur: maxBlur = 1 } = {}){
        super("BokehEffect", $2046da3312f94030$var$bokeh_default, {
            blendFunction: blendFunction,
            attributes: $2046da3312f94030$export$a72ebb312f9e05c6.CONVOLUTION | $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "focus",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(focus)
                ],
                [
                    "dof",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(dof)
                ],
                [
                    "aperture",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(aperture)
                ],
                [
                    "maxBlur",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(maxBlur)
                ]
            ])
        });
    }
};
// src/effects/glsl/brightness-contrast.frag
var $2046da3312f94030$var$brightness_contrast_default = `uniform float brightness;uniform float contrast;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=inputColor.rgb+vec3(brightness-0.5);if(contrast>0.0){color/=vec3(1.0-contrast);}else{color*=vec3(1.0+contrast);}outputColor=vec4(color+vec3(0.5),inputColor.a);}`;
// src/effects/BrightnessContrastEffect.js
var $2046da3312f94030$export$35667687ce6e9ce = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new brightness/contrast effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Number} [options.brightness=0.0] - The brightness factor, ranging from -1 to 1, where 0 means no change.
   * @param {Number} [options.contrast=0.0] - The contrast factor, ranging from -1 to 1, where 0 means no change.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SRC, brightness: brightness = 0, contrast: contrast = 0 } = {}){
        super("BrightnessContrastEffect", $2046da3312f94030$var$brightness_contrast_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "brightness",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(brightness)
                ],
                [
                    "contrast",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(contrast)
                ]
            ])
        });
        this.inputColorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
    }
    /**
   * The brightness.
   *
   * @type {Number}
   */ get brightness() {
        return this.uniforms.get("brightness").value;
    }
    set brightness(value) {
        this.uniforms.get("brightness").value = value;
    }
    /**
   * Returns the brightness.
   *
   * @deprecated Use brightness instead.
   * @return {Number} The brightness.
   */ getBrightness() {
        return this.brightness;
    }
    /**
   * Sets the brightness.
   *
   * @deprecated Use brightness instead.
   * @param {Number} value - The brightness.
   */ setBrightness(value) {
        this.brightness = value;
    }
    /**
   * The contrast.
   *
   * @type {Number}
   */ get contrast() {
        return this.uniforms.get("contrast").value;
    }
    set contrast(value) {
        this.uniforms.get("contrast").value = value;
    }
    /**
   * Returns the contrast.
   *
   * @deprecated Use contrast instead.
   * @return {Number} The contrast.
   */ getContrast() {
        return this.contrast;
    }
    /**
   * Sets the contrast.
   *
   * @deprecated Use contrast instead.
   * @param {Number} value - The contrast.
   */ setContrast(value) {
        this.contrast = value;
    }
};
// src/effects/glsl/color-average.frag
var $2046da3312f94030$var$color_average_default = `void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(vec3(average(inputColor.rgb)),inputColor.a);}`;
// src/effects/ColorAverageEffect.js
var $2046da3312f94030$export$562d7192c2de1170 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new color average effect.
   *
   * @param {BlendFunction} [blendFunction] - The blend function of this effect.
   */ constructor(blendFunction){
        super("ColorAverageEffect", $2046da3312f94030$var$color_average_default, {
            blendFunction: blendFunction
        });
    }
};
// src/effects/glsl/color-depth.frag
var $2046da3312f94030$var$color_depth_default = `uniform float factor;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(floor(inputColor.rgb*factor+0.5)/factor,inputColor.a);}`;
// src/effects/ColorDepthEffect.js
var $2046da3312f94030$export$3520bcefece76c80 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new color depth effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.bits=16] - The color bit depth.
   */ constructor({ blendFunction: blendFunction, bits: bits = 16 } = {}){
        super("ColorDepthEffect", $2046da3312f94030$var$color_depth_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "factor",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
                ]
            ])
        });
        this.bits = 0;
        this.bitDepth = bits;
    }
    /**
   * The virtual amount of color bits.
   *
   * Each color channel effectively uses a fourth of the total amount of bits. Alpha remains unaffected.
   *
   * @type {Number}
   */ get bitDepth() {
        return this.bits;
    }
    set bitDepth(value) {
        this.bits = value;
        this.uniforms.get("factor").value = Math.pow(2, value / 3);
    }
    /**
   * Returns the current color bit depth.
   *
   * @return {Number} The bit depth.
   */ getBitDepth() {
        return this.bitDepth;
    }
    /**
   * Sets the virtual amount of color bits.
   *
   * @param {Number} value - The bit depth.
   */ setBitDepth(value) {
        this.bitDepth = value;
    }
};
// src/effects/glsl/chromatic-aberration.frag
var $2046da3312f94030$var$chromatic_aberration_default = `#ifdef RADIAL_MODULATION
uniform float modulationOffset;
#endif
varying float vActive;varying vec2 vUvR;varying vec2 vUvB;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 ra=inputColor.ra;vec2 ba=inputColor.ba;
#ifdef RADIAL_MODULATION
const vec2 center=vec2(0.5);float d=distance(uv,center)*2.0;d=max(d-modulationOffset,0.0);if(vActive>0.0&&d>0.0){ra=texture2D(inputBuffer,mix(uv,vUvR,d)).ra;ba=texture2D(inputBuffer,mix(uv,vUvB,d)).ba;}
#else
if(vActive>0.0){ra=texture2D(inputBuffer,vUvR).ra;ba=texture2D(inputBuffer,vUvB).ba;}
#endif
outputColor=vec4(ra.x,inputColor.g,ba.x,max(max(ra.y,ba.y),inputColor.a));}`;
// src/effects/glsl/chromatic-aberration.vert
var $2046da3312f94030$var$chromatic_aberration_default2 = `uniform vec2 offset;varying float vActive;varying vec2 vUvR;varying vec2 vUvB;void mainSupport(const in vec2 uv){vec2 shift=offset*vec2(1.0,aspect);vActive=(shift.x!=0.0||shift.y!=0.0)?1.0:0.0;vUvR=uv+shift;vUvB=uv-shift;}`;
// src/effects/ChromaticAberrationEffect.js
var $2046da3312f94030$export$5d827f77057feeb7 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new chromatic aberration effect.
   *
   * @param {Object} [options] - The options.
   * @param {Vector2} [options.offset] - The color offset.
   * @param {Boolean} [options.radialModulation=false] - Whether the effect should be modulated with a radial gradient.
   * @param {Number} [options.modulationOffset=0.15] - The modulation offset. Only applies if `radialModulation` is enabled.
   */ constructor({ offset: offset = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(1e-3, 5e-4), radialModulation: radialModulation = false, modulationOffset: modulationOffset = 0.15 } = {}){
        super("ChromaticAberrationEffect", $2046da3312f94030$var$chromatic_aberration_default, {
            vertexShader: $2046da3312f94030$var$chromatic_aberration_default2,
            attributes: $2046da3312f94030$export$a72ebb312f9e05c6.CONVOLUTION,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "offset",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(offset)
                ],
                [
                    "modulationOffset",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(modulationOffset)
                ]
            ])
        });
        this.radialModulation = radialModulation;
    }
    /**
   * The color offset.
   *
   * @type {Vector2}
   */ get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(value) {
        this.uniforms.get("offset").value = value;
    }
    /**
   * Indicates whether radial modulation is enabled.
   *
   * When enabled, the effect will be weaker in the middle and stronger towards the screen edges.
   *
   * @type {Boolean}
   */ get radialModulation() {
        return this.defines.has("RADIAL_MODULATION");
    }
    set radialModulation(value) {
        if (value) this.defines.set("RADIAL_MODULATION", "1");
        else this.defines.delete("RADIAL_MODULATION");
        this.setChanged();
    }
    /**
   * The modulation offset.
   *
   * @type {Number}
   */ get modulationOffset() {
        return this.uniforms.get("modulationOffset").value;
    }
    set modulationOffset(value) {
        this.uniforms.get("modulationOffset").value = value;
    }
    /**
   * Returns the color offset vector.
   *
   * @deprecated Use offset instead.
   * @return {Vector2} The offset.
   */ getOffset() {
        return this.offset;
    }
    /**
   * Sets the color offset vector.
   *
   * @deprecated Use offset instead.
   * @param {Vector2} value - The offset.
   */ setOffset(value) {
        this.offset = value;
    }
};
// src/effects/glsl/depth.frag
var $2046da3312f94030$var$depth_default = `void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){
#ifdef INVERTED
vec3 color=vec3(1.0-depth);
#else
vec3 color=vec3(depth);
#endif
outputColor=vec4(color,inputColor.a);}`;
// src/effects/DepthEffect.js
var $2046da3312f94030$export$616b524125abf15a = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new depth effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Boolean} [options.inverted=false] - Whether the depth should be inverted.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SRC, inverted: inverted = false } = {}){
        super("DepthEffect", $2046da3312f94030$var$depth_default, {
            blendFunction: blendFunction,
            attributes: $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH
        });
        this.inverted = inverted;
    }
    /**
   * Indicates whether depth should be inverted.
   *
   * @type {Boolean}
   */ get inverted() {
        return this.defines.has("INVERTED");
    }
    set inverted(value) {
        if (this.inverted !== value) {
            if (value) this.defines.set("INVERTED", "1");
            else this.defines.delete("INVERTED");
            this.setChanged();
        }
    }
    /**
   * Indicates whether the rendered depth is inverted.
   *
   * @deprecated Use inverted instead.
   * @return {Boolean} Whether the rendered depth is inverted.
   */ isInverted() {
        return this.inverted;
    }
    /**
   * Enables or disables depth inversion.
   *
   * @deprecated Use inverted instead.
   * @param {Boolean} value - Whether depth should be inverted.
   */ setInverted(value) {
        this.inverted = value;
    }
};
// src/enums/ColorChannel.js
var $2046da3312f94030$export$e8b1230a2d7ba080 = {
    RED: 0,
    GREEN: 1,
    BLUE: 2,
    ALPHA: 3
};
// src/enums/MaskFunction.js
var $2046da3312f94030$export$5dd4eee9fb245df8 = {
    DISCARD: 0,
    MULTIPLY: 1,
    MULTIPLY_RGB_SET_ALPHA: 2,
    MULTIPLY_RGB: 3
};
// src/materials/glsl/convolution.bokeh.frag
var $2046da3312f94030$var$convolution_bokeh_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#if PASS == 1
uniform vec4 kernel64[32];
#else
uniform vec4 kernel16[8];
#endif
uniform lowp sampler2D cocBuffer;uniform vec2 texelSize;uniform float scale;varying vec2 vUv;void main(){
#ifdef FOREGROUND
vec2 cocNearFar=texture2D(cocBuffer,vUv).rg*scale;float coc=cocNearFar.x;
#else
float coc=texture2D(cocBuffer,vUv).g*scale;
#endif
if(coc==0.0){gl_FragColor=texture2D(inputBuffer,vUv);}else{
#ifdef FOREGROUND
vec2 step=texelSize*max(cocNearFar.x,cocNearFar.y);
#else
vec2 step=texelSize*coc;
#endif
#if PASS == 1
vec4 acc=vec4(0.0);for(int i=0;i<32;++i){vec4 kernel=kernel64[i];vec2 uv=step*kernel.xy+vUv;acc+=texture2D(inputBuffer,uv);uv=step*kernel.zw+vUv;acc+=texture2D(inputBuffer,uv);}gl_FragColor=acc/64.0;
#else
vec4 maxValue=texture2D(inputBuffer,vUv);for(int i=0;i<8;++i){vec4 kernel=kernel16[i];vec2 uv=step*kernel.xy+vUv;maxValue=max(texture2D(inputBuffer,uv),maxValue);uv=step*kernel.zw+vUv;maxValue=max(texture2D(inputBuffer,uv),maxValue);}gl_FragColor=maxValue;
#endif
}}`;
// src/materials/BokehMaterial.js
var $2046da3312f94030$export$89e69b0a1c55abba = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new bokeh material.
   *
   * @param {Boolean} [fill=false] - Enables or disables the bokeh highlight fill mode.
   * @param {Boolean} [foreground=false] - Determines whether this material will be applied to foreground colors.
   */ constructor(fill = false, foreground = false){
        super({
            name: "BokehMaterial",
            defines: {
                PASS: fill ? "2" : "1"
            },
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                cocBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                kernel64: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                kernel16: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                scale: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$convolution_bokeh_default,
            vertexShader: $2046da3312f94030$var$common_default
        });
        if (foreground) this.defines.FOREGROUND = "1";
        this.generateKernel();
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The circle of confusion buffer.
   *
   * @type {Texture}
   */ set cocBuffer(value) {
        this.uniforms.cocBuffer.value = value;
    }
    /**
   * Sets the circle of confusion buffer.
   *
   * @deprecated Use cocBuffer instead.
   * @param {Texture} value - The buffer.
   */ setCoCBuffer(value) {
        this.uniforms.cocBuffer.value = value;
    }
    /**
   * The blur scale.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.scale.value;
    }
    set scale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * Returns the blur scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} The scale.
   */ getScale(value) {
        return this.scale;
    }
    /**
   * Sets the blur scale.
   *
   * @deprecated Use scale instead.
   * @param {Number} value - The scale.
   */ setScale(value) {
        this.scale = value;
    }
    /**
   * Generates the blur kernel.
   *
   * @private
   */ generateKernel() {
        const GOLDEN_ANGLE = 2.39996323;
        const points64 = new Float64Array(128);
        const points16 = new Float64Array(32);
        let i64 = 0, i16 = 0;
        for(let i = 0, sqrt80 = Math.sqrt(80); i < 80; ++i){
            const theta = i * GOLDEN_ANGLE;
            const r = Math.sqrt(i) / sqrt80;
            const u = r * Math.cos(theta), v4 = r * Math.sin(theta);
            if (i % 5 === 0) {
                points16[i16++] = u;
                points16[i16++] = v4;
            } else {
                points64[i64++] = u;
                points64[i64++] = v4;
            }
        }
        this.uniforms.kernel64.value = points64;
        this.uniforms.kernel16.value = points16;
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y);
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/materials/glsl/circle-of-confusion.frag
var $2046da3312f94030$var$circle_of_confusion_default = `#include <common>
#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform mat4 projectionMatrix;uniform mat4 projectionMatrixInverse;uniform float cameraNear;uniform float cameraFar;uniform float focusDistance;uniform float focusRange;varying vec2 vUv;float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
float depth=unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
float depth=texture2D(depthBuffer,uv).r;
#endif
#if defined(USE_LOGARITHMIC_DEPTH_BUFFER) || defined(LOG_DEPTH)
float d=pow(2.0,depth*log2(cameraFar+1.0))-1.0;float a=cameraFar/(cameraFar-cameraNear);float b=cameraFar*cameraNear/(cameraNear-cameraFar);depth=a+b/d;
#elif defined(USE_REVERSED_DEPTH_BUFFER)
depth=1.0-depth;
#endif
return depth;}
#ifdef PERSPECTIVE_CAMERA
#define getViewZ(depth) perspectiveDepthToViewZ(depth, cameraNear, cameraFar)
#else
#define getViewZ(depth) orthographicDepthToViewZ(depth, cameraNear, cameraFar)
#endif
vec3 getViewPosition(const in vec2 screenPosition,const in float depth,const in float viewZ){vec4 clipPosition=vec4(vec3(screenPosition,depth)*2.0-1.0,1.0);float clipW=projectionMatrix[2][3]*viewZ+projectionMatrix[3][3];clipPosition*=clipW;return(projectionMatrixInverse*clipPosition).xyz;}vec3 getViewPosition(const in vec2 screenPosition,const in float depth){return getViewPosition(screenPosition,depth,getViewZ(depth));}
#define getDistance(viewPosition) length(viewPosition)
void main(){float depth=readDepth(vUv);vec3 viewPosition=getViewPosition(vUv,depth);float distance=getDistance(viewPosition);float signedDistance=distance-focusDistance;float magnitude=smoothstep(0.0,focusRange,abs(signedDistance));gl_FragColor.rg=magnitude*vec2(step(signedDistance,0.0),step(0.0,signedDistance));}`;
// src/materials/CircleOfConfusionMaterial.js
var $2046da3312f94030$export$bea4e5c7bd31291c = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new CoC material.
   *
   * @param {Camera} camera - A camera.
   */ constructor(camera = null){
        super({
            name: "CircleOfConfusionMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                projectionMatrix: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                projectionMatrixInverse: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                cameraNear: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0.3),
                cameraFar: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1e3),
                focusDistance: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0),
                focusRange: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$circle_of_confusion_default,
            vertexShader: $2046da3312f94030$var$common_default
        });
        this.uniforms.focalLength = this.uniforms.focusRange;
        if (camera !== null) this.copyCameraSettings(camera);
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * The focus distance in world units.
   *
   * @type {Number}
   */ get focusDistance() {
        return this.uniforms.focusDistance.value;
    }
    set focusDistance(value) {
        this.uniforms.focusDistance.value = value;
    }
    /**
   * The focus distance in world units.
   *
   * @deprecated Use focusDistance instead.
   * @type {Number}
   */ get worldFocusDistance() {
        return this.focusDistance;
    }
    set worldFocusDistance(value) {
        this.focusDistance = value;
    }
    /**
   * Returns the focus distance.
   *
   * @deprecated Use focusDistance instead.
   * @return {Number} The focus distance.
   */ getFocusDistance(value) {
        this.uniforms.focusDistance.value = value;
    }
    /**
   * Sets the focus distance.
   *
   * @deprecated Use focusDistance instead.
   * @param {Number} value - The focus distance.
   */ setFocusDistance(value) {
        this.uniforms.focusDistance.value = value;
    }
    /**
   * The focal length.
   *
   * @deprecated Use focusRange instead.
   * @type {Number}
   */ get focalLength() {
        return this.focusRange;
    }
    set focalLength(value) {
        this.focusRange = value;
    }
    /**
   * The focus range. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get focusRange() {
        return this.uniforms.focusRange.value;
    }
    set focusRange(value) {
        this.uniforms.focusRange.value = value;
    }
    /**
   * The focus range in world units.
   *
   * @deprecated Use focusRange instead.
   * @type {Number}
   */ get worldFocusRange() {
        return this.focusRange;
    }
    set worldFocusRange(value) {
        this.focusRange = value;
    }
    /**
   * Returns the focal length.
   *
   * @deprecated Use focusRange instead.
   * @return {Number} The focal length.
   */ getFocalLength(value) {
        return this.focusRange;
    }
    /**
   * Sets the focal length.
   *
   * @deprecated Use focusRange instead.
   * @param {Number} value - The focal length.
   */ setFocalLength(value) {
        this.focusRange = value;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        this.uniforms.projectionMatrix.value = camera.projectionMatrix;
        this.uniforms.projectionMatrixInverse.value = camera.projectionMatrixInverse;
        this.uniforms.cameraNear.value = camera.near;
        this.uniforms.cameraFar.value = camera.far;
        const perspectiveCameraDefined = this.defines.PERSPECTIVE_CAMERA !== void 0;
        if (camera instanceof (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)) {
            if (!perspectiveCameraDefined) {
                this.defines.PERSPECTIVE_CAMERA = true;
                this.needsUpdate = true;
            }
        } else if (perspectiveCameraDefined) {
            delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
};
// src/materials/glsl/mask.frag
var $2046da3312f94030$var$mask_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef MASK_PRECISION_HIGH
uniform mediump sampler2D maskTexture;
#else
uniform lowp sampler2D maskTexture;
#endif
#if MASK_FUNCTION != 0
uniform float strength;
#endif
varying vec2 vUv;void main(){
#if COLOR_CHANNEL == 0
float mask=texture2D(maskTexture,vUv).r;
#elif COLOR_CHANNEL == 1
float mask=texture2D(maskTexture,vUv).g;
#elif COLOR_CHANNEL == 2
float mask=texture2D(maskTexture,vUv).b;
#else
float mask=texture2D(maskTexture,vUv).a;
#endif
#if MASK_FUNCTION == 0
#ifdef INVERTED
mask=(mask>0.0)?0.0:1.0;
#else
mask=(mask>0.0)?1.0:0.0;
#endif
#else
mask=clamp(mask*strength,0.0,1.0);
#ifdef INVERTED
mask=1.0-mask;
#endif
#endif
#if MASK_FUNCTION == 3
vec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=vec4(mask*texel.rgb,texel.a);
#elif MASK_FUNCTION == 2
gl_FragColor=vec4(mask*texture2D(inputBuffer,vUv).rgb,mask);
#else
gl_FragColor=mask*texture2D(inputBuffer,vUv);
#endif
}`;
// src/materials/MaskMaterial.js
var $2046da3312f94030$export$ba47b73346a33bfc = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new mask material.
   *
   * @param {Texture} [maskTexture] - The mask texture.
   */ constructor(maskTexture = null){
        super({
            name: "MaskMaterial",
            uniforms: {
                maskTexture: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(maskTexture),
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                strength: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$mask_default,
            vertexShader: $2046da3312f94030$var$common_default
        });
        this.colorChannel = $2046da3312f94030$export$e8b1230a2d7ba080.RED;
        this.maskFunction = $2046da3312f94030$export$5dd4eee9fb245df8.DISCARD;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The mask texture.
   *
   * @type {Texture}
   */ set maskTexture(value) {
        this.uniforms.maskTexture.value = value;
        delete this.defines.MASK_PRECISION_HIGH;
        if (value.type !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) this.defines.MASK_PRECISION_HIGH = "1";
        this.needsUpdate = true;
    }
    /**
   * Sets the mask texture.
   *
   * @deprecated Use maskTexture instead.
   * @param {Texture} value - The texture.
   */ setMaskTexture(value) {
        this.maskTexture = value;
    }
    /**
   * Sets the color channel to use for masking. Default is `ColorChannel.RED`.
   *
   * @type {ColorChannel}
   */ set colorChannel(value) {
        this.defines.COLOR_CHANNEL = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the color channel to use for masking. Default is `ColorChannel.RED`.
   *
   * @deprecated Use colorChannel instead.
   * @param {ColorChannel} value - The channel.
   */ setColorChannel(value) {
        this.colorChannel = value;
    }
    /**
   * The masking technique. Default is `MaskFunction.DISCARD`.
   *
   * @type {MaskFunction}
   */ set maskFunction(value) {
        this.defines.MASK_FUNCTION = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the masking technique. Default is `MaskFunction.DISCARD`.
   *
   * @deprecated Use maskFunction instead.
   * @param {MaskFunction} value - The function.
   */ setMaskFunction(value) {
        this.maskFunction = value;
    }
    /**
   * Indicates whether the masking is inverted.
   *
   * @type {Boolean}
   */ get inverted() {
        return this.defines.INVERTED !== void 0;
    }
    set inverted(value) {
        if (this.inverted && !value) delete this.defines.INVERTED;
        else if (value) this.defines.INVERTED = "1";
        this.needsUpdate = true;
    }
    /**
   * Indicates whether the masking is inverted.
   *
   * @deprecated Use inverted instead.
   * @return {Boolean} Whether the masking is inverted.
   */ isInverted() {
        return this.inverted;
    }
    /**
   * Determines whether the masking should be inverted.
   *
   * @deprecated Use inverted instead.
   * @param {Boolean} value - Whether the masking should be inverted.
   */ setInverted(value) {
        this.inverted = value;
    }
    /**
   * The current mask strength.
   *
   * Individual mask values will be clamped to [0.0, 1.0]. Has no effect when the mask function is set to `DISCARD`.
   *
   * @type {Number}
   */ get strength() {
        return this.uniforms.strength.value;
    }
    set strength(value) {
        this.uniforms.strength.value = value;
    }
    /**
   * Returns the current mask strength.
   *
   * @deprecated Use strength instead.
   * @return {Number} The mask strength.
   */ getStrength() {
        return this.strength;
    }
    /**
   * Sets the mask strength.
   *
   * Has no effect when the mask function is set to `DISCARD`.
   *
   * @deprecated Use strength instead.
   * @param {Number} value - The mask strength.
   */ setStrength(value) {
        this.strength = value;
    }
};
var $2046da3312f94030$export$c55093fd4f9e42f0 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new shader pass.
   *
   * @param {ShaderMaterial} material - A shader material.
   * @param {String} [input="inputBuffer"] - The name of the input buffer uniform.
   */ constructor(material, input = "inputBuffer"){
        super("ShaderPass");
        this.fullscreenMaterial = material;
        this.input = input;
    }
    /**
   * Sets the name of the input buffer uniform.
   *
   * @param {String} input - The name of the input buffer uniform.
   * @deprecated Use input instead.
   */ setInput(input) {
        this.input = input;
    }
    /**
   * Renders the effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const uniforms = this.fullscreenMaterial.uniforms;
        if (inputBuffer !== null && uniforms !== void 0 && uniforms[this.input] !== void 0) uniforms[this.input].value = inputBuffer.texture;
        renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - A renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0 && frameBufferType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
    }
};
// src/effects/glsl/depth-of-field.frag
var $2046da3312f94030$var$depth_of_field_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D nearColorBuffer;uniform mediump sampler2D farColorBuffer;
#else
uniform lowp sampler2D nearColorBuffer;uniform lowp sampler2D farColorBuffer;
#endif
#if MASK_FUNCTION != 1 && MASK_FUNCTION != 2
uniform lowp sampler2D farCoCBuffer;
#endif
uniform lowp sampler2D nearCoCBuffer;uniform float scale;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 colorNear=texture2D(nearColorBuffer,uv);vec4 colorFar=texture2D(farColorBuffer,uv);
#if MASK_FUNCTION == 1 || MASK_FUNCTION == 2
vec2 cocNearFar=vec2(texture2D(nearCoCBuffer,uv).r,colorFar.a);cocNearFar.x=min(cocNearFar.x*scale,1.0);
#else
vec2 cocNearFar=vec2(texture2D(nearCoCBuffer,uv).r,texture2D(farCoCBuffer,uv).g);cocNearFar=min(cocNearFar*scale,1.0);colorFar.a*=cocNearFar.y;
#endif
vec4 result=inputColor*(1.0-cocNearFar.y)+colorFar;result=mix(result,colorNear,cocNearFar.x);outputColor=result;}`;
// src/effects/DepthOfFieldEffect.js
var $2046da3312f94030$var$v = /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
var $2046da3312f94030$export$a473b3aa72725315 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new depth of field effect.
   *
   * @param {Camera} camera - The main camera.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.worldFocusDistance] - Deprecated. Use focusRange instead.
   * @param {Number} [options.worldFocusRange] - Deprecated. Use focusRange instead.
   * @param {Number} [options.focusDistance=3.0] - The focus distance in world units.
   * @param {Number} [options.focusRange=2.0] - The focus range in world units.
   * @param {Number} [options.focalLength] - Deprecated. Use focusRange instead.
   * @param {Number} [options.bokehScale=1.0] - The scale of the bokeh blur.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(camera, { blendFunction: blendFunction, worldFocusDistance: worldFocusDistance, worldFocusRange: worldFocusRange, focalLength: focalLength, focusDistance: focusDistance = worldFocusDistance || 3, focusRange: focusRange = worldFocusRange || focalLength || 2, bokehScale: bokehScale = 1, resolutionScale: resolutionScale = 0.5, width: width, height: height, resolutionX: resolutionX = width || $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionY: resolutionY = height || $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE } = {}){
        super("DepthOfFieldEffect", $2046da3312f94030$var$depth_of_field_default, {
            blendFunction: blendFunction,
            attributes: $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "nearColorBuffer",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "farColorBuffer",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "nearCoCBuffer",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "farCoCBuffer",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "scale",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
                ]
            ])
        });
        this.camera = camera;
        this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "DoF.Intermediate";
        this.renderTargetMasked = this.renderTarget.clone();
        this.renderTargetMasked.texture.name = "DoF.Masked.Far";
        this.renderTargetNear = this.renderTarget.clone();
        this.renderTargetNear.texture.name = "DoF.Bokeh.Near";
        this.uniforms.get("nearColorBuffer").value = this.renderTargetNear.texture;
        this.renderTargetFar = this.renderTarget.clone();
        this.renderTargetFar.texture.name = "DoF.Bokeh.Far";
        this.uniforms.get("farColorBuffer").value = this.renderTargetFar.texture;
        this.renderTargetCoC = this.renderTarget.clone();
        this.renderTargetCoC.texture.name = "DoF.CoC";
        this.uniforms.get("farCoCBuffer").value = this.renderTargetCoC.texture;
        this.renderTargetCoCBlurred = this.renderTargetCoC.clone();
        this.renderTargetCoCBlurred.texture.name = "DoF.CoC.Blurred";
        this.uniforms.get("nearCoCBuffer").value = this.renderTargetCoCBlurred.texture;
        this.cocPass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$bea4e5c7bd31291c(camera));
        const cocMaterial = this.cocMaterial;
        cocMaterial.focusDistance = focusDistance;
        cocMaterial.focusRange = focusRange;
        this.blurPass = new $2046da3312f94030$export$657273fee9302035({
            resolutionScale: resolutionScale,
            resolutionX: resolutionX,
            resolutionY: resolutionY,
            kernelSize: $2046da3312f94030$export$543b1e4815577d06.MEDIUM
        });
        this.maskPass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$ba47b73346a33bfc(this.renderTargetCoC.texture));
        const maskMaterial = this.maskPass.fullscreenMaterial;
        maskMaterial.colorChannel = $2046da3312f94030$export$e8b1230a2d7ba080.GREEN;
        this.maskFunction = $2046da3312f94030$export$5dd4eee9fb245df8.MULTIPLY_RGB;
        this.bokehNearBasePass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$89e69b0a1c55abba(false, true));
        this.bokehNearBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture;
        this.bokehNearFillPass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$89e69b0a1c55abba(true, true));
        this.bokehNearFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture;
        this.bokehFarBasePass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$89e69b0a1c55abba(false, false));
        this.bokehFarBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture;
        this.bokehFarFillPass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$89e69b0a1c55abba(true, false));
        this.bokehFarFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture;
        this.target = null;
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.bokehScale = bokehScale;
    }
    set mainCamera(value) {
        this.camera = value;
        this.cocMaterial.copyCameraSettings(value);
    }
    /**
   * The circle of confusion texture.
   *
   * @type {Texture}
   */ get cocTexture() {
        return this.renderTargetCoC.texture;
    }
    /**
   * The mask function. Default is `MULTIPLY_RGB`.
   *
   * @type {MaskFunction}
   */ get maskFunction() {
        return this.maskPass.fullscreenMaterial.maskFunction;
    }
    set maskFunction(value) {
        if (this.maskFunction !== value) {
            this.defines.set("MASK_FUNCTION", value.toFixed(0));
            this.maskPass.fullscreenMaterial.maskFunction = value;
            this.setChanged();
        }
    }
    /**
   * The circle of confusion material.
   *
   * @type {CircleOfConfusionMaterial}
   */ get cocMaterial() {
        return this.cocPass.fullscreenMaterial;
    }
    /**
   * The circle of confusion material.
   *
   * @deprecated Use cocMaterial instead.
   * @type {CircleOfConfusionMaterial}
   */ get circleOfConfusionMaterial() {
        return this.cocMaterial;
    }
    /**
   * Returns the circle of confusion material.
   *
   * @deprecated Use cocMaterial instead.
   * @return {CircleOfConfusionMaterial} The material.
   */ getCircleOfConfusionMaterial() {
        return this.cocMaterial;
    }
    /**
   * Returns the pass that blurs the foreground CoC buffer to soften edges.
   *
   * @deprecated Use blurPass instead.
   * @return {KawaseBlurPass} The blur pass.
   */ getBlurPass() {
        return this.blurPass;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * The current bokeh scale.
   *
   * @type {Number}
   */ get bokehScale() {
        return this.uniforms.get("scale").value;
    }
    set bokehScale(value) {
        this.bokehNearBasePass.fullscreenMaterial.scale = value;
        this.bokehNearFillPass.fullscreenMaterial.scale = value;
        this.bokehFarBasePass.fullscreenMaterial.scale = value;
        this.bokehFarFillPass.fullscreenMaterial.scale = value;
        this.maskPass.fullscreenMaterial.strength = value;
        this.uniforms.get("scale").value = value;
    }
    /**
   * Returns the current bokeh scale.
   *
   * @deprecated Use bokehScale instead.
   * @return {Number} The scale.
   */ getBokehScale() {
        return this.bokehScale;
    }
    /**
   * Sets the bokeh scale.
   *
   * @deprecated Use bokehScale instead.
   * @param {Number} value - The scale.
   */ setBokehScale(value) {
        this.bokehScale = value;
    }
    /**
   * Returns the current auto focus target.
   *
   * @deprecated Use target instead.
   * @return {Vector3} The target.
   */ getTarget() {
        return this.target;
    }
    /**
   * Sets the auto focus target.
   *
   * @deprecated Use target instead.
   * @param {Vector3} value - The target.
   */ setTarget(value) {
        this.target = value;
    }
    /**
   * Calculates the focus distance from the camera to the given position.
   *
   * @param {Vector3} target - The target.
   * @return {Number} The focus distance in world units.
   */ calculateFocusDistance(target) {
        return this.camera.getWorldPosition($2046da3312f94030$var$v).distanceTo(target);
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.cocMaterial.depthBuffer = depthTexture;
        this.cocMaterial.depthPacking = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const renderTarget = this.renderTarget;
        const renderTargetCoC = this.renderTargetCoC;
        const renderTargetCoCBlurred = this.renderTargetCoCBlurred;
        const renderTargetMasked = this.renderTargetMasked;
        if (this.target !== null) {
            const distance = this.calculateFocusDistance(this.target);
            this.cocMaterial.focusDistance = distance;
        }
        this.cocPass.render(renderer, null, renderTargetCoC);
        this.blurPass.render(renderer, renderTargetCoC, renderTargetCoCBlurred);
        this.maskPass.render(renderer, inputBuffer, renderTargetMasked);
        this.bokehFarBasePass.render(renderer, renderTargetMasked, renderTarget);
        this.bokehFarFillPass.render(renderer, renderTarget, this.renderTargetFar);
        this.bokehNearBasePass.render(renderer, inputBuffer, renderTarget);
        this.bokehNearFillPass.render(renderer, renderTarget, this.renderTargetNear);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.cocPass.setSize(width, height);
        this.blurPass.setSize(width, height);
        this.maskPass.setSize(width, height);
        this.renderTargetFar.setSize(width, height);
        this.renderTargetCoC.setSize(width, height);
        this.renderTargetMasked.setSize(width, height);
        this.renderTarget.setSize(w, h);
        this.renderTargetNear.setSize(w, h);
        this.renderTargetCoCBlurred.setSize(w, h);
        this.bokehNearBasePass.fullscreenMaterial.setSize(width, height);
        this.bokehNearFillPass.fullscreenMaterial.setSize(width, height);
        this.bokehFarBasePass.fullscreenMaterial.setSize(width, height);
        this.bokehFarFillPass.fullscreenMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.cocPass.initialize(renderer, alpha, frameBufferType);
        this.maskPass.initialize(renderer, alpha, frameBufferType);
        this.bokehNearBasePass.initialize(renderer, alpha, frameBufferType);
        this.bokehNearFillPass.initialize(renderer, alpha, frameBufferType);
        this.bokehFarBasePass.initialize(renderer, alpha, frameBufferType);
        this.bokehFarFillPass.initialize(renderer, alpha, frameBufferType);
        this.blurPass.initialize(renderer, alpha, (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10));
        if (renderer.capabilities.logarithmicDepthBuffer) this.cocPass.fullscreenMaterial.defines.LOG_DEPTH = "1";
        if (frameBufferType !== void 0) {
            this.renderTarget.texture.type = frameBufferType;
            this.renderTargetNear.texture.type = frameBufferType;
            this.renderTargetFar.texture.type = frameBufferType;
            this.renderTargetMasked.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) {
                this.renderTarget.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.renderTargetNear.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.renderTargetFar.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.renderTargetMasked.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
            }
        }
    }
};
// src/effects/glsl/dot-screen.frag
var $2046da3312f94030$var$dot_screen_default = `uniform vec2 angle;uniform float scale;float pattern(const in vec2 uv){vec2 point=scale*vec2(dot(angle.yx,vec2(uv.x,-uv.y)),dot(angle,uv));return(sin(point.x)*sin(point.y))*4.0;}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(inputColor.rgb*10.0-5.0+pattern(uv*resolution));outputColor=vec4(color,inputColor.a);}`;
// src/effects/DotScreenEffect.js
var $2046da3312f94030$export$f9e0c2aa66f80f09 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new dot screen effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.angle=1.57] - The angle of the dot pattern.
   * @param {Number} [options.scale=1.0] - The scale of the dot pattern.
   */ constructor({ blendFunction: blendFunction, angle: angle = Math.PI * 0.5, scale: scale = 1 } = {}){
        super("DotScreenEffect", $2046da3312f94030$var$dot_screen_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "angle",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
                ],
                [
                    "scale",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(scale)
                ]
            ])
        });
        this.angle = angle;
    }
    /**
   * The angle.
   *
   * @type {Number}
   */ get angle() {
        return Math.acos(this.uniforms.get("angle").value.y);
    }
    set angle(value) {
        this.uniforms.get("angle").value.set(Math.sin(value), Math.cos(value));
    }
    /**
   * Returns the pattern angle.
   *
   * @deprecated Use angle instead.
   * @return {Number} The angle in radians.
   */ getAngle() {
        return this.angle;
    }
    /**
   * Sets the pattern angle.
   *
   * @deprecated Use angle instead.
   * @param {Number} value - The angle in radians.
   */ setAngle(value) {
        this.angle = value;
    }
    /**
   * The scale.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.get("scale").value;
    }
    set scale(value) {
        this.uniforms.get("scale").value = value;
    }
};
// src/effects/glsl/fxaa.frag
var $2046da3312f94030$var$fxaa_default = `#define QUALITY(q) ((q) < 5 ? 1.0 : ((q) > 5 ? ((q) < 10 ? 2.0 : ((q) < 11 ? 4.0 : 8.0)) : 1.5))
#define ONE_OVER_TWELVE 0.08333333333333333
varying vec2 vUvDown;varying vec2 vUvUp;varying vec2 vUvLeft;varying vec2 vUvRight;varying vec2 vUvDownLeft;varying vec2 vUvUpRight;varying vec2 vUvUpLeft;varying vec2 vUvDownRight;vec4 fxaa(const in vec4 inputColor,const in vec2 uv){float lumaCenter=luminance(inputColor.rgb);float lumaDown=luminance(texture2D(inputBuffer,vUvDown).rgb);float lumaUp=luminance(texture2D(inputBuffer,vUvUp).rgb);float lumaLeft=luminance(texture2D(inputBuffer,vUvLeft).rgb);float lumaRight=luminance(texture2D(inputBuffer,vUvRight).rgb);float lumaMin=min(lumaCenter,min(min(lumaDown,lumaUp),min(lumaLeft,lumaRight)));float lumaMax=max(lumaCenter,max(max(lumaDown,lumaUp),max(lumaLeft,lumaRight)));float lumaRange=lumaMax-lumaMin;if(lumaRange<max(EDGE_THRESHOLD_MIN,lumaMax*EDGE_THRESHOLD_MAX)){return inputColor;}float lumaDownLeft=luminance(texture2D(inputBuffer,vUvDownLeft).rgb);float lumaUpRight=luminance(texture2D(inputBuffer,vUvUpRight).rgb);float lumaUpLeft=luminance(texture2D(inputBuffer,vUvUpLeft).rgb);float lumaDownRight=luminance(texture2D(inputBuffer,vUvDownRight).rgb);float lumaDownUp=lumaDown+lumaUp;float lumaLeftRight=lumaLeft+lumaRight;float lumaLeftCorners=lumaDownLeft+lumaUpLeft;float lumaDownCorners=lumaDownLeft+lumaDownRight;float lumaRightCorners=lumaDownRight+lumaUpRight;float lumaUpCorners=lumaUpRight+lumaUpLeft;float edgeHorizontal=(abs(-2.0*lumaLeft+lumaLeftCorners)+abs(-2.0*lumaCenter+lumaDownUp)*2.0+abs(-2.0*lumaRight+lumaRightCorners));float edgeVertical=(abs(-2.0*lumaUp+lumaUpCorners)+abs(-2.0*lumaCenter+lumaLeftRight)*2.0+abs(-2.0*lumaDown+lumaDownCorners));bool isHorizontal=(edgeHorizontal>=edgeVertical);float stepLength=isHorizontal?texelSize.y:texelSize.x;float luma1=isHorizontal?lumaDown:lumaLeft;float luma2=isHorizontal?lumaUp:lumaRight;float gradient1=abs(luma1-lumaCenter);float gradient2=abs(luma2-lumaCenter);bool is1Steepest=gradient1>=gradient2;float gradientScaled=0.25*max(gradient1,gradient2);float lumaLocalAverage=0.0;if(is1Steepest){stepLength=-stepLength;lumaLocalAverage=0.5*(luma1+lumaCenter);}else{lumaLocalAverage=0.5*(luma2+lumaCenter);}vec2 currentUv=uv;if(isHorizontal){currentUv.y+=stepLength*0.5;}else{currentUv.x+=stepLength*0.5;}vec2 offset=isHorizontal?vec2(texelSize.x,0.0):vec2(0.0,texelSize.y);vec2 uv1=currentUv-offset*QUALITY(0);vec2 uv2=currentUv+offset*QUALITY(0);float lumaEnd1=luminance(texture2D(inputBuffer,uv1).rgb);float lumaEnd2=luminance(texture2D(inputBuffer,uv2).rgb);lumaEnd1-=lumaLocalAverage;lumaEnd2-=lumaLocalAverage;bool reached1=abs(lumaEnd1)>=gradientScaled;bool reached2=abs(lumaEnd2)>=gradientScaled;bool reachedBoth=reached1&&reached2;if(!reached1){uv1-=offset*QUALITY(1);}if(!reached2){uv2+=offset*QUALITY(1);}if(!reachedBoth){for(int i=2;i<SAMPLES;++i){if(!reached1){lumaEnd1=luminance(texture2D(inputBuffer,uv1).rgb);lumaEnd1=lumaEnd1-lumaLocalAverage;}if(!reached2){lumaEnd2=luminance(texture2D(inputBuffer,uv2).rgb);lumaEnd2=lumaEnd2-lumaLocalAverage;}reached1=abs(lumaEnd1)>=gradientScaled;reached2=abs(lumaEnd2)>=gradientScaled;reachedBoth=reached1&&reached2;if(!reached1){uv1-=offset*QUALITY(i);}if(!reached2){uv2+=offset*QUALITY(i);}if(reachedBoth){break;}}}float distance1=isHorizontal?(uv.x-uv1.x):(uv.y-uv1.y);float distance2=isHorizontal?(uv2.x-uv.x):(uv2.y-uv.y);bool isDirection1=distance1<distance2;float distanceFinal=min(distance1,distance2);float edgeThickness=(distance1+distance2);bool isLumaCenterSmaller=lumaCenter<lumaLocalAverage;bool correctVariation1=(lumaEnd1<0.0)!=isLumaCenterSmaller;bool correctVariation2=(lumaEnd2<0.0)!=isLumaCenterSmaller;bool correctVariation=isDirection1?correctVariation1:correctVariation2;float pixelOffset=-distanceFinal/edgeThickness+0.5;float finalOffset=correctVariation?pixelOffset:0.0;float lumaAverage=ONE_OVER_TWELVE*(2.0*(lumaDownUp+lumaLeftRight)+lumaLeftCorners+lumaRightCorners);float subPixelOffset1=clamp(abs(lumaAverage-lumaCenter)/lumaRange,0.0,1.0);float subPixelOffset2=(-2.0*subPixelOffset1+3.0)*subPixelOffset1*subPixelOffset1;float subPixelOffsetFinal=subPixelOffset2*subPixelOffset2*SUBPIXEL_QUALITY;finalOffset=max(finalOffset,subPixelOffsetFinal);vec2 finalUv=uv;if(isHorizontal){finalUv.y+=finalOffset*stepLength;}else{finalUv.x+=finalOffset*stepLength;}return texture2D(inputBuffer,finalUv);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=fxaa(inputColor,uv);}`;
// src/effects/glsl/fxaa.vert
var $2046da3312f94030$var$fxaa_default2 = `varying vec2 vUvDown;varying vec2 vUvUp;varying vec2 vUvLeft;varying vec2 vUvRight;varying vec2 vUvDownLeft;varying vec2 vUvUpRight;varying vec2 vUvUpLeft;varying vec2 vUvDownRight;void mainSupport(const in vec2 uv){vUvDown=uv+vec2(0.0,-1.0)*texelSize;vUvUp=uv+vec2(0.0,1.0)*texelSize;vUvRight=uv+vec2(1.0,0.0)*texelSize;vUvLeft=uv+vec2(-1.0,0.0)*texelSize;vUvDownLeft=uv+vec2(-1.0,-1.0)*texelSize;vUvUpRight=uv+vec2(1.0,1.0)*texelSize;vUvUpLeft=uv+vec2(-1.0,1.0)*texelSize;vUvDownRight=uv+vec2(1.0,-1.0)*texelSize;}`;
// src/effects/FXAAEffect.js
var $2046da3312f94030$export$b10a15fb2785e23f = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new FXAA effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SRC } = {}){
        super("FXAAEffect", $2046da3312f94030$var$fxaa_default, {
            vertexShader: $2046da3312f94030$var$fxaa_default2,
            blendFunction: blendFunction,
            defines: /* @__PURE__ */ new Map([
                [
                    "EDGE_THRESHOLD_MIN",
                    "0.0312"
                ],
                [
                    "EDGE_THRESHOLD_MAX",
                    "0.125"
                ],
                [
                    "SUBPIXEL_QUALITY",
                    "0.75"
                ],
                [
                    "SAMPLES",
                    "12"
                ]
            ])
        });
    }
    /**
   * The minimum edge detection threshold. Range is [0.0, 1.0].
   *
   * @type {Number}
   */ get minEdgeThreshold() {
        return Number(this.defines.get("EDGE_THRESHOLD_MIN"));
    }
    set minEdgeThreshold(value) {
        this.defines.set("EDGE_THRESHOLD_MIN", value.toFixed(12));
        this.setChanged();
    }
    /**
   * The maximum edge detection threshold. Range is [0.0, 1.0].
   *
   * @type {Number}
   */ get maxEdgeThreshold() {
        return Number(this.defines.get("EDGE_THRESHOLD_MAX"));
    }
    set maxEdgeThreshold(value) {
        this.defines.set("EDGE_THRESHOLD_MAX", value.toFixed(12));
        this.setChanged();
    }
    /**
   * The subpixel blend quality. Range is [0.0, 1.0].
   *
   * @type {Number}
   */ get subpixelQuality() {
        return Number(this.defines.get("SUBPIXEL_QUALITY"));
    }
    set subpixelQuality(value) {
        this.defines.set("SUBPIXEL_QUALITY", value.toFixed(12));
        this.setChanged();
    }
    /**
   * The maximum amount of edge detection samples.
   *
   * @type {Number}
   */ get samples() {
        return Number(this.defines.get("SAMPLES"));
    }
    set samples(value) {
        this.defines.set("SAMPLES", value.toFixed(0));
        this.setChanged();
    }
};
// src/effects/glsl/gamma-correction.frag
var $2046da3312f94030$var$gamma_correction_default = `uniform float gamma;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=LinearToGamma(max(inputColor,0.0),gamma);}`;
// src/effects/GammaCorrectionEffect.js
var $2046da3312f94030$export$ffcf45862523c89e = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new gamma correction effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Number} [options.gamma=2.0] - The gamma factor.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SRC, gamma: gamma = 2 } = {}){
        super("GammaCorrectionEffect", $2046da3312f94030$var$gamma_correction_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "gamma",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(gamma)
                ]
            ])
        });
    }
};
// src/enums/GlitchMode.js
var $2046da3312f94030$export$678a9d3661117e39 = {
    DISABLED: 0,
    SPORADIC: 1,
    CONSTANT_MILD: 2,
    CONSTANT_WILD: 3
};
function $2046da3312f94030$var$getNoise(size, format, type) {
    const channels = /* @__PURE__ */ new Map([
        [
            (0, $ce0cdebec9150cb3$export$4e041a7967d15c4b),
            1
        ],
        [
            (0, $ce0cdebec9150cb3$export$6cdf0b461c7ce8a0),
            2
        ],
        [
            (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c),
            4
        ]
    ]);
    let data;
    if (!channels.has(format)) console.error("Invalid noise texture format");
    if (type === (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) {
        data = new Uint8Array(size * channels.get(format));
        for(let i = 0, l = data.length; i < l; ++i)data[i] = Math.random() * 255 + 0.5;
    } else {
        data = new Float32Array(size * channels.get(format));
        for(let i = 0, l = data.length; i < l; ++i)data[i] = Math.random();
    }
    return data;
}
var $2046da3312f94030$export$2d9c702b3963e69c = class extends (0, $ce0cdebec9150cb3$export$b691f601014eabe1) {
    /**
   * Constructs a new noise texture.
   *
   * Supported formats are `RGBAFormat`, `RedFormat` and `RGFormat`.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   * @param {Number} [format=RedFormat] - The texture format.
   * @param {Number} [type=UnsignedByteType] - The texture type.
   */ constructor(width, height, format = (0, $ce0cdebec9150cb3$export$4e041a7967d15c4b), type = (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)){
        super($2046da3312f94030$var$getNoise(width * height, format, type), width, height, format, type);
        this.needsUpdate = true;
    }
};
// src/effects/glsl/glitch.frag
var $2046da3312f94030$var$glitch_default = `uniform lowp sampler2D perturbationMap;uniform bool active;uniform float columns;uniform float random;uniform vec2 seeds;uniform vec2 distortion;void mainUv(inout vec2 uv){if(active){if(uv.y<distortion.x+columns&&uv.y>distortion.x-columns*random){float sx=clamp(ceil(seeds.x),0.0,1.0);uv.y=sx*(1.0-(uv.y+distortion.y))+(1.0-sx)*distortion.y;}if(uv.x<distortion.y+columns&&uv.x>distortion.y-columns*random){float sy=clamp(ceil(seeds.y),0.0,1.0);uv.x=sy*distortion.x+(1.0-sy)*(1.0-(uv.x+distortion.x));}vec2 normal=texture2D(perturbationMap,uv*random*random).rg;uv+=normal*seeds*(random*0.2);}}`;
// src/effects/GlitchEffect.js
var $2046da3312f94030$var$textureTag = "Glitch.Generated";
function $2046da3312f94030$var$randomFloat(low, high) {
    return low + Math.random() * (high - low);
}
var $2046da3312f94030$export$87a0c8b425be8598 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new glitch effect.
   *
   * TODO Change ratio to 0.15.
   * @param {Object} [options] - The options.
   * @param {Vector2} [options.chromaticAberrationOffset] - A chromatic aberration offset. If provided, the glitch effect will influence this offset.
   * @param {Vector2} [options.delay] - The minimum and maximum delay between glitch activations in seconds.
   * @param {Vector2} [options.duration] - The minimum and maximum duration of a glitch in seconds.
   * @param {Vector2} [options.strength] - The strength of weak and strong glitches.
   * @param {Texture} [options.perturbationMap] - A perturbation map. If none is provided, a noise texture will be created.
   * @param {Number} [options.dtSize=64] - The size of the generated noise map. Will be ignored if a perturbation map is provided.
   * @param {Number} [options.columns=0.05] - The scale of the blocky glitch columns.
   * @param {Number} [options.ratio=0.85] - The threshold for strong glitches.
   */ constructor({ chromaticAberrationOffset: chromaticAberrationOffset = null, delay: delay = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(1.5, 3.5), duration: duration = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(0.6, 1), strength: strength = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(0.3, 1), columns: columns = 0.05, ratio: ratio = 0.85, perturbationMap: perturbationMap = null, dtSize: dtSize = 64 } = {}){
        super("GlitchEffect", $2046da3312f94030$var$glitch_default, {
            uniforms: /* @__PURE__ */ new Map([
                [
                    "perturbationMap",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "columns",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(columns)
                ],
                [
                    "active",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(false)
                ],
                [
                    "random",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
                ],
                [
                    "seeds",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
                ],
                [
                    "distortion",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
                ]
            ])
        });
        if (perturbationMap === null) {
            const map = new $2046da3312f94030$export$2d9c702b3963e69c(dtSize, dtSize, (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c));
            map.name = $2046da3312f94030$var$textureTag;
            this.perturbationMap = map;
        } else this.perturbationMap = perturbationMap;
        this.time = 0;
        this.distortion = this.uniforms.get("distortion").value;
        this.delay = delay;
        this.duration = duration;
        this.breakPoint = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)($2046da3312f94030$var$randomFloat(this.delay.x, this.delay.y), $2046da3312f94030$var$randomFloat(this.duration.x, this.duration.y));
        this.strength = strength;
        this.mode = $2046da3312f94030$export$678a9d3661117e39.SPORADIC;
        this.ratio = ratio;
        this.chromaticAberrationOffset = chromaticAberrationOffset;
    }
    /**
   * Random number seeds.
   *
   * @type {Vector2}
   * @private
   */ get seeds() {
        return this.uniforms.get("seeds").value;
    }
    /**
   * Indicates whether the glitch effect is currently active.
   *
   * @type {Boolean}
   */ get active() {
        return this.uniforms.get("active").value;
    }
    /**
   * Indicates whether the glitch effect is currently active.
   *
   * @deprecated Use active instead.
   * @return {Boolean} Whether the glitch effect is active.
   */ isActive() {
        return this.active;
    }
    /**
   * The minimum delay between glitch activations.
   *
   * @type {Number}
   */ get minDelay() {
        return this.delay.x;
    }
    set minDelay(value) {
        this.delay.x = value;
    }
    /**
   * Returns the minimum delay between glitch activations.
   *
   * @deprecated Use minDelay instead.
   * @return {Number} The minimum delay in seconds.
   */ getMinDelay() {
        return this.delay.x;
    }
    /**
   * Sets the minimum delay between glitch activations.
   *
   * @deprecated Use minDelay instead.
   * @param {Number} value - The minimum delay in seconds.
   */ setMinDelay(value) {
        this.delay.x = value;
    }
    /**
   * The maximum delay between glitch activations.
   *
   * @type {Number}
   */ get maxDelay() {
        return this.delay.y;
    }
    set maxDelay(value) {
        this.delay.y = value;
    }
    /**
   * Returns the maximum delay between glitch activations.
   *
   * @deprecated Use maxDelay instead.
   * @return {Number} The maximum delay in seconds.
   */ getMaxDelay() {
        return this.delay.y;
    }
    /**
   * Sets the maximum delay between glitch activations.
   *
   * @deprecated Use maxDelay instead.
   * @param {Number} value - The maximum delay in seconds.
   */ setMaxDelay(value) {
        this.delay.y = value;
    }
    /**
   * The minimum duration of sporadic glitches.
   *
   * @type {Number}
   */ get minDuration() {
        return this.duration.x;
    }
    set minDuration(value) {
        this.duration.x = value;
    }
    /**
   * Returns the minimum duration of sporadic glitches.
   *
   * @deprecated Use minDuration instead.
   * @return {Number} The minimum duration in seconds.
   */ getMinDuration() {
        return this.duration.x;
    }
    /**
   * Sets the minimum duration of sporadic glitches.
   *
   * @deprecated Use minDuration instead.
   * @param {Number} value - The minimum duration in seconds.
   */ setMinDuration(value) {
        this.duration.x = value;
    }
    /**
   * The maximum duration of sporadic glitches.
   *
   * @type {Number}
   */ get maxDuration() {
        return this.duration.y;
    }
    set maxDuration(value) {
        this.duration.y = value;
    }
    /**
   * Returns the maximum duration of sporadic glitches.
   *
   * @deprecated Use maxDuration instead.
   * @return {Number} The maximum duration in seconds.
   */ getMaxDuration() {
        return this.duration.y;
    }
    /**
   * Sets the maximum duration of sporadic glitches.
   *
   * @deprecated Use maxDuration instead.
   * @param {Number} value - The maximum duration in seconds.
   */ setMaxDuration(value) {
        this.duration.y = value;
    }
    /**
   * The strength of weak glitches.
   *
   * @type {Number}
   */ get minStrength() {
        return this.strength.x;
    }
    set minStrength(value) {
        this.strength.x = value;
    }
    /**
   * Returns the strength of weak glitches.
   *
   * @deprecated Use minStrength instead.
   * @return {Number} The strength.
   */ getMinStrength() {
        return this.strength.x;
    }
    /**
   * Sets the strength of weak glitches.
   *
   * @deprecated Use minStrength instead.
   * @param {Number} value - The strength.
   */ setMinStrength(value) {
        this.strength.x = value;
    }
    /**
   * The strength of strong glitches.
   *
   * @type {Number}
   */ get maxStrength() {
        return this.strength.y;
    }
    set maxStrength(value) {
        this.strength.y = value;
    }
    /**
   * Returns the strength of strong glitches.
   *
   * @deprecated Use maxStrength instead.
   * @return {Number} The strength.
   */ getMaxStrength() {
        return this.strength.y;
    }
    /**
   * Sets the strength of strong glitches.
   *
   * @deprecated Use maxStrength instead.
   * @param {Number} value - The strength.
   */ setMaxStrength(value) {
        this.strength.y = value;
    }
    /**
   * Returns the current glitch mode.
   *
   * @deprecated Use mode instead.
   * @return {GlitchMode} The mode.
   */ getMode() {
        return this.mode;
    }
    /**
   * Sets the current glitch mode.
   *
   * @deprecated Use mode instead.
   * @param {GlitchMode} value - The mode.
   */ setMode(value) {
        this.mode = value;
    }
    /**
   * Returns the glitch ratio.
   *
   * @deprecated Use ratio instead.
   * @return {Number} The ratio.
   */ getGlitchRatio() {
        return 1 - this.ratio;
    }
    /**
   * Sets the ratio of weak (0.0) and strong (1.0) glitches.
   *
   * @deprecated Use ratio instead.
   * @param {Number} value - The ratio. Range is [0.0, 1.0].
   */ setGlitchRatio(value) {
        this.ratio = Math.min(Math.max(1 - value, 0), 1);
    }
    /**
   * The glitch column size.
   *
   * @type {Number}
   */ get columns() {
        return this.uniforms.get("columns").value;
    }
    set columns(value) {
        this.uniforms.get("columns").value = value;
    }
    /**
   * Returns the glitch column size.
   *
   * @deprecated Use columns instead.
   * @return {Number} The glitch column size.
   */ getGlitchColumns() {
        return this.columns;
    }
    /**
   * Sets the glitch column size.
   *
   * @deprecated Use columns instead.
   * @param {Number} value - The glitch column size.
   */ setGlitchColumns(value) {
        this.columns = value;
    }
    /**
   * Returns the chromatic aberration offset.
   *
   * @deprecated Use chromaticAberrationOffset instead.
   * @return {Vector2} The offset.
   */ getChromaticAberrationOffset() {
        return this.chromaticAberrationOffset;
    }
    /**
   * Sets the chromatic aberration offset.
   *
   * @deprecated Use chromaticAberrationOffset instead.
   * @param {Vector2} value - The offset.
   */ setChromaticAberrationOffset(value) {
        this.chromaticAberrationOffset = value;
    }
    /**
   * The perturbation map.
   *
   * @type {Texture}
   */ get perturbationMap() {
        return this.uniforms.get("perturbationMap").value;
    }
    set perturbationMap(value) {
        const currentMap = this.perturbationMap;
        if (currentMap !== null && currentMap.name === $2046da3312f94030$var$textureTag) currentMap.dispose();
        value.minFilter = value.magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
        value.wrapS = value.wrapT = (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5);
        value.generateMipmaps = false;
        this.uniforms.get("perturbationMap").value = value;
    }
    /**
   * Returns the current perturbation map.
   *
   * @deprecated Use perturbationMap instead.
   * @return {Texture} The current perturbation map.
   */ getPerturbationMap() {
        return this.perturbationMap;
    }
    /**
   * Replaces the current perturbation map with the given one.
   *
   * The current map will be disposed if it was generated by this effect.
   *
   * @deprecated Use perturbationMap instead.
   * @param {Texture} value - The new perturbation map.
   */ setPerturbationMap(value) {
        this.perturbationMap = value;
    }
    /**
   * Generates a perturbation map.
   *
   * @deprecated Use NoiseTexture instead.
   * @param {Number} [value=64] - The texture size.
   * @return {DataTexture} The perturbation map.
   */ generatePerturbationMap(value = 64) {
        const map = new $2046da3312f94030$export$2d9c702b3963e69c(value, value, (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c));
        map.name = $2046da3312f94030$var$textureTag;
        return map;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const mode = this.mode;
        const breakPoint = this.breakPoint;
        const offset = this.chromaticAberrationOffset;
        const s = this.strength;
        let time = this.time;
        let active = false;
        let r = 0, a = 0;
        let trigger;
        if (mode !== $2046da3312f94030$export$678a9d3661117e39.DISABLED) {
            if (mode === $2046da3312f94030$export$678a9d3661117e39.SPORADIC) {
                time += deltaTime;
                trigger = time > breakPoint.x;
                if (time >= breakPoint.x + breakPoint.y) {
                    breakPoint.set($2046da3312f94030$var$randomFloat(this.delay.x, this.delay.y), $2046da3312f94030$var$randomFloat(this.duration.x, this.duration.y));
                    time = 0;
                }
            }
            r = Math.random();
            this.uniforms.get("random").value = r;
            if (trigger && r > this.ratio || mode === $2046da3312f94030$export$678a9d3661117e39.CONSTANT_WILD) {
                active = true;
                r *= s.y * 0.03;
                a = $2046da3312f94030$var$randomFloat(-Math.PI, Math.PI);
                this.seeds.set($2046da3312f94030$var$randomFloat(-s.y, s.y), $2046da3312f94030$var$randomFloat(-s.y, s.y));
                this.distortion.set($2046da3312f94030$var$randomFloat(0, 1), $2046da3312f94030$var$randomFloat(0, 1));
            } else if (trigger || mode === $2046da3312f94030$export$678a9d3661117e39.CONSTANT_MILD) {
                active = true;
                r *= s.x * 0.03;
                a = $2046da3312f94030$var$randomFloat(-Math.PI, Math.PI);
                this.seeds.set($2046da3312f94030$var$randomFloat(-s.x, s.x), $2046da3312f94030$var$randomFloat(-s.x, s.x));
                this.distortion.set($2046da3312f94030$var$randomFloat(0, 1), $2046da3312f94030$var$randomFloat(0, 1));
            }
            this.time = time;
        }
        if (offset !== null) {
            if (active) offset.set(Math.cos(a), Math.sin(a)).multiplyScalar(r);
            else offset.set(0, 0);
        }
        this.uniforms.get("active").value = active;
    }
    /**
   * Deletes generated resources.
   */ dispose() {
        const map = this.perturbationMap;
        if (map !== null && map.name === $2046da3312f94030$var$textureTag) map.dispose();
    }
};
// src/materials/glsl/convolution.god-rays.frag
var $2046da3312f94030$var$convolution_god_rays_default = `#include <common>
#include <dithering_pars_fragment>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform vec2 lightPosition;uniform float exposure;uniform float decay;uniform float density;uniform float weight;uniform float clampMax;varying vec2 vUv;void main(){vec2 coord=vUv;vec2 delta=lightPosition-coord;delta*=1.0/SAMPLES_FLOAT*density;float illuminationDecay=1.0;vec4 color=vec4(0.0);for(int i=0;i<SAMPLES_INT;++i){coord+=delta;vec4 texel=texture2D(inputBuffer,coord);texel*=illuminationDecay*weight;color+=texel;illuminationDecay*=decay;}gl_FragColor=clamp(color*exposure,0.0,clampMax);
#include <dithering_fragment>
}`;
// src/materials/GodRaysMaterial.js
var $2046da3312f94030$export$4ed51786a9a8bef8 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new god rays material.
   *
   * TODO Remove lightPosition param.
   * @param {Vector2} lightPosition - Deprecated.
   */ constructor(lightPosition){
        super({
            name: "GodRaysMaterial",
            defines: {
                SAMPLES_INT: "60",
                SAMPLES_FLOAT: "60.0"
            },
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                lightPosition: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(lightPosition),
                density: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1),
                decay: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1),
                weight: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1),
                exposure: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1),
                clampMax: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$convolution_god_rays_default,
            vertexShader: $2046da3312f94030$var$common_default
        });
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The screen space position of the light source.
   *
   * @type {Vector2}
   */ get lightPosition() {
        return this.uniforms.lightPosition.value;
    }
    /**
   * Returns the screen space position of the light source.
   *
   * @deprecated Use lightPosition instead.
   * @return {Vector2} The position.
   */ getLightPosition() {
        return this.uniforms.lightPosition.value;
    }
    /**
   * Sets the screen space position of the light source.
   *
   * @deprecated Use lightPosition instead.
   * @param {Vector2} value - The position.
   */ setLightPosition(value) {
        this.uniforms.lightPosition.value = value;
    }
    /**
   * The density.
   *
   * @type {Number}
   */ get density() {
        return this.uniforms.density.value;
    }
    set density(value) {
        this.uniforms.density.value = value;
    }
    /**
   * Returns the density.
   *
   * @deprecated Use density instead.
   * @return {Number} The density.
   */ getDensity() {
        return this.uniforms.density.value;
    }
    /**
   * Sets the density.
   *
   * @deprecated Use density instead.
   * @param {Number} value - The density.
   */ setDensity(value) {
        this.uniforms.density.value = value;
    }
    /**
   * The decay.
   *
   * @type {Number}
   */ get decay() {
        return this.uniforms.decay.value;
    }
    set decay(value) {
        this.uniforms.decay.value = value;
    }
    /**
   * Returns the decay.
   *
   * @deprecated Use decay instead.
   * @return {Number} The decay.
   */ getDecay() {
        return this.uniforms.decay.value;
    }
    /**
   * Sets the decay.
   *
   * @deprecated Use decay instead.
   * @param {Number} value - The decay.
   */ setDecay(value) {
        this.uniforms.decay.value = value;
    }
    /**
   * The weight.
   *
   * @type {Number}
   */ get weight() {
        return this.uniforms.weight.value;
    }
    set weight(value) {
        this.uniforms.weight.value = value;
    }
    /**
   * Returns the weight.
   *
   * @deprecated Use weight instead.
   * @return {Number} The weight.
   */ getWeight() {
        return this.uniforms.weight.value;
    }
    /**
   * Sets the weight.
   *
   * @deprecated Use weight instead.
   * @param {Number} value - The weight.
   */ setWeight(value) {
        this.uniforms.weight.value = value;
    }
    /**
   * The exposure.
   *
   * @type {Number}
   */ get exposure() {
        return this.uniforms.exposure.value;
    }
    set exposure(value) {
        this.uniforms.exposure.value = value;
    }
    /**
   * Returns the exposure.
   *
   * @deprecated Use exposure instead.
   * @return {Number} The exposure.
   */ getExposure() {
        return this.uniforms.exposure.value;
    }
    /**
   * Sets the exposure.
   *
   * @deprecated Use exposure instead.
   * @param {Number} value - The exposure.
   */ setExposure(value) {
        this.uniforms.exposure.value = value;
    }
    /**
   * The maximum light intensity.
   *
   * @type {Number}
   */ get maxIntensity() {
        return this.uniforms.clampMax.value;
    }
    set maxIntensity(value) {
        this.uniforms.clampMax.value = value;
    }
    /**
   * Returns the maximum light intensity.
   *
   * @deprecated Use maxIntensity instead.
   * @return {Number} The maximum light intensity.
   */ getMaxIntensity() {
        return this.uniforms.clampMax.value;
    }
    /**
   * Sets the maximum light intensity.
   *
   * @deprecated Use maxIntensity instead.
   * @param {Number} value - The maximum light intensity.
   */ setMaxIntensity(value) {
        this.uniforms.clampMax.value = value;
    }
    /**
   * The amount of samples per pixel.
   *
   * @type {Number}
   */ get samples() {
        return Number(this.defines.SAMPLES_INT);
    }
    set samples(value) {
        const s = Math.floor(value);
        this.defines.SAMPLES_INT = s.toFixed(0);
        this.defines.SAMPLES_FLOAT = s.toFixed(1);
        this.needsUpdate = true;
    }
    /**
   * Returns the amount of samples per pixel.
   *
   * @deprecated Use samples instead.
   * @return {Number} The sample count.
   */ getSamples() {
        return this.samples;
    }
    /**
   * Sets the amount of samples per pixel.
   *
   * @deprecated Use samples instead.
   * @param {Number} value - The sample count.
   */ setSamples(value) {
        this.samples = value;
    }
};
// src/passes/RenderPass.js
var $2046da3312f94030$export$f63ea822f020b5b0 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new render pass.
   *
   * @param {Scene} scene - The scene to render.
   * @param {Camera} camera - The camera to use to render the scene.
   * @param {Material} [overrideMaterial=null] - An override material.
   */ constructor(scene, camera, overrideMaterial = null){
        super("RenderPass", scene, camera);
        this.needsSwap = false;
        this.needsDepthBlit = true;
        this.clearPass = new $2046da3312f94030$export$fc4180e277a6a0c2();
        this.overrideMaterialManager = overrideMaterial === null ? null : new $2046da3312f94030$export$6ef25c308da0147b(overrideMaterial);
        this.ignoreBackground = false;
        this.skipShadowMapUpdate = false;
        this.selection = null;
    }
    set mainScene(value) {
        this.scene = value;
    }
    set mainCamera(value) {
        this.camera = value;
    }
    get renderToScreen() {
        return super.renderToScreen;
    }
    set renderToScreen(value) {
        super.renderToScreen = value;
        this.clearPass.renderToScreen = value;
    }
    /**
   * The current override material.
   *
   * @type {Material}
   */ get overrideMaterial() {
        const manager = this.overrideMaterialManager;
        return manager !== null ? manager.material : null;
    }
    set overrideMaterial(value) {
        const manager = this.overrideMaterialManager;
        if (value !== null) {
            if (manager !== null) manager.setMaterial(value);
            else this.overrideMaterialManager = new $2046da3312f94030$export$6ef25c308da0147b(value);
        } else if (manager !== null) {
            manager.dispose();
            this.overrideMaterialManager = null;
        }
    }
    /**
   * Returns the current override material.
   *
   * @deprecated Use overrideMaterial instead.
   * @return {Material} The material.
   */ getOverrideMaterial() {
        return this.overrideMaterial;
    }
    /**
   * Sets the override material.
   *
   * @deprecated Use overrideMaterial instead.
   * @return {Material} value - The material.
   */ setOverrideMaterial(value) {
        this.overrideMaterial = value;
    }
    /**
   * Indicates whether the target buffer should be cleared before rendering.
   *
   * @type {Boolean}
   * @deprecated Use clearPass.enabled instead.
   */ get clear() {
        return this.clearPass.enabled;
    }
    set clear(value) {
        this.clearPass.enabled = value;
    }
    /**
   * Returns the selection. Default is `null` (no restriction).
   *
   * @deprecated Use selection instead.
   * @return {Selection} The selection.
   */ getSelection() {
        return this.selection;
    }
    /**
   * Sets the selection. Set to `null` to disable.
   *
   * @deprecated Use selection instead.
   * @param {Selection} value - The selection.
   */ setSelection(value) {
        this.selection = value;
    }
    /**
   * Indicates whether the scene background is disabled.
   *
   * @deprecated Use ignoreBackground instead.
   * @return {Boolean} Whether the scene background is disabled.
   */ isBackgroundDisabled() {
        return this.ignoreBackground;
    }
    /**
   * Enables or disables the scene background.
   *
   * @deprecated Use ignoreBackground instead.
   * @param {Boolean} value - Whether the scene background should be disabled.
   */ setBackgroundDisabled(value) {
        this.ignoreBackground = value;
    }
    /**
   * Indicates whether the shadow map auto update is disabled.
   *
   * @deprecated Use skipShadowMapUpdate instead.
   * @return {Boolean} Whether the shadow map update is disabled.
   */ isShadowMapDisabled() {
        return this.skipShadowMapUpdate;
    }
    /**
   * Enables or disables the shadow map auto update.
   *
   * @deprecated Use skipShadowMapUpdate instead.
   * @param {Boolean} value - Whether the shadow map auto update should be disabled.
   */ setShadowMapDisabled(value) {
        this.skipShadowMapUpdate = value;
    }
    /**
   * Returns the clear pass.
   *
   * @deprecated Use clearPass.enabled instead.
   * @return {ClearPass} The clear pass.
   */ getClearPass() {
        return this.clearPass;
    }
    /**
   * Renders the scene.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const scene = this.scene;
        const camera = this.camera;
        const selection = this.selection;
        const mask = camera.layers.mask;
        const background = scene.background;
        const shadowMapAutoUpdate = renderer.shadowMap.autoUpdate;
        const renderTarget = this.renderToScreen ? null : inputBuffer;
        if (selection !== null) camera.layers.set(selection.getLayer());
        if (this.skipShadowMapUpdate) renderer.shadowMap.autoUpdate = false;
        if (this.ignoreBackground || this.clearPass.overrideClearColor !== null) scene.background = null;
        if (this.clearPass.enabled) this.clearPass.render(renderer, inputBuffer);
        renderer.setRenderTarget(renderTarget);
        if (this.overrideMaterialManager !== null) this.overrideMaterialManager.render(renderer, scene, camera);
        else renderer.render(scene, camera);
        camera.layers.mask = mask;
        scene.background = background;
        renderer.shadowMap.autoUpdate = shadowMapAutoUpdate;
    }
};
// src/effects/glsl/god-rays.frag
var $2046da3312f94030$var$god_rays_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=texture2D(map,uv);}`;
// src/effects/GodRaysEffect.js
var $2046da3312f94030$var$v2 = /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
var $2046da3312f94030$var$m = /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
var $2046da3312f94030$export$6c90045c82ddd8e9 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new god rays effect.
   *
   * @param {Camera} [camera] - The main camera.
   * @param {Mesh|Points} [lightSource] - The light source. Must not write depth and has to be flagged as transparent.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function of this effect.
   * @param {Number} [options.samples=60.0] - The number of samples per pixel.
   * @param {Number} [options.density=0.96] - The density of the light rays.
   * @param {Number} [options.decay=0.9] - An illumination decay factor.
   * @param {Number} [options.weight=0.4] - A light ray weight factor.
   * @param {Number} [options.exposure=0.6] - A constant attenuation coefficient.
   * @param {Number} [options.clampMax=1.0] - An upper bound for the saturation of the overall effect.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   * @param {KernelSize} [options.kernelSize=KernelSize.SMALL] - The blur kernel size. Has no effect if blur is disabled.
   * @param {Boolean} [options.blur=true] - Whether the god rays should be blurred to reduce artifacts.
   */ constructor(camera, lightSource, { blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SCREEN, samples: samples = 60, density: density = 0.96, decay: decay = 0.9, weight: weight = 0.4, exposure: exposure = 0.6, clampMax: clampMax = 1, blur: blur = true, kernelSize: kernelSize = $2046da3312f94030$export$543b1e4815577d06.SMALL, resolutionScale: resolutionScale = 0.5, width: width = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, height: height = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("GodRaysEffect", $2046da3312f94030$var$god_rays_default, {
            blendFunction: blendFunction,
            attributes: $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "map",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ]
            ])
        });
        this.camera = camera;
        this._lightSource = lightSource;
        this.lightSource = lightSource;
        this.lightScene = new (0, $ce0cdebec9150cb3$export$38af1803e3442a7f)();
        this.screenPosition = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        this.renderTargetA = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetA.texture.name = "GodRays.Target.A";
        this.renderTargetB = this.renderTargetA.clone();
        this.renderTargetB.texture.name = "GodRays.Target.B";
        this.uniforms.get("map").value = this.renderTargetB.texture;
        this.renderTargetLight = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1);
        this.renderTargetLight.texture.name = "GodRays.Light";
        this.renderTargetLight.depthTexture = new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)();
        this.renderPassLight = new $2046da3312f94030$export$f63ea822f020b5b0(this.lightScene, camera);
        this.renderPassLight.clearPass.enabled = false;
        this.blurPass = new $2046da3312f94030$export$657273fee9302035({
            kernelSize: kernelSize
        });
        this.blurPass.enabled = blur;
        this.copyPass = new $2046da3312f94030$export$ec9e16bd0f76e979(this.renderTargetLight);
        this.copyPass.fullscreenMaterial.channelWeights = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)(0, 0, 0, 1);
        this.godRaysPass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$4ed51786a9a8bef8(this.screenPosition));
        const godRaysMaterial = this.godRaysMaterial;
        godRaysMaterial.density = density;
        godRaysMaterial.decay = decay;
        godRaysMaterial.weight = weight;
        godRaysMaterial.exposure = exposure;
        godRaysMaterial.maxIntensity = clampMax;
        godRaysMaterial.samples = samples;
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    set mainCamera(value) {
        this.camera = value;
        this.renderPassLight.mainCamera = value;
    }
    /**
   * Sets the light source.
   *
   * @type {Mesh|Points}
   */ get lightSource() {
        return this._lightSource;
    }
    set lightSource(value) {
        this._lightSource = value;
        if (value !== null) {
            value.material.depthWrite = false;
            value.material.transparent = true;
        }
    }
    /**
   * Returns the blur pass that reduces aliasing artifacts and makes the light softer.
   *
   * @deprecated Use blurPass instead.
   * @return {KawaseBlurPass} The blur pass.
   */ getBlurPass() {
        return this.blurPass;
    }
    /**
   * A texture that contains the intermediate result of this effect.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTargetB.texture;
    }
    /**
   * Returns the god rays texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.texture;
    }
    /**
   * The internal god rays material.
   *
   * @type {GodRaysMaterial}
   */ get godRaysMaterial() {
        return this.godRaysPass.fullscreenMaterial;
    }
    /**
   * Returns the god rays material.
   *
   * @deprecated Use godRaysMaterial instead.
   * @return {GodRaysMaterial} The material.
   */ getGodRaysMaterial() {
        return this.godRaysMaterial;
    }
    /**
   * Returns the resolution of this effect.
   *
   * @deprecated Use resolution instead.
   * @return {GodRaysMaterial} The material.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * The current width of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.width instead.
   */ get width() {
        return this.resolution.width;
    }
    set width(value) {
        this.resolution.preferredWidth = value;
    }
    /**
   * The current height of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.height instead.
   */ get height() {
        return this.resolution.height;
    }
    set height(value) {
        this.resolution.preferredHeight = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get dithering() {
        return this.godRaysMaterial.dithering;
    }
    set dithering(value) {
        const material = this.godRaysMaterial;
        material.dithering = value;
        material.needsUpdate = true;
    }
    /**
   * Indicates whether the god rays should be blurred to reduce artifacts.
   *
   * @type {Boolean}
   * @deprecated Use blurPass.enabled instead.
   */ get blur() {
        return this.blurPass.enabled;
    }
    set blur(value) {
        this.blurPass.enabled = value;
    }
    /**
   * The blur kernel size.
   *
   * @type {KernelSize}
   * @deprecated Use blurPass.kernelSize instead.
   */ get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(value) {
        this.blurPass.kernelSize = value;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * The number of samples per pixel.
   *
   * @type {Number}
   * @deprecated Use godRaysMaterial.samples instead.
   */ get samples() {
        return this.godRaysMaterial.samples;
    }
    /**
   * A higher sample count improves quality at the cost of performance.
   *
   * @type {Number}
   * @deprecated Use godRaysMaterial.samples instead.
   */ set samples(value) {
        this.godRaysMaterial.samples = value;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {Number} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.copyPass.fullscreenMaterial.depthBuffer = depthTexture;
        this.copyPass.fullscreenMaterial.depthPacking = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const lightSource = this.lightSource;
        const parent = lightSource.parent;
        const matrixAutoUpdate = lightSource.matrixAutoUpdate;
        const renderTargetA = this.renderTargetA;
        const renderTargetLight = this.renderTargetLight;
        lightSource.material.depthWrite = true;
        lightSource.matrixAutoUpdate = false;
        lightSource.updateWorldMatrix(true, false);
        if (parent !== null) {
            if (!matrixAutoUpdate) $2046da3312f94030$var$m.copy(lightSource.matrix);
            lightSource.matrix.copy(lightSource.matrixWorld);
        }
        this.lightScene.add(lightSource);
        this.copyPass.render(renderer, inputBuffer);
        this.renderPassLight.render(renderer, renderTargetLight);
        lightSource.material.depthWrite = false;
        lightSource.matrixAutoUpdate = matrixAutoUpdate;
        if (parent !== null) {
            if (!matrixAutoUpdate) lightSource.matrix.copy($2046da3312f94030$var$m);
            parent.add(lightSource);
        }
        $2046da3312f94030$var$v2.setFromMatrixPosition(lightSource.matrixWorld).project(this.camera);
        this.screenPosition.set(Math.min(Math.max(($2046da3312f94030$var$v2.x + 1) * 0.5, -1), 2), Math.min(Math.max(($2046da3312f94030$var$v2.y + 1) * 0.5, -1), 2));
        let renderTarget = renderTargetLight;
        if (this.blurPass.enabled) {
            this.blurPass.render(renderer, renderTarget, renderTargetA);
            renderTarget = renderTargetA;
        }
        this.godRaysPass.render(renderer, renderTarget, this.renderTargetB);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.renderTargetLight.setSize(width, height);
        this.renderTargetA.setSize(w, h);
        this.renderTargetB.setSize(w, h);
        this.blurPass.resolution.copy(resolution);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.blurPass.initialize(renderer, alpha, frameBufferType);
        this.renderPassLight.initialize(renderer, alpha, frameBufferType);
        this.copyPass.initialize(renderer, alpha, frameBufferType);
        this.godRaysPass.initialize(renderer, alpha, frameBufferType);
        if (frameBufferType !== void 0) {
            this.renderTargetA.texture.type = frameBufferType;
            this.renderTargetB.texture.type = frameBufferType;
            this.renderTargetLight.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) {
                this.renderTargetA.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.renderTargetB.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.renderTargetLight.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
            }
        }
    }
};
// src/effects/glsl/grid.frag
var $2046da3312f94030$var$grid_default = `uniform vec2 scale;uniform float lineWidth;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){float grid=0.5-max(abs(mod(uv.x*scale.x,1.0)-0.5),abs(mod(uv.y*scale.y,1.0)-0.5));outputColor=vec4(vec3(smoothstep(0.0,lineWidth,grid)),inputColor.a);}`;
// src/effects/GridEffect.js
var $2046da3312f94030$export$196041dbe92a1b1 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new grid effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.OVERLAY] - The blend function of this effect.
   * @param {Number} [options.scale=1.0] - The scale of the grid pattern.
   * @param {Number} [options.lineWidth=0.0] - The line width of the grid pattern.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.OVERLAY, scale: scale = 1, lineWidth: lineWidth = 0 } = {}){
        super("GridEffect", $2046da3312f94030$var$grid_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "scale",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
                ],
                [
                    "lineWidth",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(lineWidth)
                ]
            ])
        });
        this.resolution = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        this.s = 0;
        this.scale = scale;
        this.l = 0;
        this.lineWidth = lineWidth;
    }
    /**
   * The scale.
   *
   * @type {Number}
   */ get scale() {
        return this.s;
    }
    set scale(value) {
        this.s = Math.max(value, 1e-6);
        this.setSize(this.resolution.width, this.resolution.height);
    }
    /**
   * Returns the current grid scale.
   *
   * @deprecated Use scale instead.
   * @return {Number} The grid scale.
   */ getScale() {
        return this.scale;
    }
    /**
   * Sets the grid scale.
   *
   * @deprecated Use scale instead.
   * @param {Number} value - The new grid scale.
   */ setScale(value) {
        this.scale = value;
    }
    /**
   * The line width.
   *
   * @type {Number}
   */ get lineWidth() {
        return this.l;
    }
    set lineWidth(value) {
        this.l = value;
        this.setSize(this.resolution.width, this.resolution.height);
    }
    /**
   * Returns the current grid line width.
   *
   * @deprecated Use lineWidth instead.
   * @return {Number} The grid line width.
   */ getLineWidth() {
        return this.lineWidth;
    }
    /**
   * Sets the grid line width.
   *
   * @deprecated Use lineWidth instead.
   * @param {Number} value - The new grid line width.
   */ setLineWidth(value) {
        this.lineWidth = value;
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.resolution.set(width, height);
        const aspect = width / height;
        const scale = this.scale * (height * 0.125);
        this.uniforms.get("scale").value.set(aspect * scale, scale);
        this.uniforms.get("lineWidth").value = scale / height + this.lineWidth;
    }
};
// src/effects/glsl/hue-saturation.frag
var $2046da3312f94030$var$hue_saturation_default = `uniform vec3 hue;uniform float saturation;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(dot(inputColor.rgb,hue.xyz),dot(inputColor.rgb,hue.zxy),dot(inputColor.rgb,hue.yzx));float average=(color.r+color.g+color.b)/3.0;vec3 diff=average-color;if(saturation>0.0){color+=diff*(1.0-1.0/(1.001-saturation));}else{color+=diff*-saturation;}outputColor=vec4(min(color,1.0),inputColor.a);}`;
// src/effects/HueSaturationEffect.js
var $2046da3312f94030$export$cb84d7708921e909 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new hue/saturation effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Number} [options.hue=0.0] - The hue in radians.
   * @param {Number} [options.saturation=0.0] - The saturation factor, ranging from -1 to 1, where 0 means no change.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SRC, hue: hue = 0, saturation: saturation = 0 } = {}){
        super("HueSaturationEffect", $2046da3312f94030$var$hue_saturation_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "hue",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)())
                ],
                [
                    "saturation",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(saturation)
                ]
            ])
        });
        this.hue = hue;
    }
    /**
   * The saturation.
   *
   * @type {Number}
   */ get saturation() {
        return this.uniforms.get("saturation").value;
    }
    set saturation(value) {
        this.uniforms.get("saturation").value = value;
    }
    /**
   * Returns the saturation.
   *
   * @deprecated Use saturation instead.
   * @return {Number} The saturation.
   */ getSaturation() {
        return this.saturation;
    }
    /**
   * Sets the saturation.
   *
   * @deprecated Use saturation instead.
   * @param {Number} value - The saturation.
   */ setSaturation(value) {
        this.saturation = value;
    }
    /**
   * The hue.
   *
   * @type {Number}
   */ get hue() {
        const hue = this.uniforms.get("hue").value;
        return Math.acos((hue.x * 3 - 1) / 2);
    }
    set hue(value) {
        const s = Math.sin(value), c2 = Math.cos(value);
        this.uniforms.get("hue").value.set((2 * c2 + 1) / 3, (-Math.sqrt(3) * s - c2 + 1) / 3, (Math.sqrt(3) * s - c2 + 1) / 3);
    }
    /**
   * Returns the hue.
   *
   * @deprecated Use hue instead.
   * @return {Number} The hue in radians.
   */ getHue() {
        return this.hue;
    }
    /**
   * Sets the hue.
   *
   * @deprecated Use hue instead.
   * @param {Number} value - The hue in radians.
   */ setHue(value) {
        this.hue = value;
    }
};
// src/effects/glsl/lens-distortion.frag
var $2046da3312f94030$var$lens_distortion_default = `uniform vec2 distortion;uniform vec2 principalPoint;uniform vec2 focalLength;uniform float skew;float mask(const in vec2 uv){return float(uv.s>=0.0&&uv.s<=1.0&&uv.t>=0.0&&uv.t<=1.0);}void mainUv(inout vec2 uv){vec2 xn=2.0*(uv.st-0.5);vec3 xDistorted=vec3((1.0+distortion*dot(xn,xn))*xn,1.0);mat3 kk=mat3(vec3(focalLength.x,0.0,0.0),vec3(skew*focalLength.x,focalLength.y,0.0),vec3(principalPoint.x,principalPoint.y,1.0));uv=(kk*xDistorted).xy*0.5+0.5;}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=mask(uv)*inputColor;}`;
// src/effects/LensDistortionEffect.js
var $2046da3312f94030$export$1d92d776a41aead9 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new lens distortion effect.
   *
   * @param {Object} [options] - The options.
   * @param {Vector2} [options.distortion] - The distortion value.
   * @param {Vector2} [options.principalPoint] - The center point.
   * @param {Vector2} [options.focalLength] - The focal length.
   * @param {Number} [options.skew=0] - The skew value.
   */ constructor({ distortion: distortion = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(0, 0), principalPoint: principalPoint = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(0, 0), focalLength: focalLength = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(1, 1), skew: skew = 0 } = {}){
        super("LensDistortionEffect", $2046da3312f94030$var$lens_distortion_default, {
            uniforms: /* @__PURE__ */ new Map([
                [
                    "distortion",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(distortion)
                ],
                [
                    "principalPoint",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(principalPoint)
                ],
                [
                    "focalLength",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(focalLength)
                ],
                [
                    "skew",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(skew)
                ]
            ])
        });
    }
    /**
   * The radial distortion coefficients. Default is (0, 0).
   *
   * @type {Vector2}
   */ get distortion() {
        return this.uniforms.get("distortion").value;
    }
    set distortion(value) {
        this.uniforms.get("distortion").value = value;
    }
    /**
   * The principal point. Default is (0, 0).
   *
   * @type {Vector2}
   */ get principalPoint() {
        return this.uniforms.get("principalPoint").value;
    }
    set principalPoint(value) {
        this.uniforms.get("principalPoint").value = value;
    }
    /**
   * The focal length. Default is (1, 1).
   *
   * @type {Vector2}
   */ get focalLength() {
        return this.uniforms.get("focalLength").value;
    }
    set focalLength(value) {
        this.uniforms.get("focalLength").value = value;
    }
    /**
   * The skew factor in radians.
   *
   * @type {Number}
   */ get skew() {
        return this.uniforms.get("skew").value;
    }
    set skew(value) {
        this.uniforms.get("skew").value = value;
    }
};
// src/effects/glsl/lut-1d.frag
var $2046da3312f94030$var$lut_1d_default = `#ifdef LUT_PRECISION_HIGH
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D lut;
#else
uniform mediump sampler2D lut;
#endif
#else
uniform lowp sampler2D lut;
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(texture2D(lut,vec2(inputColor.r,0.5)).r,texture2D(lut,vec2(inputColor.g,0.5)).r,texture2D(lut,vec2(inputColor.b,0.5)).r,inputColor.a);}`;
// src/effects/LUT1DEffect.js
var $2046da3312f94030$export$66593ee27ed5b22a = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new color grading effect.
   *
   * @param {Texture} lut - The lookup texture.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   */ constructor(lut, { blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SRC } = {}){
        super("LUT1DEffect", $2046da3312f94030$var$lut_1d_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "lut",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ]
            ])
        });
        this.lut = lut;
    }
    /**
   * The LUT.
   *
   * @type {Texture}
   */ get lut() {
        return this.uniforms.get("lut").value;
    }
    set lut(value) {
        this.uniforms.get("lut").value = value;
        if (value !== null && (value.type === (0, $ce0cdebec9150cb3$export$f6d331659b644596) || value.type === (0, $ce0cdebec9150cb3$export$2697304443f382bc))) this.defines.set("LUT_PRECISION_HIGH", "1");
    }
};
// src/enums/LUTOperation.js
var $2046da3312f94030$export$1e225700a60fe544 = {
    SCALE_UP: "lut.scaleup"
};
// src/textures/RawImageData.js
function $2046da3312f94030$var$createCanvas(width, height, data) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;
    if (data instanceof Image) context.drawImage(data, 0, 0);
    else {
        const imageData = context.createImageData(width, height);
        imageData.data.set(data);
        context.putImageData(imageData, 0, 0);
    }
    return canvas;
}
var $2046da3312f94030$export$82a80f8de384fe62 = class _RawImageData {
    /**
   * Constructs a new image data container.
   *
   * @param {Number} [width=0] - The width of the image.
   * @param {Number} [height=0] - The height of the image.
   * @param {Uint8ClampedArray<ArrayBuffer>} [data=null] - The image data.
   */ constructor(width = 0, height = 0, data = null){
        this.width = width;
        this.height = height;
        this.data = data;
    }
    /**
   * Creates a canvas from this image data.
   *
   * @return {Canvas} The canvas, or null if it couldn't be created.
   */ toCanvas() {
        return typeof document === "undefined" ? null : $2046da3312f94030$var$createCanvas(this.width, this.height, this.data);
    }
    /**
   * Creates a new image data container.
   *
   * @param {ImageData|Image} image - An image or plain image data.
   * @return {RawImageData} The image data.
   */ static from(image) {
        const { width: width, height: height } = image;
        let data;
        if (image instanceof Image) {
            const canvas = $2046da3312f94030$var$createCanvas(width, height, image);
            if (canvas !== null) {
                const context = canvas.getContext("2d");
                data = context.getImageData(0, 0, width, height).data;
            }
        } else data = image.data;
        return new _RawImageData(width, height, data);
    }
};
// temp/lut/worker.txt
var $2046da3312f94030$var$worker_default = '"use strict";(()=>{var O={SCALE_UP:"lut.scaleup"};var _=[new Float32Array(3),new Float32Array(3)],n=[new Float32Array(3),new Float32Array(3),new Float32Array(3),new Float32Array(3)],Z=[[new Float32Array([0,0,0]),new Float32Array([1,0,0]),new Float32Array([1,1,0]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([1,0,0]),new Float32Array([1,0,1]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([0,0,1]),new Float32Array([1,0,1]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([0,1,0]),new Float32Array([1,1,0]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([0,1,0]),new Float32Array([0,1,1]),new Float32Array([1,1,1])],[new Float32Array([0,0,0]),new Float32Array([0,0,1]),new Float32Array([0,1,1]),new Float32Array([1,1,1])]];function d(a,t,r,m){let i=r[0]-t[0],e=r[1]-t[1],y=r[2]-t[2],h=a[0]-t[0],A=a[1]-t[1],w=a[2]-t[2],c=e*w-y*A,l=y*h-i*w,x=i*A-e*h,u=Math.sqrt(c*c+l*l+x*x),b=u*.5,s=c/u,F=l/u,f=x/u,p=-(a[0]*s+a[1]*F+a[2]*f),M=m[0]*s+m[1]*F+m[2]*f;return Math.abs(M+p)*b/3}function V(a,t,r,m,i,e){let y=(r+m*t+i*t*t)*4;e[0]=a[y+0],e[1]=a[y+1],e[2]=a[y+2]}function k(a,t,r,m,i,e){let y=r*(t-1),h=m*(t-1),A=i*(t-1),w=Math.floor(y),c=Math.floor(h),l=Math.floor(A),x=Math.ceil(y),u=Math.ceil(h),b=Math.ceil(A),s=y-w,F=h-c,f=A-l;if(w===y&&c===h&&l===A)V(a,t,y,h,A,e);else{let p;s>=F&&F>=f?p=Z[0]:s>=f&&f>=F?p=Z[1]:f>=s&&s>=F?p=Z[2]:F>=s&&s>=f?p=Z[3]:F>=f&&f>=s?p=Z[4]:f>=F&&F>=s&&(p=Z[5]);let[M,g,X,Y]=p,P=_[0];P[0]=s,P[1]=F,P[2]=f;let o=_[1],L=x-w,S=u-c,U=b-l;o[0]=L*M[0]+w,o[1]=S*M[1]+c,o[2]=U*M[2]+l,V(a,t,o[0],o[1],o[2],n[0]),o[0]=L*g[0]+w,o[1]=S*g[1]+c,o[2]=U*g[2]+l,V(a,t,o[0],o[1],o[2],n[1]),o[0]=L*X[0]+w,o[1]=S*X[1]+c,o[2]=U*X[2]+l,V(a,t,o[0],o[1],o[2],n[2]),o[0]=L*Y[0]+w,o[1]=S*Y[1]+c,o[2]=U*Y[2]+l,V(a,t,o[0],o[1],o[2],n[3]);let T=d(g,X,Y,P)*6,q=d(M,X,Y,P)*6,C=d(M,g,Y,P)*6,E=d(M,g,X,P)*6;n[0][0]*=T,n[0][1]*=T,n[0][2]*=T,n[1][0]*=q,n[1][1]*=q,n[1][2]*=q,n[2][0]*=C,n[2][1]*=C,n[2][2]*=C,n[3][0]*=E,n[3][1]*=E,n[3][2]*=E,e[0]=n[0][0]+n[1][0]+n[2][0]+n[3][0],e[1]=n[0][1]+n[1][1]+n[2][1]+n[3][1],e[2]=n[0][2]+n[1][2]+n[2][2]+n[3][2]}}var v=class{static expand(t,r){let m=Math.cbrt(t.length/4),i=new Float32Array(3),e=new t.constructor(r**3*4),y=t instanceof Uint8Array?255:1,h=r**2,A=1/(r-1);for(let w=0;w<r;++w)for(let c=0;c<r;++c)for(let l=0;l<r;++l){let x=l*A,u=c*A,b=w*A,s=Math.round(l+c*r+w*h)*4;k(t,m,x,u,b,i),e[s+0]=i[0],e[s+1]=i[1],e[s+2]=i[2],e[s+3]=y}return e}};self.addEventListener("message",a=>{let t=a.data,r=t.data;t.operation===O.SCALE_UP&&(r=v.expand(r,t.size)),postMessage(r,[r.buffer]),close()});})();\n';
// src/textures/lut/LookupTexture.js
var $2046da3312f94030$var$c = /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)();
var $2046da3312f94030$export$a3627e735a49df45 = class _LookupTexture extends (0, $ce0cdebec9150cb3$export$d7a3086320f856db) {
    /**
   * Constructs a cubic 3D lookup texture.
   *
   * @param {TypedArray} data - The pixel data. The default format is RGBA.
   * @param {Number} size - The sidelength.
   */ constructor(data, size){
        super(data, size, size, size);
        this.type = (0, $ce0cdebec9150cb3$export$f6d331659b644596);
        this.format = (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c);
        this.minFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
        this.magFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
        this.wrapS = (0, $ce0cdebec9150cb3$export$9d9334239a5a5e06);
        this.wrapT = (0, $ce0cdebec9150cb3$export$9d9334239a5a5e06);
        this.wrapR = (0, $ce0cdebec9150cb3$export$9d9334239a5a5e06);
        this.unpackAlignment = 1;
        this.needsUpdate = true;
        this.colorSpace = (0, $ce0cdebec9150cb3$export$42429b3acfb233a4);
        this.domainMin = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 0, 0);
        this.domainMax = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(1, 1, 1);
    }
    /**
   * Indicates that this is an instance of LookupTexture3D.
   *
   * @type {Boolean}
   * @deprecated
   */ get isLookupTexture3D() {
        return true;
    }
    /**
   * Scales this LUT up to a given target size using tetrahedral interpolation.
   *
   * @param {Number} size - The target sidelength.
   * @param {Boolean} [transferData=true] - Extra fast mode. Set to false to keep the original data intact.
   * @return {Promise<LookupTexture>} A promise that resolves with a new LUT upon completion.
   */ scaleUp(size, transferData = true) {
        const image = this.image;
        let promise;
        if (size <= image.width) promise = Promise.reject(new Error("The target size must be greater than the current size"));
        else promise = new Promise((resolve, reject)=>{
            const workerURL = URL.createObjectURL(new Blob([
                $2046da3312f94030$var$worker_default
            ], {
                type: "text/javascript"
            }));
            const worker = new Worker(workerURL);
            worker.addEventListener("error", (event)=>reject(event.error));
            worker.addEventListener("message", (event)=>{
                const lut = new _LookupTexture(event.data, size);
                this.colorSpace = lut.colorSpace;
                lut.type = this.type;
                lut.name = this.name;
                URL.revokeObjectURL(workerURL);
                resolve(lut);
            });
            const transferList = transferData ? [
                image.data.buffer
            ] : [];
            worker.postMessage({
                operation: $2046da3312f94030$export$1e225700a60fe544.SCALE_UP,
                data: image.data,
                size: size
            }, transferList);
        });
        return promise;
    }
    /**
   * Applies the given LUT to this one.
   *
   * @param {LookupTexture} lut - A LUT. Must have the same dimensions, type and format as this LUT.
   * @return {LookupTexture} This texture.
   */ applyLUT(lut) {
        const img0 = this.image;
        const img1 = lut.image;
        const size0 = Math.min(img0.width, img0.height, img0.depth);
        const size1 = Math.min(img1.width, img1.height, img1.depth);
        if (size0 !== size1) console.error("Size mismatch");
        else if (lut.type !== (0, $ce0cdebec9150cb3$export$f6d331659b644596) || this.type !== (0, $ce0cdebec9150cb3$export$f6d331659b644596)) console.error("Both LUTs must be FloatType textures");
        else if (lut.format !== (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c) || this.format !== (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)) console.error("Both LUTs must be RGBA textures");
        else {
            const data0 = img0.data;
            const data1 = img1.data;
            const size = size0;
            const sizeSq = size ** 2;
            const s = size - 1;
            for(let i = 0, l = size ** 3; i < l; ++i){
                const i4 = i * 4;
                const r = data0[i4 + 0] * s;
                const g = data0[i4 + 1] * s;
                const b = data0[i4 + 2] * s;
                const iRGB = Math.round(r + g * size + b * sizeSq) * 4;
                data0[i4 + 0] = data1[iRGB + 0];
                data0[i4 + 1] = data1[iRGB + 1];
                data0[i4 + 2] = data1[iRGB + 2];
            }
            this.needsUpdate = true;
        }
        return this;
    }
    /**
   * Converts the LUT data into unsigned byte data.
   *
   * This is a lossy operation which should only be performed after all other transformations have been applied.
   *
   * @return {LookupTexture} This texture.
   */ convertToUint8() {
        if (this.type === (0, $ce0cdebec9150cb3$export$f6d331659b644596)) {
            const floatData = this.image.data;
            const uint8Data = new Uint8Array(floatData.length);
            for(let i = 0, l = floatData.length; i < l; ++i)uint8Data[i] = floatData[i] * 255 + 0.5;
            this.image.data = uint8Data;
            this.type = (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10);
            this.needsUpdate = true;
        }
        return this;
    }
    /**
   * Converts the LUT data into float data.
   *
   * @return {LookupTexture} This texture.
   */ convertToFloat() {
        if (this.type === (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) {
            const uint8Data = this.image.data;
            const floatData = new Float32Array(uint8Data.length);
            for(let i = 0, l = uint8Data.length; i < l; ++i)floatData[i] = uint8Data[i] / 255;
            this.image.data = floatData;
            this.type = (0, $ce0cdebec9150cb3$export$f6d331659b644596);
            this.needsUpdate = true;
        }
        return this;
    }
    /**
   * Converts this LUT into RGBA data.
   *
   * @deprecated LUTs are RGBA by default since three r137.
   * @return {LookupTexture} This texture.
   */ convertToRGBA() {
        console.warn("LookupTexture", "convertToRGBA() is deprecated, LUTs are now RGBA by default");
        return this;
    }
    /**
   * Converts the output of this LUT into sRGB color space.
   *
   * @return {LookupTexture} This texture.
   */ convertLinearToSRGB() {
        const data = this.image.data;
        if (this.type === (0, $ce0cdebec9150cb3$export$f6d331659b644596)) {
            for(let i = 0, l = data.length; i < l; i += 4)$2046da3312f94030$var$c.fromArray(data, i).convertLinearToSRGB().toArray(data, i);
            this.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
            this.needsUpdate = true;
        } else console.error("Color space conversion requires FloatType data");
        return this;
    }
    /**
   * Converts the output of this LUT into linear color space.
   *
   * @return {LookupTexture} This texture.
   */ convertSRGBToLinear() {
        const data = this.image.data;
        if (this.type === (0, $ce0cdebec9150cb3$export$f6d331659b644596)) {
            for(let i = 0, l = data.length; i < l; i += 4)$2046da3312f94030$var$c.fromArray(data, i).convertSRGBToLinear().toArray(data, i);
            this.colorSpace = (0, $ce0cdebec9150cb3$export$42429b3acfb233a4);
            this.needsUpdate = true;
        } else console.error("Color space conversion requires FloatType data");
        return this;
    }
    /**
   * Converts this LUT into a 2D data texture.
   *
   * Please note that custom input domains are not carried over to 2D textures.
   *
   * @return {DataTexture} The texture.
   */ toDataTexture() {
        const width = this.image.width;
        const height = this.image.height * this.image.depth;
        const texture = new (0, $ce0cdebec9150cb3$export$b691f601014eabe1)(this.image.data, width, height);
        texture.name = this.name;
        texture.type = this.type;
        texture.format = this.format;
        texture.minFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
        texture.magFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
        texture.wrapS = this.wrapS;
        texture.wrapT = this.wrapT;
        texture.generateMipmaps = false;
        texture.needsUpdate = true;
        this.colorSpace = texture.colorSpace;
        return texture;
    }
    /**
   * Creates a new 3D LUT by copying a given LUT.
   *
   * Common image-based textures will be converted into 3D data textures.
   *
   * @param {Texture} texture - The LUT. Assumed to be cubic.
   * @return {LookupTexture} A new 3D LUT.
   */ static from(texture) {
        const image = texture.image;
        const { width: width, height: height } = image;
        const size = Math.min(width, height);
        let data;
        if (image instanceof Image) {
            const rawImageData = $2046da3312f94030$export$82a80f8de384fe62.from(image);
            const src = rawImageData.data;
            if (width > height) {
                data = new Uint8Array(src.length);
                for(let z = 0; z < size; ++z){
                    for(let y = 0; y < size; ++y)for(let x = 0; x < size; ++x){
                        const i4 = (x + z * size + y * size * size) * 4;
                        const j4 = (x + y * size + z * size * size) * 4;
                        data[j4 + 0] = src[i4 + 0];
                        data[j4 + 1] = src[i4 + 1];
                        data[j4 + 2] = src[i4 + 2];
                        data[j4 + 3] = src[i4 + 3];
                    }
                }
            } else data = new Uint8Array(src.buffer);
        } else data = image.data.slice();
        const lut = new _LookupTexture(data, size);
        lut.type = texture.type;
        lut.name = texture.name;
        texture.colorSpace = lut.colorSpace;
        return lut;
    }
    /**
   * Creates a neutral 3D LUT.
   *
   * @param {Number} size - The sidelength.
   * @return {LookupTexture} A neutral 3D LUT.
   */ static createNeutral(size) {
        const data = new Float32Array(size ** 3 * 4);
        const sizeSq = size ** 2;
        const s = 1 / (size - 1);
        for(let r = 0; r < size; ++r){
            for(let g = 0; g < size; ++g)for(let b = 0; b < size; ++b){
                const i4 = (r + g * size + b * sizeSq) * 4;
                data[i4 + 0] = r * s;
                data[i4 + 1] = g * s;
                data[i4 + 2] = b * s;
                data[i4 + 3] = 1;
            }
        }
        const lut = new _LookupTexture(data, size);
        lut.name = "neutral";
        return lut;
    }
};
// src/effects/glsl/lut-3d.frag
var $2046da3312f94030$var$lut_3d_default = `uniform vec3 scale;uniform vec3 offset;
#ifdef CUSTOM_INPUT_DOMAIN
uniform vec3 domainMin;uniform vec3 domainMax;
#endif
#ifdef LUT_3D
#ifdef LUT_PRECISION_HIGH
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler3D lut;
#else
uniform mediump sampler3D lut;
#endif
#else
uniform lowp sampler3D lut;
#endif
vec4 applyLUT(const in vec3 rgb){
#ifdef TETRAHEDRAL_INTERPOLATION
vec3 p=floor(rgb);vec3 f=rgb-p;vec3 v1=(p+0.5)*LUT_TEXEL_WIDTH;vec3 v4=(p+1.5)*LUT_TEXEL_WIDTH;vec3 v2,v3;vec3 frac;if(f.r>=f.g){if(f.g>f.b){frac=f.rgb;v2=vec3(v4.x,v1.y,v1.z);v3=vec3(v4.x,v4.y,v1.z);}else if(f.r>=f.b){frac=f.rbg;v2=vec3(v4.x,v1.y,v1.z);v3=vec3(v4.x,v1.y,v4.z);}else{frac=f.brg;v2=vec3(v1.x,v1.y,v4.z);v3=vec3(v4.x,v1.y,v4.z);}}else{if(f.b>f.g){frac=f.bgr;v2=vec3(v1.x,v1.y,v4.z);v3=vec3(v1.x,v4.y,v4.z);}else if(f.r>=f.b){frac=f.grb;v2=vec3(v1.x,v4.y,v1.z);v3=vec3(v4.x,v4.y,v1.z);}else{frac=f.gbr;v2=vec3(v1.x,v4.y,v1.z);v3=vec3(v1.x,v4.y,v4.z);}}vec4 n1=texture(lut,v1);vec4 n2=texture(lut,v2);vec4 n3=texture(lut,v3);vec4 n4=texture(lut,v4);vec4 weights=vec4(1.0-frac.x,frac.x-frac.y,frac.y-frac.z,frac.z);vec4 result=weights*mat4(vec4(n1.r,n2.r,n3.r,n4.r),vec4(n1.g,n2.g,n3.g,n4.g),vec4(n1.b,n2.b,n3.b,n4.b),vec4(1.0));return vec4(result.rgb,1.0);
#else
return texture(lut,rgb);
#endif
}
#else
#ifdef LUT_PRECISION_HIGH
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D lut;
#else
uniform mediump sampler2D lut;
#endif
#else
uniform lowp sampler2D lut;
#endif
vec4 applyLUT(const in vec3 rgb){float slice=rgb.b*LUT_SIZE;float slice0=floor(slice);float interp=slice-slice0;float centeredInterp=interp-0.5;float slice1=slice0+sign(centeredInterp);
#ifdef LUT_STRIP_HORIZONTAL
float xOffset=clamp(rgb.r*LUT_TEXEL_HEIGHT,LUT_TEXEL_WIDTH*0.5,LUT_TEXEL_HEIGHT-LUT_TEXEL_WIDTH*0.5);vec2 uv0=vec2(slice0*LUT_TEXEL_HEIGHT+xOffset,rgb.g);vec2 uv1=vec2(slice1*LUT_TEXEL_HEIGHT+xOffset,rgb.g);
#else
float yOffset=clamp(rgb.g*LUT_TEXEL_WIDTH,LUT_TEXEL_HEIGHT*0.5,LUT_TEXEL_WIDTH-LUT_TEXEL_HEIGHT*0.5);vec2 uv0=vec2(rgb.r,slice0*LUT_TEXEL_WIDTH+yOffset);vec2 uv1=vec2(rgb.r,slice1*LUT_TEXEL_WIDTH+yOffset);
#endif
vec4 sample0=texture2D(lut,uv0);vec4 sample1=texture2D(lut,uv1);return mix(sample0,sample1,abs(centeredInterp));}
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 c=inputColor.rgb;
#ifdef CUSTOM_INPUT_DOMAIN
if(c.r>=domainMin.r&&c.g>=domainMin.g&&c.b>=domainMin.b&&c.r<=domainMax.r&&c.g<=domainMax.g&&c.b<=domainMax.b){c=applyLUT(scale*c+offset).rgb;}else{c=inputColor.rgb;}
#else
#if !defined(LUT_3D) || defined(TETRAHEDRAL_INTERPOLATION)
c=clamp(c,0.0,1.0);
#endif
c=applyLUT(scale*c+offset).rgb;
#endif
outputColor=vec4(c,inputColor.a);}`;
// src/effects/LUT3DEffect.js
var $2046da3312f94030$export$16c73198fba02ce9 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new color grading effect.
   *
   * @param {Texture} lut - The lookup texture.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Boolean} [options.tetrahedralInterpolation=false] - Enables or disables tetrahedral interpolation.
   * @param {ColorSpace} [options.inputColorSpace=SRGBColorSpace] - The input color space.
   */ constructor(lut, { blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SRC, tetrahedralInterpolation: tetrahedralInterpolation = false, inputColorSpace: inputColorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa) } = {}){
        super("LUT3DEffect", $2046da3312f94030$var$lut_3d_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "lut",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "scale",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)())
                ],
                [
                    "offset",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)())
                ],
                [
                    "domainMin",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "domainMax",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ]
            ])
        });
        this.tetrahedralInterpolation = tetrahedralInterpolation;
        this.inputColorSpace = inputColorSpace;
        this.lut = lut;
    }
    /**
   * The LUT.
   *
   * @type {Texture}
   */ get lut() {
        return this.uniforms.get("lut").value;
    }
    set lut(value) {
        const defines = this.defines;
        const uniforms = this.uniforms;
        if (this.lut !== value) {
            uniforms.get("lut").value = value;
            if (value !== null) {
                const image = value.image;
                const tetrahedralInterpolation = this.tetrahedralInterpolation;
                defines.clear();
                defines.set("LUT_SIZE", Math.min(image.width, image.height).toFixed(16));
                defines.set("LUT_TEXEL_WIDTH", (1 / image.width).toFixed(16));
                defines.set("LUT_TEXEL_HEIGHT", (1 / image.height).toFixed(16));
                uniforms.get("domainMin").value = null;
                uniforms.get("domainMax").value = null;
                if (value.type === (0, $ce0cdebec9150cb3$export$f6d331659b644596) || value.type === (0, $ce0cdebec9150cb3$export$2697304443f382bc)) defines.set("LUT_PRECISION_HIGH", "1");
                if (image.width > image.height) defines.set("LUT_STRIP_HORIZONTAL", "1");
                else if (value instanceof (0, $ce0cdebec9150cb3$export$d7a3086320f856db)) defines.set("LUT_3D", "1");
                if (value instanceof $2046da3312f94030$export$a3627e735a49df45) {
                    const min = value.domainMin;
                    const max = value.domainMax;
                    if (min.x !== 0 || min.y !== 0 || min.z !== 0 || max.x !== 1 || max.y !== 1 || max.z !== 1) {
                        defines.set("CUSTOM_INPUT_DOMAIN", "1");
                        uniforms.get("domainMin").value = min.clone();
                        uniforms.get("domainMax").value = max.clone();
                    }
                }
                this.tetrahedralInterpolation = tetrahedralInterpolation;
            }
        }
    }
    /**
   * Returns the current LUT.
   *
   * @deprecated Use lut instead.
   * @return {Texture} The LUT.
   */ getLUT() {
        return this.lut;
    }
    /**
   * Sets the LUT.
   *
   * @deprecated Use lut instead.
   * @param {Texture} value - The LUT.
   */ setLUT(value) {
        this.lut = value;
    }
    /**
   * Updates the scale and offset for the LUT sampling coordinates.
   *
   * @private
   */ updateScaleOffset() {
        const lut = this.lut;
        if (lut !== null) {
            const size = Math.min(lut.image.width, lut.image.height);
            const scale = this.uniforms.get("scale").value;
            const offset = this.uniforms.get("offset").value;
            if (this.tetrahedralInterpolation && lut instanceof (0, $ce0cdebec9150cb3$export$d7a3086320f856db)) {
                if (this.defines.has("CUSTOM_INPUT_DOMAIN")) {
                    const domainScale = lut.domainMax.clone().sub(lut.domainMin);
                    scale.setScalar(size - 1).divide(domainScale);
                    offset.copy(lut.domainMin).negate().multiply(scale);
                } else {
                    scale.setScalar(size - 1);
                    offset.setScalar(0);
                }
            } else if (this.defines.has("CUSTOM_INPUT_DOMAIN")) {
                const domainScale = lut.domainMax.clone().sub(lut.domainMin).multiplyScalar(size);
                scale.setScalar(size - 1).divide(domainScale);
                offset.copy(lut.domainMin).negate().multiply(scale).addScalar(1 / (2 * size));
            } else {
                scale.setScalar((size - 1) / size);
                offset.setScalar(1 / (2 * size));
            }
        }
    }
    /**
   * Configures parameters for tetrahedral interpolation.
   *
   * @private
   */ configureTetrahedralInterpolation() {
        const lut = this.lut;
        if (lut !== null) {
            lut.minFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
            lut.magFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
            if (this.tetrahedralInterpolation) {
                if (lut instanceof (0, $ce0cdebec9150cb3$export$d7a3086320f856db)) {
                    lut.minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
                    lut.magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
                } else console.warn("Tetrahedral interpolation requires a 3D texture");
            }
            lut.needsUpdate = true;
        }
    }
    /**
   * Indicates whether tetrahedral interpolation is enabled. Requires a 3D LUT, disabled by default.
   *
   * Tetrahedral interpolation produces highly accurate results but is slower than hardware interpolation.
   *
   * @type {Boolean}
   */ get tetrahedralInterpolation() {
        return this.defines.has("TETRAHEDRAL_INTERPOLATION");
    }
    set tetrahedralInterpolation(value) {
        if (value) this.defines.set("TETRAHEDRAL_INTERPOLATION", "1");
        else this.defines.delete("TETRAHEDRAL_INTERPOLATION");
        this.configureTetrahedralInterpolation();
        this.updateScaleOffset();
        this.setChanged();
    }
    /**
   * Enables or disables tetrahedral interpolation.
   *
   * @deprecated Use tetrahedralInterpolation instead.
   * @param {Boolean} value - Whether tetrahedral interpolation should be enabled.
   */ setTetrahedralInterpolationEnabled(value) {
        this.tetrahedralInterpolation = value;
    }
};
// src/enums/DepthCopyMode.js
var $2046da3312f94030$export$f14251d45898bc40 = {
    FULL: 0,
    SINGLE: 1
};
// src/enums/DepthTestStrategy.js
var $2046da3312f94030$export$a11e355d280abe13 = {
    DEFAULT: 0,
    KEEP_MAX_DEPTH: 1,
    DISCARD_MAX_DEPTH: 2
};
// src/enums/EdgeDetectionMode.js
var $2046da3312f94030$export$20d1071ff7b64a56 = {
    DEPTH: 0,
    LUMA: 1,
    COLOR: 2
};
// src/enums/PredicationMode.js
var $2046da3312f94030$export$6b657d16effdfea4 = {
    DISABLED: 0,
    DEPTH: 1,
    CUSTOM: 2
};
// src/enums/SMAAPreset.js
var $2046da3312f94030$export$829eaccd811a63f = {
    LOW: 0,
    MEDIUM: 1,
    HIGH: 2,
    ULTRA: 3
};
// src/enums/ToneMappingMode.js
var $2046da3312f94030$export$f72cb1a914b4b608 = {
    LINEAR: 0,
    REINHARD: 1,
    REINHARD2: 2,
    REINHARD2_ADAPTIVE: 3,
    UNCHARTED2: 4,
    OPTIMIZED_CINEON: 5,
    CINEON: 5,
    ACES_FILMIC: 6,
    AGX: 7,
    NEUTRAL: 8
};
// src/enums/VignetteTechnique.js
var $2046da3312f94030$export$57fe020f9fbd56c7 = {
    DEFAULT: 0,
    ESKIL: 1
};
// src/enums/WebGLExtension.js
var $2046da3312f94030$export$f67e9dcf2e8ac241 = {
    DERIVATIVES: "derivatives",
    FRAG_DEPTH: "fragDepth",
    DRAW_BUFFERS: "drawBuffers",
    SHADER_TEXTURE_LOD: "shaderTextureLOD"
};
// src/effects/glsl/noise.frag
var $2046da3312f94030$var$noise_default = `void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 noise=vec3(rand(uv*(1.0+time)));
#ifdef PREMULTIPLY
outputColor=vec4(min(inputColor.rgb*noise,vec3(1.0)),inputColor.a);
#else
outputColor=vec4(noise,inputColor.a);
#endif
}`;
// src/effects/NoiseEffect.js
var $2046da3312f94030$export$1d02386659918a72 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new noise effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function of this effect.
   * @param {Boolean} [options.premultiply=false] - Whether the noise should be multiplied with the input colors prior to blending.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SCREEN, premultiply: premultiply = false } = {}){
        super("NoiseEffect", $2046da3312f94030$var$noise_default, {
            blendFunction: blendFunction
        });
        this.premultiply = premultiply;
    }
    /**
   * Indicates whether noise will be multiplied with the input colors prior to blending.
   *
   * @type {Boolean}
   */ get premultiply() {
        return this.defines.has("PREMULTIPLY");
    }
    set premultiply(value) {
        if (this.premultiply !== value) {
            if (value) this.defines.set("PREMULTIPLY", "1");
            else this.defines.delete("PREMULTIPLY");
            this.setChanged();
        }
    }
    /**
   * Indicates whether noise will be multiplied with the input colors prior to blending.
   *
   * @deprecated Use premultiply instead.
   * @return {Boolean} Whether noise is premultiplied.
   */ isPremultiplied() {
        return this.premultiply;
    }
    /**
   * Controls whether noise should be multiplied with the input colors prior to blending.
   *
   * @deprecated Use premultiply instead.
   * @param {Boolean} value - Whether noise should be premultiplied.
   */ setPremultiplied(value) {
        this.premultiply = value;
    }
};
// src/materials/glsl/depth-comparison.frag
var $2046da3312f94030$var$depth_comparison_default = `#include <packing>
#include <clipping_planes_pars_fragment>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform float cameraNear;uniform float cameraFar;centroid varying float vViewZ;centroid varying vec4 vProjTexCoord;void main(){
#include <clipping_planes_fragment>
vec2 projTexCoord=(vProjTexCoord.xy/vProjTexCoord.w)*0.5+0.5;
#if DEPTH_PACKING == 3201
float depth=unpackRGBAToDepth(texture2D(depthBuffer,projTexCoord));
#else
float depth=texture2D(depthBuffer,projTexCoord).r;
#endif
#if defined(USE_LOGARITHMIC_DEPTH_BUFFER) || defined(LOG_DEPTH)
float d=pow(2.0,depth*log2(cameraFar+1.0))-1.0;float a=cameraFar/(cameraFar-cameraNear);float b=cameraFar*cameraNear/(cameraNear-cameraFar);depth=a+b/d;
#elif defined(USE_REVERSED_DEPTH_BUFFER)
depth=1.0-depth;
#endif
#ifdef PERSPECTIVE_CAMERA
float viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
float viewZ=orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
float depthTest=(-vViewZ>-viewZ)?1.0:0.0;gl_FragColor.rg=vec2(0.0,depthTest);}`;
// src/materials/glsl/depth-comparison.vert
var $2046da3312f94030$var$depth_comparison_default2 = `#include <common>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
varying float vViewZ;varying vec4 vProjTexCoord;void main(){
#include <skinbase_vertex>
#include <begin_vertex>
#include <morphtarget_vertex>
#include <skinning_vertex>
#include <project_vertex>
vViewZ=mvPosition.z;vProjTexCoord=gl_Position;
#include <clipping_planes_vertex>
}`;
// src/materials/DepthComparisonMaterial.js
var $2046da3312f94030$export$36b10598ef35408b = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new depth comparison material.
   *
   * @param {Texture} [depthTexture=null] - A depth texture.
   * @param {PerspectiveCamera} [camera] - A camera.
   */ constructor(depthTexture = null, camera){
        super({
            name: "DepthComparisonMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                cameraNear: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0.3),
                cameraFar: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1e3)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$depth_comparison_default,
            vertexShader: $2046da3312f94030$var$depth_comparison_default2
        });
        this.depthBuffer = depthTexture;
        this.depthPacking = (0, $ce0cdebec9150cb3$export$8f910f4c4f73df11);
        this.copyCameraSettings(camera);
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=RGBADepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ce0cdebec9150cb3$export$8f910f4c4f73df11)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNear.value = camera.near;
            this.uniforms.cameraFar.value = camera.far;
            if (camera instanceof (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
};
// src/materials/glsl/outline.frag
var $2046da3312f94030$var$outline_default = `uniform lowp sampler2D inputBuffer;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 c0=texture2D(inputBuffer,vUv0).rg;vec2 c1=texture2D(inputBuffer,vUv1).rg;vec2 c2=texture2D(inputBuffer,vUv2).rg;vec2 c3=texture2D(inputBuffer,vUv3).rg;float d0=(c0.x-c1.x)*0.5;float d1=(c2.x-c3.x)*0.5;float d=length(vec2(d0,d1));float a0=min(c0.y,c1.y);float a1=min(c2.y,c3.y);float visibilityFactor=min(a0,a1);gl_FragColor.rg=(1.0-visibilityFactor>0.001)?vec2(d,0.0):vec2(0.0,d);}`;
// src/materials/glsl/outline.vert
var $2046da3312f94030$var$outline_default2 = `uniform vec2 texelSize;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vUv0=vec2(uv.x+texelSize.x,uv.y);vUv1=vec2(uv.x-texelSize.x,uv.y);vUv2=vec2(uv.x,uv.y+texelSize.y);vUv3=vec2(uv.x,uv.y-texelSize.y);gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/OutlineMaterial.js
var $2046da3312f94030$export$f17d9235adad998c = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new outline material.
   *
   * TODO Remove texelSize param.
   * @param {Vector2} [texelSize] - The screen texel size.
   */ constructor(texelSize = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()){
        super({
            name: "OutlineMaterial",
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$outline_default,
            vertexShader: $2046da3312f94030$var$outline_default2
        });
        this.uniforms.texelSize.value.set(texelSize.x, texelSize.y);
        this.uniforms.maskTexture = this.uniforms.inputBuffer;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y);
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
var $2046da3312f94030$export$4059e0d5f564fa1 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new depth pass.
   *
   * @param {Scene} scene - The scene to render.
   * @param {Camera} camera - The camera to use to render the scene.
   * @param {Object} [options] - The options.
   * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(scene, camera, { renderTarget: renderTarget, resolutionScale: resolutionScale = 1, width: width = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, height: height = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("DepthPass");
        this.needsSwap = false;
        this.renderPass = new $2046da3312f94030$export$f63ea822f020b5b0(scene, camera, new (0, $ce0cdebec9150cb3$export$2698c22ec13825db)({
            depthPacking: (0, $ce0cdebec9150cb3$export$8f910f4c4f73df11)
        }));
        const renderPass = this.renderPass;
        renderPass.skipShadowMapUpdate = true;
        renderPass.ignoreBackground = true;
        this.renderTarget = renderTarget;
        if (this.renderTarget === void 0) {
            this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
                minFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
                magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0)
            });
            this.renderTarget.texture.name = "DepthPass.Target";
        }
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    set mainScene(value) {
        this.renderPass.mainScene = value;
    }
    set mainCamera(value) {
        this.renderPass.mainCamera = value;
    }
    /**
   * The depth texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the depth texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Renders the scene depth.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const renderTarget = this.renderToScreen ? null : this.renderTarget;
        this.renderPass.render(renderer, renderTarget);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        const clearColor = renderer.capabilities.reversedDepthBuffer ? 0 : 16777215;
        const clearPass = this.renderPass.clearPass;
        clearPass.overrideClearColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(clearColor);
        clearPass.overrideClearAlpha = 1;
    }
};
// src/effects/glsl/outline.frag
var $2046da3312f94030$var$outline_default3 = `uniform lowp sampler2D edgeTexture;uniform lowp sampler2D maskTexture;uniform vec3 visibleEdgeColor;uniform vec3 hiddenEdgeColor;uniform float pulse;uniform float edgeStrength;
#ifdef USE_PATTERN
uniform lowp sampler2D patternTexture;varying vec2 vUvPattern;
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 edge=texture2D(edgeTexture,uv).rg;vec2 mask=texture2D(maskTexture,uv).rg;
#ifndef X_RAY
edge.y=0.0;
#endif
edge*=(edgeStrength*mask.x*pulse);vec3 color=edge.x*visibleEdgeColor+edge.y*hiddenEdgeColor;float visibilityFactor=0.0;
#ifdef USE_PATTERN
vec4 patternColor=texture2D(patternTexture,vUvPattern);
#ifdef X_RAY
float hiddenFactor=0.5;
#else
float hiddenFactor=0.0;
#endif
visibilityFactor=(1.0-mask.y>0.0)?1.0:hiddenFactor;visibilityFactor*=(1.0-mask.x)*patternColor.a;color+=visibilityFactor*patternColor.rgb;
#endif
float alpha=max(max(edge.x,edge.y),visibilityFactor);
#ifdef ALPHA
outputColor=vec4(color,alpha);
#else
outputColor=vec4(color,max(alpha,inputColor.a));
#endif
}`;
// src/effects/glsl/outline.vert
var $2046da3312f94030$var$outline_default4 = `uniform float patternScale;varying vec2 vUvPattern;void mainSupport(const in vec2 uv){vUvPattern=uv*vec2(aspect,1.0)*patternScale;}`;
// src/effects/OutlineEffect.js
var $2046da3312f94030$export$7c28220b97a65a06 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new outline effect.
   *
   * @param {Scene} scene - The main scene.
   * @param {Camera} camera - The main camera.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SCREEN] - The blend function. Use `BlendFunction.ALPHA` for dark outlines.
   * @param {Texture} [options.patternTexture=null] - A pattern texture.
   * @param {Number} [options.patternScale=1.0] - The pattern scale.
   * @param {Number} [options.edgeStrength=1.0] - The edge strength.
   * @param {Number} [options.pulseSpeed=0.0] - The pulse speed. A value of zero disables the pulse effect.
   * @param {Number} [options.visibleEdgeColor=0xffffff] - The color of visible edges.
   * @param {Number} [options.hiddenEdgeColor=0x22090a] - The color of hidden edges.
   * @param {KernelSize} [options.kernelSize=KernelSize.VERY_SMALL] - The blur kernel size.
   * @param {Boolean} [options.blur=false] - Whether the outline should be blurred.
   * @param {Boolean} [options.xRay=true] - Whether occluded parts of selected objects should be visible.
   * @param {Number} [options.multisampling=0] - The number of samples used for multisample antialiasing. Requires WebGL 2.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(scene, camera, { blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SCREEN, patternTexture: patternTexture = null, patternScale: patternScale = 1, edgeStrength: edgeStrength = 1, pulseSpeed: pulseSpeed = 0, visibleEdgeColor: visibleEdgeColor = 16777215, hiddenEdgeColor: hiddenEdgeColor = 2230538, kernelSize: kernelSize = $2046da3312f94030$export$543b1e4815577d06.VERY_SMALL, blur: blur = false, xRay: xRay = true, multisampling: multisampling = 0, resolutionScale: resolutionScale = 0.5, width: width = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, height: height = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("OutlineEffect", $2046da3312f94030$var$outline_default3, {
            uniforms: /* @__PURE__ */ new Map([
                [
                    "maskTexture",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "edgeTexture",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "edgeStrength",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(edgeStrength)
                ],
                [
                    "visibleEdgeColor",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(visibleEdgeColor))
                ],
                [
                    "hiddenEdgeColor",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(hiddenEdgeColor))
                ],
                [
                    "pulse",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
                ],
                [
                    "patternScale",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(patternScale)
                ],
                [
                    "patternTexture",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ]
            ])
        });
        this.blendMode.addEventListener("change", (event)=>{
            if (this.blendMode.blendFunction === $2046da3312f94030$export$ea7520add44ba1b6.ALPHA) this.defines.set("ALPHA", "1");
            else this.defines.delete("ALPHA");
            this.setChanged();
        });
        this.blendMode.blendFunction = blendFunction;
        this.patternTexture = patternTexture;
        this.xRay = xRay;
        this.scene = scene;
        this.camera = camera;
        this.renderTargetMask = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1);
        this.renderTargetMask.samples = multisampling;
        this.renderTargetMask.texture.name = "Outline.Mask";
        this.uniforms.get("maskTexture").value = this.renderTargetMask.texture;
        this.renderTargetOutline = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetOutline.texture.name = "Outline.Edges";
        this.uniforms.get("edgeTexture").value = this.renderTargetOutline.texture;
        this.clearPass = new $2046da3312f94030$export$fc4180e277a6a0c2();
        this.clearPass.overrideClearColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0);
        this.clearPass.overrideClearAlpha = 1;
        this.depthPass = new $2046da3312f94030$export$4059e0d5f564fa1(scene, camera);
        this.maskPass = new $2046da3312f94030$export$f63ea822f020b5b0(scene, camera, new $2046da3312f94030$export$36b10598ef35408b(this.depthPass.texture, camera));
        const clearPass = this.maskPass.clearPass;
        clearPass.overrideClearColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(16777215);
        clearPass.overrideClearAlpha = 1;
        this.blurPass = new $2046da3312f94030$export$657273fee9302035({
            resolutionScale: resolutionScale,
            resolutionX: resolutionX,
            resolutionY: resolutionY,
            kernelSize: kernelSize
        });
        this.blurPass.enabled = blur;
        const resolution = this.blurPass.resolution;
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.outlinePass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$f17d9235adad998c());
        const outlineMaterial = this.outlinePass.fullscreenMaterial;
        outlineMaterial.inputBuffer = this.renderTargetMask.texture;
        this.time = 0;
        this.forceUpdate = true;
        this.selection = new $2046da3312f94030$export$52baac22726c72bf();
        this.pulseSpeed = pulseSpeed;
    }
    set mainScene(value) {
        this.scene = value;
        this.depthPass.mainScene = value;
        this.maskPass.mainScene = value;
    }
    set mainCamera(value) {
        this.camera = value;
        this.depthPass.mainCamera = value;
        this.maskPass.mainCamera = value;
        this.maskPass.overrideMaterial.copyCameraSettings(value);
    }
    /**
   * The resolution of this effect.
   *
   * @type {Resolution}
   */ get resolution() {
        return this.blurPass.resolution;
    }
    /**
   * Returns the resolution.
   *
   * @return {Resizer} The resolution.
   */ getResolution() {
        return this.blurPass.getResolution();
    }
    /**
   * The amount of MSAA samples.
   *
   * Requires WebGL 2. Set to zero to disable multisampling.
   *
   * @experimental Requires three >= r138.
   * @type {Number}
   */ get multisampling() {
        return this.renderTargetMask.samples;
    }
    set multisampling(value) {
        this.renderTargetMask.samples = value;
        this.renderTargetMask.dispose();
    }
    /**
   * The pattern scale.
   *
   * @type {Number}
   */ get patternScale() {
        return this.uniforms.get("patternScale").value;
    }
    set patternScale(value) {
        this.uniforms.get("patternScale").value = value;
    }
    /**
   * The edge strength.
   *
   * @type {Number}
   */ get edgeStrength() {
        return this.uniforms.get("edgeStrength").value;
    }
    set edgeStrength(value) {
        this.uniforms.get("edgeStrength").value = value;
    }
    /**
   * The visible edge color.
   *
   * @type {Color}
   */ get visibleEdgeColor() {
        return this.uniforms.get("visibleEdgeColor").value;
    }
    set visibleEdgeColor(value) {
        this.uniforms.get("visibleEdgeColor").value = value;
    }
    /**
   * The hidden edge color.
   *
   * @type {Color}
   */ get hiddenEdgeColor() {
        return this.uniforms.get("hiddenEdgeColor").value;
    }
    set hiddenEdgeColor(value) {
        this.uniforms.get("hiddenEdgeColor").value = value;
    }
    /**
   * Returns the blur pass.
   *
   * @deprecated Use blurPass instead.
   * @return {KawaseBlurPass} The blur pass.
   */ getBlurPass() {
        return this.blurPass;
    }
    /**
   * Returns the selection.
   *
   * @deprecated Use selection instead.
   * @return {Selection} The selection.
   */ getSelection() {
        return this.selection;
    }
    /**
   * Returns the pulse speed.
   *
   * @deprecated Use pulseSpeed instead.
   * @return {Number} The speed.
   */ getPulseSpeed() {
        return this.pulseSpeed;
    }
    /**
   * Sets the pulse speed. Set to zero to disable.
   *
   * @deprecated Use pulseSpeed instead.
   * @param {Number} value - The speed.
   */ setPulseSpeed(value) {
        this.pulseSpeed = value;
    }
    /**
   * The current width of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.width instead.
   */ get width() {
        return this.resolution.width;
    }
    set width(value) {
        this.resolution.preferredWidth = value;
    }
    /**
   * The current height of the internal render targets.
   *
   * @type {Number}
   * @deprecated Use resolution.height instead.
   */ get height() {
        return this.resolution.height;
    }
    set height(value) {
        this.resolution.preferredHeight = value;
    }
    /**
   * The selection layer.
   *
   * @type {Number}
   * @deprecated Use selection.layer instead.
   */ get selectionLayer() {
        return this.selection.layer;
    }
    set selectionLayer(value) {
        this.selection.layer = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get dithering() {
        return this.blurPass.dithering;
    }
    set dithering(value) {
        this.blurPass.dithering = value;
    }
    /**
   * The blur kernel size.
   *
   * @type {KernelSize}
   * @deprecated Use blurPass.kernelSize instead.
   */ get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(value) {
        this.blurPass.kernelSize = value;
    }
    /**
   * Indicates whether the outlines should be blurred.
   *
   * @type {Boolean}
   * @deprecated Use blurPass.enabled instead.
   */ get blur() {
        return this.blurPass.enabled;
    }
    set blur(value) {
        this.blurPass.enabled = value;
    }
    /**
   * Indicates whether X-ray mode is enabled.
   *
   * @type {Boolean}
   */ get xRay() {
        return this.defines.has("X_RAY");
    }
    set xRay(value) {
        if (this.xRay !== value) {
            if (value) this.defines.set("X_RAY", "1");
            else this.defines.delete("X_RAY");
            this.setChanged();
        }
    }
    /**
   * Indicates whether X-ray mode is enabled.
   *
   * @deprecated Use xRay instead.
   * @return {Boolean} Whether X-ray mode is enabled.
   */ isXRayEnabled() {
        return this.xRay;
    }
    /**
   * Enables or disables X-ray outlines.
   *
   * @deprecated Use xRay instead.
   * @param {Boolean} value - Whether X-ray should be enabled.
   */ setXRayEnabled(value) {
        this.xRay = value;
    }
    /**
   * The pattern texture. Set to `null` to disable.
   *
   * @type {Texture}
   */ get patternTexture() {
        return this.uniforms.get("patternTexture").value;
    }
    set patternTexture(value) {
        if (value !== null) {
            value.wrapS = value.wrapT = (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5);
            this.defines.set("USE_PATTERN", "1");
            this.setVertexShader($2046da3312f94030$var$outline_default4);
        } else {
            this.defines.delete("USE_PATTERN");
            this.setVertexShader(null);
        }
        this.uniforms.get("patternTexture").value = value;
        this.setChanged();
    }
    /**
   * Sets the pattern texture.
   *
   * @deprecated Use patternTexture instead.
   * @param {Texture} value - The new texture.
   */ setPatternTexture(value) {
        this.patternTexture = value;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Clears the current selection and selects a list of objects.
   *
   * @param {Object3D[]} objects - The objects that should be outlined. This array will be copied.
   * @return {OutlinePass} This pass.
   * @deprecated Use selection.set() instead.
   */ setSelection(objects) {
        this.selection.set(objects);
        return this;
    }
    /**
   * Clears the list of selected objects.
   *
   * @return {OutlinePass} This pass.
   * @deprecated Use selection.clear() instead.
   */ clearSelection() {
        this.selection.clear();
        return this;
    }
    /**
   * Selects an object.
   *
   * @param {Object3D} object - The object that should be outlined.
   * @return {OutlinePass} This pass.
   * @deprecated Use selection.add() instead.
   */ selectObject(object) {
        this.selection.add(object);
        return this;
    }
    /**
   * Deselects an object.
   *
   * @param {Object3D} object - The object that should no longer be outlined.
   * @return {OutlinePass} This pass.
   * @deprecated Use selection.delete() instead.
   */ deselectObject(object) {
        this.selection.delete(object);
        return this;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const scene = this.scene;
        const camera = this.camera;
        const selection = this.selection;
        const uniforms = this.uniforms;
        const pulse = uniforms.get("pulse");
        const background = scene.background;
        const mask = camera.layers.mask;
        if (this.forceUpdate || selection.size > 0) {
            scene.background = null;
            pulse.value = 1;
            if (this.pulseSpeed > 0) pulse.value = Math.cos(this.time * this.pulseSpeed * 10) * 0.375 + 0.625;
            this.time += deltaTime;
            selection.setVisible(false);
            this.depthPass.render(renderer);
            selection.setVisible(true);
            camera.layers.set(selection.layer);
            this.maskPass.render(renderer, this.renderTargetMask);
            camera.layers.mask = mask;
            scene.background = background;
            this.outlinePass.render(renderer, null, this.renderTargetOutline);
            if (this.blurPass.enabled) this.blurPass.render(renderer, this.renderTargetOutline, this.renderTargetOutline);
        }
        this.forceUpdate = selection.size > 0;
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.blurPass.setSize(width, height);
        this.renderTargetMask.setSize(width, height);
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.depthPass.setSize(w, h);
        this.renderTargetOutline.setSize(w, h);
        this.outlinePass.fullscreenMaterial.setSize(w, h);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.blurPass.initialize(renderer, alpha, (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10));
        if (frameBufferType !== void 0) {
            this.depthPass.initialize(renderer, alpha, frameBufferType);
            this.maskPass.initialize(renderer, alpha, frameBufferType);
            this.outlinePass.initialize(renderer, alpha, frameBufferType);
        }
    }
};
// src/effects/glsl/pixelation.frag
var $2046da3312f94030$var$pixelation_default = `uniform bool active;uniform vec4 d;void mainUv(inout vec2 uv){if(active){uv=d.xy*(floor(uv*d.zw)+0.5);}}`;
// src/effects/PixelationEffect.js
var $2046da3312f94030$export$be408d53e0133e76 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new pixelation effect.
   *
   * @param {Object} [granularity=30.0] - The pixel granularity.
   */ constructor(granularity = 30){
        super("PixelationEffect", $2046da3312f94030$var$pixelation_default, {
            uniforms: /* @__PURE__ */ new Map([
                [
                    "active",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(false)
                ],
                [
                    "d",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)())
                ]
            ])
        });
        this.resolution = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        this._granularity = 0;
        this.granularity = granularity;
    }
    /**
   * The pixel granularity.
   *
   * A higher value yields coarser visuals.
   *
   * @type {Number}
   */ get granularity() {
        return this._granularity;
    }
    set granularity(value) {
        let d = Math.floor(value);
        if (d % 2 > 0) d += 1;
        this._granularity = d;
        this.uniforms.get("active").value = d > 0;
        this.setSize(this.resolution.width, this.resolution.height);
    }
    /**
   * Returns the pixel granularity.
   *
   * @deprecated Use granularity instead.
   * @return {Number} The granularity.
   */ getGranularity() {
        return this.granularity;
    }
    /**
   * Sets the pixel granularity.
   *
   * @deprecated Use granularity instead.
   * @param {Number} value - The new granularity.
   */ setGranularity(value) {
        this.granularity = value;
    }
    /**
   * Updates the granularity.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.set(width, height);
        const d = this.granularity;
        const x = d / resolution.x;
        const y = d / resolution.y;
        this.uniforms.get("d").value.set(x, y, 1 / x, 1 / y);
    }
};
// src/effects/glsl/realistic-bokeh.frag
var $2046da3312f94030$var$realistic_bokeh_default = `uniform float focus;uniform float focalLength;uniform float fStop;uniform float maxBlur;uniform float luminanceThreshold;uniform float luminanceGain;uniform float bias;uniform float fringe;
#ifdef MANUAL_DOF
uniform vec4 dof;
#endif
#ifdef PENTAGON
float pentagon(const in vec2 coords){const vec4 HS0=vec4(1.0,0.0,0.0,1.0);const vec4 HS1=vec4(0.309016994,0.951056516,0.0,1.0);const vec4 HS2=vec4(-0.809016994,0.587785252,0.0,1.0);const vec4 HS3=vec4(-0.809016994,-0.587785252,0.0,1.0);const vec4 HS4=vec4(0.309016994,-0.951056516,0.0,1.0);const vec4 HS5=vec4(0.0,0.0,1.0,1.0);const vec4 ONE=vec4(1.0);const float P_FEATHER=0.4;const float N_FEATHER=-P_FEATHER;float inOrOut=-4.0;vec4 P=vec4(coords,vec2(RINGS_FLOAT-1.3));vec4 dist=vec4(dot(P,HS0),dot(P,HS1),dot(P,HS2),dot(P,HS3));dist=smoothstep(N_FEATHER,P_FEATHER,dist);inOrOut+=dot(dist,ONE);dist.x=dot(P,HS4);dist.y=HS5.w-abs(P.z);dist=smoothstep(N_FEATHER,P_FEATHER,dist);inOrOut+=dist.x;return clamp(inOrOut,0.0,1.0);}
#endif
vec3 processTexel(const in vec2 coords,const in float blur){vec2 scale=texelSize*fringe*blur;vec3 c=vec3(texture2D(inputBuffer,coords+vec2(0.0,1.0)*scale).r,texture2D(inputBuffer,coords+vec2(-0.866,-0.5)*scale).g,texture2D(inputBuffer,coords+vec2(0.866,-0.5)*scale).b);float luminance=linearToRelativeLuminance(c);float threshold=max((luminance-luminanceThreshold)*luminanceGain,0.0);return c+mix(vec3(0.0),c,threshold*blur);}float gather(const in float i,const in float j,const in float ringSamples,const in vec2 uv,const in vec2 blurFactor,const in float blur,inout vec3 color){float step=PI2/ringSamples;vec2 wh=vec2(cos(j*step)*i,sin(j*step)*i);
#ifdef PENTAGON
float p=pentagon(wh);
#else
float p=1.0;
#endif
color+=processTexel(wh*blurFactor+uv,blur)*mix(1.0,i/RINGS_FLOAT,bias)*p;return mix(1.0,i/RINGS_FLOAT,bias)*p;}void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){
#ifdef PERSPECTIVE_CAMERA
float viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);
#else
float linearDepth=depth;
#endif
#ifdef MANUAL_DOF
float focalPlane=linearDepth-focus;float farDoF=(focalPlane-dof.z)/dof.w;float nearDoF=(-focalPlane-dof.x)/dof.y;float blur=(focalPlane>0.0)?farDoF:nearDoF;
#else
const float CIRCLE_OF_CONFUSION=0.03;float focalPlaneMM=focus*1000.0;float depthMM=linearDepth*1000.0;float focalPlane=(depthMM*focalLength)/(depthMM-focalLength);float farDoF=(focalPlaneMM*focalLength)/(focalPlaneMM-focalLength);float nearDoF=(focalPlaneMM-focalLength)/(focalPlaneMM*fStop*CIRCLE_OF_CONFUSION);float blur=abs(focalPlane-farDoF)*nearDoF;
#endif
const int MAX_RING_SAMPLES=RINGS_INT*SAMPLES_INT;blur=clamp(blur,0.0,1.0);vec3 color=inputColor.rgb;if(blur>=0.05){vec2 blurFactor=blur*maxBlur*texelSize;float s=1.0;int ringSamples;for(int i=1;i<=RINGS_INT;i++){ringSamples=i*SAMPLES_INT;for(int j=0;j<MAX_RING_SAMPLES;j++){if(j>=ringSamples){break;}s+=gather(float(i),float(j),float(ringSamples),uv,blurFactor,blur,color);}}color/=s;}
#ifdef SHOW_FOCUS
float edge=0.002*linearDepth;float m=clamp(smoothstep(0.0,edge,blur),0.0,1.0);float e=clamp(smoothstep(1.0-edge,1.0,blur),0.0,1.0);color=mix(color,vec3(1.0,0.5,0.0),(1.0-m)*0.6);color=mix(color,vec3(0.0,0.5,1.0),((1.0-e)-(1.0-m))*0.2);
#endif
outputColor=vec4(color,inputColor.a);}`;
// src/effects/RealisticBokehEffect.js
var $2046da3312f94030$export$bae36a32c5d14266 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new bokeh effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.focus=1.0] - The focus distance in world units.
   * @param {Number} [options.focalLength=24.0] - The focal length of the main camera.
   * @param {Number} [options.fStop=0.9] - The ratio of the lens focal length to the diameter of the entrance pupil (aperture).
   * @param {Number} [options.luminanceThreshold=0.5] - A luminance threshold.
   * @param {Number} [options.luminanceGain=2.0] - A luminance gain factor.
   * @param {Number} [options.bias=0.5] - A blur bias.
   * @param {Number} [options.fringe=0.7] - A blur offset.
   * @param {Number} [options.maxBlur=1.0] - The maximum blur strength.
   * @param {Boolean} [options.rings=3] - The number of blur iterations.
   * @param {Boolean} [options.samples=2] - The amount of samples taken per ring.
   * @param {Boolean} [options.showFocus=false] - Whether the focal point should be highlighted. Useful for debugging.
   * @param {Boolean} [options.manualDoF=false] - Enables manual control over the depth of field.
   * @param {Boolean} [options.pentagon=false] - Enables pentagonal blur shapes. Requires a high number of rings and samples.
   */ constructor({ blendFunction: blendFunction, focus: focus = 1, focalLength: focalLength = 24, fStop: fStop = 0.9, luminanceThreshold: luminanceThreshold = 0.5, luminanceGain: luminanceGain = 2, bias: bias = 0.5, fringe: fringe = 0.7, maxBlur: maxBlur = 1, rings: rings = 3, samples: samples = 2, showFocus: showFocus = false, manualDoF: manualDoF = false, pentagon: pentagon = false } = {}){
        super("RealisticBokehEffect", $2046da3312f94030$var$realistic_bokeh_default, {
            blendFunction: blendFunction,
            attributes: $2046da3312f94030$export$a72ebb312f9e05c6.CONVOLUTION | $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "focus",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(focus)
                ],
                [
                    "focalLength",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(focalLength)
                ],
                [
                    "fStop",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(fStop)
                ],
                [
                    "luminanceThreshold",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(luminanceThreshold)
                ],
                [
                    "luminanceGain",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(luminanceGain)
                ],
                [
                    "bias",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(bias)
                ],
                [
                    "fringe",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(fringe)
                ],
                [
                    "maxBlur",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(maxBlur)
                ],
                [
                    "dof",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ]
            ])
        });
        this.rings = rings;
        this.samples = samples;
        this.showFocus = showFocus;
        this.manualDoF = manualDoF;
        this.pentagon = pentagon;
    }
    /**
   * The amount of blur iterations.
   *
   * @type {Number}
   */ get rings() {
        return Number.parseInt(this.defines.get("RINGS_INT"));
    }
    set rings(value) {
        const r = Math.floor(value);
        this.defines.set("RINGS_INT", r.toFixed(0));
        this.defines.set("RINGS_FLOAT", r.toFixed(1));
        this.setChanged();
    }
    /**
   * The amount of blur samples per ring.
   *
   * @type {Number}
   */ get samples() {
        return Number.parseInt(this.defines.get("SAMPLES_INT"));
    }
    set samples(value) {
        const s = Math.floor(value);
        this.defines.set("SAMPLES_INT", s.toFixed(0));
        this.defines.set("SAMPLES_FLOAT", s.toFixed(1));
        this.setChanged();
    }
    /**
   * Indicates whether the focal point will be highlighted.
   *
   * @type {Boolean}
   */ get showFocus() {
        return this.defines.has("SHOW_FOCUS");
    }
    set showFocus(value) {
        if (this.showFocus !== value) {
            if (value) this.defines.set("SHOW_FOCUS", "1");
            else this.defines.delete("SHOW_FOCUS");
            this.setChanged();
        }
    }
    /**
   * Indicates whether the Depth of Field should be calculated manually.
   *
   * If enabled, the Depth of Field can be adjusted via the `dof` uniform.
   *
   * @type {Boolean}
   */ get manualDoF() {
        return this.defines.has("MANUAL_DOF");
    }
    set manualDoF(value) {
        if (this.manualDoF !== value) {
            if (value) {
                this.defines.set("MANUAL_DOF", "1");
                this.uniforms.get("dof").value = new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)(0.2, 1, 0.2, 2);
            } else {
                this.defines.delete("MANUAL_DOF");
                this.uniforms.get("dof").value = null;
            }
            this.setChanged();
        }
    }
    /**
   * Indicates whether the blur shape should be pentagonal.
   *
   * @type {Boolean}
   */ get pentagon() {
        return this.defines.has("PENTAGON");
    }
    set pentagon(value) {
        if (this.pentagon !== value) {
            if (value) this.defines.set("PENTAGON", "1");
            else this.defines.delete("PENTAGON");
            this.setChanged();
        }
    }
};
// src/effects/glsl/scanlines.frag
var $2046da3312f94030$var$scanlines_default = `uniform float count;
#ifdef SCROLL
uniform float scrollSpeed;
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){float y=uv.y;
#ifdef SCROLL
y+=time*scrollSpeed;
#endif
vec2 sl=vec2(sin(y*count),cos(y*count));outputColor=vec4(sl.xyx,inputColor.a);}`;
// src/effects/ScanlineEffect.js
var $2046da3312f94030$export$375e89395e3a5238 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new scanline effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.OVERLAY] - The blend function of this effect.
   * @param {Number} [options.density=1.25] - The scanline density.
   * @param {Number} [options.scrollSpeed=0.0] - The scanline scroll speed.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.OVERLAY, density: density = 1.25, scrollSpeed: scrollSpeed = 0 } = {}){
        super("ScanlineEffect", $2046da3312f94030$var$scanlines_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "count",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0)
                ],
                [
                    "scrollSpeed",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0)
                ]
            ])
        });
        this.resolution = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        this.d = density;
        this.scrollSpeed = scrollSpeed;
    }
    /**
   * The scanline density.
   *
   * @type {Number}
   */ get density() {
        return this.d;
    }
    set density(value) {
        this.d = value;
        this.setSize(this.resolution.width, this.resolution.height);
    }
    /**
   * Returns the current scanline density.
   *
   * @deprecated Use density instead.
   * @return {Number} The scanline density.
   */ getDensity() {
        return this.density;
    }
    /**
   * Sets the scanline density.
   *
   * @deprecated Use density instead.
   * @param {Number} value - The new scanline density.
   */ setDensity(value) {
        this.density = value;
    }
    /**
   * The scanline scroll speed. Default is 0 (disabled).
   *
   * @type {Number}
   */ get scrollSpeed() {
        return this.uniforms.get("scrollSpeed").value;
    }
    set scrollSpeed(value) {
        this.uniforms.get("scrollSpeed").value = value;
        if (value === 0) {
            if (this.defines.delete("SCROLL")) this.setChanged();
        } else if (!this.defines.has("SCROLL")) {
            this.defines.set("SCROLL", "1");
            this.setChanged();
        }
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.resolution.set(width, height);
        this.uniforms.get("count").value = Math.round(height * this.density);
    }
};
// src/effects/glsl/shock-wave.frag
var $2046da3312f94030$var$shock_wave_default = `uniform bool active;uniform vec2 center;uniform float waveSize;uniform float radius;uniform float maxRadius;uniform float amplitude;varying float vSize;void mainUv(inout vec2 uv){if(active){vec2 aspectCorrection=vec2(aspect,1.0);vec2 difference=uv*aspectCorrection-center*aspectCorrection;float distance=sqrt(dot(difference,difference))*vSize;if(distance>radius){if(distance<radius+waveSize){float angle=(distance-radius)*PI2/waveSize;float cosSin=(1.0-cos(angle))*0.5;float extent=maxRadius+waveSize;float decay=max(extent-distance*distance,0.0)/extent;uv-=((cosSin*amplitude*difference)/distance)*decay;}}}}`;
// src/effects/glsl/shock-wave.vert
var $2046da3312f94030$var$shock_wave_default2 = `uniform float size;uniform float cameraDistance;varying float vSize;void mainSupport(){vSize=(0.1*cameraDistance)/size;}`;
// src/effects/ShockWaveEffect.js
var $2046da3312f94030$var$HALF_PI = Math.PI * 0.5;
var $2046da3312f94030$var$v3 = /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
var $2046da3312f94030$var$ab = /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
var $2046da3312f94030$export$678e91125a3dcb0c = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new shock wave effect.
   *
   * @param {Camera} camera - The main camera.
   * @param {Vector3} [position] - The world position of the shock wave.
   * @param {Object} [options] - The options.
   * @param {Number} [options.speed=2.0] - The animation speed.
   * @param {Number} [options.maxRadius=1.0] - The extent of the shock wave.
   * @param {Number} [options.waveSize=0.2] - The wave size.
   * @param {Number} [options.amplitude=0.05] - The distortion amplitude.
   */ constructor(camera, position = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(), { speed: speed = 2, maxRadius: maxRadius = 1, waveSize: waveSize = 0.2, amplitude: amplitude = 0.05 } = {}){
        super("ShockWaveEffect", $2046da3312f94030$var$shock_wave_default, {
            vertexShader: $2046da3312f94030$var$shock_wave_default2,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "active",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(false)
                ],
                [
                    "center",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(0.5, 0.5))
                ],
                [
                    "cameraDistance",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
                ],
                [
                    "size",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
                ],
                [
                    "radius",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(-waveSize)
                ],
                [
                    "maxRadius",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(maxRadius)
                ],
                [
                    "waveSize",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(waveSize)
                ],
                [
                    "amplitude",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(amplitude)
                ]
            ])
        });
        this.position = position;
        this.speed = speed;
        this.camera = camera;
        this.screenPosition = this.uniforms.get("center").value;
        this.time = 0;
        this.active = false;
    }
    set mainCamera(value) {
        this.camera = value;
    }
    /**
   * The amplitude.
   *
   * @type {Number}
   */ get amplitude() {
        return this.uniforms.get("amplitude").value;
    }
    set amplitude(value) {
        this.uniforms.get("amplitude").value = value;
    }
    /**
   * The wave size.
   *
   * @type {Number}
   */ get waveSize() {
        return this.uniforms.get("waveSize").value;
    }
    set waveSize(value) {
        this.uniforms.get("waveSize").value = value;
    }
    /**
   * The maximum radius.
   *
   * @type {Number}
   */ get maxRadius() {
        return this.uniforms.get("maxRadius").value;
    }
    set maxRadius(value) {
        this.uniforms.get("maxRadius").value = value;
    }
    /**
   * The position of the shock wave.
   *
   * @type {Vector3}
   * @deprecated Use position instead.
   */ get epicenter() {
        return this.position;
    }
    set epicenter(value) {
        this.position = value;
    }
    /**
   * Returns the position of the shock wave.
   *
   * @deprecated Use position instead.
   * @return {Vector3} The position.
   */ getPosition() {
        return this.position;
    }
    /**
   * Sets the position of the shock wave.
   *
   * @deprecated Use position instead.
   * @param {Vector3} value - The position.
   */ setPosition(value) {
        this.position = value;
    }
    /**
   * Returns the speed of the shock wave.
   *
   * @deprecated Use speed instead.
   * @return {Number} The speed.
   */ getSpeed() {
        return this.speed;
    }
    /**
   * Sets the speed of the shock wave.
   *
   * @deprecated Use speed instead.
   * @param {Number} value - The speed.
   */ setSpeed(value) {
        this.speed = value;
    }
    /**
   * Emits the shock wave.
   */ explode() {
        this.time = 0;
        this.active = true;
        this.uniforms.get("active").value = true;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [delta] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, delta) {
        const position = this.position;
        const camera = this.camera;
        const uniforms = this.uniforms;
        const uActive = uniforms.get("active");
        if (this.active) {
            const waveSize = uniforms.get("waveSize").value;
            camera.getWorldDirection($2046da3312f94030$var$v3);
            $2046da3312f94030$var$ab.copy(camera.position).sub(position);
            uActive.value = $2046da3312f94030$var$v3.angleTo($2046da3312f94030$var$ab) > $2046da3312f94030$var$HALF_PI;
            if (uActive.value) {
                uniforms.get("cameraDistance").value = camera.position.distanceTo(position);
                $2046da3312f94030$var$v3.copy(position).project(camera);
                this.screenPosition.set(($2046da3312f94030$var$v3.x + 1) * 0.5, ($2046da3312f94030$var$v3.y + 1) * 0.5);
            }
            this.time += delta * this.speed;
            const radius = this.time - waveSize;
            uniforms.get("radius").value = radius;
            if (radius >= (uniforms.get("maxRadius").value + waveSize) * 2) {
                this.active = false;
                uActive.value = false;
            }
        }
    }
};
// src/materials/glsl/depth-mask.frag
var $2046da3312f94030$var$depth_mask_default = `#include <common>
#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer0;uniform highp sampler2D depthBuffer1;
#else
uniform mediump sampler2D depthBuffer0;uniform mediump sampler2D depthBuffer1;
#endif
uniform sampler2D inputBuffer;uniform vec2 cameraNearFar;float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);
#else
return orthographicDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);
#endif
}varying vec2 vUv;void main(){vec2 depth;
#if DEPTH_PACKING_0 == 3201
depth.x=unpackRGBAToDepth(texture2D(depthBuffer0,vUv));
#else
depth.x=texture2D(depthBuffer0,vUv).r;
#endif
#if DEPTH_PACKING_1 == 3201
depth.y=unpackRGBAToDepth(texture2D(depthBuffer1,vUv));
#else
depth.y=texture2D(depthBuffer1,vUv).r;
#endif
#if defined(USE_LOGARITHMIC_DEPTH_BUFFER) || defined(LOG_DEPTH)
float a=cameraNearFar.y/(cameraNearFar.y-cameraNearFar.x);float b=cameraNearFar.y*cameraNearFar.x/(cameraNearFar.x-cameraNearFar.y);float c=log2(cameraNearFar.y+1.0);float d=pow(2.0,depth.x*c)-1.0;depth.x=a+b/d;d=pow(2.0,depth.y*c)-1.0;depth.y=a+b/d;
#elif defined(USE_REVERSED_DEPTH_BUFFER)
depth.x=1.0-depth.x;depth.y=1.0-depth.y;
#endif
bool isMaxDepth=(depth.x==1.0);
#ifdef PERSPECTIVE_CAMERA
depth.x=viewZToOrthographicDepth(getViewZ(depth.x),cameraNearFar.x,cameraNearFar.y);depth.y=viewZToOrthographicDepth(getViewZ(depth.y),cameraNearFar.x,cameraNearFar.y);
#endif
#if DEPTH_TEST_STRATEGY == 0
bool keep=depthTest(depth.x,depth.y);
#elif DEPTH_TEST_STRATEGY == 1
bool keep=isMaxDepth||depthTest(depth.x,depth.y);
#else
bool keep=!isMaxDepth&&depthTest(depth.x,depth.y);
#endif
if(keep){gl_FragColor=texture2D(inputBuffer,vUv);}else{discard;}}`;
// src/materials/DepthMaskMaterial.js
var $2046da3312f94030$export$fe1d84eaa823805a = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new depth mask material.
   */ constructor(){
        super({
            name: "DepthMaskMaterial",
            defines: {
                DEPTH_EPSILON: "0.0001",
                DEPTH_PACKING_0: "0",
                DEPTH_PACKING_1: "0",
                DEPTH_TEST_STRATEGY: $2046da3312f94030$export$a11e355d280abe13.KEEP_MAX_DEPTH
            },
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                depthBuffer0: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                depthBuffer1: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                cameraNearFar: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(1, 1))
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$depth_mask_default,
            vertexShader: $2046da3312f94030$var$common_default
        });
        this.depthMode = (0, $ce0cdebec9150cb3$export$eedccec66ab7ebe);
    }
    /**
   * The primary depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer0(value) {
        this.uniforms.depthBuffer0.value = value;
    }
    /**
   * The primary depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking0(value) {
        this.defines.DEPTH_PACKING_0 = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the base depth buffer.
   *
   * @deprecated Use depthBuffer0 and depthPacking0 instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer0(buffer, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthBuffer0 = buffer;
        this.depthPacking0 = depthPacking;
    }
    /**
   * The secondary depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer1(value) {
        this.uniforms.depthBuffer1.value = value;
    }
    /**
   * The secondary depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking1(value) {
        this.defines.DEPTH_PACKING_1 = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer that will be compared with the base depth buffer.
   *
   * @deprecated Use depthBuffer1 and depthPacking1 instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer1(buffer, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthBuffer1 = buffer;
        this.depthPacking1 = depthPacking;
    }
    /**
   * The strategy for handling maximum depth.
   *
   * @type {DepthTestStrategy}
   */ get maxDepthStrategy() {
        return Number(this.defines.DEPTH_TEST_STRATEGY);
    }
    set maxDepthStrategy(value) {
        this.defines.DEPTH_TEST_STRATEGY = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Indicates whether maximum depth values should be preserved.
   *
   * @type {Boolean}
   * @deprecated Use maxDepthStrategy instead.
   */ get keepFar() {
        return this.maxDepthStrategy;
    }
    set keepFar(value) {
        this.maxDepthStrategy = value ? $2046da3312f94030$export$a11e355d280abe13.KEEP_MAX_DEPTH : $2046da3312f94030$export$a11e355d280abe13.DISCARD_MAX_DEPTH;
    }
    /**
   * Returns the strategy for dealing with maximum depth values.
   *
   * @deprecated Use maxDepthStrategy instead.
   * @return {DepthTestStrategy} The strategy.
   */ getMaxDepthStrategy() {
        return this.maxDepthStrategy;
    }
    /**
   * Sets the strategy for dealing with maximum depth values.
   *
   * @deprecated Use maxDepthStrategy instead.
   * @param {DepthTestStrategy} value - The strategy.
   */ setMaxDepthStrategy(value) {
        this.maxDepthStrategy = value;
    }
    /**
   * A small error threshold that is used for `EqualDepth` and `NotEqualDepth` tests. Default is `1e-4`.
   *
   * @type {Number}
   */ get epsilon() {
        return Number(this.defines.DEPTH_EPSILON);
    }
    set epsilon(value) {
        this.defines.DEPTH_EPSILON = value.toFixed(16);
        this.needsUpdate = true;
    }
    /**
   * Returns the current error threshold for depth comparisons.
   *
   * @deprecated Use epsilon instead.
   * @return {Number} The error threshold.
   */ getEpsilon() {
        return this.epsilon;
    }
    /**
   * Sets the depth comparison error threshold.
   *
   * @deprecated Use epsilon instead.
   * @param {Number} value - The new error threshold.
   */ setEpsilon(value) {
        this.epsilon = value;
    }
    /**
   * The depth mode.
   *
   * @see https://threejs.org/docs/#api/en/constants/Materials
   * @type {DepthModes}
   */ get depthMode() {
        return Number(this.defines.DEPTH_MODE);
    }
    set depthMode(value) {
        let depthTest;
        switch(value){
            case 0, $ce0cdebec9150cb3$export$69025ce147cee220:
                depthTest = "false";
                break;
            case 0, $ce0cdebec9150cb3$export$7182eb52ea3b3f04:
                depthTest = "true";
                break;
            case 0, $ce0cdebec9150cb3$export$a60d398fc7b7590e:
                depthTest = "abs(d1 - d0) <= DEPTH_EPSILON";
                break;
            case 0, $ce0cdebec9150cb3$export$2f843afa843d8916:
                depthTest = "abs(d1 - d0) > DEPTH_EPSILON";
                break;
            case 0, $ce0cdebec9150cb3$export$eedccec66ab7ebe:
                depthTest = "d0 > d1";
                break;
            case 0, $ce0cdebec9150cb3$export$296f78a0b892f81a:
                depthTest = "d0 >= d1";
                break;
            case 0, $ce0cdebec9150cb3$export$7d7234c1240a1fc4:
                depthTest = "d0 <= d1";
                break;
            case 0, $ce0cdebec9150cb3$export$c5e2c52991f30937:
            default:
                depthTest = "d0 < d1";
                break;
        }
        this.defines.DEPTH_MODE = value.toFixed(0);
        this.defines["depthTest(d0, d1)"] = depthTest;
        this.needsUpdate = true;
    }
    /**
   * Returns the current depth mode.
   *
   * @deprecated Use depthMode instead.
   * @return {DepthModes} The depth mode. Default is `LessDepth`.
   */ getDepthMode() {
        return this.depthMode;
    }
    /**
   * Sets the depth mode.
   *
   * @deprecated Use depthMode instead.
   * @param {DepthModes} mode - The depth mode.
   */ setDepthMode(mode) {
        this.depthMode = mode;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNearFar.value.set(camera.near, camera.far);
            if (camera instanceof (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
};
// src/effects/SelectiveBloomEffect.js
var $2046da3312f94030$export$6588cb38f2a0e4fe = class extends $2046da3312f94030$export$1e2a1743038c77d5 {
    /**
   * Constructs a new selective bloom effect.
   *
   * @param {Scene} scene - The main scene.
   * @param {Camera} camera - The main camera.
   * @param {Object} [options] - The options. See {@link BloomEffect} for details.
   */ constructor(scene, camera, options){
        super(options);
        this.setAttributes(this.getAttributes() | $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH);
        this.camera = camera;
        this.depthPass = new $2046da3312f94030$export$4059e0d5f564fa1(scene, camera);
        this.clearPass = new $2046da3312f94030$export$fc4180e277a6a0c2(true, false, false);
        this.clearPass.overrideClearColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0);
        this.depthMaskPass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$fe1d84eaa823805a());
        const depthMaskMaterial = this.depthMaskMaterial;
        depthMaskMaterial.copyCameraSettings(camera);
        depthMaskMaterial.depthBuffer1 = this.depthPass.texture;
        depthMaskMaterial.depthPacking1 = (0, $ce0cdebec9150cb3$export$8f910f4c4f73df11);
        depthMaskMaterial.depthMode = (0, $ce0cdebec9150cb3$export$a60d398fc7b7590e);
        this.renderTargetMasked = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetMasked.texture.name = "Bloom.Masked";
        this.selection = new $2046da3312f94030$export$52baac22726c72bf();
        this._inverted = false;
        this._ignoreBackground = false;
    }
    set mainScene(value) {
        this.depthPass.mainScene = value;
    }
    set mainCamera(value) {
        this.camera = value;
        this.depthPass.mainCamera = value;
        this.depthMaskMaterial.copyCameraSettings(value);
    }
    /**
   * Returns the selection.
   *
   * @deprecated Use selection instead.
   * @return {Selection} The selection.
   */ getSelection() {
        return this.selection;
    }
    /**
   * The depth mask material.
   *
   * @type {DepthMaskMaterial}
   * @private
   */ get depthMaskMaterial() {
        return this.depthMaskPass.fullscreenMaterial;
    }
    /**
   * Indicates whether the selection should be considered inverted.
   *
   * @type {Boolean}
   */ get inverted() {
        return this._inverted;
    }
    set inverted(value) {
        this._inverted = value;
        this.depthMaskMaterial.depthMode = value ? (0, $ce0cdebec9150cb3$export$2f843afa843d8916) : (0, $ce0cdebec9150cb3$export$a60d398fc7b7590e);
    }
    /**
   * Indicates whether the mask is inverted.
   *
   * @deprecated Use inverted instead.
   * @return {Boolean} Whether the mask is inverted.
   */ isInverted() {
        return this.inverted;
    }
    /**
   * Enables or disable mask inversion.
   *
   * @deprecated Use inverted instead.
   * @param {Boolean} value - Whether the mask should be inverted.
   */ setInverted(value) {
        this.inverted = value;
    }
    /**
   * Indicates whether the background colors will be ignored.
   *
   * @type {Boolean}
   */ get ignoreBackground() {
        return this._ignoreBackground;
    }
    set ignoreBackground(value) {
        this._ignoreBackground = value;
        this.depthMaskMaterial.maxDepthStrategy = value ? $2046da3312f94030$export$a11e355d280abe13.DISCARD_MAX_DEPTH : $2046da3312f94030$export$a11e355d280abe13.KEEP_MAX_DEPTH;
    }
    /**
   * Indicates whether the background is disabled.
   *
   * @deprecated Use ignoreBackground instead.
   * @return {Boolean} Whether the background is disabled.
   */ isBackgroundDisabled() {
        return this.ignoreBackground;
    }
    /**
   * Enables or disables the background.
   *
   * @deprecated Use ignoreBackground instead.
   * @param {Boolean} value - Whether the background should be disabled.
   */ setBackgroundDisabled(value) {
        this.ignoreBackground = value;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthMaskMaterial.depthBuffer0 = depthTexture;
        this.depthMaskMaterial.depthPacking0 = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const camera = this.camera;
        const selection = this.selection;
        const inverted = this.inverted;
        let renderTarget = inputBuffer;
        if (this.ignoreBackground || !inverted || selection.size > 0) {
            const mask = camera.layers.mask;
            camera.layers.set(selection.layer);
            this.depthPass.render(renderer);
            camera.layers.mask = mask;
            renderTarget = this.renderTargetMasked;
            this.clearPass.render(renderer, renderTarget);
            this.depthMaskPass.render(renderer, inputBuffer, renderTarget);
        }
        super.update(renderer, renderTarget, deltaTime);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        super.setSize(width, height);
        this.renderTargetMasked.setSize(width, height);
        this.depthPass.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        super.initialize(renderer, alpha, frameBufferType);
        this.clearPass.initialize(renderer, alpha, frameBufferType);
        this.depthPass.initialize(renderer, alpha, frameBufferType);
        this.depthMaskPass.initialize(renderer, alpha, frameBufferType);
        if (renderer !== null && renderer.capabilities.logarithmicDepthBuffer) this.depthMaskPass.fullscreenMaterial.defines.LOG_DEPTH = "1";
        if (frameBufferType !== void 0) {
            this.renderTargetMasked.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) this.renderTargetMasked.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
        }
    }
};
// src/effects/glsl/sepia.frag
var $2046da3312f94030$var$sepia_default = `uniform vec3 weightsR;uniform vec3 weightsG;uniform vec3 weightsB;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(dot(inputColor.rgb,weightsR),dot(inputColor.rgb,weightsG),dot(inputColor.rgb,weightsB));outputColor=vec4(color,inputColor.a);}`;
// src/effects/SepiaEffect.js
var $2046da3312f94030$export$c6ab5b20c691455c = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new sepia effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.intensity=1.0] - The intensity of the effect.
   */ constructor({ blendFunction: blendFunction, intensity: intensity = 1 } = {}){
        super("SepiaEffect", $2046da3312f94030$var$sepia_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "weightsR",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0.393, 0.769, 0.189))
                ],
                [
                    "weightsG",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0.349, 0.686, 0.168))
                ],
                [
                    "weightsB",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0.272, 0.534, 0.131))
                ]
            ])
        });
    }
    /**
   * The intensity.
   *
   * @deprecated Use blendMode.opacity instead.
   * @type {Number}
   */ get intensity() {
        return this.blendMode.opacity.value;
    }
    set intensity(value) {
        this.blendMode.opacity.value = value;
    }
    /**
   * Returns the current sepia intensity.
   *
   * @deprecated Use blendMode.opacity instead.
   * @return {Number} The intensity.
   */ getIntensity() {
        return this.intensity;
    }
    /**
   * Sets the sepia intensity.
   *
   * @deprecated Use blendMode.opacity instead.
   * @param {Number} value - The intensity.
   */ setIntensity(value) {
        this.intensity = value;
    }
    /**
   * The weights for the red channel. Default is `(0.393, 0.769, 0.189)`.
   *
   * @type {Vector3}
   */ get weightsR() {
        return this.uniforms.get("weightsR").value;
    }
    /**
   * The weights for the green channel. Default is `(0.349, 0.686, 0.168)`.
   *
   * @type {Vector3}
   */ get weightsG() {
        return this.uniforms.get("weightsG").value;
    }
    /**
   * The weights for the blue channel. Default is `(0.272, 0.534, 0.131)`.
   *
   * @type {Vector3}
   */ get weightsB() {
        return this.uniforms.get("weightsB").value;
    }
};
// src/materials/glsl/edge-detection.frag
var $2046da3312f94030$var$edge_detection_default = `varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
#if EDGE_DETECTION_MODE == 1
#include <common>
#endif
#if EDGE_DETECTION_MODE == 0 || PREDICATION_MODE == 1
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}vec3 gatherNeighbors(){float p=readDepth(vUv);float pLeft=readDepth(vUv0);float pTop=readDepth(vUv1);return vec3(p,pLeft,pTop);}
#elif PREDICATION_MODE == 2
uniform sampler2D predicationBuffer;vec3 gatherNeighbors(){float p=texture2D(predicationBuffer,vUv).r;float pLeft=texture2D(predicationBuffer,vUv0).r;float pTop=texture2D(predicationBuffer,vUv1).r;return vec3(p,pLeft,pTop);}
#endif
#if PREDICATION_MODE != 0
vec2 calculatePredicatedThreshold(){vec3 neighbours=gatherNeighbors();vec2 delta=abs(neighbours.xx-neighbours.yz);vec2 edges=step(PREDICATION_THRESHOLD,delta);return PREDICATION_SCALE*EDGE_THRESHOLD*(1.0-PREDICATION_STRENGTH*edges);}
#endif
#if EDGE_DETECTION_MODE != 0
uniform sampler2D inputBuffer;
#endif
void main(){
#if EDGE_DETECTION_MODE == 0
const vec2 threshold=vec2(DEPTH_THRESHOLD);
#elif PREDICATION_MODE != 0
vec2 threshold=calculatePredicatedThreshold();
#else
const vec2 threshold=vec2(EDGE_THRESHOLD);
#endif
#if EDGE_DETECTION_MODE == 0
vec3 neighbors=gatherNeighbors();vec2 delta=abs(neighbors.xx-vec2(neighbors.y,neighbors.z));vec2 edges=step(threshold,delta);if(dot(edges,vec2(1.0))==0.0){discard;}gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 1
float l=luminance(texture2D(inputBuffer,vUv).rgb);float lLeft=luminance(texture2D(inputBuffer,vUv0).rgb);float lTop=luminance(texture2D(inputBuffer,vUv1).rgb);vec4 delta;delta.xy=abs(l-vec2(lLeft,lTop));vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}float lRight=luminance(texture2D(inputBuffer,vUv2).rgb);float lBottom=luminance(texture2D(inputBuffer,vUv3).rgb);delta.zw=abs(l-vec2(lRight,lBottom));vec2 maxDelta=max(delta.xy,delta.zw);float lLeftLeft=luminance(texture2D(inputBuffer,vUv4).rgb);float lTopTop=luminance(texture2D(inputBuffer,vUv5).rgb);delta.zw=abs(vec2(lLeft,lTop)-vec2(lLeftLeft,lTopTop));maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges.xy*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 2
vec4 delta;vec3 c=texture2D(inputBuffer,vUv).rgb;vec3 cLeft=texture2D(inputBuffer,vUv0).rgb;vec3 t=abs(c-cLeft);delta.x=max(max(t.r,t.g),t.b);vec3 cTop=texture2D(inputBuffer,vUv1).rgb;t=abs(c-cTop);delta.y=max(max(t.r,t.g),t.b);vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}vec3 cRight=texture2D(inputBuffer,vUv2).rgb;t=abs(c-cRight);delta.z=max(max(t.r,t.g),t.b);vec3 cBottom=texture2D(inputBuffer,vUv3).rgb;t=abs(c-cBottom);delta.w=max(max(t.r,t.g),t.b);vec2 maxDelta=max(delta.xy,delta.zw);vec3 cLeftLeft=texture2D(inputBuffer,vUv4).rgb;t=abs(c-cLeftLeft);delta.z=max(max(t.r,t.g),t.b);vec3 cTopTop=texture2D(inputBuffer,vUv5).rgb;t=abs(c-cTopTop);delta.w=max(max(t.r,t.g),t.b);maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#endif
}`;
// src/materials/glsl/edge-detection.vert
var $2046da3312f94030$var$edge_detection_default2 = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,0.0);vUv1=vUv+texelSize*vec2(0.0,-1.0);
#if EDGE_DETECTION_MODE != 0
vUv2=vUv+texelSize*vec2(1.0,0.0);vUv3=vUv+texelSize*vec2(0.0,1.0);vUv4=vUv+texelSize*vec2(-2.0,0.0);vUv5=vUv+texelSize*vec2(0.0,-2.0);
#endif
gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/EdgeDetectionMaterial.js
var $2046da3312f94030$export$a9e4c517bf702b92 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new edge detection material.
   *
   * TODO Remove parameters.
   * @param {Vector2} [texelSize] - The screen texel size.
   * @param {EdgeDetectionMode} [mode=EdgeDetectionMode.COLOR] - The edge detection mode.
   */ constructor(texelSize = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(), mode = $2046da3312f94030$export$20d1071ff7b64a56.COLOR){
        super({
            name: "EdgeDetectionMaterial",
            defines: {
                THREE_REVISION: (0, $ce0cdebec9150cb3$export$3545e07a80636437).replace(/\D+/g, ""),
                LOCAL_CONTRAST_ADAPTATION_FACTOR: "2.0",
                EDGE_THRESHOLD: "0.1",
                DEPTH_THRESHOLD: "0.01",
                PREDICATION_MODE: "0",
                PREDICATION_THRESHOLD: "0.01",
                PREDICATION_SCALE: "2.0",
                PREDICATION_STRENGTH: "1.0",
                DEPTH_PACKING: "0"
            },
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                depthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                predicationBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(texelSize)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$edge_detection_default,
            vertexShader: $2046da3312f94030$var$edge_detection_default2
        });
        this.edgeDetectionMode = mode;
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * The edge detection mode.
   *
   * @type {EdgeDetectionMode}
   */ get edgeDetectionMode() {
        return Number(this.defines.EDGE_DETECTION_MODE);
    }
    set edgeDetectionMode(value) {
        this.defines.EDGE_DETECTION_MODE = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Returns the edge detection mode.
   *
   * @deprecated Use edgeDetectionMode instead.
   * @return {EdgeDetectionMode} The mode.
   */ getEdgeDetectionMode() {
        return this.edgeDetectionMode;
    }
    /**
   * Sets the edge detection mode.
   *
   * @deprecated Use edgeDetectionMode instead.
   * @param {EdgeDetectionMode} value - The edge detection mode.
   */ setEdgeDetectionMode(value) {
        this.edgeDetectionMode = value;
    }
    /**
   * The local contrast adaptation factor. Has no effect if the edge detection mode is set to DEPTH. Default is 2.0.
   *
   * If a neighbor edge has _factor_ times bigger contrast than the current edge, the edge will be discarded.
   *
   * This allows to eliminate spurious crossing edges and is based on the fact that if there is too much contrast in a
   * direction, the perceptual contrast in the other neighbors will be hidden.
   *
   * @type {Number}
   */ get localContrastAdaptationFactor() {
        return Number(this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR);
    }
    set localContrastAdaptationFactor(value) {
        this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR = value.toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the local contrast adaptation factor.
   *
   * @deprecated Use localContrastAdaptationFactor instead.
   * @return {Number} The factor.
   */ getLocalContrastAdaptationFactor() {
        return this.localContrastAdaptationFactor;
    }
    /**
   * Sets the local contrast adaptation factor. Has no effect if the edge detection mode is set to DEPTH.
   *
   * @deprecated Use localContrastAdaptationFactor instead.
   * @param {Number} value - The local contrast adaptation factor. Default is 2.0.
   */ setLocalContrastAdaptationFactor(value) {
        this.localContrastAdaptationFactor = value;
    }
    /**
   * The edge detection threshold. Range: [0.0, 0.5].
   *
   * A lower value results in more edges being detected at the expense of performance.
   *
   * For luma- and chroma-based edge detection, 0.1 is a reasonable value and allows to catch most visible edges. 0.05
   * is a rather overkill value that allows to catch 'em all. Darker scenes may require an even lower threshold.
   *
   * If depth-based edge detection is used, the threshold will depend on the scene depth.
   *
   * @type {Number}
   */ get edgeDetectionThreshold() {
        return Number(this.defines.EDGE_THRESHOLD);
    }
    set edgeDetectionThreshold(value) {
        this.defines.EDGE_THRESHOLD = value.toFixed("6");
        this.defines.DEPTH_THRESHOLD = (value * 0.1).toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the edge detection threshold.
   *
   * @deprecated Use edgeDetectionThreshold instead.
   * @return {Number} The threshold.
   */ getEdgeDetectionThreshold() {
        return this.edgeDetectionThreshold;
    }
    /**
   * Sets the edge detection threshold.
   *
   * @deprecated Use edgeDetectionThreshold instead.
   * @param {Number} value - The edge detection threshold. Range: [0.0, 0.5].
   */ setEdgeDetectionThreshold(value) {
        this.edgeDetectionThreshold = value;
    }
    /**
   * The predication mode.
   *
   * Predicated thresholding allows to better preserve texture details and to improve edge detection using an additional
   * buffer such as a light accumulation or depth buffer.
   *
   * @type {PredicationMode}
   */ get predicationMode() {
        return Number(this.defines.PREDICATION_MODE);
    }
    set predicationMode(value) {
        this.defines.PREDICATION_MODE = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Returns the predication mode.
   *
   * @deprecated Use predicationMode instead.
   * @return {PredicationMode} The mode.
   */ getPredicationMode() {
        return this.predicationMode;
    }
    /**
   * Sets the predication mode.
   *
   * @deprecated Use predicationMode instead.
   * @param {PredicationMode} value - The predication mode.
   */ setPredicationMode(value) {
        this.predicationMode = value;
    }
    /**
   * The predication buffer.
   *
   * @type {Texture}
   */ set predicationBuffer(value) {
        this.uniforms.predicationBuffer.value = value;
    }
    /**
   * Sets a custom predication buffer.
   *
   * @deprecated Use predicationBuffer instead.
   * @param {Texture} value - The predication buffer.
   */ setPredicationBuffer(value) {
        this.uniforms.predicationBuffer.value = value;
    }
    /**
   * The predication threshold.
   *
   * @type {Number}
   */ get predicationThreshold() {
        return Number(this.defines.PREDICATION_THRESHOLD);
    }
    set predicationThreshold(value) {
        this.defines.PREDICATION_THRESHOLD = value.toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the predication threshold.
   *
   * @deprecated Use predicationThreshold instead.
   * @return {Number} The threshold.
   */ getPredicationThreshold() {
        return this.predicationThreshold;
    }
    /**
   * Sets the predication threshold.
   *
   * @deprecated Use predicationThreshold instead.
   * @param {Number} value - The threshold.
   */ setPredicationThreshold(value) {
        this.predicationThreshold = value;
    }
    /**
   * The predication scale. Range: [1.0, 5.0].
   *
   * Determines how much the edge detection threshold should be scaled when using predication.
   *
   * @type {Boolean|Texture|Number}
   */ get predicationScale() {
        return Number(this.defines.PREDICATION_SCALE);
    }
    set predicationScale(value) {
        this.defines.PREDICATION_SCALE = value.toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the predication scale.
   *
   * @deprecated Use predicationScale instead.
   * @return {Number} The scale.
   */ getPredicationScale() {
        return this.predicationScale;
    }
    /**
   * Sets the predication scale.
   *
   * @deprecated Use predicationScale instead.
   * @param {Number} value - The scale. Range: [1.0, 5.0].
   */ setPredicationScale(value) {
        this.predicationScale = value;
    }
    /**
   * The predication strength. Range: [0.0, 1.0].
   *
   * Determines how much the edge detection threshold should be decreased locally when using predication.
   *
   * @type {Number}
   */ get predicationStrength() {
        return Number(this.defines.PREDICATION_STRENGTH);
    }
    set predicationStrength(value) {
        this.defines.PREDICATION_STRENGTH = value.toFixed("6");
        this.needsUpdate = true;
    }
    /**
   * Returns the predication strength.
   *
   * @deprecated Use predicationStrength instead.
   * @return {Number} The strength.
   */ getPredicationStrength() {
        return this.predicationStrength;
    }
    /**
   * Sets the predication strength.
   *
   * @deprecated Use predicationStrength instead.
   * @param {Number} value - The strength. Range: [0.0, 1.0].
   */ setPredicationStrength(value) {
        this.predicationStrength = value;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/materials/glsl/smaa-weights.frag
var $2046da3312f94030$var$smaa_weights_default = `#define sampleLevelZeroOffset(t, coord, offset) texture2D(t, coord + offset * texelSize)
#if __VERSION__ < 300
#define round(v) floor(v + 0.5)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D areaTexture;uniform lowp sampler2D searchTexture;uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}vec2 decodeDiagBilinearAccess(in vec2 e){e.r=e.r*abs(5.0*e.r-5.0*0.75);return round(e);}vec4 decodeDiagBilinearAccess(in vec4 e){e.rb=e.rb*abs(5.0*e.rb-5.0*0.75);return round(e);}vec2 searchDiag1(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 searchDiag2(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);coord.x+=0.25*texelSize.x;vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;e=decodeDiagBilinearAccess(e);coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 areaDiag(const in vec2 dist,const in vec2 e,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE_DIAG,AREATEX_MAX_DISTANCE_DIAG)*e+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.x+=0.5;texCoord.y+=AREATEX_SUBTEX_SIZE*offset;return texture2D(areaTexture,texCoord).rg;}vec2 calculateDiagWeights(const in vec2 texCoord,const in vec2 e,const in vec4 subsampleIndices){vec2 weights=vec2(0.0);vec4 d;vec2 end;if(e.r>0.0){d.xz=searchDiag1(texCoord,vec2(-1.0,1.0),end);d.x+=float(end.y>0.9);}else{d.xz=vec2(0.0);}d.yw=searchDiag1(texCoord,vec2(1.0,-1.0),end);if(d.x+d.y>2.0){vec4 coords=vec4(-d.x+0.25,d.x,d.y,-d.y-0.25)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.xy=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).rg;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).rg;c.yxwz=decodeDiagBilinearAccess(c.xyzw);vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.z);}d.xz=searchDiag2(texCoord,vec2(-1.0,-1.0),end);if(sampleLevelZeroOffset(inputBuffer,texCoord,vec2(1,0)).r>0.0){d.yw=searchDiag2(texCoord,vec2(1.0),end);d.y+=float(end.y>0.9);}else{d.yw=vec2(0.0);}if(d.x+d.y>2.0){vec4 coords=vec4(-d.x,-d.x,d.y,d.y)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.x=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).g;c.y=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(0,-1)).r;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).gr;vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.w).gr;}return weights;}float searchLength(const in vec2 e,const in float offset){vec2 scale=SEARCHTEX_SIZE*vec2(0.5,-1.0);vec2 bias=SEARCHTEX_SIZE*vec2(offset,1.0);scale+=vec2(-1.0,1.0);bias+=vec2(0.5,-0.5);scale*=1.0/SEARCHTEX_PACKED_SIZE;bias*=1.0/SEARCHTEX_PACKED_SIZE;return texture2D(searchTexture,scale*e+bias).r;}float searchXLeft(in vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x>end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(-2.0,0.0)*texelSize+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.0)+3.25;return texelSize.x*offset+texCoord.x;}float searchXRight(vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x<end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(2.0,0.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.5)+3.25;return-texelSize.x*offset+texCoord.x;}float searchYUp(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.y>end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=-vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.0)+3.25;return texelSize.y*offset+texCoord.y;}float searchYDown(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;i++){if(!(texCoord.y<end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.5)+3.25;return-texelSize.y*offset+texCoord.y;}vec2 area(const in vec2 dist,const in float e1,const in float e2,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE)*round(4.0*vec2(e1,e2))+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.y=AREATEX_SUBTEX_SIZE*offset+texCoord.y;return texture2D(areaTexture,texCoord).rg;}void detectHorizontalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,1)).r;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).r;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,-2)).r;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,-2)).r;weights*=clamp(factor,0.0,1.0);
#endif
}void detectVerticalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(1,0)).g;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).g;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(-2,0)).g;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(-2,1)).g;weights*=clamp(factor,0.0,1.0);
#endif
}void main(){vec4 weights=vec4(0.0);vec4 subsampleIndices=vec4(0.0);vec2 e=texture2D(inputBuffer,vUv).rg;if(e.g>0.0){
#if !defined(DISABLE_DIAG_DETECTION)
weights.rg=calculateDiagWeights(vUv,e,subsampleIndices);if(weights.r==-weights.g){
#endif
vec2 d;vec3 coords;coords.x=searchXLeft(vOffset[0].xy,vOffset[2].x);coords.y=vOffset[1].y;d.x=coords.x;float e1=texture2D(inputBuffer,coords.xy).r;coords.z=searchXRight(vOffset[0].zw,vOffset[2].y);d.y=coords.z;d=round(resolution.xx*d+-vPixCoord.xx);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.zy,vec2(1,0)).r;weights.rg=area(sqrtD,e1,e2,subsampleIndices.y);coords.y=vUv.y;detectHorizontalCornerPattern(weights.rg,coords.xyzy,d);
#if !defined(DISABLE_DIAG_DETECTION)
}else{e.r=0.0;}
#endif
}if(e.r>0.0){vec2 d;vec3 coords;coords.y=searchYUp(vOffset[1].xy,vOffset[2].z);coords.x=vOffset[0].x;d.x=coords.y;float e1=texture2D(inputBuffer,coords.xy).g;coords.z=searchYDown(vOffset[1].zw,vOffset[2].w);d.y=coords.z;d=round(resolution.yy*d-vPixCoord.yy);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.xz,vec2(0,1)).g;weights.ba=area(sqrtD,e1,e2,subsampleIndices.x);coords.x=vUv.x;detectVerticalCornerPattern(weights.ba,coords.xyxz,d);}gl_FragColor=weights;}`;
// src/materials/glsl/smaa-weights.vert
var $2046da3312f94030$var$smaa_weights_default2 = `uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void main(){vUv=position.xy*0.5+0.5;vPixCoord=vUv*resolution;vOffset[0]=vUv.xyxy+texelSize.xyxy*vec4(-0.25,-0.125,1.25,-0.125);vOffset[1]=vUv.xyxy+texelSize.xyxy*vec4(-0.125,-0.25,-0.125,1.25);vOffset[2]=vec4(vOffset[0].xz,vOffset[1].yw)+vec4(-2.0,2.0,-2.0,2.0)*texelSize.xxyy*MAX_SEARCH_STEPS_FLOAT;gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/SMAAWeightsMaterial.js
var $2046da3312f94030$export$b466e73f24a55218 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new SMAA weights material.
   *
   * @param {Vector2} [texelSize] - The absolute screen texel size.
   * @param {Vector2} [resolution] - The resolution.
   */ constructor(texelSize = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(), resolution = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()){
        super({
            name: "SMAAWeightsMaterial",
            defines: {
                // Configurable settings:
                MAX_SEARCH_STEPS_INT: "16",
                MAX_SEARCH_STEPS_FLOAT: "16.0",
                MAX_SEARCH_STEPS_DIAG_INT: "8",
                MAX_SEARCH_STEPS_DIAG_FLOAT: "8.0",
                CORNER_ROUNDING: "25",
                CORNER_ROUNDING_NORM: "0.25",
                // Non-configurable settings:
                AREATEX_MAX_DISTANCE: "16.0",
                AREATEX_MAX_DISTANCE_DIAG: "20.0",
                AREATEX_PIXEL_SIZE: "(1.0 / vec2(160.0, 560.0))",
                AREATEX_SUBTEX_SIZE: "(1.0 / 7.0)",
                SEARCHTEX_SIZE: "vec2(66.0, 33.0)",
                SEARCHTEX_PACKED_SIZE: "vec2(64.0, 16.0)"
            },
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                searchTexture: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                areaTexture: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                resolution: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(resolution),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(texelSize)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$smaa_weights_default,
            vertexShader: $2046da3312f94030$var$smaa_weights_default2
        });
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The search lookup texture.
   *
   * @type {Texture}
   */ get searchTexture() {
        return this.uniforms.searchTexture.value;
    }
    set searchTexture(value) {
        this.uniforms.searchTexture.value = value;
    }
    /**
   * The area lookup texture.
   *
   * @type {Texture}
   */ get areaTexture() {
        return this.uniforms.areaTexture.value;
    }
    set areaTexture(value) {
        this.uniforms.areaTexture.value = value;
    }
    /**
   * Sets the search and area lookup textures.
   *
   * @deprecated Use searchTexture and areaTexture instead.
   * @param {Texture} search - The search lookup texture.
   * @param {Texture} area - The area lookup texture.
   */ setLookupTextures(search, area2) {
        this.searchTexture = search;
        this.areaTexture = area2;
    }
    /**
   * The maximum amount of steps performed in the horizontal/vertical pattern searches, at each side of the pixel.
   * Range: [0, 112].
   *
   * In number of pixels, it's actually the double. So the maximum line length perfectly handled by, for example 16, is
   * 64 (perfectly means that longer lines won't look as good, but are still antialiased).
   *
   * @type {Number}
   */ get orthogonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_INT);
    }
    set orthogonalSearchSteps(value) {
        const s = Math.min(Math.max(value, 0), 112);
        this.defines.MAX_SEARCH_STEPS_INT = s.toFixed("0");
        this.defines.MAX_SEARCH_STEPS_FLOAT = s.toFixed("1");
        this.needsUpdate = true;
    }
    /**
   * Sets the maximum amount of steps performed in the horizontal/vertical pattern searches, at each side of the pixel.
   *
   * @deprecated Use orthogonalSearchSteps instead.
   * @param {Number} value - The search steps. Range: [0, 112].
   */ setOrthogonalSearchSteps(value) {
        this.orthogonalSearchSteps = value;
    }
    /**
   * The maximum steps performed in the diagonal pattern searches, at each side of the pixel. This search
   * jumps one pixel at a time. Range: [0, 20].
   *
   * On high-end machines this search is cheap (between 0.8x and 0.9x slower for 16 steps), but it can have a
   * significant impact on older machines.
   *
   * @type {Number}
   */ get diagonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_DIAG_INT);
    }
    set diagonalSearchSteps(value) {
        const s = Math.min(Math.max(value, 0), 20);
        this.defines.MAX_SEARCH_STEPS_DIAG_INT = s.toFixed("0");
        this.defines.MAX_SEARCH_STEPS_DIAG_FLOAT = s.toFixed("1");
        this.needsUpdate = true;
    }
    /**
   * Specifies the maximum steps performed in the diagonal pattern searches, at each side of the pixel.
   *
   * @deprecated Use diagonalSearchSteps instead.
   * @param {Number} value - The search steps. Range: [0, 20].
   */ setDiagonalSearchSteps(value) {
        this.diagonalSearchSteps = value;
    }
    /**
   * Indicates whether diagonal pattern detection is enabled.
   *
   * @type {Boolean}
   */ get diagonalDetection() {
        return this.defines.DISABLE_DIAG_DETECTION === void 0;
    }
    set diagonalDetection(value) {
        if (value) delete this.defines.DISABLE_DIAG_DETECTION;
        else this.defines.DISABLE_DIAG_DETECTION = "1";
        this.needsUpdate = true;
    }
    /**
   * Indicates whether diagonal pattern detection is enabled.
   *
   * @deprecated Use diagonalDetection instead.
   * @return {Boolean} Whether diagonal pattern detection is enabled.
   */ isDiagonalDetectionEnabled() {
        return this.diagonalDetection;
    }
    /**
   * Enables or disables diagonal pattern detection.
   *
   * @deprecated Use diagonalDetection instead.
   * @param {Boolean} value - Whether diagonal pattern detection should be enabled.
   */ setDiagonalDetectionEnabled(value) {
        this.diagonalDetection = value;
    }
    /**
   * Specifies how much sharp corners will be rounded. Range: [0, 100].
   *
   * @type {Number}
   */ get cornerRounding() {
        return Number(this.defines.CORNER_ROUNDING);
    }
    set cornerRounding(value) {
        const r = Math.min(Math.max(value, 0), 100);
        this.defines.CORNER_ROUNDING = r.toFixed("4");
        this.defines.CORNER_ROUNDING_NORM = (r / 100).toFixed("4");
        this.needsUpdate = true;
    }
    /**
   * Specifies how much sharp corners will be rounded.
   *
   * @deprecated Use cornerRounding instead.
   * @param {Number} value - The corner rounding amount. Range: [0, 100].
   */ setCornerRounding(value) {
        this.cornerRounding = value;
    }
    /**
   * Indicates whether corner detection is enabled.
   *
   * @type {Number}
   */ get cornerDetection() {
        return this.defines.DISABLE_CORNER_DETECTION === void 0;
    }
    set cornerDetection(value) {
        if (value) delete this.defines.DISABLE_CORNER_DETECTION;
        else this.defines.DISABLE_CORNER_DETECTION = "1";
        this.needsUpdate = true;
    }
    /**
   * Indicates whether corner rounding is enabled.
   *
   * @deprecated Use cornerDetection instead.
   * @return {Boolean} Whether corner rounding is enabled.
   */ isCornerRoundingEnabled() {
        return this.cornerDetection;
    }
    /**
   * Enables or disables corner rounding.
   *
   * @deprecated Use cornerDetection instead.
   * @param {Boolean} value - Whether corner rounding should be enabled.
   */ setCornerRoundingEnabled(value) {
        this.cornerDetection = value;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const uniforms = this.uniforms;
        uniforms.texelSize.value.set(1 / width, 1 / height);
        uniforms.resolution.value.set(width, height);
    }
};
// src/textures/smaa/searchImageDataURL.js
var $2046da3312f94030$var$searchImageDataURL_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAQCAYAAACm53kpAAAAeElEQVRYR+2XSwqAMAxEJ168ePEqwRSKhIIiuHjJqiU0gWE+1CQdApcVAMUAuARaMGCX1MIL/Ow13++9lW2s3mW9MWvsnWc/2fvGygwPAN4E8QzAA4CXAB6AHjG4JTHYI1ey3pcx6FHnEfhLDOIBKAmUBK6/ANUDTlROXAHd9EC1AAAAAElFTkSuQmCC";
// src/textures/smaa/areaImageDataURL.js
var $2046da3312f94030$var$areaImageDataURL_default = "data:image/png;base64,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";
// src/effects/glsl/smaa.frag
var $2046da3312f94030$var$smaa_default = `uniform sampler2D weightMap;varying vec2 vOffset0;varying vec2 vOffset1;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 a;a.x=texture2D(weightMap,vOffset0).a;a.y=texture2D(weightMap,vOffset1).g;a.wz=texture2D(weightMap,uv).rb;vec4 color=inputColor;if(dot(a,vec4(1.0))>=1e-5){bool h=max(a.x,a.z)>max(a.y,a.w);vec4 blendingOffset=vec4(0.0,a.y,0.0,a.w);vec2 blendingWeight=a.yw;movec(bvec4(h),blendingOffset,vec4(a.x,0.0,a.z,0.0));movec(bvec2(h),blendingWeight,a.xz);blendingWeight/=dot(blendingWeight,vec2(1.0));vec4 blendingCoord=blendingOffset*vec4(texelSize,-texelSize)+uv.xyxy;color=blendingWeight.x*texture2D(inputBuffer,blendingCoord.xy);color+=blendingWeight.y*texture2D(inputBuffer,blendingCoord.zw);}outputColor=color;}`;
// src/effects/glsl/smaa.vert
var $2046da3312f94030$var$smaa_default2 = `varying vec2 vOffset0;varying vec2 vOffset1;void mainSupport(const in vec2 uv){vOffset0=uv+texelSize*vec2(1.0,0.0);vOffset1=uv+texelSize*vec2(0.0,1.0);}`;
// src/effects/SMAAEffect.js
var $2046da3312f94030$export$85b31dfef8286ee7 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new SMAA effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {SMAAPreset} [options.preset=SMAAPreset.MEDIUM] - The quality preset.
   * @param {EdgeDetectionMode} [options.edgeDetectionMode=EdgeDetectionMode.COLOR] - The edge detection mode.
   * @param {PredicationMode} [options.predicationMode=PredicationMode.DISABLED] - The predication mode.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SRC, preset: preset = $2046da3312f94030$export$829eaccd811a63f.MEDIUM, edgeDetectionMode: edgeDetectionMode = $2046da3312f94030$export$20d1071ff7b64a56.COLOR, predicationMode: predicationMode = $2046da3312f94030$export$6b657d16effdfea4.DISABLED } = {}){
        super("SMAAEffect", $2046da3312f94030$var$smaa_default, {
            vertexShader: $2046da3312f94030$var$smaa_default2,
            blendFunction: blendFunction,
            attributes: $2046da3312f94030$export$a72ebb312f9e05c6.CONVOLUTION | $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "weightMap",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ]
            ])
        });
        let searchImage, areaImage;
        if (arguments.length > 1) {
            searchImage = arguments[0];
            areaImage = arguments[1];
            if (arguments.length > 2) preset = arguments[2];
            if (arguments.length > 3) edgeDetectionMode = arguments[3];
        }
        this.renderTargetEdges = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetEdges.texture.name = "SMAA.Edges";
        this.renderTargetWeights = this.renderTargetEdges.clone();
        this.renderTargetWeights.texture.name = "SMAA.Weights";
        this.uniforms.get("weightMap").value = this.renderTargetWeights.texture;
        this.clearPass = new $2046da3312f94030$export$fc4180e277a6a0c2(true, false, false);
        this.clearPass.overrideClearColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0);
        this.clearPass.overrideClearAlpha = 1;
        this.edgeDetectionPass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$a9e4c517bf702b92());
        this.edgeDetectionMaterial.edgeDetectionMode = edgeDetectionMode;
        this.edgeDetectionMaterial.predicationMode = predicationMode;
        this.weightsPass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$b466e73f24a55218());
        const loadingManager = new (0, $ce0cdebec9150cb3$export$99cc795e99919eed)();
        loadingManager.onLoad = ()=>{
            const searchTexture = new (0, $ce0cdebec9150cb3$export$5431306cf43de24a)(searchImage);
            searchTexture.name = "SMAA.Search";
            searchTexture.magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            searchTexture.minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            searchTexture.generateMipmaps = false;
            searchTexture.needsUpdate = true;
            searchTexture.flipY = true;
            this.weightsMaterial.searchTexture = searchTexture;
            const areaTexture = new (0, $ce0cdebec9150cb3$export$5431306cf43de24a)(areaImage);
            areaTexture.name = "SMAA.Area";
            areaTexture.magFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
            areaTexture.minFilter = (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8);
            areaTexture.generateMipmaps = false;
            areaTexture.needsUpdate = true;
            areaTexture.flipY = false;
            this.weightsMaterial.areaTexture = areaTexture;
            this.dispatchEvent({
                type: "load"
            });
        };
        loadingManager.itemStart("search");
        loadingManager.itemStart("area");
        if (searchImage !== void 0 && areaImage !== void 0) {
            loadingManager.itemEnd("search");
            loadingManager.itemEnd("area");
        } else if (typeof Image !== "undefined") {
            searchImage = new Image();
            areaImage = new Image();
            searchImage.addEventListener("load", ()=>loadingManager.itemEnd("search"));
            areaImage.addEventListener("load", ()=>loadingManager.itemEnd("area"));
            searchImage.src = $2046da3312f94030$var$searchImageDataURL_default;
            areaImage.src = $2046da3312f94030$var$areaImageDataURL_default;
        }
        this.applyPreset(preset);
    }
    /**
   * The edges texture.
   *
   * @type {Texture}
   */ get edgesTexture() {
        return this.renderTargetEdges.texture;
    }
    /**
   * Returns the edges texture.
   *
   * @deprecated Use edgesTexture instead.
   * @return {Texture} The texture.
   */ getEdgesTexture() {
        return this.edgesTexture;
    }
    /**
   * The edge weights texture.
   *
   * @type {Texture}
   */ get weightsTexture() {
        return this.renderTargetWeights.texture;
    }
    /**
   * Returns the edge weights texture.
   *
   * @deprecated Use weightsTexture instead.
   * @return {Texture} The texture.
   */ getWeightsTexture() {
        return this.weightsTexture;
    }
    /**
   * The edge detection material.
   *
   * @type {EdgeDetectionMaterial}
   */ get edgeDetectionMaterial() {
        return this.edgeDetectionPass.fullscreenMaterial;
    }
    /**
   * The edge detection material.
   *
   * @type {EdgeDetectionMaterial}
   * @deprecated Use edgeDetectionMaterial instead.
   */ get colorEdgesMaterial() {
        return this.edgeDetectionMaterial;
    }
    /**
   * Returns the edge detection material.
   *
   * @deprecated Use edgeDetectionMaterial instead.
   * @return {EdgeDetectionMaterial} The material.
   */ getEdgeDetectionMaterial() {
        return this.edgeDetectionMaterial;
    }
    /**
   * The edge weights material.
   *
   * @type {SMAAWeightsMaterial}
   */ get weightsMaterial() {
        return this.weightsPass.fullscreenMaterial;
    }
    /**
   * Returns the edge weights material.
   *
   * @deprecated Use weightsMaterial instead.
   * @return {SMAAWeightsMaterial} The material.
   */ getWeightsMaterial() {
        return this.weightsMaterial;
    }
    /**
   * Sets the edge detection sensitivity.
   *
   * See {@link EdgeDetectionMaterial#setEdgeDetectionThreshold} for more details.
   *
   * @deprecated Use edgeDetectionMaterial instead.
   * @param {Number} threshold - The edge detection sensitivity. Range: [0.05, 0.5].
   */ setEdgeDetectionThreshold(threshold) {
        this.edgeDetectionMaterial.edgeDetectionThreshold = threshold;
    }
    /**
   * Sets the maximum amount of horizontal/vertical search steps.
   *
   * See {@link SMAAWeightsMaterial#setOrthogonalSearchSteps} for more details.
   *
   * @deprecated Use weightsMaterial instead.
   * @param {Number} steps - The search steps. Range: [0, 112].
   */ setOrthogonalSearchSteps(steps) {
        this.weightsMaterial.orthogonalSearchSteps = steps;
    }
    /**
   * Applies the given quality preset.
   *
   * @param {SMAAPreset} preset - The preset.
   */ applyPreset(preset) {
        const edgeDetectionMaterial = this.edgeDetectionMaterial;
        const weightsMaterial = this.weightsMaterial;
        switch(preset){
            case $2046da3312f94030$export$829eaccd811a63f.LOW:
                edgeDetectionMaterial.edgeDetectionThreshold = 0.15;
                weightsMaterial.orthogonalSearchSteps = 4;
                weightsMaterial.diagonalDetection = false;
                weightsMaterial.cornerDetection = false;
                break;
            case $2046da3312f94030$export$829eaccd811a63f.MEDIUM:
                edgeDetectionMaterial.edgeDetectionThreshold = 0.1;
                weightsMaterial.orthogonalSearchSteps = 8;
                weightsMaterial.diagonalDetection = false;
                weightsMaterial.cornerDetection = false;
                break;
            case $2046da3312f94030$export$829eaccd811a63f.HIGH:
                edgeDetectionMaterial.edgeDetectionThreshold = 0.1;
                weightsMaterial.orthogonalSearchSteps = 16;
                weightsMaterial.diagonalSearchSteps = 8;
                weightsMaterial.cornerRounding = 25;
                weightsMaterial.diagonalDetection = true;
                weightsMaterial.cornerDetection = true;
                break;
            case $2046da3312f94030$export$829eaccd811a63f.ULTRA:
                edgeDetectionMaterial.edgeDetectionThreshold = 0.05;
                weightsMaterial.orthogonalSearchSteps = 32;
                weightsMaterial.diagonalSearchSteps = 16;
                weightsMaterial.cornerRounding = 25;
                weightsMaterial.diagonalDetection = true;
                weightsMaterial.cornerDetection = true;
                break;
        }
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.edgeDetectionMaterial.depthBuffer = depthTexture;
        this.edgeDetectionMaterial.depthPacking = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        this.clearPass.render(renderer, this.renderTargetEdges);
        this.edgeDetectionPass.render(renderer, inputBuffer, this.renderTargetEdges);
        this.weightsPass.render(renderer, this.renderTargetEdges, this.renderTargetWeights);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.edgeDetectionMaterial.setSize(width, height);
        this.weightsMaterial.setSize(width, height);
        this.renderTargetEdges.setSize(width, height);
        this.renderTargetWeights.setSize(width, height);
    }
    /**
   * Deletes internal render targets and textures.
   */ dispose() {
        const { searchTexture: searchTexture, areaTexture: areaTexture } = this.weightsMaterial;
        if (searchTexture !== null && areaTexture !== null) {
            searchTexture.dispose();
            areaTexture.dispose();
        }
        super.dispose();
    }
    /**
   * The SMAA search image, encoded as a base64 data URL.
   *
   * @type {String}
   * @deprecated
   */ static get searchImageDataURL() {
        return $2046da3312f94030$var$searchImageDataURL_default;
    }
    /**
   * The SMAA area image, encoded as a base64 data URL.
   *
   * @type {String}
   * @deprecated
   */ static get areaImageDataURL() {
        return $2046da3312f94030$var$areaImageDataURL_default;
    }
};
// src/utils/orthographicDepthToViewZ.js
function $2046da3312f94030$var$orthographicDepthToViewZ(depth, near, far) {
    return depth * (near - far) - near;
}
// src/utils/viewZToOrthographicDepth.js
function $2046da3312f94030$var$viewZToOrthographicDepth(viewZ, near, far) {
    return Math.min(Math.max((viewZ + near) / (near - far), 0), 1);
}
// src/materials/glsl/ssao.frag
var $2046da3312f94030$var$ssao_default = `#include <common>
#include <packing>
uniform vec2 cameraNearFar;
#define cameraNear cameraNearFar.x
#define cameraFar cameraNearFar.y
#ifdef NORMAL_DEPTH
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D normalDepthBuffer;
#else
uniform mediump sampler2D normalDepthBuffer;
#endif
float readDepth(const in vec2 uv){float depth=texture2D(normalDepthBuffer,uv).a;
#if defined(USE_LOGARITHMIC_DEPTH_BUFFER) || defined(LOG_DEPTH)
float d=pow(2.0,depth*log2(cameraFar+1.0))-1.0;float a=cameraFar/(cameraFar-cameraNear);float b=cameraFar*cameraNear/(cameraNear-cameraFar);depth=a+b/d;
#endif
return depth;}
#else
uniform lowp sampler2D normalBuffer;
#if DEPTH_PACKING == 3201
uniform lowp sampler2D depthBuffer;
#elif defined(GL_FRAGMENT_PRECISION_HIGH)
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
float depth=unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
float depth=texture2D(depthBuffer,uv).r;
#endif
#if defined(USE_LOGARITHMIC_DEPTH_BUFFER) || defined(LOG_DEPTH)
float d=pow(2.0,depth*log2(cameraFar+1.0))-1.0;float a=cameraFar/(cameraFar-cameraNear);float b=cameraFar*cameraNear/(cameraNear-cameraFar);depth=a+b/d;
#endif
return depth;}
#endif
uniform lowp sampler2D noiseTexture;uniform mat4 inverseProjectionMatrix;uniform mat4 projectionMatrix;uniform vec2 texelSize;uniform float intensity;uniform float minRadiusScale;uniform float fade;uniform float bias;uniform vec2 distanceCutoff;uniform vec2 proximityCutoff;varying vec2 vUv;varying vec2 vUv2;float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
return orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
}vec3 getViewPosition(const in vec2 screenPosition,const in float depth,const in float viewZ){vec4 clipPosition=vec4(vec3(screenPosition,depth)*2.0-1.0,1.0);float clipW=projectionMatrix[2][3]*viewZ+projectionMatrix[3][3];clipPosition*=clipW;return(inverseProjectionMatrix*clipPosition).xyz;}float getAmbientOcclusion(const in vec3 p,const in vec3 n,const in float depth,const in vec2 uv){float radiusScale=1.0-smoothstep(0.0,distanceCutoff.y,depth);radiusScale=radiusScale*(1.0-minRadiusScale)+minRadiusScale;float radius=RADIUS*radiusScale;float noise=texture2D(noiseTexture,vUv2).r;float baseAngle=noise*PI2;float rings=SPIRAL_TURNS*PI2;float occlusion=0.0;int taps=0;for(int i=0;i<SAMPLES_INT;++i){float alpha=(float(i)+0.5)*INV_SAMPLES_FLOAT;float angle=alpha*rings+baseAngle;vec2 rotation=vec2(cos(angle),sin(angle));vec2 coords=alpha*radius*rotation*texelSize+uv;if(coords.s<0.0||coords.s>1.0||coords.t<0.0||coords.t>1.0){continue;}float sampleDepth=readDepth(coords);float viewZ=getViewZ(sampleDepth);
#ifdef PERSPECTIVE_CAMERA
float linearSampleDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);
#else
float linearSampleDepth=sampleDepth;
#endif
float proximity=abs(depth-linearSampleDepth);if(proximity<proximityCutoff.y){float falloff=1.0-smoothstep(proximityCutoff.x,proximityCutoff.y,proximity);vec3 Q=getViewPosition(coords,sampleDepth,viewZ);vec3 v=Q-p;float vv=dot(v,v);float vn=dot(v,n)-bias;float f=max(RADIUS_SQ-vv,0.0)/RADIUS_SQ;occlusion+=(f*f*f*max(vn/(fade+vv),0.0))*falloff;}++taps;}return occlusion/(4.0*max(float(taps),1.0));}void main(){
#ifdef NORMAL_DEPTH
vec4 normalDepth=texture2D(normalDepthBuffer,vUv);
#if defined(USE_LOGARITHMIC_DEPTH_BUFFER) || defined(LOG_DEPTH)
float d=pow(2.0,normalDepth.a*log2(cameraFar+1.0))-1.0;float a=cameraFar/(cameraFar-cameraNear);float b=cameraFar*cameraNear/(cameraNear-cameraFar);normalDepth.a=a+b/d;
#endif
#else
vec4 normalDepth=vec4(texture2D(normalBuffer,vUv).xyz,readDepth(vUv));
#endif
float ao=0.0;float depth=normalDepth.a;float viewZ=getViewZ(depth);
#ifdef PERSPECTIVE_CAMERA
float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);
#else
float linearDepth=depth;
#endif
if(linearDepth<distanceCutoff.y){vec3 viewPosition=getViewPosition(vUv,depth,viewZ);vec3 viewNormal=unpackRGBToNormal(normalDepth.rgb);ao+=getAmbientOcclusion(viewPosition,viewNormal,linearDepth,vUv);float d=smoothstep(distanceCutoff.x,distanceCutoff.y,linearDepth);ao=mix(ao,0.0,d);
#ifdef LEGACY_INTENSITY
ao=clamp(1.0-pow(1.0-ao,abs(intensity)),0.0,1.0);
#endif
}gl_FragColor.r=ao;}`;
// src/materials/glsl/ssao.vert
var $2046da3312f94030$var$ssao_default2 = `uniform vec2 noiseScale;varying vec2 vUv;varying vec2 vUv2;void main(){vUv=position.xy*0.5+0.5;vUv2=vUv*noiseScale;gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/SSAOMaterial.js
var $2046da3312f94030$export$b3b89c0d91a017a5 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new SSAO material.
   *
   * @param {Camera} camera - A camera.
   */ constructor(camera){
        super({
            name: "SSAOMaterial",
            defines: {
                SAMPLES_INT: "0",
                INV_SAMPLES_FLOAT: "0.0",
                SPIRAL_TURNS: "0.0",
                RADIUS: "1.0",
                RADIUS_SQ: "1.0",
                DISTANCE_SCALING: "1",
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                normalBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                normalDepthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                noiseTexture: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                inverseProjectionMatrix: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()),
                projectionMatrix: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                cameraNearFar: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                distanceCutoff: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                proximityCutoff: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                noiseScale: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                minRadiusScale: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0.33),
                intensity: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1),
                fade: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0.01),
                bias: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$ssao_default,
            vertexShader: $2046da3312f94030$var$ssao_default2
        });
        this.copyCameraSettings(camera);
        this.resolution = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        this.r = 1;
    }
    /**
   * The current near plane setting.
   *
   * @type {Number}
   * @private
   */ get near() {
        return this.uniforms.cameraNearFar.value.x;
    }
    /**
   * The current far plane setting.
   *
   * @type {Number}
   * @private
   */ get far() {
        return this.uniforms.cameraNearFar.value.y;
    }
    /**
   * A combined normal-depth buffer.
   *
   * @type {Texture}
   */ set normalDepthBuffer(value) {
        this.uniforms.normalDepthBuffer.value = value;
        if (value !== null) this.defines.NORMAL_DEPTH = "1";
        else delete this.defines.NORMAL_DEPTH;
        this.needsUpdate = true;
    }
    /**
   * Sets the combined normal-depth buffer.
   *
   * @deprecated Use normalDepthBuffer instead.
   * @param {Number} value - The buffer.
   */ setNormalDepthBuffer(value) {
        this.normalDepthBuffer = value;
    }
    /**
   * The normal buffer.
   *
   * @type {Texture}
   */ set normalBuffer(value) {
        this.uniforms.normalBuffer.value = value;
    }
    /**
   * Sets the normal buffer.
   *
   * @deprecated Use normalBuffer instead.
   * @param {Number} value - The buffer.
   */ setNormalBuffer(value) {
        this.uniforms.normalBuffer.value = value;
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * The noise texture.
   *
   * @type {Texture}
   */ set noiseTexture(value) {
        this.uniforms.noiseTexture.value = value;
    }
    /**
   * Sets the noise texture.
   *
   * @deprecated Use noiseTexture instead.
   * @param {Number} value - The texture.
   */ setNoiseTexture(value) {
        this.uniforms.noiseTexture.value = value;
    }
    /**
   * The sample count.
   *
   * @type {Number}
   */ get samples() {
        return Number(this.defines.SAMPLES_INT);
    }
    set samples(value) {
        this.defines.SAMPLES_INT = value.toFixed(0);
        this.defines.INV_SAMPLES_FLOAT = (1 / value).toFixed(9);
        this.needsUpdate = true;
    }
    /**
   * Returns the amount of occlusion samples per pixel.
   *
   * @deprecated Use samples instead.
   * @return {Number} The sample count.
   */ getSamples() {
        return this.samples;
    }
    /**
   * Sets the amount of occlusion samples per pixel.
   *
   * @deprecated Use samples instead.
   * @param {Number} value - The sample count.
   */ setSamples(value) {
        this.samples = value;
    }
    /**
   * The sampling spiral ring count.
   *
   * @type {Number}
   */ get rings() {
        return Number(this.defines.SPIRAL_TURNS);
    }
    set rings(value) {
        this.defines.SPIRAL_TURNS = value.toFixed(1);
        this.needsUpdate = true;
    }
    /**
   * Returns the amount of spiral turns in the occlusion sampling pattern.
   *
   * @deprecated Use rings instead.
   * @return {Number} The radius.
   */ getRings() {
        return this.rings;
    }
    /**
   * Sets the amount of spiral turns in the occlusion sampling pattern.
   *
   * @deprecated Use rings instead.
   * @param {Number} value - The radius.
   */ setRings(value) {
        this.rings = value;
    }
    /**
   * The intensity.
   *
   * @type {Number}
   * @deprecated Use SSAOEffect.intensity instead.
   */ get intensity() {
        return this.uniforms.intensity.value;
    }
    set intensity(value) {
        this.uniforms.intensity.value = value;
        if (this.defines.LEGACY_INTENSITY === void 0) {
            this.defines.LEGACY_INTENSITY = "1";
            this.needsUpdate = true;
        }
    }
    /**
   * Returns the intensity.
   *
   * @deprecated Use SSAOEffect.intensity instead.
   * @return {Number} The intensity.
   */ getIntensity() {
        return this.uniforms.intensity.value;
    }
    /**
   * Sets the intensity.
   *
   * @deprecated Use SSAOEffect.intensity instead.
   * @param {Number} value - The intensity.
   */ setIntensity(value) {
        this.uniforms.intensity.value = value;
    }
    /**
   * The depth fade factor.
   *
   * @type {Number}
   */ get fade() {
        return this.uniforms.fade.value;
    }
    set fade(value) {
        this.uniforms.fade.value = value;
    }
    /**
   * Returns the depth fade factor.
   *
   * @deprecated Use fade instead.
   * @return {Number} The fade factor.
   */ getFade() {
        return this.uniforms.fade.value;
    }
    /**
   * Sets the depth fade factor.
   *
   * @deprecated Use fade instead.
   * @param {Number} value - The fade factor.
   */ setFade(value) {
        this.uniforms.fade.value = value;
    }
    /**
   * The depth bias. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get bias() {
        return this.uniforms.bias.value;
    }
    set bias(value) {
        this.uniforms.bias.value = value;
    }
    /**
   * Returns the depth bias.
   *
   * @deprecated Use bias instead.
   * @return {Number} The bias.
   */ getBias() {
        return this.uniforms.bias.value;
    }
    /**
   * Sets the depth bias.
   *
   * @deprecated Use bias instead.
   * @param {Number} value - The bias.
   */ setBias(value) {
        this.uniforms.bias.value = value;
    }
    /**
   * The minimum radius scale for distance scaling. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get minRadiusScale() {
        return this.uniforms.minRadiusScale.value;
    }
    set minRadiusScale(value) {
        this.uniforms.minRadiusScale.value = value;
    }
    /**
   * Returns the minimum radius scale for distance scaling.
   *
   * @deprecated Use minRadiusScale instead.
   * @return {Number} The minimum radius scale.
   */ getMinRadiusScale() {
        return this.uniforms.minRadiusScale.value;
    }
    /**
   * Sets the minimum radius scale for distance scaling.
   *
   * @deprecated Use minRadiusScale instead.
   * @param {Number} value - The minimum radius scale.
   */ setMinRadiusScale(value) {
        this.uniforms.minRadiusScale.value = value;
    }
    /**
   * Updates the absolute radius.
   *
   * @private
   */ updateRadius() {
        const radius = this.r * this.resolution.height;
        this.defines.RADIUS = radius.toFixed(11);
        this.defines.RADIUS_SQ = (radius * radius).toFixed(11);
        this.needsUpdate = true;
    }
    /**
   * The occlusion sampling radius. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get radius() {
        return this.r;
    }
    set radius(value) {
        this.r = Math.min(Math.max(value, 1e-6), 1);
        this.updateRadius();
    }
    /**
   * Returns the occlusion sampling radius.
   *
   * @deprecated Use radius instead.
   * @return {Number} The radius.
   */ getRadius() {
        return this.radius;
    }
    /**
   * Sets the occlusion sampling radius.
   *
   * @deprecated Use radius instead.
   * @param {Number} value - The radius. Range [1e-6, 1.0].
   */ setRadius(value) {
        this.radius = value;
    }
    /**
   * Indicates whether distance-based radius scaling is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get distanceScaling() {
        return true;
    }
    set distanceScaling(value) {}
    /**
   * Indicates whether distance-based radius scaling is enabled.
   *
   * @deprecated
   * @return {Boolean} Whether distance scaling is enabled.
   */ isDistanceScalingEnabled() {
        return this.distanceScaling;
    }
    /**
   * Enables or disables distance-based radius scaling.
   *
   * @deprecated
   * @param {Boolean} value - Whether distance scaling should be enabled.
   */ setDistanceScalingEnabled(value) {
        this.distanceScaling = value;
    }
    /**
   * The occlusion distance threshold. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get distanceThreshold() {
        return this.uniforms.distanceCutoff.value.x;
    }
    set distanceThreshold(value) {
        this.uniforms.distanceCutoff.value.set(Math.min(Math.max(value, 0), 1), Math.min(Math.max(value + this.distanceFalloff, 0), 1));
    }
    /**
   * The occlusion distance threshold in world units.
   *
   * @type {Number}
   */ get worldDistanceThreshold() {
        return -$2046da3312f94030$var$orthographicDepthToViewZ(this.distanceThreshold, this.near, this.far);
    }
    set worldDistanceThreshold(value) {
        this.distanceThreshold = $2046da3312f94030$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * The occlusion distance falloff. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get distanceFalloff() {
        return this.uniforms.distanceCutoff.value.y - this.distanceThreshold;
    }
    set distanceFalloff(value) {
        this.uniforms.distanceCutoff.value.y = Math.min(Math.max(this.distanceThreshold + value, 0), 1);
    }
    /**
   * The occlusion distance falloff in world units.
   *
   * @type {Number}
   */ get worldDistanceFalloff() {
        return -$2046da3312f94030$var$orthographicDepthToViewZ(this.distanceFalloff, this.near, this.far);
    }
    set worldDistanceFalloff(value) {
        this.distanceFalloff = $2046da3312f94030$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * Sets the occlusion distance cutoff.
   *
   * @deprecated Use distanceThreshold and distanceFalloff instead.
   * @param {Number} threshold - The distance threshold. Range [0.0, 1.0].
   * @param {Number} falloff - The falloff. Range [0.0, 1.0].
   */ setDistanceCutoff(threshold, falloff) {
        this.uniforms.distanceCutoff.value.set(Math.min(Math.max(threshold, 0), 1), Math.min(Math.max(threshold + falloff, 0), 1));
    }
    /**
   * The occlusion proximity threshold. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get proximityThreshold() {
        return this.uniforms.proximityCutoff.value.x;
    }
    set proximityThreshold(value) {
        this.uniforms.proximityCutoff.value.set(Math.min(Math.max(value, 0), 1), Math.min(Math.max(value + this.proximityFalloff, 0), 1));
    }
    /**
   * The occlusion proximity threshold in world units.
   *
   * @type {Number}
   */ get worldProximityThreshold() {
        return -$2046da3312f94030$var$orthographicDepthToViewZ(this.proximityThreshold, this.near, this.far);
    }
    set worldProximityThreshold(value) {
        this.proximityThreshold = $2046da3312f94030$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * The occlusion proximity falloff. Range: [0.0, 1.0].
   *
   * @type {Number}
   */ get proximityFalloff() {
        return this.uniforms.proximityCutoff.value.y - this.proximityThreshold;
    }
    set proximityFalloff(value) {
        this.uniforms.proximityCutoff.value.y = Math.min(Math.max(this.proximityThreshold + value, 0), 1);
    }
    /**
   * The occlusion proximity falloff in world units.
   *
   * @type {Number}
   */ get worldProximityFalloff() {
        return -$2046da3312f94030$var$orthographicDepthToViewZ(this.proximityFalloff, this.near, this.far);
    }
    set worldProximityFalloff(value) {
        this.proximityFalloff = $2046da3312f94030$var$viewZToOrthographicDepth(-value, this.near, this.far);
    }
    /**
   * Sets the occlusion proximity cutoff.
   *
   * @deprecated Use proximityThreshold and proximityFalloff instead.
   * @param {Number} threshold - The range threshold. Range [0.0, 1.0].
   * @param {Number} falloff - The falloff. Range [0.0, 1.0].
   */ setProximityCutoff(threshold, falloff) {
        this.uniforms.proximityCutoff.value.set(Math.min(Math.max(threshold, 0), 1), Math.min(Math.max(threshold + falloff, 0), 1));
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNearFar.value.set(camera.near, camera.far);
            this.uniforms.projectionMatrix.value.copy(camera.projectionMatrix);
            this.uniforms.inverseProjectionMatrix.value.copy(camera.projectionMatrix).invert();
            if (camera instanceof (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const uniforms = this.uniforms;
        const noiseTexture = uniforms.noiseTexture.value;
        if (noiseTexture !== null) uniforms.noiseScale.value.set(width / noiseTexture.image.width, height / noiseTexture.image.height);
        uniforms.texelSize.value.set(1 / width, 1 / height);
        this.resolution.set(width, height);
        this.updateRadius();
    }
};
// src/materials/glsl/depth-downsampling.frag
var $2046da3312f94030$var$depth_downsampling_default = `#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
#ifdef DOWNSAMPLE_NORMALS
uniform lowp sampler2D normalBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}int findBestDepth(const in float samples[4]){float c=(samples[0]+samples[1]+samples[2]+samples[3])*0.25;float distances[4];distances[0]=abs(c-samples[0]);distances[1]=abs(c-samples[1]);distances[2]=abs(c-samples[2]);distances[3]=abs(c-samples[3]);float maxDistance=max(max(distances[0],distances[1]),max(distances[2],distances[3]));int remaining[3];int rejected[3];int i,j,k;for(i=0,j=0,k=0;i<4;++i){if(distances[i]<maxDistance){remaining[j++]=i;}else{rejected[k++]=i;}}for(;j<3;++j){remaining[j]=rejected[--k];}vec3 s=vec3(samples[remaining[0]],samples[remaining[1]],samples[remaining[2]]);c=(s.x+s.y+s.z)/3.0;distances[0]=abs(c-s.x);distances[1]=abs(c-s.y);distances[2]=abs(c-s.z);float minDistance=min(distances[0],min(distances[1],distances[2]));for(i=0;i<3;++i){if(distances[i]==minDistance){break;}}return remaining[i];}void main(){float d[4];d[0]=readDepth(vUv0);d[1]=readDepth(vUv1);d[2]=readDepth(vUv2);d[3]=readDepth(vUv3);int index=findBestDepth(d);
#ifdef DOWNSAMPLE_NORMALS
vec3 n[4];n[0]=texture2D(normalBuffer,vUv0).rgb;n[1]=texture2D(normalBuffer,vUv1).rgb;n[2]=texture2D(normalBuffer,vUv2).rgb;n[3]=texture2D(normalBuffer,vUv3).rgb;
#else
vec3 n[4];n[0]=vec3(0.0);n[1]=vec3(0.0);n[2]=vec3(0.0);n[3]=vec3(0.0);
#endif
gl_FragColor=vec4(n[index],d[index]);}`;
// src/materials/glsl/depth-downsampling.vert
var $2046da3312f94030$var$depth_downsampling_default2 = `uniform vec2 texelSize;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vUv0=uv;vUv1=vec2(uv.x,uv.y+texelSize.y);vUv2=vec2(uv.x+texelSize.x,uv.y);vUv3=uv+texelSize;gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/DepthDownsamplingMaterial.js
var $2046da3312f94030$export$b2d248d2215da09e = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new depth downsampling material.
   */ constructor(){
        super({
            name: "DepthDownsamplingMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                normalBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$depth_downsampling_default,
            vertexShader: $2046da3312f94030$var$depth_downsampling_default2
        });
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * The normal buffer.
   *
   * @type {Texture}
   */ set normalBuffer(value) {
        this.uniforms.normalBuffer.value = value;
        if (value !== null) this.defines.DOWNSAMPLE_NORMALS = "1";
        else delete this.defines.DOWNSAMPLE_NORMALS;
        this.needsUpdate = true;
    }
    /**
   * Sets the normal buffer.
   *
   * @deprecated Use normalBuffer instead.
   * @param {Texture} value - The normal buffer.
   */ setNormalBuffer(value) {
        this.normalBuffer = value;
    }
    /**
   * Sets the texel size.
   *
   * @deprecated Use setSize() instead.
   * @param {Number} x - The texel width.
   * @param {Number} y - The texel height.
   */ setTexelSize(x, y) {
        this.uniforms.texelSize.value.set(x, y);
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/passes/DepthDownsamplingPass.js
var $2046da3312f94030$export$eb8020324d924933 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new depth downsampling pass.
   *
   * @param {Object} [options] - The options.
   * @param {Texture} [options.normalBuffer=null] - A texture that contains view space normals. See {@link NormalPass}.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor({ normalBuffer: normalBuffer = null, resolutionScale: resolutionScale = 0.5, width: width = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, height: height = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("DepthDownsamplingPass");
        const material = new $2046da3312f94030$export$b2d248d2215da09e();
        material.normalBuffer = normalBuffer;
        this.fullscreenMaterial = material;
        this.needsDepthTexture = true;
        this.needsSwap = false;
        this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            minFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
            magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
            depthBuffer: false,
            type: (0, $ce0cdebec9150cb3$export$f6d331659b644596)
        });
        this.renderTarget.texture.name = "DepthDownsamplingPass.Target";
        this.renderTarget.texture.generateMipmaps = false;
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    /**
   * The normal(RGB) + depth(A) texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the normal(RGB) + depth(A) texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.fullscreenMaterial.depthBuffer = depthTexture;
        this.fullscreenMaterial.depthPacking = depthPacking;
    }
    /**
   * Downsamples depth and scene normals.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
        this.fullscreenMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        const gl = renderer.getContext();
        const renderable = gl.getExtension("EXT_color_buffer_float") || gl.getExtension("EXT_color_buffer_half_float");
        if (!renderable) throw new Error("Rendering to float texture is not supported.");
    }
};
// src/effects/glsl/ssao.frag
var $2046da3312f94030$var$ssao_default3 = `uniform lowp sampler2D aoBuffer;uniform float luminanceInfluence;uniform float intensity;
#if defined(DEPTH_AWARE_UPSAMPLING) && defined(NORMAL_DEPTH)
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D normalDepthBuffer;
#else
uniform mediump sampler2D normalDepthBuffer;
#endif
#endif
#ifdef COLORIZE
uniform vec3 color;
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){float aoLinear=texture2D(aoBuffer,uv).r;
#if defined(DEPTH_AWARE_UPSAMPLING) && defined(NORMAL_DEPTH) && __VERSION__ == 300
vec4 normalDepth[4];normalDepth[0]=textureOffset(normalDepthBuffer,uv,ivec2(0,0));normalDepth[1]=textureOffset(normalDepthBuffer,uv,ivec2(0,1));normalDepth[2]=textureOffset(normalDepthBuffer,uv,ivec2(1,0));normalDepth[3]=textureOffset(normalDepthBuffer,uv,ivec2(1,1));float dot01=dot(normalDepth[0].rgb,normalDepth[1].rgb);float dot02=dot(normalDepth[0].rgb,normalDepth[2].rgb);float dot03=dot(normalDepth[0].rgb,normalDepth[3].rgb);float minDot=min(dot01,min(dot02,dot03));float s=step(THRESHOLD,minDot);float smallestDistance=1.0;int index;for(int i=0;i<4;++i){float distance=abs(depth-normalDepth[i].a);if(distance<smallestDistance){smallestDistance=distance;index=i;}}ivec2 offsets[4];offsets[0]=ivec2(0,0);offsets[1]=ivec2(0,1);offsets[2]=ivec2(1,0);offsets[3]=ivec2(1,1);ivec2 coord=ivec2(uv*vec2(textureSize(aoBuffer,0)))+offsets[index];float aoNearest=texelFetch(aoBuffer,coord,0).r;float ao=mix(aoNearest,aoLinear,s);
#else
float ao=aoLinear;
#endif
float l=luminance(inputColor.rgb);ao=mix(ao,0.0,l*luminanceInfluence);ao=clamp(ao*intensity,0.0,1.0);
#ifdef COLORIZE
outputColor=vec4(1.0-ao*(1.0-color),inputColor.a);
#else
outputColor=vec4(vec3(1.0-ao),inputColor.a);
#endif
}`;
// src/effects/SSAOEffect.js
var $2046da3312f94030$var$NOISE_TEXTURE_SIZE = 64;
var $2046da3312f94030$export$49399bb0221f2549 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new SSAO effect.
   *
   * @todo Move normalBuffer to options.
   * @param {Camera} [camera] - The main camera.
   * @param {Texture} [normalBuffer] - A texture that contains the scene normals.
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.MULTIPLY] - The blend function of this effect.
   * @param {Boolean} [options.distanceScaling=true] - Deprecated.
   * @param {Boolean} [options.depthAwareUpsampling=true] - Enables or disables depth-aware upsampling. Has no effect if WebGL 2 is not supported.
   * @param {Texture} [options.normalDepthBuffer=null] - Deprecated.
   * @param {Number} [options.samples=9] - The amount of samples per pixel. Should not be a multiple of the ring count.
   * @param {Number} [options.rings=7] - The amount of spiral turns in the occlusion sampling pattern. Should be a prime number.
   * @param {Number} [options.worldDistanceThreshold] - The world distance threshold at which the occlusion effect starts to fade out.
   * @param {Number} [options.worldDistanceFalloff] - The world distance falloff. Influences the smoothness of the occlusion cutoff.
   * @param {Number} [options.worldProximityThreshold] - The world proximity threshold at which the occlusion starts to fade out.
   * @param {Number} [options.worldProximityFalloff] - The world proximity falloff. Influences the smoothness of the proximity cutoff.
   * @param {Number} [options.distanceThreshold=0.97] - Deprecated.
   * @param {Number} [options.distanceFalloff=0.03] - Deprecated.
   * @param {Number} [options.rangeThreshold=0.0005] - Deprecated.
   * @param {Number} [options.rangeFalloff=0.001] - Deprecated.
   * @param {Number} [options.minRadiusScale=0.1] - The minimum radius scale.
   * @param {Number} [options.luminanceInfluence=0.7] - Determines how much the luminance of the scene influences the ambient occlusion.
   * @param {Number} [options.radius=0.1825] - The occlusion sampling radius, expressed as a scale relative to the resolution. Range [1e-6, 1.0].
   * @param {Number} [options.intensity=1.0] - The intensity of the ambient occlusion.
   * @param {Number} [options.bias=0.025] - An occlusion bias. Eliminates artifacts caused by depth discontinuities.
   * @param {Number} [options.fade=0.01] - Influences the smoothness of the shadows. A lower value results in higher contrast.
   * @param {Color} [options.color=null] - The color of the ambient occlusion.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(camera, normalBuffer, { blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.MULTIPLY, samples: samples = 9, rings: rings = 7, normalDepthBuffer: normalDepthBuffer = null, depthAwareUpsampling: depthAwareUpsampling = true, worldDistanceThreshold: worldDistanceThreshold, worldDistanceFalloff: worldDistanceFalloff, worldProximityThreshold: worldProximityThreshold, worldProximityFalloff: worldProximityFalloff, distanceThreshold: distanceThreshold = 0.97, distanceFalloff: distanceFalloff = 0.03, rangeThreshold: rangeThreshold = 5e-4, rangeFalloff: rangeFalloff = 1e-3, minRadiusScale: minRadiusScale = 0.1, luminanceInfluence: luminanceInfluence = 0.7, radius: radius = 0.1825, intensity: intensity = 1, bias: bias = 0.025, fade: fade = 0.01, color: color2 = null, resolutionScale: resolutionScale = 1, width: width = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, height: height = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("SSAOEffect", $2046da3312f94030$var$ssao_default3, {
            blendFunction: blendFunction,
            attributes: $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH,
            defines: /* @__PURE__ */ new Map([
                [
                    "THRESHOLD",
                    "0.997"
                ]
            ]),
            uniforms: /* @__PURE__ */ new Map([
                [
                    "aoBuffer",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "normalDepthBuffer",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(normalDepthBuffer)
                ],
                [
                    "luminanceInfluence",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(luminanceInfluence)
                ],
                [
                    "color",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "intensity",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(intensity)
                ],
                [
                    "scale",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0)
                ]
            ])
        });
        this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "AO.Target";
        this.uniforms.get("aoBuffer").value = this.renderTarget.texture;
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.camera = camera;
        this.depthDownsamplingPass = new $2046da3312f94030$export$eb8020324d924933({
            normalBuffer: normalBuffer,
            resolutionScale: resolutionScale
        });
        this.depthDownsamplingPass.enabled = normalDepthBuffer === null;
        this.ssaoPass = new $2046da3312f94030$export$c55093fd4f9e42f0(new $2046da3312f94030$export$b3b89c0d91a017a5(camera));
        const noiseTexture = new $2046da3312f94030$export$2d9c702b3963e69c($2046da3312f94030$var$NOISE_TEXTURE_SIZE, $2046da3312f94030$var$NOISE_TEXTURE_SIZE, (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c));
        noiseTexture.wrapS = noiseTexture.wrapT = (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5);
        const ssaoMaterial = this.ssaoMaterial;
        ssaoMaterial.normalBuffer = normalBuffer;
        ssaoMaterial.noiseTexture = noiseTexture;
        ssaoMaterial.minRadiusScale = minRadiusScale;
        ssaoMaterial.samples = samples;
        ssaoMaterial.radius = radius;
        ssaoMaterial.rings = rings;
        ssaoMaterial.fade = fade;
        ssaoMaterial.bias = bias;
        ssaoMaterial.distanceThreshold = distanceThreshold;
        ssaoMaterial.distanceFalloff = distanceFalloff;
        ssaoMaterial.proximityThreshold = rangeThreshold;
        ssaoMaterial.proximityFalloff = rangeFalloff;
        if (worldDistanceThreshold !== void 0) ssaoMaterial.worldDistanceThreshold = worldDistanceThreshold;
        if (worldDistanceFalloff !== void 0) ssaoMaterial.worldDistanceFalloff = worldDistanceFalloff;
        if (worldProximityThreshold !== void 0) ssaoMaterial.worldProximityThreshold = worldProximityThreshold;
        if (worldProximityFalloff !== void 0) ssaoMaterial.worldProximityFalloff = worldProximityFalloff;
        if (normalDepthBuffer !== null) {
            this.ssaoMaterial.normalDepthBuffer = normalDepthBuffer;
            this.defines.set("NORMAL_DEPTH", "1");
        }
        this.depthAwareUpsampling = depthAwareUpsampling;
        this.color = color2;
    }
    set mainCamera(value) {
        this.camera = value;
        this.ssaoMaterial.copyCameraSettings(value);
    }
    /**
   * Sets the normal buffer.
   *
   * @type {Texture}
   */ get normalBuffer() {
        return this.ssaoMaterial.normalBuffer;
    }
    set normalBuffer(value) {
        this.ssaoMaterial.normalBuffer = value;
        this.depthDownsamplingPass.fullscreenMaterial.normalBuffer = value;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * The SSAO material.
   *
   * @type {SSAOMaterial}
   */ get ssaoMaterial() {
        return this.ssaoPass.fullscreenMaterial;
    }
    /**
   * Returns the SSAO material.
   *
   * @deprecated Use ssaoMaterial instead.
   * @return {SSAOMaterial} The material.
   */ getSSAOMaterial() {
        return this.ssaoMaterial;
    }
    /**
   * The amount of occlusion samples per pixel.
   *
   * @type {Number}
   * @deprecated Use ssaoMaterial.samples instead.
   */ get samples() {
        return this.ssaoMaterial.samples;
    }
    set samples(value) {
        this.ssaoMaterial.samples = value;
    }
    /**
   * The amount of spiral turns in the occlusion sampling pattern.
   *
   * @type {Number}
   * @deprecated Use ssaoMaterial.rings instead.
   */ get rings() {
        return this.ssaoMaterial.rings;
    }
    set rings(value) {
        this.ssaoMaterial.rings = value;
    }
    /**
   * The occlusion sampling radius.
   *
   * @type {Number}
   * @deprecated Use ssaoMaterial.radius instead.
   */ get radius() {
        return this.ssaoMaterial.radius;
    }
    set radius(value) {
        this.ssaoMaterial.radius = value;
    }
    /**
   * Indicates whether depth-aware upsampling is enabled.
   *
   * @type {Boolean}
   */ get depthAwareUpsampling() {
        return this.defines.has("DEPTH_AWARE_UPSAMPLING");
    }
    set depthAwareUpsampling(value) {
        if (this.depthAwareUpsampling !== value) {
            if (value) this.defines.set("DEPTH_AWARE_UPSAMPLING", "1");
            else this.defines.delete("DEPTH_AWARE_UPSAMPLING");
            this.setChanged();
        }
    }
    /**
   * Indicates whether depth-aware upsampling is enabled.
   *
   * @deprecated Use depthAwareUpsampling instead.
   * @return {Boolean} Whether depth-aware upsampling is enabled.
   */ isDepthAwareUpsamplingEnabled() {
        return this.depthAwareUpsampling;
    }
    /**
   * Enables or disables depth-aware upsampling.
   *
   * @deprecated Use depthAwareUpsampling instead.
   * @param {Boolean} value - Whether depth-aware upsampling should be enabled.
   */ setDepthAwareUpsamplingEnabled(value) {
        this.depthAwareUpsampling = value;
    }
    /**
   * Indicates whether distance-based radius scaling is enabled.
   *
   * @type {Boolean}
   * @deprecated
   */ get distanceScaling() {
        return true;
    }
    set distanceScaling(value) {}
    /**
   * The color of the ambient occlusion. Set to `null` to disable.
   *
   * @type {Color}
   */ get color() {
        return this.uniforms.get("color").value;
    }
    set color(value) {
        const uniforms = this.uniforms;
        const defines = this.defines;
        if (value !== null) {
            if (defines.has("COLORIZE")) uniforms.get("color").value.set(value);
            else {
                defines.set("COLORIZE", "1");
                uniforms.get("color").value = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(value);
                this.setChanged();
            }
        } else if (defines.has("COLORIZE")) {
            defines.delete("COLORIZE");
            uniforms.get("color").value = null;
            this.setChanged();
        }
    }
    /**
   * The luminance influence factor. Range: [0.0, 1.0].
   *
   * @type {Boolean}
   */ get luminanceInfluence() {
        return this.uniforms.get("luminanceInfluence").value;
    }
    set luminanceInfluence(value) {
        this.uniforms.get("luminanceInfluence").value = value;
    }
    /**
   * The intensity.
   *
   * @type {Number}
   */ get intensity() {
        return this.uniforms.get("intensity").value;
    }
    set intensity(value) {
        this.uniforms.get("intensity").value = value;
    }
    /**
   * Returns the color of the ambient occlusion.
   *
   * @deprecated Use color instead.
   * @return {Color} The color.
   */ getColor() {
        return this.color;
    }
    /**
   * Sets the color of the ambient occlusion. Set to `null` to disable colorization.
   *
   * @deprecated Use color instead.
   * @param {Color} value - The color.
   */ setColor(value) {
        this.color = value;
    }
    /**
   * Sets the occlusion distance cutoff.
   *
   * @deprecated Use ssaoMaterial instead.
   * @param {Number} threshold - The distance threshold. Range [0.0, 1.0].
   * @param {Number} falloff - The falloff. Range [0.0, 1.0].
   */ setDistanceCutoff(threshold, falloff) {
        this.ssaoMaterial.distanceThreshold = threshold;
        this.ssaoMaterial.distanceFalloff = falloff;
    }
    /**
   * Sets the occlusion proximity cutoff.
   *
   * @deprecated Use ssaoMaterial instead.
   * @param {Number} threshold - The proximity threshold. Range [0.0, 1.0].
   * @param {Number} falloff - The falloff. Range [0.0, 1.0].
   */ setProximityCutoff(threshold, falloff) {
        this.ssaoMaterial.proximityThreshold = threshold;
        this.ssaoMaterial.proximityFalloff = falloff;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthDownsamplingPass.setDepthTexture(depthTexture, depthPacking);
        this.ssaoMaterial.depthBuffer = depthTexture;
        this.ssaoMaterial.depthPacking = depthPacking;
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        const renderTarget = this.renderTarget;
        if (this.depthDownsamplingPass.enabled) this.depthDownsamplingPass.render(renderer);
        this.ssaoPass.render(renderer, null, renderTarget);
    }
    /**
   * Sets the size.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.ssaoMaterial.copyCameraSettings(this.camera);
        this.ssaoMaterial.setSize(w, h);
        this.renderTarget.setSize(w, h);
        this.depthDownsamplingPass.resolution.scale = resolution.scale;
        this.depthDownsamplingPass.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        try {
            let normalDepthBuffer = this.uniforms.get("normalDepthBuffer").value;
            if (normalDepthBuffer === null) {
                this.depthDownsamplingPass.initialize(renderer, alpha, frameBufferType);
                normalDepthBuffer = this.depthDownsamplingPass.texture;
                this.uniforms.get("normalDepthBuffer").value = normalDepthBuffer;
                this.ssaoMaterial.normalDepthBuffer = normalDepthBuffer;
                this.defines.set("NORMAL_DEPTH", "1");
            }
        } catch (e) {
            this.depthDownsamplingPass.enabled = false;
        }
    }
};
// src/effects/glsl/texture.frag
var $2046da3312f94030$var$texture_default = `#ifdef TEXTURE_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
varying vec2 vUv2;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){
#ifdef UV_TRANSFORM
vec4 texel=texture2D(map,vUv2);
#else
vec4 texel=texture2D(map,uv);
#endif
outputColor=TEXEL;outputColor.a=max(inputColor.a,outputColor.a);}`;
// src/effects/glsl/texture.vert
var $2046da3312f94030$var$texture_default2 = `#ifdef ASPECT_CORRECTION
uniform float scale;
#else
uniform mat3 uvTransform;
#endif
varying vec2 vUv2;void mainSupport(const in vec2 uv){
#ifdef ASPECT_CORRECTION
vUv2=uv*vec2(aspect,1.0)*scale;
#else
vUv2=(uvTransform*vec3(uv,1.0)).xy;
#endif
}`;
// src/effects/TextureEffect.js
var $2046da3312f94030$export$d1c9dd073fa6a2a3 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new texture effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Texture} [options.texture] - A texture.
   * @param {Boolean} [options.aspectCorrection=false] - Deprecated. Adjust the texture's offset, repeat and center instead.
   */ constructor({ blendFunction: blendFunction, texture: texture = null, aspectCorrection: aspectCorrection = false } = {}){
        super("TextureEffect", $2046da3312f94030$var$texture_default, {
            blendFunction: blendFunction,
            defines: /* @__PURE__ */ new Map([
                [
                    "TEXEL",
                    "texel"
                ]
            ]),
            uniforms: /* @__PURE__ */ new Map([
                [
                    "map",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "scale",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
                ],
                [
                    "uvTransform",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ]
            ])
        });
        this.texture = texture;
        this.aspectCorrection = aspectCorrection;
    }
    /**
   * The texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.uniforms.get("map").value;
    }
    set texture(value) {
        const prevTexture = this.texture;
        const uniforms = this.uniforms;
        const defines = this.defines;
        if (prevTexture !== value) {
            uniforms.get("map").value = value;
            uniforms.get("uvTransform").value = value.matrix;
            defines.delete("TEXTURE_PRECISION_HIGH");
            if (value !== null) {
                if (value.matrixAutoUpdate) {
                    defines.set("UV_TRANSFORM", "1");
                    this.setVertexShader($2046da3312f94030$var$texture_default2);
                } else {
                    defines.delete("UV_TRANSFORM");
                    this.setVertexShader(null);
                }
                if (value.type !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) defines.set("TEXTURE_PRECISION_HIGH", "1");
                if (prevTexture === null || prevTexture.type !== value.type || prevTexture.encoding !== value.encoding) this.setChanged();
            }
        }
    }
    /**
   * Returns the texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.texture;
    }
    /**
   * Sets the texture.
   *
   * @deprecated Use texture instead.
   * @param {Texture} value - The texture.
   */ setTexture(value) {
        this.texture = value;
    }
    /**
   * Indicates whether aspect correction is enabled.
   *
   * @type {Number}
   * @deprecated Adjust the texture's offset, repeat, rotation and center instead.
   */ get aspectCorrection() {
        return this.defines.has("ASPECT_CORRECTION");
    }
    set aspectCorrection(value) {
        if (this.aspectCorrection !== value) {
            if (value) this.defines.set("ASPECT_CORRECTION", "1");
            else this.defines.delete("ASPECT_CORRECTION");
            this.setChanged();
        }
    }
    /**
   * Indicates whether the texture UV coordinates will be transformed using the transformation matrix of the texture.
   *
   * @type {Boolean}
   * @deprecated Use texture.matrixAutoUpdate instead.
   */ get uvTransform() {
        const texture = this.texture;
        return texture !== null && texture.matrixAutoUpdate;
    }
    set uvTransform(value) {
        const texture = this.texture;
        if (texture !== null) texture.matrixAutoUpdate = value;
    }
    /**
   * Sets the swizzles that will be applied to the components of a texel before it is written to the output color.
   *
   * @param {ColorChannel} r - The swizzle for the `r` component.
   * @param {ColorChannel} [g=r] - The swizzle for the `g` component.
   * @param {ColorChannel} [b=r] - The swizzle for the `b` component.
   * @param {ColorChannel} [a=r] - The swizzle for the `a` component.
   */ setTextureSwizzleRGBA(r, g = r, b = r, a = r) {
        const rgba = "rgba";
        let swizzle = "";
        if (r !== $2046da3312f94030$export$e8b1230a2d7ba080.RED || g !== $2046da3312f94030$export$e8b1230a2d7ba080.GREEN || b !== $2046da3312f94030$export$e8b1230a2d7ba080.BLUE || a !== $2046da3312f94030$export$e8b1230a2d7ba080.ALPHA) swizzle = [
            ".",
            rgba[r],
            rgba[g],
            rgba[b],
            rgba[a]
        ].join("");
        this.defines.set("TEXEL", "texel" + swizzle);
        this.setChanged();
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        if (this.texture.matrixAutoUpdate) this.texture.updateMatrix();
    }
};
// src/materials/glsl/convolution.tilt-shift.frag
var $2046da3312f94030$var$convolution_tilt_shift_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform vec4 maskParams;varying vec2 vUv;varying vec2 vUv2;varying vec2 vOffset;float linearGradientMask(const in float x){return smoothstep(maskParams.x,maskParams.y,x)-smoothstep(maskParams.w,maskParams.z,x);}void main(){vec2 dUv=vOffset*(1.0-linearGradientMask(vUv2.y));vec4 sum=texture2D(inputBuffer,vec2(vUv.x-dUv.x,vUv.y+dUv.y));sum+=texture2D(inputBuffer,vec2(vUv.x+dUv.x,vUv.y+dUv.y));sum+=texture2D(inputBuffer,vec2(vUv.x+dUv.x,vUv.y-dUv.y));sum+=texture2D(inputBuffer,vec2(vUv.x-dUv.x,vUv.y-dUv.y));gl_FragColor=sum*0.25;
#include <colorspace_fragment>
}`;
// src/materials/glsl/convolution.tilt-shift.vert
var $2046da3312f94030$var$convolution_tilt_shift_default2 = `uniform vec4 texelSize;uniform float kernel;uniform float scale;uniform float aspect;uniform vec2 rotation;varying vec2 vUv;varying vec2 vUv2;varying vec2 vOffset;void main(){vec2 uv=position.xy*0.5+0.5;vUv=uv;vUv2=(uv-0.5)*2.0*vec2(aspect,1.0);vUv2=vec2(dot(rotation,vUv2),dot(rotation,vec2(vUv2.y,-vUv2.x)));vOffset=(texelSize.xy*vec2(kernel)+texelSize.zw)*scale;gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/TiltShiftBlurMaterial.js
var $2046da3312f94030$export$207fd7140c306e23 = class extends $2046da3312f94030$export$c69ac3f2757c20a {
    /**
   * Constructs a new tilt shift blur material.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.offset=0.0] - The relative offset of the focus area.
   * @param {Number} [options.rotation=0.0] - The rotation of the focus area in radians.
   * @param {Number} [options.focusArea=0.4] - The relative size of the focus area.
   * @param {Number} [options.feather=0.3] - The softness of the focus area edges.
   */ constructor({ kernelSize: kernelSize = $2046da3312f94030$export$543b1e4815577d06.MEDIUM, offset: offset = 0, rotation: rotation = 0, focusArea: focusArea = 0.4, feather: feather = 0.3 } = {}){
        super();
        this.fragmentShader = $2046da3312f94030$var$convolution_tilt_shift_default;
        this.vertexShader = $2046da3312f94030$var$convolution_tilt_shift_default2;
        this.kernelSize = kernelSize;
        this.uniforms.aspect = new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1);
        this.uniforms.rotation = new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)());
        this.uniforms.maskParams = new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)());
        this._offset = offset;
        this._focusArea = focusArea;
        this._feather = feather;
        this.rotation = rotation;
        this.updateParams();
    }
    /**
   * The relative offset of the focus area.
   *
   * @private
   */ updateParams() {
        const params = this.uniforms.maskParams.value;
        const a = Math.max(this.focusArea, 0);
        const b = Math.max(a - this.feather, 0);
        params.set(this.offset - a, this.offset - b, this.offset + a, this.offset + b);
    }
    /**
   * The rotation of the focus area in radians.
   *
   * @type {Number}
   */ get rotation() {
        return Math.acos(this.uniforms.rotation.value.x);
    }
    set rotation(value) {
        this.uniforms.rotation.value.set(Math.cos(value), Math.sin(value));
    }
    /**
   * The relative offset of the focus area.
   *
   * @type {Number}
   */ get offset() {
        return this._offset;
    }
    set offset(value) {
        this._offset = value;
        this.updateParams();
    }
    /**
   * The relative size of the focus area.
   *
   * @type {Number}
   */ get focusArea() {
        return this._focusArea;
    }
    set focusArea(value) {
        this._focusArea = value;
        this.updateParams();
    }
    /**
   * The softness of the focus area edges.
   *
   * @type {Number}
   */ get feather() {
        return this._feather;
    }
    set feather(value) {
        this._feather = value;
        this.updateParams();
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        super.setSize(width, height);
        this.uniforms.aspect.value = width / height;
    }
};
// src/passes/TiltShiftBlurPass.js
var $2046da3312f94030$export$4c0a27a0f0e81f27 = class extends $2046da3312f94030$export$657273fee9302035 {
    /**
   * Constructs a new Kawase blur pass.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.offset=0.0] - The relative offset of the focus area.
   * @param {Number} [options.rotation=0.0] - The rotation of the focus area in radians.
   * @param {Number} [options.focusArea=0.4] - The relative size of the focus area.
   * @param {Number} [options.feather=0.3] - The softness of the focus area edges.
   * @param {KernelSize} [options.kernelSize=KernelSize.MEDIUM] - The blur kernel size.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   */ constructor({ offset: offset = 0, rotation: rotation = 0, focusArea: focusArea = 0.4, feather: feather = 0.3, kernelSize: kernelSize = $2046da3312f94030$export$543b1e4815577d06.MEDIUM, resolutionScale: resolutionScale = 0.5, resolutionX: resolutionX = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionY: resolutionY = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE } = {}){
        super({
            kernelSize: kernelSize,
            resolutionScale: resolutionScale,
            resolutionX: resolutionX,
            resolutionY: resolutionY
        });
        this.blurMaterial = new $2046da3312f94030$export$207fd7140c306e23({
            kernelSize: kernelSize,
            offset: offset,
            rotation: rotation,
            focusArea: focusArea,
            feather: feather
        });
    }
};
// src/effects/glsl/tilt-shift.frag
var $2046da3312f94030$var$tilt_shift_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
uniform vec2 maskParams;varying vec2 vUv2;float linearGradientMask(const in float x){return step(maskParams.x,x)-step(maskParams.y,x);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){float mask=linearGradientMask(vUv2.y);vec4 texel=texture2D(map,uv);outputColor=mix(texel,inputColor,mask);}`;
// src/effects/glsl/tilt-shift.vert
var $2046da3312f94030$var$tilt_shift_default2 = `uniform vec2 rotation;varying vec2 vUv2;void mainSupport(const in vec2 uv){vUv2=(uv-0.5)*2.0*vec2(aspect,1.0);vUv2=vec2(dot(rotation,vUv2),dot(rotation,vec2(vUv2.y,-vUv2.x)));}`;
// src/effects/TiltShiftEffect.js
var $2046da3312f94030$export$c658e8e07b156fbc = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new tilt shift Effect
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {Number} [options.offset=0.0] - The relative offset of the focus area.
   * @param {Number} [options.rotation=0.0] - The rotation of the focus area in radians.
   * @param {Number} [options.focusArea=0.4] - The relative size of the focus area.
   * @param {Number} [options.feather=0.3] - The softness of the focus area edges.
   * @param {Number} [options.bias=0.06] - Deprecated.
   * @param {KernelSize} [options.kernelSize=KernelSize.MEDIUM] - The blur kernel size.
   * @param {Number} [options.resolutionScale=0.5] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   */ constructor({ blendFunction: blendFunction, offset: offset = 0, rotation: rotation = 0, focusArea: focusArea = 0.4, feather: feather = 0.3, kernelSize: kernelSize = $2046da3312f94030$export$543b1e4815577d06.MEDIUM, resolutionScale: resolutionScale = 0.5, resolutionX: resolutionX = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionY: resolutionY = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE } = {}){
        super("TiltShiftEffect", $2046da3312f94030$var$tilt_shift_default, {
            vertexShader: $2046da3312f94030$var$tilt_shift_default2,
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "rotation",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
                ],
                [
                    "maskParams",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
                ],
                [
                    "map",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ]
            ])
        });
        this._offset = offset;
        this._focusArea = focusArea;
        this._feather = feather;
        this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTarget.texture.name = "TiltShift.Target";
        this.uniforms.get("map").value = this.renderTarget.texture;
        this.blurPass = new $2046da3312f94030$export$4c0a27a0f0e81f27({
            kernelSize: kernelSize,
            resolutionScale: resolutionScale,
            resolutionX: resolutionX,
            resolutionY: resolutionY,
            offset: offset,
            rotation: rotation,
            focusArea: focusArea,
            feather: feather
        });
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.rotation = rotation;
        this.updateParams();
    }
    /**
   * Updates the mask params.
   *
   * @private
   */ updateParams() {
        const params = this.uniforms.get("maskParams").value;
        const x = Math.max(this.focusArea - this.feather, 0);
        params.set(this.offset - x, this.offset + x);
    }
    /**
   * The rotation of the focus area in radians.
   *
   * @type {Number}
   */ get rotation() {
        return Math.acos(this.uniforms.get("rotation").value.x);
    }
    set rotation(value) {
        this.uniforms.get("rotation").value.set(Math.cos(value), Math.sin(value));
        this.blurPass.blurMaterial.rotation = value;
    }
    /**
   * The relative offset of the focus area.
   *
   * @type {Number}
   */ get offset() {
        return this._offset;
    }
    set offset(value) {
        this._offset = value;
        this.blurPass.blurMaterial.offset = value;
        this.updateParams();
    }
    /**
   * The relative size of the focus area.
   *
   * @type {Number}
   */ get focusArea() {
        return this._focusArea;
    }
    set focusArea(value) {
        this._focusArea = value;
        this.blurPass.blurMaterial.focusArea = value;
        this.updateParams();
    }
    /**
   * The softness of the focus area edges.
   *
   * @type {Number}
   */ get feather() {
        return this._feather;
    }
    set feather(value) {
        this._feather = value;
        this.blurPass.blurMaterial.feather = value;
        this.updateParams();
    }
    /**
   * A blend bias.
   *
   * @type {Number}
   * @deprecated
   */ get bias() {
        return 0;
    }
    set bias(value) {}
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        this.blurPass.render(renderer, inputBuffer, this.renderTarget);
    }
    /**
   * Updates the size of internal render targets.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
        this.blurPass.resolution.copy(resolution);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.blurPass.initialize(renderer, alpha, frameBufferType);
        if (frameBufferType !== void 0) {
            this.renderTarget.texture.type = frameBufferType;
            if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) this.renderTarget.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
        }
    }
};
// src/materials/glsl/adaptive-luminance.frag
var $2046da3312f94030$var$adaptive_luminance_default = `#include <packing>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
uniform lowp sampler2D luminanceBuffer0;uniform lowp sampler2D luminanceBuffer1;uniform float minLuminance;uniform float deltaTime;uniform float tau;varying vec2 vUv;void main(){float l0=unpackRGBAToFloat(texture2D(luminanceBuffer0,vUv));
#if __VERSION__ < 300
float l1=texture2DLodEXT(luminanceBuffer1,vUv,MIP_LEVEL_1X1).r;
#else
float l1=textureLod(luminanceBuffer1,vUv,MIP_LEVEL_1X1).r;
#endif
l0=max(minLuminance,l0);l1=max(minLuminance,l1);float adaptedLum=l0+(l1-l0)*(1.0-exp(-deltaTime*tau));gl_FragColor=(adaptedLum==1.0)?vec4(1.0):packFloatToRGBA(adaptedLum);}`;
// src/materials/AdaptiveLuminanceMaterial.js
var $2046da3312f94030$export$1756588d8d0bb63e = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new adaptive luminance material.
   */ constructor(){
        super({
            name: "AdaptiveLuminanceMaterial",
            defines: {
                MIP_LEVEL_1X1: "0.0"
            },
            uniforms: {
                luminanceBuffer0: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                luminanceBuffer1: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                minLuminance: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0.01),
                deltaTime: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0),
                tau: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
            },
            extensions: {
                shaderTextureLOD: true
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$adaptive_luminance_default,
            vertexShader: $2046da3312f94030$var$common_default
        });
    }
    /**
   * The primary luminance buffer that contains the downsampled average luminance.
   *
   * @type {Texture}
   */ set luminanceBuffer0(value) {
        this.uniforms.luminanceBuffer0.value = value;
    }
    /**
   * Sets the primary luminance buffer that contains the downsampled average luminance.
   *
   * @deprecated Use luminanceBuffer0 instead.
   * @param {Texture} value - The buffer.
   */ setLuminanceBuffer0(value) {
        this.uniforms.luminanceBuffer0.value = value;
    }
    /**
   * The secondary luminance buffer.
   *
   * @type {Texture}
   */ set luminanceBuffer1(value) {
        this.uniforms.luminanceBuffer1.value = value;
    }
    /**
   * Sets the secondary luminance buffer.
   *
   * @deprecated Use luminanceBuffer1 instead.
   * @param {Texture} value - The buffer.
   */ setLuminanceBuffer1(value) {
        this.uniforms.luminanceBuffer1.value = value;
    }
    /**
   * The 1x1 mipmap level.
   *
   * This level is used to identify the smallest mipmap of the primary luminance buffer.
   *
   * @type {Number}
   */ set mipLevel1x1(value) {
        this.defines.MIP_LEVEL_1X1 = value.toFixed(1);
        this.needsUpdate = true;
    }
    /**
   * Sets the 1x1 mipmap level.
   *
   * @deprecated Use mipLevel1x1 instead.
   * @param {Number} value - The level.
   */ setMipLevel1x1(value) {
        this.mipLevel1x1 = value;
    }
    /**
   * The delta time.
   *
   * @type {Number}
   */ set deltaTime(value) {
        this.uniforms.deltaTime.value = value;
    }
    /**
   * Sets the delta time.
   *
   * @deprecated Use deltaTime instead.
   * @param {Number} value - The delta time.
   */ setDeltaTime(value) {
        this.uniforms.deltaTime.value = value;
    }
    /**
   * The lowest possible luminance value.
   *
   * @type {Number}
   */ get minLuminance() {
        return this.uniforms.minLuminance.value;
    }
    set minLuminance(value) {
        this.uniforms.minLuminance.value = value;
    }
    /**
   * Returns the lowest possible luminance value.
   *
   * @deprecated Use minLuminance instead.
   * @return {Number} The minimum luminance.
   */ getMinLuminance() {
        return this.uniforms.minLuminance.value;
    }
    /**
   * Sets the minimum luminance.
   *
   * @deprecated Use minLuminance instead.
   * @param {Number} value - The minimum luminance.
   */ setMinLuminance(value) {
        this.uniforms.minLuminance.value = value;
    }
    /**
   * The luminance adaptation rate.
   *
   * @type {Number}
   */ get adaptationRate() {
        return this.uniforms.tau.value;
    }
    set adaptationRate(value) {
        this.uniforms.tau.value = value;
    }
    /**
   * Returns the luminance adaptation rate.
   *
   * @deprecated Use adaptationRate instead.
   * @return {Number} The adaptation rate.
   */ getAdaptationRate() {
        return this.uniforms.tau.value;
    }
    /**
   * Sets the luminance adaptation rate.
   *
   * @deprecated Use adaptationRate instead.
   * @param {Number} value - The adaptation rate.
   */ setAdaptationRate(value) {
        this.uniforms.tau.value = value;
    }
};
// src/passes/AdaptiveLuminancePass.js
var $2046da3312f94030$export$cefb3791de100f47 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new adaptive luminance pass.
   *
   * @param {Texture} luminanceBuffer - A buffer that contains the current scene luminance.
   * @param {Object} [options] - The options.
   * @param {Number} [options.minLuminance=0.01] - The minimum luminance.
   * @param {Number} [options.adaptationRate=1.0] - The luminance adaptation rate.
   */ constructor(luminanceBuffer, { minLuminance: minLuminance = 0.01, adaptationRate: adaptationRate = 1 } = {}){
        super("AdaptiveLuminancePass");
        this.fullscreenMaterial = new $2046da3312f94030$export$1756588d8d0bb63e();
        this.needsSwap = false;
        this.renderTargetPrevious = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            minFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
            magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
            depthBuffer: false
        });
        this.renderTargetPrevious.texture.name = "Luminance.Previous";
        const material = this.fullscreenMaterial;
        material.luminanceBuffer0 = this.renderTargetPrevious.texture;
        material.luminanceBuffer1 = luminanceBuffer;
        material.minLuminance = minLuminance;
        material.adaptationRate = adaptationRate;
        this.renderTargetAdapted = this.renderTargetPrevious.clone();
        this.renderTargetAdapted.texture.name = "Luminance.Adapted";
        this.copyPass = new $2046da3312f94030$export$ec9e16bd0f76e979(this.renderTargetPrevious, false);
    }
    /**
   * The adaptive luminance texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTargetAdapted.texture;
    }
    /**
   * Returns the adaptive 1x1 luminance texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTargetAdapted.texture;
    }
    /**
   * Sets the 1x1 mipmap level.
   *
   * This level is used to identify the smallest mipmap of the main luminance texture which contains the downsampled
   * average scene luminance.
   *
   * @type {Number}
   * @deprecated Use fullscreenMaterial.mipLevel1x1 instead.
   */ set mipLevel1x1(value) {
        this.fullscreenMaterial.mipLevel1x1 = value;
    }
    /**
   * The luminance adaptation rate.
   *
   * @type {Number}
   * @deprecated Use fullscreenMaterial.adaptationRate instead.
   */ get adaptationRate() {
        return this.fullscreenMaterial.adaptationRate;
    }
    /**
   * @type {Number}
   * @deprecated Use fullscreenMaterial.adaptationRate instead.
   */ set adaptationRate(value) {
        this.fullscreenMaterial.adaptationRate = value;
    }
    /**
   * Renders the scene normals.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        this.fullscreenMaterial.deltaTime = deltaTime;
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTargetAdapted);
        renderer.render(this.scene, this.camera);
        this.copyPass.render(renderer, this.renderTargetAdapted);
    }
};
// src/effects/glsl/tone-mapping.frag
var $2046da3312f94030$var$tone_mapping_default = `#include <tonemapping_pars_fragment>
uniform float whitePoint;
#if TONE_MAPPING_MODE == 2 || TONE_MAPPING_MODE == 3
uniform float middleGrey;
#if TONE_MAPPING_MODE == 3
uniform lowp sampler2D luminanceBuffer;
#else
uniform float averageLuminance;
#endif
vec3 Reinhard2ToneMapping(vec3 color){color*=toneMappingExposure;float l=luminance(color);
#if TONE_MAPPING_MODE == 3
float lumAvg=unpackRGBAToFloat(texture2D(luminanceBuffer,vec2(0.5)));
#else
float lumAvg=averageLuminance;
#endif
float lumScaled=(l*middleGrey)/max(lumAvg,1e-6);float lumCompressed=lumScaled*(1.0+lumScaled/(whitePoint*whitePoint));lumCompressed/=(1.0+lumScaled);return clamp(lumCompressed*color,0.0,1.0);}
#elif TONE_MAPPING_MODE == 4
#define A 0.15
#define B 0.50
#define C 0.10
#define D 0.20
#define E 0.02
#define F 0.30
vec3 Uncharted2Helper(const in vec3 x){return((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}vec3 Uncharted2ToneMapping(vec3 color){color*=toneMappingExposure;return clamp(Uncharted2Helper(color)/Uncharted2Helper(vec3(whitePoint)),0.0,1.0);}
#endif
void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){
#if TONE_MAPPING_MODE == 2 || TONE_MAPPING_MODE == 3
outputColor=vec4(Reinhard2ToneMapping(inputColor.rgb),inputColor.a);
#elif TONE_MAPPING_MODE == 4
outputColor=vec4(Uncharted2ToneMapping(inputColor.rgb),inputColor.a);
#else
outputColor=vec4(toneMapping(inputColor.rgb),inputColor.a);
#endif
}`;
// src/effects/ToneMappingEffect.js
var $2046da3312f94030$export$6df7d6dd546cd57a = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new tone mapping effect.
   *
   * The additional parameters only affect the Reinhard2 operator.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction=BlendFunction.SRC] - The blend function of this effect.
   * @param {Boolean} [options.adaptive=false] - Deprecated. Use mode instead.
   * @param {ToneMappingMode} [options.mode=ToneMappingMode.AGX] - The tone mapping mode.
   * @param {Number} [options.resolution=256] - The resolution of the luminance texture. Must be a power of two.
   * @param {Number} [options.maxLuminance=4.0] - Deprecated. Same as whitePoint.
   * @param {Number} [options.whitePoint=4.0] - The white point.
   * @param {Number} [options.middleGrey=0.6] - The middle grey factor.
   * @param {Number} [options.minLuminance=0.01] - The minimum luminance. Prevents very high exposure in dark scenes.
   * @param {Number} [options.averageLuminance=1.0] - The average luminance. Used for the non-adaptive Reinhard operator.
   * @param {Number} [options.adaptationRate=1.0] - The luminance adaptation rate.
   */ constructor({ blendFunction: blendFunction = $2046da3312f94030$export$ea7520add44ba1b6.SRC, adaptive: adaptive = false, mode: mode = adaptive ? $2046da3312f94030$export$f72cb1a914b4b608.REINHARD2_ADAPTIVE : $2046da3312f94030$export$f72cb1a914b4b608.AGX, resolution: resolution = 256, maxLuminance: maxLuminance = 4, whitePoint: whitePoint = maxLuminance, middleGrey: middleGrey = 0.6, minLuminance: minLuminance = 0.01, averageLuminance: averageLuminance = 1, adaptationRate: adaptationRate = 1 } = {}){
        super("ToneMappingEffect", $2046da3312f94030$var$tone_mapping_default, {
            blendFunction: blendFunction,
            uniforms: /* @__PURE__ */ new Map([
                [
                    "luminanceBuffer",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null)
                ],
                [
                    "maxLuminance",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(maxLuminance)
                ],
                // Unused
                [
                    "whitePoint",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(whitePoint)
                ],
                [
                    "middleGrey",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(middleGrey)
                ],
                [
                    "averageLuminance",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(averageLuminance)
                ]
            ])
        });
        this.renderTargetLuminance = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            minFilter: (0, $ce0cdebec9150cb3$export$5d8599b6a933fb1b),
            depthBuffer: false
        });
        this.renderTargetLuminance.texture.generateMipmaps = true;
        this.renderTargetLuminance.texture.name = "Luminance";
        this.luminancePass = new $2046da3312f94030$export$855ea63a754bfd18({
            renderTarget: this.renderTargetLuminance
        });
        this.adaptiveLuminancePass = new $2046da3312f94030$export$cefb3791de100f47(this.luminancePass.texture, {
            minLuminance: minLuminance,
            adaptationRate: adaptationRate
        });
        this.uniforms.get("luminanceBuffer").value = this.adaptiveLuminancePass.texture;
        this.resolution = resolution;
        this.mode = mode;
    }
    /**
   * The tone mapping mode.
   *
   * @type {ToneMappingMode}
   */ get mode() {
        return Number(this.defines.get("TONE_MAPPING_MODE"));
    }
    set mode(value) {
        if (this.mode === value) return;
        const revision = (0, $ce0cdebec9150cb3$export$3545e07a80636437).replace(/\D+/g, "");
        const cineonToneMapping = revision >= 168 ? "CineonToneMapping(texel)" : "OptimizedCineonToneMapping(texel)";
        this.defines.clear();
        this.defines.set("TONE_MAPPING_MODE", value.toFixed(0));
        switch(value){
            case $2046da3312f94030$export$f72cb1a914b4b608.LINEAR:
                this.defines.set("toneMapping(texel)", "LinearToneMapping(texel)");
                break;
            case $2046da3312f94030$export$f72cb1a914b4b608.REINHARD:
                this.defines.set("toneMapping(texel)", "ReinhardToneMapping(texel)");
                break;
            case $2046da3312f94030$export$f72cb1a914b4b608.CINEON:
            case $2046da3312f94030$export$f72cb1a914b4b608.OPTIMIZED_CINEON:
                this.defines.set("toneMapping(texel)", cineonToneMapping);
                break;
            case $2046da3312f94030$export$f72cb1a914b4b608.ACES_FILMIC:
                this.defines.set("toneMapping(texel)", "ACESFilmicToneMapping(texel)");
                break;
            case $2046da3312f94030$export$f72cb1a914b4b608.AGX:
                this.defines.set("toneMapping(texel)", "AgXToneMapping(texel)");
                break;
            case $2046da3312f94030$export$f72cb1a914b4b608.NEUTRAL:
                this.defines.set("toneMapping(texel)", "NeutralToneMapping(texel)");
                break;
            default:
                this.defines.set("toneMapping(texel)", "texel");
                break;
        }
        this.adaptiveLuminancePass.enabled = value === $2046da3312f94030$export$f72cb1a914b4b608.REINHARD2_ADAPTIVE;
        this.setChanged();
    }
    /**
   * Returns the current tone mapping mode.
   *
   * @deprecated Use mode instead.
   * @return {ToneMappingMode} The tone mapping mode.
   */ getMode() {
        return this.mode;
    }
    /**
   * Sets the tone mapping mode.
   *
   * @deprecated Use mode instead.
   * @param {ToneMappingMode} value - The tone mapping mode.
   */ setMode(value) {
        this.mode = value;
    }
    /**
   * The white point. Default is `4.0`.
   *
   * Only applies to Reinhard2 (Modified & Adaptive).
   *
   * @type {Number}
   */ get whitePoint() {
        return this.uniforms.get("whitePoint").value;
    }
    set whitePoint(value) {
        this.uniforms.get("whitePoint").value = value;
    }
    /**
   * The middle grey factor. Default is `0.6`.
   *
   * Only applies to Reinhard2 (Modified & Adaptive).
   *
   * @type {Number}
   */ get middleGrey() {
        return this.uniforms.get("middleGrey").value;
    }
    set middleGrey(value) {
        this.uniforms.get("middleGrey").value = value;
    }
    /**
   * The average luminance.
   *
   * Only applies to Reinhard2 (Modified).
   *
   * @type {Number}
   */ get averageLuminance() {
        return this.uniforms.get("averageLuminance").value;
    }
    set averageLuminance(value) {
        this.uniforms.get("averageLuminance").value = value;
    }
    /**
   * The adaptive luminance material.
   *
   * @type {AdaptiveLuminanceMaterial}
   */ get adaptiveLuminanceMaterial() {
        return this.adaptiveLuminancePass.fullscreenMaterial;
    }
    /**
   * Returns the adaptive luminance material.
   *
   * @deprecated Use adaptiveLuminanceMaterial instead.
   * @return {AdaptiveLuminanceMaterial} The material.
   */ getAdaptiveLuminanceMaterial() {
        return this.adaptiveLuminanceMaterial;
    }
    /**
   * The resolution of the luminance texture. Must be a power of two.
   *
   * @type {Number}
   */ get resolution() {
        return this.luminancePass.resolution.width;
    }
    set resolution(value) {
        const exponent = Math.max(0, Math.ceil(Math.log2(value)));
        const size = Math.pow(2, exponent);
        this.luminancePass.resolution.setPreferredSize(size, size);
        this.adaptiveLuminanceMaterial.mipLevel1x1 = exponent;
    }
    /**
   * Returns the resolution of the luminance texture.
   *
   * @deprecated Use resolution instead.
   * @return {Number} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Sets the resolution of the luminance texture. Must be a power of two.
   *
   * @deprecated Use resolution instead.
   * @param {Number} value - The resolution.
   */ setResolution(value) {
        this.resolution = value;
    }
    /**
   * Indicates whether this pass uses adaptive luminance.
   *
   * @type {Boolean}
   * @deprecated Use mode instead.
   */ get adaptive() {
        return this.mode === $2046da3312f94030$export$f72cb1a914b4b608.REINHARD2_ADAPTIVE;
    }
    set adaptive(value) {
        this.mode = value ? $2046da3312f94030$export$f72cb1a914b4b608.REINHARD2_ADAPTIVE : $2046da3312f94030$export$f72cb1a914b4b608.REINHARD2;
    }
    /**
   * The luminance adaptation rate.
   *
   * @type {Number}
   * @deprecated Use adaptiveLuminanceMaterial.adaptationRate instead.
   */ get adaptationRate() {
        return this.adaptiveLuminanceMaterial.adaptationRate;
    }
    set adaptationRate(value) {
        this.adaptiveLuminanceMaterial.adaptationRate = value;
    }
    /**
   * @type {Number}
   * @deprecated
   */ get distinction() {
        console.warn(this.name, "distinction was removed.");
        return 1;
    }
    set distinction(value) {
        console.warn(this.name, "distinction was removed.");
    }
    /**
   * Updates this effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   */ update(renderer, inputBuffer, deltaTime) {
        if (this.adaptiveLuminancePass.enabled) {
            this.luminancePass.render(renderer, inputBuffer);
            this.adaptiveLuminancePass.render(renderer, null, null, deltaTime);
        }
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.adaptiveLuminancePass.initialize(renderer, alpha, frameBufferType);
    }
};
// src/effects/glsl/vignette.frag
var $2046da3312f94030$var$vignette_default = `uniform float offset;uniform float darkness;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){const vec2 center=vec2(0.5);vec3 color=inputColor.rgb;
#if VIGNETTE_TECHNIQUE == 0
float d=distance(uv,center);color*=smoothstep(0.8,offset*0.799,d*(darkness+offset));
#else
vec2 coord=(uv-center)*vec2(offset);color=mix(color,vec3(1.0-darkness),dot(coord,coord));
#endif
outputColor=vec4(color,inputColor.a);}`;
// src/effects/VignetteEffect.js
var $2046da3312f94030$export$f32350b7e107bb62 = class extends $2046da3312f94030$export$a32b0b1c1ac59d04 {
    /**
   * Constructs a new Vignette effect.
   *
   * @param {Object} [options] - The options.
   * @param {BlendFunction} [options.blendFunction] - The blend function of this effect.
   * @param {VignetteTechnique} [options.technique=VignetteTechnique.DEFAULT] - The Vignette technique.
   * @param {Boolean} [options.eskil=false] - Deprecated. Use technique instead.
   * @param {Number} [options.offset=0.5] - The Vignette offset.
   * @param {Number} [options.darkness=0.5] - The Vignette darkness.
   */ constructor({ blendFunction: blendFunction, eskil: eskil = false, technique: technique = eskil ? $2046da3312f94030$export$57fe020f9fbd56c7.ESKIL : $2046da3312f94030$export$57fe020f9fbd56c7.DEFAULT, offset: offset = 0.5, darkness: darkness = 0.5 } = {}){
        super("VignetteEffect", $2046da3312f94030$var$vignette_default, {
            blendFunction: blendFunction,
            defines: /* @__PURE__ */ new Map([
                [
                    "VIGNETTE_TECHNIQUE",
                    technique.toFixed(0)
                ]
            ]),
            uniforms: /* @__PURE__ */ new Map([
                [
                    "offset",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(offset)
                ],
                [
                    "darkness",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(darkness)
                ]
            ])
        });
    }
    /**
   * The Vignette technique.
   *
   * @type {VignetteTechnique}
   */ get technique() {
        return Number(this.defines.get("VIGNETTE_TECHNIQUE"));
    }
    set technique(value) {
        if (this.technique !== value) {
            this.defines.set("VIGNETTE_TECHNIQUE", value.toFixed(0));
            this.setChanged();
        }
    }
    /**
   * Indicates whether Eskil's Vignette technique is enabled.
   *
   * @type {Boolean}
   * @deprecated Use technique instead.
   */ get eskil() {
        return this.technique === $2046da3312f94030$export$57fe020f9fbd56c7.ESKIL;
    }
    /**
   * Indicates whether Eskil's Vignette technique is enabled.
   *
   * @type {Boolean}
   * @deprecated Use technique instead.
   */ set eskil(value) {
        this.technique = value ? $2046da3312f94030$export$57fe020f9fbd56c7.ESKIL : $2046da3312f94030$export$57fe020f9fbd56c7.DEFAULT;
    }
    /**
   * Returns the Vignette technique.
   *
   * @deprecated Use technique instead.
   * @return {VignetteTechnique} The technique.
   */ getTechnique() {
        return this.technique;
    }
    /**
   * Sets the Vignette technique.
   *
   * @deprecated Use technique instead.
   * @param {VignetteTechnique} value - The technique.
   */ setTechnique(value) {
        this.technique = value;
    }
    /**
   * The Vignette offset.
   *
   * @type {Number}
   */ get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(value) {
        this.uniforms.get("offset").value = value;
    }
    /**
   * Returns the Vignette offset.
   *
   * @deprecated Use offset instead.
   * @return {Number} The offset.
   */ getOffset() {
        return this.offset;
    }
    /**
   * Sets the Vignette offset.
   *
   * @deprecated Use offset instead.
   * @param {Number} value - The offset.
   */ setOffset(value) {
        this.offset = value;
    }
    /**
   * The Vignette darkness.
   *
   * @type {Number}
   */ get darkness() {
        return this.uniforms.get("darkness").value;
    }
    set darkness(value) {
        this.uniforms.get("darkness").value = value;
    }
    /**
   * Returns the Vignette darkness.
   *
   * @deprecated Use darkness instead.
   * @return {Number} The darkness.
   */ getDarkness() {
        return this.darkness;
    }
    /**
   * Sets the Vignette darkness.
   *
   * @deprecated Use darkness instead.
   * @param {Number} value - The darkness.
   */ setDarkness(value) {
        this.darkness = value;
    }
};
var $2046da3312f94030$export$cb134e582ee96ec4 = class extends (0, $ce0cdebec9150cb3$export$3b0d6d7590275603) {
    /**
   * Loads a LUT.
   *
   * @param {String} url - The URL of the 3dl-file.
   * @param {Function} [onLoad] - A callback that receives the loaded lookup texture.
   * @param {Function} [onProgress] - A progress callback that receives the XMLHttpRequest instance.
   * @param {Function} [onError] - An error callback that receives the URL of the file that failed to load.
   */ load(url, onLoad = ()=>{}, onProgress = ()=>{}, onError = null) {
        const externalManager = this.manager;
        const internalManager = new (0, $ce0cdebec9150cb3$export$99cc795e99919eed)();
        const loader = new (0, $ce0cdebec9150cb3$export$98435a25b5cf7b2b)(internalManager);
        loader.setPath(this.path);
        loader.setResponseType("text");
        externalManager.itemStart(url);
        loader.load(url, (data)=>{
            try {
                const result = this.parse(data);
                externalManager.itemEnd(url);
                onLoad(result);
            } catch (e) {
                internalManager.onError(url);
                onError(e);
            }
        }, onProgress);
    }
    /**
   * Loads a LUT.
   *
   * @param {String} url - The URL of the 3dl-file.
   * @param {Function} [onProgress] - A progress callback that receives the XMLHttpRequest instance.
   * @return {Promise<LookupTexture>} A promise that returns the lookup texture.
   */ loadAsync(url, onProgress = ()=>{}) {
        const externalManager = this.manager;
        const internalManager = new (0, $ce0cdebec9150cb3$export$99cc795e99919eed)();
        return new Promise((resolve, reject)=>{
            internalManager.onError = (url2)=>{
                externalManager.itemError(url2);
                reject(`Failed to load ${url2}`);
            };
            this.load(url, resolve, onProgress);
        });
    }
    /**
   * Parses the given data.
   *
   * @param {String} input - The LUT data.
   * @return {LookupTexture} The lookup texture.
   * @throws {Error} Fails if the data is invalid.
   */ parse(input) {
        const regExpGridInfo = /^[\d ]+$/m;
        const regExpDataPoints = /^([\d.e+-]+) +([\d.e+-]+) +([\d.e+-]+) *$/gm;
        let result = regExpGridInfo.exec(input);
        if (result === null) throw new Error("Missing grid information");
        const gridLines = result[0].trim().split(/\s+/g).map((n)=>Number(n));
        const gridStep = gridLines[1] - gridLines[0];
        const size = gridLines.length;
        const sizeSq = size ** 2;
        for(let i = 1, l = gridLines.length; i < l; ++i){
            if (gridStep !== gridLines[i] - gridLines[i - 1]) throw new Error("Inconsistent grid size");
        }
        const data = new Float32Array(size ** 3 * 4);
        let maxValue = 0;
        let index = 0;
        while((result = regExpDataPoints.exec(input)) !== null){
            const r = Number(result[1]);
            const g = Number(result[2]);
            const b = Number(result[3]);
            maxValue = Math.max(maxValue, r, g, b);
            const bLayer = index % size;
            const gLayer = Math.floor(index / size) % size;
            const rLayer = Math.floor(index / sizeSq) % size;
            const d4 = (bLayer * sizeSq + gLayer * size + rLayer) * 4;
            data[d4 + 0] = r;
            data[d4 + 1] = g;
            data[d4 + 2] = b;
            data[d4 + 3] = 1;
            ++index;
        }
        const bits = Math.ceil(Math.log2(maxValue));
        const maxBitValue = Math.pow(2, bits);
        for(let i = 0, l = data.length; i < l; i += 4){
            data[i + 0] /= maxBitValue;
            data[i + 1] /= maxBitValue;
            data[i + 2] /= maxBitValue;
        }
        return new $2046da3312f94030$export$a3627e735a49df45(data, size);
    }
};
var $2046da3312f94030$export$69bfa3b61900cd8b = class extends (0, $ce0cdebec9150cb3$export$3b0d6d7590275603) {
    /**
   * Loads a LUT.
   *
   * @param {String} url - The URL of the CUBE-file.
   * @param {Function} [onLoad] - A callback that receives the loaded lookup texture.
   * @param {Function} [onProgress] - A progress callback that receives the XMLHttpRequest instance.
   * @param {Function} [onError] - An error callback that receives the URL of the file that failed to load.
   */ load(url, onLoad = ()=>{}, onProgress = ()=>{}, onError = null) {
        const externalManager = this.manager;
        const internalManager = new (0, $ce0cdebec9150cb3$export$99cc795e99919eed)();
        const loader = new (0, $ce0cdebec9150cb3$export$98435a25b5cf7b2b)(internalManager);
        loader.setPath(this.path);
        loader.setResponseType("text");
        loader.load(url, (data)=>{
            try {
                const result = this.parse(data);
                externalManager.itemEnd(url);
                onLoad(result);
            } catch (e) {
                internalManager.onError(url);
                onError(e);
            }
        }, onProgress);
    }
    /**
   * Loads a LUT asynchronously.
   *
   * @param {String} url - The URL of the CUBE-file.
   * @param {Function} [onProgress] - A progress callback that receives the XMLHttpRequest instance.
   * @return {Promise<LookupTexture>} A promise that returns the lookup texture.
   */ loadAsync(url, onProgress = ()=>{}) {
        const externalManager = this.manager;
        const internalManager = new (0, $ce0cdebec9150cb3$export$99cc795e99919eed)();
        return new Promise((resolve, reject)=>{
            internalManager.onError = (url2)=>{
                externalManager.itemError(url2);
                reject(`Failed to load ${url2}`);
            };
            this.load(url, resolve, onProgress);
        });
    }
    /**
   * Parses the given data.
   *
   * @param {String} input - The LUT data.
   * @return {LookupTexture} The lookup texture.
   * @throws {Error} Fails if the data is invalid.
   */ parse(input) {
        const regExpTitle = /TITLE +"([^"]*)"/;
        const regExpSize = /LUT_3D_SIZE +(\d+)/;
        const regExpDomainMin = /DOMAIN_MIN +([\d.]+) +([\d.]+) +([\d.]+)/;
        const regExpDomainMax = /DOMAIN_MAX +([\d.]+) +([\d.]+) +([\d.]+)/;
        const regExpDataPoints = /^([\d.e+-]+) +([\d.e+-]+) +([\d.e+-]+) *$/gm;
        let result = regExpTitle.exec(input);
        const title = result !== null ? result[1] : null;
        result = regExpSize.exec(input);
        if (result === null) throw new Error("Missing LUT_3D_SIZE information");
        const size = Number(result[1]);
        const data = new Float32Array(size ** 3 * 4);
        const domainMin = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 0, 0);
        const domainMax = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(1, 1, 1);
        result = regExpDomainMin.exec(input);
        if (result !== null) domainMin.set(Number(result[1]), Number(result[2]), Number(result[3]));
        result = regExpDomainMax.exec(input);
        if (result !== null) domainMax.set(Number(result[1]), Number(result[2]), Number(result[3]));
        if (domainMin.x > domainMax.x || domainMin.y > domainMax.y || domainMin.z > domainMax.z) {
            domainMin.set(0, 0, 0);
            domainMax.set(1, 1, 1);
            throw new Error("Invalid input domain");
        }
        let i = 0;
        while((result = regExpDataPoints.exec(input)) !== null){
            data[i++] = Number(result[1]);
            data[i++] = Number(result[2]);
            data[i++] = Number(result[3]);
            data[i++] = 1;
        }
        const lut = new $2046da3312f94030$export$a3627e735a49df45(data, size);
        lut.domainMin.copy(domainMin);
        lut.domainMax.copy(domainMax);
        if (title !== null) lut.name = title;
        return lut;
    }
};
var $2046da3312f94030$export$aabc8868efe21aac = class extends (0, $ce0cdebec9150cb3$export$3b0d6d7590275603) {
    /**
   * Loads the SMAA data images.
   *
   * @param {Function} [onLoad] - A callback that receives the search image and area image as a pair.
   * @param {Function} [onError] - An error callback that receives the URL of the image that failed to load.
   * @return {Promise<Image[]>} A promise that returns the search image and area image as a pair.
   */ load(onLoad = ()=>{}, onError = null) {
        if (arguments.length === 4) {
            onLoad = arguments[1];
            onError = arguments[3];
        } else if (arguments.length === 3 || typeof arguments[0] !== "function") {
            onLoad = arguments[1];
            onError = null;
        }
        const externalManager = this.manager;
        const internalManager = new (0, $ce0cdebec9150cb3$export$99cc795e99919eed)();
        return new Promise((resolve, reject)=>{
            const searchImage = new Image();
            const areaImage = new Image();
            internalManager.onError = (url)=>{
                externalManager.itemError(url);
                if (onError !== null) {
                    onError(`Failed to load ${url}`);
                    resolve();
                } else reject(`Failed to load ${url}`);
            };
            internalManager.onLoad = ()=>{
                const result = [
                    searchImage,
                    areaImage
                ];
                onLoad(result);
                resolve(result);
            };
            searchImage.addEventListener("error", (e)=>{
                internalManager.itemError("smaa-search");
            });
            areaImage.addEventListener("error", (e)=>{
                internalManager.itemError("smaa-area");
            });
            searchImage.addEventListener("load", ()=>{
                externalManager.itemEnd("smaa-search");
                internalManager.itemEnd("smaa-search");
            });
            areaImage.addEventListener("load", ()=>{
                externalManager.itemEnd("smaa-area");
                internalManager.itemEnd("smaa-area");
            });
            externalManager.itemStart("smaa-search");
            externalManager.itemStart("smaa-area");
            internalManager.itemStart("smaa-search");
            internalManager.itemStart("smaa-area");
            searchImage.src = $2046da3312f94030$var$searchImageDataURL_default;
            areaImage.src = $2046da3312f94030$var$areaImageDataURL_default;
        });
    }
};
// src/materials/glsl/convolution.box.frag
var $2046da3312f94030$var$convolution_box_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef BILATERAL
#include <packing>
uniform vec2 cameraNearFar;
#define cameraNear cameraNearFar.x
#define cameraFar cameraNearFar.y
#ifdef NORMAL_DEPTH
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D normalDepthBuffer;
#else
uniform mediump sampler2D normalDepthBuffer;
#endif
float readDepth(const in vec2 uv){float depth=texture2D(normalDepthBuffer,uv).a;
#if defined(USE_LOGARITHMIC_DEPTH_BUFFER) || defined(LOG_DEPTH)
float d=pow(2.0,depth*log2(cameraFar+1.0))-1.0;float a=cameraFar/(cameraFar-cameraNear);float b=cameraFar*cameraNear/(cameraNear-cameraFar);depth=a+b/d;
#elif defined(USE_REVERSED_DEPTH_BUFFER)
depth=1.0-depth;
#endif
return depth;}
#else
#if DEPTH_PACKING == 3201
uniform lowp sampler2D depthBuffer;
#elif defined(GL_FRAGMENT_PRECISION_HIGH)
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
float depth=unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
float depth=texture2D(depthBuffer,uv).r;
#endif
#if defined(USE_LOGARITHMIC_DEPTH_BUFFER) || defined(LOG_DEPTH)
float d=pow(2.0,depth*log2(cameraFar+1.0))-1.0;float a=cameraFar/(cameraFar-cameraNear);float b=cameraFar*cameraNear/(cameraNear-cameraFar);depth=a+b/d;
#elif defined(USE_REVERSED_DEPTH_BUFFER)
depth=1.0-depth;
#endif
return depth;}
#endif
float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);
#else
return orthographicDepthToViewZ(depth,cameraNearFar.x,cameraNearFar.y);
#endif
}
#ifdef PERSPECTIVE_CAMERA
#define linearDepth(v) viewZToOrthographicDepth(getViewZ(readDepth(v)), cameraNearFar.x, cameraNearFar.y)
#else
#define linearDepth(v) readDepth(v)
#endif
#endif
#define getTexel(v) texture2D(inputBuffer, v)
#if KERNEL_SIZE == 3
varying vec2 vUv00,vUv01,vUv02;varying vec2 vUv03,vUv04,vUv05;varying vec2 vUv06,vUv07,vUv08;
#elif KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13
varying vec2 vUv00,vUv01,vUv02,vUv03,vUv04;varying vec2 vUv05,vUv06,vUv07,vUv08,vUv09;varying vec2 vUv10,vUv11,vUv12,vUv13,vUv14;varying vec2 vUv15,vUv16,vUv17,vUv18,vUv19;varying vec2 vUv20,vUv21,vUv22,vUv23,vUv24;
#else
uniform vec2 texelSize;uniform float scale;varying vec2 vUv;
#endif
void main(){
#if KERNEL_SIZE == 3
vec4 c[]=vec4[KERNEL_SIZE_SQ](getTexel(vUv00),getTexel(vUv01),getTexel(vUv02),getTexel(vUv03),getTexel(vUv04),getTexel(vUv05),getTexel(vUv06),getTexel(vUv07),getTexel(vUv08));
#ifdef BILATERAL
float z[]=float[KERNEL_SIZE_SQ](linearDepth(vUv00),linearDepth(vUv01),linearDepth(vUv02),linearDepth(vUv03),linearDepth(vUv04),linearDepth(vUv05),linearDepth(vUv06),linearDepth(vUv07),linearDepth(vUv08));
#endif
#elif KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13
vec4 c[]=vec4[KERNEL_SIZE_SQ](getTexel(vUv00),getTexel(vUv01),getTexel(vUv02),getTexel(vUv03),getTexel(vUv04),getTexel(vUv05),getTexel(vUv06),getTexel(vUv07),getTexel(vUv08),getTexel(vUv09),getTexel(vUv10),getTexel(vUv11),getTexel(vUv12),getTexel(vUv13),getTexel(vUv14),getTexel(vUv15),getTexel(vUv16),getTexel(vUv17),getTexel(vUv18),getTexel(vUv19),getTexel(vUv20),getTexel(vUv21),getTexel(vUv22),getTexel(vUv23),getTexel(vUv24));
#ifdef BILATERAL
float z[]=float[KERNEL_SIZE_SQ](linearDepth(vUv00),linearDepth(vUv01),linearDepth(vUv02),linearDepth(vUv03),linearDepth(vUv04),linearDepth(vUv05),linearDepth(vUv06),linearDepth(vUv07),linearDepth(vUv08),linearDepth(vUv09),linearDepth(vUv10),linearDepth(vUv11),linearDepth(vUv12),linearDepth(vUv13),linearDepth(vUv14),linearDepth(vUv15),linearDepth(vUv16),linearDepth(vUv17),linearDepth(vUv18),linearDepth(vUv19),linearDepth(vUv20),linearDepth(vUv21),linearDepth(vUv22),linearDepth(vUv23),linearDepth(vUv24));
#endif
#endif
vec4 result=vec4(0.0);
#ifdef BILATERAL
float w=0.0;
#if KERNEL_SIZE == 3 || (KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13)
float centerDepth=z[KERNEL_SIZE_SQ_HALF];for(int i=0;i<KERNEL_SIZE_SQ;++i){float d=step(abs(z[i]-centerDepth),DISTANCE_THRESHOLD);result+=c[i]*d;w+=d;}
#else
float centerDepth=linearDepth(vUv);vec2 s=texelSize*scale;for(int x=-KERNEL_SIZE_HALF;x<=KERNEL_SIZE_HALF;++x){for(int y=-KERNEL_SIZE_HALF;y<=KERNEL_SIZE_HALF;++y){vec2 coords=vUv+vec2(x,y)*s;vec4 c=getTexel(coords);float z=(x==0&&y==0)?centerDepth:linearDepth(coords);float d=step(abs(z-centerDepth),DISTANCE_THRESHOLD);result+=c*d;w+=d;}}
#endif
gl_FragColor=result/max(w,1.0);
#else
#if KERNEL_SIZE == 3 || (KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13)
for(int i=0;i<KERNEL_SIZE_SQ;++i){result+=c[i];}
#else
vec2 s=texelSize*scale;for(int x=-KERNEL_SIZE_HALF;x<=KERNEL_SIZE_HALF;++x){for(int y=-KERNEL_SIZE_HALF;y<=KERNEL_SIZE_HALF;++y){result+=getTexel(uv+vec2(x,y)*s);}}
#endif
gl_FragColor=result*INV_KERNEL_SIZE_SQ;
#endif
}`;
// src/materials/glsl/convolution.box.vert
var $2046da3312f94030$var$convolution_box_default2 = `uniform vec2 texelSize;uniform float scale;
#if KERNEL_SIZE == 3
varying vec2 vUv00,vUv01,vUv02;varying vec2 vUv03,vUv04,vUv05;varying vec2 vUv06,vUv07,vUv08;
#elif KERNEL_SIZE == 5 && MAX_VARYING_VECTORS >= 13
varying vec2 vUv00,vUv01,vUv02,vUv03,vUv04;varying vec2 vUv05,vUv06,vUv07,vUv08,vUv09;varying vec2 vUv10,vUv11,vUv12,vUv13,vUv14;varying vec2 vUv15,vUv16,vUv17,vUv18,vUv19;varying vec2 vUv20,vUv21,vUv22,vUv23,vUv24;
#else
varying vec2 vUv;
#endif
void main(){vec2 uv=position.xy*0.5+0.5;
#if KERNEL_SIZE == 3
vec2 s=texelSize*scale;vUv00=uv+s*vec2(-1.0,-1.0);vUv01=uv+s*vec2(0.0,-1.0);vUv02=uv+s*vec2(1.0,-1.0);vUv03=uv+s*vec2(-1.0,0.0);vUv04=uv;vUv05=uv+s*vec2(1.0,0.0);vUv06=uv+s*vec2(-1.0,1.0);vUv07=uv+s*vec2(0.0,1.0);vUv08=uv+s*vec2(1.0,1.0);
#elif KERNEL_SIZE == 5
vec2 s=texelSize*scale;vUv00=uv+s*vec2(-2.0,-2.0);vUv01=uv+s*vec2(-1.0,-2.0);vUv02=uv+s*vec2(0.0,-2.0);vUv03=uv+s*vec2(1.0,-2.0);vUv04=uv+s*vec2(2.0,-2.0);vUv05=uv+s*vec2(-2.0,-1.0);vUv06=uv+s*vec2(-1.0,-1.0);vUv07=uv+s*vec2(0.0,-1.0);vUv08=uv+s*vec2(1.0,-1.0);vUv09=uv+s*vec2(2.0,-1.0);vUv10=uv+s*vec2(-2.0,0.0);vUv11=uv+s*vec2(-1.0,0.0);vUv12=uv;vUv13=uv+s*vec2(1.0,0.0);vUv14=uv+s*vec2(2.0,0.0);vUv15=uv+s*vec2(-2.0,1.0);vUv16=uv+s*vec2(-1.0,1.0);vUv17=uv+s*vec2(0.0,1.0);vUv18=uv+s*vec2(1.0,1.0);vUv19=uv+s*vec2(2.0,1.0);vUv20=uv+s*vec2(-2.0,2.0);vUv21=uv+s*vec2(-1.0,2.0);vUv22=uv+s*vec2(0.0,2.0);vUv23=uv+s*vec2(1.0,2.0);vUv24=uv+s*vec2(2.0,2.0);
#else
vUv=uv;
#endif
gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/BoxBlurMaterial.js
var $2046da3312f94030$export$d331d314f1169029 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new box blur material.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.bilateral=false] - Enables or disables bilateral blurring.
   * @param {Number} [options.kernelSize=5] - The kernel size.
   */ constructor({ bilateral: bilateral = false, kernelSize: kernelSize = 5 } = {}){
        super({
            name: "BoxBlurMaterial",
            defines: {
                DEPTH_PACKING: "0",
                DISTANCE_THRESHOLD: "0.1"
            },
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                depthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                normalDepthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                cameraNearFar: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                scale: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$convolution_box_default,
            vertexShader: $2046da3312f94030$var$convolution_box_default2
        });
        this.bilateral = bilateral;
        this.kernelSize = kernelSize;
        this.maxVaryingVectors = 8;
    }
    /**
   * The maximum amount of varying vectors.
   *
   * Should be synced with `renderer.capabilities.maxVaryings`. Default is 8.
   *
   * @type {Number}
   */ set maxVaryingVectors(value) {
        this.defines.MAX_VARYING_VECTORS = value.toFixed(0);
    }
    /**
   * The kernel size.
   *
   * - Must be an odd number
   * - Kernel size 3 and 5 use optimized code paths
   * - Default is 5
   *
   * @type {Number}
   */ get kernelSize() {
        return Number(this.defines.KERNEL_SIZE);
    }
    set kernelSize(value) {
        if (value % 2 === 0) throw new Error("The kernel size must be an odd number");
        this.defines.KERNEL_SIZE = value.toFixed(0);
        this.defines.KERNEL_SIZE_HALF = Math.floor(value / 2).toFixed(0);
        this.defines.KERNEL_SIZE_SQ = (value ** 2).toFixed(0);
        this.defines.KERNEL_SIZE_SQ_HALF = Math.floor(value ** 2 / 2).toFixed(0);
        this.defines.INV_KERNEL_SIZE_SQ = (1 / value ** 2).toFixed(6);
        this.needsUpdate = true;
    }
    /**
   * The blur scale.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.scale.value;
    }
    set scale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * The current near plane setting.
   *
   * @type {Number}
   * @private
   */ get near() {
        return this.uniforms.cameraNearFar.value.x;
    }
    /**
   * The current far plane setting.
   *
   * @type {Number}
   * @private
   */ get far() {
        return this.uniforms.cameraNearFar.value.y;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * A combined normal-depth buffer. Overrides {@link depthBuffer} if set.
   *
   * @type {Texture}
   */ set normalDepthBuffer(value) {
        this.uniforms.normalDepthBuffer.value = value;
        if (value !== null) this.defines.NORMAL_DEPTH = "1";
        else delete this.defines.NORMAL_DEPTH;
        this.needsUpdate = true;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Indicates whether bilateral filtering is enabled.
   *
   * @type {Boolean}
   */ get bilateral() {
        return this.defines.BILATERAL !== void 0;
    }
    set bilateral(value) {
        if (value !== null) this.defines.BILATERAL = "1";
        else delete this.defines.BILATERAL;
        this.needsUpdate = true;
    }
    /**
   * The bilateral filter distance threshold in world units.
   *
   * @type {Number}
   */ get worldDistanceThreshold() {
        return -$2046da3312f94030$var$orthographicDepthToViewZ(Number(this.defines.DISTANCE_THRESHOLD), this.near, this.far);
    }
    set worldDistanceThreshold(value) {
        const threshold = $2046da3312f94030$var$viewZToOrthographicDepth(-value, this.near, this.far);
        this.defines.DISTANCE_THRESHOLD = threshold.toFixed(12);
        this.needsUpdate = true;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNearFar.value.set(camera.near, camera.far);
            if (camera instanceof (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
// src/materials/glsl/depth-copy.frag
var $2046da3312f94030$var$depth_copy_default = `#include <packing>
varying vec2 vUv;
#ifdef NORMAL_DEPTH
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D normalDepthBuffer;
#else
uniform mediump sampler2D normalDepthBuffer;
#endif
float readDepth(const in vec2 uv){return texture2D(normalDepthBuffer,uv).a;}
#else
#if INPUT_DEPTH_PACKING == 3201
uniform lowp sampler2D depthBuffer;
#elif defined(GL_FRAGMENT_PRECISION_HIGH)
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if INPUT_DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}
#endif
void main(){
#if INPUT_DEPTH_PACKING == OUTPUT_DEPTH_PACKING
gl_FragColor=texture2D(depthBuffer,vUv);
#else
float depth=readDepth(vUv);
#if OUTPUT_DEPTH_PACKING == 3201
gl_FragColor=(depth==1.0)?vec4(1.0):packDepthToRGBA(depth);
#else
gl_FragColor=vec4(vec3(depth),1.0);
#endif
#endif
}`;
// src/materials/glsl/depth-copy.vert
var $2046da3312f94030$var$depth_copy_default2 = `varying vec2 vUv;
#if DEPTH_COPY_MODE == 1
uniform vec2 texelPosition;
#endif
void main(){
#if DEPTH_COPY_MODE == 1
vUv=texelPosition;
#else
vUv=position.xy*0.5+0.5;
#endif
gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/DepthCopyMaterial.js
var $2046da3312f94030$export$c6821a730bfea2ec = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new depth copy material.
   */ constructor(){
        super({
            name: "DepthCopyMaterial",
            defines: {
                INPUT_DEPTH_PACKING: "0",
                OUTPUT_DEPTH_PACKING: "0",
                DEPTH_COPY_MODE: "0"
            },
            uniforms: {
                depthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelPosition: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)())
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$depth_copy_default,
            vertexShader: $2046da3312f94030$var$depth_copy_default2
        });
        this.depthCopyMode = $2046da3312f94030$export$f14251d45898bc40.FULL;
    }
    /**
   * The input depth buffer.
   *
   * @type {Texture}
   */ get depthBuffer() {
        return this.uniforms.depthBuffer.value;
    }
    set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The input depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ set inputDepthPacking(value) {
        this.defines.INPUT_DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * The output depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ get outputDepthPacking() {
        return Number(this.defines.OUTPUT_DEPTH_PACKING);
    }
    set outputDepthPacking(value) {
        this.defines.OUTPUT_DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the input depth buffer.
   *
   * @deprecated Use depthBuffer and inputDepthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthBuffer = buffer;
        this.inputDepthPacking = depthPacking;
    }
    /**
   * Returns the current input depth packing strategy.
   *
   * @deprecated
   * @return {DepthPackingStrategies} The input depth packing strategy.
   */ getInputDepthPacking() {
        return Number(this.defines.INPUT_DEPTH_PACKING);
    }
    /**
   * Sets the input depth packing strategy.
   *
   * @deprecated Use inputDepthPacking instead.
   * @param {DepthPackingStrategies} value - The new input depth packing strategy.
   */ setInputDepthPacking(value) {
        this.defines.INPUT_DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Returns the current output depth packing strategy.
   *
   * @deprecated Use outputDepthPacking instead.
   * @return {DepthPackingStrategies} The output depth packing strategy.
   */ getOutputDepthPacking() {
        return Number(this.defines.OUTPUT_DEPTH_PACKING);
    }
    /**
   * Sets the output depth packing strategy.
   *
   * @deprecated Use outputDepthPacking instead.
   * @param {DepthPackingStrategies} value - The new output depth packing strategy.
   */ setOutputDepthPacking(value) {
        this.defines.OUTPUT_DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * The screen space position used for single-texel copy operations.
   *
   * @type {Vector2}
   */ get texelPosition() {
        return this.uniforms.texelPosition.value;
    }
    /**
   * Returns the screen space position used for single-texel copy operations.
   *
   * @deprecated Use texelPosition instead.
   * @return {Vector2} The position.
   */ getTexelPosition() {
        return this.uniforms.texelPosition.value;
    }
    /**
   * Sets the screen space position used for single-texel copy operations.
   *
   * @deprecated
   * @param {Vector2} value - The position.
   */ setTexelPosition(value) {
        this.uniforms.texelPosition.value = value;
    }
    /**
   * The depth copy mode.
   *
   * @type {DepthCopyMode}
   */ get mode() {
        return this.depthCopyMode;
    }
    set mode(value) {
        this.depthCopyMode = value;
        this.defines.DEPTH_COPY_MODE = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Returns the depth copy mode.
   *
   * @deprecated Use mode instead.
   * @return {DepthCopyMode} The depth copy mode.
   */ getMode() {
        return this.mode;
    }
    /**
   * Sets the depth copy mode.
   *
   * @deprecated Use mode instead.
   * @param {DepthCopyMode} value - The new mode.
   */ setMode(value) {
        this.mode = value;
    }
};
// src/materials/glsl/effect.frag
var $2046da3312f94030$var$effect_default = `#include <common>
#include <packing>
#include <dithering_pars_fragment>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#if DEPTH_PACKING == 3201
uniform lowp sampler2D depthBuffer;
#elif defined(GL_FRAGMENT_PRECISION_HIGH)
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;vec4 sRGBToLinear(const in vec4 value){return vec4(mix(pow(value.rgb*0.9478672986+vec3(0.0521327014),vec3(2.4)),value.rgb*0.0773993808,vec3(lessThanEqual(value.rgb,vec3(0.04045)))),value.a);}float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
float depth=unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
float depth=texture2D(depthBuffer,uv).r;
#endif
#if defined(USE_LOGARITHMIC_DEPTH_BUFFER) || defined(LOG_DEPTH)
float d=pow(2.0,depth*log2(cameraFar+1.0))-1.0;float a=cameraFar/(cameraFar-cameraNear);float b=cameraFar*cameraNear/(cameraNear-cameraFar);depth=a+b/d;
#elif defined(USE_REVERSED_DEPTH_BUFFER)
depth=1.0-depth;
#endif
return depth;}float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
return orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
}vec3 RGBToHCV(const in vec3 RGB){vec4 P=mix(vec4(RGB.bg,-1.0,2.0/3.0),vec4(RGB.gb,0.0,-1.0/3.0),step(RGB.b,RGB.g));vec4 Q=mix(vec4(P.xyw,RGB.r),vec4(RGB.r,P.yzx),step(P.x,RGB.r));float C=Q.x-min(Q.w,Q.y);float H=abs((Q.w-Q.y)/(6.0*C+EPSILON)+Q.z);return vec3(H,C,Q.x);}vec3 RGBToHSL(const in vec3 RGB){vec3 HCV=RGBToHCV(RGB);float L=HCV.z-HCV.y*0.5;float S=HCV.y/(1.0-abs(L*2.0-1.0)+EPSILON);return vec3(HCV.x,S,L);}vec3 HueToRGB(const in float H){float R=abs(H*6.0-3.0)-1.0;float G=2.0-abs(H*6.0-2.0);float B=2.0-abs(H*6.0-4.0);return clamp(vec3(R,G,B),0.0,1.0);}vec3 HSLToRGB(const in vec3 HSL){vec3 RGB=HueToRGB(HSL.x);float C=(1.0-abs(2.0*HSL.z-1.0))*HSL.y;return(RGB-0.5)*C+HSL.z;}FRAGMENT_HEAD void main(){FRAGMENT_MAIN_UV vec4 color0=texture2D(inputBuffer,UV);vec4 color1=vec4(0.0);FRAGMENT_MAIN_IMAGE color0.a=clamp(color0.a,0.0,1.0);gl_FragColor=color0;
#ifdef ENCODE_OUTPUT
#include <colorspace_fragment>
#endif
#include <dithering_fragment>
}`;
// src/materials/glsl/effect.vert
var $2046da3312f94030$var$effect_default2 = `uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;VERTEX_HEAD void main(){vUv=position.xy*0.5+0.5;VERTEX_MAIN_SUPPORT gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/EffectMaterial.js
var $2046da3312f94030$export$a26662c57c109212 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new effect material.
   *
   * @param {Map<String, String>} [shaderParts] - Deprecated. Use setShaderData instead.
   * @param {Map<String, String>} [defines] - Deprecated. Use setShaderData instead.
   * @param {Map<String, Uniform>} [uniforms] - Deprecated. Use setShaderData instead.
   * @param {Camera} [camera] - A camera.
   * @param {Boolean} [dithering=false] - Deprecated.
   */ constructor(shaderParts, defines, uniforms, camera, dithering = false){
        super({
            name: "EffectMaterial",
            defines: {
                THREE_REVISION: (0, $ce0cdebec9150cb3$export$3545e07a80636437).replace(/\D+/g, ""),
                DEPTH_PACKING: "0",
                ENCODE_OUTPUT: "1"
            },
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                depthBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                resolution: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                cameraNear: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0.3),
                cameraFar: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1e3),
                aspect: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1),
                time: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(0)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            dithering: dithering
        });
        if (shaderParts) this.setShaderParts(shaderParts);
        if (defines) this.setDefines(defines);
        if (uniforms) this.setUniforms(uniforms);
        this.copyCameraSettings(camera);
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * Sets the input buffer.
   *
   * @deprecated Use inputBuffer instead.
   * @param {Texture} value - The input buffer.
   */ setInputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The depth buffer.
   *
   * @type {Texture}
   */ get depthBuffer() {
        return this.uniforms.depthBuffer.value;
    }
    set depthBuffer(value) {
        this.uniforms.depthBuffer.value = value;
    }
    /**
   * The depth packing strategy.
   *
   * @type {DepthPackingStrategies}
   */ get depthPacking() {
        return Number(this.defines.DEPTH_PACKING);
    }
    set depthPacking(value) {
        this.defines.DEPTH_PACKING = value.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the depth buffer.
   *
   * @deprecated Use depthBuffer and depthPacking instead.
   * @param {Texture} buffer - The depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthBuffer(buffer, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.depthBuffer = buffer;
        this.depthPacking = depthPacking;
    }
    /**
   * Sets the shader data.
   *
   * @param {EffectShaderData} data - The shader data.
   * @return {EffectMaterial} This material.
   */ setShaderData(data) {
        this.setShaderParts(data.shaderParts);
        this.setDefines(data.defines);
        this.setUniforms(data.uniforms);
        this.setExtensions(data.extensions);
    }
    /**
   * Sets the shader parts.
   *
   * @deprecated Use setShaderData instead.
   * @param {Map<String, String>} shaderParts - A collection of shader snippets. See {@link EffectShaderSection}.
   * @return {EffectMaterial} This material.
   */ setShaderParts(shaderParts) {
        this.fragmentShader = $2046da3312f94030$var$effect_default.replace($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_HEAD, shaderParts.get($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_HEAD) || "").replace($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_UV, shaderParts.get($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_UV) || "").replace($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE, shaderParts.get($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE) || "");
        this.vertexShader = $2046da3312f94030$var$effect_default2.replace($2046da3312f94030$export$a147810b69c6903e.VERTEX_HEAD, shaderParts.get($2046da3312f94030$export$a147810b69c6903e.VERTEX_HEAD) || "").replace($2046da3312f94030$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT, shaderParts.get($2046da3312f94030$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT) || "");
        this.needsUpdate = true;
        return this;
    }
    /**
   * Sets the shader macros.
   *
   * @deprecated Use setShaderData instead.
   * @param {Map<String, String>} defines - A collection of preprocessor macro definitions.
   * @return {EffectMaterial} This material.
   */ setDefines(defines) {
        for (const entry of defines.entries())this.defines[entry[0]] = entry[1];
        this.needsUpdate = true;
        return this;
    }
    /**
   * Sets the shader uniforms.
   *
   * @deprecated Use setShaderData instead.
   * @param {Map<String, Uniform>} uniforms - A collection of uniforms.
   * @return {EffectMaterial} This material.
   */ setUniforms(uniforms) {
        for (const entry of uniforms.entries())this.uniforms[entry[0]] = entry[1];
        return this;
    }
    /**
   * Sets the required shader extensions.
   *
   * @deprecated Use setShaderData instead.
   * @param {Set<WebGLExtension>} extensions - A collection of extensions.
   * @return {EffectMaterial} This material.
   */ setExtensions(extensions) {
        this.extensions = {};
        for (const extension of extensions)this.extensions[extension] = true;
        return this;
    }
    /**
   * Indicates whether output encoding is enabled.
   *
   * @type {Boolean}
   */ get encodeOutput() {
        return this.defines.ENCODE_OUTPUT !== void 0;
    }
    set encodeOutput(value) {
        if (this.encodeOutput !== value) {
            if (value) this.defines.ENCODE_OUTPUT = "1";
            else delete this.defines.ENCODE_OUTPUT;
            this.needsUpdate = true;
        }
    }
    /**
   * Indicates whether output encoding is enabled.
   *
   * @deprecated Use encodeOutput instead.
   * @return {Boolean} Whether output encoding is enabled.
   */ isOutputEncodingEnabled(value) {
        return this.encodeOutput;
    }
    /**
   * Enables or disables output encoding.
   *
   * @deprecated Use encodeOutput instead.
   * @param {Boolean} value - Whether output encoding should be enabled.
   */ setOutputEncodingEnabled(value) {
        this.encodeOutput = value;
    }
    /**
   * The time in seconds.
   *
   * @type {Number}
   */ get time() {
        return this.uniforms.time.value;
    }
    set time(value) {
        this.uniforms.time.value = value;
    }
    /**
   * Sets the delta time.
   *
   * @deprecated Use time instead.
   * @param {Number} value - The delta time in seconds.
   */ setDeltaTime(value) {
        this.uniforms.time.value += value;
    }
    /**
   * Copies the settings of the given camera.
   *
   * @deprecated Use copyCameraSettings instead.
   * @param {Camera} camera - A camera.
   */ adoptCameraSettings(camera) {
        this.copyCameraSettings(camera);
    }
    /**
   * Copies the settings of the given camera.
   *
   * @param {Camera} camera - A camera.
   */ copyCameraSettings(camera) {
        if (camera) {
            this.uniforms.cameraNear.value = camera.near;
            this.uniforms.cameraFar.value = camera.far;
            if (camera instanceof (0, $ce0cdebec9150cb3$export$74e4ae24825f68d7)) this.defines.PERSPECTIVE_CAMERA = "1";
            else delete this.defines.PERSPECTIVE_CAMERA;
            this.needsUpdate = true;
        }
    }
    /**
   * Sets the resolution.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const uniforms = this.uniforms;
        uniforms.resolution.value.set(width, height);
        uniforms.texelSize.value.set(1 / width, 1 / height);
        uniforms.aspect.value = width / height;
    }
    /**
   * An enumeration of shader code placeholders.
   *
   * @deprecated Use EffectShaderSection instead.
   * @type {Object}
   */ static get Section() {
        return $2046da3312f94030$export$a147810b69c6903e;
    }
};
// src/materials/glsl/convolution.gaussian.frag
var $2046da3312f94030$var$convolution_gaussian_default = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform vec2 kernel[STEPS];varying vec2 vOffset;varying vec2 vUv;void main(){vec4 result=texture2D(inputBuffer,vUv)*kernel[0].y;for(int i=1;i<STEPS;++i){vec2 offset=kernel[i].x*vOffset;vec4 c0=texture2D(inputBuffer,vUv+offset);vec4 c1=texture2D(inputBuffer,vUv-offset);result+=(c0+c1)*kernel[i].y;}gl_FragColor=result;
#include <colorspace_fragment>
}`;
// src/materials/glsl/convolution.gaussian.vert
var $2046da3312f94030$var$convolution_gaussian_default2 = `uniform vec2 texelSize;uniform vec2 direction;uniform float scale;varying vec2 vOffset;varying vec2 vUv;void main(){vOffset=direction*texelSize*scale;vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}`;
// src/materials/GaussianBlurMaterial.js
var $2046da3312f94030$export$c01ac62da39ecb86 = class extends (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d) {
    /**
   * Constructs a new convolution material.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.kernelSize=35] - The kernel size.
   */ constructor({ kernelSize: kernelSize = 35 } = {}){
        super({
            name: "GaussianBlurMaterial",
            uniforms: {
                inputBuffer: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                texelSize: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                direction: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()),
                kernel: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(null),
                scale: new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(1)
            },
            blending: (0, $ce0cdebec9150cb3$export$63b8d6b580fc65ba),
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: $2046da3312f94030$var$convolution_gaussian_default,
            vertexShader: $2046da3312f94030$var$convolution_gaussian_default2
        });
        this._kernelSize = 0;
        this.kernelSize = kernelSize;
    }
    /**
   * The input buffer.
   *
   * @type {Texture}
   */ set inputBuffer(value) {
        this.uniforms.inputBuffer.value = value;
    }
    /**
   * The kernel size.
   *
   * @type {Number}
   */ get kernelSize() {
        return this._kernelSize;
    }
    set kernelSize(value) {
        this._kernelSize = value;
        this.generateKernel(value);
    }
    /**
   * The blur direction.
   *
   * @type {Vector2}
   */ get direction() {
        return this.uniforms.direction.value;
    }
    /**
   * The blur kernel scale. Values greater than 1.0 may introduce artifacts.
   *
   * @type {Number}
   */ get scale() {
        return this.uniforms.scale.value;
    }
    set scale(value) {
        this.uniforms.scale.value = value;
    }
    /**
   * Generates the Gauss kernel.
   *
   * @param {KernelSize} kernelSize - The kernel size. Should be an odd number.
   * @private
   */ generateKernel(kernelSize) {
        const kernel = new $2046da3312f94030$export$66c54bc65bf8869c(kernelSize);
        const steps = kernel.linearSteps;
        const kernelData = new Float64Array(steps * 2);
        for(let i = 0, j = 0; i < steps; ++i){
            kernelData[j++] = kernel.linearOffsets[i];
            kernelData[j++] = kernel.linearWeights[i];
        }
        this.uniforms.kernel.value = kernelData;
        this.defines.STEPS = steps.toFixed(0);
        this.needsUpdate = true;
    }
    /**
   * Sets the size of this object.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.uniforms.texelSize.value.set(1 / width, 1 / height);
    }
};
var $2046da3312f94030$export$13b54093f26c053a = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new box blur pass.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.kernelSize=5] - Must be an odd number. The sizes 3 and 5 use optimized code paths.
   * @param {Number} [options.iterations=1] - The amount of times the blur should be applied.
   * @param {Number} [options.bilateral=false] - Enables or disables bilateral blurring.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   */ constructor({ kernelSize: kernelSize = 5, iterations: iterations = 1, bilateral: bilateral = false, resolutionScale: resolutionScale = 1, resolutionX: resolutionX = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionY: resolutionY = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE } = {}){
        super("BoxBlurPass");
        this.needsDepthTexture = bilateral;
        this.renderTargetA = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetA.texture.name = "Blur.Target.A";
        this.renderTargetB = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetB.texture.name = "Blur.Target.B";
        this.blurMaterial = new $2046da3312f94030$export$d331d314f1169029({
            bilateral: bilateral,
            kernelSize: kernelSize
        });
        this.copyMaterial = new $2046da3312f94030$export$d4b5f24bda67f7e4();
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.iterations = iterations;
    }
    set mainCamera(value) {
        this.blurMaterial.copyCameraSettings(value);
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing strategy.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.blurMaterial.depthBuffer = depthTexture;
        this.blurMaterial.depthPacking = depthPacking;
    }
    /**
   * Renders the blur.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const scene = this.scene;
        const camera = this.camera;
        const renderTargetA = this.renderTargetA;
        const renderTargetB = this.renderTargetB;
        const blurMaterial = this.blurMaterial;
        this.fullscreenMaterial = blurMaterial;
        let previousBuffer = inputBuffer;
        for(let i = 0, l = Math.max(this.iterations, 1); i < l; ++i){
            const buffer = (i & 1) === 0 ? renderTargetA : renderTargetB;
            blurMaterial.inputBuffer = previousBuffer.texture;
            renderer.setRenderTarget(buffer);
            renderer.render(scene, camera);
            previousBuffer = buffer;
        }
        this.copyMaterial.inputBuffer = previousBuffer.texture;
        this.fullscreenMaterial = this.copyMaterial;
        renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
        renderer.render(scene, camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.renderTargetA.setSize(w, h);
        this.renderTargetB.setSize(w, h);
        this.blurMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (renderer !== null) this.blurMaterial.maxVaryingVectors = renderer.capabilities.maxVaryings;
        if (frameBufferType !== void 0) {
            this.renderTargetA.texture.type = frameBufferType;
            this.renderTargetB.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            else if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) {
                this.renderTargetA.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.renderTargetB.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
            }
        }
    }
};
var $2046da3312f94030$export$d66f952c334c662b = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new depth save pass.
   *
   * @param {Object} [options] - The options.
   * @param {DepthPackingStrategies} [options.depthPacking=RGBADepthPacking] - The output depth packing.
   */ constructor({ depthPacking: depthPacking = (0, $ce0cdebec9150cb3$export$8f910f4c4f73df11) } = {}){
        super("DepthCopyPass");
        const material = new $2046da3312f94030$export$c6821a730bfea2ec();
        material.outputDepthPacking = depthPacking;
        this.fullscreenMaterial = material;
        this.needsDepthTexture = true;
        this.needsSwap = false;
        this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            type: depthPacking === (0, $ce0cdebec9150cb3$export$8f910f4c4f73df11) ? (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10) : (0, $ce0cdebec9150cb3$export$f6d331659b644596),
            minFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
            magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
            depthBuffer: false
        });
        this.renderTarget.texture.name = "DepthCopyPass.Target";
    }
    /**
   * The output depth texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the output depth texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * The output depth packing.
   *
   * @type {DepthPackingStrategies}
   */ get depthPacking() {
        return this.fullscreenMaterial.outputDepthPacking;
    }
    /**
   * Returns the output depth packing.
   *
   * @deprecated Use depthPacking instead.
   * @return {DepthPackingStrategies} The depth packing.
   */ getDepthPacking() {
        return this.fullscreenMaterial.outputDepthPacking;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.fullscreenMaterial.depthBuffer = depthTexture;
        this.fullscreenMaterial.inputDepthPacking = depthPacking;
    }
    /**
   * Copies depth from a depth texture.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        renderer.setRenderTarget(this.renderToScreen ? null : this.renderTarget);
        renderer.render(this.scene, this.camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.renderTarget.setSize(width, height);
    }
};
// src/passes/DepthPickingPass.js
var $2046da3312f94030$var$threeRevision = Number((0, $ce0cdebec9150cb3$export$3545e07a80636437).replace(/\D+/g, ""));
var $2046da3312f94030$var$unpackDownscale = 255 / 256;
var $2046da3312f94030$var$unpackFactorsLegacy = new Float32Array([
    $2046da3312f94030$var$unpackDownscale / 256 ** 3,
    $2046da3312f94030$var$unpackDownscale / 65536,
    $2046da3312f94030$var$unpackDownscale / 256,
    $2046da3312f94030$var$unpackDownscale
]);
var $2046da3312f94030$var$unpackFactors = new Float32Array([
    $2046da3312f94030$var$unpackDownscale,
    $2046da3312f94030$var$unpackDownscale / 256,
    $2046da3312f94030$var$unpackDownscale / 65536,
    1 / 256 ** 3
]);
function $2046da3312f94030$var$unpackRGBAToDepth(packedDepth) {
    const f = $2046da3312f94030$var$threeRevision >= 167 ? $2046da3312f94030$var$unpackFactors : $2046da3312f94030$var$unpackFactorsLegacy;
    return (packedDepth[0] * f[0] + packedDepth[1] * f[1] + packedDepth[2] * f[2] + packedDepth[3] * f[3]) / 255;
}
var $2046da3312f94030$export$bd325dd997857b23 = class extends $2046da3312f94030$export$d66f952c334c662b {
    /**
   * Constructs a new depth picking pass.
   *
   * @param {Object} [options] - The options.
   * @param {DepthPackingStrategies} [options.depthPacking=RGBADepthPacking] - The depth packing.
   * @param {Number} [options.mode=DepthCopyMode.SINGLE] - The depth copy mode.
   */ constructor({ depthPacking: depthPacking = (0, $ce0cdebec9150cb3$export$8f910f4c4f73df11), mode: mode = $2046da3312f94030$export$f14251d45898bc40.SINGLE } = {}){
        if (depthPacking !== (0, $ce0cdebec9150cb3$export$8f910f4c4f73df11) && depthPacking !== (0, $ce0cdebec9150cb3$export$deeb383078690b50)) throw new Error(`Unsupported depth packing: ${depthPacking}`);
        super({
            depthPacking: depthPacking
        });
        this.name = "DepthPickingPass";
        this.fullscreenMaterial.mode = mode;
        this.pixelBuffer = depthPacking === (0, $ce0cdebec9150cb3$export$8f910f4c4f73df11) ? new Uint8Array(4) : new Float32Array(4);
        this.callback = null;
    }
    /**
   * Reads depth at a specific screen position.
   *
   * Only one depth value can be picked per frame. Calling this method multiple times per frame will overwrite the
   * picking coordinates. Unresolved promises will be abandoned.
   *
   * @example
   * const ndc = new Vector3();
   * const clientRect = myViewport.getBoundingClientRect();
   * const clientX = pointerEvent.clientX - clientRect.left;
   * const clientY = pointerEvent.clientY - clientRect.top;
   * ndc.x = (clientX / myViewport.clientWidth) * 2.0 - 1.0;
   * ndc.y = -(clientY / myViewport.clientHeight) * 2.0 + 1.0;
   * const depth = await depthPickingPass.readDepth(ndc);
   * ndc.z = depth * 2.0 - 1.0;
   *
   * const worldPosition = ndc.unproject(camera);
   *
   * @param {Vector2|Vector3} ndc - Normalized device coordinates. Only X and Y are relevant.
   * @return {Promise<Number>} A promise that returns the depth on the next frame.
   */ readDepth(ndc) {
        this.fullscreenMaterial.texelPosition.set(ndc.x * 0.5 + 0.5, ndc.y * 0.5 + 0.5);
        return new Promise((resolve)=>{
            this.callback = resolve;
        });
    }
    /**
   * Copies depth and resolves depth picking promises.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const material = this.fullscreenMaterial;
        const mode = material.mode;
        if (mode === $2046da3312f94030$export$f14251d45898bc40.FULL) super.render(renderer);
        if (this.callback !== null) {
            const renderTarget = this.renderTarget;
            const pixelBuffer = this.pixelBuffer;
            const packed = renderTarget.texture.type !== (0, $ce0cdebec9150cb3$export$f6d331659b644596);
            let x = 0, y = 0;
            if (mode === $2046da3312f94030$export$f14251d45898bc40.SINGLE) super.render(renderer);
            else {
                const texelPosition = material.texelPosition;
                x = Math.round(texelPosition.x * renderTarget.width);
                y = Math.round(texelPosition.y * renderTarget.height);
            }
            renderer.readRenderTargetPixels(renderTarget, x, y, 1, 1, pixelBuffer);
            this.callback(packed ? $2046da3312f94030$var$unpackRGBAToDepth(pixelBuffer) : pixelBuffer[0]);
            this.callback = null;
        }
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        if (this.fullscreenMaterial.mode === $2046da3312f94030$export$f14251d45898bc40.FULL) super.setSize(width, height);
    }
};
function $2046da3312f94030$var$prefixSubstrings(prefix, substrings, strings) {
    for (const substring of substrings){
        const prefixed = "$1" + prefix + substring.charAt(0).toUpperCase() + substring.slice(1);
        const regExp = new RegExp("([^\\.])(\\b" + substring + "\\b)", "g");
        for (const entry of strings.entries())if (entry[1] !== null) strings.set(entry[0], entry[1].replace(regExp, prefixed));
    }
}
function $2046da3312f94030$var$integrateEffect(prefix, effect, data) {
    let fragmentShader = effect.getFragmentShader();
    let vertexShader = effect.getVertexShader();
    const mainImageExists = fragmentShader !== void 0 && /mainImage/.test(fragmentShader);
    const mainUvExists = fragmentShader !== void 0 && /mainUv/.test(fragmentShader);
    data.attributes |= effect.getAttributes();
    if (fragmentShader === void 0) throw new Error(`Missing fragment shader (${effect.name})`);
    else if (mainUvExists && (data.attributes & $2046da3312f94030$export$a72ebb312f9e05c6.CONVOLUTION) !== 0) throw new Error(`Effects that transform UVs are incompatible with convolution effects (${effect.name})`);
    else if (!mainImageExists && !mainUvExists) throw new Error(`Could not find mainImage or mainUv function (${effect.name})`);
    else {
        const functionRegExp = /\w+\s+(\w+)\([\w\s,]*\)\s*{/g;
        const shaderParts = data.shaderParts;
        let fragmentHead = shaderParts.get($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_HEAD) || "";
        let fragmentMainUv = shaderParts.get($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_UV) || "";
        let fragmentMainImage = shaderParts.get($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE) || "";
        let vertexHead = shaderParts.get($2046da3312f94030$export$a147810b69c6903e.VERTEX_HEAD) || "";
        let vertexMainSupport = shaderParts.get($2046da3312f94030$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT) || "";
        const varyings = /* @__PURE__ */ new Set();
        const names = /* @__PURE__ */ new Set();
        if (mainUvExists) {
            fragmentMainUv += `	${prefix}MainUv(UV);
`;
            data.uvTransformation = true;
        }
        if (vertexShader !== null && /mainSupport/.test(vertexShader)) {
            const needsUv = /mainSupport *\([\w\s]*?uv\s*?\)/.test(vertexShader);
            vertexMainSupport += `	${prefix}MainSupport(`;
            vertexMainSupport += needsUv ? "vUv);\n" : ");\n";
            for (const m2 of vertexShader.matchAll(/(?:varying\s+\w+\s+([\S\s]*?);)/g))for (const n of m2[1].split(/\s*,\s*/)){
                data.varyings.add(n);
                varyings.add(n);
                names.add(n);
            }
            for (const m2 of vertexShader.matchAll(functionRegExp))names.add(m2[1]);
        }
        for (const m2 of fragmentShader.matchAll(functionRegExp))names.add(m2[1]);
        for (const d of effect.defines.keys())names.add(d.replace(/\([\w\s,]*\)/g, ""));
        for (const u of effect.uniforms.keys())names.add(u);
        names.delete("while");
        names.delete("for");
        names.delete("if");
        effect.uniforms.forEach((val, key)=>data.uniforms.set(prefix + key.charAt(0).toUpperCase() + key.slice(1), val));
        effect.defines.forEach((val, key)=>data.defines.set(prefix + key.charAt(0).toUpperCase() + key.slice(1), val));
        const shaders = /* @__PURE__ */ new Map([
            [
                "fragment",
                fragmentShader
            ],
            [
                "vertex",
                vertexShader
            ]
        ]);
        $2046da3312f94030$var$prefixSubstrings(prefix, names, data.defines);
        $2046da3312f94030$var$prefixSubstrings(prefix, names, shaders);
        fragmentShader = shaders.get("fragment");
        vertexShader = shaders.get("vertex");
        const blendMode = effect.blendMode;
        data.blendModes.set(blendMode.blendFunction, blendMode);
        if (mainImageExists) {
            if (effect.inputColorSpace !== null && effect.inputColorSpace !== data.colorSpace) fragmentMainImage += effect.inputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa) ? "color0 = sRGBTransferOETF(color0);\n	" : "color0 = sRGBToLinear(color0);\n	";
            if (effect.outputColorSpace !== (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51)) data.colorSpace = effect.outputColorSpace;
            else if (effect.inputColorSpace !== null) data.colorSpace = effect.inputColorSpace;
            const depthParamRegExp = /MainImage *\([\w\s,]*?depth[\w\s,]*?\)/;
            fragmentMainImage += `${prefix}MainImage(color0, UV, `;
            if ((data.attributes & $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH) !== 0 && depthParamRegExp.test(fragmentShader)) {
                fragmentMainImage += "depth, ";
                data.readDepth = true;
            }
            fragmentMainImage += "color1);\n	";
            const blendOpacity = prefix + "BlendOpacity";
            data.uniforms.set(blendOpacity, blendMode.opacity);
            fragmentMainImage += `color0 = blend${blendMode.blendFunction}(color0, color1, ${blendOpacity});

	`;
            fragmentHead += `uniform float ${blendOpacity};

`;
        }
        fragmentHead += fragmentShader + "\n";
        if (vertexShader !== null) vertexHead += vertexShader + "\n";
        shaderParts.set($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_HEAD, fragmentHead);
        shaderParts.set($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_UV, fragmentMainUv);
        shaderParts.set($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE, fragmentMainImage);
        shaderParts.set($2046da3312f94030$export$a147810b69c6903e.VERTEX_HEAD, vertexHead);
        shaderParts.set($2046da3312f94030$export$a147810b69c6903e.VERTEX_MAIN_SUPPORT, vertexMainSupport);
        if (effect.extensions !== null) for (const extension of effect.extensions)data.extensions.add(extension);
    }
}
var $2046da3312f94030$export$9b60604040f63be5 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new effect pass.
   *
   * @param {Camera} camera - The main camera.
   * @param {...Effect} effects - The effects that will be rendered by this pass.
   */ constructor(camera, ...effects){
        super("EffectPass");
        this.fullscreenMaterial = new $2046da3312f94030$export$a26662c57c109212(null, null, null, camera);
        this.listener = (event)=>this.handleEvent(event);
        this.effects = [];
        this.setEffects(effects);
        this.skipRendering = false;
        this.minTime = 1;
        this.maxTime = Number.POSITIVE_INFINITY;
        this.timeScale = 1;
    }
    set mainScene(value) {
        for (const effect of this.effects)effect.mainScene = value;
    }
    set mainCamera(value) {
        this.fullscreenMaterial.copyCameraSettings(value);
        for (const effect of this.effects)effect.mainCamera = value;
    }
    /**
   * Indicates whether this pass encodes its output when rendering to screen.
   *
   * @type {Boolean}
   * @deprecated Use fullscreenMaterial.encodeOutput instead.
   */ get encodeOutput() {
        return this.fullscreenMaterial.encodeOutput;
    }
    set encodeOutput(value) {
        this.fullscreenMaterial.encodeOutput = value;
    }
    /**
   * Indicates whether dithering is enabled.
   *
   * @type {Boolean}
   */ get dithering() {
        return this.fullscreenMaterial.dithering;
    }
    set dithering(value) {
        const material = this.fullscreenMaterial;
        material.dithering = value;
        material.needsUpdate = true;
    }
    /**
   * Sets the effects.
   *
   * @param {Effect[]} effects - The effects.
   * @protected
   */ setEffects(effects) {
        for (const effect of this.effects)effect.removeEventListener("change", this.listener);
        this.effects = effects.sort((a, b)=>b.attributes - a.attributes);
        for (const effect of this.effects)effect.addEventListener("change", this.listener);
    }
    /**
   * Updates the compound shader material.
   *
   * @protected
   */ updateMaterial() {
        const data = new $2046da3312f94030$export$810aed40073d4f73();
        let id = 0;
        for (const effect of this.effects){
            if (effect.blendMode.blendFunction === $2046da3312f94030$export$ea7520add44ba1b6.DST) data.attributes |= effect.getAttributes() & $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH;
            else if ((data.attributes & effect.getAttributes() & $2046da3312f94030$export$a72ebb312f9e05c6.CONVOLUTION) !== 0) throw new Error(`Convolution effects cannot be merged (${effect.name})`);
            else $2046da3312f94030$var$integrateEffect("e" + id++, effect, data);
        }
        let fragmentHead = data.shaderParts.get($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_HEAD);
        let fragmentMainImage = data.shaderParts.get($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE);
        let fragmentMainUv = data.shaderParts.get($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_UV);
        const blendRegExp = /\bblend\b/g;
        for (const blendMode of data.blendModes.values())fragmentHead += blendMode.getShaderCode().replace(blendRegExp, `blend${blendMode.blendFunction}`) + "\n";
        if ((data.attributes & $2046da3312f94030$export$a72ebb312f9e05c6.DEPTH) !== 0) {
            if (data.readDepth) fragmentMainImage = "float depth = readDepth(UV);\n\n	" + fragmentMainImage;
            this.needsDepthTexture = this.getDepthTexture() === null;
        } else this.needsDepthTexture = false;
        if (data.colorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) fragmentMainImage += "color0 = sRGBToLinear(color0);\n	";
        if (data.uvTransformation) {
            fragmentMainUv = "vec2 transformedUv = vUv;\n" + fragmentMainUv;
            data.defines.set("UV", "transformedUv");
        } else data.defines.set("UV", "vUv");
        data.shaderParts.set($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_HEAD, fragmentHead);
        data.shaderParts.set($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_IMAGE, fragmentMainImage);
        data.shaderParts.set($2046da3312f94030$export$a147810b69c6903e.FRAGMENT_MAIN_UV, fragmentMainUv);
        for (const [key, value] of data.shaderParts)if (value !== null) data.shaderParts.set(key, value.trim().replace(/^#/, "\n#"));
        this.skipRendering = id === 0;
        this.needsSwap = !this.skipRendering;
        this.fullscreenMaterial.setShaderData(data);
    }
    /**
   * Rebuilds the shader material.
   */ recompile() {
        this.updateMaterial();
    }
    /**
   * Returns the current depth texture.
   *
   * @return {Texture} The current depth texture, or null if there is none.
   */ getDepthTexture() {
        return this.fullscreenMaterial.depthBuffer;
    }
    /**
   * Sets the depth texture.
   *
   * @param {Texture} depthTexture - A depth texture.
   * @param {DepthPackingStrategies} [depthPacking=BasicDepthPacking] - The depth packing.
   */ setDepthTexture(depthTexture, depthPacking = (0, $ce0cdebec9150cb3$export$deeb383078690b50)) {
        this.fullscreenMaterial.depthBuffer = depthTexture;
        this.fullscreenMaterial.depthPacking = depthPacking;
        for (const effect of this.effects)effect.setDepthTexture(depthTexture, depthPacking);
    }
    /**
   * Renders the effect.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        for (const effect of this.effects)effect.update(renderer, inputBuffer, deltaTime);
        if (!this.skipRendering || this.renderToScreen) {
            const material = this.fullscreenMaterial;
            material.inputBuffer = inputBuffer.texture;
            material.time += deltaTime * this.timeScale;
            renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
            renderer.render(this.scene, this.camera);
        }
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        this.fullscreenMaterial.setSize(width, height);
        for (const effect of this.effects)effect.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        this.renderer = renderer;
        for (const effect of this.effects)effect.initialize(renderer, alpha, frameBufferType);
        this.updateMaterial();
        if (frameBufferType !== void 0 && frameBufferType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
    }
    /**
   * Deletes disposable objects.
   */ dispose() {
        super.dispose();
        for (const effect of this.effects){
            effect.removeEventListener("change", this.listener);
            effect.dispose();
        }
    }
    /**
   * Handles events.
   *
   * @param {Event} event - An event.
   */ handleEvent(event) {
        switch(event.type){
            case "change":
                this.recompile();
                break;
        }
    }
};
var $2046da3312f94030$export$5990dba06227c4dd = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new Gaussian blur pass.
   *
   * @param {Object} [options] - The options.
   * @param {Number} [options.kernelSize=35] - The kernel size. Should be an odd number in the range [3, 1020].
   * @param {Number} [options.iterations=1] - The amount of times the blur should be applied.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   */ constructor({ kernelSize: kernelSize = 35, iterations: iterations = 1, resolutionScale: resolutionScale = 1, resolutionX: resolutionX = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionY: resolutionY = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE } = {}){
        super("GaussianBlurPass");
        this.renderTargetA = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
            depthBuffer: false
        });
        this.renderTargetA.texture.name = "Blur.Target.A";
        this.renderTargetB = this.renderTargetA.clone();
        this.renderTargetB.texture.name = "Blur.Target.B";
        this.blurMaterial = new $2046da3312f94030$export$c01ac62da39ecb86({
            kernelSize: kernelSize
        });
        this.copyMaterial = new $2046da3312f94030$export$d4b5f24bda67f7e4();
        this.copyMaterial.inputBuffer = this.renderTargetB.texture;
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
        this.iterations = iterations;
    }
    /**
   * Renders the blur.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const scene = this.scene;
        const camera = this.camera;
        const renderTargetA = this.renderTargetA;
        const renderTargetB = this.renderTargetB;
        const blurMaterial = this.blurMaterial;
        this.fullscreenMaterial = blurMaterial;
        let previousBuffer = inputBuffer;
        for(let i = 0, l = Math.max(this.iterations, 1); i < l; ++i){
            blurMaterial.direction.set(1, 0);
            blurMaterial.inputBuffer = previousBuffer.texture;
            renderer.setRenderTarget(renderTargetA);
            renderer.render(scene, camera);
            blurMaterial.direction.set(0, 1);
            blurMaterial.inputBuffer = renderTargetA.texture;
            renderer.setRenderTarget(renderTargetB);
            renderer.render(scene, camera);
            if (i === 0 && l > 1) previousBuffer = renderTargetB;
        }
        this.fullscreenMaterial = this.copyMaterial;
        renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
        renderer.render(scene, camera);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        const w = resolution.width, h = resolution.height;
        this.renderTargetA.setSize(w, h);
        this.renderTargetB.setSize(w, h);
        this.blurMaterial.setSize(width, height);
    }
    /**
   * Performs initialization tasks.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {Boolean} alpha - Whether the renderer uses the alpha channel or not.
   * @param {Number} frameBufferType - The type of the main frame buffers.
   */ initialize(renderer, alpha, frameBufferType) {
        if (frameBufferType !== void 0) {
            this.renderTargetA.texture.type = frameBufferType;
            this.renderTargetB.texture.type = frameBufferType;
            if (frameBufferType !== (0, $ce0cdebec9150cb3$export$2e8ce08d3f6f5e10)) {
                this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
                this.copyMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1";
            } else if (renderer !== null && renderer.outputColorSpace === (0, $ce0cdebec9150cb3$export$561f394b24edfcaa)) {
                this.renderTargetA.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
                this.renderTargetB.texture.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa);
            }
        }
    }
};
// src/passes/LambdaPass.js
var $2046da3312f94030$export$9eabb5915fb6b06 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new lambda pass.
   *
   * @param {Function} f - A function.
   */ constructor(f){
        super("LambdaPass", null, null);
        this.needsSwap = false;
        this.f = f;
    }
    /**
   * Executes the function.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        this.f();
    }
};
var $2046da3312f94030$export$68bd776dda9a43a9 = class extends $2046da3312f94030$export$802bc10488da99c7 {
    /**
   * Constructs a new normal pass.
   *
   * @param {Scene} scene - The scene to render.
   * @param {Camera} camera - The camera to use to render the scene.
   * @param {Object} [options] - The options.
   * @param {WebGLRenderTarget} [options.renderTarget] - A custom render target.
   * @param {Number} [options.resolutionScale=1.0] - The resolution scale.
   * @param {Number} [options.resolutionX=Resolution.AUTO_SIZE] - The horizontal resolution.
   * @param {Number} [options.resolutionY=Resolution.AUTO_SIZE] - The vertical resolution.
   * @param {Number} [options.width=Resolution.AUTO_SIZE] - Deprecated. Use resolutionX instead.
   * @param {Number} [options.height=Resolution.AUTO_SIZE] - Deprecated. Use resolutionY instead.
   */ constructor(scene, camera, { renderTarget: renderTarget, resolutionScale: resolutionScale = 1, width: width = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, height: height = $2046da3312f94030$export$48a76196cafe3b93.AUTO_SIZE, resolutionX: resolutionX = width, resolutionY: resolutionY = height } = {}){
        super("NormalPass");
        this.needsSwap = false;
        this.renderPass = new $2046da3312f94030$export$f63ea822f020b5b0(scene, camera, new (0, $ce0cdebec9150cb3$export$bfe8c0a091f41ae7)());
        const renderPass = this.renderPass;
        renderPass.ignoreBackground = true;
        renderPass.skipShadowMapUpdate = true;
        const clearPass = renderPass.getClearPass();
        clearPass.overrideClearColor = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(7829503);
        clearPass.overrideClearAlpha = 1;
        this.renderTarget = renderTarget;
        if (this.renderTarget === void 0) {
            this.renderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(1, 1, {
                minFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
                magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0)
            });
            this.renderTarget.texture.name = "NormalPass.Target";
        }
        const resolution = this.resolution = new $2046da3312f94030$export$48a76196cafe3b93(this, resolutionX, resolutionY, resolutionScale);
        resolution.addEventListener("change", (e)=>this.setSize(resolution.baseWidth, resolution.baseHeight));
    }
    set mainScene(value) {
        this.renderPass.mainScene = value;
    }
    set mainCamera(value) {
        this.renderPass.mainCamera = value;
    }
    /**
   * The normal texture.
   *
   * @type {Texture}
   */ get texture() {
        return this.renderTarget.texture;
    }
    /**
   * The normal texture.
   *
   * @deprecated Use texture instead.
   * @return {Texture} The texture.
   */ getTexture() {
        return this.renderTarget.texture;
    }
    /**
   * Returns the resolution settings.
   *
   * @deprecated Use resolution instead.
   * @return {Resolution} The resolution.
   */ getResolution() {
        return this.resolution;
    }
    /**
   * Returns the current resolution scale.
   *
   * @return {Number} The resolution scale.
   * @deprecated Use resolution.preferredWidth or resolution.preferredHeight instead.
   */ getResolutionScale() {
        return this.resolution.scale;
    }
    /**
   * Sets the resolution scale.
   *
   * @param {Number} scale - The new resolution scale.
   * @deprecated Use resolution.preferredWidth or resolution.preferredHeight instead.
   */ setResolutionScale(scale) {
        this.resolution.scale = scale;
    }
    /**
   * Renders the scene normals.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [deltaTime] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */ render(renderer, inputBuffer, outputBuffer, deltaTime, stencilTest) {
        const renderTarget = this.renderToScreen ? null : this.renderTarget;
        this.renderPass.render(renderer, renderTarget, renderTarget);
    }
    /**
   * Updates the size of this pass.
   *
   * @param {Number} width - The width.
   * @param {Number} height - The height.
   */ setSize(width, height) {
        const resolution = this.resolution;
        resolution.setBaseSize(width, height);
        this.renderTarget.setSize(resolution.width, resolution.height);
    }
};
// src/textures/lut/TetrahedralUpscaler.js
var $2046da3312f94030$var$P = [
    new Float32Array(3),
    new Float32Array(3)
];
var $2046da3312f94030$var$C = [
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3)
];
var $2046da3312f94030$var$T = [
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ]
];
function $2046da3312f94030$var$calculateTetrahedronVolume(a, b, c2, d) {
    const bcX = c2[0] - b[0];
    const bcY = c2[1] - b[1];
    const bcZ = c2[2] - b[2];
    const baX = a[0] - b[0];
    const baY = a[1] - b[1];
    const baZ = a[2] - b[2];
    const crossX = bcY * baZ - bcZ * baY;
    const crossY = bcZ * baX - bcX * baZ;
    const crossZ = bcX * baY - bcY * baX;
    const length = Math.sqrt(crossX * crossX + crossY * crossY + crossZ * crossZ);
    const triangleArea = length * 0.5;
    const normalX = crossX / length;
    const normalY = crossY / length;
    const normalZ = crossZ / length;
    const constant = -(a[0] * normalX + a[1] * normalY + a[2] * normalZ);
    const dot = d[0] * normalX + d[1] * normalY + d[2] * normalZ;
    const height = Math.abs(dot + constant);
    return height * triangleArea / 3;
}
function $2046da3312f94030$var$sample(data, size, x, y, z, color2) {
    const i4 = (x + y * size + z * size * size) * 4;
    color2[0] = data[i4 + 0];
    color2[1] = data[i4 + 1];
    color2[2] = data[i4 + 2];
}
function $2046da3312f94030$var$tetrahedralSample(data, size, u, v4, w, color2) {
    const px = u * (size - 1);
    const py = v4 * (size - 1);
    const pz = w * (size - 1);
    const minX = Math.floor(px);
    const minY = Math.floor(py);
    const minZ = Math.floor(pz);
    const maxX = Math.ceil(px);
    const maxY = Math.ceil(py);
    const maxZ = Math.ceil(pz);
    const su = px - minX;
    const sv = py - minY;
    const sw = pz - minZ;
    if (minX === px && minY === py && minZ === pz) $2046da3312f94030$var$sample(data, size, px, py, pz, color2);
    else {
        let vertices;
        if (su >= sv && sv >= sw) vertices = $2046da3312f94030$var$T[0];
        else if (su >= sw && sw >= sv) vertices = $2046da3312f94030$var$T[1];
        else if (sw >= su && su >= sv) vertices = $2046da3312f94030$var$T[2];
        else if (sv >= su && su >= sw) vertices = $2046da3312f94030$var$T[3];
        else if (sv >= sw && sw >= su) vertices = $2046da3312f94030$var$T[4];
        else if (sw >= sv && sv >= su) vertices = $2046da3312f94030$var$T[5];
        const [P0, P1, P2, P3] = vertices;
        const coords = $2046da3312f94030$var$P[0];
        coords[0] = su;
        coords[1] = sv;
        coords[2] = sw;
        const tmp = $2046da3312f94030$var$P[1];
        const diffX = maxX - minX;
        const diffY = maxY - minY;
        const diffZ = maxZ - minZ;
        tmp[0] = diffX * P0[0] + minX;
        tmp[1] = diffY * P0[1] + minY;
        tmp[2] = diffZ * P0[2] + minZ;
        $2046da3312f94030$var$sample(data, size, tmp[0], tmp[1], tmp[2], $2046da3312f94030$var$C[0]);
        tmp[0] = diffX * P1[0] + minX;
        tmp[1] = diffY * P1[1] + minY;
        tmp[2] = diffZ * P1[2] + minZ;
        $2046da3312f94030$var$sample(data, size, tmp[0], tmp[1], tmp[2], $2046da3312f94030$var$C[1]);
        tmp[0] = diffX * P2[0] + minX;
        tmp[1] = diffY * P2[1] + minY;
        tmp[2] = diffZ * P2[2] + minZ;
        $2046da3312f94030$var$sample(data, size, tmp[0], tmp[1], tmp[2], $2046da3312f94030$var$C[2]);
        tmp[0] = diffX * P3[0] + minX;
        tmp[1] = diffY * P3[1] + minY;
        tmp[2] = diffZ * P3[2] + minZ;
        $2046da3312f94030$var$sample(data, size, tmp[0], tmp[1], tmp[2], $2046da3312f94030$var$C[3]);
        const V0 = $2046da3312f94030$var$calculateTetrahedronVolume(P1, P2, P3, coords) * 6;
        const V1 = $2046da3312f94030$var$calculateTetrahedronVolume(P0, P2, P3, coords) * 6;
        const V2 = $2046da3312f94030$var$calculateTetrahedronVolume(P0, P1, P3, coords) * 6;
        const V3 = $2046da3312f94030$var$calculateTetrahedronVolume(P0, P1, P2, coords) * 6;
        $2046da3312f94030$var$C[0][0] *= V0;
        $2046da3312f94030$var$C[0][1] *= V0;
        $2046da3312f94030$var$C[0][2] *= V0;
        $2046da3312f94030$var$C[1][0] *= V1;
        $2046da3312f94030$var$C[1][1] *= V1;
        $2046da3312f94030$var$C[1][2] *= V1;
        $2046da3312f94030$var$C[2][0] *= V2;
        $2046da3312f94030$var$C[2][1] *= V2;
        $2046da3312f94030$var$C[2][2] *= V2;
        $2046da3312f94030$var$C[3][0] *= V3;
        $2046da3312f94030$var$C[3][1] *= V3;
        $2046da3312f94030$var$C[3][2] *= V3;
        color2[0] = $2046da3312f94030$var$C[0][0] + $2046da3312f94030$var$C[1][0] + $2046da3312f94030$var$C[2][0] + $2046da3312f94030$var$C[3][0];
        color2[1] = $2046da3312f94030$var$C[0][1] + $2046da3312f94030$var$C[1][1] + $2046da3312f94030$var$C[2][1] + $2046da3312f94030$var$C[3][1];
        color2[2] = $2046da3312f94030$var$C[0][2] + $2046da3312f94030$var$C[1][2] + $2046da3312f94030$var$C[2][2] + $2046da3312f94030$var$C[3][2];
    }
}
var $2046da3312f94030$export$a7045d693b4714f8 = class {
    /**
   * Expands the given data to the target size.
   *
   * @param {TypedArray} data - The input RGBA data. Assumed to be cubic.
   * @param {Number} size - The target size.
   * @return {TypedArray} The new data.
   */ static expand(data, size) {
        const originalSize = Math.cbrt(data.length / 4);
        const rgb = new Float32Array(3);
        const array = new data.constructor(size ** 3 * 4);
        const maxValue = data instanceof Uint8Array ? 255 : 1;
        const sizeSq = size ** 2;
        const s = 1 / (size - 1);
        for(let z = 0; z < size; ++z){
            for(let y = 0; y < size; ++y)for(let x = 0; x < size; ++x){
                const u = x * s;
                const v4 = y * s;
                const w = z * s;
                const i4 = Math.round(x + y * size + z * sizeSq) * 4;
                $2046da3312f94030$var$tetrahedralSample(data, originalSize, u, v4, w, rgb);
                array[i4 + 0] = rgb[0];
                array[i4 + 1] = rgb[1];
                array[i4 + 2] = rgb[2];
                array[i4 + 3] = maxValue;
            }
        }
        return array;
    }
};
// src/textures/smaa/SMAAAreaImageData.js
var $2046da3312f94030$var$area = [
    new Float32Array(2),
    new Float32Array(2)
];
var $2046da3312f94030$var$ORTHOGONAL_SIZE = 16;
var $2046da3312f94030$var$DIAGONAL_SIZE = 20;
var $2046da3312f94030$var$DIAGONAL_SAMPLES = 30;
var $2046da3312f94030$var$SMOOTH_MAX_DISTANCE = 32;
var $2046da3312f94030$var$orthogonalSubsamplingOffsets = new Float32Array([
    0,
    -0.25,
    0.25,
    -0.125,
    0.125,
    -0.375,
    0.375
]);
var $2046da3312f94030$var$diagonalSubsamplingOffsets = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        0.25,
        -0.25
    ]),
    new Float32Array([
        -0.25,
        0.25
    ]),
    new Float32Array([
        0.125,
        -0.125
    ]),
    new Float32Array([
        -0.125,
        0.125
    ])
];
var $2046da3312f94030$var$orthogonalEdges = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        3,
        3
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        4,
        0
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        4,
        3
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        0,
        4
    ]),
    new Uint8Array([
        3,
        4
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        4,
        1
    ]),
    new Uint8Array([
        1,
        4
    ]),
    new Uint8Array([
        4,
        4
    ])
];
var $2046da3312f94030$var$diagonalEdges = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        0,
        2
    ]),
    new Uint8Array([
        1,
        2
    ]),
    new Uint8Array([
        2,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        2,
        2
    ]),
    new Uint8Array([
        3,
        2
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        2,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        2,
        3
    ]),
    new Uint8Array([
        3,
        3
    ])
];
function $2046da3312f94030$var$lerp(a, b, p) {
    return a + (b - a) * p;
}
function $2046da3312f94030$var$saturate(a) {
    return Math.min(Math.max(a, 0), 1);
}
function $2046da3312f94030$var$smoothArea(d) {
    const a1 = $2046da3312f94030$var$area[0];
    const a2 = $2046da3312f94030$var$area[1];
    const b1X = Math.sqrt(a1[0] * 2) * 0.5;
    const b1Y = Math.sqrt(a1[1] * 2) * 0.5;
    const b2X = Math.sqrt(a2[0] * 2) * 0.5;
    const b2Y = Math.sqrt(a2[1] * 2) * 0.5;
    const p = $2046da3312f94030$var$saturate(d / $2046da3312f94030$var$SMOOTH_MAX_DISTANCE);
    a1[0] = $2046da3312f94030$var$lerp(b1X, a1[0], p);
    a1[1] = $2046da3312f94030$var$lerp(b1Y, a1[1], p);
    a2[0] = $2046da3312f94030$var$lerp(b2X, a2[0], p);
    a2[1] = $2046da3312f94030$var$lerp(b2Y, a2[1], p);
}
function $2046da3312f94030$var$getOrthArea(p1X, p1Y, p2X, p2Y, x, result) {
    const dX = p2X - p1X;
    const dY = p2Y - p1Y;
    const x1 = x;
    const x2 = x + 1;
    const y1 = p1Y + dY * (x1 - p1X) / dX;
    const y2 = p1Y + dY * (x2 - p1X) / dX;
    if (x1 >= p1X && x1 < p2X || x2 > p1X && x2 <= p2X) {
        if (Math.sign(y1) === Math.sign(y2) || Math.abs(y1) < 1e-4 || Math.abs(y2) < 1e-4) {
            const a = (y1 + y2) / 2;
            if (a < 0) {
                result[0] = Math.abs(a);
                result[1] = 0;
            } else {
                result[0] = 0;
                result[1] = Math.abs(a);
            }
        } else {
            const t = -p1Y * dX / dY + p1X;
            const tInt = Math.trunc(t);
            const a1 = t > p1X ? y1 * (t - tInt) / 2 : 0;
            const a2 = t < p2X ? y2 * (1 - (t - tInt)) / 2 : 0;
            const a = Math.abs(a1) > Math.abs(a2) ? a1 : -a2;
            if (a < 0) {
                result[0] = Math.abs(a1);
                result[1] = Math.abs(a2);
            } else {
                result[0] = Math.abs(a2);
                result[1] = Math.abs(a1);
            }
        }
    } else {
        result[0] = 0;
        result[1] = 0;
    }
    return result;
}
function $2046da3312f94030$var$getOrthAreaForPattern(pattern, left, right, offset, result) {
    const a1 = $2046da3312f94030$var$area[0];
    const a2 = $2046da3312f94030$var$area[1];
    const o1 = 0.5 + offset;
    const o2 = 0.5 + offset - 1;
    const d = left + right + 1;
    switch(pattern){
        case 0:
            result[0] = 0;
            result[1] = 0;
            break;
        case 1:
            if (left <= right) $2046da3312f94030$var$getOrthArea(0, o2, d / 2, 0, left, result);
            else {
                result[0] = 0;
                result[1] = 0;
            }
            break;
        case 2:
            if (left >= right) $2046da3312f94030$var$getOrthArea(d / 2, 0, d, o2, left, result);
            else {
                result[0] = 0;
                result[1] = 0;
            }
            break;
        case 3:
            $2046da3312f94030$var$getOrthArea(0, o2, d / 2, 0, left, a1);
            $2046da3312f94030$var$getOrthArea(d / 2, 0, d, o2, left, a2);
            $2046da3312f94030$var$smoothArea(d, $2046da3312f94030$var$area);
            result[0] = a1[0] + a2[0];
            result[1] = a1[1] + a2[1];
            break;
        case 4:
            if (left <= right) $2046da3312f94030$var$getOrthArea(0, o1, d / 2, 0, left, result);
            else {
                result[0] = 0;
                result[1] = 0;
            }
            break;
        case 5:
            result[0] = 0;
            result[1] = 0;
            break;
        case 6:
            if (Math.abs(offset) > 0) {
                $2046da3312f94030$var$getOrthArea(0, o1, d, o2, left, a1);
                $2046da3312f94030$var$getOrthArea(0, o1, d / 2, 0, left, a2);
                $2046da3312f94030$var$getOrthArea(d / 2, 0, d, o2, left, result);
                a2[0] = a2[0] + result[0];
                a2[1] = a2[1] + result[1];
                result[0] = (a1[0] + a2[0]) / 2;
                result[1] = (a1[1] + a2[1]) / 2;
            } else $2046da3312f94030$var$getOrthArea(0, o1, d, o2, left, result);
            break;
        case 7:
            $2046da3312f94030$var$getOrthArea(0, o1, d, o2, left, result);
            break;
        case 8:
            if (left >= right) $2046da3312f94030$var$getOrthArea(d / 2, 0, d, o1, left, result);
            else {
                result[0] = 0;
                result[1] = 0;
            }
            break;
        case 9:
            if (Math.abs(offset) > 0) {
                $2046da3312f94030$var$getOrthArea(0, o2, d, o1, left, a1);
                $2046da3312f94030$var$getOrthArea(0, o2, d / 2, 0, left, a2);
                $2046da3312f94030$var$getOrthArea(d / 2, 0, d, o1, left, result);
                a2[0] = a2[0] + result[0];
                a2[1] = a2[1] + result[1];
                result[0] = (a1[0] + a2[0]) / 2;
                result[1] = (a1[1] + a2[1]) / 2;
            } else $2046da3312f94030$var$getOrthArea(0, o2, d, o1, left, result);
            break;
        case 10:
            result[0] = 0;
            result[1] = 0;
            break;
        case 11:
            $2046da3312f94030$var$getOrthArea(0, o2, d, o1, left, result);
            break;
        case 12:
            $2046da3312f94030$var$getOrthArea(0, o1, d / 2, 0, left, a1);
            $2046da3312f94030$var$getOrthArea(d / 2, 0, d, o1, left, a2);
            $2046da3312f94030$var$smoothArea(d, $2046da3312f94030$var$area);
            result[0] = a1[0] + a2[0];
            result[1] = a1[1] + a2[1];
            break;
        case 13:
            $2046da3312f94030$var$getOrthArea(0, o2, d, o1, left, result);
            break;
        case 14:
            $2046da3312f94030$var$getOrthArea(0, o1, d, o2, left, result);
            break;
        case 15:
            result[0] = 0;
            result[1] = 0;
            break;
    }
    return result;
}
function $2046da3312f94030$var$isInsideArea(a1X, a1Y, a2X, a2Y, x, y) {
    let result = a1X === a2X && a1Y === a2Y;
    if (!result) {
        const xm = (a1X + a2X) / 2;
        const ym = (a1Y + a2Y) / 2;
        const a = a2Y - a1Y;
        const b = a1X - a2X;
        const c2 = a * (x - xm) + b * (y - ym);
        result = c2 > 0;
    }
    return result;
}
function $2046da3312f94030$var$getDiagAreaForPixel(a1X, a1Y, a2X, a2Y, pX, pY) {
    let n = 0;
    for(let y = 0; y < $2046da3312f94030$var$DIAGONAL_SAMPLES; ++y)for(let x = 0; x < $2046da3312f94030$var$DIAGONAL_SAMPLES; ++x){
        const offsetX = x / ($2046da3312f94030$var$DIAGONAL_SAMPLES - 1);
        const offsetY = y / ($2046da3312f94030$var$DIAGONAL_SAMPLES - 1);
        if ($2046da3312f94030$var$isInsideArea(a1X, a1Y, a2X, a2Y, pX + offsetX, pY + offsetY)) ++n;
    }
    return n / ($2046da3312f94030$var$DIAGONAL_SAMPLES * $2046da3312f94030$var$DIAGONAL_SAMPLES);
}
function $2046da3312f94030$var$getDiagArea(pattern, a1X, a1Y, a2X, a2Y, left, offset, result) {
    const e = $2046da3312f94030$var$diagonalEdges[pattern];
    const e1 = e[0];
    const e2 = e[1];
    if (e1 > 0) {
        a1X += offset[0];
        a1Y += offset[1];
    }
    if (e2 > 0) {
        a2X += offset[0];
        a2Y += offset[1];
    }
    result[0] = 1 - $2046da3312f94030$var$getDiagAreaForPixel(a1X, a1Y, a2X, a2Y, 1 + left, 0 + left);
    result[1] = $2046da3312f94030$var$getDiagAreaForPixel(a1X, a1Y, a2X, a2Y, 1 + left, 1 + left);
    return result;
}
function $2046da3312f94030$var$getDiagAreaForPattern(pattern, left, right, offset, result) {
    const a1 = $2046da3312f94030$var$area[0];
    const a2 = $2046da3312f94030$var$area[1];
    const d = left + right + 1;
    switch(pattern){
        case 0:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 1:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 0 + d, 0 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 2:
            $2046da3312f94030$var$getDiagArea(pattern, 0, 0, 1 + d, 0 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 3:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, result);
            break;
        case 4:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 0 + d, 0 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 5:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 0 + d, 0 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 6:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 1 + d, 0 + d, left, offset, result);
            break;
        case 7:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 1 + d, 0 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 8:
            $2046da3312f94030$var$getDiagArea(pattern, 0, 0, 1 + d, 1 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 9:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, result);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, result);
            break;
        case 10:
            $2046da3312f94030$var$getDiagArea(pattern, 0, 0, 1 + d, 1 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 11:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 12:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, result);
            break;
        case 13:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 1 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 14:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
        case 15:
            $2046da3312f94030$var$getDiagArea(pattern, 1, 1, 1 + d, 1 + d, left, offset, a1);
            $2046da3312f94030$var$getDiagArea(pattern, 1, 0, 1 + d, 0 + d, left, offset, a2);
            result[0] = (a1[0] + a2[0]) / 2;
            result[1] = (a1[1] + a2[1]) / 2;
            break;
    }
    return result;
}
function $2046da3312f94030$var$generatePatterns(patterns, offset, orthogonal) {
    const result = new Float32Array(2);
    for(let i = 0, l = patterns.length; i < l; ++i){
        const pattern = patterns[i];
        const data = pattern.data;
        const size = pattern.width;
        for(let y = 0; y < size; ++y)for(let x = 0; x < size; ++x){
            if (orthogonal) $2046da3312f94030$var$getOrthAreaForPattern(i, x, y, offset, result);
            else $2046da3312f94030$var$getDiagAreaForPattern(i, x, y, offset, result);
            const c2 = (y * size + x) * 2;
            data[c2] = result[0] * 255;
            data[c2 + 1] = result[1] * 255;
        }
    }
}
function $2046da3312f94030$var$assemble(baseX, baseY, patterns, edges2, size, orthogonal, target) {
    const dstData = target.data;
    const dstWidth = target.width;
    for(let i = 0, l = patterns.length; i < l; ++i){
        const edge = edges2[i];
        const pattern = patterns[i];
        const srcData = pattern.data;
        const srcWidth = pattern.width;
        for(let y = 0; y < size; ++y)for(let x = 0; x < size; ++x){
            const pX = edge[0] * size + baseX + x;
            const pY = edge[1] * size + baseY + y;
            const c2 = (pY * dstWidth + pX) * 4;
            const d = orthogonal ? (y * y * srcWidth + x * x) * 2 : (y * srcWidth + x) * 2;
            dstData[c2] = srcData[d];
            dstData[c2 + 1] = srcData[d + 1];
            dstData[c2 + 2] = 0;
            dstData[c2 + 3] = 255;
        }
    }
}
var $2046da3312f94030$export$73fc6bfc4fcb4fee = class {
    /**
   * Creates a new area image.
   *
   * @return {RawImageData} The generated image data.
   */ static generate() {
        const width = 10 * $2046da3312f94030$var$ORTHOGONAL_SIZE;
        const height = $2046da3312f94030$var$orthogonalSubsamplingOffsets.length * 5 * $2046da3312f94030$var$ORTHOGONAL_SIZE;
        const data = new Uint8ClampedArray(width * height * 4);
        const result = new $2046da3312f94030$export$82a80f8de384fe62(width, height, data);
        const orthPatternSize = Math.pow($2046da3312f94030$var$ORTHOGONAL_SIZE - 1, 2) + 1;
        const diagPatternSize = $2046da3312f94030$var$DIAGONAL_SIZE;
        const orthogonalPatterns = [];
        const diagonalPatterns = [];
        for(let i = 3, l = data.length; i < l; i += 4)data[i] = 255;
        for(let i = 0; i < 16; ++i){
            orthogonalPatterns.push(new $2046da3312f94030$export$82a80f8de384fe62(orthPatternSize, orthPatternSize, new Uint8ClampedArray(orthPatternSize * orthPatternSize * 2), 2));
            diagonalPatterns.push(new $2046da3312f94030$export$82a80f8de384fe62(diagPatternSize, diagPatternSize, new Uint8ClampedArray(diagPatternSize * diagPatternSize * 2), 2));
        }
        for(let i = 0, l = $2046da3312f94030$var$orthogonalSubsamplingOffsets.length; i < l; ++i){
            $2046da3312f94030$var$generatePatterns(orthogonalPatterns, $2046da3312f94030$var$orthogonalSubsamplingOffsets[i], true);
            $2046da3312f94030$var$assemble(0, 5 * $2046da3312f94030$var$ORTHOGONAL_SIZE * i, orthogonalPatterns, $2046da3312f94030$var$orthogonalEdges, $2046da3312f94030$var$ORTHOGONAL_SIZE, true, result);
        }
        for(let i = 0, l = $2046da3312f94030$var$diagonalSubsamplingOffsets.length; i < l; ++i){
            $2046da3312f94030$var$generatePatterns(diagonalPatterns, $2046da3312f94030$var$diagonalSubsamplingOffsets[i], false);
            $2046da3312f94030$var$assemble(5 * $2046da3312f94030$var$ORTHOGONAL_SIZE, 4 * $2046da3312f94030$var$DIAGONAL_SIZE * i, diagonalPatterns, $2046da3312f94030$var$diagonalEdges, $2046da3312f94030$var$DIAGONAL_SIZE, false, result);
        }
        return result;
    }
};
// temp/smaa/worker.txt
var $2046da3312f94030$var$worker_default2 = '"use strict";(()=>{function q(t,a,s){let e=document.createElement("canvas"),n=e.getContext("2d");if(e.width=t,e.height=a,s instanceof Image)n.drawImage(s,0,0);else{let r=n.createImageData(t,a);r.data.set(s),n.putImageData(r,0,0)}return e}var F=class t{constructor(a=0,s=0,e=null){this.width=a,this.height=s,this.data=e}toCanvas(){return typeof document=="undefined"?null:q(this.width,this.height,this.data)}static from(a){let{width:s,height:e}=a,n;if(a instanceof Image){let r=q(s,e,a);r!==null&&(n=r.getContext("2d").getImageData(0,0,s,e).data)}else n=a.data;return new t(s,e,n)}};var M=[new Float32Array(2),new Float32Array(2)],D=16,W=20,I=30,j=32,v=new Float32Array([0,-.25,.25,-.125,.125,-.375,.375]),N=[new Float32Array([0,0]),new Float32Array([.25,-.25]),new Float32Array([-.25,.25]),new Float32Array([.125,-.125]),new Float32Array([-.125,.125])],z=[new Uint8Array([0,0]),new Uint8Array([3,0]),new Uint8Array([0,3]),new Uint8Array([3,3]),new Uint8Array([1,0]),new Uint8Array([4,0]),new Uint8Array([1,3]),new Uint8Array([4,3]),new Uint8Array([0,1]),new Uint8Array([3,1]),new Uint8Array([0,4]),new Uint8Array([3,4]),new Uint8Array([1,1]),new Uint8Array([4,1]),new Uint8Array([1,4]),new Uint8Array([4,4])],p=[new Uint8Array([0,0]),new Uint8Array([1,0]),new Uint8Array([0,2]),new Uint8Array([1,2]),new Uint8Array([2,0]),new Uint8Array([3,0]),new Uint8Array([2,2]),new Uint8Array([3,2]),new Uint8Array([0,1]),new Uint8Array([1,1]),new Uint8Array([0,3]),new Uint8Array([1,3]),new Uint8Array([2,1]),new Uint8Array([3,1]),new Uint8Array([2,3]),new Uint8Array([3,3])];function C(t,a,s){return t+(a-t)*s}function B(t){return Math.min(Math.max(t,0),1)}function _(t){let a=M[0],s=M[1],e=Math.sqrt(a[0]*2)*.5,n=Math.sqrt(a[1]*2)*.5,r=Math.sqrt(s[0]*2)*.5,o=Math.sqrt(s[1]*2)*.5,c=B(t/j);a[0]=C(e,a[0],c),a[1]=C(n,a[1],c),s[0]=C(r,s[0],c),s[1]=C(o,s[1],c)}function d(t,a,s,e,n,r){let o=s-t,c=e-a,h=n,i=n+1,w=a+c*(h-t)/o,b=a+c*(i-t)/o;if(h>=t&&h<s||i>t&&i<=s)if(Math.sign(w)===Math.sign(b)||Math.abs(w)<1e-4||Math.abs(b)<1e-4){let g=(w+b)/2;g<0?(r[0]=Math.abs(g),r[1]=0):(r[0]=0,r[1]=Math.abs(g))}else{let g=-a*o/c+t,k=Math.trunc(g),m=g>t?w*(g-k)/2:0,U=g<s?b*(1-(g-k))/2:0;(Math.abs(m)>Math.abs(U)?m:-U)<0?(r[0]=Math.abs(m),r[1]=Math.abs(U)):(r[0]=Math.abs(U),r[1]=Math.abs(m))}else r[0]=0,r[1]=0;return r}function J(t,a,s,e,n){let r=M[0],o=M[1],c=.5+e,h=.5+e-1,i=a+s+1;switch(t){case 0:{n[0]=0,n[1]=0;break}case 1:{a<=s?d(0,h,i/2,0,a,n):(n[0]=0,n[1]=0);break}case 2:{a>=s?d(i/2,0,i,h,a,n):(n[0]=0,n[1]=0);break}case 3:{d(0,h,i/2,0,a,r),d(i/2,0,i,h,a,o),_(i,M),n[0]=r[0]+o[0],n[1]=r[1]+o[1];break}case 4:{a<=s?d(0,c,i/2,0,a,n):(n[0]=0,n[1]=0);break}case 5:{n[0]=0,n[1]=0;break}case 6:{Math.abs(e)>0?(d(0,c,i,h,a,r),d(0,c,i/2,0,a,o),d(i/2,0,i,h,a,n),o[0]=o[0]+n[0],o[1]=o[1]+n[1],n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2):d(0,c,i,h,a,n);break}case 7:{d(0,c,i,h,a,n);break}case 8:{a>=s?d(i/2,0,i,c,a,n):(n[0]=0,n[1]=0);break}case 9:{Math.abs(e)>0?(d(0,h,i,c,a,r),d(0,h,i/2,0,a,o),d(i/2,0,i,c,a,n),o[0]=o[0]+n[0],o[1]=o[1]+n[1],n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2):d(0,h,i,c,a,n);break}case 10:{n[0]=0,n[1]=0;break}case 11:{d(0,h,i,c,a,n);break}case 12:{d(0,c,i/2,0,a,r),d(i/2,0,i,c,a,o),_(i,M),n[0]=r[0]+o[0],n[1]=r[1]+o[1];break}case 13:{d(0,h,i,c,a,n);break}case 14:{d(0,c,i,h,a,n);break}case 15:{n[0]=0,n[1]=0;break}}return n}function K(t,a,s,e,n,r){let o=t===s&&a===e;if(!o){let c=(t+s)/2,h=(a+e)/2,i=e-a,w=t-s;o=i*(n-c)+w*(r-h)>0}return o}function G(t,a,s,e,n,r){let o=0;for(let c=0;c<I;++c)for(let h=0;h<I;++h){let i=h/(I-1),w=c/(I-1);K(t,a,s,e,n+i,r+w)&&++o}return o/(I*I)}function A(t,a,s,e,n,r,o,c){let h=p[t],i=h[0],w=h[1];return i>0&&(a+=o[0],s+=o[1]),w>0&&(e+=o[0],n+=o[1]),c[0]=1-G(a,s,e,n,1+r,0+r),c[1]=G(a,s,e,n,1+r,1+r),c}function Q(t,a,s,e,n){let r=M[0],o=M[1],c=a+s+1;switch(t){case 0:{A(t,1,1,1+c,1+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 1:{A(t,1,0,0+c,0+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 2:{A(t,0,0,1+c,0+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 3:{A(t,1,0,1+c,0+c,a,e,n);break}case 4:{A(t,1,1,0+c,0+c,a,e,r),A(t,1,1,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 5:{A(t,1,1,0+c,0+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 6:{A(t,1,1,1+c,0+c,a,e,n);break}case 7:{A(t,1,1,1+c,0+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 8:{A(t,0,0,1+c,1+c,a,e,r),A(t,1,0,1+c,1+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 9:{A(t,1,0,1+c,1+c,a,e,n),A(t,1,0,1+c,1+c,a,e,n);break}case 10:{A(t,0,0,1+c,1+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 11:{A(t,1,0,1+c,1+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 12:{A(t,1,1,1+c,1+c,a,e,n);break}case 13:{A(t,1,1,1+c,1+c,a,e,r),A(t,1,0,1+c,1+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 14:{A(t,1,1,1+c,1+c,a,e,r),A(t,1,1,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}case 15:{A(t,1,1,1+c,1+c,a,e,r),A(t,1,0,1+c,0+c,a,e,o),n[0]=(r[0]+o[0])/2,n[1]=(r[1]+o[1])/2;break}}return n}function R(t,a,s){let e=new Float32Array(2);for(let n=0,r=t.length;n<r;++n){let o=t[n],c=o.data,h=o.width;for(let i=0;i<h;++i)for(let w=0;w<h;++w){s?J(n,w,i,a,e):Q(n,w,i,a,e);let b=(i*h+w)*2;c[b]=e[0]*255,c[b+1]=e[1]*255}}}function T(t,a,s,e,n,r,o){let c=o.data,h=o.width;for(let i=0,w=s.length;i<w;++i){let b=e[i],g=s[i],k=g.data,m=g.width;for(let U=0;U<n;++U)for(let x=0;x<n;++x){let Z=b[0]*n+t+x,O=((b[1]*n+a+U)*h+Z)*4,L=r?(U*U*m+x*x)*2:(U*m+x)*2;c[O]=k[L],c[O+1]=k[L+1],c[O+2]=0,c[O+3]=255}}}var S=class{static generate(){let a=10*D,s=v.length*5*D,e=new Uint8ClampedArray(a*s*4),n=new F(a,s,e),r=Math.pow(D-1,2)+1,o=W,c=[],h=[];for(let i=3,w=e.length;i<w;i+=4)e[i]=255;for(let i=0;i<16;++i)c.push(new F(r,r,new Uint8ClampedArray(r*r*2),2)),h.push(new F(o,o,new Uint8ClampedArray(o*o*2),2));for(let i=0,w=v.length;i<w;++i)R(c,v[i],!0),T(0,5*D*i,c,z,D,!0,n);for(let i=0,w=N.length;i<w;++i)R(h,N[i],!1),T(5*D,4*W*i,h,p,W,!1,n);return n}};var P=new Map([[y(0,0,0,0),new Float32Array([0,0,0,0])],[y(0,0,0,1),new Float32Array([0,0,0,1])],[y(0,0,1,0),new Float32Array([0,0,1,0])],[y(0,0,1,1),new Float32Array([0,0,1,1])],[y(0,1,0,0),new Float32Array([0,1,0,0])],[y(0,1,0,1),new Float32Array([0,1,0,1])],[y(0,1,1,0),new Float32Array([0,1,1,0])],[y(0,1,1,1),new Float32Array([0,1,1,1])],[y(1,0,0,0),new Float32Array([1,0,0,0])],[y(1,0,0,1),new Float32Array([1,0,0,1])],[y(1,0,1,0),new Float32Array([1,0,1,0])],[y(1,0,1,1),new Float32Array([1,0,1,1])],[y(1,1,0,0),new Float32Array([1,1,0,0])],[y(1,1,0,1),new Float32Array([1,1,0,1])],[y(1,1,1,0),new Float32Array([1,1,1,0])],[y(1,1,1,1),new Float32Array([1,1,1,1])]]);function H(t,a,s){return t+(a-t)*s}function y(t,a,s,e){let n=H(t,a,.75),r=H(s,e,1-.25);return H(n,r,1-.125)}function V(t,a){let s=0;return a[3]===1&&(s+=1),s===1&&a[2]===1&&t[1]!==1&&t[3]!==1&&(s+=1),s}function $(t,a){let s=0;return a[3]===1&&t[1]!==1&&t[3]!==1&&(s+=1),s===1&&a[2]===1&&t[0]!==1&&t[2]!==1&&(s+=1),s}var E=class{static generate(){let o=new Uint8ClampedArray(2178),c=new Uint8ClampedArray(1024*4);for(let h=0;h<33;++h)for(let i=0;i<66;++i){let w=.03125*i,b=.03125*h;if(P.has(w)&&P.has(b)){let g=P.get(w),k=P.get(b),m=h*66+i;o[m]=127*V(g,k),o[m+33]=127*$(g,k)}}for(let h=0,i=17;i<33;++i)for(let w=0;w<64;++w,h+=4)c[h]=o[i*66+w],c[h+3]=255;return new F(64,16,c)}};self.addEventListener("message",t=>{let a=S.generate(),s=E.generate();postMessage({areaImageData:a,searchImageData:s},[a.data.buffer,s.data.buffer]),close()});})();\n';
// src/textures/smaa/SMAAImageGenerator.js
function $2046da3312f94030$var$generate(useCache = true) {
    const workerURL = URL.createObjectURL(new Blob([
        $2046da3312f94030$var$worker_default2
    ], {
        type: "text/javascript"
    }));
    const worker = new Worker(workerURL);
    URL.revokeObjectURL(workerURL);
    return new Promise((resolve, reject)=>{
        worker.addEventListener("error", (event)=>reject(event.error));
        worker.addEventListener("message", (event)=>{
            const searchImageData = $2046da3312f94030$export$82a80f8de384fe62.from(event.data.searchImageData);
            const areaImageData = $2046da3312f94030$export$82a80f8de384fe62.from(event.data.areaImageData);
            const urls = [
                searchImageData.toCanvas().toDataURL("image/png", 1),
                areaImageData.toCanvas().toDataURL("image/png", 1)
            ];
            if (useCache) {
                localStorage.setItem("smaa-search", urls[0]);
                localStorage.setItem("smaa-area", urls[1]);
            }
            resolve(urls);
        });
        worker.postMessage(null);
    });
}
var $2046da3312f94030$export$ca191ed58d7431fe = class {
    /**
   * Constructs a new SMAA image generator.
   */ constructor(){
        this.disableCache = false;
    }
    /**
   * Enables or disables caching via localStorage.
   *
   * @param {Boolean} value - Whether the cache should be enabled.
   */ setCacheEnabled(value) {
        this.disableCache = !value;
    }
    /**
   * Generates the SMAA data images.
   *
   * @example
   * SMAAImageGenerator.generate().then(([search, area]) => {
   *   const smaaEffect = new SMAAEffect(search, area);
   * });
   * @return {Promise<Image[]>} A promise that returns the search image and area image as a pair.
   */ generate() {
        const useCache = !this.disableCache && window.localStorage !== void 0;
        const cachedURLs = useCache ? [
            localStorage.getItem("smaa-search"),
            localStorage.getItem("smaa-area")
        ] : [
            null,
            null
        ];
        const promise = cachedURLs[0] !== null && cachedURLs[1] !== null ? Promise.resolve(cachedURLs) : $2046da3312f94030$var$generate(useCache);
        return promise.then((urls)=>{
            return new Promise((resolve, reject)=>{
                const searchImage = new Image();
                const areaImage = new Image();
                const manager = new (0, $ce0cdebec9150cb3$export$99cc795e99919eed)();
                manager.onLoad = ()=>resolve([
                        searchImage,
                        areaImage
                    ]);
                manager.onError = reject;
                searchImage.addEventListener("error", (e)=>manager.itemError("smaa-search"));
                areaImage.addEventListener("error", (e)=>manager.itemError("smaa-area"));
                searchImage.addEventListener("load", ()=>manager.itemEnd("smaa-search"));
                areaImage.addEventListener("load", ()=>manager.itemEnd("smaa-area"));
                manager.itemStart("smaa-search");
                manager.itemStart("smaa-area");
                searchImage.src = urls[0];
                areaImage.src = urls[1];
            });
        });
    }
};
// src/textures/smaa/SMAASearchImageData.js
var $2046da3312f94030$var$edges = /* @__PURE__ */ new Map([
    [
        $2046da3312f94030$var$bilinear(0, 0, 0, 0),
        new Float32Array([
            0,
            0,
            0,
            0
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(0, 0, 0, 1),
        new Float32Array([
            0,
            0,
            0,
            1
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(0, 0, 1, 0),
        new Float32Array([
            0,
            0,
            1,
            0
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(0, 0, 1, 1),
        new Float32Array([
            0,
            0,
            1,
            1
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(0, 1, 0, 0),
        new Float32Array([
            0,
            1,
            0,
            0
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(0, 1, 0, 1),
        new Float32Array([
            0,
            1,
            0,
            1
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(0, 1, 1, 0),
        new Float32Array([
            0,
            1,
            1,
            0
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(0, 1, 1, 1),
        new Float32Array([
            0,
            1,
            1,
            1
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(1, 0, 0, 0),
        new Float32Array([
            1,
            0,
            0,
            0
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(1, 0, 0, 1),
        new Float32Array([
            1,
            0,
            0,
            1
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(1, 0, 1, 0),
        new Float32Array([
            1,
            0,
            1,
            0
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(1, 0, 1, 1),
        new Float32Array([
            1,
            0,
            1,
            1
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(1, 1, 0, 0),
        new Float32Array([
            1,
            1,
            0,
            0
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(1, 1, 0, 1),
        new Float32Array([
            1,
            1,
            0,
            1
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(1, 1, 1, 0),
        new Float32Array([
            1,
            1,
            1,
            0
        ])
    ],
    [
        $2046da3312f94030$var$bilinear(1, 1, 1, 1),
        new Float32Array([
            1,
            1,
            1,
            1
        ])
    ]
]);
function $2046da3312f94030$var$lerp2(a, b, p) {
    return a + (b - a) * p;
}
function $2046da3312f94030$var$bilinear(e0, e1, e2, e3) {
    const a = $2046da3312f94030$var$lerp2(e0, e1, 0.75);
    const b = $2046da3312f94030$var$lerp2(e2, e3, 0.75);
    return $2046da3312f94030$var$lerp2(a, b, 0.875);
}
function $2046da3312f94030$var$deltaLeft(left, top) {
    let d = 0;
    if (top[3] === 1) d += 1;
    if (d === 1 && top[2] === 1 && left[1] !== 1 && left[3] !== 1) d += 1;
    return d;
}
function $2046da3312f94030$var$deltaRight(left, top) {
    let d = 0;
    if (top[3] === 1 && left[1] !== 1 && left[3] !== 1) d += 1;
    if (d === 1 && top[2] === 1 && left[0] !== 1 && left[2] !== 1) d += 1;
    return d;
}
var $2046da3312f94030$export$fcf9afd86c84a43a = class {
    /**
   * Creates a new search image.
   *
   * @return {RawImageData} The generated image data.
   */ static generate() {
        const width = 66;
        const height = 33;
        const halfWidth = width / 2;
        const croppedWidth = 64;
        const croppedHeight = 16;
        const data = new Uint8ClampedArray(width * height);
        const croppedData = new Uint8ClampedArray(croppedWidth * croppedHeight * 4);
        for(let y = 0; y < height; ++y)for(let x = 0; x < width; ++x){
            const s = 0.03125 * x;
            const t = 0.03125 * y;
            if ($2046da3312f94030$var$edges.has(s) && $2046da3312f94030$var$edges.has(t)) {
                const e1 = $2046da3312f94030$var$edges.get(s);
                const e2 = $2046da3312f94030$var$edges.get(t);
                const i = y * width + x;
                data[i] = 127 * $2046da3312f94030$var$deltaLeft(e1, e2);
                data[i + halfWidth] = 127 * $2046da3312f94030$var$deltaRight(e1, e2);
            }
        }
        for(let i = 0, y = height - croppedHeight; y < height; ++y)for(let x = 0; x < croppedWidth; ++x, i += 4){
            croppedData[i] = data[y * width + x];
            croppedData[i + 3] = 255;
        }
        return new $2046da3312f94030$export$82a80f8de384fe62(croppedWidth, croppedHeight, croppedData);
    }
};


function $470c8158486f2eac$export$407448d2b89b1813(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $470c8158486f2eac$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $470c8158486f2eac$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $470c8158486f2eac$var$ownKeys(Object(source), true).forEach(function(key) {
            $470c8158486f2eac$export$407448d2b89b1813(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $470c8158486f2eac$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function $ed71381219283563$export$71511d61b312f219(o, p) {
    $ed71381219283563$export$71511d61b312f219 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ed71381219283563$export$71511d61b312f219(o, p);
}
function $ed71381219283563$export$407448d2b89b1813() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}




/**
 *
 * @param terms
 *
 * | a b |
 * | c d |
 *
 * @returns {number} determinant
 */ function $c502f246d0b5067c$export$8b22cf2602fb60ce() {
    for(var _len = arguments.length, terms = new Array(_len), _key = 0; _key < _len; _key++)terms[_key] = arguments[_key];
    var a = terms[0], b = terms[1], c = terms[2], d = terms[3];
    return a * d - b * c;
}
/**
 *
 * @param terms
 *
 * | a b c |
 * | d e f |
 * | g h i |
 *
 * @returns {number} determinant
 */ function $c502f246d0b5067c$export$4368d992c4eafac0() {
    for(var _len2 = arguments.length, terms = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)terms[_key2] = arguments[_key2];
    var a = terms[0], b = terms[1], c = terms[2], d = terms[3], e = terms[4], f = terms[5], g = terms[6], h = terms[7], i = terms[8];
    return a * e * i + b * f * g + c * d * h - c * e * g - b * d * i - a * f * h;
}
/**
 *
 * @param terms
 *
 * | a b c g |
 * | h i j k |
 * | l m n o |
 *
 * @returns {number} determinant
 */ function $c502f246d0b5067c$export$db3b6bfb95261072() {
    for(var _len3 = arguments.length, terms = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)terms[_key3] = arguments[_key3];
    terms[0];
    terms[1];
    terms[2];
    terms[3];
    terms[4];
    terms[5];
    terms[6];
    terms[7];
    terms[8];
    terms[9];
    terms[10];
    terms[11];
    terms[12];
    terms[13];
    terms[14]; // TODO
}
/**
 *
 * Get the determinant of matrix m without row r and col c
 *
 * @param {matrix} m Starter matrix
 * @param r row to remove
 * @param c col to remove
 *
 *     | a b c |
 * m = | d e f |
 *     | g h i |
 *
 * getMinor(m, 1, 1) would result in this determinant
 *
 * | a c |
 * | g i |
 *
 * @returns {number} determinant
 */ function $c502f246d0b5067c$export$39b482c5e57630a8(matrix, r, c) {
    var _matrixTranspose = matrix.clone().transpose();
    var x = [];
    var l = _matrixTranspose.elements.length;
    var n = Math.sqrt(l);
    for(var i = 0; i < l; i++){
        var element = _matrixTranspose.elements[i];
        var row = Math.floor(i / n);
        var col = i % n;
        if (row !== r - 1 && col !== c - 1) x.push(element);
    }
    return $c502f246d0b5067c$export$4368d992c4eafac0.apply(void 0, x);
}
/**
 *
 */ function $c502f246d0b5067c$export$407448d2b89b1813(m1, m2) {
    var sum = [];
    var m1Array = m1.toArray();
    var m2Array = m2.toArray();
    for(var i = 0; i < m1Array.length; i++)sum[i] = m1Array[i] + m2Array[i];
    return new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)().fromArray(sum);
}
var $c502f246d0b5067c$export$953cecd6e717a553 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    determinant2: $c502f246d0b5067c$export$8b22cf2602fb60ce,
    determinant3: $c502f246d0b5067c$export$4368d992c4eafac0,
    determinant4: $c502f246d0b5067c$export$db3b6bfb95261072,
    getMinor: $c502f246d0b5067c$export$39b482c5e57630a8,
    matrixSum3: $c502f246d0b5067c$export$407448d2b89b1813
});


function $701fd23866307bd4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $701fd23866307bd4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $701fd23866307bd4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $701fd23866307bd4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $701fd23866307bd4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $701fd23866307bd4$var$_arrayLikeToArray(o, minLen);
}
function $701fd23866307bd4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $701fd23866307bd4$export$71511d61b312f219(arr, i) {
    return $701fd23866307bd4$var$_arrayWithHoles(arr) || $701fd23866307bd4$var$_iterableToArrayLimit(arr, i) || $701fd23866307bd4$var$_unsupportedIterableToArray(arr, i) || $701fd23866307bd4$var$_nonIterableRest();
}
function $701fd23866307bd4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $701fd23866307bd4$var$_arrayLikeToArray(arr);
}
function $701fd23866307bd4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $701fd23866307bd4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $701fd23866307bd4$export$407448d2b89b1813(arr) {
    return $701fd23866307bd4$var$_arrayWithoutHoles(arr) || $701fd23866307bd4$var$_iterableToArray(arr) || $701fd23866307bd4$var$_unsupportedIterableToArray(arr) || $701fd23866307bd4$var$_nonIterableSpread();
}
function $701fd23866307bd4$var$_construct(Parent, args, Class) {
    if ((0, $ed71381219283563$export$407448d2b89b1813)()) $701fd23866307bd4$var$_construct = Reflect.construct;
    else $701fd23866307bd4$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $ed71381219283563$export$71511d61b312f219)(instance, Class.prototype);
        return instance;
    };
    return $701fd23866307bd4$var$_construct.apply(null, arguments);
}
/**
 *
 * @param point
 *
 * @param triangle
 *
 * @returns {boolean} true if the point is in the triangle
 *
 * TODO: Find explainer
 */ function $701fd23866307bd4$export$23f2a1d2818174ef(point, triangle) {
    var _triangle$ = $701fd23866307bd4$export$71511d61b312f219(triangle[0], 2), ax = _triangle$[0], ay = _triangle$[1];
    var _triangle$2 = $701fd23866307bd4$export$71511d61b312f219(triangle[1], 2), bx = _triangle$2[0], by = _triangle$2[1];
    var _triangle$3 = $701fd23866307bd4$export$71511d61b312f219(triangle[2], 2), cx = _triangle$3[0], cy = _triangle$3[1];
    var _point = $701fd23866307bd4$export$71511d61b312f219(point, 2), px = _point[0], py = _point[1]; // TODO Sub with static calc
    var matrix = new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)(); // prettier-ignore
    matrix.set(ax, ay, ax * ax + ay * ay, 1, bx, by, bx * bx + by * by, 1, cx, cy, cx * cx + cy * cy, 1, px, py, px * px + py * py, 1);
    return matrix.determinant() <= 0;
}
function $701fd23866307bd4$export$8b22cf2602fb60ce(triangle) {
    var _triangle$4 = $701fd23866307bd4$export$71511d61b312f219(triangle[0], 2), x1 = _triangle$4[0], y1 = _triangle$4[1];
    var _triangle$5 = $701fd23866307bd4$export$71511d61b312f219(triangle[1], 2), x2 = _triangle$5[0], y2 = _triangle$5[1];
    var _triangle$6 = $701fd23866307bd4$export$71511d61b312f219(triangle[2], 2), x3 = _triangle$6[0], y3 = _triangle$6[1]; // prettier-ignore
    return (0, $c502f246d0b5067c$export$4368d992c4eafac0)(x1, y1, 1, x2, y2, 1, x3, y3, 1);
}
/**
 * Uses triangle area determinant to check if 3 points are collinear.
 * If they are, they can't make a triangle, so the determinant will be 0!
 *
 *      0     1     2
 * ─────■─────■─────■
 *
 *
 * Fun fact, you can use this same determinant to check the order of the points in the triangle
 *
 * NOTE: Should this use a buffer instead? NOTE: Should this use a buffer instead? [x0, y0, x1, y1, x2, y2]?
 *
 */ function $701fd23866307bd4$export$db3b6bfb95261072(points) {
    return $701fd23866307bd4$export$8b22cf2602fb60ce(points) === 0;
} // TODO This is the same principle as the prev function, find a way to make it have sense
function $701fd23866307bd4$export$f1e1789686576879(triangle) {
    return $701fd23866307bd4$export$8b22cf2602fb60ce(triangle) < 0;
}
/**
 
The circumcircle is a circle touching all the vertices of a triangle or polygon.

             ┌───┐             
             │ B │             
             └───┘             
           .───●───.           
        ,─'   ╱ ╲   '─.        
      ,'     ╱   ╲     `.      
     ╱      ╱     ╲      ╲     
    ;      ╱       ╲      :    
    │     ╱         ╲     │    
    │    ╱           ╲    │    
    :   ╱             ╲   ;    
     ╲ ╱               ╲ ╱     
┌───┐ ●─────────────────● ┌───┐
│ A │  `.             ,'  │ C │
└───┘    '─.       ,─'    └───┘
            `─────'                         
 */ /**
 *
 * @param triangle
 *
 * @returns {number} circumcircle
 */ // https://math.stackexchange.com/a/1460096
function $701fd23866307bd4$export$39b482c5e57630a8(triangle) {
    // TS-TODO the next few lines are ignored because the types aren't current to the change in vectors (that can now be iterated)
    // @ts-ignore
    var _triangle$7 = $701fd23866307bd4$export$71511d61b312f219(triangle[0], 2), ax = _triangle$7[0], ay = _triangle$7[1]; // @ts-ignore
    var _triangle$8 = $701fd23866307bd4$export$71511d61b312f219(triangle[1], 2), bx = _triangle$8[0], by = _triangle$8[1]; // @ts-ignore
    var _triangle$9 = $701fd23866307bd4$export$71511d61b312f219(triangle[2], 2), cx = _triangle$9[0], cy = _triangle$9[1];
    if ($701fd23866307bd4$export$db3b6bfb95261072(triangle)) return null; // points are collinear
    var m = new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)(); // prettier-ignore
    m.set(1, 1, 1, 1, ax * ax + ay * ay, ax, ay, 1, bx * bx + by * by, bx, by, 1, cx * cx + cy * cy, cx, cy, 1);
    var m11 = (0, $c502f246d0b5067c$export$39b482c5e57630a8)(m, 1, 1);
    var m13 = (0, $c502f246d0b5067c$export$39b482c5e57630a8)(m, 1, 3);
    var m12 = (0, $c502f246d0b5067c$export$39b482c5e57630a8)(m, 1, 2);
    var m14 = (0, $c502f246d0b5067c$export$39b482c5e57630a8)(m, 1, 4);
    var x0 = 0.5 * (m12 / m11);
    var y0 = 0.5 * (m13 / m11);
    var r2 = x0 * x0 + y0 * y0 + m14 / m11;
    return {
        x: Math.abs(x0) === 0 ? 0 : x0,
        y: Math.abs(y0) === 0 ? 0 : -y0,
        r: Math.sqrt(r2)
    };
} // https://stackoverflow.com/questions/39984709/how-can-i-check-wether-a-point-is-inside-the-circumcircle-of-3-points
function $701fd23866307bd4$export$2d1720544b23b823(point, triangle) {
    var _ref = Array.isArray(triangle[0]) ? triangle[0] : triangle[0].toArray(), _ref2 = $701fd23866307bd4$export$71511d61b312f219(_ref, 2), ax = _ref2[0], ay = _ref2[1];
    var _ref3 = Array.isArray(triangle[1]) ? triangle[1] : triangle[1].toArray(), _ref4 = $701fd23866307bd4$export$71511d61b312f219(_ref3, 2), bx = _ref4[0], by = _ref4[1];
    var _ref5 = Array.isArray(triangle[2]) ? triangle[2] : triangle[2].toArray(), _ref6 = $701fd23866307bd4$export$71511d61b312f219(_ref5, 2), cx = _ref6[0], cy = _ref6[1];
    var _point2 = $701fd23866307bd4$export$71511d61b312f219(point, 2), px = _point2[0], py = _point2[1];
    if ($701fd23866307bd4$export$db3b6bfb95261072(triangle)) throw new Error("Collinear points don't form a triangle");
    /**
          | ax-px, ay-py, (ax-px)² + (ay-py)² |
    det = | bx-px, by-py, (bx-px)² + (by-py)² |
          | cx-px, cy-py, (cx-px)² + (cy-py)² |
  */ var x1mpx = ax - px;
    var aympy = ay - py;
    var bxmpx = bx - px;
    var bympy = by - py;
    var cxmpx = cx - px;
    var cympy = cy - py; // prettier-ignore
    var d = (0, $c502f246d0b5067c$export$4368d992c4eafac0)(x1mpx, aympy, x1mpx * x1mpx + aympy * aympy, bxmpx, bympy, bxmpx * bxmpx + bympy * bympy, cxmpx, cympy, cxmpx * cxmpx + cympy * cympy); // if d is 0, the point is on C
    if (d === 0) return true;
    return !$701fd23866307bd4$export$f1e1789686576879(triangle) ? d > 0 : d < 0;
} // From https://algorithmtutor.com/Computational-Geometry/Determining-if-two-consecutive-segments-turn-left-or-right/
var $701fd23866307bd4$var$mv1 = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
var $701fd23866307bd4$var$mv2 = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
/**
 
     ╱      ╲     
    ╱        ╲    
   ▕          ▏   
                  
 right      left  

 * NOTE: Should this use a buffer instead? [x0, y0, x1, y1]?
 */ function $701fd23866307bd4$export$4368d992c4eafac0(points) {
    var _points$map = points.map(function(p) {
        if (Array.isArray(p)) return $701fd23866307bd4$var$_construct((0, $ce0cdebec9150cb3$export$c977b3e384af9ae1), $701fd23866307bd4$export$407448d2b89b1813(p));
        return p;
    }), _points$map2 = $701fd23866307bd4$export$71511d61b312f219(_points$map, 3), p1 = _points$map2[0], p2 = _points$map2[1], p3 = _points$map2[2];
    if ($701fd23866307bd4$export$db3b6bfb95261072(points)) return false; // @ts-ignore
    var p2p1 = $701fd23866307bd4$var$mv1.subVectors(p2, p1); // @ts-ignore
    var p3p1 = $701fd23866307bd4$var$mv2.subVectors(p3, p1);
    var cross = p3p1.cross(p2p1);
    return cross > 0;
}
var $701fd23866307bd4$export$625550452a3fa3ec = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    isPointInTriangle: $701fd23866307bd4$export$23f2a1d2818174ef,
    triangleDeterminant: $701fd23866307bd4$export$8b22cf2602fb60ce,
    arePointsCollinear: $701fd23866307bd4$export$db3b6bfb95261072,
    isTriangleClockwise: $701fd23866307bd4$export$f1e1789686576879,
    getCircumcircle: $701fd23866307bd4$export$39b482c5e57630a8,
    isPointInCircumcircle: $701fd23866307bd4$export$2d1720544b23b823,
    doThreePointsMakeARight: $701fd23866307bd4$export$4368d992c4eafac0
});






/**
 * Clamps a value between a range.
 */ function $81e217a8cc1f1057$export$db3b6bfb95261072(value, min, max) {
    return Math.max(min, Math.min(max, value));
} // Loops the value t, so that it is never larger than length and never smaller than 0.
function $81e217a8cc1f1057$var$repeat(t, length) {
    return $81e217a8cc1f1057$export$db3b6bfb95261072(t - Math.floor(t / length) * length, 0, length);
} // Calculates the shortest difference between two given angles.
function $81e217a8cc1f1057$export$4368d992c4eafac0(current, target) {
    var delta = $81e217a8cc1f1057$var$repeat(target - current, Math.PI * 2);
    if (delta > Math.PI) delta -= Math.PI * 2;
    return delta;
}
/**
 * Converts degrees to radians.
 */ function $81e217a8cc1f1057$export$407448d2b89b1813(degrees) {
    return degrees / 180 * Math.PI;
}
/**
 * Converts radians to degrees.
 */ function $81e217a8cc1f1057$export$43caf9889c228507(radians) {
    return radians * 180 / Math.PI;
} // adapted from https://gist.github.com/stephanbogner/a5f50548a06bec723dcb0991dcbb0856 by https://twitter.com/st_phan
function $81e217a8cc1f1057$export$8b22cf2602fb60ce(buffer, _ref) {
    var _ref$radius = _ref.radius, radius = _ref$radius === void 0 ? 1 : _ref$radius;
    var samples = buffer.length / 3;
    var offset = 2 / samples;
    var increment = Math.PI * (3 - 2.2360679775);
    for(var i = 0; i < buffer.length; i += 3){
        var y = i * offset - 1 + offset / 2;
        var distance = Math.sqrt(1 - Math.pow(y, 2));
        var phi = i % samples * increment;
        var x = Math.cos(phi) * distance;
        var z = Math.sin(phi) * distance;
        buffer[i] = x * radius;
        buffer[i + 1] = y * radius;
        buffer[i + 2] = z * radius;
    }
} // @ts-ignore
function $81e217a8cc1f1057$export$90a7f3efeed30595(a, b) {
    var eps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.EPSILON;
    return Math.abs(a.x - b.x) < eps && Math.abs(a.y - b.y) < eps && Math.abs(a.z - b.z) < eps;
}
/**
 * Sorts vectors in lexicographic order, works with both v2 and v3
 *
 *  Use as:
 *  const sorted = arrayOfVectors.sort(lexicographicOrder)
 */ // https://en.wikipedia.org/wiki/Lexicographic_order
function $81e217a8cc1f1057$export$f1e1789686576879(a, b) {
    if (a.x === b.x) {
        // do a check to see if points is 3D,
        // in which case add y eq check and sort by z
        if (typeof a.z !== "undefined") {
            if (a.y === b.y) return a.z - b.z;
        }
        return a.y - b.y;
    }
    return a.x - b.x;
}
/**
 * Convex Hull
 *
 * Returns an array of 2D Vectors representing the convex hull of a set of 2D Vectors
 */ /**
 * Calculate the convex hull of a set of points
 */ function $81e217a8cc1f1057$export$39b482c5e57630a8(_points) {
    var points = _points.sort($81e217a8cc1f1057$export$f1e1789686576879); // put p1 and p2 in a list lUpper with p1 as the first point
    var lUpper = [
        points[0],
        points[1]
    ]; // for i <- 3 to n
    for(var i = 2; i < points.length; i++){
        lUpper.push(points[i]); // while lUpper contains more than 2 points and the last three points in lUpper do not make a right turn
        while(lUpper.length > 2 && (0, $701fd23866307bd4$export$4368d992c4eafac0)((0, $701fd23866307bd4$export$407448d2b89b1813)(lUpper.slice(-3))))// delete the middle of the last three points from lUpper
        lUpper.splice(lUpper.length - 2, 1);
    } // put pn and pn-1 in a list lLower with pn as the first point
    var lLower = [
        points[points.length - 1],
        points[points.length - 2]
    ]; // for (i <- n - 2 downto 1)
    for(var _i = points.length - 3; _i >= 0; _i--){
        // append pi to lLower
        lLower.push(points[_i]); // while lLower contains more than 2 points and the last three points in lLower do not make a right turn
        while(lLower.length > 2 && (0, $701fd23866307bd4$export$4368d992c4eafac0)((0, $701fd23866307bd4$export$407448d2b89b1813)(lLower.slice(-3))))// delete the middle of the last three points from lLower
        lLower.splice(lLower.length - 2, 1);
    } // remove the first and last point from lLower to avoid duplication of the points where the upper and lower hull meet
    lLower.splice(0, 1);
    lLower.splice(lLower.length - 1, 1); // prettier-ignore
    var c = [].concat(lUpper, lLower);
    return c;
}
function $81e217a8cc1f1057$export$dda1d9f60106f0e9(x, _ref2, _ref3) {
    var _ref4 = (0, $701fd23866307bd4$export$71511d61b312f219)(_ref2, 2), low1 = _ref4[0], high1 = _ref4[1];
    var _ref5 = (0, $701fd23866307bd4$export$71511d61b312f219)(_ref3, 2), low2 = _ref5[0], high2 = _ref5[1];
    return low2 + (x - low1) * (high2 - low2) / (high1 - low1);
}
/**
 *
 * https://www.desmos.com/calculator/vsnmlaljdu
 *
 * Ease-in-out, goes to -Infinite before 0 and Infinite after 1
 *
 * @param t
 * @returns
 */ function $81e217a8cc1f1057$export$2d1720544b23b823(t) {
    return t * t * t * (t * (t * 6 - 15) + 10);
}
/**
 *
 * Returns the result of linearly interpolating between input A and input B by input T.
 *
 * @param v0
 * @param v1
 * @param t
 * @returns
 */ function $81e217a8cc1f1057$export$882b5998b3b9117c(v0, v1, t) {
    return v0 * (1 - t) + v1 * t;
}
/**
 *
 * Returns the linear parameter that produces the interpolant specified by input T within the range of input A to input B.
 *
 * @param v0
 * @param v1
 * @param t
 * @returns
 */ function $81e217a8cc1f1057$export$23f2a1d2818174ef(v0, v1, t) {
    return (t - v0) / (v1 - v0);
}
/**
 *
 */ function $81e217a8cc1f1057$export$7ccc53e8f1e7dfc5(x, y, z) {
    var m = Math.sqrt(x * x + y * y + z * z);
    return [
        x / m,
        y / m,
        z / m
    ];
}
/**
 *
 */ function $81e217a8cc1f1057$export$ffb5f4729a158638(x, y, z) {
    var x2 = x * x;
    var y2 = y * y;
    var z2 = z * z;
    var nx = x * Math.sqrt(1 - (y2 + z2) / 2 + y2 * z2 / 3);
    var ny = y * Math.sqrt(1 - (z2 + x2) / 2 + z2 * x2 / 3);
    var nz = z * Math.sqrt(1 - (x2 + y2) / 2 + x2 * y2 / 3);
    return [
        nx,
        ny,
        nz
    ];
} // https://math.stackexchange.com/questions/180418/calculate-rotation-matrix-to-align-vector-a-to-vector-b-in-3d
/**
 * Give two unit vectors a and b, returns the transformation matrix that rotates a onto b.
 *
 * */ function $81e217a8cc1f1057$export$35e795649ee09318(a, b) {
    var v = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)().crossVectors(a, b);
    var c = a.dot(b);
    var i = new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)().identity(); //  skew-symmetric cross-product matrix of 𝑣 https://en.wikipedia.org/wiki/Skew-symmetric_matrix
    // prettier-ignore
    var vx = new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)().set(0, -v.z, v.y, v.z, 0, -v.x, -v.y, v.x, 0);
    var vxsquared = new (0, $ce0cdebec9150cb3$export$8ff26dafa08918)().multiplyMatrices(vx, vx).multiplyScalar(1 / (1 + c));
    var _final = (0, $c502f246d0b5067c$export$407448d2b89b1813)((0, $c502f246d0b5067c$export$407448d2b89b1813)(i, vx), vxsquared);
    return _final;
} // calculate latitude and longitude (in radians) from point on unit sphere
function $81e217a8cc1f1057$export$342063e11d6c3cad(x, y, z) {
    var lat = Math.asin(y);
    var lon = Math.atan2(x, -z);
    return [
        lat,
        lon
    ];
} // calculate point on unit sphere given latitude and logitude in radians
function $81e217a8cc1f1057$export$ae1af26003f05816(lat, lon) {
    var y = Math.sin(lat);
    var r = Math.cos(lat);
    var x = Math.sin(lon) * r;
    var z = -Math.cos(lon) * r;
    return [
        x,
        y,
        z
    ];
}
/**
 * Given a plane and a segment, return the intersection point if it exists or null it doesn't.
 */ function $81e217a8cc1f1057$export$9e5f44173e64f162(plane, segment) {
    var _segment = (0, $701fd23866307bd4$export$71511d61b312f219)(segment, 2), a = _segment[0], b = _segment[1];
    var matrix = $81e217a8cc1f1057$export$35e795649ee09318(plane.normal, new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 1, 0));
    var t = $81e217a8cc1f1057$export$23f2a1d2818174ef(a.clone().applyMatrix3(matrix).y, b.clone().applyMatrix3(matrix).y, 0);
    return new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)().lerpVectors(a, b, t);
}
/**
 * Given a plane and a point, return the distance.
 */ function $81e217a8cc1f1057$export$2408f22a0fab9ae5(p, plane) {
    var d = plane.normal.dot(p); // TODO
    return d;
}
function $81e217a8cc1f1057$export$625550452a3fa3ec(coords, sides) {
    var _coords = (0, $701fd23866307bd4$export$71511d61b312f219)(coords, 3), ix = _coords[0], iy = _coords[1], iz = _coords[2];
    var _sides = (0, $701fd23866307bd4$export$71511d61b312f219)(sides, 2), rx = _sides[0], ry = _sides[1];
    return iz * rx * ry + iy * rx + ix;
}
function $81e217a8cc1f1057$export$3b14a55fb2447963(index, size) {
    var _size = (0, $701fd23866307bd4$export$71511d61b312f219)(size, 2), rx = _size[0], ry = _size[1];
    var a = rx * ry;
    var z = index / a;
    var b = index - a * z;
    var y = b / rx;
    var x = b % rx;
    return [
        x,
        y,
        z
    ];
}
function $81e217a8cc1f1057$export$efccba1c4a2ef57b(coords, size) {
    return coords[0] + size[0] * coords[1];
}
function $81e217a8cc1f1057$export$d141bba7fdc215a3(index, columns) {
    var x = index % columns;
    var y = Math.floor(index / columns);
    return [
        x,
        y
    ];
}
var $81e217a8cc1f1057$export$953cecd6e717a553 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    clamp: $81e217a8cc1f1057$export$db3b6bfb95261072,
    deltaAngle: $81e217a8cc1f1057$export$4368d992c4eafac0,
    degToRad: $81e217a8cc1f1057$export$407448d2b89b1813,
    radToDeg: $81e217a8cc1f1057$export$43caf9889c228507,
    fibonacciOnSphere: $81e217a8cc1f1057$export$8b22cf2602fb60ce,
    vectorEquals: $81e217a8cc1f1057$export$90a7f3efeed30595,
    lexicographic: $81e217a8cc1f1057$export$f1e1789686576879,
    convexHull: $81e217a8cc1f1057$export$39b482c5e57630a8,
    remap: $81e217a8cc1f1057$export$dda1d9f60106f0e9,
    fade: $81e217a8cc1f1057$export$2d1720544b23b823,
    lerp: $81e217a8cc1f1057$export$882b5998b3b9117c,
    inverseLerp: $81e217a8cc1f1057$export$23f2a1d2818174ef,
    normalize: $81e217a8cc1f1057$export$7ccc53e8f1e7dfc5,
    pointOnCubeToPointOnSphere: $81e217a8cc1f1057$export$ffb5f4729a158638,
    rotateVectorOnVector: $81e217a8cc1f1057$export$35e795649ee09318,
    pointToCoordinate: $81e217a8cc1f1057$export$342063e11d6c3cad,
    coordinateToPoint: $81e217a8cc1f1057$export$ae1af26003f05816,
    planeSegmentIntersection: $81e217a8cc1f1057$export$9e5f44173e64f162,
    pointToPlaneDistance: $81e217a8cc1f1057$export$2408f22a0fab9ae5,
    getIndexFrom3D: $81e217a8cc1f1057$export$625550452a3fa3ec,
    get3DFromIndex: $81e217a8cc1f1057$export$3b14a55fb2447963,
    getIndexFrom2D: $81e217a8cc1f1057$export$efccba1c4a2ef57b,
    get2DFromIndex: $81e217a8cc1f1057$export$d141bba7fdc215a3
});


/**
 *
 */ function $74bb85474ca25c07$export$df995fae86a55f06() {
    return [
        0,
        0
    ];
}
function $74bb85474ca25c07$export$ae1af26003f05816() {
    return [
        1,
        1
    ];
}
function $74bb85474ca25c07$export$407448d2b89b1813(a, b) {
    return [
        a[0] + b[0],
        a[1] + b[1]
    ];
}
function $74bb85474ca25c07$export$8b22cf2602fb60ce(a, n) {
    return [
        a[0] + n,
        a[1] + n
    ];
}
function $74bb85474ca25c07$export$2408f22a0fab9ae5(a, b) {
    return [
        a[0] - b[0],
        a[1] - b[1]
    ];
}
function $74bb85474ca25c07$export$db3b6bfb95261072(a, n) {
    return [
        a[0] - n,
        a[1] - n
    ];
}
function $74bb85474ca25c07$export$4368d992c4eafac0(a, n) {
    return [
        a[0] * n,
        a[1] * n
    ];
}
function $74bb85474ca25c07$export$f1e1789686576879(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
/**
 * Calculate the squared length of a vector.
 * Use this when comparing two vectors instead of length, as it's more efficient (no sqrt)
 */ function $74bb85474ca25c07$export$882b5998b3b9117c(a) {
    return a[0] * a[0] + a[1] * a[1];
}
/**
 * Calculate the length of a vector.
 * If you only need to compare lenghts, consider using the more efficient lengthSqr
 */ function $74bb85474ca25c07$export$2d1720544b23b823(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1]);
}
function $74bb85474ca25c07$export$39b482c5e57630a8(a, b) {
    return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]));
}
var $74bb85474ca25c07$export$90a7f3efeed30595 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    zero: $74bb85474ca25c07$export$df995fae86a55f06,
    one: $74bb85474ca25c07$export$ae1af26003f05816,
    add: $74bb85474ca25c07$export$407448d2b89b1813,
    addValue: $74bb85474ca25c07$export$8b22cf2602fb60ce,
    sub: $74bb85474ca25c07$export$2408f22a0fab9ae5,
    subValue: $74bb85474ca25c07$export$db3b6bfb95261072,
    scale: $74bb85474ca25c07$export$4368d992c4eafac0,
    dot: $74bb85474ca25c07$export$f1e1789686576879,
    lengthSqr: $74bb85474ca25c07$export$882b5998b3b9117c,
    length: $74bb85474ca25c07$export$2d1720544b23b823,
    distance: $74bb85474ca25c07$export$39b482c5e57630a8
});


/**
 *
 */ function $e034f0b93acfa456$export$df995fae86a55f06() {
    return [
        0,
        0,
        0
    ];
}
function $e034f0b93acfa456$export$ae1af26003f05816() {
    return [
        1,
        1,
        1
    ];
}
function $e034f0b93acfa456$export$407448d2b89b1813(a, b) {
    return [
        a[0] + b[0],
        a[1] + b[1],
        a[2] + b[2]
    ];
}
function $e034f0b93acfa456$export$8b22cf2602fb60ce(a, n) {
    return [
        a[0] + n,
        a[1] + n,
        a[2] + n
    ];
}
function $e034f0b93acfa456$export$2408f22a0fab9ae5(a, b) {
    return [
        a[0] - b[0],
        a[1] - b[1],
        a[2] - b[2]
    ];
}
function $e034f0b93acfa456$export$db3b6bfb95261072(a, n) {
    return [
        a[0] - n,
        a[1] - n,
        a[2] - n
    ];
}
function $e034f0b93acfa456$export$4368d992c4eafac0(a, n) {
    return [
        a[0] * n,
        a[1] * n,
        a[2] * n
    ];
}
function $e034f0b93acfa456$export$f1e1789686576879(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $e034f0b93acfa456$export$2d1720544b23b823(a, b) {
    var x = a[1] * b[2] - a[2] * b[1];
    var y = a[2] * b[0] - a[0] * b[2];
    var z = a[0] * b[1] - a[1] * b[0];
    return [
        x,
        y,
        z
    ];
}
/**
 * Calculate the squared length of a vector.
 * Use this when comparing two vectors instead of length, as it's more efficient (no sqrt)
 */ function $e034f0b93acfa456$export$882b5998b3b9117c(a) {
    return a[0] * a[0] + a[1] * a[1] + a[2] * a[2];
}
/**
 * Calculate the length of a vector.
 * If you only need to compare lenghts, consider using the more efficient lengthSqr
 */ function $e034f0b93acfa456$export$39b482c5e57630a8(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]);
}
function $e034f0b93acfa456$export$dda1d9f60106f0e9(a, b) {
    return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]) + (a[2] - b[2]) * (a[2] - b[2]));
}
var $e034f0b93acfa456$export$90a7f3efeed30595 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    zero: $e034f0b93acfa456$export$df995fae86a55f06,
    one: $e034f0b93acfa456$export$ae1af26003f05816,
    add: $e034f0b93acfa456$export$407448d2b89b1813,
    addValue: $e034f0b93acfa456$export$8b22cf2602fb60ce,
    sub: $e034f0b93acfa456$export$2408f22a0fab9ae5,
    subValue: $e034f0b93acfa456$export$db3b6bfb95261072,
    scale: $e034f0b93acfa456$export$4368d992c4eafac0,
    dot: $e034f0b93acfa456$export$f1e1789686576879,
    cross: $e034f0b93acfa456$export$2d1720544b23b823,
    lengthSqr: $e034f0b93acfa456$export$882b5998b3b9117c,
    length: $e034f0b93acfa456$export$39b482c5e57630a8,
    distance: $e034f0b93acfa456$export$dda1d9f60106f0e9
});


function $d31ab2cfd182cd3c$export$2408f22a0fab9ae5(buffer) {
    var stride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var swizzle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "xyz";
    var o = {
        x: 0,
        y: 0,
        z: 0
    };
    for(var _i = 0; _i < buffer.length; _i += stride){
        o.x = buffer[_i];
        o.y = buffer[_i + 1];
        o.z = buffer[_i + 2];
        var _swizzle$split = swizzle.split(""), _swizzle$split2 = (0, $701fd23866307bd4$export$71511d61b312f219)(_swizzle$split, 3), x = _swizzle$split2[0], y = _swizzle$split2[1], z = _swizzle$split2[2]; // TODO Fix this ugly type
        buffer[_i] = o[x];
        buffer[_i + 1] = o[y];
        if (stride === 3) buffer[_i + 2] = o[z];
    }
    return buffer;
}
/**
 * @param buffer A stride 2 points buffer
 * @param valueGenerator A function that returns the value of the z axis at index i
 * @returns
 */ function $d31ab2cfd182cd3c$export$407448d2b89b1813(buffer, size) {
    var valueGenerator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {
        return Math.random();
    };
    var newSize = size + 1;
    var newBuffer = new Float32Array(buffer.length / size * newSize);
    for(var _i2 = 0; _i2 < buffer.length; _i2 += size){
        var _j = _i2 / size * newSize;
        newBuffer[_j] = buffer[_i2];
        newBuffer[_j + 1] = buffer[_i2 + 1];
        if (size === 2) newBuffer[_j + 2] = valueGenerator(_j);
        if (size === 3) {
            newBuffer[_j + 2] = buffer[_i2 + 2];
            newBuffer[_j + 3] = valueGenerator(_j);
        }
    }
    return newBuffer;
}
/**
 * Lerps bufferA and bufferB into final
 *
 * @param bufferA
 * @param bufferB
 * @param final
 * @param t
 */ function $d31ab2cfd182cd3c$export$882b5998b3b9117c(bufferA, bufferB, _final, t) {
    for(var _i3 = 0; _i3 < bufferA.length; _i3++)_final[_i3] = (0, $81e217a8cc1f1057$export$882b5998b3b9117c)(bufferA[_i3], bufferB[_i3], t);
} // TODO add stride
// TODO Fix types & vectors
/**
 *
 * Translate all points in the passed buffer by the passed translactionVector.
 *
 * @param buffer
 * @param translationVector
 * @returns
 */ function $d31ab2cfd182cd3c$export$625550452a3fa3ec(buffer, translationVector) {
    var stride = translationVector.length;
    for(var _i4 = 0; _i4 < buffer.length; _i4 += stride){
        buffer[_i4] += translationVector[0];
        buffer[_i4 + 1] += translationVector[1];
        buffer[_i4 + 2] += translationVector[2];
    }
    return buffer;
} // TODO add stride
// TODO remove quaternion & vector3 dependencies
function $d31ab2cfd182cd3c$export$43caf9889c228507(buffer, rotation) {
    var defaultRotation = {
        center: [
            0,
            0,
            0
        ],
        q: new (0, $ce0cdebec9150cb3$export$23d6a54f0bbc85a3)().identity()
    };
    var v = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
    var _defaultRotation$rota = (0, $470c8158486f2eac$export$71511d61b312f219)((0, $470c8158486f2eac$export$71511d61b312f219)({}, defaultRotation), rotation), q = _defaultRotation$rota.q, center = _defaultRotation$rota.center;
    for(var _i5 = 0; _i5 < buffer.length; _i5 += 3){
        v.set(buffer[_i5] - center[0], buffer[_i5 + 1] - center[1], buffer[_i5 + 2] - center[2]);
        v.applyQuaternion(q);
        buffer[_i5] = v.x + center[0];
        buffer[_i5 + 1] = v.y + center[1];
        buffer[_i5 + 2] = v.z + center[1];
    }
    return buffer;
}
function $d31ab2cfd182cd3c$export$953cecd6e717a553(buffer, stride, callback) {
    for(var _i6 = 0, _j2 = 0; _i6 < buffer.length; _i6 += stride, _j2++)if (stride === 3) {
        var res = callback([
            buffer[_i6],
            buffer[_i6 + 1],
            buffer[_i6 + 2]
        ], _j2);
        buffer.set(res, _i6);
    } else buffer.set(callback([
        buffer[_i6],
        buffer[_i6 + 1]
    ], _j2), _i6);
    return buffer;
}
/**
 * Reduces passed buffer
 */ function $d31ab2cfd182cd3c$export$db3b6bfb95261072(b, stride, callback, acc) {
    for(var _i7 = 0, _j3 = 0; _i7 < b.length; _i7 += stride, _j3++)if (stride === 2) acc = callback(acc, [
        b[_i7],
        b[_i7 + 1]
    ], _j3);
    else acc = callback(acc, [
        b[_i7],
        b[_i7 + 1],
        b[_i7 + 2]
    ], _j3);
    return acc;
}
function $d31ab2cfd182cd3c$export$f1e1789686576879(b, stride, opts) {
    var defaultExpandOptions = {
        center: [
            0,
            0,
            0
        ]
    };
    var _defaultExpandOptions = (0, $470c8158486f2eac$export$71511d61b312f219)((0, $470c8158486f2eac$export$71511d61b312f219)({}, defaultExpandOptions), opts), center = _defaultExpandOptions.center, distance = _defaultExpandOptions.distance;
    for(var _i8 = 0; _i8 < b.length; _i8 += stride){
        /**
     * 1. translate to origin (subtract the scaling center)
     * 2. scale by the correct amount (multiply by a constant)
     * 2. translate from origin (add the scaling center)
     */ b[_i8] = (b[_i8] - center[0]) * (1 + distance) + center[0];
        b[_i8 + 1] = (b[_i8 + 1] - center[1]) * (1 + distance) + center[1];
        if (stride === 3) b[_i8 + 2] = (b[_i8 + 2] - center[1]) * (1 + distance) + center[2];
    }
    return b;
}
function $d31ab2cfd182cd3c$export$4368d992c4eafac0(myBuffer, stride) {
    return $d31ab2cfd182cd3c$export$db3b6bfb95261072(myBuffer, stride, function(acc, point) {
        if (stride === 3) // some type hacking is necessary to avoid type errors going from [n, n] => [n, n, n]
        // but it's not an actual problem, as this path would always get a v3
        acc = (0, $e034f0b93acfa456$export$407448d2b89b1813)(acc, point);
        else acc = (0, $74bb85474ca25c07$export$407448d2b89b1813)(acc, point);
        return acc;
    }, (0, $74bb85474ca25c07$export$df995fae86a55f06)());
}
function $d31ab2cfd182cd3c$export$2d1720544b23b823(myBuffer, stride, callback) {
    // 1. make an array of the correct size
    var indices = Int16Array.from({
        length: myBuffer.length / stride
    }, function(_, i) {
        return i;
    }); // 2. sort the indices array
    indices.sort(function(a, b) {
        var pa = myBuffer.slice(a * stride, a * stride + stride);
        var pb = myBuffer.slice(b * stride, b * stride + stride);
        return callback(pa, pb);
    }); // 3. make a copy of the original array to fetch indices from
    var prevBuffer = myBuffer.slice(0); // 4. mutate the passed array
    for(var _i9 = 0; _i9 < indices.length; _i9++){
        var _j4 = indices[_i9];
        myBuffer.set(prevBuffer.slice(_j4 * stride, _j4 * stride + stride), _i9 * 3);
    }
    return myBuffer;
}
var $d31ab2cfd182cd3c$export$8b22cf2602fb60ce = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    swizzle: $d31ab2cfd182cd3c$export$2408f22a0fab9ae5,
    addAxis: $d31ab2cfd182cd3c$export$407448d2b89b1813,
    lerp: $d31ab2cfd182cd3c$export$882b5998b3b9117c,
    translate: $d31ab2cfd182cd3c$export$625550452a3fa3ec,
    rotate: $d31ab2cfd182cd3c$export$43caf9889c228507,
    map: $d31ab2cfd182cd3c$export$953cecd6e717a553,
    reduce: $d31ab2cfd182cd3c$export$db3b6bfb95261072,
    expand: $d31ab2cfd182cd3c$export$f1e1789686576879,
    center: $d31ab2cfd182cd3c$export$4368d992c4eafac0,
    sort: $d31ab2cfd182cd3c$export$2d1720544b23b823
});



function $301f68c544b81353$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



/*
 * A speed-improved perlin and simplex noise algorithms for 2D.
 *
 * Based on example code by Stefan Gustavson (stegu@itn.liu.se).
 * Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
 * Better rank ordering method by Stefan Gustavson in 2012.
 * Converted to Javascript by Joseph Gentle.
 *
 * Version 2012-03-09
 *
 * This code was placed in the public domain by its original author,
 * Stefan Gustavson. You may use it as you see fit, but
 * attribution is appreciated.
 *
 */ var $55c0de1b43ad661c$var$Grad = function Grad(x, y, z) {
    var _this = this;
    (0, $301f68c544b81353$export$71511d61b312f219)(this, Grad);
    (0, $470c8158486f2eac$export$407448d2b89b1813)(this, "dot2", function(x, y) {
        return _this.x * x + _this.y * y;
    });
    (0, $470c8158486f2eac$export$407448d2b89b1813)(this, "dot3", function(x, y, z) {
        return _this.x * x + _this.y * y + _this.z * z;
    });
    this.x = x;
    this.y = y;
    this.z = z;
};
var $55c0de1b43ad661c$var$grad3 = [
    new $55c0de1b43ad661c$var$Grad(1, 1, 0),
    new $55c0de1b43ad661c$var$Grad(-1, 1, 0),
    new $55c0de1b43ad661c$var$Grad(1, -1, 0),
    new $55c0de1b43ad661c$var$Grad(-1, -1, 0),
    new $55c0de1b43ad661c$var$Grad(1, 0, 1),
    new $55c0de1b43ad661c$var$Grad(-1, 0, 1),
    new $55c0de1b43ad661c$var$Grad(1, 0, -1),
    new $55c0de1b43ad661c$var$Grad(-1, 0, -1),
    new $55c0de1b43ad661c$var$Grad(0, 1, 1),
    new $55c0de1b43ad661c$var$Grad(0, -1, 1),
    new $55c0de1b43ad661c$var$Grad(0, 1, -1),
    new $55c0de1b43ad661c$var$Grad(0, -1, -1)
];
var $55c0de1b43ad661c$var$p = [
    151,
    160,
    137,
    91,
    90,
    15,
    131,
    13,
    201,
    95,
    96,
    53,
    194,
    233,
    7,
    225,
    140,
    36,
    103,
    30,
    69,
    142,
    8,
    99,
    37,
    240,
    21,
    10,
    23,
    190,
    6,
    148,
    247,
    120,
    234,
    75,
    0,
    26,
    197,
    62,
    94,
    252,
    219,
    203,
    117,
    35,
    11,
    32,
    57,
    177,
    33,
    88,
    237,
    149,
    56,
    87,
    174,
    20,
    125,
    136,
    171,
    168,
    68,
    175,
    74,
    165,
    71,
    134,
    139,
    48,
    27,
    166,
    77,
    146,
    158,
    231,
    83,
    111,
    229,
    122,
    60,
    211,
    133,
    230,
    220,
    105,
    92,
    41,
    55,
    46,
    245,
    40,
    244,
    102,
    143,
    54,
    65,
    25,
    63,
    161,
    1,
    216,
    80,
    73,
    209,
    76,
    132,
    187,
    208,
    89,
    18,
    169,
    200,
    196,
    135,
    130,
    116,
    188,
    159,
    86,
    164,
    100,
    109,
    198,
    173,
    186,
    3,
    64,
    52,
    217,
    226,
    250,
    124,
    123,
    5,
    202,
    38,
    147,
    118,
    126,
    255,
    82,
    85,
    212,
    207,
    206,
    59,
    227,
    47,
    16,
    58,
    17,
    182,
    189,
    28,
    42,
    223,
    183,
    170,
    213,
    119,
    248,
    152,
    2,
    44,
    154,
    163,
    70,
    221,
    153,
    101,
    155,
    167,
    43,
    172,
    9,
    129,
    22,
    39,
    253,
    19,
    98,
    108,
    110,
    79,
    113,
    224,
    232,
    178,
    185,
    112,
    104,
    218,
    246,
    97,
    228,
    251,
    34,
    242,
    193,
    238,
    210,
    144,
    12,
    191,
    179,
    162,
    241,
    81,
    51,
    145,
    235,
    249,
    14,
    239,
    107,
    49,
    192,
    214,
    31,
    181,
    199,
    106,
    157,
    184,
    84,
    204,
    176,
    115,
    121,
    50,
    45,
    127,
    4,
    150,
    254,
    138,
    236,
    205,
    93,
    222,
    114,
    67,
    29,
    24,
    72,
    243,
    141,
    128,
    195,
    78,
    66,
    215,
    61,
    156,
    180
]; // To remove the need for index wrapping, double the permutation table length
var $55c0de1b43ad661c$var$perm = new Array(512);
var $55c0de1b43ad661c$var$gradP = new Array(512); // This isn't a very good seeding function, but it works ok. It supports 2^16
// different seed values. Write something better if you need more seeds.
var $55c0de1b43ad661c$var$seed = function seed(_seed) {
    if (_seed > 0 && _seed < 1) // Scale the seed out
    _seed *= 65536;
    _seed = Math.floor(_seed);
    if (_seed < 256) _seed |= _seed << 8;
    for(var i = 0; i < 256; i++){
        var v;
        if (i & 1) v = $55c0de1b43ad661c$var$p[i] ^ _seed & 255;
        else v = $55c0de1b43ad661c$var$p[i] ^ _seed >> 8 & 255;
        $55c0de1b43ad661c$var$perm[i] = $55c0de1b43ad661c$var$perm[i + 256] = v;
        $55c0de1b43ad661c$var$gradP[i] = $55c0de1b43ad661c$var$gradP[i + 256] = $55c0de1b43ad661c$var$grad3[v % 12];
    }
};
$55c0de1b43ad661c$var$seed(0);
/*
  for(var i=0; i<256; i++) {
    perm[i] = perm[i + 256] = p[i];
    gradP[i] = gradP[i + 256] = grad3[perm[i] % 12];
  }*/ // Skewing and unskewing factors for 2, 3, and 4 dimensions
var $55c0de1b43ad661c$var$F2 = 0.5 * (Math.sqrt(3) - 1);
var $55c0de1b43ad661c$var$G2 = (3 - Math.sqrt(3)) / 6;
var $55c0de1b43ad661c$var$F3 = 1 / 3;
var $55c0de1b43ad661c$var$G3 = 1 / 6; // 2D simplex noise
var $55c0de1b43ad661c$var$simplex2 = function simplex2(xin, yin) {
    var n0, n1, n2; // Noise contributions from the three corners
    // Skew the input space to determine which simplex cell we're in
    var s = (xin + yin) * $55c0de1b43ad661c$var$F2; // Hairy factor for 2D
    var i = Math.floor(xin + s);
    var j = Math.floor(yin + s);
    var t = (i + j) * $55c0de1b43ad661c$var$G2;
    var x0 = xin - i + t; // The x,y distances from the cell origin, unskewed.
    var y0 = yin - j + t; // For the 2D case, the simplex shape is an equilateral triangle.
    // Determine which simplex we are in.
    var i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
    if (x0 > y0) {
        // lower triangle, XY order: (0,0)->(1,0)->(1,1)
        i1 = 1;
        j1 = 0;
    } else {
        // upper triangle, YX order: (0,0)->(0,1)->(1,1)
        i1 = 0;
        j1 = 1;
    } // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
    // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
    // c = (3-sqrt(3))/6
    var x1 = x0 - i1 + $55c0de1b43ad661c$var$G2; // Offsets for middle corner in (x,y) unskewed coords
    var y1 = y0 - j1 + $55c0de1b43ad661c$var$G2;
    var x2 = x0 - 1 + 2 * $55c0de1b43ad661c$var$G2; // Offsets for last corner in (x,y) unskewed coords
    var y2 = y0 - 1 + 2 * $55c0de1b43ad661c$var$G2; // Work out the hashed gradient indices of the three simplex corners
    i &= 255;
    j &= 255;
    var gi0 = $55c0de1b43ad661c$var$gradP[i + $55c0de1b43ad661c$var$perm[j]];
    var gi1 = $55c0de1b43ad661c$var$gradP[i + i1 + $55c0de1b43ad661c$var$perm[j + j1]];
    var gi2 = $55c0de1b43ad661c$var$gradP[i + 1 + $55c0de1b43ad661c$var$perm[j + 1]]; // Calculate the contribution from the three corners
    var t0 = 0.5 - x0 * x0 - y0 * y0;
    if (t0 < 0) n0 = 0;
    else {
        t0 *= t0;
        n0 = t0 * t0 * gi0.dot2(x0, y0); // (x,y) of grad3 used for 2D gradient
    }
    var t1 = 0.5 - x1 * x1 - y1 * y1;
    if (t1 < 0) n1 = 0;
    else {
        t1 *= t1;
        n1 = t1 * t1 * gi1.dot2(x1, y1);
    }
    var t2 = 0.5 - x2 * x2 - y2 * y2;
    if (t2 < 0) n2 = 0;
    else {
        t2 *= t2;
        n2 = t2 * t2 * gi2.dot2(x2, y2);
    } // Add contributions from each corner to get the final noise value.
    // The result is scaled to return values in the interval [-1,1].
    return 70 * (n0 + n1 + n2);
}; // 3D simplex noise
var $55c0de1b43ad661c$var$simplex3 = function simplex3(xin, yin, zin) {
    var n0, n1, n2, n3; // Noise contributions from the four corners
    // Skew the input space to determine which simplex cell we're in
    var s = (xin + yin + zin) * $55c0de1b43ad661c$var$F3; // Hairy factor for 2D
    var i = Math.floor(xin + s);
    var j = Math.floor(yin + s);
    var k = Math.floor(zin + s);
    var t = (i + j + k) * $55c0de1b43ad661c$var$G3;
    var x0 = xin - i + t; // The x,y distances from the cell origin, unskewed.
    var y0 = yin - j + t;
    var z0 = zin - k + t; // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
    // Determine which simplex we are in.
    var i1, j1, k1; // Offsets for second corner of simplex in (i,j,k) coords
    var i2, j2, k2; // Offsets for third corner of simplex in (i,j,k) coords
    if (x0 >= y0) {
        if (y0 >= z0) {
            i1 = 1;
            j1 = 0;
            k1 = 0;
            i2 = 1;
            j2 = 1;
            k2 = 0;
        } else if (x0 >= z0) {
            i1 = 1;
            j1 = 0;
            k1 = 0;
            i2 = 1;
            j2 = 0;
            k2 = 1;
        } else {
            i1 = 0;
            j1 = 0;
            k1 = 1;
            i2 = 1;
            j2 = 0;
            k2 = 1;
        }
    } else {
        if (y0 < z0) {
            i1 = 0;
            j1 = 0;
            k1 = 1;
            i2 = 0;
            j2 = 1;
            k2 = 1;
        } else if (x0 < z0) {
            i1 = 0;
            j1 = 1;
            k1 = 0;
            i2 = 0;
            j2 = 1;
            k2 = 1;
        } else {
            i1 = 0;
            j1 = 1;
            k1 = 0;
            i2 = 1;
            j2 = 1;
            k2 = 0;
        }
    } // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
    // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
    // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
    // c = 1/6.
    var x1 = x0 - i1 + $55c0de1b43ad661c$var$G3; // Offsets for second corner
    var y1 = y0 - j1 + $55c0de1b43ad661c$var$G3;
    var z1 = z0 - k1 + $55c0de1b43ad661c$var$G3;
    var x2 = x0 - i2 + 2 * $55c0de1b43ad661c$var$G3; // Offsets for third corner
    var y2 = y0 - j2 + 2 * $55c0de1b43ad661c$var$G3;
    var z2 = z0 - k2 + 2 * $55c0de1b43ad661c$var$G3;
    var x3 = x0 - 1 + 3 * $55c0de1b43ad661c$var$G3; // Offsets for fourth corner
    var y3 = y0 - 1 + 3 * $55c0de1b43ad661c$var$G3;
    var z3 = z0 - 1 + 3 * $55c0de1b43ad661c$var$G3; // Work out the hashed gradient indices of the four simplex corners
    i &= 255;
    j &= 255;
    k &= 255;
    var gi0 = $55c0de1b43ad661c$var$gradP[i + $55c0de1b43ad661c$var$perm[j + $55c0de1b43ad661c$var$perm[k]]];
    var gi1 = $55c0de1b43ad661c$var$gradP[i + i1 + $55c0de1b43ad661c$var$perm[j + j1 + $55c0de1b43ad661c$var$perm[k + k1]]];
    var gi2 = $55c0de1b43ad661c$var$gradP[i + i2 + $55c0de1b43ad661c$var$perm[j + j2 + $55c0de1b43ad661c$var$perm[k + k2]]];
    var gi3 = $55c0de1b43ad661c$var$gradP[i + 1 + $55c0de1b43ad661c$var$perm[j + 1 + $55c0de1b43ad661c$var$perm[k + 1]]]; // Calculate the contribution from the four corners
    var t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0;
    if (t0 < 0) n0 = 0;
    else {
        t0 *= t0;
        n0 = t0 * t0 * gi0.dot3(x0, y0, z0); // (x,y) of grad3 used for 2D gradient
    }
    var t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1;
    if (t1 < 0) n1 = 0;
    else {
        t1 *= t1;
        n1 = t1 * t1 * gi1.dot3(x1, y1, z1);
    }
    var t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2;
    if (t2 < 0) n2 = 0;
    else {
        t2 *= t2;
        n2 = t2 * t2 * gi2.dot3(x2, y2, z2);
    }
    var t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3;
    if (t3 < 0) n3 = 0;
    else {
        t3 *= t3;
        n3 = t3 * t3 * gi3.dot3(x3, y3, z3);
    } // Add contributions from each corner to get the final noise value.
    // The result is scaled to return values in the interval [-1,1].
    return 32 * (n0 + n1 + n2 + n3);
}; // ##### Perlin noise stuff
// 2D Perlin Noise
var $55c0de1b43ad661c$var$perlin2 = function perlin2(x, y) {
    // Find unit grid cell containing point
    var X = Math.floor(x), Y = Math.floor(y); // Get relative xy coordinates of point within that cell
    x = x - X;
    y = y - Y; // Wrap the integer cells at 255 (smaller integer period can be introduced here)
    X = X & 255;
    Y = Y & 255; // Calculate noise contributions from each of the four corners
    var n00 = $55c0de1b43ad661c$var$gradP[X + $55c0de1b43ad661c$var$perm[Y]].dot2(x, y);
    var n01 = $55c0de1b43ad661c$var$gradP[X + $55c0de1b43ad661c$var$perm[Y + 1]].dot2(x, y - 1);
    var n10 = $55c0de1b43ad661c$var$gradP[X + 1 + $55c0de1b43ad661c$var$perm[Y]].dot2(x - 1, y);
    var n11 = $55c0de1b43ad661c$var$gradP[X + 1 + $55c0de1b43ad661c$var$perm[Y + 1]].dot2(x - 1, y - 1); // Compute the fade curve value for x
    var u = (0, $81e217a8cc1f1057$export$2d1720544b23b823)(x); // Interpolate the four results
    return (0, $81e217a8cc1f1057$export$882b5998b3b9117c)((0, $81e217a8cc1f1057$export$882b5998b3b9117c)(n00, n10, u), (0, $81e217a8cc1f1057$export$882b5998b3b9117c)(n01, n11, u), (0, $81e217a8cc1f1057$export$2d1720544b23b823)(y));
}; // 3D Perlin Noise
var $55c0de1b43ad661c$var$perlin3 = function perlin3(x, y, z) {
    // Find unit grid cell containing point
    var X = Math.floor(x), Y = Math.floor(y), Z = Math.floor(z); // Get relative xyz coordinates of point within that cell
    x = x - X;
    y = y - Y;
    z = z - Z; // Wrap the integer cells at 255 (smaller integer period can be introduced here)
    X = X & 255;
    Y = Y & 255;
    Z = Z & 255; // Calculate noise contributions from each of the eight corners
    var n000 = $55c0de1b43ad661c$var$gradP[X + $55c0de1b43ad661c$var$perm[Y + $55c0de1b43ad661c$var$perm[Z]]].dot3(x, y, z);
    var n001 = $55c0de1b43ad661c$var$gradP[X + $55c0de1b43ad661c$var$perm[Y + $55c0de1b43ad661c$var$perm[Z + 1]]].dot3(x, y, z - 1);
    var n010 = $55c0de1b43ad661c$var$gradP[X + $55c0de1b43ad661c$var$perm[Y + 1 + $55c0de1b43ad661c$var$perm[Z]]].dot3(x, y - 1, z);
    var n011 = $55c0de1b43ad661c$var$gradP[X + $55c0de1b43ad661c$var$perm[Y + 1 + $55c0de1b43ad661c$var$perm[Z + 1]]].dot3(x, y - 1, z - 1);
    var n100 = $55c0de1b43ad661c$var$gradP[X + 1 + $55c0de1b43ad661c$var$perm[Y + $55c0de1b43ad661c$var$perm[Z]]].dot3(x - 1, y, z);
    var n101 = $55c0de1b43ad661c$var$gradP[X + 1 + $55c0de1b43ad661c$var$perm[Y + $55c0de1b43ad661c$var$perm[Z + 1]]].dot3(x - 1, y, z - 1);
    var n110 = $55c0de1b43ad661c$var$gradP[X + 1 + $55c0de1b43ad661c$var$perm[Y + 1 + $55c0de1b43ad661c$var$perm[Z]]].dot3(x - 1, y - 1, z);
    var n111 = $55c0de1b43ad661c$var$gradP[X + 1 + $55c0de1b43ad661c$var$perm[Y + 1 + $55c0de1b43ad661c$var$perm[Z + 1]]].dot3(x - 1, y - 1, z - 1); // Compute the fade curve value for x, y, z
    var u = (0, $81e217a8cc1f1057$export$2d1720544b23b823)(x);
    var v = (0, $81e217a8cc1f1057$export$2d1720544b23b823)(y);
    var w = (0, $81e217a8cc1f1057$export$2d1720544b23b823)(z); // Interpolate
    return (0, $81e217a8cc1f1057$export$882b5998b3b9117c)((0, $81e217a8cc1f1057$export$882b5998b3b9117c)((0, $81e217a8cc1f1057$export$882b5998b3b9117c)(n000, n100, u), (0, $81e217a8cc1f1057$export$882b5998b3b9117c)(n001, n101, u), w), (0, $81e217a8cc1f1057$export$882b5998b3b9117c)((0, $81e217a8cc1f1057$export$882b5998b3b9117c)(n010, n110, u), (0, $81e217a8cc1f1057$export$882b5998b3b9117c)(n011, n111, u), w), v);
};
var $55c0de1b43ad661c$export$7ccc53e8f1e7dfc5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    seed: $55c0de1b43ad661c$var$seed,
    simplex2: $55c0de1b43ad661c$var$simplex2,
    simplex3: $55c0de1b43ad661c$var$simplex3,
    perlin2: $55c0de1b43ad661c$var$perlin2,
    perlin3: $55c0de1b43ad661c$var$perlin3
});
var $55c0de1b43ad661c$var$TAU = Math.PI * 2; // Credits @kchapelier https://github.com/kchapelier/wavefunctioncollapse/blob/master/example/lcg.js#L22-L30
function $55c0de1b43ad661c$var$normalizeSeed(seed) {
    if (typeof seed === "number") seed = Math.abs(seed);
    else if (typeof seed === "string") {
        var string = seed;
        seed = 0;
        for(var i = 0; i < string.length; i++)seed = (seed + (i + 1) * (string.charCodeAt(i) % 96)) % 2147483647;
    }
    if (seed === 0) seed = 311;
    return seed;
}
function $55c0de1b43ad661c$var$lcgRandom(seed) {
    var state = $55c0de1b43ad661c$var$normalizeSeed(seed);
    return function() {
        var result = state * 48271 % 2147483647;
        state = result;
        return result / 2147483647;
    };
}
var $55c0de1b43ad661c$export$2329c99376c9d0a4 = function Generator(_seed) {
    var _this = this;
    (0, $301f68c544b81353$export$71511d61b312f219)(this, Generator);
    (0, $470c8158486f2eac$export$407448d2b89b1813)(this, "seed", 0);
    (0, $470c8158486f2eac$export$407448d2b89b1813)(this, "init", function(seed) {
        _this.seed = seed;
        _this.value = $55c0de1b43ad661c$var$lcgRandom(seed);
    });
    (0, $470c8158486f2eac$export$407448d2b89b1813)(this, "value", $55c0de1b43ad661c$var$lcgRandom(this.seed));
    this.init(_seed);
};
var $55c0de1b43ad661c$var$defaultGen = new $55c0de1b43ad661c$export$2329c99376c9d0a4(Math.random());
/***
 * [3D] Sphere
 */ var $55c0de1b43ad661c$var$defaultSphere = {
    radius: 1,
    center: [
        0,
        0,
        0
    ]
}; // random on surface of sphere
// - https://twitter.com/fermatslibrary/status/1430932503578226688
// - https://mathworld.wolfram.com/SpherePointPicking.html
function $55c0de1b43ad661c$export$ae1af26003f05816(buffer, sphere) {
    var rng = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $55c0de1b43ad661c$var$defaultGen;
    var _defaultSphere$sphere = (0, $470c8158486f2eac$export$71511d61b312f219)((0, $470c8158486f2eac$export$71511d61b312f219)({}, $55c0de1b43ad661c$var$defaultSphere), sphere), radius = _defaultSphere$sphere.radius, center = _defaultSphere$sphere.center;
    for(var i = 0; i < buffer.length; i += 3){
        var u = rng.value();
        var v = rng.value();
        var theta = Math.acos(2 * v - 1);
        var phi = $55c0de1b43ad661c$var$TAU * u;
        buffer[i] = Math.sin(theta) * Math.cos(phi) * radius + center[0];
        buffer[i + 1] = Math.sin(theta) * Math.sin(phi) * radius + center[1];
        buffer[i + 2] = Math.cos(theta) * radius + center[2];
    }
    return buffer;
} // from "Another Method" https://datagenetics.com/blog/january32020/index.html
function $55c0de1b43ad661c$export$407448d2b89b1813(buffer, sphere) {
    var rng = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $55c0de1b43ad661c$var$defaultGen;
    var _defaultSphere$sphere2 = (0, $470c8158486f2eac$export$71511d61b312f219)((0, $470c8158486f2eac$export$71511d61b312f219)({}, $55c0de1b43ad661c$var$defaultSphere), sphere), radius = _defaultSphere$sphere2.radius, center = _defaultSphere$sphere2.center;
    for(var i = 0; i < buffer.length; i += 3){
        var u = Math.pow(rng.value(), 1 / 3);
        var x = rng.value() * 2 - 1;
        var y = rng.value() * 2 - 1;
        var z = rng.value() * 2 - 1;
        var mag = Math.sqrt(x * x + y * y + z * z);
        x = u * x / mag;
        y = u * y / mag;
        z = u * z / mag;
        buffer[i] = x * radius + center[0];
        buffer[i + 1] = y * radius + center[1];
        buffer[i + 2] = z * radius + center[2];
    }
    return buffer;
}
/***
 * [2D] Circle
 */ var $55c0de1b43ad661c$var$defaultCircle = {
    radius: 1,
    center: [
        0,
        0
    ]
}; // random circle https://stackoverflow.com/a/50746409
function $55c0de1b43ad661c$export$8b22cf2602fb60ce(buffer, circle) {
    var rng = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $55c0de1b43ad661c$var$defaultGen;
    var _defaultCircle$circle = (0, $470c8158486f2eac$export$71511d61b312f219)((0, $470c8158486f2eac$export$71511d61b312f219)({}, $55c0de1b43ad661c$var$defaultCircle), circle), radius = _defaultCircle$circle.radius, center = _defaultCircle$circle.center;
    for(var i = 0; i < buffer.length; i += 2){
        var r = radius * Math.sqrt(rng.value());
        var theta = rng.value() * $55c0de1b43ad661c$var$TAU;
        buffer[i] = Math.sin(theta) * r + center[0];
        buffer[i + 1] = Math.cos(theta) * r + center[1];
    }
    return buffer;
}
function $55c0de1b43ad661c$export$db3b6bfb95261072(buffer, circle) {
    var rng = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $55c0de1b43ad661c$var$defaultGen;
    var _defaultCircle$circle2 = (0, $470c8158486f2eac$export$71511d61b312f219)((0, $470c8158486f2eac$export$71511d61b312f219)({}, $55c0de1b43ad661c$var$defaultCircle), circle), radius = _defaultCircle$circle2.radius, center = _defaultCircle$circle2.center;
    for(var i = 0; i < buffer.length; i += 2){
        var theta = rng.value() * $55c0de1b43ad661c$var$TAU;
        buffer[i] = Math.sin(theta) * radius + center[0];
        buffer[i + 1] = Math.cos(theta) * radius + center[1];
    }
    return buffer;
}
/**
 * [2D] Plane
 */ var $55c0de1b43ad661c$var$defaultRect = {
    sides: 1,
    center: [
        0,
        0
    ]
};
function $55c0de1b43ad661c$export$4368d992c4eafac0(buffer, rect) {
    var rng = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $55c0de1b43ad661c$var$defaultGen;
    var _defaultRect$rect = (0, $470c8158486f2eac$export$71511d61b312f219)((0, $470c8158486f2eac$export$71511d61b312f219)({}, $55c0de1b43ad661c$var$defaultRect), rect), sides = _defaultRect$rect.sides, center = _defaultRect$rect.center;
    var sideX = typeof sides === "number" ? sides : sides[0];
    var sideY = typeof sides === "number" ? sides : sides[1];
    for(var i = 0; i < buffer.length; i += 2){
        buffer[i] = (rng.value() - 0.5) * sideX + center[0];
        buffer[i + 1] = (rng.value() - 0.5) * sideY + center[1];
    }
    return buffer;
}
function $55c0de1b43ad661c$export$f1e1789686576879(buffer, rect) {
    return buffer;
}
/***
 * [3D] Box
 */ function $55c0de1b43ad661c$export$2d1720544b23b823(buffer, box) {
    var rng = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $55c0de1b43ad661c$var$defaultGen;
    var _defaultBox$box = (0, $470c8158486f2eac$export$71511d61b312f219)((0, $470c8158486f2eac$export$71511d61b312f219)({}, $55c0de1b43ad661c$var$defaultBox), box), sides = _defaultBox$box.sides, center = _defaultBox$box.center;
    var sideX = typeof sides === "number" ? sides : sides[0];
    var sideY = typeof sides === "number" ? sides : sides[1];
    var sideZ = typeof sides === "number" ? sides : sides[2];
    for(var i = 0; i < buffer.length; i += 3){
        buffer[i] = (rng.value() - 0.5) * sideX + center[0];
        buffer[i + 1] = (rng.value() - 0.5) * sideY + center[1];
        buffer[i + 2] = (rng.value() - 0.5) * sideZ + center[2];
    }
    return buffer;
}
var $55c0de1b43ad661c$var$defaultBox = {
    sides: 1,
    center: [
        0,
        0,
        0
    ]
};
function $55c0de1b43ad661c$export$39b482c5e57630a8(buffer, box) {
    var rng = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $55c0de1b43ad661c$var$defaultGen;
    var _defaultBox$box2 = (0, $470c8158486f2eac$export$71511d61b312f219)((0, $470c8158486f2eac$export$71511d61b312f219)({}, $55c0de1b43ad661c$var$defaultBox), box), sides = _defaultBox$box2.sides, center = _defaultBox$box2.center;
    var sideX = typeof sides === "number" ? sides : sides[0];
    var sideY = typeof sides === "number" ? sides : sides[1];
    var sideZ = typeof sides === "number" ? sides : sides[2];
    for(var i = 0; i < buffer.length; i += 3){
        buffer[i] = (rng.value() - 0.5) * sideX + center[0];
        buffer[i + 1] = (rng.value() - 0.5) * sideY + center[1];
        buffer[i + 2] = (rng.value() - 0.5) * sideZ + center[2];
    }
    return buffer;
}
var $55c0de1b43ad661c$export$23f2a1d2818174ef = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Generator: $55c0de1b43ad661c$export$2329c99376c9d0a4,
    onSphere: $55c0de1b43ad661c$export$ae1af26003f05816,
    inSphere: $55c0de1b43ad661c$export$407448d2b89b1813,
    inCircle: $55c0de1b43ad661c$export$8b22cf2602fb60ce,
    onCircle: $55c0de1b43ad661c$export$db3b6bfb95261072,
    inRect: $55c0de1b43ad661c$export$4368d992c4eafac0,
    onRect: $55c0de1b43ad661c$export$f1e1789686576879,
    inBox: $55c0de1b43ad661c$export$2d1720544b23b823,
    onBox: $55c0de1b43ad661c$export$39b482c5e57630a8,
    noise: $55c0de1b43ad661c$export$7ccc53e8f1e7dfc5
});





/**
 * Rounded square wave easing
 */ var $95b754901e182d16$export$43caf9889c228507 = function rsqw(t) {
    var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.01;
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var f = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1 / (2 * Math.PI);
    return a / Math.atan(1 / delta) * Math.atan(Math.sin(2 * Math.PI * t * f) / delta);
};
/**
 * Exponential easing
 */ var $95b754901e182d16$export$407448d2b89b1813 = function exp(t) {
    return 1 / (1 + t + 0.48 * t * t + 0.235 * t * t * t);
};
/**
 * Damp, based on Game Programming Gems 4 Chapter 1.10
 *   Return value indicates whether the animation is still running.
 */ function $95b754901e182d16$export$4368d992c4eafac0(/** The object */ current, /** The key to animate */ prop, /** To goal value */ target) {
    var smoothTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.25;
    var delta = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.01;
    var maxSpeed = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Infinity;
    var easing = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : $95b754901e182d16$export$407448d2b89b1813;
    var eps = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0.001;
    var vel = "velocity_" + prop;
    if (current.__damp === undefined) current.__damp = {};
    if (current.__damp[vel] === undefined) current.__damp[vel] = 0;
    if (Math.abs(current[prop] - target) <= eps) {
        current[prop] = target;
        return false;
    }
    smoothTime = Math.max(0.0001, smoothTime);
    var omega = 2 / smoothTime;
    var t = easing(omega * delta);
    var change = current[prop] - target;
    var originalTo = target; // Clamp maximum maxSpeed
    var maxChange = maxSpeed * smoothTime;
    change = Math.min(Math.max(change, -maxChange), maxChange);
    target = current[prop] - change;
    var temp = (current.__damp[vel] + omega * change) * delta;
    current.__damp[vel] = (current.__damp[vel] - omega * temp) * t;
    var output = target + (change + temp) * t; // Prevent overshooting
    if (originalTo - current[prop] > 0.0 === output > originalTo) {
        output = originalTo;
        current.__damp[vel] = (output - originalTo) / delta;
    }
    current[prop] = output;
    return true;
}
/**
 * DampAngle, based on Game Programming Gems 4 Chapter 1.10
 */ function $95b754901e182d16$export$8b22cf2602fb60ce(current, prop, target, smoothTime, delta, maxSpeed, easing, eps) {
    return $95b754901e182d16$export$4368d992c4eafac0(current, prop, current[prop] + (0, $81e217a8cc1f1057$export$4368d992c4eafac0)(current[prop], target), smoothTime, delta, maxSpeed, easing, eps);
}
/**
 * Vector2D Damp
 */ var $95b754901e182d16$var$v2d = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
var $95b754901e182d16$var$a2, $95b754901e182d16$var$b2;
function $95b754901e182d16$export$db3b6bfb95261072(current, target, smoothTime, delta, maxSpeed, easing, eps) {
    if (typeof target === "number") $95b754901e182d16$var$v2d.setScalar(target);
    else if (Array.isArray(target)) $95b754901e182d16$var$v2d.set(target[0], target[1]);
    else $95b754901e182d16$var$v2d.copy(target);
    $95b754901e182d16$var$a2 = $95b754901e182d16$export$4368d992c4eafac0(current, "x", $95b754901e182d16$var$v2d.x, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$b2 = $95b754901e182d16$export$4368d992c4eafac0(current, "y", $95b754901e182d16$var$v2d.y, smoothTime, delta, maxSpeed, easing, eps);
    return $95b754901e182d16$var$a2 || $95b754901e182d16$var$b2;
}
/**
 * Vector3D Damp
 */ var $95b754901e182d16$var$v3d = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
var $95b754901e182d16$var$a3, $95b754901e182d16$var$b3, $95b754901e182d16$var$c3;
function $95b754901e182d16$export$2d1720544b23b823(current, target, smoothTime, delta, maxSpeed, easing, eps) {
    if (typeof target === "number") $95b754901e182d16$var$v3d.setScalar(target);
    else if (Array.isArray(target)) $95b754901e182d16$var$v3d.set(target[0], target[1], target[2]);
    else $95b754901e182d16$var$v3d.copy(target);
    $95b754901e182d16$var$a3 = $95b754901e182d16$export$4368d992c4eafac0(current, "x", $95b754901e182d16$var$v3d.x, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$b3 = $95b754901e182d16$export$4368d992c4eafac0(current, "y", $95b754901e182d16$var$v3d.y, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$c3 = $95b754901e182d16$export$4368d992c4eafac0(current, "z", $95b754901e182d16$var$v3d.z, smoothTime, delta, maxSpeed, easing, eps);
    return $95b754901e182d16$var$a3 || $95b754901e182d16$var$b3 || $95b754901e182d16$var$c3;
}
/**
 * Vector4D Damp
 */ var $95b754901e182d16$var$v4d = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
var $95b754901e182d16$var$a4, $95b754901e182d16$var$b4, $95b754901e182d16$var$c4, $95b754901e182d16$var$d4;
function $95b754901e182d16$export$39b482c5e57630a8(current, target, smoothTime, delta, maxSpeed, easing, eps) {
    if (typeof target === "number") $95b754901e182d16$var$v4d.setScalar(target);
    else if (Array.isArray(target)) $95b754901e182d16$var$v4d.set(target[0], target[1], target[2], target[3]);
    else $95b754901e182d16$var$v4d.copy(target);
    $95b754901e182d16$var$a4 = $95b754901e182d16$export$4368d992c4eafac0(current, "x", $95b754901e182d16$var$v4d.x, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$b4 = $95b754901e182d16$export$4368d992c4eafac0(current, "y", $95b754901e182d16$var$v4d.y, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$c4 = $95b754901e182d16$export$4368d992c4eafac0(current, "z", $95b754901e182d16$var$v4d.z, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$d4 = $95b754901e182d16$export$4368d992c4eafac0(current, "w", $95b754901e182d16$var$v4d.w, smoothTime, delta, maxSpeed, easing, eps);
    return $95b754901e182d16$var$a4 || $95b754901e182d16$var$b4 || $95b754901e182d16$var$c4 || $95b754901e182d16$var$d4;
}
/**
 * Euler Damp
 */ var $95b754901e182d16$var$rot = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$d93cc409a0768c5f)();
var $95b754901e182d16$var$aE, $95b754901e182d16$var$bE, $95b754901e182d16$var$cE;
function $95b754901e182d16$export$dda1d9f60106f0e9(current, target, smoothTime, delta, maxSpeed, easing, eps) {
    if (Array.isArray(target)) $95b754901e182d16$var$rot.set(target[0], target[1], target[2], target[3]);
    else $95b754901e182d16$var$rot.copy(target);
    $95b754901e182d16$var$aE = $95b754901e182d16$export$8b22cf2602fb60ce(current, "x", $95b754901e182d16$var$rot.x, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$bE = $95b754901e182d16$export$8b22cf2602fb60ce(current, "y", $95b754901e182d16$var$rot.y, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$cE = $95b754901e182d16$export$8b22cf2602fb60ce(current, "z", $95b754901e182d16$var$rot.z, smoothTime, delta, maxSpeed, easing, eps);
    return $95b754901e182d16$var$aE || $95b754901e182d16$var$bE || $95b754901e182d16$var$cE;
}
/**
 * Color Damp
 */ var $95b754901e182d16$var$col = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)();
var $95b754901e182d16$var$aC, $95b754901e182d16$var$bC, $95b754901e182d16$var$cC;
function $95b754901e182d16$export$23f2a1d2818174ef(current, target, smoothTime, delta, maxSpeed, easing, eps) {
    if (target instanceof (0, $ce0cdebec9150cb3$export$892596cec99bc70e)) $95b754901e182d16$var$col.copy(target);
    else if (Array.isArray(target)) $95b754901e182d16$var$col.setRGB(target[0], target[1], target[2]);
    else $95b754901e182d16$var$col.set(target);
    $95b754901e182d16$var$aC = $95b754901e182d16$export$4368d992c4eafac0(current, "r", $95b754901e182d16$var$col.r, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$bC = $95b754901e182d16$export$4368d992c4eafac0(current, "g", $95b754901e182d16$var$col.g, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$cC = $95b754901e182d16$export$4368d992c4eafac0(current, "b", $95b754901e182d16$var$col.b, smoothTime, delta, maxSpeed, easing, eps);
    return $95b754901e182d16$var$aC || $95b754901e182d16$var$bC || $95b754901e182d16$var$cC;
}
/**
 * Quaternion Damp
 * https://gist.github.com/maxattack/4c7b4de00f5c1b95a33b
 * Copyright 2016 Max Kaufmann (max.kaufmann@gmail.com)
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ var $95b754901e182d16$var$qt = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$23d6a54f0bbc85a3)();
var $95b754901e182d16$var$v4result = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
var $95b754901e182d16$var$v4velocity = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
var $95b754901e182d16$var$v4error = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$fa7daccca11cdbe3)();
var $95b754901e182d16$var$aQ, $95b754901e182d16$var$bQ, $95b754901e182d16$var$cQ, $95b754901e182d16$var$dQ;
function $95b754901e182d16$export$35e795649ee09318(current, target, smoothTime, delta, maxSpeed, easing, eps) {
    var cur = current;
    if (Array.isArray(target)) $95b754901e182d16$var$qt.set(target[0], target[1], target[2], target[3]);
    else $95b754901e182d16$var$qt.copy(target);
    var multi = current.dot($95b754901e182d16$var$qt) > 0 ? 1 : -1;
    $95b754901e182d16$var$qt.x *= multi;
    $95b754901e182d16$var$qt.y *= multi;
    $95b754901e182d16$var$qt.z *= multi;
    $95b754901e182d16$var$qt.w *= multi;
    $95b754901e182d16$var$aQ = $95b754901e182d16$export$4368d992c4eafac0(current, "x", $95b754901e182d16$var$qt.x, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$bQ = $95b754901e182d16$export$4368d992c4eafac0(current, "y", $95b754901e182d16$var$qt.y, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$cQ = $95b754901e182d16$export$4368d992c4eafac0(current, "z", $95b754901e182d16$var$qt.z, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$dQ = $95b754901e182d16$export$4368d992c4eafac0(current, "w", $95b754901e182d16$var$qt.w, smoothTime, delta, maxSpeed, easing, eps); // smooth damp (nlerp approx)
    $95b754901e182d16$var$v4result.set(current.x, current.y, current.z, current.w).normalize();
    $95b754901e182d16$var$v4velocity.set(cur.__damp.velocity_x, cur.__damp.velocity_y, cur.__damp.velocity_z, cur.__damp.velocity_w); // ensure deriv is tangent
    $95b754901e182d16$var$v4error.copy($95b754901e182d16$var$v4result).multiplyScalar($95b754901e182d16$var$v4velocity.dot($95b754901e182d16$var$v4result) / $95b754901e182d16$var$v4result.dot($95b754901e182d16$var$v4result));
    cur.__damp.velocity_x -= $95b754901e182d16$var$v4error.x;
    cur.__damp.velocity_y -= $95b754901e182d16$var$v4error.y;
    cur.__damp.velocity_z -= $95b754901e182d16$var$v4error.z;
    cur.__damp.velocity_w -= $95b754901e182d16$var$v4error.w;
    current.set($95b754901e182d16$var$v4result.x, $95b754901e182d16$var$v4result.y, $95b754901e182d16$var$v4result.z, $95b754901e182d16$var$v4result.w);
    return $95b754901e182d16$var$aQ || $95b754901e182d16$var$bQ || $95b754901e182d16$var$cQ || $95b754901e182d16$var$dQ;
}
/**
 * Spherical Damp
 */ var $95b754901e182d16$var$spherical = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$d712cd887b4a00f7)();
var $95b754901e182d16$var$aS, $95b754901e182d16$var$bS, $95b754901e182d16$var$cS;
function $95b754901e182d16$export$342063e11d6c3cad(current, target, smoothTime, delta, maxSpeed, easing, eps) {
    if (Array.isArray(target)) $95b754901e182d16$var$spherical.set(target[0], target[1], target[2]);
    else $95b754901e182d16$var$spherical.copy(target);
    $95b754901e182d16$var$aS = $95b754901e182d16$export$4368d992c4eafac0(current, "radius", $95b754901e182d16$var$spherical.radius, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$bS = $95b754901e182d16$export$8b22cf2602fb60ce(current, "phi", $95b754901e182d16$var$spherical.phi, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$cS = $95b754901e182d16$export$8b22cf2602fb60ce(current, "theta", $95b754901e182d16$var$spherical.theta, smoothTime, delta, maxSpeed, easing, eps);
    return $95b754901e182d16$var$aS || $95b754901e182d16$var$bS || $95b754901e182d16$var$cS;
}
/**
 * Matrix4 Damp
 */ var $95b754901e182d16$var$mat = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
var $95b754901e182d16$var$mPos = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
var $95b754901e182d16$var$mRot = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$23d6a54f0bbc85a3)();
var $95b754901e182d16$var$mSca = /*@__PURE__*/ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)();
var $95b754901e182d16$var$aM, $95b754901e182d16$var$bM, $95b754901e182d16$var$cM;
function $95b754901e182d16$export$882b5998b3b9117c(current, target, smoothTime, delta, maxSpeed, easing, eps) {
    var cur = current;
    if (cur.__damp === undefined) {
        cur.__damp = {
            position: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(),
            rotation: new (0, $ce0cdebec9150cb3$export$23d6a54f0bbc85a3)(),
            scale: new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)()
        };
        current.decompose(cur.__damp.position, cur.__damp.rotation, cur.__damp.scale);
    }
    if (Array.isArray(target)) $95b754901e182d16$var$mat.set.apply($95b754901e182d16$var$mat, (0, $701fd23866307bd4$export$407448d2b89b1813)(target));
    else $95b754901e182d16$var$mat.copy(target);
    $95b754901e182d16$var$mat.decompose($95b754901e182d16$var$mPos, $95b754901e182d16$var$mRot, $95b754901e182d16$var$mSca);
    $95b754901e182d16$var$aM = $95b754901e182d16$export$2d1720544b23b823(cur.__damp.position, $95b754901e182d16$var$mPos, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$bM = $95b754901e182d16$export$35e795649ee09318(cur.__damp.rotation, $95b754901e182d16$var$mRot, smoothTime, delta, maxSpeed, easing, eps);
    $95b754901e182d16$var$cM = $95b754901e182d16$export$2d1720544b23b823(cur.__damp.scale, $95b754901e182d16$var$mSca, smoothTime, delta, maxSpeed, easing, eps);
    current.compose(cur.__damp.position, cur.__damp.rotation, cur.__damp.scale);
    return $95b754901e182d16$var$aM || $95b754901e182d16$var$bM || $95b754901e182d16$var$cM;
}
var $95b754901e182d16$export$f1e1789686576879 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    rsqw: $95b754901e182d16$export$43caf9889c228507,
    exp: $95b754901e182d16$export$407448d2b89b1813,
    damp: $95b754901e182d16$export$4368d992c4eafac0,
    dampAngle: $95b754901e182d16$export$8b22cf2602fb60ce,
    damp2: $95b754901e182d16$export$db3b6bfb95261072,
    damp3: $95b754901e182d16$export$2d1720544b23b823,
    damp4: $95b754901e182d16$export$39b482c5e57630a8,
    dampE: $95b754901e182d16$export$dda1d9f60106f0e9,
    dampC: $95b754901e182d16$export$23f2a1d2818174ef,
    dampQ: $95b754901e182d16$export$35e795649ee09318,
    dampS: $95b754901e182d16$export$342063e11d6c3cad,
    dampM: $95b754901e182d16$export$882b5998b3b9117c
});





function $edd73bf47935fdf3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $ed71381219283563$export$71511d61b312f219)(subClass, superClass);
}
function $edd73bf47935fdf3$var$_getPrototypeOf(o) {
    $edd73bf47935fdf3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $edd73bf47935fdf3$var$_getPrototypeOf(o);
}
function $edd73bf47935fdf3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $edd73bf47935fdf3$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $edd73bf47935fdf3$var$_assertThisInitialized(self);
}
function $edd73bf47935fdf3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = (0, $ed71381219283563$export$407448d2b89b1813)();
    return function _createSuperInternal() {
        var Super = $edd73bf47935fdf3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $edd73bf47935fdf3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $edd73bf47935fdf3$var$_possibleConstructorReturn(this, result);
    };
}
var $edd73bf47935fdf3$export$db202ddc8be9136 = /*#__PURE__*/ function(_THREE$BufferGeometry) {
    $edd73bf47935fdf3$var$_inherits(RoundedPlaneGeometry, _THREE$BufferGeometry);
    var _super = $edd73bf47935fdf3$var$_createSuper(RoundedPlaneGeometry);
    function RoundedPlaneGeometry() {
        var _this;
        var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
        var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.2;
        var segments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 16;
        (0, $301f68c544b81353$export$71511d61b312f219)(this, RoundedPlaneGeometry);
        _this = _super.call(this); // helper const's
        var wi = width / 2 - radius; // inner width
        var hi = height / 2 - radius; // inner height
        var ul = radius / width; // u left
        var ur = (width - radius) / width; // u right
        var vl = radius / height; // v low
        var vh = (height - radius) / height; // v high
        var positions = [
            wi,
            hi,
            0,
            -wi,
            hi,
            0,
            -wi,
            -hi,
            0,
            wi,
            -hi,
            0
        ];
        var uvs = [
            ur,
            vh,
            ul,
            vh,
            ul,
            vl,
            ur,
            vl
        ];
        var n = [
            3 * (segments + 1) + 3,
            3 * (segments + 1) + 4,
            segments + 4,
            segments + 5,
            2 * (segments + 1) + 4,
            2,
            1,
            2 * (segments + 1) + 3,
            3,
            4 * (segments + 1) + 3,
            4,
            0
        ];
        var indices = [
            n[0],
            n[1],
            n[2],
            n[0],
            n[2],
            n[3],
            n[4],
            n[5],
            n[6],
            n[4],
            n[6],
            n[7],
            n[8],
            n[9],
            n[10],
            n[8],
            n[10],
            n[11]
        ];
        var phi, cos, sin, xc, yc, uc, vc, idx;
        for(var i = 0; i < 4; i++){
            xc = i < 1 || i > 2 ? wi : -wi;
            yc = i < 2 ? hi : -hi;
            uc = i < 1 || i > 2 ? ur : ul;
            vc = i < 2 ? vh : vl;
            for(var j = 0; j <= segments; j++){
                phi = Math.PI / 2 * (i + j / segments);
                cos = Math.cos(phi);
                sin = Math.sin(phi);
                positions.push(xc + radius * cos, yc + radius * sin, 0);
                uvs.push(uc + ul * cos, vc + vl * sin);
                if (j < segments) {
                    idx = (segments + 1) * i + j + 4;
                    indices.push(i, idx, idx + 1);
                }
            }
        }
        _this.setIndex(new $ce0cdebec9150cb3$export$8dea267bd6bde117(new Uint32Array(indices), 1));
        _this.setAttribute("position", new $ce0cdebec9150cb3$export$8dea267bd6bde117(new Float32Array(positions), 3));
        _this.setAttribute("uv", new $ce0cdebec9150cb3$export$8dea267bd6bde117(new Float32Array(uvs), 2));
        return _this;
    }
    return RoundedPlaneGeometry;
}($ce0cdebec9150cb3$export$b7be63a67df8959); // Author: https://stackoverflow.com/users/268905/knee-cola
// https://stackoverflow.com/questions/20774648/three-js-generate-uv-coordinate
function $edd73bf47935fdf3$export$407448d2b89b1813(bufferGeometry) {
    var uvs = [];
    var vertices = [];
    for(var i = 0; i < bufferGeometry.attributes.position.array.length / 3; i++){
        var x = bufferGeometry.attributes.position.array[i * 3 + 0];
        var y = bufferGeometry.attributes.position.array[i * 3 + 1];
        var z = bufferGeometry.attributes.position.array[i * 3 + 2];
        vertices.push(new $ce0cdebec9150cb3$export$64b5c384219d3699(x, y, z));
    }
    var polarVertices = vertices.map($edd73bf47935fdf3$var$cartesian2polar);
    for(var _i = 0; _i < polarVertices.length / 3; _i++){
        var tri = new $ce0cdebec9150cb3$export$5a465592bfe74b48(vertices[_i * 3 + 0], vertices[_i * 3 + 1], vertices[_i * 3 + 2]);
        var normal = tri.getNormal(new $ce0cdebec9150cb3$export$64b5c384219d3699());
        for(var f = 0; f < 3; f++){
            var vertex = polarVertices[_i * 3 + f];
            if (vertex.theta === 0 && (vertex.phi === 0 || vertex.phi === Math.PI)) {
                var alignedVertice = vertex.phi === 0 ? _i * 3 + 1 : _i * 3 + 0;
                vertex = {
                    r: vertex.r,
                    phi: vertex.phi,
                    theta: polarVertices[alignedVertice].theta
                };
            }
            if (vertex.theta === Math.PI && $edd73bf47935fdf3$var$cartesian2polar(normal).theta < Math.PI / 2) vertex.theta = -Math.PI;
            var canvasPoint = $edd73bf47935fdf3$var$polar2canvas(vertex);
            uvs.push(1 - canvasPoint.x, 1 - canvasPoint.y);
        }
    }
    if (bufferGeometry.attributes.uv) delete bufferGeometry.attributes.uv;
    bufferGeometry.setAttribute("uv", new $ce0cdebec9150cb3$export$cbe7a62641830ebd(uvs, 2));
    bufferGeometry.attributes.uv.needsUpdate = true;
    return bufferGeometry;
}
function $edd73bf47935fdf3$var$cartesian2polar(position) {
    var r = Math.sqrt(position.x * position.x + position.z * position.z + position.y * position.y);
    return {
        r: r,
        phi: Math.acos(position.y / r),
        theta: Math.atan2(position.z, position.x)
    };
}
function $edd73bf47935fdf3$var$polar2canvas(polarPoint) {
    return {
        y: polarPoint.phi / Math.PI,
        x: (polarPoint.theta + Math.PI) / (2 * Math.PI)
    };
} // Author: Alex Khoroshylov (https://stackoverflow.com/users/8742287/alex-khoroshylov)
// https://stackoverflow.com/questions/20774648/three-js-generate-uv-coordinate
function $edd73bf47935fdf3$export$8b22cf2602fb60ce(bufferGeometry) {
    bufferGeometry.computeBoundingBox();
    var bboxSize = bufferGeometry.boundingBox.getSize(new $ce0cdebec9150cb3$export$64b5c384219d3699());
    var boxSize = Math.min(bboxSize.x, bboxSize.y, bboxSize.z);
    var boxGeometry = new $ce0cdebec9150cb3$export$33e43285f7406bd5(boxSize, boxSize, boxSize);
    var cube = new $ce0cdebec9150cb3$export$e176487c05830cc5(boxGeometry);
    cube.rotation.set(0, 0, 0);
    cube.updateWorldMatrix(true, false);
    var transformMatrix = cube.matrix.clone().invert();
    var uvBbox = new $ce0cdebec9150cb3$export$6f7d5a9418ab2aa3(new $ce0cdebec9150cb3$export$64b5c384219d3699(-boxSize / 2, -boxSize / 2, -boxSize / 2), new $ce0cdebec9150cb3$export$64b5c384219d3699(boxSize / 2, boxSize / 2, boxSize / 2));
    $edd73bf47935fdf3$var$_applyBoxUV(bufferGeometry, transformMatrix, uvBbox, boxSize);
    bufferGeometry.attributes.uv.needsUpdate = true;
    return bufferGeometry;
}
function $edd73bf47935fdf3$var$_applyBoxUV(geom, transformMatrix, bbox, bbox_max_size) {
    var coords = [];
    coords.length = 2 * geom.attributes.position.array.length / 3; //maps 3 verts of 1 face on the better side of the cube
    //side of the cube can be XY, XZ or YZ
    var makeUVs = function makeUVs(v0, v1, v2) {
        //pre-rotate the model so that cube sides match world axis
        v0.applyMatrix4(transformMatrix);
        v1.applyMatrix4(transformMatrix);
        v2.applyMatrix4(transformMatrix); //get normal of the face, to know into which cube side it maps better
        var n = new $ce0cdebec9150cb3$export$64b5c384219d3699();
        n.crossVectors(v1.clone().sub(v0), v1.clone().sub(v2)).normalize();
        n.x = Math.abs(n.x);
        n.y = Math.abs(n.y);
        n.z = Math.abs(n.z);
        var uv0 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
        var uv1 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1();
        var uv2 = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(); // xz mapping
        if (n.y > n.x && n.y > n.z) {
            uv0.x = (v0.x - bbox.min.x) / bbox_max_size;
            uv0.y = (bbox.max.z - v0.z) / bbox_max_size;
            uv1.x = (v1.x - bbox.min.x) / bbox_max_size;
            uv1.y = (bbox.max.z - v1.z) / bbox_max_size;
            uv2.x = (v2.x - bbox.min.x) / bbox_max_size;
            uv2.y = (bbox.max.z - v2.z) / bbox_max_size;
        } else if (n.x > n.y && n.x > n.z) {
            uv0.x = (v0.z - bbox.min.z) / bbox_max_size;
            uv0.y = (v0.y - bbox.min.y) / bbox_max_size;
            uv1.x = (v1.z - bbox.min.z) / bbox_max_size;
            uv1.y = (v1.y - bbox.min.y) / bbox_max_size;
            uv2.x = (v2.z - bbox.min.z) / bbox_max_size;
            uv2.y = (v2.y - bbox.min.y) / bbox_max_size;
        } else if (n.z > n.y && n.z > n.x) {
            uv0.x = (v0.x - bbox.min.x) / bbox_max_size;
            uv0.y = (v0.y - bbox.min.y) / bbox_max_size;
            uv1.x = (v1.x - bbox.min.x) / bbox_max_size;
            uv1.y = (v1.y - bbox.min.y) / bbox_max_size;
            uv2.x = (v2.x - bbox.min.x) / bbox_max_size;
            uv2.y = (v2.y - bbox.min.y) / bbox_max_size;
        }
        return {
            uv0: uv0,
            uv1: uv1,
            uv2: uv2
        };
    };
    if (geom.index) // is it indexed buffer geometry?
    for(var vi = 0; vi < geom.index.array.length; vi += 3){
        var idx0 = geom.index.array[vi];
        var idx1 = geom.index.array[vi + 1];
        var idx2 = geom.index.array[vi + 2];
        var vx0 = geom.attributes.position.array[3 * idx0];
        var vy0 = geom.attributes.position.array[3 * idx0 + 1];
        var vz0 = geom.attributes.position.array[3 * idx0 + 2];
        var vx1 = geom.attributes.position.array[3 * idx1];
        var vy1 = geom.attributes.position.array[3 * idx1 + 1];
        var vz1 = geom.attributes.position.array[3 * idx1 + 2];
        var vx2 = geom.attributes.position.array[3 * idx2];
        var vy2 = geom.attributes.position.array[3 * idx2 + 1];
        var vz2 = geom.attributes.position.array[3 * idx2 + 2];
        var v0 = new $ce0cdebec9150cb3$export$64b5c384219d3699(vx0, vy0, vz0);
        var v1 = new $ce0cdebec9150cb3$export$64b5c384219d3699(vx1, vy1, vz1);
        var v2 = new $ce0cdebec9150cb3$export$64b5c384219d3699(vx2, vy2, vz2);
        var uvs = makeUVs(v0, v1, v2);
        coords[2 * idx0] = uvs.uv0.x;
        coords[2 * idx0 + 1] = uvs.uv0.y;
        coords[2 * idx1] = uvs.uv1.x;
        coords[2 * idx1 + 1] = uvs.uv1.y;
        coords[2 * idx2] = uvs.uv2.x;
        coords[2 * idx2 + 1] = uvs.uv2.y;
    }
    else for(var _vi = 0; _vi < geom.attributes.position.array.length; _vi += 9){
        var _vx = geom.attributes.position.array[_vi];
        var _vy = geom.attributes.position.array[_vi + 1];
        var _vz = geom.attributes.position.array[_vi + 2];
        var _vx2 = geom.attributes.position.array[_vi + 3];
        var _vy2 = geom.attributes.position.array[_vi + 4];
        var _vz2 = geom.attributes.position.array[_vi + 5];
        var _vx3 = geom.attributes.position.array[_vi + 6];
        var _vy3 = geom.attributes.position.array[_vi + 7];
        var _vz3 = geom.attributes.position.array[_vi + 8];
        var _v = new $ce0cdebec9150cb3$export$64b5c384219d3699(_vx, _vy, _vz);
        var _v2 = new $ce0cdebec9150cb3$export$64b5c384219d3699(_vx2, _vy2, _vz2);
        var _v3 = new $ce0cdebec9150cb3$export$64b5c384219d3699(_vx3, _vy3, _vz3);
        var _uvs = makeUVs(_v, _v2, _v3);
        var _idx = _vi / 3;
        var _idx2 = _idx + 1;
        var _idx3 = _idx + 2;
        coords[2 * _idx] = _uvs.uv0.x;
        coords[2 * _idx + 1] = _uvs.uv0.y;
        coords[2 * _idx2] = _uvs.uv1.x;
        coords[2 * _idx2 + 1] = _uvs.uv1.y;
        coords[2 * _idx3] = _uvs.uv2.x;
        coords[2 * _idx3 + 1] = _uvs.uv2.y;
    }
    if (geom.attributes.uv) delete geom.attributes.uv;
    geom.setAttribute("uv", new $ce0cdebec9150cb3$export$cbe7a62641830ebd(coords, 2));
}
var $edd73bf47935fdf3$export$39b482c5e57630a8 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    RoundedPlaneGeometry: $edd73bf47935fdf3$export$db202ddc8be9136,
    applySphereUV: $edd73bf47935fdf3$export$407448d2b89b1813,
    applyBoxUV: $edd73bf47935fdf3$export$8b22cf2602fb60ce
});





/**
 * Helpers for converting buffers to and from Three.js objects
 */ /**
 * Convents passed buffer of passed stride to an array of vectors with the correct length.
 *
 * @param buffer
 * @param stride
 * @returns
 */ function $05b8d5dc7d950538$export$8b22cf2602fb60ce(buffer) {
    var stride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var p = [];
    for(var i = 0, j = 0; i < buffer.length; i += stride, j++)if (stride === 3) p[j] = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(buffer[i], buffer[i + 1], buffer[i + 2]);
    else p[j] = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(buffer[i], buffer[i + 1]);
    return p;
}
/**
 * Transforms a passed Vector2 or Vector3 array to a points buffer
 *
 * @param vectorArray
 * @returns
 */ function $05b8d5dc7d950538$export$90a7f3efeed30595(vectorArray) {
    var l = vectorArray.length;
    var stride = vectorArray[0].hasOwnProperty("z") ? 3 : 2;
    var buffer = new Float32Array(l * stride);
    for(var i = 0; i < l; i++){
        var j = i * stride;
        buffer[j] = vectorArray[i].x;
        buffer[j + 1] = vectorArray[i].y;
        if (stride === 3) buffer[j + 2] = vectorArray[i].z;
    }
    return buffer;
}
var $05b8d5dc7d950538$export$625550452a3fa3ec = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    bufferToVectors: $05b8d5dc7d950538$export$8b22cf2602fb60ce,
    vectorsToBuffer: $05b8d5dc7d950538$export$90a7f3efeed30595
});













/**
 * Abstract base class for all post processing passes.
 *
 * This module is only relevant for post processing with {@link WebGLRenderer}.
 *
 * @abstract
 * @three_import import { Pass } from 'three/addons/postprocessing/Pass.js';
 */ class $93b96f2f881ee758$export$802bc10488da99c7 {
    /**
	 * Constructs a new pass.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPass = true;
        /**
		 * If set to `true`, the pass is processed by the composer.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to `true`, the pass indicates to swap read and write buffer after rendering.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.needsSwap = true;
        /**
		 * If set to `true`, the pass clears its buffer before rendering
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clear = false;
        /**
		 * If set to `true`, the result of the pass is rendered to screen. The last pass in the composers
		 * pass chain gets automatically rendered to screen, no matter how this property is configured.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.renderToScreen = false;
    }
    /**
	 * Sets the size of the pass.
	 *
	 * @abstract
	 * @param {number} width - The width to set.
	 * @param {number} height - The height to set.
	 */ setSize() {}
    /**
	 * This method holds the render logic of a pass. It must be implemented in all derived classes.
	 *
	 * @abstract
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render() {
        console.error('THREE.Pass: .render() must be implemented in derived pass.');
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the pass is no longer used in your app.
	 *
	 * @abstract
	 */ dispose() {}
}
// Helper for passes that need to fill the viewport with a single quad.
const $93b96f2f881ee758$var$_camera = new (0, $ce0cdebec9150cb3$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
class $93b96f2f881ee758$var$FullscreenTriangleGeometry extends (0, $ce0cdebec9150cb3$export$b7be63a67df8959) {
    constructor(){
        super();
        this.setAttribute('position', new (0, $ce0cdebec9150cb3$export$cbe7a62641830ebd)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        this.setAttribute('uv', new (0, $ce0cdebec9150cb3$export$cbe7a62641830ebd)([
            0,
            2,
            0,
            0,
            2,
            0
        ], 2));
    }
}
const $93b96f2f881ee758$var$_geometry = new $93b96f2f881ee758$var$FullscreenTriangleGeometry();
/**
 * This module is a helper for passes which need to render a full
 * screen effect which is quite common in context of post processing.
 *
 * The intended usage is to reuse a single full screen quad for rendering
 * subsequent passes by just reassigning the `material` reference.
 *
 * This module can only be used with {@link WebGLRenderer}.
 *
 * @augments Mesh
 * @three_import import { FullScreenQuad } from 'three/addons/postprocessing/Pass.js';
 */ class $93b96f2f881ee758$export$3983474c8e6e978b {
    /**
	 * Constructs a new full screen quad.
	 *
	 * @param {?Material} material - The material to render te full screen quad with.
	 */ constructor(material){
        this._mesh = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)($93b96f2f881ee758$var$_geometry, material);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the instance is no longer used in your app.
	 */ dispose() {
        this._mesh.geometry.dispose();
    }
    /**
	 * Renders the full screen quad.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ render(renderer) {
        renderer.render(this._mesh, $93b96f2f881ee758$var$_camera);
    }
    /**
	 * The quad's material.
	 *
	 * @type {?Material}
	 */ get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}



class $51c5c49040a59a26$var$$e4ca8dcb0218f846$var$FullScreenTriangleGeometry extends (0, $ce0cdebec9150cb3$export$b7be63a67df8959) {
    boundingSphere = new (0, $ce0cdebec9150cb3$export$805e8b72413ccaba)();
    constructor(){
        super();
        this.setAttribute("position", new (0, $ce0cdebec9150cb3$export$8dea267bd6bde117)(new Float32Array([
            -1,
            -1,
            3,
            -1,
            -1,
            3
        ]), 2));
        this.setAttribute("uv", new (0, $ce0cdebec9150cb3$export$8dea267bd6bde117)(new Float32Array([
            0,
            0,
            2,
            0,
            0,
            2
        ]), 2));
    }
    computeBoundingSphere() {}
}
const $51c5c49040a59a26$var$$e4ca8dcb0218f846$var$_geometry = /* @__PURE__ */ new $51c5c49040a59a26$var$$e4ca8dcb0218f846$var$FullScreenTriangleGeometry();
const $51c5c49040a59a26$var$$e4ca8dcb0218f846$var$_camera = /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$9ebf355ee4ed261b)();
class $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5 {
    constructor(material){
        this._mesh = new (0, $ce0cdebec9150cb3$export$e176487c05830cc5)($51c5c49040a59a26$var$$e4ca8dcb0218f846$var$_geometry, material);
        this._mesh.frustumCulled = false;
    }
    render(renderer) {
        renderer.render(this._mesh, $51c5c49040a59a26$var$$e4ca8dcb0218f846$var$_camera);
    }
    get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
    dispose() {
        this._mesh.material.dispose();
        this._mesh.geometry.dispose();
    }
}
const $51c5c49040a59a26$var$$1ed45968c1160c3c$export$c9b263b9a17dffd7 = {
    uniforms: {
        "sceneDiffuse": {
            value: null
        },
        "sceneDepth": {
            value: null
        },
        "sceneNormal": {
            value: null
        },
        "projMat": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "viewMat": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "projViewMat": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "projectionMatrixInv": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "viewMatrixInv": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "cameraPos": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)()
        },
        "resolution": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
        },
        "biasAdjustment": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
        },
        "time": {
            value: 0.0
        },
        "samples": {
            value: []
        },
        "bluenoise": {
            value: null
        },
        "distanceFalloff": {
            value: 1.0
        },
        "radius": {
            value: 5.0
        },
        "near": {
            value: 0.1
        },
        "far": {
            value: 1000.0
        },
        "ortho": {
            value: false
        },
        "screenSpaceRadius": {
            value: false
        },
        "frame": {
            value: 0.0
        }
    },
    depthWrite: false,
    depthTest: false,
    vertexShader: /* glsl */ `
varying vec2 vUv;
void main() {
  vUv = uv;
  gl_Position = vec4(position, 1);
}`,
    fragmentShader: /* glsl */ `
    #define SAMPLES 16
    #define FSAMPLES 16.0
uniform sampler2D sceneDiffuse;
uniform highp sampler2D sceneNormal;
uniform highp sampler2D sceneDepth;
uniform mat4 projectionMatrixInv;
uniform mat4 viewMatrixInv;
uniform mat4 projMat;
uniform mat4 viewMat;
uniform mat4 projViewMat;
uniform vec3 cameraPos;
uniform vec2 resolution;
uniform vec2 biasAdjustment;
uniform float time;
uniform vec3[SAMPLES] samples;
uniform float radius;
uniform float distanceFalloff;
uniform float near;
uniform float far;
uniform float frame;
uniform bool ortho;
uniform bool screenSpaceRadius;
uniform sampler2D bluenoise;
    varying vec2 vUv;
    highp float linearize_depth(highp float d, highp float zNear,highp float zFar)
    {
        return (zFar * zNear) / (zFar - d * (zFar - zNear));
    }
    highp float linearize_depth_ortho(highp float d, highp float nearZ, highp float farZ) {
      return nearZ + (farZ - nearZ) * d;
    }
    highp float linearize_depth_log(highp float d, highp float nearZ,highp float farZ) {
      float depth = pow(2.0, d * log2(farZ + 1.0)) - 1.0;
      float a = farZ / (farZ - nearZ);
      float b = farZ * nearZ / (nearZ - farZ);
      float linDepth = a + b / depth;
      /*return ortho ? linearize_depth_ortho(
        linDepth,
        nearZ,
        farZ
      ) :linearize_depth(linDepth, nearZ, farZ);*/
       #ifdef ORTHO

       return linearize_depth_ortho(d, nearZ, farZ);

        #else
        return linearize_depth(linDepth, nearZ, farZ);
        #endif
    }

    vec3 getWorldPosLog(vec3 posS) {
      vec2 uv = posS.xy;
      float z = posS.z;
      float nearZ =near;
      float farZ = far;
      float depth = pow(2.0, z * log2(farZ + 1.0)) - 1.0;
      float a = farZ / (farZ - nearZ);
      float b = farZ * nearZ / (nearZ - farZ);
      float linDepth = a + b / depth;
      vec4 clipVec = vec4(uv, linDepth, 1.0) * 2.0 - 1.0;
      vec4 wpos = projectionMatrixInv * clipVec;
      return wpos.xyz / wpos.w;
    }
    vec3 getWorldPos(float depth, vec2 coord) {
      #ifdef LOGDEPTH
        #ifndef ORTHO
          return getWorldPosLog(vec3(coord, depth));
        #endif
      #endif
      float z = depth * 2.0 - 1.0;
      vec4 clipSpacePosition = vec4(coord * 2.0 - 1.0, z, 1.0);
      vec4 viewSpacePosition = projectionMatrixInv * clipSpacePosition;
      // Perspective division
     vec4 worldSpacePosition = viewSpacePosition;
     worldSpacePosition.xyz /= worldSpacePosition.w;
      return worldSpacePosition.xyz;
  }

  vec3 computeNormal(vec3 worldPos, vec2 vUv) {
    ivec2 p = ivec2(vUv * resolution);
    #ifdef REVERSEDEPTH
    float c0 = 1.0 - texelFetch(sceneDepth, p, 0).x;
    float l2 = 1.0 - texelFetch(sceneDepth, p - ivec2(2, 0), 0).x;
    float l1 = 1.0 - texelFetch(sceneDepth, p - ivec2(1, 0), 0).x;
    float r1 = 1.0 - texelFetch(sceneDepth, p + ivec2(1, 0), 0).x;
    float r2 = 1.0 - texelFetch(sceneDepth, p + ivec2(2, 0), 0).x;
    float b2 = 1.0 - texelFetch(sceneDepth, p - ivec2(0, 2), 0).x;
    float b1 = 1.0 - texelFetch(sceneDepth, p - ivec2(0, 1), 0).x;
    float t1 = 1.0 - texelFetch(sceneDepth, p + ivec2(0, 1), 0).x;
    float t2 = 1.0 - texelFetch(sceneDepth, p + ivec2(0, 2), 0).x;
    #else
    float c0 = texelFetch(sceneDepth, p, 0).x;
    float l2 = texelFetch(sceneDepth, p - ivec2(2, 0), 0).x;
    float l1 = texelFetch(sceneDepth, p - ivec2(1, 0), 0).x;
    float r1 = texelFetch(sceneDepth, p + ivec2(1, 0), 0).x;
    float r2 = texelFetch(sceneDepth, p + ivec2(2, 0), 0).x;
    float b2 = texelFetch(sceneDepth, p - ivec2(0, 2), 0).x;
    float b1 = texelFetch(sceneDepth, p - ivec2(0, 1), 0).x;
    float t1 = texelFetch(sceneDepth, p + ivec2(0, 1), 0).x;
    float t2 = texelFetch(sceneDepth, p + ivec2(0, 2), 0).x;
    #endif

    float dl = abs((2.0 * l1 - l2) - c0);
    float dr = abs((2.0 * r1 - r2) - c0);
    float db = abs((2.0 * b1 - b2) - c0);
    float dt = abs((2.0 * t1 - t2) - c0);

    vec3 ce = getWorldPos(c0, vUv).xyz;

    vec3 dpdx = (dl < dr) ? ce - getWorldPos(l1, (vUv - vec2(1.0 / resolution.x, 0.0))).xyz
                          : -ce + getWorldPos(r1, (vUv + vec2(1.0 / resolution.x, 0.0))).xyz;
    vec3 dpdy = (db < dt) ? ce - getWorldPos(b1, (vUv - vec2(0.0, 1.0 / resolution.y))).xyz
                          : -ce + getWorldPos(t1, (vUv + vec2(0.0, 1.0 / resolution.y))).xyz;

    return normalize(cross(dpdx, dpdy));
}

mat3 makeRotationZ(float theta) {
	float c = cos(theta);
	float s = sin(theta);
	return mat3(c, - s, 0,
			s,  c, 0,
			0,  0, 1);
  }

void main() {
      vec4 diffuse = texture2D(sceneDiffuse, vUv);
      #ifdef REVERSEDEPTH
      float depth = 1.0 - texture2D(sceneDepth, vUv).x;
      #else
      float depth = texture2D(sceneDepth, vUv).x;
      #endif
      if (depth == 1.0) {
        gl_FragColor = vec4(vec3(1.0), 1.0);
        return;
      }
      vec3 worldPos = getWorldPos(depth, vUv);
      #ifdef HALFRES
        vec3 normal = texture2D(sceneNormal, vUv).rgb;
      #else
        vec3 normal = computeNormal(worldPos, vUv);
      #endif
      vec4 noise = texture2D(bluenoise, gl_FragCoord.xy / 128.0);
      vec2 harmoniousNumbers = vec2(
        1.618033988749895,
        1.324717957244746
      );
      noise.rg += harmoniousNumbers * frame;
      noise.rg = fract(noise.rg);
        vec3 helperVec = vec3(0.0, 1.0, 0.0);
        if (dot(helperVec, normal) > 0.99) {
          helperVec = vec3(1.0, 0.0, 0.0);
        }
        vec3 tangent = normalize(cross(helperVec, normal));
        vec3 bitangent = cross(normal, tangent);
        mediump mat3 tbn = mat3(tangent, bitangent, normal) *  makeRotationZ( noise.r * 3.1415962 * 2.0) ;

      mediump float occluded = 0.0;
      mediump float totalWeight = 0.0;
      float radiusToUse = screenSpaceRadius ? distance(
        worldPos,
        getWorldPos(depth, vUv +
          vec2(radius, 0.0) / resolution)
      ) : radius;
      float distanceFalloffToUse =screenSpaceRadius ?
          radiusToUse * distanceFalloff
      : radiusToUse * distanceFalloff * 0.2;
      float bias = (min(
        0.1,
        distanceFalloffToUse * 0.1
      ) / near) * fwidth(distance(worldPos, cameraPos)) / radiusToUse;
      bias = biasAdjustment.x + biasAdjustment.y * bias;
      mediump float offsetMove = noise.g;
      mediump float offsetMoveInv = 1.0 / FSAMPLES;
      float farTimesNear = far * near;
      float farMinusNear = far - near;
      
      for(int i = 0; i < SAMPLES; i++) {
        mediump vec3 sampleDirection = tbn * samples[i];

        float moveAmt = fract(offsetMove);
        offsetMove += offsetMoveInv;
        vec3 samplePos = worldPos + radiusToUse * moveAmt * sampleDirection;
        vec4 offset = projMat * vec4(samplePos, 1.0);
        offset.xyz /= offset.w;
        offset.xyz = offset.xyz * 0.5 + 0.5;
        
        if (all(greaterThan(offset.xyz * (1.0 - offset.xyz), vec3(0.0)))) {
          #ifdef REVERSEDEPTH
          float sampleDepth = 1.0 - textureLod(sceneDepth, offset.xy, 0.0).x;
          #else
          float sampleDepth = textureLod(sceneDepth, offset.xy, 0.0).x;
          #endif

          /*#ifdef LOGDEPTH
          float distSample = linearize_depth_log(sampleDepth, near, far);
      #else
          #ifdef ORTHO
              float distSample = near + farMinusNear * sampleDepth;
          #else
              float distSample = (farTimesNear) / (far - sampleDepth * farMinusNear);
          #endif
      #endif*/
      #ifdef ORTHO
          float distSample = near + sampleDepth * farMinusNear;
      #else
          #ifdef LOGDEPTH
              float distSample = linearize_depth_log(sampleDepth, near, far);
          #else
              float distSample = (farTimesNear) / (far - sampleDepth * farMinusNear);
          #endif
      #endif
      
      #ifdef ORTHO
          float distWorld = near + offset.z * farMinusNear;
      #else
          float distWorld = (farTimesNear) / (far - offset.z * farMinusNear);
      #endif
          
          mediump float rangeCheck = smoothstep(0.0, 1.0, distanceFalloffToUse / (abs(distSample - distWorld)));
          vec2 diff = gl_FragCoord.xy - floor(offset.xy * resolution);
          occluded += rangeCheck * float(distSample != distWorld) * float(sampleDepth != depth) * step(distSample + bias, distWorld) * step(
            1.0,
            dot(diff, diff)
          );
          
          totalWeight ++;
        }
      }
      float occ = clamp(1.0 - occluded / (totalWeight == 0.0 ? 1.0 : totalWeight), 0.0, 1.0);
      gl_FragColor = vec4(occ, 0.5 + 0.5 * normal);
}`
};
const $51c5c49040a59a26$var$$12b21d24d1192a04$export$a815acccbd2c9a49 = {
    uniforms: {
        "sceneDiffuse": {
            value: null
        },
        "sceneDepth": {
            value: null
        },
        "tDiffuse": {
            value: null
        },
        "transparencyDWFalse": {
            value: null
        },
        "transparencyDWTrue": {
            value: null
        },
        "transparencyDWTrueDepth": {
            value: null
        },
        "transparencyAware": {
            value: false
        },
        "projMat": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "viewMat": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "projectionMatrixInv": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "viewMatrixInv": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "cameraPos": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)()
        },
        "resolution": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
        },
        "color": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(0, 0, 0)
        },
        "blueNoise": {
            value: null
        },
        "downsampledDepth": {
            value: null
        },
        "time": {
            value: 0.0
        },
        "intensity": {
            value: 10.0
        },
        "renderMode": {
            value: 0.0
        },
        "gammaCorrection": {
            value: false
        },
        "ortho": {
            value: false
        },
        "near": {
            value: 0.1
        },
        "far": {
            value: 1000.0
        },
        "screenSpaceRadius": {
            value: false
        },
        "radius": {
            value: 0.0
        },
        "distanceFalloff": {
            value: 1.0
        },
        "fog": {
            value: false
        },
        "fogExp": {
            value: false
        },
        "fogDensity": {
            value: 0.0
        },
        "fogNear": {
            value: Infinity
        },
        "fogFar": {
            value: Infinity
        },
        "colorMultiply": {
            value: true
        },
        "aoTones": {
            value: 0.0
        }
    },
    depthWrite: false,
    depthTest: false,
    vertexShader: /* glsl */ `
		varying vec2 vUv;
		void main() {
			vUv = uv;
			gl_Position = vec4(position, 1);
		}`,
    fragmentShader: /* glsl */ `
		uniform sampler2D sceneDiffuse;
    uniform highp sampler2D sceneDepth;
    uniform highp sampler2D downsampledDepth;
    uniform highp sampler2D transparencyDWFalse;
    uniform highp sampler2D transparencyDWTrue;
    uniform highp sampler2D transparencyDWTrueDepth;
    uniform sampler2D tDiffuse;
    uniform sampler2D blueNoise;
    uniform vec2 resolution;
    uniform vec3 color;
    uniform mat4 projectionMatrixInv;
    uniform mat4 viewMatrixInv;
    uniform float intensity;
    uniform float renderMode;
    uniform float near;
    uniform float far;
    uniform float aoTones;
    uniform bool gammaCorrection;
    uniform bool ortho;
    uniform bool screenSpaceRadius;
    uniform bool fog;
    uniform bool fogExp;
    uniform bool colorMultiply;
    uniform bool transparencyAware;
    uniform float fogDensity;
    uniform float fogNear;
    uniform float fogFar;
    uniform float radius;
    uniform float distanceFalloff;
    uniform vec3 cameraPos;
    varying vec2 vUv;
    highp float linearize_depth(highp float d, highp float zNear,highp float zFar)
    {
        return (zFar * zNear) / (zFar - d * (zFar - zNear));
    }
    highp float linearize_depth_ortho(highp float d, highp float nearZ, highp float farZ) {
      return nearZ + (farZ - nearZ) * d;
    }
    highp float linearize_depth_log(highp float d, highp float nearZ,highp float farZ) {
      float depth = pow(2.0, d * log2(farZ + 1.0)) - 1.0;
      float a = farZ / (farZ - nearZ);
      float b = farZ * nearZ / (nearZ - farZ);
      float linDepth = a + b / depth;
      return ortho ? linearize_depth_ortho(
        linDepth,
        nearZ,
        farZ
      ) :linearize_depth(linDepth, nearZ, farZ);
    }
    vec3 getWorldPosLog(vec3 posS) {
        vec2 uv = posS.xy;
        float z = posS.z;
        float nearZ =near;
        float farZ = far;
        float depth = pow(2.0, z * log2(farZ + 1.0)) - 1.0;
        float a = farZ / (farZ - nearZ);
        float b = farZ * nearZ / (nearZ - farZ);
        float linDepth = a + b / depth;
        vec4 clipVec = vec4(uv, linDepth, 1.0) * 2.0 - 1.0;
        vec4 wpos = projectionMatrixInv * clipVec;
        return wpos.xyz / wpos.w;
      }
      vec3 getWorldPos(float depth, vec2 coord) {
        #ifdef LOGDEPTH
          #ifndef ORTHO
            return getWorldPosLog(vec3(coord, depth));
          #endif
        #endif
      //  }
        float z = depth * 2.0 - 1.0;
        vec4 clipSpacePosition = vec4(coord * 2.0 - 1.0, z, 1.0);
        vec4 viewSpacePosition = projectionMatrixInv * clipSpacePosition;
        // Perspective division
       vec4 worldSpacePosition = viewSpacePosition;
       worldSpacePosition.xyz /= worldSpacePosition.w;
        return worldSpacePosition.xyz;
    }
  
    vec3 computeNormal(vec3 worldPos, vec2 vUv) {
      ivec2 p = ivec2(vUv * resolution);
      #ifdef REVERSEDEPTH
      float c0 = 1.0 - texelFetch(sceneDepth, p, 0).x;
      float l2 = 1.0 - texelFetch(sceneDepth, p - ivec2(2, 0), 0).x;
      float l1 = 1.0 - texelFetch(sceneDepth, p - ivec2(1, 0), 0).x;
      float r1 = 1.0 - texelFetch(sceneDepth, p + ivec2(1, 0), 0).x;
      float r2 = 1.0 - texelFetch(sceneDepth, p + ivec2(2, 0), 0).x;
      float b2 = 1.0 - texelFetch(sceneDepth, p - ivec2(0, 2), 0).x;
      float b1 = 1.0 - texelFetch(sceneDepth, p - ivec2(0, 1), 0).x;
      float t1 = 1.0 - texelFetch(sceneDepth, p + ivec2(0, 1), 0).x;
      float t2 = 1.0 - texelFetch(sceneDepth, p + ivec2(0, 2), 0).x;
      #else
      float c0 = texelFetch(sceneDepth, p, 0).x;
      float l2 = texelFetch(sceneDepth, p - ivec2(2, 0), 0).x;
      float l1 = texelFetch(sceneDepth, p - ivec2(1, 0), 0).x;
      float r1 = texelFetch(sceneDepth, p + ivec2(1, 0), 0).x;
      float r2 = texelFetch(sceneDepth, p + ivec2(2, 0), 0).x;
      float b2 = texelFetch(sceneDepth, p - ivec2(0, 2), 0).x;
      float b1 = texelFetch(sceneDepth, p - ivec2(0, 1), 0).x;
      float t1 = texelFetch(sceneDepth, p + ivec2(0, 1), 0).x;
      float t2 = texelFetch(sceneDepth, p + ivec2(0, 2), 0).x;
      #endif
  
      float dl = abs((2.0 * l1 - l2) - c0);
      float dr = abs((2.0 * r1 - r2) - c0);
      float db = abs((2.0 * b1 - b2) - c0);
      float dt = abs((2.0 * t1 - t2) - c0);
  
      vec3 ce = getWorldPos(c0, vUv).xyz;
  
      vec3 dpdx = (dl < dr) ? ce - getWorldPos(l1, (vUv - vec2(1.0 / resolution.x, 0.0))).xyz
                            : -ce + getWorldPos(r1, (vUv + vec2(1.0 / resolution.x, 0.0))).xyz;
      vec3 dpdy = (db < dt) ? ce - getWorldPos(b1, (vUv - vec2(0.0, 1.0 / resolution.y))).xyz
                            : -ce + getWorldPos(t1, (vUv + vec2(0.0, 1.0 / resolution.y))).xyz;
  
      return normalize(cross(dpdx, dpdy));
  }

    #include <common>
    #include <dithering_pars_fragment>
    void main() {
        //vec4 texel = texture2D(tDiffuse, vUv);//vec3(0.0);
        vec4 sceneTexel = texture2D(sceneDiffuse, vUv);
        #ifdef REVERSEDEPTH
        float depth = 1.0 - texture2D(sceneDepth, vUv).x;
        #else
        float depth = texture2D(sceneDepth, vUv).x;
        #endif
        #ifdef HALFRES 
        vec4 texel;
        if (depth == 1.0) {
            texel = vec4(0.0, 0.0, 0.0, 1.0);
        } else {
        vec3 worldPos = getWorldPos(depth, vUv);
        vec3 normal = computeNormal(getWorldPos(depth, vUv), vUv);
       // vec4 texel = texture2D(tDiffuse, vUv);
       // Find closest depth;
       float totalWeight = 0.0;
       float radiusToUse = screenSpaceRadius ? distance(
        worldPos,
        getWorldPos(depth, vUv +
          vec2(radius, 0.0) / resolution)
      ) : radius;
      float distanceFalloffToUse =screenSpaceRadius ?
          radiusToUse * distanceFalloff
      : distanceFalloff;
        for(float x = -1.0; x <= 1.0; x++) {
            for(float y = -1.0; y <= 1.0; y++) {
                vec2 offset = vec2(x, y);
                ivec2 p = ivec2(
                    (vUv * resolution * 0.5) + offset
                );
                vec2 pUv = vec2(p) / (resolution * 0.5);
                float sampleDepth = texelFetch(downsampledDepth,p, 0).x;
                vec4 sampleInfo = texelFetch(tDiffuse, p, 0);
                vec3 normalSample = sampleInfo.gba * 2.0 - 1.0;
                vec3 worldPosSample = getWorldPos(sampleDepth, pUv);
                float tangentPlaneDist = abs(dot(worldPosSample - worldPos, normal));
                float rangeCheck = exp(-1.0 * tangentPlaneDist * (1.0 / distanceFalloffToUse)) * max(dot(normal, normalSample), 0.0);
                float weight = rangeCheck;
                totalWeight += weight;
                texel += sampleInfo * weight;
            }
        }
        if (totalWeight == 0.0) {
            texel = texture2D(tDiffuse, vUv);
        } else {
            texel /= totalWeight;
        }
    }
        #else
        vec4 texel = texture2D(tDiffuse, vUv);
        #endif

        #ifdef LOGDEPTH
        texel.r = clamp(texel.r, 0.0, 1.0);
        if (texel.r == 0.0) {
          texel.r = 1.0;
        }
        #endif
     
        float finalAo = pow(texel.r, intensity);
        if (aoTones > 0.0) {
            finalAo = ceil(finalAo * aoTones) / aoTones;
        }
        float fogFactor;
        float fogDepth = distance(
            cameraPos,
            getWorldPos(depth, vUv)
        );
        if (fog) {
            if (fogExp) {
                fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );
            } else {
                fogFactor = smoothstep( fogNear, fogFar, fogDepth );
            }
        }
        if (transparencyAware) {
            float transparencyDWOff = texture2D(transparencyDWFalse, vUv).a;
            float transparencyDWOn = texture2D(transparencyDWTrue, vUv).a;
            float adjustmentFactorOff = transparencyDWOff;
            #ifdef REVERSEDEPTH
            float depthSample = 1.0 - texture2D(sceneDepth, vUv).r;
            float trueDepthSample = 1.0 - texture2D(transparencyDWTrueDepth, vUv).r;
            #else
            float depthSample = texture2D(sceneDepth, vUv).r;
            float trueDepthSample = texture2D(transparencyDWTrueDepth, vUv).r;
            #endif
            float adjustmentFactorOn = (1.0 - transparencyDWOn) * (
                trueDepthSample == depthSample ? 1.0 : 0.0
            );
            float adjustmentFactor = max(adjustmentFactorOff, adjustmentFactorOn);
            finalAo = mix(finalAo, 1.0, adjustmentFactor);
        }
        finalAo = mix(finalAo, 1.0, fogFactor);
        vec3 aoApplied = color * mix(vec3(1.0), sceneTexel.rgb, float(colorMultiply));
        if (renderMode == 0.0) {
            gl_FragColor = vec4( mix(sceneTexel.rgb, aoApplied, 1.0 - finalAo), sceneTexel.a);
        } else if (renderMode == 1.0) {
            gl_FragColor = vec4( mix(vec3(1.0), aoApplied, 1.0 - finalAo), sceneTexel.a);
        } else if (renderMode == 2.0) {
            gl_FragColor = vec4( sceneTexel.rgb, sceneTexel.a);
        } else if (renderMode == 3.0) {
            if (vUv.x < 0.5) {
                gl_FragColor = vec4( sceneTexel.rgb, sceneTexel.a);
            } else if (abs(vUv.x - 0.5) < 1.0 / resolution.x) {
                gl_FragColor = vec4(1.0);
            } else {
                gl_FragColor = vec4( mix(sceneTexel.rgb, aoApplied, 1.0 - finalAo), sceneTexel.a);
            }
        } else if (renderMode == 4.0) {
            if (vUv.x < 0.5) {
                gl_FragColor = vec4( sceneTexel.rgb, sceneTexel.a);
            } else if (abs(vUv.x - 0.5) < 1.0 / resolution.x) {
                gl_FragColor = vec4(1.0);
            } else {
                gl_FragColor = vec4( mix(vec3(1.0), aoApplied, 1.0 - finalAo), sceneTexel.a);
            }
        }
        #include <dithering_fragment>
        if (gammaCorrection) {
            gl_FragColor = sRGBTransferOETF(gl_FragColor);
        }
    }
    `
};
const $51c5c49040a59a26$var$$e52378cd0f5a973d$export$57856b59f317262e = {
    uniforms: {
        "sceneDiffuse": {
            value: null
        },
        "sceneDepth": {
            value: null
        },
        "tDiffuse": {
            value: null
        },
        "projMat": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "viewMat": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "projectionMatrixInv": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "viewMatrixInv": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "cameraPos": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)()
        },
        "resolution": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
        },
        "time": {
            value: 0.0
        },
        "r": {
            value: 5.0
        },
        "blueNoise": {
            value: null
        },
        "radius": {
            value: 12.0
        },
        "worldRadius": {
            value: 5.0
        },
        "index": {
            value: 0.0
        },
        "poissonDisk": {
            value: []
        },
        "distanceFalloff": {
            value: 1.0
        },
        "near": {
            value: 0.1
        },
        "far": {
            value: 1000.0
        },
        "screenSpaceRadius": {
            value: false
        }
    },
    depthWrite: false,
    depthTest: false,
    vertexShader: /* glsl */ `
		varying vec2 vUv;
		void main() {
			vUv = uv;
			gl_Position = vec4(position, 1.0);
		}`,
    fragmentShader: /* glsl */ `
		uniform sampler2D sceneDiffuse;
    uniform highp sampler2D sceneDepth;
    uniform sampler2D tDiffuse;
    uniform sampler2D blueNoise;
    uniform mat4 projectionMatrixInv;
    uniform mat4 viewMatrixInv;
    uniform vec2 resolution;
    uniform float r;
    uniform float radius;
     uniform float worldRadius;
    uniform float index;
     uniform float near;
     uniform float far;
     uniform float distanceFalloff;
     uniform bool screenSpaceRadius;
    varying vec2 vUv;

    highp float linearize_depth(highp float d, highp float zNear,highp float zFar)
    {
        highp float z_n = 2.0 * d - 1.0;
        return 2.0 * zNear * zFar / (zFar + zNear - z_n * (zFar - zNear));
    }
    highp float linearize_depth_log(highp float d, highp float nearZ,highp float farZ) {
     float depth = pow(2.0, d * log2(farZ + 1.0)) - 1.0;
     float a = farZ / (farZ - nearZ);
     float b = farZ * nearZ / (nearZ - farZ);
     float linDepth = a + b / depth;
     return linearize_depth(linDepth, nearZ, farZ);
   }
   highp float linearize_depth_ortho(highp float d, highp float nearZ, highp float farZ) {
     return nearZ + (farZ - nearZ) * d;
   }
   vec3 getWorldPosLog(vec3 posS) {
     vec2 uv = posS.xy;
     float z = posS.z;
     float nearZ =near;
     float farZ = far;
     float depth = pow(2.0, z * log2(farZ + 1.0)) - 1.0;
     float a = farZ / (farZ - nearZ);
     float b = farZ * nearZ / (nearZ - farZ);
     float linDepth = a + b / depth;
     vec4 clipVec = vec4(uv, linDepth, 1.0) * 2.0 - 1.0;
     vec4 wpos = projectionMatrixInv * clipVec;
     return wpos.xyz / wpos.w;
   }
    vec3 getWorldPos(float depth, vec2 coord) {
     #ifdef LOGDEPTH
      #ifndef ORTHO
          return getWorldPosLog(vec3(coord, depth));
      #endif
     #endif
        
        float z = depth * 2.0 - 1.0;
        vec4 clipSpacePosition = vec4(coord * 2.0 - 1.0, z, 1.0);
        vec4 viewSpacePosition = projectionMatrixInv * clipSpacePosition;
        // Perspective division
       vec4 worldSpacePosition = viewSpacePosition;
       worldSpacePosition.xyz /= worldSpacePosition.w;
        return worldSpacePosition.xyz;
    }
    #include <common>
    #define NUM_SAMPLES 16
    uniform vec2 poissonDisk[NUM_SAMPLES];
    void main() {
        const float pi = 3.14159;
        vec2 texelSize = vec2(1.0 / resolution.x, 1.0 / resolution.y);
        vec2 uv = vUv;
        vec4 data = texture2D(tDiffuse, vUv);
        float occlusion = data.r;
        float baseOcc = data.r;
        vec3 normal = data.gba * 2.0 - 1.0;
        float count = 1.0;
        float d = texture2D(sceneDepth, vUv).x;
        if (d == 1.0) {
          gl_FragColor = data;
          return;
        }
        vec3 worldPos = getWorldPos(d, vUv);
        float size = radius;
        float angle;
        if (index == 0.0) {
             angle = texture2D(blueNoise, gl_FragCoord.xy / 128.0).w * PI2;
        } else if (index == 1.0) {
             angle = texture2D(blueNoise, gl_FragCoord.xy / 128.0).z * PI2;
        } else if (index == 2.0) {
             angle = texture2D(blueNoise, gl_FragCoord.xy / 128.0).y * PI2;
        } else {
             angle = texture2D(blueNoise, gl_FragCoord.xy / 128.0).x * PI2;
        }

        mat2 rotationMatrix = mat2(cos(angle), -sin(angle), sin(angle), cos(angle));
        float radiusToUse = screenSpaceRadius ? distance(
          worldPos,
          getWorldPos(d, vUv +
            vec2(worldRadius, 0.0) / resolution)
        ) : worldRadius;
        float distanceFalloffToUse =screenSpaceRadius ?
        radiusToUse * distanceFalloff
    : radiusToUse * distanceFalloff * 0.2;

        float invDistance = (1.0 / distanceFalloffToUse);
        for(int i = 0; i < NUM_SAMPLES; i++) {
            vec2 offset = (rotationMatrix * poissonDisk[i]) * texelSize * size;
            vec4 dataSample = texture2D(tDiffuse, uv + offset);
            float occSample = dataSample.r;
            vec3 normalSample = dataSample.gba * 2.0 - 1.0;
            float dSample = texture2D(sceneDepth, uv + offset).x;
            vec3 worldPosSample = getWorldPos(dSample, uv + offset);
            float tangentPlaneDist = abs(dot(worldPosSample - worldPos, normal));
            float rangeCheck = float(dSample != 1.0) * exp(-1.0 * tangentPlaneDist * invDistance ) * max(dot(normal, normalSample), 0.0);
            occlusion += occSample * rangeCheck;
            count += rangeCheck;
        }
        if (count > 0.0) {
          occlusion /= count;
        }
        occlusion = clamp(occlusion, 0.0, 1.0);
        if (occlusion == 0.0) {
          occlusion = 1.0;
        }
        gl_FragColor = vec4(occlusion, 0.5 + 0.5 * normal);
    }
    `
};
const $51c5c49040a59a26$var$$26aca173e0984d99$export$1efdf491687cd442 = {
    uniforms: {
        "sceneDepth": {
            value: null
        },
        "resolution": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)()
        },
        "near": {
            value: 0.1
        },
        "far": {
            value: 1000.0
        },
        "viewMatrixInv": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "projectionMatrixInv": {
            value: /* @__PURE__ */ new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)()
        },
        "logDepth": {
            value: false
        },
        "ortho": {
            value: false
        }
    },
    depthWrite: false,
    depthTest: false,
    vertexShader: /* glsl */ `
    varying vec2 vUv;
    void main() {
        vUv = uv;
        gl_Position = vec4(position, 1);
    }`,
    fragmentShader: /* glsl */ `
    uniform highp sampler2D sceneDepth;
    uniform vec2 resolution;
    uniform float near;
    uniform float far;
    uniform bool logDepth;
    uniform bool ortho;
    uniform mat4 viewMatrixInv;
    uniform mat4 projectionMatrixInv;
    varying vec2 vUv;
    layout(location = 1) out vec4 gNormal;
    vec3 getWorldPosLog(vec3 posS) {
        vec2 uv = posS.xy;
        float z = posS.z;
        float nearZ =near;
        float farZ = far;
        float depth = pow(2.0, z * log2(farZ + 1.0)) - 1.0;
        float a = farZ / (farZ - nearZ);
        float b = farZ * nearZ / (nearZ - farZ);
        float linDepth = a + b / depth;
        vec4 clipVec = vec4(uv, linDepth, 1.0) * 2.0 - 1.0;
        vec4 wpos = projectionMatrixInv * clipVec;
        return wpos.xyz / wpos.w;
      }
      vec3 getWorldPos(float depth, vec2 coord) {
        if (logDepth && !ortho) {
          return getWorldPosLog(vec3(coord, depth));
        }
        float z = depth * 2.0 - 1.0;
        vec4 clipSpacePosition = vec4(coord * 2.0 - 1.0, z, 1.0);
        vec4 viewSpacePosition = projectionMatrixInv * clipSpacePosition;
        // Perspective division
       vec4 worldSpacePosition = viewSpacePosition;
       worldSpacePosition.xyz /= worldSpacePosition.w;
        return worldSpacePosition.xyz;
    }
  
    vec3 computeNormal(vec3 worldPos, vec2 vUv) {
      ivec2 p = ivec2(vUv * resolution);
      #ifdef REVERSEDEPTH
      float c0 = 1.0 - texelFetch(sceneDepth, p, 0).x;
      float l2 = 1.0 - texelFetch(sceneDepth, p - ivec2(2, 0), 0).x;
      float l1 = 1.0 - texelFetch(sceneDepth, p - ivec2(1, 0), 0).x;
      float r1 = 1.0 - texelFetch(sceneDepth, p + ivec2(1, 0), 0).x;
      float r2 = 1.0 - texelFetch(sceneDepth, p + ivec2(2, 0), 0).x;
      float b2 = 1.0 - texelFetch(sceneDepth, p - ivec2(0, 2), 0).x;
      float b1 = 1.0 - texelFetch(sceneDepth, p - ivec2(0, 1), 0).x;
      float t1 = 1.0 - texelFetch(sceneDepth, p + ivec2(0, 1), 0).x;
      float t2 = 1.0 - texelFetch(sceneDepth, p + ivec2(0, 2), 0).x;
      #else
      float c0 = texelFetch(sceneDepth, p, 0).x;
      float l2 = texelFetch(sceneDepth, p - ivec2(2, 0), 0).x;
      float l1 = texelFetch(sceneDepth, p - ivec2(1, 0), 0).x;
      float r1 = texelFetch(sceneDepth, p + ivec2(1, 0), 0).x;
      float r2 = texelFetch(sceneDepth, p + ivec2(2, 0), 0).x;
      float b2 = texelFetch(sceneDepth, p - ivec2(0, 2), 0).x;
      float b1 = texelFetch(sceneDepth, p - ivec2(0, 1), 0).x;
      float t1 = texelFetch(sceneDepth, p + ivec2(0, 1), 0).x;
      float t2 = texelFetch(sceneDepth, p + ivec2(0, 2), 0).x;
      #endif
  
      float dl = abs((2.0 * l1 - l2) - c0);
      float dr = abs((2.0 * r1 - r2) - c0);
      float db = abs((2.0 * b1 - b2) - c0);
      float dt = abs((2.0 * t1 - t2) - c0);
  
      vec3 ce = getWorldPos(c0, vUv).xyz;
  
      vec3 dpdx = (dl < dr) ? ce - getWorldPos(l1, (vUv - vec2(1.0 / resolution.x, 0.0))).xyz
                            : -ce + getWorldPos(r1, (vUv + vec2(1.0 / resolution.x, 0.0))).xyz;
      vec3 dpdy = (db < dt) ? ce - getWorldPos(b1, (vUv - vec2(0.0, 1.0 / resolution.y))).xyz
                            : -ce + getWorldPos(t1, (vUv + vec2(0.0, 1.0 / resolution.y))).xyz;
  
      return normalize(cross(dpdx, dpdy));
  }
    void main() {
        vec2 uv = vUv - vec2(0.5) / resolution;
        vec2 pixelSize = vec2(1.0) / resolution;
        highp vec2[4] uvSamples;
        uvSamples[0] = uv;
        uvSamples[1] = uv + vec2(pixelSize.x, 0.0);
        uvSamples[2] = uv + vec2(0.0, pixelSize.y);
        uvSamples[3] = uv + pixelSize;
        #ifdef REVERSEDEPTH
        float depth00 = 1.0 - texture2D(sceneDepth, uvSamples[0]).r;
        float depth10 = 1.0 - texture2D(sceneDepth, uvSamples[1]).r;
        float depth01 = 1.0 - texture2D(sceneDepth, uvSamples[2]).r;
        float depth11 = 1.0 - texture2D(sceneDepth, uvSamples[3]).r;
        #else
        float depth00 = texture2D(sceneDepth, uvSamples[0]).r;
        float depth10 = texture2D(sceneDepth, uvSamples[1]).r;
        float depth01 = texture2D(sceneDepth, uvSamples[2]).r;
        float depth11 = texture2D(sceneDepth, uvSamples[3]).r;
        #endif
        float minDepth = min(min(depth00, depth10), min(depth01, depth11));
        float maxDepth = max(max(depth00, depth10), max(depth01, depth11));
        float targetDepth = minDepth;
        // Checkerboard pattern to avoid artifacts
        if (mod(gl_FragCoord.x + gl_FragCoord.y, 2.0) > 0.5) { 
            targetDepth = maxDepth;
        }
        int chosenIndex = 0;
        float[4] samples;
        samples[0] = depth00;
        samples[1] = depth10;
        samples[2] = depth01;
        samples[3] = depth11;
        for(int i = 0; i < 4; ++i) {
            if (samples[i] == targetDepth) {
                chosenIndex = i;
                break;
            }
        }
        gl_FragColor = vec4(samples[chosenIndex], 0.0, 0.0, 1.0);
        gNormal = vec4(computeNormal(
            getWorldPos(samples[chosenIndex], uvSamples[chosenIndex]), uvSamples[chosenIndex]
        ), 0.0);
    }`
};
const $51c5c49040a59a26$var$$06269ad78f3c5fdf$var$BlueNoise = `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`;
const $51c5c49040a59a26$var$$06269ad78f3c5fdf$var$bluenoiseBits = /* @__PURE__ */ (()=>Uint8Array.from(atob($51c5c49040a59a26$var$$06269ad78f3c5fdf$var$BlueNoise), (c)=>c.charCodeAt(0)))();
var $51c5c49040a59a26$var$$06269ad78f3c5fdf$export$2e2bcd8739ae039 = $51c5c49040a59a26$var$$06269ad78f3c5fdf$var$bluenoiseBits;
const $51c5c49040a59a26$var$$ff9437d9c7577f11$var$version = /* @__PURE__ */ (()=>parseInt((0, $ce0cdebec9150cb3$export$3545e07a80636437).replace(/\D+/g, "")))();
const $51c5c49040a59a26$var$$ff9437d9c7577f11$export$156f6a58f569aa09 = $51c5c49040a59a26$var$$ff9437d9c7577f11$var$version >= 162 ? class extends (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f) {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, {
            ...options,
            count: count
        });
        this.isWebGLMultipleRenderTargets = true;
    }
    get texture() {
        return this.textures;
    }
} : class extends (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f) {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
};
/**
 * 
 * @param {*} timerQuery 
 * @param {THREE.WebGLRenderer} gl 
 * @param {N8AOPostPass | N8AOPass} pass 
 */ function $51c5c49040a59a26$var$$87431ee93b037844$var$checkTimerQuery(timerQuery, gl, pass) {
    const available = gl.getQueryParameter(timerQuery, gl.QUERY_RESULT_AVAILABLE);
    if (available) {
        const elapsedTimeInNs = gl.getQueryParameter(timerQuery, gl.QUERY_RESULT);
        const elapsedTimeInMs = elapsedTimeInNs / 1000000;
        pass.lastTime = pass.lastTime === 0 ? elapsedTimeInMs : pass.timeRollingAverage * pass.lastTime + (1 - pass.timeRollingAverage) * elapsedTimeInMs;
    } else setTimeout(()=>{
        $51c5c49040a59a26$var$$87431ee93b037844$var$checkTimerQuery(timerQuery, gl, pass);
    }, 1);
}
class $51c5c49040a59a26$export$2489f9981ab0fa82 extends (0, $2046da3312f94030$export$802bc10488da99c7) {
    /**
     * 
     * @param {THREE.Scene} scene
     * @param {THREE.Camera} camera 
     * @param {number} width 
     * @param {number} height
     *  
     * @property {THREE.Scene} scene
     * @property {THREE.Camera} camera
     * @property {number} width
     * @property {number} height
     */ constructor(scene, camera, width = 512, height = 512){
        super();
        this.width = width;
        this.height = height;
        this.clear = true;
        this.camera = camera;
        this.scene = scene;
        /**
         * @type {Proxy & {
         * aoSamples: number,
         * aoRadius: number,
         * denoiseSamples: number,
         * denoiseRadius: number,
         * distanceFalloff: number,
         * intensity: number,
         * denoiseIterations: number,
         * renderMode: 0 | 1 | 2 | 3 | 4,
         * color: THREE.Color,
         * gammaCorrection: boolean,
         * depthBufferType: 1 | 2 | 3,
         * screenSpaceRadius: boolean,
         * halfRes: boolean,
         * depthAwareUpsampling: boolean
         * colorMultiply: boolean
         * }
         */ this.autosetGamma = true;
        this.configuration = new Proxy({
            aoSamples: 16,
            aoRadius: 5.0,
            aoTones: 0.0,
            denoiseSamples: 8,
            denoiseRadius: 12,
            distanceFalloff: 1.0,
            intensity: 5,
            denoiseIterations: 2.0,
            renderMode: 0,
            biasOffset: 0.0,
            biasMultiplier: 0.0,
            color: new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0, 0, 0),
            gammaCorrection: true,
            depthBufferType: $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default,
            screenSpaceRadius: false,
            halfRes: false,
            depthAwareUpsampling: true,
            colorMultiply: true,
            transparencyAware: false,
            accumulate: false
        }, {
            set: (target, propName, value)=>{
                const oldProp = target[propName];
                target[propName] = value;
                if (value.equals) {
                    if (!value.equals(oldProp)) this.firstFrame();
                } else if (oldProp !== value) this.firstFrame();
                if (propName === "aoSamples" && oldProp !== value) this.configureAOPass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                if (propName === "denoiseSamples" && oldProp !== value) this.configureDenoisePass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                if (propName === "halfRes" && oldProp !== value) {
                    this.configureAOPass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                    this.configureHalfResTargets();
                    this.configureEffectCompositer(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                    this.setSize(this.width, this.height);
                }
                if (propName === "depthAwareUpsampling" && oldProp !== value) this.configureEffectCompositer(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                if (propName === "gammaCorrection") this.autosetGamma = false;
                if (propName === "transparencyAware" && oldProp !== value) {
                    this.autoDetectTransparency = false;
                    this.configureTransparencyTarget();
                }
                return true;
            }
        });
        /** @type {THREE.Vector3[]} */ this.samples = [];
        /** @type {THREE.Vector2[]} */ this.samplesDenoise = [];
        this.autoDetectTransparency = true;
        this.frames = 0;
        this.lastViewMatrix = new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
        this.lastProjectionMatrix = new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
        this.configureEffectCompositer(this.configuration.depthBufferType);
        this.configureSampleDependentPasses();
        this.configureHalfResTargets();
        this.detectTransparency();
        this.configureTransparencyTarget();
        //   this.effectCompisterQuad = new FullScreenTriangle(new THREE.ShaderMaterial(EffectCompositer));
        this.copyQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
            uniforms: {
                tDiffuse: {
                    value: null
                }
            },
            depthWrite: false,
            vertexShader: `
            varying vec2 vUv;
            void main() {
                vUv = uv;
                gl_Position = vec4(position, 1);
            }
            `,
            fragmentShader: `
            uniform sampler2D tDiffuse;
            varying vec2 vUv;
            void main() {
                gl_FragColor = texture2D(tDiffuse, vUv);
            }
            `
        }));
        this.writeTargetInternal = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            depthBuffer: false,
            format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)
        });
        this.readTargetInternal = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            depthBuffer: false,
            format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)
        });
        this.outputTargetInternal = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            depthBuffer: false
        });
        this.accumulationRenderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            depthBuffer: false,
            format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c),
            type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
            stencilBuffer: false,
            depthBuffer: false,
            alpha: true
        });
        this.accumulationQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
            uniforms: {
                frame: {
                    value: 0
                },
                tDiffuse: {
                    value: null
                }
            },
            transparent: true,
            opacity: 1,
            vertexShader: `
             varying vec2 vUv;
             void main() {
                 vUv = uv;
                 gl_Position = vec4(position, 1);
             }`,
            fragmentShader: `
             uniform sampler2D tDiffuse;
             uniform float frame;
                varying vec2 vUv;
                void main() {
                    vec4 color = texture2D(tDiffuse, vUv);
                    gl_FragColor = vec4(color.rgb, 1.0 / (frame + 1.0));
                }
                `
        }));
        /** @type {THREE.DataTexture} */ this.bluenoise = new (0, $ce0cdebec9150cb3$export$b691f601014eabe1)($51c5c49040a59a26$var$$06269ad78f3c5fdf$export$2e2bcd8739ae039, 128, 128);
        this.bluenoise.colorSpace = (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51);
        this.bluenoise.wrapS = (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5);
        this.bluenoise.wrapT = (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5);
        this.bluenoise.minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
        this.bluenoise.magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
        this.bluenoise.needsUpdate = true;
        this.lastTime = 0;
        this.timeRollingAverage = 0.99;
        this.needsDepthTexture = true;
        this.needsSwap = true;
        this._r = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        this._c = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)();
    }
    configureHalfResTargets() {
        this.firstFrame();
        if (this.configuration.halfRes) {
            this.depthDownsampleTarget = new $51c5c49040a59a26$var$$ff9437d9c7577f11$export$156f6a58f569aa09(this.width / 2, this.height / 2, 2);
            if ((0, $ce0cdebec9150cb3$export$3545e07a80636437) <= 161) this.depthDownsampleTarget.textures = this.depthDownsampleTarget.texture;
            this.depthDownsampleTarget.textures[0].format = (0, $ce0cdebec9150cb3$export$4e041a7967d15c4b);
            this.depthDownsampleTarget.textures[0].type = (0, $ce0cdebec9150cb3$export$f6d331659b644596);
            this.depthDownsampleTarget.textures[0].minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            this.depthDownsampleTarget.textures[0].magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            this.depthDownsampleTarget.textures[0].depthBuffer = false;
            this.depthDownsampleTarget.textures[1].format = (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c);
            this.depthDownsampleTarget.textures[1].type = (0, $ce0cdebec9150cb3$export$2697304443f382bc);
            this.depthDownsampleTarget.textures[1].minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            this.depthDownsampleTarget.textures[1].magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            this.depthDownsampleTarget.textures[1].depthBuffer = false;
            this.depthDownsampleQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)($51c5c49040a59a26$var$$26aca173e0984d99$export$1efdf491687cd442));
        } else {
            if (this.depthDownsampleTarget) {
                this.depthDownsampleTarget.dispose();
                this.depthDownsampleTarget = null;
            }
            if (this.depthDownsampleQuad) {
                this.depthDownsampleQuad.dispose();
                this.depthDownsampleQuad = null;
            }
        }
    }
    detectTransparency() {
        if (this.autoDetectTransparency) {
            let isTransparency = false;
            this.scene.traverse((obj)=>{
                if (obj.material && obj.material.transparent) isTransparency = true;
            });
            if (isTransparency) this.configuration.transparencyAware = true;
        }
    }
    configureTransparencyTarget() {
        if (this.configuration.transparencyAware) {
            this.transparencyRenderTargetDWFalse = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
                minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
                magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
                type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
                format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)
            });
            this.transparencyRenderTargetDWTrue = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
                minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
                magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
                type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
                format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)
            });
            this.transparencyRenderTargetDWTrue.depthTexture = new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)(this.width, this.height, (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96));
            this.depthCopyPass = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
                uniforms: {
                    depthTexture: {
                        value: this.depthTexture
                    },
                    reverseDepthBuffer: {
                        value: this.configuration.depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse
                    }
                },
                vertexShader: /* glsl */ `
            varying vec2 vUv;
            void main() {
                vUv = uv;
                gl_Position = vec4(position, 1);
            }`,
                fragmentShader: /* glsl */ `
            uniform sampler2D depthTexture;
            uniform bool reverseDepthBuffer;
            varying vec2 vUv;
            void main() {
                if (reverseDepthBuffer) {
               float d = 1.0 - texture2D(depthTexture, vUv).r;
           
               d += 0.00001;
               gl_FragDepth = 1.0 - d;
            } else {
                float d = texture2D(depthTexture, vUv).r;
                d += 0.00001;
                gl_FragDepth = d;
            }
               gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
            }
            `
            }));
        } else {
            if (this.transparencyRenderTargetDWFalse) {
                this.transparencyRenderTargetDWFalse.dispose();
                this.transparencyRenderTargetDWFalse = null;
            }
            if (this.transparencyRenderTargetDWTrue) {
                this.transparencyRenderTargetDWTrue.dispose();
                this.transparencyRenderTargetDWTrue = null;
            }
            if (this.depthCopyPass) {
                this.depthCopyPass.dispose();
                this.depthCopyPass = null;
            }
        }
    }
    renderTransparency(renderer) {
        const oldBackground = this.scene.background;
        const oldClearColor = renderer.getClearColor(new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)());
        const oldClearAlpha = renderer.getClearAlpha();
        const oldVisibility = new Map();
        const oldAutoClearDepth = renderer.autoClearDepth;
        this.scene.traverse((obj)=>{
            oldVisibility.set(obj, obj.visible);
        });
        // Override the state
        this.scene.background = null;
        renderer.autoClearDepth = false;
        renderer.setClearColor(new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0, 0, 0), 0);
        this.depthCopyPass.material.uniforms.depthTexture.value = this.depthTexture;
        this.depthCopyPass.material.uniforms.reverseDepthBuffer.value = this.configuration.depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse;
        // Render out transparent objects WITHOUT depth write
        renderer.setRenderTarget(this.transparencyRenderTargetDWFalse);
        this.scene.traverse((obj)=>{
            if (obj.material) obj.visible = oldVisibility.get(obj) && (obj.material.transparent && !obj.material.depthWrite && !obj.userData.treatAsOpaque || !!obj.userData.cannotReceiveAO);
        });
        renderer.clear(true, true, true);
        this.depthCopyPass.render(renderer);
        renderer.render(this.scene, this.camera);
        // Render out transparent objects WITH depth write
        renderer.setRenderTarget(this.transparencyRenderTargetDWTrue);
        this.scene.traverse((obj)=>{
            if (obj.material) obj.visible = oldVisibility.get(obj) && obj.material.transparent && obj.material.depthWrite && !obj.userData.treatAsOpaque;
        });
        renderer.clear(true, true, true);
        this.depthCopyPass.render(renderer);
        renderer.render(this.scene, this.camera);
        // Restore
        this.scene.traverse((obj)=>{
            obj.visible = oldVisibility.get(obj);
        });
        renderer.setClearColor(oldClearColor, oldClearAlpha);
        this.scene.background = oldBackground;
        renderer.autoClearDepth = oldAutoClearDepth;
    }
    configureSampleDependentPasses() {
        this.configureAOPass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
        this.configureDenoisePass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
    }
    configureAOPass(depthBufferType = $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default, ortho = false) {
        this.firstFrame();
        this.samples = this.generateHemisphereSamples(this.configuration.aoSamples);
        const e = {
            ...$51c5c49040a59a26$var$$1ed45968c1160c3c$export$c9b263b9a17dffd7
        };
        e.fragmentShader = e.fragmentShader.replace("16", this.configuration.aoSamples).replace("16.0", this.configuration.aoSamples + ".0");
        if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log) e.fragmentShader = "#define LOGDEPTH\n" + e.fragmentShader;
        else if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse) e.fragmentShader = "#define REVERSEDEPTH\n" + e.fragmentShader;
        if (ortho) e.fragmentShader = "#define ORTHO\n" + e.fragmentShader;
        if (this.configuration.halfRes) e.fragmentShader = "#define HALFRES\n" + e.fragmentShader;
        if (this.effectShaderQuad) {
            this.effectShaderQuad.material.dispose();
            this.effectShaderQuad.material = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(e);
        } else this.effectShaderQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(e));
    }
    configureDenoisePass(depthBufferType = $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default, ortho = false) {
        this.firstFrame();
        this.samplesDenoise = this.generateDenoiseSamples(this.configuration.denoiseSamples, 11);
        const p = {
            ...$51c5c49040a59a26$var$$e52378cd0f5a973d$export$57856b59f317262e
        };
        p.fragmentShader = p.fragmentShader.replace("16", this.configuration.denoiseSamples);
        if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log) p.fragmentShader = "#define LOGDEPTH\n" + p.fragmentShader;
        else if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse) p.fragmentShader = "#define REVERSEDEPTH\n" + p.fragmentShader;
        if (ortho) p.fragmentShader = "#define ORTHO\n" + p.fragmentShader;
        if (this.poissonBlurQuad) {
            this.poissonBlurQuad.material.dispose();
            this.poissonBlurQuad.material = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(p);
        } else this.poissonBlurQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(p));
    }
    configureEffectCompositer(depthBufferType = $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default, ortho = false) {
        this.firstFrame();
        const e = {
            ...$51c5c49040a59a26$var$$12b21d24d1192a04$export$a815acccbd2c9a49
        };
        if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log) e.fragmentShader = "#define LOGDEPTH\n" + e.fragmentShader;
        else if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse) e.fragmentShader = "#define REVERSEDEPTH\n" + e.fragmentShader;
        if (ortho) e.fragmentShader = "#define ORTHO\n" + e.fragmentShader;
        if (this.configuration.halfRes && this.configuration.depthAwareUpsampling) e.fragmentShader = "#define HALFRES\n" + e.fragmentShader;
        if (this.effectCompositerQuad) {
            this.effectCompositerQuad.material.dispose();
            this.effectCompositerQuad.material = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(e);
        } else this.effectCompositerQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(e));
    }
    /**
         * 
         * @param {Number} n 
         * @returns {THREE.Vector3[]}
         */ generateHemisphereSamples(n) {
        const points = [];
        for(let k = 0; k < n; k++){
            const theta = 2.399963 * k;
            const r = Math.sqrt(k + 0.5) / Math.sqrt(n);
            const x = r * Math.cos(theta);
            const y = r * Math.sin(theta);
            // Project to hemisphere
            const z = Math.sqrt(1 - (x * x + y * y));
            points.push(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(x, y, z));
        }
        return points;
    }
    /**
         * 
         * @param {number} numSamples 
         * @param {number} numRings 
         * @returns {THREE.Vector2[]}
         */ generateDenoiseSamples(numSamples, numRings) {
        const angleStep = 2 * Math.PI * numRings / numSamples;
        const invNumSamples = 1.0 / numSamples;
        const radiusStep = invNumSamples;
        const samples = [];
        let radius = invNumSamples;
        let angle = 0;
        for(let i = 0; i < numSamples; i++){
            samples.push(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(Math.cos(angle), Math.sin(angle)).multiplyScalar(Math.pow(radius, 0.75)));
            radius += radiusStep;
            angle += angleStep;
        }
        return samples;
    }
    setSize(width, height) {
        this.firstFrame();
        this.width = width;
        this.height = height;
        const c = this.configuration.halfRes ? 0.5 : 1;
        this.writeTargetInternal.setSize(width * c, height * c);
        this.readTargetInternal.setSize(width * c, height * c);
        this.accumulationRenderTarget.setSize(width * c, height * c);
        if (this.configuration.halfRes) this.depthDownsampleTarget.setSize(width * c, height * c);
        if (this.configuration.transparencyAware) {
            this.transparencyRenderTargetDWFalse.setSize(width, height);
            this.transparencyRenderTargetDWTrue.setSize(width, height);
        }
        this.outputTargetInternal.setSize(width, height);
    }
    setDepthTexture(depthTexture) {
        this.depthTexture = depthTexture;
    }
    firstFrame() {
        this.needsFrame = true;
    }
    render(renderer, inputBuffer, outputBuffer) {
        const xrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        // Copy inputBuffer to outputBuffer
        //renderer.setRenderTarget(outputBuffer);
        //  this.copyQuad.material.uniforms.tDiffuse.value = inputBuffer.texture;
        //   this.copyQuad.render(renderer);
        if (renderer.capabilities.logarithmicDepthBuffer && this.configuration.depthBufferType !== $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log || renderer.capabilities.reverseDepthBuffer && this.configuration.depthBufferType !== $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse) {
            this.configuration.depthBufferType = renderer.capabilities.logarithmicDepthBuffer ? $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log : renderer.capabilities.reverseDepthBuffer ? $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse : $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default;
            this.configureAOPass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
            this.configureDenoisePass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
            this.configureEffectCompositer(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
        }
        this.detectTransparency();
        if (inputBuffer.texture.type !== this.outputTargetInternal.texture.type || inputBuffer.texture.format !== this.outputTargetInternal.texture.format) {
            this.outputTargetInternal.texture.type = inputBuffer.texture.type;
            this.outputTargetInternal.texture.format = inputBuffer.texture.format;
            this.outputTargetInternal.texture.needsUpdate = true;
        }
        this.camera.updateMatrixWorld();
        if (this.lastViewMatrix.equals(this.camera.matrixWorldInverse) && this.lastProjectionMatrix.equals(this.camera.projectionMatrix) && this.configuration.accumulate && !this.needsFrame) this.frame++;
        else {
            if (this.configuration.accumulate) {
                renderer.setRenderTarget(this.accumulationRenderTarget);
                renderer.clear(true, true, true);
            }
            this.frame = 0;
            this.needsFrame = false;
        }
        this.lastViewMatrix.copy(this.camera.matrixWorldInverse);
        this.lastProjectionMatrix.copy(this.camera.projectionMatrix);
        let gl;
        let ext;
        let timerQuery;
        if (this.debugMode) {
            gl = renderer.getContext();
            ext = gl.getExtension("EXT_disjoint_timer_query_webgl2");
            if (ext === null) {
                console.error("EXT_disjoint_timer_query_webgl2 not available, disabling debug mode.");
                this.debugMode = false;
            }
        }
        if (this.debugMode) {
            timerQuery = gl.createQuery();
            gl.beginQuery(ext.TIME_ELAPSED_EXT, timerQuery);
        }
        if (this.configuration.transparencyAware) this.renderTransparency(renderer);
        this._r.set(this.width, this.height);
        let trueRadius = this.configuration.aoRadius;
        if (this.configuration.halfRes && this.configuration.screenSpaceRadius) trueRadius *= 0.5;
        if (this.frame < 1024 / this.configuration.aoSamples) {
            if (this.configuration.halfRes) {
                renderer.setRenderTarget(this.depthDownsampleTarget);
                this.depthDownsampleQuad.material.uniforms.sceneDepth.value = this.depthTexture;
                this.depthDownsampleQuad.material.uniforms.resolution.value = this._r;
                this.depthDownsampleQuad.material.uniforms["near"].value = this.camera.near;
                this.depthDownsampleQuad.material.uniforms["far"].value = this.camera.far;
                this.depthDownsampleQuad.material.uniforms["projectionMatrixInv"].value = this.camera.projectionMatrixInverse;
                this.depthDownsampleQuad.material.uniforms["viewMatrixInv"].value = this.camera.matrixWorld;
                this.depthDownsampleQuad.material.uniforms["logDepth"].value = this.configuration.logarithmicDepthBuffer;
                this.depthDownsampleQuad.material.uniforms["ortho"].value = this.camera.isOrthographicCamera;
                this.depthDownsampleQuad.render(renderer);
            }
            this.effectShaderQuad.material.uniforms["sceneDiffuse"].value = inputBuffer.texture;
            this.effectShaderQuad.material.uniforms["sceneDepth"].value = this.configuration.halfRes ? this.depthDownsampleTarget.textures[0] : this.depthTexture;
            this.effectShaderQuad.material.uniforms["sceneNormal"].value = this.configuration.halfRes ? this.depthDownsampleTarget.textures[1] : null;
            this.effectShaderQuad.material.uniforms["projMat"].value = this.camera.projectionMatrix;
            this.effectShaderQuad.material.uniforms["viewMat"].value = this.camera.matrixWorldInverse;
            this.effectShaderQuad.material.uniforms["projViewMat"].value = this.camera.projectionMatrix.clone().multiply(this.camera.matrixWorldInverse.clone());
            this.effectShaderQuad.material.uniforms["projectionMatrixInv"].value = this.camera.projectionMatrixInverse;
            this.effectShaderQuad.material.uniforms["viewMatrixInv"].value = this.camera.matrixWorld;
            this.effectShaderQuad.material.uniforms["cameraPos"].value = this.camera.getWorldPosition(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)());
            this.effectShaderQuad.material.uniforms["biasAdjustment"].value = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(this.configuration.biasOffset, this.configuration.biasMultiplier);
            this.effectShaderQuad.material.uniforms["resolution"].value = this.configuration.halfRes ? this._r.clone().multiplyScalar(0.5).floor() : this._r;
            this.effectShaderQuad.material.uniforms["time"].value = performance.now() / 1000;
            this.effectShaderQuad.material.uniforms["samples"].value = this.samples;
            this.effectShaderQuad.material.uniforms["bluenoise"].value = this.bluenoise;
            this.effectShaderQuad.material.uniforms["radius"].value = trueRadius;
            this.effectShaderQuad.material.uniforms["distanceFalloff"].value = this.configuration.distanceFalloff;
            this.effectShaderQuad.material.uniforms["near"].value = this.camera.near;
            this.effectShaderQuad.material.uniforms["far"].value = this.camera.far;
            this.effectShaderQuad.material.uniforms["ortho"].value = this.camera.isOrthographicCamera;
            this.effectShaderQuad.material.uniforms["screenSpaceRadius"].value = this.configuration.screenSpaceRadius;
            this.effectShaderQuad.material.uniforms["frame"].value = this.frame;
            // Start the AO
            renderer.setRenderTarget(this.writeTargetInternal);
            this.effectShaderQuad.render(renderer);
            // End the AO
            // Start the blur
            for(let i = 0; i < this.configuration.denoiseIterations; i++){
                [this.writeTargetInternal, this.readTargetInternal] = [
                    this.readTargetInternal,
                    this.writeTargetInternal
                ];
                this.poissonBlurQuad.material.uniforms["tDiffuse"].value = this.readTargetInternal.texture;
                this.poissonBlurQuad.material.uniforms["sceneDepth"].value = this.configuration.halfRes ? this.depthDownsampleTarget.textures[0] : this.depthTexture;
                this.poissonBlurQuad.material.uniforms["projMat"].value = this.camera.projectionMatrix;
                this.poissonBlurQuad.material.uniforms["viewMat"].value = this.camera.matrixWorldInverse;
                this.poissonBlurQuad.material.uniforms["projectionMatrixInv"].value = this.camera.projectionMatrixInverse;
                this.poissonBlurQuad.material.uniforms["viewMatrixInv"].value = this.camera.matrixWorld;
                this.poissonBlurQuad.material.uniforms["cameraPos"].value = this.camera.getWorldPosition(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)());
                this.poissonBlurQuad.material.uniforms["resolution"].value = this.configuration.halfRes ? this._r.clone().multiplyScalar(0.5).floor() : this._r;
                this.poissonBlurQuad.material.uniforms["time"].value = performance.now() / 1000;
                this.poissonBlurQuad.material.uniforms["blueNoise"].value = this.bluenoise;
                this.poissonBlurQuad.material.uniforms["radius"].value = this.configuration.denoiseRadius * (this.configuration.halfRes ? 0.5 : 1);
                this.poissonBlurQuad.material.uniforms["worldRadius"].value = trueRadius;
                this.poissonBlurQuad.material.uniforms["distanceFalloff"].value = this.configuration.distanceFalloff;
                this.poissonBlurQuad.material.uniforms["index"].value = i;
                this.poissonBlurQuad.material.uniforms["poissonDisk"].value = this.samplesDenoise;
                this.poissonBlurQuad.material.uniforms["near"].value = this.camera.near;
                this.poissonBlurQuad.material.uniforms["far"].value = this.camera.far;
                this.poissonBlurQuad.material.uniforms["screenSpaceRadius"].value = this.configuration.screenSpaceRadius;
                renderer.setRenderTarget(this.writeTargetInternal);
                this.poissonBlurQuad.render(renderer);
            }
            renderer.setRenderTarget(this.accumulationRenderTarget);
            const oldAutoClear = renderer.autoClear;
            renderer.autoClear = false;
            this.accumulationQuad.material.uniforms["tDiffuse"].value = this.writeTargetInternal.texture;
            this.accumulationQuad.material.uniforms["frame"].value = this.frame;
            this.accumulationQuad.render(renderer);
            renderer.autoClear = oldAutoClear;
        }
        // Now, we have the blurred AO in writeTargetInternal
        // End the blur
        // Start the composition
        if (this.configuration.transparencyAware) {
            this.effectCompositerQuad.material.uniforms["transparencyDWFalse"].value = this.transparencyRenderTargetDWFalse.texture;
            this.effectCompositerQuad.material.uniforms["transparencyDWTrue"].value = this.transparencyRenderTargetDWTrue.texture;
            this.effectCompositerQuad.material.uniforms["transparencyDWTrueDepth"].value = this.transparencyRenderTargetDWTrue.depthTexture;
            this.effectCompositerQuad.material.uniforms["transparencyAware"].value = true;
        }
        this.effectCompositerQuad.material.uniforms["sceneDiffuse"].value = inputBuffer.texture;
        this.effectCompositerQuad.material.uniforms["sceneDepth"].value = this.depthTexture;
        this.effectCompositerQuad.material.uniforms["aoTones"].value = this.configuration.aoTones;
        this.effectCompositerQuad.material.uniforms["near"].value = this.camera.near;
        this.effectCompositerQuad.material.uniforms["far"].value = this.camera.far;
        this.effectCompositerQuad.material.uniforms["projectionMatrixInv"].value = this.camera.projectionMatrixInverse;
        this.effectCompositerQuad.material.uniforms["viewMatrixInv"].value = this.camera.matrixWorld;
        this.effectCompositerQuad.material.uniforms["ortho"].value = this.camera.isOrthographicCamera;
        this.effectCompositerQuad.material.uniforms["downsampledDepth"].value = this.configuration.halfRes ? this.depthDownsampleTarget.textures[0] : this.depthTexture;
        this.effectCompositerQuad.material.uniforms["resolution"].value = this._r;
        this.effectCompositerQuad.material.uniforms["blueNoise"].value = this.bluenoise;
        this.effectCompositerQuad.material.uniforms["intensity"].value = this.configuration.intensity;
        this.effectCompositerQuad.material.uniforms["renderMode"].value = this.configuration.renderMode;
        this.effectCompositerQuad.material.uniforms["screenSpaceRadius"].value = this.configuration.screenSpaceRadius;
        this.effectCompositerQuad.material.uniforms["radius"].value = trueRadius;
        this.effectCompositerQuad.material.uniforms["distanceFalloff"].value = this.configuration.distanceFalloff;
        this.effectCompositerQuad.material.uniforms["gammaCorrection"].value = this.autosetGamma ? this.renderToScreen : this.configuration.gammaCorrection;
        this.effectCompositerQuad.material.uniforms["tDiffuse"].value = this.accumulationRenderTarget.texture;
        this.effectCompositerQuad.material.uniforms["color"].value = this._c.copy(this.configuration.color).convertSRGBToLinear();
        this.effectCompositerQuad.material.uniforms["colorMultiply"].value = this.configuration.colorMultiply;
        this.effectCompositerQuad.material.uniforms["cameraPos"].value = this.camera.getWorldPosition(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)());
        this.effectCompositerQuad.material.uniforms["fog"].value = !!this.scene.fog;
        if (this.scene.fog) {
            if (this.scene.fog.isFog) {
                this.effectCompositerQuad.material.uniforms["fogExp"].value = false;
                this.effectCompositerQuad.material.uniforms["fogNear"].value = this.scene.fog.near;
                this.effectCompositerQuad.material.uniforms["fogFar"].value = this.scene.fog.far;
            } else if (this.scene.fog.isFogExp2) {
                this.effectCompositerQuad.material.uniforms["fogExp"].value = true;
                this.effectCompositerQuad.material.uniforms["fogDensity"].value = this.scene.fog.density;
            } else console.error(`Unsupported fog type ${this.scene.fog.constructor.name} in SSAOPass.`);
        }
        renderer.setRenderTarget(/* this.renderToScreen ? null :
                 outputBuffer*/ this.outputTargetInternal);
        this.effectCompositerQuad.render(renderer);
        renderer.setRenderTarget(this.renderToScreen ? null : outputBuffer);
        this.copyQuad.material.uniforms["tDiffuse"].value = this.outputTargetInternal.texture;
        this.copyQuad.render(renderer);
        if (this.debugMode) {
            gl.endQuery(ext.TIME_ELAPSED_EXT);
            $51c5c49040a59a26$var$$87431ee93b037844$var$checkTimerQuery(timerQuery, gl, this);
        }
        renderer.xr.enabled = xrEnabled;
    }
    /**
         * Enables the debug mode of the AO, meaning the lastTime value will be updated.
         */ enableDebugMode() {
        this.debugMode = true;
    }
    /**
         * Disables the debug mode of the AO, meaning the lastTime value will not be updated.
         */ disableDebugMode() {
        this.debugMode = false;
    }
    /**
         * Sets the display mode of the AO
         * @param {"Combined" | "AO" | "No AO" | "Split" | "Split AO"} mode - The display mode. 
         */ setDisplayMode(mode) {
        this.configuration.renderMode = [
            "Combined",
            "AO",
            "No AO",
            "Split",
            "Split AO"
        ].indexOf(mode);
    }
    /**
         * 
         * @param {"Performance" | "Low" | "Medium" | "High" | "Ultra"} mode 
         */ setQualityMode(mode) {
        if (mode === "Performance") {
            this.configuration.aoSamples = 8;
            this.configuration.denoiseSamples = 4;
            this.configuration.denoiseRadius = 12;
        } else if (mode === "Low") {
            this.configuration.aoSamples = 16;
            this.configuration.denoiseSamples = 4;
            this.configuration.denoiseRadius = 12;
        } else if (mode === "Medium") {
            this.configuration.aoSamples = 16;
            this.configuration.denoiseSamples = 8;
            this.configuration.denoiseRadius = 12;
        } else if (mode === "High") {
            this.configuration.aoSamples = 64;
            this.configuration.denoiseSamples = 8;
            this.configuration.denoiseRadius = 6;
        } else if (mode === "Ultra") {
            this.configuration.aoSamples = 64;
            this.configuration.denoiseSamples = 16;
            this.configuration.denoiseRadius = 6;
        }
    }
}
/**
 * 
 * @param {*} timerQuery 
 * @param {THREE.WebGLRenderer} gl 
 * @param {N8AOPass} pass 
 */ function $51c5c49040a59a26$var$$05f6997e4b65da14$var$checkTimerQuery(timerQuery, gl, pass) {
    const available = gl.getQueryParameter(timerQuery, gl.QUERY_RESULT_AVAILABLE);
    if (available) {
        const elapsedTimeInNs = gl.getQueryParameter(timerQuery, gl.QUERY_RESULT);
        const elapsedTimeInMs = elapsedTimeInNs / 1000000;
        pass.lastTime = pass.lastTime === 0 ? elapsedTimeInMs : pass.timeRollingAverage * pass.lastTime + (1 - pass.timeRollingAverage) * elapsedTimeInMs;
    } else setTimeout(()=>{
        $51c5c49040a59a26$var$$05f6997e4b65da14$var$checkTimerQuery(timerQuery, gl, pass);
    }, 1);
}
const $51c5c49040a59a26$export$ed4ee5d1e55474a5 = {
    Default: 1,
    Log: 2,
    Reverse: 3
};
class $51c5c49040a59a26$export$2d57db20b5eb5e0a extends (0, $93b96f2f881ee758$export$802bc10488da99c7) {
    /**
     * 
     * @param {THREE.Scene} scene
     * @param {THREE.Camera} camera 
     * @param {number} width 
     * @param {number} height
     *  
     * @property {THREE.Scene} scene
     * @property {THREE.Camera} camera
     * @property {number} width
     * @property {number} height
     */ constructor(scene, camera, width = 512, height = 512){
        super();
        this.width = width;
        this.height = height;
        this.clear = true;
        this.camera = camera;
        this.scene = scene;
        /**
         * @type {Proxy & {
         * aoSamples: number,
         * aoRadius: number,
         * denoiseSamples: number,
         * denoiseRadius: number,
         * distanceFalloff: number,
         * intensity: number,
         * denoiseIterations: number,
         * renderMode: 0 | 1 | 2 | 3 | 4,
         * color: THREE.Color,
         * gammaCorrection: boolean,
         * depthBufferType: 1 | 2 | 3,
         * screenSpaceRadius: boolean,
         * halfRes: boolean,
         * depthAwareUpsampling: boolean,
         * autoRenderBeauty: boolean
         * colorMultiply: boolean
         * }
         */ this.configuration = new Proxy({
            aoSamples: 16,
            aoRadius: 5.0,
            aoTones: 0.0,
            denoiseSamples: 8,
            denoiseRadius: 12,
            distanceFalloff: 1.0,
            intensity: 5,
            denoiseIterations: 2.0,
            renderMode: 0,
            biasOffset: 0.0,
            biasMultiplier: 0.0,
            color: new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0, 0, 0),
            gammaCorrection: true,
            depthBufferType: $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default,
            screenSpaceRadius: false,
            halfRes: false,
            depthAwareUpsampling: true,
            autoRenderBeauty: true,
            colorMultiply: true,
            transparencyAware: false,
            stencil: false,
            accumulate: false
        }, {
            set: (target, propName, value)=>{
                const oldProp = target[propName];
                target[propName] = value;
                if (value.equals) {
                    if (!value.equals(oldProp)) this.firstFrame();
                } else if (oldProp !== value) this.firstFrame();
                if (propName === "aoSamples" && oldProp !== value) this.configureAOPass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                if (propName === "denoiseSamples" && oldProp !== value) this.configureDenoisePass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                if (propName === "halfRes" && oldProp !== value) {
                    this.configureAOPass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                    this.configureHalfResTargets();
                    this.configureEffectCompositer(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                    this.setSize(this.width, this.height);
                }
                if (propName === "depthAwareUpsampling" && oldProp !== value) this.configureEffectCompositer(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
                if (propName === "transparencyAware" && oldProp !== value) {
                    this.autoDetectTransparency = false;
                    this.configureTransparencyTarget();
                }
                if (propName === "stencil" && oldProp !== value) {
                    /*  this.beautyRenderTarget.stencilBuffer = value;
                      this.beautyRenderTarget.depthTexture.format = value ? THREE.DepthStencilFormat : THREE.DepthFormat;
                      this.beautyRenderTarget.depthTexture.type = value ? THREE.UnsignedInt248Type : THREE.UnsignedIntType;
                      this.beautyRenderTarget.depthTexture.needsUpdate = true;
                      this.beautyRenderTarget.needsUpdate = true;*/ this.beautyRenderTarget.dispose();
                    this.beautyRenderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
                        minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
                        magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
                        type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
                        format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c),
                        stencilBuffer: value
                    });
                    this.beautyRenderTarget.depthTexture = new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)(this.width, this.height, value ? (0, $ce0cdebec9150cb3$export$6c8ea339bfab1301) : (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96));
                    this.beautyRenderTarget.depthTexture.format = value ? (0, $ce0cdebec9150cb3$export$1e113ac2d0905829) : (0, $ce0cdebec9150cb3$export$c1b6b5136be58045);
                }
                return true;
            }
        });
        /** @type {THREE.Vector3[]} */ this.samples = [];
        /** @type {THREE.Vector2[]} */ this.samplesDenoise = [];
        this.autoDetectTransparency = true;
        this.frame = 0;
        this.lastViewMatrix = new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
        this.lastProjectionMatrix = new (0, $ce0cdebec9150cb3$export$2ae72fc923e5eb5)();
        this.beautyRenderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
            type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
            format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c),
            stencilBuffer: false
        });
        this.beautyRenderTarget.depthTexture = new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)(this.width, this.height, (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96));
        this.beautyRenderTarget.depthTexture.format = (0, $ce0cdebec9150cb3$export$c1b6b5136be58045);
        this.configureEffectCompositer(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
        this.configureSampleDependentPasses();
        this.configureHalfResTargets();
        this.detectTransparency();
        this.configureTransparencyTarget();
        this.writeTargetInternal = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            depthBuffer: false,
            format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)
        });
        this.readTargetInternal = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            depthBuffer: false,
            format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)
        });
        this.accumulationRenderTarget = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
            minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            magFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
            depthBuffer: false,
            format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c),
            type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
            stencilBuffer: false,
            depthBuffer: false,
            alpha: true
        });
        /** @type {THREE.DataTexture} */ this.bluenoise = new (0, $ce0cdebec9150cb3$export$b691f601014eabe1)($51c5c49040a59a26$var$$06269ad78f3c5fdf$export$2e2bcd8739ae039, 128, 128);
        this.accumulationQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
            uniforms: {
                frame: {
                    value: 0
                },
                tDiffuse: {
                    value: null
                }
            },
            transparent: true,
            opacity: 1,
            vertexShader: `
             varying vec2 vUv;
             void main() {
                 vUv = uv;
                 gl_Position = vec4(position, 1);
             }`,
            fragmentShader: `
             uniform sampler2D tDiffuse;
             uniform float frame;
                varying vec2 vUv;
                void main() {
                    vec4 color = texture2D(tDiffuse, vUv);
                    gl_FragColor = vec4(color.rgb, 1.0 / (frame + 1.0));
                }
                `
        }));
        this.bluenoise.colorSpace = (0, $ce0cdebec9150cb3$export$bfcb490c2dd3db51);
        this.bluenoise.wrapS = (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5);
        this.bluenoise.wrapT = (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5);
        this.bluenoise.minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
        this.bluenoise.magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
        this.bluenoise.needsUpdate = true;
        this.lastTime = 0;
        this.timeRollingAverage = 0.99;
        this._r = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)();
        this._c = new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)();
    }
    configureHalfResTargets() {
        this.firstFrame();
        if (this.configuration.halfRes) {
            this.depthDownsampleTarget = new $51c5c49040a59a26$var$$ff9437d9c7577f11$export$156f6a58f569aa09(this.width / 2, this.height / 2, 2);
            if ((0, $ce0cdebec9150cb3$export$3545e07a80636437) <= 161) this.depthDownsampleTarget.textures = this.depthDownsampleTarget.texture;
            this.depthDownsampleTarget.textures[0].format = (0, $ce0cdebec9150cb3$export$4e041a7967d15c4b);
            this.depthDownsampleTarget.textures[0].type = (0, $ce0cdebec9150cb3$export$f6d331659b644596);
            this.depthDownsampleTarget.textures[0].minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            this.depthDownsampleTarget.textures[0].magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            this.depthDownsampleTarget.textures[0].depthBuffer = false;
            this.depthDownsampleTarget.textures[1].format = (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c);
            this.depthDownsampleTarget.textures[1].type = (0, $ce0cdebec9150cb3$export$2697304443f382bc);
            this.depthDownsampleTarget.textures[1].minFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            this.depthDownsampleTarget.textures[1].magFilter = (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0);
            this.depthDownsampleTarget.textures[1].depthBuffer = false;
            const e = {
                ...$51c5c49040a59a26$var$$26aca173e0984d99$export$1efdf491687cd442
            };
            if (this.configuration.depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse) e.fragmentShader = "#define REVERSEDEPTH\n" + e.fragmentShader;
            this.depthDownsampleQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(e));
        } else {
            if (this.depthDownsampleTarget) {
                this.depthDownsampleTarget.dispose();
                this.depthDownsampleTarget = null;
            }
            if (this.depthDownsampleQuad) {
                this.depthDownsampleQuad.dispose();
                this.depthDownsampleQuad = null;
            }
        }
    }
    detectTransparency() {
        if (this.autoDetectTransparency) {
            let isTransparency = false;
            this.scene.traverse((obj)=>{
                if (obj.material && obj.material.transparent) isTransparency = true;
            });
            this.configuration.transparencyAware = isTransparency;
        }
    }
    configureTransparencyTarget() {
        if (this.configuration.transparencyAware) {
            this.transparencyRenderTargetDWFalse = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
                minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
                magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
                type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
                format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)
            });
            this.transparencyRenderTargetDWTrue = new (0, $ce0cdebec9150cb3$export$3c052beb2e51e23f)(this.width, this.height, {
                minFilter: (0, $ce0cdebec9150cb3$export$8a72f490b25c56c8),
                magFilter: (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0),
                type: (0, $ce0cdebec9150cb3$export$2697304443f382bc),
                format: (0, $ce0cdebec9150cb3$export$3f8bb04b555a363c)
            });
            this.transparencyRenderTargetDWTrue.depthTexture = new (0, $ce0cdebec9150cb3$export$fc830aa069cc8c2f)(this.width, this.height, (0, $ce0cdebec9150cb3$export$c3c7fc4518ebba96));
            this.depthCopyPass = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)({
                uniforms: {
                    depthTexture: {
                        value: this.depthTexture
                    },
                    reverseDepthBuffer: {
                        value: this.configuration.depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse
                    }
                },
                vertexShader: /* glsl */ `
                        varying vec2 vUv;
                        void main() {
                            vUv = uv;
                            gl_Position = vec4(position, 1);
                        }`,
                fragmentShader: /* glsl */ `
                        uniform sampler2D depthTexture;
                        uniform bool reverseDepthBuffer;
                        varying vec2 vUv;
                        void main() {
                            if (reverseDepthBuffer) {
                           float d = 1.0 - texture2D(depthTexture, vUv).r;
                       
                           d += 0.00001;
                           gl_FragDepth = 1.0 - d;
                        } else {
                            float d = texture2D(depthTexture, vUv).r;
                            d += 0.00001;
                            gl_FragDepth = d;
                        }
                           gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
                        }
                        `
            }));
        } else {
            if (this.transparencyRenderTargetDWFalse) {
                this.transparencyRenderTargetDWFalse.dispose();
                this.transparencyRenderTargetDWFalse = null;
            }
            if (this.transparencyRenderTargetDWTrue) {
                this.transparencyRenderTargetDWTrue.dispose();
                this.transparencyRenderTargetDWTrue = null;
            }
            if (this.depthCopyPass) {
                this.depthCopyPass.dispose();
                this.depthCopyPass = null;
            }
        }
    }
    renderTransparency(renderer) {
        const oldBackground = this.scene.background;
        const oldClearColor = renderer.getClearColor(new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)());
        const oldClearAlpha = renderer.getClearAlpha();
        const oldVisibility = new Map();
        const oldAutoClearDepth = renderer.autoClearDepth;
        this.scene.traverse((obj)=>{
            oldVisibility.set(obj, obj.visible);
        });
        // Override the state
        this.scene.background = null;
        renderer.autoClearDepth = false;
        renderer.setClearColor(new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(0, 0, 0), 0);
        this.depthCopyPass.material.uniforms.depthTexture.value = this.beautyRenderTarget.depthTexture;
        this.depthCopyPass.material.uniforms.reverseDepthBuffer.value = this.configuration.depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse;
        // Render out transparent objects WITHOUT depth write
        renderer.setRenderTarget(this.transparencyRenderTargetDWFalse);
        this.scene.traverse((obj)=>{
            if (obj.material) obj.visible = oldVisibility.get(obj) && (obj.material.transparent && !obj.material.depthWrite && !obj.userData.treatAsOpaque || !!obj.userData.cannotReceiveAO);
        });
        renderer.clear(true, true, true);
        this.depthCopyPass.render(renderer);
        renderer.render(this.scene, this.camera);
        // Render out transparent objects WITH depth write
        renderer.setRenderTarget(this.transparencyRenderTargetDWTrue);
        this.scene.traverse((obj)=>{
            if (obj.material) obj.visible = oldVisibility.get(obj) && obj.material.transparent && obj.material.depthWrite && !obj.userData.treatAsOpaque;
        });
        renderer.clear(true, true, true);
        this.depthCopyPass.render(renderer);
        renderer.render(this.scene, this.camera);
        // Restore
        this.scene.traverse((obj)=>{
            obj.visible = oldVisibility.get(obj);
        });
        renderer.setClearColor(oldClearColor, oldClearAlpha);
        this.scene.background = oldBackground;
        renderer.autoClearDepth = oldAutoClearDepth;
    }
    configureSampleDependentPasses() {
        this.firstFrame();
        this.configureAOPass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
        this.configureDenoisePass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
    }
    configureAOPass(depthBufferType = $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default, ortho = false) {
        this.firstFrame();
        this.samples = this.generateHemisphereSamples(this.configuration.aoSamples);
        const e = {
            ...$51c5c49040a59a26$var$$1ed45968c1160c3c$export$c9b263b9a17dffd7
        };
        e.fragmentShader = e.fragmentShader.replace("16", this.configuration.aoSamples).replace("16.0", this.configuration.aoSamples + ".0");
        if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log) e.fragmentShader = "#define LOGDEPTH\n" + e.fragmentShader;
        else if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse) e.fragmentShader = "#define REVERSEDEPTH\n" + e.fragmentShader;
        if (ortho) e.fragmentShader = "#define ORTHO\n" + e.fragmentShader;
        if (this.configuration.halfRes) e.fragmentShader = "#define HALFRES\n" + e.fragmentShader;
        if (this.effectShaderQuad) {
            this.effectShaderQuad.material.dispose();
            this.effectShaderQuad.material = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(e);
        } else this.effectShaderQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(e));
    }
    configureDenoisePass(depthBufferType = $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default, ortho = false) {
        this.firstFrame();
        this.samplesDenoise = this.generateDenoiseSamples(this.configuration.denoiseSamples, 11);
        const p = {
            ...$51c5c49040a59a26$var$$e52378cd0f5a973d$export$57856b59f317262e
        };
        p.fragmentShader = p.fragmentShader.replace("16", this.configuration.denoiseSamples);
        if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log) p.fragmentShader = "#define LOGDEPTH\n" + p.fragmentShader;
        else if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse) p.fragmentShader = "#define REVERSEDEPTH\n" + p.fragmentShader;
        if (ortho) p.fragmentShader = "#define ORTHO\n" + p.fragmentShader;
        if (this.poissonBlurQuad) {
            this.poissonBlurQuad.material.dispose();
            this.poissonBlurQuad.material = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(p);
        } else this.poissonBlurQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(p));
    }
    configureEffectCompositer(depthBufferType = $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default, ortho = false) {
        this.firstFrame();
        const e = {
            ...$51c5c49040a59a26$var$$12b21d24d1192a04$export$a815acccbd2c9a49
        };
        if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log) e.fragmentShader = "#define LOGDEPTH\n" + e.fragmentShader;
        else if (depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse) e.fragmentShader = "#define REVERSEDEPTH\n" + e.fragmentShader;
        if (ortho) e.fragmentShader = "#define ORTHO\n" + e.fragmentShader;
        if (this.configuration.halfRes && this.configuration.depthAwareUpsampling) e.fragmentShader = "#define HALFRES\n" + e.fragmentShader;
        if (this.effectCompositerQuad) {
            this.effectCompositerQuad.material.dispose();
            this.effectCompositerQuad.material = new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(e);
        } else this.effectCompositerQuad = new $51c5c49040a59a26$var$$e4ca8dcb0218f846$export$dcd670d73db751f5(new (0, $ce0cdebec9150cb3$export$83c7d75d550a8b0d)(e));
    }
    /**
         * 
         * @param {Number} n 
         * @returns {THREE.Vector3[]}
         */ generateHemisphereSamples(n) {
        const points = [];
        for(let k = 0; k < n; k++){
            const theta = 2.399963 * k;
            let r = Math.sqrt(k + 0.5) / Math.sqrt(n);
            const x = r * Math.cos(theta);
            const y = r * Math.sin(theta);
            // Project to hemisphere
            const z = Math.sqrt(1 - (x * x + y * y));
            points.push(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)(x, y, z));
        }
        return points;
    }
    /**
         * 
         * @param {number} numSamples 
         * @param {number} numRings 
         * @returns {THREE.Vector2[]}
         */ generateDenoiseSamples(numSamples, numRings) {
        const angleStep = 2 * Math.PI * numRings / numSamples;
        const invNumSamples = 1.0 / numSamples;
        const radiusStep = invNumSamples;
        const samples = [];
        let radius = invNumSamples;
        let angle = 0;
        for(let i = 0; i < numSamples; i++){
            samples.push(new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(Math.cos(angle), Math.sin(angle)).multiplyScalar(Math.pow(radius, 0.75)));
            radius += radiusStep;
            angle += angleStep;
        }
        return samples;
    }
    setSize(width, height) {
        this.firstFrame();
        this.width = width;
        this.height = height;
        const c = this.configuration.halfRes ? 0.5 : 1;
        this.beautyRenderTarget.setSize(width, height);
        this.writeTargetInternal.setSize(width * c, height * c);
        this.readTargetInternal.setSize(width * c, height * c);
        this.accumulationRenderTarget.setSize(width * c, height * c);
        if (this.configuration.halfRes) this.depthDownsampleTarget.setSize(width * c, height * c);
        if (this.configuration.transparencyAware) {
            this.transparencyRenderTargetDWFalse.setSize(width, height);
            this.transparencyRenderTargetDWTrue.setSize(width, height);
        }
    }
    firstFrame() {
        this.needsFrame = true;
    }
    render(renderer, writeBuffer, readBuffer, deltaTime, maskActive) {
        if (renderer.capabilities.logarithmicDepthBuffer && this.configuration.depthBufferType !== $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log || renderer.capabilities.reverseDepthBuffer && this.configuration.depthBufferType !== $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse) {
            this.configuration.depthBufferType = renderer.capabilities.logarithmicDepthBuffer ? $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log : renderer.capabilities.reverseDepthBuffer ? $51c5c49040a59a26$export$ed4ee5d1e55474a5.Reverse : $51c5c49040a59a26$export$ed4ee5d1e55474a5.Default;
            this.configureAOPass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
            this.configureDenoisePass(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
            this.configureEffectCompositer(this.configuration.depthBufferType, this.camera.isOrthographicCamera);
        }
        this.detectTransparency();
        this.camera.updateMatrixWorld();
        if (this.lastViewMatrix.equals(this.camera.matrixWorldInverse) && this.lastProjectionMatrix.equals(this.camera.projectionMatrix) && this.configuration.accumulate && !this.needsFrame) this.frame++;
        else {
            if (this.configuration.accumulate) {
                renderer.setRenderTarget(this.accumulationRenderTarget);
                renderer.clear(true, true, true);
            }
            this.frame = 0;
            this.needsFrame = false;
        }
        this.lastViewMatrix.copy(this.camera.matrixWorldInverse);
        this.lastProjectionMatrix.copy(this.camera.projectionMatrix);
        let gl;
        let ext;
        let timerQuery;
        if (this.debugMode) {
            gl = renderer.getContext();
            ext = gl.getExtension("EXT_disjoint_timer_query_webgl2");
            if (ext === null) {
                console.error("EXT_disjoint_timer_query_webgl2 not available, disabling debug mode.");
                this.debugMode = false;
            }
        }
        if (this.configuration.autoRenderBeauty) {
            renderer.setRenderTarget(this.beautyRenderTarget);
            renderer.render(this.scene, this.camera);
            if (this.configuration.transparencyAware) this.renderTransparency(renderer);
        }
        if (this.debugMode) {
            timerQuery = gl.createQuery();
            gl.beginQuery(ext.TIME_ELAPSED_EXT, timerQuery);
        }
        const xrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        this._r.set(this.width, this.height);
        let trueRadius = this.configuration.aoRadius;
        if (this.configuration.halfRes && this.configuration.screenSpaceRadius) trueRadius *= 0.5;
        if (this.frame < 1024 / this.configuration.aoSamples) {
            if (this.configuration.halfRes) {
                renderer.setRenderTarget(this.depthDownsampleTarget);
                this.depthDownsampleQuad.material.uniforms.sceneDepth.value = this.beautyRenderTarget.depthTexture;
                this.depthDownsampleQuad.material.uniforms.resolution.value = this._r;
                this.depthDownsampleQuad.material.uniforms["near"].value = this.camera.near;
                this.depthDownsampleQuad.material.uniforms["far"].value = this.camera.far;
                this.depthDownsampleQuad.material.uniforms["projectionMatrixInv"].value = this.camera.projectionMatrixInverse;
                this.depthDownsampleQuad.material.uniforms["viewMatrixInv"].value = this.camera.matrixWorld;
                this.depthDownsampleQuad.material.uniforms["logDepth"].value = this.configuration.depthBufferType === $51c5c49040a59a26$export$ed4ee5d1e55474a5.Log;
                this.depthDownsampleQuad.material.uniforms["ortho"].value = this.camera.isOrthographicCamera;
                this.depthDownsampleQuad.render(renderer);
            }
            this.effectShaderQuad.material.uniforms["sceneDiffuse"].value = this.beautyRenderTarget.texture;
            this.effectShaderQuad.material.uniforms["sceneDepth"].value = this.configuration.halfRes ? this.depthDownsampleTarget.textures[0] : this.beautyRenderTarget.depthTexture;
            this.effectShaderQuad.material.uniforms["sceneNormal"].value = this.configuration.halfRes ? this.depthDownsampleTarget.textures[1] : null;
            this.effectShaderQuad.material.uniforms["projMat"].value = this.camera.projectionMatrix;
            this.effectShaderQuad.material.uniforms["viewMat"].value = this.camera.matrixWorldInverse;
            this.effectShaderQuad.material.uniforms["projViewMat"].value = this.camera.projectionMatrix.clone().multiply(this.camera.matrixWorldInverse.clone());
            this.effectShaderQuad.material.uniforms["projectionMatrixInv"].value = this.camera.projectionMatrixInverse;
            this.effectShaderQuad.material.uniforms["viewMatrixInv"].value = this.camera.matrixWorld;
            this.effectShaderQuad.material.uniforms["cameraPos"].value = this.camera.getWorldPosition(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)());
            this.effectShaderQuad.material.uniforms["biasAdjustment"].value = new (0, $ce0cdebec9150cb3$export$c977b3e384af9ae1)(this.configuration.biasOffset, this.configuration.biasMultiplier);
            this.effectShaderQuad.material.uniforms["resolution"].value = this.configuration.halfRes ? this._r.clone().multiplyScalar(0.5).floor() : this._r;
            this.effectShaderQuad.material.uniforms["time"].value = performance.now() / 1000;
            this.effectShaderQuad.material.uniforms["samples"].value = this.samples;
            this.effectShaderQuad.material.uniforms["bluenoise"].value = this.bluenoise;
            this.effectShaderQuad.material.uniforms["radius"].value = trueRadius;
            this.effectShaderQuad.material.uniforms["distanceFalloff"].value = this.configuration.distanceFalloff;
            this.effectShaderQuad.material.uniforms["near"].value = this.camera.near;
            this.effectShaderQuad.material.uniforms["far"].value = this.camera.far;
            this.effectShaderQuad.material.uniforms["ortho"].value = this.camera.isOrthographicCamera;
            this.effectShaderQuad.material.uniforms["screenSpaceRadius"].value = this.configuration.screenSpaceRadius;
            this.effectShaderQuad.material.uniforms["frame"].value = this.frame;
            // Start the AO
            renderer.setRenderTarget(this.writeTargetInternal);
            this.effectShaderQuad.render(renderer);
            // End the AO
            // Start the blur
            for(let i = 0; i < this.configuration.denoiseIterations; i++){
                [this.writeTargetInternal, this.readTargetInternal] = [
                    this.readTargetInternal,
                    this.writeTargetInternal
                ];
                this.poissonBlurQuad.material.uniforms["tDiffuse"].value = this.readTargetInternal.texture;
                this.poissonBlurQuad.material.uniforms["sceneDepth"].value = this.configuration.halfRes ? this.depthDownsampleTarget.textures[0] : this.beautyRenderTarget.depthTexture;
                this.poissonBlurQuad.material.uniforms["projMat"].value = this.camera.projectionMatrix;
                this.poissonBlurQuad.material.uniforms["viewMat"].value = this.camera.matrixWorldInverse;
                this.poissonBlurQuad.material.uniforms["projectionMatrixInv"].value = this.camera.projectionMatrixInverse;
                this.poissonBlurQuad.material.uniforms["viewMatrixInv"].value = this.camera.matrixWorld;
                this.poissonBlurQuad.material.uniforms["cameraPos"].value = this.camera.getWorldPosition(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)());
                this.poissonBlurQuad.material.uniforms["resolution"].value = this.configuration.halfRes ? this._r.clone().multiplyScalar(0.5).floor() : this._r;
                this.poissonBlurQuad.material.uniforms["time"].value = performance.now() / 1000;
                this.poissonBlurQuad.material.uniforms["blueNoise"].value = this.bluenoise;
                this.poissonBlurQuad.material.uniforms["radius"].value = this.configuration.denoiseRadius * (this.configuration.halfRes ? 0.5 : 1);
                this.poissonBlurQuad.material.uniforms["worldRadius"].value = trueRadius;
                this.poissonBlurQuad.material.uniforms["distanceFalloff"].value = this.configuration.distanceFalloff;
                this.poissonBlurQuad.material.uniforms["index"].value = i;
                this.poissonBlurQuad.material.uniforms["poissonDisk"].value = this.samplesDenoise;
                this.poissonBlurQuad.material.uniforms["near"].value = this.camera.near;
                this.poissonBlurQuad.material.uniforms["far"].value = this.camera.far;
                this.poissonBlurQuad.material.uniforms["screenSpaceRadius"].value = this.configuration.screenSpaceRadius;
                renderer.setRenderTarget(this.writeTargetInternal);
                this.poissonBlurQuad.render(renderer);
            }
            renderer.setRenderTarget(this.accumulationRenderTarget);
            const oldAutoClear = renderer.autoClear;
            renderer.autoClear = false;
            this.accumulationQuad.material.uniforms["tDiffuse"].value = this.writeTargetInternal.texture;
            this.accumulationQuad.material.uniforms["frame"].value = this.frame;
            this.accumulationQuad.render(renderer);
            renderer.autoClear = oldAutoClear;
        }
        // Now, we have the blurred AO in writeTargetInternal
        // End the blur
        // Start the composition
        if (this.configuration.transparencyAware) {
            this.effectCompositerQuad.material.uniforms["transparencyDWFalse"].value = this.transparencyRenderTargetDWFalse.texture;
            this.effectCompositerQuad.material.uniforms["transparencyDWTrue"].value = this.transparencyRenderTargetDWTrue.texture;
            this.effectCompositerQuad.material.uniforms["transparencyDWTrueDepth"].value = this.transparencyRenderTargetDWTrue.depthTexture;
            this.effectCompositerQuad.material.uniforms["transparencyAware"].value = true;
        }
        this.effectCompositerQuad.material.uniforms["sceneDiffuse"].value = this.beautyRenderTarget.texture;
        this.effectCompositerQuad.material.uniforms["sceneDepth"].value = this.beautyRenderTarget.depthTexture;
        this.effectCompositerQuad.material.uniforms["aoTones"].value = this.configuration.aoTones;
        this.effectCompositerQuad.material.uniforms["near"].value = this.camera.near;
        this.effectCompositerQuad.material.uniforms["far"].value = this.camera.far;
        this.effectCompositerQuad.material.uniforms["projectionMatrixInv"].value = this.camera.projectionMatrixInverse;
        this.effectCompositerQuad.material.uniforms["viewMatrixInv"].value = this.camera.matrixWorld;
        this.effectCompositerQuad.material.uniforms["ortho"].value = this.camera.isOrthographicCamera;
        this.effectCompositerQuad.material.uniforms["downsampledDepth"].value = this.configuration.halfRes ? this.depthDownsampleTarget.textures[0] : this.beautyRenderTarget.depthTexture;
        this.effectCompositerQuad.material.uniforms["resolution"].value = this._r;
        this.effectCompositerQuad.material.uniforms["blueNoise"].value = this.bluenoise;
        this.effectCompositerQuad.material.uniforms["intensity"].value = this.configuration.intensity;
        this.effectCompositerQuad.material.uniforms["renderMode"].value = this.configuration.renderMode;
        this.effectCompositerQuad.material.uniforms["screenSpaceRadius"].value = this.configuration.screenSpaceRadius;
        this.effectCompositerQuad.material.uniforms["radius"].value = trueRadius;
        this.effectCompositerQuad.material.uniforms["distanceFalloff"].value = this.configuration.distanceFalloff;
        this.effectCompositerQuad.material.uniforms["gammaCorrection"].value = this.configuration.gammaCorrection;
        this.effectCompositerQuad.material.uniforms["tDiffuse"].value = this.accumulationRenderTarget.texture;
        this.effectCompositerQuad.material.uniforms["color"].value = this._c.copy(this.configuration.color).convertSRGBToLinear();
        this.effectCompositerQuad.material.uniforms["colorMultiply"].value = this.configuration.colorMultiply;
        this.effectCompositerQuad.material.uniforms["cameraPos"].value = this.camera.getWorldPosition(new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)());
        this.effectCompositerQuad.material.uniforms["fog"].value = !!this.scene.fog;
        if (this.scene.fog) {
            if (this.scene.fog.isFog) {
                this.effectCompositerQuad.material.uniforms["fogExp"].value = false;
                this.effectCompositerQuad.material.uniforms["fogNear"].value = this.scene.fog.near;
                this.effectCompositerQuad.material.uniforms["fogFar"].value = this.scene.fog.far;
            } else if (this.scene.fog.isFogExp2) {
                this.effectCompositerQuad.material.uniforms["fogExp"].value = true;
                this.effectCompositerQuad.material.uniforms["fogDensity"].value = this.scene.fog.density;
            } else console.error(`Unsupported fog type ${this.scene.fog.constructor.name} in SSAOPass.`);
        }
        renderer.setRenderTarget(this.renderToScreen ? null : writeBuffer);
        this.effectCompositerQuad.render(renderer);
        if (this.debugMode) {
            gl.endQuery(ext.TIME_ELAPSED_EXT);
            $51c5c49040a59a26$var$$05f6997e4b65da14$var$checkTimerQuery(timerQuery, gl, this);
        }
        renderer.xr.enabled = xrEnabled;
    }
    /**
         * Enables the debug mode of the AO, meaning the lastTime value will be updated.
         */ enableDebugMode() {
        this.debugMode = true;
    }
    /**
         * Disables the debug mode of the AO, meaning the lastTime value will not be updated.
         */ disableDebugMode() {
        this.debugMode = false;
    }
    /**
         * Sets the display mode of the AO
         * @param {"Combined" | "AO" | "No AO" | "Split" | "Split AO"} mode - The display mode. 
         */ setDisplayMode(mode) {
        this.configuration.renderMode = [
            "Combined",
            "AO",
            "No AO",
            "Split",
            "Split AO"
        ].indexOf(mode);
    }
    /**
         * 
         * @param {"Performance" | "Low" | "Medium" | "High" | "Ultra"} mode 
         */ setQualityMode(mode) {
        if (mode === "Performance") {
            this.configuration.aoSamples = 8;
            this.configuration.denoiseSamples = 4;
            this.configuration.denoiseRadius = 12;
        } else if (mode === "Low") {
            this.configuration.aoSamples = 16;
            this.configuration.denoiseSamples = 4;
            this.configuration.denoiseRadius = 12;
        } else if (mode === "Medium") {
            this.configuration.aoSamples = 16;
            this.configuration.denoiseSamples = 8;
            this.configuration.denoiseRadius = 12;
        } else if (mode === "High") {
            this.configuration.aoSamples = 64;
            this.configuration.denoiseSamples = 8;
            this.configuration.denoiseRadius = 6;
        } else if (mode === "Ultra") {
            this.configuration.aoSamples = 64;
            this.configuration.denoiseSamples = 16;
            this.configuration.denoiseRadius = 6;
        }
    }
}


const $7c8119e0ee165095$export$589fe5e500e6a125 = /*@__PURE__*/ (0, $2WGWz.createContext)(null);
function $7c8119e0ee165095$export$52baac22726c72bf({ children: e, enabled: t = !0 }) {
    const [o, r] = (0, $2WGWz.useState)([]), a = (0, $2WGWz.useMemo)(()=>({
            selected: o,
            select: r,
            enabled: t
        }), [
        o,
        r,
        t
    ]);
    return /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($7c8119e0ee165095$export$589fe5e500e6a125.Provider, {
        value: a,
        children: e
    });
}
function $7c8119e0ee165095$export$ef9b1a59e592288f({ enabled: e = !1, children: t, ...o }) {
    const r = (0, $2WGWz.useRef)(null), a = (0, $2WGWz.useContext)($7c8119e0ee165095$export$589fe5e500e6a125);
    return (0, $2WGWz.useEffect)(()=>{
        if (a && e) {
            let n = !1;
            const i = [];
            if (r.current.traverse((s)=>{
                s.type === "Mesh" && i.push(s), a.selected.indexOf(s) === -1 && (n = !0);
            }), n) return a.select((s)=>[
                    ...s,
                    ...i
                ]), ()=>{
                a.select((s)=>s.filter((l)=>!i.includes(l)));
            };
        }
    }, [
        e,
        t,
        a
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("group", {
        ref: r,
        ...o,
        children: t
    });
}
const $7c8119e0ee165095$export$62f16d743a4a34a4 = /*@__PURE__*/ (0, $2WGWz.createContext)(null), $7c8119e0ee165095$var$ie = (e)=>(e.getAttributes() & 2) === 2, $7c8119e0ee165095$export$7fe01e6ab8aa748c = /*@__PURE__*/ (0, $2WGWz.memo)(/*@__PURE__*/ (0, $2WGWz.forwardRef)(({ children: e, camera: t, scene: o, resolutionScale: r, enabled: a = !0, renderPriority: n = 1, autoClear: i = !0, depthBuffer: s, enableNormalPass: l, stencilBuffer: p, multisampling: _ = 8, frameBufferType: S = (0, $ce0cdebec9150cb3$export$2697304443f382bc) }, g)=>{
    const { gl: d, scene: m, camera: v, size: x } = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)(), f = o || m, u = t || v, [c, U, b] = (0, $2WGWz.useMemo)(()=>{
        const C = new (0, $2046da3312f94030$export$7fe01e6ab8aa748c)(d, {
            depthBuffer: s,
            stencilBuffer: p,
            multisampling: _,
            frameBufferType: S
        });
        C.addPass(new (0, $2046da3312f94030$export$f63ea822f020b5b0)(f, u));
        let R = null, E = null;
        return l && (E = new (0, $2046da3312f94030$export$68bd776dda9a43a9)(f, u), E.enabled = !1, C.addPass(E), r !== void 0 && (R = new (0, $2046da3312f94030$export$eb8020324d924933)({
            normalBuffer: E.texture,
            resolutionScale: r
        }), R.enabled = !1, C.addPass(R))), [
            C,
            E,
            R
        ];
    }, [
        u,
        d,
        s,
        p,
        _,
        S,
        f,
        l,
        r
    ]);
    (0, $2WGWz.useEffect)(()=>c?.setSize(x.width, x.height), [
        c,
        x
    ]), (0, $02a5e071daeb5f48$export$96f57966bedc81b4)((C, R)=>{
        if (a) {
            const E = d.autoClear;
            d.autoClear = i, p && !i && d.clearStencil(), c.render(R), d.autoClear = E;
        }
    }, a ? n : 0);
    const F = (0, $2WGWz.useRef)(null);
    (0, $2WGWz.useLayoutEffect)(()=>{
        const C = [], R = F.current.__r3f;
        if (R && c) {
            const E = R.children;
            for(let T = 0; T < E.length; T++){
                const N = E[T].object;
                if (N instanceof (0, $2046da3312f94030$export$a32b0b1c1ac59d04)) {
                    const q = [
                        N
                    ];
                    if (!$7c8119e0ee165095$var$ie(N)) {
                        let G = null;
                        for(; (G = E[T + 1]?.object) instanceof (0, $2046da3312f94030$export$a32b0b1c1ac59d04) && !$7c8119e0ee165095$var$ie(G);)q.push(G), T++;
                    }
                    const $ = new (0, $2046da3312f94030$export$9b60604040f63be5)(u, ...q);
                    C.push($);
                } else N instanceof (0, $2046da3312f94030$export$802bc10488da99c7) && C.push(N);
            }
            for (const T of C)c?.addPass(T);
            U && (U.enabled = !0), b && (b.enabled = !0);
        }
        return ()=>{
            for (const E of C)c?.removePass(E);
            U && (U.enabled = !1), b && (b.enabled = !1);
        };
    }, [
        c,
        e,
        u,
        U,
        b
    ]), (0, $2WGWz.useEffect)(()=>{
        const C = d.toneMapping;
        return d.toneMapping = (0, $ce0cdebec9150cb3$export$9fcb6b4294603b2), ()=>{
            d.toneMapping = C;
        };
    }, [
        d
    ]);
    const X = (0, $2WGWz.useMemo)(()=>({
            composer: c,
            normalPass: U,
            downSamplingPass: b,
            resolutionScale: r,
            camera: u,
            scene: f
        }), [
        c,
        U,
        b,
        r,
        u,
        f
    ]);
    return (0, $2WGWz.useImperativeHandle)(g, ()=>c, [
        c
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($7c8119e0ee165095$export$62f16d743a4a34a4.Provider, {
        value: X,
        children: /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("group", {
            ref: F,
            children: e
        })
    });
})), $7c8119e0ee165095$export$fb2b8a41d9966b32 = (e)=>typeof e == "object" && e != null && "current" in e ? e.current : e;
let $7c8119e0ee165095$var$vt = 0;
const $7c8119e0ee165095$var$le = /*@__PURE__*/ new WeakMap, $7c8119e0ee165095$export$860beaf0e87f1a9f = (e, t)=>function({ blendFunction: o = t?.blendFunction, opacity: r = t?.opacity, ...a }) {
        let n = $7c8119e0ee165095$var$le.get(e);
        if (!n) {
            const l = `@react-three/postprocessing/${e.name}-${$7c8119e0ee165095$var$vt++}`;
            (0, $02a5e071daeb5f48$export$f1e1789686576879)({
                [l]: e
            }), $7c8119e0ee165095$var$le.set(e, n = l);
        }
        const i = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)((l)=>l.camera), s = (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).useMemo(()=>[
                ...t?.args ?? [],
                ...a.args ?? [
                    {
                        ...t,
                        ...a
                    }
                ]
            ], [
            JSON.stringify(a)
        ]);
        return /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)(n, {
            camera: i,
            "blendMode-blendFunction": o,
            "blendMode-opacity-value": r,
            ...a,
            args: s
        });
    }, $7c8119e0ee165095$export$25531d08a39b482d = (e, t)=>{
    const o = e[t];
    return (0, (/*@__PURE__*/$parcel$interopDefault($2WGWz))).useMemo(()=>typeof o == "number" ? new $ce0cdebec9150cb3$export$c977b3e384af9ae1(o, o) : o ? new $ce0cdebec9150cb3$export$c977b3e384af9ae1(...o) : new $ce0cdebec9150cb3$export$c977b3e384af9ae1, [
        o
    ]);
}, $7c8119e0ee165095$export$5751c1c6582d7b51 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function({ blendFunction: e, worldFocusDistance: t, worldFocusRange: o, focusDistance: r, focusRange: a, focalLength: n, bokehScale: i, resolutionScale: s, resolutionX: l, resolutionY: p, width: _, height: S, target: g, depthTexture: d, ...m }, v) {
    const { camera: x } = (0, $2WGWz.useContext)($7c8119e0ee165095$export$62f16d743a4a34a4), f = g != null, u = (0, $2WGWz.useMemo)(()=>{
        const c = new (0, $2046da3312f94030$export$a473b3aa72725315)(x, {
            blendFunction: e,
            worldFocusDistance: t,
            worldFocusRange: o,
            focusDistance: r,
            focusRange: a,
            focalLength: n,
            bokehScale: i,
            resolutionScale: s,
            resolutionX: l,
            resolutionY: p,
            width: _,
            height: S
        });
        f && (c.target = new (0, $ce0cdebec9150cb3$export$64b5c384219d3699)), d && c.setDepthTexture(d.texture, d.packing);
        const U = c.maskPass;
        return U.maskFunction = (0, $2046da3312f94030$export$5dd4eee9fb245df8).MULTIPLY_RGB_SET_ALPHA, c;
    }, [
        x,
        e,
        t,
        o,
        r,
        a,
        n,
        i,
        s,
        l,
        p,
        _,
        S,
        f,
        d
    ]);
    return (0, $2WGWz.useEffect)(()=>()=>{
            u.dispose();
        }, [
        u
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ...m,
        ref: v,
        object: u,
        target: g
    });
}), $7c8119e0ee165095$export$5b3bf8af12b82213 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(({ target: e, mouse: t = !1, debug: o, manual: r = !1, smoothTime: a = .25, ...n }, i)=>{
    const s = (0, $2WGWz.useRef)(null), l = (0, $2WGWz.useRef)(null), p = (0, $2WGWz.useRef)(null), _ = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)(({ scene: b })=>b), S = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)(({ pointer: b })=>b), { composer: g, camera: d } = (0, $2WGWz.useContext)($7c8119e0ee165095$export$62f16d743a4a34a4), [m] = (0, $2WGWz.useState)(()=>new (0, $2046da3312f94030$export$bd325dd997857b23)), [v] = (0, $2WGWz.useState)(()=>new (0, $2046da3312f94030$export$ec9e16bd0f76e979));
    (0, $2WGWz.useEffect)(()=>(g.addPass(m), g.addPass(v), ()=>{
            g.removePass(m), g.removePass(v);
        }), [
        g,
        m,
        v
    ]), (0, $2WGWz.useEffect)(()=>()=>{
            m.dispose(), v.dispose();
        }, [
        m,
        v
    ]);
    const [x] = (0, $2WGWz.useState)(()=>new $ce0cdebec9150cb3$export$64b5c384219d3699(0, 0, 0)), [f] = (0, $2WGWz.useState)(()=>new $ce0cdebec9150cb3$export$64b5c384219d3699(0, 0, 0)), u = (0, $2WGWz.useCallback)(async (b, F)=>(f.x = b, f.y = F, f.z = await m.readDepth(f), f.z = f.z * 2 - 1, 1 - f.z > 1e-7 ? f.unproject(d) : !1), [
        f,
        m,
        d
    ]), c = (0, $2WGWz.useCallback)(async (b, F = !0)=>{
        if (e) x.set(...e);
        else {
            const { x: X, y: C } = t ? S : {
                x: 0,
                y: 0
            }, R = await u(X, C);
            R && x.copy(R);
        }
        F && s.current?.target && (a > 0 && b > 0 ? (0, $95b754901e182d16$export$f1e1789686576879).damp3(s.current.target, x, a, b) : s.current.target.copy(x));
    }, [
        e,
        x,
        t,
        u,
        a,
        S
    ]);
    (0, $02a5e071daeb5f48$export$96f57966bedc81b4)(async (b, F)=>{
        r || c(F), l.current && l.current.position.copy(x), p.current && s.current?.target && p.current.position.copy(s.current.target);
    });
    const U = (0, $2WGWz.useMemo)(()=>({
            dofRef: s,
            hitpoint: x,
            update: c
        }), [
        x,
        c
    ]);
    return (0, $2WGWz.useImperativeHandle)(i, ()=>U, [
        U
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
        children: [
            o ? (0, $02a5e071daeb5f48$export$ae1af26003f05816)(/*@__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                children: [
                    /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("mesh", {
                        ref: l,
                        children: [
                            /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("sphereGeometry", {
                                args: [
                                    o,
                                    16,
                                    16
                                ]
                            }),
                            /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("meshBasicMaterial", {
                                color: "#00ff00",
                                opacity: 1,
                                transparent: !0,
                                depthWrite: !1
                            })
                        ]
                    }),
                    /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("mesh", {
                        ref: p,
                        children: [
                            /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("sphereGeometry", {
                                args: [
                                    o / 2,
                                    16,
                                    16
                                ]
                            }),
                            /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("meshBasicMaterial", {
                                color: "#00ff00",
                                opacity: .5,
                                transparent: !0,
                                depthWrite: !1
                            })
                        ]
                    })
                ]
            }), _) : null,
            /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($7c8119e0ee165095$export$5751c1c6582d7b51, {
                ref: s,
                ...n,
                target: x
            })
        ]
    });
}), $7c8119e0ee165095$var$_t = {
    fragmentShader: `
    uniform float time;
    uniform vec2 lensPosition;
    uniform vec2 screenRes;
    uniform vec3 colorGain;
    uniform float starPoints;
    uniform float glareSize;
    uniform float flareSize;
    uniform float flareSpeed;
    uniform float flareShape;
    uniform float haloScale;
    uniform float opacity;
    uniform bool animated;
    uniform bool anamorphic;
    uniform bool enabled;
    uniform bool secondaryGhosts;
    uniform bool starBurst;
    uniform float ghostScale;
    uniform bool aditionalStreaks;
    uniform sampler2D lensDirtTexture;
    vec2 vTexCoord;
    
    float rand(float n){return fract(sin(n) * 43758.5453123);}

    float noise(float p){
      float fl = floor(p);
      float fc = fract(p);
      return mix(rand(fl),rand(fl + 1.0), fc);
    }

    vec3 hsv2rgb(vec3 c)
    {
      vec4 k = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
      vec3 p = abs(fract(c.xxx + k.xyz) * 6.0 - k.www);
      return c.z * mix(k.xxx, clamp(p - k.xxx, 0.0, 1.0), c.y);
    }

    float saturate(float x)
    {
      return clamp(x, 0.,1.);
    }

    vec2 rotateUV(vec2 uv, float rotation)
    {
      return vec2(
          cos(rotation) * uv.x + sin(rotation) * uv.y,
          cos(rotation) * uv.y - sin(rotation) * uv.x
      );
    }

    // Based on https://www.shadertoy.com/view/XtKfRV
    vec3 drawflare(vec2 p, float intensity, float rnd, float speed, int id)
    {
      float flarehueoffset = (1. / 32.) * float(id) * 0.1;
      float lingrad = distance(vec2(0.), p);
      float expgrad = 1. / exp(lingrad * (fract(rnd) * 0.66 + 0.33));
      vec3 colgrad = hsv2rgb(vec3( fract( (expgrad * 8.) + speed * flareSpeed + flarehueoffset), pow(1.-abs(expgrad*2.-1.), 0.45), 20.0 * expgrad * intensity)); //rainbow spectrum effect

      float internalStarPoints;

      if(anamorphic){
        internalStarPoints = 1.0;
      } else{
        internalStarPoints = starPoints;
      }
      
      float blades = length(p * flareShape * sin(internalStarPoints * atan(p.x, p.y)));
      
      float comp = pow(1.-saturate(blades), ( anamorphic ? 100. : 12.));
      comp += saturate(expgrad-0.9) * 3.;
      comp = pow(comp * expgrad, 8. + (1.-intensity) * 5.);
      
      if(flareSpeed > 0.0){
        return vec3(comp) * colgrad;
      } else{
        return vec3(comp) * flareSize * 15.;
      }
    }

    float dist(vec3 a, vec3 b) { return abs(a.x - b.x) + abs(a.y - b.y) + abs(a.z - b.z); }

    vec3 saturate(vec3 x)
    {
      return clamp(x, vec3(0.0), vec3(1.0));
    }

    // Based on https://www.shadertoy.com/view/XtKfRV
    float glare(vec2 uv, vec2 pos, float size)
    {
      vec2 main;

      if(animated){
        main = rotateUV(uv-pos, time * 0.1);      
      } else{
        main = uv-pos;     
      }
      
      float ang = atan(main.y, main.x) * (anamorphic ? 1.0 : starPoints);
      float dist = length(main); 
      dist = pow(dist, .9);
      
      float f0 = 1.0/(length(uv-pos)*(1.0/size*16.0)+.2);

      return f0+f0*(sin((ang))*.2 +.3);
    }

    float sdHex(vec2 p){
      p = abs(p);
      vec2 q = vec2(p.x*2.0*0.5773503, p.y + p.x*0.5773503);
      return dot(step(q.xy,q.yx), 1.0-q.yx);
    }

    //Based on https://www.shadertoy.com/view/dllSRX
    float fpow(float x, float k){
      return x > k ? pow((x-k)/(1.0-k),2.0) : 0.0;
    }

    vec3 renderhex(vec2 uv, vec2 p, float s, vec3 col){
      uv -= p;
      if (abs(uv.x) < 0.2*s && abs(uv.y) < 0.2*s){
          return mix(vec3(0),mix(vec3(0),col,0.1 + fpow(length(uv/s),0.1)*10.0),smoothstep(0.0,0.1,sdHex(uv*20.0/s)));
      }
      return vec3(0);
    }

    // Based on https://www.shadertoy.com/view/4sX3Rs
    vec3 LensFlare(vec2 uv, vec2 pos)
    {
      vec2 main = uv-pos;
      vec2 uvd = uv*(length(uv));
      
      float ang = atan(main.x,main.y);
      
      float f0 = .3/(length(uv-pos)*16.0+1.0);
      
      f0 = f0*(sin(noise(sin(ang*3.9-(animated ? time : 0.0) * 0.3) * starPoints))*.2 );
      
      float f1 = max(0.01-pow(length(uv+1.2*pos),1.9),.0)*7.0;

      float f2 = max(.9/(10.0+32.0*pow(length(uvd+0.99*pos),2.0)),.0)*0.35;
      float f22 = max(.9/(11.0+32.0*pow(length(uvd+0.85*pos),2.0)),.0)*0.23;
      float f23 = max(.9/(12.0+32.0*pow(length(uvd+0.95*pos),2.0)),.0)*0.6;
      
      vec2 uvx = mix(uv,uvd, 0.1);
      
      float f4 = max(0.01-pow(length(uvx+0.4*pos),2.9),.0)*4.02;
      float f42 = max(0.0-pow(length(uvx+0.45*pos),2.9),.0)*4.1;
      float f43 = max(0.01-pow(length(uvx+0.5*pos),2.9),.0)*4.6;
      
      uvx = mix(uv,uvd,-.4);
      
      float f5 = max(0.01-pow(length(uvx+0.1*pos),5.5),.0)*2.0;
      float f52 = max(0.01-pow(length(uvx+0.2*pos),5.5),.0)*2.0;
      float f53 = max(0.01-pow(length(uvx+0.1*pos),5.5),.0)*2.0;
      
      uvx = mix(uv,uvd, 2.1);
      
      float f6 = max(0.01-pow(length(uvx-0.3*pos),1.61),.0)*3.159;
      float f62 = max(0.01-pow(length(uvx-0.325*pos),1.614),.0)*3.14;
      float f63 = max(0.01-pow(length(uvx-0.389*pos),1.623),.0)*3.12;
      
      vec3 c = vec3(glare(uv,pos, glareSize));

      vec2 prot;

      if(animated){
        prot = rotateUV(uv - pos, (time * 0.1));  
      } else if(anamorphic){
        prot = rotateUV(uv - pos, 1.570796);     
      } else {
        prot = uv - pos;
      }

      c += drawflare(prot, (anamorphic ? flareSize * 10. : flareSize), 0.1, time, 1);
      
      c.r+=f1+f2+f4+f5+f6; c.g+=f1+f22+f42+f52+f62; c.b+=f1+f23+f43+f53+f63;
      c = c*1.3 * vec3(length(uvd)+.09);
      c+=vec3(f0);
      
      return c;
    }

    vec3 cc(vec3 color, float factor,float factor2)
    {
      float w = color.x+color.y+color.z;
      return mix(color,vec3(w)*factor,w*factor2);
    }    

    float rnd(vec2 p)
    {
      float f = fract(sin(dot(p, vec2(12.1234, 72.8392) )*45123.2));
      return f;   
    }

    float rnd(float w)
    {
      float f = fract(sin(w)*1000.);
      return f;   
    }

    float regShape(vec2 p, int N)
    {
      float f;
      
      float a=atan(p.x,p.y)+.2;
      float b=6.28319/float(N);
      f=smoothstep(.5,.51, cos(floor(.5+a/b)*b-a)*length(p.xy)* 2.0  -ghostScale);
          
      return f;
    }

    // Based on https://www.shadertoy.com/view/Xlc3D2
    vec3 circle(vec2 p, float size, float decay, vec3 color, vec3 color2, float dist, vec2 position)
    {
      float l = length(p + position*(dist*2.))+size/2.;
      float l2 = length(p + position*(dist*4.))+size/3.;
      
      float c = max(0.01-pow(length(p + position*dist), size*ghostScale), 0.0)*10.;
      float c1 = max(0.001-pow(l-0.3, 1./40.)+sin(l*20.), 0.0)*3.;
      float c2 =  max(0.09/pow(length(p-position*dist/.5)*1., .95), 0.0)/20.;
      float s = max(0.02-pow(regShape(p*5. + position*dist*5. + decay, 6) , 1.), 0.0)*1.5;
      
      color = cos(vec3(0.44, .24, .2)*16. + dist/8.)*0.5+.5;
      vec3 f = c*color;
      f += c1*color;
      f += c2*color;  
      f +=  s*color;
      return f;
    }

    vec4 getLensColor(float x){
      return vec4(vec3(mix(mix(mix(mix(mix(mix(mix(mix(mix(mix(mix(mix(mix(mix(mix(vec3(0., 0., 0.),
        vec3(0., 0., 0.), smoothstep(0.0, 0.063, x)),
        vec3(0., 0., 0.), smoothstep(0.063, 0.125, x)),
        vec3(0.0, 0., 0.), smoothstep(0.125, 0.188, x)),
        vec3(0.188, 0.131, 0.116), smoothstep(0.188, 0.227, x)),
        vec3(0.31, 0.204, 0.537), smoothstep(0.227, 0.251, x)),
        vec3(0.192, 0.106, 0.286), smoothstep(0.251, 0.314, x)),
        vec3(0.102, 0.008, 0.341), smoothstep(0.314, 0.392, x)),
        vec3(0.086, 0.0, 0.141), smoothstep(0.392, 0.502, x)),
        vec3(1.0, 0.31, 0.0), smoothstep(0.502, 0.604, x)),
        vec3(.1, 0.1, 0.1), smoothstep(0.604, 0.643, x)),
        vec3(1.0, 0.929, 0.0), smoothstep(0.643, 0.761, x)),
        vec3(1.0, 0.086, 0.424), smoothstep(0.761, 0.847, x)),
        vec3(1.0, 0.49, 0.0), smoothstep(0.847, 0.89, x)),
        vec3(0.945, 0.275, 0.475), smoothstep(0.89, 0.941, x)),
        vec3(0.251, 0.275, 0.796), smoothstep(0.941, 1.0, x))),
      1.0);
    }

    float dirtNoise(vec2 p){
      vec2 f = fract(p);
      f = (f * f) * (3.0 - (2.0 * f));    
      float n = dot(floor(p), vec2(1.0, 157.0));
      vec4 a = fract(sin(vec4(n + 0.0, n + 1.0, n + 157.0, n + 158.0)) * 43758.5453123);
      return mix(mix(a.x, a.y, f.x), mix(a.z, a.w, f.x), f.y);
    } 

    float fbm(vec2 p){
      const mat2 m = mat2(0.80, -0.60, 0.60, 0.80);
      float f = 0.0;
      f += 0.5000*dirtNoise(p); p = m*p*2.02;
      f += 0.2500*dirtNoise(p); p = m*p*2.03;
      f += 0.1250*dirtNoise(p); p = m*p*2.01;
      f += 0.0625*dirtNoise(p);
      return f/0.9375;
    }

    vec4 getLensStar(vec2 p){
      vec2 pp = (p - vec2(0.5)) * 2.0;
      float a = atan(pp.y, pp.x);
      vec4 cp = vec4(sin(a * 1.0), length(pp), sin(a * 13.0), sin(a * 53.0));
      float d = sin(clamp(pow(length(vec2(0.5) - p) * 0.5 + haloScale /2., 5.0), 0.0, 1.0) * 3.14159);
      vec3 c = vec3(d) * vec3(fbm(cp.xy * 16.0) * fbm(cp.zw * 9.0) * max(max(max(max(0.5, sin(a * 1.0)), sin(a * 3.0) * 0.8), sin(a * 7.0) * 0.8), sin(a * 9.0) * 10.6));
      c *= vec3(mix(2.0, (sin(length(pp.xy) * 256.0) * 0.5) + 0.5, sin((clamp((length(pp.xy) - 0.875) / 0.1, 0.0, 1.0) + 0.0) * 2.0 * 3.14159) * 1.5) + 0.5) * 0.3275;
      return vec4(vec3(c * 1.0), d);	
    }

    vec4 getLensDirt(vec2 p){
      p.xy += vec2(fbm(p.yx * 3.0), fbm(p.yx * 2.0)) * 0.0825;
      vec3 o = vec3(mix(0.125, 0.25, max(max(smoothstep(0.1, 0.0, length(p - vec2(0.25))),
                                            smoothstep(0.4, 0.0, length(p - vec2(0.75)))),
                                            smoothstep(0.8, 0.0, length(p - vec2(0.875, 0.125))))));
      o += vec3(max(fbm(p * 1.0) - 0.5, 0.0)) * 0.5;
      o += vec3(max(fbm(p * 2.0) - 0.5, 0.0)) * 0.5;
      o += vec3(max(fbm(p * 4.0) - 0.5, 0.0)) * 0.25;
      o += vec3(max(fbm(p * 8.0) - 0.75, 0.0)) * 1.0;
      o += vec3(max(fbm(p * 16.0) - 0.75, 0.0)) * 0.75;
      o += vec3(max(fbm(p * 64.0) - 0.75, 0.0)) * 0.5;
      return vec4(clamp(o, vec3(0.15), vec3(1.0)), 1.0);	
    }

    vec4 textureLimited(sampler2D tex, vec2 texCoord){
      if(((texCoord.x < 0.) || (texCoord.y < 0.)) || ((texCoord.x > 1.) || (texCoord.y > 1.))){
        return vec4(0.0);
      }else{
        return texture(tex, texCoord); 
      }
    }

    vec4 textureDistorted(sampler2D tex, vec2 texCoord, vec2 direction, vec3 distortion) {
      return vec4(textureLimited(tex, (texCoord + (direction * distortion.r))).r,
                  textureLimited(tex, (texCoord + (direction * distortion.g))).g,
                  textureLimited(tex, (texCoord + (direction * distortion.b))).b,
                  1.0);
    }

    // Based on https://www.shadertoy.com/view/4sK3W3
    vec4 getStartBurst(){
      vec2 aspectTexCoord = vec2(1.0) - (((vTexCoord - vec2(0.5)) * vec2(1.0)) + vec2(0.5)); 
      vec2 texCoord = vec2(1.0) - vTexCoord; 
      vec2 ghostVec = (vec2(0.5) - texCoord) * 0.3 - lensPosition;
      vec2 ghostVecAspectNormalized = normalize(ghostVec * vec2(1.0)) * vec2(1.0);
      vec2 haloVec = normalize(ghostVec) * 0.6;
      vec2 haloVecAspectNormalized = ghostVecAspectNormalized * 0.6;
      vec2 texelSize = vec2(1.0) / vec2(screenRes.xy);
      vec3 distortion = vec3(-(texelSize.x * 1.5), 0.2, texelSize.x * 1.5);
      vec4 c = vec4(0.0);
      for (int i = 0; i < 8; i++) {
        vec2 offset = texCoord + (ghostVec * float(i));
        c += textureDistorted(lensDirtTexture, offset, ghostVecAspectNormalized, distortion) * pow(max(0.0, 1.0 - (length(vec2(0.5) - offset) / length(vec2(0.5)))), 10.0);
      }                       
      vec2 haloOffset = texCoord + haloVecAspectNormalized; 
      return (c * getLensColor((length(vec2(0.5) - aspectTexCoord) / length(vec2(haloScale))))) + 
            (textureDistorted(lensDirtTexture, haloOffset, ghostVecAspectNormalized, distortion) * pow(max(0.0, 1.0 - (length(vec2(0.5) - haloOffset) / length(vec2(0.5)))), 10.0));
    } 

    void mainImage(vec4 inputColor, vec2 uv, out vec4 outputColor)
    {
      vec2 myUV = uv -0.5;
      myUV.y *= screenRes.y/screenRes.x;
      vec2 finalLensPosition = lensPosition * 0.5;
      finalLensPosition.y *= screenRes.y/screenRes.x;
      
      //First Lens flare pass
      vec3 finalColor = LensFlare(myUV, finalLensPosition) * 20.0 * colorGain / 256.;

      //Aditional streaks
      if(aditionalStreaks){
        vec3 circColor = vec3(0.9, 0.2, 0.1);
        vec3 circColor2 = vec3(0.3, 0.1, 0.9);

        for(float i=0.;i<10.;i++){
          finalColor += circle(myUV, pow(rnd(i*2000.)*2.8, .1)+1.41, 0.0, circColor+i , circColor2+i, rnd(i*20.)*3.+0.2-.5, lensPosition);
        }
      }

      //Alternative ghosts
      if(secondaryGhosts){
        vec3 altGhosts = vec3(0);
        altGhosts += renderhex(myUV, -lensPosition*0.25, ghostScale * 1.4, vec3(0.25,0.35,0));
        altGhosts += renderhex(myUV, lensPosition*0.25, ghostScale * 0.5, vec3(1,0.5,0.5));
        altGhosts += renderhex(myUV, lensPosition*0.1, ghostScale * 1.6, vec3(1,1,1));
        altGhosts += renderhex(myUV, lensPosition*1.8, ghostScale * 2.0, vec3(0,0.5,0.75));
        altGhosts += renderhex(myUV, lensPosition*1.25, ghostScale * 0.8, vec3(1,1,0.5));
        altGhosts += renderhex(myUV, -lensPosition*1.25, ghostScale * 5.0, vec3(0.5,0.5,0.25));
        
        //Circular ghosts
        altGhosts += fpow(1.0 - abs(distance(lensPosition*0.8,myUV) - 0.7),0.985)*colorGain / 2100.;
        finalColor += altGhosts;
      }
      

      //Starburst                     
      if(starBurst){
        vTexCoord = myUV + 0.5;
        vec4 lensMod = getLensDirt(myUV);
        float tooBright = 1.0 - (clamp(0.5, 0.0, 0.5) * 2.0); 
        float tooDark = clamp(0.5 - 0.5, 0.0, 0.5) * 2.0;
        lensMod += mix(lensMod, pow(lensMod * 2.0, vec4(2.0)) * 0.5, tooBright);
        float lensStarRotationAngle = ((myUV.x + myUV.y)) * (1.0 / 6.0);
        vec2 lensStarTexCoord = (mat2(cos(lensStarRotationAngle), -sin(lensStarRotationAngle), sin(lensStarRotationAngle), cos(lensStarRotationAngle)) * vTexCoord);
        lensMod += getLensStar(lensStarTexCoord) * 2.;
        
        finalColor += clamp((lensMod.rgb * getStartBurst().rgb ), 0.01, 1.0);
      }

      //Final composed output
      if(enabled){
        outputColor = vec4(mix(finalColor, vec3(.0), opacity) + inputColor.rgb, inputColor.a);
      } else {
        outputColor = vec4(inputColor);
      }
    }
  `
};
class $7c8119e0ee165095$export$72fc8dc6a61b62d8 extends (0, $2046da3312f94030$export$a32b0b1c1ac59d04) {
    constructor({ blendFunction: t, enabled: o, glareSize: r, lensPosition: a, screenRes: n, starPoints: i, flareSize: s, flareSpeed: l, flareShape: p, animated: _, anamorphic: S, colorGain: g, lensDirtTexture: d, haloScale: m, secondaryGhosts: v, aditionalStreaks: x, ghostScale: f, opacity: u, starBurst: c }){
        super("LensFlareEffect", $7c8119e0ee165095$var$_t.fragmentShader, {
            blendFunction: t,
            uniforms: /*@__PURE__*/ new Map([
                [
                    "enabled",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(o)
                ],
                [
                    "glareSize",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(r)
                ],
                [
                    "lensPosition",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(a)
                ],
                [
                    "time",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(0)
                ],
                [
                    "screenRes",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(n)
                ],
                [
                    "starPoints",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(i)
                ],
                [
                    "flareSize",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(s)
                ],
                [
                    "flareSpeed",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(l)
                ],
                [
                    "flareShape",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(p)
                ],
                [
                    "animated",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(_)
                ],
                [
                    "anamorphic",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(S)
                ],
                [
                    "colorGain",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(g)
                ],
                [
                    "lensDirtTexture",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(d)
                ],
                [
                    "haloScale",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(m)
                ],
                [
                    "secondaryGhosts",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(v)
                ],
                [
                    "aditionalStreaks",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(x)
                ],
                [
                    "ghostScale",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(f)
                ],
                [
                    "starBurst",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(c)
                ],
                [
                    "opacity",
                    new $ce0cdebec9150cb3$export$2947cebfe91c02f8(u)
                ]
            ])
        });
    }
    update(t, o, r) {
        const a = this.uniforms.get("time");
        a && (a.value += r);
    }
}
const $7c8119e0ee165095$var$xt = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f($7c8119e0ee165095$export$72fc8dc6a61b62d8), $7c8119e0ee165095$export$3f909fba4d49fe3d = ({ smoothTime: e = .07, blendFunction: t = 23, enabled: o = !0, glareSize: r = .2, lensPosition: a = new $ce0cdebec9150cb3$export$64b5c384219d3699(-25, 6, -60), screenRes: n = new $ce0cdebec9150cb3$export$c977b3e384af9ae1(0, 0), starPoints: i = 6, flareSize: s = .01, flareSpeed: l = .01, flareShape: p = .01, animated: _ = !0, anamorphic: S = !1, colorGain: g = new $ce0cdebec9150cb3$export$892596cec99bc70e(20, 20, 20), lensDirtTexture: d = null, haloScale: m = .5, secondaryGhosts: v = !0, aditionalStreaks: x = !0, ghostScale: f = 0, opacity: u = 1, starBurst: c = !1 })=>{
    const U = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)(({ viewport: T })=>T), b = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)(({ raycaster: T })=>T), { scene: F, camera: X } = (0, $2WGWz.useContext)($7c8119e0ee165095$export$62f16d743a4a34a4), [C] = (0, $2WGWz.useState)(()=>new $ce0cdebec9150cb3$export$c977b3e384af9ae1), [R] = (0, $2WGWz.useState)(()=>new $ce0cdebec9150cb3$export$64b5c384219d3699), E = (0, $2WGWz.useRef)(null);
    return (0, $02a5e071daeb5f48$export$96f57966bedc81b4)((T, N)=>{
        if (!E?.current) return;
        const q = E.current.uniforms.get("lensPosition"), $ = E.current.uniforms.get("opacity");
        if (!q || !$) return;
        let G = 1;
        if (R.copy(a).project(X), R.z > 1) return;
        q.value.x = R.x, q.value.y = R.y, C.x = R.x, C.y = R.y, b.setFromCamera(C, X);
        const ve = b.intersectObjects(F.children, !0), { object: I } = ve[0] || {};
        I && (I.userData?.lensflare === "no-occlusion" ? G = 0 : I instanceof $ce0cdebec9150cb3$export$e176487c05830cc5 && (I.material.uniforms?._transmission?.value > .2 || I.material._transmission && I.material._transmission > .2 ? G = .2 : I.material.transparent && (G = I.material.opacity))), (0, $95b754901e182d16$export$f1e1789686576879).damp($, "value", G, e, N);
    }), (0, $2WGWz.useEffect)(()=>{
        if (!E?.current) return;
        const T = E.current.uniforms.get("screenRes");
        T && (T.value.x = U.width, T.value.y = U.height);
    }, [
        U
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($7c8119e0ee165095$var$xt, {
        ref: E,
        blendFunction: t,
        enabled: o,
        glareSize: r,
        lensPosition: a,
        screenRes: n,
        starPoints: i,
        flareSize: s,
        flareSpeed: l,
        flareShape: p,
        animated: _,
        anamorphic: S,
        colorGain: g,
        lensDirtTexture: d,
        haloScale: m,
        secondaryGhosts: v,
        aditionalStreaks: x,
        ghostScale: f,
        opacity: u,
        starBurst: c
    });
}, $7c8119e0ee165095$export$b987ea0722284bfd = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$1e2a1743038c77d5), {
    blendFunction: 0
}), $7c8119e0ee165095$export$b24829d47a62c440 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$35667687ce6e9ce)), $7c8119e0ee165095$export$b65128210853dd06 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$5d827f77057feeb7)), $7c8119e0ee165095$export$710e309e9ce6e25b = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function({ blendFunction: e = 23 }, t) {
    const o = (0, $2WGWz.useMemo)(()=>new (0, $2046da3312f94030$export$562d7192c2de1170)(e), [
        e
    ]);
    return /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: t,
        object: o,
        dispose: null
    });
}), $7c8119e0ee165095$export$c46070340397c934 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$3520bcefece76c80)), $7c8119e0ee165095$export$950556173b6cbecb = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$616b524125abf15a)), $7c8119e0ee165095$export$2c0e8a454b7c4c74 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$f9e0c2aa66f80f09)), $7c8119e0ee165095$export$57656748f4faa507 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function({ active: e = !0, ...t }, o) {
    const r = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)((p)=>p.invalidate), a = $7c8119e0ee165095$export$25531d08a39b482d(t, "delay"), n = $7c8119e0ee165095$export$25531d08a39b482d(t, "duration"), i = $7c8119e0ee165095$export$25531d08a39b482d(t, "strength"), s = $7c8119e0ee165095$export$25531d08a39b482d(t, "chromaticAberrationOffset"), l = (0, $2WGWz.useMemo)(()=>new (0, $2046da3312f94030$export$87a0c8b425be8598)({
            ...t,
            delay: a,
            duration: n,
            strength: i,
            chromaticAberrationOffset: s
        }), [
        a,
        n,
        t,
        i,
        s
    ]);
    return (0, $2WGWz.useLayoutEffect)(()=>{
        l.mode = e ? t.mode || (0, $2046da3312f94030$export$678a9d3661117e39).SPORADIC : (0, $2046da3312f94030$export$678a9d3661117e39).DISABLED, r();
    }, [
        e,
        l,
        r,
        t.mode
    ]), (0, $2WGWz.useEffect)(()=>()=>{
            l.dispose?.();
        }, [
        l
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: o,
        object: l,
        dispose: null
    });
}), $7c8119e0ee165095$export$6774e24e67720253 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function(e, t) {
    const { camera: o } = (0, $2WGWz.useContext)($7c8119e0ee165095$export$62f16d743a4a34a4), r = (0, $2WGWz.useMemo)(()=>new (0, $2046da3312f94030$export$6c90045c82ddd8e9)(o, $7c8119e0ee165095$export$fb2b8a41d9966b32(e.sun), e), [
        o,
        e
    ]);
    return (0, $2WGWz.useLayoutEffect)(()=>void (r.lightSource = $7c8119e0ee165095$export$fb2b8a41d9966b32(e.sun)), [
        r,
        e.sun
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: t,
        object: r,
        dispose: null
    });
}), $7c8119e0ee165095$export$ef2184bd89960b14 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function({ size: e, ...t }, o) {
    const r = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)((n)=>n.invalidate), a = (0, $2WGWz.useMemo)(()=>new (0, $2046da3312f94030$export$196041dbe92a1b1)(t), [
        t
    ]);
    return (0, $2WGWz.useLayoutEffect)(()=>{
        e && a.setSize(e.width, e.height), r();
    }, [
        a,
        e,
        r
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: o,
        object: a,
        dispose: null
    });
}), $7c8119e0ee165095$export$ee99256e31bf0a8b = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$cb84d7708921e909)), $7c8119e0ee165095$export$484d33a0500a4ce1 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$1d02386659918a72), {
    blendFunction: 5
}), $7c8119e0ee165095$export$5beeae30d1389e5 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function({ selection: e = [], selectionLayer: t = 10, blendFunction: o, patternTexture: r, edgeStrength: a, pulseSpeed: n, visibleEdgeColor: i, hiddenEdgeColor: s, width: l, height: p, kernelSize: _, blur: S, xRay: g, ...d }, m) {
    const v = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)((U)=>U.invalidate), { scene: x, camera: f } = (0, $2WGWz.useContext)($7c8119e0ee165095$export$62f16d743a4a34a4), u = (0, $2WGWz.useMemo)(()=>new (0, $2046da3312f94030$export$7c28220b97a65a06)(x, f, {
            blendFunction: o,
            patternTexture: r,
            edgeStrength: a,
            pulseSpeed: n,
            visibleEdgeColor: i,
            hiddenEdgeColor: s,
            width: l,
            height: p,
            kernelSize: _,
            blur: S,
            xRay: g,
            ...d
        }), [
        o,
        S,
        f,
        a,
        p,
        s,
        _,
        r,
        n,
        x,
        i,
        l,
        g
    ]), c = (0, $2WGWz.useContext)($7c8119e0ee165095$export$589fe5e500e6a125);
    return (0, $2WGWz.useEffect)(()=>{
        if (!c && e) return u.selection.set(Array.isArray(e) ? e.map($7c8119e0ee165095$export$fb2b8a41d9966b32) : [
            $7c8119e0ee165095$export$fb2b8a41d9966b32(e)
        ]), v(), ()=>{
            u.selection.clear(), v();
        };
    }, [
        u,
        e,
        c,
        v
    ]), (0, $2WGWz.useEffect)(()=>{
        u.selectionLayer = t, v();
    }, [
        u,
        v,
        t
    ]), (0, $2WGWz.useRef)(void 0), (0, $2WGWz.useEffect)(()=>{
        if (c && c.enabled && c.selected?.length) return u.selection.set(c.selected), v(), ()=>{
            u.selection.clear(), v();
        };
    }, [
        c,
        u.selection,
        v
    ]), (0, $2WGWz.useEffect)(()=>()=>{
            u.dispose();
        }, [
        u
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: m,
        object: u
    });
}), $7c8119e0ee165095$export$69a04bc8ebc0624c = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function({ granularity: e = 5 }, t) {
    const o = (0, $2WGWz.useMemo)(()=>new (0, $2046da3312f94030$export$be408d53e0133e76)(e), [
        e
    ]);
    return /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: t,
        object: o,
        dispose: null
    });
}), $7c8119e0ee165095$export$744638893df3f65e = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$375e89395e3a5238), {
    blendFunction: 24,
    density: 1.25
}), $7c8119e0ee165095$var$Mt = (e, t)=>e.layers.enable(t.selection.layer), $7c8119e0ee165095$var$Dt = (e, t)=>e.layers.disable(t.selection.layer), $7c8119e0ee165095$export$c3976fbcb724b8a6 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function({ selection: e = [], selectionLayer: t = 10, lights: o = [], inverted: r = !1, ignoreBackground: a = !1, luminanceThreshold: n, luminanceSmoothing: i, intensity: s, width: l, height: p, kernelSize: _, mipmapBlur: S, ...g }, d) {
    o.length === 0 && console.warn("SelectiveBloom requires lights to work.");
    const m = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)((c)=>c.invalidate), { scene: v, camera: x } = (0, $2WGWz.useContext)($7c8119e0ee165095$export$62f16d743a4a34a4), f = (0, $2WGWz.useMemo)(()=>{
        const c = new (0, $2046da3312f94030$export$6588cb38f2a0e4fe)(v, x, {
            blendFunction: 0,
            luminanceThreshold: n,
            luminanceSmoothing: i,
            intensity: s,
            width: l,
            height: p,
            kernelSize: _,
            mipmapBlur: S,
            ...g
        });
        return c.inverted = r, c.ignoreBackground = a, c;
    }, [
        v,
        x,
        n,
        i,
        s,
        l,
        p,
        _,
        S,
        r,
        a,
        g
    ]), u = (0, $2WGWz.useContext)($7c8119e0ee165095$export$589fe5e500e6a125);
    return (0, $2WGWz.useEffect)(()=>{
        if (!u && e) return f.selection.set(Array.isArray(e) ? e.map($7c8119e0ee165095$export$fb2b8a41d9966b32) : [
            $7c8119e0ee165095$export$fb2b8a41d9966b32(e)
        ]), m(), ()=>{
            f.selection.clear(), m();
        };
    }, [
        f,
        e,
        u,
        m
    ]), (0, $2WGWz.useEffect)(()=>{
        f.selection.layer = t, m();
    }, [
        f,
        m,
        t
    ]), (0, $2WGWz.useEffect)(()=>{
        if (o && o.length > 0) return o.forEach((c)=>$7c8119e0ee165095$var$Mt($7c8119e0ee165095$export$fb2b8a41d9966b32(c), f)), m(), ()=>{
            o.forEach((c)=>$7c8119e0ee165095$var$Dt($7c8119e0ee165095$export$fb2b8a41d9966b32(c), f)), m();
        };
    }, [
        f,
        m,
        o,
        t
    ]), (0, $2WGWz.useEffect)(()=>{
        if (u && u.enabled && u.selected?.length) return f.selection.set(u.selected), m(), ()=>{
            f.selection.clear(), m();
        };
    }, [
        u,
        f.selection,
        m
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: d,
        object: f,
        dispose: null
    });
}), $7c8119e0ee165095$export$1eeb4741c69006fa = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$c6ab5b20c691455c)), $7c8119e0ee165095$export$6ac360c454a4604a = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function(e, t) {
    const { camera: o, normalPass: r, downSamplingPass: a, resolutionScale: n } = (0, $2WGWz.useContext)($7c8119e0ee165095$export$62f16d743a4a34a4), i = (0, $2WGWz.useMemo)(()=>r === null && a === null ? (console.error("Please enable the NormalPass in the EffectComposer in order to use SSAO."), {}) : new (0, $2046da3312f94030$export$49399bb0221f2549)(o, r && !a ? r.texture : null, {
            blendFunction: 21,
            samples: 30,
            rings: 4,
            distanceThreshold: 1,
            distanceFalloff: 0,
            rangeThreshold: .5,
            rangeFalloff: .1,
            luminanceInfluence: .9,
            radius: 20,
            bias: .5,
            intensity: 1,
            color: void 0,
            normalDepthBuffer: a ? a.texture : null,
            resolutionScale: n ?? 1,
            depthAwareUpsampling: !0,
            ...e
        }), [
        o,
        a,
        r,
        n
    ]);
    return /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: t,
        object: i,
        dispose: null
    });
}), $7c8119e0ee165095$export$1beb8bc393ba9643 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$85b31dfef8286ee7)), $7c8119e0ee165095$export$6b0a6384ebf04f97 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$b10a15fb2785e23f)), $7c8119e0ee165095$var$jt = {
    fragmentShader: `
    uniform int rampType;

    uniform vec2 rampStart;
    uniform vec2 rampEnd;

    uniform vec4 startColor;
    uniform vec4 endColor;

    uniform float rampBias;
    uniform float rampGain;

    uniform bool rampMask;
    uniform bool rampInvert;

    float getBias(float time, float bias) {
      return time / (((1.0 / bias) - 2.0) * (1.0 - time) + 1.0);
    }

    float getGain(float time, float gain) {
      if (time < 0.5)
        return getBias(time * 2.0, gain) / 2.0;
      else
        return getBias(time * 2.0 - 1.0, 1.0 - gain) / 2.0 + 0.5;
    }

    void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
      vec2 centerPixel = uv * resolution;
      vec2 startPixel = rampStart * resolution;
      vec2 endPixel = rampEnd * resolution;

      float rampAlpha;

      if (rampType == 1) {
        vec2 fuv = centerPixel / resolution.y;
        vec2 suv = startPixel / resolution.y;
        vec2 euv = endPixel / resolution.y;

        float radius = length(suv - euv);
        float falloff = length(fuv - suv);
        rampAlpha = smoothstep(0.0, radius, falloff);
      } else {
        float radius = length(startPixel - endPixel);
        vec2 direction = normalize(vec2(endPixel.x - startPixel.x, -(startPixel.y - endPixel.y)));

        float fade = dot(centerPixel - startPixel, direction);
        if (rampType == 2) fade = abs(fade);

        rampAlpha = smoothstep(0.0, 1.0, fade / radius);
      }

      rampAlpha = abs((rampInvert ? 1.0 : 0.0) - getBias(rampAlpha, rampBias) * getGain(rampAlpha, rampGain));

      if (rampMask) {
        vec4 inputBuff = texture2D(inputBuffer, uv);
        outputColor = mix(inputBuff, inputColor, rampAlpha);
      } else {
        outputColor = mix(startColor, endColor, rampAlpha);
      }
    }
  `
};
var $7c8119e0ee165095$export$d405c73f99fcc6a6 = /*@__PURE__*/ ((e)=>(e[e.Linear = 0] = "Linear", e[e.Radial = 1] = "Radial", e[e.MirroredLinear = 2] = "MirroredLinear", e))($7c8119e0ee165095$export$d405c73f99fcc6a6 || {});
class $7c8119e0ee165095$export$a5fb7e1f5e2d9d86 extends (0, $2046da3312f94030$export$a32b0b1c1ac59d04) {
    constructor({ rampType: t = 0, rampStart: o = [
        .5,
        .5
    ], rampEnd: r = [
        1,
        1
    ], startColor: a = [
        0,
        0,
        0,
        1
    ], endColor: n = [
        1,
        1,
        1,
        1
    ], rampBias: i = .5, rampGain: s = .5, rampMask: l = !1, rampInvert: p = !1, ..._ } = {}){
        super("RampEffect", $7c8119e0ee165095$var$jt.fragmentShader, {
            ..._,
            uniforms: /*@__PURE__*/ new Map([
                [
                    "rampType",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(t)
                ],
                [
                    "rampStart",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(o)
                ],
                [
                    "rampEnd",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(r)
                ],
                [
                    "startColor",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(a)
                ],
                [
                    "endColor",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(n)
                ],
                [
                    "rampBias",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(i)
                ],
                [
                    "rampGain",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(s)
                ],
                [
                    "rampMask",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(l)
                ],
                [
                    "rampInvert",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(p)
                ]
            ])
        });
    }
}
const $7c8119e0ee165095$export$d5f885e7bd4f2167 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f($7c8119e0ee165095$export$a5fb7e1f5e2d9d86), $7c8119e0ee165095$export$5431306cf43de24a = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function({ textureSrc: e, texture: t, opacity: o = 1, ...r }, a) {
    const n = (0, $02a5e071daeb5f48$export$2329c99376c9d0a4)((0, $ce0cdebec9150cb3$export$fd1bfc71f64c538c), e);
    (0, $2WGWz.useLayoutEffect)(()=>{
        n.colorSpace = (0, $ce0cdebec9150cb3$export$561f394b24edfcaa), n.wrapS = n.wrapT = (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5);
    }, [
        n
    ]);
    const i = (0, $2WGWz.useMemo)(()=>new (0, $2046da3312f94030$export$d1c9dd073fa6a2a3)({
            ...r,
            texture: n || t
        }), [
        r,
        n,
        t
    ]);
    return /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: a,
        object: i,
        "blendMode-opacity-value": o,
        dispose: null
    });
}), $7c8119e0ee165095$export$ab392850fad3699 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$6df7d6dd546cd57a)), $7c8119e0ee165095$export$d689db682b980db1 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$f32350b7e107bb62)), $7c8119e0ee165095$export$5971314d029975ec = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$678e91125a3dcb0c)), $7c8119e0ee165095$export$9e211ba6bd682e04 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(function({ lut: e, tetrahedralInterpolation: t, ...o }, r) {
    const a = (0, $2WGWz.useMemo)(()=>new (0, $2046da3312f94030$export$16c73198fba02ce9)(e, o), [
        e,
        o
    ]), n = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)((i)=>i.invalidate);
    return (0, $2WGWz.useLayoutEffect)(()=>{
        t && (a.tetrahedralInterpolation = t), e && (a.lut = e), n();
    }, [
        a,
        n,
        e,
        t
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: r,
        object: a,
        dispose: null
    });
}), $7c8119e0ee165095$export$ddb571201459d413 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f((0, $2046da3312f94030$export$c658e8e07b156fbc), {
    blendFunction: 0
}), $7c8119e0ee165095$var$Kt = {
    fragmentShader: `

    // original shader by Evan Wallace

    #define MAX_ITERATIONS 100

    uniform float blur;
    uniform float taper;
    uniform vec2 start;
    uniform vec2 end;
    uniform vec2 direction;
    uniform int samples;

    float random(vec3 scale, float seed) {
        /* use the fragment position for a different seed per-pixel */
        return fract(sin(dot(gl_FragCoord.xyz + seed, scale)) * 43758.5453 + seed);
    }

    void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
        vec4 color = vec4(0.0);
        float total = 0.0;
        vec2 startPixel = vec2(start.x * resolution.x, start.y * resolution.y);
        vec2 endPixel = vec2(end.x * resolution.x, end.y * resolution.y);
        float f_samples = float(samples);
        float half_samples = f_samples / 2.0;

        // use screen diagonal to normalize blur radii
        float maxScreenDistance = distance(vec2(0.0), resolution); // diagonal distance
        float gradientRadius = taper * (maxScreenDistance);
        float blurRadius = blur * (maxScreenDistance / 16.0);

        /* randomize the lookup values to hide the fixed number of samples */
        float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);
        vec2 normal = normalize(vec2(startPixel.y - endPixel.y, endPixel.x - startPixel.x));
        float radius = smoothstep(0.0, 1.0, abs(dot(uv * resolution - startPixel, normal)) / gradientRadius) * blurRadius;

        #pragma unroll_loop_start
        for (int i = 0; i <= MAX_ITERATIONS; i++) {
            if (i >= samples) { break; } // return early if over sample count
            float f_i = float(i);
            float s_i = -half_samples + f_i;
            float percent = (s_i + offset - 0.5) / half_samples;
            float weight = 1.0 - abs(percent);
            vec4 sample_i = texture2D(inputBuffer, uv + normalize(direction) / resolution * percent * radius);
            /* switch to pre-multiplied alpha to correctly blur transparent images */
            sample_i.rgb *= sample_i.a;
            color += sample_i * weight;
            total += weight;
        }
        #pragma unroll_loop_end

        outputColor = color / total;

        /* switch back from pre-multiplied alpha */
        outputColor.rgb /= outputColor.a + 0.00001;
    }
    `
};
class $7c8119e0ee165095$export$c658e8e07b156fbc extends (0, $2046da3312f94030$export$a32b0b1c1ac59d04) {
    constructor({ blendFunction: t = 23, blur: o = .15, taper: r = .5, start: a = [
        .5,
        0
    ], end: n = [
        .5,
        1
    ], samples: i = 10, direction: s = [
        1,
        1
    ] } = {}){
        super("TiltShiftEffect", $7c8119e0ee165095$var$Kt.fragmentShader, {
            blendFunction: t,
            attributes: 2,
            uniforms: /*@__PURE__*/ new Map([
                [
                    "blur",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(o)
                ],
                [
                    "taper",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(r)
                ],
                [
                    "start",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(a)
                ],
                [
                    "end",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(n)
                ],
                [
                    "samples",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(i)
                ],
                [
                    "direction",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(s)
                ]
            ])
        });
    }
}
const $7c8119e0ee165095$export$786b200b2fbea151 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f($7c8119e0ee165095$export$c658e8e07b156fbc, {
    blendFunction: 23
}), $7c8119e0ee165095$var$Jt = `
uniform sampler2D uCharacters;
uniform float uCharactersCount;
uniform float uCellSize;
uniform bool uInvert;
uniform vec3 uColor;

const vec2 SIZE = vec2(16.);

vec3 greyscale(vec3 color, float strength) {
    float g = dot(color, vec3(0.299, 0.587, 0.114));
    return mix(color, vec3(g), strength);
}

vec3 greyscale(vec3 color) {
    return greyscale(color, 1.0);
}

void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
    vec2 cell = resolution / uCellSize;
    vec2 grid = 1.0 / cell;
    vec2 pixelizedUV = grid * (0.5 + floor(uv / grid));
    vec4 pixelized = texture2D(inputBuffer, pixelizedUV);
    float greyscaled = greyscale(pixelized.rgb).r;

    if (uInvert) {
        greyscaled = 1.0 - greyscaled;
    }

    float characterIndex = floor((uCharactersCount - 1.0) * greyscaled);
    vec2 characterPosition = vec2(mod(characterIndex, SIZE.x), floor(characterIndex / SIZE.y));
    vec2 offset = vec2(characterPosition.x, -characterPosition.y) / SIZE;
    vec2 charUV = mod(uv * (cell / SIZE), 1.0 / SIZE) - vec2(0., 1.0 / SIZE) + offset;
    vec4 asciiCharacter = texture2D(uCharacters, charUV);

    asciiCharacter.rgb = uColor * asciiCharacter.r;
    asciiCharacter.a = pixelized.a;
    outputColor = asciiCharacter;
}
`;
class $7c8119e0ee165095$var$Qt extends (0, $2046da3312f94030$export$a32b0b1c1ac59d04) {
    constructor({ font: t = "arial", characters: o = " .:,'-^=*+?!|0#X%WM@", fontSize: r = 54, cellSize: a = 16, color: n = "#ffffff", invert: i = !1 } = {}){
        const s = /*@__PURE__*/ new Map([
            [
                "uCharacters",
                new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$5431306cf43de24a))
            ],
            [
                "uCellSize",
                new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(a)
            ],
            [
                "uCharactersCount",
                new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(o.length)
            ],
            [
                "uColor",
                new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(new (0, $ce0cdebec9150cb3$export$892596cec99bc70e)(n))
            ],
            [
                "uInvert",
                new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(i)
            ]
        ]);
        super("ASCIIEffect", $7c8119e0ee165095$var$Jt, {
            uniforms: s
        });
        const l = this.uniforms.get("uCharacters");
        l && (l.value = this.createCharactersTexture(o, t, r));
    }
    createCharactersTexture(t, o, r) {
        const a = document.createElement("canvas"), n = 1024, i = 16, s = n / i;
        a.width = a.height = n;
        const l = new (0, $ce0cdebec9150cb3$export$f7189e49152d1c13)(a, void 0, (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5), (0, $ce0cdebec9150cb3$export$533346c8e8dac0f5), (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0), (0, $ce0cdebec9150cb3$export$727aa5ec3fe39bf0)), p = a.getContext("2d");
        if (!p) throw new Error("Context not available");
        p.clearRect(0, 0, n, n), p.font = `${r}px ${o}`, p.textAlign = "center", p.textBaseline = "middle", p.fillStyle = "#fff";
        for(let _ = 0; _ < t.length; _++){
            const S = t[_], g = _ % i, d = Math.floor(_ / i);
            p.fillText(S, g * s + s / 2, d * s + s / 2);
        }
        return l.needsUpdate = !0, l;
    }
}
const $7c8119e0ee165095$export$4a7108e5554afff8 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(({ font: e = "arial", characters: t = " .:,'-^=*+?!|0#X%WM@", fontSize: o = 54, cellSize: r = 16, color: a = "#ffffff", invert: n = !1 }, i)=>{
    const s = (0, $2WGWz.useMemo)(()=>new $7c8119e0ee165095$var$Qt({
            characters: t,
            font: e,
            fontSize: o,
            cellSize: r,
            color: a,
            invert: n
        }), [
        t,
        o,
        r,
        a,
        n,
        e
    ]);
    return /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: i,
        object: s
    });
}), $7c8119e0ee165095$var$to = {
    fragmentShader: `
    uniform float factor;

    void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
      vec2 vUv = uv;
      float frequency = 6.0 * factor;
      float amplitude = 0.015 * factor;
      float x = vUv.y * frequency + time * 0.7; 
      float y = vUv.x * frequency + time * 0.3;
      vUv.x += cos(x + y) * amplitude * cos(y);
      vUv.y += sin(x - y) * amplitude * cos(y);
      vec4 rgba = texture(inputBuffer, vUv);
      outputColor = rgba;
    }
  `
};
class $7c8119e0ee165095$export$a6db2152d07dccf9 extends (0, $2046da3312f94030$export$a32b0b1c1ac59d04) {
    constructor({ blendFunction: t = 23, factor: o = 0 } = {}){
        super("WaterEffect", $7c8119e0ee165095$var$to.fragmentShader, {
            blendFunction: t,
            attributes: 2,
            uniforms: /*@__PURE__*/ new Map([
                [
                    "factor",
                    new (0, $ce0cdebec9150cb3$export$2947cebfe91c02f8)(o)
                ]
            ])
        });
    }
}
const $7c8119e0ee165095$export$e80d8610b6a39f76 = /*@__PURE__*/ $7c8119e0ee165095$export$860beaf0e87f1a9f($7c8119e0ee165095$export$a6db2152d07dccf9, {
    blendFunction: 23
}), $7c8119e0ee165095$export$920b0cd348d3591 = /*@__PURE__*/ (0, $2WGWz.forwardRef)(({ halfRes: e, screenSpaceRadius: t, quality: o, depthAwareUpsampling: r = !0, aoRadius: a = 5, aoSamples: n = 16, denoiseSamples: i = 4, denoiseRadius: s = 12, distanceFalloff: l = 1, intensity: p = 1, color: _, renderMode: S = 0 }, g)=>{
    const { camera: d, scene: m } = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)(), v = (0, $2WGWz.useMemo)(()=>new (0, $51c5c49040a59a26$export$2489f9981ab0fa82)(m, d), [
        d,
        m
    ]);
    return (0, $2WGWz.useLayoutEffect)(()=>{
        (0, $02a5e071daeb5f48$export$2408f22a0fab9ae5)(v.configuration, {
            color: _,
            aoRadius: a,
            distanceFalloff: l,
            intensity: p,
            aoSamples: n,
            denoiseSamples: i,
            denoiseRadius: s,
            screenSpaceRadius: t,
            renderMode: S,
            halfRes: e,
            depthAwareUpsampling: r
        });
    }, [
        t,
        _,
        a,
        l,
        p,
        n,
        i,
        s,
        S,
        e,
        r,
        v
    ]), (0, $2WGWz.useLayoutEffect)(()=>{
        o && v.setQualityMode(o.charAt(0).toUpperCase() + o.slice(1));
    }, [
        v,
        o
    ]), /*@__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("primitive", {
        ref: g,
        object: v
    });
});



const $282695370de42c48$var$TUBE_COUNT = 12;
const $282695370de42c48$var$TUBE_LENGTH = 2.0;
const $282695370de42c48$var$TUBE_RADIUS = 0.14;
const $282695370de42c48$var$CENTER_GAP = 0.75; // where rods start (replaces SPHERE_RADIUS)
const $282695370de42c48$var$ORB_COUNT = 7;
/**
 * LCD grouping for the PS2 clock orbs.
 * Returns the number of visible orb groups based on the lowest common
 * denominator of 60 that divides evenly into the current second.
 */ function $282695370de42c48$var$getOrbGroupCount(seconds) {
    if (seconds % 60 === 0) return 1;
    if (seconds % 30 === 0) return 2;
    if (seconds % 20 === 0) return 3;
    if (seconds % 15 === 0) return 4;
    if (seconds % 12 === 0) return 5;
    if (seconds % 10 === 0) return 6;
    return 7;
}
/**
 * Find the nearest grouping second and the distance to it.
 * Grouping seconds are: 0,10,12,15,20,24,30,36,40,45,48,50,60
 */ const $282695370de42c48$var$GROUPING_SECONDS = [
    0,
    10,
    12,
    15,
    20,
    24,
    30,
    36,
    40,
    45,
    48,
    50,
    60
];
function $282695370de42c48$var$nearestGroupingDistance(exactSecond) {
    let bestDist = 60;
    let bestSec = 0;
    for (const gs of $282695370de42c48$var$GROUPING_SECONDS){
        const d = Math.abs(exactSecond - gs);
        if (d < bestDist) {
            bestDist = d;
            bestSec = gs;
        }
    }
    return {
        nearest: bestSec % 60,
        dist: bestDist,
        groupCount: $282695370de42c48$var$getOrbGroupCount(bestSec % 60)
    };
}
/**
 * Fullscreen wormhole tunnel — a ray-marched infinite tunnel with
 * highly textured cloudy/cottony walls and perspective depth.
 * Creates the feeling of flying through a never-ending passage.
 */ function $282695370de42c48$var$WormholeTunnel() {
    const materialRef = (0, $2WGWz.useRef)(null);
    const shaderData = (0, $2WGWz.useMemo)(()=>({
            uniforms: {
                uTime: {
                    value: 0
                },
                uResolution: {
                    value: new $ce0cdebec9150cb3$export$c977b3e384af9ae1(1, 1)
                }
            },
            vertexShader: `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
            fragmentShader: `
      uniform float uTime;
      uniform vec2 uResolution;
      varying vec2 vUv;

      // High quality noise
      float hash(vec2 p) {
        vec3 p3 = fract(vec3(p.xyx) * 0.1031);
        p3 += dot(p3, p3.yzx + 33.33);
        return fract((p3.x + p3.y) * p3.z);
      }

      float noise(vec2 p) {
        vec2 i = floor(p);
        vec2 f = fract(p);
        f = f * f * f * (f * (f * 6.0 - 15.0) + 10.0); // quintic interp
        float a = hash(i);
        float b = hash(i + vec2(1.0, 0.0));
        float c = hash(i + vec2(0.0, 1.0));
        float d = hash(i + vec2(1.0, 1.0));
        return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);
      }

      // Layered fractal noise for cottony texture
      float fbm(vec2 p) {
        float value = 0.0;
        float amplitude = 0.5;
        float frequency = 1.0;
        for (int i = 0; i < 7; i++) {
          value += amplitude * noise(p * frequency);
          frequency *= 2.0;
          amplitude *= 0.5;
        }
        return value;
      }

      // Wispy cloud pattern with turbulence
      float cloudPattern(vec2 p, float t) {
        float n1 = fbm(p + vec2(t * 0.1, t * 0.05));
        float n2 = fbm(p * 1.5 + vec2(-t * 0.08, t * 0.12) + n1 * 0.5);
        float n3 = fbm(p * 0.7 + vec2(t * 0.06, -t * 0.04) + n2 * 0.3);
        return n1 * 0.5 + n2 * 0.3 + n3 * 0.2;
      }

      void main() {
        vec2 uv = vUv - 0.5;
        float aspect = uResolution.x / uResolution.y;

        // Distance from center \u{2014} computed before aspect correction for circular shape
        float dist = length(uv);

        uv.x *= aspect;

        // Tunnel depth: map radial distance to Z depth
        // Closer to center = farther away in the tunnel
        float depth = 0.5 / (dist + 0.05);

        // Angle around the tunnel \u{2014} use normalized coords to avoid atan seam
        float angle = atan(uv.y, uv.x);

        // Seamless angular coordinate: sample noise in 2D using cos/sin
        // instead of raw angle, so there's no discontinuity at \xb1PI
        float tunnelSpeed = uTime * 0.4;
        float angFreq = 2.0;
        vec2 angCoord = vec2(cos(angle * angFreq), sin(angle * angFreq));

        // Tunnel UV using seamless angular + depth
        vec2 tunnelUV = vec2(
          angCoord.x + angCoord.y * 0.5,
          depth + tunnelSpeed
        );
        // Second seamless coord for variety
        vec2 tunnelUV2 = vec2(
          angCoord.x * 0.7 - angCoord.y * 0.3 + 3.0,
          depth * 1.3 + tunnelSpeed * 0.8
        );

        // Multi-layered cloud texture at different scales
        float cloud1 = cloudPattern(tunnelUV * 1.5, uTime * 0.3);
        float cloud2 = cloudPattern(tunnelUV2 * 2.5 + 5.0, uTime * 0.2);
        float cloud3 = cloudPattern(tunnelUV * 0.8 + tunnelUV2 * 0.4 + 10.0, uTime * 0.15);

        // Combine clouds with emphasis on fine detail
        float clouds = cloud1 * 0.4 + cloud2 * 0.35 + cloud3 * 0.25;

        // Add wispy streaks along the tunnel
        float streaks = noise(vec2(angCoord.x * 6.0 + angCoord.y * 3.0, depth * 2.0 + tunnelSpeed * 0.5));
        streaks = pow(streaks, 2.0) * 0.3;
        clouds += streaks;

        // Color palette: dark purple/blue with high-contrast clouds
        vec3 darkPurple = vec3(0.03, 0.01, 0.06);
        vec3 midPurple = vec3(0.14, 0.09, 0.25);
        vec3 lightLavender = vec3(0.30, 0.22, 0.48);
        vec3 blueHint = vec3(0.08, 0.10, 0.22);

        // High contrast: sharpen cloud edges
        float sharpClouds = smoothstep(0.3, 0.7, clouds);
        vec3 color = mix(darkPurple, midPurple, sharpClouds);
        color = mix(color, lightLavender, pow(clouds, 3.0) * 0.6);
        color = mix(color, blueHint, streaks * 0.5);

        // Modulate brightness with texture for that cottony feel
        color *= 0.25 + clouds * 0.6;

        // Subtle center glow \u{2014} the distant tunnel opening
        float centerGlow = smoothstep(0.2, 0.0, dist);
        centerGlow = pow(centerGlow, 2.5);
        vec3 glowColor = vec3(0.18, 0.12, 0.30);
        color = mix(color, glowColor, centerGlow * 0.4);

        // Depth fog toward center
        float fog = smoothstep(0.35, 0.02, dist);
        vec3 fogColor = vec3(0.10, 0.06, 0.18);
        color = mix(color, fogColor, fog * 0.5);

        gl_FragColor = vec4(color, 1.0);
      }
    `
        }), []);
    const { size: size } = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)();
    (0, $02a5e071daeb5f48$export$96f57966bedc81b4)(({ clock: clock })=>{
        if (materialRef.current) {
            materialRef.current.uniforms.uTime.value = clock.getElapsedTime();
            materialRef.current.uniforms.uResolution.value.set(size.width, size.height);
        }
    });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("mesh", {
        position: [
            0,
            0,
            -5
        ],
        renderOrder: -1,
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("planeGeometry", {
                args: [
                    20,
                    20
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("shaderMaterial", {
                ref: materialRef,
                args: [
                    shaderData
                ],
                depthWrite: false,
                depthTest: false
            })
        ]
    });
}
/**
 * Procedural environment map for crystal reflections.
 * Creates a simple purple-blue gradient cubemap.
 */ function $282695370de42c48$var$CrystalEnvMap() {
    const { scene: scene } = (0, $02a5e071daeb5f48$export$e7094788287c5e9b)();
    (0, $2WGWz.useMemo)(()=>{
        const size = 64;
        const data = new Uint8Array(size * size * 4);
        // Create a simple gradient texture
        for(let y = 0; y < size; y++)for(let x = 0; x < size; x++){
            const i = (y * size + x) * 4;
            const fx = x / size;
            const fy = y / size;
            // Purple-blue gradient
            data[i] = Math.floor(30 + fx * 40 + fy * 20); // R
            data[i + 1] = Math.floor(20 + fx * 30 + fy * 40); // G
            data[i + 2] = Math.floor(60 + fx * 60 + fy * 80); // B
            data[i + 3] = 255; // A
        }
        const texture = new $ce0cdebec9150cb3$export$b691f601014eabe1(data, size, size);
        texture.needsUpdate = true;
        texture.mapping = $ce0cdebec9150cb3$export$d64030b316d3b087;
        scene.environment = texture;
        return ()=>{
            scene.environment = null;
            texture.dispose();
        };
    }, [
        scene
    ]);
    return null;
}
const $282695370de42c48$var$TRAIL_LENGTH = 20; // more segments, closely spaced for a smooth smear
/**
 * 7 flying orbs with comet-like tails, gliding in smooth spherical orbits.
 * Each orb has its own unique orbit parameters for natural-looking motion.
 * Grouping offsets are smoothly interpolated so LCD transitions are seamless.
 */ function $282695370de42c48$var$Orbs() {
    const orbRefs = (0, $2WGWz.useRef)([]);
    const trailRefs = (0, $2WGWz.useRef)([]);
    const posHistory = (0, $2WGWz.useRef)(Array.from({
        length: $282695370de42c48$var$ORB_COUNT
    }, ()=>Array.from({
            length: $282695370de42c48$var$TRAIL_LENGTH
        }, ()=>new $ce0cdebec9150cb3$export$64b5c384219d3699())));
    // Each orb has unique orbital parameters for visual variety
    const orbParams = (0, $2WGWz.useMemo)(()=>Array.from({
            length: $282695370de42c48$var$ORB_COUNT
        }, (_, i)=>({
                thetaSpeed: 2.0 + i * 0.08,
                thetaOffset: i / $282695370de42c48$var$ORB_COUNT * Math.PI * 2
            })), []);
    const trailScales = (0, $2WGWz.useMemo)(()=>Array.from({
            length: $282695370de42c48$var$TRAIL_LENGTH
        }, (_, i)=>{
            const t = i / $282695370de42c48$var$TRAIL_LENGTH;
            return {
                scale: 0.6 * (1.0 - t * 0.8),
                opacity: 0.25 * Math.pow(1.0 - t, 2),
                emissive: 0.8 * Math.pow(1.0 - t, 2)
            };
        }), []);
    const frameCount = (0, $2WGWz.useRef)(0);
    (0, $02a5e071daeb5f48$export$96f57966bedc81b4)(()=>{
        const now = new Date();
        const h = now.getHours() % 12;
        const m = now.getMinutes();
        const s = now.getSeconds();
        const ms = now.getMilliseconds();
        // Wall-clock time drives everything — deterministic on refresh
        const exactSecond = s + ms / 1000;
        const totalSeconds = h * 3600 + m * 60 + exactSecond;
        const t = totalSeconds;
        // Orbit radius expands throughout the hour
        const minuteProgress = (m * 60 + s + ms / 1000) / 3600;
        const orbitRadius = 0.2 + minuteProgress * 0.5;
        // Hour-hand angle (analog clock: 12 o'clock = top = -π/2)
        const hourAngle = (h + m / 60) / 12 * Math.PI * 2 - Math.PI / 2;
        // LCD grouping: find nearest grouping second and blend strength
        const { groupCount: groupCount, dist: groupDist } = $282695370de42c48$var$nearestGroupingDistance(exactSecond);
        // Smoothly ramp grouping strength: full at 0 distance, fades over ~2 seconds
        const groupWindow = 2.0;
        const groupStrength = Math.max(0, 1.0 - groupDist / groupWindow);
        // Sharpen with smoothstep for a nicer ease
        const smoothGroupStrength = groupStrength * groupStrength * (3 - 2 * groupStrength);
        frameCount.current++;
        const shouldUpdateTrail = frameCount.current % 2 === 0;
        for(let i = 0; i < $282695370de42c48$var$ORB_COUNT; i++){
            const orb = orbRefs.current[i];
            if (!orb) continue;
            const params = orbParams[i];
            // --- Free-flying position (driven by wall-clock time) ---
            const theta = t * params.thetaSpeed + params.thetaOffset;
            const freeX = Math.cos(theta) * orbitRadius;
            const freeY = Math.sin(theta) * orbitRadius;
            // 3D precession for spherical swirl
            const tiltAmount = 0.5 + Math.sin(t * 0.15 + i * 0.4) * 0.3;
            const tiltAxis = t * 0.2 + i * 0.9;
            const cosT = Math.cos(tiltAmount);
            const sinT = Math.sin(tiltAmount);
            const cosA = Math.cos(tiltAxis);
            const sinA = Math.sin(tiltAxis);
            const y1 = freeY * cosT;
            const z1Free = freeY * sinT;
            const x2Free = freeX * cosA - y1 * sinA;
            const y2Free = freeX * sinA + y1 * cosA;
            // --- Group target position ---
            const groupIndex = i % groupCount;
            let groupAngle;
            if (groupCount === 1) // All orbs converge to the hour-hand position
            groupAngle = hourAngle;
            else // Distribute group centers evenly around the orbit
            groupAngle = groupIndex / groupCount * Math.PI * 2 - Math.PI / 2;
            // Group targets sit on the orbit circle (in XY, no tilt)
            const groupX = Math.cos(groupAngle) * orbitRadius * 0.6;
            const groupY = Math.sin(groupAngle) * orbitRadius * 0.6;
            const groupZ = 0;
            // Blend between free-flying and grouped positions
            const finalX = x2Free + (groupX - x2Free) * smoothGroupStrength;
            const finalY = y2Free + (groupY - y2Free) * smoothGroupStrength;
            const finalZ = z1Free + (groupZ - z1Free) * smoothGroupStrength;
            orb.position.set(finalX, finalY, finalZ);
            if (shouldUpdateTrail) {
                const history = posHistory.current[i];
                for(let j = $282695370de42c48$var$TRAIL_LENGTH - 1; j > 0; j--)history[j].copy(history[j - 1]);
                history[0].set(finalX, finalY, finalZ);
            }
            const history = posHistory.current[i];
            for(let j = 0; j < $282695370de42c48$var$TRAIL_LENGTH; j++){
                const trail = trailRefs.current[i * $282695370de42c48$var$TRAIL_LENGTH + j];
                if (!trail || !history[j]) continue;
                trail.position.copy(history[j]);
                const sc = trailScales[j].scale;
                trail.scale.set(sc, sc, sc);
            }
        }
    });
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("group", {
        children: [
            Array.from({
                length: $282695370de42c48$var$ORB_COUNT
            }).map((_, i)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("mesh", {
                    ref: (el)=>{
                        if (el) orbRefs.current[i] = el;
                    },
                    children: [
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("sphereGeometry", {
                            args: [
                                0.05,
                                10,
                                10
                            ]
                        }),
                        /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("meshStandardMaterial", {
                            color: "#ddeeff",
                            emissive: "#ddeeff",
                            emissiveIntensity: 3
                        })
                    ]
                }, `orb-${i}`)),
            Array.from({
                length: $282695370de42c48$var$ORB_COUNT
            }).map((_, i)=>Array.from({
                    length: $282695370de42c48$var$TRAIL_LENGTH
                }).map((_, j)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("mesh", {
                        ref: (el)=>{
                            if (el) trailRefs.current[i * $282695370de42c48$var$TRAIL_LENGTH + j] = el;
                        },
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("sphereGeometry", {
                                args: [
                                    0.035,
                                    6,
                                    6
                                ]
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("meshStandardMaterial", {
                                color: "#ddeeff",
                                emissive: "#ddeeff",
                                emissiveIntensity: trailScales[j].emissive,
                                transparent: true,
                                opacity: trailScales[j].opacity,
                                depthWrite: false
                            })
                        ]
                    }, `trail-${i}-${j}`)))
        ]
    });
}
/**
 * A single hexagonal crystal rod with optional "liquid fill".
 */ function $282695370de42c48$var$CrystalRod({ index: index, isCurrentHour: isCurrentHour, fillLevel: fillLevel }) {
    const rodRef = (0, $2WGWz.useRef)(null);
    const angle = index / $282695370de42c48$var$TUBE_COUNT * Math.PI * 2 - Math.PI / 2;
    const dist = $282695370de42c48$var$CENTER_GAP + 0.15 + $282695370de42c48$var$TUBE_LENGTH / 2;
    (0, $02a5e071daeb5f48$export$96f57966bedc81b4)(({ clock: clock })=>{
        if (rodRef.current) {
            const t = clock.getElapsedTime();
            rodRef.current.rotation.x = t * 0.4 + index * (Math.PI / 6);
        }
    });
    const baseColor = '#1858a0';
    const baseEmissive = '#0a3868';
    const baseEmissiveIntensity = 0.7;
    const fillColor = '#70c8f0';
    const fillEmissive = '#50a8d8';
    const fillEmissiveIntensity = 2.5;
    // Liquid fills from the center end (negative X, close to hub) and drains toward outer tip.
    // fillLevel=1 means full rod is lit, fillLevel→0 means only near-center portion remains.
    const filledLen = $282695370de42c48$var$TUBE_LENGTH * fillLevel;
    const emptyLen = $282695370de42c48$var$TUBE_LENGTH - filledLen;
    // Center end is at -TUBE_LENGTH/2, outer tip is at +TUBE_LENGTH/2
    // Filled portion: starts at center end, extends outward
    const filledCenter = -$282695370de42c48$var$TUBE_LENGTH / 2 + filledLen / 2;
    const emptyCenter = $282695370de42c48$var$TUBE_LENGTH / 2 - emptyLen / 2;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("group", {
        rotation: [
            0,
            0,
            -angle
        ],
        children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("group", {
            ref: rodRef,
            position: [
                dist,
                0,
                0
            ],
            children: isCurrentHour && fillLevel > 0.01 ? /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("mesh", {
                        position: [
                            filledCenter,
                            0,
                            0
                        ],
                        rotation: [
                            0,
                            0,
                            Math.PI / 2
                        ],
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("cylinderGeometry", {
                                args: [
                                    $282695370de42c48$var$TUBE_RADIUS,
                                    $282695370de42c48$var$TUBE_RADIUS,
                                    filledLen,
                                    6
                                ]
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("meshPhysicalMaterial", {
                                color: fillColor,
                                emissive: fillEmissive,
                                emissiveIntensity: fillEmissiveIntensity,
                                transparent: true,
                                opacity: 0.9,
                                roughness: 0.02,
                                metalness: 0.1,
                                transmission: 0.3,
                                thickness: 2.0,
                                ior: 2.2,
                                clearcoat: 1,
                                clearcoatRoughness: 0.01,
                                envMapIntensity: 2.0,
                                specularIntensity: 1.5,
                                specularColor: "#ffffff",
                                sheen: 0.3,
                                sheenColor: "#88ccff"
                            })
                        ]
                    }),
                    emptyLen > 0.01 && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("mesh", {
                        position: [
                            emptyCenter,
                            0,
                            0
                        ],
                        rotation: [
                            0,
                            0,
                            Math.PI / 2
                        ],
                        children: [
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("cylinderGeometry", {
                                args: [
                                    $282695370de42c48$var$TUBE_RADIUS,
                                    $282695370de42c48$var$TUBE_RADIUS,
                                    emptyLen,
                                    6
                                ]
                            }),
                            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("meshPhysicalMaterial", {
                                color: "#2870a0",
                                emissive: "#185888",
                                emissiveIntensity: 0.9,
                                transparent: true,
                                opacity: 0.88,
                                roughness: 0.02,
                                metalness: 0.12,
                                transmission: 0.35,
                                thickness: 2.0,
                                ior: 2.2,
                                clearcoat: 1,
                                clearcoatRoughness: 0.01,
                                envMapIntensity: 1.8,
                                specularIntensity: 1.2,
                                specularColor: "#aaddff",
                                sheen: 0.3,
                                sheenColor: "#4488cc"
                            })
                        ]
                    })
                ]
            }) : /* Single solid rod */ /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("mesh", {
                rotation: [
                    0,
                    0,
                    Math.PI / 2
                ],
                children: [
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("cylinderGeometry", {
                        args: [
                            $282695370de42c48$var$TUBE_RADIUS,
                            $282695370de42c48$var$TUBE_RADIUS,
                            $282695370de42c48$var$TUBE_LENGTH,
                            6
                        ]
                    }),
                    /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("meshPhysicalMaterial", {
                        color: baseColor,
                        emissive: baseEmissive,
                        emissiveIntensity: baseEmissiveIntensity,
                        transparent: true,
                        opacity: 0.9,
                        roughness: 0.02,
                        metalness: 0.15,
                        transmission: 0.35,
                        thickness: 2.0,
                        ior: 2.2,
                        clearcoat: 1,
                        clearcoatRoughness: 0.01,
                        envMapIntensity: 2.0,
                        specularIntensity: 1.5,
                        specularColor: "#aaddff",
                        sheen: 0.3,
                        sheenColor: "#4488cc"
                    })
                ]
            })
        })
    });
}
/**
 * Main clock assembly.
 */ function $282695370de42c48$var$ClockGroup() {
    const outerRef = (0, $2WGWz.useRef)(null);
    const faceRef = (0, $2WGWz.useRef)(null);
    const [clockState, setClockState] = (0, $2WGWz.useState)(()=>{
        const now = new Date();
        const h = now.getHours() % 12;
        const m = now.getMinutes();
        const s = now.getSeconds();
        const totalSecondsInHour = m * 60 + s;
        const rawFill = 1.0 - totalSecondsInHour / 3600;
        const fillInRamp = Math.min(totalSecondsInHour / 5.0, 1.0);
        return {
            h: h,
            fillLevel: rawFill * fillInRamp
        };
    });
    (0, $02a5e071daeb5f48$export$96f57966bedc81b4)(()=>{
        const now = new Date();
        const s = now.getSeconds();
        const ms = now.getMilliseconds();
        const m = now.getMinutes();
        const h = now.getHours() % 12;
        const exactSeconds = s + ms / 1000;
        // The clock face rotates around an axis that passes through the
        // highlighted hour rod. This means the hour rod stays roughly stationary
        // while the rest of the face spins around it like a coin flip.
        const hourRodAngle = h / 12 * Math.PI * 2 - Math.PI / 2;
        const spinAngle = exactSeconds / 60 * Math.PI * 2;
        if (faceRef.current) {
            // The rod layout uses rotation=[0,0,-angle] then position=[dist,0,0],
            // so the rod's world direction from center is (cos(angle), -sin(angle), 0).
            // The rotation axis must pass through the rod to keep it stationary.
            const axisX = Math.cos(hourRodAngle);
            const axisY = -Math.sin(hourRodAngle);
            const axis = new $ce0cdebec9150cb3$export$64b5c384219d3699(axisX, axisY, 0).normalize();
            const quaternion = new $ce0cdebec9150cb3$export$23d6a54f0bbc85a3().setFromAxisAngle(axis, spinAngle);
            faceRef.current.quaternion.copy(quaternion);
        }
        if (outerRef.current) outerRef.current.rotation.set(0, 0, 0);
        // Update rod highlighting and fill level reactively
        const totalSecondsInHour = m * 60 + exactSeconds;
        const rawFill = 1.0 - totalSecondsInHour / 3600;
        // At the top of the hour, fill up over 5 seconds instead of snapping to full
        const fillInDuration = 5.0;
        const fillInRamp = Math.min(totalSecondsInHour / fillInDuration, 1.0);
        const fill = rawFill * fillInRamp;
        setClockState((prev)=>{
            if (prev.h !== h || Math.abs(prev.fillLevel - fill) > 0.01) return {
                h: h,
                fillLevel: fill
            };
            return prev;
        });
    });
    const { h: h, fillLevel: fillLevel } = clockState;
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("group", {
        ref: outerRef,
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("group", {
                ref: faceRef,
                children: Array.from({
                    length: $282695370de42c48$var$TUBE_COUNT
                }).map((_, i)=>/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($282695370de42c48$var$CrystalRod, {
                        index: i,
                        isCurrentHour: i === h,
                        fillLevel: i === h ? fillLevel : 0
                    }, i))
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($282695370de42c48$var$Orbs, {})
        ]
    });
}
function $282695370de42c48$var$Scene() {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $419c6008abfcce61$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("ambientLight", {
                intensity: 0.3,
                color: "#5566aa"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("pointLight", {
                position: [
                    5,
                    5,
                    5
                ],
                intensity: 1.2,
                color: "#6688cc"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("pointLight", {
                position: [
                    -4,
                    -3,
                    4
                ],
                intensity: 0.6,
                color: "#5566aa"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("pointLight", {
                position: [
                    0,
                    0,
                    5
                ],
                intensity: 1.0,
                color: "#7799cc"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("pointLight", {
                position: [
                    0,
                    0,
                    -5
                ],
                intensity: 0.5,
                color: "#5566aa"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($282695370de42c48$var$CrystalEnvMap, {}),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($282695370de42c48$var$WormholeTunnel, {}),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($282695370de42c48$var$ClockGroup, {}),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7c8119e0ee165095$export$7fe01e6ab8aa748c), {
                children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $7c8119e0ee165095$export$b987ea0722284bfd), {
                    luminanceThreshold: 0.2,
                    luminanceSmoothing: 0.9,
                    intensity: 1.3
                })
            })
        ]
    });
}
function $282695370de42c48$export$43e77ba18cc28ff4() {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)((0, $eccc7fd3f3cbe7a9$export$8d01c972ee8b14a9), {
        camera: {
            position: [
                0,
                0,
                7
            ],
            fov: 40
        },
        gl: {
            antialias: true,
            alpha: false
        },
        style: {
            width: '100vw',
            height: '100vh'
        },
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("color", {
                attach: "background",
                args: [
                    '#1a0f2e'
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($282695370de42c48$var$Scene, {})
        ]
    });
}




var $2WGWz = parcelRequire("2WGWz");
function $902a37bd0b41c39c$var$getLocaleOverride() {
    const params = new URLSearchParams(window.location.search);
    return params.get('locale') || undefined;
}
function $902a37bd0b41c39c$var$formatDate(date, locale) {
    return date.toLocaleDateString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
}
function $902a37bd0b41c39c$var$formatTime(date, locale) {
    return date.toLocaleTimeString(locale, {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit'
    });
}
/**
 * Detect if daylight saving time is currently active.
 * Compares the current UTC offset to the January offset —
 * if they differ, DST is in effect.
 */ function $902a37bd0b41c39c$var$isDST(date) {
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    const stdOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    return date.getTimezoneOffset() < stdOffset;
}
function $902a37bd0b41c39c$var$SunIcon() {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96.98 96.98",
        className: "sun-icon",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("circle", {
                cx: "48.49",
                cy: "48.49",
                r: "29.24",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("rect", {
                x: "45.35",
                width: "6.21",
                height: "15.14",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("rect", {
                x: "45.35",
                y: "81.84",
                width: "6.21",
                height: "15.14",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("rect", {
                x: "86.3",
                y: "42.4",
                width: "6.21",
                height: "15.14",
                fill: "#fff",
                transform: "translate(139.38 -39.43) rotate(90)"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("rect", {
                x: "4.47",
                y: "42.4",
                width: "6.21",
                height: "15.14",
                fill: "#fff",
                transform: "translate(57.54 42.4) rotate(90)"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("rect", {
                x: "74.32",
                y: "12.89",
                width: "6.21",
                height: "15.14",
                fill: "#fff",
                transform: "translate(37.15 -48.75) rotate(45)"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("rect", {
                x: "16.45",
                y: "70.76",
                width: "6.21",
                height: "15.14",
                fill: "#fff",
                transform: "translate(61.12 9.11) rotate(45)"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("rect", {
                x: "73.74",
                y: "71.33",
                width: "6.21",
                height: "15.14",
                fill: "#fff",
                transform: "translate(186.99 80.36) rotate(135)"
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("rect", {
                x: "15.88",
                y: "13.47",
                width: "6.21",
                height: "15.14",
                fill: "#fff",
                transform: "translate(47.28 22.49) rotate(135)"
            })
        ]
    });
}
function $902a37bd0b41c39c$export$e0c4108d503b161() {
    const [now, setNow] = (0, $2WGWz.useState)(new Date());
    const locale = (0, $2WGWz.useMemo)(()=>$902a37bd0b41c39c$var$getLocaleOverride(), []);
    (0, $2WGWz.useEffect)(()=>{
        const interval = setInterval(()=>setNow(new Date()), 1000);
        return ()=>clearInterval(interval);
    }, []);
    const dst = $902a37bd0b41c39c$var$isDST(now);
    const forkRef = (0, $2WGWz.useRef)(null);
    const restartFade = (0, $2WGWz.useCallback)(()=>{
        const el = forkRef.current;
        if (!el) return;
        el.style.animation = 'none';
        // Force reflow to restart animation
        el.offsetHeight;
        el.style.animation = '';
    }, []);
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "time-overlay",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("div", {
                className: "time-date",
                children: $902a37bd0b41c39c$var$formatDate(now, locale)
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
                className: "time-clock",
                children: [
                    dst && /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)($902a37bd0b41c39c$var$SunIcon, {}),
                    $902a37bd0b41c39c$var$formatTime(now, locale)
                ]
            }),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)("a", {
                ref: forkRef,
                className: "fork-link",
                href: "https://github.com/richiepreece/clock",
                target: "_blank",
                rel: "noopener noreferrer",
                onMouseEnter: restartFade,
                children: "Fork me on GitHub"
            })
        ]
    });
}


function $cd93687958c8007e$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsxs)("div", {
        className: "clock-container",
        children: [
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $282695370de42c48$export$43e77ba18cc28ff4), {}),
            /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $902a37bd0b41c39c$export$e0c4108d503b161), {})
        ]
    });
}


let $70fc9a727fa662ae$var$container = document.getElementById("app");
let $70fc9a727fa662ae$var$root = (0, $9304165f01abb7b7$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $2WGWz.StrictMode), {
    children: /*#__PURE__*/ (0, $419c6008abfcce61$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=clock.2bc16fa9.js.map
